angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog, $mdMedia) {
  $scope.status = '  ';
  $scope.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showPrompt = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.prompt()
      .title('What would you name your dog?')
      .textContent('Bowser is a common name.')
          .placeholder('dog name')
      .ariaLabel('Dog name')
      .targetEvent(ev)
          .parent(angular.element(document.body))
      .ok('Okay!')
      .cancel('I\'m a cat person');

    $mdDialog.show(confirm).then(function(result) {
      $scope.status = 'You decided to name your dog ' + result + '.';
    }, function() {
      $scope.status = 'You didn\'t name your dog.';
    });
  };

  $scope.showAdvanced = function(ev) {
    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;

    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: useFullScreen
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });



    $scope.$watch(function() {
      return $mdMedia('xs') || $mdMedia('sm');
    }, function(wantsFullScreen) {
      $scope.customFullscreen = (wantsFullScreen === true);
    });

  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };


});

function DialogController($scope, $mdDialog) {
  $scope.hide = function() {
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.progetti', ['flow'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_progetti_progetti', {
                    url: '/sprardb/progetti',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetti.html',
                            controller: 'ProgettiController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_progetti_progetti_en', {
                    url: '/sprardb/progetti/:attivo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetti.html',
                            controller: 'ProgettiController as vm'
                        }
                    }
                })
                .state('app.sprardb_progetti_progetti_dis', {
                    url: '/sprardb/progetti/:attivo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetti.html',
                            controller: 'ProgettiController as vm'
                        }
                    }
                })
                .state('app.sprardb_progetti_progetti_par', {
                    url: '/sprardb/progetti/:attivo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetti.html',
                            controller: 'ProgettiController as vm'
                        }
                    }
                })
                .state('app.sprardb_progetti_progetti_progetto', {
                    url: '/sprardb/progetto/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetto/dettaglio.html',
                            controller: 'DettaglioController as vm'
                        }
                    }
                    ,
                    resolve: {
//                        Progetto: function (msApi, $stateParams)
//                        {
//                            return msApi.resolve('progetto@get', {id: $stateParams.id});
//
//                        },
//                        Tags: function (msApi)
//                        {
//                            return msApi.resolve('tags@get');
//
//                        },
//                        Bandi: function (msApi)
//                        {
//                            return msApi.resolve('bandi@get');
//
//                        }
                    }
                })
                .state('app.sprardb_progetti_nuovo', {
                    url: '/progetti/progetto/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/progetti/progetto/dettaglio.html',
                            controller: 'DettaglioController as vm'
                        }
                    }
                })

                ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/progetti/progetti');

        // Api
        msApiProvider.register('progetto', ['http://localhost/sprardb/app-server/web/progettos/search']);
        msApiProvider.register('tags', ['http://localhost/sprardb/app-server/web/tags']);
        msApiProvider.register('bandi', ['http://localhost/sprardb/app-server/web/bandos']);


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.progetti', {
            title: 'PROGETTI',
            icon: 'icon-apps',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.progetti.listap', {
            title: 'Ricerca progetti',
            icon: 'icon-view-list',
            state: 'app.sprardb_progetti_progetti',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.progetti.new', {
            title: 'Nuovo Progetto',
            icon: 'icon-plus-network',
            state: 'app.sprardb_progetti_nuovo',
            weight: 2
        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.enabled', {
//            title: 'Progetti attivi',
//            icon: 'icon-select-inverse',
//            state: 'app.sprardb_progetti_progetti_en({attivo:1})',
//            weight: 3
//        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.disabled', {
//            title: 'Progetti disattivati',
//            icon: 'icon-select-off',
//            state: 'app.sprardb_progetti_progetti_dis({attivo:0})',
//            weight: 4
//        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.partial', {
//            title: 'Progetti incompleti',
//            icon: 'icon-select',
//            state: 'app.sprardb_progetti_progetti_par({attivo:-1})',
//            weight: 5
//        });
        /*
         msNavigationServiceProvider.saveItem('scadmin.progetti', {
         title: 'Progetti',
         weight: 30
         });
         msNavigationServiceProvider.saveItem('scadmin.progetti.listap', {
         title: 'Ricerca progetti',
         icon: 'icon-apps',
         state: 'app.sprardb_progetti_progetti',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.progetti.new', {
         title: 'Nuovo Progetto',
         icon: 'icon-plus-network',
         state: 'app.sprardb_progetti_nuovo',
         weight: 2
         });
         */



        /*
         msNavigationServiceProvider.saveItem('properatore.progetti', {
         title: 'Progetti',
         weight: 30
         });
         msNavigationServiceProvider.saveItem('properatore.progetti.listap', {
         title: 'Ricerca progetti',
         icon: 'icon-apps',
         state: 'app.sprardb_progetti_progetti',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scsegreteria.progetti', {
         title: 'Progetti',
         weight: 30
         });
         msNavigationServiceProvider.saveItem('scsegreteria.progetti.listap', {
         title: 'Ricerca progetti',
         icon: 'icon-apps',
         state: 'app.sprardb_progetti_progetti',
         weight: 1
         });
         //        msNavigationServiceProvider.saveItem('properatore.progetti.new', {
         //            title: 'Nuovo Progetto',
         //            icon: 'icon-plus-network',
         //            state: 'app.sprardb_progetti_nuovo',
         //            weight: 2
         //        });

         msNavigationServiceProvider.saveItem('pramministratore.progetti', {
         title: 'Progetti',
         weight: 30
         });
         msNavigationServiceProvider.saveItem('pramministratore.progetti.listap', {
         title: 'Ricerca progetti',
         icon: 'icon-apps',
         state: 'app.sprardb_progetti_progetti',
         weight: 1
         });
         */
//        msNavigationServiceProvider.saveItem('pramministratore.progetti.new', {
//            title: 'Nuovo Progetto',
//            icon: 'icon-plus-network',
//            state: 'app.sprardb_progetti_nuovo',
//            weight: 2
//        });

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.progetti')
            .controller('ProgettoDialogController', ProgettoDialogController);

    /** @ngInject */
    function ProgettoDialogController($mdDialog, Progetto, Contacts, Tags, msUtils, msApi, api, $state)
    {
        var vm = this;
        vm.isDisabled = false;
        vm.simulateQuery = false;
        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
        });
        api.bandi.bando.get({}, function (response) {
            vm.bandos = response.data;
        });
        vm.provincias = [];
        vm.istats = [];
        // Data
        vm.title = 'Modifica';
        vm.progetto = angular.copy(Progetto);
        console.log(vm.progetto);
        vm.contacts = Contacts;
        vm.tags = Tags;
        vm.newProgetto = false;
        vm.allFields = false;

        if (!vm.progetto)
        {
            vm.progetto = {
                id: null,
                nome: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataInizio: null,
                dataFine: null,
                durata: null,
                budget: null,
                operatori: null,
                postiTotali: null,
                postiFinanziati: null,
                postiRiservatiSC: null,
                postiAsilo: null,
                postiUmanitari: null,
                postiRifugiati: null,
                bandos: [],
                entes: [],
                strutturas: [],
                documentos: [],
                tags: [],
                progettoextras: []
            };

            vm.title = 'Nuovo';
            vm.newProgetto = true;
            vm.progetto.tags = [];
        }
        vm.progetto.dataInizio = new Date(vm.progetto.dataInizio);
        vm.progetto.dataFine = new Date(vm.progetto.dataFine);

        // Methods
        vm.addNewProgetto = addNewProgetto;
        vm.saveProgetto = saveProgetto;
        vm.deleteProgettoConfirm = deleteProgettoConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;

        if (vm.progetto.codRegione !== null || vm.progetto.codRegione !== '') {
            console.log("*");
            vm.caricaProvince(vm.progetto.codRegione);
        }
        if (vm.progetto.codProvincia !== null || vm.progetto.codProvincia !== '') {
            console.log("*");
            vm.caricaComuni(vm.progetto.codProvincia);
        }

//        vm.createFilterFor = createFilterFor;
//        vm.querySearch = querySearch;
//        vm.searchTextChange = searchTextChange;
//        vm.selectedItemChange = selectedItemChange;
        //////////

        /**
         * Add new contact
         */
        function addNewProgetto()
        {
            vm.contacts.unshift(vm.progetto);

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveProgetto(progetto)
        {

            if (vm.newProgetto == true) {
                api.progetti.progetto.save(progetto, function (response) {
                    vm.esito = response.data;
                });
            }
            if (vm.newProgetto == false) {
                progetto['verb'] = progetto.id;
                api.progetti.progetto.aggiorna({verb: progetto.id}, progetto, function (response) {
                    vm.esito = response.data;
                });
            }

//            // Dummy save action
//            for (var i = 0; i < vm.contacts.length; i++)
//            {
//                if (vm.contacts[i].id === vm.progetto.id)
//                {
//                    vm.contacts[i] = angular.copy(vm.progetto);
//                    break;
//                }
//            }
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteProgettoConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Are you sure want to delete the contact?')
                    .htmlContent('<b>' + vm.progetto.name + ' ' + vm.progetto.lastName + '</b>' + ' will be deleted.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Progetto), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia}, function (response) {
                vm.istats = response.data;
            });
//            msApi.register('dialog.istats', ['http://localhost/sprardb/app-server/web/istats/search?codProvincia='+codprovincia]);
//            msApi.resolve('dialog.istats@get').then(function (d) {
//            vm.istats = d.data;
//        });
        }
        function caricaProvince(codregione) {
            console.log(vm.regiones);
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
            });
//            msApi.register('dialog.provincias', ['http://localhost/sprardb/app-server/web/provincias/search?codRegione='+codregione]);
//            msApi.resolve('dialog.provincias@get').then(function (d) {
//                vm.provincias = d.data;
//            });
        }

//        function createFilterFor(query) {
//            var lowercaseQuery = angular.lowercase(query);
//
//            return function filterFn(item) {
//                return (item.istat.indexOf(lowercaseQuery) === 0);
//            };
//
//        }
//        function querySearch(query) {
//            var results = query ? vm.istats.filter(createFilterFor(query)) : vm.istats,
//                    deferred;
//            if (vm.simulateQuery) {
//                deferred = $q.defer();
//                $timeout(function () {
//                    deferred.resolve(results);
//                }, Math.random() * 1000, false);
//                return deferred.promise;
//            } else {
//                return results;
//            }
//        }
//
//        function searchTextChange(text) {
//            console.log('Text changed to ' + text);
//        }
//
//        function selectedItemChange(item) {
//            console.log('Item changed to ' + JSON.stringify(item));
//        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.tags', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_tags', {
            url    : '/sprardb/configurazioni/tags',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/tags/tags.html',
                    controller : 'TagsController as vm'
                }
            },
            resolve: {
                Tags: function (msApi)
                {
                    return msApi.resolve('tags.tags@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/tags');


        // Api
       msApiProvider.register('tags.tags', ['http://localhost/sprardb/app-server/web/tags']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.tags', {
             title: 'Tag',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_tags',
             weight: 4
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.tags')
        .controller('TagDialogController', TagDialogController);

    /** @ngInject */
    function TagDialogController($mdDialog, Tag, Tags, User, msUtils, msApi,$state,api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.tag = angular.copy(Tag);
        console.log(vm.tag);
        vm.tags = Tags;
        vm.user = User;
        vm.newTag = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.tag )
        {
          vm.evento = "new";
            vm.tag = {
                'id'      : null,
                'tag'    : null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newTag = true;

        }

        // Methods
        vm.saveTag = saveTag;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function saveTag(ev,tag)
        {
          if (ev=="new") { api.tags.tag.save(tag);}
          if (ev=="update"){ api.tags.tag.aggiorna(tag);}
            $state.reload();
            closeDialog();
        }


        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il tag?')
                .htmlContent('<b>' + vm.tag.tag + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
              api.tags.tag.remove({id: Tag.id});
              $state.reload();
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.personaruolos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_personaruolos', {
            url    : '/sprardb/configurazioni/personaruolos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/personaruolos/personaruolos.html',
                    controller : 'PersonaruolosController as vm'
                }
            },
            resolve: {
                Personaruolos: function (msApi)
                {
                    return msApi.resolve('personaruolos.personaruolos@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/personaruolos');


        // Api
       msApiProvider.register('personaruolos.personaruolos', ['http://localhost/sprardb/app-server/web/personaruolos']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.personaruolos', {
             title: 'Persona/Ruolo',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_personaruolos',
             weight: 1
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.personaruolos')
        .controller('PersonaruoloDialogController', PersonaruoloDialogController);

    /** @ngInject */
    function PersonaruoloDialogController($mdDialog, Personaruolo, Personaruolos, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.personaruolo = angular.copy(Personaruolo);
        console.log(vm.personaruolo);
        vm.personaruolos = Personaruolos;
        vm.user = User;
        vm.newPersonaruolo = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.personaruolo )
        {
          vm.evento = "new";
            vm.personaruolo = {
                'id'      : null,
                'gruppo'    : null,
                'descrizione': null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newPersonaruolo = true;

        }

        // Methods
        vm.savePersonaruolo = savePersonaruolo;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function savePersonaruolo(ev,personaruolo)
        {
          if (ev=="new") { api.personaruolos.personaruolo.save(personaruolo);}
          if (ev=="update"){ api.personaruolos.personaruolo.aggiorna(personaruolo);}
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */

        function deleteContactConfirm(personaruolo, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il ruolo?')
                .htmlContent('<b>' + vm.personaruolo.descrizione + ' / ' + vm.personaruolo.gruppo + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
              api.personaruolos.personaruolo.remove({id: Personaruolo.id});
              $state.reload();

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.entetipos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_entetipos', {
            url    : '/sprardb/configurazioni/entetipos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/entetipos/entetipos.html',
                    controller : 'EntetiposController as vm'
                }
            },
            resolve: {
                Entetipos: function (msApi)
                {
                    return msApi.resolve('entetipos.entetipos@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/entetipos');


        // Api
       msApiProvider.register('entetipos.entetipos', ['http://localhost/sprardb/app-server/web/entetipos']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.entetipos', {
             title: 'Ente/Tipo',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_entetipos',
             weight: 2
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.entetipos')
        .controller('EntetipoDialogController', EntetipoDialogController);

    /** @ngInject */
    function EntetipoDialogController($mdDialog, Entetipo, Entetipos, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.entetipo = angular.copy(Entetipo);
        console.log(vm.entetipo);
        vm.entetipos = Entetipos;
        vm.user = User;
        vm.newEntetipo = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.entetipo )
        {
          vm.evento = "new";
            vm.entetipo = {
                'id'      : null,
                'enteTipo_id'    : null,
                'descrizione': null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newEntetipo = true;

        }

        // Methods
        vm.saveEntetipo = saveEntetipo;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function saveEntetipo(ev,entetipo)
        {
          if (ev=="new") { api.entetipos.entetipo.save(entetipo);}
          if (ev=="update"){ api.entetipos.entetipo.aggiorna(entetipo);}
            $state.reload();
            closeDialog();
        }


        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il tipo ente?')
                .htmlContent('<b>' + vm.entetipo.descrizione + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
              api.entetipos.entetipo.remove({id: Entetipo.id});
              $state.reload();

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.enteruolos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_enteruolos', {
            url    : '/sprardb/configurazioni/enteruolos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/enteruolos/enteruolos.html',
                    controller : 'EnteruolosController as vm'
                }
            },
            resolve: {
                Enteruolos: function (msApi)
                {
                    return msApi.resolve('enteruolos.enteruolos@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/enteruolos');


        // Api
       msApiProvider.register('enteruolos.enteruolos', ['http://localhost/sprardb/app-server/web/enteruolos']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.enteruolos', {
             title: 'Ente/Ruolo',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_enteruolos',
             weight: 3
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.enteruolos')
        .controller('EnteruoloDialogController', EnteruoloDialogController);

    /** @ngInject */
    function EnteruoloDialogController($mdDialog, Enteruolo, Enteruolos, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.enteruolo = angular.copy(Enteruolo);
        console.log(vm.enteruolo);
        vm.enteruolos = Enteruolos;
        vm.user = User;
        vm.newEnteruolo = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.enteruolo )
        {
          vm.evento = "new";
            vm.enteruolo = {
                'id'      : null,
                'gruppo'    : null,
                'descrizione': null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newEnteruolo = true;

        }

        // Methods
        vm.saveEnteruolo = saveEnteruolo;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function saveEnteruolo(ev,enteruolo)
        {

          if (ev=="new") { api.enteruolos.enteruolo.save(enteruolo);}
          if (ev=="update"){ api.enteruolos.enteruolo.aggiorna(enteruolo);}
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */


        function deleteContactConfirm(enteruolo,ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il ruolo?')
                .htmlContent('<b>' + vm.enteruolo.descrizione+ ' ' + vm.enteruolo.gruppo + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
                api.enteruolos.enteruolo.remove({id: Enteruolo.id});
                $state.reload();
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.documentotipos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_documentotipos', {
            url    : '/sprardb/configurazioni/documentotipos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/documentotipos/documentotipos.html',
                    controller : 'DocumentotiposController as vm'
                }
            },
            resolve: {
                Documentotipos: function (msApi)
                {
                    return msApi.resolve('documentotipos.documentotipos@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/documentotipos');


        // Api
       msApiProvider.register('documentotipos.documentotipos', ['http://localhost/sprardb/app-server/web/documentotipos']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.documentotipos', {
             title: 'Documento/Tipo',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_documentotipos',
             weight: 6
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.documentotipos')
        .controller('DocumentotipoDialogController', DocumentotipoDialogController);

    /** @ngInject */
    function DocumentotipoDialogController($mdDialog, Documentotipo, Documentotipos, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.documentotipo = angular.copy(Documentotipo);
        console.log(vm.documentotipo);
        vm.documentotipos = Documentotipos;
        vm.user = User;
        vm.newDocumentotipo = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.documentotipo )
        {
          vm.evento = "new";
            vm.documentotipo = {
                'id'      : null,
                'gruppo'  : null,
                'tipo': null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newDocumentotipo = true;

        }

        // Methods

        vm.saveDocumentotipo = saveDocumentotipo;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;


        //////////

        /**
         * Save contact
         */
        function saveDocumentotipo(ev,documentotipo)
        {
          if (ev=="new") { api.documentotipos.documentotipo.save(documentotipo);}
          if (ev=="update"){ api.documentotipos.documentotipo.aggiorna(documentotipo);}
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */



        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il documento?')
                .htmlContent('<b>' + vm.documentotipo.tipo + ' / ' + vm.documentotipo.gruppo +'</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
                api.documentotipos.documentotipo.remove({id: Documentotipo.id});
                $state.reload();
            });

        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.bandos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,$mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_configurazioni_bandos', {
            url    : '/sprardb/configurazioni/bandos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sprardb/configurazioni/bandos/bandos.html',
                    controller : 'BandosController as vm'
                }
            },
            resolve: {
                Bandos: function (msApi)
                {
                    return msApi.resolve('bandos.bandos@get');

                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/sprardb/configurazioni/bandos');


        // Api
       msApiProvider.register('bandos.bandos', ['http://localhost/sprardb/app-server/web/bandos']);
       msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD');
          return m.isValid() ? m.toDate() : new Date(NaN);
        };


        msNavigationServiceProvider.saveItem('sprardb.configurazioni.bandos', {
             title: 'Bando',
             icon : 'icon-cog-box',
             state: 'app.sprardb_configurazioni_bandos',
             weight: 5
         });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.configurazioni.bandos')
        .controller('BandoDialogController', BandoDialogController);

    /** @ngInject */
    function BandoDialogController($mdDialog, Bando, Bandos, User, msUtils, msApi,$state,api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.bando = angular.copy(Bando);
        console.log(vm.bando);
        vm.bandos = Bandos;
        vm.user = User;
        vm.newBando = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.bando )
        {
          vm.evento = "new";
            vm.bando = {
                'id'      : null,
                'descrizione': null,
                'dataInizio': null,
                'dataFine': null,

            };
            vm.title = 'Nuovo Contatto';
            vm.newBando = true;

        }

        vm.bando.dataInizio=new Date(vm.bando.dataInizio);
        vm.bando.dataFine=new Date(vm.bando.dataFine);

        // Methods
        vm.saveBando = saveBando;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save Bando
         */
        function saveBando(ev,bando)
        {
          if (ev=="new") { api.bandi.bando.save(bando);}
          if (ev=="update"){ api.bandi.bando.aggiorna(bando);}
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */
        function deleteContactConfirm(bando, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il contatto?')
                .htmlContent('<b>' + bando.descrizione + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
                api.bandi.bando.remove({id: Bando.id});
                $state.reload();

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.core',
                    [
                        'ngAnimate',
                        'ngAria',
                        'ngCookies',
                        'ngMessages',
                        'ngResource',
                        'ngSanitize',
                        'ngMaterial',
                        'angular-chartist',
                        'chart.js',
                        'datatables',
                        'gridshore.c3js.chart',
                        'nvd3',
                        'pascalprecht.translate',
                        'timer',
                        'ui.router',
                        'uiGmapgoogle-maps',
                        'textAngular',
                        'ui.sortable',
                        'ng-sortable',
                        'xeditable',
                        'moment-picker',
                        'md.data.table',
                        'base64',
                        'ngPDFViewer',
                        'ngStorage',
                        'ngCookies',
                        'angular.filter'
                    ]);
})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbDocumentiStrutturaController', sprardbDocumentiStrutturaController)
            .directive('sprardbDocumentiStruttura', sprardbDocumentiStrutturaDirective);
    /** @ngInject */

    function sprardbDocumentiStrutturaController($scope, api, $mdToast, fuseGenerator, $mdDialog, $filter, $rootScope) {
        var vmd = this;
        vmd.api = api;

        vmd.step1 = true;
        vmd.step2 = false;
        vmd.d = {};
        vmd.contatore = 0;

        api.tipiModello = api.tipoModelloStruttura.query();
        vmd.tipiModello = api.tipiModello;

        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documenti = [];
        vmd.baseUrl = api.baseUrl;

        vmd.d.documentoTipos = [];
        vmd.d.params = {};
        vmd.d.sceglitipo = true;
        vmd.d.ngFlowOptions = {};
        vmd.d.ngFlow = {
            flow: {}
        };
        vmd.messageresult = "Files caricato correttamente!!";

        vmd.loadDT = loadDT;
        function loadDT() {
            //console.log("loadDT", vmd.uploadCfg);
            vmd.step1 = true;
            vmd.step2 = false;
            vmd.tipiModello = api.tipiModello;
            updateTipoModello();
            vmd.d = {};
            vmd.d.params = vmd.uploadCfg;
            if (vmd.uploadCfg.documentoTipo_id > 0) {
                vmd.d.sceglitipo = false;
            }
            vmd.d.ngFlowOptions = {
                target: api.baseUrl + 'documentos/upload-flow',
                chunkSize: 1 * 1024 * 1024,
                maxChunkRetries: 1,
                simultaneousUploads: 1,
                testChunks: false,
                progressCallbacksInterval: 1000,
                headers: {'Authorization': 'Basic ' + vmd.authb, 'X-Requested-With': 'XMLHttpRequest', },
                query: vmd.d.params //{documentoTipo_id: 3, progetto_id: 30},
            };
            vmd.d.ngFlow = {
                flow: {}
            };
            if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {

                var searchpayload = {};
                searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                    searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                }
                searchpayload.expand = 'key';

                api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                    vmd.documenti = d.data;
                    vmd.uploadCfg.caricato = angular.isUndefined(d.data.length) ? 0 : d.data.length;
                    checkDocumentiRichiesti();
                });
            }
        }
        vmd.reloadDT = reloadDT;
        function reloadDT() {

            vmd.step1 = true;
            vmd.step2 = false;
            vmd.tipiModello = api.tipiModello;
            updateTipoModello();
            vmd.messageresult = "File caricato correttamente!!";

            if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                var searchpayload = {};
                searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                    searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                }
                searchpayload.expand = 'key';
                api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                    vmd.documenti = d.data;
                    vmd.uploadCfg.tuttidocumenti = d.data.length;
                    vmd.uploadCfg.caricato = angular.isUndefined(d.data.length) ? 0 : d.data.length;
                    checkDocumentiRichiesti();
                });
            }
        }

        function numeroSufficiente() {
          return vmd.uploadCfg.caricato >= vmd.uploadCfg.mincaricato;
        }

        function mod1art22Caricato() {
          return $filter('filter')(vmd.documenti, {tipoModello_id: 4}).length > 0
        }

        function getTipoModello(tipoModello_id) {
          return $filter('filter')(api.tipiModello, {id: tipoModello_id})[0];
        }

        function checkDocumentiRichiesti()
        {
          if (mod1art22Caricato()) {
            vmd.uploadCfg.mincaricato = 2;

            if (!numeroSufficiente()) {
              vmd.tipiModello = $filter('filter')(api.tipiModello, {id: 4});
              vmd.d.params.tipoModello_id = 4;
              updateTipoModello();

              vmd.documenti.forEach(function (documento) {
                vmd.uploadCfg.tipiDocumento = $filter('filter')(vmd.uploadCfg.tipiDocumento, {id: '!'+documento.documento.documentoTipo_id});
              })
            }
          }
        }

        $scope.updateTipoModello = updateTipoModello;
        function updateTipoModello () {
          vmd.d.params.documentoTipo_id = null;
          var tipoModello = getTipoModello(vmd.d.params.tipoModello_id);
          if (tipoModello) {
            vmd.uploadCfg.tipiDocumento = tipoModello.tipiDocumento;
          }
        }


        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {

            vmd.step1 = false;
            vmd.step2 = true;

        }
        vmd.closeUpload = closeUpload;
        function closeUpload()
        {
            vmd.step1 = true;
            vmd.step2 = false;
            vmd.tipiModello = api.tipiModello;
            vmd.d.params.tipoModello_id = null;
        }


        vmd.d.closeDialog = closeDialog;
        function closeDialog()
        {
            vmd.step1 = true;
            vmd.step2 = false;
        }


        vmd.upload = upload;
        function upload()
        {
            console.log('upload');
            vmd.d.ngFlow.flow.upload();
        }

        vmd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            //console.log("FileAdded", file);
        }

        vmd.fileSuccess = fileSuccess;
        function fileSuccess(file, message)
        {

//            console.log('File Sucess');
//            console.log("File", file);
//            console.log("Message", message);
        }

        vmd.fileError = fileError;
        function fileError(file, message, flow)
        {
          var data = angular.fromJson(message);
          vmd.messageresult = 'Errore durante il caricamento';
          $rootScope.$broadcast('httpValidationError', data);
        }

        vmd.uploadComplete = uploadComplete;
        function uploadComplete() {
          vmd.d.params.tipoModello_id = null;
          $mdToast.show(
            $mdToast.simple()
            .textContent(vmd.messageresult)
            .position('bottom right')
            .hideDelay(3000)
          );
          reloadDT();
        }

    }

    function sprardbDocumentiStrutturaDirective($compile)
    {
        return {
            require: ['sprardbDocumentiStruttura', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                // tipiDocumento: '<',
                msModelType: '@?'
            },
            controller: 'sprardbDocumentiStrutturaController as vmd',
            transclude: true,
            templateUrl: 'app/main/sprardb/progetti/strutture/struttura/sprardb-documenti-struttura.html',
            link: function (scope, element, attrs, controllers, transclude)
            {

                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;

                ctrl.loadDT();

            }
        };

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.strutture', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_progetti_strutture', {
                    url: '/sprardb/strutture',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/strutture/strutture.html',
                            controller: 'StruttureController as vm'
                        }
                    }

                })
                .state('app.sprardb_progetti_strutture_struttura', {
                    url: '/strutture/struttura/:id/:progetto_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/progetti/strutture/struttura/dettaglios.html',
                            controller: 'DettagliosController as vm'
                        }
                    }
                    ,
                    resolve: {
                        locals: function ($stateParams) {
                            return {
                                dialog: false,
                                progetto_id: $stateParams.progetto_id,
                                struttura_id: $stateParams.id
                            }
                        }

                    }
                })

                ;


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/progetti/strutture');

        // Api
        msApiProvider.register('struttura', ['http://localhost/sprardb/app-server/web/strutturas/search']);
        msApiProvider.register('accoglienza', ['http://localhost/sprardb/app-server/web/strutturaaccoglienzas']);
        msApiProvider.register('alloggio', ['http://localhost/sprardb/app-server/web/strutturaalloggios']);

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.progetti.strutturelista', {
            title: 'Strutture accoglienza',
            icon: 'icon-hospital-building',
            state: 'app.sprardb_progetti_strutture',
            weight: 10
        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.strutture.new', {
//            title: 'Nuova Struttura',
//            icon: 'icon-plus-network',
//            state: 'app.sprardb_progetti_strutture_new',
//            weight: 2
//        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.strutture.enabled', {
//            title: 'Strutture attive',
//            icon: 'icon-select-inverse',
//            state: 'app.sprardb_progetti_strutture_en',
//            weight: 3
//        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.strutture.disabled', {
//            title: 'Strutture disattivate',
//            icon: 'icon-select-off',
//            state: 'app.sprardb_progetti_strutture_dis',
//            weight: 4
//        });
        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.strutture')
            .controller('DettagliosController', DettagliosController)
            .controller('DettaglioMcController', DettaglioMcController)
            .controller('DialogsController', DialogsController)
            .controller('DialogsEntiController', DialogsEntiController)
            .directive('datepickerValidationFix', datepickerValidationFix);

    function datepickerValidationFix() {
        return {
            restrict: 'A',
            require: 'mdDatepicker',
            link: function (scope, element, attrs, mdDatepickerCtrl) {
                // Fix to run validation when a datepicker's minDate changes
                // Bug #5938
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.minDate;
                }, function () {
                    if (mdDatepickerCtrl.dateUtil.isValidDate(mdDatepickerCtrl.date)) {
                        mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    }
                });
                // Fix to clear error state when setting date programatically from null
                // Bug #6086
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.date;
                }, function (newVal, oldVal) {

                    // if (newVal && !oldVal) {
                    mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    // }
                });
            }
        }
    }

    /** @ngInject */
    function DettagliosController($state, $document, $filter, api, msUtils, $mdDialog, $scope, locals, $mdToast)
    {
        var vm = this;
        vm.setupDate = setupDate;

        //deleted injects: Struttura,
        vm.parametricaricamento = {
            documentoTipo_id: 0,
            gruppo: 'STRUTTURA',
            dettaglio: false,
            dettagliomin: true,
            entita: 'struttura',
            entitakey: 'struttura_id',
            caricato: 0,
            mincaricato: 1,
            mostratutti: true

        }

        vm.struttura = {};
        //vm.struttura = angular.copy(Struttura.data[0]);
        var Struttura = {};
        vm.struttura_id = locals.struttura_id;
        vm.progetto_id = locals.progetto_id;
        vm.view = locals.view;
        vm.esterna = locals.esterna;
        vm.parametricaricamento.struttura_id = vm.struttura_id;
        vm.parametricaricamento.entita_id = vm.struttura_id;

        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.isnew = true;
        var Accoglienza = locals.Accoglienza;
        var Alloggio = locals.Alloggio;
        vm.accoglienzas = {};
        vm.alloggios = {};
        if (angular.isDefined(locals.Accoglienza)) {
            vm.accoglienzas = Accoglienza.data;
        }
        if (angular.isDefined(locals.Alloggio)) {
            vm.alloggios = Alloggio.data;
        }
        if (angular.isUndefined(locals.Accoglienza)) {
            api.strutturas.accoglienza.search({pagination: -1, sort: "descrizione"}, function (d) {
                Accoglienza = d;
                vm.accoglienzas = Accoglienza.data;
            });
        }
        if (angular.isUndefined(locals.Alloggio)) {
            api.strutturas.alloggio.search({pagination: -1, sort: "descrizione"}, function (d) {
                Alloggio = d;
                vm.alloggios = Alloggio.data;
            });
        }

        vm.provincias = [];
        vm.istats = [];
        vm.progettos = [];

        vm.newStruttura = false;
        vm.evento = 'update';
        vm.allFields = false;
        vm.search = '';
        vm.enteruolos = null;
        api.enteruolos.enteruolo.cerca({gruppo: 'STRUTTURA'}, function (response) {
            vm.enteruolos = response.data;
        });
        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
        });
        api.istats.province.get({pagination: 150}, function (response) {
            vm.provincias = response.data;
        });


        vm.loadstrutturas = function () {
            api.strutturas.struttura.get({
              id: vm.struttura_id,
              fields: "id,progetto_id,nome,indirizzo,codComune,strutturaAccoglienza_id,strutturaAlloggio_id,numeroPosti,numeroStanze,numeroIgienici,attivo,dataInizio,dataFine,id_alloggio,comePropostaProgettuale,istats,strutturahasentes,strutturahasbeneficiarios,strutturaAccoglienzas,strutturaAlloggios,strutturaextras,beneficiarios,progettos,tipoModelloStruttura_id",
              expand: 'documenti.key'
            }).$promise.then(function (response) {
                Struttura = response;
                vm.struttura = angular.copy(Struttura);
                vm.progettoInizio = new Date(vm.struttura.progettos.dataInizio);
                vm.progettoFine = new Date(vm.struttura.progettos.dataFine);
                vm.setupDate(vm.struttura);
                if (vm.parametricaricamento.caricato >= vm.parametricaricamento.mincaricato) {
                    vm.struttura.attivo = "1";
                }

                vm.links = response._links;
                vm.meta = response._meta;
                api.istats.istat.cerca({codProvincia: vm.struttura.istats.codProvincia, pagination: 400}, function (response) {
                    vm.istats = response.data;
                    vm.struttura.istats.provincia = vm.istats[0].codProvincia
                    vm.struttura.istats.regione = vm.istats[0].codRegione;
                });

                vm.struttura.beneficiariAttivi = 0;
                angular.forEach(vm.struttura.strutturahasbeneficiarios, function (shb) {
                    if (shb.dataCessazione == null || shb.dataCessazione == '0000-00-00') {
                        vm.struttura.beneficiariAttivi++;
                    }
                });
            }, function (response) {
            });
            return vm.struttura;
        };
        if (vm.struttura_id) {
            vm.isnew = false;
            vm.loadstrutturas();
        }

        vm.ricerca = {
            'bandos-id': null,
            'bandos-dataFine': null,
            'istats-regione': null,
            'postiLiberi': null,
            'attivo': null,
            'tags-id': null
        };
        vm.ricercalabel = {
            'bandos-id': 'Bando: ',
            'bandos-dataFine': 'Anno Bando: ',
            'istats-regione': 'Regione: ',
            'postiLiberi': 'Posti liberi: ',
            'attivo': 'Progetto attivo: ',
            'tags-id': 'Tag: '
        };
        vm.ricerca2 = {};
        vm.searched = false;
        vm.search2 = "";


        if (vm.isnew)
        {
            vm.struttura = {
                id: null,
                progetto_id: vm.progetto_id,
                nome: null,
                codComune: null,
                indirizzo: null,
                strutturaAccoglienza_id: null,
                strutturaAlloggio_id: null,
                numeroPosti: 0,
                numeroStanze: 0,
                numeroIgienici: 0,
                dataInizio: null,
                dataFine: null,
                //dataInizio2: null,
                //dataFine2: null,
                attivo: 0,
                daattivare: 1,
                comePropostaProgettuale: null,
                entes: [],
                documenti: [],
                progettos: {
                    id: null,
                    nome: locals.nomeProgetto
                },
                strutturaextras: [],
                istats: {
                    regione: null,
                    provincia: null,
                    comune: null,
                    codRegione: null,
                    codProvincia: null,
                    istat: null,
                    area: null
                },
                strutturaAccoglienzas: {
                    id: null,
                    descrizione: null
                },
                strutturaAlloggios: {
                    id: null,
                    descrizione: null
                },
                beneficiarios: [],
                strutturahasentes: []
            };
            vm.isnew = true;
            vm.evento = 'new';
            vm.title = 'Nuovo';
            vm.newStruttura = true;
        }
        //setting date


        if (vm.isnew && vm.progetto_id === "0") {
            //carico progetti per scelta
            api.progetti.progetto.get({fields: 'id,nome,codProvincia', pagination: 500}, function (response) {
                vm.progettos = response.data;
            });
        }
        if (vm.isnew && vm.progetto_id !== "0") {
            //carico regione e provincia da progetti
            var codprovincia = null;
            api.progetti.progetto.get({id: vm.struttura.progetto_id}, function (response) {
                vm.struttura.istats.regione = response.istats.regione;
                vm.struttura.istats.provincia = response.istats.provincia;
                vm.struttura.codComune = response.codComune;
                vm.progettoInizio = new Date(response.dataInizio);
                vm.progettoFine = new Date(response.dataFine);
                vm.setupDate();
                codprovincia = response.codProvincia;
                api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                    vm.istats = response.data;
                });
            });
        }


        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.caricaComuni = caricaComuni;
        vm.gotoStrutture = gotoStrutture;
        vm.saveStruttura = saveStruttura;
        vm.openDialog = openDialog;
        vm.openEntiDialog = openEntiDialog;
        vm.save = save;
        vm.delete = del;
        vm.controlloPosti = controlloPosti;

        function setupDate(s) {
            var oggi = new Date();
            var d120 = moment.duration({'days': 120});
            var a1 = moment.duration({'years': 1});
            var a10 = moment.duration({'years': 10});
            var a20 = moment.duration({'years': 20});
            vm.maxInizio = oggi;
            vm.minInizio = new Date(moment(oggi).subtract(d120).format('YYYY-MM-DD'));
            vm.maxFine = oggi;
            vm.minFine = new Date(moment(oggi).subtract(d120).format('YYYY-MM-DD'));


            if (vm.isnew) {
                vm.struttura.dataInizio = null;
                vm.struttura.dataFine = null;
            }
            if (vm.api.isAdmin || vm.api.isAccoglienza) {
                vm.maxInizio = new Date(moment(oggi).add(a1).format('YYYY-MM-DD'));
                vm.minInizio = new Date(moment(oggi).subtract(a20).format('YYYY-MM-DD'));
                vm.maxFine = new Date(moment(oggi).add(a1).format('YYYY-MM-DD'));
                vm.minFine = new Date(moment(oggi).subtract(a20).format('YYYY-MM-DD'));
            }
            if (vm.progettoInizio > vm.minInizio) {
                vm.minInizio = vm.progettoInizio;
            }
            if (s) {
                if (s.dataInizio !== null) {
                    vm.struttura.dataInizio = new Date(vm.struttura.dataInizio);
                    var di = moment(new Date(s.dataInizio));
                    if (di > moment(oggi).subtract(a1)) {
                        vm.minFine = new Date(di.format('YYYY-MM-DD'));
                    }
                } else {
                    vm.struttura.dataInizio = null;
                }
                if (s.dataFine !== null) {
                    vm.struttura.dataFine = new Date(vm.struttura.dataFine);
                } else {
                    vm.struttura.dataFine = null;
                }
                vm.struttura.wasDataFine = vm.struttura.dataFine;
            }

        }
        if (vm.isnew) {
            //setta date se è nuovo
            vm.setupDate();
        }


        vm.dataoggi = new Date();
        vm.m = moment(vm.dataoggi);
        vm.dataoggistring = vm.m.format("YYYY-MM-DD");
        vm.alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Processo')
                .textContent('Operazione Confermata.')
                .ariaLabel('conferma')
                .ok('OK');

        function caricaComuni(codProv) {

            api.istats.istat.cerca({codProvincia: codProv, pagination: 400}, function (response) {
                vm.istats = response.data;
            });

        }


        function saveStruttura(evento) {
            var struttura = vm.struttura;
            angular.forEach(struttura.entes, function (value, key) {
                delete struttura.entes[key]._links;
            });
            var m = moment(struttura.dataInizio2);
            struttura.dataInizio = m.format("YYYY-MM-DD");
            var m = moment(struttura.dataFine2);
            struttura.dataFine = m.format("YYYY-MM-DD");

            if (evento === 'update') {
              api.strutture.struttura.aggiorna(vm.struttura, function (response) {
                var hasmanyentes = {modelrelation: 'Strutturahasente', idname: 'struttura_id', idvalue: struttura.id, idnamefk: 'ente_id', idnamePayload: 'id', payload: struttura.entes};

                if (struttura.entes.length > 0) {
                  api.strutture.struttura.hasmany(hasmanyentes, function (response) {
                    $state.reload();
                  });
                } else {
                  $state.reload();
                }
              });
            }
            if (evento === 'new') {
                api.strutture.struttura.save(struttura, function (response) {
                    var struttid = response.id;
                    var hasmanyentes = {modelrelation: 'Strutturahasente', idname: 'struttura_id', idvalue: struttid, idnamefk: 'ente_id', idnamePayload: 'id', payload: struttura.entes};
                    if (struttura.entes.length > 0) {
                        api.strutture.struttura.hasmany(hasmanyentes, function (response) {
                          $state.go('app.sprardb_progetti_strutture_struttura', {id: struttid});
                        });
                    } else {
                      $state.go('app.sprardb_progetti_strutture_struttura', {id: struttid});
                    }
                });
            }
        }
        function gotoStrutture() {
            $state.go('app.sprardb_progetti_strutture');
        }
        function save() {
            var struttura = angular.copy(vm.struttura);
            var m = moment(struttura.dataInizio);
            struttura.dataInizio = m.format("YYYY-MM-DD");

            if (vm.parametricaricamento.caricato >= vm.parametricaricamento.mincaricato) {
                struttura.attivo = "1";
                struttura.daattivare = 0;
            } else {
                struttura.attivo = "0";
            }

            if (struttura.dataFine === null) {
                //struttura.dataFine = 'NULL';
            } else {
                var m = moment(struttura.dataFine);
                struttura.dataFine = m.format("YYYY-MM-DD");
                struttura.attivo = "0";
            }

            if (vm.isnew) {
                //nuovo
                api.strutture.struttura.save(struttura, function (response) {
                    if (locals.dialog) {
                      $mdToast.show(
                        $mdToast.simple()
                          .textContent('Struttura correttamente salvata. La troverete tra le strutture da attivare fino a quando non verranno allegati i documenti relativi')
                          .position('bottom right')
                          .hideDelay(10000)
                      ).then(
                        $mdDialog.cancel().then(
                          $state.reload()
                        )
                      );
                    } else {
                      $mdToast.show(
                        $mdToast.simple()
                          .textContent('Struttura correttamente salvata. La troverete tra le strutture da attivare fino a quando non verranno allegati i documenti relativi')
                          .position('bottom right')
                          .hideDelay(10000)
                      ).then(
                        $mdDialog.cancel().then(
                          vm.gotoStrutture()
                        )
                      );
                    }
                });
            }
            if (!vm.isnew) {
                //aggiorna
                api.strutture.struttura.aggiorna(struttura, function (response) {
                    $state.reload();
                });
            }

        }
        function del() {
            var struttura = vm.struttura;
            struttura.attivo = "0";
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare questa struttura?')
                    .htmlContent('<b>' + vm.struttura.nome + '</b>' + ' sarà disattivata.')
                    .ariaLabel('cancella persona')
                    .ok('OK')
                    .cancel('ABBANDONA');


            $mdDialog.show(confirm).then(function ()
            {
                api.strutture.struttura.aggiorna(struttura, function (response) {
                    $state.reload();
                });
            }, function () {
            });
        }

        function controlloPosti() {
            var progetto = {};
            api.progettos.progetto.get({id: vm.progetto_id}, function (response) {
                progetto = response;

            });

        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }


        /*
         vm.selectedItem = null;
         vm.searchText = null;
         vm.selectedItem2 = null;
         vm.searchText2 = null;
         vm.selectedItem3 = null;
         vm.searchText3 = null;
         vm.querySearch = querySearch;
         vm.transformChip = transformChip;

         function transformChip(chip) {
         // If it is an object, it's already a known chip
         if (angular.isObject(chip)) {
         return chip;
         }
         // Otherwise, create a new one
         return {name: chip, type: 'new'}
         }

         function querySearch(query, obj, nomecampo) {
         var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
         return results;
         }

         function createFilterFor(query, nomecampo) {
         //var lowercaseQuery = angular.lowercase(query);

         return function filterFn(collection) {
         return (collection[nomecampo].indexOf(query) === 0);
         };

         }
         */
        function openDialog(ev, struttura, index) {
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#struttura-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: struttura,
                    index: index,
                    tabella: 'struttura'
                }
            });
        }
        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.enteruolos.enteruolo.cerca({gruppo: 'STRUTTURA'}, function (response) {
                vm.tempruolo = response;
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    $mdDialog.show({
                        controller: 'DialogsEntiController',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Struttura: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }

    }

    function DettaglioMcController($state, $document, $filter, api, msUtils, $mdDialog, $scope, locals, $mdToast){
      var vm = this;
      vm.api = api;

      vm.loadstrutturas = loadstrutturas;
      vm.save = save;
      vm.closeDialog = closeDialog;
      vm.caricaComuni = caricaComuni;
      vm.isDisabled = isDisabled;

      vm.struttura_id = locals.struttura_id;
      vm.esterna = locals.esterna;

      vm.parametricaricamento = {
        documentoTipo_id: 0,
        gruppo: 'STRUTTURA',
        dettaglio: false,
        dettagliomin: true,
        entita: 'struttura',
        entitakey: 'struttura_id',
        caricato: 0,
        mincaricato: 1,
        mostratutti: true,
        struttura_id : vm.struttura_id,
        entita_id : vm.struttura_id
      }

      vm.struttura = {
        id: locals.struttura_id,
        isNewModel: true,
        progetto_id: locals.progetto_id,
        safeAttributes: ['nome','indirizzo','codComune','strutturaAccoglienza_id','strutturaAlloggio_id','numeroPosti','numeroStanze','numeroIgienici','dataInizio','dataFine','destinazione'],
        destinazione: null,
        dataInizio: new Date(),
        dataFine: null,
        attivo: 0
      }

      vm.currDate = new Date();

      vm.destinazioni = api.destinazione.query();

      vm.accoglienze = locals.Accoglienza.data;
      vm.alloggi = locals.Alloggio.data;

      api.istats.regioni.get({}, function (response) {
        vm.regiones = response.data;
      });
      api.istats.province.get({pagination: 150}, function (response) {
        vm.provincias = response.data;
      });

      if (vm.struttura_id) {
        loadstrutturas();
      }

      function loadstrutturas() {
        api.strutturaMc.get({
          id: vm.struttura_id,
          expand: 'documenti.key,progetto.nome,safeAttributes'
        }, function (res) {
          vm.struttura = res;
          vm.struttura.dataInizio = new Date(res.dataInizio);
          vm.struttura.dataFine = res.dataFine ? new Date(res.dataFine) : null;
        });
      }

      function save()
      {
        var struttura = angular.copy(vm.struttura);
        console.log(api.hasgroup);

        struttura.dataInizio = struttura.dataInizio.toISOString().substring(0,10);
        if (struttura.dataFine) {
          struttura.dataFine =  struttura.dataFine.toISOString().substring(0,10);
        }

        struttura.esterna = vm.esterna;
        if (vm.esterna && vm.struttura_id === undefined){
          struttura.attivo = 1;
          api.strutturaMc.saveEsterna(struttura,function (response) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Struttura esterna correttamente salvata.')
                .hideDelay(10000)
            ).then(
              $mdDialog.hide()
            );
          },function (res) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Errore salvataggio struttura esterna.')
                .hideDelay(10000)
            );
          });
        }else{
          api.strutturaMc.save(struttura, function (response) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Struttura correttamente salvata.' + (struttura.isNewModel ? ' La troverete tra le strutture da attivare fino a quando non verranno allegati i documenti relativi' : ''))
                .position('bottom right')
                .hideDelay(10000)
            ).then(
              $mdDialog.hide()
            );
          });
        }
      }

      function caricaComuni(codProv) {
        api.istats.istat.cerca({codProvincia: codProv, pagination: 400}, function (response) {
          vm.istats = response.data;
        });
      }

      function closeDialog()
      {
        $mdDialog.cancel();
      }

      function isDisabled(attribute)
      {
        return vm.struttura.safeAttributes.indexOf(attribute) === -1;
      }

      $scope.filtraId = function (item) {
        if (vm.esterna){
          return ['RESETTLEMENT','AMPLIAMENTO AFGHANI/UCRAINI'].indexOf(item.descrizione) === -1;
        }
        return  ['ACCOGLIENZA AFGHANI/UCRAINI'].indexOf(item.descrizione) === -1;
      }


    }


    /** @ngInject */

    function DialogsController($scope, $state, $mdDialog, struttura, api, index)
    {
        var vmd = this;
        vmd.strutturaextras = angular.copy(struttura.strutturaextras);
        vmd.isnew = true;
        vmd.extra = {
            id: null,
            chiave: null,
            valore: null,
            struttura_id: struttura.id
        };

        if (index !== null) {
            vmd.isnew = false;
            vmd.extra = {
                id: vmd.strutturaextras[index].id,
                chiave: vmd.strutturaextras[index].chiave,
                valore: vmd.strutturaextras[index].valore,
                struttura_id: vmd.strutturaextras[index].struttura_id
            };
        }

        vmd.saveExtra = saveExtra;
        vmd.deleteExtra = deleteExtra;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function saveExtra() {
            if (vmd.isnew) {
                api.strutture.extra.save(vmd.extra, function (response) {
                    $state.reload();
                    $scope.hide();
                });
            }
            if (!vmd.isnew) {
                api.strutture.extra.aggiorna(vmd.extra, function (response) {

                    $state.reload();
                    $scope.hide();
                });
            }

        }
        function deleteExtra() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('<b>' + vmd.extra.chiave + ' ' + vmd.extra.valore + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella extra')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {
                api.strutture.extra.delete(vmd.extra, function (response) {

                    $scope.hide();
                    $state.reload();
                });
            }, function () {
            });

            $mdDialog.show({
                controller: 'DialogsController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#struttura-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    struttura: struttura,
                    index: index,
                }
            });
        }
    }

    function DialogsEntiController($scope, $state, $mdDialog, Struttura, api, AllRuolo, index, AllEnteTipo, Regioni, newlink)
    {
        var vmd = this;
        vmd.struttura_id = Struttura.id;
        vmd.index = index;
        vmd.progetto_nome = Struttura.nome;
        vmd.ente_id = null;
        vmd.ente_nome = null;
        vmd.entes = angular.copy(Struttura.entes);
        vmd.ente = {
            id: null,
            enteTipo_id: null,
            enteTipoPadre_id: null,
            nome: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            attivo: '1',
            enteruolos: [],
        };
        vmd.allentes = {};
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewente = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewente = true;
        }
        vmd.ruolosSelected = [];

        if (vmd.index !== null) {
            vmd.ente_id = Struttura.entes[index].id;
            vmd.ente_nome = Struttura.entes[index].nome;
            vmd.ente = angular.copy(Struttura.entes[index]);
            angular.forEach(Struttura.strutturahasentes, function (obj) {
                if ((vmd.ente.id) == obj.ente_id) {
                    vmd.ruolosSelected.push(obj.enteRuolo_id);
                }
            });
        }
        vmd.allentetipos = AllEnteTipo.data;
        vmd.allruolo = AllRuolo.data;
        vmd.regiones = Regioni;
        vmd.provincias = [];
        vmd.istats = [];


        vmd.progettohasente = {
            struttura_id: vmd.struttura_id,
            ente_id: vmd.ente_id,
        };

        vmd.ricerca = {
            nome: null,
            enteTipo_id: null,
            codRegione: null,
        };
        vmd.enteselezionato = {
            id: null
        };


        vmd.save = save;
        vmd.delete = del;
        vmd.cercaEnte = cercaEnte;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.restituisciEnte = restituisciEnte;
        if (vmd.ente.codRegione !== null || vmd.ente.codRegione !== '') {
            //vmd.caricaProvince(vmd.ente.codRegione);
        }
        if (vmd.ente.codProvincia !== null || vmd.ente.codProvincia !== '') {
            //vmd.caricaComuni(vmd.ente.codProvincia);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaEnte() {
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.entes.ente.like(vmd.ricerca, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.entes.ente.get({}, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
        }
        function restituisciEnte() {
            api.entes.ente.get({id: vmd.enteselezionato.id}, function (response) {
                vmd.enteselezionato = response;
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(Struttura.strutturahasentes, function (obj2) {
                var pushpayload = {
                    struttura_id: obj2.struttura_id,
                    ente_id: obj2.ente_id,
                    enteRuolo_id: obj2.enteRuolo_id};
                payload.push(pushpayload);
            });

            if (!vmd.isnewente && !vmd.newlink) {
                //modifica
                //vmd.entes.splice(vmd.index, 1);
                payload = [];
                angular.forEach(Struttura.strutturahasentes, function (obj2) {
                    if ((vmd.entes[vmd.index].id) != obj2.ente_id) {
                        var pushpayload = {
                            struttura_id: obj2.struttura_id,
                            ente_id: obj2.ente_id,
                            enteRuolo_id: obj2.enteRuolo_id};
                        payload.push(pushpayload);
                    }
                });
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewente && !vmd.newlink) {
                //nuova entita
                api.entes.ente.save(vmd.ente, function (response) {
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            struttura_id: vmd.struttura_id,
                            ente_id: response.id,
                            enteRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanyentes = {
                        modelrelation: 'Strutturahasente',
                        idname: 'struttura_id',
                        idvalue: vmd.struttura_id,
                        idnamefk: 'ente_id',
                        idnamefk2: 'enteRuolo_id',
                        idnamePayload: 'ente_id',
                        payload: payload
                    };
                    api.entes.ente.hasmany(hasmanyentes, function (response) {

                        $state.reload();
                        $scope.hide();
                    });
                });
            }

            if (vmd.newlink) {
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        struttura_id: vmd.struttura_id,
                        ente_id: vmd.enteselezionato.id,
                        enteRuolo_id: ruolo};
                    payload.push(pushpayload);
                });
                var hasmanyentes = {
                    modelrelation: 'Strutturahasente',
                    idname: 'struttura_id',
                    idvalue: vmd.struttura_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'enteRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload
                };
                api.entes.ente.hasmany(hasmanyentes, function (response) {

                    $state.reload();
                    $scope.hide();
                });

            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella ente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                //vmd.entes.splice(vmd.index, 1);
                var payload = [];
                angular.forEach(Struttura.strutturahasentes, function (obj2) {
                    if ((vmd.entes[vmd.index].id) != obj2.ente_id) {
                        var pushpayload = {
                            struttura_id: obj2.struttura_id,
                            ente_id: obj2.ente_id,
                            enteRuolo_id: obj2.enteRuolo_id};
                        payload.push(pushpayload);
                    }
                });
                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                var hasmanyentes = {
                    modelrelation: 'Strutturahasente',
                    idname: 'struttura_id',
                    idvalue: vmd.struttura_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'enteRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload
                };
                api.entes.ente.hasmany(hasmanyentes, function (response) {

                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });

        }

        vmd.selectedItem = null;
        vmd.searchText = null;
        vmd.selectedItem2 = null;
        vmd.searchText2 = null;
        vmd.selectedItem3 = null;
        vmd.searchText3 = null;
        vmd.querySearch = querySearch;
        vmd.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }


    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.progetti')
            .controller('ProgettoController', ProgettoController);

    /** @ngInject */
    function ProgettoController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api)
    {
        var vm = this;
        // Data
        console.log($state.params.id);
        
//        api.progetti.progetto.get({},function (response){
//            vm.Progetti=response;
//            vm.contacts=response.data;
//            vm.links=response._links;
//            vm.meta=response._meta;
//        });

        // Methods
       
        
        
        
        //////////
        

    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.progetti')
            .controller('DettaglioController', DettaglioController)
            .controller('DialogController', DialogController)
            .controller('DialogCorsiController', DialogCorsiController)
            .controller('DialogClonaCorsiController', DialogClonaCorsiController)
            .controller('DialogClonaServiziController', DialogClonaServiziController)
            .controller('DialogAssCorsiBenController',DialogAssCorsiBenController)
            .controller('DialogAssServiziBenController',DialogAssServiziBenController)
            .controller('DialogServiziController', DialogServiziController)
            .controller('DialogPersoneController', DialogPersoneController)
            .controller('DialogRevisoreController', DialogRevisoreController)
            .controller('DialogPersoneNewController', DialogPersoneNewController)
            .controller('DialogPersoneAttivaController', DialogPersoneAttivaController)
            .controller('DialogEntiController', DialogEntiController)
            .controller('DialogRegisterController', DialogRegisterController)
            .controller('DialogProfiloNewController', DialogProfiloNewController)
            .controller('DialogProgettoEntiController', DialogProgettoEntiController)
            .filter('sommaDi', sommaDi)
            .filter('filterByArray', filterByArray)
            .filter('filtraRuoliProgetto', filtraRuoliProgetto)
            .filter('filterByArray2', filterByArray2);

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }
    function filterByArray2($filter) {
        return function (list, arrayFilter, element, collection) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter && list) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[collection][element]) != -1;
                });
            }

        };
    }
    function sommaDi() {
        return function (data, arr) {
            var key = arr[0];
            var satt = arr[1];
            var sdatt = arr[2];
            if (angular.isUndefined(data) || angular.isUndefined(key))
                return 0;
            var sum = 0;
            angular.forEach(data, function (value) {
                if (angular.isDefined(satt) && value['attivo'] == satt) {
                    sum = sum + parseInt(value[key], 10);
                }
                if (angular.isDefined(sdatt) && value['daattivare'] == sdatt) {
                    sum = sum + parseInt(value[key], 10);
                }
                if (angular.isUndefined(satt) && angular.isUndefined(sdatt)) {
                    sum = sum + parseInt(value[key], 10);
                }

            });
            return sum;
        }
    }

    function filtraRuoliProgetto($filter) {
      return function (list, ruoli) {

        if (ruoli.length === 0) {
          return list;
        }
        if (ruoli && list) {
          return $filter("filter")(list, function (enti) {
            var filtra = false;
            angular.forEach(enti.progettohasentes, function(progettohasente) {
              if(ruoli.includes(progettohasente.enteRuolo_id)) {
                filtra = true;
              }
            })
            return filtra;
          });
        }
      };
    }

    /** @ngInject */
    function DettaglioController($scope, $state, $document, $filter, api, msUtils, $mdDialog, $stateParams, $mdToast, ricerca, eventi, acl)
    {
        //deleted injects: Progetto, Tags, Bandi
        var vm = this;
        $scope.cancelDialog = $mdDialog.cancel;
        vm.uploadParams = {
            documentoTipo_id: 0,
            gruppo: 'PROGETTO',
            dettaglio: true,
            entita: 'progetto',
            entitakey: 'progetto_id'
        };
        vm.isAdmin = api.isAdmin;
        vm.isOperatore = api.isOperatoreG;
        vm.isReadOnly = api.isReadOnly;
        vm.isVisitatore = api.isVisitatore;
        vm.isRevisore = api.isRevisore;
        vm.isTutor = api.isTutor;
        vm.canSeeRevisoreTab = vm.isReadOnly || vm.isAdmin;
        vm.api = api;
        vm.isallowed = acl.isallowed;
        ricerca.reloadCS();
        vm.enteruoloprogetto = ricerca.enteruoloprogettos;
        vm.personaruoloprogettos = ricerca.personaruoloprogettos;
        vm.personaruoloentes = ricerca.personaruoloentes;
        vm.personaruoloambitos = ricerca.personaruoloambitos;
        vm.oggi = new Date();
        vm.maggiorenne = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.centanni = new Date((vm.oggi.getFullYear() - 100) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.gestionediretta = 0;
        vm.corsicat = ricerca.corsicategoria;
        vm.servizicat = ricerca.servizicategoria;
        vm.modificaDisabilitata = true;
        vm.sino = ricerca.sino;
        vm.booleanOptions = [
          {id: 1, label: 'Sì'},
          {id: 0, label: 'No'},
        ];
        vm.searchOperatore = {
          attivo: 1,
          credenziali: null
        }
        $scope.entiPerNuovoProgetto=[];

        vm.canTitolare = vm.isAdmin || vm.isTutor || vm.api.isAccoglienza || vm.api.isSegreteria || vm.api.isRendicontazione;

        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipologieAccoglienza = res.data;
        });
        vm.ricerca = ricerca;
        vm.regiones = ricerca.regiones;

        vm.years = [
            {id: ""},
            {id: (new Date()).getFullYear()},
            {id: (new Date()).getFullYear() - 1},
            {id: (new Date()).getFullYear() - 2},
            {id: (new Date()).getFullYear() - 3},
            {id: (new Date()).getFullYear() - 4}
        ];

        vm.sersearchYear = new Date().getFullYear();
        vm.corsearchYear = new Date().getFullYear();

        vm.ren = {
            entita1_id: $stateParams.id,
            entita2_id: 0,
            progetto_id: $stateParams.id,
            eventoFiltro: {crea: 1, id_IN: "4000,4001,4002,4003,4004,4005,4006,4007,4008,4009,4010", sort: "nome"},
            titolo: "Nuovo evento rendicontazione"
        };
        vm.mon = {
            entita1_id: $stateParams.id,
            entita2_id: $stateParams.id,
            progetto_id: $stateParams.id,
            monitoraggio_id: 0,
            eventoFiltro: {crea: 1, id_IN: "5000", sort: "nome"},
            titolo: "Nuovo evento monitoraggio"
        };

        vm.colors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg', 'md-orange-800-bg'];
        vm.icons = ['icon-drag', 'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close', 'icon-exclamation'];
        vm.today = new Date();
        vm.todayToEnd = new Date(new Date(vm.today).setMonth(vm.today.getMonth() + 36));
        //inizializzo progetto se modifica verrà sovrascritto
        if (!vm.progetto)
        {
            vm.isnew = true;
            vm.progetto = {
                id: null,
                nome: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataInizio: moment(vm.today).format("YYYY-MM-DD"),
                dataFine: moment(vm.todayToEnd).format("YYYY-MM-DD"),
                dataInizio2: null,
                dataFine2: null,
                durata: null,
                budget: 0,
                operatori: null,
                postiTotali: null,
                postiFinanziati: null,
                postiRiservatiSC: 0,
                postiAsilo: null,
                postiUmanitari: null,
                postiRifugiati: null,
                postiLiberi: null,
                attivo: -1,
                bandi: [],
                enti: [],
                strutture: [],
                documenti: [],
                tags: [],
                progettoextra: [],
                bandosIds: []
            };
            vm.progetto.tags = [];
        }
        vm.progetto.dataInizio2 = new Date(vm.progetto.dataInizio);
        vm.progetto.dataFine2 = new Date(vm.progetto.dataFine);

        var Progetto = {};
        vm.loadprogettos = function () {
            api.progettomc.get({id: $stateParams.id, expand:'enti.progettohasentes.enteruolo'}, function (response) {
                Progetto = response;
                vm.progetto = angular.copy(Progetto);

                loadStrutture();
                loadCorsi();
                loadServizi();

                vm.cercaOperatore();
                vm.getRevisori();
                vm.progetto.personas.$promise.then(function (data) {
                    // Ora posso accedere ai dati
                    vm.persone = data;
                });

                vm.links = response._links;
                vm.meta = response._meta;
                vm.ren = {
                    entita1_id: vm.progetto.id,
                    entita2_id: 0,
                    progetto_id: vm.progetto.id,
                    eventoFiltro: {crea: 1, id_IN: "4000,4001,4002,4003,4004,4005,4006,4007,4008,4009,4010", sort: "nome"},
                    titolo: "Nuovo evento rendicontazione"
                };
                vm.mon = {
                    entita1_id: vm.progetto.id,
                    entita2_id: vm.progetto.id,
                    progetto_id: vm.progetto.id,
                    monitoraggio_id: 0,
                    eventoFiltro: {crea: 1, id_IN: "5000", sort: "nome"},
                    titolo: "Nuovo evento monitoraggio"
                };

                if (vm.progetto.codRegione) {
                    vm.caricaProvince(vm.progetto.codRegione);
                    if (vm.progetto.codProvincia) {
                        vm.caricaComuni(vm.progetto.codProvincia);
                    }
                }
                // if (vm.progetto.codRegione !== null || vm.progetto.codRegione !== '') {
                //     api.istats.province.get({codRegione: vm.progetto.codRegione}, function (response) {
                //         vm.provincias = response.data;
                //         if (vm.progetto.codProvincia !== null || vm.progetto.codProvincia !== '') {
                //             api.istats.istat.cerca({codProvincia: vm.progetto.codProvincia, pagination: 400}, function (response) {
                //                 vm.istats = response.data;
                //             });
                //         }
                //     });
                //     //vm.caricaProvince(vm.progetto.codRegione);
                // }

                vm.progetto.dataInizio2 = new Date(vm.progetto.dataInizio);
                vm.progetto.dataFine2 = new Date(vm.progetto.dataFine);
                vm.progetto.bandosIds = [];
                angular.forEach(vm.progetto.bandi, function (bobj) {
                    vm.progetto.bandosIds.push(bobj.id);
                });

                vm.uploadParams.progetto_id = vm.progetto.id;
                vm.uploadParams.entita_id = vm.progetto.id;

                vm.modificaDisabilitata = (!vm.isnew && vm.progetto.attivo >= 0);
                if (vm.api.isAdmin) {//|| vm.api.isAccoglienza) {
                    vm.modificaDisabilitata = false;
                }

            });

            return vm.progetto;
        };

        vm.mostraRuoliProgetto = function (ev, ente) {
          $scope.ente = ente;
          $mdDialog.show({
            templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/dialogMostraRuoliProgettoEnti.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            scope: $scope,
            preserveScope: true,
          });
        }

        vm.getRevisori = function(){
          api.progettomc.revisori({id: $stateParams.id, expand: 'persona.user'}, function (data) {
            vm.progetto.revisori = data;
            vm.revisori = {};
            angular.forEach(vm.progetto.revisori, function(value) {
              /*if (!value.attivo){
                return;
              }*/
              if(vm.revisori[value.persona_id] !== undefined) {
                if (value.attivo){
                  vm.revisori[value.persona_id].anni.push(value.anno);
                }
              }else{
                value.anni = value.attivo?[value.anno]:[];
                vm.revisori[value.persona_id] = value;
              }
            });
          });
        }
        if ($stateParams.id) {
            vm.isnew = false;
            vm.loadprogettos();
        }

        var Tags = {};
        vm.loadtags = function () {
            /*api.tags.tag.get().$promise.then(function (response) {
                Tags = response.data;
                vm.tags = response.data;
            }, function (response) {
                console.log(response);
            });
            return vm.tags;*/
        };
        //vm.loadtags();
        //vm.tags = Tags.data;

        vm.provincias = [];
        vm.istats = [];
        vm.allFields = false;
        vm.search = '';
        vm.payloadsToStore = [];
        vm.searchCorsi = {
          page: 1,
          'per-page': 20
        }

        vm.searchServizi = {
          page: 1,
          'per-page': 20
        }


        vm.deleteProgettoConfirm = deleteProgettoConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.tagchip = tagchip;
        vm.descrizionechip = descrizionechip;
        vm.gotoProgetti = gotoProgetti;
        vm.gotoDettaglios = gotoDettaglios;
        vm.saveProgetto = saveProgetto;
        vm.edited = edited;
        vm.openDialog = openDialog;
        vm.openDialogEditStruttura = openDialogEditStruttura;
        vm.openDialogNewStruttura = openDialogNewStruttura;
        vm.openCorsiDialog = openCorsiDialog;
        vm.openAssCorsiBenDialog = openAssCorsiBenDialog;
        vm.openAssServiziBenDialog = openAssServiziBenDialog;
        vm.openClonaCorsiDialog = openClonaCorsiDialog;
        vm.openClonaServiziDialog = openClonaServiziDialog;
        vm.openServiziDialog = openServiziDialog;
        vm.openEntiDialog = openEntiDialog;
        vm.createProgettoEnti = createProgettoEnti;
        vm.openPersoneDialog = openPersoneDialog;
        vm.openRevisoriDialog = openRevisoriDialog;
        vm.openPersoneAttivaDialog = openPersoneAttivaDialog;
        vm.cambiaFiltroStruttura = cambiaFiltroStruttura;
        vm.restituisciPersona = restituisciPersona;
        vm.calcolaTotaliStrutture = calcolaTotaliStrutture;
        vm.calcolatoRP = [];
        vm.round = round;
        vm.filtraRuoli = filtraRuoli;
        vm.openProgettoEnti = openProgettoEnti;
        vm.cercaOperatore = cercaOperatore;
        vm.openOperatoreDialog = openOperatoreDialog;
        vm.loadCorsi = loadCorsi;
        vm.loadServizi = loadServizi;

        function loadEnti()
        {
          if($stateParams.id) {
            api.progettomc.get({id: $stateParams.id, fields:'enti', expand:'enti.progettohasentes.enteruolo'}, function (response) {
              vm.progetto.enti = [];
              angular.merge(vm.progetto.enti, response.enti);
            });
          }

        }

        function loadCorsi() {
          vm.progetto.corsos = api.progettomc.hascorsi.index(angular.merge({}, {filter: {and: [{progetto_id: $stateParams.id}, {dataInizio: {xlike: vm.corsearchYear+'%'}}]}}, vm.searchCorsi), function (response) {
            vm.totalCountCorsi = response._meta.totalCount;
          });
        }

      function loadServizi() {
        vm.progetto.servizios = api.progettomc.hasservizi.index(angular.merge({}, {filter: {and: [{progetto_id: $stateParams.id}, {dataInizio: {xlike: vm.sersearchYear+'%'}}]}}, vm.searchServizi), function (response) {
          vm.totalCountServizi = response._meta.totalCount;
        });
      }

        function filtraRuoli(value, index, array)
        {
          return [1,8].contains(value.enteRuolo_id);
        }

        function loadStrutture()
        {
          api.progettomc.strutture({id: vm.progetto.id, expand:'strutturaAccoglienza,strutturaAlloggio'}, function (data) {
            vm.progetto.strutturas = data;

            vm.calcolaTotaliStrutture();
          });
        }

        function round(decimal) {
            console.log("decimal", decimal);
            console.log(Math.round(decimal));
            return Math.round(decimal);
        }

        function restituisciPersona(pid) {
            if (vm.calcolaRP) {
                vm.calcolaRP = false;
                api.personas.persona.get({id: pid}, function (response) {
                    var personaselezionato = response;
                    var personaHasProgettos = angular.copy(personaselezionato.personahasprogettos);
                    var php;
                    var esito = {};

                    angular.forEach(personaHasProgettos, function (obj) {
                        if (obj.progetto_id == vm.progetto.id && obj.loginAttiva == 1) {
                            vm.calcolaRP = true;
                            return 1;
                        }
                    });
                });
                vm.calcolaRP = true;
                return 0;
            }
        }


        //vm.docmancanti = null;
        //vm.satt = null;
        vm.filtros = 1;
        vm.satt = 1;
        vm.sesterna = 0;
        function cambiaFiltroStruttura(valore) {
            //filtri su due valori. vm.satt e vm.attach
            switch (valore) {
                case "0":
                    vm.sdatt = 0;
                    vm.satt = 0;
                    vm.sesterna = 0;
                    break;
                case "1":
                    delete(vm.sdatt);
                    vm.satt = 1;
                    vm.sesterna = 0;
                    break;
                case "-1":
                    delete(vm.sdatt);
                    delete(vm.satt);
                    delete(vm.sesterna);
                    break;
                case "2":
                    delete(vm.satt);
                    vm.sdatt = 1;
                    vm.sesterna = 0;
                    break;
                case "3":
                    delete(vm.sdatt);
                    vm.sesterna = 1;
                    vm.satt = 1;
                    break;

                case "4":
                  delete(vm.sdatt);
                  vm.sesterna = 1;
                  vm.satt = 0;
                  break;
                default:

            }
            vm.calcolaTotaliStrutture();
        }

        function calcolaTotaliStrutture() {
            var strutture = vm.progetto.strutturas;

            strutture = angular.isDefined(vm.ssearch) ? $filter('filter')(strutture, {nome:vm.ssearch}) : strutture;
            strutture = angular.isDefined(vm.satt) ? $filter('filter')(strutture, {attivo:vm.satt}) : strutture;
            strutture = angular.isDefined(vm.sdatt) ? $filter('filter')(strutture, {daattivare:vm.sdatt}) : strutture;
            strutture = angular.isDefined(vm.sesterna) ? $filter('filter')(strutture, {esterna:vm.sesterna}) : strutture;

            vm.progetto.totalePostiStrutture = 0;
            vm.progetto.totalePostiOccupati = 0;

            angular.forEach(strutture, function(struttura) {
                vm.progetto.totalePostiStrutture += parseInt(struttura.numeroPosti);
                vm.progetto.totalePostiOccupati += parseInt(struttura.numeroBeneficiariPresenti);
            });
        }

        function openRevisoriDialog(ev, progetto, index, newlink) {
          $mdDialog.show({
            controller: 'DialogRevisoreController',
            controllerAs: 'vmd',
            templateUrl: 'app/main/sprardb/form/dialogRevisoreForm.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              Progetto: progetto,
              index: index,
              newlink: newlink
            }
          }).finally(function(){
            vm.getRevisori();
          });
        }
        vm.work = eventi.work;//work;
        function work(event, segnalato, processo, trigger, isnew) {
            console.log('---vm.work');
            var extrasetup = {};
            var callback = {};
            var segnalatos = [];
            if (angular.isArray(segnalato)) {
                segnalatos = segnalato;
                extrasetup = JSON.parse(segnalato[0].eventoTipo.extra);
                callback = JSON.parse(segnalato[0].eventoTipo.callback);
            } else {
                segnalatos.push(segnalato);
                extrasetup = JSON.parse(segnalato.eventoTipo.extra);
                callback = JSON.parse(segnalato.eventoTipo.callback);
            }

            var formDefinition = extrasetup.properties[processo].fields;
            var title = extrasetup.properties[processo].title;
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'ProcessosController',
                controllerAs: 'vm',
                focusOnOpen: true,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {
                    segnalati: segnalatos,
                    formDefinition: formDefinition,
                    title: title,
                    eventoStato_id: processo
                },
                templateUrl: 'app/main/sprardb/eventi/dialogs/processosc.html',
            });
        }
        function edited() {
            //return angular.equals(Progetto.data[0], vm.progetto);
            return angular.equals(Progetto, vm.progetto);
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //console.log("vm.istats:", vm.istats);
                //vm.progetto.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.progetto.codProvincia = null;
                //vm.progetto.codComune = null;
                vm.istats = {};
            });
        }
        function tagchip(chip) {
            return {
                tag: chip
            }
        }
        function descrizionechip(chip) {
            return {
                descrizione: chip
            }
        }

        function saveProgetto(evento) {

            //vm.payloadsToStore

            console.log(evento);
            var progetto = vm.progetto;
            progetto.bandos = [];

            angular.forEach(vm.progetto.bandosIds, function (value, key) {
                progetto.bandos.push({id: value});
            });
            angular.forEach(progetto.tags, function (value, key) {
                delete progetto.tags[key]._links;
            });


            var m = moment(progetto.dataInizio2);
            progetto.dataInizio = m.format("YYYY-MM-DD");
            var m = moment(progetto.dataFine2);
            progetto.dataFine = m.format("YYYY-MM-DD");
            console.log(progetto);
            var payload = [];
            var pushpayload = {};
            var hasmanyentes = {};
            if (evento === false) {

                angular.forEach(vm.payloadsToStore, function (objente) {
                    vm.erp = $filter('filter')(vm.enteruoloprogetto, {id: objente.enteRuolo_id})[0];
                    pushpayload = {
                        progetto_id: progetto.id,
                        ente_id: objente.ente_id,
                        enteRuolo_id: objente.enteRuolo_id,
                        ruolo: vm.erp.descrizione};
                    payload.push(pushpayload);
                });
                hasmanyentes = {
                    modelrelation: 'Progettohasente',
                    idname: 'progetto_id',
                    idvalue: progetto.id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'enteRuolo_id',
                    idnamePayload: 'ente_id',
                    extrafields: ["ruolo"],
                    payload: payload
                };
                api.progetti.progetto.aggiorna(vm.progetto, function (response) {
                    var hasmanytags = {modelrelation: 'Progettohastag', idname: 'progetto_id', idvalue: progetto.id, idnamefk: 'tag_id', idnamePayload: 'id', payload: progetto.tags};
                    var hasmanybandos = {modelrelation: 'Progettohasbando', idname: 'progetto_id', idvalue: progetto.id, idnamefk: 'bando_id', idnamePayload: 'id', payload: progetto.bandos};
                    api.progetti.progetto.hasmany(hasmanybandos, function (response) {
                        console.log('many bando');
                        $state.reload();

                    });
                });
            }
            if (evento === true) {
                api.progettomc.save(progetto, function (response) {
                    console.log('response save');
                    console.log(response);
                    var progid = response.id;
                    var hasmanytags = {modelrelation: 'Progettohastag', idname: 'progetto_id', idvalue: response.id, idnamefk: 'tag_id', idnamePayload: 'id', payload: progetto.tags};
                    var hasmanybandos = {modelrelation: 'Progettohasbando', idname: 'progetto_id', idvalue: response.id, idnamefk: 'bando_id', idnamePayload: 'id', payload: progetto.bandos};
                    angular.forEach(vm.payloadsToStore, function (objente) {
                        vm.erp = $filter('filter')(vm.enteruoloprogetto, {id: objente.enteRuolo_id})[0];
                        pushpayload = {
                            progetto_id: response.id,
                            ente_id: objente.ente_id,
                            enteRuolo_id: objente.enteRuolo_id,
                            ruolo: vm.erp.descrizione};
                        payload.push(pushpayload);
                    });
                    hasmanyentes = {
                        modelrelation: 'Progettohasente',
                        idname: 'progetto_id',
                        idvalue: response.id,
                        idnamefk: 'ente_id',
                        idnamefk2: 'enteRuolo_id',
                        idnamePayload: 'ente_id',
                        delete: false,
                        extrafields: ["ruolo"],
                        payload: payload
                    };
                    api.progetti.progetto.hasmany(hasmanybandos, function (response) {
                        console.log('many bando');
                        api.progetti.progetto.hasmany(hasmanyentes, function (response) {
                            console.log('many ente');
                            if (vm.isnew) {
                                $state.go('app.sprardb_progetti_progetti_progetto', {id: progid});
                            } else {
                                $state.reload();
                            }
                        });
                    });
                });
            }
        }

        vm.saveRendicontazioneData = saveRendicontazioneData;
        function saveRendicontazioneData() {
            //new
            if (!vm.progetto.progettoparametrirendicontaziones.hasOwnProperty('id'))
            {
                vm.progetto.progettoparametrirendicontaziones.progetto_id = vm.progetto.id;
                api.progetti.progettoParametriRendicontazione.save(vm.progetto.progettoparametrirendicontaziones, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati salvati correttamente')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                });
            } else
                    //update
                    {
                        //assegno l'ID del progetto
                        api.progetti.progettoParametriRendicontazione.aggiorna(vm.progetto.progettoparametrirendicontaziones, function (response) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Dati salvati correttamente')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    }
        }


        function gotoProgetti() {
            $state.go('app.sprardb_progetti_progetti');
        }
        function gotoDettaglios(id, progetto_id)
        {
            $state.go('app.sprardb_progetti_strutture_struttura', {id: id, progetto_id: progetto_id});
        }

        function openProgettoEnti(ev, ruoloId, item, ente) {
          var ruolo = $filter('filter')(ricerca.enteruoloprogettos, {id: ruoloId})[0];

          $mdDialog.cancel();
          $mdDialog.show({
            controller: 'DialogProgettoEntiController',
            controllerAs: 'vmd',
            templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/dialogProgettoEntiForm.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
              ruolo: ruolo,
              progettoEnte: item,
              apiRicerca: ricerca,
              progetto: vm.progetto,
              ente: ente
            }
          }).then(loadEnti)
        }

      function createProgettoEnti(ev, ruoloId, item) {
        var ruolo = $filter('filter')(ricerca.enteruoloprogettos, {id: ruoloId})[0];

        $mdDialog.cancel();
        $mdDialog.show({
          controller: 'DialogProgettoEntiController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/dialogProgettoEntiForm.html',
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true,
          locals: {
            ruolo: ruolo,
            progettoEnte: item,
            apiRicerca: ricerca,
            progetto: vm.progetto,
          }
        }).then(function (result) {
          vm.payloadsToStore[result.enteRuolo_id] = result;
          if (result.enteRuolo_id === 8) {
            if (vm.progetto.nome === null) {
              vm.progetto.nome = vm.payloadsToStore[8].nomeEnte;
            }
            api.entes.ente.get({id: result.ente_id}, function (et) {
              vm.progetto.codRegione = et.codRegione;
              vm.caricaProvince(vm.progetto.codRegione);
              vm.progetto.codProvincia = et.codProvincia;
              vm.caricaComuni(vm.progetto.codProvincia);
              vm.progetto.codComune = et.codComune;
            });
          }
        })
      }


        /**
         * Delete Contact Confirm Dialog
         */
        function deleteProgettoConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Are you sure want to delete the contact?')
                    .htmlContent('<b>' + vm.progetto.name + ' ' + vm.progetto.lastName + '</b>' + ' will be deleted.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Progetto), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vm.selectedcat = [];
        vm.togglecat = function (item, list) {
            //console.log(item);
            //console.log(list);
            var idx = list.indexOf(item);
            //console.log(idx);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };
        vm.existscat = function (item, list) {
            //console.log(item);
            //console.log(list);
            return list.indexOf(item) > -1;
        };


        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }

        // vm.attivaLogin = attivaLogin;
        //
        // function attivaLogin(progetto_id, persona_id) {
        //
        //     api.personas.persona.get({id: persona_id}).$promise.then(function (response) {
        //         vm.persona = angular.copy(response);
        //         vm.controllo = "DISATTIVA";
        //
        //         var id_hasProgetto = [];
        //
        //         for (var indice = 0, len = vm.persona.personahasprogettos.length; indice < len; indice++) {
        //             if (vm.persona.personahasprogettos[indice].progetto_id == progetto_id && vm.persona.personahasprogettos[indice].loginAttiva == 0) {
        //                 vm.controllo = "ATTIVA";
        //             }
        //             if (vm.persona.personahasprogettos[indice].progetto_id == progetto_id) {
        //                 id_hasProgetto.push(vm.persona.personahasprogettos[indice].id);
        //             }
        //         }
        //
        //         if (vm.controllo == "ATTIVA") {
        //             vm.loginAttiva = 1;
        //         } else {
        //             vm.loginAttiva = 0;
        //         }
        //
        //         var payload = {progetto_id: progetto_id, loginAttiva: vm.loginAttiva, persona_id: persona_id, id_hasProgetto: id_hasProgetto};
        //
        //         var confirm = $mdDialog.confirm(payload)
        //                 .title('Modifica attivazione Login Progetto')
        //                 .htmlContent(vm.controllo + ' login sul progetto seguente?')
        //                 .ok('Esegui')
        //                 .cancel('Non eseguire');
        //         $mdDialog.show(confirm).then(function () {
        //
        //             for (var indice = 0, len = payload.id_hasProgetto.length; indice < len; indice++) {
        //                 api.personas.hasprogetto.aggiorna({id: payload.id_hasProgetto[indice], loginAttiva: payload.loginAttiva}, function (u) {
        //                 });
        //             }
        //             console.log("try", payload);
        //
        //             $state.reload()
        //
        //         }, function () {
        //             //abbandona
        //         });
        //
        //     }, function (response) {
        //     });
        // }

        function openDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'progetto',
                }
            });
        }

        vm.tempstruttura = null;
        vm.tempaccoglienza = null;
        vm.tempalloggio = null;
        vm.openDialogViewStruttura = openDialogViewStruttura;
        function openDialogViewStruttura(ev, struttura_id, progetto_id) {
            console.log("struttura_id: ", struttura_id);
            api.strutture.struttura2.cerca({id: struttura_id, pagination: 10}, function (response) {
                vm.tempstruttura = response;
                if (angular.isUndefined(struttura_id)) {
                    vm.tempstruttura = {};
                }
                api.strutture.accoglienza.get({sort: "descrizione"}, function (response) {
                    vm.tempaccoglienza = response;
                    api.strutture.alloggio.get({sort: "descrizione"}, function (response) {
                        vm.tempalloggio = response;
                        $mdDialog.show({
                            controller: 'DettagliosController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/sprardb/form/strutturaForm.html',
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            fullscreen: true,
                            locals: {
                                Struttura: vm.tempstruttura,
                                Accoglienza: vm.tempaccoglienza,
                                Alloggio: vm.tempalloggio,
                                progetto_id: progetto_id,
                                struttura_id: struttura_id,
                                dialog: true,
                                view: true,
                                deltaposti: (vm.progetto.postiTotali - vm.progetto.totalePostiStrutture)
                            }
                        });
                    });
                });
            });
        }
        function openDialogEditStruttura(ev, struttura_id, progetto_id) {
            console.log("struttura_id: ", struttura_id);
            api.strutture.struttura2.cerca({id: struttura_id, pagination: 10, fields: 'id,esterna'}, function (response) {
                vm.tempstruttura = response;
                if (angular.isUndefined(struttura_id)) {
                    vm.tempstruttura = {};
                }
                api.strutture.accoglienza.get({sort: "descrizione"}, function (response) {
                    vm.tempaccoglienza = response;
                    api.strutture.alloggio.cerca({sort: "descrizione", id_IN: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15"}, function (response) {
                        vm.tempalloggio = response;
                        $mdDialog.show({
                            controller: 'DettaglioMcController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/sprardb/form/strutturaFormMc.html',
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            fullscreen: true,
                            locals: {
                              Struttura: vm.tempstruttura,
                              Accoglienza: vm.tempaccoglienza,
                              Alloggio: vm.tempalloggio,
                              progetto_id: progetto_id,
                              struttura_id: struttura_id,
                              dialog: true,
                              esterna: vm.tempstruttura.data[0].esterna
                            }
                        }).then(loadStrutture);
                    });
                });
            });
        }
        function openDialogNewStruttura(ev, progetto_id,esterna) {
            vm.tempstruttura = {};

            api.strutture.accoglienza.get({sort: "descrizione"}, function (response) {
                vm.tempaccoglienza = response;
                api.strutture.alloggio.get({sort: "descrizione"}, function (response) {
                    vm.tempalloggio = response;
                    $mdDialog.show({
                        controller: 'DettaglioMcController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/sprardb/form/strutturaFormMc.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                          Struttura: vm.tempstruttura,
                          Accoglienza: vm.tempaccoglienza,
                          Alloggio: vm.tempalloggio,
                          progetto_id: progetto_id,
                          struttura_id: undefined,
                          dialog: true,
                          esterna: esterna
                        }
                    }).then(loadStrutture);
                });
            });
        }

        vm.tempcorsi = null;
        vm.tempservizi = null;
        vm.tempenti = null;

        function openCorsiDialog(ev, item, id, idCat, index, newlink) {
            vm.tempcorsi = {};
            console.log(item);
            $mdDialog.show({
                controller: 'DialogCorsiController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogCorsiForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    All: vm.tempcorsi,
                    anni: vm.years,
                    Progetto: item,
                    index: index,
                    idCorsoCat: idCat,
                    idCorsoTab: id,
                    newlink: newlink
                }
            });
            //});
        }

        function openAssCorsiBenDialog(ev, item, id, idCat, index, newlink) {
            vm.tempcorsi = {};
            $mdDialog.show({
                controller: 'DialogAssCorsiBenController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogAssCorsiBenForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    All: vm.tempcorsi,
                    Progetto: item,
                    index: index,
                    idCorsoCat: idCat,
                    idCorsoTab: id,
                    newlink: newlink
                }
            });
        }

        function openAssServiziBenDialog(ev, item, id, idCat, index, newlink) {
            console.log("item", item);
            console.log("id", id);
            console.log("idCat", idCat);
            console.log("index", index);
            console.log("newlink", newlink);
            vm.tempcorsi = {};
            $mdDialog.show({
                controller: 'DialogAssServiziBenController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogAssServiziBenForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    All: vm.tempservizi,
                    Progetto: item,
                    index: index,
                    idServizioCat: idCat,
                    idServizioTab: id,
                    newlink: newlink
                }
            });
        }

        function openClonaCorsiDialog(ev, item, id, idCat, index, newlink) {
            vm.tempcorsi = {};
            var corsiDaClonare = angular.copy(item.corsos);

            $mdDialog.show({
                controller: 'DialogClonaCorsiController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogClonaCorsiForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    All: vm.tempcorsi,
                    Progetto: item,
                    CorsiDaClonare: corsiDaClonare, // Passa i corsi da clonare come parametro
                    index: index,
                    idCorsoCat: idCat,
                    idCorsoTab: id,
                    newlink: newlink
                }
            });
            //});
        }

        function openClonaServiziDialog(ev, item, id, idCat, index, newlink) {
            //            api.cs.servizio.search({pagination: -1, sort: "descrizione"}, function (response) {
            //                vm.tempservizi = response;
                        vm.tempservizi = {};
                        $mdDialog.show({
                            controller: 'DialogClonaServiziController',
                            controllerAs: 'vmd',
                            templateUrl: 'app/main/sprardb/form/dialogClonaServiziForm.html',
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            fullscreen: true,
                            locals: {
                                All: vm.tempservizi,
                                Progetto: item,
                                index: index,
                                idServizioCat: idCat,
                                idServizioTab: id,
                                newlink: newlink
                            }
                        });
                        //});
                    }




        function openServiziDialog(ev, item, id, idCat, index, newlink) {
//            api.cs.servizio.search({pagination: -1, sort: "descrizione"}, function (response) {
//                vm.tempservizi = response;
            vm.tempservizi = {};
            $mdDialog.show({
                controller: 'DialogServiziController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogServiziForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    All: vm.tempservizi,
                    anni: vm.years,
                    Progetto: item,
                    index: index,
                    idServizioCat: idCat,
                    idServizioTab: id,
                    newlink: newlink
                }
            });
            //});
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, progetto, index, newlink, store, ruolos) {

            if (store == undefined) {
                store = false;
            }

            var filtro_id = [];
            filtro_id[1] = "4,5,10,11,12,29,30,31,35,36,43,15,21,42,40,41,37,38,29";
            filtro_id[8] = "4,5,10,11,12,29,30,31,35,36,43";
            filtro_id[2] = "4,5,10,11,12,29,30,31,35,36,43,15,21,42,40,41,37,38,29";
            filtro_id[6] = "7";
            filtro_id[7] = "8";
            api.enteruolos.enteruolo.cerca({gruppo: 'PROGETTO', sort: 'descrizione'}, function (response) {
                vm.tempruolo = angular.copy(response);
                //elimino ente ruolo segnalatore
                //vm.tempruolo.data.splice(2, 1);
                var ix = 0;
                angular.forEach(vm.tempruolo.data, function (tr) {
                    if (tr.id === 3) {
                        vm.tempruolo.data.splice(ix, 1);
                    }
                    ix = ix + 1;
                });
                api.entetipos.entetipo.cerca({id_IN: filtro_id[ruolos], pagination: -1}, function (response) {
                    vm.tempentetipo = response;
                    $mdDialog.show({
                        controller: 'DialogEntiController',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Progetto: progetto,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink,
                            isstore: store,
                            ruolos: ruolos,
                            filtro_id: filtro_id[ruolos]
                        }
                    }).then(function (datastore) {
                        //console.log("datastore:", datastore);
                        angular.forEach(datastore, function (datas, kdatas) {
//                            console.log('datas');
//                            console.log(datas);
//                            console.log('kdatas');
//                            console.log(kdatas);
                            vm.payloadsToStore[kdatas] = datas;
                            if (vm.progetto.nome === null) {
                                vm.progetto.nome = vm.payloadsToStore[8].nomeEnte;
                            }
                            if (kdatas === 8) {
                                api.entes.ente.get({id: datas.ente_id}, function (et) {
                                    vm.progetto.codRegione = et.codRegione;
                                    vm.caricaProvince(vm.progetto.codRegione);
                                    vm.progetto.codProvincia = et.codProvincia;
                                    vm.caricaComuni(vm.progetto.codProvincia);
                                    vm.progetto.codComune = et.codComune;
                                });
                            }
                        });
                        //vm.payloadsToStore = datastore;
                        //console.log("payloadsToStore:", vm.payloadsToStore);
                    });
                });

            });
        }

        vm.tempruolo2 = null;
        function openPersoneAttivaDialog(ev, progetto, index, newlink) {

            var persona_id = 0;
            var progetto_id = progetto.id;
            var ente_id = 0;
            if (index !== null) {
                persona_id = vm.progetto.personas.data[index].id;
            }
            var enti_collegati = angular.copy(vm.progetto.enti);
            var progetti_collegati = [];
//            var r_persona_progetto = angular.copy(vm.personaruoloprogettos);
//            var r_persona_ambito = angular.copy(vm.personaruoloambitos);
//            var r_persona_ente = angular.copy(vm.personaruoloentes);
//            var r_ente_progetto = angular.copy(vm.enteruoloprogetto);
            $mdDialog.show({
                controller: 'DialogPersoneAttivaController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogPersoneAttivaForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Progetto: progetto,
                    index: index,
                    Regioni: vm.regiones,
                    newlink: newlink,
                    enti_collegati: enti_collegati,
                    persona_id: persona_id,
                    progetto_id: progetto_id,
                    ente_id: ente_id,
                    progetti_collegati: progetti_collegati
                }
            });
        }

        function openOperatoreDialog(ev, persona)
        {
          $mdDialog.show({
            controller: 'OperatoriDialogController',
            controllerAs: 'vmd',
            templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/dialogOperatoriForm.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
              persona: persona,
              progetto: vm.progetto,
              cercaOperatore: cercaOperatore
            }
          }).then(cercaOperatore);
        }

        function openPersoneDialog(ev, progetto, persona, newlink) {

            var progetto_id = progetto.id;
            var ente_id = 0;

            var enti_collegati = angular.copy(vm.progetto.enti);
            var progetti_collegati = [];
//            var r_persona_progetto = angular.copy(vm.personaruoloprogettos);
//            var r_persona_ambito = angular.copy(vm.personaruoloambitos);
//            var r_persona_ente = angular.copy(vm.personaruoloentes);
//            var r_ente_progetto = angular.copy(vm.enteruoloprogetto);
            $mdDialog.show({
                controller: 'DialogPersoneNewController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogPersoneNewForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Progetto: progetto,
                    Regioni: vm.regiones,
                    newlink: newlink,
                    enti_collegati: enti_collegati,
                    persona: persona,
                    progetto_id: progetto_id,
                    ente_id: ente_id,
                    progetti_collegati: progetti_collegati,
                }
            });
        }

        vm.openProfiloNewDialog = openProfiloNewDialog;
        function openProfiloNewDialog(ev, progetto, user_id, index) {

            var persona_id = 0;
            var progetto_id = progetto.id;
            var ente_id = 0;
            if (index !== null) {
                persona_id = vm.progetto.personas.data[index].id;
            }

            $mdDialog.show({
                controller: 'DialogProfiloNewController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogProfiloNewForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    index: index,
                    persona_id: persona_id,
                    progetto_id: progetto_id,
                    user_id: user_id
                }
            }).then(function (datastore) {
                console.log(datastore);
                if (datastore.doit) {
                    if (datastore.disableuser === true) {
                        //disabilita solo utente
                        api.users.log.toggleuser({persona_id: datastore.persona_id}, function (response) {
                            console.log(response);
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Attivazione profilo cambiata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    } else {
                        //startreset
                        //passwordreset
                        api.users.log.startreset({email: datastore.email, username: datastore.username}, function (pr) {
                            var passwordresettoken = pr.token;
//                            angular.forEach(pr, function (opr, k) {
//                                if (k >= 0 && k <= 42) {
//                                    passwordresettoken = passwordresettoken + opr;
//                                }
//                            })
                            api.users.log.passwordreset({token: passwordresettoken, password: datastore.password}, function (us) {
                                if (angular.isDefined(us.id)) {
                                    var email = {};
                                    email.to = [];
                                    email.to.push(us.email);
                                    email.oggetto = "Banca dati SC - Cambiamento Password";
                                    email.corpo = "Gentile utente,<br>Il suo profilo è stato aggiornato come richiesto, le riportiamo di seguito le credenziali di accesso.<br><br>Indirizzo di accesso alla Banca Dati:<br>http://bancadati.sprar.it<br><br>Le credenziali da adoperare al suo accesso sono:<br>Nome Utente: " + us.username + "<br>Password: " + datastore.password + "<br><br><br>Cordiali Saluti<br>Reparto Assistenza Tecnica SC";
                                    api.emails.send.send(email, function (rrr) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Invio email compeltato.')
                                                .position('bottom right')
                                                .hideDelay(2000)
                                                );
                                    });
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Password cambiata per utente ' + us.username + ' ' + us.email + '. Attendere prego.')
                                            .position('bottom right')
                                            .hideDelay(7000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento password. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        })
                    }
                }
            });
        }
        vm.openRegisterDialog = openRegisterDialog;
        function openRegisterDialog(ev, persona_id, gruppo_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: false,
                    isnew: true,
                    gruppo_id: gruppo_id
                }
            }).then(function (datastore) {
                if (datastore.doit) {
                    console.log(datastore);
                    datastore.sendemail = 1;
                    api.users.log.createuser(datastore, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Nuovo profilo creato.')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                $state.reload()
                                );
                    });
                }
            });
        }
        vm.openUserDialog = openUserDialog;
        function openUserDialog(ev, persona_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: true,
                    isnew: false,
                    gruppo_id: false
                }
            }).then(function (datastore) {
                console.log("datastore", datastore);
                if (datastore.doit) {
                    if (datastore.disableuser === true) {
                        //disabilita solo utente
                        api.users.log.toggleuser({persona_id: datastore.persona_id}, function (response) {
                            console.log(response);
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Attivazione profilo cambiata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    } else {

                        if (angular.isDefined(datastore.modificag) && datastore.modificag == true && angular.isDefined(datastore.changeGroup) && datastore.changeGroup == true) {

                            delete datastore['changeGroup'];

                            api.users.log.changegroup(datastore, function (ug) {
                                if (angular.isDefined(ug.id)) {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Profili correttamente modificati')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento profili. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        } else {

                            //startreset
                            //passwordreset
                            api.users.log.startreset({email: datastore.email, username: datastore.username}, function (pr) {
                                var passwordresettoken = pr.token;
//                            angular.forEach(pr, function (opr, k) {
//                                if (k >= 0 && k <= 42) {
//                                    passwordresettoken = passwordresettoken + opr;
//                                }
//                            })
                                api.users.log.passwordreset({token: passwordresettoken, password: datastore.password}, function (us) {
                                    if (angular.isDefined(us.id)) {
                                        var email = {};
                                        email.to = [];
                                        email.to.push(us.email);
                                        //email.to.push("incittimarco@gmail.com");
                                        email.oggetto = "Banca dati SC - Cambiamento Password";
                                        email.corpo = "Gentile utente,<br>Il suo profilo è stato aggiornato come richiesto, le riportiamo di seguito le credenziali di accesso.<br><br>Indirizzo di accesso alla Banca Dati:<br>http://bancadati.sprar.it<br><br>Le credenziali da adoperare al suo accesso sono:<br>Nome Utente: " + us.username + "<br>Password: " + datastore.password + "<br><br><br>Cordiali Saluti<br>Reparto Assistenza Tecnica SC";
                                        api.emails.send.send(email, function (rrr) {
                                            $mdToast.show(
                                                    $mdToast.simple()
                                                    .textContent('Invio email compeltato.')
                                                    .position('bottom right')
                                                    .hideDelay(2000)
                                                    );
                                        });
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Password cambiata per utente ' + us.username + ' ' + us.email + '. Attendere prego.')
                                                .position('bottom right')
                                                .hideDelay(7000)
                                                ).then(
                                                $state.reload()
                                                );
                                    } else {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Errore durante cambiamento password. Riprova.')
                                                .position('bottom right')
                                                .hideDelay(3000)
                                                )
                                    }
                                });
                            });

                        }

                    }
                }
            });
        }

        vm.createprequery = createprequery;
        function createprequery(sid, pid) {
            var obj = {
                "progetto_id_IN": [pid],
                "struttura_id_IN": [sid]
            }
            return JSON.stringify(obj);
        }

        vm.cambiagestionediretta = cambiagestionediretta;
        function cambiagestionediretta() {
            if (vm.gestionediretta == 1) {
                vm.payloadsToStore[1] = {
                    enteRuolo_id: 1,
                    ente_id: vm.payloadsToStore[8].ente_id,
                    nomeEnte: vm.payloadsToStore[8].nomeEnte,
                    progetto_id: vm.payloadsToStore[8].progetto_id
                }
            } else {
                delete vm.payloadsToStore[1];
            }
            console.log("vm.payloadsToStore", vm.payloadsToStore);
        }


      function buildFilter() {
        var filter = {};

        if(!isEmpty(vm.searchOperatore.attivo)) {
          filter = {'persona_has_progetto.attivo': vm.searchOperatore.attivo};
        }

        return filter;
      }

      function isEmpty(value)
      {
        return (value && (value.length !== undefined && value.length === 0)) || (!value && value !== 0);
      }

      function cercaOperatore() {
        var payload = {
          id:$stateParams.id,
          expand:'accessoProgetto,personahasprogetto.personaRuolo,altriProgetti.personaRuolo,altriProgetti.progettoMin,ruoliEnte,user',
          filter: {'persona_has_progetto.attivo': vm.searchOperatore.attivo},
          credenziali: vm.searchOperatore.credenziali
        }

        if(vm.progetto.personas && vm.progetto.personas.$cancelRequest) {
          vm.progetto.personas.$cancelRequest();
        }
        vm.progetto.personas = api.progettomc.persone(payload);
      }
    }

    function DialogProgettoEntiController($state, $scope, $mdDialog, $mdToast, api, locals) {
      var vmd = this;

      vmd.getEnti = getEnti;
      vmd.onChangeTipo = onChangeTipo;
      vmd.salva = salva;
      vmd.salvaNuovoProgettoEnte = salvaNuovoProgettoEnte;
      vmd.elimina = elimina;

      var baseLabel = 'Scegli un ente';

      vmd.progetto = locals.progetto;
      vmd.ente = locals.ente;
      vmd.apiRicerca = locals.apiRicerca;
      vmd.minLength = 3;

      vmd.progettoEnte = {
        attivo: 1,
        enteruolo: angular.copy(locals.ruolo)
      };
      vmd.isNew = true;

      if (locals.progettoEnte) {
        vmd.isNew = false;
        vmd.progettoEnte = angular.copy(locals.progettoEnte);
      }

      vmd.search = {
        sort: 'nome',
        'per-page': 50,
        page: 1,
      };
      vmd.ricerca = {};
      vmd.enti = [];

      updateLabel();


      function onChangeTipo() {
        vmd.ente = null;

        getEnti();
      }

      function getEnti() {
        if (vmd.enti.$resolved === false) {
          vmd.enti.$cancelRequest();
        }

        if (vmd.ricerca.nome && vmd.ricerca.nome.length >= vmd.minLength) {
          var filter = buildFilter();
          var payload = angular.merge({}, {filter: filter}, vmd.search);
          vmd.enti = api.entemc.list(payload);
          vmd.enti.$promise.then(updateLabel)
        } else {
          vmd.enti = [];
          updateLabel();
        }
      }

      function elimina()
      {
        api.progettoentemc.delete({id: vmd.progettoEnte.id}, function() {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Relazione eliminata.')
              .position('bottom right')
              .hideDelay(3000)
          );
          $mdDialog.hide();
        })
      }

      function updateLabel() {
        vmd.sceltaEnteLabel = baseLabel + (vmd.enti.$resolved ? ' ('+ vmd.enti.length +')' : '...');
      }

      function buildFilter() {
        var filter = {and: []};
        if(vmd.ricerca.nome) {
          filter.and.push({
            or: [
              {'nome': {xlike: vmd.ricerca.nome + '%'}},
              {'nome': {like: ' ' + vmd.ricerca.nome}}
            ]
          })
        }

        if(vmd.ricerca.enteTipo_id) {
          filter.and.push({
            enteTipo_id: vmd.ricerca.enteTipo_id
          })
        }

        return filter;
      }

      function salvaNuovoProgettoEnte() {
        var payload = angular.merge({}, vmd.progettoEnte, {
          ente_id: vmd.ente.id,
          ruolo: vmd.progettoEnte.enteruolo.descrizione,
          enteRuolo_id: vmd.progettoEnte.enteruolo.id,
          nomeEnte: vmd.ente.nome
        });

        $mdToast.show(
          $mdToast.simple()
            .textContent('Ente salvato correttamente.')
            .position('bottom right')
            .hideDelay(3000)
        );
        $mdDialog.hide(payload);
      }

      function salva () {
        var payload = angular.merge({}, vmd.progettoEnte, {
          ente_id: vmd.ente.id,
          ruolo: vmd.progettoEnte.enteruolo.descrizione,
          enteRuolo_id: vmd.progettoEnte.enteruolo.id,
          progetto_id: vmd.progetto.id
        });

        api.progettoentemc.save(payload, function() {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Ente salvato correttamente.')
              .position('bottom right')
              .hideDelay(3000)
          );
          $mdDialog.hide();
        })
      }

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }

    /** @ngInject */
    function DialogController($scope, $state, $mdDialog, progetto, api, index, tabella)
    {
        console.log("dialog controller in progetto");
        var vmd = this;
        vmd.api = api;
        vmd.nomeModello = tabella + 'extras';
        vmd.nomeModelloChiave = tabella + '_id';
        vmd.nomeModelloApi = tabella + 's';
        vmd[vmd.nomeModello] = angular.copy(progetto[vmd.nomeModello]);
        vmd.isnew = true;
        vmd.extra = {
            id: null,
            chiave: null,
            valore: null,
        };
        vmd.extra[vmd.nomeModelloChiave] = progetto.id;
        console.log(vmd.extra);

        if (index !== null) {
            vmd.isnew = false;
            vmd.extra = {
                id: vmd[vmd.nomeModello][index].id,
                chiave: vmd[vmd.nomeModello][index].chiave,
                valore: vmd[vmd.nomeModello][index].valore,
            };
            vmd.extra[vmd.nomeModelloChiave] = vmd[vmd.nomeModello][index][vmd.nomeModelloChiave]
        }

        vmd.saveExtra = saveExtra;
        vmd.deleteExtra = deleteExtra;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function saveExtra() {
            if (vmd.isnew) {
                api[vmd.nomeModelloApi].extra.save(vmd.extra, function (response) {
                    $state.reload();
                    $scope.hide();
                });
            }
            if (!vmd.isnew) {
                api[vmd.nomeModelloApi].extra.aggiorna(vmd.extra, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }

        }
        function deleteExtra() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('<b>' + vmd.extra.chiave + ' ' + vmd.extra.valore + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella extra')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {
                api[vmd.nomeModelloApi].extra.delete(vmd.extra, function (response) {
                    console.log(response);
                    $scope.hide();
                    $state.reload();
                });
            }, function () {
            });


            //console.log(progetto_id);
//            $mdDialog.show({
//                controller: 'DialogController',
//                controllerAs: 'vmd',
//                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
//                //parent: angular.element($document.find('#progetto-extras')),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                locals: {
//                    progetto: progetto,
//                    index: index,
//                }
//            });
        }
    }

    function DialogServiziController($scope, $state, $mdDialog, Progetto, idServizioTab, idServizioCat, api, anni, All, index, newlink, $mdToast, ricerca)
    {
        var vmd = this;
        vmd.api = api;
        vmd.isAdmin = api.isAdmin;
        vmd.progetto_id = Progetto.id;
        vmd.index = index;
        vmd.progetto_nome = Progetto.nome;
        vmd.servizio_id = null;
        vmd.nomecategoria = null;
        vmd.servizio_nome = null;
        vmd.dataInizio = new Date();
        vmd.dataFine = new Date();
        vmd.anni = angular.copy(anni);
        vmd.anni.shift();
        vmd.progettohasservizioId = idServizioTab;
        vmd.servizio = {
            id: null,
            descrizione: null,
            note: null
        };

        //vmd.allservizi = All.data;
        vmd.allcategoria = ricerca.servizicategoria;
        vmd.allservizi = ricerca.servizitutti;
        vmd.links = {};
        vmd.meta = {};
        vmd.isnew = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnew = true;
        }

        if (vmd.index !== null) {
//            vmd.servizio_id = Progetto.servizios[index].servizi_id;
//            vmd.servizio_nome = Progetto.servizios[index].descrizione;
//            vmd.dataInizio = new Date(Progetto.servizios[index].dataInizio);
//            vmd.dataFine = new Date(Progetto.servizios[index].dataFine);
//            vmd.id = Progetto.servizios[index].id;
//            vmd.servizio = angular.copy(Progetto.servizios[index]);

            //c'era un errore sull'index
            //lo ricalcolo partendo dall'id e lo rivalorizzo correttamente
            var newindex = 0;
            angular.forEach(Progetto.servizios.data, function (p) {
                if (p.id == vmd.progettohasservizioId) {
                    vmd.index = newindex;
                    vmd.id = p.id;
                    vmd.servizio_id = p.servizi_id;
                    vmd.anno = p.annoServizio;
                    vmd.servizio_nome = p.descrizione;
                    vmd.servizio = angular.copy(p);
                    vmd.nomecategoria = p.servizi.descrizione;
                }
                newindex++;
            });

        }
        vmd.progettohasservizi = {
            progetto_id: vmd.progetto_id,
            servizi_id: vmd.servizio_id,
            anno: vmd.anno
        };
        vmd.ricerca = {
            descrizione: null,
        };
        vmd.selezionato = {
            id: null,
            servizi_id: null
        };

        vmd.save = save;
        vmd.delete = del;
        vmd.aggiornaServizio = aggiorna;
        vmd.insertnew = insertnew;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };


      function save() {

        var pushpayload = {
          servizi_id: vmd.selezionato.id,
          anno: vmd.progettohasservizi.anno,
          progetto_id: vmd.progettohasservizi.progetto_id
        };
        api.progettomc.hasservizi.save(pushpayload, function (u) {
          $mdDialog.hide();
          if (angular.isDefined(u.id)) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Servizio correttamente inserito.')
                .position('bottom right')
                .hideDelay(3000)
            ).then(
              $state.reload()
            );
          } else {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Errore durante il salvataggio.')
                .position('bottom right')
                .hideDelay(3000)
            );
          }
        });

      }
      function aggiorna() {
        $mdDialog.hide();
        var pushpayload = {
          id: vmd.id,
          anno: vmd.progettohasservizi.anno
        };
        api.progettomc.hasservizi.save(pushpayload, function (u) {
          if (angular.isDefined(u.id)) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Servizio correttamente modificato.')
                .position('bottom right')
                .hideDelay(3000)
            ).then(
              $state.reload()
            );
          } else {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Errore durante il salvataggio.')
                .position('bottom right')
                .hideDelay(3000)
            );
          }
        });

      }
      function del() {
        var confirm = $mdDialog.confirm()
          .title('Sei sicuro di voler cancellare questo servizio?')
          .htmlContent('Il servizio sarà cancellato.')
          .ariaLabel('cancella servizio')
          .ok('OK')
          .cancel('ABBANDONA');

        $mdDialog.show(confirm).then(function () {
          api.progettomc.hasservizi.remove({id: idServizioTab}, function (u) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Servizio correttamente eliminato.')
                .position('bottom right')
                .hideDelay(3000)
            ).then(
              $state.reload()
            );
          })
        });
      }
        function insertnew() {
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Esiste già un servizio con questo nome nella stessa categoria')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');
            api.servizi.index({filter: {and: [{servizi_id: vmd.servizio.servizi_id}, {descrizione: vmd.servizio.descrizione}]}}, function (e) {
                if (e.data.length > 0) {
                    $mdDialog.show(alert);
                } else {

                    api.servizi.save(vmd.servizio, function (response) {
                        vmd.allservizi.push(response);
                        $mdDialog.hide();
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent("Nuovo servizio correttamente inserito. E' possibile ora associarlo.")
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    });

                }

            });


        }
    }

    function DialogCorsiController($scope, $state, $mdDialog, Progetto, idCorsoTab, idCorsoCat, api,anni, All, index, newlink, $mdToast, ricerca)
    {
        var vmd = this;
        vmd.isAdmin = api.isAdmin;
        vmd.api = api;
        vmd.progetto_id = Progetto.id;
        vmd.index = index;
        vmd.progetto_nome = Progetto.nome;
        vmd.corso_id = null;
        vmd.nomecategoria = null;
        vmd.dataInizio = new Date();
        vmd.dataFine = new Date();
        vmd.corso_nome = null;
        vmd.progettohascorsoId = idCorsoTab;
        vmd.anni = angular.copy(anni);
        vmd.anni.shift();
        vmd.corso = {
            id: null,
            descrizione: null,
            note: null
        };

        //vmd.allcorsi = All.data;

        vmd.allcategoria = ricerca.corsicategoria;
        vmd.allcorsi = ricerca.corsitutti;
        vmd.links = {};
        vmd.meta = {};
        vmd.isnew = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnew = true;
        }

        if (vmd.index !== null) {
            //c'era un errore sull'index
            //lo ricalcolo partendo dall'id e lo rivalorizzo correttamente
            var newindex = 0;
            angular.forEach(Progetto.corsos.data, function (p) {
                if (p.id == vmd.progettohascorsoId) {
                    //trovato record
                    vmd.index = newindex;
                    vmd.id = p.id;
                    vmd.corso_id = p.corsi_id;
                    vmd.anno = p.annoCorso;
                    vmd.corso_nome = p.descrizione;
                    vmd.corso = angular.copy(p);
                    vmd.nomecategoria = p.corsi.descrizione;
                }
                newindex++;
            });


        }

        vmd.progettohascorsi = {
            progetto_id: vmd.progetto_id,
            corsi_id: vmd.corso_id,
            anno: vmd.anno
        };
        vmd.ricerca = {
            descrizione: null,
        };
        vmd.selezionato = {
            id: null,
            corsi_id: null
        };

        vmd.save = save;
        vmd.delete = del;
        vmd.aggiornaCorso = aggiorna;
        vmd.insertnew = insertnew;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function insertnew() {
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Esiste già un corso con questo nome nella stessa categoria')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');
            api.corsi.index({filter : {and: [{corsi_id: vmd.corso.corsi_id}, {descrizione: vmd.corso.descrizione}]}}, function (e) {
                if (e.data.length > 0) {
                    $mdDialog.show(alert);
                } else {

                    api.corsi.save(vmd.corso, function (response) {
                        var newidcorso = response.id;
                        $mdDialog.hide();
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent("Nuovo corso correttamente inserito. E' possibile ora associarlo.")
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                    vmd.allcorsi.push(response)
                                );
                    });
                }
            });
        }
        function save() {

          var pushpayload = {
            corsi_id: vmd.selezionato.id,
            anno: vmd.progettohascorsi.anno,
            progetto_id: vmd.progettohascorsi.progetto_id
          };
          api.progettomc.hascorsi.save(pushpayload, function (u) {
            $mdDialog.hide();
            if (angular.isDefined(u.id)) {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Corso correttamente inserito.')
                  .position('bottom right')
                  .hideDelay(3000)
              ).then(
                $state.reload()
              );
            } else {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Errore durante il salvataggio.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            }
          });

        }
        function aggiorna() {
          $mdDialog.hide();
          var pushpayload = {
            id: vmd.id,
            anno: vmd.progettohascorsi.anno
          };
          api.progettomc.hascorsi.save(pushpayload, function (u) {
            if (angular.isDefined(u.id)) {
              Progetto.corsos[vmd.index] = u;
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Corso correttamente modificato.')
                  .position('bottom right')
                  .hideDelay(3000)
              ).then(
                $state.reload()
              );
            } else {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Errore durante il salvataggio.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            }
          });

        }
        function del() {
            var confirm = $mdDialog.confirm()
              .title('Sei sicuro di voler cancellare questo corso?')
              .htmlContent('Il corso sarà cancellato.')
              .ariaLabel('cancella corso')
              .ok('OK')
              .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function () {
              api.progettomc.hascorsi.remove({id: idCorsoTab}, function (u) {
                  $mdToast.show(
                      $mdToast.simple()
                      .textContent('Corso correttamente eliminato.')
                      .position('bottom right')
                      .hideDelay(3000)
                  ).then(
                    $state.reload()
                  );
              })
            });
        }
    }

    function DialogClonaCorsiController($scope, $state, $mdDialog, Progetto, idCorsoTab, idCorsoCat, api, All, index, newlink, $mdToast, ricerca){

        var vmd = this;
        vmd.isAdmin = api.isAdmin;
        vmd.api = api;

        vmd.corsos = angular.copy(Progetto.corsos);


        vmd.years = [
            {id: (new Date()).getFullYear()},
            {id: (new Date()).getFullYear() - 1},
            {id: (new Date()).getFullYear() - 2},
            {id: (new Date()).getFullYear() - 3},
            {id: (new Date()).getFullYear() - 4}
        ];

        vmd.sersearchYear = new Date().getFullYear();
        vmd.corsearchYear = new Date().getFullYear();
        vmd.annualitaPrecedente = null;
        vmd.corsiClonati = [];

        vmd.corsiPerAnno = [];

        vmd.cancel = function cancel(){
            $mdDialog.cancel();
        };

        $scope.hide = function () {
            $mdDialog.hide();
        };

        // Funzione per ottenere i corsi in base all'anno selezionato
        vmd.getCorsiPerAnno = function(anno) {
            api.progettomc.hascorsi.index({filter: {and: [{'progetto_id': Progetto.id}, {dataInizio: {xlike: anno+'%'}}]}}, function (res) {
              vmd.corsiPerAnno = res.data;
              vmd.corsiPerAnno.forEach(function(corso) {
                corso.selected = true;
              });
            })
        };

        vmd.clonaCorsi = function () {
            if (!vmd.corsearchYear || !vmd.corcloneYear) {
                var avviso = $mdDialog.confirm()
                    .title('Anno obbligatorio')
                    .htmlContent('Selezionare sia l\'anno di partenza che l\'anno di destinazione')
                    .ok('CHIUDI');
                $mdDialog.show(avviso);
                return;
            }

            var corsiSelezionati = vmd.corsiPerAnno.filter(function (corso) {
                return corso.selected;
            });

            if (corsiSelezionati.length === 0) {
                var avviso = $mdDialog.confirm()
                    .title('Corso obbligatorio')
                    .htmlContent('Selezionare almeno un Corso da clonare')
                    .ok('CHIUDI');
                $mdDialog.show(avviso);
                return;
            }

            var corsiDaClonareIds = corsiSelezionati.map(function (corso) {
                return corso.id;
            });

            api.corsi.clonaCorsi({
              annoPartenza: vmd.corsearchYear,
              annoDestinazione: vmd.corcloneYear,
              corsiDaClonareIds: corsiDaClonareIds,
              progetto_id: Progetto.id
            }, function (response) {
              $state.reload();
              $mdDialog.hide();
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Corsi Clonati Correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
              )
            }, function (error) {
              console.error("Errore nella chiamata API:", error);
            });
        };


    }

    function DialogClonaServiziController($scope, $state, $mdDialog, Progetto, idServizioTab, idServizioCat, api, All, index, newlink, $mdToast, ricerca)
    {
        var vmd = this;
        vmd.api = api;
        vmd.isAdmin = api.isAdmin;

        vmd.servizios = angular.copy(Progetto.servizios);

        vmd.years = [
            {id: (new Date()).getFullYear()},
            {id: (new Date()).getFullYear() - 1},
            {id: (new Date()).getFullYear() - 2},
            {id: (new Date()).getFullYear() - 3},
            {id: (new Date()).getFullYear() - 4}
        ];

        vmd.sersearchYear = new Date().getFullYear();
        vmd.corsearchYear = new Date().getFullYear();
        vmd.annualitaPrecedente = null;
        vmd.serviziClonati = [];


        // Inizializza la variabile serviziPerAnno nell'oggetto vmd
        vmd.serviziPerAnno = [];

        vmd.getServiziPerAnno = function(anno) {
          api.progettomc.hasservizi.index({filter: {and: [{'progetto_id': Progetto.id}, {dataInizio: {xlike: anno+'%'}}]}}, function (res) {
            vmd.serviziPerAnno = res.data;
            vmd.serviziPerAnno.forEach(function(servizio) {
              servizio.selected = true;
            });
          })
        };

        vmd.clonaServizi = function () {
            if (!vmd.corsearchYear) {
                var avviso = $mdDialog.confirm()
                    .title('Anno di partenza obbligatorio')
                    .htmlContent('Inserire un anno di partenza')
                    .ok('CHIUDI');
                $mdDialog.show(avviso);
                return;
            }

            var serviziSelezionati = vmd.serviziPerAnno.filter(function (servizio) {
                return servizio.selected;
            });

            if (serviziSelezionati.length === 0) {
                var avviso = $mdDialog.confirm()
                    .title('Servizio obbligatorio')
                    .htmlContent('Selezionare almeno un Servizio da clonare')
                    .ok('CHIUDI');
                $mdDialog.show(avviso);
                return;
            }

            var serviziDaClonareIds = serviziSelezionati.map(function (servizio) {
                return servizio.id;
            });

            api.servizi.clonaServizi({
                annoCorrente: vmd.corsearchYear,
                annoDestinazione: vmd.corcloneYear,
                serviziDaClonareIds: serviziDaClonareIds,
                progetto_id: Progetto.id
            }, function (response) {
              $mdDialog.hide();
              $state.reload();
              $mdToast.show(
                  $mdToast.simple()
                  .textContent('Servizi Clonati Correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
                  );
            }, function (error) {
                console.error("Errore nella chiamata API:", error);
            });

        };

        $scope.hide = function () {
            $mdDialog.hide();
        };

        vmd.cancel = function () {
            $mdDialog.cancel();
        };

    }


    function DialogAssCorsiBenController($scope, $state, $mdDialog, Progetto, api, All, index, newlink, $mdToast, ricerca)
    {
        var vmd = this;
        vmd.corsos = angular.copy(Progetto.corsos);
        vmd.corsiPerAnno = [];
        vmd.beneficiariProgetto = [];
        vmd.progetto_id = Progetto.id;
        // Dichiarazione delle variabili per i dati selezionati
        vmd.selectedCorsi = [];
        vmd.selectedBeneficiari = [];
        vmd.models = [];

        vmd.getCorsiPerAnno = function(anno) {
          api.progettomc.hascorsi.index({filter: {and: [{'progetto_id': vmd.progetto_id}, {dataInizio: {xlike: new Date().getFullYear()+'%'}}]}}, function (res) {
            vmd.corsiPerAnno = res.data;
            vmd.corsiPerAnno.forEach(function(corso) {
              corso.selected = true;
            });
          })
        };

        vmd.checkYear = function() {
            vmd.models.forEach(function(model) {
                var inizioYear = model.dataInizio.getFullYear();

                // Calcola la data massima consentita (ultimo giorno dell'anno della data d'inizio)
                var ultimoGiornoAnnoInizio = new Date(inizioYear, 11, 31);
                console.log(ultimoGiornoAnnoInizio);

                // Imposta md-max-date sul modello corrente
                model.maxDateFine = ultimoGiornoAnnoInizio;
            });
        };


        vmd.getBeneficiari = function() {
            // Aggiungi un oggetto di ricerca con il parametro 'ricerca'
            api.progettomc.beneficiariProgetto({
                progettoId: vmd.progetto_id,
                ricerca: vmd.ricerca // Aggiungi il parametro di ricerca
            }).$promise.then(function(res) {
                vmd.beneficiariProgetto = res.data;
            });
        };

        vmd.getBeneficiari();

        vmd.inizializzaModel = function() {
            if (vmd.selectedBeneficiari.length > 0) {
                // Inizializza un nuovo modello solo se almeno un beneficiario è selezionato
                vmd.models.push(getModel());
            }
        };


        // Funzione per ottenere un modello generico
        function getModel() {
            return {
                progetto_id: vmd.progetto_id,
                beneficiario_id: vmd.selectedBeneficiari,
                selectedCorsi: [],
                dataInizio: null,
                dataFine: null
            };
        }

        vmd.cancellaModel = function cancellaModel(model)
        {
        vmd.models = vmd.models.filter(m => m !== model);
        }

        vmd.associaCorsi = function() {
            // Verifica che ci siano beneficiari e corsi selezionati
            if (vmd.models) {
                console.log("Id Beneficiari: ", vmd.models);

                // Esegui la logica per associare corsi ai beneficiari
                api.progettomc.associaCorsi({
                    model:vmd.models
                }).$promise.then(function(response) {
                      $mdDialog.hide();
                      $state.reload();
                      $mdToast.show(
                          $mdToast.simple()
                          .textContent('Corsi Associati Correttamente.')
                          .position('bottom right')
                          .hideDelay(3000)
                          );
                }, function (error) {
                    console.error("Errore nella chiamata API:", error);
                });
            } else {
                // Gestisci il caso in cui non ci siano beneficiari o corsi selezionati
                console.log('Seleziona almeno un beneficiario e un corso');
            }
        };

        vmd.cancel = function () {
            $mdDialog.cancel();
        };


    }

    function DialogAssServiziBenController($scope, $state, $mdDialog, Progetto, api, All, index, newlink, $mdToast, ricerca)
    {
        var vmd = this;
        vmd.beneficiariProgetto = [];
        vmd.progetto_id = Progetto.id;
        // Dichiarazione delle variabili per i dati selezionati
        vmd.selectedServizi = [];
        vmd.selectedBeneficiari = [];
        vmd.models = [];

        vmd.getServiziPerAnno = function(anno) {
          api.progettomc.hasservizi.index({filter: {and: [{'progetto_id': vmd.progetto_id}, {dataInizio: {xlike: new Date().getFullYear()+'%'}}]}}, function (res) {
            vmd.serviziPerAnno = res.data;
            vmd.serviziPerAnno.forEach(function(servizio) {
              servizio.selected = true;
            });
          })
        };

        vmd.checkYear = function() {
            vmd.models.forEach(function(model) {
                var inizioYear = model.dataInizio.getFullYear();

                // Calcola la data massima consentita (ultimo giorno dell'anno della data d'inizio)
                var ultimoGiornoAnnoInizio = new Date(inizioYear, 11, 31);
                console.log(ultimoGiornoAnnoInizio);

                // Imposta md-max-date sul modello corrente
                model.maxDateFine = ultimoGiornoAnnoInizio;
            });
        };


        vmd.getBeneficiari = function() {
            // Aggiungi un oggetto di ricerca con il parametro 'ricerca'
            api.progettomc.beneficiariProgetto({
                progettoId: vmd.progetto_id,
                'per-page': 50,
                ricerca: vmd.ricerca // Aggiungi il parametro di ricerca
            }).$promise.then(function(res) {
                vmd.beneficiariProgetto = res.data;
            });
        };

        vmd.getBeneficiari();


        vmd.inizializzaModel = function() {
            if (vmd.selectedBeneficiari.length > 0) {
                // Inizializza un nuovo modello solo se almeno un beneficiario è selezionato
                vmd.models.push(getModel());
                console.log('Modello inizializzato:', vmd.models);


            } else {
                console.log('Seleziona almeno un beneficiario prima di aggiungere un servizio.');
            }
        };


        // Funzione per ottenere un modello generico
        function getModel() {
            return {
                progetto_id: vmd.progetto_id,
                beneficiario_id: vmd.selectedBeneficiari,
                selectedServizi: [],
                dataInizio: null,
                dataFine: null
            };
        }

        vmd.cancellaModel = function cancellaModel(model)
        {
        vmd.models = vmd.models.filter(m => m !== model);
        }



        vmd.associaServizi = function() {
            // Verifica che ci siano beneficiari e servizi selezionati
            if (vmd.models) {
                console.log("Id Beneficiari: ", vmd.models);

                // Esegui la logica per associare servizi ai beneficiari
                api.progettomc.associaServizi({
                    model:vmd.models
                }).$promise.then(function(response) {
                  $mdDialog.hide();
                  $state.reload();
                  $mdToast.show(
                      $mdToast.simple()
                      .textContent('Servizi Associati Correttamente.')
                      .position('bottom right')
                      .hideDelay(3000)
                      );
                }, function (error) {
                    console.error("Errore nella chiamata API:", error);
                });
            } else {
                // Gestisci il caso in cui non ci siano beneficiari o corsi selezionati
                console.log('Seleziona almeno un beneficiario e un Servizio');
            }
        };


        vmd.cancel = function () {
            $mdDialog.cancel();
        };

    }

    function DialogEntiController($scope, $state, $mdDialog, Progetto, api, AllRuolo, index, AllEnteTipo, Regioni, newlink, isstore, locals, filtro_id, ruolos, ricerca, $mdToast)
    {
        var vmd = this;
        vmd.api = api;
        vmd.isstore = isstore;
        vmd.progetto_id = Progetto.id;
        vmd.ente_id = index;
        vmd.index = Progetto.enti.map(function (o) {
            return o.id;
        }).indexOf(vmd.ente_id);
        console.log("vmd.index", vmd.index);
        vmd.progetto_nome = Progetto.nome;
        vmd.ente_id = null;
        vmd.ente_nome = null;
        vmd.entes = angular.copy(Progetto.enti);
        vmd.ruolo_passato = parseInt(ruolos);
        vmd.enteruoloprogettos = ricerca.enteruoloprogettos;

        vmd.ente = {
            id: null,
            enteTipo_id: null,
            enteTipoPadre_id: null,
            nome: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            attivo: '1',
            enteruolos: [],
        };
        vmd.allentes = {};
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewente = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewente = true;
        }
        vmd.ruolosSelected = [];
        vmd.ruolosSelected_ro = [];
        console.log("vmd.ruolosSelected_0", angular.copy(vmd.ruolosSelected));
        console.log("vmd.progetto_id", angular.copy(vmd.progetto_id));
        if (angular.isDefined(locals.ruolos)) {
            vmd.ruolosSelected.push(locals.ruolos);
        }
        console.log("vmd.ruolosSelected_1", angular.copy(vmd.ruolosSelected));
        vmd.dataStore = [];

        vmd.enteselezionato = {
            id: null
        };
        vmd.ricerca = {
            nome: null,
            enteTipo_id: null,
            codRegione: null,
        };

        if (vmd.index !== null && vmd.index !== -1) {
            console.log("vmd.index", vmd.index);
            vmd.ente_id = Progetto.enti[vmd.index].id;
            vmd.enteselezionato.id = Progetto.enti[vmd.index].id;
            vmd.ente_nome = Progetto.enti[vmd.index].nome;
            vmd.ente = angular.copy(Progetto.enti[vmd.index]);

            vmd.ricerca.id_IN = [vmd.enteselezionato.id];
            cercaEnte();
            restituisciEnte();
        }
        vmd.allentetipos = AllEnteTipo.data;
        vmd.allruolo = AllRuolo.data;
        vmd.regiones = Regioni;
        vmd.provincias = [];
        vmd.istats = [];


        vmd.progettohasente = {
            progetto_id: vmd.progetto_id,
            ente_id: vmd.ente_id,
        };





        vmd.save = savenew;
        vmd.store = store;
        vmd.delete = del;
        vmd.cercaEnte = cercaEnte;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.restituisciEnte = restituisciEnte;
        if (vmd.ente.codRegione !== null || vmd.ente.codRegione !== '') {
            //vmd.caricaProvince(vmd.ente.codRegione);
        }
        if (vmd.ente.codProvincia !== null || vmd.ente.codProvincia !== '') {
            //vmd.caricaComuni(vmd.ente.codProvincia);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaEnte() {

            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });

            var ricerca = angular.copy(vmd.ricerca);

            vmd.ricerca.pagination = -1;
            vmd.ricerca.dacl = 1;
            vmd.ricerca.fields = "id,nome,progettohasentes";
            vmd.ricerca.sort = "nome";
            if (angular.isDefined(filtro_id) && filtro_id != "") {
                if (angular.isUndefined(vmd.ricerca.enteTipo_id)) {
                    vmd.ricerca.enteTipo_id_IN = filtro_id.split();
                } else {
                    delete vmd.ricerca.enteTipo_id_IN;
                }
            }
            if (Object.keys(ricerca).length > 0) {
                api.entes.ente.search(vmd.ricerca, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                    if (angular.isDefined(vmd.ricerca.id_IN)) {
                        delete vmd.ricerca.id_IN;
                    }
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciEnte() {
            api.entes.ente.get({id: vmd.enteselezionato.id}, function (response) {
                vmd.enteselezionato = response;
                vmd.progettohasentes = angular.copy(vmd.enteselezionato.progettohasentes);
                angular.forEach(vmd.progettohasentes, function (obj) {
                    console.log("obj:", obj);
                    if (obj.progetto_id == vmd.progetto_id) {
                        console.log("okok")
                        vmd.ruolosSelected.push(obj.enteRuolo_id);
                        console.log("vmd.ruolosSelected_2", angular.copy(vmd.ruolosSelected));
                    } else {
                        vmd.ruolosSelected_ro.push(obj);
                    }
                });
                console.log("vmd.ruolosSelected_2", angular.copy(vmd.ruolosSelected));
                console.log("vmd.ruolosSelected_ro", angular.copy(vmd.ruolosSelected_ro));

            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(vmd.entes, function (obj) {
                angular.forEach(obj.enteruolos, function (obj2) {
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        ente_id: obj.id,
                        enteRuolo_id: obj2.id};
                    payload.push(pushpayload);
                });
            });

            if (!vmd.isnewente && !vmd.newlink) {
                //modifica
                vmd.entes.splice(vmd.index, 1);
                payload = [];
                angular.forEach(vmd.entes, function (obj) {
                    angular.forEach(obj.enteruolos, function (obj2) {
                        var pushpayload = {
                            progetto_id: vmd.progetto_id,
                            ente_id: obj.id,
                            enteRuolo_id: obj2.id};
                        payload.push(pushpayload);
                    });
                });
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewente && !vmd.newlink) {
                //nuova entita
                api.entes.ente.save(vmd.ente, function (response) {
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            progetto_id: vmd.progetto_id,
                            ente_id: response.id,
                            enteRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanyentes = {
                        modelrelation: 'Progettohasente',
                        idname: 'progetto_id',
                        idvalue: vmd.progetto_id,
                        idnamefk: 'ente_id',
                        idnamefk2: 'enteRuolo_id',
                        idnamePayload: 'ente_id',
                        payload: payload
                    };
                    api.entes.ente.hasmany(hasmanyentes, function (response) {
                        console.log(response);
                        $state.reload();
                        $scope.hide();
                    });
                });
            }

            if (vmd.newlink) {
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        ente_id: vmd.enteselezionato.id,
                        enteRuolo_id: ruolo};
                    payload.push(pushpayload);
                });
                var hasmanyentes = {
                    modelrelation: 'Progettohasente',
                    idname: 'progetto_id',
                    idvalue: vmd.progetto_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'enteRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload
                };
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });

            }
        }

        function savenew() {
            var phe_copy = [];
            var ruoloSelected = angular.copy(vmd.ruolosSelected);
            var tphe_copy = {};
            var ente_id = null;
            if (!vmd.isnewente) {
                ente_id = vmd.enteselezionato.id;
            }
            console.log("vmd.ruolosSelected", angular.copy(vmd.ruolosSelected));


            angular.forEach(ruoloSelected, function (rs) {
                //ruoli selezionati
                tphe_copy = {};
                tphe_copy.progetto_id = vmd.progetto_id;
                tphe_copy.enteRuolo_id = rs;
                tphe_copy.ente_id = ente_id;

                var ir = -1;
                ir = vmd.enteruoloprogettos.map(function (o) {
                    return o.id;
                }).indexOf(rs);
                if (ir > -1) {
                    tphe_copy.ruolo = vmd.enteruoloprogettos[ir].descrizione;
                }
                phe_copy.push(tphe_copy);
            });
            //aggiungo gli altri ruoli eventuali dell'ente selezionato

            angular.forEach(vmd.ruolosSelected_ro, function (ro) {
                //ruoli selezionati
                tphe_copy = {};
                tphe_copy.progetto_id = ro.progetto_id;
                tphe_copy.enteRuolo_id = ro.enteRuolo_id;
                tphe_copy.ente_id = ro.ente_id;
                tphe_copy.ruolo = ro.ruolo;
                phe_copy.push(tphe_copy);
            });


            if (vmd.isnewente) {
            } else {
                // solo collegamtnto
                // progetto_has_ente = {
                //     modelrelation: 'Progettohasente',
                //     idname: 'ente_id',
                //     idvalue: ente_id,
                //     idnamefk: 'progetto_id',
                //     idnamefk2: 'enteRuolo_id',
                //     idnamePayload: 'progetto_id',
                //     extrafields: ["ruolo"],
                //     payload: phe_copy
                // };
                // console.log("progetto_has_ente:", progetto_has_ente)
                // api.progettos.progetto.hasmany(progetto_has_ente, function (rphe) {
                //     $mdToast.show(
                //             $mdToast.simple()
                //             .textContent('Collegamento enti modificato')
                //             .position('bottom right')
                //             .hideDelay(2000)
                //             ).then(function (fine) {
                //         $state.reload();
                //         $scope.hide();
                //     }
                //     );
                // });
            }

        }

        function store() {
            var payload = [];
            var pushpayload = {}
            angular.forEach(vmd.ruolosSelected, function (ruolo) {
                pushpayload = {
                    progetto_id: 0,
                    ente_id: vmd.enteselezionato.id,
                    enteRuolo_id: ruolo,
                    nomeEnte: vmd.enteselezionato.nome
                };
                //vmd.dataStore.push = vmd.enteselezionato.nome;
                payload[ruolo] = pushpayload;
            });
            $mdDialog.hide(payload);
        }

        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.<br>.')
                    .ariaLabel('cancella Ente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                console.log("vmd.progettohasentes_cancella", vmd.progettohasentes);
                var id_to_delete_e = [];

                angular.forEach(vmd.progettohasentes, function (p) {
                    if (p.progetto_id === vmd.progetto_id) {
                        id_to_delete_e.push(p.id);
                    }
                });
                console.log("id_to_delete_e: ", id_to_delete_e);
                angular.forEach(id_to_delete_e, function (d) {
                    api.progettos.hasente.remove({id: d});
                });
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Eliminazione in corso..attendere qualche istante.')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(function () {
                    $scope.hide();
                    $state.reload();
                });



            }, function () {
            });
            /*
             var confirm = $mdDialog.confirm()
             .title('Sei sicuro di voler cancellare questo collegamento?')
             .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.')
             .ariaLabel('cancella ente')
             .ok('OK')
             .cancel('ABBANDONA');
             var alert = $mdDialog.alert()
             .clickOutsideToClose(true)
             .title('Attenzione')
             .textContent('Non puoi rimuovere ultimo elemento.')
             .ariaLabel('Attenzione ultimo')
             .ok('OK');

             $mdDialog.show(confirm).then(function ()
             {
             vmd.entes.splice(vmd.index, 1);
             var payload = [];
             angular.forEach(vmd.entes, function (obj) {
             angular.forEach(obj.enteruolos, function (obj2) {
             var pushpayload = {
             progetto_id: vmd.progetto_id,
             ente_id: obj.id,
             enteRuolo_id: obj2.id};
             payload.push(pushpayload);
             });
             });
             if (payload.length === 0) {
             $mdDialog.show(alert);
             }
             //console.log(payload);
             var hasmanyentes = {
             modelrelation: 'Progettohasente',
             idname: 'progetto_id',
             idvalue: vmd.progetto_id,
             idnamefk: 'ente_id',
             idnamefk2: 'enteRuolo_id',
             idnamePayload: 'ente_id',
             payload: payload
             };
             api.entes.ente.hasmany(hasmanyentes, function (response) {
             console.log(response);
             $state.reload();
             $scope.hide();
             });
             }, function () {
             });
             */
        }

        vmd.selectedItem = null;
        vmd.searchText = null;
        vmd.selectedItem2 = null;
        vmd.searchText2 = null;
        vmd.selectedItem3 = null;
        vmd.searchText3 = null;
        vmd.querySearch = querySearch;
        vmd.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }


    }

    function DialogPersoneController($scope, $state, $mdDialog, Progetto, api, AllRuolo, AllRuolo2, index, Regioni, newlink)
    {
        var vmd = this;
        vmd.api = api;
        vmd.progetto_id = Progetto.id;
        vmd.index = index;
        vmd.progetto_nome = Progetto.nome;
        vmd.persona_id = null;
        vmd.persona_nome = null;
        vmd.personas = angular.copy(Progetto.personas);
        vmd.persona = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            progettoruolos: [],
            ruolos: [],
            nascita: [],
        };
        vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
        vmd.allpersonas = [];
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewpersona = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewpersona = true;
        }
        vmd.ruolosSelected = [];
        vmd.ruolosSelected2 = [];

        if (vmd.index !== null) {
            vmd.persona_id = Progetto.personas[index].id;
            vmd.persona_nome = Progetto.personas[index].cognome + ' ' + Progetto.personas[index].nome;
            vmd.persona = angular.copy(Progetto.personas[index]);
            vmd.allpersonas.push(angular.copy(Progetto.personas[index]));
            angular.forEach(vmd.persona.progettoruolos, function (obj) {
                vmd.ruolosSelected.push(obj.id);
            });
        }
        vmd.allruolo = AllRuolo.data;
        vmd.allpersonaruolo = AllRuolo2.data;
        vmd.regiones = Regioni;
        vmd.regiones2 = Regioni;
        vmd.provincias = [];
        vmd.istats = [];
        vmd.provincias2 = [];
        vmd.istats2 = [];
        vmd.nazionalitas = [];
        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: "200"}, function (response) {
            vmd.nazionalitas = response.data;
            //console.log(vmd.nazionalitas);
        });


        vmd.progettohaspersona = {
            progetto_id: vmd.progetto_id,
            persona_id: vmd.persona_id,
        };

        vmd.ricerca = {
            cognome: null,
        };
        vmd.ricerca['entes-nome'] = null;
        vmd.ricerca['istats-comune'] = null;
        vmd.personaselezionato = {
            id: null
        };


        vmd.save = save;
        vmd.delete = del;
        vmd.cercaPersona = cercaPersona;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.caricaProvince2 = caricaProvince2;
        vmd.caricaComuni2 = caricaComuni2;
        vmd.restituisciPersona = restituisciPersona;
        if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
            //vmd.caricaProvince(vmd.persona.codRegione);
        }
        if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
            //vmd.caricaComuni(vmd.persona.codProvincia);
        }
//        if (vmd.persona.nascita.codRegione !== null || vmd.persona.nascita.codRegione !== '') {
//            vmd.caricaProvince2(vmd.persona.nascita.codRegione);
//        }
//        if (vmd.persona.nascita.codProvincia !== null || vmd.persona.nascita.codProvincia !== '') {
//            vmd.caricaComuni2(vmd.persona.nascita.codProvincia);
//        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaPersona() {
            vmd.ricerca['entes-nome'] = vmd.ricerca.cognome;
            vmd.ricerca['istats-comune'] = vmd.ricerca.cognome;
            vmd.ricerca['operatore'] = 'OR';
            vmd.ricerca['pagination'] = '100';
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.personas.persona.like(vmd.ricerca, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.personas.persona.get({}, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciPersona() {
            api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
                vmd.personaselezionato = response;
                //console.log(vmd.personaselezionato);
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }
        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias2 = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(vmd.personas, function (obj) {
                angular.forEach(obj.progettoruolos, function (obj2) {
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        persona_id: obj.id,
                        personaRuolo_id: obj2.id};
                    payload.push(pushpayload);
                });
            });


            if (!vmd.isnewpersona && !vmd.newlink) {
                //modifica collegamento
                vmd.personas.splice(vmd.index, 1);
                payload = [];
                angular.forEach(vmd.personas, function (obj) {
                    angular.forEach(obj.progettoruolos, function (obj2) {
                        var pushpayload = {
                            progetto_id: vmd.progetto_id,
                            persona_id: obj.id,
                            personaRuolo_id: obj2.id};
                        payload.push(pushpayload);
                    });
                });
                /*
                 var newpayload = [];
                 angular.forEach(payload, function (value, key) {
                 if (value.persona_id !== vmd.personaselezionato.id) {
                 newpayload.push(value);
                 }
                 });
                 payload = newpayload;
                 */
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewpersona && !vmd.newlink) {
                //nuova entita + colelgamento
                var pushpayload2 = {}
                var m = moment(vmd.persona.dataNascita2);
                vmd.persona.dataNascita = m.format("YYYY-MM-DD");
                api.personas.persona.save(vmd.persona, function (response) {
                    console.log('salvata persona');
                    var perId = response.id;
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            progetto_id: vmd.progetto_id,
                            persona_id: perId,
                            personaRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanypersonaps = {
                        modelrelation: 'Personahasprogetto',
                        idname: 'progetto_id',
                        idvalue: vmd.progetto_id,
                        idnamefk: 'persona_id',
                        idnamefk2: 'personaRuolo_id',
                        idnamePayload: 'persona_id',
                        payload: payload};
                    api.personas.persona.hasmany(hasmanypersonaps, function (response) {
                        console.log('Risposta inserimento in Persona_has_progetto');
                        console.log(response);
                        angular.forEach(vmd.ruolosSelected2, function (ruolo) {
                            pushpayload2 = {
                                persona_id: perId,
                                id: ruolo};
                        });
                        var newpayload = [];
                        newpayload.push(pushpayload2);
                        var hasmanypersonas = {
                            modelrelation: 'Personahasruolo',
                            idname: 'persona_id',
                            idvalue: perId,
                            idnamefk: 'ruolo_id',
                            idnamePayload: 'id',
                            payload: newpayload
                        };
                        api.personas.persona.hasmany(hasmanypersonas, function (response) {
                            console.log('Risposta inserimento in Persona_has_ruolo');
                            console.log(response);
                            $state.reload();
                            $scope.hide();
                        });
                    });
                });
            }

            if (vmd.newlink) {
                //nuovo collegamento
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
//                    console.log('ruolo: ' + ruolo);
//                    console.log('persona: ' + vmd.personaselezionato.id);
//                    console.log('progettto: ' + vmd.progetto_id);
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        persona_id: vmd.personaselezionato.id,
                        personaRuolo_id: ruolo};
                    payload.push(pushpayload);
                });
//                console.log(payload);
                var hasmanypersonas = {
                    modelrelation: 'Personahasprogetto',
                    idname: 'progetto_id',
                    idvalue: vmd.progetto_id,
                    idnamefk: 'persona_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'persona_id',
                    payload: payload
                };
                api.personas.persona.hasmany(hasmanypersonas, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });

            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.persona_nome + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella persona')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                console.log(vmd.personas);
                vmd.personas.splice(vmd.index, 1);
                var payload = [];
                angular.forEach(vmd.personas, function (obj) {
                    angular.forEach(obj.progettoruolos, function (obj2) {
                        var pushpayload = {
                            progetto_id: vmd.progetto_id,
                            persona_id: obj.id,
                            personaRuolo_id: obj2.id};
                        payload.push(pushpayload);
                    });
                });
                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                var hasmanypersonas = {modelrelation: 'Personahasprogetto', idname: 'progetto_id', idvalue: vmd.progetto_id, idnamefk: 'persona_id', idnamefk2: 'personaRuolo_id', idnamePayload: 'persona_id', payload: payload};
                console.log(hasmanypersonas);
                api.personas.persona.hasmany(hasmanypersonas, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });

        }

        vmd.selectedItem = null;
        vmd.searchText = null;
        vmd.selectedItem2 = null;
        vmd.searchText2 = null;
        vmd.selectedItem3 = null;
        vmd.searchText3 = null;
        vmd.querySearch = querySearch;
        vmd.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }

        vmd.checkEmail = checkEmail;
        function checkEmail(ev) {
            console.log("persona", vmd.persona);
            console.log("scope", $scope);
            if (angular.isDefined(vmd.persona.email)) {
                api.users.log.checkemail({email: vmd.persona.email}).$promise.then(
                        function (response) {
                            console.log(response);
                            if (response.esito == 1) {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
            }
        }
    }

    function DialogRevisoreController($scope, $state, $mdDialog, Progetto, api, index, newlink) {
      var vmd = this;
      vmd.isnew = newlink;
      vmd.api = api;
      vmd.progetto = Progetto;
      vmd.anno = null;
      vmd.persona_id = newlink? null:vmd.progetto.revisori[index].persona.id;
      api.progettomc.anniRendicontazioni({id: vmd.progetto.id,persona_id: vmd.persona_id},function(res){
        vmd.anniRend = res;
      })
      api.progettomc.revisoriNonAssociati({id:vmd.progetto.id},function (res) {
        vmd.revisori = res;
      })
      vmd.associa = associa;
      function associa(anno) {
        api.progettomc.associaRevisore({id:vmd.progetto.id,persona_id: vmd.persona_id,anni:anno != null ?anno:vmd.anno},function () {
          $scope.cancel();
        })
      }

      vmd.dissocia = dissocia;
      function dissocia(anno) {
        api.progettomc.dissociaRevisore({id:vmd.progetto.id,persona_id: vmd.persona_id,anno:anno},function () {
          $scope.cancel();
        })
      }

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }

    function DialogPersoneAttivaController($scope, $state, $mdDialog, Progetto, api, index, Regioni, newlink, ricerca, enti_collegati, progetti_collegati, $mdToast, persona_id, ente_id, progetto_id, locals)
    {
        var vmd = this;
        vmd.api = api;
        vmd.locals = locals;
        vmd.progetto_id = progetto_id;
        vmd.isAdmin = api.isAdmin;
        //vmd.persona_id
        //vmd.ente_id
        vmd.index = index;
        vmd.progetto_nome = Progetto.nome;
        vmd.persona_id = null;
        vmd.persona_nome = null;
        vmd.personas = angular.copy(Progetto.personas);
        vmd.personastudis = ricerca.personastudis;
        console.log("vmd.personastudis", vmd.personastudis);

        vmd.enteruoloprogetto = ricerca.enteruoloprogettos;
        vmd.personaruoloprogettos = ricerca.personaruoloprogettos;
        vmd.personaruoloentes = ricerca.personaruoloentes;
        vmd.personaruoloambitos = ricerca.personaruoloambitos;
        vmd.tuttipersonaruolos = ricerca.personaruoloprogettos;
        angular.forEach(vmd.personaruoloambitos, function (pra) {
            pra.ambito = 1;
            vmd.tuttipersonaruolos.push(pra);
        });
        console.log("vmd.tuttipersonaruolos", vmd.tuttipersonaruolos);
        vmd.enti_collegati = enti_collegati;
        vmd.progetti_collegati = progetti_collegati;


        if (vmd.progetti_collegati.length == 0) {
            vmd.progetti_collegati.push(Progetto);
        }

        vmd.personaHasProgettos = [];
        vmd.personaHasEntes = [];
        vmd.phe = [];
        vmd.php = [];
        vmd.phe2 = [];
        vmd.php2 = [];
        angular.forEach(vmd.enti_collegati, function (e) {
            if (angular.isUndefined(vmd.phe[e.id])) {
                vmd.phe[e.id] = [];
            }
            if (angular.isUndefined(vmd.phe2[e.id])) {
                vmd.phe2[e.id] = [];
            }
        });
        angular.forEach(vmd.progetti_collegati, function (p) {
            if (angular.isUndefined(vmd.php[p.id])) {
                vmd.php[p.id] = [];
            }
            if (angular.isUndefined(vmd.php2[p.id])) {
                vmd.php2[p.id] = [];
            }
        });

        vmd.indexEnte = [0];
        vmd.phe_new = [
            {},
            {},
            {},
            {},
            {},
            {}
        ];


        vmd.persona = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            dataNascita: '1900-12-09',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            progettoruolos: [],
            ruolos: [],
            nascita: [],
            studi_id: 0
        };
        vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
        vmd.allpersonas = [];
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewpersona = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewpersona = true;
            vmd.phe = angular.copy(vmd.phe_new);
            vmd.php = [];
            vmd.php = [
                {progetto_id: vmd.progetto_id},
                {progetto_id: vmd.progetto_id}
            ];
        }
        vmd.ruolosSelected = [];
        vmd.ambitosSelected = [];
        vmd.incaricosSelected = [];
        vmd.ruolosSelected_ro = [];
        vmd.ambitosSelected_ro = [];
        vmd.incaricosSelected_ro = [];
        vmd.ruolosSelected_rw = [];
        vmd.ambitosSelected_rw = [];
        vmd.incaricosSelected_rw = [];
        vmd.ruolosSelected2 = [];

        vmd.php_selected = [];
        vmd.phe_selected = [];

        if (vmd.index !== null) {
            vmd.persona_id = Progetto.personas[index].id;
            vmd.persona_nome = Progetto.personas[index].cognome + ' ' + Progetto.personas[index].nome;
            vmd.persona = angular.copy(Progetto.personas[index]);
            vmd.allpersonas.push(angular.copy(Progetto.personas[index]));
//            angular.forEach(vmd.persona.progettoruolos, function (obj) {
//                vmd.ruolosSelected.push(obj.id);
//            });
        }
        vmd.regiones = Regioni;
        vmd.regiones2 = Regioni;
        vmd.provincias = [];
        vmd.istats = [];
        vmd.provincias2 = [];
        vmd.istats2 = [];
        vmd.nazionalitas = ricerca.naziones;
        console.log("quiprog");

        vmd.ricerca = {
            cognome: null,
        };
        vmd.ricerca['entes-nome'] = null;
        vmd.ricerca['istats-comune'] = null;
        vmd.ricerca.dataNascita = null;
        vmd.dataNascitaB = null;
        vmd.ricerca.codiceFiscale = null;
        vmd.personaselezionato = {
            id: null
        };


        vmd.attivaDisattiva = attivaDisattiva;
        vmd.cercaPersona = cercaPersona;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.caricaProvince2 = caricaProvince2;
        vmd.caricaComuni2 = caricaComuni2;
        vmd.restituisciPersona = restituisciPersona;
        vmd.aggrimuoviente = aggrimuoviente;

        if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
            //vmd.caricaProvince(vmd.persona.codRegione);
        }
        if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
            //vmd.caricaComuni(vmd.persona.codProvincia);
        }
//        if (vmd.persona.nascita.codRegione !== null || vmd.persona.nascita.codRegione !== '') {
//            vmd.caricaProvince2(vmd.persona.nascita.codRegione);
//        }
//        if (vmd.persona.nascita.codProvincia !== null || vmd.persona.nascita.codProvincia !== '') {
//            vmd.caricaComuni2(vmd.persona.nascita.codProvincia);
//        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function aggrimuoviente(indice) {
            if (angular.isUndefined(indice)) {
                if (vmd.indexEnte.length <= 5) {
                    vmd.indexEnte.push(vmd.indexEnte.length);
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Massimo 6 incarichi/funzioni')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                }
            } else {
                vmd.indexEnte.splice(indice, 1);
                vmd.phe[indice] = {};
            }

            console.log("vmd.indexEnte", vmd.indexEnte);
            console.log("vmd.phe", vmd.phe);
            console.log("vmd.php", vmd.php);
        }

        function cercaPersona() {
            //cerco anche tra i nomi degli enti
            vmd.ricerca['entes-nome'] = vmd.ricerca['istats-comune'];
            vmd.ricerca.dataNascita = null;
            //vmd.ricerca['istats-comune'] = vmd.ricerca.comune;
            console.log("vmd.dataNascitaB:", vmd.dataNascitaB);
            if (vmd.dataNascitaB !== null) {
                vmd.ricerca.dataNascita = moment(angular.copy(vmd.dataNascitaB)).format("YYYY-MM-DD");

            }
            console.log("vmd.ricerca:", angular.copy(vmd.ricerca));
            vmd.ricerca['operatore'] = 'OR';
            vmd.ricerca['pagination'] = '200';
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null' || value === '') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                if (angular.isUndefined(vmd.ricerca.dataNascita)) {
                    api.personas.persona.like(vmd.ricerca, function (response) {
                        vmd.allpersonas = response.data;
                        vmd.links = response._links;
                        vmd.meta = response._meta;
                    });
                } else {
                    api.personas.persona.search(vmd.ricerca, function (response) {
                        vmd.allpersonas = response.data;
                        vmd.links = response._links;
                        vmd.meta = response._meta;
                    });
                }

            } else {
                api.personas.persona.get({}, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciPersona() {
            api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
                vmd.personaselezionato = response;
                vmd.personaHasProgettos = angular.copy(vmd.personaselezionato.personahasprogettos);
                vmd.personaHasEntes = angular.copy(vmd.personaselezionato.personahasentes);
                angular.forEach(vmd.personaHasProgettos, function (obj) {
                    if (angular.isUndefined(vmd.php[obj.progetto_id])) {
                        vmd.php[obj.progetto_id] = [];
                    }
                    if (angular.isUndefined(vmd.php2[obj.progetto_id])) {
                        vmd.php2[obj.progetto_id] = [];
                    }
                    vmd.php[obj.progetto_id].push(obj.personaRuolo_id);
                    vmd.php2[obj.progetto_id].push(obj);

                    if (obj.progetto_id == vmd.progetto_id) {
                        vmd.ruolosSelected.push(obj.personaRuolo_id);
                        vmd.ambitosSelected.push(obj.personaRuolo_id);
                        vmd.ruolosSelected.push(obj);
                        vmd.ambitosSelected.push(obj);
                    } else {
                        vmd.ruolosSelected_ro.push(obj);
                        vmd.ambitosSelected_ro.push(obj);
                    }
                });
                angular.forEach(vmd.personaHasEntes, function (obj) {
                    if (angular.isUndefined(vmd.phe[obj.ente_id])) {
                        vmd.phe[obj.ente_id] = [];
                    }
                    if (angular.isUndefined(vmd.phe2[obj.ente_id])) {
                        vmd.phe2[obj.ente_id] = [];
                    }
                    vmd.phe[obj.ente_id].push(obj.personaRuolo_id);
                    vmd.phe2[obj.ente_id].push(obj);

                    if (vmd.enti_collegati.map(function (o) {
                        return o.id;
                    }).indexOf(obj.ente_id) > -1) {
                        vmd.incaricosSelected.push(obj.personaRuolo_id);
                        vmd.incaricosSelected_rw.push(obj);
                    } else {
                        vmd.incaricosSelected_ro.push(obj);
                    }
                });
                console.log("vmd.enti_collegati", vmd.enti_collegati);
                console.log("vmd.personaruoloprogettos", vmd.personaruoloprogettos);
                console.log("vmd.progetti_collegati", vmd.progetti_collegati);
                console.log("vmd.php2", vmd.php2);
                console.log("vmd.phe2", vmd.phe2);
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }
        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias2 = response.data;
            });
        }

        function attivaDisattiva() {
            console.log("vmd.php2", vmd.php2[vmd.progetto_id]);

            vmd.controllo = vmd.php2[vmd.progetto_id];

            for (var indice = 0, len = vmd.controllo.length; indice < len; indice++) {
                api.personas.hasprogetto.aggiorna({id: vmd.controllo[indice].id, attivo: vmd.controllo[indice].attivo}, function (u) {
                });
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Modifica attivazione eseguita con successo')
                        .position('bottom right')
                        .hideDelay(1000)
                        );
            }

            $scope.hide();

            $state.reload();
        }

    }

    function DialogPersoneNewController($scope, $state, $mdDialog, Progetto, api, Regioni, newlink, ricerca, enti_collegati, progetti_collegati, $mdToast, persona, ente_id, progetto_id, locals)
    {
        var vmd = this;
        vmd.api = api;
        vmd.locals = locals;
        vmd.progetto_id = progetto_id;
        vmd.isAdmin = api.isAdmin;
        //vmd.persona_id
        //vmd.ente_id
        vmd.progetto_nome = Progetto.nome;

        if(persona) {
          vmd.persona = persona;
          vmd.persona_id = persona.id;
          vmd.persona_has_progetto = angular.copy(persona.personahasprogetto[0]);
        }

        vmd.persona_nome = null;
        vmd.personas = angular.copy(Progetto.personas);
        vmd.personastudis = ricerca.personastudis;
        console.log("vmd.personastudis", vmd.personastudis);

        vmd.enteruoloprogetto = ricerca.enteruoloprogettos;
        vmd.personaruoloprogettos = ricerca.personaruoloprogettos;
        vmd.personaruoloentes = ricerca.personaruoloentes;
        vmd.personaruoloambitos = ricerca.personaruoloambitos;
        vmd.enti_collegati = enti_collegati;
        vmd.progetti_collegati = progetti_collegati;


        if (vmd.progetti_collegati.length == 0) {
            vmd.progetti_collegati.push(Progetto);
        }

        vmd.personaHasProgettos = [];
        vmd.personaHasEntes = [];
        vmd.phe = [];
        vmd.php = [];
        angular.forEach(vmd.enti_collegati, function (e) {
            if (angular.isUndefined(vmd.phe[e.id])) {
                vmd.phe[e.id] = [];
            }
        });
        angular.forEach(vmd.progetti_collegati, function (p) {
            if (angular.isUndefined(vmd.php[p.id])) {
                vmd.php[p.id] = [];
            }
        });

        vmd.indexEnte = [0];
        vmd.phe_new = [
            {},
            {},
            {},
            {},
            {},
            {}
        ];


        vmd.persona = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            dataNascita: '1900-12-09',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            progettoruolos: [],
            ruolos: [],
            nascita: [],
            studi_id: 0
        };
        vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
        vmd.allpersonas = [];
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewpersona = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && !persona) {
            vmd.isnewpersona = true;
            vmd.phe = angular.copy(vmd.phe_new);
            vmd.php = [];
            vmd.php = [
                {progetto_id: vmd.progetto_id},
                {progetto_id: vmd.progetto_id}
            ];
        }
        vmd.ruolosSelected = [];
        vmd.ambitosSelected = [];
        vmd.incaricosSelected = [];
        vmd.ruolosSelected_ro = [];
        vmd.ambitosSelected_ro = [];
        vmd.incaricosSelected_ro = [];
        vmd.ruolosSelected_rw = [];
        vmd.ambitosSelected_rw = [];
        vmd.incaricosSelected_rw = [];
        vmd.ruolosSelected2 = [];

        vmd.php_selected = [];
        vmd.phe_selected = [];

        if (persona !== null) {
          vmd.persona_nome = persona.cognome + ' ' + persona.nome;
          vmd.persona = angular.copy(persona);
          vmd.allpersonas.push(angular.copy(persona));
//            angular.forEach(vmd.persona.progettoruolos, function (obj) {
//                vmd.ruolosSelected.push(obj.id);
//            });
        }
        vmd.regiones = Regioni;
        vmd.regiones2 = Regioni;
        vmd.provincias = [];
        vmd.istats = [];
        vmd.provincias2 = [];
        vmd.istats2 = [];
        vmd.nazionalitas = ricerca.naziones;

        vmd.ricerca = {
            cognome: null,
        };
        vmd.ricerca['entes-nome'] = null;
        vmd.ricerca['istats-comune'] = null;
        vmd.ricerca.dataNascita = null;
        vmd.dataNascitaB = null;
        vmd.ricerca.codiceFiscale = null;
        vmd.personaselezionato = {
            id: null
        };


        vmd.savenew = savenew;
        vmd.delete = del;
        vmd.cercaPersona = cercaPersona;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.caricaProvince2 = caricaProvince2;
        vmd.caricaComuni2 = caricaComuni2;
        vmd.restituisciPersona = restituisciPersona;
        vmd.aggrimuoviente = aggrimuoviente;

        if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
            //vmd.caricaProvince(vmd.persona.codRegione);
        }
        if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
            //vmd.caricaComuni(vmd.persona.codProvincia);
        }
//        if (vmd.persona.nascita.codRegione !== null || vmd.persona.nascita.codRegione !== '') {
//            vmd.caricaProvince2(vmd.persona.nascita.codRegione);
//        }
//        if (vmd.persona.nascita.codProvincia !== null || vmd.persona.nascita.codProvincia !== '') {
//            vmd.caricaComuni2(vmd.persona.nascita.codProvincia);
//        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function aggrimuoviente(indice) {
            if (angular.isUndefined(indice)) {
                if (vmd.indexEnte.length <= 5) {
                    vmd.indexEnte.push(vmd.indexEnte.length);
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Massimo 6 incarichi/funzioni')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                }
            } else {
                vmd.indexEnte.splice(indice, 1);
                vmd.phe[indice] = {};
            }

            console.log("vmd.indexEnte", vmd.indexEnte);
            console.log("vmd.phe", vmd.phe);
            console.log("vmd.php", vmd.php);
        }

        function cercaPersona() {
            //cerco anche tra i nomi degli enti
            vmd.ricerca['entes-nome'] = vmd.ricerca['istats-comune'];
            vmd.ricerca.dataNascita = null;
            //vmd.ricerca['istats-comune'] = vmd.ricerca.comune;
            console.log("vmd.dataNascitaB:", vmd.dataNascitaB);
            if (vmd.dataNascitaB !== null) {
                vmd.ricerca.dataNascita = moment(angular.copy(vmd.dataNascitaB)).format("YYYY-MM-DD");

            }
            console.log("vmd.ricerca:", angular.copy(vmd.ricerca));
            vmd.ricerca['operatore'] = 'OR';
            vmd.ricerca['pagination'] = '200';
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null' || value === '') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                if (angular.isUndefined(vmd.ricerca.dataNascita)) {
                    api.personas.persona.like(vmd.ricerca, function (response) {
                        vmd.allpersonas = response.data;
                        vmd.links = response._links;
                        vmd.meta = response._meta;
                    });
                } else {
                    api.personas.persona.search(vmd.ricerca, function (response) {
                        vmd.allpersonas = response.data;
                        vmd.links = response._links;
                        vmd.meta = response._meta;
                    });
                }

            } else {
                api.personas.persona.get({}, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciPersona() {
            api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
                vmd.personaselezionato = response;
                vmd.personaHasProgettos = angular.copy(vmd.personaselezionato.personahasprogettos);
                vmd.personaHasEntes = angular.copy(vmd.personaselezionato.personahasentes);
                angular.forEach(vmd.personaHasProgettos, function (obj) {
                    if (angular.isUndefined(vmd.php[obj.progetto_id])) {
                        vmd.php[obj.progetto_id] = [];
                    }
                    vmd.php[obj.progetto_id].push(obj.personaRuolo_id);

                    if (obj.progetto_id == vmd.progetto_id) {
                        vmd.ruolosSelected.push(obj.personaRuolo_id);
                        vmd.ambitosSelected.push(obj.personaRuolo_id);
                        vmd.ruolosSelected.push(obj);
                        vmd.ambitosSelected.push(obj);
                    } else {
                        vmd.ruolosSelected_ro.push(obj);
                        vmd.ambitosSelected_ro.push(obj);
                    }
                });
                angular.forEach(vmd.personaHasEntes, function (obj) {
                    if (angular.isUndefined(vmd.phe[obj.ente_id])) {
                        vmd.phe[obj.ente_id] = [];
                    }
                    vmd.phe[obj.ente_id].push(obj.personaRuolo_id);

                    if (vmd.enti_collegati.map(function (o) {
                        return o.id;
                    }).indexOf(obj.ente_id) > -1) {
                        vmd.incaricosSelected.push(obj.personaRuolo_id);
                        vmd.incaricosSelected_rw.push(obj);
                    } else {
                        vmd.incaricosSelected_ro.push(obj);
                    }
                });

            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }
        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias2 = response.data;
            });
        }


        function savenew() {
            var php_copy = vmd.php;
            var phe_copy = vmd.phe;
            var isReferente = false;
            var idRuoloReferenteProgetto = 9;

            if (vmd.isnewpersona) {
                //trasformo php e phe
                var tphp_copy = [];
                var tphe_copy = [];

                angular.forEach(php_copy, function (p) {
                    if (angular.isUndefined(tphp_copy[p.progetto_id])) {
                        tphp_copy[p.progetto_id] = [];
                    }
                    angular.forEach(p.ruolo_id, function (r) {
                        if (tphp_copy[p.progetto_id].indexOf(r) === -1) {
                            tphp_copy[p.progetto_id].push(r);
                        }
                    });

                });
                angular.forEach(phe_copy, function (e) {
                    if (angular.isUndefined(tphe_copy[e.ente_id])) {
                        tphe_copy[e.ente_id] = [];
                    }
                    angular.forEach(e.ruolo_id, function (r) {
                        if (tphe_copy[e.ente_id].indexOf(r) === -1) {
                            tphe_copy[e.ente_id].push(r);
                        }
                    });
                });
                php_copy = tphp_copy;
                phe_copy = tphe_copy;
            }

            //PARTO DA persona_id -> progetto_id/ente_id ->personaRuolo_id
            var persona_id = vmd.personaselezionato.id;
            //potrebbe essere null se nuovo
            var php_payload = [];
            var phe_payload = [];
            angular.forEach(php_copy, function (l1v, l1k) {
                var tphp_payload = {};
                angular.forEach(l1v, function (l2v) {
                    tphp_payload = {};
                    tphp_payload.persona_id = persona_id;
                    tphp_payload.progetto_id = l1k;
                    tphp_payload.personaRuolo_id = l2v;
                    if (l2v === idRuoloReferenteProgetto) {
                        isReferente = true;
                    }

                    var ir = -1;
                    ir = vmd.personaruoloprogettos.map(function (o) {
                        return o.id;
                    }).indexOf(l2v);
                    var ia = -1;
                    ia = vmd.personaruoloambitos.map(function (o) {
                        return o.id;
                    }).indexOf(l2v);

                    if (ir > -1) {
                        tphp_payload.ruolo = vmd.personaruoloprogettos[ir].descrizione;
                    }
                    if (ia > -1) {
                        tphp_payload.ruolo = vmd.personaruoloambitos[ia].descrizione;
                    }

                    php_payload.push(tphp_payload);
                });
            });
            angular.forEach(phe_copy, function (l1v, l1k) {
                var tphe_payload = {};
                angular.forEach(l1v, function (l2v) {
                    tphe_payload = {};
                    tphe_payload.persona_id = persona_id;
                    tphe_payload.ente_id = l1k;
                    tphe_payload.personaRuolo_id = l2v;

                    var ie = -1;
                    ie = vmd.personaruoloentes.map(function (o) {
                        return o.id;
                    }).indexOf(l2v);

                    if (ie > -1) {
                        tphe_payload.ruolo = vmd.personaruoloentes[ie].descrizione;
                    }

                    phe_payload.push(tphe_payload);
                });
            });



            var persona_has_progetto = {};
            var persona_has_ente = {};

            if (vmd.isnewpersona) {
                //nuova entita + colelgamento

                var m = moment(vmd.persona.dataNascita2);
                vmd.persona.dataNascita = m.format("YYYY-MM-DD");
                api.personas.persona.save(vmd.persona, function (response) {

                    persona_id = response.id;
                    if (persona_id > 0) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Persona salvata')
                                .position('bottom right')
                                .hideDelay(1000)
                                );
                        //modifico payload aggiungendo persona_id
                        angular.forEach(php_payload, function (v, k) {
                            if (php_payload[k].persona_id == null) {
                                php_payload[k].persona_id = persona_id;
                            }
                        });
                        angular.forEach(phe_payload, function (v, k) {
                            if (phe_payload[k].persona_id == null) {
                                phe_payload[k].persona_id = persona_id;
                            }
                        });
                        persona_has_progetto = {
                            modelrelation: 'Personahasprogetto',
                            idname: 'persona_id',
                            idvalue: persona_id,
                            idnamefk: 'progetto_id',
                            idnamefk2: 'personaRuolo_id',
                            idnamePayload: 'progetto_id',
                            extrafields: ["ruolo"],
                            payload: php_payload

                        };
                        persona_has_ente = {
                            modelrelation: 'Personahasente',
                            idname: 'persona_id',
                            idvalue: persona_id,
                            idnamefk: 'ente_id',
                            idnamefk2: 'personaRuolo_id',
                            idnamePayload: 'ente_id',
                            extrafields: ["ruolo"],
                            payload: phe_payload
                        };
                        api.personas.persona.hasmany(persona_has_progetto, function (rphp) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Collegamento progetto creato')
                                    .position('bottom right')
                                    .hideDelay(1000)
                                    );
                            // api.personas.persona.hasmany(persona_has_ente, function (rphe) {
                            //     $mdToast.show(
                            //             $mdToast.simple()
                            //             .textContent('Collegamento enti creato')
                            //             .position('bottom right')
                            //             .hideDelay(3000)
                            //             );
                            //     //.then(function () {
                            //     console.log("isReferente:", isReferente);
                            //     if (isReferente) {
                            //         var indiceevento = vmd.locals.Progetto.eventos.map(function (o) {
                            //             return o.eventoTipo_id;
                            //         }).indexOf(3004);
                            //         var idEvento = vmd.locals.Progetto.eventos[indiceevento].id;
                            //         api.eventos.evento.update({id: idEvento, eventoStato_id: 4}, function (r) {
                            //             $state.reload();
                            //             $scope.hide();
                            //         });
                            //     } else {
                            //         $state.reload();
                            //         $scope.hide();
                            //     }
                            //     //});
                            //
                            // });
                        });

                    }
                });
            } else {
                //solo collegamento
                persona_has_progetto = {
                    modelrelation: 'Personahasprogetto',
                    idname: 'persona_id',
                    idvalue: persona_id,
                    idnamefk: 'progetto_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'progetto_id',
                    extrafields: ["ruolo"],
                    payload: php_payload

                };
                persona_has_ente = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    extrafields: ["ruolo"],
                    payload: phe_payload
                };
                if (vmd.persona_has_progetto) {
                  api.progettomc.accessPermission(vmd.persona_has_progetto);
                }
                api.personas.persona.hasmany(persona_has_progetto, function (rphp) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Collegamento progetto modificato')
                            .position('bottom right')
                            .hideDelay(1000)
                            );
                    // api.personas.persona.hasmany(persona_has_ente, function (rphe) {
                    //     $mdToast.show(
                    //             $mdToast.simple()
                    //             .textContent('Collegamento enti modificato')
                    //             .position('bottom right')
                    //             .hideDelay(1000)
                    //             ).then(function (fine) {
                    //         if (isReferente) {
                    //             var indiceevento = vmd.locals.Progetto.eventos.map(function (o) {
                    //                 return o.eventoTipo_id;
                    //             }).indexOf(3004);
                    //             var idEvento = vmd.locals.Progetto.eventos[indiceevento].id;
                    //             if (angular.isDefined(idEvento)) {
                    //                 api.eventos.evento.update({id: idEvento, eventoStato_id: 4}, function (r) {
                    //                     $state.reload();
                    //                     $scope.hide();
                    //                 });
                    //             }
                    //         } else {
                    //             $state.reload();
                    //             $scope.hide();
                    //         }
                    //     }
                    //     );
                    // });
                });

            }

            console.log("persona_has_ente:", persona_has_ente);
            console.log("persona_has_progetto", persona_has_progetto);
            //io non le avevo prossime 2 righe Corrado SI
            $state.reload();
            $scope.hide();
//var hasmanypersonaps = {
//                        modelrelation: 'Personahasprogetto',
//                        idname: 'progetto_id',
//                        idvalue: vmd.progetto_id,
//                        idnamefk: 'persona_id',
//                        idnamefk2: 'personaRuolo_id',
//                        idnamePayload: 'persona_id',
//                        payload: payload};

        }
        vmd.check = check;
        function check() {
            console.log("vmd.phe_selected:", vmd.phe);
            console.log("vmd.php_selected:", vmd.php);
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.persona_nome + '</b>' + ' sarà cancellato.<br>.')
                    .ariaLabel('cancella persona')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function ()
            {
                var id_to_delete_p = [];
                var id_to_delete_e = [];
                angular.forEach(vmd.personaHasProgettos, function (p) {
                    if (p.persona_id == vmd.personaselezionato.id && p.progetto_id == vmd.progetto_id) {
                        id_to_delete_p.push(p.id);
                    }
                });
                angular.forEach(vmd.personaHasEntes, function (p) {
                    if (p.persona_id == vmd.personaselezionato.id && (vmd.enti_collegati.map(function (o) {
                        return o.id;
                    }).indexOf(p.ente_id) > -1)) {
                        id_to_delete_e.push(p.id);
                    }
                });
                angular.forEach(id_to_delete_p, function (d) {
                    api.personas.hasprogetto.remove({id: d});
                });
                angular.forEach(id_to_delete_e, function (d) {
                    api.personas.hasente.remove({id: d});
                });
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Eliminazione in corso..attendere qualche istante.')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(function () {
                    $scope.hide();
                    $state.reload();
                });



            }, function () {
            });

        }

        vmd.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vmd.persona.email)) {
                api.users.log.checkemail({email: vmd.persona.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
            }
        }
        vmd.checkCF = checkCF;
        vmd.validcf = true;
        function checkCF(ev) {
            console.log("persona", vmd.persona);
            console.log("scope", $scope);
            if (angular.isDefined(vmd.persona.codiceFiscale)) {
                api.users.log.checkcf({codiceFiscale: vmd.persona.codiceFiscale}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", false);
                                vmd.validcf = false;
                            } else {
                                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", true);
                                vmd.validcf = true;
                            }
                        });
            } else {
                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", true);
                vmd.validcf = true;
            }
        }


        vmd.rimuoviente = rimuoviente;
        function rimuoviente(index) {
            console.log(index);
            console.log(vmd.phe);
            vmd.phe.splice(index, 1);
        }
        vmd.aggiungiente = aggiungiente;
        function aggiungiente(index) {
            vmd.phe.splice(index, 1);
        }


    }

    function DialogProfiloNewController($scope, $state, $mdDialog, api, index, ricerca, $mdToast, persona_id, progetto_id, locals)
    {
        var vmd = this;
        vmd.locals = locals;
        console.log("vmd.locals", vmd.locals);
        vmd.user = {
            username: null,
            email: null,
            password: null,
            passwordc: null,
            status: 0,
            gruppo_id: []
        };
        vmd.user_id = -1;
        vmd.isnewuser = true;
        vmd.gruppiselected;
        vmd.api = api;
        if (angular.isDefined(vmd.locals.user_id)) {
            vmd.isnewuser = false;
            vmd.user_id = vmd.locals.user_id;

        }
        if (!vmd.isnewuser) {
            api.users.user2.get({id: vmd.user_id}, function (u) {
                vmd.user = u;
                vmd.user.gruppo_id = vmd.user.gruppos.map(function (o) {
                    return o.id;
                });
                vmd.gruppiselected = vmd.user.gruppos.map(function (o) {
                    return o.id;
                });
                console.log("vmd.user", vmd.user);
            });
        }


        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        vmd.checkEmail = checkEmail;
        function checkEmail() {
            if (angular.isDefined(vmd.user.email)) {
                api.users.log.checkemail({email: vmd.user.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.personaNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.personaNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.personaNForm.email.$setValidity("unique", true);
            }
        }

        vmd.preregister = preregister;
        function preregister() {
            $scope.personaNForm.username.$setValidity("unique", true);
            //vmd.checkEmail();
            api.users.log.preregister(vmd.user).$promise.then(
                    function (response) {
                        if (response.status != undefined && response.status == 200) {
                            $scope.personaNForm.username.$setValidity("unique", true);
                            $scope.personaNForm.email.$setValidity("unique", true);
                        } else {
                            if (angular.isDefined(response.email)) {
                                $scope.personaNForm.email.$setValidity("unique", false);
                            }


                            if (response.username != undefined) {
                                $scope.personaNForm.username.$setValidity("unique", false);
                            }
                        }
                    });
            //vmd.errors = $scope.registerForm.$error;
        }

        vmd.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vmd.user.password !== vmd.user.passwordc) {
                $scope.personaNForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.personaNForm.passwordc.$setValidity("passwordVerify", true);
            }
        }
        vmd.resetErrors = resetErrors;
        function resetErrors() {
            $scope.personaNForm.username.$setValidity("unique", true);
            $scope.personaNForm.email.$setValidity("unique", true);
        }
        vmd.createuser = createuser;
        function createuser() {
            console.log("vmd.user", vmd.user);
            console.log("gruppiselected", vmd.gruppiselected);
//            api.users.log.preregister(vmd.user, function (e) {
//                delete e.$promise;
//                delete e.$resolved;
//                if (e.status === 200) {
//                    vmd.user.doit = true;
//                    vmd.user.disableuser = false;
//                    $mdDialog.hide(vmd.user);
//                } else {
//                    vmd.errors = angular.copy(e);
//                    angular.forEach(vmd.errors, function (er, k) {
//                        $scope.personaNForm[k].$setValidity("unique", false);
//                    });
//                    console.log("vmd.errors", vmd.errors);
//                }
//            });
        }

        vmd.changepassword = changepassword;
        function changepassword() {
            vmd.user.doit = true;
            vmd.user.disableuser = false;
            $mdDialog.hide(vmd.user);
        }

        vmd.disableuser = disableuser;
        function disableuser() {
            vmd.user.doit = true;
            vmd.user.disableuser = true;
            $mdDialog.hide(vmd.user);
        }

        vmd.gruppi = [];
        vmd.gruppi = loadGroups();
        function loadGroups() {
            api.gruppos.gruppi.search({sort: "gruppo"}, function (response) {
                vmd.gruppi = response.data;
            });
        }




    }

    function DialogRegisterController($scope, $state, $mdDialog, api, locals) {
        var vm = this;
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.modificag = false;
        vm.passwordvisible = "password";
        console.log(" DialogRegisterController");
        vm.locals = locals;
        //console.log("vm.locals", vm.locals);
        vm.disabled = vm.locals.disabled;
        vm.registerdata = {};
        vm.registerdata.doit = false;
        vm.registerdata.isnew = vm.locals.isnew;
        vm.registerdata.disableuser = false;
        vm.registerdata.persona_id = vm.locals.persona_id;

        if (vm.locals.gruppo_id !== false) {
            //disabilita gruppi
            vm.registerdata.gruppo_id = vm.locals.gruppo_id;
        }

        if (angular.isDefined(vm.locals.persona_id)) {
            api.personas.persona2.get({id: vm.locals.persona_id}, function (d) {
                //console.log("d", d);

                if (d.users !== null && angular.isDefined(d.users.user)) {
                    vm.registerdata = d.users.user;
                    vm.registerdata.gruppo_id = d.users.user.groups.map(function (o) {
                        return o.group_id;
                    });
                    vm.locals.gruppo_id = d.users.user.groups.map(function (o) {
                        return o.group_id;
                    });
                    vm.registerdata.email = d.users.user.email;


                }
                if (angular.isUndefined(vm.registerdata.email)) {
                    vm.registerdata.email = d.email;
                }
                vm.registerdata.persona_id = vm.locals.persona_id;
                if (angular.isUndefined(vm.registerdata.username)) {
                    vm.registerdata.username = d.cognome.toLowerCase() + "." + d.nome.toLowerCase();
                    vm.registerdata.username = vm.registerdata.username.substring(0, 15);
                }
                var autopassword = api.makeid(8);
                vm.registerdata.password = autopassword;
                vm.registerdata.passwordc = autopassword;
                vm.preregister;
            });
        }

        vm.checkEmail = checkEmail;
        function checkEmail() {
            if (angular.isDefined(vm.registerdata.email)) {
                api.users.log.checkemail({email: vm.registerdata.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            } else {
                                $scope.registerForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.registerForm.email.$setValidity("unique", true);
            }
        }

        vm.preregister = preregister;
        function preregister() {
            $scope.registerForm.username.$setValidity("unique", true);
            //vm.checkEmail();
            api.users.log.preregister(vm.registerdata).$promise.then(
                    function (response) {
                        if (response.status != undefined && response.status == 200) {
                            $scope.registerForm.username.$setValidity("unique", true);
                            $scope.registerForm.email.$setValidity("unique", true);
                        } else {
                            if (angular.isDefined(response.email)) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            }
                            if (response.username != undefined) {
                                $scope.registerForm.username.$setValidity("unique", false);
                            }
                        }
                    });
            //vm.errors = $scope.registerForm.$error;
        }

        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.registerdata.password !== vm.registerdata.passwordc) {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", true);
            }
        }
        vm.resetErrors = resetErrors;
        function resetErrors() {
            $scope.registerForm.username.$setValidity("unique", true);
            $scope.registerForm.email.$setValidity("unique", true);
        }
        vm.createuser = createuser;
        function createuser() {
            api.users.log.preregister(vm.registerdata, function (e) {
                delete e.$promise;
                delete e.$resolved;
                if (e.status === 200) {
                    vm.registerdata.doit = true;
                    vm.registerdata.disableuser = false;
                    $mdDialog.hide(vm.registerdata);
                } else {
                    vm.errors = angular.copy(e);
                    angular.forEach(vm.errors, function (er, k) {
                        $scope.registerForm[k].$setValidity("unique", false);
                    });
                    console.log("vm.errors", vm.errors);
                }
            });
        }

        vm.changepassword = changepassword;
        function changepassword() {
            vm.registerdata.doit = true;
            vm.registerdata.disableuser = false;
            vm.registerdata.modificag = vm.modificag;

            $mdDialog.hide(vm.registerdata);
        }

        vm.changeGruop = changeGruop;
        function changeGruop() {
            vm.registerdata.doit = true;
            vm.registerdata.disableuser = false;
            vm.registerdata.modificag = vm.modificag;
            vm.registerdata.changeGroup = true;

            $mdDialog.hide(vm.registerdata);
        }

        vm.disableuser = disableuser;
        function disableuser() {
            vm.registerdata.doit = true;
            vm.registerdata.disableuser = true;
            $mdDialog.hide(vm.registerdata);
        }

        vm.gruppi = [];
        vm.gruppi = loadGroups();
        function loadGroups() {
            api.gruppos.gruppi.search({sort: "gruppo"}, function (response) {
                vm.gruppi = response.data;
            });
        }

        vm.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide(vm.registerdata);
        }

    }

})();

 
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.contatti', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_contatti', {
            url: '/sprardb/anagrafiche',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/contatti/contacts.html',
                    controller: 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');

                },
                Tags: function (msApi)
                {
                    return msApi.resolve('tags@get');

                }
            }
        });

        $stateProvider.state('app.sprardb_contatti_dettaglio_dettaglio', {
            url: '/sprardb/contatti/dettaglio/contact/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/contatti/dettaglio/dettaglio.html',
                    controller: 'DettaglioBController as vm'
                }
            },
            resolve: {
                Persona: function (msApi, $stateParams)
                {

                    return msApi.resolve('contacts1@get', {id: $stateParams.id});

                },
                Tags: function (msApi)
                {
                    return msApi.resolve('tags@get');

                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/contatti');


        // Api
        msApiProvider.register('contacts.contacts', ['http://localhost/sprardb/app-server/web/personas']);
        msApiProvider.register('contacts1', ['http://localhost/sprardb/app-server/web/personas/search']);
        msApiProvider.register('tags', ['http://localhost/sprardb/app-server/web/tags']);


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';




    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.contatti')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        vm.evento = "update";

        vm.provincias = [];
        vm.istats = [];

        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;

        vm.provincias2 = [];
        vm.istats2 = [];

        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;


        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2=vm.regiones;
        });

        if ( !vm.contact )
        {
            vm.evento = "new";
            vm.contact = {
                'id'      : null,
                'nome'    : null,
                'cognome': null,
                'sesso'  : null,
                'codRegione': null,
                'codProvincia' : null,
                'codComune' : null,
                'indirizzo' : null,
                'cap' : null,
                'email'   : '',
                'telefono'   : '',
                'dataNascita': "01-01-2016",
                'dataNascita2': null,
                'codComuneNascita' : null,
                'codNazionalita' : null,
                'codiceFiscale': null,
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2=new Date(vm.contact.dataNascita);


        vm.contact2 = {
            'codRegione': null,
            'codProvincia' : null,
            'codComune' : null,
            'codComuneNascita' : null,
            };

        vm.nazioni=null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination:200},function (response){
            vm.nazioni=response.data;
            vm.links=response._links;
            vm.meta=response._meta;
        });



        if ((vm.regiones !== null || vm.contact.codRegione !== '') && vm.evento === "update") {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if ((vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') && vm.evento === "update") {
            vm.caricaComuni(vm.contact.codProvincia);
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        if ((vm.regiones2 !== null || vm.contact2.codRegione !== '') && vm.evento === "update") {
            vm.caricaProvince2(vm.contact.nascita.codRegione);
        }
        if ((vm.contact2.codProvincia !== null || vm.contact2.codProvincia !== '') && vm.evento === "update") {
            vm.caricaComuni2(vm.contact.nascita.codProvincia);
        }

        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }




      

        // Methods
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.persona = vm.contact;
        //////////

        /**
         * Save contact
         */
        function saveContact(ev,contact)
        {
          if (ev=="new") {
            var m = moment(contact.dataNascita2);
            contact.dataNascita = m.format("YYYY-MM-DD");
            api.personas.persona.save(contact,function (response){
                $state.reload();
                closeDialog();
                });
          }
          if (ev=="update"){
            var m = moment(contact.dataNascita2);
            contact.dataNascita = m.format("YYYY-MM-DD");
            api.personas.persona.aggiorna(contact,function (response){
                $state.reload();
                closeDialog();
                });
          }
        }

        /**
         * Delete Contact Dialog
         */


        function deleteContactConfirm(contact , ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il contatto?')
                .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

                $mdDialog.show(confirm).then(function ()
                {
                  api.personas.persona.remove({id: Contact.id},function (response){
                      $state.reload();
                      closeDialog();
                      });

                });

          }




        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';
    angular.module('app.sprardb.notification', []).config(config);
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {

        $stateProvider.state('app.sprardb_notification', {
            url: '/sprardb/segnalazioni',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/notification/notification.html',
                    controller: 'NotificationController as vm'
                }
            },
            datas: {
                autoinsert: false
            }

        });
        $stateProvider.state('app.sprardb_autoinserimento', {
            url: '/sprardb/autosegnalazioni',
            views: {
                'content@app': {
                    //templateUrl: 'app/main/sprardb/notification/autoinserimento.html',
                    templateUrl: 'app/main/sprardb/notification/notification.html',
                    controller: 'NotificationController as vm'
                }
            },
            datas: {
              title: "Ricerca modello C",
              autoinsert: true,
              tipologie: ['656','689']
            }

        });
        $stateProvider.state('app.sprardb_ricercasc', {
          url: '/sprardb/autosegnalazionisc',
          views: {
            'content@app': {
              templateUrl: 'app/main/sprardb/notification/notification.html',
              controller: 'NotificationController as vm'
            }
          },
          datas: {
            title: "Ricerca Inserimento SC",
            autoinsert: true,
            tipologie: ['605']
          }

        });

      $stateProvider.state('app.sprardb_notification_presenti', {
        url: '/sprardb/presenti',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/notification/notification.html',
            controller: 'NotificationController as vm'
          }
        },
        datas: {
          title: "Ricerca Inserimenti Sul Territorio",
          autoinsert: true,
          tipologie: ['697']
        }
      });
        $stateProvider.state('app.sprardb_rsegnalati', {
            url: '/sprardb/ricercasegnalati',
            views: {
                'content@app': {
                    //templateUrl: 'app/main/sprardb/notification/autoinserimento.html',
                    templateUrl: 'app/main/sprardb/notification/rsegnalati.html',
                    controller: 'RsegnalatiController as vm'
                }
            },
            datas: {
              autoinsert: false
            }

        });
        $stateProvider.state('app.sprardb_nuovasegnalazione', {
            url: '/nuovasegnalazione',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/notification/notification-details.html',
                    controller: 'NotificationDetailController as vm'
                }
            },
            datas: {
                autoinsert: false
            }
        });
        $stateProvider.state('app.sprardb_nuovaautosegnalazione', {
            url: '/nuovaautosegnalazione',
            views: {
                'content@app': {
                    //templateUrl: 'app/main/sprardb/notification/autoinserimento-details.html',
                    templateUrl: 'app/main/sprardb/notification/notification-details.html',
                    controller: 'NotificationDetailController as vm'
                }
            },
            datas: {
              title:'Nuova Registrazione',
              autoinsert: true
            }
        });
        $stateProvider.state('app.sprardb_notification.editreport', {
            url: '/visualizza/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/notification/notification-details.html',
                    controller: 'NotificationDetailController as vm'
                }
            },
            datas: {
                autoinsert: false
            }
        });
        $stateProvider.state('app.sprardb_notification.editareport', {
            url: '/visualizzaauto/:id',
            views: {
                'content@app': {
                    //templateUrl: 'app/main/sprardb/notification/autoinserimento-details.html',
                    templateUrl: 'app/main/sprardb/notification/notification-details.html',
                    controller: 'NotificationDetailController as vm'
                }
            },
            datas: {
                autoinsert: true
            }
        });
        $stateProvider.state('app.sprardb_notification.segnalatori', {
            url: '/segnalatori',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/notification/segnalatori.html',
                    controller: 'oooSegnalatoriController as vm'
                }
            }
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/notification');
        // Api
        //msApiProvider.register('beneficiario', ['http://localhost/sprardb/app-server/web/segnalaziones/search']);

//locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };
        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };
        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

// Navigation
        //msNavigationServiceProvider.saveItem('sprardb.segins.segnalazioni.lista', {
//        msNavigationServiceProvider.saveItem('sprardb.segins', {
//            title: 'SEGNALAZIONI',
//            //icon: 'icon-briefcase-upload',
//            weight: 2,
//            //allow: [1, 3, 6, 11]
//        });

        msNavigationServiceProvider.saveItem('sprardb.segnalazioni.ricercasegnalazioni', {
            title: 'Ricerca segnalazioni',
            icon: 'icon-view-list',
            state: 'app.sprardb_notification',
            weight: 1
        });
        //msNavigationServiceProvider.saveItem('sprardb.segins.ainserimenti.lista', {
        msNavigationServiceProvider.saveItem('sprardb.segnalazioni.ricercaauto', {
            title: 'Ricerca Autosegnalazione',
            icon: 'icon-view-list',
            state: 'app.sprardb_autoinserimento',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('sprardb.segnalazioni.ricercasegnalati', {
            title: 'Ricerca Segnalati',
            icon: 'icon-view-list',
            state: 'app.sprardb_rsegnalati',
            weight: 3
        });
        /*
         //barra segnalatore
         msNavigationServiceProvider.saveItem('segnalatore.segnalazioni.ricercasegnalazioni', {
         title: 'Ricerca segnalazioni',
         icon: 'icon-view-list',
         state: 'app.sprardb_notification',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('segnalatore.segnalazioni.nuovasegnalazione', {
         title: 'Nuova segnalazione',
         icon: 'icon-playlist-plus',
         state: 'app.sprardb_nuovasegnalazione',
         weight: 5
         });
         msNavigationServiceProvider.saveItem('segnalatore.segnalazioni.ricercasegnalati', {
         title: 'Ricerca Segnalati',
         icon: 'icon-view-list',
         state: 'app.sprardb_rsegnalati',
         weight: 6
         });
         //barra segreteria
         msNavigationServiceProvider.saveItem('scsegreteria.segnalazioni.ricercasegnalazioni', {
         title: 'Ricerca segnalazioni',
         icon: 'icon-view-list',
         state: 'app.sprardb_notification',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('scsegreteria.segnalazioni.nuovasegnalazione', {
         title: 'Nuova segnalazione',
         icon: 'icon-playlist-plus',
         state: 'app.sprardb_nuovasegnalazione',
         weight: 5
         });
         msNavigationServiceProvider.saveItem('scsegreteria.segnalazioni.ricercasegnalati', {
         title: 'Ricerca Segnalati',
         icon: 'icon-view-list',
         state: 'app.sprardb_rsegnalati',
         weight: 6
         });
         //barra properatore
         msNavigationServiceProvider.saveItem('properatore.segnalazioni.ricercaauto', {
         title: 'Ricerca Autosegnalazione',
         icon: 'icon-view-list',
         state: 'app.sprardb_autoinserimento',
         weight: 5
         });
         msNavigationServiceProvider.saveItem('properatore.segnalazioni.nuovaasegnalazione', {
         title: 'Nuova autosegnalazione',
         icon: 'icon-playlist-plus',
         state: 'app.sprardb_nuovaautosegnalazione',
         weight: 6
         });
         msNavigationServiceProvider.saveItem('properatore.segnalazioni.ricercasegnalati', {
         title: 'Ricerca Segnalati',
         icon: 'icon-view-list',
         state: 'app.sprardb_rsegnalati',
         weight: 7
         });
         */
//barra admin
//        msNavigationServiceProvider.saveItem('scadmin.segnalazioni.ricercasegnalazioni', {
//            title: 'Ricerca segnalazioni',
//            icon: 'icon-view-list',
//            state: 'app.sprardb_notification',
//            weight: 4
//        });
//        msNavigationServiceProvider.saveItem('scadmin.segnalazioni.nuovasegnalazione', {
//            title: 'Nuova segnalazione',
//            icon: 'icon-playlist-plus',
//            state: 'app.sprardb_nuovasegnalazione',
//            weight: 5
//        });
//        msNavigationServiceProvider.saveItem('scadmin.segnalazioni.ricercaauto', {
//            title: 'Ricerca Autosegnalazione',
//            icon: 'icon-view-list',
//            state: 'app.sprardb_autoinserimento',
//            weight: 6
//        });
//        msNavigationServiceProvider.saveItem('scadmin.segnalazioni.nuovaasegnalazione', {
//            title: 'Nuova autosegnalazione',
//            icon: 'icon-playlist-plus',
//            state: 'app.sprardb_nuovaautosegnalazione',
//            weight: 7
//        });
//        msNavigationServiceProvider.saveItem('scadmin.segnalazioni.ricercasegnalati', {
//            title: 'Ricerca Segnalati',
//            icon: 'icon-view-list',
//            state: 'app.sprardb_rsegnalati',
//            weight: 8
//        });









    }
})();


(function ()
{
    'use strict';

    angular.module('app.sprardb.notification').controller('NotificationValidateController', NotificationValidateController);

    function NotificationValidateController($scope, $mdDialog, locals, $state, api) {
        var vm = this;
        vm.tokenauto = locals.tokenauto;
        vm.tokenresend = false;
        vm.verifydata = {
            mobile: locals.mobile,
            token: null
        };
        vm.verify = verify;
        vm.validtoken = false;
        function verify() {
            api.tokens.token.validatecode(vm.verifydata, function (response) {

                vm.validtoken = false;
                $mdDialog.hide(response);
            }, function (response) {
                vm.validtoken = true;
            });
        }
        ;
        vm.cancel = function () {
            $mdDialog.cancel();
        };
        vm.resend = function () {
            api.tokens.token.sendcode({mobile: vm.verifydata.mobile}, function (response) {
                vm.tokenauto = response.token;
                $scope.tokenresend = true;
            }, function (response) {
                console.log(response);
            });
        };
    }

})();



(function ()
{
    'use strict';

    angular
            .module('app.sprardb.notification')
            .controller('NotificatioPersonaViewController', NotificatioPersonaViewController);

    /** @ngInject */
    function NotificatioPersonaViewController($mdDialog, locals, msUtils, msApi, $state, api,Notification)
    {
        console.log(Notification);
    }
});


(function ()
{
    'use strict';

    angular
            .module('app.sprardb.notification')
            .controller('NotificatioPersonaEditController', NotificatioPersonaEditController);

    /** @ngInject */
    function NotificatioPersonaEditController($scope, $mdDialog, locals, api)
    {
        var vm = this;
        vm.title = 'Modifica segnalato';
        vm.segnalati = {};
        vm.segnalati;
        vm.segnalati = {
            id: locals.persona.id,
            nome: locals.persona.nome,
            cognome: locals.persona.cognome,
            sesso: locals.persona.sesso,
            dataNascita: new Date(locals.persona.dataNascita),
            codNazionalita: locals.persona.codNazionalita,
            note: locals.persona.note,
            noteSanitarie: locals.persona.noteSanitarie,
        };

        vm.nazionalitas = [];
        /**
         * Get Nationality list
         */
        vm.country = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'NAZIONE', sort: 'descrizione'}).$promise.then(function (response) {
                vm.nazionalitas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.country();

        vm.updateNotification = updateNotification;
        function updateNotification() {
            $mdDialog.hide(vm.segnalati);
        }
        vm.closeDialog = closeDialog;
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.notification')
            .controller('NotificatioPersonaAddController', NotificatioPersonaAddController)
            .filter('validacampi', validacampi)
            .filter('filtraparentele', filtraparentele)
            .filter('filtranucleo', filtranucleo);

    function filtraparentele($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter.length === 1) {
              switch (arrayFilter[0]) {
                case 0:
                  arrayFilter[1] = [674, 680];
                  break;
                case 1:
                  arrayFilter[1] = [674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684, 685, 686];
                  break
                case -1:
                  arrayFilter[1] = [671];
                  break;
                case -2:
                  arrayFilter[1] = [673];
                  break
              }
            }
            if (arrayFilter && arrayFilter[1]) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter[1].indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    function filtranucleo($filter) {
        return function (list, filtranucleo, valore_filtrare, element) {
            var array_filtrare = [];
            array_filtrare.push(valore_filtrare);
            //aggiungo sempre SINGOLO e NON SO
            //id -1 e 2
            array_filtrare.push(-1);
            //array_filtrare.push(2);
            if (!filtranucleo) {
                return list;
            }
            if (filtranucleo) {
                return $filter("filter")(list, function (listItem) {
                    //mostrare solo nucleo familiare o monoparentale secondo la precedente scelta
                    //con aggiunta di singolo e non so sempre
                    return array_filtrare.indexOf(listItem[element]) != -1;
//                    if (listItem[element] == valore_filtrare) {
//                        return true;
//                    }
                });
            }
        };
    }

    function validacampi() {
        return function (form, arrayCampi) {
//            console.log("FORM", form);
//            console.log("CAMPI", arrayCampi);
            var esito = true;
            angular.forEach(arrayCampi, function (singoloCampo) {
                //console.log("FORM-CAMPO", form[singoloCampo]);
                if (form[singoloCampo].$invalid) {
                    //console.log(singoloCampo, "invalido");
                    esito = false;
                }
            });
            return esito;

        };
    }

    /** @ngInject */
    function NotificatioPersonaAddController($mdDialog, $state, api, ricerca, $mdToast, $scope, locals)
    {
        //$scope, $mdSidenav, $mdDialog, $state, $document, $cookies, $base64, $http, api, $mdToast, $stateParams, $localStorage, ricerca
        var vm = this;
        // Data
        vm.toggleblocco = toggleblocco;
        vm.isParentelaDisabled = isParentelaDisabled;
        vm.resetParentela = resetParentela;

        vm.selectedtab = 0;
        vm.maxtabs = 3;
        vm.blocco1 = ['cognome', 'nome', 'sesso', 'nazionalita', 'dataNascita', 'parentela_id', 'dataIngresso'];
        vm.blocco2 = ['manifestazioneVolontaProtezioneInternazionale', 'compilazioneC3', 'tipoProtezione', 'provenienzaSegnalato'];
        vm.blocco3 = [];
        vm.blocco4 = ['documentoSoggiorno'];
        vm.blocco5 = ['tipoDocumentoIdentita', 'luogoRilascioDocumento', 'modalitaAccertamentoIdentita', 'richiestaAperturaTutela'];
        vm.hascapofamiglia = locals.hascapofamiglia;
        vm.capof_id = locals.capof_id;
        vm.tipofamiglia = locals.tipofamiglia;
        vm.esterna = locals.esterna;
        vm.tipoSegnalazione = locals.tipoSegnalazione;
        console.log(vm.tipoSegnalazione);
        vm.autoinsert = false;
        if (angular.isDefined(locals.autoinsert)) {
            vm.autoinsert = locals.autoinsert;
        }
        vm.filternucleo = false;
        if (vm.tipofamiglia !== null) {
            vm.filternucleo = true;
        }
        vm.parametricaricamento = {
            documentoTipo_id: 0,
            gruppo: 'SEGNALATO',
            dettaglio: false,
            dettagliomin: true,
            entita: 'segnalato',
            entitakey: 'segnalato_id',
            caricato: 0,
            mincaricato: 0,
            mostratutti: true
        }

        function toggleblocco(nomecontenitore, nomecampo, azione) {
            /*
             * azione non obbligatoria 1 = aggiungi
             * 0 = rimuovi
             */
            var nomecampo2 = nomecampo;
            if (nomecampo2 == "dataManifestazioneVolonta") {
                nomecampo2 = "dataInteresseExArt";
            }

            var index = vm[nomecontenitore].indexOf(nomecampo);
            if (angular.isUndefined(azione)) {
                if (index === -1) {
                    vm[nomecontenitore].push(nomecampo);
                } else {
                    vm[nomecontenitore].splice(index, 1);
                    vm.segnalati[nomecampo2] = null;
                }
            } else {
                if ((azione === 1 || azione === "1") && index === -1) {
                    vm[nomecontenitore].push(nomecampo);
                }
                if ((azione === 0 || azione === "0") && index > -1) {
                    vm[nomecontenitore].splice(index, 1);
                    vm.segnalati[nomecampo2] = null;
                }


            }
        }

        vm.minori = locals.minori;
        vm.isnew = locals.isnew;
        vm.segnalazione_id = locals.segnalazione_id;
        vm.readonly = false;
        if (angular.isDefined(locals.readonly)) {
            vm.readonly = locals.readonly;
        }
        vm.nucleoFamiliare = locals.nucleoFamiliare;
        vm.nucleoFamiliare = 1;
        vm.oggi = new Date();
        vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.maxDated = new Date((vm.oggi.getFullYear() + 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDatesafe = new Date((vm.oggi.getFullYear() - 50) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDatesafeDoc = angular.copy(vm.minDatesafe);
        vm.minDated = new Date((vm.oggi.getFullYear() - 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.maxDatem = vm.oggi;
        if (vm.minori) {
            vm.minDate = vm.maxDate;
            vm.maxDate = vm.oggi;
            vm.maxtabs = 4;
        }
        vm.minDatem = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.sino = ricerca.sino;
        vm.provenienza = ricerca.provenienza;
        vm.dublino = ricerca.dublino;
        vm.ingressos = ricerca.ingresso;
        vm.iTipoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PASSAPORTO"}, {descrizione: "CARTA IDENTITA"}, {descrizione: "ALTRO"}];
        vm.iLuogoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PAESE ORIGINE"}, {descrizione: "ITALIA"}, {descrizione: "ALTRO"}];
        vm.iModalitaAccertamento = [{descrizione: "NESSUNO"}, {descrizione: "DOCUMENTO"}, {descrizione: "COLLOQUIO"}, {descrizione: "ACCERTAMENTO SANITARIO"}, {descrizione: "ALTRO"}];
        vm.iQualifica = [{descrizione: "NESSUNO"}, {descrizione: "SINDACO"}, {descrizione: "ASSESSORE"}, {descrizione: "DIRIGENTE"}, {descrizione: "ASSISTENTE SOCIALE"}, {descrizione: "AVVOCATO"}, {descrizione: "TUTORE VOLONTARIO"}, {descrizione: "ALTRO"}];
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        })

        vm.title = 'Nuovo segnalato';

        vm.segnalati = {};
        vm.segnalati.dataNascita = null;
        vm.segnalati.dataIngresso = null;
        vm.segnalati.dataInizio = null;
        vm.segnalati.dataInteresseExArt = null;
        vm.segnalati.dataC3 = null;
        vm.segnalati.dataRichiestaProtezione = null;
        vm.segnalati.dataRichiestaPds = null;
        vm.segnalati.dataRilascioDocumento = null;
        vm.segnalati.dataScadenzaDocumento = null;
        vm.segnalati.iDataRichiestaTutela = null;
        vm.segnalati.iDataAperturaTutela = null;
        vm.segnalati.tipologia_id = null;
        vm.segnalati.nucleoFamiliare = -1;
        vm.segnalati.capof_id = vm.capof_id;
        vm.segnalati.segnalazione_id = vm.segnalazione_id;
        vm.segnalati.cui = ''
        vm.segnalati.codiceVestanet = ''
        vm.checkboxCui = false
        vm.checkboxVestanet = false

        vm.checkboxCuiOnClick = function () {
          if (vm.checkboxCui) {
            vm.segnalati.cui = "NON DISPONIBILE"
          } else {
            vm.segnalati.cui = ''
          }
        }

      vm.checkboxVestanetOnClick = function () {
        if (vm.checkboxVestanet) {
          vm.segnalati.codiceVestanet = "NON DISPONIBILE"
        } else {
          vm.segnalati.codiceVestanet = ''
        }
      }


        if (vm.tipo == 606) {
            vm.segnalati.idVulnerabilita = 800;
            console.log("i'm here", vm.segnalati.idVulnerabilita)
        }
        if (angular.isDefined(locals.segnalato)) {
            vm.segnalati = angular.copy(locals.segnalato);
            angular.forEach(vm.segnalati, function (value, key) {
                if (key.toLowerCase().indexOf("data") !== -1) {
                    //if (!angular.isDate(key)) {
                    if (value === '0000-00-00' || value === null) {
                        vm.segnalati[key] = null;
                    } else {
                        vm.segnalati[key] = new Date(value);
                    }
                }
            });
            var ec = angular.copy(vm.segnalati.extraCommissione);
            if (ec === "") {
                ec = '{"decretoMinniti":"SI"}';
            }
            vm.segnalati.extraCommissione = angular.fromJson(ec);

            angular.forEach(vm.segnalati.extraCommissione, function (value, key) {
                if (key.toLowerCase().indexOf("data") !== -1) {
                    //if (!angular.isDate(key)) {
                    if (value === '0000-00-00' || value === null) {
                        vm.segnalati.extraCommissione[key] = null;
                    } else {
                        vm.segnalati.extraCommissione[key] = new Date(value);
                    }
                }
            });
            vm.parametricaricamento.segnalato_id = locals.segnalato.id;
            vm.parametricaricamento.entita_id = locals.segnalato.id;

            // se la response ritorna un codice vestanet o cui  nullo
            // allora metti la checkbox gia spuntata e prevalorizzata a non disponibile.
            if(vm.segnalati.cui == null){
              vm.checkboxCui = true
              vm.segnalati.cui = "NON DISPONIBILE"
            }
            if(vm.segnalati.codiceVestanet == null){
              vm.checkboxVestanet = true
              vm.segnalati.codiceVestanet = "NON DISPONIBILE"
            }
        }
        vm.toggle = {};
        vm.toggle.dataC3 = false;

        vm.disable = disable;
        function disable(item) {
            console.log(item);
        }

        vm.sceglidata = sceglidata;
        function sceglidata(data1, data2) {
            return (data1 || data2);
        }

        function resetParentela()
        {
          if (vm.segnalati.parentela_id == 674) {
            vm.hascapofamiglia = false;
          }

          vm.segnalati.parentela_id = {
            '-2': 673,
            '-1': 671
          }[vm.segnalati.nucleoFamiliare] || null;
        }

        function isParentelaDisabled(item)
        {
          return [0,1].includes(vm.segnalati.nucleoFamiliare) && !((vm.hascapofamiglia ?1:0) ^ (item.id == 674 ?1:0));
        }

        /**
         * Get Nationality list
         */
        vm.country = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'NAZIONE', sort: 'descrizione', pagination: 300}).$promise.then(function (response) {
                vm.nazionalitas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.country();
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: '-note,descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
                angular.forEach(vm.parentelas, function (parentela) {

                });
            }, function (response) {
                console.log(response);
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.tipoprotezione();
        vm.documento = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'DOCUMENTO', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.documentos = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.documento();
        vm.enterilascio = function () {
            api.entes.ente.search({enteTipo_id: 7, sort: 'nome', dacl: 1, pagination: 200, fields: 'id,nome'}).$promise.then(function (response) {
                vm.enterilascios = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.enterilascio();

        vm.nucleofamiliare = function () {
            api.beneficiarioattributis.beneficiario.search({'query[]': [{operatore: 'AND', 'id<': 693,gruppo: 'NUCLEOFAMILIARE'}], sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.nucleofamiliares = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.nucleofamiliare();

        vm.saveNotification = saveNotification;
        /**
         * Save Notification
         */
        function saveNotification() {
            vm.segnalati.isupdated = true;
            angular.forEach(vm.segnalati, function (value, key) {
              if (key.toLowerCase().indexOf("data") !== -1) {
                //if (!angular.isDate(key)) {
                if (value === '0000-00-00' || value === null) {
                  vm.segnalati[key] = null;
                } else {
                  vm.segnalati[key] = moment(value).format('YYYY-MM-DD');
                }
              }
            });
            angular.forEach(vm.segnalati.extraCommissione, function (value, key) {
                if (key.toLowerCase().indexOf("data") !== -1) {
                    //if (!angular.isDate(key)) {
                    if (value === '0000-00-00' || value === null) {
                        vm.segnalati.extraCommissione[key] = null;
                    } else {
                        vm.segnalati.extraCommissione[key] = moment(value).format('YYYY-MM-DD');
                    }
                }
            });
            var extraCommissione = angular.copy(vm.segnalati.extraCommissione);
            vm.segnalati.extraCommissione = angular.toJson(extraCommissione, false);
            //console.log('textJson', angular.toJson(extraCommissione, false));

            // se il codice cui o vestanet sono vuoti, reinposta a null il valore
            if (vm.segnalati.cui === "NON DISPONIBILE"){
              vm.segnalati.cui = null
            }
            if (vm.segnalati.codiceVestanet === "NON DISPONIBILE"){
              vm.segnalati.codiceVestanet = null
            }

            $mdDialog.hide(vm.segnalati);
        }

        vm.closeDialog = closeDialog;
        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        vm.commissiones = [
            {id: "ANCONA", competenza: "Marche, Abruzzo"},
            {id: "BARI", competenza: "Bari, Matera"},
            {id: "BOLOGNA", competenza: "Emilia Romagna"},
            {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
            {id: "CAGLIARI", competenza: "Sardegna"},
            {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
            {id: "CATANIA", competenza: "Catania, Enna"},
            {id: "CROTONE", competenza: "Calabria"},
            {id: "FIRENZE", competenza: "Toscana, Umbria"},
            {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
            {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
            {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
            {id: "MILANO", competenza: "Lombardia"},
            {id: "PALERMO", competenza: "Palermo, Messina"},
            {id: "ROMA", competenza: "Lazio"},
            {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
            {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
            {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
            {id: "TRAPANI", competenza: "Trapani, Agrigento"},
            {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
        ];
        vm.loadprefettura = loadprefettura;
        function loadprefettura() {
            api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.prefetturas = response.data;
            });
        }
        vm.loadprefettura();

        vm.loadquestura = loadquestura;
        function loadquestura() {
            api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.questuras = response.data;
            });
        }
        vm.loadquestura();

        vm.motivods = motivods;
        function motivods() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "descrizione"}, function (r) {
                vm.motivods = r.data;
            });
        }
        vm.motivods();

        if (angular.isUndefined(vm.segnalati.extraCommissione) || vm.segnalati.extraCommissione === "") {
            vm.segnalati.extraCommissione = {};
            vm.segnalati.extraCommissione.dataAudizione = null;
            vm.segnalati.extraCommissione.dataNotificaDiniego = null;
            vm.segnalati.extraCommissione.dataNotificaRicorso = null;
            vm.segnalati.extraCommissione.decretoMinniti = "SI";
        }

        loadPaeseProvenienza();
        function loadPaeseProvenienza() {
            api.paeseTerzoProvenienza.index({expand:'nazione.descrizione'}, function (response) {
              vm.paeseProvenienza = response.data;
            })
        }


        vm.formStatus = {
            row1: {
                formtype: "row",
                status: "open"
            }
            ,
            "decretoMinniti": {
                "type": "string",
                "title": "Applicazione Decreto Minniti",
                "description": "Modalita Richiesta Commissione",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "decretoMinniti",
                "required": true,
                "formtype": "select",
                "validationMessage": "Scegliere la modalità richiesta in Commissione",
                "onchange": "",
                "disabled": true,
                "data": "[{id:'SI'},{id:'NO'}]",
                "chiave": "id",
                "valore": "id"
            },
            "commissione": {
                "type": "string",
                "title": "Commissione Territoriale competente",
                "description": "Commissione Territoriale competente",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "commissione",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere una commissione territoriale",
                "onchange": "vm.abilitacampicommissione('commissione')",
                "data": "vm.commissiones",
                "chiave": "id",
                "valore": [
                    "id",
                    "competenza"
                ],
                "novalore": "0",
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.commissione"
            }
            ,
            "noteRichiesta": {
                "type": "string",
                "title": "Note",
                "description": "Note",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "noteRichiesta",
                "formtype": "textarea",
                "validationMessage": "Inserire una nota",
                "required": false,
                rows: "1",
                formName: "notificationForm"
            }
            ,
            row2: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "prefettura": {
                "type": "string",
                "title": "Prefettura compet.richiesta protezione",
                "description": "Prefettura competente",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "prefettura",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere la prefettura",
                "onchange": "vm.abilitacampicommissione('prefettura')",
                "data": "vm.prefetturas",
                "chiave": "id",
                "valore": "nome",
                "novalore": "0",
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.prefettura"
            }

            ,
            "questura": {
                "type": "string",
                "title": "Questura compent.richiesta protezione",
                "description": "Questura competente",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "questura",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere la questura",
                "onchange": "vm.abilitacampicommissione('questura')",
                "data": "vm.questuras",
                "chiave": "id",
                "valore": "nome",
                "novalore": "0",
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.questura"
            }
            ,
            "dataAudizione": {
                "type": "string",
                "title": "Data Audizione",
                "description": "Data Audizione",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "dataAudizione",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "vm.abilitacampicommissione('dataAudizione')",
                formName: "notificationForm",
                disabled: "(!(vm.cambiaData('dataAudizione')))",
                mdmindate: "(vm.cambiaData('dataAudizione'))",
                mdmaxdate: "vm.oggi"
            }
            ,
            row3: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "diniego": {
                "type": "string",
                "title": "C'è stato un diniego?",
                "description": "C'è stato un diniego?",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "diniego",
                "required": false,
                "formtype": "select",
                "validationMessage": "Dinego obbligatorio",
                "onchange": "vm.abilitacampicommissione('diniego')",
                "data": "[{id:'NO',descrizione:'Nessun diniego'},{id:'SI',descrizione:'Diniego presente'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.diniego"
            }
            ,
            "motivoDiniego": {
                "type": "string",
                "title": "Motivo del diniego",
                "description": "Motivo del diniego",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "motivoDiniego",
                "required": false,
                "formtype": "select",
                "validationMessage": "Selezionare motivo",
                "onchange": "vm.abilitacampicommissione('motivoDiniego')",
                "data": "vm.motivods",
                "novalore": "0",
                "chiave": "id",
                "valore": "descrizione",
                disabled: "vm.statoCampiCommissione.motivoDiniego"
            }
            ,
            "dataNotificaDiniego": {
                "type": "string",
                "title": "Data notifica diniego",
                "description": "Data notifica diniego",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "dataNotificaDiniego",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "vm.abilitacampicommissione('dataNotificaDiniego')",
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.dataNotificaDiniego",
                mdmindate: "(vm.cambiaData('dataNotificaDiniego'))",
                mdmaxdate: "vm.oggi"
            }
            ,
            row4: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "ricorso": {
                "type": "string",
                "title": "C'è stato un ricorso?",
                "description": "C'è stato un ricorso?",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "ricorso",
                "required": false,
                "formtype": "select",
                "validationMessage": "Ricorso obbligatorio",
                "onchange": "vm.abilitacampicommissione('ricorso')",
                "data": "[{id:'NO',descrizione:'Nessuna ricorso richiesto'},{id:'SI',descrizione:'Richiesto ricorso'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.ricorso"
            }
            ,
            "gradoRicorso": {
                "type": "string",
                "title": "Quanti gradi di ricorso?",
                "description": "Quanti gradi di ricorso?",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "gradoRicorso",
                "required": false,
                "formtype": "select",
                "validationMessage": "Grado ricorso obbligatorio",
                "onchange": "vm.abilitacampicommissione('gradoRicorso')",
                "data": "[{id:null,descrizione:'Nulla'},{id:'Primo grado',descrizione:'Ricorso al max 1 grado'},{id:'Secondo grado',descrizione:'Ricorso al max 2 grado'},{id:'Cassazione',descrizione:'Arrivati al 3 grado di giudizio'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.gradoRicorso"
            }
            ,
            "dataNotificaRicorso": {
                "type": "string",
                "title": "Data notifica ricorso",
                "description": "Data notifica ricorso",
                "callbackModel": "segnalati.extraCommissione",
                "dbfield": "dataNotificaRicorso",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "vm.abilitacampicommissione('dataNotificaRicorso')",
                formName: "notificationForm",
                disabled: "vm.statoCampiCommissione.dataNotificaRicorso",
                mdmindate: "(vm.cambiaData('dataNotificaRicorso'))",
                mdmaxdate: "vm.oggi"
            }
            ,
            row10: {
                formtype: "row",
                status: "close"
            }
        };

        vm.dataLimiteMinimo = false;
        vm.cambiaData = cambiaData;
        function cambiaData(nomeData) {
            vm.dataLimiteMinimo = false;
            var controlli = [
                'dataIngresso',
                'dataInteresseExArt',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];
            vm.finoA = controlli.indexOf(nomeData);
            for (i = 0; i < vm.finoA; i++) {
                if (i <= 3) {
                    if (vm.segnalati[controlli[i]] !== null) {
                        vm.dataLimiteMinimo = vm.segnalati[controlli[i]];
                    }
                } else {
                    if (vm.segnalati.extraCommissione[controlli[i]] !== null) {
                        vm.dataLimiteMinimo = vm.segnalati.extraCommissione[controlli[i]];
                    }
                }
            }

            return vm.dataLimiteMinimo;



        }
        vm.controllaD = controllaD;
        function controllaD(nomeData) {
            var controlli = [
                'dataIngresso',
                'dataInteresseExArt',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];
            var nomicampi = [
                'dataIngresso',
                'dataManifestazioneVolonta',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];

            angular.forEach(controlli, function (c, ii) {
                var campoprecedente = c;
                if (ii > 0) {
                    campoprecedente = controlli[ii - 1];
                }


                if (vm.segnalati[c] < vm.segnalati[campoprecedente] && vm.segnalati[c] != null && vm.segnalati[campoprecedente] !== null) {
//                    console.log("c:", c);
//                    console.log(vm.segnalati[c]);
//
//                    console.log("campoprecedente:", campoprecedente);
//                    console.log(vm.segnalati[campoprecedente]);

                    vm.segnalati[c] = null;
                }

            });

        }

        vm.cambiaRpds = cambiaRpds;
        function cambiaRpds() {
            vm.minDatesafeDoc = angular.copy(vm.segnalati.dataRichiestaPds);
            if (angular.isDefined(vm.segnalati.dataRilascioDocumento) && (vm.segnalati.dataRilascioDocumento < vm.segnalati.dataRichiestaPds)) {
                vm.segnalati.dataRilascioDocumento = null;
            }
        }

        vm.documentoAbilitato = documentoAbilitato;
        function documentoAbilitato(itemdocumento, idTipoSoggiorno) {
            var esito = true; //ng-disabled=false
            var temp = itemdocumento.note.split(",");
            if (angular.isDefined(idTipoSoggiorno)) {
                var temp1 = idTipoSoggiorno.toString();
                if (temp.indexOf(temp1) > -1) {
                    esito = false;
                }
            }
            return esito;
        }
        vm.alertDocumento = alertDocumento;
        function alertDocumento() {
            var confirm = $mdDialog.confirm()
                    .title('Cambio tipo di documento')
                    .htmlContent('Alcune voci potrebbero essere disabilitate in base al <b>Tipo di soggiorno</b> scelto.')
                    .ariaLabel('cambia ts')
                    .ok('Ok');
            $mdDialog.show(confirm);
        }

        vm.statoCampiCommissione = {};
        if (!locals.segnalato) {
            vm.statoCampiCommissione = {
                commissione: false,
                prefettura: true,
                questura: true,
                dataAudizione: true,
                diniego: true,
                motivoDiniego: true,
                dataNotificaDiniego: true,
                ricorso: true,
                gradoRicorso: true,
                dataNotificaRicorso: true
            };
        }
        vm.abilitacampicommissione = abilitacampicommissione;
        function abilitacampicommissione(nomeCampo) {
            vm.dataLimiteMinimo = false;
            var controlli = [
                'commissione',
                'prefettura',
                'questura',
                'dataAudizione',
                'diniego',
                'motivoDiniego',
                'dataNotificaDiniego',
                'ricorso',
                'gradoRicorso',
                'dataNotificaRicorso'
            ];

            var index_campocorrente = controlli.indexOf(nomeCampo);
            //console.log(nomeCampo + ': ', vm.segnalati.extraCommissione);
            var campoAbilitare = controlli[index_campocorrente + 1];
            if (vm.segnalati.extraCommissione[controlli[index_campocorrente]] == null ||
                    vm.segnalati.extraCommissione[controlli[index_campocorrente]] == 0 ||
                    vm.segnalati.extraCommissione[controlli[index_campocorrente]] === "NO") {
                for (i = (index_campocorrente + 1); i < controlli.length; i++) {
                    if (controlli[i].startsWith("data")) {
                        vm.segnalati.extraCommissione[controlli[i]] = null;
                    } else {
                        delete vm.segnalati.extraCommissione[controlli[i]];
                    }
                    vm.statoCampiCommissione[controlli[i]] = true;
                }

            } else {
                vm.statoCampiCommissione[campoAbilitare] = false;
            }
        }


    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entisegnalatori', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_entisegnalatori', {
            url: '/sprardb/entisegnalatori',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entisegnalatori/entisegnalatori.html',
                    controller: 'EntisegnalatoriController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_entisegnalatori_dettaglio', {
            url: '/sprardb/entisegnalatori/dettaglio/ente/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entisegnalatori/dettaglio/dettaglio.html',
                    controller: 'DettaglioESController as vm'
                }
            }
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/entisegnalatori');


        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'YYYY-MM-DD');
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        msNavigationServiceProvider.saveItem('sprardb.entisegnalatori.entes', {
            title: 'Enti Segnalatori',
            icon: 'icon-sign-caution',
            state: 'app.sprardb_entisegnalatori',
            weight: 1
        });
        /*
         //segnalatore
         msNavigationServiceProvider.saveItem('segnalatore.entisegnalatori.entes', {
         title: 'Enti Segnalatori',
         icon: 'icon-sign-caution',
         state: 'app.sprardb_entisegnalatori',
         weight: 1
         });
         //segreteia
         msNavigationServiceProvider.saveItem('scsegreteria.entisegnalatori.entes', {
         title: 'Enti Segnalatori',
         icon: 'icon-sign-caution',
         state: 'app.sprardb_entisegnalatori',
         weight: 1
         });
         */
        //operatore
//        msNavigationServiceProvider.saveItem('properatore.entisegnalatori.entes', {
//            title: 'Enti Segnalatori',
//            icon: 'icon-sign-caution',
//            state: 'app.sprardb_entisegnalatori',
//            weight: 1
//        });
        //admin
        /*
         msNavigationServiceProvider.saveItem('scadmin.entisegnalatori.entes', {
         title: 'Enti Segnalatori',
         icon: 'icon-sign-caution',
         state: 'app.sprardb_entisegnalatori',
         weight: 1
         });
         */
//        msNavigationServiceProvider.saveItem('scadmin.entisegnalatori.nentes', {
//            title: 'Nuovo Ente Segnalatore',
//            icon: 'icon-plus',
//            state: 'app.sprardb_entisegnalatori_dettaglio({id:0})',
//            weight: 3
//        });


    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entisegnalatori')
            .controller('EntisegnalatoriDialogController', EntisegnalatoriDialogController);

    /** @ngInject */
    function EntisegnalatoriDialogController($mdDialog, Ente, Entes, User, msUtils, msApi, $state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Ente';
        vm.ente = angular.copy(Ente);
        vm.entes = Entes;
        vm.user = User;
        vm.newEnte = false;
        vm.allFields = false;
        vm.evento = "update";

        if (!vm.ente)
        {
            vm.evento = "new";
            vm.ente = {
                'id': null,
                'nome': null,
                'enteTipo_id': null,
                'codRegione': null,
                'codProvincia': null,
                'codComune': null,
                'indirizzo': null,
                'cap': null,
                'email': null,
                'telefono': null,
                'entetipo': null,
                'enteextras': null,
                'tags': null,
                'progettos': null,
            };

            vm.title = 'Nuovo Ente';
            vm.newEnte = true;
            vm.ente.tags = [];
        }


        // Methods
        vm.saveEnte = saveEnte;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function saveEnte(ev, ente)
        {
            if (ev == "new") {
                console.log(ente);
                api.entes.ente.save(ente);
            }
            if (ev == "update") {
                api.entes.ente.aggiorna(ente);
            }
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */


        function deleteContactConfirm(ente, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare questo ente?')
                    .htmlContent('<b>' + vm.ente.nome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
                api.entes.ente.remove({id: Ente.id});
                $state.reload();
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entes', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        // $stateProvider.state('app.sprardb_entes', {
        //     url: '/sprardb/entes',
        //     views: {
        //         'content@app': {
        //             templateUrl: 'app/main/sprardb/entes/entes.html',
        //             controller: 'EntesController as vm'
        //         }
        //     },
        //     resolve: {}
        // });
        $stateProvider.state('app.sprardb_gestore', {
            url: '/sprardb/gestore/:progettos_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_comune', {
            url: '/sprardb/comune/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_provincia', {
            url: '/sprardb/provincia/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_regione', {
            url: '/sprardb/regione/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_questura', {
            url: '/sprardb/questura/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_prefettura', {
            url: '/sprardb/prefettura/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_ministero', {
            url: '/sprardb/ministero/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_commontana', {
            url: '/sprardb/commontana/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_uncomune', {
            url: '/sprardb/uncomune/:enteTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_segnalatore', {
            url: '/sprardb/segnalatore/:segnalatore',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/entes.html',
                    controller: 'EntesController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_entes_dettaglio_dettaglio', {
            url: '/sprardb/entes/dettaglio/ente/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/entes/dettaglio/dettaglio.html',
                    controller: 'DettaglioEController as vm'
                }
            },
            resolve: {}
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/entes');


        // Api
        msApiProvider.register('entes.entes', ['http://localhost/sprardb/app-server/web/entes']);
        msApiProvider.register('entes1', ['http://localhost/sprardb/app-server/web/entes/search']);
        msApiProvider.register('tags', ['http://localhost/sprardb/app-server/web/tags']);

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('YYYY-MM-DD') : new Date(NaN);
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'YYYY-MM-DD');
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes', {
//            title: 'Enti',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_entes',
//            weight: 1
//        });
//
//        //scadmin
//        msNavigationServiceProvider.saveItem('scadmin.rubrica.entes', {
//            title: 'Enti',
//            icon: 'icon-plus-network',
//            state: 'app.sprardb_entes',
//            weight: 1
//        });
        //segreteria
        /*
         msNavigationServiceProvider.saveItem('scsegreteria.rubrica.entes', {
         title: 'Enti',
         icon: 'icon-plus-network',
         state: 'app.sprardb_entes',
         weight: 1
         });
         */
        //properatore
//        msNavigationServiceProvider.saveItem('properatore.rubrica.entes', {
//            title: 'Enti',
//            icon: 'icon-plus-network',
//            state: 'app.sprardb_entes',
//            weight: 1
//        });

//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.new', {
//            title: 'Nuovo ente',
//            icon: 'icon-plus-network', //app.sprardb_notification.editreport({ id:notification.id })
//            state: 'app.sprardb_entes_dettaglio_dettaglio({id:0})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.gestore', {
//            title: 'Gestore',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_gestore({progettos_id:0})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.comune', {
//            title: 'Comuni',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_comune({enteTipo_id:4})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.provincia', {
//            title: 'Provincia',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_provincia({enteTipo_id:5})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.regione', {
//            title: 'Regione',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_regione({enteTipo_id:6})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.questura', {
//            title: 'Questura',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_questura({enteTipo_id:7})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.prefettura', {
//            title: 'Prefettura',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_prefettura({enteTipo_id:8})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.ministero', {
//            title: 'Ministero',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_ministero({enteTipo_id:9})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.commontana', {
//            title: 'Comunita Montana',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_commontana({enteTipo_id:10})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.uncomune', {
//            title: 'Unione Comuni',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_uncomune({enteTipo_id:11})',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes.segnalatore', {
//            title: 'Segnalatore',
//            icon: 'icon-account-box-outline',
//            state: 'app.sprardb_segnalatore({segnalatore:1})',
//            weight: 1
//        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.entes')
        .controller('EnteDialogController', EnteDialogController);

    /** @ngInject */
    function EnteDialogController($mdDialog, Ente, Entes, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Ente';
        vm.ente = angular.copy(Ente);
        vm.entes = Entes;
        vm.user = User;
        vm.newEnte = false;
        vm.allFields = false;
        vm.evento = "update";

        if ( !vm.ente )
        {
          vm.evento = "new";
            vm.ente = {
                'id'      : null,
                'nome'    : null,
                'enteTipo_id': null,
                'codRegione': null,
                'codProvincia' : null,
                'codComune' : null,
                'indirizzo' : null,
                'cap' : null,
                'email'   : null,
                'telefono'   : null,
                'entetipo' : null,
                'enteextras' : null,
                'tags': null,
                'progettos': null,
            };

            vm.title = 'Nuovo Ente';
            vm.newEnte = true;
            vm.ente.tags = [];
        }


        // Methods
        vm.saveEnte = saveEnte;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        /**
         * Save contact
         */
        function saveEnte(ev,ente)
        {
          if (ev=="new") { console.log(ente); api.entes.ente.save(ente);}
          if (ev=="update"){ api.entes.ente.aggiorna(ente);}
            $state.reload();
            closeDialog();
        }

        /**
         * Delete Contact Dialog
         */


        function deleteContactConfirm(ente, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare questo ente?')
                .htmlContent('<b>' + vm.ente.nome + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {
              api.entes.ente.remove({id: Ente.id});
              $state.reload();
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.contatti')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils, msApi,$state, api)
    {
        var vm = this;

        // Data
        vm.title = 'Modifica Contatto';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        vm.evento = "update";

        vm.provincias = [];
        vm.istats = [];

        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;

        vm.provincias2 = [];
        vm.istats2 = [];

        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;


        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2=vm.regiones;
        });

        if ( !vm.contact )
        {
            vm.evento = "new";
            vm.contact = {
                'id'      : null,
                'nome'    : null,
                'cognome': null,
                'sesso'  : null,
                'codRegione': null,
                'codProvincia' : null,
                'codComune' : null,
                'indirizzo' : null,
                'cap' : null,
                'email'   : '',
                'telefono'   : '',
                'dataNascita': "01-01-2016",
                'dataNascita2': null,
                'codComuneNascita' : null,
                'codNazionalita' : null,
                'codiceFiscale': null,
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2=new Date(vm.contact.dataNascita);


        vm.contact2 = {
            'codRegione': null,
            'codProvincia' : null,
            'codComune' : null,
            'codComuneNascita' : null,
            };

        vm.nazioni=null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination:200},function (response){
            vm.nazioni=response.data;
            vm.links=response._links;
            vm.meta=response._meta;
        });



        if ((vm.regiones !== null || vm.contact.codRegione !== '') && vm.evento === "update") {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if ((vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') && vm.evento === "update") {
            vm.caricaComuni(vm.contact.codProvincia);
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        if ((vm.regiones2 !== null || vm.contact2.codRegione !== '') && vm.evento === "update") {
            vm.caricaProvince2(vm.contact.nascita.codRegione);
        }
        if ((vm.contact2.codProvincia !== null || vm.contact2.codProvincia !== '') && vm.evento === "update") {
            vm.caricaComuni2(vm.contact.nascita.codProvincia);
        }

        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }




      

        // Methods
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.persona = vm.contact;
        //////////

        /**
         * Save contact
         */
        function saveContact(ev,contact)
        {
          if (ev=="new") {
            var m = moment(contact.dataNascita2);
            contact.dataNascita = m.format("YYYY-MM-DD");
            api.personas.persona.save(contact,function (response){
                $state.reload();
                closeDialog();
                });
          }
          if (ev=="update"){
            var m = moment(contact.dataNascita2);
            contact.dataNascita = m.format("YYYY-MM-DD");
            api.personas.persona.aggiorna(contact,function (response){
                $state.reload();
                closeDialog();
                });
          }
        }

        /**
         * Delete Contact Dialog
         */


        function deleteContactConfirm(contact , ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler eliminare il contatto?')
                .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('ANNULLA');

                $mdDialog.show(confirm).then(function ()
                {
                  api.personas.persona.remove({id: Contact.id},function (response){
                      $state.reload();
                      closeDialog();
                      });

                });

          }




        /**
         * Close dialog
         */
        function closeDialog()
        {
                $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.beneficiari', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_beneficiari', {
                    url: '/sprardb/beneficiari/:def/:prequery',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                            controller: 'BeneficiariController as vm'
                        }
                    },
                    datas: {
                        stato: ["BENEFICIARIO"],
                        def: 1,
                        cancellato: [0],
                        titolo: 'Ricerca Presenti In Strutture',
                        api: 'v'
                    }
                })
                .state('app.sprardb_accolti', {
                    url: '/sprardb/accolti/:def/:prequery',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                            controller: 'BeneficiariController as vm'
                        }
                    },
                    datas: {
                        def: 1,
                        titolo: 'Ricerca Permanenze',
                        cancellato: [0],
                        api: 'a'
                    }

                })
                .state('app.sprardb_beneficiarit', {
                    url: '/sprardb/beneficiarit/:def/:prequery',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                            controller: 'BeneficiariController as vm'
                        }
                    },
                    datas: {
                        stato: ["BENEFICIARIO"],
                        def: 1,
                        trasferimento: 1,
                        cancellato: [0],
                        titolo: 'Ricerca Beneficiari in trasferimento',
                        api: 'v'
                    }

                })
        $stateProvider.state('app.sprardb_ricercabeneficiarisegnalati', {
            url: '/ricercabeneficiarisegnalati',
            views: {
                'content@app': {
                    //templateUrl: 'app/main/sprardb/notification/autoinserimento-details.html',
                    templateUrl: 'app/main/sprardb/beneficiari/ricercabeneficiarisegnalati.html',
                    controller: 'RicercaBeneficiariSegnalatiController as vm'
                }
            },
            datas: {
                autoinsert: true
            }
        })
                .state('app.sprardb_beneficiaril', {
                    url: '/sprardb/beneficiaril/:def',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                            controller: 'BeneficiariController as vm'
                        }
                    },
                    datas: {
                        stato: ["PRESENTE SUL TERRITORIO"],
                        def: 1,
                        cancellato: [0],
                        titolo: 'Ricerca Presenti Sul Territorio',
                        api: 'a'
                    }

                })
                .state('app.sprardb_beneficiarii', {
                    url: '/sprardb/beneficiarii/:def',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                            controller: 'BeneficiariController as vm'
                        }
                    },
                    datas: {
                        stato: ["BENEFICIARIO", "PRESENTE SUL TERRITORIO"],
                        def: 0,
                        titolo: 'Ricerca Presenti Incompleti',
                        cancellato: [0],
                        api: 'v'
                    }

                })
                .state('app.sprardb_omonimie', {
                    url: '/sprardb/omonimie/:om',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiariom.html',
                            controller: 'BeneficiariOmController as vm'
                        }
                    }

                })
                .state('app.sprardb_beneficiario', {
                    url: '/sprardb/beneficiario/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiario/dettaglio.html',
                            controller: 'DettaglioBeneficiarioController as vm'
                        }
                    }
                })
                .state('app.sprardb_beneficiariop', {
                  url: '/sprardb/beneficiariop/:codicePresenza',
                  views: {
                    'content@app': {
                      templateUrl: 'app/main/sprardb/beneficiari/beneficiario/dettagliop.html',
                      controller: 'DettaglioBeneficiarioTerritorioController as vm'
                    }
                  }
                })
                .state('app.sprardb_beneficiarioi', {
                    url: '/sprardb/beneficiarioi/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiario/dettaglioi.html',
                            controller: 'DettaglioBeneficiarioController as vm'
                        }
                    }
                })
                .state('app.sprardb_nuovobeneficiario', {
                    url: '/sprardb/nuovobeneficiario',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiario/nuovo.html',
                            controller: 'InserimentoBeneficiarioController as vm'
                        }
                    }
                })
                .state('app.sprardb_beneficiari_cancellati', {
                  url: '/sprardb/beneficiaricancellati/:prequery',
                  views: {
                    'content@app': {
                      templateUrl: 'app/main/sprardb/beneficiari/beneficiari.html',
                      controller: 'BeneficiariController as vm'
                    }
                  },
                  datas: {
                    cancellato: 1,
                    api: 'a',
                    titolo: 'Ricerca Beneficiari Cancellati',
                  }
                })
                .state('app.sprardb_beneficiariostorico', {
                    url: '/sprardb/beneficiariostorico/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/beneficiari/beneficiario/dettagliostorico.html',
                            controller: 'DettaglioBeneficiarioStoricoController as vm'
                        }
                    }
                })
                ;


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/beneficiari');

        // Api
//        msApiProvider.register('beneficiario', ['http://localhost/sprardb/app-server/web/beneficiarios/search']);

        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
//        $mdDateLocaleProvider.formatDate = function (date) {
//            return moment(date).format('YYYY-MM-DD');
//        };


        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.beneficiari', {
            title: 'Ricerca Beneficiario',
            icon: 'icon-account-multiple-outline',
            //state: 'app.sprardb_beneficiari',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.beneficiari.all', {
            title: 'Ricerca Beneficiario',
            icon: 'icon-account-multiple-outline',
            state: 'app.sprardb_beneficiari',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.beneficiari.omon', {
            title: 'Ricerca Omonimie',
            icon: 'icon-equal-box',
            state: 'app.sprardb_omonimie',
            weight: 1
        });
        //scadmin
        /*
         msNavigationServiceProvider.saveItem('scadmin.beneficiari', {
         title: 'Beneficiari',
         weight: 20
         });

         msNavigationServiceProvider.saveItem('scadmin.beneficiari.incompleti', {
         title: 'Presenti Incompleti',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiarii({def:0})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.trasferimento2', {
         title: 'In trasferimento',
         icon: 'icon-arrow-right-bold-hexagon-outline',
         state: 'app.sprardb_beneficiarit({def:1})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.ricerca', {
         title: 'Presenti',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiari({def:1})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.accolti', {
         title: 'Accolti',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_accolti({def:1})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.incompletil', {
         title: 'Pres.Territorio Incompl.',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiariil({def:0})',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.ricercal', {
         title: 'Pres.Territorio Completi',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiaril({def:1})',
         weight: 5
         });
         //        msNavigationServiceProvider.saveItem('scadmin.beneficiari.omonimie', {
         //            title: 'Omonimie',
         //            icon: 'icon-equal-box',
         //            state: 'app.sprardb_omonimie',
         //            weight: 3
         //        });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.trasferimento', {
         title: 'Lavora trasferimenti',
         icon: 'icon-arrow-right-bold-hexagon-outline',
         state: 'app.sprardbEventib({eventoTipo_id:1013})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('scadmin.beneficiari.uscitab', {
         title: 'In Uscita',
         icon: 'icon-exit-to-app',
         state: 'app.sprardbEventib({eventoTipo_id:1010})',
         weight: 6
         });
         */
        //properatore
        /*
         msNavigationServiceProvider.saveItem('properatore.beneficiari', {
         title: 'Beneficiari',
         weight: 20
         });

         msNavigationServiceProvider.saveItem('properatore.beneficiari.incompleti', {
         title: 'Presenti Incompleti',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiarii({def:0})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('properatore.beneficiari.ricerca', {
         title: 'Presenti',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiari({def:1})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('properatore.beneficiari.trasferimento', {
         title: 'In trasferimento',
         icon: 'icon-arrow-right-bold-hexagon-outline',
         state: 'app.sprardb_beneficiarit({def:1})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('properatore.beneficiari.incompletil', {
         title: 'Pres.Territorio Incompl.',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiariil({def:0})',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('properatore.beneficiari.ricercal', {
         title: 'Pres.Territorio Completi',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_beneficiaril({def:1})',
         weight: 5
         });
         */
//        msNavigationServiceProvider.saveItem('properatore.beneficiari.omonimie', {
//            title: 'Omonimie',
//            icon: 'icon-equal-box',
//            state: 'app.sprardb_omonimie',
//            weight: 3
//        });

    }

})();

(function ()
{
  'use strict';
  angular
          .module('app.sprardb.beneficiari')
          .controller('UscitaBeneficiarioController', UscitaBeneficiarioController);

  /** @ngInject */
  function UscitaBeneficiarioController($mdDialog, api)
  {
    var vmd = this;

    vmd.cancelDialog = function() {$mdDialog.cancel();}
    vmd.hideDialog = function() {$mdDialog.hide(vmd.model);}

    vmd.baseUrl = api.baseUrl;
    vmd.extraMU = vmd.uscita.extraMU.data;
    vmd.condizioni = vmd.uscita.model.condizioni;
    vmd.filter = vmd.uscita.model.filter;
    vmd.maxDate = new Date();
    vmd.model = api.postlogin.nucleiFamiliari23.uscitaModel({beneficiarioId: vmd.postloginModel.beneficiarioId}, function(res) {
      vmd.minDate = new Date(res.limiteDataUscita);
    });



  }


})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbAllegatiRendicontazioneController', sprardbAllegatiRendicontazioneController)
            .controller('uploadDialogMcController', uploadDialogMcController)
            .directive('sprardbAllegatiRendicontazione', sprardbAllegatiRendicontazione);

    /** @ngInject */
    function uploadDialogMcController($scope, parentScope, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;
        var id = $scope.$id;

        vmdd.tipoDocumentoList = parentScope.vmd.tipoDocumentoList;
        var voceSpesa = parentScope.vmd.params.voceSpesa;
        vmdd.allegatoRendicontazione = {rendicontazioneId: parentScope.vmd.datiRendicontazione.id, spesaId: voceSpesa ? voceSpesa.id : ''};
        vmdd.documento = {};
        vmdd.params = parentScope.vmd.params;
        vmdd.tipoDocumentoFilter = parentScope.vmd.tipoDocumentoFilter;

        vmdd.ngFlowOptions = {
            target: api.baseUrl + 'allegato-rendicontazione/create',
            chunkSize: 1 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 100,
            headers: {'Authorization': 'Basic ' + api.authorizationB, 'X-Requested-With': 'XMLHttpRequest'},
            query: caricaParametri
            // AllegatoRendicontazione: vmdd.allegatoRendicontazione,
            // Documento: vmdd.documento //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };
        vmdd.caricamentook = false;

        function caricaParametri()
        {
            var formData = {revisione: vmdd.params.revisione || 0};
            angular.forEach(vmdd.allegatoRendicontazione,function(value, key){
                formData['AllegatoRendicontazione['+key+']'] = value;
            });
            angular.forEach(vmdd.documento,function(value, key){
                formData['Documento['+key+']'] = value;
            })
            return formData;
        }

        // Methods
        vmdd.upload = upload;
        function upload()
        {
            // vmdd.ngFlowOptions.query = angular.toJson({AllegatoRendicontazione: vmdd.allegatoRendicontazione, Documento: vmdd.documento});
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            //console.log("file added");

        }

        vmdd.fileSuccess = fileSuccess;

        function fileSuccess(file, message)
        {
            //console.log("file success");
            vmdd.caricamentook = true;
            parentScope.$parent.init();
        }

        vmdd.inprogress = false;
        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            //console.log("upload in progress");
            $rootScope.loadingProgress = true;
            vmdd.inprogress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            vmdd.inprogress = false;
            $rootScope.loadingProgress = false;
            if (vmdd.caricamentook) {
                $mdDialog.hide();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('File caricato correttamente')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                parentScope.vmd.visibile = 1;
                angular.forEach(parentScope.$parent.documentiReload, function(value, key) {
                    parentScope.$parent.documentiReload[key] = key;
                });
            }
            if (!vmdd.caricamentook) {
                $mdDialog.hide();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Errore durante il caricamento del file')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                angular.forEach(parentScope.$parent.documentiReload, function(value, key) {
                    parentScope.$parent.documentiReload[key] = key;
                });
                $rootScope.$broadcast('httpValidationError', vmdd.errorData);
            }

            vmdd.caricamentook = false;
        }

        vmdd.fileerror = fileerror;
        function fileerror(file, message, chunk) {
          vmdd.caricamentook = false;
          vmdd.errorData = angular.fromJson(message);
        }
    }
    function sprardbAllegatiRendicontazioneController($scope, $rootScope, api, $mdToast, fuseGenerator, $mdDialog, $state) {
        var vmd = this;
        var id = $scope.$id;

        vmd.carica = carica;
        vmd.initFilterModel = initFilterModel;
        vmd.csvAllegati = csvAllegati;

        vmd.api = api;

        vmd.params = $scope.params;
        vmd.datiRendicontazione = $scope.ngModel;

        vmd.buttonObj = vmd.params.buttonObj || $scope.$parent;
        vmd.buttonKey = vmd.params.buttonKey || 'documentiButtons';
        vmd.tipoDocumentoFilter = {gruppo: vmd.params.revisione ? 'REVISIONE' : 'RENDICONTAZIONE'}

        vmd.datiRendicontazione.$promise.then(function(res) {
          vmd.tipoDocumentoList = res.modo.tipiDocumento;
        });

        vmd.visibile = 1;
        vmd.page = 1;
        vmd.perPage = 10;

        vmd.initFilterModel();
        vmd.carica();

        //vgiacomini: ogni istanza crea e guarda un trigger per ricaricare i documenti
        $scope.$parent.documentiReload[id] = false;
        $scope.$parent.$watch('documentiReload['+id+']', function(newVal, oldVal, scope) {
            if (newVal) {
                vmd.carica();
                scope.documentiReload[newVal] = false;
            }
        });

        function carica() {
            var load = function (rendicontazione) {

                var filter = {and: [{rendicontazioneId: rendicontazione.id}, {visibile: vmd.visibile}]};

                if (vmd.params.modoRevisione) {
                  if (vmd.params.revisione) {
                    filter.and.push({or: []});
                    filter.and[2].or.push({'documento.documentoTipo_id': 93}); //Certificato del Revisore e relativi allegati
                    filter.and[2].or.push({'documento.documentoTipo_id': 94}); //Attestazione rendicontazione pari a zero
                    filter.and[2].or.push({'documento.documentoTipo_id': 95}); //Altro
                  } else {
                    filter.and.push({not: {'documento.documentoTipo_id': 93}});
                    filter.and.push({not: {'documento.documentoTipo_id': 94}});
                    filter.and.push({not: {'documento.documentoTipo_id': 95}});
                  }
                }

                angular.forEach(vmd.filterModel, function(value, key) {
                    if (value) {
                        var obj = {};
                        obj[key] = value;
                        filter.and.push(obj);
                    }
                });

                if (vmd.params.voceSpesa) {
                    filter.and.push({spesaId: vmd.params.voceSpesa.id});
                }
                if (vmd.allegati) vmd.allegati.$cancelRequest();
                vmd.allegati = api.allegatorendicontazione.query
                (
                    {page: vmd.page, 'per-page': vmd.perPage, expand: 'key,documento', filter: filter},
                    function(res) {
                        vmd.totalCount = res._meta.totalCount;
                    }
                );
            }

            vmd.datiRendicontazione.$promise.then(load)
        }

        function initFilterModel()
        {
            vmd.filterModel = {
                'documento.data': {
                    '>=': null,
                    '<': null
                }
            };
        }

        vmd.openUpload = openUpload;
        function openUpload(ev) {
            $mdDialog.show({
                controller: 'uploadDialogMcController',
                controllerAs: 'vmdd',
                templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/upload-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {parentScope: $scope}
            });
        }

        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function csvAllegati()
        {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Download lista in corso...')
                    .position('bottom right')
                    .hideDelay(3000)
            );

            window.open(api.baseUrl +'documento-rendicontazione/'+ vmd.datiRendicontazione.id +'/csv-allegati?k='+ vmd.datiRendicontazione.key, '_blank', '');
        }

        vmd.cancelladocumento = cancelladocumento;
        function cancelladocumento(did, stato) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var confirm2 = $mdDialog.confirm()
                    .title('Sei sicuro di voler ripristinare?')
                    .htmlContent('Il documento sarà ripristinato.')
                    .ariaLabel('ripristina doc')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var msg = 'File cancellato';
            var msg2 = 'File ripristinato';
            if (stato == 1) {
                confirm = angular.copy(confirm2);
                msg = angular.copy(msg2);
            }
            var payload = {id: did, visibile: stato}
            if(vmd.params.revisione) {
              payload.revisione = 1;
            }

            $mdDialog.show(confirm).then(function () {
                api.allegatorendicontazione.update(payload, function (res) {
                    angular.forEach($scope.$parent.documentiReload, function(value, key) {
                        $scope.$parent.documentiReload[key] = key;
                    });
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msg)
                            .position('bottom right')
                            .hideDelay(3000)
                    );
                })
            });
        }
    }

    function sprardbAllegatiRendicontazione($compile)
    {
        return {
            require: ['ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                params: '=',
                msModelType: '@?'
            },
            controller: 'sprardbAllegatiRendicontazioneController as vmd',
            transclude: true,
            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/sprardb-allegati-rendicontazione.html'
        };

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.rendicontazioni', ['angular.filter', 'ui.utils.masks'])
            .factory('rendicontazioniUtility', rendicontazioniUtility)
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {
        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

        $stateProvider
                .state('app.sprardb_rendicontazioni', {
                    url: '/sprardb/rendicontazioni',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazioni.html',
                            controller: 'RendicontazioniController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_rendicontazionimc', {
                    url: '/sprardb/rendicontazionimc',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionimc.html',
                            controller: 'RendicontazioniMcController as vm'
                        }
                    }
                })
                .state('app.sprardb_rendicontazionimc_rendicontazione', {
                    url: '/sprardb/rendicontazionimc/rendicontazione/:id',
                    onEnter: function (api, $state, $stateParams) {

                        $stateParams.rendicontazione = api.documentorendicontazione.get({id: $stateParams.id}, function (res) {
                            switch (res.progettoRendicontazioneTipo_id) {
                                case 1:
                                case 2:
                                case 4:
                                    $state.go('app.sprardb_rendicontazionimc_rendicontazione.preventivo', $stateParams);
                                    return;
                                case 3:
                                case 5:
                                    $state.go('app.sprardb_rendicontazionimc_rendicontazione.rendicontazione', $stateParams);
                                    return;
                            }
                        });
                    },
                    params: {
                        rendicontazione: null
                    }
                })
                .state('app.sprardb_rendicontazionimc_rendicontazione.rendicontazione', {
                    parent: 'app.sprardb_rendicontazionimc_rendicontazione',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/rendicontazione.html',
                            controller: 'RendicontazionemcController as vm'
                        }
                    }
                })
                .state('app.sprardb_rendicontazionimc_rendicontazione.preventivo', {
                    parent: 'app.sprardb_rendicontazionimc_rendicontazione',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/preventivo.html',
                            controller: 'PreventivomcController as vm'
                        }
                    }
                })
                .state('app.sprardb_rendicontazionimc_progetto', {
                    url: '/sprardb/rendicontazionimc/progetto/:projectId',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/progetto.html',
                            controller: 'RendicontazionimcProgettoController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_rendicontazioni_rendicontazione', {
                    url: '/sprardb/rendicontazioni/rendicontazione/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazione/rendicontazione.html',
                            controller: 'RendicontazioneController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    },
                    params: {
                        projectId: null,
                        tipoRendicontazione: null,
                        annoCorrente: null,
                        page: 1
                    }

                })
                .state('app.sprardb_rendicontazioni_progetto', {
                    url: '/sprardb/rendicontazioni/progetto/:projectId',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/progetto/progetto.html',
                            controller: 'RendicontazioniProgettoController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_rendicontazioni_setup', {
                    url: '/sprardb/rendicontazioni/setup/:attivo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/setup/setuplistrendicontazione.html',
                            controller: 'SetupListRendicontazioneController as vm'
                        }
                    }


                })
                .state('app.sprardb_rendicontazioni_setupdetail', {
                    url: '/sprardb/rendicontazioni/setupdetail',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/setup/dettaglio.html',
                            controller: 'SetupDettaglioController as vm'

                        }
                    },
                    params: {
                        obj: null
                    }


                })
                .state('app.sprardb_rendicontazioni_setupdetailb', {
                    url: '/sprardb/rendicontazioni/setupdetailb/:ids',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/rendicontazioni/setup/dettagliob.html',
                            controller: 'SetupDetailBulkController as vm'
                        }
                    }


                })

                ;
                
        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/sprardb/rendicontazioni');

        // Navigation
//        msNavigationServiceProvider.saveItem('sprardb.rendicontazioni', {
//            title: 'RENDICONTAZIONI',
//            icon: 'icon-clipboard-text',
//            weight: 50001
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rendicontazioni.all', {
//            title: 'Tutte Rendicontazioni',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni',
//            weight: 2
//        });
//        msNavigationServiceProvider.saveItem('sprardb.rendicontazioni.setup', {
//            title: 'Setup',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni_setup({attivo:1})',
//            weight: 2
//        });
//        msNavigationServiceProvider.saveItem('scadmin.rendicontazioni', {
//            title: 'RENDICONTAZIONI',
//            weight: 50001
//        });
//        msNavigationServiceProvider.saveItem('scadmin.rendicontazioni.all', {
//            title: 'Tutte Rendicontazioni',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni',
//            weight: 1
//        });
//        msNavigationServiceProvider.saveItem('scadmin.rendicontazioni.setup', {
//            title: 'Setup',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni_setup({attivo:1})',
//            weight: 2
//        });
//        //consegno il controllo di rendicontazione anche a pr admin
//        msNavigationServiceProvider.saveItem('pramministratore.rendicontazioni', {
//            title: 'RENDICONTAZIONI',
//            weight: 50001
//        });
//        msNavigationServiceProvider.saveItem('pramministratore.rendicontazioni.all', {
//            title: 'Tutte Rendicontazioni',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni',
//            weight: 1
//        });
//
//        //consegno il controllo di rendicontazione anche a pr admin
//        msNavigationServiceProvider.saveItem('properatore.rendicontazioni', {
//            title: 'RENDICONTAZIONI',
//            weight: 50001
//        });
//        msNavigationServiceProvider.saveItem('properatore.rendicontazioni.all', {
//            title: 'Tutte Rendicontazioni',
//            icon: 'icon-clipboard-text',
//            state: 'app.sprardb_rendicontazioni',
//            weight: 1
//        });

    }


//    //centralizziamo le Utility per le Rendicontazioni
    function rendicontazioniUtility() {
      function get(path)
      {
        var tokens = path.split('.');
        var value = this;
        tokens.forEach(function(property) {
          if (value.hasOwnProperty(property)) {
            value = value[property];
          } else {
            throw new Error('Invalid path');
          }
        });
        return value;
      }

      function serializza(prospetto)
      {
        var rows = [];

        function preOrder(item)
        {
          if (item.items && !item.class) {
            item.class = 'md-blue-grey-200-bg';
            item.style = {
              textStyle: 'tableSubHeader',
              numberStyle: 'tableSubHeaderTot',
              percentStyle: 'tableSubHeaderTot'
            }
          }

          rows.push(item);

          if (item.items) {
            angular.forEach(item.items, function (child) {
              preOrder(child);
            })
          }
        }

        angular.forEach(prospetto.items, function(child) {
          child.class = 'md-light-blue-100-bg'
          child.style = {
            textStyle: 'tableSubHeader',
            numberStyle: 'tableSubHeaderTot'
          }
          preOrder(child);
        })

        return rows;
      }

      return {
        get: get,
        serializza: serializza
      };
    }

})();

(function () {
  'use strict';

  angular
    .module('app.sprardb.rendicontazioni')
    .controller('RendicontazionemcController', RendicontazionemcController)
    .controller('DialogVoceRegistroSpesemcController', DialogVoceRegistroSpesemcController)
    .controller('DialogMessaggiController', DialogMessaggiController);

  /** @ngInject */
  function RendicontazionemcController($scope, $rootScope, api, $stateParams, $window, $filter, $mdDialog, $mdToast, $compile, $state, rendicontazioniUtility) {
    var vm = this;

    vm.api = api;

    vm.backToRendicontazioni = backToRendicontazioni;
    vm.openVoceRegistroSpeseDialog = openVoceRegistroSpeseDialog;
    vm.deleteVoceRegistroSpeseDialog = deleteVoceRegistroSpeseDialog;
    vm.caricaVociSpesa = caricaVociSpesa;
    vm.initSearch = initSearch;
    vm.caricaProspetto = caricaProspetto;
    vm.invia = invia;
    vm.annullaInvio = annullaInvio;
    vm.riapri = riapri;
    vm.mostraMessaggi = mostraMessaggi;
    vm.apriIntegrazione = apriIntegrazione;
    vm.chiudiIntegrazione = chiudiIntegrazione;
    vm.isLastStep = isLastStep;
    vm.confermaValidazione = confermaValidazione;
    vm.updateRevisione = updateRevisione;

    $scope.documentiReload = {};
    $scope.documentiButtons = {
      create: undefined,
      update: undefined,
      'mostra-cancellati': undefined
    };
    vm.revisioneButtons = angular.copy($scope.documentiButtons);

    vm.prospettoSerializzato = {
      costiDiretti: undefined,
      costiIndiretti: undefined
    };
    vm.importi = ['importoCofinanziato', 'contributoRichiesto', 'totale'];
    vm.errors = [];
    vm.alerts = [];
    vm.buttons = {
      'conferma-validazione': undefined,
      'invia': undefined,
      'riapri': undefined,
      'chiudi-integrazione': undefined,
      'apri-integrazione': undefined,
      'messaggi': undefined
    };
    vm.steps = {};
    vm.selectedIndex = 0;

    vm.rendicontazioniStati = api.rendicontazionemc.stati.query();
    vm.rendicontazioniTipi = api.rendicontazionemc.tipi.query();

    vm.liste = {
      codiciSpesa: [],
      naturaDocumento: api.rendicontazionemc.naturaDocumento.query(),
      tipoPagamento: api.rendicontazionemc.tipoPagamento.query(),
      programma: api.rendicontazionemc.programma.query()
    }

    vm.datiRendicontazione = $stateParams.rendicontazione;
    vm.id = vm.datiRendicontazione.id;

    $scope.init = function (){
      vm.datiRendicontazione = api.documentorendicontazione.get({
        id: vm.id,
        expand: 'stato,progetto,prospetto,modalita.codiciSpesa,modalita.codiciNonAggiornabili,storicoStato,modo.tipiDocumento,' +
          'statoArchiviazione,revisione,setup,documentoRevisionePresente'
      }, function(res) {
        vm.prospettoSerializzato.costiDiretti = rendicontazioniUtility.serializza(res.prospetto.costiDiretti);
        vm.prospettoSerializzato.costiIndiretti = rendicontazioniUtility.serializza(res.prospetto.costiIndiretti);
        vm.datiRevisione = res.revisione;
        vm.modoRevisione = res.modo.revisione;
        vm.steps = calcolaStep(vm.datiRendicontazione);

        vm.liste.codiciSpesa = []
        res.modalita.codiciSpesa.forEach(function(codice) {
          res.modalita.codiciNonAggiornabili.forEach(function(na) {
            if (codice.id === na.id || codice.codice.charAt(0) === '~') {
              codice.nonAggiornabile = true;
            }
          })
          vm.liste.codiciSpesa.push(codice);
        })

        valida();
      });
    }
    $scope.init();

    showAllButtons();

    initSearch();
    caricaVociSpesa();

    function showAllButtons()
    {
      showButtons();
      $scope.documentiButtons = showDocumentiButtons($scope.documentiButtons);
      vm.revisioneButtons = showDocumentiButtons(vm.revisioneButtons, {revisione: 1});
    }

    function showDocumentiButtons(buttons, extraParams = {}){
      let params = angular.merge({rendicontazioneId: vm.id, 'azioni[]': getButtonActions(buttons)}, extraParams);
      return api.allegatorendicontazione.checkAccess(params);
    }

    function showButtons() {
      vm.buttons = api.documentorendicontazione.checkAccess({id: vm.id, 'azioni[]': getButtonActions(vm.buttons)});
    }

    function getButtonActions(buttons)
    {
      return Object.keys(buttons).filter((el) => el[0] !== '$');
    }

    function calcolaStep(datiRendicontazione) {
      var steps = {
        registro: false,
        prospetto: false,
        status: false,
        revisione: false,
        documenti: false
      }
      var count = 0;
      if (datiRendicontazione.modoRendicontazioneId === 1) { // Rendicontazione2017
        steps.status = ++count;
        steps.documenti = ++count;
      } else {
        steps.registro = ++count;
        steps.prospetto = ++count;
        steps.status = ++count;
        if (datiRendicontazione.revisione) {
          steps.revisione = ++count;
        }
        if (datiRendicontazione.progettoRendicontazioneStato_id >= 3) {
          steps.documenti = ++count;
        } else {
          steps.documenti = ++count;
        }
      }
      steps.count = count;
      return steps;
    }

    function isLastStep(step) {
      return vm.steps.count === step;
    }

    function updateRevisione()
    {
      if (vm.datiRendicontazione.progettoRendicontazioneStato_id == 6) {
        api.documentorendicontazione.updateRevisione({id: vm.id, RevisioneRendicontazione: vm.datiRevisione}, function (res) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Importi aggiornati')
              .position('bottom right')
              .hideDelay(1000)
          );
        })
      }
    }

    function confermaValidazione()
    {
      var confirm = $mdDialog.confirm()
        .title('Conferma validazione')
        .htmlContent("La rendicontazione finale sarà validata. Non potranno più essere apportate modifiche.")
        .ok('CONFERMA')
        .cancel('ABBANDONA');

      $mdDialog.show(confirm).then(function() {
        api.documentorendicontazione.confermaValidazione({id: vm.id}, function (ok) {
            angular.merge(vm.datiRendicontazione, ok);
            vm.datiRevisione = ok.revisione;
            vm.steps = calcolaStep(vm.datiRendicontazione);
            showAllButtons();
            vm.selectedIndex = vm.steps.revisione -1;

            $mdToast.show(
              $mdToast.simple()
                .textContent('Documento validato')
                .position('bottom right')
                .hideDelay(3000)
            );
          },
          mostraErrori
        );
      });
    }

    function invia()
    {
      if (vm.datiRendicontazione.anno >= 2022 && !(vm.datiRendicontazione.modo.label.contains('FAMI') || vm.datiRendicontazione.modo.label.contains('18_19')) && (vm.datiRevisione.speseAmmissibili === null || vm.datiRevisione.speseAmmissibili === "" || !vm.datiRendicontazione.documentoRevisionePresente)) {
        // Mostra il pop-up con il messaggio di avviso solo se speseAmmissibili non è zero
        $mdDialog.show(
          $mdDialog.alert()
            .title('Attenzione')
            .htmlContent('Non è possibile inviare la rendicontazione senza aver allegato il certificato del revisore e aver inserito l’importo delle spese ammissibili dal revisore.<br/> Nel caso di inserimento di dichiarazione di spesa pari a zero l’importo inserito relativo alle spese ammissibili del revisore deve essere pari a zero')
            .ok('OK')
        );
      } else {
        var confirm = $mdDialog.confirm()
          .title('Conferma invio definitivo')
          .htmlContent("La rendicontazione finale sarà inviata definitivamente unitamente al certificato del revisore o dichiarazione di spesa pari a zero. Non potranno più essere apportate modifiche.")
          .ok('CONFERMA')
          .cancel('ABBANDONA');

        $mdDialog.show(confirm).then(function () {
          api.documentorendicontazione.invia({id: vm.id}, function (ok) {
              angular.merge(vm.datiRendicontazione, ok);
              vm.steps = calcolaStep(vm.datiRendicontazione);
              showAllButtons();

              $mdToast.show(
                $mdToast.simple()
                  .textContent('Documento inviato')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            },
            mostraErrori
          )
        });
      }
    }

    function annullaInvio() {
      // Verifica se lo stato attuale del documento rendicontazione è 'INVIATO'
      if (vm.datiRendicontazione.stato.id === 3 /* ID dello stato 'INVIATO' */) {
        var confirm = $mdDialog.confirm()
          .title('Conferma annullamento invio')
          .htmlContent("Vuoi annullare l'invio della rendicontazione?")
          .ok('CONFERMA')
          .cancel('ABBANDONA');

        $mdDialog.show(confirm).then(function () {
          api.documentorendicontazione.annullaInvio({id: vm.id}, function (ok) {
            // Aggiorna i dati della rendicontazione con la risposta del server
            angular.merge(vm.datiRendicontazione, ok);
            vm.steps = calcolaStep(vm.datiRendicontazione);
            showAllButtons();

            $mdToast.show(
              $mdToast.simple()
                .textContent('Invio annullato')
                .position('bottom right')
                .hideDelay(3000)
            );
          }, mostraErrori);
        });
      } else {
        // Mostra un messaggio di avviso se lo stato non è 'INVIATO'
        $mdDialog.show(
          $mdDialog.alert()
            .title('Attenzione')
            .textContent('Puoi annullare l\'invio solo se lo stato attuale è \'INVIATO\'.')
            .ok('OK')
        );
      }
    }

    function valida() {
      if (vm.validaRequest && vm.validaRequest.$cancelRequest) {
        vm.validaRequest.$cancelRequest();
      }
      vm.validaRequest = api.documentorendicontazione.valida({id: vm.id}, mostraErrori);
    }

    function riapri()
    {
      var confirm = $mdDialog.confirm()
        .title('Conferma riapertura in stato bozza')
        .htmlContent("Il documento sarà riaperto in stato di bozza, dovrà essere validato e inviato di nuovo")
        .ariaLabel('riapri in bozza')
        .ok('OK')
        .cancel('ABBANDONA');

      $mdDialog.show(confirm).then(function() {
        api.documentorendicontazione.riapri({id: vm.id}, function (ok) {
          angular.merge(vm.datiRendicontazione, ok);
          vm.datiRevisione = ok.datiRevisione;
          vm.steps = calcolaStep(vm.datiRendicontazione);
          vm.selectedIndex = 0;
          showAllButtons();

          $mdToast.show(
            $mdToast.simple()
              .textContent('Documento riaperto in stato bozza')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      });
    }

    function apriIntegrazione()
    {
      var confirm = $mdDialog.confirm()
        .title('Conferma apertura integrazione')
        .htmlContent("Sarà creato un documento di integrazione alla rendicontazione finale")
        .ariaLabel('apertura integrazione')
        .ok('OK')
        .cancel('ABBANDONA');

      $mdDialog.show(confirm).then(function() {
        $mdDialog.show({
          controller: 'DialogMessaggiController',
          controllerAs: 'vm',
          templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/dialogMessaggiForm.html',
          clickOutsideToClose: false,
          fullscreen: true,
          locals: {
            rendicontazione: vm.datiRendicontazione,
            chiusura: false,
            apertura: true
          }
        }).then(function(res) {
          if (res) {
            api.documentorendicontazione.apriIntegrazione({id: vm.id}, res, function (ok) {
              var dialog;

              if (ok.statusMsg.length) {
                var alert = $mdDialog.alert()
                  .title('Richiesta integrazione/Chiusura aggiornata.')
                  .textContent(ok.statusMsg)
                  .ok('OK')

                dialog = $mdDialog.show(alert)
              } else {
                dialog = $mdToast.show(
                  $mdToast.simple()
                    .textContent('Richiesta integrazione/Chiusura aggiornata.')
                    .position('bottom right')
                    .hideDelay(5000)
                );
              }

              dialog.then($state.go('app.sprardb_rendicontazionimc_rendicontazione', {id: ok.integrazione.id}));
            });
          }
        });

      });
    }

    function chiudiIntegrazione()
    {
      var confirm = $mdDialog.confirm()
        .title('Conferma chiusura integrazione')
        .htmlContent("La pratica di integrazione verrà chiusa.")
        .ariaLabel('chiusura integrazione')
        .ok('OK')
        .cancel('ABBANDONA');

      $mdDialog.show(confirm).then(function() {
        $mdDialog.show({
          controller: 'DialogMessaggiController',
          controllerAs: 'vm',
          templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/dialogMessaggiForm.html',
          clickOutsideToClose: false,
          fullscreen: true,
          locals: {
            rendicontazione: vm.datiRendicontazione,
            chiusura: true,
            apertura: false
          }
        }).then(function (res) {
          if (res) {
            api.documentorendicontazione.chiudiIntegrazione({id: vm.id}, res, function (ok) {
              vm.datiRendicontazione = ok.integrazione;
              vm.steps = calcolaStep(vm.datiRendicontazione);
              showButtons();

              if (ok.statusMsg.length) {
                var alert = $mdDialog.alert()
                  .title('Pratica di Integrazione chiusa.')
                  .textContent(ok.statusMsg)
                  .ok('OK');

                $mdDialog.show(alert);
              } else {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent('Pratica di Integrazione chiusa.')
                    .position('bottom right')
                    .hideDelay(5000)
                );
              }
            });
          }
        });

      });
    }

    function mostraErrori(response) {
      vm.errors = response.data;

      vm.buttons.$promise.then(function(){
        vm.buttons.invia.disabled = vm.buttons.invia.disabled || vm.errors.length > 0;
      })
      vm.alerts = angular.isDefined(response.alerts) ? response.alerts : vm.alerts;
      $('.error-container').empty();
      angular.forEach(vm.errors.concat(vm.alerts), function(e) {
        if (e.field) {
          var element = $compile('<i class="icon icon-alert'+(e.type === 'alert' ? '-box' : '')+' md-raised md-'+e.type+' md-'+e.type+'-fg ' +
            's30 rulesValidatorIcon"><md-tooltip md-direction="top">'+ e.message +'</md-tooltip></i>')($scope);
          $('#' + e.field.replace(/\./g, "\\.")).append(element);
        }
      });
    }

    function caricaVociSpesa()
    {
      var params = {
        rendicontazioneId: vm.id,
        expand: 'codiceSpesa',
        'per-page': vm['per-page'],
        page: vm.page,
        sort: vm.sort,
        filter: vm.filterModel
      }
      if (vm.vociSpesa) vm.vociSpesa.$cancelRequest();
      vm.vociSpesa = api.vociSpesa.query(params, function(res) {
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });
    }

    function caricaProspetto()
    {
      if (vm.datiRendicontazione.$cancelRequest) vm.datiRendicontazione.$cancelRequest();
      api.documentorendicontazione.get({id: vm.id, expand: 'prospetto'}, function(res) {
        vm.datiRendicontazione.prospetto = res.prospetto;
        vm.prospettoSerializzato.costiDiretti = rendicontazioniUtility.serializza(res.prospetto.costiDiretti);
        vm.prospettoSerializzato.costiIndiretti = rendicontazioniUtility.serializza(res.prospetto.costiIndiretti);

        valida();
      });
    }

    function initSearch()
    {
      vm.filterModel = {
        dataDocumento: {
          '>=': null,
          '<': null
        },
        dataPagamento: {
          '>=': null,
          '<': null
        }
      };

      vm.page = 1;
      vm['per-page'] = 10;
      vm.sort = '-progressivo';
    }

    function backToRendicontazioni() {
      $window.history.back();
    }

    function openVoceRegistroSpeseDialog(voceSpesa) {

      $mdDialog.show({
        controller: 'DialogVoceRegistroSpesemcController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/voceRegistroSpese-dialog.html',
        //                targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
          vm: vm,
          voceSpesa: voceSpesa
        }
      });

    }

    function deleteVoceRegistroSpeseDialog(item)
    {
      api.rendicontazionemc.voceSpesa.delete({id: item.id}, function (value, responseHeaders) {
        vm.caricaVociSpesa();
        vm.caricaProspetto();

        angular.forEach($scope.documentiReload, function(value, key) {
          $scope.documentiReload[key] = key;
        });
        $mdToast.show(
          $mdToast.simple()
            .textContent('Voce Registro delle spese cancellata')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    }

    function mostraMessaggi() {
      $mdDialog.show({
        controller: 'DialogMessaggiController',
        controllerAs: 'vm',
        templateUrl: 'app/main/sprardb/rendicontazioni/rendicontazionemc/dialogMessaggiForm.html',
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          rendicontazione: vm.datiRendicontazione,
          chiusura: false,
          apertura: false
        }
      });
    }
  }

  function DialogVoceRegistroSpesemcController($scope, $mdDialog, $mdToast, api, $stateParams, $filter, vm, voceSpesa) {
    var vmd = this;
    vmd.selected = {};
    vmd.liste = vm.liste;
    vmd.datiRendicontazione = vm.datiRendicontazione;

    vmd.voceSpesa = voceSpesa ? voceSpesa : {
      documentoRendicontazioneId: $stateParams.id,
      dataDocumento: new Date(),
      dataPagamento: new Date(),
      attivo: 1,
      programmaId: 1
    };

    $scope.hide = function () {
      $mdDialog.hide();
    };
    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    vmd.salvaVoceRendicontazione = function () {
      var payload = angular.copy(vmd.voceSpesa);

      payload.dataDocumento = payload.dataDocumento.toISOString().substring(0,10);
      if (payload.dataPagamento) {
        payload.dataPagamento =  payload.dataPagamento.toISOString().substring(0,10);
      }

      api.rendicontazionemc.voceSpesa.save
      (
        payload,
        function(value, responseHeaders) { //success
          vm.caricaVociSpesa();
          vm.caricaProspetto();

          $mdDialog.hide();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Voce Registro delle spese ' + (voceSpesa ? 'aggiornata' : 'creata'))
              .position('bottom right')
              .hideDelay(3000)
          );
        }
      );
    };
  }

  function DialogMessaggiController($scope, $state, $mdDialog, api, locals, $mdToast) {
    var vm = this;

    vm.apertura_chiusura = locals.chiusura || locals.apertura;
    vm.apertura = locals.apertura;
    vm.chiusura = locals.chiusura;

    vm.oggi = new Date();

    api.documentorendicontazione.checkAccess({'azioni[]': ['messaggi'], id: locals.rendicontazione.id}, function (res) {
      vm.messaggi = res.messaggi.hidden ? [] : api.documentorendicontazione.messaggi({id: locals.rendicontazione.id});
    })

    vm.dataScadenza = locals.rendicontazione.dataScadenza ? new Date(locals.rendicontazione.dataScadenza) : null;

    api.documentorendicontazione.checkAccess({'azioni[]': ['aggiorna-data-scadenza'], id: locals.rendicontazione.id}, function (res) {
      vm.aggiornaDisabled = res.disabled;
      if (vm.apertura_chiusura) {
        vm.aggiornaHidden = true;
      } else {
        vm.aggiornaHidden = res.hidden;
      }
    })

    if (locals.rendicontazione.progettoRendicontazioneTipo_id === 3) {
      vm.showDataScadenza = vm.apertura;
    } else if (locals.rendicontazione.progettoRendicontazioneTipo_id === 5) {
      vm.showDataScadenza = true;
      if (locals.rendicontazione.progettoRendicontazioneStato_id === 4) {
        vm.disableDataScadenza = vm.apertura_chiusura;
      } else if (locals.rendicontazione.progettoRendicontazioneStato_id === 3) {
        vm.disableDataScadenza = !vm.apertura;
      }
    }

    vm.model = {
      documentoRendicontazioneId: locals.rendicontazione.id,
      data: moment().format("DD/MM/YYYY"),
      testo: ''
    }

    vm.salvamessaggio = salvamessaggio;
    function salvamessaggio() {
      vm.res = {
        dataScadenza: vm.dataScadenza ? moment(vm.dataScadenza).format("YYYY-MM-DD") : null,
        messaggio: vm.model
      }
      if (!vm.apertura_chiusura) {
        api.documentorendicontazione.creaMessaggio({id: vm.model.documentoRendicontazioneId}, vm.res, function (ok) {
          $mdDialog.hide();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Messaggio salvato')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      } else {
        $mdDialog.hide(vm.res);
      }
    }

    vm.aggiornadataScadenza = aggiornadataScadenza;
    function aggiornadataScadenza() {
      var body = {dataScadenza: moment(vm.dataScadenza).format("YYYY-MM-DD")};
      api.documentorendicontazione.aggiornaDataScadenza({id: vm.model.documentoRendicontazioneId}, body, function (ok) {
        $mdDialog.hide();
        if (ok.statusMsg.length) {
          var alert = $mdDialog.alert()
            .title('Data scadenza Integrazione aggiornata')
            .textContent(ok.statusMsg)
            .ok('OK');

          $mdDialog.show(alert);
        } else {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Data scadenza Integrazione aggiornata')
              .position('bottom right')
              .hideDelay(5000)
          );
        }
        locals.rendicontazione.dataScadenza = ok.integrazione.dataScadenza;
      })
    }

    vm.closeDialog = closeDialog;

    function closeDialog() {
      $mdDialog.hide();
    }

  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.rendicontazioni')
            .controller('RendicontazionimcProgettoController', RendicontazionimcProgettoController);

    /** @ngInject */

    function RendicontazionimcProgettoController($state, api, $scope, $stateParams, $q, rendicontazioniUtility) {
        var vm = this;

        vm.gotoRendicontazione = gotoRendicontazione;
        vm.backToRendicontazioni = backToRendicontazioni;

        vm.cambiaAnnoSetup = cambiaAnnoSetup;
        vm.creaDocumento = creaDocumento;

        vm.setupId = null;
        vm.disableBtn = {
            1: true,
            2: true,
            3: true,
            4: true
        };

        vm.progetto = api.progettomc.get({
            id: $stateParams.projectId,
            expand: 'setup,documentiRendicontazione.tipo,documentiRendicontazione.stato,documentiRendicontazione.setup'
        });

        function getDocumento(tipoId) {
            return {
                progetto_id: $stateParams.projectId,
                progettoRendicontazioneTipo_id: tipoId,
                setupId: vm.setupId,
            };
        }

        function creaDocumento(tipoId) {
            api.documentorendicontazione.save(getDocumento(tipoId), function (ok) {
                gotoRendicontazione(ok.id);
            });
        }

        vm.visualizzaRendicontazione = false;


        function cambiaAnnoSetup() {
            angular.forEach(vm.disableBtn, function (val, key) {
                api.documentorendicontazione.createValidation(getDocumento(key), function (response) {
                    vm.visualizzaRendicontazione = true;

                    vm.disableBtn[key] = !response.result;
                });

            });
        }

        function gotoRendicontazione(idRendicontazione) {
            $state.go('app.sprardb_rendicontazionimc_rendicontazione', {id: idRendicontazione});
        }

        function backToRendicontazioni() {
            $state.go('app.sprardb_rendicontazionimc');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.sprardb.rendicontazioni')
        .controller('PreventivomcController', PreventivomcController);

    /** @ngInject */
    function PreventivomcController(api, $stateParams, $window, $scope, $compile, $mdDialog, $mdToast, $rootScope, $filter, rendicontazioniUtility) {
        var vm = this;

        vm.backToRendicontazioni = backToRendicontazioni;
        vm.salva = salva;
        vm.invia = invia;
        vm.riapri = riapri;
        vm.capsLabel = capsLabel;
        vm.caricaImportiPreventivo = caricaImportiPreventivo;

        vm.api = api;

        vm.importi = ['importoCofinanziato', 'contributoRichiesto', 'totale'];
        vm.tipi = ['impegnato', 'quietanzato'];
        vm.errors = [];

        vm.buttons = {
            'update-voci-costo': undefined,
            'invia': undefined,
            'riapri': undefined
        };

        vm.prospettoSerializzato = {
            costiDiretti: undefined,
            costiIndiretti: undefined
        };

        $scope.documentiReload = {};
        $scope.documentiButtons = {
          create: undefined,
          update: undefined,
          'mostra-cancellati': undefined
        };

        vm.rendicontazioniStati = api.rendicontazionemc.stati.query();
        vm.rendicontazioniTipi = api.rendicontazionemc.tipi.query();

        vm.datiRendicontazione = $stateParams.rendicontazione;

        var gruppo = {
          2: 'RIMODULAZIONE',
          4: 'SAL'
        }[vm.datiRendicontazione.progettoRendicontazioneTipo_id];

        showButtons();
        showDocumentiButtons();

        vm.datiRendicontazione = api.documentorendicontazione.get({
            id: vm.datiRendicontazione.id,
            expand: 'modo,tipo,stato,progetto,prospetto,storicoStato,modo.tipiDocumento,setup'+(needPreventivo()?',preventivo.prospetto':'')
        }, onResponse);

        function onResponse(res)
        {
          if (res.preventivo) {
            vm.preventivoProspetto = res.preventivo.prospetto;
            vm.preventivoProspetto.get = rendicontazioniUtility.get;
          }
          $scope.tipoDocumentoList = $filter('filter')(res.modo.tipiDocumento, {gruppo: gruppo});

          vm.prospettoSerializzato.costiDiretti = rendicontazioniUtility.serializza(res.prospetto.costiDiretti);
          vm.prospettoSerializzato.costiIndiretti = rendicontazioniUtility.serializza(res.prospetto.costiIndiretti);
          api.documentorendicontazione.valida({id: vm.datiRendicontazione.id}, mostraErrori, mostraErrori);
        }

        function caricaImportiPreventivo(checkAccess)
        {
          if (vm.datiRendicontazione.progettoRendicontazioneTipo_id !== 2
            || vm.datiRendicontazione.progettoRendicontazioneStato_id !== 1
            || !vm.datiRendicontazione.preventivo
            || vm.datiRendicontazione.preventivo.progettoRendicontazioneStato_id !== 3) {
            return false;
          }
          if (checkAccess) return true;

          var confirm = $mdDialog.confirm()
            .title('CARICA IMPORTI DAL PREVENTIVO')
            .htmlContent("Questa funzione consente di recuperare i valori delle voci dal preventivo già validato.<br>" +
              "Tutti gli importi attualmente visibili saranno persi se non precedentemente salvati.<br>" +
              "Per confermare le modifiche è necessario usare 'Salva in Bozza'.")
            .ariaLabel('Carica Importi Preventivo')
            .ok('OK')
            .cancel('ABBANDONA');

          $mdDialog.show(confirm).then(function() {
            [vm.prospettoSerializzato.costiDiretti,
              vm.prospettoSerializzato.costiIndiretti,
              vm.datiRendicontazione.prospetto.costiDiretti,
              vm.datiRendicontazione.prospetto.costiIndiretti,
              vm.datiRendicontazione.prospetto.costiComplessivi
            ].forEach(function(costi){
              if (angular.isArray(costi)) {
                angular.forEach(costi, riportaRiga);
              } else {
                riportaRiga(costi);
              }
            })

            function riportaRiga(riga) {
              var vocePreventivo = vm.preventivoProspetto.get(riga.path);
              angular.forEach(vm.datiRendicontazione.modo.importiPreventivo, function (importo) {
                if (riga.voce) {
                  riga.voce[importo] = vocePreventivo[importo];
                } else if(!riga.isDisabled) {
                  riga[importo] = vocePreventivo[importo];
                }
              })
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent('Importi del preventivo caricati')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
        }

        function showDocumentiButtons(){
          $scope.documentiButtons = api.allegatorendicontazione.checkAccess({
            rendicontazioneId: vm.datiRendicontazione.id,
            'azioni[]': getButtonActions($scope.documentiButtons)
          });
        }

        function showButtons() {
          vm.buttons = api.documentorendicontazione.checkAccess({
            id: vm.datiRendicontazione.id,
            'azioni[]': getButtonActions(vm.buttons)
          });
        }

        function getButtonActions(buttons)
        {
          return Object.keys(buttons).filter((el) => el[0] !== '$');
        }

        function needPreventivo()
        {
          return [2,4].includes(vm.datiRendicontazione.progettoRendicontazioneTipo_id);
        }

        function salva()
        {
            var postData = [];
            ['costiDiretti', 'costiIndiretti'].forEach(function(tipoCosti) {
                angular.forEach(vm.prospettoSerializzato[tipoCosti], function(codice){
                    if (vm.datiRendicontazione.progettoRendicontazioneTipo_id === 4) {
                        postData.push(codice.impegnato.voce, codice.quietanzato.voce);
                    } else {
                        postData.push(codice.voce);
                    }
                });
            });
            postData = postData.filter(function (val) {return val != null});

            $rootScope.ignoraErrori = true;

            api.documentorendicontazione.updateVociCosto({id: vm.datiRendicontazione.id}, postData, function(okRes) {
                $rootScope.ignoraErrori = false;
                angular.merge(vm.datiRendicontazione, okRes.datiRendicontazione);
                onResponse(okRes.datiRendicontazione);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Il documento è stato salvato correttamente')
                        .position('bottom right')
                        .hideDelay(3000)
                );

                showButtons();
            }, function (response) {

                if (response.status === 422) {
                    $rootScope.$broadcast('httpValidationError', response.data);
                } else {
                    var alert = $mdDialog.alert()
                        .title('Errore imprevisto durante il salvataggio')
                        .htmlContent("Non è stato possibile salvare i dati inseriti, si prega di riprovare più tardi.<br>" +
                            "Se il problema persiste contattare SC")
                        .ok('OK')

                    $mdDialog.show(alert);
                }

                $rootScope.ignoraErrori = false;
            });
        }

        function invia()
        {
            var confirm = $mdDialog.confirm()
                .title('Conferma validazione e invio')
                .htmlContent("Il documento sarà validato e inviato, poi non potrà essere modificato")
                .ariaLabel('valida e invia')
                .ok('OK')
                .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function() {
                api.documentorendicontazione.invia({id: vm.datiRendicontazione.id}, function (ok) {
                    angular.merge(vm.datiRendicontazione, ok);
                    showButtons();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Documento validato e inviato')
                            .position('bottom right')
                            .hideDelay(3000)
                    );
                  },
                  mostraErrori
                );
            });
        }

        function riapri()
        {
            var confirm = $mdDialog.confirm()
                .title('Conferma riapertura in stato bozza')
                .htmlContent("Il documento sarà riaperto in stato di bozza, dovrà essere validato e inviato di nuovo")
                .ariaLabel('riapri in bozza')
                .ok('OK')
                .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function() {
                api.documentorendicontazione.riapri({id: vm.datiRendicontazione.id}, function (ok) {
                  angular.merge(vm.datiRendicontazione, ok);
                  showButtons();

                  $mdToast.show(
                      $mdToast.simple()
                          .textContent('Documento riaperto in stato bozza')
                          .position('bottom right')
                          .hideDelay(3000)
                  );
                });
            });
        }

        function mostraErrori(response) {
          vm.errors = response.data;
          vm.buttons.invia.disabled = vm.buttons.invia.disabled || vm.errors.length > 0;
          vm.alerts = angular.isDefined(response.alerts) ? response.alerts : vm.alerts;
          $('.error-container').empty();
          angular.forEach(vm.errors.concat(vm.alerts), function(e) {
            var element = $compile('<i class="icon icon-alert'+(e.type === 'alert' ? '-box' : '')+' md-raised md-'+e.type+' md-'+e.type+'-fg ' +
              's30 rulesValidatorIcon"><md-tooltip md-direction="top">'+ e.message +'</md-tooltip></i>')($scope);
            $('#' + e.field.replace(/\./g, "\\.")).append(element);
          });
        }

        function backToRendicontazioni() {
            $window.history.back();
        }

        function capsLabel(importiPrev){
            var ret = [];
            importiPrev.forEach(function (value) {
                ret.push(value.replace(/([A-Z])/g, ' $1').toUpperCase());
            });
            return ret;
        }
    }
})();


(function () {
    'use strict';

    angular
            .module('app.sprardb.rendicontazioni')
            .controller('RendicontazioneController', RendicontazioneController)
            .controller('DialogVoceRegistroSpeseController', DialogVoceRegistroSpeseController)
            .controller('DialogUploadFileController', DialogUploadFileController)
            .controller('DialogMessaggisticaController', DialogMessaggisticaController)
            .directive("fileread", Fileread)
            .filter('filterTipo', filterTipo);

    /** @ngInject */

    function RendicontazioneController($state, api, $scope, $stateParams, $mdToast, $mdDialog, rendicontazioniUtility, acl, eventi, $filter) {
        console.log("$stateParams: ", $stateParams);
        var vm = this;
        vm.numbersOnly = '\\d+';
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly;
        vm.isallowed = acl.isallowed;
        vm.uploadParams = {
            documentoTipo_id: 0,
            gruppo: 'RENDICONTAZIONE',
            dettaglio: true,
            dettagliomin: false,
            entita: 'rendicontazione',
            entitakey: 'progettoRendicontazione_id',
            cancellazione: true
        };
        vm.api = api;

        vm.backToRendicontazioni = backToRendicontazioni;
        vm.datiRendicontazione = {};
        vm.datiRimodulazione = {};
        vm.datiPFP = {};
        vm.parametriRendicontazione = null;
        vm.nuovaRendicontazione = false;
        vm.allLoaded = false;
        vm.getTotal = rendicontazioniUtility.getTotal;
        vm.rulesValidator = rulesValidator;
        vm.checkErrors = checkErrors;
        vm.saveRendicontazione = saveRendicontazione;
        vm.saveStatus = saveStatus;
        vm.mostramessaggi = mostramessaggi;
        vm.confermaIntegrazione = confermaIntegrazione;
        vm.openVoceRegistroSpeseDialog = openVoceRegistroSpeseDialog;
        vm.codiciSpesaPreventivo = [];
        vm.tipoPagamento = [];
        vm.naturaDocumento = [];
        vm.registroSpese = null;
        vm.backToProject = backToProject;
        vm.projectId = null;
        vm.uploadDocumentoVoceSpesa = uploadDocumentoVoceSpesa;
        vm.totalePrecedente = false;
        vm.bandos = [];
        var rules = [];
        var rulesErrors = [];
        vm.checkLoaded001 = 0;
        vm.checkLoaded002 = 0;

        vm.registroSpesePaginazione = {};
        vm.registroSpesePaginazione.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.registroSpesePaginazione.limitOptions = [25];
        vm.registroSpesePaginazione.pagination = 25;
        vm.registroSpesePaginazione.page = $stateParams.page;
        vm.registroSpesePaginazione.sort = "-progressivo";
        vm.registroSpesePaginazione.meta = {};
        vm.registroSpesePaginazione.meta.perPage = vm.registroSpesePaginazione.pagination;
        vm.registroSpesePaginazione.meta.currentPage = vm.registroSpesePaginazione.page;
        vm.registroSpesePaginazione.meta.pageCount = vm.registroSpesePaginazione.page;
        vm.registroSpesePaginazione.meta.totalCount = vm.registroSpesePaginazione.page;

        vm.registroSpesePagina = function (items) {
            var parti_da = (vm.registroSpesePaginazione.pagination * (vm.registroSpesePaginazione.page - 1));
            //vm.datiRendicontazioneItemsTemp = $filter("orderBy")(vm.datiRendicontazioneItemsTemp, vm.registroSpesePaginazione.sort);
            vm.datiRendicontazioneItems = vm.datiRendicontazioneItemsTemp.slice(parti_da, (parti_da + vm.registroSpesePaginazione.pagination));

        };
        vm.registroSpeseOrdina = function (order) {
            var parti_da = (vm.registroSpesePaginazione.pagination * (vm.registroSpesePaginazione.page - 1));
            vm.datiRendicontazioneItemsTemp = $filter("orderBy")(vm.datiRendicontazioneItemsTemp, vm.registroSpesePaginazione.sort);
            vm.datiRendicontazioneItems = vm.datiRendicontazioneItemsTemp.slice(parti_da, (parti_da + vm.registroSpesePaginazione.pagination));
        };
        vm.logOrder = function (order) {
//            console.log("Ordinamento", order);
//            console.log("Variabile:", vm.query.order);
        }

        //recuperiamo i codici spesa, che utilizzeremo in diversi ambiti


        api.rendicontaziones.jsonInput.get({
            id: 1
        }, function (res) {
            res.jsonModel.forEach(function (key, value) {
                key.items.forEach(function (key2, value2) {
                    vm.codiciSpesaPreventivo.push(key2);
                });
            });
        });

        //recuperiamo i codici delle ricevute, per il modulo consuntivo finale
        //vm.codiciRicevute = api.rendicontaziones.jsonInput.get({id: 5});
        //vm.codiciRicevute = vm.codiciRicevute.jsonModel;


        api.rendicontaziones.jsonInput.get({
            id: 6
        }, function (res) {
            res.jsonModel.forEach(function (key, value) {
                vm.tipoPagamento.push(key);
            });
        });
        //recuperiamo i codici dei documenti, per il modulo consuntivo finale


        api.rendicontaziones.jsonInput.get({
            id: 5
        }, function (res) {
            res.jsonModel.forEach(function (key, value) {
                vm.naturaDocumento.push(key);
            });
        });

        //        console.log(vm.codiciSpesaPreventivo);
        //se sono impostati ID progetto e Tipo rendicontazione si tratta di una nuova Rendicontazione

        if ($stateParams.projectId && $stateParams.tipoRendicontazione) {
            vm.nuovaRendicontazione = true;
            vm.tipoRendicontazione = $stateParams.tipoRendicontazione;
            //var statoRendicontazione = vm.tipoRendicontazione;
            //se il tipo è 1 siamo al Preventivo
            //recuperiamo lo schema relativo al formato della rendicontazione
            //recuperiamo i parametri della rendicontazione


            api.progettos.progetto.get({
                id: $stateParams.projectId
            }, function (res) {
                vm.progetto = res;
                vm.projectId = res.id;
                //restituisce parametri anno in corso

                vm.parametriRendicontazione = res.progettoparametrirendicontaziones;
                vm.datiRendicontazione.pprs = res.progettoparametrirendicontaziones;

                //recuperiamo la rendicontazione precedente

                if (vm.tipoRendicontazione != 1) {
                    //ricerchiamo per progetto, tipo 1 (limita comunque sia il 2 che il 3) e anno


                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: res.id,
                        progettoRendicontazioneTipo_id: 1,
                        anno: res.anno
                    }, function (res2) {
                        //se abbiamo un risultato

                        if (res2.data.length) {
                            //calcoliamo il totale
                            vm.totalePrecedente = vm.getTotal(res2.data[0].jsonData)['importi']['totaleCostiComplessivi']['totale'];

                        }
                    });
                }

                vm.allLoaded = true;
                vm.checkLoaded001 = 1;
                //vm.checkLoaded002 = 0;
                //vm.checkLoaded003 = 0;
                //devo eseguire il validatore
                console.log("come siamo messi con il controllo caricamento 001?", vm.checkLoaded001);
                console.log("come siamo messi con il controllo caricamento 002?", vm.checkLoaded002);
                if ((vm.checkLoaded002 + vm.checkLoaded001) == 2) {
                    loadRules();

                }

            });

            api.rendicontaziones.jsonInput.get({
                id: vm.tipoRendicontazione
            }, function (res) {

                vm.jsonModel = res.jsonModel;

                if (vm.tipoRendicontazione == 1) {
                    vm.datiRendicontazione.jsonData = res.jsonModel;

                } else if (vm.tipoRendicontazione == 2) {
                    console.log("qui");
                    // var annoCorrente = new Date().getFullYear();
                    var annoCorrente = $stateParams.annoCorrente;

                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: $stateParams.projectId,
                        progettoRendicontazioneTipo_id: 1,
                        anno: annoCorrente
                    }, function (res2) {
                        console.log(res2);
                        //se abbiamo un risultato

                        if (res2.data.length) {
                            //console.log("1");
                            vm.datiRendicontazione.jsonData = res2.data[0].jsonData;

                        } else {
                            //console.log("2");
                            vm.datiRendicontazione.jsonData = res.jsonModel;
                        }
                    });

                } else if (vm.tipoRendicontazione == 4) {
                    //                    console.log("qui");
                    //var annoCorrente = new Date().getFullYear();
                    var annoCorrente = $stateParams.annoCorrente;

                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: $stateParams.projectId,
                        progettoRendicontazioneTipo_id: 1,
                        anno: annoCorrente
                    }, function (res2) {
                        console.log(res2);
                        //se abbiamo un risultato

                        if (res2.data.length) {
                            //console.log("1");
                            vm.datiRendicontazione.jsonData = res2.data[0].jsonData;

                        } else {
                            //console.log("2");
                            vm.datiRendicontazione.jsonData = res.jsonModel;
                        }
                    });

                } else if (vm.tipoRendicontazione == 5) {

                    //var annoCorrente = new Date().getFullYear();
                    var annoCorrente = $stateParams.annoCorrente;

                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: $stateParams.projectId,
                        progettoRendicontazioneTipo_id: 3,
                        anno: annoCorrente
                    }, function (res2) {
                        console.log(res2);
                        //se abbiamo un risultato

                        if (res2.data.length) {
                            //console.log("1");
                            vm.datiRendicontazione.jsonData = res2.data[0].jsonData;

                        } else {
                            //console.log("2");
                            vm.datiRendicontazione.jsonData = res.jsonModel;
                        }
                    });

                } else if (vm.tipoRendicontazione == 3) {
                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: vm.datiRendicontazione.progetto_id,
                        progettoRendicontazioneTipo_id: 2,
                        anno: vm.datiRendicontazione.anno
                    }, function (rim) {

                        if (rim.data.length) {
                            vm.rimodulazione = true;
                        }
                        if (!rim.data.length) {
                            vm.rimodulazione = false;

                        }
                    });

                    vm.datiRendicontazione.jsonData = {};
                    vm.datiRendicontazioneRecap = {};
                    vm.datiRimodulazione = {};
                    vm.datiPFP = {};
                    var annoCorrente = $stateParams.annoCorrente;
                    //devo trasferire i dati di prosecuzione e proroga tecnica dal documento precedente al nuovo documento di rendicontazione finale
                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: $stateParams.projectId,
                        progettoRendicontazioneTipo_id: 2,
                        anno: annoCorrente
                    }, function (rend) {

                        vm.datiRimodulazione = rend.data[0];
                        vm.datiRendicontazione.prosecuzione = vm.datiRimodulazione.prosecuzione;
                        vm.datiRendicontazione.prorogaTecnica = vm.datiRimodulazione.prorogaTecnica;
                        vm.totaleIRimodulazione = vm.getTotal(vm.datiRimodulazione.jsonData).I.importi.totale;

                        //console.log("dentro la funzione");
                        //console.log(vm.datiRendicontazione.prosecuzione);
                        //console.log("dentro la funzione");
                    });
                    //recupero i totali della voce [I] in pfp per il calcolo corretto delle economie. dati del PFP
                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: vm.datiRendicontazione.progetto_id,
                        progettoRendicontazioneTipo_id: 1,
                        anno: annoCorrente
                    }, function (PFP) {

                        vm.datiPFP = vm.getTotal(PFP.data[0].jsondata);
                        vm.totaleIPFP = vm.datiPFP.I.importi.totale;
                        vm.totaleIPFPcontributo = vm.datiPFP.I.importi.contributoRichiesto;
                        vm.totaleIPFPcofinanziato = vm.datiPFP.I.importi.importoCofinanziato;

                    });

                    //recuperiamo lo schema di tipo 1 per rivalidare i conteggi


                    api.rendicontaziones.jsonInput.get({
                        id: 1
                    }, function (res2) {
                        vm.datiRendicontazioneRecap.jsonData = res2.jsonModel;
                    });
                }
                //vm.checkLoaded001 = 1;
                vm.checkLoaded002 = 1;
                //vm.checkLoaded003 = 0;
                //devo eseguire il validatore
                console.log("come siamo messi con il controllo caricamento 001?", vm.checkLoaded001);
                console.log("come siamo messi con il controllo caricamento 002?", vm.checkLoaded002);
                if ((vm.checkLoaded002 + vm.checkLoaded001) == 2) {
                    loadRules();

                }

            });

            api.rendicontaziones.stati.get(function (res) {
                vm.rendicontazioniStati = res;
            });

            api.rendicontaziones.tipi.get(function (res) {
                vm.rendicontazioniTipi = res;
            });

        } else if ($stateParams.id !== '') {
            console.log("Allora stateParams è vuoto");

            api.rendicontaziones.rendicontazione.get({
                id: $stateParams.id
            }, function (res) {

                vm.datiRendicontazione = res;

                if (res.progettoRendicontazioneTipo_id === 2) {
                    vm.uploadParams.gruppo = 'RIMODULAZIONE';
                }

                vm.finale = vm.datiRendicontazione.rendicontazioneFinale_id == null ; //Lor: condizione affichè sia finale
                vm.uploadParams.progettoRendicontazioneStato_id = vm.datiRendicontazione.progettoRendicontazioneStato_id;
                var testindex = 0;
                var i1 = 0;
                vm.datiRendicontazioneItemsTemp = [];
                if (angular.isDefined(vm.datiRendicontazione.jsonData.items)) {
                    //vm.datiRendicontazioneItems = angular.copy(vm.datiRendicontazione.jsonData.items);
                    for (i1 = 0; i1 < vm.datiRendicontazione.jsonData.items.length; i1++) {
                        var i2 = 0;
                        var oggetto1 = vm.datiRendicontazione.jsonData.items[i1];
                        vm.datiRendicontazioneItemsTemp[i1] = angular.copy(oggetto1);//{};
                        for (i2 = 0; i2 < oggetto1.length; i2++) {
                            var oggetto2 = oggetto1[i2];
                            if (oggetto2 !== null) {
                                if (vm.datiRendicontazione.anno != 2017) {
                                    vm.datiRendicontazioneItemsTemp[i1][oggetto2.id] = oggetto2.value;
                                }
                            }
                        }
//                    console.log("xxxxxxxxxx:", vm.datiRendicontazioneItemsTemp[i1]);
                    }
                }
                vm.registroSpesePaginazione.meta.totalCount = vm.datiRendicontazioneItemsTemp.length;
                vm.datiRendicontazioneItemsTemp = $filter("orderBy")(vm.datiRendicontazioneItemsTemp, vm.registroSpesePaginazione.sort);
                vm.registroSpesePagina();
                // vm.datiRendicontazioneItems = vm.datiRendicontazioneItemsTemp.slice(0, vm.registroSpesePaginazione.pagination);
//                console.log("vm.datiRendicontazioneItems: ", angular.copy(vm.datiRendicontazioneItems));


                angular.forEach(vm.datiRendicontazione.jsonData.items, function (t1) {
                    angular.forEach(t1, function (t2) {
                        if (t2 !== null) {
                            if (vm.datiRendicontazione.anno != 2017) {
                                vm.datiRendicontazione.jsonData.items[testindex][t2.id] = t2.value;
//                                console.log("testindex:", testindex);
//                                console.log("id:", t2.id);
//                                console.log("valore:", t2.value);
//                                console.log(" = ", vm.datiRendicontazione.jsonData.items[testindex][t2.id]);
//                                console.log("-----");
                            }
                        }
                    });
                    testindex++;
                });

                //copia dei dati





                console.log("000-res", angular.copy(vm.datiRendicontazione));
                vm.allLoaded = true;
                //valorizzo il tipo di rendicontazione
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.pprs;
                //precedente:
                //vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;

                vm.projectId = res.progettos.id;
                vm.uploadParams.progettoRendicontazione_id = vm.datiRendicontazione.id;
                vm.uploadParams.entita_id = vm.datiRendicontazione.id;
                vm.bandos = res.progettos.bandos;
                //var stringa = vm.bandos.map(a => a.descrizione);
                var stringa = vm.bandos.map(function (b) {
                    return b.descrizione;
                }
                //a => a.descrizione
                );
                var bandoString = stringa.join(", ");
                vm.bandoString = bandoString;

                //vm.validasal = vm.datiRendicontazione.jsonData[9].items[0].fields[0].value;
                vm.validasal = {};
                if (vm.datiRendicontazione.jsonData) {
                    if (vm.datiRendicontazione.jsonData[9]) {
                        vm.validasal = vm.datiRendicontazione.jsonData[9].items[0].fields[0].value;
                        vm.datiRendicontazione.jsonData[9].items[0].fields[1].value = new Date(vm.datiRendicontazione.jsonData[9].items[0].fields[1].value);
                    }
                }
                ;
                //vm.datiRendicontazione.jsonData[9].items[0].fields[1].value = new Date();
                //vm.datiRendicontazione.jsonData[9].items[0].fields[1].value = new Date(vm.datiRendicontazione.jsonData[9].items[0].fields[1].value);


                //recuperiamo la rendicontazione precedente
                //console.log(vm.tipoRendicontazione);

                if (vm.tipoRendicontazione === 2) {
                    var annoCorrente = $stateParams.annoCorrente;
                    if (annoCorrente == null) {
                        annoCorrente = vm.datiRendicontazione.anno
                    }
                    //ricerchiamo per progetto, tipo 1 (limita comunque sia il 2 che il 3) e anno


                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: res.progettos.id,
                        progettoRendicontazioneTipo_id: 1,
                        anno: annoCorrente
                    }, function (res) {
                        //se abbiamo un risultato

                        if (res.data.length) {
                            //vm.bozzarimodulazione = api.rendicontaziones.rendicontazione.search({progetto_id: res.progettos.id, progettoRendicontazioneTipo_id: 2, anno: res.progettos.anno});
                            //calcoliamo il totale
                            vm.totalePrecedente = vm.getTotal(res.data[0].jsonData)['importi']['totaleCostiComplessivi']['totale'];
                            //vm.totalei = (res.data[0].jsonData);
                            vm.totaliPrecedenti = vm.getTotal(res.data[0].jsonData);
                            vm.totaleI = vm.totaliPrecedenti.I.importi.totale;
                            vm.totaleIcontributoRichiesto = vm.totaliPrecedenti.I.importi.contributoRichiesto;
                            console.log("controlliamo sempre");
                            console.log(vm.totaleIrichiesto);

                            vm.totaleL = vm.totaliPrecedenti.L.importi.totale;
                            vm.totaleB = vm.totaliPrecedenti.B.importi.totale;
                            vm.totaleG = vm.totaliPrecedenti.G.importi.totale;
                            vm.totaleS = vm.totaliPrecedenti.S.importi.totale;
                            vm.totaleT = vm.totaliPrecedenti.T.importi.totale;

                            vm.totaleP = vm.totaliPrecedenti.P.importi.totale;
                            vm.totaleA = vm.totaliPrecedenti.A.importi.totale;
                            vm.totaleCi = vm.totaliPrecedenti.Ci.importi.totale;

                            console.log("quistosempre");
                            //console.log(vm.totalei);
                            console.log(vm.totaliPrecedenti);
                            //console.log(res.data[0].jsonData);
                            //console.log(vm.totaliPrecedenti.I.importi.totale);
                        }
                        //devo recuperare i dati del PFP


                        api.rendicontaziones.rendicontazione.search({
                            progetto_id: vm.datiRendicontazione.progetto_id,
                            progettoRendicontazioneTipo_id: 1,
                            anno: vm.datiRendicontazione.anno
                        }, function (PFP) {

                            if (PFP.data.length) {
                                vm.PFP = PFP.data[0];
                                vm.datiPFP = vm.getTotal(PFP.data[0].jsonData);
                                vm.totaleIPFP = vm.datiPFP.I.importi.totale;
                                vm.totaleIPFPcontributo = vm.datiPFP.I.importi.contributoRichiesto;
                                vm.totaleIPFPcofinanziato = vm.datiPFP.I.importi.importoCofinanziato;
                            }

                            loadRules();

                        });

                    });
                }

                if (vm.tipoRendicontazione === 3 && vm.nuovaRendicontazione == false) {

                    api.rendicontaziones.rendicontazione.search({
                        progetto_id: vm.datiRendicontazione.progetto_id,
                        progettoRendicontazioneTipo_id: 2,
                        anno: vm.datiRendicontazione.anno
                    }, function (rim) {

                        if (rim.data.length) {
                            vm.rimodulazione = true;
                        }
                        if (!rim.data.length) {
                            vm.rimodulazione = false;

                        }
                                //Recupera i dati in modo erroneo:
								//var annoCorrente = $stateParams.annoCorrente;
								var annoCorrente = vm.datiRendicontazione.anno;


                        api.rendicontaziones.rendicontazione.search({
                            progetto_id: res.progettos.id,
                            progettoRendicontazioneTipo_id: 2,
                            anno: annoCorrente
                             //Recupera i dati in modo erroneo:
							//anno: res.progettos.anno
                        }, function (res) {
                            //se abbiamo un risultato

                            if (res.data.length) {
                                vm.datiRimodulazione = {};
                                vm.datiPFP = {};
                                //Recupera i dati in modo erroneo:
								//var annoCorrente = $stateParams.annoCorrente;
								var annoCorrente = vm.datiRendicontazione.anno;
                                //devo trasferire i dati di prosecuzione e proroga tecnica dal documento precedente al nuovo documento di rendicontazione finale
                                api.rendicontaziones.rendicontazione.search({
                                    progetto_id: vm.datiRendicontazione.progetto_id,
                                    progettoRendicontazioneTipo_id: 2,
                                    anno: annoCorrente
                                }, function (rend) {

                                    vm.datiRimodulazione = rend.data[0];

                                    vm.datiRendicontazione.prosecuzione = vm.datiRendicontazione.prosecuzione;
                                    vm.datiRendicontazione.prorogaTecnica = vm.datiRendicontazione.prorogaTecnica;
                                    console.log("dentro la funzione 002");
                                    console.log(vm.datiRendicontazione.prosecuzione);
                                    console.log("dentro la funzione 002");

                                    vm.totaleIRimodulazione = vm.getTotal(vm.datiRimodulazione.jsonData).I.importi.totale;

                                    //devo recuperare i dati del PFP


                                    api.rendicontaziones.rendicontazione.search({
                                        progetto_id: vm.datiRendicontazione.progetto_id,
                                        progettoRendicontazioneTipo_id: 1,
                                        anno: annoCorrente
                                    }, function (PFP) {
                                        if (PFP.data.length) {
                                            vm.PFP = PFP.data[0];
                                            vm.datiPFP = vm.getTotal(PFP.data[0].jsonData);
                                            vm.totaleIPFP = vm.datiPFP.I.importi.totale;
                                            vm.totaleIPFPcontributo = vm.datiPFP.I.importi.contributoRichiesto;
                                            vm.totaleIPFPcofinanziato = vm.datiPFP.I.importi.importoCofinanziato;
                                        }
                                        vm.datiRendicontazioneRecap = {};
                                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                                        api.rendicontaziones.jsonInput.get({
                                            id: 1
                                        }, function (res2) {
                                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                                            api.rendicontaziones.jsonInput.get({
                                                id: res.progettoRendicontazioneTipo_id
                                            }, function (res) {
                                                //                console.log(res.jsonModel);
                                                //disattivo per il problema della modale
                                                //vm.jsonModel = res.jsonModel;
                                                loadRules();
                                            });
                                        });

                                    });
                                });

                                //calcoliamo il totale
                                vm.totalePrecedente = vm.getTotal(res.data[0].jsonData)['importi']['totaleCostiComplessivi']['totale'];
                                //vm.totalei = (res.data[0].jsonData);
                                vm.totaliPrecedenti = vm.getTotal(res.data[0].jsonData);
                                vm.totaleI = vm.totaliPrecedenti.I.importi.totale;

                                vm.totaleL = vm.totaliPrecedenti.L.importi.totale;
                                vm.totaleB = vm.totaliPrecedenti.B.importi.totale;
                                vm.totaleG = vm.totaliPrecedenti.G.importi.totale;
                                vm.totaleS = vm.totaliPrecedenti.S.importi.totale;
                                vm.totaleT = vm.totaliPrecedenti.T.importi.totale;

                                vm.totaleP = vm.totaliPrecedenti.P.importi.totale;
                                vm.totaleA = vm.totaliPrecedenti.A.importi.totale;
                                vm.totaleCi = vm.totaliPrecedenti.Ci.importi.totale;

                                console.log("quistosempre");
                                //console.log(vm.totalei);
                                console.log(vm.totaliPrecedenti);
                                //console.log(res.data[0].jsonData);
                                //console.log(vm.totaliPrecedenti.I.importi.totale);
                            } else {
                                vm.datiRendicontazioneRecap = {};
                                //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                                api.rendicontaziones.jsonInput.get({
                                    id: 1
                                }, function (res2) {
                                    vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                                    api.rendicontaziones.jsonInput.get({
                                        id: res.progettoRendicontazioneTipo_id
                                    }, function (res) {
                                        //                console.log(res.jsonModel);
                                        //disattivo per il problema della modale
                                        //vm.jsonModel = res.jsonModel;
                                        loadRules();
                                    });
                                });

                            }
                            console.log("001a-res", angular.copy(vm.datiRendicontazione));
                        });
                    });

                }
                console.log("002-res", angular.copy(vm.datiRendicontazione));

                api.rendicontaziones.jsonInput.get({
                    id: res.progettoRendicontazioneTipo_id
                }, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;
                });

                if (vm.tipoRendicontazione == 3) {
                    vm.datiRendicontazioneRecap = {};
                    //recuperiamo lo schema di tipo 1 per rivalidare i conteggi


                    api.rendicontaziones.jsonInput.get({
                        id: 1
                    }, function (res2) {
                        vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                    });
                }
                //devo eseguire il validatore [togliere]

                if (vm.tipoRendicontazione === 1) {

                    api.rendicontaziones.jsonInput.get({
                        id: res.progettoRendicontazioneTipo_id
                    }, function (res) {
                        //                console.log(res.jsonModel);
                        //disattivo per il problema della modale
                        //vm.jsonModel = res.jsonModel;
                        loadRules();
                    });

                }
            });
            api.rendicontaziones.stati.get(function (res) {
                vm.rendicontazioniStati = res;
            });

            api.rendicontaziones.tipi.get(function (res) {
                vm.rendicontazioniTipi = res;
            });

        } else {
            //temporaneo forward
            $state.go('app.sprardb_rendicontazioni');
            //            $state.go('app.sprardb_rendicontazioni_rendicontazione', {projectId: '30', tipoRendicontazione: '3'});
        }
        //valerio: registriamo anche qui la fuzione di back alla lista rendicontazioni
        function backToRendicontazioni() {
            $state.go('app.sprardb_rendicontazioni');
        }

        function elaboraResocontoRendicontazioneFinale(model) {

            vm.datiRendicontazione.jsonData.items.forEach(function (key) {
                var codiceSpesa = key[6].value;
                var spesaAttiva = 1;
                if (angular.isDefined(key[12])) {
                    spesaAttiva = key[12].value;
                }

                model.forEach(function (key2) {
                    key2.items.forEach(function (key3) {
                        if (key3.id == codiceSpesa && spesaAttiva == 1) {

                            key3.fields[0].value = Number(key3.fields[0].value) + Number(key[9].value);
                            key3.fields[1].value = Number(key3.fields[1].value) + Number(key[10].value);

                        }
                    });
                });
            });
            return model;

        }
        ;

        function backToProject() {

            $state.go('app.sprardb_rendicontazioni_progetto', {
                projectId: vm.projectId
            });
        }

        //sistema di arrotondamento
        function arrotondo(value) {
            return (Math.round(value * 100) / 100);
        }

        //Stabiliamo le regole di validazione
        //Errori

        function loadRules() {

            var rulesErrors = [];

            //Batteria di controlli per tuti
            rules['P_importi_totale'] = function (model) {
                //senza parametro anno
                //var limite = vm.parametriRendicontazione.costoPersonale + 1;
                var limite = arrotondo(vm.datiRendicontazione.pprs.costoPersonale);
                var valore = arrotondo(vm.getTotal(model)['P']['importi']['totale']);
                //                console.log("limite", limite);
                //                console.log("valore", valore);
                //limite = Math.round(limite, 2);
                if (valore > limite) {
                    return "Il valore inserito nella macrovoce P deve essere uguale o minore - mai superiore - del valore numerico/economico \"Costo del personale\" (qui " + (limite) + "€).";
                }
                return false;
            };

            rules['Ci_importi_contributoRichiesto'] = function (model) {

                var limite = arrotondo((vm.getTotal(model)['importi']['totaleCostiDiretti']['contributoRichiesto'] / 100) * 10);

                var valore = arrotondo(vm.getTotal(model)['Ci']['importi']['contributoRichiesto']);
                //                console.log("limite", limite);
                //                console.log("valore", valore);

                if (valore > limite) {
                    return "La cella \"Costi indiretti - contributo richiesto\"  deve corrispondere al massimo al 10% del \"Totale costi diretti - contributi richiesti\" (qui " + (limite) + "€).";
                }
                return false;
            };
            //Batteria di controlli per PFP
			if (vm.tipoRendicontazione === 1) {
                rules['totaleCostiComplessivi_importoCofinanziato'] = function (model) {
                    //senza parametro anno
                    //var limite = vm.parametriRendicontazione.cofinanziamento;

                    var limite = arrotondo(vm.datiRendicontazione.pprs.cofinanziamento);

                    var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['importoCofinanziato']);
//                    console.log("limite", limite);
//                    console.log("valore", valore);

                    if (valore != limite)
                    {
                        return "Il \"piano finanziario preventivo\" deve riportare un \"Totale Complessivo - Importo Cofinanziato\" identico ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€). ";
                    }
                    return false;
                };

                rules['totaleCostiComplessivi_contributoRichiesto'] = function (model) {
                    //senza parametro anno
                    //var limite = vm.parametriRendicontazione.contributo;

                    var limite = arrotondo(vm.datiRendicontazione.pprs.contributo);

                    var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['contributoRichiesto']);
//                    console.log("limite", limite);
//                    console.log("valore", valore);

                    if (valore != limite)
                    {
                        return "Il \"piano finanziario preventivo\" deve riportare un \"Totale Complessivo - Contributo Richiesto\" identico ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€). ";
                    }
                    return false;
                };

                rules['totaleCostiComplessivi_totale'] = function (model) {

                    var limite = arrotondo(vm.datiRendicontazione.pprs.costoComplessivo);

                    var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale']);
//                    console.log("limite", limite);
//                    console.log("valore", valore);

                    if (valore != limite)
                    {
                        return "Il \"piano finanziario preventivo\" deve riportare un \"Totale Complessivo - Costo Totale\" identico ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€).";
                    }
                    //disattivo la regola seguente in quanto va applicato un controllo diverso per lo stadio 2 e 3
                    //if (vm.tipoRendicontazione != 1 && vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale'] > vm.totalePrecedente)
                    //{
                    //    return "La cella \"Totale Complessivo - Costo Totale\"  non può eccedere l'importo indicato nelle Rendicontazioni precedenti. ";
                    //}
                    return false;
                };
                rules['I_importi_contributoRichiesto'] = function (model) {

                    var limite = arrotondo((vm.datiRendicontazione.pprs.costoComplessivo / 100) * 7);
                    var valore = arrotondo(vm.getTotal(model)['I']['importi']['contributoRichiesto']);

//                    console.log("limite", limite);
//
//                    console.log("valore", valore);
                    if (valore < limite) {

                        return "Il valore \"Contributo richiesto\" di I_TOTALE, non può essere inferiore al 7% del costo complessivo (qui " + (limite) + "€).";
                    }
                    return false;
                };

            }
            ;

            //Batteria di controlli per la rimodulazione
            if (vm.tipoRendicontazione == 2) {
                if (vm.datiRendicontazione.anno !== 2020) {
                    rules['I_importi_contributoRichiesto'] = function (model) {

                        var limite = arrotondo(vm.totaleIcontributoRichiesto);
                        var valore = arrotondo(vm.getTotal(model)['I']['importi']['contributoRichiesto']);
                        vm.valore = valore;

                        //                    console.log("limite", limite);
                        //                    console.log("valore", valore);

                        if (valore < limite) {

                            return "L\'importo della macro voce I_TOTALE \"Contributo richiesto\" non può subire diminuzione rispetto a quanto indicato nel piano preventivo approvato (qui " + (limite) + "€).";
                        }
                        return false;
                    };
                } else {
                    rules['L_L2_importi_contributoRichiesto'] = function (model) {
                        var limite = arrotondo((vm.datiRendicontazione.pprs.costoComplessivo / 100) * 3);
                        var valore = arrotondo(vm.getTotal(model)['L']['L2']['importi']['contributoRichiesto']);
                        if (valore > limite) {

                            return "Il valore inserito nella riga L2 - \"Contributo richiesto\"  deve essere al massimo pari al 3% del \"Costo Complessivo Assegnato\" (qui " + (limite) + "€).";
                        }
                        return false;
                    };
                    rules['L_L1_importi_contributoRichiesto'] = function (model) {
                        var limite = arrotondo((vm.datiRendicontazione.pprs.costoComplessivo / 100) * 3.33);
                        var valore = arrotondo(vm.getTotal(model)['L']['L1']['importi']['contributoRichiesto']);

                        if (valore > limite) {

                            return "Il valore inserito nella riga L1 - \"Contributo richiesto\" deve essere al massimo pari al 3,33% del \"Costo Complessivo Assegnato\" (qui " + (limite) + "€).";
                        }
                        return false;
                    };
                }

            	rules['totaleCostiComplessivi_importoCofinanziato'] = function (model) {
            		//senza parametro anno
            		//var limite = vm.parametriRendicontazione.cofinanziamento;

            		var limite = arrotondo(vm.datiRendicontazione.pprs.cofinanziamento);

            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['importoCofinanziato']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);
            		if (valore !== limite) {
            			return "Il \"piano finanziario rimodulato\" deve riportare un \"Totale Complessivo - Importo Cofinanziato\" uguale ai corrispondenti importi approvati e assegnati dalla Commissione (qui " + (limite) + "€)";
            		}
            		return false;
            	};
            	//rispettiamo anche la percentuale di cofinanziamento indicata in setup

            	rules['totaleCostiComplessivi_contributoRichiesto'] = function (model) {

            		var limite = arrotondo(vm.datiRendicontazione.pprs.contributo);

            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['contributoRichiesto']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);
            		if (valore !== limite) {
            			return "Il \"piano finanziario rimodulato\" deve riportare un \"Totale Complessivo - Contributo Richiesto\" uguale ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€)";
            		}
            		return false;
            	};

            	rules['totaleCostiComplessivi_totale'] = function (model) {

            		var limite = arrotondo(vm.datiRendicontazione.pprs.costoComplessivo);

            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);
            		if (valore !== limite) {
            			return "Il \"piano finanziario rimodulato\" deve riportare un \"Totale Complessivo - Costo Totale\" uguale ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€)";
            		}
            		//disattivo la regola seguente in quanto va applicato un controllo diverso per lo stadio 2 e 3
            		//if (vm.tipoRendicontazione != 1 && vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale'] > vm.totalePrecedente)
            		//{
            		//    return "La cella \"Totale Complessivo - Costo Totale\"  non può eccedere l'importo indicato nelle Rendicontazioni precedenti. ";
            		//}
            		return false;
            	};

            };

            //Batteria di controlli comuni a PFP e Rimodulato
            var stepRendicontazione = vm.datiRendicontazione.progettoRendicontazioneTipo_id; //voila!
            if (!vm.tipoRendicontazione) {
            	vm.tipoRendicontazione = stepRendicontazione;
            }
            //console.log("statorendiconto", vm.tipoRendicontazione);

            if (vm.tipoRendicontazione < 3 && vm.nuovaRendicontazione == false && vm.datiRendicontazione.anno !== 2020) {

            	rules['L_L2_importi_contributoRichiesto'] = function (model) {
            		//senza parametro anno
            		var totalePratica = vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale'];
            		var limite = arrotondo((totalePratica / 100) * 3);
            		var valore = arrotondo(vm.getTotal(model)['L']['L2']['importi']['contributoRichiesto']);
            		//                console.log("limite", limite);
            		//                console.log("valore", valore);

            		if (valore > limite) {

            			return "Il valore inserito nella riga L2 - \"Contributo richiesto\"  deve essere al massimo pari al 3% del \"Costo Complessivo Assegnato\" (qui " + (limite) + "€).";
            		}
            		return false;
            	};
            	rules['L_L1_importi_contributoRichiesto'] = function (model) {
            		//senza parametro anno
            		var totalePratica = vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale'];
            		var limite = arrotondo((totalePratica / 100) * 3.33);

            		var valore = arrotondo(vm.getTotal(model)['L']['L1']['importi']['contributoRichiesto']);
            		//                console.log("limite", limite);
            		//                console.log("valore", valore);

            		if (valore > limite) {

            			return "Il valore inserito nella riga L1 - \"Contributo richiesto\" deve essere al massimo pari al 3,33% del \"Costo Complessivo Assegnato\" (qui " + (limite) + "€).";
            		}
            		return false;
            	};
            };

            //Batteria di controlli per RIMODULAZIONE FINALE

            var stepRendicontazione = vm.datiRendicontazione.progettoRendicontazioneTipo_id; //voila!
            if (!vm.tipoRendicontazione) {
            	vm.tipoRendicontazione = stepRendicontazione;
            }
            //console.log("statorendiconto", vm.tipoRendicontazione);

            if (vm.tipoRendicontazione === 3 && vm.nuovaRendicontazione == false) {
            	//regola di controllo bloccante su I - nel caso in cui ne chiedano l'attivazione
            	//    rules['I_importi_contributoRichiesto'] = function (model) {
            	//    var valore = arrotondo(vm.getTotal(model)['I']['importi']['contributoRichiesto']);
            	//	var limite = arrotondo((vm.totaleIPFPcontributo / vm.datiRendicontazione.pprs.costoComplessivo)*(vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale']));
            	//        if (valore < limite) {
            	//
            	//            return "La percentuale sul totale del contributo richiesto in [I] non dovrebbe essere inferiore a quella riscontrata nel PFP";
            	//        }
            	//        return false;
            	//    };


            	rules['L_L2_importi_contributoRichiesto'] = function (model) {
            		//senza parametro anno

            		var limite = arrotondo((vm.datiRendicontazione.pprs.costoComplessivo / 100) * 3);
            		var valore = arrotondo(vm.getTotal(model)['L']['L2']['importi']['contributoRichiesto']);
            		//                console.log("limite", limite);
            		//                console.log("valore", valore);

            		if (valore > limite) {

            			return "L'importo di L2 - contributo richiesto deve essere ≤ al 3% del costo complessivo assegnato (qui " + (limite) + "€).";
            		}
            		return false;
            	};
            	rules['L_L1_importi_contributoRichiesto'] = function (model) {
            		//senza parametro anno

            		var limite = arrotondo((vm.datiRendicontazione.pprs.costoComplessivo / 100) * 3.33);

            		var valore = arrotondo(vm.getTotal(model)['L']['L1']['importi']['contributoRichiesto']);
            		//                console.log("limite", limite);
            		//                console.log("valore", valore);

            		if (valore > limite) {

            			return "Il valore inserito nella riga L1 - \"Contributo richiesto\" deve essere al massimo pari al 3,33% del \"Costo Complessivo Assegnato\" (qui " + (limite) + "€).";
            		}
            		return false;
            	};

            	//controllo per L, B, G, S, I, T
            	//settore [L]
                // TODO: dovrebbe essere L_importi_totale (vgiacomini)
                rules['L_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleL) + (vm.totaleL / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).L.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {

            			return "L\'importo imputato alla macro voce L_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).L.importi.totale < vm.totaleL)
            		//{
            		//	return "L\'importo imputato alla macro voce L_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};
            	//settore [B]
            	//console.log("logostotali", vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            	//console.log("logostot", vm.totaleB);
                // TODO: dovrebbe essere B_importi_totale (vgiacomini)
                rules['B_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleB) + (vm.totaleB / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {

            			return "L\'importo imputato alla macro voce B_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale < vm.totaleB)
            		//{
            		//	return "L\'importo imputato alla macro voce B_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};
            	//settore [G]
            	//console.log("logostotali", vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            	//console.log("logostot", vm.totaleB);
                // TODO: dovrebbe essere G_importi_totale (vgiacomini)
                rules['G_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleG) + (vm.totaleG / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).G.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {

            			return "L\'importo imputato alla macro voce G_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).G.importi.totale < vm.totaleG)
            		//{
            		//	return "L\'importo imputato alla macro voce G_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};
            	//settore [S]
            	//console.log("logostotali", vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            	//console.log("logostot", vm.totaleB);
                // TODO: dovrebbe essere S_importi_totale (vgiacomini)
                rules['S_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleS) + (vm.totaleS / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).S.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {

            			return "L\'importo imputato alla macro voce S_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).S.importi.totale < vm.totaleS)
            		//{
            		//	return "L\'importo imputato alla macro voce S_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};
            	//settore [I]
            	//console.log("logostotali", vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            	//console.log("logostot", vm.totaleB);
            	rules['I_importi_totale'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleI) + (vm.totaleI / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).I.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {
            			return "L\'importo imputato alla macro voce I_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).I.importi.totale < vm.totaleI)
            		//{
            		//	return "L\'importo imputato alla macro voce I_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};
            	//settore [T]
            	//console.log("logostotali", vm.getTotal(vm.datiRendicontazioneRecap.jsonData).B.importi.totale);
            	//console.log("logostot", vm.totaleB);

                // TODO: dovrebbe essere T_importi_totale (vgiacomini)
            	rules['T_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo((vm.totaleT) + (vm.totaleT / 10));
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).T.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {
            			return "L\'importo imputato alla macro voce T_TOTALE non può subire incrementi superiori al 10%";
            		}
            		//else if (vm.getTotal(vm.datiRendicontazioneRecap.jsonData).T.importi.totale < vm.totaleT)
            		//{
            		//	return "L\'importo imputato alla macro voce T_TOTALE non può essere inferiore al valore in rimodulazione";
            		//}
            		return false;
            	};

            	//controllo per P, A, Ci
            	//settore [P]

                rules['P_importi_totale'] = function (model) {
                    /*if (vm.tipoRendicontazione != 3) {
                    return false
                    }*/

                    var limite = arrotondo(vm.totaleP);
                    var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).P.importi.totale);
                    //                    console.log("limite", limite);
                    //                    console.log("valore", valore);

                    if (valore > limite) {
                        return "L\'importo imputato alla macro voce P_TOTALE non può essere superiore al valore approvato in rimodulazione (qui " + (vm.totaleP) + "€).";
                    }
                    return false;
                };
            	//settore [A]

                // TODO: dovrebbe essere A_importi_totale (vgiacomini)
                rules['A_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo(vm.datiRendicontazione.anno === 2020 ? vm.totaleA * 1.1 : vm.totaleA);
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).A.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {
            			return "L\'importo imputato alla macro voce A_TOTALE non può essere superiore al valore in rimodulazione (qui " + (limite) + "€).";
            		}
            		return false;
            	};
            	//settore [Ci]

                // TODO: dovrebbe essere Ci_importi_totale (vgiacomini)
                rules['Ci_importi_contributoRichiesto'] = function (model) {
            		/*if (vm.tipoRendicontazione != 3) {
            		return false
            		}*/

            		var limite = arrotondo(vm.datiRendicontazione.anno === 2020 ? vm.totaleCi * 1.1 : vm.totaleCi);
            		var valore = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData).Ci.importi.totale);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		if (valore > limite) {
            			return "L\'importo imputato alla macro voce Ci_TOTALE non può essere superiore al valore in rimodulazione (qui " + (limite) + "€).";
            		}
            		return false;
            	};

            	rules['totaleCostiComplessivi_importoCofinanziato'] = function (model) {

            		var limite = arrotondo(vm.datiRendicontazione.pprs.cofinanziamento);
            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['importoCofinanziato']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		//preparo le variabili per il controllo delle economie sulle eventuali riduzioni della voce [i] non trasferibili su altre voci di spesa
            		//vm.economieRendicontoCofinanziato = arrotondo(vm.totaleIPFPcofinanziato - (vm.getTotal(model)['I']['importi']['importoCofinanziato']));
            		//if (vm.economieRendicontoCofinanziato < 0) {
            		//    vm.economieRendicontoCofinanziato = 0;
            		//}

            		//if (valore > (limite - vm.economieRendicontoCofinanziato))
            		if (valore > limite) {
            			return "Il \"piano finanziario consuntivo\" deve riportare un \"Totale Complessivo - Importo Cofinanziato\" uguale o inferiore ai corrispondenti importi approvati e assegnati dalla Commissione (qui " + (limite) + "€)";
            		}
            		return false;
            	};
            	//rispettiamo anche la percentuale di cofinanziamento indicata in setup
            	rules['totaleCostiComplessivi_percCofinanziamento'] = function (model) {

            		var perCofinanziamento = arrotondo(vm.datiRendicontazione.pprs.percCofinanziamento);
            		var totaleProgetto = arrotondo(vm.getTotal(vm.datiRendicontazioneRecap.jsonData)['importi']['totaleCostiComplessivi']['totale']);
            		var valoreCofinanziamento = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['importoCofinanziato']);
            		var perCalcolata = arrotondo((valoreCofinanziamento / totaleProgetto) * 100);

            		if (perCalcolata < perCofinanziamento) {
            			return "L'importo del cofinanziamento deve essere maggiore o uguale alla percentuale approvata dal Ministero.  " + (valoreCofinanziamento) + "€ corrisponde al " + (perCalcolata) + "% ed è inferiore rispetto al " + (perCofinanziamento) + "% sul totale.";
            		}
            		return false;
            	};

            	rules['totaleCostiComplessivi_contributoRichiesto'] = function (model) {

            		var limite = arrotondo(vm.datiRendicontazione.pprs.contributo);
            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['contributoRichiesto']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		//preparo le variabili per il controllo delle economie sulle eventuali riduzioni della voce [i] non trasferibili su altre voci di spesa
            		vm.economieRendicontoContributo = arrotondo(vm.totaleIPFPcontributo - vm.getTotal(model)['I']['importi']['contributoRichiesto']);
            		if (vm.economieRendicontoContributo < 0 || vm.datiRendicontazione.anno === 2020) {
            			vm.economieRendicontoContributo = 0;
					}

            		if (valore > (limite - vm.economieRendicontoContributo)) {
            		//if (valore > limite) {
            			//messaggio cassato in revisione
						//return "Il \"piano finanziario consuntivo\" deve riportare un \"Totale Complessivo - Contributo Richiesto\" uguale o inferiore ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€). Se non è stata rispettata la percentuale prevista nel PFP sulla macrovoce I l'importo residuo non potrà essere trasferito in nessun'altra voce di spesa";
						//messaggio richiesto da SC, ma problematico:
						return "Attenzione. Non è stata rispettata la percentuale prevista nel PFP sulla macrovoce I. L'importo residuo non può essere trasferito in nessun'altra voce di spesa.";
            		}
            		return false;
            	};

            	rules['totaleCostiComplessivi_totale'] = function (model) {

            		var limite = arrotondo(vm.datiRendicontazione.pprs.costoComplessivo);
            		var valore = arrotondo(vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale']);
            		//                    console.log("limite", limite);
            		//                    console.log("valore", valore);

            		//preparo le variabili per il controllo delle economie sulle eventuali riduzioni della voce [i] non trasferibili su altre voci di spesa
            		//vm.economieRendiconto = arrotondo(vm.totaleIPFP - (vm.getTotal(model)['I']['importi']['totale']));
            		// if (vm.economieRendiconto < 0) {
            		//  vm.economieRendiconto = 0;
            		//}

            		//if (valore > (limite - vm.economieRendiconto)) {
            		if (valore > limite) {

            			return "Il \"piano finanziario consuntivo\" deve riportare un \"Totale Complessivo - Costo Totale\" uguale o inferiore ai corrispondenti importi approvati e assegnati dalla Commissione di Valutazione(qui " + (limite) + "€)";
            		}
            		//disattivo la regola seguente in quanto va applicato un controllo diverso per lo stadio 2 e 3
            		//if (vm.tipoRendicontazione != 1 && vm.getTotal(model)['importi']['totaleCostiComplessivi']['totale'] > vm.totalePrecedente)
            		//{
            		//    return "La cella \"Totale Complessivo - Costo Totale\"  non può eccedere l'importo indicato nelle Rendicontazioni precedenti. ";
            		//}
            		return false;
            	};
            };
            //fine dei controlli specifici per la rendicontazione finale
        }
        ;
        //fine funzione caricamento regole


        //questa funzione elabora le regole e produce eventualmente i warning

        function rulesValidator(obj, model) {
            //se il caricamento non è completo evitiamo la validazione

            if (!vm.allLoaded) {
                return false;
            }
            // mediante questa condizione elimino il controllo delle voci di rimodulazione
            // quando prorogaTecnica + prosecuzione
            // resta attivo comunque il sistema di disabilitazione della validazione
            // risultato: no line error - salvataggio tuttavia impossibile

            if ((vm.datiRendicontazione.prorogaTecnica + vm.datiRendicontazione.prosecuzione) == 2) {
                return false;
            }

            if (!model) {
                return false;
            }
            if (rules.hasOwnProperty(obj)) {
                var esito = rules[obj](model);
                rulesErrors[obj] = esito;
                return esito;
            }

            rulesErrors[obj] = false;
            return false;
        }

        //funzione per l'elaborazione finale dei controlli in consuntivo. Comparazione con i valori di rimodulazione e applicazione dei delta
        /*
         vm.disabilitapulsante = false;
         vm.controllatotali = controllatotali;
         function controllatotali (parametro){
         var esito = false;
         var arraya = ["L","B","G","S","T","I"];
         var arrayb = ["P","A","Ci"];
         //quando non c'è -1

         if (arraya.indexOf(parametro) > -1)
         {
         //controlli del primo gruppo se inferiore a precedente bloccante
         if ((vm.getTotal(vm.datiRendicontazione.jsonData)['importi']['totale']) < (vm.totaliPrecedenti['importi']['totale']));
         {
         esito = true;
         vm.disabilitapulsante = true;
         }

         else {
         //controlli del primo gruppo superiore a precedente 10% bloccante
         if ((vm.getTotal(vm.datiRendicontazione.jsonData)['importi']['totale']) / (vm.totaliPrecedenti['importi']['totale'])) > 1.1 {
         esito = true;
         vm.disabilitapulsante = true;
         }
         else {
         //controlli del primo gruppo superiore a precedente max 10% segnale non bloccante
         esito = true;
         vm.disabilitapulsante= false;
         }
         }


         return esito;
         }


         if (arrayb.indexOf (parametro) > -1)
         {

         //controlli del secondo gruppo

         }
         };*/
        ///fine della funzione di controllo


        function checkErrors() {
            if ((vm.datiRendicontazione.prorogaTecnica + vm.datiRendicontazione.prosecuzione) == 2) {
                return false;

            } else {
                for (var key in rulesErrors) {
                    if (rulesErrors[key]) {
                        return true;
                    }
                }
                return false;
            }
        }

        vm.fineallega = fineallega;
        function fineallega() {
            api.eventos.evento.search({
                entita1_id: vm.datiRendicontazione.progetto_id,
                eventoStato_id: 1,
                eventoTipo_id_IN: "4004",
                sort: "-id"
            }, function (r) {

                var newitem = r.data[0];
                //apri popoup per lavorazione
                eventi.work("completa", newitem, 4, "completa", false);
            });

        }
        vm.validaallega = validaallega;
        function validaallega() {
            api.eventos.evento.search({
                entita1_id: vm.datiRendicontazione.progetto_id,
                eventoStato_id: 1,
                eventoTipo_id_IN: "4008",
                sort: "-id"
            }, function (r) {

                var newitem = r.data[0];
                //apri popoup per lavorazione
                eventi.work("completa", newitem, 4, "completa", false);
            });

        }
        vm.invalidaallega = invalidaallega;
        function invalidaallega() {
            api.eventos.evento.search({
                entita1_id: vm.datiRendicontazione.progetto_id,
                eventoStato_id: 1,
                eventoTipo_id_IN: "4008",
                sort: "-id"
            }, function (r) {

                var newitem = r.data[0];
                //apri popoup per lavorazione
                eventi.work("completa", newitem, 5, "completa", false);
            });

        }
        //        console.log(vm.codiciSpesaPreventivo);
        function confermaIntegrazione() {
            //                    console.log("qui");
            //var annoCorrente = new Date().getFullYear();
            var annoCorrente = $stateParams.annoCorrente;
            //console.log("$stateParams", $stateParams);
            api.rendicontaziones.rendicontazione.get({id: $stateParams.id}, function (r) {
                if (r) {
                    r.jsonData.items = null;
                    r.jsonData.items = [];
                    vm.datiRendicontazione.jsonData = r.jsonData;
                    vm.saveRendicontazione(4);
                }
            });

//            api.rendicontaziones.rendicontazione.search({
//                progetto_id: $stateParams.projectId,
//                progettoRendicontazioneTipo_id: 3,
//                anno: annoCorrente
//            }, function (res2) {
//                console.log("res2", res2);
//                //se abbiamo un risultato
//
//                if (res2.data.length) {
//                    vm.datiRendicontazione.jsonData = res2.data[0].jsonData;
//                    console.log("res3", vm.datiRendicontazione.jsonData);
//
//                } else {
//                    //console.log("2");
//                    vm.datiRendicontazione.jsonData = res.jsonModel;
//                }
//            });
//            vm.saveRendicontazione(4);
        }

        function saveRendicontazione(stato) {
            console.log("tr:", angular.copy(vm.tipoRendicontazione));
            if (!vm.nuovaRendicontazione) {
                var rendicontazione = vm.datiRendicontazione;
                var statoAttuale = angular.copy(rendicontazione.progettoRendicontazioneStato_id);
                var statoFuturo = stato;
                var tipoPratica = rendicontazione.progettoRendicontazioneTipo_id;
                var anno = rendicontazione.anno;

                if (
                        //disattivo la prima condizione di passaggio di stato avendo agganciato la messaggistica alla conferma di apertura
                                (statoAttuale == 3 && statoFuturo == 3) ||
                                (statoAttuale == 5 && statoFuturo == 3) ||
                                (statoAttuale == 4 && statoFuturo == 3) || (!statoFuturo)) {
                    //messaggistica
                    var messaggi = angular.copy(rendicontazione.jsonData.messages);
                    console.log("messaggi", messaggi);
                    $mdDialog.show({
                        controller: 'DialogMessaggisticaController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/dialogMessaggiForm.html',
                        clickOutsideToClose: false,
                        fullscreen: true,
                        locals: {
                            messaggi: messaggi
                        }
                    }).then(function (datastore) {
                        console.log("datastore", datastore);
                        var redirect = false;
                        if (datastore.doit) {
                            if (angular.isUndefined(datastore.nuovomessaggio)) {
                                datastore.nuovomessaggio = "--Nessun messaggio inserito--";
                            }
                            var nuovomessaggio = datastore.messaggi + "\r\n" + datastore.datanuovomessaggio + "\r\n" + datastore.nuovomessaggio;
                            var dataAdesso = moment(new Date()).format("DD/MM/YYYY");
                            if ((statoAttuale == 3 && statoFuturo == 3) || (statoAttuale == 5 && statoFuturo == 3)){
                                redirect = true;
                                var nuovomessaggio = nuovomessaggio + "\r\n" + dataAdesso + "\r\n" + "Richiesta NUOVA integrazione alla pratica codice:" + rendicontazione.id;
                            }
                            if (statoAttuale == 4 && statoFuturo == 3) {
                                var nuovomessaggio = nuovomessaggio + "\r\n" + dataAdesso + "\r\n" + "Chiusura integrazione alla pratica codice:" + rendicontazione.id;
                            }
//ui-sref="app.sprardb_rendicontazioni_rendicontazione({projectId: vm.datiRendicontazione.progetto_id, tipoRendicontazione: 5, annoCorrente: vm.datiRendicontazione.anno, prosecuzione:vm.datiRendicontazione.prosecuzione, importi:vm.datiRendicontazione.importi, jsonData:vm.datiRendicontazione.jsonData})"
                            rendicontazione.jsonData.messages = nuovomessaggio;
                            rendicontazione.progettoRendicontazioneStato_id = stato;
                            api.rendicontaziones.rendicontazione.aggiorna(rendicontazione, function (response) {
                                var pratica = response;
                                pratica.jsonData.items = null;
                                pratica.jsonData.items = [];
                                var email = {};
                                email.to = [];
                                email.to.push("noreply@serviziocentrale.it");
                                email.to.push(vm.datiRendicontazione.progettos.email);

                                email.oggetto = "Messaggio Integrazione Rendicontazione";
                                email.corpo = "Gentili colleghi da questo momento è attiva la funzione di integrazione documentale.";

                                if (redirect) {
                                    api.emails.send.send(email, function (response) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Richiesta integrazione/Chiusura aggiornata.')
                                                .position('bottom right')
                                                .hideDelay(5000)).then(
                                                $state.go('app.sprardb_rendicontazioni_rendicontazione', {projectId: pratica.progetto_id, tipoRendicontazione: 5, annoCorrente: pratica.anno, prosecuzione: pratica.prosecuzione, importi: pratica.importi, jsonData: pratica.jsonData, idPadre: pratica.id})
                                                );
                                        //$mdDialog.hide();
                                    });
                                }
                                if (!redirect) {
                                    api.emails.send.send(email, function (response) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Richiesta integrazione/Chiusura aggiornata.')
                                                .position('bottom right')
                                                .hideDelay(5000)).then(
                                                $state.reload()
                                                );

                                    });
                                }

                            });
                        }
                    });

                }
                //nuovo messaggio per la rimodulazione in invio [testare con mail personale]
                else if (statoFuturo == 3 && tipoPratica == 2) {
                    rendicontazione.progettoRendicontazioneStato_id = stato;
                    api.rendicontaziones.rendicontazione.aggiorna(rendicontazione, function (response) {
                        if (stato == 3) {
                            var email = {};
                            email.to = [];
                            var codice = "PR-" + vm.datiRendicontazione.codiceProgetto + "-" + vm.datiRendicontazione.id + "-" + vm.datiRendicontazione.anno;
                            email.to.push(vm.datiRendicontazione.progettos.email);
                            email.to.push("noreply@serviziocentrale.it");
                            email.oggetto = "Documento di Rimodulazione correttamente inviato al Servizio Centrale";
                            email.corpo = "E' stato correttamente inviato il documento RIMODULAZIONE per l'annualità " + anno + ".<br>Si ricorda che la trasmissione di eventuali allegati deve avvenire attraverso il pulsante <b>“CARICA UN FILE”</b> nella sezione " + anno + " NUOVA RENDICONTAZIONE.";

                            api.emails.send.send(email, function (response) {
                                $mdToast.show(
                                        $mdToast.simple()
                                        .textContent('Dati salvati correttamente e codice spedito.')
                                        .position('bottom right')
                                        .hideDelay(5000));
                                $mdDialog.hide();
                            });
                        } else {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Dati salvati correttamente')
                                    .position('bottom right')
                                    .hideDelay(3000)).then(
                                    $state.reload());
                        }
                    });
                } else {
                    rendicontazione.progettoRendicontazioneStato_id = stato;
                    api.rendicontaziones.rendicontazione.aggiorna(rendicontazione, function (response) {
                        if (stato == 5) {
                            var email = {};
                            email.to = [];
                            var codice = "PR-" + vm.datiRendicontazione.codiceProgetto + "-" + vm.datiRendicontazione.id + "-" + vm.datiRendicontazione.anno;
                            email.to.push(vm.datiRendicontazione.progettos.email);
                            email.to.push("noreply@serviziocentrale.it");
                            email.oggetto = "Codice Validazione Rendicontazione";
                            email.corpo = "Il codice assegnato alla rendicontazione validata è " + codice + "<br><br>Ringraziamo per la collaborazione<br>Cordiali Saluti";

                            api.emails.send.send(email, function (response) {
                                $mdToast.show(
                                        $mdToast.simple()
                                        .textContent('Dati salvati correttamente e codice spedito.')
                                        .position('bottom right')
                                        .hideDelay(5000));
                                $mdDialog.hide();
                            });
                        } else {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Dati salvati correttamente')
                                    .position('bottom right')
                                    .hideDelay(3000)).then(
                                    $state.reload());
                        }
                    });
                }

            } else {
                var nuovaRendicontazione = {};
                nuovaRendicontazione.jsonData = vm.datiRendicontazione.jsonData;
                nuovaRendicontazione.prorogaTecnica = vm.datiRendicontazione.prorogaTecnica;
                nuovaRendicontazione.prosecuzione = vm.datiRendicontazione.prosecuzione;
                if (angular.isUndefined(nuovaRendicontazione.jsonData.items)) {
                    var items = [[
                            {
                                "id": "progressivo",
                                "label": "Progressivo",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "naturaDocumento",
                                "label": "Natura del documento giustificativo",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "dataDocumento",
                                "label": "Data del doc.",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "numeroDocumento",
                                "label": "Nr documento",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "tipoPagamento",
                                "label": "Tipo pagamento",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "dataPagamento",
                                "label": "Data pagamento",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "codiceSpesa",
                                "label": "Cod. spesa",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "descrizioneRegistrazione",
                                "label": "Descrizione registrazione",
                                "type": "string",
                                "value": ""
                            },
                            {
                                "id": "importoTotaleDocumento",
                                "label": "Importo totale del documento giustificativo",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "importoCofinanziato",
                                "label": "Importo cofinanziato",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "importoFinanziato",
                                "label": "Importo finanziato",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "importoImputatoProgetto",
                                "label": "Importo totale imputato al progetto",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "attivo",
                                "label": "Attiva in rendicontazione",
                                "type": "integer",
                                "value": 1
                            },
                            {
                                "id": "prorogaTecnica",
                                "label": "Spesa in regime di proroga tecnica",
                                "type": "integer",
                                "value": 0
                            },
                            {
                                "id": "programma",
                                "label": "Programma",
                                "type": "integer",
                                "value": 0
                            }
                        ]];

                    nuovaRendicontazione.jsonData.items = items;
                }
                if (angular.isUndefined(nuovaRendicontazione.jsonData.messages)) {
                    nuovaRendicontazione.jsonData.messages = "";
                }
                nuovaRendicontazione.progetto_id = $stateParams.projectId;
                nuovaRendicontazione.progettoRendicontazioneTipo_id = $stateParams.tipoRendicontazione;
                nuovaRendicontazione.progettoRendicontazioneStato_id = stato;
                nuovaRendicontazione.codiceProgetto = vm.progetto.codiceMinistero;
                nuovaRendicontazione.enteLocale = vm.progetto.bandos[0].descrizione;
                nuovaRendicontazione.anno = $stateParams.annoCorrente;
                api.rendicontaziones.rendicontazione.save(nuovaRendicontazione, function (response) {

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati salvati correttamente')
                            .position('bottom right')
                            .hideDelay(3000)).then(
                            $state.go('app.sprardb_rendicontazioni_rendicontazione', {
                                id: response.id
                            }, {
                                reload: true,
                                inherit: false
                            }));
                });
            }
        }

        function mostramessaggi() {

            var rendicontazione = vm.datiRendicontazione;
            var statoAttuale = angular.copy(rendicontazione.progettoRendicontazioneStato_id);
            //var statoFuturo = stato;
            var tipoPratica = rendicontazione.progettoRendicontazioneTipo_id;
            var anno = rendicontazione.anno;
            //if ((statoAttuale == 3 && statoFuturo == 4) || (statoAttuale == 4 && statoFuturo == 3) || (!statoFuturo)) {
            //messaggistica
            var messaggi = angular.copy(rendicontazione.jsonData.messages);
            console.log("messaggi", messaggi);
            $mdDialog.show({
                controller: 'DialogMessaggisticaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/dialogMessaggiForm.html',
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    messaggi: messaggi
                }
            }).then(function (datastore) {
                console.log("datastore", datastore);
                if (datastore.doit) {
                    if (angular.isUndefined(datastore.nuovomessaggio)) {
                        datastore.nuovomessaggio = "--Nessun messaggio inserito--";
                    }
                    var nuovomessaggio = datastore.messaggi + "\r\n" + datastore.datanuovomessaggio + "\r\n" + datastore.nuovomessaggio;
                    rendicontazione.jsonData.messages = nuovomessaggio;
                    //rendicontazione.progettoRendicontazioneStato_id = stato;
                    api.rendicontaziones.rendicontazione.aggiorna(rendicontazione, function (response) {
                        var email = {};
                        email.to = [];
                        email.to.push("noreply@serviziocentrale.it");
                        email.to.push(vm.datiRendicontazione.progettos.email);

                        email.oggetto = "Messaggio dal sistema di rendicontazione della banca dati SPRAR";
                        email.corpo = "Un messaggio è stato aggiunto alla pratica di rendicontazione del progetto:\r\n" + nuovomessaggio;

                        api.emails.send.send(email, function (response) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Messaggio inoltrato')
                                    .position('bottom right')
                                    .hideDelay(5000));
                            $mdDialog.hide();
                        });

                    });
                }
            });

            //}
            //nuovo messaggio per la rimodulazione in invio [testare con mail personale]


        }


        function saveStatus() {
            if (!vm.nuovaRendicontazione) {
                var stato = {};
                stato.id = vm.datiRendicontazione.id;
                stato.jsonData = vm.datiRendicontazione.jsonData;
                stato.prorogaTecnica = vm.datiRendicontazione.prorogaTecnica;
                stato.prosecuzione = vm.datiRendicontazione.prosecuzione;
                stato.progettoRendicontazioneTipo_id = vm.datiRendicontazione.progettoRendicontazioneTipo_id;
                stato.progettoRendicontazioneStato_id = vm.datiRendicontazione.progettoRendicontazioneStato_id;
                stato.progetto_id = vm.datiRendicontazione.progetto_id;
                //api.rendicontaziones.rendicontazione.aggiorna(rendicontazione, function (response) {
                api.rendicontaziones.rendicontazione.aggiorna(stato, function (response) {

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Stato salvato')
                            .position('bottom right')
                            .hideDelay(3000)).then(
                            $state.go('app.sprardb_rendicontazioni_rendicontazione', {
                                id: response.id
                            }, {
                                reload: true,
                                inherit: false
                            }));
                });
            }
        }

        vm.salvaVoceRendicontazione = function (voceData) {
            console.log("stoqui");
            //console.log(vm.datiRendicontazione);
            console.log(voceData);

            $stateParams.page = vm.registroSpesePaginazione.page;

            api.rendicontaziones.rendicontazione.itemsjsondata({version: vm.datiRendicontazione.version, item: voceData}, function (r) {
                if (r) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Voce Registro delle spese inserita/aggiornata')
                            .position('bottom right')
                            .hideDelay(3000)).then(
                        $state.transitionTo($state.current, $stateParams, { reload: true, inherit: false, notify: true})
                            );
                }
            });


            /*
             if (vm.nuovaRendicontazione) {
             vm.datiRendicontazione.jsonData.items = [];
             }

             var progressivo = voceData[0].value;
             var update = false;
             vm.datiRendicontazione.jsonData.items.forEach(function (elem, key) {
             if (elem[0].value === progressivo)
             {
             vm.datiRendicontazione.jsonData.items[key] = voceData;
             update = true;
             }
             });

             if (!update) {
             vm.datiRendicontazione.jsonData.items.push(voceData);
             }
             saveRendicontazione(1);
             */
        }

        //tentativo di rimozione a cascata anche dei documenti correllati al record di rendicontazione.
        //da terminare. Non trovo corrispondenti funzioni per PROGETTORENDICONTAZIONE_HAS_DOCUMENTO
        vm.cancelladocumento = cancelladocumento;
        function cancelladocumento(dprogettoRendicontazione_id, did) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function () {
                api.documentos.remove.save({
                    id: did,
                    progettoRendicontazione_id: dprogettoRendicontazione_id
                }, function (d) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Files cancellato!!')
                            .position('bottom right')

                            .hideDelay(3000)).then(function () {});

                });
            }, function () {});

        }
        vm.deleteVoceRegistroSpeseDialog = function (voceData) {

            voceData.push({id: "azione", value: 2});
            voceData.push({id: "rid", value: $stateParams.id});
            delete(voceData.attivo);
            delete(voceData.codiceSpesa);
            delete(voceData.dataDocumento);
            delete(voceData.dataPagamento);
            delete(voceData.descrizioneRegistrazione);
            delete(voceData.importoCofinanziato);
            delete(voceData.importoFinanziato);
            delete(voceData.importoImputatoProgetto);
            delete(voceData.importoTotaleDocumento);
            delete(voceData.naturaDocumento);
            delete(voceData.numeroDocumento);
            delete(voceData.programma);
            delete(voceData.progressivo);
            delete(voceData.prorogaTecnica);
            delete(voceData.tipoPagamento);
            //console.log(voceData);
            api.rendicontaziones.rendicontazione.itemsjsondata({version: vm.datiRendicontazione.version, item: voceData}, function (r) {
                if (r) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Voce Registro delle spese cancellata')
                            .position('bottom right')
                            .hideDelay(3000)).then(
                            $state.reload()
                            );
                }
            });

            /*
             var progressivo = voceData[0].value;
             vm.datiRendicontazione.jsonData.items.forEach(function (elem, key) {

             if (elem[0].value === progressivo) {

             //questo invece rimuove la porzione di json corrispondente alla voce di rendicontazione pertinente
             vm.datiRendicontazione.jsonData.items.splice(key, 1);
             var recuperaAllegati = {pagination: 8000, fields: "id"};
             var idAnnullare = [];
             recuperaAllegati.progettoRendicontazione_id = $stateParams.id;
             recuperaAllegati.progettoRendicontazioneProgressivo_id = voceData.progressivo;
             api.hasdocumento.rendicontazione.search(recuperaAllegati, function (r) {
             angular.forEach(r.data, function (o) {
             idAnnullare.push(o.id);
             });
             var ii = 1;
             var aggiornatitutti = false;
             for (ii = 1; ii <= idAnnullare.length; ii++) {
             console.log("ii: ", ii);
             var updatecompletati = 0;
             var updateJson = {};
             updateJson.id = idAnnullare[ii - 1];
             updateJson.progettoRendicontazioneProgressivo_id = 0;
             updateJson.visibile = 0;
             api.hasdocumento.rendicontaziones.update(updateJson, function (u) {
             updatecompletati++;

             if (updatecompletati == idAnnullare.length) {
             saveRendicontazione(1);
             }
             });

             }

             });

             }
             });
             */

        }

        vm.salvaFile = function (data) {
            console.log(data);
            var upload = null;
            upload.progettoRendicontazione_id = data.file;
            upload.progettoRendicontazioneProgressivo_id = data.file;
            upload.file = data.file;
        }

        function openVoceRegistroSpeseDialog(data, tipo) {
            //se è 0 una nuova voce
            console.log("stoproprioqui:", data);
            console.log(vm.datiRendicontazione.jsonData.items);

            if (data[0].value === 0) {
                if (vm.datiRendicontazione.jsonData.items) {
                    //data[0].value = Number(vm.datiRendicontazione.jsonData.items.length) + 1;
                    var max = 0;
                    angular.forEach(vm.datiRendicontazione.jsonData.items, function (it) {
                        if (max < it[0].value) {
                            max = it[0].value;
                        }
                    });
                    max = max + 1;
                    data[0].value = max;

                } else {
                    data[0].value = 1;
                }
            }
            //console.log("stoqui");
            //console.log(data);
            var DatiVoceRendicontazione = angular.copy(data);
            DatiVoceRendicontazione.push({id: "azione", value: tipo});
            DatiVoceRendicontazione.push({id: "rid", value: vm.datiRendicontazione.id});


            $mdDialog.show({
                controller: 'DialogVoceRegistroSpeseController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/voceRegistroSpese-dialog.html',
                //                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    bindToController: true,
                    CodiciSpesaPreventivo: vm.codiciSpesaPreventivo,
                    tipoPagamento: vm.tipoPagamento,
                    naturaDocumento: vm.naturaDocumento,
                    SalvaVoceRendicontazione: vm.salvaVoceRendicontazione,
                    DatiVoceRendicontazione: DatiVoceRendicontazione,
                }
            });

        }

        function uploadDocumentoVoceSpesa(progressivoFile) {

            if (!progressivoFile) {
                return false;
            }

            api.documentotipos.documentotipo.search({
                gruppo: "RENDICONTAZIONE"
            }, function (res) {

                //                console.log(res);
                vm.tipiFile = res.data;
                $mdDialog.show({
                    controller: 'DialogUploadFileController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/uploadFile-dialog.html',
                    clickOutsideToClose: true,
                    locals: {
                        bindToController: true,
                        progressivoFile: progressivoFile,
                        rendicontazioneId: vm.datiRendicontazione.id,
                        tipiFile: vm.tipiFile,
                        salvaFile: vm.salvaFile
                    }
                });
            });

            //            var tipoDocumento = 1;
            //            var idRendicontazione = vm;
            //             console.log(progressivoFile);
            //             console.log(vm.datiRendicontazione.id);


        }

    }

    function DialogMessaggisticaController($scope, $state, $mdDialog, api, locals) {
        var vm = this;
        vm.isAdmin = api.isAdmin;
        vm.isReadOnly = api.isReadOnly;
        vm.api = api;
        console.log("DialogMessaggisticaController");
        vm.locals = locals;
        vm.registerdata = angular.copy(locals);
        vm.registerdata.datanuovomessaggio = moment(new Date()).format("DD/MM/YYYY");
        vm.registerdata.doit = false;

        vm.salvamessaggio = salvamessaggio;
        function salvamessaggio() {
            vm.registerdata.doit = true;
//            if (angular.isUndefined(vm.registerdata.nuovomessaggio)) {
//                vm.registerdata.doit = false;
//            }
            $mdDialog.hide(vm.registerdata);
        }

        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide(vm.registerdata);
        }

    }
    //creo una direttiva per la formattazione dei campi mediante il comando blurCurrency

    //direttiva marco in produzione: tolta dopo avere verificato le interferenze dei vecchi file con i nuovi
    /*
     (function () {

     'use strict';

     function blurCurrency($filter) {

     function link(scope, el, attrs, ngModelCtrl) {

     function formatter(value) {
     if (value.indexOf(",") > -1 && value.indexOf(".") > -1) {
     value = value.replace(".", "");
     value = value.replace(".", "");
     value = value.replace(".", "");
     value = value.replace(".", "");
     }
     value = value.replace(",", ".");
     value = value.toString().replace(/[^0-9._-]/g, '');
     value = parseFloat(value);
     var formattedValue = value + ' €';
     //var formattedValue = $filter('currency')(value).toLocaleString("it-IT");
     el.val(formattedValue);

     ngModelCtrl.$setViewValue(value);
     if (!scope.$$phase || !scope.$root.$$phase) {
     scope.$apply();
     }

     return formattedValue;
     }
     ngModelCtrl.$formatters.push(formatter);

     el.bind('focus', function () {
     el.val('');
     });

     el.bind('blur', function () {
     formatter(el.val());
     });
     }

     return {
     require: '^ngModel',
     scope: true,
     link: link
     };
     }
     blurCurrency.$inject = ['$filter'];

     angular
     .module('app.sprardb.rendicontazioni')
     .directive('blurCurrency', blurCurrency);

     })();
     */

    //Direttiva per la formattazione dei campi mediante il comando blurCurrency: recuperata 18/10/2018

    (function () {

        'use strict';

        function blurCurrency($filter) {

            function link(scope, el, attrs, ngModelCtrl) {

                function formatter(value) {
                    value = value ? parseFloat(value.toString().replace(/[^0-9._-]/g, '')) || 0 : 0;
                    var formattedValue = $filter('currency')(value).toLocaleString("it-IT");
                    el.val(formattedValue);

                    ngModelCtrl.$setViewValue(value);
                    if (!scope.$$phase || !scope.$root.$$phase) {
                        scope.$apply();
                    }

                    return formattedValue;
                }
                ngModelCtrl.$formatters.push(formatter);

                el.bind('focus', function () {
                    el.val('');
                });

                el.bind('blur', function () {
                    formatter(el.val());
                });
            }

            return {
                require: '^ngModel',
                scope: true,
                link: link
            };
        }
        blurCurrency.$inject = ['$filter'];

        angular
                .module('app.sprardb.rendicontazioni')
                .directive('blurCurrency', blurCurrency);

    })();


    function DialogVoceRegistroSpeseController($scope, $mdDialog, CodiciSpesaPreventivo, tipoPagamento, naturaDocumento, SalvaVoceRendicontazione, DatiVoceRendicontazione) {
        var vmd = this;
        vmd.selected = {};
        vmd.codiciSpesaPreventivo = CodiciSpesaPreventivo;
        vmd.tipoPagamento = tipoPagamento;
        vmd.naturaDocumento = naturaDocumento;
        //console.log("quisto");
        //console.log(vmd.codiciSpesaPreventivo);
        //console.log(vmd.tipoPagamento);


        vmd.datiVoceRendicontazione = DatiVoceRendicontazione;
        //Registro le variabili di data con il formato appropriato
        console.log("dativocerendicontazionecheck", vmd.datiVoceRendicontazione);
        if (vmd.datiVoceRendicontazione[12].value == undefined) {
            vmd.datiVoceRendicontazione[12].value = 1;
        }
        if (vmd.datiVoceRendicontazione[5].value == "") {
            vmd.datiVoceRendicontazione[5].value = new Date();
        }

        if (vmd.datiVoceRendicontazione[2].value == "") {
            vmd.datiVoceRendicontazione[2].value = new Date();
        }
        vmd.datiVoceRendicontazione[2].value = new Date(vmd.datiVoceRendicontazione[2].value);

        if (vmd.datiVoceRendicontazione[5].value !== null) {
            vmd.datiVoceRendicontazione[5].value = new Date(vmd.datiVoceRendicontazione[5].value);
        }
        $scope.hide = function () {
            $mdDialog.hide();
        };
        console.log("datiVociDettaglio", vmd.datiVoceRendicontazione);
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        vmd.salvaVoceRendicontazione = function () {
            $mdDialog.cancel();
            SalvaVoceRendicontazione(vmd.datiVoceRendicontazione);
        };
    }

    function DialogUploadFileController($scope, $mdDialog, progressivoFile, rendicontazioneId, tipiFile, salvaFile) {
        var vmd = this;
        vmd.selected = {};
        vmd.progressivoFile = progressivoFile;
        vmd.rendicontazioneId = rendicontazioneId;
        vmd.tipiFile = tipiFile;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        vmd.salvaFile = salvaFile;
    }

    function filterTipo() {
        return function (input, dictionary) {

            if (!dictionary) {
                return input;
            }

            var output = "";
            dictionary.data.forEach(function (value, key) {

                if (value.id == input) {
                    output = value.descrizione;
                }
            });
            return output;
        }
    }

    function Fileread() {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.rendicontazioni')
            .controller('RendicontazioniProgettoController', RendicontazioneProgettoController)

            .filter('filterTipo', filterTipo);

    /** @ngInject */

    function RendicontazioneProgettoController($state, api, $scope, $stateParams, $q, rendicontazioniUtility)
    {
        var vm = this;
        vm.gotoRendicontazione = gotoRendicontazione;
        vm.backToRendicontazioni = backToRendicontazioni;

        var date = new Date();
        vm.setupId = null;
        vm.oggi = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

        vm.cambiaAnnoSetup = cambiaAnnoSetup;
        vm.checkAnnoRendicontazione = checkAnnoRendicontazione;
        vm.checkParametriRendicontazione = checkParametriRendicontazione;
        vm.disableBtnNuovoPreventivo = disableBtnNuovoPreventivo;
        vm.disableBtnNuovoSAL = disableBtnNuovoSAL;
        vm.disableBtnNuovaRimodulazione = disableBtnNuovaRimodulazione;
        vm.disableBtnNuovaRendicontazione = disableBtnNuovaRendicontazione;
        vm.getTotal = rendicontazioniUtility.getTotal;
        vm.downloadPdf = downloadPdf;
        vm.downloadPdfSAL = downloadPdfSAL;

        /***
         $q.all([
         api.progettos.progetto.get({id: $stateParams.projectId}),
         api.rendicontaziones.stati.get(),
         api.rendicontaziones.tipi.get(),
         ]).then(function(data){
         vm.progetto = data[0];
         vm.rendicontazioniStati = data[1];
         vm.rendicontazioniTipi = data[2];
         });
         ***/

        api.progettos.progetto.get({id: $stateParams.projectId}, function (res) {
            vm.progetto = res;
        });
        api.rendicontaziones.stati.get(function (res) {
            vm.rendicontazioniStati = res;
        });
        api.rendicontaziones.tipi.get(function (res) {
            vm.rendicontazioniTipi = res;
        });

        function cambiaAnnoSetup() {
            api.rendicontaziones.progettoParametriRendicontazione.search({progetto_id: $stateParams.projectId, setupId: vm.setupId}, function (setupAttuale)
            {
                vm.setupAttuale = setupAttuale.data[0];
            });
        }

        function gotoRendicontazione(idRendicontazione)
        {
            $state.go('app.sprardb_rendicontazioni_rendicontazione', {id: idRendicontazione});
        }

        function checkParametriRendicontazione()
        {
            if (vm.progetto)
            {
                // monosetup
                // if (!vm.progetto.progettoparametrirendicontaziones)
                if (!vm.setupAttuale)
                    return false;
                else
                    return true;
            }
            return false;
        }

        function checkAnnoRendicontazione(data, tipoRendicontazione)
        {
            var output = false;
            data.forEach(function (value, key) {
                if (value.progettoRendicontazioneTipo_id == tipoRendicontazione && value.setupId == vm.setupId)
                {
                    output = true;
                }
            });
            return output;
        }



        function disableBtnNuovoPreventivo()
        {
            if (!vm.progetto)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataPreventivoInizio > vm.oggi ||
            //        vm.progetto.progettoparametrirendicontaziones.dataPreventivoFine < vm.oggi)
            //sostituisco con il confronto multisetup
            if (vm.setupAttuale.dataPreventivoInizio > vm.oggi ||
                    vm.setupAttuale.dataPreventivoFine < vm.oggi)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataPreventivoInizio == vm.progetto.progettoparametrirendicontaziones.dataPreventivoFine)
            if (vm.setupAttuale.dataPreventivoInizio == vm.setupAttuale.dataPreventivoFine)
            {
                return true;
            }
            //verifichiamo che non esista già una preventivo per l'anno corrente
            var tipoRendicontazione = 1;
            if (vm.checkAnnoRendicontazione(vm.progetto.progettorendicontaziones, tipoRendicontazione))
            {
                return true;
            }
            return false;
        }

        function disableBtnNuovaRimodulazione()
        {
            if (!vm.setupId)
            {
                return true;
            }
            if (!vm.progetto)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataRimodulazioneInizio > vm.oggi ||
            //        vm.progetto.progettoparametrirendicontaziones.dataRimodulazioneFine < vm.oggi)
            if (vm.setupAttuale.dataRimodulazioneInizio > vm.oggi ||
                    vm.setupAttuale.dataRimodulazioneFine < vm.oggi)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataRimodulazioneInizio == vm.progetto.progettoparametrirendicontaziones.dataRimodulazioneFine)
            if (vm.setupAttuale.dataRimodulazioneInizio == vm.setupAttuale.dataRimodulazioneFine)
            {
                return true;
            }
            if (vm.progetto.progettorendicontaziones.length > 0)
            {
                //verifichiamo che non esista già una rimodulazione per l'anno corrente
                var tipoRendicontazione = 2;
                if (vm.checkAnnoRendicontazione(vm.progetto.progettorendicontaziones, tipoRendicontazione))
                {
                    return true;
                }
                //ordiniamo l'array delle rendicontazioni by id rendicontazione descending
                vm.progetto.progettorendicontaziones.sort(function (a, b) {
                    return b.id - a.id
                });
                //verifichiamo che l'ultima rendicontazione sia o un preventivo in stato diverso da "Validato" oppure una rimodulazione in stato diverso da "Validato"
                if ((vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 1 || vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 2) &&
                        vm.progetto.progettorendicontaziones[0].progettoRendicontazioneStato_id != 3)
                {
                    return true;
                }
            }
            return false;
        }
        function disableBtnNuovoSAL()
        {
            if (!vm.setupId)
            {
                return true;
            }
            if (!vm.progetto)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataSALInizio > vm.oggi ||
            //        vm.progetto.progettoparametrirendicontaziones.dataSALFine < vm.oggi)
            if (vm.setupAttuale.dataSALInizio > vm.oggi ||
                    vm.setupAttuale.dataSALFine < vm.oggi)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataSALInizio == vm.progetto.progettoparametrirendicontaziones.dataSALFine)
            if (vm.setupAttuale.dataSALInizio == vm.setupAttuale.dataSALFine)
            {
                return true;
            }
            if (vm.progetto.progettorendicontaziones.length > 0)
            {
                //verifichiamo che non esista già un SAL per l'anno corrente
                var tipoRendicontazione = 4;
                if (vm.checkAnnoRendicontazione(vm.progetto.progettorendicontaziones, tipoRendicontazione))
                {
                    return true;
                }
                //ordiniamo l'array delle rendicontazioni by id rendicontazione descending
                vm.progetto.progettorendicontaziones.sort(function (a, b) {
                    return b.id - a.id
                });
                //verifichiamo che l'ultima rendicontazione sia o un preventivo in stato diverso da "Validato" oppure una rimodulazione in stato diverso da "Validato"
                if ((vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 1 || vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 4) &&
                        vm.progetto.progettorendicontaziones[0].progettoRendicontazioneStato_id != 3)
                {
                    return true;
                }
            }
            return false;
        }

        function disableBtnNuovaRendicontazione()
        {
            if (!vm.setupId)
            {
                return true;
            }
            if (!vm.progetto)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataRendicontazioneInizio > vm.oggi ||
            //        vm.progetto.progettoparametrirendicontaziones.dataRendicontazioneFine < vm.oggi)
            if (vm.setupAttuale.dataRendicontazioneInizio > vm.oggi ||
                    vm.setupAttuale.dataRendicontazioneFine < vm.oggi)
            {
                return true;
            }
            //confronto monosetup
            //if (vm.progetto.progettoparametrirendicontaziones.dataRendicontazioneInizio == vm.progetto.progettoparametrirendicontaziones.dataRendicontazioneFine)
            if (vm.setupAttuale.dataRendicontazioneInizio == vm.setupAttuale.dataRendicontazioneFine)
            {
                return true;
            }
            if (vm.progetto.progettorendicontaziones.length > 0)
            {
                //verifichiamo che non esista già una rendicontazione finale per l'anno corrente
                var tipoRendicontazione = 3;
                if (vm.checkAnnoRendicontazione(vm.progetto.progettorendicontaziones, tipoRendicontazione))
                {
                    return true;
                }
                //ordiniamo l'array delle rendicontazioni by id rendicontazione descending
                vm.progetto.progettorendicontaziones.sort(function (a, b) {
                    return b.id - a.id
                });
                //verifichiamo che l'ultima rendicontazione sia un preventivo in stato diverso da "Validato" o una rendicontazione finale
                if ((vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 1 && vm.progetto.progettorendicontaziones[0].progettoRendicontazioneStato_id != 3) ||
                        vm.progetto.progettorendicontaziones[0].progettoRendicontazioneTipo_id == 3 && vm.progetto.progettorendicontaziones[0].setupId == vm.setupId)
                {
                    return true;
                }
            }
            return false;
        }


        function backToRendicontazioni() {
            $state.go('app.sprardb_rendicontazioni');
        }

        function downloadPdf(event, rendicontazione) {
            //console.log(rendicontazione);

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;

                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaPdf();
                        });
                    } else
                    {
                        creaPdf();
                    }
                });
            });
        }

        function creaPdf() {


            var tabaledata = [];
            tabaledata.push([
                {text: 'COD.', style: 'tableHeader'},
                {text: 'DESCRIZIONE SPESA', style: 'tableHeader'},
                {text: 'IMPORTO COFINANAZIATO', style: 'tableHeader'},
                {text: 'CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                {text: 'COSTO TOTALE PROGETTO', style: 'tableHeader'}
            ]);

            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }
            if (vm.datiRendicontazioneOutput !== undefined)
            {
                vm.datiRendicontazioneOutput.jsonData.forEach(function (elements, key) {
                    var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['importoCofinanziato'] + " €";
                    var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['contributoRichiesto'] + " €";
                    var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['totale'] + " €";
                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label, style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
                //tot costi diretti
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'] + " €";
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'] + " €";
                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['totale'] + " €";
                tabaledata.push(['', {text: 'TOTALE COSTI DIRETTI', style: 'tableSubFooter'}, {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}]);
                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'] + " €";
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'] + " €";
                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['totale'] + " €";
                tabaledata.push(['', {text: 'TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)', style: 'tableSubFooter'}, {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}]);
                var docDefinition = {
                    content: [
                        {text: 'PROGETTO ' + vm.rendicontazione.progettos.nome, style: 'header'},
                        {text: '\n', style: 'header'},
                        {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'},
                        {text: 'Documento: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneTipo_id, vm.rendicontazioniTipi), style: 'headerleft'},
                        {text: 'Stato: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneStato_id, vm.rendicontazioniStati), style: 'headerleft'},
                        {text: '\n', style: 'header'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
                                body: tabaledata
                            },
                            //layout: 'lightVerticalLines'
                            layout: 'lightHorizontalLines'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 12,
                            alignment: 'right'
                        },
                        headerleft: {
                            fontSize: 12,
                            alignment: 'left'
                        },
                        demoTable: {
                            fontSize: 8,
                            margin: [0, 10, 0, 10],
                            color: 'black'

                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 8,
                            color: 'black'
                        },
                        tableSubHeader: {
                            bold: true,
                            fontSize: 10,
                            color: 'grey',
                            //background: 'grey'
                        },
                        tableSubHeaderTot: {
                            bold: true,
                            fontSize: 10,
                            color: 'grey',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tableSubFooter: {
                            bold: true,
                            fontSize: 10,
                            color: 'blue',
                            //background: 'grey'
                        },
                        tableSubFooterTot: {
                            bold: true,
                            fontSize: 10,
                            color: 'blue',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tot: {
                            alignment: 'right'
                        }
                    }
                };
                pdfMake.createPdf(docDefinition).download("rendicontazione_" + vm.rendicontazione.progettos.id + '.pdf');
            }
        }
        function downloadPdfSAL(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;


                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaPdfSAL();
                        });
                    } else
                    {
                        creaPdfSAL();
                    }
                });
            });
        }

        function creaPdfSAL() {

            console.log('i dati della rendicontazione', vm.datiRendicontazione);

            var tabaledata = [];
            tabaledata.push([
                {text: 'COD.', style: 'tableHeader'},
                //{text: 'A IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'B CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'C COSTO TOTALE PROGETTO', style: 'tableHeader'},
                //{text: 'D IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'E CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'F COSTO TOTALE PROGETTO', style: 'tableHeader'},
                //{text: 'G IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'H CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'I COSTO TOTALE PROGETTO', style: 'tableHeader'}
                {text: 'DESCRIZIONE SPESA', style: 'tableHeader'},
                {text: 'A', style: 'tableHeader'},
                {text: 'B', style: 'tableHeader'},
                {text: 'C [A+B]', style: 'tableHeader'},
                {text: 'D', style: 'tableHeader'},
                {text: 'E', style: 'tableHeader'},
                {text: 'F [D+E]', style: 'tableHeader'},
                {text: 'G', style: 'tableHeader'},
                {text: 'H', style: 'tableHeader'},
                {text: 'I [G+H]', style: 'tableHeader'},
                {text: '% (F/C)', style: 'tableHeader'},
                {text: '% (I/C)', style: 'tableHeader'}
            ]);
            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "€";
            };
            //VALERIO: Creo il metodo di formattazione della percentuale
            Number.prototype.formatPercent = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "%";
            };


            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                //inizio ciclo costi diretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json
                var costiDiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "P" | item.id == "L" | item.id == "B" | item.id == "G" | item.id == "S" | item.id == "T" | item.id == "I" | item.id == "A";
                });

                //console.log('nuovavariabile',costiDiretti);
                //vm.datiRendicontazioneOutput.jsonData=vm.datiRendicontazioneOutput.jsonData.filter(function(item){
                //return item.id=="P" | item.id=="L"| item.id=="G"| item.id=="S"| item.id=="T"| item.id=="I"| item.id=="A";
                //});

                costiDiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale2 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale3 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiesto']);
                    var totale4 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoImpegnato'];
                    var totale5 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoImpegnato'];
                    var totale6 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoImpegnato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoImpegnato']);
                    var totale7 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato'];
                    var totale8 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoQuietanziato'];
                    var totale9 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoQuietanziato']);

                    var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                    var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                    var totale1 = totale1.formatMoney(2, ',', '.');
                    var totale2 = totale2.formatMoney(2, ',', '.');
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    var totale4 = totale4.formatMoney(2, ',', '.');
                    var totale5 = totale5.formatMoney(2, ',', '.');
                    var totale6 = totale6.formatMoney(2, ',', '.');
                    var totale7 = totale7.formatMoney(2, ',', '.');
                    var totale8 = totale8.formatMoney(2, ',', '.');
                    var totale9 = totale9.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label.substring(0, 50), style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}, {text: totale4, style: 'tableSubHeaderTot'}, {text: totale5, style: 'tableSubHeaderTot'}, {text: totale6, style: 'tableSubHeaderTot'}, {text: totale7, style: 'tableSubHeaderTot'}, {text: totale8, style: 'tableSubHeaderTot'}, {text: totale9, style: 'tableSubHeaderTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiDiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([
                            items.id,
                            items.label.substring(0, 50),
                            {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[0].value) + (items.fields[1].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[2].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[3].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[2].value) + (items.fields[3].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[4].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[5].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[4].value) + (items.fields[5].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[2].value) + (items.fields[3].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[4].value) + (items.fields[5].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'}
                        ]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
                console.log("tabaletabale", tabaledata);
//fine ciclo costi diretti
                //tot costi diretti

                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'];
                var totale3 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto']);
                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoImpegnato'];
                var totale6 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoImpegnato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoImpegnato']);
                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoQuietanziato'];
                var totale9 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoQuietanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoQuietanziato']);

                var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                tabaledata.push([{text: 'Costi diretti', style: 'tableSubFooter'}, '', {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}, {text: totale4, style: 'tableSubFooterTot'}, {text: totale5, style: 'tableSubFooterTot'}, {text: totale6, style: 'tableSubFooterTot'}, {text: totale7, style: 'tableSubFooterTot'}, {text: totale8, style: 'tableSubFooterTot'}, {text: totale9, style: 'tableSubFooterTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                //inizio ciclo costi indiretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json

                //spezzo
                var costiIndiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "Ci";
                });
                costiIndiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale2 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale3 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiesto']);
                    var totale4 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoImpegnato'];
                    var totale5 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoImpegnato'];
                    var totale6 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoImpegnato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoImpegnato']);
                    var totale7 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato'];
                    var totale8 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoQuietanziato'];
                    var totale9 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoQuietanziato']);

                    var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                    var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                    var totale1 = totale1.formatMoney(2, ',', '.');
                    var totale2 = totale2.formatMoney(2, ',', '.');
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    var totale4 = totale4.formatMoney(2, ',', '.');
                    var totale5 = totale5.formatMoney(2, ',', '.');
                    var totale6 = totale6.formatMoney(2, ',', '.');
                    var totale7 = totale7.formatMoney(2, ',', '.');
                    var totale8 = totale8.formatMoney(2, ',', '.');
                    var totale9 = totale9.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label.substring(0, 50), style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}, {text: totale4, style: 'tableSubHeaderTot'}, {text: totale5, style: 'tableSubHeaderTot'}, {text: totale6, style: 'tableSubHeaderTot'}, {text: totale7, style: 'tableSubHeaderTot'}, {text: totale8, style: 'tableSubHeaderTot'}, {text: totale9, style: 'tableSubHeaderTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiIndiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([
                            items.id,
                            items.label.substring(0, 50),
                            {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[0].value) + (items.fields[1].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[2].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[3].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[2].value) + (items.fields[3].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[4].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[5].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[4].value) + (items.fields[5].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[2].value) + (items.fields[3].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[4].value) + (items.fields[5].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'}
                        ]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
//fine ciclo costi indiretti
                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'];
                var totale3 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto']);
                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoImpegnato'];
                var totale6 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoImpegnato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoImpegnato']);
                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoQuietanziato'];
                var totale9 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoQuietanziato']);

                var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                tabaledata.push([{text: 'Totale', style: 'tableSubFooter'}, '', {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}
                    , {text: totale4, style: 'tableSubFooterTot'}, {text: totale5, style: 'tableSubFooterTot'}, {text: totale6, style: 'tableSubFooterTot'}
                    , {text: totale7, style: 'tableSubFooterTot'}, {text: totale8, style: 'tableSubFooterTot'}, {text: totale9, style: 'tableSubFooterTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}
                ]);

                var docDefinition = {
                    // a string or { width: number, height: number }
                    pageSize: 'A4',
                    // by default we use portrait, you can change it to landscape if you wish
                    pageOrientation: 'landscape',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [30, 30, 30, 30],
                    content: [
                        {text: 'PROGETTO ' + vm.rendicontazione.progettos.nome, style: 'header'},
                        {text: '\n'},
                        {text: 'cod. ' + vm.datiRendicontazione.codiceProgetto},
                        {text: '\n'},
                        {text: 'Bando: ' + vm.datiRendicontazione.progettos.bandos[0].descrizione},
                        {text: '\n', style: 'header'},
                        {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'},
                        {text: 'Documento: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneTipo_id, vm.rendicontazioniTipi), style: 'headerleft'},
                        {text: 'Stato: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneStato_id, vm.rendicontazioniStati), style: 'headerleft'},
                        {text: '\n', style: 'headerleft'},
                        {text: 'GRUPPO PREVENTIVO', style: 'dida'},
                        {text: 'A: IMPORTO COFINANZIATO | B: CONTRIBUTO RICHIESTO | C: COSTO TOTALE PROGETTO', style: 'dida'},
                        {text: '\n', style: 'dida'},
                        {text: 'GRUPPO SOMME IMPEGNATE', style: 'dida'},
                        {text: 'D: IMPORTO COFINANZIATO impegnato | E: CONTRIBUTO RICHIESTO impegnato | F: COSTO TOTALE PROGETTO impegnato', style: 'dida'},
                        {text: '\n', style: 'dida'},
                        {text: 'GRUPPO SOMME QUIETANZATE', style: 'dida'},
                        {text: 'G: IMPORTO COFINANZIATO quietanzato | H: CONTRIBUTO RICHIESTO quietanzato | I: COSTO TOTALE PROGETTO quietanzato', style: 'dida'},
                        {text: '\n', style: 'header'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                body: tabaledata
                            },
                            //layout: 'lightVerticalLines'
                            layout: 'lightHorizontalLines'
                        },
                        {text: '\n', style: 'header'},
                        {text: '\n', style: 'header'},
                        {text: '\n', style: 'header'},
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 7.5,
                            alignment: 'right'
                        },
                        headerleft: {
                            fontSize: 7.5,
                            alignment: 'left'
                        },
                        demoTable: {
                            fontSize: 7.5,
                            margin: [0, 10, 0, 10],
                            color: 'black'

                        },
                        dida: {
                            fontSize: 7.5,
                            alignment: 'left'
                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'black'
                        },
                        tableSubHeader: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'grey',
                            //background: 'grey'
                        },
                        tableSubHeaderTot: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'grey',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tableSubFooter: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'blue',
                            //background: 'grey'
                        },
                        tableSubFooterTot: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'blue',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tot: {
                            alignment: 'right'
                        }
                    }

                };
                pdfMake.createPdf(docDefinition).download("rendicontazione_" + vm.rendicontazione.progettos.id + '.pdf');
                //console.log("quisto");
                //console.log(docDefinition);
            }

        }

        function decodeTipo(input, dictionary)
        {
            var output = "";
            dictionary.data.forEach(function (value, key) {
                if (value.id == input)
                {
                    output = value.descrizione;
                }
            });
            return output;
        }
        function elaboraResocontoRendicontazioneFinale(model) {

            //console.log(vm.datiRendicontazione);
            vm.datiRendicontazione.jsonData.items.forEach(function (key) {
                var codiceSpesa = key[6].value;

                model.forEach(function (key2) {
                    key2.items.forEach(function (key3) {
                        if (key3.id == codiceSpesa) {

                            key3.fields[0].value = Number(key3.fields[0].value) + Number(key[9].value);
                            key3.fields[1].value = Number(key3.fields[1].value) + Number(key[10].value);

                        }
                    });
                });
            });

            return model;
        }
        ;

    }


    function filterTipo()
    {
        return function (input, dictionary) {
            var output = "";
            dictionary.data.forEach(function (value, key) {
                if (value.id == input)
                {
                    output = value.descrizione;
                }
            });
            return output;
        }
    }






})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.proroghe', ['flow'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_proroghe', {
                    url: '/sprardb/proroghe',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/proroghe.html',
                            controller: 'ProrogheController as vm'
                        },
                    }

                })
                .state('app.sprardb_proroga', {
                    url: '/sprardb/proroga/:id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/dettaglio/dettaglioProroga.html',
                            controller: 'DettaglioProrogaController as vm'
                        }
                    }
                })
                .state('app.prorogarichiesta', {
                    url: '/sprardb/prorogarichiesta/:eventoTipo_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/prorogherichieste.html',
                            controller: 'EventisController as vm'
                        }
                    }

                })
                .state('app.richiestecompletare', {
                    url: '/sprardb/richiestecompletare/:eventoTipo_id/:eventoStato_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/prorogherichieste.html',
                            controller: 'EventisController as vm'
                        }
                    },
                    datas: {
                      titolo:'Proroghe da completare',
                      statoiniziale: ["1"]
                    }

                })
                .state('app.richiesteautorizzare', {
                    url: '/sprardb/richiesteautorizzare/:eventoTipo_id/:eventoStato_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/prorogherichieste.html',
                            controller: 'EventisController as vm'
                        }
                    },
                    datas: {
                      titolo:'Proroghe da lavorare',
                      statoiniziale: ["3"]
                    }

                })
                .state('app.prorogheautorizzate', {
                    url: '/sprardb/prorogheautorizzate/:eventoTipo_id/:eventoStato_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/prorogherichieste.html',
                            controller: 'EventisController as vm'
                        }
                    },
                    datas: {
                      titolo:'Proroghe autorizzate',
                      statoiniziale: ["4"]
                    }

                })
                .state('app.prorogherifiutate', {
                    url: '/sprardb/prorogherifiutate/:eventoTipo_id/:eventoStato_id',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/proroghe/prorogherichieste.html',
                            controller: 'EventisController as vm'
                        }
                    },
                    datas: {
                      titolo:'Proroghe rifiutate',
                      statoiniziale: ["5"]
                    }

                })
                ;


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

        /*

         msNavigationServiceProvider.saveItem('scadmin.proroga', {
         title: 'Proroghe',
         weight: 40
         });
         msNavigationServiceProvider.saveItem('scadmin.proroga.richiestecompletare', {
         title: 'da completare',
         icon: 'icon-timelapse',
         state: 'app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.proroga.richiesteautorizzare', {
         title: 'Da Autorizzare',
         icon: 'icon-calendar-clock',
         state: 'app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('scadmin.proroga.prorogheautorizzate', {
         title: 'Autorizzate',
         icon: 'icon-thumb-up-outline',
         state: 'app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('scadmin.proroga.prorogherifiutate', {
         title: 'Rifiutate',
         icon: 'icon-thumb-down-outline',
         state: 'app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('scadmin.proroga.ricercaproroga', {
         title: 'Ricerca',
         icon: 'icon-file-find',
         state: 'app.sprardb_proroghe',
         weight: 6
         });
         */

        /*
         msNavigationServiceProvider.saveItem('properatore.proroga', {
         title: 'Proroga',
         weight: 40
         });
         msNavigationServiceProvider.saveItem('properatore.proroga.richiestecompletare', {
         title: 'da completare',
         icon: 'icon-timelapse',
         state: 'app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('properatore.proroga.richiesteautorizzare', {
         title: 'Pendenti',
         icon: 'icon-calendar-clock',
         state: 'app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('properatore.proroga.prorogheautorizzate', {
         title: 'Autorizzate',
         icon: 'icon-thumb-up-outline',
         state: 'app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('properatore.proroga.prorogherifiutate', {
         title: 'Rifiutate',
         icon: 'icon-thumb-down-outline',
         state: 'app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})',
         weight: 4
         });
         msNavigationServiceProvider.saveItem('properatore.proroga.ricercaproroga', {
         title: 'Ricerca',
         icon: 'icon-file-find',
         state: 'app.sprardb_proroghe',
         weight: 6
         });
         */

    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.proroghe')
    .controller('ProrogheShowController', ['eventi', '$mdDialog', '$scope', ProrogheShowController]);

  /** @ngInject */
  function ProrogheShowController(eventi, $mdDialog, $scope)
  {
    var vmd = this;

    vmd.cancelDialog = function() {$mdDialog.cancel()}
    vmd.lavoraProroga = lavoraProroga;
    vmd.viewEvento = eventi.viewDetails;

    vmd.colors = eventi.colors2;

    vmd.beneficiario.proroghe.forEach(function(proroga) {
      if (typeof proroga.extra === "string") {
        proroga.extra = JSON.parse(proroga.extra);
      }
    })

    function lavoraProroga(model, action, event)
    {
      $mdDialog.show({
        controller: 'ProrogaDialogController',
        controllerAs: 'vmd',
        bindToController: true,
        templateUrl: 'app/main/sprardb/proroghe/dialogs/proroga.dialog.html',
        clickOutsideToClose: false,
        targetEvent: event,
        locals: {
          action: action,
          model: model,
          showDialogPromise: vmd.showDialogPromise
        }
      }).then(vmd.showDialogPromise.resolve);
    }
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.proroghe')
    .controller('ProrogaDialogController', ['ricerca', '$mdDialog', 'api', '$mdToast', 'proroghe','$state', ProrogaDialogController]);

  /** @ngInject */
  function ProrogaDialogController(ricerca, $mdDialog, api, $mdToast, proroghe,$state) {
    var vmd = this;

    //vmd.action è una tra conferma|approva|rifiuta

    vmd.cancelDialog = cancelDialog;
    vmd.isEligible = proroghe.isEligible;
    vmd.lavora = lavora;
    vmd.salva = salva;

    vmd.altriBeneficiari = {};
    vmd.eventoIds = {};
    vmd.mesi = [1, 2, 3, 4, 5, 6];
    vmd.proroga = {};
    vmd.isNew = true;
    vmd.ricerca = ricerca;
    vmd.userInfo = api.userlogged;
    vmd.userCan = api.user.can;

    if (vmd.model.codice) { //model è un beneficiario: nuova proroga
      vmd.beneficiario = vmd.model
      vmd.proroga.entita1_id = vmd.beneficiario.id;
      vmd.proroga.nomeOperatore = vmd.userInfo.nome;
      vmd.proroga.cognomeOperatore = vmd.userInfo.cognome;
      vmd.proroga.emailOperatore = vmd.userInfo.email;
      vmd.proroga.telefonoOperatore = vmd.userInfo.telefono;
      vmd.proroga.actions = ['update', 'conferma'];
    } else { //model è un evento di proroga
      const beneficiarioAttributes = ['id', 'codice', 'nome', 'cognome', 'parentela', 'progetto.nome'];
      let params = {
        id: vmd.model.id,
        expand: 'b.parentela,b.parenti.parentela,parenti.b.parentela,entita1,eventoTipo,eventoStato,parenti',
        fields: '*,parenti.id,' + api.fields('b', beneficiarioAttributes)
          + ',' + api.fields('parenti.b', beneficiarioAttributes)
          + ',' + api.fields('b.parenti', beneficiarioAttributes)
      };

      vmd.proroga = api.proroga.get(params, function (res) {
        vmd.model = res;
        vmd.beneficiario = res.b;
        vmd.isNew = false;
        initAltriBeneficiari(res);
      });
    }

    function cancelDialog() {
      if (vmd.dataChanged) {
        $mdDialog.hide();
      } else {
        $mdDialog.cancel();
      }
      vmd.dataChanged = false;
    }

    function getExtraIds(altriModel) {
      const ids = Object.keys(altriModel)
      return ids.filter(function (id) {
        return altriModel[id];
      })
    }

    function initAltriBeneficiari(res) {
      if (vmd.action === 'conferma') {
        res.parenti = res.b.parenti;
        res.altriBenIds.forEach(function (v) {
          vmd.altriBeneficiari[v] = true
        });
      } else {
        res.parenti.forEach(function (proroga) {
          vmd.eventoIds[proroga.id] = true;
        })
      }
    }

    function lavora() {
      if (vmd.action === 'conferma' && vmd.isNew) {
        vmd.proroga.altriBenIds = getExtraIds(vmd.altriBeneficiari);
        vmd.proroga.nomeOperatore = vmd.userInfo.nome;
        vmd.proroga.cognomeOperatore = vmd.userInfo.cognome;
        vmd.proroga.emailOperatore = vmd.userInfo.email;
        vmd.proroga.telefonoOperatore = vmd.userInfo.telefono;
        console.log(vmd.proroga.altriBenIds);
        if (vmd.model.parenti.length > 0 && vmd.proroga.altriBenIds.length === 0) {
          var confirm = $mdDialog.confirm()
            .title('Conferma richiesta proroga singola')
            .htmlContent('Il beneficiario appartiene a un nucleo familiare, se si conferma la richiesta sarà inviata SOLO per questo beneficiario.<br>' +
              'Qualora sia necessario richiedere la proroga per altri componenti del nucleo familiare, prima della conferma spuntare i codici interessati.')
            .ok('CONFERMA')
            .cancel('ANNULLA');

          $mdDialog.show(confirm).then(callLavora, function(cancel) {
            salva().finally(vmd.showDialogPromise.resolve);
          });
          return;
        }
      } else {
        vmd.proroga.eventoIds = getExtraIds(vmd.eventoIds);
      }

      callLavora();
    }

    function callLavora()
    {
      api.proroga[vmd.action](vmd.proroga, getResponseHandler(vmd.action));
    }

    function salva()
    {
      vmd.proroga.altriBenIds = getExtraIds(vmd.altriBeneficiari);
      vmd.proroga.nomeOperatore = vmd.userInfo.nome;
      vmd.proroga.cognomeOperatore = vmd.userInfo.cognome;
      vmd.proroga.emailOperatore = vmd.userInfo.email;
      vmd.proroga.telefonoOperatore = vmd.userInfo.telefono;
      console.log(vmd.proroga.userInfo);
      vmd.proroga = api.proroga.save(vmd.proroga, function(res) {
        initAltriBeneficiari(res);
        vmd.dataChanged = true;
        $mdToast.show($mdToast.simple()
          .textContent('Informazioni salvate.')
          .position('bottom right')
          .hideDelay(3000));
      });

      vmd.proroga.$promise.finally(function() {
        vmd.prorogaForm.$setPristine();
        vmd.prorogaForm.$setUntouched();
      })

      return vmd.proroga.$promise;
    }


    // Funzione per eliminare la proroga
    vmd.eliminaProroga = function() {
      var confirm = $mdDialog.confirm()
        .title('Conferma eliminazione proroga')
        .textContent('Sei sicuro di voler eliminare questa proroga?')
        .ok('Elimina')
        .cancel('Annulla');

      $mdDialog.show(confirm).then(function() {
        api.proroga.delete({ id: vmd.proroga.id }, function(response) {
          $mdToast.show($mdToast.simple()
          .textContent('Proroga Eliminata.')
          .position('bottom right')
          .hideDelay(3000));
          $mdDialog.hide();
          $state.reload();
        }, function(error) {
          console.error('Errore durante l\'eliminazione della proroga:', error);
        });
      });
    };



    function getResponseHandler(azione)
    {
      return function(res) {
        const n = res.numProrogheLavorate;
        const msg = (n > 1 ? `${n} richieste` : 'Richiesta') + ' di proroga ' + `${azione}` + (n > 1 ? 'te.' : 'ta.');

        $mdToast.show($mdToast.simple()
          .textContent(msg)
          .position('bottom right')
          .hideDelay(3000));
        if (vmd.showDialogPromise) {
          vmd.showDialogPromise.resolve();
        }
        return $mdDialog.hide(res);
      }
    }

  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.beneficiari')
            .controller('DettaglioProrogaController', DettaglioProrogaController)
            .filter('filterByArray', filterByArray);

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    /** @ngInject */
    function DettaglioProrogaController($state, $document, $filter, api, msUtils, $mdDialog, eventi, acl, ricerca, $mdToast)
    {
        console.log("DettaglioProrogaController");
        var vm = this;
        vm.isallowed = acl.isallowed2;

        vm.activeFilter = {};
        vm.activeFilter.tipo = [];
        vm.activeFilter.stato = [];
        vm.letteraTrasf = eventi.letteraTrasf;
        vm.toggleFilter = function (datas, tipo) {
            //console.log(datas);
            //console.log(tipo);
            angular.forEach(datas, function (data) {
                var found = vm.activeFilter[tipo].indexOf(data);

                if (found >= 0) {
                    vm.activeFilter[tipo].splice(found, 1);
                } else {
                    vm.activeFilter[tipo].push(data);
                }
            });
        };
        vm.options = ricerca.options;
        vm.selected = ricerca.selected;
        vm.limitOptions = ricerca.limitOptions;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.exallsearchs = ricerca.begin_allsearchs();
        vm.attallsearchs = ricerca.begin_allsearchs();
        vm.beneficiario_id = $state.params.id;

        vm.tabellastrutture = [
            {
                etichetta: "#",
                campo: ['id'],
                mdorderby: "id",
                style: "text-align: center;"

            }, {
                etichetta: "struttura",
                mdorderby: "nome",
                campo: ['nome', 'progettos.nome'],
                b: true

            }, {
                etichetta: "ubicazione",
                mdorderby: "indirizzo",
                campo: ['indirizzo', 'istats.comune', 'istats.provincia'],
                icona: null

            }, {
                etichetta: "tipologia",
                campo: ['strutturaAccoglienzas.descrizione', 'strutturaAlloggios.descrizione']

            }, {
                etichetta: "attivo",
                campo: ['attivo'],
                mdorderby: "attivo",
                icona: {'0': 'icon-bookmark-outline', '1': 'icon-bookmark-check'}

            }, {
                etichetta: "posti",
                mdorderby: "numeroPosti",
                campo: ['numeroPosti']
            }, {
                etichetta: "stanze",
                mdorderby: "numeroStanze",
                campo: ['numeroStanze']
            }, {
                etichetta: "s.igien",
                mdorderby: "numeroIgienici",
                campo: ['numeroIgienici']
            }, {
                a: true,
                bottoni: [{
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxx",
                        ngclick: "",
                        uisref: "app.sprardb_progetti_strutture_struttura",
                        ngif: true
                    }, {
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxxu",
                        ngclick: function click() {
                            console.log("click");
                        },
                        uisref: "",
                        ngif: false
                    }]
            }
        ];
        vm.click = click;
        function click() {
            console.log("click");
        }

        vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005], stato: [1, 3, 5, 10, 11, 15]};
        //vm.arraydocumenti = {tipo: [2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030], stato: [1]};
        vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2999], stato: [1]};
        vm.arrayproroga = {tipo: [1011], stato: [1, 3, 4]};
        vm.arrayuscita = {tipo: [1010], stato: [1]};
        vm.arrayallontanamento = {tipo: [1012], stato: [1, 3]};
        vm.arraytrasferimento = {tipo: [1013, 1014], stato: [1, 2, 3]};

        //poi verranno ricaricati quando carico beneficiario
        vm.newprocess = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
            titolo: "Nuovo evento"
        };
        vm.sg = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
            titolo: "Nuovo status giuridico"
        };
        vm.acc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
            titolo: "Nuova proroga"
        };
        vm.uscita = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
            titolo: "Nuova uscita"
        };
        vm.newpro = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
            titolo: "Nuova proroga"
        };
        vm.newdoc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
            titolo: "Aggiungi/rinnova documento"
        };
        vm.newtrasf = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento"
        };
        vm.newall = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
            titolo: "Nuovo allontanamento"
        };
//fine sprar new process
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.Beneficiario = {};//Beneficiario;
        vm.beneficiario = {};//angular.copy(Beneficiario.data[0])
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoDocumento = null;
        vm.tipoIngresso = null;
        vm.stato = null;
        vm.uploadParams = {
            documentoTipo_id: 0,
            gruppo: 'BENEFICIARIO',
            dettaglio: true,
            entita: 'beneficiario',
            entitakey: 'beneficiario_id'
        };
        vm.uploadParams.beneficiario_id = vm.beneficiario_id;
        vm.uploadParams.entita_id = vm.beneficiario_id;

        vm.viewEvento = eventi.viewDetails;
        vm.colors = eventi.colors;
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;

        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "200", sort: "descrizione"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "50", sort: "descrizione"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", sort: "ordinamento,descrizione"}, function (response) {
            vm.tipoDocumento = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.tipoIngresso = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "STATO", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.stato = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "TIPO-PROTEZIONE", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.tipoProteziones = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "PARENTELA", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.parentelas = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "VULNERABILITA", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.vulnerabilitas = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.ingressos = response.data;
        });
        api.entes.ente.cerca({enteTipo_id: "7", pagination: "200", sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
            vm.enteDocumentoids = response.data;
        });

        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.vulnerabilita();

        vm.sino = ricerca.sino;
        vm.provenienza = ricerca.provenienza;
        vm.dublino = ricerca.dublino;
        vm.iTipoDocumento = [{descrizione: "PASSAPORTO"}, {descrizione: "CARTA IDENTITA"}, {descrizione: "ALTRO"}];
        vm.iLuogoDocumento = [{descrizione: "PAESE ORIGINE"}, {descrizione: "ITALIA"}, {descrizione: "ALTRO"}];
        vm.iModalitaAccertamento = [{descrizione: "COLLOQUIO"}, {descrizione: "ACCERTAMENTO"}, {descrizione: "ALTRO"}];
        vm.iQualifica = [{descrizione: "SINDACO"}, {descrizione: "ASSESSORE"}, {descrizione: "DIRIGENTE"}, {descrizione: "ASSISTENTE SOCIALE"}, {descrizione: "AVVOCATO"}, {descrizione: "TUTORE VOLONTARIO"}, {descrizione: "ALTRO"}];

        vm.isnew = false;
        vm.evento = 'update';
        var searchpayload = {};
        searchpayload = {id: vm.beneficiario_id};
        vm.beneficiario.eventostatusgs = [];
        vm.beneficiario.eventoprorogas = [];
        vm.beneficiario.eventouscitas = [];
        vm.beneficiario.eventotrasferimentos = [];
        vm.beneficiario.eventoallontanamentos = [];
        vm.beneficiario.eventodocumentos = [];
        vm.beneficiario.eventoAstatusgs = [];
        vm.beneficiario.eventoAprorogas = [];
        vm.beneficiario.eventoAuscitas = [];
        vm.beneficiario.eventoAtrasferimentos = [];
        vm.beneficiario.eventoAallontanamentos = [];
        vm.beneficiario.eventoAdocumentos = [];
//carica beneficiario
        vm.loadb = function () {
            api.beneficiarios.beneficiario.get(searchpayload).$promise.then(function (response) {
                vm.Beneficiario = response;
                vm.beneficiario = response;

                vm.uploadParams.beneficiario_id = vm.beneficiario.id;
                vm.uploadParams.entita_id = vm.beneficiario.id;
                vm.isnew = false;
                if (!vm.beneficiario)
                {
                    vm.beneficiario = {};
                    vm.evento = 'new';
                    vm.isnew = true;
                }

                angular.forEach(vm.beneficiario, function (value, key) {
                    if (key.toLowerCase().indexOf("data") !== -1) {
                        if (value === '0000-00-00' || value === null) {
                            vm.beneficiario[key] = null;
                        } else {
                            vm.beneficiario[key] = new Date(value);
                        }
                    }
                });

                vm.beneficiario.minore = false;
                vm.minori = false;
                vm.oggi = new Date();
                vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.maxDated = new Date((vm.oggi.getFullYear() + 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDatesafe = new Date((vm.oggi.getFullYear() - 20) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDated = new Date((vm.oggi.getFullYear() - 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.maxDatem = vm.oggi;
//                vm.beneficiario.minore = true;
//                vm.minori = true;
                if (angular.isUndefined(vm.beneficiario.segnalaziones) || vm.beneficiario.segnalaziones == null) {
                    //non ha segnalazione VECCHI
                    vm.beneficiario.segnalaziones = {};
                    vm.beneficiario.segnalaziones.idTipoSegnalazione = 0;
                }
                if (vm.beneficiario.segnalaziones.idTipoSegnalazione == 607) {
                    //tipo segnalzione = minori era un msna
                    vm.beneficiario.minore = true;
                    vm.minori = true;
                }
                if (vm.minori) {
                    vm.minDate = vm.maxDate;
                    vm.maxDate = vm.oggi;
                    //vm.arraytrasferimento = {tipo: [1013, 1014], stato: [1, 2, 3]};
                    //tipoProtezione_id che consentono la richiesta di trasferimento in struttura maggiorenni
                    var arraytipoProtezione_id_max = [590, 591, 592, 593];
                    if (arraytipoProtezione_id_max.indexOf(vm.beneficiario.tipoProtezione_id) >= 0) {
                        vm.arraytrasferimento.tipo.push(1015);
                    }
                    if (arraytipoProtezione_id_max.indexOf(vm.beneficiario.tipoProtezione_id) == -1) {
                        vm.arrayuscita.tipo.push(1016);
                    }

                }

                vm.newprocess = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
                    titolo: "Nuovo evento"
                };
                vm.sg = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
                    titolo: "Nuovo status giuridico"
                };
                vm.acc = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
                    titolo: "Nuova proroga"
                };
                vm.uscita = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
                    titolo: "Nuova uscita"
                };
                vm.newpro = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
                    titolo: "Nuova proroga"
                };
                vm.newdoc = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
                    titolo: "Aggiungi/rinnova documento"
                };
                vm.newtrasf = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
                    titolo: "Nuovo trasferimento"
                };
                vm.newall = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
                    titolo: "Nuovo allontanamento"
                };

                var counter = 0;

                vm.spliteventos = {
                    eventostatusgs: vm.arraystatus,
                    eventoprorogas: vm.arrayproroga,
                    eventouscitas: vm.arrayuscita,
                    eventotrasferimentos: vm.arraytrasferimento,
                    eventodocumentos: vm.arraydocumenti,
                    eventoallontanamentos: vm.arrayallontanamento
                };
                vm.splitAeventos = {
                    eventoAstatusgs: vm.arraystatus,
                    eventoAprorogas: vm.arrayproroga,
                    eventoAuscitas: vm.arrayuscita,
                    eventoAtrasferimentos: vm.arraytrasferimento,
                    eventoAdocumentos: vm.arraydocumenti,
                    eventoAallontanamentos: vm.arrayallontanamento
                };
                vm.beneficiario.eventostatusgs = [];
                vm.beneficiario.eventoprorogas = [];
                vm.beneficiario.eventouscitas = [];
                vm.beneficiario.eventotrasferimentos = [];
                vm.beneficiario.eventoallontanamentos = [];
                vm.beneficiario.eventodocumentos = [];
                vm.beneficiario.eventoAstatusgs = [];
                vm.beneficiario.eventoAprorogas = [];
                vm.beneficiario.eventoAuscitas = [];
                vm.beneficiario.eventoAtrasferimentos = [];
                vm.beneficiario.eventoAallontanamentos = [];
                vm.beneficiario.eventoAdocumentos = [];
                angular.forEach(vm.beneficiario.eventos, function (obj) {
                    vm.beneficiario.eventos[counter].processi = obj.eventoTipo.processo.split("|");
                    //separo processi status, documenti e proroghe, trasferimenti/uscite in 4 oggetti, solo quelli da lavorare
                    angular.forEach(vm.spliteventos, function (dati, chiave) {
                        if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && dati.stato.indexOf(obj.eventoStato_id) >= 0) {
                            //soddisfa condizioni di tipo e stato contemporaneamente
                            vm.beneficiario[chiave].push(obj);
                        }
                    });
                    angular.forEach(vm.splitAeventos, function (dati, chiave) {
                        if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0) {
                            vm.beneficiario[chiave].push(obj);
                        }
                    });
                    counter++;
                });





            });
            return vm.beneficiario;
        };
        vm.loadb();


        vm.search = {};



        vm.save = save;
        vm.completa = save;
        vm.delete = del;
        vm.closeDialog = closeDialog;
        vm.returnBeneficiari = returnBeneficiari;
        vm.openExtraDialog = openExtraDialog;
        vm.openAttributiDialog = openAttributiDialog;
        vm.cessa = cessazione;


        function save(evento) {
            console.log("isnew?:", evento);
            var beneficiario = vm.beneficiario;
            var placeholderdate = new Date("1970-01-01");
            angular.forEach(beneficiario, function (value, key) {
                console.log("valori:", value);
                if (key.toLowerCase().indexOf("data") !== -1) {
                    console.log("valori:", value);
                    console.log("valori:", new Date(value));
                    if (angular.isDate(value)) {
                        if (moment(value).format("YYYY-MM-DD") !== "1970-01-01") {
                            beneficiario[key] = moment(value).format("YYYY-MM-DD");
                        } else {
                            beneficiario[key] = null;
                        }
                    } else {
                        beneficiario[key] = null;
                    }

                }
            });
            console.log("beneficiario", beneficiario);
            if (evento) {
                api.beneficiarios.beneficiario.save(beneficiario, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Beneficiario inserito')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    $state.go('app.sprardb_beneficiari');
                });
            }
            if (!evento) {
                api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Beneficiario aggiornato')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    $state.go('app.sprardb_beneficiarii', {def: 0});
                });
            }


        }
        vm.displayextra = false;
        vm.getExtra = getExtra;
        function getExtra(path, data) {
            //console.log(path);
            var paths = path.split('.');
            var root = data;
            angular.forEach(paths, function (obj) {
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                    } catch (err) {
                    }
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }

        vm.dataoggi = new Date();
        vm.m = moment(vm.dataoggi);
        vm.dataoggistring = vm.m.format("YYYY-MM-DD");
        vm.alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Processo')
                .textContent('Operazione Confermata.')
                .ariaLabel('conferma')
                .ok('OK');
        function cessazione(id, e1, e2) {
            var confirm = $mdDialog.confirm()
                    .title('Vuoi far uscire il beneficiario?')
                    .htmlContent('Il beneficiario risulterà uscito a partire dalla data di oggi..')
                    .ariaLabel('r uscita')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function ()
            {
                api.eventos.evento.save({dataInizio: vm.dataoggistring, eventoTipo_id: 8, entita1_id: e1, eventoStato_id: 4, alert: 0}, function (response) {
                    console.log(response);
                    api.beneficiarios.beneficiario.aggiorna({id: e1, stato: 'LIBERO'}, function (response) {
                        console.log(response);
                        $mdDialog.show(vm.alert);
                        $state.reload();
                    });
                });
            }, function () {

            });
        }


        function del(evento) {
        }


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function returnBeneficiari() {
            $state.go('app.sprardb_proroghe');
        }
        function openExtraDialog(ev, progetto, index) {
            console.log(progetto);
            console.log(index);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'beneficiario',
                }
            });
        }


        function openAttributiDialog(ev, item, index, newlink) {

            $mdDialog.show({
                controller: 'DialogAttributiController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogAttributiBForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Beneficiario: item,
                    index: index,
                    newlink: newlink
                }
            });

        }
        vm.attributiLabel = {
            'COMPETENZE': 'Competenze professionali',
            'CORSO': 'Interessi Corsi',
            'DOCUMENTO': 'Tipo Documento Ingresso',
            'INGRESSO': 'Tipo di Ingresso',
            'LINGUA': 'Lingua',
            'LINGUA-CONOSCENZA': 'Conoscenza lingue',
            'MOTIVO-USCITA': 'Motivo di Uscita',
            'NAZIONE': 'Nazione',
            'PARENTELA': 'Gradi di parentela',
            'PROFESSIONE': 'Professione svolte',
            'RELIGIONE': 'Religione',
            'SERVIZIO': 'Interesse a servizio',
            'STATO': 'Stato',
            'STUDI': 'Studi Effettuati',
            'STUDI-AREA': 'Area studi di interesse',
            'VULNERABILITA': 'Tipo di Vulnerabilità',
        };


        vm.tempstruttura = null;
        vm.tempaccoglienza = null;
        vm.tempalloggio = null;
        vm.openDialogs = openDialogs;
        function openDialogs(ev, struttura_id, progetto_id) {
//            $state.params.progetto_id = progetto_id;
//            $state.params.id = struttura_id;
            api.strutture.struttura2.cerca({id: struttura_id}, function (response) {
                vm.tempstruttura = response;
                if (angular.isUndefined(struttura_id)) {
                    vm.tempstruttura = {};
                }
                api.strutture.accoglienza.get({}, function (response) {
                    vm.tempaccoglienza = response;
                    api.strutture.alloggio.get({}, function (response) {
                        vm.tempalloggio = response;
                        $mdDialog.show({
                            controller: 'DettagliosController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/sprardb/form/strutturaForm.html',
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            fullscreen: true,
                            locals: {
                                Struttura: vm.tempstruttura,
                                Accoglienza: vm.tempaccoglienza,
                                Alloggio: vm.tempalloggio,
                                progetto_id: progetto_id,
                                struttura_id: struttura_id
                            }
                        });
                    });
                });
            });
        }

        vm.work = work;
        function work(event, segnalato, processo, trigger, isnew) {
            console.log('---vm.work');

            var extrasetup = {};
            var callback = {};
            var segnalatos = [];
            if (angular.isArray(segnalato)) {
                segnalatos = segnalato;
                extrasetup = JSON.parse(segnalato[0].eventoTipo.extra);
                callback = JSON.parse(segnalato[0].eventoTipo.callback);
            } else {
                segnalatos.push(segnalato);
                extrasetup = JSON.parse(segnalato.eventoTipo.extra);
                callback = JSON.parse(segnalato.eventoTipo.callback);
            }

//            console.log(extrasetup);
//            console.log(callback);
//            console.log(segnalato);
//            console.log(processo);
//            console.log(trigger);
//            console.log(isnew);


            var formDefinition = extrasetup.properties[processo].fields;
            var title = extrasetup.properties[processo].title;
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'ProcessosController',
                controllerAs: 'vm',
                focusOnOpen: true,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {
                    segnalati: segnalatos,
                    formDefinition: formDefinition,
                    title: title,
                    eventoStato_id: processo
                },
                templateUrl: 'app/main/sprardb/eventi/dialogs/processosc.html',
            });
        }
        vm.prorogaAperta = prorogaAperta;
        function prorogaAperta(beneficiario) {
            var found = false;
            angular.forEach(beneficiario.eventoAprorogas, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3 || proroga.eventoStato_id === 4) {
                    found = true;
                }
            });
            return found;

        }
        vm.prorogaApertaId = prorogaApertaId;
        function prorogaApertaId(beneficiario) {
            var found = 0;
            angular.forEach(beneficiario.eventoAprorogas, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3 || proroga.eventoStato_id === 4) {
                    found = proroga.id;
                }
            });
            return found;

        }
        vm.prorogaApertaObj = prorogaApertaObj;
        function prorogaApertaObj(beneficiario) {
            var found = {};
            angular.forEach(beneficiario.eventoAprorogas, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3 || proroga.eventoStato_id === 4) {
                    found = proroga;
                }
            });

            return found;

        }
        vm.prorogaApertaExtra = prorogaApertaExtra;
        function prorogaApertaExtra(beneficiario) {
            var found = {};
            angular.forEach(beneficiario.eventoAprorogas, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3 || proroga.eventoStato_id === 4) {
                    try {
                        found = JSON.parse(proroga.extra);
                        angular.forEach(found, function (rd, rk) {
                            if (rk.toLowerCase().indexOf("data") !== -1) {
                                found[rk] = new Date(rd);
                                found[rk] = moment(found[rk]).format("DD/MM/YYYY");
                            }

                        });
                    } catch (err) {
                    }
                }
            });
            return found;

        }

        vm.labelformat = labelformat;
        function labelformat(label) {
            return label.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
        }

        vm.getDataModel = DataModel;
        function DataModel(path, item) {

            var paths = path.split('.');
            var root = item;
            angular.forEach(paths, function (obj) {
                console.log("obj", obj);
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                        console.log(root);
                    } catch (err) {
                    }
                    angular.forEach(root, function (rd, rk) {
                        if (rk.toLowerCase().indexOf("data") !== -1) {
                            root[rk] = new Date(rd);
                            root[rk] = moment(root[rk]).format("DD/MM/YYYY");
                        }

                    })
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }



    }


})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.strutture')
            .controller('StruttureController', StruttureController);

    /** @ngInject */
    function StruttureController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, $q)
    {
        var vm = this;
        // Data

        vm.Strutture = null;
        vm.Tags = null;
        vm.Bandi = null;
        api.strutture.struttura.get({}, function (response) {
            vm.Strutture = response;
            vm.strutture = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });
        api.tags.tag.get({}, function (response) {
            vm.Tags = response;
            vm.tags = response.data;
            vm.users = response.data;
        });
        api.strutture.accoglienza.get({}, function (response) {
            vm.Accoglienza = response;
            vm.accoglienzas = response.data;
        });
        api.strutture.alloggio.get({}, function (response) {
            vm.Alloggio = response;
            vm.alloggios = response.data;
        });
        api.istats.istat.distinct({regione: 'distinct'}, function (response) {
            vm.regiones = response.data;
        });

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        vm.ricerca = {
            'strutturaAlloggio_id': null,
            'strutturaAccoglienza_id': null,
            'numeroPosti': null,
            'attivo': null,
            'tags-id': null,
            'istats-regione': null
        };
        vm.ricercalabel = {
            'strutturaAlloggio_id': 'Tipo Alloggio: ',
            'strutturaAccoglienza_id': 'Tipo Accoglienza: ',
            'istats-regione': 'Regione: ',
            'numeroPosti': 'Posti in struttura: ',
            'attivo': 'Struttura attiva: ',
            'tags-id': 'Tag: '
        };
        vm.ricerca2 = {};
        vm.searched = false;
        vm.search2 = "";
        vm.mostraitag = false;
        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.pager = pager;
        vm.openDialogFull = openDialogFull;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.aggiungiTag = aggiungiTag;
        vm.orderby = orderby;
        vm.gotoDettaglio = gotoDettaglio;

        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.strutture = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        //////////
        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.strutture.struttura.get({sort: order + field}, function (response) {
                vm.Strutture = response;
                vm.strutture = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['nome'] = string;
            vm.ricerca2['istats-comune'] = string;
            vm.ricerca2['operatore'] = 'OR';
            api.strutture.struttura.like(vm.ricerca2, function (response) {
                vm.Strutture = response;
                vm.strutture = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            //console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.strutture.struttura.like(vm.ricerca, function (response) {
                    vm.Strutture = response;
                    vm.strutture = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.strutture.struttura.get({}, function (response) {
                    vm.Strutture = response;
                    vm.strutture = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.progetti.progetto.get({}, function (response) {
                vm.Strutture = response;
                vm.strutture = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }
        function aggiungiTag(tstring) {
            api.tags.tag.save({tag: tstring}, function (response) {
                $state.reload();
            });
        }

        /**
         * Change Strutture List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            }
            else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            }
            else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function openDialogFull(ev, struttura) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && ($mdMedia('xs') || $mdMedia('sm'));
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/strutture/dialogs/struttura/dialog1.tmpl.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: useFullScreen,
                locals: {
                    Progetto: struttura,
                    Tags: vm.tags,
                    Strutture: vm.strutture
                }
            });
        }

        /**
         * Open new struttura dialog
         *
         * @param ev
         * @param struttura
         */
        function openContactDialog(ev, struttura)
        {
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/strutture/dialogs/contact/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Struttura: struttura,
                    User: vm.user,
                    Strutture: vm.strutture
                }
            });
        }

        /**
         * Delete Struttura Confirm Dialog
         */
        function deleteContactConfirm(struttura, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare il struttura?')
                    .htmlContent('<b>' + struttura.name + ' ' + struttura.lastName + '</b>' + ' sarà disattivato.')
                    .ariaLabel('delete struttura')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(struttura);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Struttura
         */
        function deleteContact(struttura)
        {
            vm.strutture.splice(vm.strutture.indexOf(struttura), 1);
        }

        /**
         * Delete Selected Strutture
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare i strutture?')
                    .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' saranno disattivati.')
                    .ariaLabel('delete strutture')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (struttura)
                {
                    deleteContact(struttura);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the struttura
         *
         * @param struttura
         * @param event
         */
        function toggleSelectContact(struttura, event)
        {
            if (event)
            {
                event.stopPropagation();
            }

            if (vm.selectedContacts.indexOf(struttura) > -1)
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(struttura), 1);
            }
            else
            {
                vm.selectedContacts.push(struttura);
            }
        }

        /**
         * Deselect strutture
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all strutture
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if (vm.newGroupName === '')
            {
                return;
            }

            var newGroup = {
                'id': msUtils.guidGenerator(),
                'name': vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                    .title('Are you sure want to delete the group?')
                    .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                    .ariaLabel('delete group')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        function gotoDettaglio(id, progetto_id)
        {
            $state.go('app.sprardb_progetti_strutture_struttura', {id: id, progetto_id: progetto_id});
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.progetti.progetti')
            .controller('ProgettiController', ProgettiController);

    /** @ngInject */
    function ProgettiController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, ricerca, acl, $filter, $mdToast, $cookieStore)
    {
        var vm = this;
        acl.reload();
        console.log(vm);
        vm.api = api;
        vm.searchForms = {
            "id": {
                type: "string",
                title: "id",
                description: "id",
                callbackModel: "ricerca",
                dbfield: "id",
                formtype: "text",
                style: "display:none;"
            },
            "codiceMinistero": {
                type: "string",
                title: "Codice progetto",
                description: "Codice progetto...",
                callbackModel: "ricerca",
                dbfield: "codiceMinistero",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.filtrap()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "tipologiaAccoglienzaId_IN": {
                type: "string",
                title: "Tipologia Progetto",
                description: "Tipologia Progetto...",
                callbackModel: "ricerca",
                dbfield: "tipologiaAccoglienzaId_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipAccoglienza",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "entes-nome": {
                type: "string",
                title: "Nome Ente Gestore/Titolare/Partner",
                description: "Nome Ente Gestore/Titolare/Partner...",
                callbackModel: "ricerca",
                dbfield: "entes-nome_LIKE",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoattivo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "bandos-id_IN": {
                type: "string",
                title: "Categoria/Bando",
                description: "Categoria/Bando...",
                callbackModel: "ricerca",
                dbfield: "bandos-id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            // "bandos-anni_LIKE": {
            //     type: "string",
            //     title: "Anno bando",
            //     description: "Anno bando",
            //     callbackModel: "ricerca",
            //     dbfield: "bandos-anni_LIKE",
            //     formtype: "select",
            //     multiple: true,
            //     onchange: "vm.onSearch()",
            //     data: "vm.anni",
            //     chiave: "id",
            //     valore: ["id", "descrizione"]
            // },
            "postiLiberi": {
                type: "string",
                title: "Numero posti liberi",
                description: "Numero posti liberi...",
                callbackModel: "ricerca",
                dbfield: "postiLiberi",
                formtype: "text",
                multiple: true,
                onchange: "vm.onSearch()",
                style: ""
            },
        };


        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Email', 'telefono': 'Telefono', 'postiTotali': 'Posti totali', 'codiceMinistero': 'Codice Min', 'attivo': 'Attivo'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo2;
        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipAccoglienza = res.data;
        });
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.enteruoloprogettos = ricerca.enteruoloprogettos

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.pagination = 10;
        vm.colors = ricerca.colors;


        // Data
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.ricerca.attivo = 1;
        vm.ricerca.operatore = "AND";
        vm.preselezione = $cookieStore.get('progetto_id');
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.ricerca.id = vm.preselezione;
        }
        vm.allsearchs['query[]'][1] = vm.ricerca;
        //vm.entetipos = ricerca.enteprimosettores;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.Bandi = ricerca.bandos;
        vm.bandos = ricerca.bandos;
        vm.anni = ricerca.anni();
        // Dati
        vm.Progetti = null;
        vm.Tags = null;
        vm.Bandi = null;
        vm.contacts = []
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.loadprogettos = function (tiporicerca) {
            tiporicerca = tiporicerca || "search";

            api.progettomc[tiporicerca](vm.allsearchs, function (response) {
                vm.progetti = response.data;

                vm.Progetti = response;
                vm.links = response._links;
                vm.meta = response._meta;

            }, function (response) {
                //console.log(response);
            });
            return vm.progetti;
        };
        vm.loadprogettos();
        console.log(vm.progetto);

        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.Tags = response;
                vm.tags = response.data;
                vm.users = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        // vm.loadbandos = function () {
        //     api.bandi.bando.distinct({dataFine: 'distinct', attivo: 1}).$promise.then(function (response) {
        //         vm.annos = response.data;
        //     }, function (response) {
        //         //console.log(response);
        //     });
        //     return vm.annos;
        // };
        // vm.loadbandos();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "progetto"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;


        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoProgetto = gotoProgetto;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
//
        vm.orderby = orderby;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.aggiungiTag = aggiungiTag;
//
        vm.openDialogFull = openDialogFull;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.deleteContact = deleteContact;
        vm.selectAllContacts = selectAllContacts;
//
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.pager = pager;



        //////////


        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Email', 'telefono': 'Telefono', 'postiTotali': 'Posti totali', 'codiceMinistero': 'Codice Min', 'attivo': 'Attivo'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,postiTotali';
            api.progettos.progetto.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            console.log('KEY:'+key);
            console.log('VALUE:'+value);
            console.log(vm.searchForms[key].data);
            console.log(vm.searchForms);
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
//                if (angular.isDate(value)) {
//                    return moment(date).format('DD/MM/YYYY');
//                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }

        function onSearch() {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';

                if (vm.ricerca2.indexOf(",") > -1) {
                    vm.allsearchs['query[]'][0]["codiceMinistero_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["nome_IN"] = vm.ricerca2;
                } else {
                    vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].codiceMinistero = vm.ricerca2;
                }

            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
            vm.loadprogettos(tiporicerca);
            vm.searched = true;
        }

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }


        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            vm.dataFilter.sort = order + field;
            api.progetti.progetto.search(vm.dataFilter, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['bandos-descrizione'] = string;
            //vm.ricerca2['strutturas-nome'] = string;
            vm.ricerca2['email'] = string;
            vm.ricerca2['nome'] = string;
            vm.ricerca2['operatore'] = 'OR';
            api.progetti.progetto.like(vm.ricerca2, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            //console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.progetti.progetto.like(vm.ricerca, function (response) {
                    vm.Progetti = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.progetti.progetto.search({}, function (response) {
                    vm.Progetti = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.progetti.progetto.search({}, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }
        function aggiungiTag(tstring) {
            api.tags.tag.save({tag: tstring}, function (response) {
                $state.reload();
            });
        }


        function openDialogFull(ev, progetto) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && ($mdMedia('xs') || $mdMedia('sm'));
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/contact/dialog1.tmpl.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: useFullScreen,
                locals: {
                    Progetto: progetto,
                    Tags: vm.tags,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/contact/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Contact: contact,
                    User: vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare il progetto?')
                    .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' sarà disattivato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare i progetti?')
                    .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' saranno disattivati.')
                    .ariaLabel('delete contacts')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }


        function toggleSelectContact(contact, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedContacts.indexOf(contact) > -1) {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            } else {
                vm.selectedContacts.push(contact);
            }
        }
        function deselectContacts() {
            vm.selectedContacts = [];
        }
        function selectAllContacts() {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if (vm.newGroupName === '')
            {
                return;
            }

            var newGroup = {
                'id': msUtils.guidGenerator(),
                'name': vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                    .title('Are you sure want to delete the group?')
                    .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                    .ariaLabel('delete group')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }
        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        vm.filtrap = filtrap;
        function filtrap() {
            var regioni = vm.ricerca.codRegione_IN;
            var allprovincias = ricerca.provincias;
            var provinciasfiltered = [];
            angular.forEach(regioni, function (regione) {
                angular.forEach(allprovincias, function (allprovincia) {
                    if (allprovincia.codRegione === regione) {
                        provinciasfiltered.push(allprovincia);
                    }
                });
            });
            vm.provincias = provinciasfiltered;
            if (angular.isUndefined(vm.ricerca.codRegione_IN)) {
                vm.provincias = allprovincias;
            }
        }

    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.progetti.progetti')
    .controller('OperatoriDialogController', ['locals','$mdDialog','ricerca','api','$mdToast', OperatoriDialogController]);

  function OperatoriDialogController(locals, $mdDialog, ricerca, api, $mdToast)
  {
    var vmd = this;

    vmd.cancel = function() { $mdDialog.cancel();}
    vmd.cancellaModel = cancellaModel;
    vmd.cancellaRelazione = cancellaRelazione
    vmd.cercaPersona = cercaPersona;
    vmd.changePersona = changePersona;
    vmd.checkRuoliUnique = checkRuoliUnique;
    vmd.inizializzaModel = inizializzaModel;
    vmd.salva = salva;
    vmd.toggleAccessoProgetto = toggleAccessoProgetto;
    vmd.userCan = api.user.can;


    vmd.locals = locals;
    vmd.persona = locals.persona;
    vmd.cercaModel = {};
    vmd.models = locals.persona ? angular.copy(locals.persona.personahasprogetto) : [];
    vmd.ricerca = ricerca;

    vmd.ruoli = api.personaruolos.personaruolo.search({'query[]': {gruppo_IN: ["AMBITO","PROGETTO"]}, sort: "gruppo,descrizione"});


    function cancellaModel(model)
    {
      vmd.models = vmd.models.filter(m => m !== model);
    }

    function cercaPersona()
    {
      let filter = {
        operatore: 'AND',
        'query[]': [
          {operatore: 'OR', 'entes-nome': vmd.cercaModel.nomeComune, 'istats-comune': vmd.cercaModel.nomeComune},
          {operatore: 'AND', cognome: vmd.cercaModel.cognome},
          {operatore: 'AND', codiceFiscale: vmd.cercaModel.codiceFiscale},
        ]
      }
      vmd.persone = api.personas.persona.like(filter);
    }

    function changePersona()
    {
      vmd.models = [];
      api.personas.persona.get({id: vmd.persona.id}, function (response) {
        var progetti = response.personahasprogettos
        if(progetti.length > 0) {
          progetti = progetti.filter(item => item.progetto_id === locals.progetto.id)
          progetti.forEach(function (progetto) {
            progetto.dataInizio = new Date(progetto.dataInizio)
            progetto.dataFine = new Date(progetto.dataFine)
            vmd.models.push(progetto);
          })
        }
        vmd.models.push(getModel());
      });

    }

    function checkRuoliUnique()
    {
      let ruoli = {};
      vmd.errorMsg = '';
      vmd.models.forEach(function(model){
        ruoli[model.personaRuolo_id] = true;
      })
      return vmd.errorMsg === '';
    }

    function getModel()
    {
      return {
        progetto_id: locals.progetto.id,
        persona_id: vmd.persona?.id,
        attivo: 1
      }
    }
    function inizializzaModel()
    {
      vmd.models.push(getModel());
    }

    function salva()
    {
      api.personas.hasprogetto.aggiorna({models: vmd.models}, function(res) {
        $mdToast.show(
          $mdToast.simple()
            .textContent(vmd.locals.persona ? 'Informazioni salvate' : 'Operatore associato')
            .position('bottom right')
            .hideDelay(3000)
        );
        $mdDialog.hide();
      });
    }

    function cancellaRelazione() {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler eliminare la relazione di questo operatore con il progetto?')
        .htmlContent('Non sarà più possibile recuperare le informazioni.')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.personas.hasprogetto.delete({id: vmd.persona.personahasprogetto[0].id}, function(res) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Relazione cancellata correttamente.')
              .position('bottom right')
              .hideDelay(3000)
          )
          locals.cercaOperatore()
          $mdDialog.hide();
        });
      });
    }

    function toggleAccessoProgetto()
    {
      let firstModel = vmd.models[0];
      let payload = {
        accessPermission: vmd.persona.accessoProgetto ? 0 : 1,
        id: firstModel.id,
        progetto_id: firstModel.progetto_id,
      }
      api.progettomc.accessPermission(payload, function(res) {
        vmd.persona.accessoProgetto = res.accessPermission;
      });
    }
  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.postlogin', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
          .state('app.sprardb_postlogin2', {
            url: '/sprardb/postlogin/postlogin2',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/postlogin/nuclei-familiari23/nuclei-familiari23.html',
                    controller: 'NucleiFamiliari23Controller as vm'
                }
            }
          });
          $stateProvider.state('app.sprardb_postlogin', {
            url: '/sprardb/postlogin',
            views: {
              'content@app': {
                templateUrl: 'app/main/sprardb/postlogin/cancellazione-beneficiari/cancellazione-beneficiari.html',
                controller: 'CancellazioneBeneficiariController as vm'
              }
            }
          });
//        $stateProvider.state('app.sprardb_postlogin2', {
//            url: '/sprardb/postlogin2',
//            views: {
//                'content@app': {
//                    templateUrl: 'app/main/sprardb/postlogin/postlogin2.html',
//                    controller: 'Postlogin2Controller as vm'
//                }
//            }
//        });




        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

    }

})();

(function ()
{
  'use strict';
  angular
    .module('app.sprardb.postlogin')
    .controller('NucleiFamiliari23Controller', ['$mdDialog','api','$filter','$mdToast','$state','$cookies', NucleiFamiliari23Controller]);

  /** @ngInject */
  function NucleiFamiliari23Controller($mdDialog, api, $filter, $mdToast, $state, $cookies)
  {
    var vm = this;

    // vm.cancelDialog = function() {$mdDialog.cancel();}
    vm.apriUscita = apriUscita;
    vm.confermaNucleo = confermaNucleo;
    vm.confermaPresenza = confermaPresenza;
    vm.displayNucleo = displayNucleo;
    vm.displayParentela = displayParentela;
    vm.finePostlogin = finePostlogin;
    vm.onChangeParentela = onChangeParentela;
    vm.onSearchNucleo = onSearchNucleo;
    vm.onSearchPresenza = onSearchPresenza;
    vm.scaricaRapporto = scaricaRapporto;
    vm.scegliCapofamiglia = scegliCapofamiglia;
    vm.valida = valida;

    vm.baseUrl = api.baseUrl;
    vm.presenza = {
      pagination: {page: 1, 'per-page': 5},
      downloadButton: true,
      confirm: true,
      models: {},
    };
    vm.nucleo = {
      pagination: {page: 1, 'per-page': 5},
      downloadButton: true,
      confirm: true,
      models: {},
    };
    vm.progettoId = $cookies.get('progetto_id');
    vm.tipNucleoFamiliare = api.beneficiarioattributis.beneficiario.search({gruppo: 'NUCLEOFAMILIARE', sort: 'descrizione'});
    vm.tipParentela = api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: '-note,descrizione'});

    vm.uscita = {
      model: api.postlogin.nucleiFamiliari23.uscitaModel(),
      motivi: api.beneficiarios.attributi.search({gruppo: "MOTIVO-USCITA", sort: "ordinamento,descrizione"}),
      extraMU: api.beneficiarios.attributi.like({gruppo: "MU-", sort: "ordinamento,descrizione"})
    }
    vm.user = api.user;

    onSearchNucleo();
    onSearchPresenza();

    function apriUscita(model)
    {
      if (model.b.def == 0) {
        let alert = $mdDialog.alert()
          .title('Uscita per beneficiario incompleto')
          .textContent("Non è possibile mettere in uscita un beneficiario incompleto. Si prega di completarlo nell'apposita sezione")
          .ok('OK');

        $mdDialog.show(alert);
        return;
      }

      $mdDialog.show({
        controller: 'UscitaBeneficiarioController',
        controllerAs: 'vmd',
        bindToController: true,
        templateUrl: 'app/main/sprardb/beneficiari/beneficiario/uscita/uscita.dialog.html',
        clickOutsideToClose: false,
        locals: {
          uscita: vm.uscita,
          postloginModel: model
        }
      }).then(function(modelUscita) {
        model.UscitaBeneficiario = modelUscita;
        api.postlogin.nucleiFamiliari23.uscita(model, function(res) {
          onSearchPresenza();
          onSearchNucleo();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Uscita Confermata')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      });
    }

    function confermaNucleo(model)
    {
      function _confermaNucleo() {
        api.postlogin.nucleiFamiliari23.confermaNucleo(model, function(res) {
          onSearchNucleo();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Nucleo Familiare Confermato')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      }

      function isNucleoChanged(model)
      {
        let ret = false;
        ['nucleoFamiliare','parentela_id','capof_id'].forEach(function(attr){
          if (model[attr] != model.b[attr]) {
            ret = true;
          }
        });
        return ret;
      }

      if (vm.nucleo.confirm) {
        let ok = $mdDialog.confirm()
          .clickOutsideToClose(true)
          .title('Conferma Nucleo Familiare')
          .textContent('Le informazioni del nucleo familiare di questo beneficiario saranno '+ (isNucleoChanged(model) ? 'aggiornate' : 'confermate'))
          .cancel('Annulla')
          .ok('Conferma');

        $mdDialog.show(ok).then(_confermaNucleo);
      } else {
        _confermaNucleo();
      }
    }

    function confermaPresenza(model)
    {
      function _confermaPresenza() {
        api.postlogin.nucleiFamiliari23.confermaPresenza(model, function(res) {
          onSearchPresenza();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Presenza Confermata')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      }

      if (vm.presenza.confirm) {
        let ok = $mdDialog.confirm()
          .clickOutsideToClose(true)
          .title('Conferma Presenza Beneficiario')
          .textContent('Conferma la presenza di questo beneficiario')
          .cancel('Annulla')
          .ok('Conferma');

        $mdDialog.show(ok).then(_confermaPresenza);
      } else {
        _confermaPresenza();
      }
    }

    function displayNucleo(nucleoFamiliare)
    {
      return '<b>'+ $filter('filter')(vm.tipNucleoFamiliare.data, {codice: nucleoFamiliare})[0].descrizione +'</b>';
    }

    function displayParentela(parentela_id)
    {
      return parentela_id ? '<b>'+ $filter('filter')(vm.tipParentela.data, {id: parentela_id})[0].descrizione +'</b>' : 'Selezionare Parentela';
    }

    function finePostlogin()
    {
      if (vm.nucleo.totalCount || vm.presenza.totalCount) {
        $state.go(api.primapagina, api.primapagina_attributi);
      } else {
        api.postlogin.nucleiFamiliari23.fine(function() {
          $state.go(api.primapagina, api.primapagina_attributi);
        });
      }
    }

    function onChangeParentela(model)
    {
      if (model.parentela_id == 674) {
        model.capof_id = null;
      }
    }

    function onSearchNucleo()
    {
      // vm.nucleo.totalCount = null;
      let params = angular.merge({
        filter: {and: [
          {nucleo: null},
          {or: [{presenza: null}, {presenza: 1}]},
          {progettoId: vm.progettoId}
        ]},
        fields: '*,b.id,b.codice,b.nome,b.cognome,b.dataNascita,b.def,b.sesso,b.parentela.*,b.capofamiglia.*,b.nazionalita.descrizione' +
          ',b.nucleoFamiliare,b.capof_id,b.parentela_id,b.progetto.nome,b.struttura.nome',
        expand: 'b.capofamiglia,b.parentela,b.nazionalita,b.progetto,b.struttura',
      }, vm.nucleo.pagination);

      if (vm.nucleo.models.$cancelRequest) vm.nucleo.models.$cancelRequest();
      vm.nucleo.models = api.postlogin.nucleiFamiliari23.query(params, function(res) {
        vm.nucleo.totalCount = res._meta.totalCount;
      });
    }

    function onSearchPresenza()
    {
      // vm.presenza.totalCount = null;
      let params = angular.merge({
        filter: {presenza: null, progettoId: vm.progettoId},
        fields: '*,b.id,b.codice,b.nome,b.cognome,b.dataNascita,b.def,b.sesso,b.progetto.nome,b.struttura.nome',
        expand: 'b.nazionalita,b.progetto,b.struttura',
      }, vm.presenza.pagination);

      if (vm.presenza.models.$cancelRequest) vm.presenza.models.$cancelRequest();
      vm.presenza.models = api.postlogin.nucleiFamiliari23.query(params, function(res) {
        vm.presenza.totalCount = res._meta.totalCount;
      });
    }

    function scaricaRapporto(tipo)
    {
      vm[tipo].downloadButton = false;
      $mdToast.show(
        $mdToast.simple()
          .textContent('Dati in arrivo...')
          .position('bottom right')
          .hideDelay(3000)
      );
      api.postlogin.nucleiFamiliari23.report({tipo: tipo}, function(res){
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet([Object.keys(res.columns)], {skipHeader: true});
        ws = XLSX.utils.sheet_add_json(ws, res.data.data, {origin: 'A2', skipHeader: true});
        XLSX.utils.book_append_sheet(wb, ws, tipo);

        var date = moment(new Date()).format('_YYYY-MM-DD_hh.mm');
        XLSX.writeFile(wb, 'report_postlogin_'+ tipo + date +".xlsx");

      }).$promise.finally(function(){
        vm[tipo].downloadButton = true;
      });
    }


    function scegliCapofamiglia(model)
    {
      $mdDialog.show({
        controller: 'DialogCapofamigliaController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/form/dialogCapofamigliaForm.html',
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          beneficiario_id: model.beneficiarioId,
          capoFamiglia: model.b.capofamiglia,
        }
      }).then(function(response){
        model.capof_id = response.capoF.segnalato_id;
        model.b.capofamiglia = response.capoF;
      });
    }

    function valida(model)
    {
      if (!model.parentela_id) {
        return false;
      }

      if ([0,1].includes(model.nucleoFamiliare) && model.parentela_id != 674 && !model.capof_id) {
        return false;
      }

      return true;
    }


  }
})();

(function ()
{
  'use strict';
  angular
    .module('app.sprardb.postlogin')
    .controller('CancellazioneBeneficiariController', CancellazioneBeneficiariController)
    .controller('MostraBeneficiariDuplicatiDialogController', MostraBeneficiariDuplicatiDialogController);

    /** @ngInject */
    function CancellazioneBeneficiariController($mdDialog, api, $filter, $mdToast, $state, $cookies) {
      var vm = this;
      vm.pagination= {page: 1, 'per-page': 5};
      vm.downloadButton= true;
      vm.confirmDialog= true;
      vm.models= {};
      vm.progettoId = $cookies.get('progetto_id');
      vm.user = api.user;
      vm.lavorato = 0

      vm.onSearch = onSearch;
      vm.cancellaBeneficiario = cancellaBeneficiario;
      vm.confermaBeneficiario = confermaBeneficiario;
      vm.scaricaRapporto = scaricaRapporto;
      vm.finePostloginBen = finePostloginBen;
      vm.annullaCancellazione = annullaCancellazione;
      vm.mostraBeneficiariDuplicati = mostraBeneficiariDuplicati;


      onSearch();
      function onSearch()
      {
        // vm.nucleo.totalCount = null;
        let params = angular.merge({
          filter: {and: [
              {progettoId: vm.progettoId},
              {lavorato: vm.lavorato}
            ]},
          fields: '*,b.id,b.codice,b.nome,b.cognome,b.dataNascita,b.def,b.sesso,b.nazionalita.descrizione' +
            ',b.progetto.nome,b.struttura.nome',
          expand: 'b.nazionalita,b.progetto,b.struttura',
        }, vm.pagination);

        if (vm.models.$cancelRequest) vm.models.$cancelRequest();
        vm.models = api.postlogin.cancellazioneBeneficiari.query(params, function(res) {
          vm.totalCount = res._meta.totalCount;
        });
      }

      function cancellaBeneficiario(beneficiario) {
        function _cancellaBeneficiario() {
          api.postlogin.cancellazioneBeneficiari.cancella(beneficiario, function(res) {
            onSearch();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Beneficiario cancellato correttamente!')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
        }

        if (vm.confirmDialog) {
          let ok = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Conferma Cancellazione Beneficiario')
            .textContent('Sei sicuro di voler cancellare questo beneficiario?')
            .cancel('Annulla')
            .ok('Conferma');

          $mdDialog.show(ok).then(_cancellaBeneficiario);
        } else {
          _cancellaBeneficiario();
        }
      }

      function annullaCancellazione(beneficiario) {
        function _annullaCancellazione() {
          api.postlogin.cancellazioneBeneficiari.annulla(beneficiario, function(res) {
            onSearch();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Cancellazione beneficiario annullata correttamente!')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
        }

        if (vm.confirmDialog) {
          let ok = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Conferma Annullamento Cancellazione Beneficiario')
            .textContent('Sei sicuro di voler annullare la cancellazione di questo beneficiario?')
            .cancel('Annulla')
            .ok('Conferma');

          $mdDialog.show(ok).then(_annullaCancellazione);
        } else {
          _annullaCancellazione();
        }
      }

      function scaricaRapporto(tipo)
      {
        vm.downloadButton = false;
        $mdToast.show(
          $mdToast.simple()
            .textContent('Dati in arrivo...')
            .position('bottom right')
            .hideDelay(3000)
        );
        api.postlogin.cancellazioneBeneficiari.report({}, function(res){
          var wb = XLSX.utils.book_new();
          var ws = XLSX.utils.json_to_sheet([Object.keys(res.columns)], {skipHeader: true});
          ws = XLSX.utils.sheet_add_json(ws, res.data.data, {origin: 'A2', skipHeader: true});
          XLSX.utils.book_append_sheet(wb, ws, tipo);

          var date = moment(new Date()).format('_YYYY-MM-DD_hh.mm');
          XLSX.writeFile(wb, 'report_postlogin_cancellazione_beneficiari' + date +".xlsx");

        }).$promise.finally(function(){
          vm.downloadButton = true;
        });
      }

      function confermaBeneficiario(beneficiario) {
        function _confermaBeneficiario() {
          api.postlogin.cancellazioneBeneficiari.conferma(beneficiario, function(res) {
            onSearch();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Beneficiario confermato correttamente!')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
        }

        if (vm.confirmDialog) {
          let ok = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Conferma Beneficiario')
            .textContent('Sei sicuro di voler confermare questo beneficiario?')
            .cancel('Annulla')
            .ok('Conferma');

          $mdDialog.show(ok).then(_confermaBeneficiario);
        } else {
          _confermaBeneficiario();
        }
      }

      function finePostloginBen()
      {
        console.log(vm.totalCount)
        if (vm.totalCount) {
          $state.go(api.primapagina, api.primapagina_attributi);
        } else {
          api.postlogin.cancellazioneBeneficiari.fine(function() {
            $state.go(api.primapagina, api.primapagina_attributi);
          });
        }
      }

      function mostraBeneficiariDuplicati(ev, model) {
        $mdDialog.show({
          controller: 'MostraBeneficiariDuplicatiDialogController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/postlogin/cancellazione-beneficiari/dialogs/mostraBeneficiariDuplicati.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: {id: model.id, beneficiarioId: model.beneficiarioId}
        });
      }
    }

    function MostraBeneficiariDuplicatiDialogController($mdDialog, api, $filter, $mdToast, locals) {
      var vmd = this;
      vmd.locals = locals;
      vmd.dataInizioProgetto=[];

      api.postlogin.cancellazioneBeneficiari.beneficiariDuplicati({id: locals.id, expand: 'b.nazionalita,b.progetto,b.struttura,b.tipoIngresso,b.protezioneTipo'}).$promise.then(function (d){
        vmd.models = d.data;
        angular.forEach(vmd.models, function (beneficiario) {
          api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante,progetto_id', beneficiario_id: beneficiario.b.id}).$promise.then(function (r) {
            if (r.data.length > 0) {
              var data = r.data;
              angular.forEach(data, function (d) {
                console.log(beneficiario.progettoId);
                console.log(d.progetto_id);
                if (beneficiario.progettoId === d.progetto_id) {
                  vmd.dataInizioProgetto[beneficiario.b.id] = d.dataInizio;
                }
              });
            }
          });
        })

      });

      vmd.closeDialog = closeDialog;
      function closeDialog()
      {
        $mdDialog.cancel();
      }
    }


})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas2', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_personas2', {
            url: '/sprardb/personas2',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/personas2/personas2.html',
                    controller: 'Personas2Controller as vm'
                }
            }
        });

        $stateProvider.state('app.sprardb_personasdettaglio2', {
            url: '/sprardb/personas2/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/personas2/dettaglio/dettaglio.html',
                    controller: 'DettaglioP2Controller as vm'
                }
            },
            resolve: {
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/personas2');


        // Api
        msApiProvider.register('contacts.contacts', ['http://localhost/sprardb/app-server/web/personas2']);
        msApiProvider.register('contacts1', ['http://localhost/sprardb/app-server/web/persona2/search']);
        msApiProvider.register('tags', ['http://localhost/sprardb/app-server/web/tags']);


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';


//        msNavigationServiceProvider.saveItem('scadmin.rubrica', {
//            title: 'RUBRICA',
//            //icon: 'icon-book',
//            weight: 5000
//        });
//        //scadmin
//        msNavigationServiceProvider.saveItem('scadmin.rubrica.personas2', {
//            title: 'Persone',
//            icon: 'icon-account-multiple-outline',
//            state: 'app.sprardb_personas2',
//            weight: 1
//        });
        /*
         msNavigationServiceProvider.saveItem('scsegreteria.rubrica', {
         title: 'RUBRICA',
         //icon: 'icon-book',
         weight: 5000
         });
         //scadmin
         msNavigationServiceProvider.saveItem('scsegreteria.rubrica.personas2', {
         title: 'Persone',
         icon: 'icon-account-multiple-outline',
         state: 'app.sprardb_personas2',
         weight: 1
         });
         */
        //properatore
//        msNavigationServiceProvider.saveItem('properatore.rubrica.personas2', {
//            title: 'Persone',
//            icon: 'icon-account-multiple-outline',
//            state: 'app.sprardb_personas2',
//            weight: 1
//        });

        //





    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas2')
//            .controller('DettaglioB2aController', DettaglioB2aController)
//            .controller('DialogEnti3aController', DialogEnti3aController)
            .controller('DialogSelProgettiController', DialogSelProgettiController)
            .controller('DettaglioP2Controller', DettaglioP2Controller);



    function DettaglioP2Controller($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $mdToast, $cookies, $filter)
    {

        var vm = this;


        vm.saveRoles = saveRoles;

        vm.roleNames = api.users.role.roleNames();

        vm.userlogged = api.userlogged;
        vm.confermaUtente = vm.userlogged.privacy;

        vm.api = api;
        vm.isAdmin = api.isAdmin;
        vm.limitOptions = ricerca.limitOptions;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.pagination = { page: 1, 'per-page': 20};

        vm.options = ricerca.options;

        vm.meta = [];

        vm.loadRuolo = function (page,limit) {
            var payload = {
                expand: 'personaRuolo,progetto',
                filter: { 'persona_id': vm.id, 'progetto.nome': vm.esearch}, // Filtra solo per l'ID della persona
                page: page,
                'per-page': limit
            };

            // Esegui la chiamata API o la query per ottenere i ruoli associati alla persona
            api.personas.hasprogetto.index(payload, function (response) {
                vm.contact.ruoli = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        };


        vm.onSearchRuolo = function (page, limit) {
            vm.loadRuolo(page, limit);
        };

        vm.id = $state.params.id;
        vm.isnew = false;
        if (vm.id == '0' || angular.isUndefined($state.params.id) || $state.params.id == "") {
            vm.isnew = true;
        }
        vm.gruppos = ricerca.gruppos;
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.currentuser = api.user;
        vm.evento = "update";
        vm.loadpersona = function () {
            var Persona = {};
            api.personas.persona.get({id: vm.id, expand: 'personahasentes.ente,personahasentes.ente.istats,personahasentes.ente.entetipo,periodiRendicontazione'}, function (response) {
                Persona = response;
                vm.loadRuolo();

                vm.contact = angular.copy(Persona);
                vm.contactBackup = angular.copy(Persona);
                vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
                if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
                    vm.caricaProvince(vm.contact.codRegione);
                }
                if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
                    vm.caricaComuni(vm.contact.codProvincia);
                }
                //vm.ruolitotali = vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasentes.length;
                if (!angular.isUndefined(vm.contact.nascita)) {
                    if (vm.contact.nascita !== null) {
                        vm.caricaProvince2(vm.contact.nascita.codRegione);
                        vm.caricaComuni2(vm.contact.nascita.codProvincia);
                    }
                }

                vm.contact.anniRendicontazione = vm.contact.periodiRendicontazione.map(function (periodo) {
                    return periodo.anno;
                  }).join(', ');
                console.log(vm.contact.periodiRendicontazione);
            });
            return Persona;
        };
        if (!vm.isnew) {
            vm.loadpersona();
        }

        vm.provincias = [];
        vm.istats = [];
        //vm.tags = Tags.data;
        api.tags.tag.cerca({pagination: 50, sort: "tag", tipo: "generico"}, function (response) {
            vm.tags = response.data;
        });



        vm.provincias2 = [];
        vm.istats2 = [];
        vm.regiones = null;
        vm.regiones2 = null;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = response.data;
        });
        vm.personaruolos = null;
        api.personaruolos.personaruolo.get({}, function (response) {
            vm.personaruolos = response.data;
        });

        api.beneficiarioattributis.beneficiarioattributi.like({gruppo: 'NAZIONE', sort: "descrizione", pagination: -1}, function (r) {
          vm.nazionalitas = r.data;
        });
        vm.studis = ricerca.personastudis;

        if (vm.isnew)
        {
            console.log("entro?");
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                cognome: null,
                sesso: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataNascita: null,
                dataNascita2: null,
                codComuneNascita: null,
                codNazionalita: null,
                codiceFiscale: null,
                tags: [],
                progettos: [],
                entes: [],
                ruolos: [],
                personahasprogettos: [],
                personahasentes: []
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];
            console.log(vm.contact);
        }

// Methods
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;
        vm.gotoPersona = gotoPersona;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoEnte = gotoEnte;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openEntiDialog = openEntiDialog;
        vm.getRuoloFilter = getRuoloFilter;

        vm.ruolitotali = 0;
//
//        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
//            vm.caricaProvince(vm.contact.codRegione);
//        }
//        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
//            vm.caricaComuni(vm.contact.codProvincia);
//        }







        ////////////////////////////////////////////////

        vm.checkEmail = checkEmail;
        function checkEmail(ev) {

            if (angular.isDefined(vm.contact.email) && vm.contact.email !== vm.contactBackup.email) {
                api.users.log.checkemail({email: vm.contact.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.personaNForm.email.$setValidity("unique", false);
                            } else {
                                api.users.log.checkemail2({email: vm.contact.email}, function (r) {
                                    if (r.esito == 1) {
                                        $scope.personaNForm.email.$setValidity("unique", false);
                                    } else {
                                        $scope.personaNForm.email.$setValidity("unique", true);
                                    }

                                });


                            }
                        });
            } else {
                $scope.personaNForm.email.$setValidity("unique", true);
            }
        }
        vm.checkCf = checkCf;
        vm.cfvalido = 1;
        function checkCf(ev) {
            if (angular.isDefined(vm.contact.codiceFiscale) && vm.contact.codiceFiscale !== vm.contactBackup.codiceFiscale) {
                api.users.log.checkcf({codiceFiscale: vm.contact.codiceFiscale}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.personaNForm.codicefiscale.$setValidity("unique", false);
                                vm.cfvalido = 0;
                            } else {
                                $scope.personaNForm.codicefiscale.$setValidity("unique", true);
                                vm.cfvalido = 1;
                            }
                        });
            }
        }

        vm.passwordvisible = "password";

        vm.pswdiversa = 1;
        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.logindata.passwordAttuale === vm.logindata.nuovaPassword) {
                $scope.personaNForm.nuovaPassword.$setValidity("passwordVerify", false);
                vm.pswdiversa = 0;
            } else {
                $scope.personaNForm.nuovaPassword.$setValidity("passwordVerify", true);
                vm.pswdiversa = 1;
            }
        }

        vm.validatepassword = validatepassword;
        vm.passwordvalidata = null;
        function validatepassword(ev) {
            api.users.log.validatepassword({username: vm.userlogged.username, password: vm.logindata.passwordAttuale}, function (d) {
                if (d.data) {
                    vm.passwordvalidata = 1;
                } else {
                    vm.passwordvalidata = 0;
                }
            });

        }

        function getRuoloFilter(parolaChiave)
        {
          return {
            personahasprogetto: {
              personaruolo: {
                descrizione: parolaChiave
              }
            }
          };
        }


        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                vm.istats = {};
            });
        }



        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                vm.istats2 = {};
            });
        }


        /**
         * Save contact
         */
        function saveContact()
        {


            var m = moment(vm.contact.dataNascita2);
            vm.contact.dataNascita = m.format("YYYY-MM-DD");
            if (vm.isnew) {
                api.personas.persona.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    if (response.id > 0) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Inserimento Completato con successo')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        //$state.go('app.sprardb_personasdettaglio2', {id: contact_id});
                    }
                });
            }
            if (!vm.isnew) {
                api.personas.persona.aggiorna(vm.contact, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Aggiornamento Anagrafica Completato con successo')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    if (vm.confermaUtente && vm.contact.utentes && vm.contact.utentes[0] && vm.contact.utentes[0].username) {
                        api.users.log.userupdate({username: vm.contact.utentes[0].username, email: vm.contact.email}, function (r) {
                            if (r.esito === 1) {
                                $mdToast.show(
                                        $mdToast.simple()
                                        .textContent('Email allineata con profilo collegato')
                                        .position('bottom right')
                                        .hideDelay(3000)
                                        )
                            } else {
                                $mdToast.show(
                                        $mdToast.simple()
                                        .textContent('Errore. Email non allineata con profilo collegato')
                                        .position('bottom right')
                                        .hideDelay(3000)
                                        )
                            }

                        });
                    }
                    //$state.reload();
                });
            }
            if (!vm.confermaUtente) {
                api.users.log.userupdate({nuovaPassword: vm.logindata.nuovaPassword, username: vm.userlogged.username, email: vm.contact.email}, function (r) {
                    if (r.esito === 1) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Aggiornamento Informazioni Completato con successo')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(function () {
                            $cookies.remove('user');
                            $cookies.remove('ente_id');
                            $cookies.remove('progetto_id');
                            $cookies.remove('ALL_p_id');
                            $cookies.remove('ALL_s_id');
                            $cookies.putObject('user', {autorizzato: 0});
                            $state.go('app.sprardb_auth_login');
                        });
                    } else {

                    }

                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoPersona() {
            $state.go('app.sprardb_contatti');
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }


        function gotoEnte(id)
        {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: id});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.personas.persona.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoPersona();
                });

            });

        }


        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                console.log(vm.tempruolo);
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    console.log(vm.tempentetipo);
                    $mdDialog.show({
                        controller: 'DialogEnti2Controller',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Persona: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }

        // vm.attivaLogin = attivaLogin;
        //
        // function attivaLogin(progetto_id) {
        //
        // 	api.personas.persona.get({id: vm.id}).$promise.then(function (response) {
        //         vm.persona = angular.copy(response);
        //         vm.controllo= "DISATTIVA";
        //
        //         var id_hasProgetto = [];
        //
        //         for(var indice = 0, len = vm.persona.personahasprogettos.length; indice < len; indice++){
        //     		if(vm.persona.personahasprogettos[indice].progetto_id==progetto_id && vm.persona.personahasprogettos[indice].loginAttiva==0){
        //     			vm.controllo= "ATTIVA";
        //     		}
        //     		if(vm.persona.personahasprogettos[indice].progetto_id==progetto_id){
        //     			id_hasProgetto.push(vm.persona.personahasprogettos[indice].id);
        //     		}
        //     	}
        //
        //         if(vm.controllo=="ATTIVA"){
        //         	vm.loginAttiva=1;
        //         }else{
        //         	vm.loginAttiva=0;
        //         }
        //
        //         var payload = { progetto_id:progetto_id, loginAttiva:vm.loginAttiva, persona_id:vm.id, id_hasProgetto:id_hasProgetto};
        //
        //         var confirm = $mdDialog.confirm(payload)
        //         .title('Modifica attivazione Login Progetto')
        //         .htmlContent(vm.controllo+' login sul progetto seguente?')
        //         .ok('Esegui')
        //         .cancel('Non eseguire');
        //         $mdDialog.show(confirm).then(function () {
        //
        //         	for(var indice = 0, len = payload.id_hasProgetto.length; indice < len; indice++){
        //         		api.personas.hasprogetto.aggiorna({id: payload.id_hasProgetto[indice], loginAttiva: payload.loginAttiva}, function (u){
        //         		});
        //         	}
        //         	console.log("try", payload);
        //
        //         	$state.reload()
        //
		    //     }, function () {
		    //         //abbandona
		    //     });
        //
        //     }, function (response) {
        //     });
        // }
        vm.openDialogProgetti = openDialogProgetti;
        function openDialogProgetti(ev,progetto,index) {
            console.log(progetto);
            $mdDialog.show({
            controller: 'DialogSelProgettiController',
            controllerAs: 'vmd',
            templateUrl: 'app/main/sprardb/form/dialogProgettiForm.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                progetto: progetto,
                Regioni: vm.regiones,
              }
            });
        }

        vm.openUserDialog = openUserDialog;
        function openUserDialog(ev, persona_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: true,
                    isnew: false,
                    gruppo_id: false
                }
            }).then(function (datastore) {
                console.log("datastore", datastore);
                if (datastore.doit) {
                    if (datastore.disableuser === true) {
                        //disabilita solo utente
                        api.users.log.toggleuser({persona_id: datastore.persona_id}, function (response) {
                            console.log(response);
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Attivazione profilo cambiata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    } else {

                    	if (angular.isDefined(datastore.modificag) && datastore.modificag == true && angular.isDefined(datastore.changeGroup) && datastore.changeGroup == true){

                    		delete datastore['changeGroup'];

                    		api.users.log.changegroup(datastore, function (ug) {
                                if (angular.isDefined(ug.id)) {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Profili correttamente modificati')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento profili. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                    	} else {

                        //startreset
                        //passwordreset

                    		console.log("email", datastore.email);
                    		console.log("username", datastore.username);

                        api.users.log.startreset({email: datastore.email, username: datastore.username}, function (pr) {
                            var passwordresettoken = pr.token;
                                console.log("token", passwordresettoken);
//                            angular.forEach(pr, function (opr, k) {
//                                if (k >= 0 && k <= 42) {
//                                    passwordresettoken = passwordresettoken + opr;
//                                }
//                            })
                            api.users.log.passwordreset({token: passwordresettoken, password: datastore.password}, function (us) {
                                if (angular.isDefined(us.id)) {
                                    var email = {};
                                    email.to = [];
                                    email.to.push(us.email);
                                    email.oggetto = "Banca dati SC - Cambiamento Password";
                                    email.corpo = "Gentile utente,<br>Il suo profilo è stato aggiornato come richiesto, le riportiamo di seguito le credenziali di accesso.<br><br>Indirizzo di accesso alla Banca Dati:<br>http://bancadati.sprar.it<br><br>Le credenziali da adoperare al suo accesso sono:<br>Nome Utente: " + us.username + "<br>Password: " + datastore.password + "<br><br><br>Cordiali Saluti<br>Reparto Assistenza Tecnica SC";
                                    api.emails.send.send(email, function (rrr) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Invio email compeltato.')
                                                .position('bottom right')
                                                .hideDelay(2000)
                                                );
                                    });
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Password cambiata per utente ' + us.username + ' ' + us.email + '. Attendere prego.')
                                            .position('bottom right')
                                            .hideDelay(7000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento password. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        });

                                }

                    }
                }
            });
        }

        vm.openRegisterDialog = openRegisterDialog;
        function openRegisterDialog(ev, persona_id, gruppo_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: false,
                    isnew: true,
                    gruppo_id: gruppo_id
                }
            }).then(function (datastore) {
                if (datastore.doit) {
                    console.log(datastore);
                    datastore.sendemail = 1;
                    api.users.log.createuser(datastore, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Nuovo profilo creato.')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                $state.reload()
                                );
                    });
                }
            });
        }

      function saveRoles()
      {
        api.users.role.assegnaRuoli({user_id: vm.changedUser.id, roles: vm.changedUser.roleNames}, function(res) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Ruoli/Profili Utente salvati')
              .position('bottom right')
              .hideDelay(3000)
          )
          vm.changedUser.roleNames = res.roles;
          vm.changedUser = undefined;
        });
      }

    }

    function DialogSelProgettiController($scope, $mdDialog, locals, api, $http,$state,$mdToast,ricerca) {
      var vmd = this;
      vmd.id = $state.params.id
      vmd.provincesByRegion = {};
      vmd.regions = []; // Variabile per memorizzare le regioni
      vmd.selectedRegions = [];
      vmd.selectedAccoglienzaID =[];
      vmd.selectedRegionIds = [];
      vmd.selectedProgetti = [];
      vmd.periodiRendicontazione = [];
      vmd.selectedStatoProgetti=null;
      vmd.nomeProgetto=null;

      vmd.anni = api.documentorendicontazione.anni();

      // Funzione per ottenere tutte le regioni
      vmd.regions = ricerca.regiones;

      vmd.getProgettiByProvincia = getProgettiByProvincia;
      vmd.salvaDati = salvaDati;
      vmd.getProvinces = getProvinces;
      vmd.cambiaStatoProgetti = cambiaStatoProgetti;
      vmd.aggiungiProgetto = aggiungiProgetto;

    // Chiamata iniziale per ottenere tutte le regioni
      getPersonaData(vmd.id);
      function getPersonaData(personaId) {
          api.personas.persona3.get({ id: personaId, expand: 'progetti, regioni, province, tipologie, periodiRendicontazione' }, function (response) {
              vmd.personaData = response;
              vmd.selectedProvinces = vmd.personaData.province;
              vmd.selectedAccoglienza = vmd.personaData.tipologie;
              vmd.selectedRegions = vmd.personaData.regioni;
              vmd.attivo = vmd.selectedProvinces.length === 0 ?  1 :  vmd.personaData.attivoConsulenti;
              vmd.periodiRendicontazione = vmd.personaData.periodiRendicontazione
              vmd.selectedProgetti = vmd.personaData.progetti;
              vmd.progetti = vmd.personaData.progetti.sort((a,b) => a.nome.localeCompare(b.nome, "it", { ignorePunctuation: true }));
              vmd.getProvinces(vmd.selectedRegions);
          });
      }

      function cambiaStatoProgetti() {
        var payload = {
          filter: {
            or: [{nome: {xlike: vmd.nomeProgetto+'%'}}, {nome: {like: ' '+vmd.nomeProgetto}}, {codiceMinistero: {xlike: '%'+vmd.nomeProgetto+'%'}}]
          },
          fields: "id,nome,codiceMinistero",
          sort: "nome"
        };
        if(vmd.selectedStatoProgetti !== null) {
          payload.filter.attivo = vmd.selectedStatoProgetti
        }
        vmd.listProgetti = api.progettomc.query(payload);
      }

      function aggiungiProgetto(progetto) {
        if(!progetto) return;
        if(!vmd.selectedProgetti.some((item) => item.id === progetto.id)) {
          vmd.selectedProgetti.push({id: progetto.id, nome: progetto.nome});
          vmd.progetti = vmd.selectedProgetti;
          vmd.progetti = vmd.progetti.sort((a,b) => a.nome.localeCompare(b.nome, "it", { ignorePunctuation: true }))
        }
      }

      // Funzione per ottenere le province delle regioni selezionate
      function getProvinces(selectedRegions) {
        vmd.provincesByRegion = []; // Pulisci le province esistenti
        // Per ciascuna regione selezionata, recupera le province
        const check = vmd.selectedRegions.some(function(el) {
          return el.id === 'Tutti';
        })
        if(check) {
          api.istats.province.get({pagination: 10000}, function (response) {
            vmd.provincesByRegion = response.data;
          });
        } else {
          selectedRegions.forEach(function (region) {
            var codRegione = region.id;
            api.istats.province.get({ codRegione: codRegione }, function (response) {
              vmd.provincesByRegion.push(...response.data);
            });
          });
        }

      }

      vmd.accoglienza =[];
      function getTipologiaAccoglienza(){
          api.tipologiaAccoglienza.tipologie.get({}, function (response) {
              vmd.accoglienza = response.data;
              vmd.selectedAccoglienzaID = response.data.id;
          });
      }
      getTipologiaAccoglienza();

      function getProgettiByProvincia(codProvincia) {
          api.progetti.progetto.get({ codProvincia: codProvincia }, function (response) {
              vmd.progettiByProvincia[codProvincia] = response.data;
          });
      }

      vmd.resetForm = function() {
          // Pulisci i dati immessi dall'utente
          vmd.selectedRegions = [];
          vmd.selectedProvinces = [];
          vmd.selectedAccoglienza = [];
      }

      vmd.resetProgetti = function() {
        // Pulisci i dati immessi dall'utente
        vmd.selectedProgetti = [];
      }

      async function salvaDati() {

        if (vmd.selectedAccoglienza.length === 0) {
          // Se non ha selezionato nulla, includi tutte le tipologie di accoglienza disponibili
          vmd.selectedAccoglienza = vmd.accoglienza;
        }

        if(vmd.periodiRendicontazione.length === 0){
          vmd.periodiRendicontazione = vmd.anni;
        }
        let payload = {
          tipologie: vmd.selectedAccoglienza,
          regioni: vmd.selectedRegions,
          province: vmd.selectedProvinces,
          personaId: vmd.id,
          attivoConsulenti: vmd.attivo,
          progetti: vmd.selectedProgetti,
          periodiRendicontazione: vmd.periodiRendicontazione
        };

        api.personas.persona3.associa(payload, function (response) {
          $mdDialog.hide().then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Dati salvati con successo.')
                .position('bottom right')
                .hideDelay(5000)
            );
            $state.reload();
          });
        });
      }


      vmd.closeDialog = function () {
          $mdDialog.hide();
      }
  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_personas', {
            url: '/sprardb/personas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/personas/personas.html',
                    controller: 'PersonasController as vm'
                }
            }
        });

        $stateProvider.state('app.sprardb_personasdettaglio', {
            url: '/sprardb/personas/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/personas/dettaglio/dettaglio.html',
                    controller: 'DettaglioPController as vm'
                }
            },
            resolve: {
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/personas');


        // Api
        msApiProvider.register('contacts.contacts', ['http://localhost/sprardb/app-server/web/personas']);
        msApiProvider.register('contacts1', ['http://localhost/sprardb/app-server/web/personas/search']);
        msApiProvider.register('tags', ['http://localhost/sprardb/app-server/web/tags']);


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';


//        msNavigationServiceProvider.saveItem('scadmin.rubrica', {
//            title: 'RUBRICA',
//            //icon: 'icon-book',
//            weight: 5000
//        });
        //scadmin
//        msNavigationServiceProvider.saveItem('scadmin.rubrica.personas', {
//            title: 'Persone',
//            icon: 'icon-account-multiple-outline',
//            state: 'app.sprardb_personas',
//            weight: 1
//        });
        //properatore

        //





    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas')
            .controller('DettaglioB2Controller', DettaglioB2Controller)
            .controller('DialogEnti3Controller', DialogEnti3Controller);


    /** @ngInject */
    function DettaglioB2Controller($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, Persona, Tags)
    {

        var vm = this;
        vm.id = $state.params.id;
        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }
        console.log(vm.isnew);
        vm.evento = "update";
        vm.contact = angular.copy(Persona.data[0]);

        vm.provincias = [];
        vm.istats = [];
        vm.tags = Tags.data;

        vm.provincias2 = [];
        vm.istats2 = [];
        vm.regiones = null;
        vm.regiones2 = null;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = response.data;
        });
        vm.personaruolos = null;
        api.personaruolos.personaruolo.get({}, function (response) {
            vm.personaruolos = response.data;
        });

        vm.nazioni = null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: 200}, function (response) {
            vm.nazioni = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });






        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                cognome: null,
                sesso: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataNascita: "2013-08-08",
                dataNascita2: null,
                codComuneNascita: null,
                codNazionalita: null,
                codiceFiscale: null,
                tags: [],
                progettos: [],
                entes: [],
                ruolos: [],
                personahasprogettos: [],
                personahasentes: []
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.contact2 = {
            'codRegione': null,
            'codProvincia': null,
            'codComune': null,
            'codComuneNascita': null,
        };


// Methods
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;
        vm.gotoPersona = gotoPersona;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoEnte = gotoEnte;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openEntiDialog = openEntiDialog;



        vm.ruolitotali = vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasentes.length;
        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);
        }
        if (!angular.isUndefined(vm.contact.nascita)) {
            if (vm.contact.nascita !== null) {
                vm.caricaProvince2(vm.contact.nascita.codRegione);
                vm.caricaComuni2(vm.contact.nascita.codProvincia);
            }
        }


        console.log('isnew:' + vm.isnew);
        console.log('contact:');
        console.log(vm.contact);
        console.log('contact.tags:');
        console.log(vm.contact.tags);




        ////////////////////////////////////////////////

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }









        /**
         * Save contact
         */
        function saveContact()
        {

            console.log('isnew:' + vm.isnew);
            console.log('contact:');
            console.log(vm.contact);
            console.log('contact.tags:');
            console.log(vm.contact.tags);


            var m = moment(vm.contact.dataNascita2);
            vm.contact.dataNascita = m.format("YYYY-MM-DD");
            if (vm.isnew) {
                api.personas.persona.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: response.id, tag_id: obj.id});
                    });
                    //
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: contact_id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload,
                        delete: false
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            console.log(response);
                            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                        });
                    } else {
                        $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                    }
                });
            }
            if (!vm.isnew) {
                api.personas.persona.aggiorna(vm.contact, function (response) {
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: vm.contact.id, tag_id: obj.id});
                    });
                    //delete: false,
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: vm.contact.id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            $state.reload();
                        });
                    } else {
                        $state.reload();
                    }
                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoPersona() {
            $state.go('app.sprardb_contatti');
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }


        function gotoEnte(id)
        {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: id});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.personas.persona.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoPersona();
                });

            });

        }


        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                console.log(vm.tempruolo);
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    console.log(vm.tempentetipo);
                    $mdDialog.show({
                        controller: 'DialogEnti2Controller',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Persona: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }


    }

    function DialogEnti3Controller($scope, $state, $mdDialog, Persona, api, AllRuolo, index, AllEnteTipo, Regioni, newlink)
    {
        var vmd = this;
        vmd.persona_id = Persona.id;
        vmd.index = index;
        vmd.persona_nome = Persona.cognome + ' ' + Persona.nome;
        vmd.ente_id = null;
        vmd.ente_nome = null;
        vmd.entes = angular.copy(Persona.entes);
        vmd.ente = {
            id: null,
            enteTipo_id: null,
            enteTipoPadre_id: null,
            nome: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            attivo: '1',
            enteruolos: [],
        };
        vmd.allentes = {};
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewente = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewente = true;
        }
        vmd.ruolosSelected = [];

        if (vmd.index !== null) {
            vmd.ente_id = Persona.entes[index].id;
            vmd.ente_nome = Persona.entes[index].nome;
            vmd.ente = angular.copy(Persona.entes[index]);

            angular.forEach(Persona.personahasentes, function (obj) {
                if ((vmd.ente.id) == obj.ente_id) {
                    vmd.ruolosSelected.push(obj.personaRuolo_id);
                }
            });
//            angular.forEach(vmd.ente.enteruolos, function (obj) {
//                vmd.ruolosSelected.push(obj.id);
//            });
        }
        vmd.allentetipos = AllEnteTipo.data;
        vmd.allruolo = AllRuolo.data;
        vmd.regiones = Regioni;
        vmd.provincias = [];
        vmd.istats = [];


        vmd.progettohasente = {
            progetto_id: vmd.persona_id,
            ente_id: vmd.ente_id,
        };

        vmd.ricerca = {
            nome: null,
            enteTipo_id: null,
            codRegione: null,
        };
        vmd.enteselezionato = {
            id: null
        };


        vmd.save = save;
        vmd.delete = del;
        vmd.cercaEnte = cercaEnte;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.restituisciEnte = restituisciEnte;
        if (vmd.ente.codRegione !== null || vmd.ente.codRegione !== '') {
            //vmd.caricaProvince(vmd.ente.codRegione);
        }
        if (vmd.ente.codProvincia !== null || vmd.ente.codProvincia !== '') {
            //vmd.caricaComuni(vmd.ente.codProvincia);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaEnte() {
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.entes.ente.like(vmd.ricerca, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.entes.ente.get({}, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciEnte() {
            api.entes.ente.get({id: vmd.enteselezionato.id}, function (response) {
                vmd.enteselezionato = response;
                //console.log(vmd.enteselezionato);
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(Persona.personahasentes, function (obj2) {
                var pushpayload = {
                    persona_id: obj2.persona_id,
                    ente_id: obj2.ente_id,
                    personaRuolo_id: obj2.personaRuolo_id};
                payload.push(pushpayload);
            });
            /*            
             var payload = [];
             angular.forEach(vmd.entes, function (obj) {
             angular.forEach(obj.enteruolos, function (obj2) {
             var pushpayload = {
             persona_id: vmd.persona_id,
             ente_id: obj.id,
             personaRuolo_id: obj2.id};
             payload.push(pushpayload);
             });
             });
             */
            if (!vmd.isnewente && !vmd.newlink) {
                //modifica
                vmd.entes.splice(vmd.index, 1);
                payload = [];
                angular.forEach(Persona.personahasentes, function (obj2) {
                    var pushpayload = {
                        persona_id: obj2.persona_id,
                        ente_id: obj2.ente_id,
                        personaRuolo_id: obj2.personaRuolo_id};
                    payload.push(pushpayload);
                });
                /*
                 angular.forEach(vmd.entes, function (obj) {
                 angular.forEach(obj.enteruolos, function (obj2) {
                 var pushpayload = {
                 persona_id: vmd.persona_id,
                 ente_id: obj.id,
                 personaRuolo_id: obj2.id};
                 payload.push(pushpayload);
                 });
                 });
                 */
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewente && !vmd.newlink) {
                //nuovo ente + inserimento link
                api.entes.ente.save(vmd.ente, function (response) {
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            persona_id: vmd.persona_id,
                            ente_id: response.id,
                            personaRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanyentes = {
                        modelrelation: 'Personahasente',
                        idname: 'persona_id',
                        idvalue: vmd.persona_id,
                        idnamefk: 'ente_id',
                        idnamefk2: 'personaRuolo_id',
                        idnamePayload: 'ente_id',
                        payload: payload
                    };
                    api.entes.ente.hasmany(hasmanyentes, function (response) {
                        console.log(response);
                        $state.reload();
                        $scope.hide();
                    });
                });
            }

            if (vmd.newlink) {
                //inserimento solo links
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        persona_id: vmd.persona_id,
                        ente_id: vmd.enteselezionato.id,
                        personaRuolo_id: ruolo};
                    payload.push(pushpayload);
                });

                var hasmanyentes = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: vmd.persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload
                };
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });

            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella ente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                var payload = [];
                angular.forEach(Struttura.personahasentes, function (obj2) {
                    if ((vmd.entes[vmd.index].id) != obj2.ente_id) {
                        var pushpayload = {
                            persona_id: obj2.persona_id,
                            ente_id: obj2.ente_id,
                            personaRuolo_id: obj2.personaRuolo_id};
                        payload.push(pushpayload);
                    }
                });
                /*
                 vmd.entes.splice(vmd.index, 1);
                 var payload = [];
                 angular.forEach(vmd.entes, function (obj) {
                 angular.forEach(obj.enteruolos, function (obj2) {
                 var pushpayload = {
                 persona_id: vmd.persona_id,
                 ente_id: obj.id,
                 personaRuolo_id: obj2.id};
                 payload.push(pushpayload);
                 });
                 });
                 */
                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                //console.log(payload);
                var hasmanyentes = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: vmd.persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload};
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });

        }




    }

})();

(function ()
{
  'use strict';

  angular.module('app.sprardb.monitoraggio', ['unsavedChanges', 'ngQuill'])
    .config(['$stateProvider', 'unsavedWarningsConfigProvider', 'ngQuillConfigProvider', config]);

  /** @ngInject */
  function config($stateProvider, unsavedWarningsConfigProvider, ngQuillConfigProvider)
  {
    $stateProvider
      .state('app.sprardb_monitoraggio', {
        url: '/sprardb/monitoraggio/visite',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/monitoraggi.html',
            controller: 'MonitoraggiController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio_tutor', {
        url: '/sprardb/monitoraggio/tutor',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/tutor/tutor.html',
            controller: 'TutorController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio.view', {
        url: '/{visitaId:int}',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/monitoraggio.html',
            controller: 'MonitoraggioController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio.view.checklist', {
        url: '/{visitaId:int}/checklist/{id:int}',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/dettaglio/checklist.html',
            controller: 'ChecklistController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio.view.rapporto', {
        url: '/{visitaId:int}/rapporto/{id:int}',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/dettaglio/rapporto.html',
            controller: 'RapportoController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio_dashboard', {
        url: '/sprardb/monitoraggio',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/dashboard.html',
            controller: 'DashboardMonitoraggioController as vm'
          }
        }
      })
      .state('app.sprardb_monitoraggio_cruscotto', {
        url: '/sprardb/monitoraggio/cruscotto',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/monitoraggio/cruscotto.html',
            controller: 'CruscottoMonitoraggioController as vm'
          }
        }
      });

    unsavedWarningsConfigProvider.routeEvent = '$stateChangeStart';
    unsavedWarningsConfigProvider.navigateMessage =
    unsavedWarningsConfigProvider.reloadMessage  = "I dati non salvati andranno persi. Continuare?";


    ngQuillConfigProvider.set({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['link']
        ]
      },
      theme: 'snow',
      sanitize: true
    });
  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('TutorController', TutorController)
        .controller('AggiungiTutorController', AggiungiTutorController)
        .controller('CambiaRuoliController', CambiaRuoliController);

  /** @ngInject */
  function TutorController($scope, $mdSidenav, $mdDialog, api)
  {
    var vm = this;

    vm.loadTutor = loadTutor;
    vm.cambiaRuoli = cambiaRuoli;
    vm.aggiungiTutor = aggiungiTutor;
    vm.exportCsv = exportCsv;

    vm.user = api.user;
    vm.search = {
      'per-page': 10,
      page: 1
    };
    vm.quadrimestri = {1:'Q1',2:'Q2',3:'Q3'};
    vm.anno = new Date().getFullYear();
    vm.anni = [vm.anno -1, vm.anno, vm.anno +1];

    initPagination();
    loadTutor();

    function loadTutor()
    {
      var params = {anno: vm.anno};
      angular.merge(params, vm.search);
      vm.listaTutor = api.monitoraggio.tutor.query(params,function(res){
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });
    }

    function toggleSidenav(sidenavId)
    {
        $mdSidenav(sidenavId).toggle();
    }

    function initPagination()
    {
      vm.search.page = 1;
      vm.search['per-page'] = 10;
    }

    function aggiungiTutor(ev)
    {
      $mdDialog.show({
          controller: 'AggiungiTutorController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/monitoraggio/dialogs/aggiungi-tutor.html',
          targetEvent: ev,
          clickOutsideToClose: false
      }).then(loadTutor);
    }

    function cambiaRuoli(ev, tutor)
    {
      $mdDialog.show({
        controller: 'CambiaRuoliController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/monitoraggio/dialogs/cambia-ruoli-tutor.html',
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          tutor: tutor
        }
      }).then(loadTutor);
    }

    function exportCsv() {
      var columns = {
        cognome: 'Cognome',
        nome: 'Nome',
      }

      switch (vm.listaTutor.data[0].descrizione) {
        case('SEMESTRE'):
          columns = {
              ...columns,
              assegnate_S1: 'assegnate_S1',
              assegnate_S2: 'assegnate_S2',
              eseguite_S1: 'eseguite_S1',
              eseguite_S2: 'eseguite_S2',
          }
          break;
        case('QUADRIMESTRE'):
          columns = {
            ...columns,
            assegnate_Q1: 'assegnate_Q1',
            assegnate_Q2: 'assegnate_Q2',
            assegnate_Q3: 'assegnate_Q3',
            eseguite_Q1: 'eseguite_Q1',
            eseguite_Q2: 'eseguite_Q2',
            eseguite_Q3: 'eseguite_Q3'
          }
          break;
      }

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet([columns], {skipHeader: true});
      ws = XLSX.utils.sheet_add_json(ws, filterData(vm.listaTutor.data, columns), {origin: 'A2', skipHeader: true});
      XLSX.utils.book_append_sheet(wb, ws, 'Tutor '+vm.anno);

      var data = moment(new Date()).format('_YYYY-MM-DD_hh.mm');
      XLSX.writeFile(wb, "tutor_" + vm.anno + data +".xlsx");
    }

    function filterData(data, columns)
    {
      var res = [];
      angular.forEach(data, function(row) {
        var r = {};
        angular.forEach(columns, function (label, k) {
          r[k] = row[k];
        });
        res.push(r);
      });

      return res;
    }
  }

  /** @ngInject */
  function AggiungiTutorController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api)
  {
    var vmd = this;
    vmd.cancel = cancel;
    vmd.hide = hide;
    vmd.salva = salva;
    vmd.cercaTutor = cercaTutor;

    vmd.ruoli = ['TUTOR-AMMINISTRATIVO', 'TUTOR-QUALITATIVO'];

    function salva()
    {
      api.monitoraggio.tutor.save(vmd.newTutor, function(res){
        $mdDialog.hide();
        $mdToast.show(
          $mdToast.simple()
            .textContent('Tutor aggiunto.')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    }

    function cercaTutor(search)
    {
      if (vmd.listaTutor && vmd.listaTutor.$cancelRequest) {
        vmd.listaTutor.$cancelRequest();
      }
      if (search.length >= 3) {
        vmd.listaTutor = api.monitoraggio.tutor.cerca({search:search});
      }
    }

    function hide() {
      $mdDialog.hide();
    }
    function cancel() {
      $mdDialog.cancel();
    }  }

  /** @ngInject */
  function CambiaRuoliController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api, tutor)
  {
    var vmd = this;
    vmd.cancel = cancel;
    vmd.hide = hide;
    vmd.salva = salva;

    vmd.ruoli = ['TUTOR-AMMINISTRATIVO', 'TUTOR-QUALITATIVO'];
    vmd.tutor = api.monitoraggio.tutor.get(tutor);

    function salva()
    {
      api.monitoraggio.tutor.save(vmd.tutor, function(res){
        $mdDialog.hide();
        $mdToast.show(
          $mdToast.simple()
            .textContent('Ruoli salvati.')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    }

    function hide() {
      $mdDialog.hide();
    }
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('RapportoController', RapportoController);

    /** @ngInject */
    function RapportoController($scope, $mdSidenav, $mdDialog, $state, $stateParams, api, $mdToast)
    {
      var vm = this;

      vm.salva = salva;
      vm.stateUp = function(){ $state.go('^', {'#': 'dettagli'}); }

      vm.id = $stateParams.id;
      vm.user = api.user;
      var p = api.user.permissions;

      vm.dettaglio = api.monitoraggio.dettaglio.get({id: vm.id}, function(res) {
        vm.disabled = !(!res.validato && ((!res.inviato && res.created_by === vm.user.id)
          || (res.inviato && p.includes('edit-checklist-amm') && res.tipo === 'amministrativo')
          || (res.inviato && p.includes('edit-checklist-qual') && res.tipo === 'qualitativo')));

        if (res.visita.tipo === 'CONGIUNTO') {
          vm.altroTipo = res.tipo === 'amministrativo' ? 'qualitativo' : 'amministrativo';
        }
      });

      function salva()
      {
        var payload = ['id', 'rapporto', 'note', 'version'].reduce(function (payload, key) {
            payload[key] = vm.dettaglio[key];
            return payload;
        }, {});

        vm.dettaglio = api.monitoraggio.dettaglio.save(payload, function(res) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Informazioni Salvate')
              .position('bottom right')
              .hideDelay(3000)
          )
        });

      }

    }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('ChecklistController', ChecklistController);

    /** @ngInject */
    function ChecklistController($scope, $mdSidenav, $mdDialog, $state, $stateParams, api, $mdToast, $filter)
    {
      var vm = this;

      vm.exportCsv = exportCsv;
      vm.salva = salva;
      vm.getRange = getRange;
      vm.showHelp = showHelp;
      vm.stateUp = function(){ $state.go('^', {'#': 'dettagli'}); }

      var p = api.user.permissions;
      vm.id = $stateParams.id;
      var expand = 'owner.persona,visita.progettoMonitoraggio.progetto.tipologiaAccoglienza,progettoMonitoraggio.progetto.istats,progettoMonitoraggio.progetto.bandi,checklistTemplate,visita.enti,visita.stato,visita.esito,visita.report,visita.report.giudizio';
      vm.dettaglio = vm.d = api.monitoraggio.dettaglio.get({id: vm.id,expand:expand}, function(res){
        vm.template = res.checklistTemplate;
        vm.disabled = !(!res.validato && ((!res.inviato && res.created_by === api.user.id)
          || (res.inviato && p.includes('edit-checklist-amm') && res.tipo === 'amministrativo')
          || (res.inviato && p.includes('edit-checklist-qual') && res.tipo === 'qualitativo')));


        if(vm.d.checklist === null && vm.dettaglio.tipo === 'qualitativo') {
          //Settate temporaneamente i valori delle voci M5, N3, N10
          vm.d.checklist = {
            items: {
              M: {
                items: {
                  M5: {optionsId:599, note: "Campo non selezionabile"}}
              },
              N: {
                items: {
                  N3: {optionsId: 615, note: "Campo non selezionabile"},
                  N10: {optionsId: 640, note: "Campo non selezionabile"}
                }
              },
            }
          }
        }
      });



      function showHelp(subitem)
      {
        var alert = $mdDialog.alert({
          title: subitem.descrizione,
          htmlContent: subitem.help,
          ok: 'OK',
          clickOutsideToClose: true
        });

        $mdDialog.show(alert);
      }

      function exportCsv()
      {
        var wb = XLSX.utils.book_new();
        var data = serializzaChecklist();
        let nome = 'checklist_'+ vm.dettaglio.tipo.substring(0, 4);

        var dataInizio = $filter('date')(vm.dettaglio.visita.data, 'dd/MM/yyyy') || '';
        var dataInvio =  vm.dettaglio.visita.report ? $filter('date')(vm.dettaglio.visita.report.dataInvio, 'dd/MM/yyyy') || '' : '';
        var entePartner = $filter('filter')(vm.dettaglio.visita.enti, {ruolo: 'partner'});
        var enteAderente = $filter('filter')(vm.dettaglio.visita.enti, {ruolo: 'aderente'});
        var enteAttuatore = $filter('filter')(vm.dettaglio.visita.enti, {ruolo: 'attuatore'});
        var tipAccoglienza = vm.dettaglio.visita.tipAccoglienza;
        var stato = vm.dettaglio.visita.stato.descrizione;
        let report = vm.dettaglio.visita.report;


        let default_sheet = XLSX.utils.json_to_sheet([{
          "Codice Visita": vm.dettaglio.visita.id,
          "Codice Progetto": vm.dettaglio.visita.progettoMonitoraggio.codiceProgetto,
          "Categoria": vm.dettaglio.visita.progettoMonitoraggio.progetto.bandi[0]?.descrizione,
          "Tipologia di accoglienza": displayMultiple(tipAccoglienza, 'descrizione'),
          "Regione": vm.dettaglio.visita.progettoMonitoraggio.progetto.istats.regione,
          "Provincia": vm.dettaglio.visita.progettoMonitoraggio.progetto.istats.provincia,
          "Ente locale capofila": vm.dettaglio.visita.progettoMonitoraggio.enteLocale,
          "Posti finanziati da FU (con eventuale variazione inclusa)": vm.dettaglio.visita.numeroPosti,
          "Enti locali partner o consorziati": displayMultiple(entePartner, 'nomeEnte'),
          "Enti locali aderenti al progetto": displayMultiple(enteAderente, 'nomeEnte'),
          "Enti attuatori": displayMultiple(enteAttuatore, 'nomeEnte'),
          "Posti attivi": vm.dettaglio.visita.numeroPostiAttivi,
          "Strutture di accoglienza visitate": vm.dettaglio.visita.numeroStruttureVisitate,
          "Strutture di accoglienza": vm.dettaglio.visita.numeroStrutture,
          anno: vm.dettaglio.visita.progettoMonitoraggio.anno,
          "Eseguito in data": dataInizio,
          "Numero giorni di visita": vm.dettaglio.visita.numeroGiorni,
          "Data Invio": dataInvio,
          "In loco/a distanza": vm.dettaglio.visita.daRemoto ? "D" : "L",
          "Tipologia monitoraggio": vm.dettaglio.visita.tipo,
          "Presenza Prefettura": vm.dettaglio.visita.presenzaPrefettura ? "SI" : "NO",
          "Presenza Ministero": vm.dettaglio.visita.presenzaMinistero ? "SI" : "NO",
          "Stato del monitoraggio": stato,
          "Monitoraggio con richieste": report ? (report.richieste ? 'Con richieste' : 'Senza richieste') : null,
          "Valutazione Sintetica presente nel report di monitoraggio": report ? report.giudizio?.descrizione : null,
          "Esito del monitoraggio": vm.dettaglio.visita.esito?.descrizione,
          "Segnalato MinInt": vm.dettaglio.visita.dataSegnalazione !== null ? "SI" : "NO",
          "Data segnalazione al MinInt": vm.dettaglio.visita.dataSegnalazione !== null ?  $filter('date')(vm.dettaglio.visita.dataSegnalazione, 'dd/MM/yyyy')  : null,
          "Score della checklist": vm.dettaglio.checklist.score,
          "Punteggio della checklist": vm.dettaglio.checklist.punteggio,
          "Checklist con richieste": vm.dettaglio.richieste ? 'Con richieste' : 'Senza richieste',
          "Valutazione Sintetica della checklist": vm.dettaglio.checklist.giudizio?.descrizione,

        }]);
        XLSX.utils.book_append_sheet(wb, default_sheet, 'default');

        let checklist_sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, checklist_sheet, nome);

        var date = moment(new Date()).format('_YYYY-MM-DD_hh.mm');
        XLSX.writeFile(wb, nome +'_'+ vm.dettaglio.id + date +".xlsx");
      }

      function displayMultiple(array, displayName)
      {
        if (angular.isArray(array)) {
          return array.map(function(val) {
            return val[displayName];
          }).join(', ');
        }
      }

      function serializzaChecklist()
      {
        let data = [];
        let checklist = vm.dettaglio.checklist;
        let riga = angular.merge({},
          {
            codice: null,
            score: null,
          },
          vm.dettaglio.tipo === 'amministrativo' ? {docPresente: null, docRichiesta: null} : {label: null},
          {
            note: null,
            descrizione: null,
          }
        );

        angular.forEach(vm.template, function(macro, macroId) {
          let row = angular.merge({}, riga, {
            codice: macro.codice,
            score: $filter('number') (checklist.items[macroId]?.score, 10),
            descrizione: macro.descrizione
          });
          data.push(row);
          angular.forEach(macro.items, function(micro, microId) {
            let row = angular.merge({}, riga, {codice: micro.codice});

            let checklistItem = checklist.items[macroId]?.items[microId];
            if (checklistItem) {
              let range = getRange(micro.range);
              row.score = checklistItem.score;

              if (vm.dettaglio.tipo === 'amministrativo') {
                angular.merge(row, {
                  docPresente: checklistItem.docPresente ? 'Sì' : null,
                  docRichiesta: checklistItem.docRichiesta  ? 'Sì' : null
                });
              }

              let selectedOption = range.find(function(option){
                return option.key === checklistItem.optionsId;
              });

              if (selectedOption) {
                row.score = selectedOption.value;
                if (vm.dettaglio.tipo === 'qualitativo') {
                  angular.merge(row, {label: selectedOption.label});
                }
              }

              angular.merge(row, {note: checklistItem.note});
            }
            angular.merge(row, {descrizione: micro.descrizione});

            data.push(row);
          })
        })

        return data;
      }

      function getRange(range)
      {
        if (!angular.isArray(range)) {
          if (vm.dettaglio.visita === undefined) {
            range = [];
          } else {
            range = range[vm.dettaglio.visita.progettoMonitoraggio.progetto.tipologiaAccoglienza.descrizione];
          }
        }
        return range;
      }

      //Funzione Salvataggio check-List mantenere le caselle in rosso
      function salva()
      {
        var payload = ['id', 'checklist', 'version'].reduce(function (payload, key) {
            payload[key] = vm.dettaglio[key];
            return payload;
        }, {});

        api.monitoraggio.dettaglio.save(payload, function(res) {
          angular.merge(vm.dettaglio,res);
          $mdToast.show(
            $mdToast.simple()
            .textContent('Informazioni Salvate')
            .position('bottom right')
            .hideDelay(3000)
            )
          $scope.checklistForm.$setPristine();


          if ($scope.checklistForm.$invalid) {
            angular.forEach($scope.checklistForm.$error, function (field) {
              angular.forEach(field, function(errorField){
                errorField.$setTouched();
              })
            });
          }

        });

        $scope.checklistForm.$setPristine();


        if ($scope.checklistForm.$invalid) {
          angular.forEach($scope.checklistForm.$error, function (field) {
            angular.forEach(field, function(errorField){
              errorField.$setTouched();
            })
          });
        }
      }




    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.monitoraggio')
    .controller('AzioniDettaglioController', AzioniDettaglioController)
    .directive('azioniDettaglio', azioniDettaglio);

  /** @ngInject */
  function AzioniDettaglioController($scope, api, $mdDialog, $mdToast, $state)
  {
    var vm = this;

    vm.canDuplicate = canDuplicate;
    vm.canRifiutaDettaglio = canRifiutaDettaglio;
    vm.canValidaDettaglio = canValidaDettaglio;
    vm.duplicaDettaglio = duplicaDettaglio;
    vm.eliminaDettaglio = eliminaDettaglio;
    vm.inviaDettaglio = inviaDettaglio;
    vm.rifiutaDettaglio = rifiutaDettaglio;
    vm.validaDettaglio = validaDettaglio;
    vm.invalidaDettaglio = invalidaDettaglio;

    var p = api.user.permissions;
    vm.user = api.user;
    vm.dettaglio = $scope.ngModel;
    vm.duplica = $scope.duplica;

    vm.dettaglio.disabled = vm.dettaglio.visita.statoId !== 2
      || !(!vm.dettaglio.validato && ((!vm.dettaglio.inviato && vm.dettaglio.created_by === api.user.id)
      || (vm.dettaglio.inviato && p.includes('edit-checklist-amm') && vm.dettaglio.tipo === 'amministrativo')
      || (vm.dettaglio.inviato && p.includes('edit-checklist-qual') && vm.dettaglio.tipo === 'qualitativo')));

      vm.dettaglio.inviato = vm.dettaglio.timeInvio !== null;

    if (vm.dettaglio.inviato) {
      vm.dettaglio.dataInvio = vm.dettaglio.timeInvio; // Converti il timestamp in una data nell'hmtl
      if(vm.dettaglio.inviatoBy) {
        vm.dettaglio.tutorInviato = vm.dettaglio.inviatoBy.persona.nomeCognome;
      }
    } else {
      vm.dettaglio.dataInvio = null;
      vm.dettaglio.tutorInviato = null;
    }

    vm.currentState = $state.current;

    console.log(vm.dettaglio);

    function canDuplicate()
    {
      if (vm.dettaglio.visita.statoId !== 2) return false;

      if (vm.dettaglio.tipo === 'amministrativo') {
        return vm.dettaglio.visita.tutorAmmId === api.user.id || api.user.permissions.includes('add-checklist-uff-amm')
      }

      if (vm.dettaglio.tipo === 'qualitativo') {
        return vm.dettaglio.visita.tutorQualId === api.user.id || api.user.permissions.includes('add-checklist-uff-qual')
      }
    }

    function canRifiutaDettaglio()
    {
      if (vm.dettaglio.rifiutato || !vm.dettaglio.timeInvio) return false;

      if (vm.dettaglio.validato && !api.user.permissions.includes('rifiuta-checklist-validata')) return false;

      if (vm.dettaglio.tipo === 'amministrativo') return api.user.permissions.includes('edit-checklist-amm');
      if (vm.dettaglio.tipo === 'qualitativo') return api.user.permissions.includes('edit-checklist-qual');

      return false;
    }

    function canValidaDettaglio()
    {
      if (vm.dettaglio.validato || !vm.dettaglio.inviato) return false;

      if (vm.dettaglio.tipo === 'amministrativo') return api.user.permissions.includes('edit-checklist-amm');
      if (vm.dettaglio.tipo === 'qualitativo') return api.user.permissions.includes('edit-checklist-qual');

      return false;
    }

    function duplicaDettaglio()
    {
      var confirm = $mdDialog.confirm()
        .title('Duplicazione dettaglio')
        .htmlContent('Questo creerà un nuovo dettaglio con le stesse informazioni del dettaglio selezionato.')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.duplica(vm.dettaglio, function(res) {
          loadDettagli();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio duplicato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function eliminaDettaglio()
    {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler eliminare il dettaglio?')
        .htmlContent('Il dettaglio sarà eliminato.')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.delete({id: vm.dettaglio.id, version: vm.dettaglio.version}, function(res) {
          loadDettagli();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio eliminato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function invalidaDettaglio()
    {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler invalidare il dettaglio?')
        .htmlContent('Il dettaglio sarà invalidato.')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.invalida({id: vm.dettaglio.id, version: vm.dettaglio.version}, function(res) {
          loadDettagli();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio invalidato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function inviaDettaglio()
    {
      //In caso di richiesta selezionata o no
      let messRichiesta = vm.dettaglio.richieste == 1
        ? "<br><b>*ATTENZIONE CI SONO DELLE RICHIESTE SELEZIONATE RIGUARDANTI LA VISITA.</b>"
        : "<br><b>*ATTENZIONE NON CI SONO DELLE RICHIESTE SELEZIONATE RIGUARDANTI LA VISITA.</b>";
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler inviare il dettaglio?')
        .htmlContent('Il dettaglio sarà inviato per la revisione al Servizio Centrale e non sarà più possibile modificarlo.'+messRichiesta)
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.invia(vm.dettaglio, function(res) {
          $scope.$parent.$parent.vm.loadVisita();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio inviato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function rifiutaDettaglio()
    {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler rifiutare il dettaglio?')
        .htmlContent('Il dettaglio sarà rifiutato')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.rifiuta(vm.dettaglio, function(res) {
          reloadVisite();

          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio rifiutato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function validaDettaglio()
    {
      //In caso di richiesta selezionata o no
      let messRichiesta = vm.dettaglio.richieste == 1
        ? "<br><b>*ATTENZIONE CI SONO DELLE RICHIESTE SELEZIONATE RIGUARDANTI LA VISITA.</b>"
        : "<br><b>*ATTENZIONE NON CI SONO DELLE RICHIESTE SELEZIONATE RIGUARDANTI LA VISITA.</b>";
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler validare il dettaglio?')
        .htmlContent('Il dettaglio sarà validato e la valutazione indicata comparirà nel report.'+messRichiesta)
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.dettaglio.valida(vm.dettaglio, function(res) {
          reloadVisite();

          $mdToast.show(
            $mdToast.simple()
              .textContent('Dettaglio validato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function loadDettagli()
    {
      //1 parent è ng-repeat
      $scope.$parent.$parent.vm.loadDettagli();
    }

    function reloadVisite()
    {
      //1 parent è ng-repeat
      var parentVm = $scope.$parent.$parent.vm;
      if (typeof parentVm.loadVisita == 'function') {
        parentVm.loadVisita();
      } else {
        parentVm.loadDettagli();
        parentVm.loadMonitoraggiDaConfermare();
      }
    }

  }

  function azioniDettaglio($compile)
  {
    return {
      require: ['ngModel'],
      restrict: 'E',
      scope: {
        ngModel: '=',
        duplica: '<'
      },
      controller: 'AzioniDettaglioController as vm',
      templateUrl: 'app/main/sprardb/monitoraggio/dettaglio/azioni-dettaglio.html'
    };

  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.liste_distribuzione.liste_distribuzione', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_liste_distribuzione', {
                    url: '/sprardb/liste_distribuzione',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/liste_distribuzione/liste_distribuzione/liste_distribuzione.html',
                            controller: 'ListedistribuzioneController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_liste_distribuzione_en', {
                    url: '/sprardb/liste_distribuzione/:attivo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/liste_distribuzione/liste_distribuzione/liste_distribuzione.html',
                            controller: 'ListedistribuzioneController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_liste_distribuzione_persone', {
                    url: '/liste_distribuzione/persone',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/liste_distribuzione/persone/persone.html',
                            controller: 'PersoneController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })
                .state('app.sprardb_liste_distribuzione_comunicazioni_comunicazione', {
                    url: '/liste_distribuzione/comunicazioni/comunicazione',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/liste_distribuzione/comunicazioni/comunicazione/comunicazione.html',
                            controller: 'ComunicazioniController as vm'
                        },
                    },
                    data: {
                        Filter: {}
                    }

                })

                ;


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/sprardb/rendicontazioni');

        // Navigation

//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.enti', {
//            title: 'Ricerca enti',
//            icon: 'icon-account-box-outline',
//            state: '',
//            weight: 2
//        });
//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.persone', {
//            title: 'Ricerca persone',
//            icon: 'icon-account-multiple-outline',
//            state: 'app.sprardb_liste_distribuzione_persone',
//            weight: 3
//        });
//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.enabled', {
//            title: 'Liste attive',
//            icon: 'icon-view-list',
//            state: 'app.sprardb_liste_distribuzione_en({attivo:1})',
//            weight: 4
//        });
//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.comunicazioni_enabled', {
//            title: 'Liste comunicazioni',
//            icon: 'icon-view-list',
//            //state: 'app.sprardb_liste_distribuzione_comunicazioni',
//            state: '',
//            weight: 5
//        });
//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.comunicazioni_new', {
//            title: 'Componi comunicazione',
//            icon: 'icon-plus-network',
//            //state: 'app.sprardb_liste_distribuzione_comunicazioni_comunicazione',
//            state: '',
//            weight: 6
//        });
//        msNavigationServiceProvider.saveItem('sprardb.liste_distribuzione.code', {
//            title: 'Coda',
//            icon: 'icon-cog-box',
//            state: '',
//            weight: 7
//        });
    }
    ;

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.liste_distribuzione.liste_distribuzione')
            .controller('PersoneController', PersoneController)
            .controller('DialogListeController', DialogListeController);

    /** @ngInject */
    function PersoneController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api, $q)
    {
        var vm = this;
        vm.datiPersone = {};
        vm.allLoaded = false;
        
        vm.OpenAggiungiAListaDialog = OpenAggiungiAListaDialog;
        vm.salvaLista = salvaLista;
        
        vm.selected = [];
        vm.options = {
            rowSelection: true,
            multiSelect: true,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        
        vm.limitOptions = [5, 10, 15, 20];
        
        vm.searched = false;
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 15;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;
        // Data
        //if ($state.params.attivo) {
        //    vm.allsearchs['query[]'][1]['attivo'] = $state.params.attivo;
        //}
        
        vm.persone = null;
       
        api.persone.persona.like(vm.allsearchs, function (response) {
            vm.persone = response;
            vm.links = response._links;
            vm.meta = response._meta;            
        });  
        api.progettos.progetto.distinct({nome: 'distinct'}, function (response) {
            vm.progettos = response.data;
        });
        api.istats.istat.distinct({regione: 'distinct'}, function (response) {
            vm.regiones = response.data;
        });        
       
        /***
        vm.selectedItem = [];
        vm.log = function (item) {
            console.log(item);
            vm.selectedItem.insert = item;
        }   
        ***/
        
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        vm.ricerca = {
            'progettos-nome': null,            
            'residenza-regione': null,
            'tags-id': null
        };
        vm.ricercalabel = {
            'progettos-nome': 'Progetto: ',            
            'residenza-regione': 'Regione: ',
            'tags-id': 'Tag: '
        };
        vm.ricerca2 = "";
        vm.searched = false;
        vm.search2 = "";
        vm.mostraitag = false;     
        // Methods
        vm.exists = msUtils.exists;
        vm.pager = pager;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.orderby = orderby;
        
        vm.colors = ['md-blue-grey-400-bg', 'md-blue-grey-600-bg', 'md-teal-300-bg', 'md-teal-700-bg', 'md-amber-300-bg', 'md-amber-700-bg', 'md-grey-400-bg', 'md-grey-800-bg', 'md-light-green-300-bg', 'md-light-green-500-bg', 'md-red-500-bg', 'md-red-900-bg', 'md-cyan-800-bg', 'md-cyan-400-bg', 'md-lime-300-bg', 'md-lime-500-bg', 'md-blue-400-bg', 'md-blue-900-bg', 'md-pink-200-bg', 'md-pink-700-bg', 'md-light-green-900-bg', 'md-lime-900-bg', 'md-blue-grey-900-bg'];

        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            //console.log(vm.ricerca2);
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].cognome = vm.ricerca2;                
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            //console.log(vm.allsearchs);
            api.persone.persona.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.persone = d;
                vm.links = d._links;
                vm.meta = d._meta;                
            }
            );
            vm.searched = true;
        }
        
        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            vm.dataFilter.sort = order + field;
            api.persone.persona.search(vm.dataFilter, function (response) {
                vm.persone = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['nome'] = string;
            vm.ricerca2['operatore'] = 'OR';
            vm.ricerca2['cognome'] = string;
            vm.ricerca2['operatore'] = 'OR';            
            api.persone.persona.like(vm.ricerca2, function (response) {
                vm.persone = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }        
        
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            //console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.persone.persona.search({}, function (response) {
                    vm.persone = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.persone.persona.search({}, function (response) {
                    vm.persone = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.persone.persona.search({}, function (response) {
                vm.persone = response;
                vm.contacts = response.data;                
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        
        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }        

        vm.liste = null;
        function OpenAggiungiAListaDialog(ev)
        {
            api.listedistribuzione.lista.search({fields: "id,nome", pagination: "10000", sort: "id"}, function(response){
                vm.liste = response;
//                console.log(response);
                $mdDialog.show({
                    controller: 'DialogListeController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/liste_distribuzione/persone/dialogs/aggiungi_a_lista-dialog.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Liste: vm.liste,
                        Persone: vm.selected,
                        SalvaLista: vm.salvaLista,                        
                    }
                });
            });
        }
        
        function salvaLista(data)
        {
            //console.log(data.persone);
            //console.log(data.liste);
            //console.log(data.listaNew);
            
            if (data.listaNew) 
            {
                var lista = {
                    id: null,
                    nome: data.listaNew
                    //attivo: '1'
                };
                api.listedistribuzione.lista.save(lista, function (response) {
                    console.log('response lista save');
                    console.log(response);
                    data.liste = [];
                    data.liste.push(response.id);
                    saveLista(data);
                });                
            }
            else {
                saveLista(data);
            }
            
        }    
        
        function saveLista(data)
        {
            //console.log(data.persone);
            //console.log(data.liste);
            angular.forEach(data.persone, function (persona) {            
                var payload = [];
                angular.forEach(data.liste, function (lista) {
                    var pushpayload = {
                        persona_id: persona, 
                        id: lista};
                    payload.push(pushpayload);
                });            
                var hasmanyliste = {modelrelation: 'Personahaslistadistribuzione', idname: 'persona_id', idvalue: persona, idnamefk: 'listaDistribuzione_id', idnamePayload: 'id', payload: payload};            
                console.log(hasmanyliste);
                api.persone.persona.hasmany(hasmanyliste, function (response) {
                    console.log('response update listes');
                    console.log(response);
                });                
            
            });          
            
            //occorre mostrare il messaggio e ricaricare la pagina solo al termine di tutte le operazioni sul db
            //ora lo gestiamo con il timeout, in seguita andrà gestito con un servizio
            
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Attendere prego...')
                    .position('bottom right')
                    .hideDelay(3000)
            );                                  
            
            setTimeout(function(){ 
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati salvati correttamente')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(
                        $state.go('app.sprardb_liste_distribuzione_persone', {}, {reload: true, inherit: false})
                );                      
            }, 3000);
            
        }            
        
    }
    
    function DialogListeController($scope, $state, $mdDialog, Liste, Persone, SalvaLista)
    {
        var vmd = this;
        vmd.liste = Liste;
        vmd.persone = Persone;
        vmd.aggiungiALista = aggiungiALista;
        vmd.selected = {};
        vmd.data = {};
        
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        
        function aggiungiALista(){
            $mdDialog.hide();
            vmd.data.persone = vmd.persone;
            vmd.data.liste = vmd.selected.listaId;
            vmd.data.listaNew = vmd.selected.listaNew;
            SalvaLista(vmd.data);
        }
    }


})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.liste_distribuzione.liste_distribuzione')
            .controller('ListedistribuzioneController', ListedistribuzioneController)

    /** @ngInject */
    function ListedistribuzioneController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, $q)
    {
        var vm = this;
        vm.datiListe = {};
        vm.allLoaded = false;
        
        vm.selected = [];
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.limitOptions = [5, 10, 15, 20];
        
        vm.searched = false;
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 15;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;
        // Data
        if ($state.params.attivo) {
            vm.allsearchs['query[]'][1]['attivo'] = $state.params.attivo;
        }
        
        vm.liste = null;
       
        api.listedistribuzione.lista.like(vm.allsearchs, function (response) {
            vm.liste = response;
            vm.links = response._links;
            vm.meta = response._meta;            
        });  
        
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        vm.ricerca = {
            'progettos-nome': null,            
            'residenza-regione': null,
            'tags-id': null
        };
        vm.ricercalabel = {
            'progettos-nome': 'Progetto: ',            
            'residenza-regione': 'Regione: ',
            'tags-id': 'Tag: '
        };
        vm.ricerca2 = "";
        vm.searched = false;
        vm.search2 = "";
        vm.mostraitag = false;     
        // Methods
        vm.exists = msUtils.exists;
        vm.pager = pager;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.orderby = orderby;
        
        vm.colors = ['md-blue-grey-400-bg', 'md-blue-grey-600-bg', 'md-teal-300-bg', 'md-teal-700-bg', 'md-amber-300-bg', 'md-amber-700-bg', 'md-grey-400-bg', 'md-grey-800-bg', 'md-light-green-300-bg', 'md-light-green-500-bg', 'md-red-500-bg', 'md-red-900-bg', 'md-cyan-800-bg', 'md-cyan-400-bg', 'md-lime-300-bg', 'md-lime-500-bg', 'md-blue-400-bg', 'md-blue-900-bg', 'md-pink-200-bg', 'md-pink-700-bg', 'md-light-green-900-bg', 'md-lime-900-bg', 'md-blue-grey-900-bg'];

        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            //console.log(vm.ricerca2);
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].descrizione = vm.ricerca2;                
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            //console.log(vm.allsearchs);
            api.listedistribuzione.lista.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.liste = d;
                vm.links = d._links;
                vm.meta = d._meta;                
            }
            );
            vm.searched = true;
        }
        
        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            vm.dataFilter.sort = order + field;
            api.listedistribuzione.lista.search(vm.dataFilter, function (response) {
                vm.liste = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['nome'] = string;
            vm.ricerca2['operatore'] = 'OR';
            vm.ricerca2['descrizione'] = string;
            vm.ricerca2['operatore'] = 'OR';            
            api.listedistribuzione.lista.like(vm.ricerca2, function (response) {
                vm.liste = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }        
        
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            //console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.listedistribuzione.lista.search({}, function (response) {
                    vm.liste = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.listedistribuzione.lista.search({}, function (response) {
                    vm.liste = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.listedistribuzione.lista.search({}, function (response) {
                vm.liste = response;
                vm.contacts = response.data;                
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        
        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }        

    }

    
      

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entisegnalatori')
            .controller('DettaglioESController', DettaglioESController)
            .controller('DialogPersoneEnteSController', DialogPersoneEnteSController)
            .controller('DialogExtraEnteSController', DialogExtraEnteSController)
            .controller('DialogSegnalatoriNewController', DialogSegnalatoriNewController)
            .filter('filterByArray', filterByArray);

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    /** @ngInject */
    function DettaglioESController($scope, $state, $mdSidenav, msUtils, $mdDialog, $document, api, extra, $mdToast)
    {

        var vm = this;
        var Persona = {};
        vm.id = $state.params.id;
        vm.provincias = [];
        vm.istats = [];
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.isSegnalatore = api.isSegnalatore;
        vm.apiuser = api.user;
        //vm.contact = {};
        vm.loadentes = function () {
            api.entes.ente.get({id: vm.id}).$promise.then(function (response) {
                Persona = response;
                vm.contact = angular.copy(Persona);
                console.log('ente:', vm.contact);
                if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
                    vm.caricaProvince(vm.contact.codRegione);
                }
                if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
                    vm.caricaComuni(vm.contact.codProvincia);
                }
            }, function (response) {
            });
            return Persona;
        };
        vm.loadentes();



        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }
        //vm.tags = Tags.data;

        api.entetipos.entetipo.cerca({pagination: 50, enteTipo_id_IN: "1,3", sort: "descrizione"}, function (response) {
            vm.tempentetipo = response.data;
        });
        api.enteruolos.enteruolo.cerca({pagination: 50}, function (response) {
            vm.enteruolos = response.data;
        });
        api.personaruolos.personaruolo.cerca({pagination: 50}, function (response) {
            vm.personaruolos = response.data;
        });
        api.tags.tag.cerca({pagination: 50, sort: "tag", tipo: "generico"}, function (response) {
            vm.tags = response.data;
        });

        vm.evento = "update";

        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;

        vm.gotoEnti = gotoEnti;
        vm.gotoPersonaDettaglio = gotoPersonaDettaglio;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = vm.regiones;
        });

        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                enteTipo_id: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                entetipo: null,
                enteextras: null,
                tags: null,
                progettos: null,
                segnalatore: 1,
                attivo: 1
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);

        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }

        console.log('isnew:' + vm.isnew);
        console.log('contact:');
        console.log(vm.contact);
        console.log('contact.tags:');
        console.log(vm.contact.tags);

        // Methods
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoStruttura = gotoStruttura;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openPersoneEnteDialog = openPersoneEnteDialog;

        //////////

        /**
         * Save contact
         */
        function saveContact()
        {
            console.log('isnew:', vm.isnew);
            console.log('ente:', vm.contact);

            if (vm.isnew) {
                api.entes.ente.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    console.log(response);
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Salvataggio effettuato.')
                            .position('bottom right')
                            .hideDelay(2000)
                            );
                    $state.go('app.sprardb_entisegnalatori');
                });
            }
            if (!vm.isnew) {
                api.entes.ente.aggiorna(vm.contact, function (response) {
                    console.log(response);
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Aggiornamento effettuato.')
                            .position('bottom right')
                            .hideDelay(2000)
                            );
                    $state.go('app.sprardb_entisegnalatori');
                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoEnti() {
            $state.go('app.sprardb_entes');
        }

        function gotoPersonaDettaglio(id) {
            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: id});
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }
        function gotoStruttura(ids, idp)
        {
            $state.go('app.sprardb_progetti_strutture_struttura', {id: ids, progetto_id: idp});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare questo ente?')
                    .htmlContent('<b>' + vm.contact.nome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.entes.ente.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoEnti();
                });

            });

        }


        function openExtraDialog(ev, item, index) {
            extra.init('ente', item, index);
            $mdDialog.show({
                controller: 'DialogExtraEnteController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }
        vm.tempruolo2 = null;
        function openPersoneEnteDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                api.personaruolos.personaruolo.get({}, function (response) {
                    vm.tempruolo2 = response;
                    $mdDialog.show({
                        controller: 'DialogPersoneEnteSController',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogPersoneEnteSForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllRuolo2: vm.tempruolo2,
                            Ente: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });
            });
        }


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vm.openPersoneDialog = openPersoneNewDialog;
        function openPersoneNewDialog(ev, ente, index, newlink) {

            var persona_id = 0;
            var ente_id = ente.id;
            var progetto_id = 0;
            if (index !== null) {
                persona_id = vm.contact.personas[index].id;
            }
            var enti_collegati = [];//angular.copy(vm.progetto.entes);
            var progetti_collegati = [];
//            var r_persona_progetto = angular.copy(vm.personaruoloprogettos);
//            var r_persona_ambito = angular.copy(vm.personaruoloambitos);
//            var r_persona_ente = angular.copy(vm.personaruoloentes);
//            var r_ente_progetto = angular.copy(vm.enteruoloprogetto);
            $mdDialog.show({
                controller: 'DialogSegnalatoriNewController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogSegnalatoriNewForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Ente: ente,
                    index: index,
                    Regioni: vm.regiones,
                    newlink: newlink,
                    enti_collegati: enti_collegati,
                    persona_id: persona_id,
                    progetto_id: progetto_id,
                    ente_id: ente_id,
                    progetti_collegati: progetti_collegati
                }
            });
        }
        vm.openRegisterDialog = openRegisterDialog;
        function openRegisterDialog(ev, persona_id, gruppo_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: false,
                    isnew: true,
                    gruppo_id: gruppo_id
                }
            }).then(function (datastore) {
                if (datastore.doit) {
                    console.log(datastore);
                    datastore.sendemail = 1;
                    api.users.log.createuser(datastore, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Nuovo profilo creato.')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                $state.reload()
                                );
                    });
                }
            });
        }

        vm.openUserDialog = openUserDialog;
        function openUserDialog(ev, persona_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: true,
                    isnew: false,
                    gruppo_id: false
                }
            }).then(function (datastore) {
                console.log("datastore", datastore);
                if (datastore.doit) {
                    if (datastore.disableuser === true) {
                        //disabilita solo utente
                        api.users.log.toggleuser({persona_id: datastore.persona_id}, function (response) {
                            console.log(response);
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Attivazione profilo cambiata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    } else {
                        //startreset
                        //passwordreset
                        api.users.log.startreset({email: datastore.email, username: datastore.username}, function (pr) {
                            var passwordresettoken = pr.token;
//                            angular.forEach(pr, function (opr, k) {
//                                if (k >= 0 && k <= 42) {
//                                    passwordresettoken = passwordresettoken + opr;
//                                }
//                            })
                            api.users.log.passwordreset({token: passwordresettoken, password: datastore.password}, function (us) {
                                if (angular.isDefined(us.id)) {
                                    var email = {};
                                    email.to = [];
                                    email.to.push(us.email);
                                    email.oggetto = "Banca dati SC - Cambiamento Password";
                                    email.corpo = "Gentile utente,<br>Il suo profilo è stato aggiornato come richiesto, le riportiamo di seguito le credenziali di accesso.<br><br>Indirizzo di accesso alla Banca Dati:<br>http://bancadati.sprar.it<br><br>Le credenziali da adoperare al suo accesso sono:<br>Nome Utente: " + us.username + "<br>Password: " + datastore.password + "<br><br><br>Cordiali Saluti<br>Reparto Assistenza Tecnica SC";
                                    api.emails.send.send(email, function (rrr) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Invio email compeltato.')
                                                .position('bottom right')
                                                .hideDelay(2000)
                                                );
                                    });
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Password cambiata per utente ' + us.username + ' ' + us.email + '. Attendere prego.')
                                            .position('bottom right')
                                            .hideDelay(7000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento password. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        });
                        if (angular.isDefined(datastore.modificag) && datastore.modificag == true) {
                            api.users.log.changegroup(datastore, function (ug) {
                                if (angular.isDefined(ug.id)) {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Profili correttamente modificati')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento profili. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        }
                    }
                }
            });
        }


        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }

        vm.checkTelefono = checkTelefono;
        function checkTelefono(ev) {
            api.entes.ente.search({telefono: vm.persondata.telefono, fields: "id,nome,telefono,piva,email", attivo: 1}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1) {
                            $scope.enteNForm.telefono.$setValidity("unique", false);
                        } else {
                            $scope.enteNForm.telefono.$setValidity("unique", true);
                        }
                    });
        }
        vm.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vm.persondata.email)) {
                api.entes.ente.search({email: vm.persondata.email, fields: "id,nome,telefono,piva,email", attivo: 1}).$promise.then(
                        function (response) {
                            if (response.data.length >= 1) {
                                $scope.enteNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.enteNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.registerForm.email.$setValidity("unique", true);
            }
        }
        vm.checkCf = checkCf;
        function checkCf(ev) {
            api.entes.ente.search({piva: vm.persondata.piva, fields: "id,nome,telefono,piva", attivo: 1}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1) {
                            $scope.enteNForm.piva.$setValidity("unique", false);
                        } else {
                            $scope.enteNForm.piva.$setValidity("unique", true);
                        }
                    });
        }


    }

    function DialogSegnalatoriNewController($scope, $state, $mdDialog, Ente, api, index, Regioni, newlink, ricerca, enti_collegati, progetti_collegati, $mdToast, persona_id, ente_id, progetto_id, locals)
    {
        var vmd = this;
        vmd.locals = locals;
        vmd.ente_id = ente_id;
        //vmd.persona_id
        //vmd.ente_id
        vmd.index = index;
        vmd.ente_nome = Ente.nome;
        vmd.persona_id = null;
        vmd.persona_nome = null;
        vmd.personas = angular.copy(Ente.personas);
        vmd.personastudis = ricerca.personastudis;
        console.log("vmd.personastudis", vmd.personastudis);

        vmd.personaruoloentes = ricerca.personaruoloentes;
        vmd.enti_collegati = enti_collegati;
        vmd.progetti_collegati = progetti_collegati;


        if (vmd.enti_collegati.length == 0) {
            vmd.enti_collegati.push(Ente);
        }

        vmd.personaHasEntes = [];
        vmd.phe = [];
        angular.forEach(vmd.enti_collegati, function (e) {
            if (angular.isUndefined(vmd.phe[e.id])) {
                vmd.phe[e.id] = [];
            }
        });
        console.log("vmd.phe:", vmd.phe);
        vmd.indexEnte = [0];
        vmd.phe_new = [
            {},
            {},
            {},
            {},
            {},
            {}
        ];


        vmd.persona = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            dataNascita: '1900-12-09',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            enteruolos: [],
            ruolos: [],
            nascita: [],
            studi_id: 0
        };
        vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
        vmd.allpersonas = [];
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewpersona = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewpersona = true;
            vmd.phe = angular.copy(vmd.phe_new);
        }
        vmd.incaricosSelected = [];
        vmd.incaricosSelected_ro = [];
        vmd.incaricosSelected_rw = [];

        vmd.phe_selected = [];

        if (vmd.index !== null) {
            vmd.persona_id = Ente.personas[index].id;
            vmd.persona_nome = Ente.personas[index].cognome + ' ' + Ente.personas[index].nome;
            vmd.persona = angular.copy(Ente.personas[index]);
            vmd.allpersonas.push(angular.copy(Ente.personas[index]));

        }
        vmd.regiones = Regioni;
        vmd.regiones2 = Regioni;
        vmd.provincias = [];
        vmd.istats = [];
        vmd.provincias2 = [];
        vmd.istats2 = [];
        vmd.nazionalitas = ricerca.naziones;

        vmd.ricerca = {
            cognome: null,
        };
        vmd.ricerca['entes-nome'] = null;
        vmd.ricerca['istats-comune'] = null;
        vmd.personaselezionato = {
            id: null
        };


        vmd.savenew = savenew;
        vmd.delete = del;
        vmd.cercaPersona = cercaPersona;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.caricaProvince2 = caricaProvince2;
        vmd.caricaComuni2 = caricaComuni2;
        vmd.restituisciPersona = restituisciPersona;
        vmd.aggrimuoviente = aggrimuoviente;

        if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
            //vmd.caricaProvince(vmd.persona.codRegione);
        }
        if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
            //vmd.caricaComuni(vmd.persona.codProvincia);
        }
//        if (vmd.persona.nascita.codRegione !== null || vmd.persona.nascita.codRegione !== '') {
//            vmd.caricaProvince2(vmd.persona.nascita.codRegione);
//        }
//        if (vmd.persona.nascita.codProvincia !== null || vmd.persona.nascita.codProvincia !== '') {
//            vmd.caricaComuni2(vmd.persona.nascita.codProvincia);
//        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function aggrimuoviente(indice) {
            if (angular.isUndefined(indice)) {
                if (vmd.indexEnte.length <= 5) {
                    vmd.indexEnte.push(vmd.indexEnte.length);
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Massimo 6 incarichi/funzioni')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                }
            } else {
                vmd.indexEnte.splice(indice, 1);
                vmd.phe[indice] = {};
            }

            console.log("vmd.indexEnte", vmd.indexEnte);
            console.log("vmd.phe", vmd.phe);
            console.log("vmd.php", vmd.php);
        }

        function cercaPersona() {
            vmd.ricerca['entes-nome'] = vmd.ricerca.cognome;
            vmd.ricerca['istats-comune'] = vmd.ricerca.cognome;
            vmd.ricerca['operatore'] = 'OR';
            vmd.ricerca['pagination'] = '200';
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.personas.persona.like(vmd.ricerca, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.personas.persona.get({}, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciPersona() {
            api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
                vmd.personaselezionato = response;
                vmd.personaHasEntes = angular.copy(vmd.personaselezionato.personahasentes);

                angular.forEach(vmd.personaHasEntes, function (obj) {
                    if (angular.isUndefined(vmd.phe[obj.ente_id])) {
                        vmd.phe[obj.ente_id] = [];
                    }
                    vmd.phe[obj.ente_id].push(obj.personaRuolo_id);

                    if (vmd.enti_collegati.map(function (o) {
                        return o.id;
                    }).indexOf(obj.ente_id) > -1) {
                        vmd.incaricosSelected.push(obj.personaRuolo_id);
                        vmd.incaricosSelected_rw.push(obj);
                    } else {
                        vmd.incaricosSelected_ro.push(obj);
                    }
                });

            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }
        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias2 = response.data;
            });
        }

        function savenew() {
            var phe_copy = vmd.phe;

            if (vmd.isnewpersona) {
                //trasformo php e phe
                var tphe_copy = [];


                angular.forEach(phe_copy, function (e) {
                    if (angular.isUndefined(tphe_copy[e.ente_id])) {
                        tphe_copy[e.ente_id] = [];
                    }
                    angular.forEach(e.ruolo_id, function (r) {
                        if (tphe_copy[e.ente_id].indexOf(r) === -1) {
                            tphe_copy[e.ente_id].push(r);
                        }
                    });
                });
                phe_copy = tphe_copy;
            }

            //PARTO DA persona_id -> progetto_id/ente_id ->personaRuolo_id
            var persona_id = vmd.personaselezionato.id;
            //potrebbe essere null se nuovo
            var phe_payload = [];

            angular.forEach(phe_copy, function (l1v, l1k) {
                var tphe_payload = {};
                angular.forEach(l1v, function (l2v) {
                    tphe_payload = {};
                    tphe_payload.persona_id = persona_id;
                    tphe_payload.ente_id = l1k;
                    tphe_payload.personaRuolo_id = l2v;

                    var ie = -1;
                    ie = vmd.personaruoloentes.map(function (o) {
                        return o.id;
                    }).indexOf(l2v);

                    if (ie > -1) {
                        tphe_payload.ruolo = vmd.personaruoloentes[ie].descrizione;
                    }

                    phe_payload.push(tphe_payload);
                });
            });



            var persona_has_ente = {};

            if (vmd.isnewpersona) {
                //nuova entita + colelgamento

                var m = moment(vmd.persona.dataNascita2);
                vmd.persona.dataNascita = m.format("YYYY-MM-DD");
                api.personas.persona.save(vmd.persona, function (response) {

                    persona_id = response.id;
                    if (persona_id > 0) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Persona salvata')
                                .position('bottom right')
                                .hideDelay(1000)
                                );
                        //modifico payload aggiungendo persona_id

                        angular.forEach(phe_payload, function (v, k) {
                            if (phe_payload[k].persona_id == null) {
                                phe_payload[k].persona_id = persona_id;
                            }
                        });

                        persona_has_ente = {
                            modelrelation: 'Personahasente',
                            idname: 'persona_id',
                            idvalue: persona_id,
                            idnamefk: 'ente_id',
                            idnamefk2: 'personaRuolo_id',
                            idnamePayload: 'ente_id',
                            extrafields: ["ruolo"],
                            payload: phe_payload
                        };

                        api.personas.persona.hasmany(persona_has_ente, function (rphe) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Collegamento enti creato')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                            $scope.hide();


                        });

                    }
                });
            } else {
                //solo collegamento

                persona_has_ente = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    extrafields: ["ruolo"],
                    payload: phe_payload
                };

                api.personas.persona.hasmany(persona_has_ente, function (rphe) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Collegamento enti modificato')
                            .position('bottom right')
                            .hideDelay(1000)
                            ).then(
                            $state.reload()
                            );
                    $scope.hide();
                });

            }

            console.log("persona_has_ente_FINAL:", persona_has_ente);


        }
        vmd.check = check;
        function check() {
            console.log("vmd.phe_selected:", vmd.phe);
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.persona_nome + '</b>' + ' sarà cancellato.<br>.')
                    .ariaLabel('cancella persona')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                var id_to_delete_e = [];

                angular.forEach(vmd.personaHasEntes, function (p) {
                    if (p.persona_id == vmd.personaselezionato.id && (vmd.enti_collegati.map(function (o) {
                        return o.id;
                    }).indexOf(p.ente_id) > -1)) {
                        id_to_delete_e.push(p.id);
                    }
                });

                angular.forEach(id_to_delete_e, function (d) {
                    api.personas.hasente.remove({id: d});
                });
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Eliminazione in corso..attendere qualche istante.')
                        .position('bottom right')
                        .hideDelay(10000)
                        ).then(function () {
                    $scope.hide();
                    $state.reload();
                });
                console.log(vmd.personaHasEntes);
                console.log("id_to_delete_e:", id_to_delete_e);



            }, function () {
            });

        }

        vmd.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vmd.persona.email)) {
                api.users.log.checkemail({email: vmd.persona.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.$$childTail.personaNForm.email.$setValidity("unique", true);
            }
        }
        vmd.checkCF = checkCF;
        vmd.validcf = true;
        function checkCF(ev) {
            console.log("persona", vmd.persona);
            console.log("scope", $scope);
            if (angular.isDefined(vmd.persona.codiceFiscale)) {
                api.users.log.checkcf({codiceFiscale: vmd.persona.codiceFiscale}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", false);
                                vmd.validcf = false;
                            } else {
                                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", true);
                                vmd.validcf = true;
                            }
                        });
            } else {
                $scope.$$childTail.personaNForm.codicefiscale.$setValidity("unique", true);
                vmd.validcf = true;
            }
        }


        vmd.rimuoviente = rimuoviente;
        function rimuoviente(index) {
            console.log(index);
            console.log(vmd.phe);
            vmd.phe.splice(index, 1);
        }
        vmd.aggiungiente = aggiungiente;
        function aggiungiente(index) {
            vmd.phe.splice(index, 1);
        }


    }


    function DialogPersoneEnteSController($scope, $state, $mdDialog, Ente, api, AllRuolo, AllRuolo2, index, Regioni, newlink, $mdToast)
    {
        /*
         var vmd = this;
         vmd.ente_id = Ente.id;
         vmd.index = index;
         vmd.ente_nome = Ente.nome;
         vmd.persona_id = null;
         vmd.persona_nome = null;
         vmd.personas = angular.copy(Ente.personas);
         vmd.persona = {
         id: null,
         nome: null,
         cognome: null,
         sesso: null,
         codRegione: null,
         codProvincia: null,
         codComune: null,
         indirizzo: null,
         cap: null,
         email: null,
         telefono: null,
         dataNascita: '1980-01-01',
         dataNascita2: null,
         codComuneNascita: null,
         codNazionalita: null,
         codiceFiscale: null,
         enteruolos: [],
         ruolos: [],
         nascita: [],
         };
         vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
         vmd.allpersonas = [];
         vmd.links = {};
         vmd.meta = {};
         vmd.isnewpersona = false;
         vmd.newlink = newlink;
         if (!vmd.newlink && vmd.index === null) {
         vmd.isnewpersona = true;
         }
         vmd.ruolosSelected = [];
         vmd.ruolosSelected2 = [];
         
         if (vmd.index !== null) {
         vmd.persona_id = Ente.personas[index].id;
         vmd.persona_nome = Ente.personas[index].cognome + ' ' + Ente.personas[index].nome;
         vmd.persona = angular.copy(Ente.personas[index]);
         vmd.allpersonas.push(angular.copy(Ente.personas[index]));
         angular.forEach(Ente.personahasentes, function (obj) {
         if ((vmd.persona.id) == obj.persona_id) {
         vmd.ruolosSelected.push(obj.personaRuolo_id);
         }
         });
         
         }
         vmd.allruolo = AllRuolo.data;
         vmd.allpersonaruolo = AllRuolo2.data;
         vmd.regiones = Regioni;
         vmd.regiones2 = Regioni;
         vmd.provincias = [];
         vmd.istats = [];
         vmd.provincias2 = [];
         vmd.istats2 = [];
         vmd.nazionalitas = [];
         api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: "200"}, function (response) {
         vmd.nazionalitas = response.data;
         });
         
         
         vmd.progettohaspersona = {
         progetto_id: vmd.progetto_id,
         persona_id: vmd.persona_id,
         };
         
         vmd.ricerca = {
         cognome: null,
         };
         vmd.ricerca['entes-nome'] = null;
         vmd.ricerca['istats-comune'] = null;
         vmd.personaselezionato = {
         id: null
         };
         
         
         vmd.save = save;
         vmd.delete = del;
         vmd.cercaPersona = cercaPersona;
         vmd.caricaProvince = caricaProvince;
         vmd.caricaComuni = caricaComuni;
         vmd.caricaProvince2 = caricaProvince2;
         vmd.caricaComuni2 = caricaComuni2;
         vmd.restituisciPersona = restituisciPersona;
         if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
         }
         if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
         }
         
         $scope.hide = function () {
         $mdDialog.hide();
         };
         
         $scope.cancel = function () {
         $mdDialog.cancel();
         };
         
         function cercaPersona() {
         vmd.ricerca['entes-nome'] = vmd.ricerca.cognome;
         vmd.ricerca['istats-comune'] = vmd.ricerca.cognome;
         vmd.ricerca['operatore'] = 'OR';
         vmd.ricerca['pagination'] = '100';
         angular.forEach(vmd.ricerca, function (value, key) {
         if (value === null || value === 'null') {
         delete vmd.ricerca[key];
         }
         });
         if (Object.keys(vmd.ricerca).length > 0) {
         api.personas.persona.like(vmd.ricerca, function (response) {
         vmd.allpersonas = response.data;
         vmd.links = response._links;
         vmd.meta = response._meta;
         });
         } else {
         api.personas.persona.get({}, function (response) {
         vmd.allpersonas = response.data;
         vmd.links = response._links;
         vmd.meta = response._meta;
         });
         }
         }
         function restituisciPersona() {
         api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
         vmd.personaselezionato = response;
         });
         }
         
         function caricaComuni(codprovincia) {
         api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
         vmd.istats = response.data;
         });
         }
         function caricaProvince(codregione) {
         api.istats.province.get({codRegione: codregione}, function (response) {
         vmd.provincias = response.data;
         });
         }
         function caricaComuni2(codprovincia) {
         api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
         vmd.istats2 = response.data;
         });
         }
         function caricaProvince2(codregione) {
         api.istats.province.get({codRegione: codregione}, function (response) {
         vmd.provincias2 = response.data;
         });
         }
         
         
         function save() {
         var payload = [];
         angular.forEach(Ente.personahasentes, function (obj2) {
         var pushpayload = {
         persona_id: obj2.persona_id,
         ente_id: obj2.ente_id,
         personaRuolo_id: obj2.personaRuolo_id};
         payload.push(pushpayload);
         });
         
         if (!vmd.isnewpersona && !vmd.newlink) {
         //modifica collegamento
         payload = [];
         angular.forEach(Ente.personahasentes, function (obj2) {
         if ((vmd.persona.id) != obj2.persona_id) {
         var pushpayload = {
         persona_id: obj2.persona_id,
         ente_id: obj2.ente_id,
         personaRuolo_id: obj2.personaRuolo_id};
         payload.push(pushpayload);
         }
         });
         
         
         vmd.newlink = true;
         //così rigenera i links della nuova asociazione
         }
         if (vmd.isnewpersona && !vmd.newlink) {
         //nuova entita + colelgamento
         var pushpayload2 = {}
         var m = moment(vmd.persona.dataNascita2);
         vmd.persona.dataNascita = m.format("YYYY-MM-DD");
         api.personas.persona.save(vmd.persona, function (response) {
         console.log('salvata persona');
         var perId = response.id;
         angular.forEach(vmd.ruolosSelected, function (ruolo) {
         var pushpayload = {
         ente_id: vmd.ente_id,
         persona_id: perId,
         personaRuolo_id: ruolo};
         payload.push(pushpayload);
         });
         var hasmanypersonaps = {
         modelrelation: 'Personahasente',
         idname: 'ente_id',
         idvalue: vmd.ente_id,
         idnamefk: 'persona_id',
         idnamefk2: 'personaRuolo_id',
         idnamePayload: 'persona_id',
         payload: payload};
         api.personas.persona.hasmany(hasmanypersonaps, function (response) {
         console.log('Risposta inserimento in Persona_has_progetto');
         console.log(response);
         angular.forEach(vmd.ruolosSelected2, function (ruolo) {
         pushpayload2 = {
         persona_id: perId,
         id: ruolo};
         });
         var newpayload = [];
         newpayload.push(pushpayload2);
         var hasmanypersonas = {
         modelrelation: 'Personahasente',
         idname: 'ente_id',
         idvalue: vmd.ente_id,
         idnamefk: 'persona_id',
         idnamefk2: 'personaRuolo_id',
         idnamePayload: 'persona_id',
         payload: payload
         };
         api.personas.persona.hasmany(hasmanypersonas, function (response) {
         console.log('Risposta inserimento in Persona_has_ruolo');
         console.log(response);
         $state.reload();
         $scope.hide();
         });
         });
         });
         }
         
         if (vmd.newlink) {
         //nuovo collegamento
         angular.forEach(vmd.ruolosSelected, function (ruolo) {
         var pushpayload = {
         ente_id: vmd.ente_id,
         persona_id: vmd.personaselezionato.id,
         personaRuolo_id: ruolo};
         payload.push(pushpayload);
         });
         //                console.log(payload);
         var hasmanypersonas = {
         modelrelation: 'Personahasente',
         idname: 'ente_id',
         idvalue: vmd.ente_id,
         idnamefk: 'persona_id',
         idnamefk2: 'personaRuolo_id',
         idnamePayload: 'persona_id',
         payload: payload
         };
         api.personas.persona.hasmany(hasmanypersonas, function (response) {
         console.log(response);
         $state.reload();
         $scope.hide();
         });
         
         }
         }
         function del() {
         var confirm = $mdDialog.confirm()
         .title('Sei sicuro di voler cancellare questo collegamento?')
         .htmlContent('<b>' + vmd.persona_nome + '</b>' + ' sarà cancellato.')
         .ariaLabel('cancella persona')
         .ok('OK')
         .cancel('ABBANDONA');
         var alert = $mdDialog.alert()
         .clickOutsideToClose(true)
         .title('Attenzione')
         .textContent('Non puoi rimuovere ultimo elemento.')
         .ariaLabel('Attenzione ultimo')
         .ok('OK');
         
         $mdDialog.show(confirm).then(function ()
         {
         var payload = [];
         angular.forEach(Ente.personahasentes, function (obj2) {
         if ((vmd.persona.id) != obj2.persona_id) {
         var pushpayload = {
         persona_id: obj2.persona_id,
         ente_id: obj2.ente_id,
         personaRuolo_id: obj2.personaRuolo_id};
         payload.push(pushpayload);
         }
         });
         
         
         if (payload.length === 0) {
         $mdDialog.show(alert);
         }
         var hasmanypersonas = {
         modelrelation: 'Personahasente',
         idname: 'ente_id',
         idvalue: vmd.ente_id,
         idnamefk: 'persona_id',
         idnamefk2: 'personaRuolo_id',
         idnamePayload: 'persona_id',
         payload: payload
         };
         console.log(hasmanypersonas);
         api.personas.persona.hasmany(hasmanypersonas, function (response) {
         console.log(response);
         $state.reload();
         $scope.hide();
         });
         }, function () {
         });
         
         }
         
         vmd.selectedItem = null;
         vmd.searchText = null;
         vmd.selectedItem2 = null;
         vmd.searchText2 = null;
         vmd.selectedItem3 = null;
         vmd.searchText3 = null;
         vmd.querySearch = querySearch;
         vmd.transformChip = transformChip;
         
         
         function transformChip(chip) {
         // If it is an object, it's already a known chip
         if (angular.isObject(chip)) {
         return chip;
         }
         // Otherwise, create a new one
         return {name: chip, type: 'new'}
         }
         
         
         function querySearch(query, obj, nomecampo) {
         var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
         return results;
         }
         
         
         function createFilterFor(query, nomecampo) {
         //var lowercaseQuery = angular.lowercase(query);
         
         return function filterFn(collection) {
         return (collection[nomecampo].indexOf(query) === 0);
         };
         
         }
         
         
         */
        console.log("ENTE:", Ente);
        var vmd = this;
        vmd.checkCodiceSegnalatore = false;
        vmd.showfarebut1 = false;
        vmd.showfarebut2 = true;
        vmd.showorganization = true;
        vmd.responseCodice = {};
        vmd.persondata = {};
        vmd.persondata.codiceSegnalatore = Ente.codiceSegnalatore;
        vmd.persondata.dataNascita = null;
        if (angular.isDefined(Ente.codiceSegnalatore)) {
            vmd.checkCodiceSegnalatore = true;
            vmd.showfarebut2 = false;
            vmd.showfarebut1 = true;
            vmd.responseCodice = Ente;
        }
        //vmd.contact.dataNascita2 = new Date(vmd.contact.dataNascita);
        vmd.oggi = new Date();
        vmd.maxDate = new Date((vmd.oggi.getFullYear() - 18) + "-" + (vmd.oggi.getMonth() + 1) + "-" + vmd.oggi.getDate());
        vmd.minDate = new Date((vmd.oggi.getFullYear() - 99) + "-" + (vmd.oggi.getMonth() + 1) + "-" + vmd.oggi.getDate());


        vmd.checkCodice = checkCodice;
        function checkCodice() {
            api.users.log.checkcodice({codiceSegnalatore: vmd.persondata.codiceSegnalatore}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            vmd.responseCodice = response;
                            vmd.showfarebut2 = false;
                            vmd.showfarebut1 = true;
                            vmd.checkCodiceSegnalatore = true;
                            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", true);
                        } else {
                            vmd.checkCodiceSegnalatore = false;
                            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", false);
                        }
                    });
        }
        vmd.resetCodice = resetCodice;
        function resetCodice() {
            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", true);
        }
        vmd.indietro = indietro;
        function indietro() {
            vmd.checkCodiceSegnalatore = false;
            vmd.showfarebut1 = false;
            vmd.showfarebut2 = true;
        }
        vmd.checkTelefono = checkTelefono;
        function checkTelefono(ev) {
            api.users.log.checktelefono({telefono: vmd.persondata.telefono}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            $scope.registerForm.telefono.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.telefono.$setValidity("unique", true);
                        }
                    });
        }
        vmd.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vmd.persondata.email)) {
                api.users.log.checkemail({email: vmd.persondata.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            } else {
                                $scope.registerForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.registerForm.email.$setValidity("unique", true);
            }
        }
        vmd.checkCf = checkCf;
        function checkCf(ev) {
            api.users.log.checkcf({codiceFiscale: vmd.persondata.codiceFiscale}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            $scope.registerForm.codiceFiscale.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.codiceFiscale.$setValidity("unique", true);
                        }
                    });
        }
        vmd.preregister = preregister;
        function preregister() {
            $scope.registerForm.username.$setValidity("unique", true);
            checkEmail();
            api.users.log.preregister(vmd.persondata).$promise.then(
                    function (response) {
                        if (response.status != undefined && response.status == 200) {
                            $scope.registerForm.username.$setValidity("unique", true);
                            $scope.registerForm.email.$setValidity("unique", true);
                        } else {
                            if (angular.isDefined(response.email)) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            }


                            if (response.username != undefined) {
                                $scope.registerForm.username.$setValidity("unique", false);
                            }
                        }
                    });
        }

        vmd.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vmd.persondata.password !== vmd.persondata.passwordc) {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", true);
            }
        }



        vmd.roles = [];
        vmd.roles = loadRoles();
        function loadRoles() {
            api.personaruolos.personaruolo.search({gruppo: 'ENTE', sort: "descrizione"}).$promise.then(function (response) {
                var roles = response.data;
                vmd.roles = roles.map(function (repo) {
                    repo.value = repo.gruppo.toLowerCase();
                    return repo;
                });
            }, function (response) {
                //console.log(response);
            });
        }



        vmd.register = register;
        function register(ev) {

            var erroreg = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('ERRORE Inserimento segnalatore')
                    .textContent("Si è verificato un errore non gestito. Contattare Servizio Centrale")
                    .ariaLabel('Errore')
                    .ok('OK');

            var ok = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .title('Inserimento segnalatore')
                    .textContent('Inserimento effettuato. Email spedita al segnalatore.')
                    .ariaLabel('okdialog')
                    .ok('Ok');

            var confirm = $mdDialog.confirm()
                    .title('Inserimento segnalatore')
                    .textContent('I dati appena inseriti saranno registrati.')
                    .ariaLabel('confermoInserimento')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Salva')
                    .cancel('Abbandona');
            $mdDialog.show(confirm).then(function () {
                //conferma
                vmd.user = angular.copy(vmd.persondata);
                vmd.person = angular.copy(vmd.persondata);
                vmd.organization = {};
                //user
                delete(vmd.user.codiceFiscale);
                delete(vmd.user.codiceSegnalatore);
                delete(vmd.user.cognome);
                delete(vmd.user.nome);
                delete(vmd.user.designation);
                delete(vmd.user.sesso);
                delete(vmd.user.telefono);
                delete(vmd.user.dataNascita);
                //person
                delete(vmd.person.codiceSegnalatore);
                delete(vmd.person.username);
                delete(vmd.person.password);
                delete(vmd.person.passwordc);
                vmd.person.dataNascita = moment(vmd.persondata.dataNascita).format('YYYY-MM-DD');
                //organization
                vmd.organization.id = vmd.responseCodice.id;

//            console.log('persondata',vmd.persondata);
//            console.log('user', vmd.user);
//            console.log('person', vmd.person);
//            console.log('organization', vmd.organization);

                api.stagingarea.register.save({user: vmd.user, person: vmd.person, organization: vmd.organization}, function (res) {
                    console.log(res);
                    if (res.status === 200) {
                        $mdDialog.show(ok).then(function () {
                            $state.go('app.sprardb_entisegnalatori');
                        });
                    }
                    if (res.status === 400) {
                        var errore = $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('ERRORE Inserimento segnalatore')
                                .textContent(res.message)
                                .ariaLabel('Errore')
                                .ok('OK');
                        $mdDialog.show(errore);
                    }
                }, function (res) {
                    $mdDialog.show(erroreg);
                });

            }, function () {
                //abbandono
            });
        }

        vmd.toggleuser = toggleuser;
        function toggleuser() {
            $mdDialog.hide(vmd.registerdata);
        }
        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }


    }

    function DialogExtraEnteSController($scope, $state, $mdSidenav, msUtils, $mdDialog, $document, api, extra) {
        var vmd = this;
        vmd.nomeModello = extra.nomeModello;
        vmd.nomeModelloChiave = extra.nomeModelloChiave;
        vmd.nomeModelloApi = extra.nomeModelloApi;
        vmd[vmd.nomeModello] = extra[vmd.nomeModello];
        vmd.isnew = extra.isnew;
        vmd.extra = extra.extra;
        vmd.extra[vmd.nomeModelloChiave] = extra.extra[vmd.nomeModelloChiave];

        vmd.saveExtra = extra.saveExtra;
        vmd.deleteExtra = extra.deleteExtra;
        vmd.hide = extra.hide;

    }



})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.enti', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.sprardb_enti', {
            url: '/sprardb/enti',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/enti/enti.html',
                    controller: 'EntiController as vm'
                }
            }
        }).state('app.sprardb_enti.dettaglio', {
            url: '/{id:int}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/enti/dettaglio/ente.html',
                    controller: 'EnteController as vm'
                }
            }
        }).state('app.sprardb_enti.new', {
          url: '/new',
          views: {
            'content@app': {
              templateUrl: 'app/main/sprardb/enti/dettaglio/ente.html',
              controller: 'EnteController as vm'
            }
          }
        })
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.enti')
            .controller('EnteController', EnteController)
            .controller('DialogPersoneEnteController', DialogPersoneEnteController)
            .controller('DialogRuoliPersonaEnteController', DialogRuoliPersonaEnteController);

    /** @ngInject */
    function EnteController($stateParams, $state, $mdDialog, api, $mdToast, ricerca)
    {
      var vm = this;

      vm.salva = salva;
      vm.onChangeRegione = onChangeRegione;
      vm.onChangeProvincia = onChangeProvincia;
      vm.gotoProgetto = gotoProgetto;
      vm.openPersoneEnteDialog = openPersoneEnteDialog;
      vm.loadEnte = loadEnte;
      vm.mostraRuoliPersonaEnte = mostraRuoliPersonaEnte;
      vm.elimina = elimina;

      vm.isAdmin = api.isAdmin;
      vm.isVisitatore = api.isVisitatore;
      vm.isReadOnly = api.isReadOnly;
      vm.api = api;
      vm.ricercaApi = ricerca;
      vm.ente = {};

      vm.stati = [
        {label: 'Tutti', value: undefined},
        {label: 'Attivi', value: function(p){return p.relazioniEnteAttive.length > 0}},
        {label: 'Disattivi', value: function(p){return p.relazioniEnteAttive.length === 0}},
      ];
      vm.statoPersone = 0;
      vm.filtroPersoneAttive = vm.stati[0].value;

      vm.statiProgetto = [
        {label: 'Tutti', value: undefined},
        vm.filtroProgAttivi = {label: 'Attivi', value: {progettohasentes: {attivo: 1}}},
        {label: 'Disattivi', value: {progettohasentes: {attivo: 0}}},
      ];
      vm.statoProgetti = 0;
      vm.filtroStatoProg = vm.statiProgetto[0].value;

      if ($stateParams.id) {
        vm.ente.id = $stateParams.id;
        loadEnte()
      }


      function loadEnte()
      {
        vm.ente = api.entemc.get({id:vm.ente.id,
            expand:'persone.user,persone.personahasentes.personaruolo,persone.personahasprogetto.personaRuolo,' +
                'persone.relazioniEnteAttive,progetti.istats,progetti.progettohasentes.enteruolo'
          }, function () {
            caricaProvince();
            caricaComuni()
          }
        );
      }

      function elimina()
      {
        var confirm = $mdDialog.confirm()
          .title('Conferma eliminazione ente')
          .htmlContent("L'ente sarà eliminato")
          .ok('CONFERMA')
          .cancel('ABBANDONA');

        $mdDialog.show(confirm).then(function() {
          api.entemc.delete({id: vm.ente.id}, function() {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Ente eliminato')
                .position('bottom right')
                .hideDelay(3000)
            );

            $state.go('app.sprardb_enti');
          });

        });
      }

      function salva()
      {
        api.entemc.save(vm.ente, function(res) {
          angular.merge(vm.ente, res);
          $mdToast.show(
            $mdToast.simple()
              .textContent('Informazioni salvate.')
              .position('bottom right')
              .hideDelay(2000)
          );
          $state.go('app.sprardb_enti.dettaglio', {id: res.id});
        });
      }

      function caricaProvince()
      {
        api.istats.province.get({codRegione: vm.ente.codRegione}, function (response) {
          vm.province = response.data;
          vm.istats = {};
        });
      }

      function caricaComuni()
      {
        api.istats.istat.cerca({codProvincia: vm.ente.codProvincia, pagination: 400}, function (response) {
          vm.istats = response.data;
        });
      }

      function onChangeRegione()
      {
        vm.ente.codComune = null;
        vm.ente.codProvincia = null;
        caricaProvince();
      }

      function onChangeProvincia()
      {
        vm.ente.codComune = null;
        caricaComuni();
      }

      function gotoProgetto(progettoid)
      {
        $state.go('app.sprardb_progetti_progetti_progetto', {id: progettoid});
      }

      function mostraRuoliPersonaEnte(ev, persona)
      {
        $mdDialog.show({
          controller: 'DialogRuoliPersonaEnteController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/enti/dialogs/dialogMostraRuoli.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            persona
          }
        });
      }

      function openPersoneEnteDialog(ev, action, persona) {
        if(persona) {
            var entiCollegati = persona.personahasentes;
        }

        $mdDialog.show({
          controller: 'DialogPersoneEnteController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/enti/dialogs/dialogAssociaPersonaEnte.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            action: action,
            persona: persona,
            entiCollegati: entiCollegati,
            ricercaApi: vm.ricercaApi,
            ente: vm.ente,
            vm: vm
          }
        }).then(function () {
          loadEnte();
        });
      }

    }

    function DialogPersoneEnteController($scope, $mdToast, $state, $mdDialog, api, locals)
    {
      var vmd = this;
      vmd.cercaPersona = cercaPersona;
      vmd.inizializzaModel = inizializzaModel;
      vmd.save = save;
      vmd.delete = del;

      vmd.ricercaApi = locals.ricercaApi;
      vmd.ente = locals.ente;
      vmd.action = locals.action;
      vmd.entiCollegati = locals.entiCollegati;
      vmd.persona = locals.persona;
      vmd.expand = 0;
      vmd.booleanOptions = [
        {id: 1, label: 'Sì'},
        {id: 0, label: 'No'}
      ]

      vmd.models = [];
      vmd.ruoli = [];

      if(vmd.entiCollegati) {
        vmd.personaId = vmd.persona.id;
        api.personas.persona.get({id: vmd.personaId}, function (res) {
          vmd.allpersonas = [res];
        });
        caricaEnti();
      }

      function caricaEnti(){
        angular.forEach(vmd.entiCollegati, function (personaEnte) {
          inizializzaModel(personaEnte);
        })
      }

      function cercaPersona() {
        api.personas.persona.like(vmd.ricerca, function (response) {
          vmd.allpersonas = response.data;
          vmd.links = response._links;
          vmd.meta = response._meta;
        });
      }

      function inizializzaModel(personaEnte) {
          vmd.models.push({
            id: personaEnte?.id ?? null,
            dataInizio: personaEnte?.dataInizio ?? null,
            dataFine: personaEnte?.dataFine ?? null,
            persona_id: vmd.personaId,
            attivo: personaEnte?.attivo ?? 1,
            personaRuolo_id: personaEnte?.personaRuolo_id ?? null,
            ente_id: vmd.ente.id
          })
      }

      function save() {
        api.personaentemc.save(vmd.models, function (okResponse) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Informazioni salvate.')
              .position('bottom right')
              .hideDelay(2000)
          );
          $mdDialog.hide();
        })
      }


      function del(model) {
        if(model.id) {
          model._delete = true;
        } else {
          vmd.models = vmd.models.filter(personaEnte => personaEnte !== model);
        }
      }

      $scope.cancel = function () {
        $mdDialog.cancel();
      }
    }

    function DialogRuoliPersonaEnteController($scope, $mdDialog, locals) {
      var vmd = this;
      vmd.persona = locals.persona;
      vmd.personaEnte = vmd.persona.personahasentes

      $scope.cancel = function () {
        $mdDialog.cancel();
      }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entes')
            .controller('DettaglioEController', DettaglioEController)
            .controller('DialogPersoneEnteController', DialogPersoneEnteController)
            .controller('DialogExtraEnteController', DialogExtraEnteController);

    /** @ngInject */
    function DettaglioEController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, extra, ricerca, $mdToast)
    {

        var vm = this;
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.api = api;
        var Persona = {};
        vm.id = $state.params.id;
        vm.provincias = [];
        vm.istats = [];
        //vm.contact = {};
        vm.loadentes = function () {
            api.entes.ente.get({id: vm.id}).$promise.then(function (response) {
                Persona = response;
                vm.contact = angular.copy(Persona);
                if (vm.id == 0) {
                    vm.contact = {};
                    vm.contact.attivo = 1;
                    vm.contact.segnalatore = 0;
                }
                if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
                    vm.caricaProvince(vm.contact.codRegione);
                }
                if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
                    vm.caricaComuni(vm.contact.codProvincia);
                }
            }, function (response) {
            });
            return Persona;
        };
        vm.loadentes();

        //filtri tipologia
        vm.filtro_id = [];
        vm.filtro_id[1] = [15, 21, 42, 40, 41, 37, 38, 29]; //attuatore
        vm.filtro_id[8] = [29, 43, 35, 30, 12, 4, 10, 36, 5, 31, 11]; //titolare
        vm.filtro_id[2] = [15, 21, 42, 40, 41, 37, 38, 29]; //partner
        vm.filtro_id[6] = [7]; //questura
        vm.filtro_id[7] = [8]; //prefettura

        vm.filtro_id_applicato = [];
        vm.filtro_id[0] = [];
        var ii = 4;
        for (ii = 4; ii <= 50; ii++) {
            vm.filtro_id[0].push(ii);

        }
        vm.filtro_id_applicato = vm.filtro_id[0];


        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }

        //vm.tags = Tags.data;

        api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
            vm.tempentetipo = response.data;
        });
        api.enteruolos.enteruolo.cerca({pagination: 50}, function (response) {
            vm.enteruolos = response.data;
        });
        api.personaruolos.personaruolo.cerca({pagination: 50}, function (response) {
            vm.personaruolos = response.data;
        });
        api.tags.tag.cerca({pagination: 50, sort: "tag", tipo: "generico"}, function (response) {
            vm.tags = response.data;
        });

        vm.evento = "update";

        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;

        vm.gotoEnti = gotoEnti;
        vm.gotoPersonaDettaglio = gotoPersonaDettaglio;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = vm.regiones;
        });


        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                enteTipo_id: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                entetipo: null,
                enteextras: null,
                tags: null,
                progettos: null,
                segnalatore: 0,
                attivo: 1
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }

        console.log('isnew:' + vm.isnew);
        console.log('contact:');
        console.log(vm.contact);
        console.log('contact.tags:');
        console.log(vm.contact.tags);

        // Methods
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoStruttura = gotoStruttura;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openPersoneEnteDialog = openPersoneEnteDialog;

        //////////

        /**
         * Save contact
         */
        function saveContact()
        {
            console.log('isnew:' + vm.isnew);
            console.log('contact:');
            console.log(vm.contact);
            console.log('contact.tags:');
            console.log(vm.contact.tags);


            if (vm.isnew) {
                api.entes.ente.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Ente correttamente inserito')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: contact_id})
                            );
                });
            }
            if (!vm.isnew) {
                api.entes.ente.aggiorna(vm.contact, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Ente correttamente aggiornato')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );



                });
            }



        }

        /**
         * Delete Contact Dialog
         */

        function gotoEnti() {
            $state.go('app.sprardb_entes');
        }

        function gotoPersonaDettaglio(id) {
            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: id});
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }
        function gotoStruttura(ids, idp)
        {
            $state.go('app.sprardb_progetti_strutture_struttura', {id: ids, progetto_id: idp});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare questo ente?')
                    .htmlContent('<b>' + vm.contact.nome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.entes.ente.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoEnti();
                });

            });

        }


        function openExtraDialog(ev, item, index) {
            extra.init('ente', item, index);
            $mdDialog.show({
                controller: 'DialogExtraEnteController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }
        vm.tempruolo2 = null;
        function openPersoneEnteDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                api.personaruolos.personaruolo.get({}, function (response) {
                    vm.tempruolo2 = response;
                    $mdDialog.show({
                        controller: 'DialogPersoneEnteController',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogPersoneEnteForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllRuolo2: vm.tempruolo2,
                            Ente: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });
            });
        }


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }



        vm.openPersoneDialog = openPersoneNewDialog;
        function openPersoneNewDialog(ev, ente, index, newlink) {

            var persona_id = 0;
            var ente_id = ente.id;
            var progetto_id = 0;
            if (index !== null) {
                persona_id = vm.contact.personas[index].id;
            }
            var enti_collegati = [];//angular.copy(vm.progetto.entes);
            var progetti_collegati = [];
//            var r_persona_progetto = angular.copy(vm.personaruoloprogettos);
//            var r_persona_ambito = angular.copy(vm.personaruoloambitos);
//            var r_persona_ente = angular.copy(vm.personaruoloentes);
//            var r_ente_progetto = angular.copy(vm.enteruoloprogetto);
            $mdDialog.show({
                controller: 'DialogSegnalatoriNewController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogSegnalatoriNewForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Ente: ente,
                    index: index,
                    Regioni: vm.regiones,
                    newlink: newlink,
                    enti_collegati: enti_collegati,
                    persona_id: persona_id,
                    progetto_id: progetto_id,
                    ente_id: ente_id,
                    progetti_collegati: progetti_collegati
                }
            });
        }
        vm.openRegisterDialog = openRegisterDialog;
        function openRegisterDialog(ev, persona_id, gruppo_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: false,
                    isnew: true,
                    gruppo_id: gruppo_id
                }
            }).then(function (datastore) {
                if (datastore.doit) {
                    console.log(datastore);
                    datastore.sendemail = 1;
                    api.users.log.createuser(datastore, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Nuovo profilo creato.')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                $state.reload()
                                );
                    });
                }
            });
        }

        vm.openUserDialog = openUserDialog;
        function openUserDialog(ev, persona_id) {

            $mdDialog.show({
                controller: 'DialogRegisterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dialogRegisterForm.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    persona_id: persona_id,
                    disabled: true,
                    isnew: false,
                    gruppo_id: false
                }
            }).then(function (datastore) {
                console.log("datastore", datastore);
                if (datastore.doit) {
                    if (datastore.disableuser === true) {
                        //disabilita solo utente
                        api.users.log.toggleuser({persona_id: datastore.persona_id}, function (response) {
                            console.log(response);
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Attivazione profilo cambiata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    $state.reload()
                                    );
                        });
                    } else {
                        //startreset
                        //passwordreset
                        api.users.log.startreset({email: datastore.email, username: datastore.username}, function (pr) {
                            var passwordresettoken = pr.token;
//                            angular.forEach(pr, function (opr, k) {
//                                if (k >= 0 && k <= 42) {
//                                    passwordresettoken = passwordresettoken + opr;
//                                }
//                            })
                            api.users.log.passwordreset({token: passwordresettoken, password: datastore.password}, function (us) {
                                if (angular.isDefined(us.id)) {
                                    var email = {};
                                    email.to = [];
                                    email.to.push(us.email);
                                    email.oggetto = "Banca dati SC - Cambiamento Password";
                                    email.corpo = "Gentile utente,<br>Il suo profilo è stato aggiornato come richiesto, le riportiamo di seguito le credenziali di accesso.<br><br>Indirizzo di accesso alla Banca Dati:<br>http://bancadati.sprar.it<br><br>Le credenziali da adoperare al suo accesso sono:<br>Nome Utente: " + us.username + "<br>Password: " + datastore.password + "<br><br><br>Cordiali Saluti<br>Reparto Assistenza Tecnica SC";
                                    api.emails.send.send(email, function (rrr) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Invio email compeltato.')
                                                .position('bottom right')
                                                .hideDelay(2000)
                                                );
                                    });
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Password cambiata per utente ' + us.username + ' ' + us.email + '. Attendere prego.')
                                            .position('bottom right')
                                            .hideDelay(7000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento password. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        });
                        if (angular.isDefined(datastore.modificag) && datastore.modificag == true) {
                            api.users.log.changegroup(datastore, function (ug) {
                                if (angular.isDefined(ug.id)) {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Profili correttamente modificati')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            ).then(
                                            $state.reload()
                                            );
                                } else {
                                    $mdToast.show(
                                            $mdToast.simple()
                                            .textContent('Errore durante cambiamento profili. Riprova.')
                                            .position('bottom right')
                                            .hideDelay(3000)
                                            )
                                }
                            });
                        }
                    }
                }
            });
        }


    }

    function DialogPersoneEnteController($scope, $state, $mdDialog, Ente, api, AllRuolo, AllRuolo2, index, Regioni, newlink)
    {
        var vmd = this;
        vmd.ente_id = Ente.id;
        vmd.index = index;
        vmd.ente_nome = Ente.nome;
        vmd.persona_id = null;
        vmd.persona_nome = null;
        vmd.personas = angular.copy(Ente.personas);
        vmd.persona = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            enteruolos: [],
            ruolos: [],
            nascita: [],
        };
        vmd.persona.dataNascita2 = new Date(vmd.persona.dataNascita);
        vmd.allpersonas = [];
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewpersona = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewpersona = true;
        }
        vmd.ruolosSelected = [];
        vmd.ruolosSelected2 = [];

        if (vmd.index !== null) {
            vmd.persona_id = Ente.personas[index].id;
            vmd.persona_nome = Ente.personas[index].cognome + ' ' + Ente.personas[index].nome;
            vmd.persona = angular.copy(Ente.personas[index]);
            vmd.allpersonas.push(angular.copy(Ente.personas[index]));
            angular.forEach(Ente.personahasentes, function (obj) {
                if ((vmd.persona.id) == obj.persona_id) {
                    vmd.ruolosSelected.push(obj.personaRuolo_id);
                }
            });

        }
        vmd.allruolo = AllRuolo.data;
        vmd.allpersonaruolo = AllRuolo2.data;
        vmd.regiones = Regioni;
        vmd.regiones2 = Regioni;
        vmd.provincias = [];
        vmd.istats = [];
        vmd.provincias2 = [];
        vmd.istats2 = [];
        vmd.nazionalitas = [];
        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: "200"}, function (response) {
            vmd.nazionalitas = response.data;
            //console.log(vmd.nazionalitas);
        });


        vmd.progettohaspersona = {
            progetto_id: vmd.progetto_id,
            persona_id: vmd.persona_id,
        };

        vmd.ricerca = {
            cognome: null,
        };
        vmd.ricerca['entes-nome'] = null;
        vmd.ricerca['istats-comune'] = null;
        vmd.personaselezionato = {
            id: null
        };


        vmd.save = save;
        vmd.delete = del;
        vmd.cercaPersona = cercaPersona;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.caricaProvince2 = caricaProvince2;
        vmd.caricaComuni2 = caricaComuni2;
        vmd.restituisciPersona = restituisciPersona;
        if (vmd.persona.codRegione !== null || vmd.persona.codRegione !== '') {
            //vmd.caricaProvince(vmd.persona.codRegione);
        }
        if (vmd.persona.codProvincia !== null || vmd.persona.codProvincia !== '') {
            //vmd.caricaComuni(vmd.persona.codProvincia);
        }
//        if (vmd.persona.nascita.codRegione !== null || vmd.persona.nascita.codRegione !== '') {
//            vmd.caricaProvince2(vmd.persona.nascita.codRegione);
//        }
//        if (vmd.persona.nascita.codProvincia !== null || vmd.persona.nascita.codProvincia !== '') {
//            vmd.caricaComuni2(vmd.persona.nascita.codProvincia);
//        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaPersona() {
            vmd.ricerca['entes-nome'] = vmd.ricerca.cognome;
            vmd.ricerca['istats-comune'] = vmd.ricerca.cognome;
            vmd.ricerca['operatore'] = 'OR';
            vmd.ricerca['pagination'] = '100';
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.personas.persona.like(vmd.ricerca, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.personas.persona.get({}, function (response) {
                    vmd.allpersonas = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciPersona() {
            api.personas.persona.get({id: vmd.personaselezionato.id}, function (response) {
                vmd.personaselezionato = response;
                //console.log(vmd.personaselezionato);
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }
        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats2 = response.data;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias2 = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(Ente.personahasentes, function (obj2) {
                var pushpayload = {
                    persona_id: obj2.persona_id,
                    ente_id: obj2.ente_id,
                    personaRuolo_id: obj2.personaRuolo_id};
                payload.push(pushpayload);
            });

            if (!vmd.isnewpersona && !vmd.newlink) {
                //modifica collegamento
                payload = [];
                angular.forEach(Ente.personahasentes, function (obj2) {
                    if ((vmd.persona.id) != obj2.persona_id) {
                        var pushpayload = {
                            persona_id: obj2.persona_id,
                            ente_id: obj2.ente_id,
                            personaRuolo_id: obj2.personaRuolo_id};
                        payload.push(pushpayload);
                    }
                });

                /*
                 var newpayload = [];
                 angular.forEach(payload, function (value, key) {
                 if (value.persona_id !== vmd.personaselezionato.id) {
                 newpayload.push(value);
                 }
                 });
                 payload = newpayload;
                 */
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewpersona && !vmd.newlink) {
                //nuova entita + colelgamento
                var pushpayload2 = {}
                var m = moment(vmd.persona.dataNascita2);
                vmd.persona.dataNascita = m.format("YYYY-MM-DD");
                api.personas.persona.save(vmd.persona, function (response) {
                    console.log('salvata persona');
                    var perId = response.id;
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            ente_id: vmd.ente_id,
                            persona_id: perId,
                            personaRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanypersonaps = {
                        modelrelation: 'Personahasente',
                        idname: 'ente_id',
                        idvalue: vmd.ente_id,
                        idnamefk: 'persona_id',
                        idnamefk2: 'personaRuolo_id',
                        idnamePayload: 'persona_id',
                        payload: payload};
                    api.personas.persona.hasmany(hasmanypersonaps, function (response) {
                        console.log('Risposta inserimento in Persona_has_progetto');
                        console.log(response);
                        angular.forEach(vmd.ruolosSelected2, function (ruolo) {
                            pushpayload2 = {
                                persona_id: perId,
                                id: ruolo};
                        });
                        var newpayload = [];
                        newpayload.push(pushpayload2);
                        var hasmanypersonas = {
                            modelrelation: 'Personahasente',
                            idname: 'ente_id',
                            idvalue: vmd.ente_id,
                            idnamefk: 'persona_id',
                            idnamefk2: 'personaRuolo_id',
                            idnamePayload: 'persona_id',
                            payload: payload
                        };
                        api.personas.persona.hasmany(hasmanypersonas, function (response) {
                            console.log('Risposta inserimento in Persona_has_ruolo');
                            console.log(response);
                            $state.reload();
                            $scope.hide();
                        });
                    });
                });
            }

            if (vmd.newlink) {
                //nuovo collegamento
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        ente_id: vmd.ente_id,
                        persona_id: vmd.personaselezionato.id,
                        personaRuolo_id: ruolo};
                    payload.push(pushpayload);
                });
//                console.log(payload);
                var hasmanypersonas = {
                    modelrelation: 'Personahasente',
                    idname: 'ente_id',
                    idvalue: vmd.ente_id,
                    idnamefk: 'persona_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'persona_id',
                    payload: payload
                };
                api.personas.persona.hasmany(hasmanypersonas, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });

            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.persona_nome + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella persona')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                var payload = [];
                angular.forEach(Ente.personahasentes, function (obj2) {
                    if ((vmd.persona.id) != obj2.persona_id) {
                        var pushpayload = {
                            persona_id: obj2.persona_id,
                            ente_id: obj2.ente_id,
                            personaRuolo_id: obj2.personaRuolo_id};
                        payload.push(pushpayload);
                    }
                });


                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                var hasmanypersonas = {
                    modelrelation: 'Personahasente',
                    idname: 'ente_id',
                    idvalue: vmd.ente_id,
                    idnamefk: 'persona_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'persona_id',
                    payload: payload
                };
                console.log(hasmanypersonas);
                api.personas.persona.hasmany(hasmanypersonas, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });

        }

        vmd.selectedItem = null;
        vmd.searchText = null;
        vmd.selectedItem2 = null;
        vmd.searchText2 = null;
        vmd.selectedItem3 = null;
        vmd.searchText3 = null;
        vmd.querySearch = querySearch;
        vmd.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }
    }

    function DialogExtraEnteController($scope, $state, $mdSidenav, msUtils, $mdDialog, $document, api, extra) {
        var vmd = this;
        vmd.nomeModello = extra.nomeModello;
        vmd.nomeModelloChiave = extra.nomeModelloChiave;
        vmd.nomeModelloApi = extra.nomeModelloApi;
        vmd[vmd.nomeModello] = extra[vmd.nomeModello];
        vmd.isnew = extra.isnew;
        vmd.extra = extra.extra;
        vmd.extra[vmd.nomeModelloChiave] = extra.extra[vmd.nomeModelloChiave];

        vmd.saveExtra = extra.saveExtra;
        vmd.deleteExtra = extra.deleteExtra;
        vmd.hide = extra.hide;

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.documenti.file-manager', ['flow'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.sprardb_documenti', {
            url: '/sprardb/documenti/file-manager',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/documenti/file-manager/file-manager.html',
                    controller: 'FileManager2Controller as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_nuovodocumento', {
            url: '/sprardb/documenti/:azione',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/documenti/file-manager/file-manager.html',
                    controller: 'FileManager2Controller as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/documenti/file-manager');

        // Api
        //msApiProvider.register('fileManager.documents', ['http://localhost/sprardb/app-server/web/documentos']);
        // Navigation

        msNavigationServiceProvider.saveItem('sprardb.documenti', {
            title: 'Documenti',
            weight: 100
        });
        msNavigationServiceProvider.saveItem('sprardb.documenti.new', {
            title: 'Carica documento',
            icon: 'icon-box-upload',
            state: 'app.sprardb_nuovodocumento({azione:"nuovo"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.documenti.my', {
            title: 'I miei documenti',
            icon: 'icon-heart-outline',
            state: 'app.sprardb_documenti',
            weight: 2
        });
        /*
         msNavigationServiceProvider.saveItem('scadmin.documenti', {
         title: 'Documenti',
         weight: 100
         });
         msNavigationServiceProvider.saveItem('scadmin.documenti.new', {
         title: 'Carica documento',
         icon: 'icon-box-upload',
         state: 'app.sprardb_nuovodocumento({azione:"nuovo"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.documenti.my', {
         title: 'I miei documenti',
         icon: 'icon-heart-outline',
         state: 'app.sprardb_documenti',
         weight: 2
         });
         */
        /*
         msNavigationServiceProvider.saveItem('scsegreteria.documenti', {
         title: 'Documenti',
         weight: 100
         });
         msNavigationServiceProvider.saveItem('scsegreteria.documenti.new', {
         title: 'Carica documento',
         icon: 'icon-box-upload',
         state: 'app.sprardb_nuovodocumento({azione:"nuovo"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scsegreteria.documenti.my', {
         title: 'I miei documenti',
         icon: 'icon-heart-outline',
         state: 'app.sprardb_documenti',
         weight: 2
         });
         */
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.documenti.file-manager')
            .controller('FileManager2Controller', FileManager2Controller)
            .controller('FileManagerUploadDialogController', FileManagerUploadDialogController);


    /** @ngInject */
    function FileManager2Controller($mdSidenav, $state, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {
        var vm = this;
        vm.parametristato = $state.params;

        console.log("params", $state.params);
        // Data
        vm.searchForms = {
            "documentotipos-gruppo": {
                type: "string",
                title: "Gruppo documenti",
                description: "Gruppo documenti...",
                callbackModel: "ricerca",
                dbfield: "documentotipos-gruppo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch();vm.loaddocumentotipo2()",
                data: "vm.documentotipo",
                chiave: "gruppo",
                valore: "gruppo|uppercase"
            },
            "documentotipos-tipo": {
                type: "string",
                title: "Tipo documento",
                description: "Tipo documento...",
                callbackModel: "ricerca",
                dbfield: "documentotipos-tipo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo2",
                chiave: "tipo",
                valore: "tipo|uppercase"
            },
            "data>": {
                type: "string",
                title: "Da data",
                description: "Da data",
                callbackModel: "ricerca",
                dbfield: "data>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "data<": {
                type: "string",
                title: "A data",
                description: "A data",
                callbackModel: "ricerca",
                dbfield: "data<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            }
        };

        vm.baseUrl = api.baseUrl;
        vm.authb = api.authorizationB;
        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.pagination = 10;
        vm.colors = ricerca.colors;
        vm.ricerca = {};
        vm.ricerca2 = "";

        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = ['Archivio', 'Documenti'];
        vm.folders = [];
        vm.files = [];
        vm.loadfiles = function () {
            api.documentos.documento.search(vm.allsearchs, function (response) {
                vm.files = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
            return vm.files;
        };
        vm.loadfiles();

        vm.documentotipo = [];
        vm.loaddocumentotipo = function () {
            api.documentos.tipo.distinct({gruppo: 'distinct', pagination: -1}, function (response) {
                vm.documentotipo = response.data;
                console.log("vm.documentotipo", vm.documentotipo);
            });
            return vm.documentotipo;
        };
        vm.loaddocumentotipo();

        vm.documentotipo2 = [];
        vm.grupposelezionato = null;
        vm.loaddocumentotipo2 = function () {
            var payload = {pagination: -1};
            if (angular.isDefined(vm.ricerca["documentotipos-gruppo"])) {
                payload = {gruppo: vm.ricerca["documentotipos-gruppo"], pagination: -1};
            }
            api.documentos.tipo.search(payload, function (response) {
                vm.documentotipo2 = response.data;
                console.log("vm.documentotipo2", vm.documentotipo2);
            });
            return vm.documentotipo2;
        };
        vm.loaddocumentotipo2();

        vm.onGruppo = onGruppo;
        function onGruppo() {}




        //vm.files = Documents.data;
        vm.selected = vm.files[0];

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target: api.baseUrl + 'documentos/upload',
            chunkSize: 15 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            headers: {'Authorization': 'Basic ' + api.authorizationB},
            query: {documentoTipo_id: 3, progetto_id: 30},
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            console.log(file);
            // Prepare the temp file data for file list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: '',
                owner: 'Emily Bennett',
                size: '',
                modified: moment().format('MMMM D, YYYY'),
                opened: '',
                created: moment().format('MMMM D, YYYY'),
                extention: '',
                location: 'My Files > Documents',
                offline: false,
                preview: 'assets/images/etc/sample-file-preview.jpg'
            };

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.files, function (item, index)
            {
                if (item.id && item.id === file.uniqueIdentifier)
                {
                    // Normally you would update the file from
                    // database but we are cheating here!

                    // Update the file info
                    item.name = file.file.name;
                    item.type = 'document';

                    // Figure out & upddate the size
                    if (file.file.size < 1024)
                    {
                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
                    } else if (file.file.size >= 1024 && file.file.size < 1048576)
                    {
                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
                    } else if (file.file.size >= 1048576 && file.file.size < 1073741824)
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
                    } else
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
                    }
                }
            });
        }

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }


        vm.exportcsvente = exportcsvente;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.onSearch = onSearch;
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nomefile': 'Nome File'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nomefile';
            vm.allsearchsTemp.fields = 'id,nomefile';
            api.documentos.documento.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                console.log('vm.entesexport', vm.entesexport);
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }
        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);

            var valores = vm.searchForms[key].valore.split("|");

            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';

                if (vm.ricerca2.indexOf(",") > -1) {
                    vm.allsearchs['query[]'][0]["id_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["nomefile_IN"] = vm.ricerca2;
                } else {
                    vm.allsearchs['query[]'][0].nomefile = vm.ricerca2;
                    vm.allsearchs['query[]'][0].id = vm.ricerca2;
                }

            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.documentos.documento.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.files = d.data;
                vm.links = d._links;
                vm.meta = d._meta;

            }
            );
            vm.searched = true;
        }

        vm.openUpload = openUpload;
        function openUpload(ev, authB) {
            //console.log(progetto_id);
            var st = true;

            $mdDialog.show({
                controller: 'FileManagerUploadDialogController',
                controllerAs: 'vmdd',
                templateUrl: 'app/main/sprardb/documenti/file-manager/uploaddocumentsDialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    authorizationB: authB,
                    sceglitipo: st,
                    gruppi: vm.documentotipo
                }
            });
        }


        //se nuovo lancio dialog
        if (angular.isDefined(vm.parametristato.azione) && vm.parametristato.azione === 'nuovo') {
            api.documentos.tipo.distinct({gruppo: 'distinct', pagination: -1}, function (response) {
                vm.documentotipo = response.data;
                vm.openUpload(null, vm.authb);
                console.log("vm.documentotipo", vm.documentotipo);
            });
        }


    }
    function FileManagerUploadDialogController(locals, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;
        vmdd.gruppi = locals.gruppi;
        vmdd.baseurl = api.baseUrl;
        var target = vmdd.baseurl + 'documentos/upload';
        vmdd.params = {};
        vmdd.ngFlowOptions = {
            target: target,
            chunkSize: 15 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            headers: {'Authorization': 'Basic ' + locals.authB, 'X-Requested-With': 'XMLHttpRequest', },
            query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };

        // Methods
        vmdd.upload = upload;
        function upload()
        {
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {

        }

        vmdd.fileSuccess = fileSuccess;

        function fileSuccess(file, message)
        {

        }

        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            $rootScope.loadingProgress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            $rootScope.loadingProgress = false;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Files caricato correttamente!!')
                    .position('bottom right')
                    .hideDelay(3000)
                    ).then(function () {
                $mdDialog.hide();
                $state.reload();
            }
            );
            ;
        }
        vmdd.selezionagruppo = selezionagruppo;
        vmdd.documentotipo = [];
        function selezionagruppo() {
            var payload = {pagination: -1};
            if (angular.isDefined(vmdd.grupposelezionato)) {
                payload = {gruppo: vmdd.grupposelezionato, pagination: -1};
            }
            api.documentos.tipo.search(payload, function (response) {
                vmdd.documentotipo = response.data;
            });
        }
        vmdd.selezionagruppo();

        vmdd.selezionatipo = selezionatipo;
        function selezionatipo() {
            console.log(vmdd.params);
            //vmdd.ngFlowOptions.query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},

        }


    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.contatti')
            .controller('DettaglioBController', DettaglioBController)
            .controller('DialogEnti2Controller', DialogEnti2Controller);


    /** @ngInject */
    function DettaglioBController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, Persona, Tags)
    {

        var vm = this;
        vm.id = $state.params.id;
        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }
        console.log(vm.isnew);
        vm.evento = "update";
        vm.contact = angular.copy(Persona.data[0]);

        vm.provincias = [];
        vm.istats = [];
        vm.tags = Tags.data;

        vm.provincias2 = [];
        vm.istats2 = [];
        vm.regiones = null;
        vm.regiones2 = null;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = response.data;
        });
        vm.personaruolos = null;
        api.personaruolos.personaruolo.get({}, function (response) {
            vm.personaruolos = response.data;
        });

        vm.nazioni = null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: 200}, function (response) {
            vm.nazioni = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });




        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                cognome: null,
                sesso: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataNascita: "2013-08-08",
                dataNascita2: null,
                codComuneNascita: null,
                codNazionalita: null,
                codiceFiscale: null,
                tags: [],
                progettos: [],
                entes: [],
                ruolos: [],
                personahasprogettos: [],
                personahasentes: []
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.contact2 = {
            'codRegione': null,
            'codProvincia': null,
            'codComune': null,
            'codComuneNascita': null,
        };


// Methods
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;
        vm.gotoPersona = gotoPersona;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoEnte = gotoEnte;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openEntiDialog = openEntiDialog;



        vm.ruolitotali = vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasentes.length;
        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);
        }
        if (!angular.isUndefined(vm.contact.nascita)) {
            if (vm.contact.nascita !== null) {
                vm.caricaProvince2(vm.contact.nascita.codRegione);
                vm.caricaComuni2(vm.contact.nascita.codProvincia);
            }
        }


        console.log('isnew:' + vm.isnew);
        console.log('contact:');
        console.log(vm.contact);
        console.log('contact.tags:');
        console.log(vm.contact.tags);




        ////////////////////////////////////////////////

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }









        /**
         * Save contact
         */
        function saveContact()
        {

            console.log('isnew:' + vm.isnew);
            console.log('contact:');
            console.log(vm.contact);
            console.log('contact.tags:');
            console.log(vm.contact.tags);


            var m = moment(vm.contact.dataNascita2);
            vm.contact.dataNascita = m.format("YYYY-MM-DD");
            if (vm.isnew) {
                api.personas.persona.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: response.id, tag_id: obj.id});
                    });
                    //
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: contact_id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload,
                        delete: false
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            console.log(response);
                            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                        });
                    } else {
                        $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                    }
                });
            }
            if (!vm.isnew) {
                api.personas.persona.aggiorna(vm.contact, function (response) {
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: vm.contact.id, tag_id: obj.id});
                    });
                    //delete: false,
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: vm.contact.id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            $state.reload();
                        });
                    } else {
                        $state.reload();
                    }
                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoPersona() {
            $state.go('app.sprardb_contatti');
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }


        function gotoEnte(id)
        {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: id});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.personas.persona.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoPersona();
                });

            });

        }


        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                console.log(vm.tempruolo);
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    console.log(vm.tempentetipo);
                    $mdDialog.show({
                        controller: 'DialogEnti2Controller',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Persona: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }


    }

    function DialogEnti2Controller($scope, $state, $mdDialog, Persona, api, AllRuolo, index, AllEnteTipo, Regioni, newlink)
    {
        var vmd = this;
        vmd.persona_id = Persona.id;
        vmd.index = index;
        vmd.persona_nome = Persona.cognome + ' ' + Persona.nome;
        vmd.ente_id = null;
        vmd.ente_nome = null;
        vmd.entes = angular.copy(Persona.entes);
        vmd.ente = {
            id: null,
            enteTipo_id: null,
            enteTipoPadre_id: null,
            nome: null,
            codRegione: null,
            codProvincia: null,
            codComune: null,
            indirizzo: null,
            cap: null,
            email: null,
            telefono: null,
            attivo: '1',
            enteruolos: [],
        };
        vmd.allentes = {};
        vmd.links = {};
        vmd.meta = {};
        vmd.isnewente = false;
        vmd.newlink = newlink;
        if (!vmd.newlink && vmd.index === null) {
            vmd.isnewente = true;
        }
        vmd.ruolosSelected = [];

        if (vmd.index !== null) {
            vmd.ente_id = Persona.entes[index].id;
            vmd.ente_nome = Persona.entes[index].nome;
            vmd.ente = angular.copy(Persona.entes[index]);

            angular.forEach(Persona.personahasentes, function (obj) {
                if ((vmd.ente.id) == obj.ente_id) {
                    vmd.ruolosSelected.push(obj.personaRuolo_id);
                }
            });
//            angular.forEach(vmd.ente.enteruolos, function (obj) {
//                vmd.ruolosSelected.push(obj.id);
//            });
        }
        vmd.allentetipos = AllEnteTipo.data;
        vmd.allruolo = AllRuolo.data;
        vmd.regiones = Regioni;
        vmd.provincias = [];
        vmd.istats = [];


        vmd.progettohasente = {
            progetto_id: vmd.persona_id,
            ente_id: vmd.ente_id,
        };

        vmd.ricerca = {
            nome: null,
            enteTipo_id: null,
            codRegione: null,
        };
        vmd.enteselezionato = {
            id: null
        };


        vmd.save = save;
        vmd.delete = del;
        vmd.cercaEnte = cercaEnte;
        vmd.caricaProvince = caricaProvince;
        vmd.caricaComuni = caricaComuni;
        vmd.restituisciEnte = restituisciEnte;
        if (vmd.ente.codRegione !== null || vmd.ente.codRegione !== '') {
            //vmd.caricaProvince(vmd.ente.codRegione);
        }
        if (vmd.ente.codProvincia !== null || vmd.ente.codProvincia !== '') {
            //vmd.caricaComuni(vmd.ente.codProvincia);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function cercaEnte() {
            angular.forEach(vmd.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vmd.ricerca[key];
                }
            });
            if (Object.keys(vmd.ricerca).length > 0) {
                api.entes.ente.like(vmd.ricerca, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            } else {
                api.entes.ente.get({}, function (response) {
                    vmd.allentes = response.data;
                    vmd.links = response._links;
                    vmd.meta = response._meta;
                });
            }
            //console.log(vmd.ricerca);
        }
        function restituisciEnte() {
            api.entes.ente.get({id: vmd.enteselezionato.id}, function (response) {
                vmd.enteselezionato = response;
                //console.log(vmd.enteselezionato);
            });
        }

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vmd.istats = response.data;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vmd.provincias = response.data;
            });
        }


        function save() {
            var payload = [];
            angular.forEach(Persona.personahasentes, function (obj2) {
                var pushpayload = {
                    persona_id: obj2.persona_id,
                    ente_id: obj2.ente_id,
                    personaRuolo_id: obj2.personaRuolo_id};
                payload.push(pushpayload);
            });
            /*
             var payload = [];
             angular.forEach(vmd.entes, function (obj) {
             angular.forEach(obj.enteruolos, function (obj2) {
             var pushpayload = {
             persona_id: vmd.persona_id,
             ente_id: obj.id,
             personaRuolo_id: obj2.id};
             payload.push(pushpayload);
             });
             });
             */
            if (!vmd.isnewente && !vmd.newlink) {
                //modifica
                vmd.entes.splice(vmd.index, 1);
                payload = [];
                angular.forEach(Persona.personahasentes, function (obj2) {
                    var pushpayload = {
                        persona_id: obj2.persona_id,
                        ente_id: obj2.ente_id,
                        personaRuolo_id: obj2.personaRuolo_id};
                    payload.push(pushpayload);
                });
                /*
                 angular.forEach(vmd.entes, function (obj) {
                 angular.forEach(obj.enteruolos, function (obj2) {
                 var pushpayload = {
                 persona_id: vmd.persona_id,
                 ente_id: obj.id,
                 personaRuolo_id: obj2.id};
                 payload.push(pushpayload);
                 });
                 });
                 */
                vmd.newlink = true;
                //così rigenera i links della nuova asociazione
            }
            if (vmd.isnewente && !vmd.newlink) {
                //nuovo ente + inserimento link
                api.entes.ente.save(vmd.ente, function (response) {
                    angular.forEach(vmd.ruolosSelected, function (ruolo) {
                        var pushpayload = {
                            persona_id: vmd.persona_id,
                            ente_id: response.id,
                            personaRuolo_id: ruolo};
                        payload.push(pushpayload);
                    });
                    var hasmanyentes = {
                        modelrelation: 'Personahasente',
                        idname: 'persona_id',
                        idvalue: vmd.persona_id,
                        idnamefk: 'ente_id',
                        idnamefk2: 'personaRuolo_id',
                        idnamePayload: 'ente_id',
                        payload: payload
                    };
                    api.entes.ente.hasmany(hasmanyentes, function (response) {
                        console.log(response);
                        $state.reload();
                        $scope.hide();
                    });
                });
            }

            if (vmd.newlink) {
                //inserimento solo links
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        persona_id: vmd.persona_id,
                        ente_id: vmd.enteselezionato.id,
                        personaRuolo_id: ruolo};
                    payload.push(pushpayload);
                });

                var hasmanyentes = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: vmd.persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload
                };
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });

            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella ente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.show(confirm).then(function ()
            {
                var payload = [];
                angular.forEach(Struttura.personahasentes, function (obj2) {
                    if ((vmd.entes[vmd.index].id) != obj2.ente_id) {
                        var pushpayload = {
                            persona_id: obj2.persona_id,
                            ente_id: obj2.ente_id,
                            personaRuolo_id: obj2.personaRuolo_id};
                        payload.push(pushpayload);
                    }
                });
                /*
                 vmd.entes.splice(vmd.index, 1);
                 var payload = [];
                 angular.forEach(vmd.entes, function (obj) {
                 angular.forEach(obj.enteruolos, function (obj2) {
                 var pushpayload = {
                 persona_id: vmd.persona_id,
                 ente_id: obj.id,
                 personaRuolo_id: obj2.id};
                 payload.push(pushpayload);
                 });
                 });
                 */
                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                //console.log(payload);
                var hasmanyentes = {
                    modelrelation: 'Personahasente',
                    idname: 'persona_id',
                    idvalue: vmd.persona_id,
                    idnamefk: 'ente_id',
                    idnamefk2: 'personaRuolo_id',
                    idnamePayload: 'ente_id',
                    payload: payload};
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });

        }




    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.tags')
            .controller('TagsController', TagsController);

    /** @ngInject */
    function TagsController($scope, $state, $mdSidenav, Tags, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.tags = Tags.data;
        vm.links = Tags._links;
        vm.meta = Tags._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        console.log(vm.tags);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getTags = getTags;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.tags.tag.get({sort: order + field}, function (response) {
                vm.tags = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.tags.tag.like(vm.ricerca, function (response) {
                    vm.tags = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.tags.tag.get({}, function (response) {
                    vm.tags = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.tag = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.tags.tag.like(vm.ricerca, function (response) {
                    vm.tags = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.tags.tag.get({}, function (response) {
                    vm.tags = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }

        function getTags() {
            //$rootScope.loadingProgress = true;
            msApi.register('tags.tags',
                    [api.baseUrl + 'tags',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('tags.tags@get').then(function (d) {
                vm.tags = d.data;
            });
        }

        getTags();


        function pagerNext(uri) {
            msApi.register('tags.next', [uri]);
            msApi.resolve('tags.next@get').then(function (d) {
                vm.tags = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('tags.prev', [uri]);
            msApi.resolve('tags.prev@get').then(function (d) {
                vm.tags = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, tag)
        {
            $mdDialog.show({
                controller: 'TagDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/tags/dialogs/tag/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Tag: tag,
                    User: vm.user,
                    Tags: vm.tags
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.personaruolos')
            .controller('PersonaruolosController', PersonaruolosController);

    /** @ngInject */
    function PersonaruolosController($scope, $state, $mdSidenav, Personaruolos, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.personaruolos = Personaruolos.data;
        vm.links = Personaruolos._links;
        vm.meta = Personaruolos._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        console.log(vm.personaruolos);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getPersonaruolos = getPersonaruolos;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.personaruolos.personaruolo.get({sort: order + field}, function (response) {
                vm.personaruolos = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.personaruolos.personaruolo.like(vm.ricerca, function (response) {
                    vm.personaruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.personaruolos.personaruolo.get({}, function (response) {
                    vm.personaruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.descrizione = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.personaruolos.personaruolo.like(vm.ricerca, function (response) {
                    vm.personaruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.personaruolos.personaruolo.get({}, function (response) {
                    vm.personaruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }

        function getPersonaruolos() {
            //$rootScope.loadingProgress = true;
            msApi.register('personaruolos.personaruolos',
                    [api.baseUrl + 'personaruolos',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('personaruolos.personaruolos@get').then(function (d) {
                vm.personaruolos = d.data;
            });
        }

        getPersonaruolos();


        function pagerNext(uri) {
            msApi.register('personaruolos.next', [uri]);
            msApi.resolve('personaruolos.next@get').then(function (d) {
                vm.personaruolos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('personaruolos.prev', [uri]);
            msApi.resolve('personaruolos.prev@get').then(function (d) {
                vm.personaruolos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, personaruolo)
        {
            $mdDialog.show({
                controller: 'PersonaruoloDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/personaruolos/dialogs/personaruolo/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Personaruolo: personaruolo,
                    User: vm.user,
                    Personaruolos: vm.personaruolos
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.entetipos')
            .controller('EntetiposController', EntetiposController);

    /** @ngInject */
    function EntetiposController($scope, $state, $mdSidenav, Entetipos, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.entetipos = Entetipos.data;
        vm.links = Entetipos._links;
        vm.meta = Entetipos._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        console.log(vm.entetipos);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getEntetipos = getEntetipos;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.entetipos.entetipo.get({sort: order + field}, function (response) {
                vm.entetipos = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.entetipos.entetipo.like(vm.ricerca, function (response) {
                    vm.entetipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.entetipos.entetipo.get({}, function (response) {
                    vm.entetipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.descrizione = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.entetipos.entetipo.like(vm.ricerca, function (response) {
                    vm.entetipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.bandos.bando.get({}, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }


        function getEntetipos() {
            //$rootScope.loadingProgress = true;
            msApi.register('entetipos.entetipos',
                    [api.baseUrl + 'entetipos',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('entetipos.entetipos@get').then(function (d) {
                vm.entetipos = d.data;
            });
        }

        getEntetipos();


        function pagerNext(uri) {
            msApi.register('entetipos.next', [uri]);
            msApi.resolve('entetipos.next@get').then(function (d) {
                vm.entetipos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('entetipos.prev', [uri]);
            msApi.resolve('entetipos.prev@get').then(function (d) {
                vm.entetipos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, entetipo)
        {
            $mdDialog.show({
                controller: 'EntetipoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/entetipos/dialogs/entetipo/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Entetipo: entetipo,
                    User: vm.user,
                    Entetipos: vm.entetipos
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.enteruolos')
            .controller('EnteruolosController', EnteruolosController);

    /** @ngInject */
    function EnteruolosController($scope, $state, $mdSidenav, Enteruolos, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.enteruolos = Enteruolos.data;
        vm.links = Enteruolos._links;
        vm.meta = Enteruolos._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        console.log(vm.enteruolos);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getEnteruolos = getEnteruolos;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.enteruolos.enteruolo.get({sort: order + field}, function (response) {
                vm.enteruolos = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.enteruolos.enteruolo.like(vm.ricerca, function (response) {
                    vm.enteruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.enteruolos.enteruolo.get({}, function (response) {
                    vm.enteruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.descrizione = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.enteruolos.enteruolo.like(vm.ricerca, function (response) {
                    vm.enteruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.enteruolos.enteruolo.get({}, function (response) {
                    vm.enteruolos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }



        function getEnteruolos() {
            //$rootScope.loadingProgress = true;
            msApi.register('enteruolos.enteruolos',
                    [api.baseUrl + 'enteruolos',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('enteruolos.enteruolos@get').then(function (d) {
                vm.enteruolos = d.data;
            });
        }

        getEnteruolos();



        function pagerNext(uri) {
            msApi.register('enteruolos.next', [uri]);
            msApi.resolve('enteruolos.next@get').then(function (d) {
                vm.enteruolos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('enteruolos.prev', [uri]);
            msApi.resolve('enteruolos.prev@get').then(function (d) {
                vm.enteruolos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, enteruolo)
        {
            $mdDialog.show({
                controller: 'EnteruoloDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/enteruolos/dialogs/enteruolo/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Enteruolo: enteruolo,
                    User: vm.user,
                    Enteruolos: vm.enteruolos
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.documentotipos')
            .controller('DocumentotiposController', DocumentotiposController);

    /** @ngInject */
    function DocumentotiposController($scope, $state, $mdSidenav, Documentotipos, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.documentotipos = Documentotipos.data;
        vm.links = Documentotipos._links;
        vm.meta = Documentotipos._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraidocumentotipo = false;
        console.log(vm.documentotipos);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getDocumentotipos = getDocumentotipos;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.documentotipos.documentotipo.get({sort: order + field}, function (response) {
                vm.documentotipos = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.documentotipos.documentotipo.like(vm.ricerca, function (response) {
                    vm.documentotipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.documentotipos.documentotipo.get({}, function (response) {
                    vm.documentotipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.tipo = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.documentotipos.documentotipo.like(vm.ricerca, function (response) {
                    vm.documentotipos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.documentotipos.documentotipo.get({}, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }

        function getDocumentotipos() {
            //$rootScope.loadingProgress = true;
            msApi.register('documentotipos.documentotipos',
                    [api.baseUrl + 'documentotipos',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('documentotipos.documentotipos@get').then(function (d) {
                vm.documentotipos = d.data;
            });
        }


        getDocumentotipos();

        function pagerNext(uri) {
            msApi.register('documentotipos.next', [uri]);
            msApi.resolve('documentotipos.next@get').then(function (d) {
                vm.documentotipos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('documentotipos.prev', [uri]);
            msApi.resolve('documentotipos.prev@get').then(function (d) {
                vm.documentotipos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, documentotipo)
        {
            $mdDialog.show({
                controller: 'DocumentotipoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/documentotipos/dialogs/documentotipo/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Documentotipo: documentotipo,
                    User: vm.user,
                    Documentotipos: vm.documentotipos
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.configurazioni.bandos')
            .controller('BandosController', BandosController);

    /** @ngInject */
    function BandosController($scope, $state, $mdSidenav, Bandos, User, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.bandos = Bandos.data;
        vm.links = Bandos._links;
        vm.meta = Bandos._meta;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraibando = false;
        console.log(vm.bandos);
        vm.ricerca = {};

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getBandos = getBandos;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.bandos.bando.get({sort: order + field}, function (response) {
                vm.bandos = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServer() {
            console.log(vm.ricerca);
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.bandos.bando.like(vm.ricerca, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.bandos.bando.get({}, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
        }

        function searchServer2() {
            vm.ricerca.descrizione = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.bandos.bando.like(vm.ricerca, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.bandos.bando.get({}, function (response) {
                    vm.bandos = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }

        function getBandos() {
            //$rootScope.loadingProgress = true;
            msApi.register('bandos.bandos',
                    [api.baseUrl + 'bandos',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('bandos.bandos@get').then(function (d) {
                vm.bandos = d.data;
            });
        }
        getBandos();


        function pagerNext(uri) {
            msApi.register('bandos.next', [uri]);
            msApi.resolve('bandos.next@get').then(function (d) {
                vm.bandos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }


        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('bandos.prev', [uri]);
            msApi.resolve('bandos.prev@get').then(function (d) {
                vm.bandos = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }


        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, bando)
        {
            $mdDialog.show({
                controller: 'BandoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/configurazioni/bandos/dialogs/bando/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Bando: bando,
                    User: vm.user,
                    Bandos: vm.bandos
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';
    angular
            .module('app.sprardb.beneficiari')
            .controller('DettaglioBeneficiarioController', DettaglioBeneficiarioController)
            .controller('DettaglioBeneficiarioStoricoController', DettaglioBeneficiarioStoricoController)
            .controller('DettaglioBeneficiarioTerritorioController', DettaglioBeneficiarioTerritorioController)
            .controller('InserimentoBeneficiarioController', InserimentoBeneficiarioController)
            .controller('DialogAttributiController', DialogAttributiController)
            .controller('DialogCorsiBenController', DialogCorsiBenController)
            .controller('DialogServiziBenController', DialogServiziBenController)
            .controller('CambioDataDialogController', CambioDataDialogController)
            .controller('AnnullaUscitaController', AnnullaUscitaController)
            .controller('AccogliInStrutturaController', AccogliInStrutturaController)
            .controller('DialogCapofamigliaController', DialogCapofamigliaController)
            .controller('CambioStrutturaController', CambioStrutturaController)
            .controller('DisattivaEsternaController', DisattivaEsternaController)
            .controller('CambioDataMcController', CambioDataMcController)
            .controller('LiberaBeneficiarioController', LiberaBeneficiarioController)
            .controller('TerminaNelTerritorioController', TerminaNelTerritorioController)
            .controller('MostraStoricoAccoglienzaController', MostraStoricoAccoglienzaController)
            .filter('filterByArray', filterByArray)
            .filter('validacampi', validacampi)
            .filter('filtranucleo', filtranucleo)
            .directive('datepickerValidationFix', datepickerValidationFix);
    function datepickerValidationFix() {
        return {
            restrict: 'A',
            require: 'mdDatepicker',
            link: function (scope, element, attrs, mdDatepickerCtrl) {
                // Fix to run validation when a datepicker's minDate changes
                // Bug #5938
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.minDate;
                }, function () {
                    if (mdDatepickerCtrl.dateUtil.isValidDate(mdDatepickerCtrl.date)) {
                        mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    }
                });
                // Fix to clear error state when setting date programatically from null
                // Bug #6086
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.date;
                }, function (newVal, oldVal) {

                    // if (newVal && !oldVal) {
                    mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    // }
                });
            }
        }
    }

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    function filtranucleo($filter) {
        return function (list, filtranucleo, valore_filtrare, element) {
            var array_filtrare = [];
            array_filtrare.push(valore_filtrare);
            //aggiungo sempre SINGOLO e NON SO
            //id -1 e 2
            array_filtrare.push(-1);
            array_filtrare.push(2);
            if (!filtranucleo) {
                return list;
            }
            if (filtranucleo) {
                return $filter("filter")(list, function (listItem) {
                    //mostrare solo nucleo familiare o monoparentale secondo la precedente scelta
                    //con aggiunta di singolo e non so sempre
                    return array_filtrare.indexOf(listItem[element]) != -1;
//                    if (listItem[element] == valore_filtrare) {
//                        return true;
//                    }
                });
            }
        };
    }

    function validacampi() {
        return function (form, arrayCampi) {
            var esito = true;
            angular.forEach(arrayCampi, function (singoloCampo) {
                //console.log("FORM-CAMPO", form[singoloCampo]);
                if (form[singoloCampo].$invalid) {
                    //console.log(singoloCampo, "invalido");
                    esito = false;
                }
            });
            return esito;
        };
    }

    /** @ngInject */
    function DettaglioBeneficiarioController($state, $document, $filter, api, msUtils, $mdDialog, eventi, acl, ricerca, $mdToast, $cookies)
    {
        var vm = this;

        vm.cambiaDataAccoglienza = cambiaDataAccoglienza;
        vm.mostraStoricoAccoglienza = mostraStoricoAccoglienza;
        vm.cancellaBeneficiario = cancellaBeneficiario;
        vm.reintegraBeneficiario = reintegraBeneficiario;

        vm.place1 = new Date("3000-01-01");
        vm.place2 = new Date("1900-01-01");
        vm.isallowed = acl.isallowed2;
        vm.richestaprorogaottenibile = eventi.richestaprorogaottenibile;
        vm.uscitaottenibile = eventi.uscitaottenibile;
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.isTutor = api.isTutor;
        vm.canUpdateTipologia = !api.isAdminG;
        vm.canSetCapofamiglia = api.isAdmin || api.isAccoglienza || api.isAmministratore || api.isOperatore;
        vm.api = api;
        vm.filternucleo = false;
        vm.isomonimo = false;
        vm.activeFilter = {};
        vm.activeFilter.tipo = [];
        vm.activeFilter.stato = [];
        vm.letteraTrasf = eventi.letteraTrasf;
        vm.colors = eventi.colors2;
        ricerca.reloadCS();
        vm.toggleFilter = function (datas, tipo) {
            //console.log(datas);
            //console.log(tipo);
            angular.forEach(datas, function (data) {
                var found = vm.activeFilter[tipo].indexOf(data);
                if (found >= 0) {
                    vm.activeFilter[tipo].splice(found, 1);
                } else {
                    vm.activeFilter[tipo].push(data);
                }
            });
        };
        vm.ricercaService = ricerca;
        vm.options = ricerca.options;
        vm.selected = ricerca.selected;
        vm.limitOptions = ricerca.limitOptions;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.exallsearchs = ricerca.begin_allsearchs();
        vm.allprogettos = ricerca.progettos;
        //console.log("all",vm.allprogettos);
        vm.isReadOnly = false;
        vm.cookiepid = $cookies.getObject('ALL_p_id');
        vm.progettiAbilitati = vm.cookiepid.split(",").map(Number);
        vm.prpi = true;
        vm.dataIngressoProgettoCambiata = false;
        vm.caricamentoultimato = false;


      function cambiaDataAccoglienza(ev)
      {
        $mdDialog.show({
          controller: 'CambioDataMcController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/beneficiari/dialog/cambioDataMc_dialog.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: {
            beneficiario: vm.beneficiario
          }
        }).then(function(payload){
          payload.id = vm.beneficiario.id;
          api.beneficiariomc.cambiaDataInizio(payload, function(res) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Data Inizio Cambiata')
                .position('bottom right')
                .hideDelay(3000)
            )
            $state.reload();
          })
        });
      }

      function mostraStoricoAccoglienza()
      {
        console.log("dentro");
        $mdDialog.show({
          controller: 'MostraStoricoAccoglienzaController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/beneficiari/dialog/mostraDataMc_dialog.html',
          clickOutsideToClose: true,
          locals: {
            eventiCambioData: vm.eventiCambioData
          }
        });
      }

      function cancellaBeneficiario() {
        var confirm = $mdDialog.confirm()
          .title('Elimina beneficiario')
          .textContent('Sei sicuro di voler eliminare il beneficiario corrente?')
          .ok('Conferma')
          .cancel('Annulla');
        $mdDialog.show(confirm).then(function() {
          api.beneficiariomc.cancellaBeneficiario({id: vm.beneficiario.id}, function (res) {
            $state.reload();
          });
        });
      }

      function reintegraBeneficiario() {
        var confirm = $mdDialog.confirm()
          .title('Reintegra beneficiario')
          .textContent('Sei sicuro di voler reintegrare il beneficiario nel progetto corrente?')
          .ok('Conferma')
          .cancel('Annulla');
        $mdDialog.show(confirm).then(function() {
          api.beneficiariomc.reintegraBeneficiario({id: vm.beneficiario.id}, function (res) {
            $state.reload();
          });
        });
      }


        vm.beneficiario_id = $state.params.id;
        vm.oggi = new Date();
        var m4 = moment.duration({'days': 120});
        vm.oggim4 = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
        vm.dataOggiDisplay = $filter('date')(vm.oggi, 'dd/MM/yyyy');
        vm.tabellastrutture = [
            {
                etichetta: "#",
                campo: ['id'],
                mdorderby: "id",
                style: "text-align: center;"

            }, {
                etichetta: "struttura",
                mdorderby: "nome",
                campo: ['nome', 'progettos.nome'],
                b: true

            }, {
                etichetta: "ubicazione",
                mdorderby: "indirizzo",
                campo: ['indirizzo', 'istats.comune', 'istats.provincia'],
                icona: null

            }, {
                etichetta: "tipologia",
                campo: ['strutturaAccoglienzas.descrizione', 'strutturaAlloggios.descrizione']

            }, {
                etichetta: "attivo",
                campo: ['attivo'],
                mdorderby: "attivo",
                icona: {'0': 'icon-bookmark-outline', '1': 'icon-bookmark-check'}

            }, {
                etichetta: "posti",
                mdorderby: "numeroPosti",
                campo: ['numeroPosti']
            }, {
                etichetta: "stanze",
                mdorderby: "numeroStanze",
                campo: ['numeroStanze']
            }, {
                etichetta: "s.igien",
                mdorderby: "numeroIgienici",
                campo: ['numeroIgienici']
            }, {
                a: true,
                bottoni: [{
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxx",
                        ngclick: "",
                        uisref: "app.sprardb_progetti_strutture_struttura",
                        ngif: true
                    }, {
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxxu",
                        ngclick: function click() {
                            //console.log("click");
                        },
                        uisref: "",
                        ngif: false
                    }]
            }
        ];

        vm.corsicat = ricerca.corsicategoria;
        vm.servizicat = ricerca.servizicategoria;
        vm.statobeneficiarios = ricerca.statobeneficiarios;

        vm.genericValidationError = {};
        vm.genericValidationError.required = "Campo obbligatorio da riempire : ";
        vm.genericValidationError.mindate = "Data troppo piccola : ";
        vm.genericValidationError.maxdate = "Data troppo grande : ";

        vm.nstatusgs = [
            {id: 591, descrizione: "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO"},
            {id: 592, descrizione: "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA"},
            {id: 593, descrizione: "TITOLARE PROTEZIONE UMANITARIA"}
        ];
        vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014,2015,2016], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
        vm.arraynstatus = {tipo: [1999], stato: [1]};
        vm.arraynstatus2 = {tipo: [1998], stato: [1]};
        vm.arrayallstatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014,2015,2016], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
        //vm.arraystatus = {tipo: [2000], stato: [1, 3, 4, 5, 10, 11, 15, 20]};
        //vm.arraydocumenti = {tipo: [2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030], stato: [1]};
        vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088], stato: [1, 4]};
        vm.arrayproroga = {tipo: [1011], stato: [1, 3, 4]}; //eliminato 1009
        vm.arrayuscita = {tipo: [1010], stato: [1]};
        vm.arrayallontanamento = {tipo: [1012], stato: [1, 3]};
        vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 4, 5, 20]};
        if (vm.api.isOperatoreG) {
            vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 5, 20]};
        }
        //divido trasferimento interno e esterno
        vm.arraytrasferimentoA = {tipo: [1013], stato: [-1, 1, 2, 3]};
        vm.arraytrasferimentoB = {tipo: [1014], stato: [1, 2, 3]};
        vm.arraytrasferimentoC = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 4, 5, 20]};
        if (vm.api.isOperatoreG) {
            vm.arraytrasferimentoC = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 4, 5, 20]};
        }
        vm.arraynewprocess = {tipo: [2000, 2001, 2002, 2003, 1010], stato: [1, 3, 5, 10, 11, 14, 15, 16, 17, 20]};
        //poi verranno ricaricati quando carico beneficiario
        vm.newprocess = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
            titolo: "Nuovo evento",
            numeroEventi: 5
        };
        vm.sg = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
            titolo: "Nuovo status giuridico",
            numeroEventi: vm.arraystatus.tipo.length
        };
        vm.nsg = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraynstatus.tipo.join(), sort: "nome"},
            titolo: "AGGIUNGI TIPO SOGGIORNO",
            numeroEventi: vm.arraynstatus.tipo.length
        };
        vm.nsg2 = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraynstatus2.tipo.join(), sort: "nome"},
            titolo: "MODIFICA TIPO SOGGIORNO",
            numeroEventi: vm.arraynstatus2.tipo.length
        };
        vm.acc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: vm.arrayproroga.tipo.length
        };
        vm.uscita = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
            titolo: "Nuova uscita",
            numeroEventi: vm.arrayuscita.tipo.length
        };
        vm.newpro = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: 1
        };
        vm.newdoc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
            titolo: "Aggiungi/rinnova documento",
            numeroEventi: vm.arraydocumenti.tipo.length
        };
        vm.newtrasf = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimento.tipo.length
        };
        //divido trasferimento interno e esterno
        vm.newtrasfA = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoA.tipo.length
        };
        vm.newtrasfB = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoB.tipo.length
        };
        vm.newall = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
            titolo: "Nuovo allontanamento",
            numeroEventi: vm.arrayallontanamento.tipo.length
        };
//fine sprar new process
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.Beneficiario = {}; //Beneficiario;
        vm.beneficiario = {}; //angular.copy(Beneficiario.data[0])
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoDocumento = null;
        vm.tipoIngresso = null;
        vm.stato = null;
        vm.uploadParams = {
            documentoTipo_id: 0,
            gruppo: 'BENEFICIARIO',
            dettaglio: true,
            entita: 'beneficiario',
            entitakey: 'beneficiario_id',
            entitakey2: 'pid',
            pid: 0,
            entita2_id: 0,
            cancellazione: vm.api.isAdminG,
            isAdminG: vm.api.isAdminG
        };
        vm.uploadParams.beneficiario_id = vm.beneficiario_id;
        vm.uploadParams.entita_id = vm.beneficiario_id;
        vm.uploadParams2 = {
            documentoTipo_id: 0,
            gruppo: 'TRASFERIMENTI',
            dettaglio: true,
            entita: 'beneficiario',
            entitakey: 'beneficiario_id'
        };
        vm.uploadParams2.beneficiario_id = vm.beneficiario_id;
        vm.uploadParams2.entita_id = vm.beneficiario_id;
        vm.viewEvento = eventi.viewDetails;
        vm.colors = eventi.colors;
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "500", sort: "descrizione"}, function (response) {
            vm.nazioni = response.data;
            vm.nazionalitas = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "50", sort: "descrizione"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", sort: "descrizione"}, function (response) {
            vm.tipoDocumento = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50", sort: "descrizione"}, function (response) {
            vm.tipoIngresso = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "STATO", pagination: "50", sort: "descrizione"}, function (response) {
            vm.stato = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "TIPO-PROTEZIONE", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.tipoProteziones = response.data;
        });
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        })
//        api.beneficiarios.attributi.cerca({gruppo: "PARENTELA", pagination: "50", sort: "descrizione"}, function (response) {
//            vm.parentelas = response.data;
//        });
//        api.beneficiarios.attributi.cerca({gruppo: "VULNERABILITA", pagination: "50", sort: "descrizione"}, function (response) {
//            vm.vulnerabilitas = response.data;
//        });
        vm.ingresso = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'INGRESSO', sort: 'descrizione'}).$promise.then(function (response) {
                vm.ingressos = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.ingresso();
        api.entes.ente.cerca({enteTipo_id: "7", pagination: "200", sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
            vm.enteDocumentoids = response.data;
        });
        vm.nucleofamiliare = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'NUCLEOFAMILIARE', sort: 'descrizione'}).$promise.then(function (response) {
                vm.nucleofamiliares = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.nucleofamiliare();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.vulnerabilita();
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: '-note,descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
                angular.forEach(vm.parentelas, function (parentela) {

                });
            }, function (response) {
                //console.log(response);
            });
        };
        vm.parentela();
        vm.popupEsterna = function(){
          $mdDialog.show({
            controller: 'DisattivaEsternaController',
            controllerAs: 'vmd',
            templateUrl:'app/main/sprardb/beneficiari/dialog/disattivaEsterna.html' ,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              progetto_id: vm.beneficiario.progetto_id,
              struttura: $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})
            }
          });
        }

        vm.eliminaProcesso = function(ev, evento){
            var confirm = $mdDialog.confirm()
                .title('Elimina processo')
                .textContent('Sei sicuro di voler eliminare il processo?')
                .targetEvent(ev)
                .ok('Conferma')
                .cancel('Annulla');

            $mdDialog.show(confirm).then(function() {
                api.processi.processo.elimina({id: evento.id},function(res){
                    $state.reload();
                });
            });
        }

        vm.sino = ricerca.sino;
        vm.provenienza = api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "TIPO-PROVENIENZA", sort: "ordinamento,descrizione", pagination: 100});
        vm.dublino = ricerca.dublino;
        vm.iTipoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PASSAPORTO"}, {descrizione: "CARTA IDENTITA"}, {descrizione: "ALTRO"}];
        vm.iLuogoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PAESE ORIGINE"}, {descrizione: "ITALIA"}, {descrizione: "ALTRO"}];
        vm.iModalitaAccertamento = [{descrizione: "NESSUNO"}, {descrizione: "DOCUMENTO"}, {descrizione: "COLLOQUIO"}, {descrizione: "ACCERTAMENTO"}, {descrizione: "ALTRO"}];
        vm.iQualifica = [{descrizione: "NESSUNO"}, {descrizione: "SINDACO"}, {descrizione: "ASSESSORE"}, {descrizione: "DIRIGENTE"}, {descrizione: "ASSISTENTE SOCIALE"}, {descrizione: "AVVOCATO"}, {descrizione: "TUTORE VOLONTARIO"}, {descrizione: "ALTRO"}];
        vm.isnew = false;
        vm.evento = 'update';
        var searchpayload = {expand: 'progetto', fields: 'progetto.nome,*', id: vm.beneficiario_id};
        vm.beneficiario.eventostatusgs = [];
        vm.beneficiario.eventoprorogas = [];
        vm.beneficiario.eventouscitas = [];
        vm.beneficiario.eventotrasferimentos = [];
        vm.beneficiario.eventoallontanamentos = [];
        vm.beneficiario.eventodocumentos = [];
        vm.beneficiario.eventoAstatusgs = [];
        vm.beneficiario.eventoAprorogas = [];
        vm.beneficiario.eventoAuscitas = [];
        vm.beneficiario.eventoAtrasferimentos = [];
        vm.beneficiario.eventoAallontanamentos = [];
        vm.beneficiario.eventoAdocumentos = [];
        vm.beneficiario_segnalato = {};
        // vm.eraTitolare = false;
//carica beneficiario
        vm.loadb = function () {
            api.paeseTerzoProvenienza.index({expand:'nazione.descrizione'}, function (response) {
              vm.paeseProvenienza = response.data;
            })
            api.beneficiarios.beneficiario.get(searchpayload).$promise.then(function (response) {
                vm.Beneficiario = response;
                vm.beneficiario = response;
                vm.strutturaCorr = $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})[0];
                vm.shb_corr = $filter('filter')(vm.beneficiario.strutturahasbeneficiarios, {dataCessazione: null})[0];
                vm.beneficiario.dataNascita = new Date(vm.beneficiario.dataNascita);

                //vgiac: è necessario avere le informazioni sul segnalato?
                // {
                //     if (vm.beneficiario.segnalato_id > 0)
                //         api.segnalatos.segnalato.get({id: vm.beneficiario.segnalato_id}, function (s) {
                //             vm.beneficiario_segnalato = s;
                //             if (s.tipoProtezione_id == 591 || s.tipoProtezione_id == 592 || s.tipoProtezione_id == 593 || s.tipoProtezione_id == 961 || s.tipoProtezione_id == 962) {
                //                 vm.eraTitolare = true;
                //             }
                //         });
                // }
                if (vm.beneficiario.nucleoFamiliare !== null) {
                    vm.filternucleo = true;
                }

                vm.uploadParams.beneficiario_id = vm.beneficiario.id;
                vm.uploadParams.entita_id = vm.beneficiario.id;
                vm.uploadParams.pid = vm.beneficiario.progetto_id;
                vm.uploadParams.entita2_id = vm.beneficiario.progetto_id;
                vm.uploadParams2.beneficiario_id = vm.beneficiario.id;
                vm.uploadParams2.entita_id = vm.beneficiario.id;
                vm.isnew = false;
                if (!vm.beneficiario)
                {
                    vm.beneficiario = {};
                    vm.evento = 'new';
                    vm.isnew = true;
                }

//                console.log("check vm.cookiepid:", vm.cookiepid);
//                console.log("check progettiAbilitati:", vm.progettiAbilitati);
//                console.log("check vm.beneficiario.progetto_id:", vm.beneficiario.progetto_id);
//                console.log("check readonly:", vm.progettiAbilitati.indexOf(vm.beneficiario.progetto_id));
                if (vm.progettiAbilitati.indexOf(vm.beneficiario.progetto_id) == -1 && !vm.api.isAdmin) {
                    vm.isReadOnly = true;

                }

                angular.forEach(vm.beneficiario, function (value, key) {
                    if (key.toLowerCase().indexOf("data") !== -1) {
                        if (value === '0000-00-00' || value === null) {
                            vm.beneficiario[key] = null;
                        } else {
                            vm.beneficiario[key] = new Date(value);
                        }
                    }
                });

                vm.beneficiario.dataInizioDisplay = $filter('date')(vm.beneficiario.dataInizio, 'dd/MM/yyyy');
                vm.eventiCambioData = $filter('filter')(vm.beneficiario.eventos, {eventoTipo_id: 30000});
                vm.eventiPresenze = $filter('filter')(vm.beneficiario.eventos, {eventoTipo_id: 1018})
//commissione statica
                var isJsonString = function (str) {
                    try {
                        JSON.parse(str);
                    } catch (e) {
                        return {};
                    }
                    return JSON.parse(str);
                };
                var ec = angular.copy(vm.beneficiario.extraCommissione);
                vm.beneficiario.extraCommissione = isJsonString(ec);
                angular.forEach(vm.beneficiario.extraCommissione, function (value, key) {
                    if (key.toLowerCase().indexOf("data") !== -1) {
                        //if (!angular.isDate(key)) {
                        if (value === '0000-00-00' || value === null) {
                            vm.beneficiario.extraCommissione[key] = null;
                        } else {
                            vm.beneficiario.extraCommissione[key] = new Date(value);
                        }
                    }
                });
                vm.beneficiario.minore = false;
                vm.minori = false;
                vm.oggi = new Date();
                vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.maxDated = new Date((vm.oggi.getFullYear() + 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDatesafe = new Date((vm.oggi.getFullYear() - 20) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.minDated = new Date((vm.oggi.getFullYear() - 5) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
                vm.maxDatem = vm.oggi;
//                vm.beneficiario.minore = true;
//                vm.minori = true;
                if (angular.isUndefined(vm.beneficiario.segnalaziones) || vm.beneficiario.segnalaziones == null) {
                    //non ha segnalazione VECCHI
                    vm.beneficiario.segnalaziones = {};
                    vm.beneficiario.segnalaziones.idTipoSegnalazione = 0;
                }
                //console.log("BENEFICIARIO-B4", vm.beneficiario);
                if (vm.beneficiario.segnalaziones.idTipoSegnalazione == 607) {
                    //tipo segnalzione = minori era un msna
                    vm.beneficiario.minore = true;
                    vm.minori = true;
                }
                if (vm.minori) {
                    vm.minDate = vm.maxDate;
                    vm.maxDate = vm.oggi;
                    //vm.arraytrasferimento = {tipo: [1013, 1014], stato: [1, 2, 3]};
                    //tipoProtezione_id che consentono la richiesta di trasferimento in struttura maggiorenni
                    var arraytipoProtezione_id_max = [590, 591, 592, 593];
                    if (arraytipoProtezione_id_max.indexOf(vm.beneficiario.tipoProtezione_id) >= 0) {
                        vm.arraytrasferimento.tipo.push(1015);
                        vm.arraytrasferimentoA.tipo.push(1015);
                    }
                    if (arraytipoProtezione_id_max.indexOf(vm.beneficiario.tipoProtezione_id) == -1) {
                        vm.arrayuscita.tipo.push(1016);
                    }

                }

                vm.newprocess = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
                    titolo: "Nuovo evento",
                    numeroEventi: 5
                };
                vm.sg = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
                    titolo: "Nuovo status giuridico",
                    numeroEventi: vm.arraystatus.tipo.length
                };
                vm.nsg = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraynstatus.tipo.join(), sort: "nome"},
                    titolo: "AGGIUNGI TIPO SOGGIORNO",
                    numeroEventi: vm.arraynstatus.tipo.length
                };
                vm.nsg2 = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraynstatus2.tipo.join(), sort: "nome"},
                    titolo: "MODIFICA TIPO SOGGIORNO",
                    numeroEventi: vm.arraynstatus2.tipo.length
                };
                vm.acc = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
                    titolo: "Nuova proroga",
                    numeroEventi: vm.arrayproroga.tipo.length
                };
                vm.uscita = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
                    titolo: "Nuova uscita",
                    numeroEventi: vm.arrayuscita.tipo.length
                };
                vm.newpro = {
                    entita1_id: vm.beneficiario.id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
                    titolo: "Nuova proroga",
                    numeroEventi: 1
                };

                var documento_id_abilitati = [];
                angular.forEach(ricerca.corr_tiprot_doc, function (docs, tprot) {
                    if (parseInt(tprot) === vm.beneficiario.tipoProtezione_id) {
                        documento_id_abilitati = docs;
                    }
                });
                var processi_doc_abilitati = [];
                angular.forEach(ricerca.corr_doc_processi, function (processo_id_ab, doc) {
                    if (documento_id_abilitati.indexOf(parseInt(doc)) > -1) {
                        processi_doc_abilitati.push(processo_id_ab);
                    }
                });
                vm.arraydocumentiB = angular.copy(vm.arraydocumenti);
                vm.arraydocumenti = {tipo: processi_doc_abilitati, stato: [1]};
                vm.newdoc = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
                    titolo: "Aggiungi/rinnova documento",
                    numeroEventi: vm.arraydocumenti.tipo.length
                };
                vm.newtrasf = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
                    titolo: "Nuovo trasferimento",
                    numeroEventi: vm.arraytrasferimento.tipo.length
                };
                vm.newtrasfA = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
                    titolo: "Nuovo trasferimento",
                    numeroEventi: vm.arraytrasferimentoA.tipo.length
                };
                vm.newtrasfB = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
                    titolo: "Nuovo trasferimento",
                    numeroEventi: vm.arraytrasferimentoB.tipo.length
                };
                vm.newall = {
                    entita1_id: vm.beneficiario_id,
                    entita2_id: vm.beneficiario.struttura_id,
                    eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
                    titolo: "Nuovo allontanamento",
                    numeroEventi: vm.arrayallontanamento.tipo.length
                };
                var counter = 0;
                vm.spliteventos = {
                    eventostatusgs: vm.arraystatus,
                    eventonstatusgs: vm.arraynstatus,
                    eventonstatusg2s: vm.arraynstatus2,
                    eventoprorogas: vm.arrayproroga,
                    eventouscitas: vm.arrayuscita,
                    eventotrasferimentos: vm.arraytrasferimento,
                    eventotrasferimentoAs: vm.arraytrasferimentoA,
                    eventotrasferimentoBs: vm.arraytrasferimentoB,
                    eventodocumentos: vm.arraydocumenti,
                    eventoallontanamentos: vm.arrayallontanamento
                };
                vm.splitAeventos = {
                    eventoAstatusgs: vm.arraystatus,
                    eventoAnstatusgs: vm.arrayallstatus,
                    eventoAprorogas: vm.arrayproroga,
                    eventoAuscitas: vm.arrayuscita,
                    eventoAtrasferimentos: vm.arraytrasferimento,
                    eventoAtrasferimentoAs: vm.arraytrasferimentoA,
                    eventoAtrasferimentoBs: vm.arraytrasferimentoB,
                    eventoAtrasferimentoCs: vm.arraytrasferimentoC,
                    eventoAdocumentos: vm.arraydocumentiB,
                    eventoAallontanamentos: vm.arrayallontanamento
                };
                vm.beneficiario.eventostatusgs = [];
                vm.beneficiario.eventonstatusgs = [];
                vm.beneficiario.eventonstatusg2s = [];
                vm.beneficiario.eventoprorogas = [];
                vm.beneficiario.eventouscitas = [];
                vm.beneficiario.eventotrasferimentos = [];
                vm.beneficiario.eventotrasferimentoAs = [];
                vm.beneficiario.eventotrasferimentoBs = [];
                vm.beneficiario.eventoallontanamentos = [];
                vm.beneficiario.eventodocumentos = [];
                vm.beneficiario.eventoAstatusgs = [];
                vm.beneficiario.eventoAnstatusgs = [];
                vm.beneficiario.eventoAprorogas = [];
                vm.beneficiario.eventoAuscitas = [];
                vm.beneficiario.eventoAtrasferimentos = [];
                vm.beneficiario.eventoAtrasferimentoAs = [];
                vm.beneficiario.eventoAtrasferimentoBs = [];
                vm.beneficiario.eventoAtrasferimentoCs = [];
                vm.beneficiario.eventoAallontanamentos = [];
                vm.beneficiario.eventoAdocumentos = [];
                angular.forEach(vm.beneficiario.eventos, function (obj) {
                    //console.log("obj", obj);
                    vm.beneficiario.eventos[counter].processi = obj.eventoTipo.processo.split("|");
                    //separo processi status, documenti e proroghe, trasferimenti/uscite in 4 oggetti, solo quelli da lavorare
                    angular.forEach(vm.spliteventos, function (dati, chiave) {

                        if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && dati.stato.indexOf(obj.eventoStato_id) >= 0) {

                            //soddisfa condizioni di tipo e stato contemporaneamente
                            vm.beneficiario[chiave].push(obj);
                            //console.log("eventos:", chiave, vm.beneficiario[chiave]);
                        }
                    });
                    angular.forEach(vm.splitAeventos, function (dati, chiave) {
                        obj.extra = angular.fromJson(obj.extra);
                        if (vm.api.isAdmin) {
                            if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0) {

                                vm.beneficiario[chiave].push(obj);
                            }
                        } else {
                            if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && obj.progetto_id == vm.beneficiario.progetto_id && dati.stato.indexOf(obj.eventoStato_id) >= 0) {

                                vm.beneficiario[chiave].push(obj);
                            }
                        }

                    });
                    counter++;
                });

                var sgcount = 0;
                var sgcounthowmany = 0;

                angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                    if (esg.eventoTipo_id == 2000) {
                        sgcount = kesg;
                        sgcounthowmany++;
                    }
                });
                if (sgcounthowmany >= 1) {
                    var copyeventostatusg = angular.copy(vm.beneficiario.eventostatusgs);
                    vm.beneficiario.eventostatusgs = null;
                    vm.beneficiario.eventostatusgs = [];
                    vm.beneficiario.eventostatusgs.push(copyeventostatusg[sgcount]);
                }


                if (vm.beneficiario.trasferimento === 1) {
                    //progetto arrivo
                    api.progettos.progetto.get({id: vm.beneficiario.progetto_id, fields: "id,nome"}, function (p) {
                        vm.beneficiario.progettos = p;
                    });
                }

                if (vm.beneficiario.eventostatusgs[0]) {
                    if (vm.beneficiario.v_genSingMinori == 1) {
                        vm.testform = vm.extractjsonform2(vm.beneficiario.eventostatusgs[0]);
                    }
                    if (vm.beneficiario.v_genSingMinori == 0) {
                        vm.testform = vm.extractjsonform(vm.beneficiario.eventostatusgs[0]);
                    }
                    console.log("vm.testform", vm.testform);
                    console.log("vm.beneficiario.v_genSingMinori", vm.beneficiario.v_genSingMinori);
                }
                vm.beneficiarioBackup = angular.copy(vm.beneficiario);
                vm.beneficiario.tipoProtezioneCambiato = false;
                vm.beneficiario.tipoDocumentoCambiato = false;

                vm.tuttoDisabilitato = true;
                if (vm.beneficiario.stato == 'BENEFICIARIO') {
                    vm.tuttoDisabilitato = false;
                }
                //console.log("vm.tuttoDisabiltiato", angular.copy(vm.tuttoDisabiltiato));
                vm.beneficiario.di = new Date("3000-01-01");
                vm.beneficiario.du = new Date("1900-01-01");
                vm.beneficiario.dip = new Date("3000-01-01");
                vm.beneficiario.dup = new Date("1900-01-01");
                vm.beneficiario.struttura_id2 = vm.beneficiario.struttura_id;
                //if (!(vm.api.isAdmin || vm.api.isAccoglienza)) {
                angular.forEach(vm.beneficiario.strutturahasbeneficiarios, function (shb0) {
                    var dip;
                    var dup;

                    if (vm.beneficiario.progetto_id == shb0.progetto_id) {
                        dip = new Date(shb0.dataInserimento);
                        dup = (shb0.dataCessazione == null) ? null : new Date(shb0.dataCessazione);
                        if (dip <= vm.beneficiario.dip) {
                            vm.beneficiario.dip = dip;
                        }
                        if (dup >= vm.beneficiario.dup || dup == null) {
                            vm.beneficiario.dup = dup;
                        }
                    }

                });
                angular.forEach(vm.beneficiario.strutturahasbeneficiarios, function (shb) {
                    if (vm.possovisualizzare(shb.progetto_id)) {
                        if (shb.struttura_id != 1 && shb.struttura_id != -1) {
                            var di;
                            var du;
                            di = new Date(shb.dataInserimento);
                            du = (shb.dataCessazione == null) ? null : new Date(shb.dataCessazione);
                            if (di <= vm.beneficiario.di) {
                                vm.beneficiario.di = di;
                                vm.beneficiario.struttura_id2 = shb.struttura_id;
                            }
                            if (du >= vm.beneficiario.du || du == null) {
                                vm.beneficiario.du = du;
                            }
                        }
                    }
                });

                vm.famiglia = null;

                api.eventos.evento.search({eventoTipo_id: '1002', entita1_id: vm.beneficiario.segnalato_id}, function (response) {

                    if (response.data.length > 0) {
                        vm.extraSegnalazione = response.data[0].extra;
                    }
                });

                if (vm.beneficiario.capof_id != 0) {
                    api.beneficiarios.minimal.search({capof_id: vm.beneficiario.capof_id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
                        if (d) {
                            vm.famiglia = d.data;
                        }
                        api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                          vm.beneficiario.capoFamiglia =  res.data[0] ? res.data[0] : null;
                          if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                            vm.famiglia.push(f);
                          }
                        });
                    });
                } else {
                  api.beneficiarios.minimal.search({capof_id: vm.beneficiario.id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
                    if (d) {
                      vm.famiglia = d.data;
                    }
                    api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                      vm.beneficiario.capoFamiglia = res.data[0] ? res.data[0] : null;
                      if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                        vm.famiglia.push(vm.beneficiario.capoFamiglia)
                      }
                    });
                  });
                }
                popUpIncompleti();
                vm.calcolomontante();
                vm.caricamentoultimato = true;
                if(vm.beneficiario.dataFine != null){
                    intervalloData();

                }

              // se la response ritorna un codice vestanet o cui  nullo
              // allora metti la checkbox gia spuntata e prevalorizzata a non disponibile.
              if(vm.beneficiario.cui === null){
                vm.checkboxCui = true
                vm.beneficiario.cui = "NON DISPONIBILE"
              }
              if(vm.beneficiario.codiceVestanet === null){
                vm.checkboxVestanet = true
                vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
              }
            });


            return vm.beneficiario;
        };



        // logica per codice vestanet e cui
        // serve un refactoring completo di questo controller imo.

        vm.checkboxCuiOnClick = function () {
          if (vm.checkboxCui) {
            vm.beneficiario.cui = "NON DISPONIBILE"
          } else {
            vm.beneficiario.cui = ''
          }
        }

        vm.checkboxVestanetOnClick = function () {
          if (vm.checkboxVestanet) {
            vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
          } else {
            vm.beneficiario.codiceVestanet = ''
          }
        }

        vm.mostraCapofamiglia = function (famiglia, capoF) {
          var ret = true;
          angular.forEach(famiglia,function (ben) {
            if(ben.codice == capoF.codice){
                ret = false;
            }
          });
          return ret;
        }

        vm.loadb();
        vm.search = {};
        vm.save = save;
        vm.completa = save;
        vm.closeDialog = closeDialog;
        vm.returnBeneficiari = returnBeneficiari;
        vm.openExtraDialog = openExtraDialog;
        vm.openAttributiDialog = openAttributiDialog;
        vm.cessa = cessazione;
        vm.dataAdOggi = dataAdOggi;
        vm.terminaNelTerritorio = terminaNelTerritorio;
        vm.liberaBeneficiario = liberaBeneficiario;
        vm.accogliInStruttura = accogliInStruttura;
        vm.cambiaCapofamigliaDialog = function(ev,capoF){
          api.beneficiarios.beneficiario.canSetCapofamiglia({id:vm.beneficiario.id},function (res) {
            $mdDialog.show({
              controller: 'DialogCapofamigliaController',
              controllerAs: 'vmd',
              templateUrl: 'app/main/sprardb/form/dialogCapofamigliaForm.html',
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                beneficiario_id: vm.beneficiario.id,
                capoFamiglia: vm.beneficiario.capoFamiglia? vm.beneficiario.capoFamiglia: null,
              }
            }).then(function(response){
              if(response){
                vm.beneficiario.capof_id = response.capoF.segnalato_id;
                vm.beneficiario.capoFamiglia = response.capoF;
                vm.capofamigliaForm.$setDirty();
              }
            });
          });
        };

        vm.cambioStruttura = function()  {
          $mdDialog.show({
            controller: 'CambioStrutturaController',
            controllerAs: 'vmd',
            templateUrl:'app/main/sprardb/form/cambiaStrutturaFormMc.html' ,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              progetto_id: vm.beneficiario.progetto_id,
              struttura_id: vm.beneficiario.struttura_id,
              struttura : vm.strutturaCorr,
              min_date : vm.shb_corr.dataInserimento
            }
          }).then(function(response){
            if(response){
              var payload = {
                id:vm.beneficiario.id,
                struttura_id:response.struttura,
                data:response.dataCambioStruttura,
                note:response.note,
              }
              api.beneficiariomc.cambioStruttura(payload,function (res) {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent('Cambio Struttura effettuato con successo')
                    .position('bottom right')
                    .hideDelay(3000)
                )
                vm.beneficiario.struttura_id = res.beneficiario.struttura_id;
                if (res.disattivabile) {
                  $mdDialog.show({
                    controller: 'DisattivaEsternaController',
                    controllerAs: 'vmd',
                    templateUrl:'app/main/sprardb/beneficiari/dialog/disattivaEsterna.html' ,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                      progetto_id: vm.beneficiario.progetto_id,
                      struttura: $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})
                    }
                  });
                }
                vm.loadb();
              },function () {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent('Errore nel cambio struttura')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                vm.loadb();
              })
            }
          });
        }

        function liberaBeneficiario () {
            var popUp = $mdDialog.confirm()
            .title('Uscita Beneficiario')
            .htmlContent('Necessario far uscire il Beneficiario prima di compiere questa azione')
            .ok('Ok');
            console.log(vm.beneficiario);
            if(vm.Beneficiario.stato !== 'TERMINATO'){
                $mdDialog.show(popUp);
                return;
            }

          $mdDialog.show({
            controller: 'LiberaBeneficiarioController',
            controllerAs: 'vmd',
            templateUrl:'app/main/sprardb/beneficiari/dialog/liberaBeneficiario-dialog.html' ,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              beneficiario: vm.beneficiario,
              items: vm.uscita,

            }
          }).then(function() {
            vm.loadb()
          })
        }


      function terminaNelTerritorio () {
        $mdDialog.show({
          controller: 'TerminaNelTerritorioController',
          controllerAs: 'vmd',
          templateUrl:'app/main/sprardb/beneficiari/dialog/terminaBeneficiarioNelTerritorio-dialog.html' ,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            beneficiario: vm.beneficiario,
          }
        }).then(function() {
          vm.loadb()
        })
      }

      function accogliInStruttura () {
        $mdDialog.show({
          controller: 'AccogliInStrutturaController',
          controllerAs: 'vmd',
          templateUrl:'app/main/sprardb/beneficiari/dialog/accogliInStruttura-dialog.html' ,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            beneficiario: vm.beneficiario,
          }
        }).then(function() {
          vm.loadb()
        })
      }

      function dataAdOggi(dataInizio) {
        var di = new Date(dataInizio);
        var adesso = moment();
        return adesso.diff(di, 'days');
      }

        vm.giorniDifferenza = giorniDifferenza;

        function giorniDifferenza(din, dus) {
            var di = new Date(din);
            var du = moment(dus);
            if (dus == null) {
                du = moment(new Date());
            }

            return du.diff(di, 'days');
        }

        vm.calcolomontante = calcolomontante;
        function calcolomontante() {
            console.log("test");
            vm.calcolomontanteeffettuato = null;
            vm.calcolomontanteeffettuato = [];
            vm.calcoloultimapresenza = null;
            vm.calcoloultimapresenza = [];
            var b = vm.beneficiario;
            var dip = b.dataInizio;
            var dup = b.dataUscita;
            var bid = b.id;
            var nmontante = 0;
            if (angular.isUndefined(vm.calcolomontanteeffettuato[bid])) {
                vm.calcolomontanteeffettuato[bid] = 0;
                if (dup !== null) {
                    api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante', beneficiario_id: bid, dacl: 1}).$promise.then(function (r) {
                        if (r.data.length > 0) {
                            var data = r.data;
                            angular.forEach(data, function (d) {
                                if (d.dataUscita == null && d.dataUscitaB == null) {
                                    var di = new Date(d.dataInizio);
                                    var adesso = moment();
                                    vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                                } else {
                                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                                }
                            });
                        }
                    });

                } else {
                    api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante', beneficiario_id: bid, dacl: 1}).$promise.then(function (r) {
                        if (r.data.length > 0) {
                            var data = r.data;
                            angular.forEach(data, function (d) {
                                if (d.dataUscita == null && d.dataUscitaB == null) {
                                    var di = new Date(d.dataInizio);
                                    var adesso = moment();
                                    vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                                } else {
                                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                                }
                            });
                        }
                    });
                }
            }

        }

        vm.changeDataIns = changeDataIns;

        function changeDataIns(id, data, flag) {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'CambioDataDialogController',
                controllerAs: 'vmd',
                focusOnOpen: false,
                //parent: angular.element($document.find('#content-container')),
                templateUrl: 'app/main/sprardb/beneficiari/dialog/cambioData-dialog.html',
                locals: {
                    id: id,
                    data: data,
                    flag: flag
                }
            }).then(function (payload) {
                for (var indice = 0, len = vm.beneficiario.strutturahasbeneficiarios.length; indice < len; indice++) {
                    if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataInserimento") {
                        vm.beneficiario.strutturahasbeneficiarios[indice].dataInserimento = payload.data;
                    }
                    if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataCessazione") {
                        vm.beneficiario.strutturahasbeneficiarios[indice].dataCessazione = payload.data;
                    }
                }
            });
        }


        function save(evento) {
            //console.log("isnew?:", evento);
            if(vm.beneficiario.cui === "NON DISPONIBILE" || vm.beneficiario.cui === '') {
              vm.beneficiario.cui = null
            }
            if(vm.beneficiario.codiceVestanet === "NON DISPONIBILE" || vm.beneficiario.codiceVestanet === '') {
              vm.beneficiario.codiceVestanet = null
            }
            var beneficiario = angular.extend({}, vm.beneficiario);
            var placeholderdate = new Date("1970-01-01");
            angular.forEach(beneficiario, function (value, key) {
                //console.log("valori:", value);
                if (key.toLowerCase().indexOf("data") !== -1) {
                    //console.log("valori:", value);
                    //console.log("valori:", new Date(value));
                    if (angular.isDate(value)) {
                        if (moment(value).format("YYYY-MM-DD") !== "1970-01-01") {
                            beneficiario[key] = moment(value).format("YYYY-MM-DD");
                        } else {
                            beneficiario[key] = null;
                        }
                    } else {
                        beneficiario[key] = null;
                    }

                }
            });
            var extraCommissione = angular.copy(beneficiario.extraCommissione);
            beneficiario.extraCommissione = angular.toJson(extraCommissione, false);
            //console.log("beneficiario", beneficiario);
            if (evento) {
                api.beneficiarios.beneficiario.save(beneficiario, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Beneficiario inserito')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    $state.go('app.sprardb_beneficiari');
                });
            } else {
                if (beneficiario.def == 0) {
                    api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Beneficiario incompleto aggiornato')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        $state.reload();
                    });
                } else {
                    api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Beneficiario aggiornato')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        $state.reload();
                    });
                }
            }
            /*
             if (!evento) {
             api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
             $mdToast.show(
             $mdToast.simple()
             .textContent('Beneficiario aggiornato')
             .position('bottom right')
             .hideDelay(3000)
             );
             $state.go('app.sprardb_beneficiarii', {def: 0});
             });
             }
             */


        }
        vm.displayextra = false;
        vm.getExtra = getExtra;
        function getExtra(path, data) {
            //console.log(path);
            var paths = path.split('.');
            var root = data;
            angular.forEach(paths, function (obj) {
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                    } catch (err) {
                    }
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }

        vm.dataoggi = new Date();
        vm.m = moment(vm.dataoggi);
        vm.dataoggistring = vm.m.format("YYYY-MM-DD");
        vm.alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Processo')
                .textContent('Operazione Confermata.')
                .ariaLabel('conferma')
                .ok('OK');
        function cessazione(id, e1, e2) {
            var confirm = $mdDialog.confirm()
                    .title('Vuoi far uscire il beneficiario?')
                    .htmlContent('Il beneficiario risulterà uscito a partire dalla data di oggi..')
                    .ariaLabel('r uscita')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function ()
            {
                api.eventos.evento.save({dataInizio: vm.dataoggistring, eventoTipo_id: 8, entita1_id: e1, eventoStato_id: 4, alert: 0}, function (response) {
                    //console.log(response);
                    api.beneficiarios.beneficiario.aggiorna({id: e1, stato: 'LIBERO'}, function (response) {
                        //console.log(response);
                        $mdDialog.show(vm.alert);
                        $state.reload();
                    });
                });
            }, function () {

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function returnBeneficiari() {
            $state.go('app.sprardb_beneficiari', {def: 1});
        }
        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto);
            //console.log(index);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'beneficiario',
                }
            });
        }


        function openAttributiDialog(ev, item, index, newlink) {

            $mdDialog.show({
                controller: 'DialogAttributiController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogAttributiBForm.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    Beneficiario: item,
                    index: index,
                    newlink: newlink
                }
            });
        }
        vm.attributiLabel = {
            'COMPETENZE': 'Competenze professionali',
            'CORSO': 'Interessi Corsi',
            'DOCUMENTO': 'Tipo Documento Ingresso',
            'INGRESSO': 'Tipo di Ingresso',
            'LINGUA': 'Lingua',
            'LINGUA-CONOSCENZA': 'Conoscenza lingue',
            'MOTIVO-USCITA': 'Motivo di Uscita',
            'NAZIONE': 'Nazione',
            'PARENTELA': 'Gradi di parentela',
            'PROFESSIONE': 'Professione svolte',
            'RELIGIONE': 'Religione',
            'SERVIZIO': 'Interesse a servizio',
            'STATO': 'Stato',
            'STUDI': 'Studi Effettuati',
            'STUDI-AREA': 'Area studi di interesse',
            'VULNERABILITA': 'Tipo di Vulnerabilità',
        };
        vm.tempstruttura = null;
        vm.tempaccoglienza = null;
        vm.tempalloggio = null;

        vm.openDialogs = openDialogs;
        function openDialogs(ev, struttura_id, progetto_id) {
          api.strutture.struttura2.cerca({id: struttura_id, pagination: 10, fields: 'id,esterna'}, function (response) {
            vm.tempstruttura = response;
            if (angular.isUndefined(struttura_id)) {
              vm.tempstruttura = {};
            }
            api.strutture.accoglienza.get({sort: "descrizione"}, function (response) {
              vm.tempaccoglienza = response;
              api.strutture.alloggio.cerca({sort: "descrizione", id_IN: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15"}, function (response) {
                vm.tempalloggio = response;
                $mdDialog.show({
                  controller: 'DettaglioMcController',
                  controllerAs: 'vm',
                  templateUrl: 'app/main/sprardb/form/strutturaFormMc.html',
                  targetEvent: ev,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    Struttura: vm.tempstruttura,
                    Accoglienza: vm.tempaccoglienza,
                    Alloggio: vm.tempalloggio,
                    progetto_id: progetto_id,
                    struttura_id: struttura_id,
                    dialog: true,
                    esterna: vm.tempstruttura.data[0].esterna
                  }
                }).then(vm.loadb());
              });
            });
          })
        }

        vm.work = eventi.work;
        vm.work2 = eventi.work2;

        vm.years = [
            {id: ""},
            {id: (new Date()).getFullYear()},
            {id: (new Date()).getFullYear() - 1},
            {id: (new Date()).getFullYear() - 2},
            {id: (new Date()).getFullYear() - 3},
            {id: (new Date()).getFullYear() - 4},
            {id: (new Date()).getFullYear() - 5},
            {id: (new Date()).getFullYear() - 6},
            {id: (new Date()).getFullYear() - 7},
            {id: (new Date()).getFullYear() - 8},
            {id: (new Date()).getFullYear() - 9},
            {id: (new Date()).getFullYear() - 10},
            {id: (new Date()).getFullYear() - 11},
            {id: (new Date()).getFullYear() - 12},
            {id: (new Date()).getFullYear() - 13},
            {id: (new Date()).getFullYear() - 14},
            {id: (new Date()).getFullYear() - 15},
            {id: (new Date()).getFullYear() - 16},
            {id: (new Date()).getFullYear() - 17},
            {id: (new Date()).getFullYear() - 18},
            {id: (new Date()).getFullYear() - 19},
            {id: (new Date()).getFullYear() - 20}
        ];
        vm.sersearchYear = new Date().getFullYear();
        vm.corsearchYear = new Date().getFullYear();



        vm.openCorsiBenDialog = openCorsiBenDialog;
        function openCorsiBenDialog(ev, item, index, newlink) {
            var oggi = new Date();
            var today = moment(oggi).format('YYYY-MM-DD');
            var cu = angular.copy(item.corsos);
            var ii = 0;
            var nuovoindice = null;
            for (ii = 0; ii < cu.length; ii++) {
                if (cu[ii].id == index) {
                    nuovoindice = ii;
                }
            }
            api.progettos.hascorsi.search({pagination: -1, progetto_id: vm.beneficiario.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
                vm.tempcorsi = response;
                $mdDialog.show({
                    controller: 'DialogCorsiBenController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/form/dialogCorsiBenForm.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        All: vm.tempcorsi,
                        Ben: item,
                        index: nuovoindice,
                        newlink: newlink
                    }
                });
            });
        }

        vm.openServiziBenDialog = openServiziBenDialog;
        function openServiziBenDialog(ev, item, index, newlink) {
            var oggi = new Date();
            var today = moment(oggi).format('YYYY-MM-DD');
            var su = angular.copy(item.servizios);
            console.log("su:", su);

            var ii = 0;
            var nuovoindice = null;
            for (ii = 0; ii < su.length; ii++) {
                console.log("ii: ", ii);
                console.log("su[ii]: ", su[ii]);
                if (su[ii].id == index) {
                    nuovoindice = ii;
                }
            }
            console.log("nuovoindice", nuovoindice);
            api.progettos.hasservizi.search({pagination: -1, progetto_id: vm.beneficiario.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
                vm.tempservizi = response;
                //console.log("response", response);
                $mdDialog.show({
                    controller: 'DialogServiziBenController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/form/dialogServiziBenForm.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        All: vm.tempservizi,
                        Ben: item,
                        index: nuovoindice,
                        newlink: newlink
                    }
                });
            });
        }

        vm.omonimiac = omonimiac;
        function omonimiac(item) {
            var itemcopy = angular.copy(item);
            //itemcopy.debug = 1;
            //delete (itemcopy.id);
            var dataTemp = moment(itemcopy.dataNascita).format('YYYY-MM-DD');
            itemcopy.dataNascita = dataTemp;
            itemcopy.extend = 0;
            api.segnalatos.segnalato2.omonimia(itemcopy, function (r) {
                vm.isomonimo = false;
                var apertura = $mdDialog.confirm()
                        .title('Omonimia')
                        .htmlContent(r.messaggio)
                        .ariaLabel('Confirmmation Box')
                        .ok('DETTAGLI')
                        .cancel('CHIUDI');
                if (r.stato == 1) {
                    vm.isomonimo = true;
                    if (vm.api.isAdmin) {
                        vm.isomonimo = false;
                    }
                    $mdDialog.show(apertura).then(function () {
                        itemcopy.results = 1;
                        api.segnalatos.segnalato2.omonimia(itemcopy, function (r) {
                            var risultati = "";
                            angular.forEach(r.data, function (om) {
                                var importato = (om.beneficiario_id) ? "SEGNALATO" : "BENEFICIARIO";
                                risultati = risultati + "#" + om.id + " <b>" + om.cognome.toUpperCase() + " " + om.nome.toUpperCase() + "</b>, " + om.dataNascita + " " + " - " + importato + "<br>";

                            });
                            if (vm.api.isAdmin) {
                                risultati = risultati + "<b>Nota: per utenti Admin non esiste il blocco indicato. Questo alert è solo un avvertimento</b>";
                            }
                            var apertura2 = $mdDialog.alert()
                                    .title('Dettaglio Omonimia')
                                    .htmlContent(risultati)
                                    .ariaLabel('ConfirmmationBox')
                                    .ok('CHIUDI');
                            $mdDialog.show(apertura2);
                            itemcopy.results = 0;
                        });
                    });
                }
            });
        }



        //scheda statica commissione status
        vm.commissiones = [
            {id: "ANCONA", competenza: "Marche, Abruzzo"},
            {id: "BARI", competenza: "Bari, Matera"},
            {id: "BOLOGNA", competenza: "Emilia Romagna"},
            {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
            {id: "CAGLIARI", competenza: "Sardegna"},
            {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
            {id: "CATANIA", competenza: "Catania, Enna"},
            {id: "CROTONE", competenza: "Calabria"},
            {id: "FIRENZE", competenza: "Toscana, Umbria"},
            {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
            {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
            {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
            {id: "MILANO", competenza: "Lombardia"},
            {id: "PALERMO", competenza: "Palermo, Messina"},
            {id: "ROMA", competenza: "Lazio"},
            {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
            {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
            {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
            {id: "TRAPANI", competenza: "Trapani, Agrigento"},
            {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
        ];
        vm.loadprefettura = loadprefettura;
        function loadprefettura() {
            api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.prefetturas = response.data;
            });
        }
        vm.loadprefettura();
        vm.loadquestura = loadquestura;
        function loadquestura() {
            api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.questuras = response.data;
            });
        }
        vm.loadquestura();
        vm.motivods = motivods;
        function motivods() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "descrizione"}, function (r) {
                vm.motivods = r.data;
            });
        }
        vm.motivods();
        if (angular.isUndefined(vm.beneficiario.extraCommissione) || angular.fromJson(vm.beneficiario.extraCommissione.length) == 0) {
            vm.beneficiario.extraCommissione = {};
            vm.beneficiario.extraCommissione.dataAudizione = null;
            vm.beneficiario.extraCommissione.dataNotificaDiniego = null;
            vm.beneficiario.extraCommissione.dataNotificaRicorso = null;
        }


        vm.formStatus = {
            row1: {
                formtype: "row",
                status: "open"
            }
            ,
            "commissione": {
                "type": "string",
                "title": "Commissione Territoriale competente",
                "description": "Commissione Territoriale competente",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "commissione",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere una commissione territoriale",
                "onchange": "",
                "data": "vm.commissiones",
                "chiave": "id",
                "valore": [
                    "id",
                    "competenza"
                ],
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin"
            }
            ,
            "noteRichiesta": {
                "type": "string",
                "title": "Note",
                "description": "Note",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "noteRichiesta",
                "formtype": "textarea",
                "validationMessage": "Inserire una nota",
                "required": false,
                rows: "2",
                formName: "personaNForm",
                disabled: "!vm.isAdmin"
            },
            row2: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "prefettura": {
                "type": "string",
                "title": "Prefettura competente",
                "description": "Prefettura competente",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "prefettura",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere la prefettura",
                "onchange": "",
                "data": "vm.prefetturas",
                "chiave": "id",
                "valore": "nome",
                "novalore": "0",
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin"
            }

            ,
            "questura": {
                "type": "string",
                "title": "Questura competente",
                "description": "Questura competente",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "questura",
                "required": false,
                "formtype": "select",
                "validationMessage": "Scegliere la questura",
                "onchange": "",
                "data": "vm.questuras",
                "chiave": "id",
                "valore": "nome",
                "novalore": "0",
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin"
            },
            "dataAudizione": {
                "type": "string",
                "title": "Data Audizione",
                "description": "Data Audizione",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "dataAudizione",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "",
                formName: "personaNForm",
                style: "padding-top: 21px;",
                disabled: "!vm.isAdmin"
            }
//            ,
//            "sospensiva": {
//                "type": "string",
//                "title": "Applicazione della sospensiva",
//                "description": "Applicazione della sospensiva",
//                "callbackModel": "beneficiario.extraCommissione",
//                "dbfield": "sospensiva",
//                "required": false,
//                "formtype": "select",
//                "validationMessage": "Scegliere la questura",
//                "onchange": "",
//                "data": "[{id:'NO',descrizione:'Nessuna sospensiva applicata'},{id:'SI',descrizione:'Sospensiva applicata al processo'}]",
//                "chiave": "id",
//                "valore": ["id", "descrizione"],
//                formName: "personaNForm",
//                style: "height: 52px;",
//                disabled: "!vm.isAdmin"
//            }
//
//            ,
//            "mesiSospensiva": {
//                "type": "string",
//                "title": "Mesi Sospensiva",
//                "description": "Mesi Sospensiva",
//                "callbackModel": "beneficiario.extraCommissione",
//                "dbfield": "mesiSospensiva",
//                "required": false,
//                "formtype": "text",
//                "validationMessage": "Inserire mesi",
//                formName: "personaNForm",
//                style: "height: 52px;",
//                disabled: "!vm.isAdmin"
//            }
            ,
            row3: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "diniego": {
                "type": "string",
                "title": "C'è stato un diniego?",
                "description": "C'è stato un diniego?",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "diniego",
                "required": false,
                "formtype": "select",
                "validationMessage": "Dinego obbligatorio",
                "onchange": "",
                "data": "[{id:'NO',descrizione:'Nessuna diniego'},{id:'SI',descrizione:'Diniego presente'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin",
                "novalore": "0"
            }
            ,
            "motivoDiniego": {
                "type": "string",
                "title": "Motivo del diniego",
                "description": "Motivo del diniego",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "motivoDiniego",
                "required": false,
                "formtype": "select",
                "validationMessage": "Selezionare motivo",
                "onchange": "",
                "data": "vm.motivods",
                "chiave": "id",
                "valore": "descrizione",
                style: "height: 52px;",
                disabled: "!vm.isAdmin",
                "novalore": "0"
            }
            ,
            "dataNotificaDiniego": {
                "type": "string",
                "title": "Data notifica diniego",
                "description": "Data notifica diniego",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "dataNotificaDiniego",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "",
                formName: "personaNForm",
                style: "padding-top: 21px;",
                disabled: "!vm.isAdmin"
            }
            ,
            row4: {
                formtype: "row",
                status: "closeopen"
            }
            ,
            "ricorso": {
                "type": "string",
                "title": "C'è stato un ricorso?",
                "description": "C'è stato un ricorso?",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "ricorso",
                "required": false,
                "formtype": "select",
                "validationMessage": "Ricorso obbligatorio",
                "onchange": "",
                "data": "[{id:'NO',descrizione:'Nessuna ricorso richiesto'},{id:'SI',descrizione:'Richiesto ricorso'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin",
                "novalore": "0"
            }
            ,
            "gradoRicorso": {
                "type": "string",
                "title": "Quanti gradi di ricorso?",
                "description": "Quanti gradi di ricorso?",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "gradoRicorso",
                "required": false,
                "formtype": "select",
                "validationMessage": "Grado ricorso obbligatorio",
                "onchange": "",
                "data": "[{id:'Primo grado',descrizione:'Ricorso al max 1 grado'},{id:'Secondo grado',descrizione:'Ricorso al max 2 grado'},{id:'Cassazione',descrizione:'Arrivati al 3 grado di giudizio'}]",
                "chiave": "id",
                "valore": ["id", "descrizione"],
                formName: "personaNForm",
                style: "height: 52px;",
                disabled: "!vm.isAdmin",
                "novalore": "0"
            }
            ,
            "dataNotificaRicorso": {
                "type": "string",
                "title": "Data notifica ricorso",
                "description": "Data notifica ricorso",
                "callbackModel": "beneficiario.extraCommissione",
                "dbfield": "dataNotificaRicorso",
                "required": false,
                "formtype": "datepickerv",
                "validationMessage": "Data richiesta",
                "onchange": "",
                formName: "personaNForm",
                style: "padding-top: 21px;",
                disabled: "!vm.isAdmin"
            }
            ,
            row10: {
                formtype: "row",
                status: "close"
            }
        };
        vm.extractjsonform = extractjsonform;
        function extractjsonform(evento) {
            vm.extra = {};
            vm.parent = {};
            vm.parent = angular.copy(vm.beneficiario);
            var tipoProtezione_id = vm.parent.tipoProtezione_id;
            //console.log("vm.parent", angular.copy(vm.parent));

            var isStato4 = false;
            if (evento.eventoStato_id === 4) {
                isStato4 = true;
            }
            var jsonschema = JSON.parse(angular.copy(evento.eventoTipo.extra));
            //console.log("jsonschema", jsonschema);
            try {
                var jsondata = JSON.parse(angular.copy(evento.extra));
            } catch (err) {
                var jsondata = {};
            }
            angular.forEach(jsondata, function (dv, dk) {
                if (dk.startsWith("data")) {
                    //console.log("dk", dk);
                    if (dv === '0000-00-00' || dv === null) {
                        jsondata[dk] = null;
                    } else {
                        jsondata[dk] = new Date(dv);
                    }
                }
            });
            console.log("extractjsonform1//jsondata:", jsondata);
            if (jsondata === null) {
                jsondata = {};
            }
            var jsonform = {};
            var index = 1;
            var ordine_jsonschema = ["3", "4", "5", "10", "15", "11", "16", "17", "14", "20"];
            var tipoProtezioneRipetuto = false;
            for (var indice = 0, len = ordine_jsonschema.length; indice < len; indice++) {
                var n = ordine_jsonschema[indice];
                //angular.forEach(ordine_jsonschema, function (n) {
//                console.log("evento.eventoStato_id", evento.eventoStato_id);
//                console.log("n", parseInt(n));

                var k = n;
                var v = jsonschema.properties[n];
                //});
                //angular.forEach(jsonschema.properties, function (v, k) {
                var rowtemp = {
                    formtype: "row",
                    status: "closeopen"
                };
                var rowtemp2 = {
                    formtype: "row",
                    status: "closeopen"
                };
                if (index == 1) {
                    rowtemp.status = 'open';
                }
                jsonform['row' + index] = rowtemp;
                var subindex = 1;
                var sectionshow = false;
                if (angular.isDefined(v)) {
                    angular.forEach(v.fields, function (v1, k1) {
                        if (angular.isDefined(jsondata[v1.dbfield])) {
                            sectionshow = true;
                            if (v1.dbfield === 'tipoProtezione_id' && tipoProtezioneRipetuto) {
                                sectionshow = false;
                            }
                            if (v1.dbfield === 'tipoProtezione_id' && !tipoProtezioneRipetuto) {
                                tipoProtezioneRipetuto = true;
                            }

                        }
                    });
                }
                if (sectionshow && isStato4 && n > 4) {
                    sectionshow = false;
                }
                if (sectionshow && evento.eventoStato_id < parseInt(n)) {
                    sectionshow = false;
                }
                var tipoprotezioneDisabled = [590, 961, 962];
                if (sectionshow) {
                    jsonform['divider' + index] = {
                        formtype: "divider",
                        description: v.title
                    };
                    angular.forEach(v.fields, function (v1, k1) {
                        if (subindex > 3) {
                            jsonform['row' + index + "_" + subindex] = rowtemp2;
                            subindex = 1;
                        }
                        jsonform[k1] = v1;
                        //jsonform[k1].disabled = (tipoprotezioneDisabled.indexOf(vm.beneficiario.tipoProtezione_id) === -1 || vm.api.isOperatore);
                        jsonform[k1].disabled = (vm.api.isOperatore);
                        if (tipoProtezione_id !== 590 || vm.api.isAdmin) {
                            jsonform[k1]['required'] = false;
                        }
                        subindex++;
                        if (angular.isDefined(jsondata[v1.dbfield])) {
                            vm[v1.callbackModel][v1.dbfield] = jsondata[v1.dbfield];
                        } else {
                            vm[v1.callbackModel][v1.dbfield] = null;
                        }

                    });
                }
                index++;
            }
            //);
            //controllo se ci sono note chiusura automatiche
            if (jsondata && angular.isDefined(jsondata.noteGenerali)) {
                jsonform.noteGenerali = jsondata.noteGenerali;
            }
            jsonform['row' + index] = {formtype: "row", status: "close"};
            //console.log("jsonform", jsonform);
            //console.log("vm.parent", angular.copy(vm.parent));
            return jsonform;
        }
        vm.extractjsonform2 = extractjsonform2;
        function extractjsonform2(evento) {
            vm.extra = {};
            vm.parent = {};
            vm.parent = angular.copy(vm.beneficiario);
            var tipoProtezione_id = vm.parent.tipoProtezione_id;
            //console.log("vm.parent", angular.copy(vm.parent));

            var isStato4 = false;
            if (evento.eventoStato_id === 4) {
                isStato4 = true;
            }
            var jsonschema = JSON.parse(angular.copy(evento.eventoTipo.extra));
            //console.log("jsonschema", jsonschema);
            try {
                var jsondata = JSON.parse(angular.copy(evento.extra));
            } catch (err) {
                var jsondata = {};
            }
            angular.forEach(jsondata, function (dv, dk) {
                if (dk.startsWith("data")) {
                    //console.log("dk", dk);
                    if (dv === '0000-00-00' || dv === null) {
                        jsondata[dk] = null;
                    } else {
                        jsondata[dk] = new Date(dv);
                    }
                }
            });
            //console.log("jsondata", jsondata);
            if (jsondata === null) {
                jsondata = {};
            }
            var jsonform = {};
            var index = 1;
            var ordine_jsonschema = ["3", "4", "5", "10", "15", "11", "16", "17", "14", "20"];
            var tipoProtezioneRipetuto = false;
            for (var indice = 0, len = ordine_jsonschema.length; indice < len; indice++) {
                var n = ordine_jsonschema[indice];
                //angular.forEach(ordine_jsonschema, function (n) {
//                console.log("evento.eventoStato_id", evento.eventoStato_id);
                //console.log("n", parseInt(n));

                var k = n;
                var v = jsonschema.properties[n];
                //console.log("jsonschema", jsonschema);
                //console.log("v", v);
                //});
                //angular.forEach(jsonschema.properties, function (v, k) {
                var rowtemp = {
                    formtype: "row",
                    status: "closeopen"
                };
                var rowtemp2 = {
                    formtype: "row",
                    status: "closeopen"
                };
                if (index == 1) {
                    rowtemp.status = 'open';
                }
                jsonform['row' + index] = rowtemp;
                var subindex = 1;
                var sectionshow = true;
                if (angular.isDefined(v)) {
                    angular.forEach(v.fields, function (v1, k1) {
                        if (angular.isDefined(jsondata[v1.dbfield])) {
                            sectionshow = true;
                            if (v1.dbfield === 'tipoProtezione_id' && tipoProtezioneRipetuto) {
                                //sectionshow = false;
                            }
                            if (v1.dbfield === 'tipoProtezione_id' && !tipoProtezioneRipetuto) {
                                tipoProtezioneRipetuto = true;
                            }

                        }
                    });
                }
                if (sectionshow && isStato4 && n > 4) {
                    //sectionshow = false;
                }
                if (sectionshow && evento.eventoStato_id < parseInt(n)) {
                    //sectionshow = false;
                }
                var tipoprotezioneDisabled = [590, 961, 962];
                if (sectionshow) {
                    jsonform['divider' + index] = {
                        formtype: "divider",
                        description: "(" + n + ") " + v.title
                    };
                    angular.forEach(v.fields, function (v1, k1) {
                        if (subindex > 3) {
                            jsonform['row' + index + "_" + subindex] = rowtemp2;
                            subindex = 1;
                        }
                        jsonform[k1] = v1;
                        //jsonform[k1].disabled = (tipoprotezioneDisabled.indexOf(vm.beneficiario.tipoProtezione_id) === -1 || vm.api.isOperatore);

                        jsonform[k1].disabled = false;
                        //blocco PR-OPERATORE
                        if (!(vm.api.isAdmin || vm.api.isAccoglienza)) {
                            jsonform[k1].disabled = true;
                        }

                        if ((v1.dbfield == 'tipoProtezione_id' || v1.dbfield == 'dataAvvenutaNotificaEsitoPositivo' || v1.dbfield == 'dataAvvenutaNotificaAccoglimentoRicorso') && vm.api.isOperatore) {
                            jsonform[k1].disabled = true;
                        }
                        if (tipoProtezione_id !== 590 || vm.api.isAdmin) {
                            jsonform[k1]['required'] = false;
                        }
                        subindex++;
                        if (angular.isDefined(jsondata[v1.dbfield])) {
                            vm[v1.callbackModel][v1.dbfield] = jsondata[v1.dbfield];
                        } else {
                            vm[v1.callbackModel][v1.dbfield] = null;
                        }

                    });
                }
                index++;
            }
            //);
            //controllo se ci sono note chiusura automatiche
            if (jsondata && angular.isDefined(jsondata.noteGenerali)) {
                jsonform.noteGenerali = jsondata.noteGenerali;
            }
            jsonform['row' + index] = {formtype: "row", status: "close"};
            //console.log("jsonform", jsonform);
            //console.log("vm.parent", angular.copy(vm.parent));
            return jsonform;
        }

        vm.callbackfunc = true;

        vm.loadParent = loadParent;
        function loadParent() {
            vm.parent.dataRichiestaProtezione = vm.beneficiario.dataRichiestaProtezione;
        }

        vm.aggiornaEventoSG = aggiornaEventoSG;
        function aggiornaEventoSG(id) {
//            angular.forEach(vm.parent.eventostatusgs, function (esg) {
//                var extraTemp = JSON.parse(angular.copy(esg.extra));
//                angular.forEach(extraTemp, function (v, k) {
//                    console.log("v", v);
//                    vm.extra[k] = v;
//                });
//                console.log("extraTemp", extraTemp);
//            });


            if (angular.isDefined(vm.parent.dataRichiestaProtezione) && vm.parent.dataRichiestaProtezione !== null) {
                vm.extra.dataRichiestaProtezione = moment(vm.parent.dataRichiestaProtezione).format('YYYY-MM-DD');
            }
            var tprot_id = [591, 592, 593];
            var dtprot_id = [];
            dtprot_id[591] = "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO";
            dtprot_id[592] = "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA";
            dtprot_id[593] = "TITOLARE PROTEZIONE UMANITARIA";

            if (angular.isDefined(vm.parent.tipoProtezione_id) && tprot_id.indexOf(vm.parent.tipoProtezione_id) !== -1) {
                vm.extra.tipoProtezione_id = vm.parent.tipoProtezione_id;
                vm.extra.descrizioneTipoProtezione = dtprot_id[vm.parent.tipoProtezione_id];
            }

            var extrapayload = JSON.stringify(vm.extra);
            var payload = {};
            payload.id = id;
            payload.extra = extrapayload;
            //console.log("vm.extra: ", vm.extra);
            api.eventos.evento.update(payload, function (upd) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Processo status giuridco aggiornato!!')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(
                        vm.loadb()
                        );
            });
        }
        vm.aggiornaEventoSGeSalva = aggiornaEventoSGeSalva;
        function aggiornaEventoSGeSalva(id) {

//            angular.forEach(vm.parent.eventostatusgs, function (esg) {
//                var extraTemp = JSON.parse(angular.copy(esg.extra));
//                angular.forEach(extraTemp, function (v, k) {
//                    vm.extra[k] = v;
//                });
//                angular.forEach(esg, function (v, k) {
//                    vm.extra[k] = v;
//                });
//            });
//            vm.extra.dataRichiestaProtezione = moment(vm.parent.dataRichiestaProtezione).format('YYYY-MM-DD');

            if (angular.isDefined(vm.parent.dataRichiestaProtezione) && vm.parent.dataRichiestaProtezione !== null) {
                vm.extra.dataRichiestaProtezione = moment(vm.parent.dataRichiestaProtezione).format('YYYY-MM-DD');
            }
            var tprot_id = [591, 592, 593];
            var dtprot_id = [];
            dtprot_id[591] = "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO";
            dtprot_id[592] = "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA";
            dtprot_id[593] = "TITOLARE PROTEZIONE UMANITARIA";

            if (angular.isDefined(vm.parent.tipoProtezione_id) && tprot_id.indexOf(vm.parent.tipoProtezione_id) !== -1) {
                vm.extra.tipoProtezione_id = vm.parent.tipoProtezione_id;
                vm.extra.descrizioneTipoProtezione = dtprot_id[vm.parent.tipoProtezione_id];
            }

            var extrapayload = JSON.stringify(vm.extra);
            var payload = {};
            payload.id = id;
            payload.extra = extrapayload;
            api.eventos.evento.update(payload, function (upd) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Processo status giuridco aggiornato!!')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(
                        vm.save(vm.isnew)
                        );
            });
        }

        vm.aggiornaVestanet = aggiornaVestanet;
        function aggiornaVestanet() {
            var benVestanet = {};
            benVestanet.id = vm.beneficiario.id;
            benVestanet.codiceVestanet = vm.beneficiario.codiceVestanet;
            api.beneficiarios.beneficiario.update(benVestanet, function (response) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Codice Vestanet aggiornato.')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                $state.go('app.sprardb_beneficiari');
            });
        }

        vm.nascondiStringa = nascondiStringa;
        function nascondiStringa(stringa, progetto_id) {
            if (angular.isDefined(stringa) && stringa !== null) {
                var lunghezza = stringa.toString().length;
                var progetti = $cookies.getObject('ALL_p_id');
                var progettiA = progetti.split();
                if (progetti.indexOf(progetto_id) === -1 && !vm.isAdmin && !vm.isVisitatore && !vm.isTutor) {
                    stringa = stringa.replace(/[a-zA-Z0-9]/g, "*");
                }
            }

            return stringa;
        }
        vm.possovisualizzare = possovisualizzare;
        function possovisualizzare(progetto_id) {

            var progetti = $cookies.getObject('ALL_p_id');
            var results = true;
            if ((progetti.indexOf(progetto_id) === -1 && !vm.isAdmin && !vm.isVisitatore && !vm.isTutor)) {
                results = false;
            }
            //console.log("results:", results);

            return results;
        }


        vm.dataLimiteMinimo = false;
        vm.cambiaData = cambiaData;
        function cambiaData(nomeData) {
            vm.dataLimiteMinimo = false;
            var controlli = [
                'dataIngresso',
                'dataInteresseExArt',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];
            vm.finoA = controlli.indexOf(nomeData);
            for (i = 0; i < vm.finoA; i++) {
                if (i <= 3) {
                    if (vm.beneficiario[controlli[i]] !== null) {
                        vm.dataLimiteMinimo = vm.beneficiario[controlli[i]];
                    }
                } else {
                    if (vm.beneficiario.extraCommissione[controlli[i]] !== null) {
                        vm.dataLimiteMinimo = vm.beneficiario.extraCommissione[controlli[i]];
                    }
                }
            }

            return vm.dataLimiteMinimo;
        }
        vm.controllaD = controllaD;
        function controllaD(nomeData) {
            var controlli = [
                'dataIngresso',
                'dataInteresseExArt',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];
            var nomicampi = [
                'dataIngresso',
                'dataManifestazioneVolonta',
                'dataC3',
                'dataRichiestaProtezione',
                'dataAudizione',
                'dataNotificaDiniego',
                'dataNotificaRicorso'
            ];
            angular.forEach(controlli, function (c, ii) {
                var campoprecedente = c;
                if (ii > 0) {
                    campoprecedente = controlli[ii - 1];
                }


                if (vm.beneficiario[c] < vm.beneficiario[campoprecedente] && vm.beneficiario[c] != null && vm.beneficiario[campoprecedente] !== null) {
//                    console.log("c:", c);
//                    console.log(vm.segnalati[c]);
//
//                    console.log("campoprecedente:", campoprecedente);
//                    console.log(vm.segnalati[campoprecedente]);

                    vm.beneficiario[c] = null;
                }

            });
        }

        vm.checkCambiaTipoSoggiorno = checkCambiaTipoSoggiorno;
        function checkCambiaTipoSoggiorno() {

            var confirm1 = $mdDialog.confirm()
                    .title('Tipo di soggiorno non consentito')
                    .htmlContent('Il cambiamento che stai tentando di effettuare non è valido.<br>Per ulteriori informazione <b>contattare il Servizio Centrale.</b><br><br>Verrà ripristinata la precedente tipologia di soggiorno.')
                    .ariaLabel('cambia ts')
                    .ok('Ok');

            if (vm.beneficiario.v_genSingMinori == 1) {
                //vecchio porting
                var ctsp = vm.checkCambioTipoSoggiornoPossibile();
                if (ctsp === false) {
                    $mdDialog.show(confirm1);
                }
                if (ctsp === true) {
                    var confirm = $mdDialog.confirm()
                            .title('Cambio tipo di soggiorno')
                            .htmlContent('Procedendo a modificare direttamente il tipo di soggiorno, i dati relativi alla Commissione potrebbero risultare non coerenti o incompleti.<br>Ricorda di cambiare anche il <b>&quot;Documento di Soggiorno&quot;</b>.')
                            .ariaLabel('cambia ts')
                            .ok('Ok ho capito, modifica')
                            .cancel('Non Modificare');
                    $mdDialog.show(confirm).then(function () {
                        //Ok Ho capito
                        var sgcount = 0;
                        var sgcounthowmany = 0;
                        angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                            if (esg.eventoTipo_id == 2000) {
                                sgcount = kesg;
                                sgcounthowmany++;
                            }
                        });
                        if (sgcounthowmany > 1) {
                            angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                                if (esg.eventoTipo_id == 2000 && kesg !== sgcount) {
                                    delete vm.beneficiario.eventostatusgs[kesg];
                                }
                            });
                        }
                        if (vm.beneficiarioBackup.tipoProtezione_id == vm.beneficiario.tipoProtezione_id) {
                            vm.beneficiario.tipoProtezioneCambiato = false;
                            if (vm.beneficiario.eventostatusgs[sgcount]) {
                                vm.testform = vm.extractjsonform2(vm.beneficiario.eventostatusgs[sgcount]);
                            }
                        } else {
                            vm.beneficiario.tipoProtezioneCambiato = true;
                            if (vm.beneficiario.eventostatusgs[sgcount]) {
                                vm.testform = vm.extractjsonform2(vm.beneficiario.eventostatusgs[sgcount]);
                            }
                        }
                        var data = moment().format('DD/MM/YYYY');
                        var confirm2 = $mdDialog.prompt()
                                .title('Data Avvenuta Notifica')
                                .textContent('La data di avvenuta notifica è un dato obbligatorio, per favore inserisci:')
                                .placeholder('Data Avvenuta Notifica gg/mm/aaaa')
                                .ariaLabel('dan')
                                .initialValue(data)
                                .ok('OK')
                                .cancel('Abbandona');

                        $mdDialog.show(confirm2).then(function (result) {
                            var dataValida = moment(result, 'DD/MM/YYYY', true).isValid();
                            if (dataValida) {
                                //data valida ricalcolo data fine
                                var newdata = moment(result, 'DD/MM/YYYY', true);
                                var newdataString = newdata.format('YYYY-MM-DD');
                                var m6 = moment.duration({'months': 6});
                                var nuovaDataFine = new Date(newdata.add(m6).format('YYYY-MM-DD'));
                                vm.beneficiario.dataFine = nuovaDataFine;
                                var confirmsave = $mdDialog.confirm()
                                        .title('Conferma cambiamenti')
                                        .htmlContent('Hai apportato modifiche ai campi:<br>1) <strong>Tipo di Soggiorno</strong><br>2) <strong>Data Fine Accoglienza</strong><br>3) <strong>Data avvenuta notifica</strong><br><br><strong>Vuoi Salvare ora queste modifiche?</strong>')
                                        .ariaLabel('daud')
                                        .ok('Salva cambiamenti')
                                        .cancel('Abbandona i cambiamenti');
                                $mdDialog.show(confirmsave).then(function () {
                                    //salva e conferma

                                    //controllo evento 2000 per aggiornamento
                                    //console.log("vm.beneficiario.eventostatusgs: ", vm.beneficiario.eventostatusgs);
                                    if (angular.isDefined(vm.beneficiario.eventostatusgs[0])) {
                                        //esiste evento aggiorno
                                        var idEvento2000 = vm.beneficiario.eventostatusgs[0]["id"];
                                        vm.extra.tipoProtezione_id = vm.beneficiario.tipoProtezione_id;
                                        vm.extra.dataAvvenutaNotificaEsitoPositivo = newdataString;
                                        var oggi = new Date();
                                        var oggit = moment(oggi).format('YYYY-MM-DD');
                                        vm.extra.noteGenerali = "Tipologia di soggiorno modificata fuori processo in data: " + oggit;
                                        vm.aggiornaEventoSGeSalva(idEvento2000);
                                    } else {
                                        //non esiste evento aggiorno solo beneficiario
                                        vm.save(vm.isnew);
                                    }
                                    //salva beneficiario

                                }, function () {
                                    //abbandona in conferma
                                    var annulla2Alert = $mdDialog.alert()
                                            .clickOutsideToClose(true)
                                            .title('Cambiamenti Annullati')
                                            .textContent('I cambiamenti verranno annullati')
                                            .ariaLabel('Annullati')
                                            .ok('OK');
                                    $mdDialog.show(annulla2Alert);
                                    vm.beneficiario.tipoProtezione_id = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
                                    vm.beneficiario.dataFine = angular.copy(vm.beneficiarioBackup.dataFine);
                                    vm.beneficiario.tipoProtezioneCambiato = false;
                                });

                            } else {
                                //data avvenuta notifica non valida
                                var annullaAlert = $mdDialog.alert()
                                        .clickOutsideToClose(true)
                                        .title('Data non valida')
                                        .textContent('I cambiamenti verranno annullati')
                                        .ariaLabel('Annullati')
                                        .ok('OK');
                                $mdDialog.show(annullaAlert);
                                vm.beneficiario.tipoProtezione_id = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
                                vm.beneficiario.dataFine = angular.copy(vm.beneficiarioBackup.dataFine);
                                vm.beneficiario.tipoProtezioneCambiato = false;
                            }


                            console.log("data valida? ", dataValida);

                        }, function () {
                            var annullaAlert = $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title('Data non inserita')
                                    .textContent('I cambiamenti verranno annullati')
                                    .ariaLabel('Annullati')
                                    .ok('OK');
                            $mdDialog.show(annullaAlert);
                            vm.beneficiario.tipoProtezione_id = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
                            vm.beneficiario.tipoProtezioneCambiato = false;
                        });
                    }, function () {
                        // Abbandona
                        vm.beneficiario.tipoProtezione_id = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
                        vm.beneficiario.tipoProtezioneCambiato = false;
                    });
                }

            } else {
                //nuovi dati
                vm.cambiaTipoSoggiorno();
            }

        }

        vm.checkCambioTipoSoggiornoPossibile = checkCambioTipoSoggiornoPossibile;
        function checkCambioTipoSoggiornoPossibile() {
            var tipoProtezioneCaricato = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
            var tipoProtezioneSelezionato = angular.copy(vm.beneficiario.tipoProtezione_id);
            var tipoSoggiornoModificabili = [590, 594, 596, 597, 961, 962];
            var tipoSoggiornoDestinazione = [591, 592, 593, 595];
            if (tipoSoggiornoModificabili.indexOf(tipoProtezioneCaricato) > -1) {
                if (tipoSoggiornoDestinazione.indexOf(tipoProtezioneSelezionato) == -1) {

                    vm.beneficiario.tipoProtezione_id = tipoProtezioneCaricato;
                    vm.beneficiario.tipoProtezioneCambiato = false;
                    return false;
                } else {

                    return true;
                }
            } else {
                if (tipoSoggiornoModificabili.indexOf(tipoProtezioneCaricato) == -1) {
                    vm.beneficiario.tipoProtezione_id = tipoProtezioneCaricato;
                    vm.beneficiario.tipoProtezioneCambiato = false;
                    return false;
                }
            }
        }


        vm.cambiaTipoSoggiorno = cambiaTipoSoggiorno;
        function cambiaTipoSoggiorno() {
            var confirm = $mdDialog.confirm()
                    .title('Cambio tipo di soggiorno')
                    .htmlContent('Procedendo a modificare il tipo di soggiorno, i dati relativi alla Commissione potrebbero risultare non coerenti o incompleti.<br>Se sei in possesso di tali dati, completa prima la sezione <b>&quot;Richiesta in Commissione&quot;</b>, in caso contrario, procedi alla modifica')
                    .ariaLabel('cambia ts')
                    .ok('Ok ho capito, modifica')
                    .cancel('Non Modificare');
            $mdDialog.show(confirm).then(function () {
                var sgcount = 0;
                var sgcounthowmany = 0;
                angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                    if (esg.eventoTipo_id == 2000) {
                        sgcount = kesg;
                        sgcounthowmany++;
                    }
                });
                if (sgcounthowmany > 1) {
                    angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                        if (esg.eventoTipo_id == 2000 && kesg !== sgcount) {
                            delete vm.beneficiario.eventostatusgs[kesg];
                        }
                    });
                }
                if (vm.beneficiarioBackup.tipoProtezione_id == vm.beneficiario.tipoProtezione_id) {
                    vm.beneficiario.tipoProtezioneCambiato = false;
                    if (vm.beneficiario.eventostatusgs[sgcount]) {
                        vm.testform = vm.extractjsonform(vm.beneficiario.eventostatusgs[sgcount]);
                    }
                } else {
                    vm.beneficiario.tipoProtezioneCambiato = true;
                    if (vm.beneficiario.eventostatusgs[sgcount]) {
                        vm.testform = null;
                    }
                }
                // mi serve aggiornare required se cambio



            }, function () {
                //console.log("qui");
                vm.beneficiario.tipoProtezione_id = angular.copy(vm.beneficiarioBackup.tipoProtezione_id);
                vm.beneficiario.tipoProtezioneCambiato = false;
            });
        }

        vm.cambiaDataR = cambiaDataR;
        function cambiaDataR(dataRil, dataAcc, dataFine) {
            var confirm = $mdDialog.confirm()
                    .title('Modifica data rilascio documento')
                    .htmlContent('Si vuole modificare anche la Data Inizio Accoglienza dal ' + moment(dataAcc).format('DD-MM-YYYY') + ' al ' + moment(dataRil).format('DD-MM-YYYY'))
                    .ok('Modifica')
                    .cancel('Non modificare');
            $mdDialog.show(confirm).then(function () {

                vm.beneficiario.dataInizio = vm.beneficiario.dataRilascioDocumento;

                vm.cambiaDataFine(dataFine, dataRil);


            }, function () {
                //abbandona
            });
        }

        //Questa Funzione controlla la scadenza della data di fine accoglienza beneficiario(30 giorni prima) e mostra popup
        //1 popup se la data sta per scadere (entro i 30 giorni)
        //2 popup se la data è scaduta
        function intervalloData() {
            if(vm.beneficiario.stato === "PRESENTE SUL TERRITORIO") return;
            var dataOdiernaEff = new Date();
            var dataOdierna = new Date();
            var dataFine = new Date(vm.beneficiario.dataFine);
            function addDays(theDate, days) {
                return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
            }
            var dataOdierna = addDays(dataOdierna, 30);
            //FormattaData
            var giorno = dataFine.getDate().toString().padStart(2, '0');
            var mese = (dataFine.getMonth() + 1).toString().padStart(2, '0'); // Mese è indicizzato da 0 a 11, quindi aggiungiamo 1 per ottenere il mese corretto.
            var anno = dataFine.getFullYear().toString();

            var dataFormattata = giorno + '/' + mese + '/' + anno;
     //Creazione Pop up
             var popUp = $mdDialog.confirm()
                  .title('Prossimo termine periodo di accoglienza del beneficiario')
                  .htmlContent('Il termine del periodo di accoglienza del beneficiario sarà superato il giorno ' + dataFormattata)
                  .ok('CHIUDI');
             var popUp2 = $mdDialog.confirm()
                  .title('Termine periodo di accoglienza del beneficiario')
                  .htmlContent('Il termine del periodo di accoglienza del beneficiario è stato superato al giorno ' + dataFormattata + ' <br/> Al fine di allineare il dato, procedere con la registrazione dell’uscita dal SAI del beneficiario o con la richiesta di proroga.')
                  .ok('CHIUDI');


            if(dataOdiernaEff > dataFine){
                $mdDialog.show(popUp2);
            }
            else if(dataFine <= dataOdierna){
                $mdDialog.show(popUp);
            }
        }

        vm.cambiaDataFine = cambiaDataFine;

        function cambiaDataFine(dataFine, dataRil) {
            var confirm = $mdDialog.confirm()
                    .title('Modifica data rilascio documento')
                    .htmlContent('Si vuole modificare anche la Data Fine Accoglienza dal ' + moment(dataFine).format('DD-MM-YYYY') + ' al ' + moment(dataRil).add(180, "days").format('DD-MM-YYYY'))
                    .ok('Modifica')
                    .cancel('Non modificare');
            $mdDialog.show(confirm).then(function () {

                function addDays(theDate, days) {
                    return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
                }

                vm.beneficiario.dataFine = addDays(vm.beneficiario.dataRilascioDocumento, 180);

                console.log("vm.beneficiario.dataInizio", vm.beneficiario.dataInizio);
                //ok reimposta
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Modificata Data Inizio Accoglienza e Data Fine Accoglienza.')
                        .position('bottom right')
                        .hideDelay(3000)
                        );

            }, function () {
                //abbandona
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Modificata Data Inizio Accoglienza.')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
            });
        }
        //Genera popo up campi obbligatori da compilare controllando se si tratta di beneficiari incompleti
        function popUpIncompleti() {
            if(vm.beneficiario.def) return;
            var campi =[];
            for (const [key, value] of Object.entries(vm.beneficiario.requiredFields)) {
                campi += "<li>" + value + "</li>";
            }
            if(campi.length > 0){
                var avvisoFields = $mdDialog.confirm()
                    .title('Beneficiario Presente incompleto')
                    .htmlContent('Per completare il beneficiario è necessario compilare i seguenti campi: <ul>' + campi + "</ul>  <br/> Fintanto che il beneficiario sarà visualizzato nel contenitore dei presenti incompleti non sarà possibile lavorare sugli aggiornamenti della scheda. <br/> Si prega di completare prontamente i campi obbligatori e procedere al salvataggio ")
                    .ok('CHIUDI');
                $mdDialog.show(avvisoFields);
            }
        }

        vm.cambiaDocumento = cambiaDocumento;
        function cambiaDocumento() {
            var confirm = $mdDialog.confirm()
                    .title('Cambio tipo di documento')
                    .htmlContent('Per procedere nella modifica del documento di soggiorno, devi essere in possesso delle informazioni relative a:<br>1) <b>Questura di rilascio</b><br>2) <b>Numero di documento</b><br>3) <b>Data Rilascio</b><br>4) <b>Data Scadenza</b>')
                    .ariaLabel('cambia doc')
                    .ok('Ok ho capito, modifica')
                    .cancel('Non Modificare');
            $mdDialog.show(confirm).then(function () {
                if (vm.beneficiarioBackup.idTipoDocumento == vm.beneficiario.idTipoDocumento) {
                    vm.beneficiario.tipoDocumentoCambiato = false;
                } else {
                    vm.beneficiario.tipoDocumentoCambiato = true;
                    vm.beneficiario.enteDocumento_id = 0;
                    vm.beneficiario.documentoNumero = null;
                    vm.beneficiario.dataRilascioDocumento = null;
                    vm.beneficiario.dataScadenzaDocumento = null;
                }
            }, function () {
                vm.beneficiario.idTipoDocumento = angular.copy(vm.beneficiarioBackup.idTipoDocumento);
                vm.beneficiario.enteDocumento_id = angular.copy(vm.beneficiarioBackup.enteDocumento_id);
                vm.beneficiario.documentoNumero = angular.copy(vm.beneficiarioBackup.documentoNumero);
                vm.beneficiario.dataRilascioDocumento = angular.copy(vm.beneficiarioBackup.dataRilascioDocumento);
                vm.beneficiario.dataScadenzaDocumento = angular.copy(vm.beneficiarioBackup.dataScadenzaDocumento);
                vm.beneficiario.tipoDocumentoCambiato = false;
            });
        }

        vm.documentoAbilitato = documentoAbilitato;
        function documentoAbilitato(itemdocumento, idTipoSoggiorno) {
            var esito = true; //ng-disabled=true
            var temp = itemdocumento.note.split(",");
            if (angular.isDefined(idTipoSoggiorno)) {
                var temp1 = idTipoSoggiorno.toString();
                if (temp.indexOf(temp1) > -1) {
                    esito = false;
                }
            }
            return esito;
        }
        vm.reimpostaE = reimpostaE;
        function reimpostaE($event, item) {
            var evento_id = item.id;
            var confirm = $mdDialog.confirm()
                    .title('Modifica dati procedura')
                    .htmlContent('Procedendo alla modifica cambierai i dati relativi alla <b>procedura in Commissione</b>, con possibili conseguenze sulla voce <b>&quot;Tipo di Soggiorno&quot;</b>.')
                    .ariaLabel('cambia doc')
                    .ok('Ok ho capito, modifica')
                    .cancel('Non modificare');
            $mdDialog.show(confirm).then(function () {
                //ok reimposta
                if (evento_id && evento_id > 0) {
                    api.eventos.evento.update({id: evento_id, eventoStato_id: 1, ordine: item.eventoStato_id}, function (r) {
                        if (r.id == evento_id) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Reimpostazione processo confermata.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(
                                    //$state.reload()
                                    vm.reimpostaOpen(r)
                                    );
                        }
                    });
                }

            }, function () {
                //abbandona
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Reimpostazione processo annullata.')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
            });
        }




        vm.reimpostaE2 = reimpostaE2;
        function reimpostaE2(item) {
            if (vm.tipoProcesso2000 == "classico") {
                vm.loadb();
                var itemEvento = angular.copy(item);
                vm.work('autoopen', itemEvento, 3, 'DATI RICHIESTA', false);
            }
            if (vm.tipoProcesso2000 == "nuovo") {
                vm.work2('autoopen', item, 3, 'DATI RICHIESTA', false);
            }

        }

        vm.reimpostaOpen = reimpostaOpen;
        function reimpostaOpen(item) {
            vm.loadb();
            var itemEvento = angular.copy(item);
//            angular.forEach(vm.beneficiario.eventostatusgs, function (e) {
//                if (e.eventoTipo_id == 2000) {
//                    itemEvento = e;
//                }
//            });
//            console.log("itemEvento", itemEvento);
            vm.work('autoopen', itemEvento, 3, 'DATI RICHIESTA', false);
        }



        vm.disabilitaReimposta = disabilitaReimposta;
        function disabilitaReimposta(item) {
            var evento = item;
            var esito = false;
            var eventoChiusura = [4, 20];
//            console.log("vm.api.isOperatore", vm.api.isOperatore);
//            console.log("evento.eventoStato_id", evento.eventoStato_id);
//            console.log("indexOf", eventoChiusura.indexOf(evento.eventoStato_id));

            if (vm.api.isAdmin || vm.api.isAccoglienza) {
                esito = false;
            }

            if (vm.api.isOperatore && eventoChiusura.indexOf(evento.eventoStato_id) > -1) {
                esito = true;
            }
            return esito;
        }
        vm.visualizzaReimposta = visualizzaReimposta;
        function visualizzaReimposta(beneficiario) {
            vm.tipoProcesso2000 = "classico";
            var evento = beneficiario.eventostatusgs;
            var tipoProtezione_id = beneficiario.tipoProtezione_id;
            var vecchio = beneficiario.v_genSingMinori;
            var protezioneCommessioneId = [590, 594];
            var titolaritaCommissioneId = [591, 592, 593];
            var esito = false;
            if (protezioneCommessioneId.indexOf(tipoProtezione_id) > -1) {
                if (vecchio == 1) {
                    esito = false;
                    vm.tipoProcesso2000 = "nuovo";
                }
                if (vecchio == 0) {
                    esito = true;
                    vm.tipoProcesso2000 = "classico";
                }
            }
            if (titolaritaCommissioneId.indexOf(tipoProtezione_id) > -1) {
                esito = true;
                vm.tipoProcesso2000 = "nuovo";
            }
            return esito;
        }

        vm.completaB = completaB;
        function completaB() {
            if(vm.beneficiario.cui === "NON DISPONIBILE" || vm.beneficiario.cui === '') {
              vm.beneficiario.cui = null
            }
            if(vm.beneficiario.codiceVestanet === "NON DISPONIBILE" || vm.beneficiario.codiceVestanet === '') {
              vm.beneficiario.codiceVestanet = null
            }
            var beneficiario = angular.copy(vm.beneficiario);
            var tipoProtezioneCambiato = false;
            var tipoDocumentoCambiato = false;
            console.log(beneficiario);
            tipoProtezioneCambiato = angular.copy(beneficiario.tipoProtezioneCambiato);
            tipoDocumentoCambiato = angular.copy(beneficiario.tipoDocumentoCambiato);
            delete beneficiario.tipoProtezioneCambiato;
            delete beneficiario.tipoDocumentoCambiato;
            //cerco evento 1007
            var evento1007_id = 0;
            var evento1007 = {};
            angular.forEach(beneficiario.eventos, function (eb) {
                if (eb.eventoTipo_id === 1007) {
                    evento1007_id = eb.id;
                }
            });
            api.eventos.evento.get({id: evento1007_id}, function (ev) {
                evento1007 = ev;
                var extraData = {};
                try {
                    extraData = JSON.parse(angular.copy(evento1007.extra));
                } catch (err) {

                }
                if (extraData == null) {
                    extraData = {};
                }
                extraData.tipoProtezioneCambiato = tipoProtezioneCambiato;
                extraData.tipoProtezione_idB = vm.beneficiarioBackup.tipoProtezione_id;
                extraData.tipoDocumentoCambiato = tipoDocumentoCambiato;
                extraData.idTipoDocumentoB = vm.beneficiarioBackup.idTipoDocumento;
                var temp = JSON.stringify(extraData);
                var toastmsg = 'Beneficiario incompleto aggiornato';
                var toastgo = 'app.sprardb_beneficiarii';
                if (beneficiario.def == 1) {
                    toastmsg = 'Beneficiario aggiornato';
                    toastgo = 'app.sprardb_beneficiari';
                }
                var toast = $mdToast.simple()
                        .textContent(toastmsg)
                        .position('bottom right')
                        .hideDelay(3000);
                var toast2 = $mdToast.simple()
                        .textContent('Errore durante aggiornamento. Riprovare')
                        .position('bottom right')
                        .hideDelay(3000);
                api.eventos.evento.update({id: evento1007_id, extra: temp}, function (upd) {
                    if (upd.id === evento1007_id) {
                        var extraCommissione = angular.copy(beneficiario.extraCommissione);
                        beneficiario.extraCommissione = angular.toJson(extraCommissione, false);
                        angular.forEach(beneficiario, function (value, key) {
                          //console.log("valori:", value);
                          if (key.toLowerCase().indexOf("data") !== -1) {
                            //console.log("valori:", value);
                            //console.log("valori:", new Date(value));
                            if (angular.isDate(value)) {
                              if (moment(value).format("YYYY-MM-DD") !== "1970-01-01") {
                                beneficiario[key] = moment(value).format("YYYY-MM-DD");
                              } else {
                                beneficiario[key] = null;
                              }
                            } else {
                              beneficiario[key] = null;
                            }

                          }
                        });
                        //console.log(beneficiario);
                        api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
                            if (response.id === beneficiario.id) {
                                $mdToast.show(
                                        toast
                                        ).then(
                                        $state.go(toastgo, {def: beneficiario.def})
                                        );
                            } else {
                                $mdToast.show(
                                        toast2
                                        ).then(
                                        $state.reload()
                                        );
                            }

                        });
                    } else {
                        $mdToast.show(
                                toast2
                                ).then(
                                $state.reload()
                                );
                    }
                });
            });
        }

        vm.alertDocumento = alertDocumento;
        function alertDocumento() {
            var confirm = $mdDialog.confirm()
                    .title('Cambio tipo di documento')
                    .htmlContent('Alcune voci potrebbero essere disabilitate in base al <b>Tipo di soggiorno</b> scelto.')
                    .ariaLabel('cambia ts')
                    .ok('Ok');
            $mdDialog.show(confirm);
        }

        vm.formattaExtra = formattaExtra;
        function formattaExtra(extra) {
            var root;
            try {
                root = JSON.parse(extra);
            } catch (err) {
            }
            angular.forEach(root, function (rd, rk) {
                if (rk.toLowerCase().indexOf("data") !== -1) {
                    root[rk] = new Date(rd);
                    root[rk] = moment(root[rk]).format("DD/MM/YYYY");
                }

            })
            root = $filter('json')(root);
            root = root.replace("{", "").replace("}", "");
            root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
            if (root.length === 0) {
                root = 'Nessun dato';
            }
            return root;
        }

    }

    function CambioStrutturaController($state, $mdDialog, locals, api) {
      var vmd = this;
      vmd.res = {
        dataCambioStruttura: null,
        esterna: 0,
        struttura: null,
        note:null
      }
      vmd.progetto_id = locals.progetto_id;
      vmd.struttura_id = locals.struttura_id;
      vmd.struttura = locals.struttura;
      console.log(locals);
      vmd.min_date = new Date(locals.min_date);
      vmd.min_date.setDate(vmd.min_date.getDate() + 1);
      console.log(vmd.min_date);
      vmd.maxDate = new Date();
      api.strutturas.strutturamin.cerca({'progetto_id': vmd.progetto_id, pagination: 400, attivo: 1}, function (response) {
        vmd.strutture = response.data;
      });
      vmd.save = function () {
        var formattedDate = moment(vmd.res.dataCambioStruttura).format('YYYY-MM-DD');
        $mdDialog.hide(angular.merge({}, vmd.res, {dataCambioStruttura: formattedDate}));
      }
      vmd.closeDialog= function () {
        $mdDialog.hide();
      }
    }
    function DisattivaEsternaController($state, $mdDialog, locals, api) {
      var vmd = this;

      vmd.progetto_id = locals.progetto_id;
      vmd.struttura = locals.struttura[0];
      vmd.closeDialog= function () {
        $mdDialog.hide();
      }
    }

    function DettaglioBeneficiarioStoricoController($state, $document, $filter, api, msUtils, $mdDialog, eventi, acl, ricerca, $mdToast, $cookies, $rootScope)
    {
        var vm = this;
        vm.isallowed = acl.isallowed2;
        vm.richestaprorogaottenibile = eventi.richestaprorogaottenibile;
        vm.uscitaottenibile = eventi.uscitaottenibile;
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.filternucleo = false;
        vm.isomonimo = false;
        vm.activeFilter = {};
        vm.activeFilter.tipo = [];
        vm.activeFilter.stato = [];
        vm.letteraTrasf = eventi.letteraTrasf;
        ricerca.reloadCS();
        vm.toggleFilter = function (datas, tipo) {
            //console.log(datas);
            //console.log(tipo);
            angular.forEach(datas, function (data) {
                var found = vm.activeFilter[tipo].indexOf(data);
                if (found >= 0) {
                    vm.activeFilter[tipo].splice(found, 1);
                } else {
                    vm.activeFilter[tipo].push(data);
                }
            });
        };
        vm.options = ricerca.options;
        vm.selected = ricerca.selected;
        vm.limitOptions = ricerca.limitOptions;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.exallsearchs = ricerca.begin_allsearchs();
        vm.attallsearchs = ricerca.begin_allsearchs();
        vm.allprogettos = ricerca.progettos;
        vm.isReadOnly = false;
        vm.cookiepid = $cookies.getObject('ALL_p_id');
        vm.progettiAbilitati = vm.cookiepid.split(",").map(Number);
        vm.prpi = true;
        vm.caricamentoultimato = false;
        vm.colors = eventi.colors2;

        vm.beneficiario_id = $state.params.id;
        vm.oggi = new Date();
        var m4 = moment.duration({'days': 120});
        vm.oggim4 = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
        vm.tabellastrutture = [
            {
                etichetta: "#",
                campo: ['id'],
                mdorderby: "id",
                style: "text-align: center;"

            }, {
                etichetta: "struttura",
                mdorderby: "nome",
                campo: ['nome', 'progettos.nome'],
                b: true

            }, {
                etichetta: "ubicazione",
                mdorderby: "indirizzo",
                campo: ['indirizzo', 'istats.comune', 'istats.provincia'],
                icona: null

            }, {
                etichetta: "tipologia",
                campo: ['strutturaAccoglienzas.descrizione', 'strutturaAlloggios.descrizione']

            }, {
                etichetta: "attivo",
                campo: ['attivo'],
                mdorderby: "attivo",
                icona: {'0': 'icon-bookmark-outline', '1': 'icon-bookmark-check'}

            }, {
                etichetta: "posti",
                mdorderby: "numeroPosti",
                campo: ['numeroPosti']
            }, {
                etichetta: "stanze",
                mdorderby: "numeroStanze",
                campo: ['numeroStanze']
            }, {
                etichetta: "s.igien",
                mdorderby: "numeroIgienici",
                campo: ['numeroIgienici']
            }, {
                a: true,
                bottoni: [{
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxx",
                        ngclick: "",
                        uisref: "app.sprardb_progetti_strutture_struttura",
                        ngif: true
                    }, {
                        icona: "icon-bookmark-outline",
                        etichetta: "xxxxu",
                        ngclick: function click() {
                            //console.log("click");
                        },
                        uisref: "",
                        ngif: false
                    }]
            }
        ];

        vm.corsicat = ricerca.corsicategoria;
        vm.servizicat = ricerca.servizicategoria;
        vm.statobeneficiarios = ricerca.statobeneficiarios;

        vm.nstatusgs = [
            {id: 591, descrizione: "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO"},
            {id: 592, descrizione: "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA"},
            {id: 593, descrizione: "TITOLARE PROTEZIONE UMANITARIA"}
        ];
        /*
         * vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
         vm.arraynstatus = {tipo: [1999], stato: [1]};
         vm.arraynstatus2 = {tipo: [1998], stato: [1]};
         vm.arrayallstatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
         //vm.arraystatus = {tipo: [2000], stato: [1, 3, 4, 5, 10, 11, 15, 20]};
         //vm.arraydocumenti = {tipo: [2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030], stato: [1]};
         vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086], stato: [1]};
         *
         */


        vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2014,2015,2016], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
        vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088], stato: [1, 4]};
        vm.arrayproroga = {tipo: [1011], stato: [1, 3, 4]}; //eliminato 1009
        vm.arrayuscita = {tipo: [1010], stato: [1]};
        vm.arrayallontanamento = {tipo: [1012], stato: [1, 3]};
        vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 4, 5, 20]};
        if (vm.api.isOperatoreG) {
            vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 5]};
        }
        //divido trasferimento interno e esterno
        vm.arraytrasferimentoA = {tipo: [1013], stato: [-1, 1, 2, 3]};
        vm.arraytrasferimentoB = {tipo: [1014], stato: [1, 2, 3]};
        vm.arraynewprocess = {tipo: [2000, 2001, 2002, 2003, 1010], stato: [1, 3, 5, 10, 11, 14, 15, 16, 17, 20]};
        //poi verranno ricaricati quando carico beneficiario
        vm.newprocess = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
            titolo: "Nuovo evento",
            numeroEventi: 5
        };
        vm.sg = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
            titolo: "Nuovo status giuridico",
            numeroEventi: vm.arraystatus.tipo.length
        };
        vm.acc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: vm.arrayproroga.tipo.length
        };
        vm.uscita = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
            titolo: "Nuova uscita",
            numeroEventi: vm.arrayuscita.tipo.length
        };
        vm.newpro = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: 1
        };
        vm.newdoc = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
            titolo: "Aggiungi/rinnova documento",
            numeroEventi: vm.arraydocumenti.tipo.length
        };
        vm.newtrasf = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimento.tipo.length
        };
        //divido trasferimento interno e esterno
        vm.newtrasfA = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoA.tipo.length
        };
        vm.newtrasfB = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoB.tipo.length
        };
        vm.newall = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
            titolo: "Nuovo allontanamento",
            numeroEventi: vm.arrayallontanamento.tipo.length
        };
//fine sprar new process
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.Beneficiario = {}; //Beneficiario;
        vm.beneficiario = {}; //angular.copy(Beneficiario.data[0])
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoDocumento = null;
        vm.tipoIngresso = null;
        vm.stato = null;
        vm.uploadParams = {
            documentoTipo_id: 0,
            gruppo: 'BENEFICIARIO',
            dettaglio: true,
            entita: 'beneficiario',
            entitakey: 'beneficiario_id',
            entitakey2: 'pid',
            pid: 0,
            entita2_id: 0,
            cancellazione: vm.api.isAdminG,
            isAdminG: vm.api.isAdminG
        };
        vm.uploadParams.beneficiario_id = vm.beneficiario_id;
        vm.uploadParams.entita_id = vm.beneficiario_id;
        vm.uploadParams2 = {
            documentoTipo_id: 0,
            gruppo: 'TRASFERIMENTI',
            dettaglio: true,
            entita: 'beneficiario',
            entitakey: 'beneficiario_id'
        };
        vm.uploadParams2.beneficiario_id = vm.beneficiario_id;
        vm.uploadParams2.entita_id = vm.beneficiario_id;
        vm.viewEvento = eventi.viewDetails;
        vm.colors = eventi.colors;
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "500", sort: "descrizione"}, function (response) {
            vm.nazioni = response.data;
            vm.nazionalitas = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "50", sort: "descrizione"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", sort: "descrizione"}, function (response) {
            vm.tipoDocumento = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50", sort: "descrizione"}, function (response) {
            vm.tipoIngresso = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "STATO", pagination: "50", sort: "descrizione"}, function (response) {
            vm.stato = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "TIPO-PROTEZIONE", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
            vm.tipoProteziones = response.data;
        });

        vm.ingresso = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'INGRESSO', sort: 'descrizione'}).$promise.then(function (response) {
                vm.ingressos = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.ingresso();
        api.entes.ente.cerca({enteTipo_id: "7", pagination: "200", sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
            vm.enteDocumentoids = response.data;
        });
        vm.nucleofamiliare = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'NUCLEOFAMILIARE', sort: 'descrizione'}).$promise.then(function (response) {
                vm.nucleofamiliares = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.nucleofamiliare();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                //console.log(response);
            });
        };
        vm.vulnerabilita();
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: '-note,descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
                angular.forEach(vm.parentelas, function (parentela) {

                });
            }, function (response) {
                //console.log(response);
            });
        };
        vm.parentela();
        vm.sino = ricerca.sino;
        vm.provenienza = ricerca.provenienza;
        vm.dublino = ricerca.dublino;
        vm.iTipoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PASSAPORTO"}, {descrizione: "CARTA IDENTITA"}, {descrizione: "ALTRO"}];
        vm.iLuogoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PAESE ORIGINE"}, {descrizione: "ITALIA"}, {descrizione: "ALTRO"}];
        vm.iModalitaAccertamento = [{descrizione: "NESSUNO"}, {descrizione: "DOCUMENTO"}, {descrizione: "COLLOQUIO"}, {descrizione: "ACCERTAMENTO"}, {descrizione: "ALTRO"}];
        vm.iQualifica = [{descrizione: "NESSUNO"}, {descrizione: "SINDACO"}, {descrizione: "ASSESSORE"}, {descrizione: "DIRIGENTE"}, {descrizione: "ASSISTENTE SOCIALE"}, {descrizione: "AVVOCATO"}, {descrizione: "TUTORE VOLONTARIO"}, {descrizione: "ALTRO"}];
        vm.isnew = false;
        vm.evento = 'update';
        var searchpayload = {};
        searchpayload = {progressivo: vm.beneficiario_id};
        vm.beneficiario.eventostatusgs = [];
        vm.beneficiario.eventoprorogas = [];
        vm.beneficiario.eventouscitas = [];
        vm.beneficiario.eventotrasferimentos = [];
        vm.beneficiario.eventoallontanamentos = [];
        vm.beneficiario.eventodocumentos = [];
        vm.beneficiario.eventoAstatusgs = [];
        vm.beneficiario.eventoAprorogas = [];
        vm.beneficiario.eventoAuscitas = [];
        vm.beneficiario.eventoAtrasferimentos = [];
        vm.beneficiario.eventoAallontanamentos = [];
        vm.beneficiario.eventoAdocumentos = [];
        vm.beneficiario_segnalato = {};
        vm.eraTitolare = false;
//carica beneficiario
        vm.bloaded = false;
        vm.popupEsterna = function(){
          $mdDialog.show({
            controller: 'DisattivaEsternaController',
            controllerAs: 'vmd',
            templateUrl:'app/main/sprardb/beneficiari/dialog/disattivaEsterna.html' ,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              progetto_id: vm.beneficiario.progetto_id,
              struttura: $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})
            }
          });
        }
        vm.loadb = function () {
            api.paeseTerzoProvenienza.index({expand:'nazione.descrizione'}, function (response) {
              vm.paeseProvenienza = response.data;
            })
            api.beneficiarios.a.search(searchpayload, function (r1) {
                vm.Beneficiario = r1.data[0];
                vm.beneficiario = r1.data[0];
                vm.struttura_corr = $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})[0]
                vm.uploadParams.beneficiario_id = vm.beneficiario.id;
                vm.uploadParams.entita_id = vm.beneficiario.id;
                vm.uploadParams.pid = vm.beneficiario.progetto_id;
                vm.uploadParams.entita2_id = vm.beneficiario.progetto_id;
                vm.uploadParams2.beneficiario_id = vm.beneficiario.id;
                vm.uploadParams2.entita_id = vm.beneficiario.id;
                //api.beneficiarios.beneficiario.get(searchpayload).$promise.then(function (response) {
                api.beneficiarios.beneficiario.get({id: vm.beneficiario.id}).$promise.then(function (r2) {
                    vm.beneficiarioattuale = r2;
                    vm.beneficiario.eventos = angular.copy(vm.beneficiarioattuale.eventos);
                    vm.beneficiario.corsos = angular.copy(vm.beneficiarioattuale.corsos);
                    vm.beneficiario.servizios = angular.copy(vm.beneficiarioattuale.servizios);
                    var campiDaImportare = [
                        'idTipoDocumento',
                        'enteDocumento_id',
                        'documentoNumero',
                        'dataRilascioDocumento',
                        'dataScadenzaDocumento',
                        'cambioQPC',
                        'noteCambioQPC',
                        'tipoProtezione_id',
                        'interesseExArt',
                        'dataInteresseExArt',
                        'c3',
                        'dataC3',
                        'dataRichiestaProtezione',
                        'dataRichiestaPds',
                        'extraCommissione'
                    ];
                    angular.forEach(campiDaImportare, function (campo) {
                        if (angular.isUndefined(vm.beneficiario[campo])) {
                            vm.beneficiario[campo] = angular.copy(vm.beneficiarioattuale[campo]);
                        }
                    });

                    var campiDaForzare = [
                        'nome',
                        'cognome',
                        'sesso',
                        'codNazionalita',
                        'dataNascita',
                        'dataFine',
                        'dataIngresso',
                        'strutturas'
                    ];
                    angular.forEach(campiDaForzare, function (campo) {
                        vm.beneficiario[campo] = angular.copy(vm.beneficiarioattuale[campo]);
                    });

                    vm.isnew = false;
                    //svm.isReadOnly = true; //

                    angular.forEach(vm.beneficiario, function (value, key) {
                        if (key.toLowerCase().indexOf("data") !== -1) {
                            if (value === '0000-00-00' || value === null) {
                                vm.beneficiario[key] = null;
                            } else {
                                vm.beneficiario[key] = new Date(value);
                            }
                        }
                    });
                    vm.beneficiario.dataInizioDisplay = $filter('date')(vm.beneficiario.dataInizioB, 'dd/MM/yyyy');
                    vm.beneficiario.dip = new Date("3000-01-01");
                    vm.beneficiario.dup = new Date("1900-01-01");
                    vm.beneficiario.struttura_id2 = vm.beneficiario.struttura_id;
                    angular.forEach(vm.beneficiario.strutturahasbeneficiarios, function (shb) {
                        var dip;
                        var dup;

                        if (vm.beneficiario.progetto_id == shb.progetto_id) {
                            dip = new Date(shb.dataInserimento);
                            dup = (shb.dataCessazione == null) ? null : new Date(shb.dataCessazione);
                            if (dip <= vm.beneficiario.dip) {
                                vm.beneficiario.dip = dip;
                            }
                            if (dup >= vm.beneficiario.dup || dup == null) {
                                vm.beneficiario.dup = dup;
                            }
                        }

                    });
                    vm.newprocess = {
                        entita1_id: vm.beneficiario.id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
                        titolo: "Nuovo evento",
                        numeroEventi: 5
                    };
                    vm.sg = {
                        entita1_id: vm.beneficiario.id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
                        titolo: "Nuovo status giuridico",
                        numeroEventi: vm.arraystatus.tipo.length
                    };
                    vm.acc = {
                        entita1_id: vm.beneficiario.id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
                        titolo: "Nuova proroga",
                        numeroEventi: vm.arrayproroga.tipo.length
                    };
                    vm.uscita = {
                        entita1_id: vm.beneficiario.id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
                        titolo: "Nuova uscita",
                        numeroEventi: vm.arrayuscita.tipo.length
                    };
                    vm.newpro = {
                        entita1_id: vm.beneficiario.id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
                        titolo: "Nuova proroga",
                        numeroEventi: 1
                    };
                    var documento_id_abilitati = [];
                    angular.forEach(ricerca.corr_tiprot_doc, function (docs, tprot) {
                        if (parseInt(tprot) === vm.beneficiario.tipoProtezione_id) {
                            documento_id_abilitati = docs;
                        }
                    });
                    var processi_doc_abilitati = [];
                    angular.forEach(ricerca.corr_doc_processi, function (processo_id_ab, doc) {
                        if (documento_id_abilitati.indexOf(parseInt(doc)) > -1) {
                            processi_doc_abilitati.push(processo_id_ab);
                        }
                    });
                    vm.arraydocumentiB = angular.copy(vm.arraydocumenti);
                    vm.arraydocumenti = {tipo: processi_doc_abilitati, stato: [1]};
                    vm.newdoc = {
                        entita1_id: vm.beneficiario_id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
                        titolo: "Aggiungi/rinnova documento",
                        numeroEventi: vm.arraydocumenti.tipo.length
                    };
                    vm.newtrasf = {
                        entita1_id: vm.beneficiario_id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
                        titolo: "Nuovo trasferimento",
                        numeroEventi: vm.arraytrasferimento.tipo.length
                    };
                    vm.newtrasfA = {
                        entita1_id: vm.beneficiario_id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
                        titolo: "Nuovo trasferimento",
                        numeroEventi: vm.arraytrasferimentoA.tipo.length
                    };
                    vm.newtrasfB = {
                        entita1_id: vm.beneficiario_id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
                        titolo: "Nuovo trasferimento",
                        numeroEventi: vm.arraytrasferimentoB.tipo.length
                    };
                    vm.newall = {
                        entita1_id: vm.beneficiario_id,
                        entita2_id: vm.beneficiario.struttura_id,
                        eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
                        titolo: "Nuovo allontanamento",
                        numeroEventi: vm.arrayallontanamento.tipo.length
                    };
                    var counter = 0;
                    vm.spliteventos = {
                        eventostatusgs: vm.arraystatus,
                        eventoprorogas: vm.arrayproroga,
                        eventouscitas: vm.arrayuscita,
                        eventotrasferimentos: vm.arraytrasferimento,
                        eventotrasferimentoAs: vm.arraytrasferimentoA,
                        eventotrasferimentoBs: vm.arraytrasferimentoB,
                        eventodocumentos: vm.arraydocumenti,
                        eventoallontanamentos: vm.arrayallontanamento
                    };
                    vm.splitAeventos = {
                        eventoAstatusgs: vm.arraystatus,
                        eventoAprorogas: vm.arrayproroga,
                        eventoAuscitas: vm.arrayuscita,
                        eventoAtrasferimentos: vm.arraytrasferimento,
                        eventoAtrasferimentoAs: vm.arraytrasferimentoA,
                        eventoAtrasferimentoBs: vm.arraytrasferimentoB,
                        eventoAdocumentos: vm.arraydocumentiB,
                        eventoAallontanamentos: vm.arrayallontanamento
                    };
                    vm.beneficiario.eventostatusgs = [];
                    vm.beneficiario.eventoprorogas = [];
                    vm.beneficiario.eventouscitas = [];
                    vm.beneficiario.eventotrasferimentos = [];
                    vm.beneficiario.eventotrasferimentoAs = [];
                    vm.beneficiario.eventotrasferimentoBs = [];
                    vm.beneficiario.eventoallontanamentos = [];
                    vm.beneficiario.eventodocumentos = [];
                    vm.beneficiario.eventoAstatusgs = [];
                    vm.beneficiario.eventoAprorogas = [];
                    vm.beneficiario.eventoAuscitas = [];
                    vm.beneficiario.eventoAtrasferimentos = [];
                    vm.beneficiario.eventoAtrasferimentoAs = [];
                    vm.beneficiario.eventoAtrasferimentoBs = [];
                    vm.beneficiario.eventoAallontanamentos = [];
                    vm.beneficiario.eventoAdocumentos = [];




                    angular.forEach(vm.beneficiario.eventos, function (obj) {
                        vm.beneficiario.eventos[counter].processi = obj.eventoTipo.processo.split("|");
                        angular.forEach(vm.spliteventos, function (dati, chiave) {
                            if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && dati.stato.indexOf(obj.eventoStato_id) >= 0) {
                                //soddisfa condizioni di tipo e stato contemporaneamente
                                vm.beneficiario[chiave].push(obj);

                            }
                        });
                        angular.forEach(vm.splitAeventos, function (dati, chiave) {

                            if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && obj.progetto_id == vm.beneficiario.progetto_id) {
                                obj.extra = angular.fromJson(obj.extra);
                                vm.beneficiario[chiave].push(obj);
                            }


                        });
                        counter++;
                    });
                    var sgcount = 0;
                    var sgcounthowmany = 0;
                    //console.log("vm.beneficiario.eventostatusgs", vm.beneficiario.eventostatusgs);
                    angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
                        if (esg.eventoTipo_id == 2000) {
                            sgcount = kesg;
                            sgcounthowmany++;
                        }
                    });
                    if (sgcounthowmany >= 1) {
                        var copyeventostatusg = angular.copy(vm.beneficiario.eventostatusgs);
                        vm.beneficiario.eventostatusgs = null;
                        vm.beneficiario.eventostatusgs = [];
                        vm.beneficiario.eventostatusgs.push(copyeventostatusg[sgcount]);
                    }

                    vm.tuttoDisabilitato = true;
                    vm.famiglia = null;
                    api.eventos.evento.search({eventoTipo_id: '1002', entita1_id: vm.beneficiario.segnalato_id}, function (response) {
                      if (response) {
                        vm.extraSegnalazione = response.data[0].extra;
                      }
                    });

                    if (vm.beneficiario.capof_id != 0) {
                        api.beneficiarios.minimal.search({capof_id: vm.beneficiario.capof_id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
                          if (d) {
                            vm.famiglia = d.data;
                          }
                          api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                            vm.beneficiario.capoFamiglia =  res.data[0] ? res.data[0] : null;
                            if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                              vm.famiglia.push(f);
                            }
                          });
                        });
                    } else {
                        api.beneficiarios.minimal.search({capof_id: vm.beneficiario.id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
                          if (d) {
                            vm.famiglia = d.data;
                          }
                          api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                            vm.beneficiario.capoFamiglia =  res.data[0] ? res.data[0] : null;
                            if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                              vm.famiglia.push(f);
                            }
                          });
                        });
                    }
                    vm.bloaded = true;
                    vm.calcolomontante();
                    vm.caricamentoultimato = true;

                    vm.eventiPresenze = $filter('filter')(vm.beneficiario.eventos, {eventoTipo_id: 1018})
                });
              // se la response ritorna un codice vestanet o cui  nullo
              // allora metti la checkbox gia spuntata e prevalorizzata a non disponibile.
              if(vm.beneficiario.cui === null){
                vm.checkboxCui = true
                vm.beneficiario.cui = "NON DISPONIBILE"
              }
              if(vm.beneficiario.codiceVestanet === null){
                vm.checkboxVestanet = true
                vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
              }
            });
        };

      // logica per codice vestanet e cui
      // serve un refactoring completo di questo controller imo.
      vm.checkboxCui = false
      vm.checkboxVestanet = false

      vm.cancellaBeneficiario = cancellaBeneficiario;
      vm.reintegraBeneficiario = reintegraBeneficiario;

      function cancellaBeneficiario() {
        var confirm = $mdDialog.confirm()
          .title('Elimina beneficiario')
          .textContent('Sei sicuro di voler eliminare il beneficiario corrente?')
          .ok('Conferma')
          .cancel('Annulla');
        $mdDialog.show(confirm).then(function() {
          api.beneficiariomc.cancellaBeneficiario({id: vm.beneficiario.beneficiario_id}, function (res) {
            $state.reload();
          });
        });
      }

      function reintegraBeneficiario() {
        var confirm = $mdDialog.confirm()
          .title('Reintegra beneficiario')
          .textContent('Sei sicuro di voler reintegrare il beneficiario nel progetto corrente?')
          .ok('Conferma')
          .cancel('Annulla');
        $mdDialog.show(confirm).then(function() {
          api.beneficiariomc.reintegraBeneficiario({id: vm.beneficiario.beneficiario_id}, function (res) {
            $state.reload();
          });
        });
      }

      vm.checkboxCuiOnClick = function () {
        if (vm.checkboxCui) {
          vm.beneficiario.cui = "NON DISPONIBILE"
        } else {
          vm.beneficiario.cui = ''
        }
      }

      vm.checkboxVestanetOnClick = function () {
        if (vm.checkboxVestanet) {
          vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
        } else {
          vm.beneficiario.codiceVestanet = ''
        }
      }


        vm.mostraCapofamiglia = function (famiglia, capoF) {
          var ret = true;
          angular.forEach(famiglia,function (ben) {
            if(ben.codice == capoF.codice){
              ret = false;
            }
          });
          return ret;
        }

        vm.lt = lt;
        function lt(val1, val2) {
            if (val1 == null || val2 == null) {
                return false;
            }
            if (!angular.isDate(val1)) {
                val1 = new Date(val1);
            }
            if (!angular.isDate(val2)) {
                val2 = new Date(val2);
            }
            return val1 <= val2;
        }



        vm.annullaUscitaBeneficiario = annullaUscitaBeneficiario;
        function annullaUscitaBeneficiario(ev) {
          $mdDialog.show({
            controller: 'AnnullaUscitaController',
            controllerAs: 'vmd',
            templateUrl: 'app/main/sprardb/beneficiari/dialog/annullaUscita-dialog.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              beneficiario: vm.beneficiario
            }
          }).then(function(payload){
            payload.id = vm.beneficiario.id;
            api.beneficiariomc.rimuoveEventoUscita(payload, function (res) {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Uscita beneficiario annullata correttamente')
                  .position('bottom right')
                  .hideDelay(3000)
              )
              $state.go('app.sprardb_beneficiario', {id: vm.beneficiario.id});
            })
          });
        }

        vm.liberaBeneficiario = liberaBeneficiario;
      function liberaBeneficiario () {
        var popUp = $mdDialog.confirm()
          .title('Uscita Beneficiario')
          .htmlContent('Necessario far uscire il Beneficiario prima di compiere questa azione')
          .ok('Ok');
        console.log(vm.beneficiario);
        if(vm.Beneficiario.stato !== 'TERMINATO'){
          $mdDialog.show(popUp);
          return;
        }

        $mdDialog.show({
          controller: 'LiberaBeneficiarioController',
          controllerAs: 'vmd',
          templateUrl:'app/main/sprardb/beneficiari/dialog/liberaBeneficiario-dialog.html' ,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            beneficiario: vm.beneficiario,
            items: vm.uscita,

          }
        }).then(function() {
          vm.loadb()
        })
      }

        vm.modificastorico = modificastorico;
        function modificastorico() {
            $rootScope.loadingProgress = true;
            var campimodificabilistorico = [
                'nucleoFamiliare',
                'parentela_id',
                'capof_id',
                'idVulnerabilita',
                'idTipoIngresso',
                'note',
                'noteSanitarie',
                'idReligione',
                'gruppoEtnico',
                'email',
                'telefono',
                'codiceFiscale',
                'tipoProtezione_id',
                'idTipoDocumento',
                'dataRilascioDocumento',
                'dataScadenzaDocumento',
                'interesseExArt',
                'dataInteresseExArt',
                'c3',
                'dataC3',
                'dataRichiestaProtezione',
                'idProvenienza',
                'idDublino',
                'dataRichiestaPds',
                'enteDocumento_id',
                'documentoNumero',
                'cambioQPC',
                'noteCambioQPC',
                'dataInizio',
                'dataUscita',
                'cui',
                'codiceVestanet'
            ];
            var campiDaForzare = [
                'nome',
                'cognome',
                'sesso',
                'codNazionalita',
                'dataNascita',
                'dataFine',
                'dataIngresso',
                'dataInizioB',
                'dataUscitaB'
            ];

            if(vm.beneficiario.cui === "NON DISPONIBILE" || vm.beneficiario.cui === '') {
              vm.beneficiario.cui = null
            }
            if(vm.beneficiario.codiceVestanet === "NON DISPONIBILE" || vm.beneficiario.codiceVestanet === '') {
              vm.beneficiario.codiceVestanet = null
            }

            var payload = {};
            payload.progressivo = vm.beneficiario.progressivo;
            var ii = 0;
            for (ii = 0; ii < campimodificabilistorico.length; ii++) {

                if (campimodificabilistorico[ii].indexOf('data') > -1) {
                    payload[campimodificabilistorico[ii]] = moment(vm.beneficiario[campimodificabilistorico[ii]]).format("YYYY-MM-DD");
                    if (vm.beneficiario[campimodificabilistorico[ii]] == null) {
                        payload[campimodificabilistorico[ii]] = null;
                    }
                } else {
                    payload[campimodificabilistorico[ii]] = vm.beneficiario[campimodificabilistorico[ii]];
//                    if (vm.beneficiario[campimodificabilistorico[ii]] == null) {
//                        delete payload[campimodificabilistorico[ii]];
//                    }
                }
            }
            var payload2 = {};
            payload2.id = vm.beneficiario.id;
            var ii = 0;
            for (ii = 0; ii < campiDaForzare.length; ii++) {
                var key = campiDaForzare[ii];
                if (campiDaForzare[ii] == 'dataInizioB') {
                    key = 'dataInizio';
                }
                if (campiDaForzare[ii] == 'dataUscitaB') {
                    key = 'dataUscita';
                }
                if (campiDaForzare[ii].indexOf('data') > -1) {
                    payload2[key] = moment(vm.beneficiario[campiDaForzare[ii]]).format("YYYY-MM-DD");
                    if (vm.beneficiario[campiDaForzare[ii]] == null) {
                        payload2[key] = null;
                    }
                } else {
                    payload2[key] = vm.beneficiario[campiDaForzare[ii]];
//                    if (vm.beneficiario[campiDaForzare[ii]] == null) {
//                        delete payload2[key];
//                    }
                }
            }

//            console.log("STORICO: ", payload);
//            console.log("CORRENTE: ", payload2);
            api.beneficiarios.beneficiario.aggiorna(payload2, function (f) {
                api.beneficiarios.storico.aggiorna(payload, function (e) {
                    $rootScope.loadingProgress = false;
                    var toast = $mdToast.simple()
                            .textContent("Dati beneficiario " + f.codice + " correttamente aggiornati")
                            .position('bottom right')
                            .hideDelay(3000);
                    $mdToast.show(
                            toast
                            ).then(
                            $state.reload()
                            );
                });
            });
        }

        vm.loadb();
        vm.search = {};
        vm.closeDialog = closeDialog;
        vm.returnBeneficiari = returnBeneficiari;
        vm.dataAdOggi = dataAdOggi;

        function dataAdOggi(dataInizio) {
            var di = new Date(dataInizio);
            var adesso = moment();
            return adesso.diff(di, 'days');
        }

        vm.giorniDifferenza = giorniDifferenza;

        function giorniDifferenza(din, dus) {

            var di = new Date(din);
            var du = moment(dus);
            if (dus == null) {
                du = moment(new Date());
            }

            return du.diff(di, 'days');
        }
        vm.calcolomontante = calcolomontante;
        function calcolomontante() {
            vm.calcolomontanteeffettuato = null;
            vm.calcolomontanteeffettuato = [];
            vm.calcoloultimapresenza = null;
            vm.calcoloultimapresenza = [];
            var b = vm.beneficiario;
            var dip = b.dataInizio;
            var dup = b.dataUscitaB;
            var bid = b.id;
            var nmontante = b.nmontante;
            if (angular.isUndefined(vm.calcolomontanteeffettuato[bid])) {
                vm.calcolomontanteeffettuato[bid] = 0;
                if (dup !== null) {
                    vm.calcolomontanteeffettuato[bid] = b.nmontante;
                    var di = new Date(b.dataInizio);
                    var adesso = moment();
                    vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');


                } else {
                    api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante', beneficiario_id: bid, dacl: 1, sort: 'dataInizio'}).$promise.then(function (r) {
                        if (r.data.length > 0) {
                            var data = r.data;
                            angular.forEach(data, function (d) {
                                var d1 = new Date(vm.beneficiario.dataUscita);
                                var d2 = new Date(d.dataUscita);
                                if (d.dataUscita == null) {
                                    d2 = new Date();
                                }
                                if (vm.beneficiario.dataUscita == null || d1 >= d2) {
                                    if (d.dataUscita == null && d.dataUscitaB == null) {
                                        var di = new Date(d.dataInizio);
                                        var adesso = moment();
                                        vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                        vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                                    } else {
                                        vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                                    }
                                }
                            });
                        }
                    });
                }
            }

        }
        vm.changeDataIns = changeDataIns;

        function changeDataIns(id, data, flag) {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'CambioDataDialogController',
                controllerAs: 'vmd',
                focusOnOpen: false,
                //parent: angular.element($document.find('#content-container')),
                templateUrl: 'app/main/sprardb/beneficiari/dialog/cambioData-dialog.html',
                locals: {
                    id: id,
                    data: data,
                    flag: flag
                }
            }).then(function (payload) {
                for (var indice = 0, len = vm.beneficiario.strutturahasbeneficiarios.length; indice < len; indice++) {
                    if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataInserimento") {
                        vm.beneficiario.strutturahasbeneficiarios[indice].dataInserimento = payload.data;
                    }
                    if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataCessazione") {
                        vm.beneficiario.strutturahasbeneficiarios[indice].dataCessazione = payload.data;
                    }
                }
            });
        }

        vm.displayextra = false;
        vm.getExtra = getExtra;
        function getExtra(path, data) {
            //console.log(path);
            var paths = path.split('.');
            var root = data;
            angular.forEach(paths, function (obj) {
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                    } catch (err) {
                    }
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }

        vm.dataoggi = new Date();
        vm.m = moment(vm.dataoggi);
        vm.dataoggistring = vm.m.format("YYYY-MM-DD");
        vm.alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Processo')
                .textContent('Operazione Confermata.')
                .ariaLabel('conferma')
                .ok('OK');


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function returnBeneficiari() {
            $state.go('app.sprardb_accolti', {def: 1});
        }

        vm.attributiLabel = {
            'COMPETENZE': 'Competenze professionali',
            'CORSO': 'Interessi Corsi',
            'DOCUMENTO': 'Tipo Documento Ingresso',
            'INGRESSO': 'Tipo di Ingresso',
            'LINGUA': 'Lingua',
            'LINGUA-CONOSCENZA': 'Conoscenza lingue',
            'MOTIVO-USCITA': 'Motivo di Uscita',
            'NAZIONE': 'Nazione',
            'PARENTELA': 'Gradi di parentela',
            'PROFESSIONE': 'Professione svolte',
            'RELIGIONE': 'Religione',
            'SERVIZIO': 'Interesse a servizio',
            'STATO': 'Stato',
            'STUDI': 'Studi Effettuati',
            'STUDI-AREA': 'Area studi di interesse',
            'VULNERABILITA': 'Tipo di Vulnerabilità',
        };
        vm.tempstruttura = null;
        vm.tempaccoglienza = null;
        vm.tempalloggio = null;


        vm.years = [
            {id: ""},
            {id: (new Date()).getFullYear()},
            {id: (new Date()).getFullYear() - 1},
            {id: (new Date()).getFullYear() - 2},
            {id: (new Date()).getFullYear() - 3},
            {id: (new Date()).getFullYear() - 4},
            {id: (new Date()).getFullYear() - 5},
            {id: (new Date()).getFullYear() - 6},
            {id: (new Date()).getFullYear() - 7},
            {id: (new Date()).getFullYear() - 8},
            {id: (new Date()).getFullYear() - 9},
            {id: (new Date()).getFullYear() - 10},
            {id: (new Date()).getFullYear() - 11},
            {id: (new Date()).getFullYear() - 12},
            {id: (new Date()).getFullYear() - 13},
            {id: (new Date()).getFullYear() - 14},
            {id: (new Date()).getFullYear() - 15},
            {id: (new Date()).getFullYear() - 16},
            {id: (new Date()).getFullYear() - 17},
            {id: (new Date()).getFullYear() - 18},
            {id: (new Date()).getFullYear() - 19},
            {id: (new Date()).getFullYear() - 20}
        ];
        vm.sersearchYear = new Date().getFullYear();
        vm.corsearchYear = new Date().getFullYear();

        vm.openCorsiBenDialog = openCorsiBenDialog;
        function openCorsiBenDialog(ev, item, index, newlink) {
            var oggi = new Date();
            var today = moment(oggi).format('YYYY-MM-DD');
            api.progettos.hascorsi.search({pagination: -1, progetto_id: item.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
                vm.tempcorsi = response;
                $mdDialog.show({
                    controller: 'DialogCorsiBenController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/form/dialogCorsiBenForm.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        All: vm.tempcorsi,
                        Ben: item,
                        index: index,
                        newlink: newlink
                    }
                });
            });
        }

        vm.openServiziBenDialog = openServiziBenDialog;
        function openServiziBenDialog(ev, item, index, newlink) {
            var oggi = new Date();
            var today = moment(oggi).format('YYYY-MM-DD');
            api.progettos.hasservizi.search({pagination: -1, progetto_id: item.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
                vm.tempservizi = response;
                //console.log("response", response);
                $mdDialog.show({
                    controller: 'DialogServiziBenController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/form/dialogServiziBenForm.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        All: vm.tempservizi,
                        Ben: item,
                        index: index,
                        newlink: newlink
                    }
                });
            });
        }




        //scheda statica commissione status
        vm.commissiones = [
            {id: "ANCONA", competenza: "Marche, Abruzzo"},
            {id: "BARI", competenza: "Bari, Matera"},
            {id: "BOLOGNA", competenza: "Emilia Romagna"},
            {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
            {id: "CAGLIARI", competenza: "Sardegna"},
            {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
            {id: "CATANIA", competenza: "Catania, Enna"},
            {id: "CROTONE", competenza: "Calabria"},
            {id: "FIRENZE", competenza: "Toscana, Umbria"},
            {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
            {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
            {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
            {id: "MILANO", competenza: "Lombardia"},
            {id: "PALERMO", competenza: "Palermo, Messina"},
            {id: "ROMA", competenza: "Lazio"},
            {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
            {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
            {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
            {id: "TRAPANI", competenza: "Trapani, Agrigento"},
            {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
        ];
        vm.loadprefettura = loadprefettura;
        function loadprefettura() {
            api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.prefetturas = response.data;
            });
        }
        vm.loadprefettura();
        vm.loadquestura = loadquestura;
        function loadquestura() {
            api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.questuras = response.data;
            });
        }
        vm.loadquestura();
        vm.motivods = motivods;
        function motivods() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "descrizione"}, function (r) {
                vm.motivods = r.data;
            });
        }
        vm.motivods();
    }

  function DettaglioBeneficiarioTerritorioController($state, $document, $filter, api, msUtils, $mdDialog, eventi, acl, ricerca, $mdToast, $cookies, $rootScope)
  {
    var vm = this;
    vm.isallowed = acl.isallowed2;
    vm.richestaprorogaottenibile = eventi.richestaprorogaottenibile;
    vm.uscitaottenibile = eventi.uscitaottenibile;
    vm.isAdmin = api.isAdmin;
    vm.api = api;
    vm.filternucleo = false;
    vm.isomonimo = false;
    vm.activeFilter = {};
    vm.activeFilter.tipo = [];
    vm.activeFilter.stato = [];
    vm.letteraTrasf = eventi.letteraTrasf;
    ricerca.reloadCS();
    vm.toggleFilter = function (datas, tipo) {
      //console.log(datas);
      //console.log(tipo);
      angular.forEach(datas, function (data) {
        var found = vm.activeFilter[tipo].indexOf(data);
        if (found >= 0) {
          vm.activeFilter[tipo].splice(found, 1);
        } else {
          vm.activeFilter[tipo].push(data);
        }
      });
    };
    vm.options = ricerca.options;
    vm.selected = ricerca.selected;
    vm.limitOptions = ricerca.limitOptions;
    vm.allsearchs = ricerca.begin_allsearchs();
    vm.exallsearchs = ricerca.begin_allsearchs();
    vm.attallsearchs = ricerca.begin_allsearchs();
    vm.allprogettos = ricerca.progettos;
    vm.isReadOnly = false;
    vm.cookiepid = $cookies.getObject('ALL_p_id');
    vm.progettiAbilitati = vm.cookiepid.split(",").map(Number);
    vm.prpi = true;
    vm.caricamentoultimato = false;
    vm.colors = eventi.colors2;

    vm.codicePresenza = $state.params.codicePresenza;
    vm.oggi = new Date();
    var m4 = moment.duration({'days': 120});
    vm.oggim4 = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
    vm.tabellastrutture = [
      {
        etichetta: "#",
        campo: ['id'],
        mdorderby: "id",
        style: "text-align: center;"

      }, {
        etichetta: "struttura",
        mdorderby: "nome",
        campo: ['nome', 'progettos.nome'],
        b: true

      }, {
        etichetta: "ubicazione",
        mdorderby: "indirizzo",
        campo: ['indirizzo', 'istats.comune', 'istats.provincia'],
        icona: null

      }, {
        etichetta: "tipologia",
        campo: ['strutturaAccoglienzas.descrizione', 'strutturaAlloggios.descrizione']

      }, {
        etichetta: "attivo",
        campo: ['attivo'],
        mdorderby: "attivo",
        icona: {'0': 'icon-bookmark-outline', '1': 'icon-bookmark-check'}

      }, {
        etichetta: "posti",
        mdorderby: "numeroPosti",
        campo: ['numeroPosti']
      }, {
        etichetta: "stanze",
        mdorderby: "numeroStanze",
        campo: ['numeroStanze']
      }, {
        etichetta: "s.igien",
        mdorderby: "numeroIgienici",
        campo: ['numeroIgienici']
      }, {
        a: true,
        bottoni: [{
          icona: "icon-bookmark-outline",
          etichetta: "xxxx",
          ngclick: "",
          uisref: "app.sprardb_progetti_strutture_struttura",
          ngif: true
        }, {
          icona: "icon-bookmark-outline",
          etichetta: "xxxxu",
          ngclick: function click() {
            //console.log("click");
          },
          uisref: "",
          ngif: false
        }]
      }
    ];

    vm.corsicat = ricerca.corsicategoria;
    vm.servizicat = ricerca.servizicategoria;
    vm.statobeneficiarios = ricerca.statobeneficiarios;

    vm.nstatusgs = [
      {id: 591, descrizione: "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO"},
      {id: 592, descrizione: "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA"},
      {id: 593, descrizione: "TITOLARE PROTEZIONE UMANITARIA"}
    ];
    /*
     * vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
     vm.arraynstatus = {tipo: [1999], stato: [1]};
     vm.arraynstatus2 = {tipo: [1998], stato: [1]};
     vm.arrayallstatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
     //vm.arraystatus = {tipo: [2000], stato: [1, 3, 4, 5, 10, 11, 15, 20]};
     //vm.arraydocumenti = {tipo: [2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030], stato: [1]};
     vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086], stato: [1]};
     *
     */


    vm.arraystatus = {tipo: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2014,2015,2016], stato: [1, 3, 4, 5, 10, 11, 14, 15, 16, 17, 20]};
    vm.arraydocumenti = {tipo: [2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088], stato: [1, 4]};
    vm.arrayproroga = {tipo: [1011], stato: [1, 3, 4]}; //eliminato 1009
    vm.arrayuscita = {tipo: [1010], stato: [1]};
    vm.arrayallontanamento = {tipo: [1012], stato: [1, 3]};
    vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 4, 5, 20]};
    if (vm.api.isOperatoreG) {
      vm.arraytrasferimento = {tipo: [1013, 6001, 6002], stato: [1, 2, 3, 5]};
    }
    //divido trasferimento interno e esterno
    vm.arraytrasferimentoA = {tipo: [1013], stato: [-1, 1, 2, 3]};
    vm.arraytrasferimentoB = {tipo: [1014], stato: [1, 2, 3]};
    vm.arraynewprocess = {tipo: [2000, 2001, 2002, 2003, 1010], stato: [1, 3, 5, 10, 11, 14, 15, 16, 17, 20]};
    //poi verranno ricaricati quando carico beneficiario
    vm.newprocess = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
      titolo: "Nuovo evento",
      numeroEventi: 5
    };
    vm.sg = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
      titolo: "Nuovo status giuridico",
      numeroEventi: vm.arraystatus.tipo.length
    };
    vm.acc = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
      titolo: "Nuova proroga",
      numeroEventi: vm.arrayproroga.tipo.length
    };
    vm.uscita = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
      titolo: "Nuova uscita",
      numeroEventi: vm.arrayuscita.tipo.length
    };
    vm.newpro = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
      titolo: "Nuova proroga",
      numeroEventi: 1
    };
    vm.newdoc = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
      titolo: "Aggiungi/rinnova documento",
      numeroEventi: vm.arraydocumenti.tipo.length
    };
    vm.newtrasf = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
      titolo: "Nuovo trasferimento",
      numeroEventi: vm.arraytrasferimento.tipo.length
    };
    //divido trasferimento interno e esterno
    vm.newtrasfA = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
      titolo: "Nuovo trasferimento",
      numeroEventi: vm.arraytrasferimentoA.tipo.length
    };
    vm.newtrasfB = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
      titolo: "Nuovo trasferimento",
      numeroEventi: vm.arraytrasferimentoB.tipo.length
    };
    vm.newall = {
      entita1_id: vm.beneficiario_id,
      eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
      titolo: "Nuovo allontanamento",
      numeroEventi: vm.arrayallontanamento.tipo.length
    };
//fine sprar new process
    vm.def = ($state.params.def) ? $state.params.def : null;
    vm.Beneficiario = {}; //Beneficiario;
    vm.beneficiario = {}; //angular.copy(Beneficiario.data[0])
    vm.nazioni = null;
    vm.religioni = null;
    vm.tipoDocumento = null;
    vm.tipoIngresso = null;
    vm.stato = null;
    vm.uploadParams = {
      documentoTipo_id: 0,
      gruppo: 'BENEFICIARIO',
      dettaglio: true,
      entita: 'beneficiario',
      entitakey: 'beneficiario_id',
      entitakey2: 'pid',
      pid: 0,
      entita2_id: 0,
      cancellazione: vm.api.isAdminG,
      isAdminG: vm.api.isAdminG
    };
    vm.uploadParams.beneficiario_id = vm.beneficiario_id;
    vm.uploadParams.entita_id = vm.beneficiario_id;
    vm.uploadParams2 = {
      documentoTipo_id: 0,
      gruppo: 'TRASFERIMENTI',
      dettaglio: true,
      entita: 'beneficiario',
      entitakey: 'beneficiario_id'
    };
    vm.uploadParams2.beneficiario_id = vm.beneficiario_id;
    vm.uploadParams2.entita_id = vm.beneficiario_id;
    vm.viewEvento = eventi.viewDetails;
    vm.colors = eventi.colors;
    vm.scolors = eventi.scolors;
    vm.colors = eventi.colors2;
    vm.icons = eventi.icons;
    api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "500", sort: "descrizione"}, function (response) {
      vm.nazioni = response.data;
      vm.nazionalitas = response.data;
    });
    api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "50", sort: "descrizione"}, function (response) {
      vm.religioni = response.data;
    });
    api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", sort: "descrizione"}, function (response) {
      vm.tipoDocumento = response.data;
    });
    api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50", sort: "descrizione"}, function (response) {
      vm.tipoIngresso = response.data;
    });
    api.beneficiarios.attributi.cerca({gruppo: "STATO", pagination: "50", sort: "descrizione"}, function (response) {
      vm.stato = response.data;
    });
    api.beneficiarios.attributi.cerca({gruppo: "TIPO-PROTEZIONE", pagination: "50", sort: "ordinamento,descrizione"}, function (response) {
      vm.tipoProteziones = response.data;
    });
    api.tipologiaBeneficiario.tipologie.search(function (res) {
      vm.tipologiaBenficiario = res.data;
    })

    vm.ingresso = function () {
      api.beneficiarioattributis.beneficiario.search({gruppo: 'INGRESSO', sort: 'descrizione'}).$promise.then(function (response) {
        vm.ingressos = response.data;
      }, function (response) {
        //console.log(response);
      });
    };
    vm.ingresso();
    api.entes.ente.cerca({enteTipo_id: "7", pagination: "200", sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
      vm.enteDocumentoids = response.data;
    });
    vm.nucleofamiliare = function () {
      api.beneficiarioattributis.beneficiario.search({gruppo: 'NUCLEOFAMILIARE', sort: 'descrizione'}).$promise.then(function (response) {
        vm.nucleofamiliares = response.data;
      }, function (response) {
        //console.log(response);
      });
    };
    vm.nucleofamiliare();
    vm.vulnerabilita = function () {
      api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
        vm.vulnerabilitas = response.data;
      }, function (response) {
        //console.log(response);
      });
    };
    vm.vulnerabilita();
    vm.parentela = function () {
      api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: '-note,descrizione'}).$promise.then(function (response) {
        vm.parentelas = response.data;
        angular.forEach(vm.parentelas, function (parentela) {

        });
      }, function (response) {
        //console.log(response);
      });
    };
    vm.parentela();
    vm.sino = ricerca.sino;
    vm.provenienza = ricerca.provenienza;
    vm.dublino = ricerca.dublino;
    vm.iTipoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PASSAPORTO"}, {descrizione: "CARTA IDENTITA"}, {descrizione: "ALTRO"}];
    vm.iLuogoDocumento = [{descrizione: "NESSUNO"}, {descrizione: "PAESE ORIGINE"}, {descrizione: "ITALIA"}, {descrizione: "ALTRO"}];
    vm.iModalitaAccertamento = [{descrizione: "NESSUNO"}, {descrizione: "DOCUMENTO"}, {descrizione: "COLLOQUIO"}, {descrizione: "ACCERTAMENTO"}, {descrizione: "ALTRO"}];
    vm.iQualifica = [{descrizione: "NESSUNO"}, {descrizione: "SINDACO"}, {descrizione: "ASSESSORE"}, {descrizione: "DIRIGENTE"}, {descrizione: "ASSISTENTE SOCIALE"}, {descrizione: "AVVOCATO"}, {descrizione: "TUTORE VOLONTARIO"}, {descrizione: "ALTRO"}];
    vm.isnew = false;
    vm.evento = 'update';
    var searchpayload = {};
    searchpayload = {codicePresenza: vm.codicePresenza};
    vm.beneficiario.eventostatusgs = [];
    vm.beneficiario.eventoprorogas = [];
    vm.beneficiario.eventouscitas = [];
    vm.beneficiario.eventotrasferimentos = [];
    vm.beneficiario.eventoallontanamentos = [];
    vm.beneficiario.eventodocumentos = [];
    vm.beneficiario.eventoAstatusgs = [];
    vm.beneficiario.eventoAprorogas = [];
    vm.beneficiario.eventoAuscitas = [];
    vm.beneficiario.eventoAtrasferimentos = [];
    vm.beneficiario.eventoAallontanamentos = [];
    vm.beneficiario.eventoAdocumentos = [];
    vm.beneficiario_segnalato = {};
    vm.eraTitolare = false;
//carica beneficiario
    vm.bloaded = false;
    vm.popupEsterna = function(){
      $mdDialog.show({
        controller: 'DisattivaEsternaController',
        controllerAs: 'vmd',
        templateUrl:'app/main/sprardb/beneficiari/dialog/disattivaEsterna.html' ,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          progetto_id: vm.beneficiario.progetto_id,
          struttura: $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})
        }
      });
    }
    vm.loadb = function () {
      api.paeseTerzoProvenienza.index({expand:'nazione.descrizione'}, function (response) {
        vm.paeseProvenienza = response.data;
      })
      api.beneficiarios.a.search(searchpayload, function (r1) {
        vm.Beneficiario = r1.data[0];
        vm.beneficiario = r1.data[0];
        vm.struttura_corr = $filter('filter')(vm.beneficiario.strutturas, {id: vm.beneficiario.struttura_id})[0]
        vm.uploadParams.beneficiario_id = vm.beneficiario.id;
        vm.uploadParams.entita_id = vm.beneficiario.id;
        vm.uploadParams.pid = vm.beneficiario.progetto_id;
        vm.uploadParams.entita2_id = vm.beneficiario.progetto_id;
        vm.uploadParams2.beneficiario_id = vm.beneficiario.id;
        vm.uploadParams2.entita_id = vm.beneficiario.id;
        api.beneficiarios.beneficiario.get({id: vm.beneficiario.id}).$promise.then(function (r2) {
          vm.beneficiarioattuale = r2;
          vm.beneficiario.eventos = angular.copy(vm.beneficiarioattuale.eventos);
          vm.beneficiario.corsos = angular.copy(vm.beneficiarioattuale.corsos);
          vm.beneficiario.servizios = angular.copy(vm.beneficiarioattuale.servizios);
          var campiDaImportare = [
            'idTipoDocumento',
            'enteDocumento_id',
            'documentoNumero',
            'dataRilascioDocumento',
            'dataScadenzaDocumento',
            'cambioQPC',
            'noteCambioQPC',
            'tipoProtezione_id',
            'interesseExArt',
            'dataInteresseExArt',
            'c3',
            'dataC3',
            'dataRichiestaProtezione',
            'dataRichiestaPds',
            'extraCommissione'
          ];
          angular.forEach(campiDaImportare, function (campo) {
            if (angular.isUndefined(vm.beneficiario[campo])) {
              vm.beneficiario[campo] = angular.copy(vm.beneficiarioattuale[campo]);
            }
          });

          var campiDaForzare = [
            'nome',
            'cognome',
            'sesso',
            'codNazionalita',
            'dataNascita',
            'dataFine',
            'dataIngresso',
            'strutturas'
          ];
          angular.forEach(campiDaForzare, function (campo) {
            vm.beneficiario[campo] = angular.copy(vm.beneficiarioattuale[campo]);
          });

          vm.isnew = false;
          //svm.isReadOnly = true; //

          angular.forEach(vm.beneficiario, function (value, key) {
            if (key.toLowerCase().indexOf("data") !== -1) {
              if (value === '0000-00-00' || value === null) {
                vm.beneficiario[key] = null;
              } else {
                vm.beneficiario[key] = new Date(value);
              }
            }
          });
          vm.newprocess = {
            entita1_id: vm.beneficiario.id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: "2000,2001,2002,2003,1010", sort: "nome"},
            titolo: "Nuovo evento",
            numeroEventi: 5
          };
          vm.sg = {
            entita1_id: vm.beneficiario.id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraystatus.tipo.join(), sort: "nome"},
            titolo: "Nuovo status giuridico",
            numeroEventi: vm.arraystatus.tipo.length
          };
          vm.acc = {
            entita1_id: vm.beneficiario.id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayproroga.tipo.join(), sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: vm.arrayproroga.tipo.length
          };
          vm.uscita = {
            entita1_id: vm.beneficiario.id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayuscita.tipo.join(), sort: "nome"},
            titolo: "Nuova uscita",
            numeroEventi: vm.arrayuscita.tipo.length
          };
          vm.newpro = {
            entita1_id: vm.beneficiario.id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: "1011", sort: "nome"},
            titolo: "Nuova proroga",
            numeroEventi: 1
          };
          var documento_id_abilitati = [];
          angular.forEach(ricerca.corr_tiprot_doc, function (docs, tprot) {
            if (parseInt(tprot) === vm.beneficiario.tipoProtezione_id) {
              documento_id_abilitati = docs;
            }
          });
          var processi_doc_abilitati = [];
          angular.forEach(ricerca.corr_doc_processi, function (processo_id_ab, doc) {
            if (documento_id_abilitati.indexOf(parseInt(doc)) > -1) {
              processi_doc_abilitati.push(processo_id_ab);
            }
          });
          vm.arraydocumentiB = angular.copy(vm.arraydocumenti);
          vm.arraydocumenti = {tipo: processi_doc_abilitati, stato: [1]};
          vm.newdoc = {
            entita1_id: vm.beneficiario_id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraydocumenti.tipo.join(), sort: "nome"},
            titolo: "Aggiungi/rinnova documento",
            numeroEventi: vm.arraydocumenti.tipo.length
          };
          vm.newtrasf = {
            entita1_id: vm.beneficiario_id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimento.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimento.tipo.length
          };
          vm.newtrasfA = {
            entita1_id: vm.beneficiario_id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoA.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoA.tipo.length
          };
          vm.newtrasfB = {
            entita1_id: vm.beneficiario_id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraytrasferimentoB.tipo.join(), sort: "nome"},
            titolo: "Nuovo trasferimento",
            numeroEventi: vm.arraytrasferimentoB.tipo.length
          };
          vm.newall = {
            entita1_id: vm.beneficiario_id,
            entita2_id: vm.beneficiario.struttura_id,
            eventoFiltro: {crea: 1, id_IN: vm.arrayallontanamento.tipo.join(), sort: "nome"},
            titolo: "Nuovo allontanamento",
            numeroEventi: vm.arrayallontanamento.tipo.length
          };
          var counter = 0;
          vm.spliteventos = {
            eventostatusgs: vm.arraystatus,
            eventoprorogas: vm.arrayproroga,
            eventouscitas: vm.arrayuscita,
            eventotrasferimentos: vm.arraytrasferimento,
            eventotrasferimentoAs: vm.arraytrasferimentoA,
            eventotrasferimentoBs: vm.arraytrasferimentoB,
            eventodocumentos: vm.arraydocumenti,
            eventoallontanamentos: vm.arrayallontanamento
          };
          vm.splitAeventos = {
            eventoAstatusgs: vm.arraystatus,
            eventoAprorogas: vm.arrayproroga,
            eventoAuscitas: vm.arrayuscita,
            eventoAtrasferimentos: vm.arraytrasferimento,
            eventoAtrasferimentoAs: vm.arraytrasferimentoA,
            eventoAtrasferimentoBs: vm.arraytrasferimentoB,
            eventoAdocumentos: vm.arraydocumentiB,
            eventoAallontanamentos: vm.arrayallontanamento
          };
          vm.beneficiario.eventostatusgs = [];
          vm.beneficiario.eventoprorogas = [];
          vm.beneficiario.eventouscitas = [];
          vm.beneficiario.eventotrasferimentos = [];
          vm.beneficiario.eventotrasferimentoAs = [];
          vm.beneficiario.eventotrasferimentoBs = [];
          vm.beneficiario.eventoallontanamentos = [];
          vm.beneficiario.eventodocumentos = [];
          vm.beneficiario.eventoAstatusgs = [];
          vm.beneficiario.eventoAprorogas = [];
          vm.beneficiario.eventoAuscitas = [];
          vm.beneficiario.eventoAtrasferimentos = [];
          vm.beneficiario.eventoAtrasferimentoAs = [];
          vm.beneficiario.eventoAtrasferimentoBs = [];
          vm.beneficiario.eventoAallontanamentos = [];
          vm.beneficiario.eventoAdocumentos = [];




          angular.forEach(vm.beneficiario.eventos, function (obj) {
            vm.beneficiario.eventos[counter].processi = obj.eventoTipo.processo.split("|");
            angular.forEach(vm.spliteventos, function (dati, chiave) {
              if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && dati.stato.indexOf(obj.eventoStato_id) >= 0) {
                //soddisfa condizioni di tipo e stato contemporaneamente
                vm.beneficiario[chiave].push(obj);

              }
            });
            angular.forEach(vm.splitAeventos, function (dati, chiave) {

              if (dati.tipo.indexOf(obj.eventoTipo_id) >= 0 && obj.progetto_id == vm.beneficiario.progetto_id) {
                obj.extra = angular.fromJson(obj.extra);
                vm.beneficiario[chiave].push(obj);
              }


            });
            counter++;
          });
          var sgcount = 0;
          var sgcounthowmany = 0;
          //console.log("vm.beneficiario.eventostatusgs", vm.beneficiario.eventostatusgs);
          angular.forEach(vm.beneficiario.eventostatusgs, function (esg, kesg) {
            if (esg.eventoTipo_id == 2000) {
              sgcount = kesg;
              sgcounthowmany++;
            }
          });
          if (sgcounthowmany >= 1) {
            var copyeventostatusg = angular.copy(vm.beneficiario.eventostatusgs);
            vm.beneficiario.eventostatusgs = null;
            vm.beneficiario.eventostatusgs = [];
            vm.beneficiario.eventostatusgs.push(copyeventostatusg[sgcount]);
          }

          vm.tuttoDisabilitato = true;
          vm.famiglia = null;
          api.eventos.evento.search({eventoTipo_id: '1002', entita1_id: vm.beneficiario.segnalato_id}, function (response) {
            if (response) {
              vm.extraSegnalazione = response.data[0].extra;
            }
          });

          if (vm.beneficiario.capof_id != 0) {
            api.beneficiarios.minimal.search({capof_id: vm.beneficiario.capof_id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
              if (d) {
                vm.famiglia = d.data;
              }
              api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                vm.beneficiario.capoFamiglia =  res.data[0] ? res.data[0] : null;
                if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                  vm.famiglia.push(f);
                }
              });
            });
          } else {
            api.beneficiarios.minimal.search({capof_id: vm.beneficiario.id, fields: "codice,nome,cognome,capof_id,parentelas"}, function (d) {
              if (d) {
                vm.famiglia = d.data;
              }
              api.beneficiarios.beneficiario.capofamiglia({capof_id:vm.beneficiario.capof_id},function(res){
                vm.beneficiario.capoFamiglia =  res.data[0] ? res.data[0] : null;
                if (vm.beneficiario.capoFamiglia && vm.mostraCapofamiglia(vm.famiglia,vm.beneficiario.capoFamiglia)) {
                  vm.famiglia.push(f);
                }
              });
            });
          }
          vm.bloaded = true;
          vm.calcolomontante();
          vm.caricamentoultimato = true;

          vm.eventiPresenze = $filter('filter')(vm.beneficiario.eventos, {eventoTipo_id: 1018})
        });
        // se la response ritorna un codice vestanet o cui  nullo
        // allora metti la checkbox gia spuntata e prevalorizzata a non disponibile.
        if(vm.beneficiario.cui === null){
          vm.checkboxCui = true
          vm.beneficiario.cui = "NON DISPONIBILE"
        }
        if(vm.beneficiario.codiceVestanet === null){
          vm.checkboxVestanet = true
          vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
        }
      });
    };

    vm.possovisualizzare = possovisualizzare;
    function possovisualizzare(progetto_id) {

      var progetti = $cookies.getObject('ALL_p_id');
      var results = true;
      if ((progetti.indexOf(progetto_id) === -1 && !vm.isAdmin && !vm.isVisitatore && !vm.isTutor)) {
        results = false;
      }
      //console.log("results:", results);

      return results;
    }

    // logica per codice vestanet e cui
    // serve un refactoring completo di questo controller imo.
    vm.checkboxCui = false
    vm.checkboxVestanet = false

    vm.cancellaBeneficiario = cancellaBeneficiario;
    vm.reintegraBeneficiario = reintegraBeneficiario;
    vm.terminaNelTerritorio = terminaNelTerritorio;

    function terminaNelTerritorio () {
      $mdDialog.show({
        controller: 'TerminaNelTerritorioController',
        controllerAs: 'vmd',
        templateUrl:'app/main/sprardb/beneficiari/dialog/terminaBeneficiarioNelTerritorio-dialog.html' ,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          beneficiario: vm.beneficiario,
        }
      })
    }

    function cancellaBeneficiario() {
      var confirm = $mdDialog.confirm()
        .title('Elimina beneficiario')
        .textContent('Sei sicuro di voler eliminare il beneficiario corrente?')
        .ok('Conferma')
        .cancel('Annulla');
      $mdDialog.show(confirm).then(function() {
        api.beneficiariomc.cancellaBeneficiario({id: vm.beneficiario.beneficiario_id}, function (res) {
          $state.reload();
        });
      });
    }

    function reintegraBeneficiario() {
      var confirm = $mdDialog.confirm()
        .title('Reintegra beneficiario')
        .textContent('Sei sicuro di voler reintegrare il beneficiario nel progetto corrente?')
        .ok('Conferma')
        .cancel('Annulla');
      $mdDialog.show(confirm).then(function() {
        api.beneficiariomc.reintegraBeneficiario({id: vm.beneficiario.beneficiario_id}, function (res) {
          $state.reload();
        });
      });
    }

    vm.checkboxCuiOnClick = function () {
      if (vm.checkboxCui) {
        vm.beneficiario.cui = "NON DISPONIBILE"
      } else {
        vm.beneficiario.cui = ''
      }
    }

    vm.checkboxVestanetOnClick = function () {
      if (vm.checkboxVestanet) {
        vm.beneficiario.codiceVestanet = "NON DISPONIBILE"
      } else {
        vm.beneficiario.codiceVestanet = ''
      }
    }


    vm.mostraCapofamiglia = function (famiglia, capoF) {
      var ret = true;
      angular.forEach(famiglia,function (ben) {
        if(ben.codice == capoF.codice){
          ret = false;
        }
      });
      return ret;
    }

    vm.lt = lt;
    function lt(val1, val2) {
      if (val1 == null || val2 == null) {
        return false;
      }
      if (!angular.isDate(val1)) {
        val1 = new Date(val1);
      }
      if (!angular.isDate(val2)) {
        val2 = new Date(val2);
      }
      return val1 <= val2;
    }

    vm.save = save;
    function save() {
      //console.log("isnew?:", evento);
      if(vm.beneficiario.cui === "NON DISPONIBILE" || vm.beneficiario.cui === '') {
        vm.beneficiario.cui = null
      }
      if(vm.beneficiario.codiceVestanet === "NON DISPONIBILE" || vm.beneficiario.codiceVestanet === '') {
        vm.beneficiario.codiceVestanet = null
      }
      var beneficiario = angular.extend({}, vm.beneficiario);
      var placeholderdate = new Date("1970-01-01");
      angular.forEach(beneficiario, function (value, key) {
        //console.log("valori:", value);
        if (key.toLowerCase().indexOf("data") !== -1) {
          //console.log("valori:", value);
          //console.log("valori:", new Date(value));
          if (angular.isDate(value)) {
            if (moment(value).format("YYYY-MM-DD") !== "1970-01-01") {
              beneficiario[key] = moment(value).format("YYYY-MM-DD");
            } else {
              beneficiario[key] = null;
            }
          } else {
            beneficiario[key] = null;
          }

        }
      });
      var extraCommissione = angular.copy(beneficiario.extraCommissione);
      beneficiario.extraCommissione = angular.toJson(extraCommissione, false);

      api.beneficiarios.beneficiario.aggiorna(beneficiario, function (response) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('Beneficiario aggiornato')
            .position('bottom right')
            .hideDelay(3000)
        );
        $state.reload();
      });
    }

    vm.loadb();
    vm.search = {};
    vm.closeDialog = closeDialog;
    vm.returnBeneficiari = returnBeneficiari;
    vm.dataAdOggi = dataAdOggi;

    function dataAdOggi(dataInizio) {
      var di = new Date(dataInizio);
      var adesso = moment();
      return adesso.diff(di, 'days');
    }

    vm.giorniDifferenza = giorniDifferenza;

    function giorniDifferenza(din, dus) {

      var di = new Date(din);
      var du = moment(dus);
      if (dus == null) {
        du = moment(new Date());
      }

      return du.diff(di, 'days');
    }
    vm.calcolomontante = calcolomontante;
    function calcolomontante() {
      vm.calcolomontanteeffettuato = null;
      vm.calcolomontanteeffettuato = [];
      vm.calcoloultimapresenza = null;
      vm.calcoloultimapresenza = [];
      var b = vm.beneficiario;
      var dip = b.dataInizio;
      var dup = b.dataUscitaB;
      var bid = b.id;
      var nmontante = b.nmontante;
      if (angular.isUndefined(vm.calcolomontanteeffettuato[bid])) {
        vm.calcolomontanteeffettuato[bid] = 0;
        if (dup !== null) {
          vm.calcolomontanteeffettuato[bid] = b.nmontante;
          var di = new Date(b.dataInizio);
          var adesso = moment();
          vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');


        } else {
          api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante', beneficiario_id: bid, dacl: 1, sort: 'dataInizio'}).$promise.then(function (r) {
            if (r.data.length > 0) {
              var data = r.data;
              angular.forEach(data, function (d) {
                var d1 = new Date(vm.beneficiario.dataUscita);
                var d2 = new Date(d.dataUscita);
                if (d.dataUscita == null) {
                  d2 = new Date();
                }
                if (vm.beneficiario.dataUscita == null || d1 >= d2) {
                  if (d.dataUscita == null && d.dataUscitaB == null) {
                    var di = new Date(d.dataInizio);
                    var adesso = moment();
                    vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                  } else {
                    vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                  }
                }
              });
            }
          });
        }
      }

    }
    vm.changeDataIns = changeDataIns;

    function changeDataIns(id, data, flag) {
      $mdDialog.show({
        clickOutsideToClose: true,
        controller: 'CambioDataDialogController',
        controllerAs: 'vmd',
        focusOnOpen: false,
        //parent: angular.element($document.find('#content-container')),
        templateUrl: 'app/main/sprardb/beneficiari/dialog/cambioData-dialog.html',
        locals: {
          id: id,
          data: data,
          flag: flag
        }
      }).then(function (payload) {
        for (var indice = 0, len = vm.beneficiario.strutturahasbeneficiarios.length; indice < len; indice++) {
          if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataInserimento") {
            vm.beneficiario.strutturahasbeneficiarios[indice].dataInserimento = payload.data;
          }
          if (vm.beneficiario.strutturahasbeneficiarios[indice].id == payload.id && payload.flag == "dataCessazione") {
            vm.beneficiario.strutturahasbeneficiarios[indice].dataCessazione = payload.data;
          }
        }
      });
    }

    vm.displayextra = false;
    vm.getExtra = getExtra;
    function getExtra(path, data) {
      //console.log(path);
      var paths = path.split('.');
      var root = data;
      angular.forEach(paths, function (obj) {
        //return obj;
        if (typeof root[obj] === 'undefined') {
          root[obj] = {};
        }
        root = root[obj];
        if (obj == 'extra') {
          try {
            root = JSON.parse(root);
          } catch (err) {
          }
          root = $filter('json')(root);
          root = root.replace("{", "").replace("}", "");
          root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
          if (root.length === 0) {
            root = 'Nessun dato';
          }
        }
      });
      return root;
    }

    vm.dataoggi = new Date();
    vm.m = moment(vm.dataoggi);
    vm.dataoggistring = vm.m.format("YYYY-MM-DD");
    vm.alert = $mdDialog.alert()
      .clickOutsideToClose(true)
      .title('Processo')
      .textContent('Operazione Confermata.')
      .ariaLabel('conferma')
      .ok('OK');


    /**
     * Close dialog
     */
    function closeDialog()
    {
      $mdDialog.hide();
    }

    function returnBeneficiari() {
      $state.go('app.sprardb_accolti', {def: 1});
    }

    vm.attributiLabel = {
      'COMPETENZE': 'Competenze professionali',
      'CORSO': 'Interessi Corsi',
      'DOCUMENTO': 'Tipo Documento Ingresso',
      'INGRESSO': 'Tipo di Ingresso',
      'LINGUA': 'Lingua',
      'LINGUA-CONOSCENZA': 'Conoscenza lingue',
      'MOTIVO-USCITA': 'Motivo di Uscita',
      'NAZIONE': 'Nazione',
      'PARENTELA': 'Gradi di parentela',
      'PROFESSIONE': 'Professione svolte',
      'RELIGIONE': 'Religione',
      'SERVIZIO': 'Interesse a servizio',
      'STATO': 'Stato',
      'STUDI': 'Studi Effettuati',
      'STUDI-AREA': 'Area studi di interesse',
      'VULNERABILITA': 'Tipo di Vulnerabilità',
    };
    vm.tempstruttura = null;
    vm.tempaccoglienza = null;
    vm.tempalloggio = null;


    vm.years = [
      {id: ""},
      {id: (new Date()).getFullYear()},
      {id: (new Date()).getFullYear() - 1},
      {id: (new Date()).getFullYear() - 2},
      {id: (new Date()).getFullYear() - 3},
      {id: (new Date()).getFullYear() - 4},
      {id: (new Date()).getFullYear() - 5},
      {id: (new Date()).getFullYear() - 6},
      {id: (new Date()).getFullYear() - 7},
      {id: (new Date()).getFullYear() - 8},
      {id: (new Date()).getFullYear() - 9},
      {id: (new Date()).getFullYear() - 10},
      {id: (new Date()).getFullYear() - 11},
      {id: (new Date()).getFullYear() - 12},
      {id: (new Date()).getFullYear() - 13},
      {id: (new Date()).getFullYear() - 14},
      {id: (new Date()).getFullYear() - 15},
      {id: (new Date()).getFullYear() - 16},
      {id: (new Date()).getFullYear() - 17},
      {id: (new Date()).getFullYear() - 18},
      {id: (new Date()).getFullYear() - 19},
      {id: (new Date()).getFullYear() - 20}
    ];
    vm.sersearchYear = new Date().getFullYear();
    vm.corsearchYear = new Date().getFullYear();

    vm.openCorsiBenDialog = openCorsiBenDialog;
    function openCorsiBenDialog(ev, item, index, newlink) {
      var oggi = new Date();
      var today = moment(oggi).format('YYYY-MM-DD');
      api.progettos.hascorsi.search({pagination: -1, progetto_id: item.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
        vm.tempcorsi = response;
        $mdDialog.show({
          controller: 'DialogCorsiBenController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/form/dialogCorsiBenForm.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            All: vm.tempcorsi,
            Ben: item,
            index: index,
            newlink: newlink
          }
        });
      });
    }

    vm.openServiziBenDialog = openServiziBenDialog;
    function openServiziBenDialog(ev, item, index, newlink) {
      var oggi = new Date();
      var today = moment(oggi).format('YYYY-MM-DD');
      api.progettos.hasservizi.search({pagination: -1, progetto_id: item.progetto_id, dataInizio: "<" + today, dataFine: ">" + today}, function (response) {
        vm.tempservizi = response;
        //console.log("response", response);
        $mdDialog.show({
          controller: 'DialogServiziBenController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/form/dialogServiziBenForm.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            All: vm.tempservizi,
            Ben: item,
            index: index,
            newlink: newlink
          }
        });
      });
    }




    //scheda statica commissione status
    vm.commissiones = [
      {id: "ANCONA", competenza: "Marche, Abruzzo"},
      {id: "BARI", competenza: "Bari, Matera"},
      {id: "BOLOGNA", competenza: "Emilia Romagna"},
      {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
      {id: "CAGLIARI", competenza: "Sardegna"},
      {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
      {id: "CATANIA", competenza: "Catania, Enna"},
      {id: "CROTONE", competenza: "Calabria"},
      {id: "FIRENZE", competenza: "Toscana, Umbria"},
      {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
      {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
      {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
      {id: "MILANO", competenza: "Lombardia"},
      {id: "PALERMO", competenza: "Palermo, Messina"},
      {id: "ROMA", competenza: "Lazio"},
      {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
      {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
      {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
      {id: "TRAPANI", competenza: "Trapani, Agrigento"},
      {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
    ];
    vm.loadprefettura = loadprefettura;
    function loadprefettura() {
      api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
        vm.prefetturas = response.data;
      });
    }
    vm.loadprefettura();
    vm.loadquestura = loadquestura;
    function loadquestura() {
      api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
        vm.questuras = response.data;
      });
    }
    vm.loadquestura();
    vm.motivods = motivods;
    function motivods() {
      api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "descrizione"}, function (r) {
        vm.motivods = r.data;
      });
    }
    vm.motivods();
  }


    function DialogAttributiController($scope, $state, $mdDialog, Beneficiario, api, index, newlink) {
        var vmd = this;
        vmd.api = api;
        vmd.beneficiario_id = Beneficiario.id;
        vmd.beneficiario_nome = Beneficiario.cognome + " " + Beneficiario.nome;
        vmd.newlink = newlink;
        vmd.isnew = newlink;
        vmd.index = index;
        vmd.beneficiarioAttributis = Beneficiario.beneficiarioAttributis;
        vmd.attributis = null;
        vmd.save = save;
        vmd.delete = del;
        vmd.caricaAttributi = caricaAttributi;
//        vmd.attributiLabel = [
//            {gruppo: 'COMPETENZE', etichetta: 'Competenze professionali'},
//            {gruppo: 'CORSO', etichetta: 'Interessi Corsi'},
//            {gruppo: 'DOCUMENTO', etichetta: 'Tipo Documento Ingresso'},
//            {gruppo: 'INGRESSO', etichetta: 'Tipo di Ingresso'},
//            {gruppo: 'LINGUA', etichetta: 'Lingua'},
//            {gruppo: 'LINGUA-CONOSCENZA', etichetta: 'Conoscenza lingue'},
//            {gruppo: 'MOTIVO-USCITA', etichetta: 'Motivo di Uscita'},
//            {gruppo: 'NAZIONE', etichetta: 'Nazione'},
//            {gruppo: 'PARENTELA', etichetta: 'Gradi di parentela'},
//            {gruppo: 'PROFESSIONE', etichetta: 'Professione svolte'},
//            {gruppo: 'RELIGIONE', etichetta: 'Religione'},
//            {gruppo: 'SERVIZIO', etichetta: 'Interesse a servizio'},
//            {gruppo: 'STATO', etichetta: 'Stato'},
//            {gruppo: 'STUDI', etichetta: 'Studi Effettuati'},
//            {gruppo: 'STUDI-AREA', etichetta: 'Area studi di interesse'},
//            {gruppo: 'VULNERABILITA', etichetta: 'Vulnerabilità'}
//        ];
        vmd.attributiLabel = [
            {gruppo: 'COMPETENZE', etichetta: 'Competenze professionali'},
            {gruppo: 'CORSO', etichetta: 'Interessi Corsi'},
            {gruppo: 'INGRESSO', etichetta: 'Tipo di Ingresso'},
            {gruppo: 'LINGUA', etichetta: 'Lingua'},
            {gruppo: 'LINGUA-CONOSCENZA', etichetta: 'Conoscenza lingue'},
            {gruppo: 'PROFESSIONE', etichetta: 'Professione svolte'},
            {gruppo: 'SERVIZIO', etichetta: 'Interesse a servizio'},
            {gruppo: 'STUDI', etichetta: 'Studi Effettuati'},
            {gruppo: 'STUDI-AREA', etichetta: 'Area studi di interesse'},
            {gruppo: 'VULNERABILITA', etichetta: 'Tipo di Vulnerabilità'},
            //{gruppo: 'FACCIA', etichetta: 'La tua faccia è'}
        ];
        vmd.gruppo = "";
        vmd.payload = {
            beneficiario_id: vmd.beneficiario_id
        };
        if (vmd.index !== null) {
            vmd.payload = angular.copy(vmd.beneficiarioAttributis[vmd.index]);
            vmd.caricaAttributi(vmd.payload.gruppo);
            console.log(vmd.payload);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function caricaAttributi(gruppo) {
            api.beneficiarios.attributi.cerca({gruppo: gruppo, pagination: "400"}, function (response) {
                vmd.attributis = response.data;
            });
        }



        function save() {
            var newpayload = [];
            angular.forEach(vmd.beneficiarioAttributis, function (obj) {
                var pushpayload = {
                    beneficiarioAttributi_id: obj.id,
                    beneficiario_id: vmd.beneficiario_id
                };
                newpayload.push(pushpayload);
            });
            var pushpayload = {
                beneficiario_id: vmd.payload.beneficiario_id,
                beneficiarioAttributi_id: vmd.payload.id
            };
            newpayload.push(pushpayload);
            console.log(newpayload);
            if (!vmd.isnew) {
                var hasmany = {modelrelation: 'Beneficiariohasbeneficiarioattributi',
                    idname: 'beneficiario_id', idvalue: vmd.beneficiario_id,
                    idnamefk: 'beneficiarioAttributi_id', idnamePayload: 'beneficiarioAttributi_id',
                    payload: newpayload};
                api.beneficiarios.beneficiario.hasmany(hasmany, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }
            if (vmd.isnew) {
                var hasmany = {modelrelation: 'Beneficiariohasbeneficiarioattributi',
                    idname: 'beneficiario_id', idvalue: vmd.beneficiario_id,
                    idnamefk: 'beneficiarioAttributi_id', idnamePayload: 'beneficiarioAttributi_id',
                    payload: newpayload};
                api.beneficiarios.beneficiario.hasmany(hasmany, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo collegamento?')
                    .htmlContent('<b>' + vmd.payload.descrizione + '</b>' + ' sarà cancellato.')
                    .ariaLabel('cancella attributi')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Non puoi rimuovere ultimo elemento.')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');
            $mdDialog.show(confirm).then(function ()
            {

                vmd.beneficiarioAttributis.splice(vmd.index, 1);
                var payload = [];
                angular.forEach(vmd.beneficiarioAttributis, function (obj) {
                    var pushpayload = {
                        beneficiario_id: vmd.beneficiario_id,
                        beneficiarioAttributi_id: obj.id
                    };
                    payload.push(pushpayload);
                });
                //vmd.entes.splice(vmd.index, 1);

                if (payload.length === 0) {
                    $mdDialog.show(alert);
                }
                //console.log(payload);
                var hasmany = {modelrelation: 'Beneficiariohasbeneficiarioattributi',
                    idname: 'beneficiario_id', idvalue: vmd.beneficiario_id,
                    idnamefk: 'beneficiarioAttributi_id', idnamePayload: 'beneficiarioAttributi_id',
                    payload: payload};
                api.beneficiarios.beneficiario.hasmany(hasmany, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            }, function () {
            });
        }




    }

    function InserimentoBeneficiarioController($state, $document, $filter, api, msUtils, $mdDialog, $cookies) {

        var vm = this;
        vm.beneficiari = null;
        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };
        vm.beneficiario = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneNascita: null,
            idNazioneProvenienza: null,
            idNazioneCittadinanza: null,
            gruppoEtnico: null,
            idReligione: null,
            email: null,
            telefono: null,
            dataNascita: '2013-08-08',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            note: null,
            noteSanitarie: null,
            beneficiarioAttributis: [],
            strutturas: [],
            progettos: [],
            bandos: [],
            beneficiarioextras: [],
            idTipoIngresso: '28',
            idTipoDocumento: '581',
            dataIngresso: null,
            dataIngresso2: null,
            dataInserimento: null,
            dataInserimento2: null,
            tipoIngresso: 'SC',
            nucleoFamiliare: '0',
            stato: 'LIBERO',
            searched: null
        };
        vm.nevento = {
            dataInserimento: new Date(),
            dataInizio: new Date(),
            dataFine: new Date(),
            dataAlert: new Date(),
            eventoTipo_id: null,
            eventoStato_id: 1,
            entita1_id: null,
            entita2_id: null,
            alert: 1,
            da: null,
            extra: null
        };
        vm.beneficiario.dataNascita2 = new Date(vm.beneficiario.dataNascita);
        vm.attributiLabel = {
            'COMPETENZE': 'Competenze professionali',
            'CORSO': 'Interessi Corsi',
            'DOCUMENTO': 'Tipo Documento Ingresso',
            'INGRESSO': 'Tipo di Ingresso',
            'LINGUA': 'Lingua',
            'LINGUA-CONOSCENZA': 'Conoscenza lingue',
            'MOTIVO-USCITA': 'Motivo di Uscita',
            'NAZIONE': 'Nazione',
            'PARENTELA': 'Gradi di parentela',
            'PROFESSIONE': 'Professione svolte',
            'RELIGIONE': 'Religione',
            'SERVIZIO': 'Interesse a servizio',
            'STATO': 'Stato',
            'STUDI': 'Studi Effettuati',
            'STUDI-AREA': 'Area studi di interesse',
            'VULNERABILITA': 'Tipo di Vulnerabilità',
        };
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoDocumento = null;
        vm.tipoIngresso = null;
        vm.stato = null;
        vm.enteruolo = null;
        vm.entegestore = null;
        vm.regiones = null;
        vm.bandos = null;
        vm.progettos = null;
        vm.strutturas = null;
        vm.eventotipos = null;
        vm.questuras = null;
        vm.existingBeneficiario = {
            id: null
        };
        vm.isnew = false;
        vm.closetable = false;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "200"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "200"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO"}, function (response) {
            vm.tipoDocumento = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "INGRESSO", pagination: "50"}, function (response) {
            vm.tipoIngresso = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "STATO", pagination: "50"}, function (response) {
            vm.stato = response.data;
        });
        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
        });
        api.bando.index({sort: "descrizione,-dataFine", 'per-page': 50, filter: {attivo: 1}}, function (response) {
            vm.bandos = response.data;
        });
        api.eventos.tipo.cerca({sort: "id", model: "app\\models\\Statusg", pagination: 50}, function (response) {
            vm.eventotipos = response.data;
        });
        api.entes.ente.search({enteTipo_id: 7, pagination: 400, sort: 'nome'}, function (d) {
            vm.questuras = d.data;
        });
        vm.ricercaProgetti = {
            'bandos-id': null,
            codRegione: null,
            attivo: 1,
            pagination: 500
        }
        vm.progettoSelezionato = "";
        vm.strutturaSelezionata = "";
        vm.tempStrutturaextras = [];
        vm.ricerca = {
        };
        vm.ricerca2 = "";
        vm.search2 = {};
        vm.selectedBeneficiarios = [];
        vm.ricercalabel = {
            nome: 'Nome: ',
            cognome: 'Cognome: ',
            sesso: 'Sesso: ',
            idNazioneProvenienza: 'Provenienza: ',
            dataNascita: 'Data di nascita: ',
            dataIngresso: 'Data di Ingresso: ',
            stato: 'Stato: ',
            stringa: 'Chiave di ricerca:'
        };
        vm.searched = false;
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length">><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            language: {
                "sEmptyTable": "Nessun dato presente nella tabella",
                "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
                "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
                "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
                "sInfoPostFix": "",
                "sInfoThousands": ".",
                "sLengthMenu": "Visualizza _MENU_ elementi",
                "sLoadingRecords": "Caricamento...",
                "sProcessing": "Elaborazione...",
                "sSearch": "Cerca:",
                "sZeroRecords": "La ricerca non ha portato alcun risultato.",
                "oPaginate": {
                    "sFirst": "Inizio",
                    "sPrevious": "Precedente",
                    "sNext": "Successivo",
                    "sLast": "Fine"
                },
                "oAria": {
                    "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
                    "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
                }
            }
        };
        vm.isSearched = isSearched;
        vm.searchExisting = searchExisting;
        vm.selectExisting = selectExisting;
        vm.selectNew = selectNew;
        vm.searchProgettos = searchProgettos;
        vm.searchStrutturas = searchStrutturas;
        vm.selStrututra = selStrututra;
        vm.submitVerticalStepper = submitVerticalStepper;
        vm.extraoptions = extraoptions;
        function extraoptions() {
            angular.forEach(vm.eventotipos, function (obj) {
                if (obj.id == vm.nevento.eventoTipo_id) {
                    vm.nevento.extra = JSON.parse(obj.extra);
                }
            });
        }

        function selStrututra() {
            vm.beneficiario.strutturas = [];
            vm.beneficiario.strutturas.push({id: vm.strutturaSelezionata});
        }
        function isSearched() {
            vm.beneficiario.searched = true;
        }

        function selectNew() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler creare beneficiario?')
                    .htmlContent('<b>' + vm.beneficiario.cognome + ' ' + vm.beneficiario.nome + '</b>' + ' verrà duplicato.<br>Capisco cosa sto facendo e dichiaro di voler procedere.')
                    .ariaLabel('seleziona esistente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function ()
            {
                vm.isnew = true;
                vm.beneficiario.searched = true;
                vm.closetable = true;
            }, function () {
            });
        }

        function searchStrutturas() {
            api.strutturas.strutturamin.cerca({'progetto_id': vm.progettoSelezionato, pagination: 600, attivo: 1}, function (response) {
                vm.strutturas = response.data;
            });
        }
        function searchProgettos() {
            angular.forEach(vm.ricercaProgetti, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricercaProgetti[key];
                }
            });
            api.progettos.progetto.cerca(vm.ricercaProgetti, function (response) {
                vm.progettos = response.data;
                vm.progettos.tot = 0;
                vm.progettos.benefAttivi = 0;
                vm.progettos.benefTotali = 0;
                vm.progettos.benefT = [];
                angular.forEach(vm.progettos.strutturas, function (subobj) {
                    vm.progettos.tot = vm.progettos.tot + subobj.numeroPosti;
                    angular.forEach(subobj.strutturahasbeneficiarios, function (subsubobj) {
                        vm.progettos.benefT.push(subsubobj.beneficiario_id);
                        vm.progettos.benefTotali++;
                    });
                });
                var insearch = vm.progettos.benefT.join();
                api.beneficiarios.beneficiario.search({id_IN: insearch, stato: 'BENEFICIARIO', operatore: 'AND'}, function (d) {
                    vm.progettos.benefAttivi = d.data.length;
                    vm.progettos.postiTotali = vm.progettos.tot;
                    vm.progettos.postiLiberi = vm.progettos.tot - vm.progettos.benefAttivi;
                });
            });
        }

        function selectExisting(id, id2) {
            console.log(id);
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler utilizzare questo beneficiario?')
                    .htmlContent('<b>' + vm.beneficiario.cognome + ' ' + vm.beneficiario.nome + '</b>' + ' sarà utilizzato per delle nuove operazioni.<br>Capisco cosa sto facendo e dichiaro di voler procedere.')
                    .ariaLabel('seleziona esistente')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function ()
            {
                vm.existingBeneficiario.id = id;
                vm.existingBeneficiario.idStruttura = id2;
                var beneficiario = $filter('filter')(vm.beneficiari, {id: id});
                console.log(beneficiario);
//                angular.forEach(vm.beneficiari, function (benef) {
//                    if (benef.id == id) {
//                        beneficiario = benef;
//                    }
//                });



                vm.beneficiario.id = beneficiario[0].id;
                vm.beneficiario.idNazioneNascita = beneficiario[0].idNazioneNascita;
                vm.beneficiario.idNazioneCittadinanza = beneficiario[0].idNazioneCittadinanza;
                vm.beneficiario.gruppoEtnico = beneficiario[0].gruppoEtnico;
                vm.beneficiario.idReligione = beneficiario[0].idReligione;
                vm.beneficiario.email = beneficiario[0].email;
                vm.beneficiario.telefono = beneficiario[0].telefono;
                vm.beneficiario.codiceFiscale = beneficiario[0].codiceFiscale;
                vm.beneficiario.note = beneficiario[0].note;
                vm.beneficiario.noteSanitarie = beneficiario[0].noteSanitarie;
                vm.beneficiario.idTipoIngresso = beneficiario[0].idTipoIngresso;
                vm.beneficiario.idTipoDocumento = beneficiario[0].idTipoDocumento;
                vm.beneficiario.dataIngresso = beneficiario[0].dataIngresso;
                //                vm.beneficiario.dataIngresso2 = new Date(beneficiario.dataIngresso);
                vm.beneficiario.dataInserimento = beneficiario[0].dataInserimento;
                //                vm.beneficiario.dataInserimento2 = new Date(beneficiario.dataInserimento);
                vm.beneficiario.nucleoFamiliare = beneficiario[0].nucleoFamiliare;
                vm.beneficiario.stato = 'LIBERO';
                vm.beneficiario.strutturahasbeneficiarios = beneficiario[0].strutturahasbeneficiarios;
                vm.beneficiario.searched = true;
                console.log(vm.beneficiario);
                vm.closetable = true;
                vm.isnew = false;
            }, function () {
            });
        }

        function searchExisting() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            var m = moment(vm.beneficiario.dataNascita2);
            vm.beneficiario.dataNascita = m.format("YYYY-MM-DD");
            vm.ricerca.nome = vm.beneficiario.nome;
            vm.ricerca.cognome = vm.beneficiario.cognome;
            vm.ricerca.sesso = vm.beneficiario.sesso;
            vm.ricerca.dataNascita = vm.beneficiario.dataNascita;
            vm.ricerca.codNazionalita = vm.beneficiario.codNazionalita;
            vm.ricerca.pagination = 200;
            api.beneficiarios.minimal.like(vm.ricerca, function (d) {
                vm.beneficiari = d.data;
                if (vm.beneficiari.length === 0) {
                    vm.beneficiario.searched = true;
                    vm.isnew = true;
                } else {
                    vm.beneficiario.searched = null;
                }
            });
            vm.searched = true;
            vm.closetable = false;
            vm.existingBeneficiario.id = null;
        }

        function submitVerticalStepper() {
            var confirm = $mdDialog.confirm()
                    .title('Confermi l\'operazione?.')
                    .htmlContent('Puoi aggiungere dettagli alla scheda beneficiario in qualsiasi momento.<br>Se <b>premi Ok</b> sarai rediretto alla <b>scheda beneficiario</b> per effettuare delle integrazioni.')
                    .ariaLabel('messaggio')
                    .ok('OK')
                    .cancel('ABBANDONA');
            /*
             * vm.nevento = {
             dataInserimento: new Date(),
             dataInizio: new Date(),
             dataFine: new Date(),
             dataAlert: new Date(),
             eventoTipo_id: null,
             eventoStato_id: 1,
             entita1_id: null,
             entita2_id: null,
             alert: 1,
             da: null,
             extra: null
             };
             */
            delete(vm.nevento.dataAlert);
            vm.user = $cookies.getObject('user');
            vm.nevento.da = vm.user.email;
            var temp = JSON.stringify(vm.nevento.extra);
            vm.nevento.extra = temp;
            var m = moment(vm.nevento.dataInserimento);
            vm.nevento.dataInserimento = m.format("YYYY-MM-DD");
            m = moment(vm.nevento.dataInizio);
            vm.nevento.dataInizio = m.format("YYYY-MM-DD");
            m = moment(vm.nevento.dataFine);
            vm.nevento.dataFine = m.format("YYYY-MM-DD");
            if (!vm.isnew) {
                $mdDialog.show(confirm).then(function ()
                {

                    api.beneficiarios.beneficiario.aggiorna(vm.beneficiario, function (response) {
                        console.log(response);
                        var payload = vm.beneficiario.strutturahasbeneficiarios;
                        payload.push({struttura_id: vm.strutturaSelezionata, beneficiario_id: vm.beneficiario.id});
                        var hasmany = {
                            modelrelation: 'Strutturahasbeneficiario',
                            idname: 'struttura_id',
                            idvalue: vm.strutturaSelezionata,
                            idnamefk: 'beneficiario_id',
                            idnamePayload: 'beneficiario_id',
                            delete: false,
                            payload: payload
                        };
                        api.beneficiarios.beneficiario.hasmany(hasmany, function (response) {
                            console.log(hasmany);
                            vm.nevento.entita1_id = vm.beneficiario.id;
                            api.eventos.evento.save(vm.nevento, function (response) {
                                console.log(response);
                                var dataoggi = new Date();
                                var m = moment(dataoggi);
                                var dataoggistring = m.format("YYYY-MM-DD");
                                vm.nevento.dataInizio = dataoggistring;
                                vm.nevento.eventoTipo_id = 3;
                                vm.nevento.eventoStato_id = 1;
                                vm.nevento.entita1_id = vm.beneficiario.id;
                                vm.nevento.entita2_id = vm.strutturaSelezionata;
                                vm.nevento.alert = 1;
                                api.eventos.evento.save(vm.nevento, function (response) {
                                    console.log(response);
                                    $state.go('app.sprardb_beneficiario', {id: vm.beneficiario.id});
                                });
                            });
                        });
                    });
                }, function () {
                    console.log(vm.beneficiario);
                });
            }
            if (vm.isnew) {
                $mdDialog.show(confirm).then(function ()
                {
                    var m = moment(vm.beneficiario.dataNascita2);
                    vm.beneficiario.dataNascita = m.format("YYYY-MM-DD");
                    m = moment(vm.beneficiario.dataIngresso2);
                    vm.beneficiario.dataIngresso = m.format("YYYY-MM-DD");
                    m = moment(vm.beneficiario.dataInserimento2);
                    vm.beneficiario.dataInserimento = m.format("YYYY-MM-DD");
                    console.log(vm.beneficiario)
                    api.beneficiarios.beneficiario.save(vm.beneficiario, function (response) {
                        console.log(response);
                        var beneficiario_id = response.id;
                        var payload = [];
                        payload.push({struttura_id: vm.strutturaSelezionata, beneficiario_id: beneficiario_id});
                        var hasmany = {
                            modelrelation: 'Strutturahasbeneficiario',
                            idname: 'struttura_id',
                            idvalue: vm.strutturaSelezionata,
                            idnamefk: 'beneficiario_id',
                            idnamePayload: 'beneficiario_id',
                            delete: false,
                            payload: payload
                        };
                        api.beneficiarios.beneficiario.hasmany(hasmany, function (response) {
                            console.log(response);
                            vm.nevento.entita1_id = beneficiario_id;
                            api.eventos.evento.save(vm.nevento, function (response) {
                                console.log(response);
                                var dataoggi = new Date();
                                var m = moment(dataoggi);
                                var dataoggistring = m.format("YYYY-MM-DD");
                                vm.nevento.dataInizio = dataoggistring;
                                vm.nevento.eventoTipo_id = 2;
                                vm.nevento.eventoStato_id = 1;
                                vm.nevento.entita1_id = beneficiario_id;
                                vm.nevento.entita2_id = vm.strutturaSelezionata;
                                vm.nevento.alert = 1;
                                api.eventos.evento.save(vm.nevento, function (response) {
                                    console.log(response);
                                    $state.go('app.sprardb_beneficiario', {id: beneficiario_id});
                                });
                            });
                        });
                    });
                }, function () {
                });
            }

        }
    }

    function DialogServiziBenController($scope, $state, $mdDialog, Ben, api, All, index, newlink, $mdToast, ricerca, $filter)
    {



        var vmd = this;
        vmd.isAdmin = api.isAdmin;
        vmd.api = api;
        vmd.beneficiario_id = Ben.id;
        vmd.progetto_id = Ben.progetto_id;
        vmd.index = index;
        vmd.beneficiario_nome = Ben.cognome + " " + Ben.nome;
        vmd.servizio_id = null;
        vmd.nomecategoria = null;
        vmd.dataInizio = new Date();
        vmd.dataFine = new Date();
        vmd.allcategoria = ricerca.servizicategoria;
        vmd.servizios = angular.copy(Ben.servizios);
        vmd.allservizi = [];
        angular.forEach(All.data, function (d) {
            var temp = {};
            var tempcat = {};
            temp = angular.copy(d.servizi);
            tempcat = angular.copy(d.cat);
            if (temp !== null) {
                temp.progetto_id = vmd.progetto_id;
                temp.phs_id = d.id;
                temp.beneficiario_id = vmd.beneficiario_id;
                temp.da = new Date(d.dataInizio);
                temp.a = new Date(d.dataFine);
                temp.cat = tempcat.descrizione;
                vmd.allservizi.push(temp);
            }
        });
        console.log("vmd.allservizi: ", vmd.allservizi);
        console.log("All.data: ", All.data);
        /*
         var controllerServ = [];
         vmd.noService = false;
         var j = 0;

         for (var i = 0; i < vmd.allservizi.length; i++) {
         if (vmd.allservizi[i].servizi_id) {
         controllerServ[j] = vmd.allservizi[i].servizi_id;
         j++;
         }
         }
         */

        vmd.controllerCors = [];
        vmd.noService = false;
        var j = 0;
        for (var i = 0; i < vmd.allservizi.length; i++) {
            if (vmd.allservizi[i].servizi_id) {
                vmd.controllerCors[j] = vmd.allservizi[i].servizi_id;
                j++;
            }
        }

        vmd.mySelezionato = {};
        vmd.isnew = false;
        if (vmd.index === null) {
            vmd.isnew = true;
        }

        if (vmd.index !== null) {
            vmd.id = vmd.servizios[index].id;
            vmd.servizio_id = vmd.servizios[index].servizi_id;
            vmd.phs_id = vmd.servizios[index].phs_id;
            vmd.dataInizio = new Date(vmd.servizios[index].dataInizio);
            vmd.dataFine = new Date(vmd.servizios[index].dataFine);
            vmd.mySelezionato.dataInizio = vmd.dataInizio;
            vmd.mySelezionato.dataFine = vmd.dataFine;

            vmd.allservizi = null;
            vmd.allservizi = [];
            api.progettos.hasservizi.get({id: vmd.phs_id}, function (d) {
                var temp = {};
                temp = angular.copy(d.servizi);
                var iid = d.servizi.servizi_id;
                api.servizi.get({id: iid}, function (e) {
                    vmd.nomecategoria = e.descrizione;
                });
                if (temp !== null) {
                    temp.progetto_id = vmd.progetto_id;
                    temp.phs_id = d.id;
                    temp.beneficiario_id = vmd.beneficiario_id;
                    temp.da = new Date(d.dataInizio);
                    temp.a = new Date(d.dataFine);
                    vmd.allservizi.push(temp);
                }

                vmd.controllerCors = null;
                vmd.controllerCors = [];
                vmd.noService = false;
                var j = 0;
                for (var i = 0; i < vmd.allservizi.length; i++) {
                    if (vmd.allservizi[i].corsi_id) {
                        vmd.controllerCors[j] = vmd.allservizi[i].servizi_id;
                        j++;
                    }
                }
                selezioneItem(vmd.servizio_id);
            });

        }

        vmd.selezionato = {
            id: null,
            index: null
        };
        vmd.save = save;
        vmd.delete = del;
        vmd.aggiornaServizio = aggiorna;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function save() {

            if (vmd.noService) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Impossibile salvare il servizio.')
                        .hideDelay(2000)
                        );
                return;
            }

            $mdDialog.hide();
            var m = moment(vmd.mySelezionato.dataInizio);
            var dataInizio = m.format("YYYY-MM-DD");
            m = moment(vmd.mySelezionato.dataFine);
            var dataFine = m.format("YYYY-MM-DD");
            var pushpayload = {
                beneficiario_id: vmd.mySelezionato.beneficiario_id,
                servizi_id: vmd.mySelezionato.id,
                progetto_id: vmd.mySelezionato.progetto_id,
                phs_id: vmd.mySelezionato.phs_id,
                dataInizio: dataInizio,
                dataFine: dataFine
            };
            api.beneficiarios.hasservizi.save(pushpayload, function (u) {
                if (angular.isDefined(u.id)) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('servizio inserito correttamente.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Errore durante il salvataggio.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });
        }
        function aggiorna() {
            $mdDialog.hide();
            var m = moment(vmd.mySelezionato.dataInizio);
            var dataInizio = m.format("YYYY-MM-DD");
            m = moment(vmd.mySelezionato.dataFine);
            var dataFine = m.format("YYYY-MM-DD");
            var pushpayload = {
                id: vmd.id,
                dataInizio: dataInizio,
                dataFine: dataFine
            };
            api.beneficiarios.hasservizi.aggiorna(pushpayload, function (u) {
                if (angular.isDefined(u.id)) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('servizio correttamente modificato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Errore durante il salvataggio.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo servizio?')
                    .htmlContent('<b>Cliccando su OK </b>' + 'il servizio sarà cancellato.')
                    .ariaLabel('cancella servizio')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function () {
                api.beneficiarios.hasservizi.remove({id: vmd.id}, function (u) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('servizio correttamente eliminato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                });
            });
        }

        vmd.selezioneItem = selezioneItem;
        function selezioneItem(id) {
            console.log("vmd.mySelezionato", vmd.mySelezionato);
            var from = angular.copy(vmd.mySelezionato.dataInizio);
            var to = angular.copy(vmd.mySelezionato.dataFine);
            var ii = 0;
            for (ii = 0; ii < vmd.allservizi.length; ii++) {
                if (vmd.allservizi[ii].id == id) {
                    vmd.mySelezionato = angular.copy(vmd.allservizi[ii]);
                }
            }
            vmd.mySelezionato.dataInizio = from;
            vmd.mySelezionato.dataFine = to;
        }

        vmd.selezioneCat = selezioneCat;

        function selezioneCat(index) {
            console.log("selezioneCat(index)", index);
//            vmd.noService = true;
//            for (var i = 0; i < controllerServ.length; i++) {
//                if (controllerServ[i] == index) {
//                    vmd.noService = false;
//                }
//            }

            vmd.noService = true;
            for (var i = 0; i < vmd.controllerCors.length; i++) {
                if (vmd.controllerCors[i] == index) {
                    vmd.noService = false;
                }
            }
            console.log("vmd.controllerCors:", vmd.controllerCors);

        }
        vmd.cambiaData = cambiaData;
        function cambiaData() {
            var from = moment(vmd.mySelezionato.dataInizio).format("YYYY-MM-DD");
            var to = moment(vmd.mySelezionato.dataFine).format("YYYY-MM-DD");
            var totale = 1;
            if (vmd.isnew) {
                vmd.allservizi = null;
                vmd.allservizi = [];
                api.progettos.hasservizi.search({pagination: -1, progetto_id: vmd.progetto_id, dataInizio: "<" + from, dataFine: ">" + to, sort: 'servizi_id'}, function (r) {
                    angular.forEach(r.data, function (d) {
                        var temp = {};
                        var tempcat = {};
                        temp = angular.copy(d.servizi);
                        tempcat = angular.copy(d.cat);
                        if (temp !== null) {
                            temp.progetto_id = vmd.progetto_id;
                            temp.phs_id = d.id;
                            temp.beneficiario_id = vmd.beneficiario_id;
                            temp.da = new Date(d.dataInizio);
                            temp.a = new Date(d.dataFine);
                            temp.cat = tempcat.descrizione;
                            vmd.allservizi.push(temp);
                        }
                        if (totale == r.data.length) {
                            vmd.controllerCors = null;
                            vmd.controllerCors = [];
                            vmd.noService = false;
                            var j = 0;
                            for (var i = 0; i < vmd.allservizi.length; i++) {
                                if (vmd.allservizi[i].servizi_id) {
                                    vmd.controllerCors[j] = vmd.allservizi[i].servizi_id;
                                    j++;
                                }
                            }
                            var test = $filter('orderBy')(vmd.allservizi, 'descrizione');
                            vmd.allservizi = angular.copy(test);
                            console.log("test:", test);
                            console.log("vmd.controllerCors:", vmd.controllerCors);
                            console.log("vmd.allservizi", vmd.allservizi);
                        }
                        totale++;
                    });
                });
            } else {
                vmd.selezioneItem(vmd.servizio_id);
            }

        }





    }

    function DialogCorsiBenController($scope, $state, $mdDialog, Ben, api, All, index, newlink, $mdToast, ricerca, $filter)
    {

        console.log("controller DialogCorsiBenController");
        var vmd = this;
        vmd.isAdmin = api.isAdmin;
        vmd.api = api;
        vmd.beneficiario_id = Ben.id;
        vmd.progetto_id = Ben.progetto_id;
        vmd.idselez = index;
        vmd.index = index;
        vmd.beneficiario_nome = Ben.cognome + " " + Ben.nome;
        vmd.corso_id = null;
        vmd.nomecategoria = null;
        vmd.dataInizio = new Date();
        vmd.dataFine = new Date();
        vmd.corsos = angular.copy(Ben.corsos);
        vmd.allcategoria = ricerca.corsicategoria;
        vmd.allcorsi = [];
        angular.forEach(All.data, function (d) {

            var temp = {};
            var tempcat = {};
            temp = angular.copy(d.corsi);
            tempcat = angular.copy(d.cat);
            if (temp !== null) {
                temp.progetto_id = vmd.progetto_id;
                temp.phc_id = d.id;
                temp.beneficiario_id = vmd.beneficiario_id;
                temp.da = new Date(d.dataInizio);
                temp.a = new Date(d.dataFine);
                temp.cat = tempcat.descrizione;
                vmd.allcorsi.push(temp);
            }

        });
        console.log("vmd.allcorsi", vmd.allcorsi);
        vmd.controllerCors = [];
        vmd.noService = false;
        var j = 0;
        for (var i = 0; i < vmd.allcorsi.length; i++) {
            if (vmd.allcorsi[i].corsi_id) {
                vmd.controllerCors[j] = vmd.allcorsi[i].corsi_id;
                j++;
            }

        }




        vmd.mySelezionato = {};
        vmd.isnew = false;
        if (vmd.index === null) {
            vmd.isnew = true;
        }

        if (vmd.index !== null) {
            vmd.id = vmd.corsos[index].id;
            vmd.corso_id = vmd.corsos[index].corsi_id;
            vmd.phc_id = vmd.corsos[index].phc_id;
            vmd.dataInizio = new Date(vmd.corsos[index].dataInizio);
            vmd.dataFine = new Date(vmd.corsos[index].dataFine);
            vmd.mySelezionato.dataInizio = vmd.dataInizio;
            vmd.mySelezionato.dataFine = vmd.dataFine;

            var totale = 1;
            vmd.allcorsi = null;
            vmd.allcorsi = [];
            api.progettos.hascorsi.get({id: vmd.phc_id}, function (d) {
                var temp = {};
                temp = angular.copy(d.corsi);
                var iid = d.corsi.corsi_id;
                api.corsi.get({id: iid}, function (e) {
                    vmd.nomecategoria = e.descrizione;
                });
                if (temp !== null) {
                    temp.progetto_id = vmd.progetto_id;
                    temp.phc_id = d.id;
                    temp.beneficiario_id = vmd.beneficiario_id;
                    temp.da = new Date(d.dataInizio);
                    temp.a = new Date(d.dataFine);
                    vmd.allcorsi.push(temp);
                }
                vmd.controllerCors = null;
                vmd.controllerCors = [];
                vmd.noService = false;
                var j = 0;
                for (var i = 0; i < vmd.allcorsi.length; i++) {
                    if (vmd.allcorsi[i].corsi_id) {
                        vmd.controllerCors[j] = vmd.allcorsi[i].corsi_id;
                        j++;
                    }
                }
                selezioneItem(vmd.corso_id);
            });
        }

        vmd.selezionato = {
            id: null,
            index: null
        };
        vmd.save = save;
        vmd.delete = del;
        vmd.aggiornaCorso = aggiorna;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function save() {

            if (vmd.noService) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Impossibile salvare il corso.')
                        .hideDelay(2000)
                        );
                return;
            }

            $mdDialog.hide();
            var m = moment(vmd.mySelezionato.dataInizio);
            var dataInizio = m.format("YYYY-MM-DD");
            m = moment(vmd.mySelezionato.dataFine);
            var dataFine = m.format("YYYY-MM-DD");
            var pushpayload = {
                beneficiario_id: vmd.mySelezionato.beneficiario_id,
                corsi_id: vmd.mySelezionato.id,
                progetto_id: vmd.mySelezionato.progetto_id,
                phc_id: vmd.mySelezionato.phc_id,
                dataInizio: dataInizio,
                dataFine: dataFine
            };
            api.beneficiarios.hascorsi.save(pushpayload, function (u) {
                if (angular.isDefined(u.id)) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Corso inserito correttamente.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Errore durante il salvataggio.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });
        }
        function aggiorna() {
            var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Attenzione')
                    .textContent('Esite già lo stesso corso definito in quel periodo')
                    .ariaLabel('Attenzione ultimo')
                    .ok('OK');

            $mdDialog.hide();
            var m = moment(vmd.mySelezionato.dataInizio);
            var dataInizio = m.format("YYYY-MM-DD");
            m = moment(vmd.mySelezionato.dataFine);
            var dataFine = m.format("YYYY-MM-DD");

            var pushpayload = {
                id: vmd.id,
                dataInizio: dataInizio,
                dataFine: dataFine
            };
            api.beneficiarios.hascorsi.aggiorna(pushpayload, function (u) {
                if (angular.isDefined(u.id)) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Corso correttamente modificato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Errore durante il salvataggio.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });
        }
        function del() {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare questo corso?')
                    .htmlContent('<b>Cliccando su OK </b>' + 'il corso sarà cancellato.')
                    .ariaLabel('cancella corso')
                    .ok('OK')
                    .cancel('ABBANDONA');
            $mdDialog.show(confirm).then(function () {
                api.beneficiarios.hascorsi.remove({id: vmd.id}, function (u) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Corso correttamente eliminato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                });
            });
        }

        vmd.selezioneItem = selezioneItem;
        function selezioneItem(id) {
            console.log("selezioneItem");
//            console.log("id:", id);
            var from = angular.copy(vmd.mySelezionato.dataInizio);
            var to = angular.copy(vmd.mySelezionato.dataFine);
            var ii = 0;
            for (ii = 0; ii < vmd.allcorsi.length; ii++) {
                if (vmd.allcorsi[ii].id == id) {
                    vmd.mySelezionato = angular.copy(vmd.allcorsi[ii]);
                }
            }
            //vmd.mySelezionato = angular.copy(vmd.allcorsi[index]);
            vmd.mySelezionato.dataInizio = from;
            vmd.mySelezionato.dataFine = to;
            console.log("vmd.mySelezionato", vmd.mySelezionato);
        }

        vmd.selezioneCat = selezioneCat;

        function selezioneCat(index) {

            vmd.noService = true;
            for (var i = 0; i < vmd.controllerCors.length; i++) {
                if (vmd.controllerCors[i] == index) {
                    vmd.noService = false;

                }

            }
//            console.log("vmd.controllerCors:", vmd.controllerCors);

        }

        vmd.cambiaData = cambiaData;
        function cambiaData() {
            var from = moment(vmd.mySelezionato.dataInizio).format("YYYY-MM-DD");
            var to = moment(vmd.mySelezionato.dataFine).format("YYYY-MM-DD");
            var totale = 1;
            if (vmd.isnew) {
                vmd.allcorsi = null;
                vmd.allcorsi = [];
                api.progettos.hascorsi.search({pagination: -1, progetto_id: vmd.progetto_id, dataInizio: "<" + from, dataFine: ">" + to, sort: 'corsi_id'}, function (r) {
                    angular.forEach(r.data, function (d) {
//                        console.log("d.length", r.data.length);
                        var temp = {};
                        var tempcat = {};
                        temp = angular.copy(d.corsi);
                        tempcat = angular.copy(d.cat);
                        if (temp !== null) {
                            temp.progetto_id = vmd.progetto_id;
                            temp.phc_id = d.id;
                            temp.beneficiario_id = vmd.beneficiario_id;
                            temp.da = new Date(d.dataInizio);
                            temp.a = new Date(d.dataFine);
                            temp.cat = tempcat.descrizione;
                            vmd.allcorsi.push(temp);
                        }
                        if (totale == r.data.length) {
                            vmd.controllerCors = null;
                            vmd.controllerCors = [];
                            vmd.noService = false;
                            var j = 0;
                            for (var i = 0; i < vmd.allcorsi.length; i++) {
                                if (vmd.allcorsi[i].corsi_id) {
                                    vmd.controllerCors[j] = vmd.allcorsi[i].corsi_id;
                                    j++;
                                }
                            }

                            var test = $filter('orderBy')(vmd.allcorsi, 'descrizione');
                            vmd.allcorsi = angular.copy(test);
//                            console.log("test:", test);
//                            console.log("vmd.controllerCors:", vmd.controllerCors);
//                            console.log("vmd.allcorsi", vmd.allcorsi);
//                            console.log("vmd.selezionato", vmd.selezionato);
//                            console.log("vmd.mySelezionato", vmd.mySelezionato);
                        }
//                        console.log("totale", totale);
                        totale++;
                    });
                });
            } else {
                console.log("else");
                vmd.selezioneItem(vmd.corso_id);
            }

        }

    }

    function CambioDataDialogController($mdDialog, api, $mdToast, $scope, locals) {
        var vmd = this;

        vmd.dataNew = new Date(locals.data);
        locals.data = vmd.dataNew;

        vmd.data = locals.data;
        vmd.flag = locals.flag;
        vmd.id = locals.id

        vmd.save = save;
        function save(data, flag, id) {
            var dataTemp = moment(data).format('YYYY-MM-DD');

            if (flag == "dataInserimento") {
                api.strutturas.hasbeneficiario.update({id: id, dataInserimento: dataTemp}, function (u) {
                });
            } else {
                api.strutturas.hasbeneficiario.update({id: id, dataCessazione: dataTemp}, function (u) {
                });
            }

            var payload = {id: id, data: dataTemp, flag: flag};
            vmd.closeDialog(payload);
        }

        vmd.closeDialog = closeDialog;
        function closeDialog(payload) {
            $mdDialog.hide(payload);
        }
    }

    function DialogCapofamigliaController($mdDialog, api, $mdToast, $scope, locals) {
      var vmd = this;
      vmd.capoFamiglia = locals.capoFamiglia;
      vmd.beneficiario_id = locals.beneficiario_id;
      vmd.capiFamiglia = [];
      vmd.ricercaNome = '';
      vmd.ricercaCognome = '';
      vmd.ricercaCodice = '';
      vmd.nuovoCapof = null;
      vmd.search = function (cercaNome,cercaCognome,cercaCodice) {
        api.beneficiarios.beneficiario.cercaCapifamiglia({id:vmd.beneficiario_id,nome:cercaNome,cognome:cercaCognome,codice:cercaCodice},function(res){
          vmd.capifamiglia = res.data;
        });
      }
      vmd.seleziona = function(capoF){
        var response = {capoF: capoF };
        $mdDialog.hide(response);
      };

      vmd.close = function(){
        $mdDialog.cancel();
      };

    }

  /** @ngInject */
  function CambioDataMcController($filter, $scope, $mdDialog, locals) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;

    vmd.beneficiario = locals.beneficiario;
    vmd.dataInizio = vmd.beneficiario.dataInizio;
    vmd.dataFine = vmd.beneficiario.dataFine;
    vmd.eventiProroghe = $filter('filter')(vmd.beneficiario.eventos, {eventoTipo_id: 1011})

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide({dataInizio: vmd.dataInizio, dataFine: vmd.dataFine});
    }

  }

  /** @ngInject */
  function MostraStoricoAccoglienzaController($filter, $scope, $mdDialog, locals) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;

    vmd.eventi = locals.eventiCambioData;

    angular.forEach(vmd.eventi, function (evento) {
      if(angular.isString(evento.extra)) {
        evento.extra = JSON.parse(evento.extra);
      }
    })

    function hideDialog()
    {
      $mdDialog.hide();
    }

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

  }

  function AnnullaUscitaController($filter, $scope, $mdDialog, locals) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;

    vmd.beneficiario = locals.beneficiario;

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide({id: vmd.beneficiario.id});
    }

  }


  function LiberaBeneficiarioController($filter, $scope, $mdDialog, $mdToast, api, locals, eventi, $state) {
    var vmd = this;
    console.log(api);

    vmd.beneficiario = locals.beneficiario;
    vmd.items = locals.items;
    vmd.dataInizio = new Date();
    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;
    vmd.liberaBeneficiario = liberaBeneficiario;
    vmd.evsearch = "";
    vmd.eventoTipos = [];
    vmd.disabled = false;


      vmd.eventoTipos = api.eventos.tipo.search(vmd.items.eventoFiltro, function (d) {

      });


    // vmd.eventoTipos è una Promise
    vmd.eventoTipos.$promise.then(function () {
        // Ora si può accedere al primo elemento dell'array data
        var primoElemento = vmd.eventoTipos.data[0];
        if (primoElemento) {
        vmd.statiPossibili = primoElemento.statiPossibili;
        vmd.extra = primoElemento.extra;
        }
    });

    vmd.newwork = newwork;

    function newwork(itemEventoTipo) {
      vmd.disabled = true;
      var stato = 4;
      var item = {};
      item.eventoTipo = itemEventoTipo;

      if (angular.isUndefined(itemEventoTipo)) {
        item.eventoTipo = vmd.eventoTipo;
      }

      console.log("newwork item.eventoTipo:", item.eventoTipo);
      var statip = vmd.statiPossibili.split(",");
      stato = statip[1];
      var payload = {};
      payload.self = {};
      payload.self.entita1_id = [vmd.items.entita1_id];
      payload.self.entita2_id = [vmd.items.entita2_id];
      payload.self.eventoTipo_id = 1010;
      payload.isnew = true;
      payload.parent = {};
      payload.extra = {};
      payload.eventoTipo_id = 1010;
      payload.entita1_id = vmd.items.entita1_id;


      var oggi = new Date();
      payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
      var extrasetup = JSON.parse(vmd.extra);
      var openpopup = angular.isDefined(extrasetup.properties[stato]);

      api.processi.processo.lavora(payload, function (response) {
        if (response.status == 200) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Processo inserito correttamente!!')
              .position('bottom right')
              .hideDelay(3000)
          );

          if (openpopup) {
            api.eventos.evento.get({id: response.id}, function (r) {
              var newitem = r;
              eventi.work("completa", newitem, stato, "completa", false);
            });
          } else {
            $state.reload();
          }
        }
      });
    }

    vmd.selected = [];
    vmd.options = {
      rowSelection: false,
      multiSelect: false,
      autoSelect: false,
      decapitate: false,
      largeEditDialog: false,
      boundaryLinks: true,
      limitSelect: true,
      pageSelect: true
    };
    vmd.query = {
      sort: '-id',
      perPage: 5,
      page: 1
    };
    vmd.limitOptions = [5, 10, 15, 20];
    vmd.allFields = true;
    vmd.colors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg', 'md-orange-800-bg'];
    vmd.icons = ['icon-drag', 'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close', 'icon-exclamation'];
    vmd.today = new Date();

    var avvisoPopup;

    function liberaBeneficiario() {
      var payload = {dataInizio: vmd.dataInizio, id: vmd.beneficiario.id};
      api.beneficiarios.beneficiario.liberaBeneficiario(payload, function(res) {
        if (res.stato === 'PRESENTE SUL TERRITORIO') {
          $mdDialog.hide().then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Beneficiario liberato correttamente')
                .position('bottom right')
                .hideDelay(3000)
            );
          });
          $state.go('app.sprardb_beneficiariop', {codicePresenza: res.codicePresenza});
        }
      });
    }

    function cancelDialog() {
      $mdDialog.cancel();
    }

    function hideDialog() {
      $mdDialog.hide();
    }
  }


  function TerminaNelTerritorioController($filter, $scope, $mdDialog, $mdToast, api, locals, $state) {
    var vmd = this;

    vmd.beneficiario = locals.beneficiario;
    vmd.dataFine = new Date();
    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;
    vmd.terminaNelTerritorio = terminaNelTerritorio;

    function terminaNelTerritorio() {
      var payload = {dataFine: vmd.dataFine, id: vmd.beneficiario.id}
      api.beneficiarios.beneficiario.terminaNelTerritorio(payload, function (res) {
        if (res.stato === 'PRESENTE SUL TERRITORIO TERMINATO') {
          $mdDialog.hide().then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Chiusura presenza sul territorio avvenuta con successo')
                .position('bottom right')
                .hideDelay(3000)
            )
          })
          $state.go('app.sprardb_beneficiariostorico', {id: vmd.beneficiario.progressivo})
        }
      })
    }

    function cancelDialog() {
      $mdDialog.cancel();
    }

    function hideDialog() {
      $mdDialog.hide();
    }
  }


  function AccogliInStrutturaController($filter, $scope, $mdDialog, $mdToast, api, locals) {
    var vmd = this;

    vmd.beneficiario = locals.beneficiario;
    vmd.api = api
    vmd.dataInizio = new Date();
    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;
    vmd.accogliInStruttura = accogliInStruttura;
    api.strutturas.strutturamin.cerca({'progetto_id': vmd.beneficiario.progetto_id, pagination: 400, attivo: 1}, function (response) {
      vmd.strutture = response.data;
    });

    function accogliInStruttura() {
      var payload = {dataInizio: vmd.dataInizio, id: vmd.beneficiario.id, strutturaId: vmd.struttura}
      api.beneficiarios.beneficiario.accogliInStruttura(payload, function(res) {
        if(res.stato === 'BENEFICIARIO') {
          $mdDialog.hide().then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Beneficiario accolto correttamente')
                .position('bottom right')
                .hideDelay(3000)
            )
          })
        }
      })
    }
    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide();
    }
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.sprardb_auth_reset-password', {
            url      : '/sprardb/auth/reset-password?token',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.sprardb_auth_reset-password': {
                    templateUrl: 'app/main/sprardb/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.sprardb_auth_reset-password',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.auth.reset-password')
            .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($scope, $stateParams, $state, $mdSidenav, msUtils, $mdDialog, $mdMedia, $http, api)
    {
        var token = $stateParams.token;
        var vm = this;
        // Data
        vm.form = {
            token: token,
            password: null,
            passwordConfirm: null
        };
        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.form.password !== vm.form.passwordConfirm) {
                $scope.resetPasswordForm.passwordConfirm.$setValidity("passwordVerify", false);
            } else {
                $scope.resetPasswordForm.passwordConfirm.$setValidity("passwordVerify", true);
            }
        }
        vm.resetPass = resetPass;
        $scope.showfarebut1 = false;
        function resetPass(event) {
            $scope.errors = {};
            api.users.log.passwordreset(vm.form, function (res) {
                if (res.status === true) {
                    $mdDialog.show(
                        $mdDialog.alert({
                                onRemoving: function () {
                                    window.location.href = '/sprardb/auth/login'
                                }
                            })
                            .clickOutsideToClose(true)
                            .title('Reset Password')
                            .textContent('La password è stata correttamente cambiata.')
                            .ok('OK')
                    );
                } else {
                    var message = '<ul>';
                    res.data.forEach(function (element) {
                        message += "<li>"+element+"</li>";
                    });
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Errore Reset Password')
                            .htmlContent(message + "</ul>")
                            .ariaLabel('E Reset Password')
                            .ok('OK')
                    );


                }
            });

            // $http.get(api.baseUrl + 'user/passwordreset?token=' + token + '&password=' + vm.form.password).success(function (result) {
            //     console.log(result);
            //     if (result.email)
            //     {
            //         $scope.showfarebut1 = true;
            //         $mdDialog.show(
            //                 $mdDialog.alert()
            //                 .clickOutsideToClose(true)
            //                 .title('Reset Password')
            //                 .textContent('La password è stata correttamente cambiata. Ti è stata inviata una email di conferma!!')
            //                 .ariaLabel('Reset Password')
            //                 .ok('OK')
            //                 );
            //     } else {
            //         $mdDialog.show(
            //                 $mdDialog.alert()
            //                 .clickOutsideToClose(true)
            //                 .title('Errore Reset Password')
            //                 .textContent(result.message)
            //                 .ariaLabel('E Reset Password')
            //                 .ok('OK')
            //                 );
            //     }
            //
            // });

        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.sprardb.auth.register', []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
                .state('app.sprardb_auth_register', {
                    url: '/sprardb/auth/register',
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/register-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.sprardb_auth_register': {
                            templateUrl: 'app/main/sprardb/auth/register/register.html',
                            controller: 'RegisterController as vm'
                        }
                    },
                    bodyClass: 'register'
                })
                .state('app.sprardb_auth_register2', {
                    url: '/sprardb/auth/register2',
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/register-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.sprardb_auth_register2': {
                            templateUrl: 'app/main/sprardb/auth/register/register2.html',
                            controller: 'Register2Controller as vm'
                        }
                    },
                    bodyClass: 'register2'
                })

                .state('app.sprardb_auth_register.success', {
                    url: '/success',
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/register-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.sprardb_auth_register.success': {
                            templateUrl: 'app/main/sprardb/auth/register/success.html',
                            controller: 'SuccessController as vm'
                        }
                    },
                    bodyClass: 'register'
                });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.auth.register', {
            title: 'Registrazione',
            state: 'app.sprardb_auth_register',
            weight: 2
        });

    }

})();



/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function () {
    'use strict';
    angular.module('app.sprardb.auth.register').controller('SuccessController', SuccessController);
    function SuccessController($scope, $state, $mdDialog, api, $window) {
        var vm = this;


    }
})();


(function ()
{
    'use strict';
    angular
            .module('app.sprardb.auth.register')
            .controller('Register2Controller', Register2Controller)
            .filter('filterByArray', filterByArray);

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    function Register2Controller($scope, $state, ricerca, $q, $log, $cookieStore, api, $mdDialog, $mdToast)
    {

        var vm = this;

        vm.regiones = ricerca.regiones;
        vm.provincias = {};
        vm.istats = {};
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.entetipos = ricerca.entetipos;
//        vm.entetipos = [];
//        api.entetipos.entetipov.search({id_IN: ,sort: "descrizione", pagination: -1}, function (r) {
//            vm.entetipos = r.data;
//        });
        vm.counts = vm.entesegnalatores.length;
        console.log(vm.regiones);
        console.log(vm.provincias);
        console.log(vm.entetipos);
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.pagination = -1;
        vm.colors = ricerca.colors;
        vm.links = {};
        vm.meta = {};
        vm.searched = false;
        vm.ricerca = {};
        vm.ricerca.segnalatore = 1;
        vm.ricerca.attivo = 1;
        vm.allsearchs.fields = "id,nome,enteTipo_id,codRegione,indirizzo,cap,email,telefono,istats,entetipo";

        vm.checkCodiceSegnalatore = false;
        vm.showfarebut1 = false;
        vm.showfarebut2 = true;
        vm.showorganization = true;
        vm.responseCodice = {};
        $scope.showfarebut1 = false;
        $scope.showfarebut2 = true;
        $scope.showorganization = true;
        vm.persondata = {};
        vm.persondata.codiceSegnalatore = '8f999132';
        //vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.oggi = new Date();
        vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());


        vm.checkCodice = checkCodice;
        function checkCodice() {
            vm.checkCodiceSegnalatore = true;
            vm.showfarebut1 = true;
            vm.showfarebut2 = false;
        }
        vm.resetCodice = resetCodice;
        function resetCodice() {
            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", true);
        }
        vm.indietro = indietro;
        function indietro() {
            vm.checkCodiceSegnalatore = false;
            vm.showfarebut1 = false;
            vm.showfarebut2 = true;
        }
        vm.checkTelefono = checkTelefono;
        function checkTelefono(ev) {
            api.entesafes.ente.search({telefono: vm.persondata.telefono, fields: "id,nome,telefono,piva,email", attivo: 1}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1) {
                            $scope.registerForm.telefono.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.telefono.$setValidity("unique", true);
                        }
                    });
        }
        vm.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vm.persondata.email)) {
                api.entesafes.ente.search({email: vm.persondata.email, fields: "id,nome,telefono,piva,email", attivo: 1}).$promise.then(
                        function (response) {
                            if (response.data.length >= 1) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            } else {
                                $scope.registerForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.registerForm.email.$setValidity("unique", true);
            }
        }
        vm.checkCf = checkCf;
        function checkCf(ev) {
            api.entesafes.ente.search({piva: vm.persondata.piva, fields: "id,nome,telefono,piva", attivo: 1}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1) {
                            $scope.registerForm.piva.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.piva.$setValidity("unique", true);
                        }
                    });
        }
        vm.preregister = preregister;
        function preregister() {
            $scope.registerForm.username.$setValidity("unique", true);
            checkEmail();
            api.users.log.preregister(vm.persondata).$promise.then(
                    function (response) {
                        if (response.status != undefined && response.status == 200) {
                            $scope.registerForm.username.$setValidity("unique", true);
                            $scope.registerForm.email.$setValidity("unique", true);
                        } else {
                            if (angular.isDefined(response.email)) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            }


                            if (response.username != undefined) {
                                $scope.registerForm.username.$setValidity("unique", false);
                            }
                        }
                    });
        }

        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.persondata.password !== vm.persondata.passwordc) {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", true);
            }
        }



        vm.roles = [];
        vm.roles = loadRoles();
        function loadRoles() {
            api.personaruolos.personaruolo.search({gruppo: 'ENTE'}).$promise.then(function (response) {
                var roles = response.data;
                vm.roles = roles.map(function (repo) {
                    repo.value = repo.gruppo.toLowerCase();
                    return repo;
                });
            }, function (response) {
                //console.log(response);
            });
        }




        vm.register = register;
        function register(ev) {

            var erroreg = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('ERRORE Inserimento ente segnalatore')
                    .htmlContent("Si è verificato un errore non gestito. <br><br>Contattare Servizio Centrale")
                    .ariaLabel('Errore')
                    .ok('OK');

            var ok = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .title('Inserimento ente segnalatore')
                    .htmlContent('Inserimento effettuato. <br><b>Controlla la tua email</b>.')
                    .ariaLabel('okdialog')
                    .ok('Vai alla login');

            var confirm = $mdDialog.confirm()
                    .title('Inserimento ente segnalatore')
                    .htmlContent('I dati appena inseriti saranno registrati. <br>Riceverai una email di avvenuta <b>presa in carico</b> della registrazione.')
                    .ariaLabel('confermoInserimento')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Salva')
                    .cancel('Abbandona');
            $mdDialog.show(confirm).then(function () {
                //conferma
                vm.ente = angular.copy(vm.persondata);


                api.stagingarea.register.savees({ente: vm.ente}, function (res) {
                    console.log(res);
                    if (res.status === 200) {
                        $mdDialog.show(ok).then(function () {
                            var email = {};
                            email.to = vm.persondata.email;
                            email.to = ["emailentesegnalatore@kubique.com", "emailentesegnalatore@serviziocentrale.it", "emailaccoglienza@kubique.com", "emailaccoglienza@serviziocentrale.it"];
                            email.oggetto = "Richiesta iscrizione";
                            email.corpo = "Salve <b>" + vm.persondata.nome + "</b>,<br>abbiamo ricevuto la sua richiesta di iscrizione.<br>Verrà contattato non appena la pratica sarà lavorata.<br><br>Ringraziamo per la collaborazione<br>Cordiali Saluti";
                            //api.emails.send2.send(email, function (response) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Iscrizione avvenuta con successo e email spedita.')
                                    .position('bottom right')
                                    .hideDelay(2000)
                                    ).then(function () {
                                $state.go('app.sprardb_auth_login');
                            });
                            $mdDialog.hide();
                            //});


                        });
                    }
                    if (res.status === 400) {
                        var errore = $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('ERRORE Inserimento segnalatore')
                                .textContent(res.message)
                                .ariaLabel('Errore')
                                .ok('OK');
                        $mdDialog.show(errore);
                    }
                }, function (res) {
                    $mdDialog.show(erroreg);
                });

            }, function () {
                //abbandono
            });
        }

        vm.toggleuser = toggleuser;
        function toggleuser() {
            $mdDialog.hide(vm.registerdata);
        }
        vm.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vm.onSearch = onSearch;
        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.entesafes.ente.like(vm.allsearchs, function (d) {
                vm.entesegnalatores = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
                vm.counts = vm.entesegnalatores.length;
            }
            );
            vm.searched = true;
        }
        vm.dettaglio = dettaglio;
        function dettaglio(item) {
            var content = "Il tuo ente di riferimento è<br><big><b>" + item.nome + "</b></big><br><br>Contattalo il prima possibile e fai richiesta del <b>CODICE DI AUTORIZZAZIONE</b><br> che ti servirà per iscriverti alla Banca dati SPRAR come un <b>NUOVO SEGNALATORE</b>.<br><br>Puoi contattare il tuo <b>ENTE DI RIFERIMENTO</b> al seguente indirizzo email:<br><big><b>" + item.email + "</b></big><br><br>Oppure telefonicamente al numero:<br><big><b>" + item.telefono + "</b></big>";
            var dett = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Contatta il tuo ente segnalatore')
                    .htmlContent(content)
                    .ariaLabel('Dettaglio')
                    .ok('OK');
            $mdDialog.show(dett);
        }

        vm.caricaComuni = caricaComuni;
        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }

        vm.caricaProvince = caricaProvince;
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }

    }
})();

(function ()
{
    'use strict';
    angular
            .module('app.sprardb.auth.register')
            .controller('RegisterController', RegisterController)
            .filter('filterByArray', filterByArray);

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    function RegisterController($scope, $state, $timeout, $q, $log, $cookieStore, api, $mdDialog)
    {
        var vm = this;
        vm.baseUrl = api.baseUrl;
        vm.checkCodiceSegnalatore = false;
        vm.showfarebut1 = false;
        vm.showfarebut2 = true;
        vm.showorganization = true;
        vm.responseCodice = {};
        $scope.showfarebut1 = false;
        $scope.showfarebut2 = true;
        $scope.showorganization = true;
        vm.persondata = {};
        //vm.persondata.codiceSegnalatore = '8f999132';
        //vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.oggi = new Date();
        vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());


        vm.checkCodice = checkCodice;
        function checkCodice() {
            api.users.log.checkcodice({codiceSegnalatore: vm.persondata.codiceSegnalatore}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            vm.responseCodice = response;
                            vm.showfarebut2 = false;
                            vm.showfarebut1 = true;
                            $cookieStore.remove('users');
                            $cookieStore.remove('person');
                            vm.checkCodiceSegnalatore = true;
                            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", true);
                        } else {
                            vm.checkCodiceSegnalatore = false;
                            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", false);
                        }
                    });
        }
        vm.resetCodice = resetCodice;
        function resetCodice() {
            $scope.registerForm.codiceSegnalatore.$setValidity("notexists", true);
        }
        vm.indietro = indietro;
        function indietro() {
            vm.checkCodiceSegnalatore = false;
            vm.showfarebut1 = false;
            vm.showfarebut2 = true;
        }
        vm.checkTelefono = checkTelefono;
        function checkTelefono(ev) {
            api.users.log.checktelefono({telefono: vm.persondata.telefono}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            $scope.registerForm.telefono.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.telefono.$setValidity("unique", true);
                        }
                    });
        }
        vm.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vm.persondata.email)) {
                api.users.log.checkemail({email: vm.persondata.email}).$promise.then(
                        function (response) {
                            if (response.esito == 1) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            } else {
                                $scope.registerForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.registerForm.email.$setValidity("unique", true);
            }
        }
        vm.checkCf = checkCf;
        function checkCf(ev) {
            api.users.log.checkcf({codiceFiscale: vm.persondata.codiceFiscale}).$promise.then(
                    function (response) {
                        if (response.esito == 1) {
                            $scope.registerForm.codiceFiscale.$setValidity("unique", false);
                        } else {
                            $scope.registerForm.codiceFiscale.$setValidity("unique", true);
                        }
                    });
        }
        vm.preregister = preregister;
        function preregister() {
            $scope.registerForm.username.$setValidity("unique", true);
            checkEmail();
            api.users.log.preregister(vm.persondata).$promise.then(
                    function (response) {
                        if (response.status != undefined && response.status == 200) {
                            $scope.registerForm.username.$setValidity("unique", true);
                            $scope.registerForm.email.$setValidity("unique", true);
                        } else {
                            if (angular.isDefined(response.email)) {
                                $scope.registerForm.email.$setValidity("unique", false);
                            }


                            if (response.username != undefined) {
                                $scope.registerForm.username.$setValidity("unique", false);
                            }
                        }
                    });
        }

        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.persondata.password !== vm.persondata.passwordc) {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.registerForm.passwordc.$setValidity("passwordVerify", true);
            }
        }



        vm.roles = [];
        vm.roles = loadRoles();
        function loadRoles() {
            api.personaruolos.personaruolo.search({gruppo: 'ENTE', sort: 'descrizione'}).$promise.then(function (response) {
                var roles = response.data;
                vm.roles = roles.map(function (repo) {
                    repo.value = repo.gruppo.toLowerCase();
                    return repo;
                });
            }, function (response) {
                //console.log(response);
            });
        }




        vm.register = register;
        function register(ev) {

            var erroreg = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('ERRORE Inserimento segnalatore')
                    .textContent("Si è verificato un errore non gestito. Contattare Servizio Centrale")
                    .ariaLabel('Errore')
                    .ok('OK');

            var ok = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .title('Inserimento segnalatore')
                    .textContent('Inserimento effettuato. Controlla la tua email.')
                    .ariaLabel('okdialog')
                    .ok('Vai alla login');

            var confirm = $mdDialog.confirm()
                    .title('Inserimento segnalatore')
                    .textContent('I dati appena inseriti saranno registrati. Riceverai una email di avvenuta attivazione dell\'account.')
                    .ariaLabel('confermoInserimento')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Salva')
                    .cancel('Abbandona');
            $mdDialog.show(confirm).then(function () {
                //conferma
                vm.user = angular.copy(vm.persondata);
                vm.person = angular.copy(vm.persondata);
                vm.organization = {};
                //user
                delete(vm.user.codiceFiscale);
                delete(vm.user.codiceSegnalatore);
                delete(vm.user.cognome);
                delete(vm.user.nome);
                delete(vm.user.designation);
                delete(vm.user.sesso);
                delete(vm.user.telefono);
                delete(vm.user.dataNascita);
                //person
                delete(vm.person.codiceSegnalatore);
                delete(vm.person.username);
                delete(vm.person.password);
                delete(vm.person.passwordc);
                vm.person.dataNascita = moment(vm.persondata.dataNascita).format('YYYY-MM-DD');
                //organization
                vm.organization.id = vm.responseCodice.id;

//            console.log('persondata',vm.persondata);
//            console.log('user', vm.user);
//            console.log('person', vm.person);
//            console.log('organization', vm.organization);

                api.stagingarea.register.save({user: vm.user, person: vm.person, organization: vm.organization}, function (res) {
                    console.log(res);
                    if (res.status === 200) {
                        $mdDialog.show(ok).then(function () {
                            $state.go('app.sprardb_auth_login');
                        });
                    }
                    if (res.status === 400) {
                        var errore = $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('ERRORE Inserimento segnalatore')
                                .textContent(res.message)
                                .ariaLabel('Errore')
                                .ok('OK');
                        $mdDialog.show(errore);
                    }
                }, function (res) {
                    $mdDialog.show(erroreg);
                });

            }, function () {
                //abbandono
            });
        }

        vm.toggleuser = toggleuser;
        function toggleuser() {
            $mdDialog.hide(vm.registerdata);
        }
        vm.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.sprardb.auth.register').controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($scope, $state, $timeout, $q, $log, $cookieStore, $mdDialog, api)
    {
        var vm = this;
        vm.organization = {};
        vm.persondata = {
            orggroup: 'Yes',
            sesso: 'M'
        };
        vm.comunenascita = 'Comune di nascita';
        vm.comuneresidenza = 'Comune di residenza';
        vm.scegliunente = 'Scegli un ente';
        vm.orgtelefono = null;


        if ($cookieStore.get('users')) {
            var user = $cookieStore.get('users');
            vm.persondata.email = user.email;
        }

        if ($cookieStore.get('person')) {
            vm.persondata = $cookieStore.get('person');
            vm.persondata.dataNascita = new Date($cookieStore.get('person').dataNascita);
            vm.persondata.sesso = $cookieStore.get('person').sesso;
            console.log(vm.persondata.sesso);
//            api.istats.istat.cerca({codIstatA: $cookieStore.get('person').codComuneNascita}).$promise.then(function (response) {
//                var repos = response.data;
//                vm.searchTextCity = repos[0].comune;
//                vm.persondata.codComuneNascita = repos[0].istat;
//
//            }, function (results) {
//                console.log(results);
//            });
//            api.istats.istat.cerca({codIstatA: $cookieStore.get('person').codComune}).$promise.then(function (response) {
//                var repos = response.data;
//                //vm.comuneresidenza = repos[0].comune;
//                vm.searchTextBirthcity = repos[0].comune;
//                //vm.selectedResidencecityChange(repos);
//                vm.persondata.codComune = repos[0].istat;
//                vm.persondata.codProvincia = repos[0].codProvincia;
//                vm.persondata.codRegione = repos[0].codRegione;
//
//            }, function (results) {
//                console.log(results);
//            });
        }

        if ($cookieStore.get('organization')) {
            vm.organization = $cookieStore.get('organization');
//            console.log('Cookie Org: ');
//            console.log(vm.organization);
            api.entesafes.ente.get({id: vm.organization.id}, function (response) {
                api.entesafes.ente.like({nome: '', segnalatore: 1}, function (d) {
                    var organizations = d.data;
                    vm.organizations = organizations.map(function (repo) {
                        repo.value = repo.nome.toLowerCase();
                        return repo;
                    });
                    var repos = response;
                    //console.log(response);
                    //vm.scegliunente = repos.nome;
                    vm.searchTextOrganization = repos.nome;
                    vm.organization.id = repos.id;
                    vm.orgtelefono = repos.telefono;
                });


            });
            //$cookieStore.remove('organization');
        }

        $scope.showorganization = true;
        vm.backward = backward;
        function backward(valstate) {
            $state.go(valstate);
        }

        vm.onTypeChange = onTypeChange;
        function onTypeChange() {
            var typeval = $scope.personForm.orggroup.$viewValue;
            if (typeval === 'Yes') {
                $scope.showorganization = true;
            } else {
                $scope.showorganization = false;
                vm.organization.id = -1;
            }
        }

        $scope.dataNascita = new Date();
        $scope.maxDate = new Date(
                $scope.dataNascita.getFullYear() - 18,
                $scope.dataNascita.getMonth() - 1,
                $scope.dataNascita.getDate());
        vm.resetEmail = resetEmail;
        function resetEmail() {
            $scope.registerForm.email.$setValidity("unique", true);
        }
        $scope.mobileverification = false;
// CITY Autocomplete section #########################################
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.repos = [];
        vm.querySearchCity = querySearchCity;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        function querySearchCity(query) {
            var results, deferred;
            if (query !== "" && query !== null && typeof query !== "undefined") {
                api.istats.istat.like({comune: query, pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });
                }, function (results) {
                    console.log(results);
                });
                results = vm.repos.filter(createFilterFor(query));
            } else {
                api.istats.istat.like({comune: 'Rom', pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });
                }, function (results) {
                    //console.log(results);
                });
                results = vm.repos;
            }
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        vm.querySearchBirthcity = querySearchBirthcity;

        function querySearchBirthcity(query) {
            var results, deferred;
            if (query !== "" && query !== null && typeof query !== "undefined") {
                api.istats.istat.like({comune: query, pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });
                }, function (results) {
                    //console.log(results);
                });
                results = vm.repos.filter(createFilterFor(query));
            } else {
                api.istats.istat.like({comune: 'Rom', pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });
                }, function (results) {
                    //console.log(results);
                });
                results = vm.repos;
            }
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }
        function selectedItemChange(item) {
            if (item) {
                vm.persondata.codComuneNascita = item.istat;
            }
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        vm.organizations = [];
        vm.organizations = loadOrganizations();
        function loadOrganizations() {
            api.entesafes.ente.like({nome: '', segnalatore: 1}).$promise.then(function (response) {
                var organizations = response.data;
                vm.organizations = organizations.map(function (repo) {
                    repo.value = repo.nome.toLowerCase();
                    return repo;
                });
            }, function (response) {
                //console.log(response);
            });
        }

        vm.querySearchOrganization = querySearchOrganization;
        function querySearchOrganization(query) {
            console.log(query);
            var results = query ? vm.organizations.filter(createFilterFor(query)) : vm.organizations, deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        vm.roles = [];
        vm.roles = loadRoles();
        function loadRoles() {
            api.personaruolos.personaruolo.search({gruppo: 'ENTE'}).$promise.then(function (response) {
                var roles = response.data;
                vm.roles = roles.map(function (repo) {
                    repo.value = repo.gruppo.toLowerCase();
                    return repo;
                });
            }, function (response) {
                //console.log(response);
            });
        }
        vm.selectedResidencecityChange = selectedResidencecityChange;
        function selectedResidencecityChange(item) {
            if (item) {
                vm.persondata.codComune = item.istat;
                vm.persondata.codProvincia = angular.copy(item.codProvincia);
                vm.persondata.codRegione = angular.copy(item.codRegione);
            }
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        vm.selectedOrganizationChange = selectedOrganizationChange;
        function selectedOrganizationChange(item) {
            if (item) {
                vm.organization.id = angular.copy(item.id);
                vm.orgtelefono = angular.copy(item.telefono);
            }
        }
        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                return (item.value.indexOf(lowercaseQuery) === 0);
            };
        }
        vm.newOrganization = newOrganization;
        function newOrganization() {
            $cookieStore.put('person', vm.persondata);
            $state.go('app.sprardb_auth_register.organization');
        }

        vm.checkTelephone = checkTelephone;
        function checkTelephone(ev) {
            var monumber = $scope.personForm.telefono.$viewValue;
            if (monumber !== undefined && monumber.length >= 10) {
                api.personas.persona.like({telefono: $scope.personForm.telefono.$viewValue},
                        function (response) {
                            if (response.data.length > 0) {
                                $scope.personForm.telefono.$setValidity("unique", false);
                            } else {
                                $scope.personForm.telefono.$setValidity("unique", true);
                            }
                            //console.log($scope.personForm);
                        },
                        function (response) {
                            //console.log(response);
                        });
            }

        }
        vm.checkUsername = checkUsername;
        function checkUsername(ev) {
            var username = $scope.personForm.username.$viewValue;
            if (username !== undefined && username.length >= 10) {
                api.personas.persona.like({telefono: $scope.personForm.telefono.$viewValue},
                        function (response) {
                            if (response.data.length > 0) {
                                $scope.personForm.telefono.$setValidity("unique", false);
                            } else {
                                $scope.personForm.telefono.$setValidity("unique", true);
                            }
                            //console.log($scope.personForm);
                        },
                        function (response) {
                            //console.log(response);
                        });
            }

        }
        vm.createProfile = createProfile;
        function createProfile(ev) {
            $scope.mobileverification = true;
            $scope.tokenfailed = false;
            var monumber = $scope.personForm.telefono.$viewValue;
            api.tokens.token.sendcode({mobile: monumber}, function (response) {
                var token1 = response.token;
                //genero token e apro dialog
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'app/main/sprardb/auth/register/dialog1.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        telefono: monumber,
                        tokenauto: token1
                    }
                }).then(function (answer) {
                    //risposta prima dialog
                    //console.log(answer);
                    //answer first, answer2 for org
                    if (vm.organization.id !== -1 && answer.attivo === 0) {
                        $scope.mobileverification = true;
                        $scope.tokenfailed = false;
                        api.tokens.token.sendcode({mobile: vm.orgtelefono}, function (response) {
                            //invio secondo token
                            var token2 = response.token;
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'app/main/sprardb/auth/register/dialog2.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: false,
                                locals: {
                                    telefono: vm.orgtelefono,
                                    tokenauto: token2
                                }
                            }).then(function (answer2) {
                                console.log(answer2);
                                if (answer2.attivo === 0) {
                                    api.stagingarea.register.save({user: user, person: vm.persondata, organization: vm.organization}, function (res) {
                                        console.log(res);
                                        if (res.status === 200) {
                                            $scope.mobileverification = false;
                                            $cookieStore.remove('users');
                                            $state.go('app.sprardb_auth_register.success');
                                        }
                                    }, function (res) {
                                        //console.log(res);
                                    });
                                }
                            });
                        }, function (response) {
                            //errore secondo token
                            //console.log(response);
                        });

                    }

                    if (answer.attivo === 0 && vm.organization.id === -1) {
                        api.stagingarea.register.save({user: user, person: vm.persondata, organization: vm.organization}, function (res) {
                            if (res.status === 200) {
                                $scope.mobileverification = false;
                                $cookieStore.remove('users');
                                $state.go('app.sprardb_auth_register.success');
                            }
                        }, function (res) {
                            //console.log(res);
                        });
                    }


                    $log.info('answer is ' + JSON.stringify(answer));
                }, function (err) {
                    //error answer
                    //console.log(err);
                });



            }, function (response) {
                //error send code
                //console.log(response);
            });


        }
    }
    angular.module('app.sprardb.auth.register').controller('DialogController', DialogController);
    function DialogController($scope, $mdDialog, api, locals) {
        $scope.tokenauto = locals.tokenauto;
        $scope.telm = locals.telefono;
        $scope.tokenresend = false;
        $scope.verify = function () {
            api.tokens.token.validatecode({mobile: locals.telefono, token: $scope.telephoneForm.token1.$viewValue}, function (response) {
                $scope.telephoneForm.token1.$setValidity("validtoken", false);
                $mdDialog.hide(response);
            }, function (response) {
                $scope.telephoneForm.token1.$setValidity("validtoken", true);
                $scope.tokenfailed = true;
            });
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.resend = function () {
            api.tokens.token.sendcode({mobile: locals.telefono}, function (response) {
                $scope.tokenauto = response.token;
                $scope.tokenresend = true;
                $scope.tokenfailed = false;
            }, function (response) {
                //console.log(response);
            });
        };
    }
})();



(function ()
{
    'use strict';
    angular.module('app.sprardb.auth.register').controller('OrganizationController', OrganizationController);

    /** @ngInject */
    function OrganizationController($scope, $state, $mdDialog, $timeout, $q, $log, api, $cookieStore)
    {
        var vm = this;
        vm.orgexists = false;
        $cookieStore.remove('organization');
        vm.comuneresidenza = 'Comune';
        vm.organization = {};
        if ($cookieStore.get('person')) {
            var person = $cookieStore.get('person');
            //vm.organization.email = person.email;
            //vm.organization.telefono = person.telefono;
        }
        vm.organization.segnalatore = 7;
        $scope.tokenresend = true;
        vm.parorg = [];
        vm.parentorgs = function () {
            api.entetipos.entetipo.search({enteTipo_id: 0}).$promise.then(function (response) {
                vm.parorg = response.data;
            }, function (response) {
                console.log(response);
            });
            return vm.parorg;
        };
        vm.parentorgs();

        vm.childorgs = [];
        vm.childorg = childorg;
        function childorg() {
            var ids = $scope.organizationForm.ids.$viewValue;
            if (ids > 0) {
                api.entetipos.entetipo.search({enteTipo_id: ids}).$promise.then(function (response) {
                    vm.childorgs = response.data;
                }, function (response) {
                    console.log(response);
                });
                return vm.childorgs;
            }
        }
// CITY Autocomplete section #########################################
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.repos = [];
        vm.querySearchCity = querySearchCity;
        function querySearchCity(query) {
            var results, deferred;
            if (query !== "" && query !== null && typeof query !== "undefined") {
                api.istats.istat.like({comune: query, pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });

                }, function (results) {
                    console.log(results);
                });
                results = vm.repos.filter(createFilterFor(query));
            } else {
                api.istats.istat.like({comune: 'Rom', pagination: 200}).$promise.then(function (response) {
                    var repos = response.data;
                    vm.repos = repos.map(function (repo) {
                        repo.value = repo.comune.toLowerCase();
                        return repo;
                    });

                }, function (results) {
                    console.log(results);
                });
                results = vm.repos;
            }
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                return (item.value.indexOf(lowercaseQuery) === 0);
            };
        }
        vm.searchTextChange = searchTextChange;
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }
        vm.selectedResidencecityChange = selectedResidencecityChange;
        function selectedResidencecityChange(item) {
            if (item) {
                vm.organization.codComune = item.istat;
                vm.organization.codProvincia = angular.copy(item.codProvincia);
                vm.organization.codRegione = angular.copy(item.codRegione);
            }
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        vm.validatePhone = checkTelephone;
        function checkTelephone(ev) {
            var monumber = $scope.organizationForm.telefono.$viewValue;
            if (monumber !== undefined && monumber.length >= 10) {
                api.entesafes.ente.search({telefono: $scope.organizationForm.telefono.$viewValue, segnalatore: 1},
                        function (response) {
                            if (response.data.length > 0) {
                                vm.organization = {};
                                $scope.organizationForm.telefono.$setValidity("unique", false);
                                vm.organization = angular.copy(response.data[0]);
                                vm.comuneresidenza = vm.organization.istats.comune;
                                vm.orgexists = true;
                            } else {
                                $scope.organizationForm.telefono.$setValidity("unique", true);
                            }
                        },
                        function (response) {
                            console.log(response);
                        });
            }

        }




        vm.validateEmail = validateEmail;
        function validateEmail() {
            var email = $scope.organizationForm.email.$viewValue;
            if (email) {
                api.entesafes.ente.search({email: email, segnalatore: 1}).$promise.then(
                        function (response) {
                            if (response.data[0]) {
                                vm.organization = {};
                                vm.organization = angular.copy(response.data[0]);
                                vm.comuneresidenza = vm.organization.istats.comune;
                                vm.orgexists = true;
                            }
                        },
                        function (response) {
                            console.log(response);
                        });
            }

        }
        vm.validatePiva = validatePiva;
        function validatePiva() {
            var piva = $scope.organizationForm.piva.$viewValue;
            if (piva) {
                api.entesafes.ente.search({piva: piva, segnalatore: 1}).$promise.then(
                        function (response) {
                            if (response.data[0]) {
                                vm.organization = {};
                                vm.organization = angular.copy(response.data[0]);
                                vm.comuneresidenza = vm.organization.istats.comune;
                                vm.orgexists = true;
                            }
                        },
                        function (response) {
                            console.log(response);
                        });
            }

        }
        vm.backward = backward;
        function backward(valstate) {
            if (vm.orgexists) {
                var orgnew = {};
                orgnew.id = vm.organization.id;
                vm.organization = {};
                $cookieStore.put('organization', orgnew);
            }
            $state.go(valstate);
        }

        vm.createProfile = createProfile;
        function createProfile(ev) {
            console.log(vm.organization);
            $scope.mobileverification = true;
            $scope.tokenfailed = false;
            var monumber = $scope.organizationForm.telefono.$viewValue;
//####################################################################
            api.tokens.token.sendcode({mobile: monumber}, function (response) {
                console.log(response);
            }, function (response) {
                console.log(response);
            });
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sprardb/auth/register/dialog2.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    telefono: monumber
                }
            }).then(function (answer) {
                if (answer.attivo === 0) {
                    api.stagingarea.register.save({user: $cookieStore.get('users'), person: $cookieStore.get('person'), organization: vm.organization}, function (res) {
                        if (res.status === 200) {
                            $scope.mobileverification = false;
                            $cookieStore.remove('users');
                            $cookieStore.remove('person');
                            $state.go('app.sprardb_auth_register.success');
                        }
                    }, function (res) {
                        $scope.mobileverification = true;
                        console.log(res);
                    });
                } else {
                    //$scope.tokenfailed = true;
                }
            }, function (err) {
                console.log(err);
                $scope.mobileverification = true;
            });
//#####################################################################

        }
    }
    angular.module('app.sprardb.auth.register').controller('DialogController', DialogController);
    function DialogController($scope, $mdDialog, api, locals) {
        $scope.telm = locals.telefono;
        $scope.tokenresend = false;
        $scope.verify = function () {
            api.tokens.token.validatecode({mobile: locals.telefono, token: $scope.telephoneForm.token1.$viewValue}, function (response) {
                $scope.telephoneForm.token1.$setValidity("validtoken", false);
                $mdDialog.hide(response);
            }, function (response) {
                $scope.telephoneForm.token1.$setValidity("validtoken", true);
                $scope.tokenfailed = true;
            });
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.resend = function () {
            api.tokens.token.sendcode({mobile: locals.telefono}, function (response) {
                $scope.tokenresend = true;
                $scope.tokenfailed = false;
            }, function (response) {
                console.log(response);
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.auth.login', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.sprardb_auth_login', {
            url: '/sprardb/auth/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.sprardb_auth_login': {
                    templateUrl: 'app/main/sprardb/auth/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.auth.login', {
            title: 'Login',
            state: 'app.sprardb_auth_login',
            weight: 1
        });

    }

})();
(function ()
{
  'use strict';

  angular
    .module('app.sprardb.auth.login')
    .controller('LoginController', LoginController)
    .controller('DialogController', DialogController);

  /** @ngInject */
  function LoginController($scope, $state, $mdDialog, $rootScope, api, $cookies, ricerca, $filter)
  {
    // Data
    var vm = this;

    vm.logindata = {
      username: null,
      password: null
    }
    vm.loggedin = false;

    vm.nascondimsg = false;
    vm.startup = new Date('2018-05-25 12:30:00');
    vm.oggi = new Date();
    console.log(vm.startup);
    console.log(vm.oggi);
    if (vm.oggi > vm.startup) {
      vm.nascondimsg = true;
    }

    vm.popup = popup;

    function popup(ev) {
      $mdDialog.show({
        controller: DialogController,
        contentElement: '#myDialog',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
    };

    // Methods
    vm.login = login;
    //console.log(api);

    $cookies.putObject('user', {autorizzato: 0});

    //////////
    function login() {
      if ($cookies.getObject('user')) {
        $cookies.remove('user');
        $cookies.putObject('user', {autorizzato: 0});
      }

      api.users.log.in(vm.logindata,
        function (response) {
          var objectResponse = angular.copy(response);

          //console.log('base64');
          //var b64t = $base64.encode(response.access_token + ':');
          //console.log(b64t);
          if (response.id > 0) {
            if (response.personas.length === 0) {
              $mdDialog.show(
                $mdDialog.alert()
                  .clickOutsideToClose(true)
                  .title('Attenzione')
                  .textContent('Nessuna persona associata a questa login. Contattare SC.')
                  .ariaLabel('Credenziali errate')
                  .ok('OK')
              ).then(function () {
                $cookies.remove('user');
                $cookies.remove('ente_id');
                $cookies.remove('progetto_id');
                $cookies.remove('ALL_p_id');
                $cookies.remove('ALL_s_id');
                $cookies.putObject('user', {autorizzato: 0});
                $state.go('app.sprardb_auth_login');
              });
            }
            var gruppi = response.gruppos;
            gruppi.forEach(function(gruppo){ delete gruppo['_links'] });

            var user = {
              access_token: response.access_token,
              persona_id: response.personas[0].id,
              telefono: response.personas[0].telefono,
              nome: response.personas[0].nome,
              cognome: response.personas[0].cognome,
              username: response.username,
              email: response.email,
              gruppos: gruppi,
              autorizzato: 1,
              id: response.id,
              privacy: response.privacy,
              primoAccessoEffettuato: response.primoAccessoEffettuato,
              permissions: response.permissions
            }
            $cookies.putObject('user', user);
            $scope.autorizzato = 1;
//                            $scope.gruppos = response.gruppos;
//                            $scope.isAdmin = false;
//                            if ($scope.gruppos.id === 3) {
//                                $scope.isAdmin = true;
//                            }

            vm.loggedin = true;
            api.reloadm();
            ricerca.reloadUnauthorized();
            api.immagazzinaPersone(response.personas);
            $rootScope.progettiesegnalatori(response.personas);

            var go = api.primapagina;
            var go2 = api.primapagina_attributi;
            if (objectResponse.privacy === 0 || objectResponse.primoAccessoEffettuato === 0) {
              if (objectResponse.privacy === 0 || objectResponse.primoAccessoEffettuato === 0) {
                go = 'app.sprardb_personasdettaglio2';
                go2 = {id: response.personas[0].id};
              } else if ($filter('filter')(objectResponse.gruppos, {gruppo: 'PR-OPERATORE'}).length) {
                go = "app.sprardb_cruscotto";
              }
            } else {
              go = api.primapagina;

              if($filter('filter')(objectResponse.gruppos, {gruppo: 'PR-OPERATORE'}).length){
                go = "app.sprardb_cruscotto";
              }

//                                    angular.forEach(api.userlogged.gruppos, function (g) {
//                                        if (g.id == 11) {
//                                            go = 'app.sprardb_notification';
//                                        }
//                                        if (g.id == 4 || g.id == 5 || g.id == 6 || g.id == 9) {
//                                            go = 'app.sprardb_autoinserimento';
//                                        }
//                                        if (g.id == 2) {
//                                            go = 'app.protocollo_segnalatienti';
//                                            go2 = {eventoTipo_id: 1003};
//                                        }
//                                    });

            }

            ricerca.reloadCS();
            $state.go(go, go2);

          }
        },
        function (response) {

          $mdDialog.show(
            $mdDialog.alert()
              .clickOutsideToClose(true)
              .title('Credenziali errate')
              .textContent(response.data.message)
              .ariaLabel('Credenziali errate')
              .ok('OK')
          );
        });
    }

    $scope.cancel = function () {
      $mdDialog.hide();
    }

  }

  function DialogController($scope, $mdDialog) {
    var vmd = this;
    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.sprardb_auth_lock', {
            url      : '/sprardb/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.sprardb_auth_lock': {
                    templateUrl: 'app/main/sprardb/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.auth.lock', {
            title : 'Blocco',
            state : 'app.sprardb_auth_lock',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sprardb.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Admin'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sprardb.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.sprardb_auth_forgot-password', {
            url      : '/sprardb/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.sprardb_auth_forgot-password': {
                    templateUrl: 'app/main/sprardb/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.auth.forgot-password', {
            title : 'Password dimenticata',
            state : 'app.sprardb_auth_forgot-password',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.auth.forgot-password')
            .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($scope, $state, $mdSidenav, msUtils, $mdDialog, $mdMedia, $http, api)
    {
        var vm = this;
        // Data
        vm.form = {
            email: null
        }

        vm.startreset = startreset
        function startreset() {
            api.users.log.startreset({AskReset: vm.form}, function (data) {
                if (data.status) {
                  $mdDialog.show(
                    $mdDialog.alert()
                      .clickOutsideToClose(true)
                      .title('Email inviata')
                      .htmlContent("Abbiamo mandato un’email a " + data.AskReset.email +
                          "<br>Per resettare la tua password, segui le istruzioni nell’email")
                      .ok('OK')
                  );
                } else {
                    $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Utente non trovato')
                        .textContent(response.data.message)
                        .ok('OK')
                    );
                }

                // api.users.log.openreset({token: mytoken}, function (result) {
                //     if (result.status == 200)
                //     {
                //         $state.go('app.sprardb_auth_reset-password', {token: token.token});
                //     } else {
                //         $mdDialog.show(
                //                 $mdDialog.alert()
                //                 .clickOutsideToClose(true)
                //                 .title('Email Inesistente. Contattare SC.')
                //                 .textContent(response.data.message)
                //                 .ariaLabel('Credenziali errate')
                //                 .ok('OK')
                //                 );
                //     }
                // });

            });
        }
    }
})();

(function ()
{
  'use strict';

  angular.module('app.sprardb.amministrazione', []).config(config);

  /** @ngInject */
  function config($stateProvider)
  {

    $stateProvider
      .state('app.sprardb_amministrazione_bando', {
        url: '/sprardb/amministrazione/bando',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/amministrazione/bando/bando.html',
            controller: 'BandoController as vm'
          }
        }
      })
      .state('app.sprardb_amministrazione_corsi', {
        url: '/sprardb/amministrazione/corsi',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/amministrazione/corsi/corsi.html',
            controller: 'CorsiController as vm'
          }
        }
      })
      .state('app.sprardb_amministrazione_servizi', {
        url: '/sprardb/amministrazione/servizi',
        views: {
          'content@app': {
            templateUrl: 'app/main/sprardb/amministrazione/servizi/servizi.html',
            controller: 'ServiziController as vm'
          }
        }
      });
  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.amministrazione')
        .controller('ServiziController', ServiziController)
        .controller('GestioneServiziController', GestioneServiziController);

  /** @ngInject */
  function ServiziController($scope, $mdToast, $mdSidenav, $mdDialog, api)
  {
    var vm = this;

    vm.toggleSidenav = toggleSidenav;
    vm.nuovoServizio = nuovoServizio;
    vm.updateServizio = updateServizio;
    vm.loadServizi = loadServizi;
    vm.loadCategorie = loadCategorie;
    vm.cancellaServizio = cancellaServizio;
    vm.reload = reload;
    vm.onSearch = onSearch;

    vm.api = api;
    vm.search = {
      sort: 'servizi_id,id',
      'per-page': 10,
      page: 1
    };
    vm.quadrimestri = {1:'Q1',2:'Q2',3:'Q3'};

    vm.viewServizi = api.user.permissions.includes('edit-servizi');
    if(vm.viewServizi) {
      reload();
    }

    function reload() {
      loadServizi();
      loadCategorie();
    }

    function loadCategorie() {
      var params = {
        filter: {
          servizi_id: null
        },
      };

      vm.categorie = api.servizi.query(params,function(res){});
    }

    function cancellaServizio(ev, item) {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler cancellare questo servizio?')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.servizi.delete(item, function(res) {
          reload();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Servizio cancellato correttamente')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function updateServizio(ev, item) {
      $mdDialog.show({
        controller: 'GestioneServiziController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/amministrazione/dialogs/new-servizio.html',
        targetEvent: ev,
        locals: {
          categorie: vm.categorie,
          servizio: item
        },
        clickOutsideToClose: true
      }).then(reload);
    }

    function loadServizi()
    {

      var params = {
        filter: {
          servizi_id: vm.selectedCategoria
        }
      }

      if (vm.descrizioneSearch) {
        params.filter.or = [
          {descrizione: {xlike: vm.descrizioneSearch + '%'}},
          {descrizione: {like: ' ' + vm.descrizioneSearch}}
        ]
      }

      angular.merge(params, vm.search);

      vm.servizi = api.servizi.index(params,function(res){
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });

    }

    function onSearch()
    {
      initPagination();
      loadServizi();
    }

    function toggleSidenav(sidenavId)
    {
        $mdSidenav(sidenavId).toggle();
    }

    function initPagination()
    {
      vm.search.page = 1;
      vm.search['per-page'] = 10;
    }

    function nuovoServizio(ev)
    {
      $mdDialog.show({
        controller: 'GestioneServiziController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/amministrazione/dialogs/new-servizio.html',
        targetEvent: ev,
        locals: {
          categorie: vm.categorie,
          servizio: {}
        },
        clickOutsideToClose: true
      }).then(reload);
    }
  }

  /** @ngInject */
  function GestioneServiziController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api, locals)
  {
    var vmd = this;
    vmd.close = close;
    vmd.salva = salva;

    vmd.categorie = locals.categorie;
    vmd.servizio = locals.servizio;
    vmd.titolo = Object.keys(vmd.servizio).length === 0 ? "Nuovo Servizio" : "Modifica Servizio";

    function salva()
    {
      vmd.saving = true;

      api.servizi.save(vmd.servizio, function(response){
        $mdDialog.hide().then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent('Servizio correttamente salvato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function close() {
      $mdDialog.cancel();
    }


  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.amministrazione')
        .controller('CorsiController', CorsiController)
        .controller('GestioneCorsiController', GestioneCorsiController);

  /** @ngInject */
  function CorsiController($scope, $mdToast, $mdSidenav, $mdDialog, api)
  {
    var vm = this;

    vm.toggleSidenav = toggleSidenav;
    vm.nuovoCorso = nuovoCorso;
    vm.updateCorso = updateCorso;
    vm.loadCorsi = loadCorsi;
    vm.loadCategorie = loadCategorie;
    vm.cancellaCorso = cancellaCorso;
    vm.reload = reload;
    vm.onSearch = onSearch;

    vm.api = api;
    vm.search = {
      sort: 'corsi_id,id',
      'per-page': 10,
      page: 1
    };
    vm.quadrimestri = {1:'Q1',2:'Q2',3:'Q3'};

    vm.viewCorsi = api.user.permissions.includes('edit-corsi');
    if(vm.viewCorsi) {
      reload();
    }

    function reload() {
      loadCorsi();
      loadCategorie();
    }

    function loadCategorie() {
      var params = {
        filter: {
          corsi_id: null
        },
      };

      vm.categorie = api.corsi.query(params,function(res){});
    }

    function cancellaCorso(ev, item) {
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler cancellare questo corso?')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.corsi.delete(item, function(res) {
          reload();
          $mdToast.show(
            $mdToast.simple()
              .textContent('Corso cancellato correttamente')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function updateCorso(ev, item) {
      $mdDialog.show({
        controller: 'GestioneCorsiController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/amministrazione/dialogs/new-corso.html',
        targetEvent: ev,
        locals: {
          categorie: vm.categorie,
          corso: item
        },
        clickOutsideToClose: true
      }).then(reload);
    }

    function loadCorsi()
    {

      var params = {
        filter: {
          corsi_id: vm.selectedCategoria
        }
      }

      if (vm.descrizioneSearch) {
        params.filter.or = [
          {descrizione: {xlike: vm.descrizioneSearch + '%'}},
          {descrizione: {like: ' ' + vm.descrizioneSearch}}
        ]
      }

      angular.merge(params, vm.search);

      vm.corsi = api.corsi.index(params,function(res){
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });

    }

    function onSearch()
    {
      initPagination();
      loadCorsi();
    }

    function toggleSidenav(sidenavId)
    {
        $mdSidenav(sidenavId).toggle();
    }

    function initPagination()
    {
      vm.search.page = 1;
      vm.search['per-page'] = 10;
    }

    function nuovoCorso(ev)
    {
      $mdDialog.show({
        controller: 'GestioneCorsiController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/amministrazione/dialogs/new-corso.html',
        targetEvent: ev,
        locals: {
          categorie: vm.categorie,
          corso: {}
        },
        clickOutsideToClose: true
      }).then(reload);
    }
  }

  /** @ngInject */
  function GestioneCorsiController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api, locals)
  {
    var vmd = this;
    vmd.close = close;
    vmd.salva = salva;

    vmd.categorie = locals.categorie;
    vmd.corso = locals.corso;
    vmd.titolo = Object.keys(vmd.corso).length === 0 ? "Nuovo Corso" : "Modifica Corso";

    function salva()
    {
      vmd.saving = true;
      var payload = vmd.corso;

      api.corsi.save(payload, function(response){
        $mdDialog.hide().then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent('Costo correttamente salvato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        });
      });
    }

    function close() {
      $mdDialog.cancel();
    }


  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.amministrazione')
        .controller('BandoController', BandoController)
        .controller('GestioneBandoController', GestioneBandoController);

  /** @ngInject */
  function BandoController($scope, $mdDialog, api)
  {
    var vm = this;

    vm.nuovoBando = nuovoBando;
    vm.loadBando = loadBando;
    vm.onSearch = onSearch;
    vm.updateBando = updateBando;

    vm.api = api;
    vm.search = {
      // 'per-page': 10,
      // page: 1,
      sort: '-id'
    };

    vm.viewBandi = api.user.permissions.includes('view-bandi');
    if(vm.viewBandi) {
      loadBando();
    }

    function loadBando()
    {
      var params = {};
      if (vm.descrizioneSearch) {
        params = {filter: {
            or: [
              {descrizione: {xlike: vm.descrizioneSearch + '%'}},
              {descrizione: {like: ' ' + vm.descrizioneSearch}}
            ]
          }};

      }
      angular.merge(params, vm.search);

      vm.bandi = api.bando.index(params,function(res){
        // vgiacomini: necessario per un bug paginazione md-data-table
        // vm.totalCount = res._meta.totalCount;
      });
    }

    function updateBando (ev, item){
      $mdDialog.show({
        controller: 'GestioneBandoController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/amministrazione/bando/new-bando.html',
        targetEvent: ev,
        locals: {
          bando: item
        },
        clickOutsideToClose: true
      }).then(loadBando);
    }

    function onSearch()
    {
      // initPagination();
      loadBando();
    }

    // function initPagination()
    // {
    //   vm.search.page = 1;
    //   vm.search['per-page'] = 10;
    // }

    function nuovoBando(ev)
    {
      $mdDialog.show({
          controller: 'GestioneBandoController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/amministrazione/bando/new-bando.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          locals:{
            bando: {
              attivo: 1,
              dataInizio: null,
              dataFine: null,
            }
          }
      }).then(loadBando);
    }
  }

  /** @ngInject */
  function GestioneBandoController($scope, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api, locals)
  {
    var vmd = this;
    vmd.close = close;
    vmd.salva = salva;

    vmd.gruppi = [
      "",
      "DM-DS",
      "FAMI",
      "FER",
      "ISAF",
      "MSNA",
      "ORD",
      "RES"
    ]

    vmd.bando = locals.bando;

    vmd.titolo = vmd.bando.dataInizio !== null ? "Modifica Bando": "Nuovo Bando";

    function salva()
    {
      var payload = vmd.bando;

      api.bando.save(payload, function(response){
        $mdDialog.hide().then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent('Bando correttamente salvato.')
              .position('bottom right')
              .hideDelay(5000)
          )
        });
      });
    }

    function close() {
      $mdDialog.cancel();
    }
  }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.video', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {



        $stateProvider.state('app.sprardb_video', {
            url: '/sprardb/videotutorial/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/video/video.html',
                    controller: 'VideoController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/video');




        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.video')
        .controller('VideoController', VideoController)
        .filter('youtubeEmbedUrl', function ($sce) {
            return function(videoId) {
                return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+ videoId +'?rel=0&modestbranding=1');
            };
        });


    /** @ngInject */
    function VideoController($scope, $stateParams, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        vm.videoid = $stateParams.id;

    }


})();

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';
    angular.module('app.sprardb.userprofile', []).config(config);
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider
                .state('app.sprardb_userprofile', {
                    url: '/sprardb/userprofile',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/userprofile/userprofile.html',
                            controller: 'UserprofileController as vm'
                        }
                    }

                });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/userprofile');
        // Navigation
//        msNavigationServiceProvider.saveItem('sprardb.userprofile', {
//            title: 'Userprofile',
//            icon: 'icon-person-box',
//            state: 'app.sprardb_userprofile',
//            weight: 1
//        });
    }
})();





/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function () {
    'use strict';
    angular.module('app.sprardb.userprofile').controller('UserprofileController', UserprofileController);
    function UserprofileController($scope, $mdSidenav, $mdDialog, $timeout, $cookieStore, $state, $document, api, $http, $base64) {
        var vm = this;
        vm.toggleSidenav = toggleSidenav;
        var user = $cookieStore.get('user');
        vm.title = "Il mio profilo";
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.sprardb.test', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.sprardb_test', {
            url  : '/sprardb/test',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/test/test.html',
                    controller : 'TestController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sprardb.test')
        .controller('TestController', TestController);

    /** @ngInject */
    function TestController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.tags', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {
        $stateProvider.state('app.sprardb_tags', {
            url: '/sprardb/tags/:tagtipo',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/tags/tags.html',
                    controller: 'TagsController as vm'
                }
            }

        });
        $stateProvider.state('app.sprardb_listae', {
            url: '/sprardb/listae/:parametro/:valore',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/tags/listae.html',
                    controller: 'ListaEController as vm'
                }
            },
            resolve: {}
        });
        $stateProvider.state('app.sprardb_listap', {
            url: '/sprardb/listap/:parametro/:valore',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/tags/listap.html',
                    controller: 'ListaPController as vm'
                }
            },
            resolve: {}
        });

        msNavigationServiceProvider.saveItem('sprardb.rubrica.listedistribuzione', {
            title: 'Liste Distribuzione',
            icon: 'icon-view-list',
            state: 'app.sprardb_tags',
            weight: 10
        });

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.tags')
            .controller('TagsDialogController', TagsDialogController)
            .controller('TagsEDialogController', TagsEDialogController)
            .controller('TagsController', TagsController)
            .controller('ListaEController', ListaEController)
            .controller('ListaPController', ListaPController);

    /** @ngInject */
    function TagsDialogController(msUtils, $mdDialog, api, $filter, $mdToast, locals)
    {
        console.log('controller tags');
        var vmd = this;
        vmd.tags = locals.Tags;
        vmd.tipotag = locals.TipoTag;
        vmd.alltags = null;
        vmd.titolo = "Visualizza Tags";
        vmd.entita = "Tag";
        if (vmd.tipotag.join().indexOf("lista") > -1) {
            vmd.titolo = "Visualizza Lista";
            vmd.entita = "Lista";
        }
//        console.log(vmd.tipotag.join());
//        api.tags.tag.like({tipo_IN: vmd.tipotag.join()}, function (d) {
//            vmd.alltags = d.data;
//        });

        vmd.cancel = cancel;
        function cancel() {
            $mdDialog.cancel();
        }

    }
    function TagsEDialogController(msUtils, $mdDialog, api, $filter, $mdToast, locals, $state)
    {
        console.log('controller E tags');
        var vmd = this;
        vmd.selected = {};
        vmd.selected.tagnew = "";
        vmd.tags = locals.Tags;
        vmd.tipotag = locals.TipoTag;
        vmd.selectedItems = locals.selected;
        vmd.alltags = null;
        vmd.titolo = "Modifica Tags";
        vmd.entita = "Tag";
        if (vmd.tipotag.join().indexOf("lista") > -1) {
            vmd.titolo = "Modifica Lista";
            vmd.entita = "Lista";
        }
        var results0 = null;
        var results1 = null;
        var jsonfilter = {};
        jsonfilter = JSON.parse('{"tipo":"' + vmd.tipotag.join() + '"}');
        results0 = $filter('filter')(vmd.tags, jsonfilter);
        results1 = $filter('unique')(results0, "id");
        //console.log('results1');
        //console.log(results1);
        //vmd.selected.tags = results1;
        vmd.tags = results1;
        api.tags.tag.like({tipo_IN: vmd.tipotag.join(), sort: "tag"}, function (d) {
            vmd.alltags = d.data;
        });

        vmd.cancel = cancel;
        function cancel() {
            $mdDialog.cancel();
        }

        vmd.test = test;
        function test() {
            console.log(vmd.selected.tags);
//elimino doppioni
            var results0 = null;
            results0 = $filter('unique')(vmd.selected.tags, "id");
            vmd.selected.tags = results0;
            console.log(vmd.selected.tags);
        }

        vmd.assegna = assegna;
        function assegna() {

            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Aggiornamento ' + vmd.entita + ' in corso.')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            if (vmd.selected.tagnew !== "") {
                //nuova lista
                var payloadnew = {};
                var inserted = {};
                payloadnew.tag = vmd.selected.tagnew;
                payloadnew.tipo = vmd.tipotag[0];
                payloadnew.privato = 0;
                api.tags.tag.save(payloadnew, function (s) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Creazione nuovo/a ' + vmd.entita)
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    console.log(s);
                    inserted = s;
                    vmd.selected.tags.push(inserted);
                    aggiorna();
                });
            } else {
                aggiorna();
            }

        }

        function aggiorna() {
            var templateHasmany = {};
            templateHasmany.listaente = {
                modelrelation: 'Entehastag',
                idname: 'ente_id',
                idvalue: 0, //dainserire
                idnamefk: 'tag_id',
                idnamePayload: 'tag_id',
                payload: null, //dainserire
                delete: true
            };
            templateHasmany.listapersona = {
                modelrelation: 'Personahastag',
                idname: 'persona_id',
                idvalue: 0, //dainserire
                idnamefk: 'tag_id',
                idnamePayload: 'tag_id',
                payload: null, //dainserire
                delete: true
            };
            templateHasmany.progetto = {
                modelrelation: 'Progettohastag',
                idname: 'progetto_id',
                idvalue: 0, //dainserire
                idnamefk: 'tag_id',
                idnamePayload: 'tag_id',
                payload: null, //dainserire
                delete: true
            };
            //console.log(templateHasmany);
            var results0 = null;
            var hasmanies = [];
            results0 = $filter('unique')(vmd.selected.tags, "id");
//            console.log('results0');
//            console.log(results0);
//            console.log('vmd.selectedItems');
//            console.log(vmd.selectedItems);
            angular.forEach(vmd.selectedItems, function (item) {
                var originaltags = angular.copy(item.tags);
//                console.log(originaltags);
                var indextags = 0;
                angular.forEach(originaltags, function (originaltag) {
                    if (originaltag.tipo === vmd.tipotag.join()) {
                        delete(originaltags[indextags]);
                    }
                    indextags++;
                });
//                console.log("originaltags");
//                console.log(originaltags);


                var payload = [];
                var hasmany = {};
                var onlypayload = {};
                var e1 = vmd.tipotag[0];
                angular.forEach(results0, function (obj) {
//                    console.log("obj:results0");
//                    console.log(obj);
                    onlypayload['tag_id'] = obj.id;
                    var entityname = templateHasmany[e1]['idname'];
//                    console.log('entityname');
//                    console.log(entityname);
                    onlypayload[entityname] = item.id;
//                    console.log('onlypayload');
//                    console.log(onlypayload);
                    //payload.push({ente_id: item.id, tag_id: obj.id});
                    payload.push(onlypayload);
                    onlypayload = {};
                });
                angular.forEach(originaltags, function (obj) {
//                    console.log("obj:originaltags");
//                    console.log(obj);
                    onlypayload['tag_id'] = obj.id;
                    var entityname = templateHasmany[e1]['idname'];
//                    console.log('entityname');
//                    console.log(entityname);
                    onlypayload[entityname] = item.id;
//                    console.log('onlypayload');
//                    console.log(onlypayload);
                    //payload.push({ente_id: item.id, tag_id: obj.id});
                    payload.push(onlypayload);
                    onlypayload = {};

                });
//                console.log("payload");
//                console.log(payload);
                if (payload.length > 0) {
                    hasmany = angular.copy(templateHasmany[e1]);
                    hasmany.idvalue = item.id;
                    hasmany.payload = payload;
//                    hasmany = {
//                        modelrelation: 'Entehastag',
//                        idname: 'ente_id',
//                        idvalue: item.id,
//                        idnamefk: 'tag_id',
//                        idnamePayload: 'tag_id',
//                        payload: payload,
//                        delete: true
//                    };
                    hasmanies.push(angular.copy(hasmany));
                }

            });
            console.log(hasmanies);
            var howmany = 0;
            var ii = 0;
            howmany = hasmanies.length;
            angular.forEach(hasmanies, function (hm) {
                api.entes.ente.hasmany(hm, function (d) {
                    console.log(d);
                    if (ii == howmany) {
                        $mdDialog.hide();
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Aggiornamento ' + vmd.entita + ' completato.')
                                .position('bottom right')
                                .hideDelay(2000)
                                ).then(
                                $state.reload()
                                );
                    }
                });
                ii++;
            });
        }

    }

    function TagsController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        //sidenavs popolamento

        vm.searchForms = {
            "tipo_IN": {
                type: "string",
                title: "Tipo Lista",
                description: "tipo Lista...",
                callbackModel: "ricerca",
                dbfield: "tipo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tag": {
                type: "string",
                title: "Lista distribuzione",
                description: "In lista...",
                callbackModel: "ricerca",
                dbfield: "tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            }

        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.lcolors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.tipos = ricerca.tipolista;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
            vm.allsearchs['query[]'][1]['tipo_IN'] = ["listaente", "listapersona"];
            api.tags.liste.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo_IN: "listaente,listapersona"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.deletetag = deletetag;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 10000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.entes.ente.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function deletetag(tag) {
            console.log(tag);
            var confirm = $mdDialog.confirm()
                    .title('Elimina ' + tag.tag)
                    .textContent('Sei sicuro di voler porcedere?')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Elimina!')
                    .cancel('Abbandona');
            $mdDialog.show(confirm).then(function () {
                api.tags.tag.remove({id: tag.id}, function (d) {
                    $state.reload();
                });
            }, function () {

            });

        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }
        ;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: obj});

        }


        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].tag = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (angular.isUndefined(vm.ricerca['tipo_IN'])) {
                vm.ricerca['tipo_IN'] = ["listaente", "listapersona"];
            }

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
//            if (angular.isUndefined(vm.allsearchs['query[]'][1]['tipo_IN'])) {
//                vm.allsearchs['query[]'][1]['tipo_IN'] = "listaente,listapersona";
//            }
            api.tags.liste.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

    function ListaEController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);

        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "attivo": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoattivo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasentes-enteRuolo_id_IN": {
                type: "string",
                title: "Ruolo",
                description: "Ruolo...",
                callbackModel: "ricerca",
                dbfield: "progettohasentes-enteRuolo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.enteruolos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "enteTipo...",
                callbackModel: "ricerca",
                dbfield: "enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatore": {
                type: "string",
                title: "segnalatore",
                description: "Segnaltore...",
                callbackModel: "ricerca",
                dbfield: "segnalatore",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-id": {
                type: "string",
                title: "Con progetti",
                description: "Con progetti...",
                callbackModel: "ricerca",
                dbfield: "progettos-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "strutturas-id": {
                type: "string",
                title: "Con strutture",
                description: "Con strutture...",
                callbackModel: "ricerca",
                dbfield: "strutturas-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personas-id": {
                type: "string",
                title: "Con persone",
                description: "Con persone...",
                callbackModel: "ricerca",
                dbfield: "personas-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tags-id": {
                type: "string",
                title: "Tags",
                description: "Con tags...",
                callbackModel: "ricerca",
                dbfield: "tags-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tags",
                chiave: "id",
                valore: "tag|uppercase"
            },
            "tags-tag": {
                type: "string",
                title: "Lista distribuzione",
                description: "In lista...",
                callbackModel: "ricerca",
                dbfield: "tags-tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            }

        };

        vm.preparati = false;
        vm.entesfileds = {'nome': 'Nome', 'email': 'E-mail', 'indirizzo': 'Indirizzo', 'telefono': 'Telefono'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.entetipos = ricerca.enteprimosettores;
        vm.regiones = ricerca.regiones;
        vm.enteruolos = ricerca.enteruoloprogettos;
        vm.provincias = ricerca.provincias;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
            console.log(vm.allsearchs);
            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
                vm.nomelista = $state.params.valore;
                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
            }
            console.log(vm.allsearchs);
            api.entes.ente.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listaente"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'nome': 'Nome', 'email': 'E-mail', 'indirizzo': 'Indirizzo', 'telefono': 'Telefono'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 10000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'nome,email,indirizzo,telefono';
            api.entes.ente.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }
        ;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: obj});

        }


        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.entes.ente.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

    function ListaPController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);

        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "personahasprogettos-personaRuolo_id_IN": {
                type: "string",
                title: "Ruolo",
                description: "Ruolo...",
                callbackModel: "ricerca",
                dbfield: "personahasprogettos-personaRuolo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.enteruolos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-id": {
                type: "string",
                title: "Con progetti",
                description: "Con progetti...",
                callbackModel: "ricerca",
                dbfield: "progettos-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tags-id": {
                type: "string",
                title: "Tags",
                description: "Con tags...",
                callbackModel: "ricerca",
                dbfield: "tags-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tags",
                chiave: "id",
                valore: "tag|uppercase"
            },
            "tags-tag": {
                type: "string",
                title: "Lista distribuzione",
                description: "In lista...",
                callbackModel: "ricerca",
                dbfield: "tags-tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            }

        };

        vm.preparati = false;
        vm.entesfileds = {'nome': 'Nome', 'email': 'E-mail', 'indirizzo': 'Indirizzo', 'telefono': 'Telefono'};
        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.entetipos = ricerca.enteprimosettores;
        vm.regiones = ricerca.regiones;
        vm.enteruolos = ricerca.personaruoloprogettos;
        vm.provincias = ricerca.provincias;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
            console.log(vm.allsearchs);
            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
                vm.nomelista = $state.params.valore;
                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
            }
            console.log(vm.allsearchs);
            api.personas.persona.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listapersona"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'nome': 'Nome', 'email': 'E-mail', 'indirizzo': 'Indirizzo', 'telefono': 'Telefono'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 10000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.personas.persona.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }
        ;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_personasdettaglio', {id: obj});

        }


        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.personas.persona.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function ()
{
    'use strict';
    angular.module('app.sprardb.statusg', []).config(config);
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.sprardb_statusgricerca', {
            url: '/sprardb/statusgricerca',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/statusg/statusg.html',
                    controller: 'StatusgRicercaController as vm'
                }
            }

        });
//        $stateProvider.state('app.sprardb_notification.newreport', {
//            url: '/report',
//            views: {
//                'content@app': {
//                    templateUrl: 'app/main/sprardb/notification/notification-details.html',
//                    controller: 'NotificationDetailController as vm'
//                }
//            }
//        });
        $stateProvider.state('app.sprardb_statusgricerca.edit', {
            url: '/report/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/statusg/statusg-details.html',
                    controller: 'StatusgDetailController as vm'
                }
            }
        });
//        $stateProvider.state('app.sprardb_notification.segnalatori', {
//            url: '/segnalatori',
//            views: {
//                'content@app': {
//                    templateUrl: 'app/main/sprardb/notification/segnalatori.html',
//                    controller: 'SegnalatoriController as vm'
//                }
//            }
//        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/statusg');
        // Api
        //msApiProvider.register('beneficiario', ['http://localhost/sprardb/app-server/web/segnalaziones/search']);
        // Navigation
        msNavigationServiceProvider.saveItem('sprardb.statusg', {
            title: 'status giuridico',
            icon: 'icon-backup-restore',
            state: 'app.sprardb_statusgricerca',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.statusg.new', {
            title: 'Nuovo status giuridico',
            icon: 'icon-message-draw',
            state: 'app.sprardb_statusg_new',
            weight: 2
        });
//        msNavigationServiceProvider.saveItem('sprardb.notification.news', {
//            title: 'Nuovo Segnalatore',
//            icon: 'icon-account-network',
//            state: 'app.sprardb_auth_register',
//            weight: 3
//        });
//        msNavigationServiceProvider.saveItem('sprardb.notification.seg', {
//            title: 'Lista enti segnalatori',
//            icon: 'icon-view-list',
//            state: 'app.sprardb_notification.segnalatori',
//            weight: 4
//        });
    }
})();



(function ()
{
    'use strict';
    angular
            .module('app.sprardb.statusg')
            .controller('StatusgRicercaController', StatusgRicercaController)
            .controller('StatusgDetailController', StatusgDetailController)
            .controller('ProcessoController', ProcessoController);
    function StatusgRicercaController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, $timeout) {
        var vm = this;
        // Data
        vm.Beneficiari = null;
        api.beneficiarios.beneficiario.get({}, function (response) {
            vm.Beneficiari = response;
            vm.beneficiari = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });
        vm.nazioni = null;
        vm.religioni = null;
        vm.documentotipo = null;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "400"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.progettos.progetto.cerca({sort: "nome", pagination: "400", fields: "id,nome"}, function (response) {
            vm.progettos = response.data;
        });
        api.strutturas.strutturamin.cerca({sort: "nome", pagination: "600", fields: "id,nome,progetto_id"}, function (response) {
            vm.strutturas = response.data;
        });
        vm.selected = [];
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.query = {
            sort: '-id',
            perPage: 5,
            page: 1
        };
        vm.limitOptions = [5, 10, 15, 20];
        vm.allFields = true;
        vm.beneficiario = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneNascita: null,
            idNazioneProvenienza: null,
            idNazioneCittadinanza: null,
            gruppoEtnico: null,
            idReligione: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            note: null,
            noteSanitarie: null,
            beneficiarioAttributis: [],
            strutturas: [],
            beneficiarioextras: [],
            idTipoIngresso: '28',
            idTipoDocumento: '581',
            dataIngresso: null,
            dataIngresso2: null,
            dataInserimento: null,
            dataInserimento2: null,
            tipoIngresso: 'SC',
            nucleoFamiliare: '0',
            stato: 'LIBERO'
        };
        vm.ricerca = {
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneProvenienza: null,
            dataNascita: null,
            dataIngresso: null,
            stato: null,
        };
        vm.ricerca2 = "";
        vm.search2 = {};
        vm.selectedBeneficiarios = [];
        vm.selectedContacts = [];
        vm.ricercalabel = {
            nome: 'Nome: ',
            cognome: 'Cognome: ',
            sesso: 'Sesso: ',
            idNazioneProvenienza: 'Nazione: ',
            dataNascita: 'Data di nascita: ',
            dataIngresso: 'Data di Ingresso: ',
            stato: 'Stato: ',
            stringa: 'Chiave di ricerca:'
        };
        vm.ricercalabel['strutturas-progetto_id'] = 'Progetto: ';
        vm.ricercalabel['strutturas-id'] = 'Struttura: ';
        vm.searched = false;
        vm.listOrderAsc = true;
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 5;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.gotoDettaglio = gotoDettaglio;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
            console.log(vm.allsearchs);
            //vm.beneficiari = api.beneficiarios.beneficiario.like(vm.allsearchs).promise;
//            vm.Beneficiari = $timeout(function () {
//                vm.Beneficiari = api.beneficiarios.beneficiario.like(vm.allsearchs).$promise;
//                vm.Beneficiari.then(function (d) {
//                    vm.beneficiari = d.data;
//                });
//            }, 2000);
//            console.log(vm.beneficiari);


            api.beneficiarios.beneficiario.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.Beneficiari = d;
                vm.beneficiari = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        function gotoDettaglio(id)
        {
            $state.go('app.sprardb_beneficiario', {id: id});
        }
        function toggleSelectContact(contact, event) {
            if (event) {
                event.stopPropagation();
            }
            vm.selectedContacts = [];
            vm.selectedContacts.push(contact);
            console.log(vm.selectedContacts);
        }
        function deselectContacts() {
            vm.selectedContacts = [];
        }
        function selectAllContacts() {
            vm.selectedContacts = $scope.filteredContacts;
        }

    }

    function StatusgDetailController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, $timeout, $stateParams) {
        var vm = this;
        // Data
        vm.Beneficiario = {};
        vm.beneficiario = {};
        vm.Eventotipos = {};
        vm.eventotipos = {};
        vm.eventostatos = {};
        vm.Eventi = {};
        vm.eventi = {};
        vm.eventiFiltrare = [];
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 20;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;
        vm.statusgiuridicos = {};
        vm.limitOptions = [5, 10, 15, 20];
        vm.extrasetup = {};
        vm.notselectable = [];
        api.beneficiarios.beneficiario.get({id: $stateParams.id}, function (response) {
            vm.Beneficiario = response;
            vm.beneficiario = response;
            //console.log(vm.beneficiario);
            api.eventos.tipo.cerca({sort: "id", model: "app\\models\\Statusg", pagination: 50}, function (response) {
                vm.Eventotipos = response;
                vm.eventotipos = response.data;
                angular.forEach(vm.eventotipos, function (obj) {
                    vm.eventiFiltrare.push(obj.id);
                });
                vm.allsearchs['query[]'][1].eventoTipo_id_IN = vm.eventiFiltrare.join();
                vm.allsearchs['query[]'][1].entita1_id = vm.beneficiario.id;
                //console.log(vm.allsearchs);
                api.eventos.evento.cerca(vm.allsearchs, function (response) {
                    vm.Eventi = response;
                    vm.eventi = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    angular.forEach(vm.eventi, function (obj) {
                        obj.extra = JSON.parse(obj.extra);
                        obj.processi = obj.eventoTipo.processo.split("|");
                        if (obj.eventoStato_id < 4) {
                            vm.notselectable.push(obj.eventoTipo_id);
                            console.log(vm.notselectable);
                        }
                    });
                    //console.log(vm.eventi);
                });
            });
        });
        api.eventos.stato.get({sort: 'id'}, function (response) {
            vm.eventostatos = response.data;
        });
        vm.showdetails = false;
        vm.selected = [];
        vm.eventoTipo_id = null;
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.limitOptions = [5, 10, 15, 20];
        vm.allFields = true;
        vm.evento = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneNascita: null,
            idNazioneProvenienza: null,
            idNazioneCittadinanza: null,
            gruppoEtnico: null,
            idReligione: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            note: null,
            noteSanitarie: null,
            beneficiarioAttributis: [],
            strutturas: [],
            beneficiarioextras: [],
            idTipoIngresso: '28',
            idTipoDocumento: '581',
            dataIngresso: null,
            dataIngresso2: null,
            dataInserimento: null,
            dataInserimento2: null,
            tipoIngresso: 'SC',
            nucleoFamiliare: '0',
            stato: 'LIBERO'
        };
        vm.onSearch = onSearch;
        function onSearch() {
            //nome
//            vm.allsearchs['query[]'] = [];
//            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
//            if (vm.ricerca2) {
//                vm.allsearchs['query[]'][0].operatore = 'OR';
//                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
//                vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
//            }
//
//            angular.forEach(vm.ricerca, function (value, key) {
//                if (value === null || value === 'null') {
//                    delete vm.ricerca[key];
//                }
//            });
//            if (vm.ricerca) {
//                vm.ricerca.operatore = 'AND'
//                vm.allsearchs['query[]'][1] = vm.ricerca;
//            }



            api.eventos.evento.search(vm.allsearchs, function (response) {
                vm.Eventi = response;
                vm.eventi = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                angular.forEach(vm.eventi, function (obj) {
                    obj.extra = JSON.parse(obj.extra);
                });
            }
            );
            vm.searched = true;
        }

        vm.work = work;
        function work(evento, nuovoStato, event, isnew) {

            angular.forEach(vm.eventotipos, function (obj) {
                vm.extrasetup = JSON.parse(obj.extra);
            });
            console.log(vm.beneficiario.id);
            $mdDialog.show({
                controllerAs: 'vm',
                clickOutsideToClose: true,
                controller: 'ProcessoController',
                targetEvent: event,
                templateUrl: 'app/main/sprardb/statusg/dialogs/processo.html',
                locals: {
                    evento: evento,
                    nuovoStato: nuovoStato,
                    isnew: isnew,
                    extrasetup: vm.extrasetup,
                    eventoTipo_id: evento,
                    beneficiario_id: vm.beneficiario.id
                }
            }).then(function (response) {

            });
        }
        vm.newwork = newwork;
        function newwork(evento, nuovoStato, event, isnew) {

            angular.forEach(vm.eventotipos, function (obj) {
                vm.extrasetup = JSON.parse(obj.extra);
            });
            $mdDialog.show({
                controllerAs: 'vm',
                clickOutsideToClose: true,
                controller: 'ProcessoController',
                targetEvent: event,
                templateUrl: 'app/main/sprardb/statusg/dialogs/processo.html',
                locals: {
                    evento: evento,
                    nuovoStato: 1,
                    isnew: isnew,
                    extrasetup: vm.extrasetup,
                }
            }).then(function (response) {
                console.log(response);
            });
        }
    }
    function ProcessoController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, $timeout, locals, $cookies) {
        var vm = this;
        vm.isnew = locals.isnew;
        vm.view = false;
        if (vm.isnew === 'readonly') {
            vm.isnew = false;
            vm.view = true;
        }
        vm.user = $cookies.getObject('user');
        vm.evento = {};
        vm.evento = locals.evento;
        vm.extrasetup = locals.extrasetup;
        console.log(locals);
        if (vm.isnew) {
            vm.evento = {
                dataInserimento: null,
                dataInizio: null,
                dataFine: null,
                dataAlert: null,
                eventoTipo_id: locals.eventoTipo_id,
                eventoStato_id: 1,
                entita1_id: locals.beneficiario_id,
                alert: 1,
                da: vm.user.email,
                a: null,
                cc: null,
                ordine: 0,
                extra: vm.extrasetup
            };
        }
        vm.evento.dataInserimento2 = new Date(vm.evento.dataInserimento);
        vm.evento.dataInizio2 = new Date(vm.evento.dataInizio);
        vm.evento.dataFine2 = new Date(vm.evento.dataFine);
        vm.evento.dataAlert2 = new Date(vm.evento.dataAlert);
        if (!vm.evento.dataInserimento) {
            vm.evento.dataInserimento2 = new Date();
        }
        if (!vm.evento.dataInizio) {
            vm.evento.dataInizio2 = new Date();
        }
        if (!vm.evento.dataFine) {
            vm.evento.dataFine2 = new Date();
        }
        if (!vm.evento.dataAlert) {
            vm.evento.dataAlert2 = new Date();
        }


        vm.colors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'];
        vm.nuovostato = locals.nuovoStato;
        vm.eventostatos = {};
        api.eventos.stato.get({id: vm.nuovostato}, function (response) {
            vm.eventostatos = response;
        });
        vm.commissiones = {};
        api.entes.ente.search({enteTipo_id: 7, pagination: 400, sort: 'nome'}, function (d) {
            vm.commissiones = d.data;
        });
        angular.forEach(vm.extrasetup, function (value, key) {
            console.log(key);
            if (!vm.evento.extra[key]) {
                vm.evento.extra[key] = value;
            }
        });
        console.log(vm.evento);
        vm.saveDialog = saveDialog;
        function saveDialog() {
            if (!vm.isnew) {
                var m = moment(vm.evento.dataInizio2);
                vm.evento.dataInizio = m.format("YYYY-MM-DD");
                m = moment(vm.evento.dataFine2);
                vm.evento.dataFine = m.format("YYYY-MM-DD");
                m = moment(vm.evento.dataAlert2);
                vm.evento.dataAlert = m.format("YYYY-MM-DD");
                vm.evento.eventoStato_id = vm.nuovostato;
                vm.evento.alert = 0;
                vm.evento.da = vm.user.email;
                vm.eventoU = angular.copy(vm.evento);
                delete(vm.eventoU._links);
                delete(vm.eventoU.eventoStato);
                delete(vm.eventoU.eventoTipo.eventoStato);
                delete(vm.eventoU.eventoTipo.processi);
                vm.eventoU.extra = JSON.stringify(vm.evento.extra);
                api.eventos.evento.aggiorna(vm.eventoU, function (d) {
                    //
                    $mdDialog.hide(vm.evento);

                    $state.reload();
                });
            }
            if (vm.isnew) {
                var m = moment(vm.evento.dataInserimento2);
                vm.evento.dataInserimento = m.format("YYYY-MM-DD");
                m = moment(vm.evento.dataAlert2);
                vm.evento.dataAlert = m.format("YYYY-MM-DD");
                vm.eventoU = angular.copy(vm.evento);
                delete(vm.eventoU.dataFine);
                vm.eventoU.extra = JSON.stringify(vm.evento.extra);
                api.eventos.evento.save(vm.eventoU, function (d) {
                    $mdDialog.hide(vm.evento);
                    $state.reload();
                });
            }

        }
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();


(function ()
{
    'use strict';

    angular
            .module('app.sprardb', [
                //contatti
                'app.sprardb.contatti',
                'app.sprardb.entes',
                'app.sprardb.enti',
                'app.sprardb.personas',
                //amministrazione
                'app.sprardb.amministrazione',
                //configurazioni
                'app.sprardb.configurazioni.personaruolos',
                'app.sprardb.configurazioni.entetipos',
                'app.sprardb.configurazioni.enteruolos',
                'app.sprardb.configurazioni.tags',
                'app.sprardb.configurazioni.bandos',
                'app.sprardb.configurazioni.documentotipos',
                //'app.sprardb.configurazioni.beneficiarioattributis',
                //auth
                'app.sprardb.auth.forgot-password',
                'app.sprardb.auth.login',
                'app.sprardb.auth.register',
                'app.sprardb.auth.reset-password',
                'app.sprardb.auth.lock',
                //ana
                //documenti
                'app.sprardb.documenti.file-manager',
                //progetti
                //'app.sprardb.progetti.datatable',
                'app.sprardb.progetti.progetti',
                //'app.sprardb.progetti.progetto',
                'app.sprardb.progetti.strutture',
                'app.sprardb.rendicontazioni',
                'app.sprardb.beneficiari',
                'app.sprardb.notification',
                'app.sprardb.userprofile',
//                'app.sprardb.statusg',
                //'app.sprardb.confermas',
                'app.sprardb.eventi',
                'app.sprardb.liste_distribuzione.liste_distribuzione',
                'app.sprardb.monitoraggio',
                'app.sprardb.tags',
                'app.sprardb.entisegnalatori',
                'app.sprardb.segnalatori',
                'app.sprardb.proroghe',
                'app.sprardb.report',
                'app.sprardb.documento',
                'app.sprardb.protocollo',
                'app.sprardb.personas2',
                'app.sprardb.video',
                //'app.sprardb.postlogin',
                'app.sprardb.amministrazione',
                'app.sprardb.cruscotto'
            ])
            .directive('dateInputFormat', DateInputFormatDirective)
            .directive('dateInputMidnight', DateInputMidnightDirective)
            .config(config);

    /** @ngInject */
    function DateInputFormatDirective()
    {
        return {
            require: 'ngModel',

            link: function(scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    return inputValue instanceof Date ? inputValue.toISOString().substring(0,10) : inputValue;
                });
            }
        };
    }

    /** @ngInject */
    function DateInputMidnightDirective()
    {
        return {
            require: 'ngModel',
            priority: 100,
            link: function(scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue instanceof Date) {
                        inputValue.setDate(inputValue.getDate() + 1);
                        return inputValue.toISOString().substring(0,10);
                    }
                    return inputValue;
                });
            }
        };
    }

    /** @ngInject */
    function config(msNavigationServiceProvider, $mdDateLocaleProvider)
    {
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function(date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        // Navigation
        msNavigationServiceProvider.saveItem('sprardb', {
            title: '',
            //icon: 'icon-data',
            group: true,
            //weight: 1
        });

        msNavigationServiceProvider.saveItem('sprardb.auth', {
            title: 'AUTENTICAZIONE',
            icon: 'icon-account-key',
            weight: 100,
            allow: [1, 3],
            hidden: function () {
                return true;
            }
        });

        msNavigationServiceProvider.saveItem('sprardb.eventi', {
            title: 'PROCESSI',
            icon: 'icon-traffic-light',
            weight: 5,
            allow: [1, 3, 4, 5, 6, 9]
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.csegnalazioni', {
            title: 'SEGNALAZIONI',
            icon: 'icon-bookmark-check',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.asegnalati', {
            title: 'ARRIVO SEGNALATI',
            icon: 'icon-car',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari', {
            title: 'BENEFICIARI',
            icon: 'icon-flag-checkered',
            weight: 3
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.statusg', {
            title: 'STATUS GIURIDICO',
            icon: 'icon-bank',
            weight: 4
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti', {
            title: 'PROGETTI',
            icon: 'icon-apps',
            weight: 5
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi', {
            title: 'RENDICONTAZIONE',
            icon: 'icon-clipboard-text',
            weight: 5
        });


        msNavigationServiceProvider.saveItem('sprardb.progetti', {
            title: 'PROGETTI',
            icon: 'icon-apps',
            weight: 9,
            allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        });
//        msNavigationServiceProvider.saveItem('sprardb.progetti.strutture', {
//            title: 'STRUTTURE',
//            icon: 'icon-hospital-building',
//            weight: 10,
//            allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
//        });
        msNavigationServiceProvider.saveItem('sprardb.beneficiari', {
            title: 'BENEFICIARI',
            icon: 'icon-hospital',
            weight: 15,
            allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        });

        msNavigationServiceProvider.saveItem('sprardb.rendicontazioni', {
            title: 'RENDICONTAZIONI',
            icon: 'icon-clipboard-text',
            weight: 16,
            allow: [1, 3, 4]
        });

        msNavigationServiceProvider.saveItem('sprardb.documenti', {
            title: 'DOCUMENTI',
            icon: 'icon-file-document',
            weight: 20,
            allow: [1, 3],
            hidden: function () {
                return true;
            }
        });
        msNavigationServiceProvider.saveItem('sprardb.configurazioni', {
            title: 'CONFIGURAZIONI',
            icon: 'icon-cog',
            weight: 30,
            allow: [1, 3],
            hidden: function () {
                return true;
            }
        });

        msNavigationServiceProvider.saveItem('sprardb.monitoraggio', {
            title: 'MONITORAGGIO',
            icon: 'icon-clipboard-text',
            weight: 88
        });
        msNavigationServiceProvider.saveItem('sprardb.rubrica', {
            title: 'RUBRICA',
            icon: 'icon-book',
            weight: 19
        });
        msNavigationServiceProvider.saveItem('sprardb.rubrica.entes', {
            title: 'ENTI',
            icon: 'icon-account-box-outline',
            weight: 1,
            allow: [1, 2, 3, 4]
        });
        msNavigationServiceProvider.saveItem('sprardb.rubrica.personas', {
            title: 'PERSONE',
            icon: 'icon-account-multiple-outline',
            weight: 2,
            allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        });



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb')
        .filter('filterDescrizione', filterDescrizione);

    /** @ngInject */
    function filterDescrizione () {
        return function (input, dictionary) {
            var ret = input;

            dictionary.forEach(function(value) {
                if (value.id === input) {
                    ret = value.descrizione;
                }
            });

            return ret;
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.segnalatori', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider.state('app.sprardb_segnalatori', {
            url: '/sprardb/segnalatori',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/segnalatori/segnalatori.html',
                    controller: 'SegnalatoriController as vm'
                }
            }
        });

        $stateProvider.state('app.sprardb_segnalatoridettaglio', {
            url: '/sprardb/segnalatori/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/segnalatori/dettaglio/dettaglio.html',
                    controller: 'DettaglioPSController as vm'
                }
            }
        });
        $stateProvider.state('app.sprardb_segnalatorifiltra', {
            url: '/sprardb/segnalatori/:parametro/:valore',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/segnalatori/segnalatori.html',
                    controller: 'SegnalatoriController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/segnalatori');


        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

//        $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
//            return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
//        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';
        /*
         msNavigationServiceProvider.saveItem('sprardb.entisegnalatori.segnalatori', {
         title: 'Segnalatori',
         icon: 'icon-human-child',
         state: 'app.sprardb_segnalatori',
         weight: 2
         });
         //segnalatore
         msNavigationServiceProvider.saveItem('segnalatore.entisegnalatori.segnalatori', {
         title: 'Segnalatori',
         icon: 'icon-human-child',
         state: 'app.sprardb_segnalatori',
         weight: 2
         });
         //segreteria
         msNavigationServiceProvider.saveItem('scsegreteria.entisegnalatori.segnalatori', {
         title: 'Segnalatori',
         icon: 'icon-human-child',
         state: 'app.sprardb_segnalatori',
         weight: 2
         });
         */
        //operatore
//        msNavigationServiceProvider.saveItem('properatore.entisegnalatori.segnalatori', {
//            title: 'Segnalatori',
//            icon: 'icon-human-child',
//            state: 'app.sprardb_segnalatori',
//            weight: 2
//        });
        //admin
        /*
         msNavigationServiceProvider.saveItem('scadmin.entisegnalatori.segnalatori', {
         title: 'Segnalatori',
         icon: 'icon-human-child',
         state: 'app.sprardb_segnalatori',
         weight: 2
         });
         */


    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.segnalatori')
            .controller('SegnalatoriController', SegnalatoriController)
            .controller('DettaglioPSController', DettaglioPSController);

    /** @ngInject */
    function SegnalatoriController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast, $cookies)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.isSegnalatore = api.isSegnalatore;
        vm.apiuser = api.user;
        console.log(vm.apiuser);
        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "codiceFiscale": {
                type: "string",
                title: "Cod.Fiscale",
                description: "inserisci codice fiscale",
                callbackModel: "ricerca",
                dbfield: "codiceFiscale",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:24px",
                required: false
            },
            "telefono": {
                type: "string",
                title: "Telefono",
                description: "inserisci il telefono",
                callbackModel: "ricerca",
                dbfield: "telefono",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:0px",
                required: false
            },
            "email": {
                type: "string",
                title: "Email",
                description: "inserisci email",
                callbackModel: "ricerca",
                dbfield: "email",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:0px",
                required: false
            },
            "entes-enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "Ente Tipo",
                callbackModel: "ricerca",
                dbfield: "entes-enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personahasusergroupvs-group_id": {
                type: "string",
                title: "Gruppo",
                description: "gruppo",
                dbfield: "personahasusergroupvs-group_id",
            }

        };
        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            console.log("searchforms:", searchvariable);
            console.log("origine:", origine);
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            console.log("dataOrigine:", dataOrigine);
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.entetipos = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        })
        vm.regiones = ricerca.regiones;
        vm.enteruolos = ricerca.personaruoloprogettos;
        vm.provincias = ricerca.provincias;
        vm.ricerca["personahasusergroupvs-group_id"] = 11;
        vm.ricerca.operatore = 'AND'
        vm.allsearchs['query[]'][1] = vm.ricerca;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
                vm.valorefiltro = $state.params.valore;
                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
            }
            api.personas.persona.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listapersona"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.personas.persona.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }


        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }
        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);

            var valores = vm.searchForms[key].valore.split("|");

            return results[0][valores[0]];
        }

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_personasdettaglio', {id: obj});

        }


        function onSearch() {
            /*
             vm.allsearchs['query[]'] = [];
             vm.allsearchs['query[]'][0] = {operatore: 'OR'};
             if (vm.ricerca2) {
             vm.allsearchs['query[]'][0].operatore = 'OR';
             vm.allsearchs['query[]'][0].nome = vm.ricerca2;
             vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
             }
             
             angular.forEach(vm.ricerca, function (value, key) {
             if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
             delete vm.ricerca[key];
             }
             });
             if (vm.ricerca) {
             vm.ricerca.operatore = 'AND'
             vm.allsearchs['query[]'][1] = vm.ricerca;
             }
             
             api.personas.persona.like(vm.allsearchs, function (d) {
             //console.log(d);
             vm.entes = d.data;
             vm.links = d._links;
             vm.meta = d._meta;
             }
             );
             vm.searched = true;
             */
            vm.ricerca["personahasusergroupvs-group_id"] = 11;
            //----------------------------------
            var tiporicerca = 'search';
            //nome
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.allsearchs['query[]'][1] = {};
            vm.allsearchs['query[]'][1]['operatore'] = 'AND';
            //vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
            if (vm.ricerca2) {
                tiporicerca = 'like';
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]['nome'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['cognome'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['email'] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
            if (tiporicerca == 'like') {
                api.personas.persona.like(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            } else {
                api.personas.persona.search(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            }

            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.attivalogin = attivalogin;
        function attivalogin(item) {

            var items = [];
            if (!angular.isArray(item)) {
                var tempitem = item;
                item = {};
                items.push(tempitem);
            } else {
                items = item;
            }
            angular.forEach(items, function (item) {
                if (item.utentes[0].status === 10) {
                    item.utentes[0].status = 0;
                } else {
                    item.utentes[0].status = 10;
                }
                console.log(item);

                var confirm = $mdDialog.confirm()
                        .title('Attivazione Autenticazione')
                        .htmlContent('Sei sicuro di voler attivare/disattivare l\'utente <b>' + item.utentes[0].username + '</b>?<br>' + 'Clicca Ok per procedere.')
                        .ariaLabel('attivaes')
                        .ok('OK')
                        .cancel('ANNULLA');

                $mdDialog.show(confirm).then(function ()
                {
                    api.users.user2.aggiorna({id: item.utentes[0].id, status: item.utentes[0].status}, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Utente correttamente attivato/disattivato')
                                .position('bottom right')
                                .hideDelay(2000)
                                );
                    });

                });
            });
        }



        vm.cambiapassword = cambiapassword;
        function cambiapassword(item, ev) {
            var items = [];
            if (!angular.isArray(item)) {
                var tempitem = item;
                item = {};
                items.push(tempitem);
            } else {
                items = item;
            }
            angular.forEach(items, function (item) {
                var confirm = $mdDialog.prompt()
                        .title('Cambia password')
                        .htmlContent('Imposta una nuova password per l\'utente <br><b>' + item.utentes[0].username + '</b><br><b>' + item.utentes[0].email + '</b>')
                        .placeholder('password')
                        .ariaLabel('password')
                        .targetEvent(ev)
                        .parent(angular.element(document.body))
                        .ok('CAMBIA PASSWORD')
                        .cancel('ANNULLA');
                $mdDialog.show(confirm).then(function (p) {
                    var payload = {};
                    if (angular.isUndefined(p)) {
                        p = "";
                    }
                    payload.username = item.utentes[0].username;
                    payload.password = p;
                    api.users.user2.cambiapassword(payload, function (r) {
                        if (r.status == 200) {
                            var passwordalert = $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title('Cambiamento password')
                                    .htmlContent('La nuova password per l\'utente <br><b>' + item.utentes[0].username + '</b><br><b>' + item.utentes[0].email + '</b> è:<br><br><big><b>' + r.passwordc + '</b></big>')
                                    .ariaLabel('cpassword')
                                    .ok('OK');
                            $mdDialog.show(passwordalert).then(function (go) {
                                $cookies.remove('user');
                                $state.go('app.sprardb_auth_login');
                            });
                        }
                        if (r.status == 403 || r.status == 400) {
                            var errore = $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title('ERRORE cambio password')
                                    .textContent(r.message)
                                    .ariaLabel('Errore')
                                    .ok('OK');
                            $mdDialog.show(errore);
                        }
                    });
                }, function () {
                    $mdToast.simple()
                            .textContent('Operazione annullata')
                            .position('bottom right')
                            .hideDelay(2000);

                });

            });
        }


    }

    function DettaglioPSController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $cookies, api, $mdToast)
    {

        var vm = this;
        vm.id = $state.params.id;
        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }
        console.log("NEW?: ", vm.isnew);
        vm.evento = "update";
        var Persona = {};
        vm.loadpersona = function () {

            api.personas.persona.get({id: vm.id}).$promise.then(function (response) {
                Persona = response;

                vm.contact = angular.copy(Persona);
                vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
                if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
                    vm.caricaProvince(vm.contact.codRegione);
                }
                if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
                    vm.caricaComuni(vm.contact.codProvincia);
                }
            }, function (response) {
            });
            return Persona;
        };
        vm.loadpersona();




        vm.provincias = [];
        vm.istats = [];
        //vm.tags = Tags.data;
        api.tags.tag.cerca({pagination: 50, sort: "tag", tipo: "generico"}, function (response) {
            vm.tags = response.data;
        });

        vm.provincias2 = [];
        vm.istats2 = [];
        vm.regiones = null;
        vm.regiones2 = null;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = response.data;
        });
        vm.personaruolos = null;
        api.personaruolos.personaruolo.get({}, function (response) {
            vm.personaruolos = response.data;
        });

        vm.nazioni = null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: 200}, function (response) {
            vm.nazioni = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });






        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                cognome: null,
                sesso: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataNascita: "2013-08-08",
                dataNascita2: null,
                codComuneNascita: null,
                codNazionalita: null,
                codiceFiscale: null,
                tags: [],
                progettos: [],
                entes: [],
                ruolos: [],
                personahasprogettos: [],
                personahasentes: []
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.contact2 = {
            'codRegione': null,
            'codProvincia': null,
            'codComune': null,
            'codComuneNascita': null,
        };


// Methods
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;
        vm.gotoPersona = gotoPersona;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoEnte = gotoEnte;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openEntiDialog = openEntiDialog;



        vm.ruolitotali = vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasentes.length;
        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);
        }
        if (!angular.isUndefined(vm.contact.nascita)) {
            if (vm.contact.nascita !== null) {
                vm.caricaProvince2(vm.contact.nascita.codRegione);
                vm.caricaComuni2(vm.contact.nascita.codProvincia);
            }
        }


//        console.log('isnew:' + vm.isnew);
//        console.log('contact:');
//        console.log(vm.contact);
//        console.log('contact.tags:');
//        console.log(vm.contact.tags);




        ////////////////////////////////////////////////

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }









        /**
         * Save contact
         */
        function saveContact()
        {

            console.log('isnew:' + vm.isnew);
            console.log('contact:', vm.contact);
            var m = moment(vm.contact.dataNascita2);
            vm.contact.dataNascita = m.format("YYYY-MM-DD");
            if (vm.isnew) {
                api.personas.persona.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    vm.id = response.id;
                    vm.loadpersona();
                });
            }
            if (!vm.isnew) {
                api.personas.persona.aggiorna(vm.contact, function (response) {
                    console.log(response);
                    vm.id = response.id;
                    vm.loadpersona();
                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoPersona() {
            $state.go('app.sprardb_contatti');
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }


        function gotoEnte(id)
        {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: id});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.personas.persona.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoPersona();
                });

            });

        }


        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                console.log(vm.tempruolo);
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    console.log(vm.tempentetipo);
                    $mdDialog.show({
                        controller: 'DialogEnti2Controller',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Persona: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }

        vm.checkTelefono = checkTelefono;
        function checkTelefono(ev) {
            api.personas.persona.search({telefono: vm.contact.telefono, fields: "id,nome,cognome,telefono,codiceFiscale,email"}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1 && (Persona.telefono !== response.data[0].telefono)) {
                            $scope.personaNForm.telefono.$setValidity("unique", false);
                        } else {
                            $scope.personaNForm.telefono.$setValidity("unique", true);
                        }
                    });
        }
        vm.checkEmail = checkEmail;
        function checkEmail(ev) {
            if (angular.isDefined(vm.contact.email)) {
                api.personas.persona.search({email: vm.contact.email, fields: "id,nome,cognome,telefono,codiceFiscale,email"}).$promise.then(
                        function (response) {
                            if (response.data.length >= 1 && (Persona.email !== response.data[0].email)) {
                                $scope.personaNForm.email.$setValidity("unique", false);
                            } else {
                                $scope.personaNForm.email.$setValidity("unique", true);
                            }
                        });
            } else {
                $scope.personaNForm.email.$setValidity("unique", true);
            }
        }

        vm.checkCf = checkCf;
        function checkCf(ev) {
            api.personas.persona.search({codiceFiscale: vm.contact.codiceFiscale, fields: "id,nome,cognome,telefono,codiceFiscale,email"}).$promise.then(
                    function (response) {
                        if (response.data.length >= 1 && (Persona.codiceFiscale !== response.data[0].codiceFiscale)) {
                            $scope.personaNForm.codiceFiscale.$setValidity("unique", false);
                        } else {
                            $scope.personaNForm.codiceFiscale.$setValidity("unique", true);
                        }
                    });
        }

        vm.resetConfirmpass = resetConfirmpass;
        function resetConfirmpass() {
            if (vm.contact.utentes[0].passwordc !== vm.contact.utentes[0].password) {
                $scope.personaNForm.passwordc.$setValidity("passwordVerify", false);
            } else {
                $scope.personaNForm.passwordc.$setValidity("passwordVerify", true);
            }
        }

        vm.cambiapassword = cambiapassword;
        function cambiapassword() {

            var confirm = $mdDialog.confirm()
                    .title('Cambiamento password')
                    .textContent('Vuoi cambiare la password?')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');
            $mdDialog.show(confirm).then(function () {

                api.users.user2.cambiapassword({username: vm.contact.utentes[0].username, password: vm.contact.utentes[0].password}, function (d) {
                    console.log(d);
                    if (d.status == 200) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Password modificata!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        $cookies.remove('user');
                        $state.go('app.sprardb_auth_login');
                    }
                    if (d.status == 403) {
                        var errore = $mdDialog.confirm()
                                .title('Cambiamento password')
                                .textContent(d.message)
                                .ariaLabel('Confirmmation Box')
                                .ok('Si');
                        $mdDialog.show(errore);
                    }
                });
            });
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.report', ['angular.filter'])
            .config(config);

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        $stateProvider
                .state('app.sprardb_reportschedamonitoraggio', {
                    url: '/sprardb/report/schedamonitoraggio',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/schedaMonitoraggioMC.html',
                            controller: 'SchedaMonitoraggioMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Scheda di monitoraggio progetto"
                    }
                })

                /*
                 .state('app.sprardb_reportbeneficiari', {
                 url: '/sprardb/report/beneficiari',
                 views: {
                 'content@app': {
                 templateUrl: 'app/main/sprardb/report/rbeneficiari.html',
                 controller: 'RbeneficiariController as vm'
                 }
                 },
                 datas: {
                 titolo: "Report dettaglio beneficiari"
                 }
                 })
                 */
                 .state('app.sprardb_estrazioniministero', {
                    url: '/sprardb/report/estrazioniministero',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/estrazioniMinistero.html',
                            controller: 'ReportMinisteroController as vm'
                        }
                    },
                    datas: {
                        titolo: "Estrazione SIM"
                    }
                })
                .state('app.sprardb_report1', {
                    url: '/sprardb/report/report1',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari",
                        query: {fields: "codice,id,nome,cognome,sesso,dataInizio,dataUscita,dataNascita,dataInserimento,dataRilascioDocumento,dataScadenzaDocumento,dataFine,trasferimento,esterna,n,strutturaEesterna,dataIngresso,documentoNumero,nazionalita,vulnerabilita,tipoIngresso,tipoDocumento,tipoProtezione,religione,eta,intervallo,attivo,nomeStruttura,codiceMinistero,nomeProgetto,codicePresenza", sort: "id", pagination: 5},
                        raggruppato: false,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'codice': 'Codice', 'id': 'Id', 'nome': 'Nome', 'cognome': 'Cognome', 'sesso': 'Sesso', 'dataInizio': 'D.Inizio', 'dataUscita': 'D.Uscita', 'dataNascita': 'D.Nascita', 'dataInserimento': 'D.Inserimento', 'dataRilascioDocumento': 'D.Rilascio Doc.', 'dataScadenzaDocumento': 'D.Scadenza Doc.', 'dataFine': 'D.Fine', 'trasferimento': 'Trasf', 'esterna': 'Acc.Esterna', 'n': 'gg', 'strutturaEesterna': 'Struttura Est.', 'dataIngresso': 'D.Ingresso', 'documentoNumero': 'Doc.Numero', 'nazionalita': 'Nazionalita', 'vulnerabilita': 'Vulnerabilita', 'tipoIngresso': 'Tipo Ingresso', 'tipoDocumento': 'Tipo Documento', 'tipoProtezione': 'Tipo Protezione', 'religione': 'Religione', 'eta': 'Eta', 'intervallo': 'Intervallo Eta', 'attivo': 'Attivo', 'nomeStruttura': 'Nome Struttura', 'codiceMinistero': 'Codice Ministero', 'nomeProgetto': 'Nome Progetto', 'codicePresenza': 'Codice Presenza'},
                        paginationExport: -1
                    }
                })

                .state('app.sprardb_reportbnazionalita', {
                    url: '/sprardb/report/beneficiarinazionalita',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per nazionalita",
                        query: {groupby: 'nazionalita', count: 'nazionalita', fields: "nazionalita,cnt", sort: "nazionalita", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'nazionalita': 'Nazionalita', 'cnt': 'Totale'},
                        paginationExport: -1,
                        report : 'nazionalita'
                    }

                })
                .state('app.sprardb_reportbgenere', {
                    url: '/sprardb/report/beneficiarigenere',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per genere",
                        query: {groupby: 'sesso', count: 'sesso', fields: "sesso,cnt", sort: "sesso", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'sesso': 'Sesso', 'cnt': 'Totale'},
                        paginationExport: -1,
                        report : 'genere'
                    }

                })
                .state('app.sprardb_reportschedamonitoraggioNuovo', {
                    url: '/sprardb/report/schedamonitoraggioNuovo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenericoMonitoraggio.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'reportnuovamonitoraggio'
                    }
                })
                .state('app.sprardb_reportschedasalnuovo', {
                    url: '/sprardb/report/schedasalnuovo',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenericoMonitoraggio.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'reportsalnuovo'
                    }
                })
                .state('app.sprardb_reportbnazionalitagenere', {
                    url: '/sprardb/report/beneficiarinazionalitagenere',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcGenereController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per nazionalita e genere",
                        query: {groupby: 'sesso,nazionalita', count: 'sesso,nazionalita', pagination: -1},
                        raggruppato: true,
                        barragruppo: false,
                        reportcampi: {'sesso': 'sesso', 'nazionalita': 'nazionalita', 'cnt': 'Totale'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportbpermessi', {
                    url: '/sprardb/report/beneficiaripermessi',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per tipo documento",
                        query: {groupby: 'tipoDocumento', count: 'tipoDocumento', fields: "tipoDocumento,cnt", sort: "tipoDocumento", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'tipoDocumento': 'Tipo Documento', 'cnt': 'Totale'},
                        paginationExport: -1,
                        report: 'tipoSoggiorno'
                    }
                })
                .state('app.sprardb_reportbprogetti', {
                    url: '/sprardb/report/beneficiariprogetti',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per tipo progetto",
                        query: {groupby: 'nomeProgetto', count: 'nomeProgetto', fields: "nomeProgetto,cnt", sort: "nomeProgetto", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'nomeProgetto': 'Nome Progetto', 'cnt': 'Totale'},
                        paginationExport: -1,
                        report: 'progetti'
                    }
                })
                .state('app.sprardb_reportmotiviuscita', {
                    url: '/sprardb/report/beneficiarimotiviuscita',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'uscita'
                    }
                })
                .state('app.sprardb_reportmodalitaingresso', {
                    url: '/sprardb/report/beneficiarimodalitaingresso',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'modIngresso'
                    }
                })
                .state('app.reportcomunistruttura', {
                    url: '/sprardb/report/beneficiaricomunistruttura',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'comuniStruttura'
                    }
                })

                .state('app.reportchecklistmonitoraggio', {
                  url: '/sprardb/report/reportchecklistmonitoraggio',
                  views: {
                    'content@app': {
                      templateUrl: 'app/main/sprardb/report/reportMonitoraggio.html',
                      controller: 'ReportMcController as vm'
                    }
                  },
                  datas: {
                    report: 'reportchecklistmonitoraggio'
                  }
                })
                .state('app.sprardb_reportbclassieta', {
                    url: '/sprardb/report/beneficiariclassieta',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'classiEta'
                    }
                })
                .state('app.sprardb_reportreportbnuclei', {
                    url: '/sprardb/report/beneficiarinuclei',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per nuclei familiari",
                        query: {groupby: 'nucleoFamiliare', count: 'nucleoFamiliare', pagination: -1},
                        raggruppato: true,
                        report:'nucleoFami'
                    }
                })
                .state('app.reportbeneficiarinumerico', {
                    url: '/sprardb/report/beneficiarinumerico',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'numerico'
                    }
                })
                .state('app.reportstrutturetipologia', {
                    url: '/sprardb/report/strutturetipologia',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'struttureTipologia'
                    }
                })
                .state('app.reportpostidisponibili', {
                    url: '/sprardb/report/postidisponibili',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report: 'postiDisponibili'
                    }
                })
                .state('app.sprardb_reportreportbdatauscita', {
                    url: '/sprardb/report/beneficiaridatauscita',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari per anno uscita",
                        query: {groupby: 'annouscita', count: 'annouscita', fields: "annouscita,cnt", sort: "annouscita", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'annouscita': 'Anno Uscita', 'cnt': 'Totale'},
                        paginationExport: -1
                    }
                })
            .state('app.sprardb_reportbeneficiaridettgli', {
                    url: '/sprardb/report/beneficiaridettagli',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        report:'dettaglio'
                    }
                })
            .state('app.sprardb_reportbeneficiaricovid', {
                url: '/sprardb/report/beneficiaricovid',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                        controller: 'ReportMcController as vm'
                    }
                },
                datas: {
                    report:'covid'
                }
            })
            .state('app.sprardb_reportproroghebeneficiari', {
              url: '/sprardb/report/proroghebeneficiari',
              views: {
                'content@app': {
                  templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                  controller: 'ReportMcController as vm'
                }
              },
              datas: {
                report:'prorogheBeneficiari'
              }
            })
            .state('app.sprardb_reportproroghelavorate', {
              url: '/sprardb/report/proroghelavorate',
              views: {
                'content@app': {
                  templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                  controller: 'ReportMcController as vm'
                }
              },
              datas: {
                report:'prorogheLavorate'
              }
            })
                .state('app.sprardb_reportbeneficiariotrasferimenti', {
                    url: '/sprardb/report/beneficiaritrasferimenti',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report beneficiari in trasferimento",
                        query: {groupby: 'trasferimento', count: 'trasferimento', fields: "trasferimento,cnt", sort: "trasferimento", pagination: 20000},
                        raggruppato: true,
                        api: 'beneficiario',
                        barragruppo: false,
                        reportcampi: {'trasferimento': 'Trasferimento', 'cnt': 'Totale'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportcorsi', {
                    url: '/sprardb/report/corsi',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'ReportMcController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report corsi attivati",
                        report: 'corsiServizi'
                    }
                })
                .state('app.sprardb_reportministero', {
                  url: '/sprardb/report/ministero',
                  views: {
                    'content@app': {
                      templateUrl: 'app/main/sprardb/report/reportMinistero.html',
                      controller: 'ReportMcController as vm'
                    }
                  },
                  datas: {
                    titolo: "Report richiesto dal ministero",
                    report: 'reportMinistero'
                  }
                })
                .state('app.sprardb_reportservizi', {
                    url: '/sprardb/report/servizi',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/rservizi.html',
                            controller: 'RserviziController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report servizi attivati"
                    }
                })
                .state('app.sprardb_reportcorsiu', {
                    url: '/sprardb/report/corsiu',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/rcorsi.html',
                            controller: 'RcorsiuController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report corsi usufruiti"
                    }
                })
                .state('app.sprardb_reportserviziu', {
                    url: '/sprardb/report/serviziu',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/rservizi.html',
                            controller: 'RserviziuController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report servizi usufruiti"
                    }
                })
                .state('app.sprardb_report2', {
                    url: '/sprardb/report/report2',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report strutture",
                        query: {fields: "id,progetto_id,nome,codComune,strutturaAccoglienza_id,strutturaAlloggio_id,numeroPosti,numeroStanze,numeroIgienici,attivo,tipoAccoglienza,tipoAlloggio,nomeProgetto,comune,codProvincia,ripartGeo,regione,provincia,codRegione", sort: "id", pagination: 5},
                        raggruppato: false,
                        api: 'struttura',
                        barragruppo: false,
                        reportcampi: {'id': 'Codice', 'progetto_id': 'progetto_id', 'nome': 'nome', 'codComune': 'codComune', 'strutturaAccoglienza_id': 'strutturaAccoglienza_id', 'strutturaAlloggio_id': 'strutturaAlloggio_id', 'numeroPosti': 'numeroPosti', 'numeroStanze': 'numeroStanze', 'numeroIgienici': 'numeroIgienici', 'attivo': 'attivo', 'tipoAccoglienza': 'tipoAccoglienza', 'tipoAlloggio': 'tipoAlloggio', 'nomeProgetto': 'nomeProgetto', 'comune': 'comune', 'codProvincia': 'codProvincia', 'ripartGeo': 'ripartGeo', 'regione': 'regione', 'provincia': 'provincia', 'codRegione': 'codRegione'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_report3', {
                    url: '/sprardb/report/report3',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report Progetti/Attuatori",
                        query: {fields: "id,codiceMinistero,nome,postiTotali,postiLiberi,attivo,regione,provincia,comune,ripartGeo,enteAttuatoreNome,enteAttuatoreRegione,enteAttuatoreProvincia,enteAttuatoreComune,enteAttuatoreRipartizioneTerritoriale", sort: "id", pagination: 5},
                        raggruppato: false,
                        api: 'progetto',
                        barragruppo: false,
                        reportcampi: {'id': 'codice', 'codiceMinistero': 'codiceMinistero', 'nome': 'nome', 'postiTotali': 'postiTotali', 'postiLiberi': 'postiLiberi', 'attivo': 'attivo', 'regione': 'regione', 'provincia': 'provincia', 'comune': 'comune', 'ripartGeo': 'ripartGeo', 'enteAttuatoreNome': 'enteAttuatoreNome', 'enteAttuatoreRegione': 'enteAttuatoreRegione', 'enteAttuatoreProvincia': 'enteAttuatoreProvincia', 'enteAttuatoreComune': 'enteAttuatoreComune', 'enteAttuatoreRipartizioneTerritoriale': 'enteAttuatoreRipartizioneTerritoriale'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_report4', {
                    url: '/sprardb/report/report4',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report Progetti/Titolari",
                        query: {fields: "id,codiceMinistero,nome,postiTotali,postiLiberi,attivo,regione,provincia,comune,ripartGeo,enteTitolareNome,enteTitolareRegione,enteTitolareProvincia,enteTitolareComune,enteTitolareRipartizioneTerritoriale", sort: "id", pagination: 5},
                        raggruppato: false,
                        api: 'progetto2',
                        barragruppo: false,
                        reportcampi: {'id': 'codice', 'codiceMinistero': 'codiceMinistero', 'nome': 'nome', 'postiTotali': 'postiTotali', 'postiLiberi': 'postiLiberi', 'attivo': 'attivo', 'regione': 'regione', 'provincia': 'provincia', 'comune': 'comune', 'ripartGeo': 'ripartGeo', 'enteTitolareNome': 'enteTitolareNome', 'enteTitolareRegione': 'enteTitolareRegione', 'enteTitolareProvincia': 'enteTitolareProvincia', 'enteTitolareComune': 'enteTitolareComune', 'enteTitolareRipartizioneTerritoriale': 'enteTitolareRipartizioneTerritoriale'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportstrutturaaccoglienza', {
                    url: '/sprardb/report/strutturaaccoglienza',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Strutture per accoglienza",
                        query: {groupby: 'tipoAccoglienza', count: 'tipoAccoglienza', fields: "tipoAccoglienza,cnt", sort: "tipoAccoglienza", pagination: 10},
                        raggruppato: true,
                        api: 'struttura',
                        barragruppo: false,
                        reportcampi: {'tipoAccoglienza': 'tipoAccoglienza', 'cnt': 'Totale'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportstrutturaalloggio', {
                    url: '/sprardb/report/strutturaalloggio',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Strutture per alloggio",
                        query: {groupby: 'tipoAlloggio', count: 'tipoAlloggio', fields: "tipoAlloggio,cnt", sort: "tipoAlloggio", pagination: 10},
                        raggruppato: true,
                        api: 'struttura',
                        barragruppo: false,
                        reportcampi: {'tipoAlloggio': 'Tipo Alloggio', 'cnt': 'Totale'},
                        paginationExport: -1
                    }

                })
                .state('app.sprardb_reportstrutturaprogetto', {
                    url: '/sprardb/report/strutturaprogetto',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Strutture per progetto",
                        query: {groupby: 'nomeProgetto', count: 'nomeProgetto', fields: "nomeProgetto,cnt", sort: "nomeProgetto", pagination: 10},
                        raggruppato: true,
                        api: 'struttura',
                        barragruppo: false,
                        reportcampi: {'nomeProgetto': 'Nome Progetto', 'cnt': 'Totale'},
                        paginationExport: -1
                    }
//                    views: {
//                        'content@app': {
//                            templateUrl: 'app/main/sprardb/report/rstrutturatemplate.html',
//                            controller: 'RstrutturaController as vm'
//                        }
//                    },
//                    datas: {
//                        titolo: "Strutture per progetto",
//                        query: {groupby: 'nomeProgetto', count: 'nomeProgetto', pagination: -1},
//                        raggruppato: true
//                    }
                })
                .state('app.sprardb_reporteaso1', {
                    url: '/sprardb/report/easo1',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reaso.html',
                            controller: 'ReasoController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report EASO reception",
                        query: {groupby: 'Ceu,Sop,DoS,ToA,NoF,Age,Gender,UAM', sort: 'NoF,Age,Gender,Sop,Ceu,ToA,Dos,UAM', fields: 'Ceu,Sop,DoS,ToA,Nc,NoF,Age,Gender,UAM,cnt', pagination: 10, count: 'Ceu,Sop,DoS,ToA,Nc,NoF,Age,Gender,UAM'},
                        raggruppato: true,
                        api: 'easo1',
                        barragruppo: false,
                        reportcampi: {'Ceu': 'Citizenship', 'Sop': 'Legal status of persons in reception', 'DoS': 'Duration of stay', 'ToA': 'Type of accommodation', 'Nc': 'National classification', 'NoF': 'Name of Facility', 'Age': 'Age', 'Gender': 'Gender', 'UAM': 'UAM', 'cnt': 'Total number of persons'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reporteaso2', {
                    url: '/sprardb/report/easo2',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reaso.html',
                            controller: 'ReasoController as vm'
                        }
                    },
                    datas: {
                        titolo: "Report EASO reception capacity",
                        query: {groupby: 'Ceu,ToA,NoF', count: 'ToA,Ceu,NoF,NoB', sort: 'Ceu,ToA,NoF', fields: 'Ceu,ToA,NoF,NoB', pagination: 10},
                        raggruppato: true,
                        api: 'easo2',
                        barragruppo: false,
                        reportcampi: {'ToA': 'Type of accommodation', 'Ceu': 'National classification', 'NoF': 'Name of Facility', 'NoB': 'Number of beds'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportposti', {
                    url: '/sprardb/report/postidisponibili',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report Posti disponibili",
                        query: {fields: "codiceMinistero,nome,postiTotali,postiLiberi,regione,provincia,comune,ripartGeo", sort: "id", pagination: 100},
                        raggruppato: false,
                        api: 'postidisponibili',
                        barragruppo: false,
                        reportcampi: {codiceMinistero: 'codiceMinistero', nome: 'nome', postiTotali: 'postiTotali', postiLiberi: 'postiLiberi', regione: 'regione', provincia: 'provincia', comune: 'comune', ripartGeo: 'ripartGeo'},
                        paginationExport: -1
                    }
                })
                .state('app.sprardb_reportpostidisponibilieattivi', {
                    url: '/sprardb/report/postidisponibilieattivi',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report Posti disponibili e attivi",
                        query: {fields: "codiceMinistero,nomeProgetto,tipoAccoglienza,postiAttivi,postiLiberiInStruttura,postiPrenotati,postiInStruttura,postiFinanziati", sort: "nomeProgetto", pagination: -1},
                        raggruppato: false,
                        api: 'postidisponibilieattivi',
                        barragruppo: false,
                        reportcampi: {codiceMinistero: 'codiceMinistero', nomeProgetto: 'nomeProgetto', tipoAccoglienza: 'tipoAccoglienza', postiFinanziati: 'postiFinanziati', postiLiberiInStruttura: 'postiLiberiInStruttura', postiPrenotati: 'postiPrenotati', postiAttivi: 'postiAttivi', comune: 'comune'},
                        paginationExport: -1,
                        funzionedoporicerca: 'aggiustapostidisponibili',
                        condizioneevidenzia: 'evidenziasforato'
                    }
                })

                .state('app.sprardb_rep1', {
                    url: '/sprardb/report/rep1',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/sprardb/report/reportGenerico.html',
                            controller: 'Report1Controller as vm'
                        }
                    },
                    datas: {
                        titolo: "Report 1",
                        query: {fields: "num,descrizione,gruppo,tipoProtezione_id,ultimo_bando_id", sort: "ultimo_bando_id", pagination: -1},
                        raggruppato: false,
                        api: 'rep1',
                        barragruppo: false,
                        reportcampi: {num: 'num', descrizione: 'descrizione', gruppo: 'gruppo', tipoProtezione_id: 'tipoProtezione_id', ultimo_bando_id: 'ultimo_bando_id'},
                        paginationExport: -1
                    }
                });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/report');

        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };
        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };
        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.report')
            .controller('ReportsController', ReportsController)
            .controller('ReasoController', ReasoController)
            .controller('ReportMcController', ReportMcController)
            .controller('SchedaMonitoraggioMcController', SchedaMonitoraggioMcController)
            .controller('ReportMinisteroController', ReportMinisteroController);


    /** @ngInject */
    function ReportsController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast)
    {
        var vm = this;
        // Data
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.params = $state.params;
        vm.def = ($state.params.def) ? $state.params.def : null;

        //vm.viewEvento = eventi.viewDetails;
        var searchpayload = {};
        if (vm.def !== null) {
            searchpayload.def = vm.def;
        }
        vm.datascadenza = ricerca.datascadenza;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.benefstatos = ricerca.statobeneficiarios;
        vm.progettos = [];
        api.progettos.progetto.cerca({sort: "nome", pagination: "-1", attivo: 1, fields: "id,nome"}, function (response) {
            vm.progettos = response.data;
        });
        vm.nazioneb = ricerca.naziones;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoproteziones = null;
        vm.parentelas = null;
        vm.vulnerabilitas = null;



        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "400"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'ordinamento,descrizione'}, function (response) {
            vm.parentelas = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}, function (response) {
            vm.vulnerabilitas = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}, function (response) {
            vm.tipoproteziones = response.data;
        });



        vm.searchForms = {
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "descrizione|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "def_IN": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Protezione",
                description: "Tipo Protezione...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataIngresso>": {
                type: "string",
                title: "Data Ingresso",
                description: "Data Ingresso",
                callbackModel: "ricerca",
                dbfield: "dataIngresso>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataUscita<": {
                type: "string",
                title: "Data Uscita",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "trasferimento_IN": {
                type: "string",
                title: "Trasferiti",
                description: "Trasferiti...",
                callbackModel: "ricerca",
                dbfield: "trasferimento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};



        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.ricerca = {};
        vm.ricerca2 = "";

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.loadbeneficiarios = function () {
            console.log(vm.allsearchs);
            if (angular.isDefined($state.params.def)) {
                vm.allsearchs['query[]'][1]['def'] = $state.params.def;
                if ($state.params.def == 0) {
                    vm.allsearchs['query[]'][1]['stato'] = 'BENEFICIARIO';
                }
            }
            console.log(vm.allsearchs);
            api.beneficiarios.v.search(vm.allsearchs).$promise.then(function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.beneficiari;
        };



        vm.selectedBeneficiarios = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'cognome';
            vm.allsearchsTemp.fields = 'id,codiceVestanet,cognome,nome,dataNascita,documentoNumero,dataIngresso,dataFine';
            api.beneficiarios.v.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                console.log("vm.entesexport", vm.entesexport);
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }


        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
//                if (angular.isDate(value)) {
//                    return moment(date).format('DD/MM/YYYY');
//                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



        vm.onSearch = onSearch;
        function onSearch() {
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';

                if (vm.ricerca2.indexOf(",") > -1) {
                    vm.allsearchs['query[]'][0]["id_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["nome_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["cognome_IN"] = vm.ricerca2;
                } else {
                    vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].id = vm.ricerca2;
                }
            }
            if (vm.def !== null) {
                vm.ricerca.def_IN = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.beneficiarios.v.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.Beneficiari = d;
                vm.beneficiari = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }

        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
//            oggi.setHours(0);
//            oggi.setMinutes(0);
//            oggi.setSeconds(0);
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }




    }

    function ReasoController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast, $mdDateLocale)
    {

        var vm = this;
        // Data
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.params = $state.params;
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.risultati = [];
        vm.strutturadati = {};
        vm.raggruppato = {};
        vm.beneficiariProgetto = [];
        vm.beneficiariProgettoBackup = [];
        vm.servizierogati = [];
        vm.tservizierogati = 0;
        vm.datas = $state.current.datas;
        vm.exporting = false;


        vm.datascadenza = ricerca.datascadenza;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.benefstatos = ricerca.statobeneficiarios;
        if (vm.api.isAdmin || vm.api.isAccoglienza) {
            vm.progettos = ricerca.progettos;
        } else {
            vm.progettos = ricerca.autorizzatoprogettos;
        }
        vm.nazioneb = ricerca.naziones;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.genere = ricerca.genere;
        vm.nucleofamiliare = ricerca.nucleoFamiliare;
        vm.nazioni = null;
        vm.religioni = null;
        vm.tipoproteziones = null;
        vm.tipoingressos = null;
        vm.parentelas = null;
        vm.vulnerabilitas = null;
        vm.nullsi = [{id: "NULL", descrizione: "NO"}];
        console.log("ricerca.progettos", ricerca.progettos);


        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "400"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'ordinamento,descrizione'}, function (response) {
            vm.parentelas = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}, function (response) {
            vm.vulnerabilitas = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}, function (response) {
            vm.tipoproteziones = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'INGRESSO', sort: 'ordinamento,descrizione'}, function (response) {
            vm.tipoingressos = response.data;
        });
        vm.oggi = new Date();
        vm.anno = vm.oggi.getFullYear();
        vm.annostart = vm.anno - 2;
        vm.periodibw = [];
        for (i = vm.anno; i >= vm.annostart; i--) {
            vm.periodibw.push({id: i + "-01-01," + i + "-06-30", descrizione: "Primo semestre " + i});
            vm.periodibw.push({id: i + "-07-01," + i + "-12-31", descrizione: "Secondo semestre " + i});
            vm.periodibw.push({id: i + "-01-01," + i + "-04-30", descrizione: "Primo quadrimestre " + i});
            vm.periodibw.push({id: i + "-05-01," + i + "-09-30", descrizione: "Secondo quadrimestre " + i});
            vm.periodibw.push({id: i + "-10-01," + i + "-12-31", descrizione: "Terzo quadrimestre " + i});
        }
        vm.periodism = [];
        for (i = vm.anno; i >= vm.annostart; i--) {
            vm.periodism.push({id: i + "-01-01," + i + "-06-30", descrizione: "Primo semestre " + i});
            vm.periodism.push({id: i + "-07-01," + i + "-12-31", descrizione: "Secondo semestre " + i});
            vm.periodism.push({id: i + "-01-01," + i + "-04-30", descrizione: "Primo quadrimestre " + i});
            vm.periodism.push({id: i + "-05-01," + i + "-09-30", descrizione: "Secondo quadrimestre " + i});
            vm.periodism.push({id: i + "-10-01," + i + "-12-31", descrizione: "Terzo quadrimestre " + i});
        }

        vm.searchForms = {
            "exitDate>": {
                type: "string",
                title: "Data Fine Report",
                description: "Data Fine Report",
                callbackModel: "ricerca",
                dbfield: "exitDate>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "exitDate_IS": {
                type: "string",
                title: "Non ancora uscito",
                description: "Non ancora uscito",
                callbackModel: "ricerca",
                dbfield: "exitDate_IS",
                formtype: "hidden",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.nullsi",
                chiave: "id",
                valore: "'NULL'"
            }
        };



        vm.preparati = false;


        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = [5, 10, 15, 20, -1];
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs2 = {};
        vm.allsearchs2.operatore = 'AND';
        vm.allsearchs2.pagination = -1;
        vm.allsearchs2.sort = 'descrizione';
        vm.colors = ricerca.colors;
        vm.allsearchs.sort = "tipoDocumento";

        vm.ricerca = {};
        vm.ricerca2 = "";

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.selectedBeneficiarios = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;
        vm.writeExportFile = writeExportFile;
        vm.reportcampi = angular.copy(vm.datas.reportcampi);

        //////////

      function writeExportFile()
      {
        var ws = XLSX.utils.json_to_sheet([vm.datas.reportcampi], {skipHeader: true});
        ws = XLSX.utils.sheet_add_json(ws, vm.reportexport, {origin: 'A2', skipHeader: true});
        console.log(vm.reportexport);

        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, vm.datas.titolo);

        /* write workbook and force a download */
        XLSX.writeFile(wb, vm.datas.api+".xlsx");
      }

        function exportcsvente() {
            vm.preparati = false;
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            var tuttiicampi = [];
            vm.reportcampi = {};

            angular.forEach(vm.strutturadati, function (v, k) {
                if (v === true) {
                    tuttiicampi.push(k);
                    vm.reportcampi[k] = vm.leggibile(k);
                }
            });
            vm.allsearchsTemp.fields = tuttiicampi.join();

            vm.reportexport = null;
            vm.exporting = true;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            //vm.reportexport = vm.beneficiari;

            onSearch();


        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

//            if (angular.isDate(value)) {
//                return moment(value).format('DD/MM/YYYY');
//            }
            if (angular.isUndefined(vm.searchForms[key].data) || vm.searchForms[key].data == undefined) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.groupby = groupby;
        function groupby(campo) {
            if (vm.allsearchs.groupby == campo) {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs.count;
            } else {
                vm.allsearchs.groupby = campo;
                vm.allsearchs.count = campo;
            }
            vm.onSearch();
        }
        vm.groupby2 = groupby2;
        function groupby2(item, campo) {
            vm.raggruppato = !vm.raggruppato;
            if (vm.raggruppato) {
                var raggruppato = $filter('groupBy')(item, campo);
                //console.log(raggruppato);
                vm.strutturadati = {};
                vm.strutturadati[campo] = true;
                vm.strutturadati["cnt"] = true;
                //console.log("raggruppato", raggruppato);
                var newdata = [];
                var tempd = {};
                angular.forEach(raggruppato, function (v, k) {
//                    console.log("v", v);
//                    console.log("k", k);
                    tempd = {};
                    tempd[campo] = k;
                    tempd['cnt'] = v.length;
                    newdata.push(tempd);
//                    console.log("tempd", angular.copy(tempd));
                });
                vm.beneficiari = newdata;
            } else {
                var strutturadaticustom = {};
                strutturadaticustom = vm.generaStrutturadati(angular.copy(vm.beneficiariProgettoBackup[0]));
                vm.strutturadati = strutturadaticustom;
                vm.beneficiari = vm.beneficiariProgettoBackup;
            }
            //console.log("vm.beneficiariProgetto[index]", angular.copy(vm.beneficiariProgetto[index]));

        }
        vm.leggibile = leggibile;
        function leggibile(campo) {
            if (campo === "cnt") {
                return "totale"
            }
            return campo.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
        }
        vm.somma = somma;
        function somma(items, campo) {
            var somma = 0;
            angular.forEach(items, function (item) {
                somma = somma + parseInt(item[campo]);
            });
            return somma;
        }

        vm.onSearch = onSearch;
        function onSearch() {
            vm.allsearchs.operatore = "AND";
            vm.allsearchs['query[]'] = [];

            vm.ric1 = angular.copy(vm.ricerca);

            angular.forEach(vm.ric1, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ric1[key];
                }
                if (angular.isDate(value)) {
                    vm.ric1[key] = moment(value).format("YYYY-MM-DD");
                }
            });
            if (vm.ric1) {
                vm.ric1.operatore = 'OR';
                vm.allsearchs['query[]'][1] = vm.ric1;
            }

            if (!vm.exporting) {
                vm.strutturadati = {};
            }
            if (angular.isDefined(vm.datas.query) && !vm.isdrilldown) {
                angular.forEach(vm.datas.query, function (v, k) {
                    vm.allsearchs[k] = v;
                });
            }

            console.log("vm.datas.paginationExport", vm.datas.paginationExport);
            console.log("vm.exporting", vm.exporting);

            if (angular.isDefined(vm.datas.paginationExport) && vm.exporting) {
                vm.allsearchs['pagination'] = vm.datas.paginationExport;
            }
            if (vm.exporting) {
                api.report[vm.datas.api].search(vm.allsearchs, function (e) {
                    vm.reportexport = e.data;
                    vm.exporting = false;
                    vm.preparati = true;
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati per esportazione pronti')
                            .position('bottom right')
                            .hideDelay(2000)
                            );
                });
            } else {
                api.report[vm.datas.api].search(vm.allsearchs, function (d) {
                    vm.isdrilldown = false;
                    //console.log(d);
                    vm.Beneficiari = angular.copy(d);
                    vm.beneficiari = angular.copy(d.data);
                    vm.links = angular.copy(d._links);
                    vm.meta = angular.copy(d._meta);
                    vm.beneficiariProgetto = [];
                    if (vm.beneficiari) {
                        console.log(vm.beneficiari);
                        vm.listaProgetti = $filter('unique')(vm.beneficiari, 'nomeProgetto');
                        vm.countProgetti = vm.listaProgetti.length;
                        vm.strutturadati = vm.generaStrutturadati(angular.copy(vm.beneficiari[0]));
                        vm.strutturadati = {
                            ToA: true,
                            Ceu: true,
                            NoF: true,
                            NoB: true,
                        };
                        console.log(vm.strutturadati);
                        vm.raggruppato = false;
                        vm.beneficiariProgettoBackup = angular.copy(vm.beneficiari);
                    }
                    if (angular.isDefined(vm.datas.raggruppato)) {
                        vm.raggruppato = vm.datas.raggruppato;
                    }

                });

            }

            vm.searched = true;
        }

        vm.isdrilldown = false;
        vm.drilldown = drilldown;
        function drilldown(campo, valore) {
            vm.isdrilldown = true;
            console.log("drilldown");
            console.log(angular.copy(vm.allsearchs));
            delete vm.allsearchs.count;
            delete vm.allsearchs.groupby;
            vm.allsearchs.pagination = 100;
            console.log(angular.copy(vm.allsearchs));
            vm.ricerca[campo] = valore;
            vm.onSearch();
        }

        vm.generaStrutturadati = generaStrutturadati;
        function generaStrutturadati(itemdata) {
            var strutturadati = itemdata;
            var strutturadaticustom = {};
            angular.forEach(strutturadati, function (v, k) {
                if (!k.startsWith("_") && k !== 'progettos' && k !== 'serviziusufruitistarts' && k !== 'progettostarts') {
                    if ((k.startsWith("id") || k.endsWith("_id")) && k !== 'id') {
                        strutturadaticustom[k] = false;
                    } else {
                        strutturadaticustom[k] = true;
                    }
                }
            });
            return strutturadaticustom;
        }


        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }

        vm.filtrap = filtrap;
        function filtrap() {
            var regioni = vm.ricerca['progettostarts-codRegione_IN'];
            var allprovincias = ricerca.provincias;
            var provinciasfiltered = [];
            angular.forEach(regioni, function (regione) {
                angular.forEach(allprovincias, function (allprovincia) {
                    if (allprovincia.codRegione === regione) {
                        provinciasfiltered.push(allprovincia);
                    }
                });
            });
            vm.provincias = provinciasfiltered;
            if (angular.isUndefined(vm.ricerca['progettostarts-codRegione_IN'])) {
                vm.provincias = allprovincias;
            }
        }
    }

    function ReportMcController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast, $mdDateLocale, $rootScope)
    {
        var vm = this;

        vm.tipoReport = $state.current.datas.report;
        vm.nomefile = '';
        vm.show = null;
        vm.api = api;

        vm.oggi = new Date();
        vm.controlA = vm.oggi;
        vm.controlDa = vm.oggi;

        vm.dataTableSelected = [];
        vm.stringRaggruppamenti = '';
        vm.stringBandi='';
        vm.stringRegioni='';
        vm.stringProvince='';
        vm.stringProgetti='';
        vm.stringEnti='';
        vm.stringTipBeneficiario='';
        vm.stringTipologie = '';
        vm.stringNazione = '';
        vm.stringTipProtezione = '';
        vm.stringGenere = '';
        vm.selected = {};
        vm.selected['per-page'] = 20;   //Lor:number of rows per page
        vm.selected.page = 1;
        vm.selected.pagination = true;
        vm.dateSelezionate = {};
        vm.selected.statoB = 'presenti';
        vm.selected.tipoMonitoraggio = 'qualitativo';
        vm.selected.attivo = null;
        vm.showDatePresenti = !(vm.tipoReport == 'uscita' || vm.tipoReport == 'comuniStruttura'|| vm.tipoReport == 'struttureTipologia' || vm.tipoReport == 'covid' || vm.tipoReport == 'prorogheBeneficiari' || vm.tipoReport == 'prorogheLavorate' || vm.tipoReport == 'reportchecklistmonitoraggio');
        vm.showDateAccolti = (false || (vm.tipoReport == 'comuniStruttura' ||  vm.tipoReport == 'struttureTipologia' || vm.tipoReport == 'covid' || vm.tipoReport == 'prorogheBeneficiari' || vm.tipoReport == 'prorogheLavorate' || vm.tipoReport == 'reportchecklistmonitoraggio'));
        vm.reportBeneficiario = !(vm.tipoReport == 'struttureTipologia' || vm.tipoReport == 'comuniStruttura' || vm.tipoReport == 'postiDisponibili' || vm.tipoReport == 'corsiServizi' || vm.tipoReport == 'reportchecklistmonitoraggio');
        vm.anniMonitoraggio = api.monitoraggio.anniMonitoraggio();
        vm.quadrimestri = {1:'1° QUADRIMESTRE',2:'2° QUADRIMESTRE',3:'3° QUADRIMESTRE'};
        vm.semestri = {4:'1° SEMESTRE',5:'2° SEMESTRE'};

        function setData(ret){
          vm.dati = ret.data;
          vm.keyNames = Object.keys(vm.dati[0] || {});
          vm.links = ret._links;
          vm.meta = ret._meta;
        }

        $scope.search = function() {
          vm.dati = null;
          vm.progress = true;

          angular.forEach(vm.dateSelezionate, function(value, key){
                if (angular.isDate(value)) {
                    vm.selected[key] = moment(value).format("YYYY-MM-DD");
                }
            });

            vm.selected.pagination = true;

            if(vm.tipoReport == 'nazionalita'){
                vm.selected.data = $scope.searchData != undefined ? moment($scope.searchData).format('L') : null;
            }

            var mappaRep = {
               'tipoSoggiorno':'beneficiariTipologiaSoggiorno',
               'uscita':'beneficiariMotiviUscita',
               'modIngresso':'beneficiariModalitaIngresso',
               'comuniStruttura':'beneficiariComuniStruttura',
               'classiEta':'beneficiariFasceEta',
               'estrazioniministero': 'estrazioniMinistero',
               'corsiServizi':'beneficiariCorsiServizi',
               'nucleoFami':'beneficiariNucleiFamiliari',
               'numerico':'beneficiariNumerico',
               'struttureTipologia':'struttureTipologia',
               'postiDisponibili':'postiDisponibili',
               'dettaglio':'beneficiariDettagli',
               'covid':'beneficiariCovid',
               'prorogheBeneficiari':'prorogheBeneficiari',
               'nazionalita':'beneficiariPerNazione',
               'progetti':'beneficiariPerProgetto',
               'genere':'beneficiariPerGenere',
               'prorogheLavorate':'prorogheLavorate',
               'reportMinistero':'reportMinistero',
               'reportchecklistmonitoraggio': 'reportChecklistMonitoraggio',
               'reportnuovamonitoraggio' : 'reportNuovaMonitoraggio',
               'reportsalnuovo' : 'reportSalNuovo'
            };

            var metodo = mappaRep[vm.tipoReport];

            switch (vm.tipoReport) {
              case 'nazionalita':
              case 'progetti':
              case 'genere':
              case 'comuniStruttura':
              case 'prorogheLavorate':
                vm.nullValue = 0
            }

            api.reportmc[metodo](vm.selected,setData).$promise.finally(function() {
              if(vm.tipoReport === 'prorogheLavorate') {
                vm.totale = vm.dati[vm.dati.length - 1];
                vm.dati.pop();
              }

              vm.progress = false;
              return true;
            });
        };

        vm.search = $scope.search;

        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = [5, 10, 15, 20, -1];

        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipAccoglienza = res.data;
        });

        api.monitoraggio.stato.query(function (res) {
          vm.statoAssegnato = angular.copy(res);
          vm.statoMonitoraggio = vm.tipoReport === 'reportchecklistmonitoraggio' ? res.filter((item) => ([3, 4, 5].includes(item.id) || item.gruppo === 'STATO-DETTAGLIO')) : res;
        });

        api.tipologiaBeneficiario.tipologie.search(function(res){
          vm.tipBeneficiario = res.data;
        });

        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "NAZIONE", sort: "descrizione", pagination: -1}, function (r) {
          vm.nazioni = r.data;
        });

        vm.genere = ['M','F'];

        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "TIPO-PROTEZIONE", sort: "descrizione", pagination: -1}, function (r) {
          vm.tipoProtezione = r.data;
        });

        api.istats.regioni.get({sort: "regione", pagination: -1}, function (r) {
            r.data.splice(0,1);   //Lor:schifezza per eliminare '-' dalla lista delle regioni
            vm.regioni = r.data;
        });

        vm.searchParams = {
          sort: 'descrizione,-dataFine',
          'per-page': 50,
          filter: {
            attivo: 1
          }
        };

      vm.searchParamsBando = {
        sort: 'descrizione,-dataFine',
        'per-page': 50,
        filter: {
          attivo: 1
        }
      };


      vm.loadBandi = loadBandi;

      function loadBandi() {
        var payload = angular.copy(vm.searchParamsBando);
        if(vm.searchParamsBando.filter.attivo == 'Tutte') {
          delete payload.searchParamsBando.filter;
        }
        api.bando.index(payload, function (r) {
          vm.bandi = r.data;
        });
      }
      loadBandi()

        api.istats.province.get({pagination: -1, sort: "provincia"}, function (r) {
            r.data.splice(0,1);   //Lor:schifezza per eliminare '-' dalla lista delle province
            vm.province = r.data;
        });
        api.progettomc.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
            vm.progetti = r.data;
        });
        api.entes.ente.searchReport({segnalatore: 1, fields: "id,nome", sort: "nome", pagination: 300}, function (r) {
            vm.enti = r.data;
        });


        $scope.filtraprovincia = function() {
            if(vm.selected['regioni[]'] == null || vm.selected['regioni[]'] == ""){
                vm.selected['groupRegioni'] = false;
            }
            vm.selected['groupProvince'] = false;
            if(vm.selected['regioni[]'] == 'Seleziona tutti'){
                return;
            }
            vm.selected['province[]'] = null;

            var allprovincias = ricerca.provincias;
            var provinciasfiltered = [];

            angular.forEach( vm.selected['regioni[]'], function (regione) {
                angular.forEach(allprovincias, function (allprovincia) {
                    if (allprovincia.codRegione == regione) {
                        provinciasfiltered.push(allprovincia);
                    }
                });
            });
            if(provinciasfiltered.length == 0){
                api.istats.province.get({pagination: -1, sort: "provincia"}, function (r) {
                    r.data.splice(0,1);   //Lor:schifezza per eliminare '-' dalla lista delle province
                    vm.province = r.data;
                });
            }else{
                vm.province = provinciasfiltered;
            }

            $scope.filtraprogetto();
        };

        $scope.filtraprogetto = function() {
            if(vm.selected['province[]'] == null || vm.selected['province[]'] == ""){
                vm.selected['groupProvince'] = false;
            }
            vm.selected['groupProgetti'] = false;

            if(vm.selected['province[]'] == 'Seleziona tutti'){
                return;
            }

            vm.selected['progetti[]'] = null;
            if (angular.isObject(vm.progettiSearch) && typeof vm.progettiSearch.$cancelRequest === 'function') {
                vm.progettiSearch.$cancelRequest();
            }

            var searchParams = {
                attivo: 1, fields: "id,nome", sort: "nome", pagination: -1, dacl: 1
            };
            searchParams['codRegione_IN[]'] = vm.selected['regioni[]'];
            searchParams['codProvincia_IN[]'] = vm.selected['province[]'];
            searchParams['tipologiaAccoglienza_IN[]'] = vm.selected['tipAccoglienza[]'];

            vm.progettiSearch = api.progettomc.search(searchParams, function (r) {
                vm.progetti = r.data;
            });

            $scope.filtraente();
        };

        $scope.filtraente = function(){
            if(vm.selected['progetti[]'] == null || vm.selected['progetti[]'] == ""){
                vm.selected['groupProgetti'] = false;
            }
            vm.selected['groupEnti'] = false;

            if(vm.selected['progetti[]'] == 'Seleziona tutti'){
                return;
            }

            vm.selected['enti[]'] = null;
            api.entes.ente.searchReport(vm.selected, function (r) {
                vm.enti = r.data;
            });
        };

        $scope.paginate = function(page,limit){
            if(limit != undefined){
                vm.selected['per-page'] = limit;
            }
            if(page != undefined){
                vm.selected.page = page;
            }
            $scope.search();
        };

        $scope.exportcsv = function() {
            vm.preparati = false;
            vm.selected.pagination = false;
            vm.progress = true;
            switch (vm.tipoReport) {
                case 'nazionalita':
                    api.reportmc.beneficiariPerNazione(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_nazionalita";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'progetti':
                    api.reportmc.beneficiariPerProgetto(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_progetti";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'genere':
                    api.reportmc.beneficiariPerGenere(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_genere";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'nucleoFami':
                    api.reportmc.beneficiariNucleiFamiliari(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_nucleo_fam";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'corsiServizi':
                    api.reportmc.beneficiariCorsiServizi(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_corsi_servizi";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'tipoSoggiorno':
                    api.reportmc.beneficiariTipologiaSoggiorno(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_tipologia_soggiorno";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'uscita':
                    api.reportmc.beneficiariMotiviUscita(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_motivi_uscita";
                        make_export(vm.reportexport,vm.nomefile);
                    });
                    break;

                case 'classiEta':
                    api.reportmc.beneficiariFasceEta(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_classi_eta";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;
                case 'estrazioniministero':
                    api.reportmc.estrazioniMinistero(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_estrazioni_ministero";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'modIngresso':
                    api.reportmc.beneficiariModalitaIngresso(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_beneficiari_per_modalita_ingresso";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'comuniStruttura':
                    api.reportmc.beneficiariComuniStruttura(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_comuni_sede_struttura";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'numerico':
                    api.reportmc.beneficiariNumerico(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_numerico_beneficiari";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'struttureTipologia':
                    api.reportmc.struttureTipologia(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_strutture_per_tipologia";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'postiDisponibili':
                    api.reportmc.postiDisponibili(vm.selected,function(ret) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_posti_disponibili_per_centro";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'dettaglio':
                    api.reportmc.beneficiariDettagli(vm.selected,function(ret){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_dettaglio_benefiiciari";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'covid':
                    api.reportmc.beneficiariCovid(vm.selected,function(ret){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Dati in arrivo...')
                                .position('bottom right')
                                .hideDelay(2000)
                        );
                        vm.reportexport = ret.data;
                        vm.nomefile = "report_benefiiciari_covid";
                        make_export(vm.reportexport,vm.nomefile);
                    })
                    break;

                case 'prorogheBeneficiari':
                  api.reportmc.prorogheBeneficiari(vm.selected,function(ret){
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent('Dati in arrivo...')
                        .position('bottom right')
                        .hideDelay(2000)
                    );
                    vm.reportexport = ret.data;
                    vm.nomefile = "report_proroghe_beneficiari";
                    make_export(vm.reportexport,vm.nomefile);
                  })
                  break;

                case 'prorogheLavorate':
                  api.reportmc.prorogheLavorate(vm.selected,function(ret){
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent('Dati in arrivo...')
                        .position('bottom right')
                        .hideDelay(2000)
                    );
                    vm.reportexport = ret.data;
                    vm.nomefile = "report_proroghe_lavorate";
                    make_export(vm.reportexport,vm.nomefile);
                  })
                  break;
                case 'reportMinistero':
                  api.reportmc.reportMinistero(vm.selected,function(ret){
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent('Dati in arrivo...')
                        .position('bottom right')
                        .hideDelay(2000)
                    );
                    vm.reportexport = ret.data;
                    vm.nomefile = "numerico_nuclei_ucraini";
                    make_export(vm.reportexport,vm.nomefile);
                  })
                  break;
              case 'reportchecklistmonitoraggio':
                api.reportmc.reportChecklistMonitoraggio(vm.selected,function(ret){
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Dati in arrivo...')
                      .position('bottom right')
                      .hideDelay(2000)
                  );
                  vm.reportexport = ret.data;

                  if(vm.selected.tipoMonitoraggio === 'qualitativo') {
                    vm.nomefile = "report_checklist_monitoraggio_qualitative";
                  } else {
                    vm.nomefile = "report_checklist_monitoraggio_amministrative";
                  }
                  make_export(vm.reportexport,vm.nomefile);
                })
                break;
            case 'reportsalnuovo':
            api.reportmc.reportSalNuovo(vm.selected,function(ret){
                $mdToast.show(
                $mdToast.simple()
                    .textContent('Dati in arrivo...')
                    .position('bottom right')
                    .hideDelay(2000)
                );
                vm.reportexport = ret.data;
                    switch(vm.selected.tipoMonitoraggio){
                        case 'qualitativo':
                            vm.nomefile = "report_sal_monitoraggio_qualitative";
                            break;
                        case 'amministrativo':
                            vm.nomefile = "report_sal_monitoraggio_amministrative";
                            break;
                        case 'congiunto':
                            vm.nomefile = "report_sal_monitoraggio_congiunto";
                            break;
                            default:
                            vm.nomefile = "report_sal_monitoraggio_all";
                            break;
                    }
                    make_export(vm.reportexport, vm.nomefile);
                });
            break;
              case 'reportnuovamonitoraggio': // Aggiunto nuovo case
                api.reportmc.reportNuovaMonitoraggio(vm.selected, function (ret) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Dati in arrivo...')
                            .position('bottom right')
                            .hideDelay(2000)
                    );
                    vm.reportexport = ret.data;
                    switch(vm.selected.tipoMonitoraggio){
                        case 'qualitativo':
                            vm.nomefile = "report_checklist_monitoraggio_qualitative";
                            break;
                        case 'amministrativo':
                            vm.nomefile = "report_checklist_monitoraggio_amministrative";
                            break;
                        case 'congiunto':
                            vm.nomefile = "report_checklist_monitoraggio_congiunto";
                            break;
                            default:
                            vm.nomefile = "report_checklist_monitoraggio_all";
                            break;
                    }
                    make_export(vm.reportexport, vm.nomefile);
                });
            break;
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent('Download dati...')
                .position('bottom right')
                .hideDelay(2000)
            );

            function make_export(data,nomeFile) {
                $scope.checkString();
                var sheet2Data = [ {Raggruppamenti:vm.stringRaggruppamenti,
                                    Bandi: vm.stringBandi,
                                    Regioni:vm.stringRegioni,
                                    Province: vm.stringProvince,
                                    Progetti: vm.stringProgetti,
                                    Enti: vm.stringEnti,
                                    Tipologie: vm.stringTipologie,
                                    TipologiaBeneficiari : vm.stringTipBeneficiario,
                                    Nazionalita : vm.stringNazione,
                                    Genere : vm.stringGenere,
                                    TipologiaSoggiorno : vm.stringTipProtezione,
                                    Anno: vm.selected.anno
                                }];
                /* generate a worksheet */
                var ws = XLSX.utils.json_to_sheet(data, {defval:""});
                var ws2 = XLSX.utils.json_to_sheet(sheet2Data, {defval:""});

                console.log(ws)
                /* add to workbook */
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws2, "Filtri");
                XLSX.utils.book_append_sheet(wb, ws, "Report");

                /* write workbook and force a download */
                XLSX.writeFile(wb, nomeFile+".xlsx");

                vm.stringRaggruppamenti = '';
                vm.stringBandi='';
                vm.stringRegioni='';
                vm.stringProvince='';
                vm.stringProgetti='';
                vm.stringEnti='';
                vm.stringTipBeneficiario='';
                vm.stringTipologie = '';
                vm.stringNazione = '';
                vm.stringTipProtezione = '';
                vm.stringGenere = '';
                vm.progress = false;
            }
        }

        $scope.selectData = function(string){
            vm.show = string;
        }

        $scope.disableCheckbox = function(string){
            if(string == 'bandi'){
                if(vm.selected['bandi[]'] == null || vm.selected['bandi[]'] == ""){
                    vm.selected['groupBandi'] = false;
                }
            }
            if(string == 'enti'){
                if(vm.selected['enti[]'] == null || vm.selected['enti[]'] == ""){
                    vm.selected['groupEnti'] = false;
                }
            }
            if(string == 'tipBeneficiario'){
              if(vm.selected['tipBeneficiario[]'] == null || vm.selected['tipBeneficiario[]'] == ""){
                vm.selected['groupTipBeneficiario'] = false;
              }
            }
            if(string == 'nazione'){
              if(vm.selected['nazione[]'] == null || vm.selected['nazione[]'] == ""){
                vm.selected['groupNazione'] = false;
              }
            }
            if(string == 'tipProtezione'){
              if(vm.selected['tipProtezione[]'] == null || vm.selected['tipProtezione[]'] == ""){
                vm.selected['groupTipProtezione'] = false;
              }
            }
            if(string == 'genere'){
              if(vm.selected['genere[]'] == null || vm.selected['genere[]'] == ""){
                vm.selected['groupGenere'] = false;
              }
            }

        }

        $scope.clear = function(string){
            switch (string) {
                case 'bandi':
                    vm.selected['bandi[]'] = undefined;
                    vm.selected['groupBandi'] = 0;
                    break;
                case 'regioni':
                    vm.selected['regioni[]'] = undefined;
                    vm.selected['groupRegioni'] = 0;
                    $scope.filtraprovincia();
                    break;
                case 'province':
                    vm.selected['province[]'] = undefined;
                    vm.selected['groupProvince'] = 0;
                    $scope.filtraprogetto();
                    break;
                case 'progetti':
                    vm.selected['progetti[]'] = undefined;
                    vm.selected['groupProgetti'] = 0;
                    $scope.filtraente();
                    break;
                case 'enti':
                    vm.selected['enti[]'] = undefined;
                    vm.selected['groupEnti'] = 0;
                    break;
                case 'tipaccoglienza':
                    vm.selected['tipAccoglienza[]'] = undefined;
                    vm.selected['groupTipAccoglienza'] = 0;
                    break;

                case 'tipbeneficiario':
                  vm.selected['tipBeneficiario[]'] = undefined;
                  vm.selected['groupTipBeneficiario'] = 0;
                  break;

                case 'nazione':
                  vm.selected['nazione[]'] = undefined;
                  vm.selected['groupNazione'] = 0;
                  break;

                case 'tipProtezione':
                  vm.selected['tipProtezione[]'] = undefined;
                  vm.selected['groupTipProtezione'] = 0;
                  break;

              case 'genere':
                vm.selected['genere[]'] = undefined;
                vm.selected['groupGenere'] = 0;
                break;
            }
        }

        $scope.checkString = function(){

            if (vm.selected['bandi[]']){
                for(var i = 0;i < vm.bandi.length;i++){
                    if(vm.selected['bandi[]'].indexOf(vm.bandi[i].id) != -1){
                        vm.stringBandi += vm.bandi[i].descrizione + ',';
                    }
                }
            }
            if (vm.selected['regioni[]']) {
                for (var i = 0; i < vm.regioni.length; i++) {
                    if (vm.selected['regioni[]'].indexOf(vm.regioni[i].id) != -1) {
                        vm.stringRegioni += vm.regioni[i].regione + ',';
                    }
                }
            }
            if (vm.selected['province[]']) {
                for (var i = 0; i < vm.province.length; i++) {
                    if (vm.selected['province[]'].indexOf(vm.province[i].id) != -1) {
                        vm.stringProvince += vm.province[i].provincia + ',';
                    }
                }
            }
            if (vm.selected['progetti[]']) {
                for (var i = 0; i < vm.progetti.length; i++) {
                    if (vm.selected['progetti[]'].indexOf(vm.progetti[i].id.toString()) != -1) {
                        vm.stringProgetti += vm.progetti[i].nome + ',';
                    }
                }
            }
            if (vm.selected['tipAccoglienza[]']) {
                for (var i = 0; i < vm.tipAccoglienza.length; i++) {
                    if (vm.selected['tipAccoglienza[]'].indexOf(vm.tipAccoglienza[i].id.toString()) != -1) {
                        vm.stringTipologie += vm.tipAccoglienza[i].descrizione + ',';
                    }
                }
            }
            if (vm.selected['enti[]']) {
              for (var i = 0; i < vm.enti.length; i++) {
                if (vm.selected['enti[]'].indexOf(vm.enti[i].id) != -1) {
                  vm.stringEnti += vm.enti[i].nome + ',';
                }
              }
            }
            if (vm.selected['tipBeneficiario[]']) {
              for (var i = 0; i < vm.tipBeneficiario.length; i++) {
                if (vm.selected['tipBeneficiario[]'].indexOf(vm.tipBeneficiario[i].id.toString()) != -1) {
                  vm.stringTipBeneficiario += vm.tipBeneficiario[i].descrizione + ',';
                }
              }
            }
            if (vm.selected['nazione[]']) {
              for (var i = 0; i < vm.nazioni.length; i++) {
                if (vm.selected['nazione[]'].indexOf(vm.nazioni[i].id.toString()) != -1) {
                  vm.stringNazione += vm.nazioni[i].descrizione + ',';
                }
              }
            }
            if (vm.selected['tipProtezione[]']) {
              for (var i = 0; i < vm.tipoProtezione.length; i++) {
                if (vm.selected['tipProtezione[]'].indexOf(vm.tipoProtezione[i].id.toString()) != -1) {
                  vm.stringTipProtezione += vm.tipoProtezione[i].descrizione + ',';
                }
              }
            }
            if (vm.selected['genere[]']) {
              for (var i = 0; i < vm.genere.length; i++) {
                if (vm.selected['genere[]'].indexOf(vm.genere[i].toString()) != -1) {
                  vm.stringGenere += vm.genere[i] + ',';
                }
              }
            }
            var arrayR = [];
            if(vm.selected['groupBandi'] == 1){
                if (vm.stringBandi == ''){
                    vm.stringBandi = 'SELEZIONA TUTTI'
                }
                arrayR.push('Bandi');
            }
            if(vm.selected['groupRegioni'] == 1){

                if (vm.stringRegioni == ''){
                    vm.stringRegioni = 'SELEZIONA TUTTI'
                }
                arrayR.push('Regioni');
            }
            if(vm.selected['groupProvince'] == 1){

                if (vm.stringProvince == ''){
                    vm.stringProvince = 'SELEZIONA TUTTI'
                }
                arrayR.push('Province');
            }
            if(vm.selected['groupProgetti'] == 1){
                if (vm.stringProgetti == ''){
                    vm.stringProgetti = 'SELEZIONA TUTTI'
                }
                arrayR.push('Progetti');
            }
            if(vm.selected['groupEnti'] == 1){
                if (vm.stringEnti == ''){
                    vm.stringEnti = 'SELEZIONA TUTTI'
                }
                arrayR.push('Enti');
            }
            if(vm.selected['groupTipBeneficiario'] == 1){
                if (vm.stringTipBeneficiario == ''){
                    vm.stringTipBeneficiario = 'SELEZIONA TUTTI'
                }
                arrayR.push('Tipologia ingresso protetto');
            }
            if(vm.selected['groupTipAccoglienza'] == 1){
              if (vm.stringTipologie == ''){
                  vm.stringTipologie = 'SELEZIONA TUTTI'
              }
              arrayR.push('Tipologie Accoglienza');
            }
            if(vm.selected['groupNazione'] == 1){
              if (vm.stringTipologie == ''){
                vm.stringTipologie = 'SELEZIONA TUTTI'
              }
              arrayR.push('Nazioni');
            }
            if(vm.selected['groupTipProtezione'] == 1){
              if (vm.stringTipologie == ''){
                vm.stringTipologie = 'SELEZIONA TUTTI'
              }
              arrayR.push('Tipologia di soggiorno');
            }
            if(vm.selected['groupGenere'] == 1){
              if (vm.stringGenere == ''){
                vm.stringGenere = 'SELEZIONA TUTTI'
              }
              arrayR.push('Genere');
            }
            arrayR.forEach(function(value){
                vm.stringRaggruppamenti += value+',';
            })
        }

        $scope.checkDate = function(tipo){
            switch (tipo) {
                case 'da':
                    vm.controlA = vm.dateSelezionate.dataDa;
                    break;

                case 'a':
                    if(vm.oggi > vm.dateSelezionate.dataA){
                        vm.controlDa = vm.dateSelezionate.dataA;
                        if (vm.dateSelezionate.dataDa > vm.dateSelezionate.dataA){
                            vm.dateSelezionate.dataDa = vm.dateSelezionate.dataA;
                        }
                    }else{
                        vm.controlDa = vm.oggi;
                    }
                     break;
            }
        }

        $scope.tipologieBReportMinistero = function(tipB){
          return tipB.id == 4 || tipB.id == 5;
        }

      $scope.nazioniReportMinistero = function(nazione){
        return nazione.id == 252 || nazione.id == 195 || nazione.id ==133;
      }
    }

    function SchedaMonitoraggioMcController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast, $mdDateLocale, $rootScope)
    {
        var vm = this;

        vm.selected = {};

        vm.attivo = 1;

        $scope.cambiaProgetti = function(){

          api.progettomc.search({attivo: vm.attivo, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
            vm.progetti = r.data;
          });

        }

        $scope.cambiaProgetti();


        vm.periodi = [
            'I SEMESTRE',
            'II SEMESTRE',
            'ANNUALE'
        ];

        vm.tipoSoggBody = [];
        vm.corsiServiziBody = [];
        var today = new Date();
        vm.currentDate =  $filter('date')(today, 'dd/MM/yyyy');

        $scope.search = function(){
            if (!vm.selected['progetti'] || !vm.anno || !vm.selected['periodo']){
              $mdDialog.show(
                $mdDialog.alert()
                  .title('Attenzione!')
                  .textContent("Per poter generare il report è necessario inserire il progetto, l'anno e il periodo")
                  .ok('Ho capito!')
              )
              return;
            }
            if(vm.selected['periodo'] == 'I SEMESTRE'){
                vm.dataDa = vm.anno.toString()+'-01-01';
                vm.dataA = vm.anno.toString()+'-06-30';
            }
            if (vm.selected['periodo'] == 'II SEMESTRE'){
                vm.dataDa = vm.anno.toString()+'-07-01';
                vm.dataA = vm.anno.toString()+'-12-31';
            }
            if(vm.selected['periodo'] == 'ANNUALE'){
                vm.dataDa = vm.anno.toString()+'-01-01';
                vm.dataA = vm.anno.toString()+'-12-31';
            }

            api.reportmc.postiProgettoMonitoraggio({id:vm.selected['progetti'],dataDa:vm.dataDa,dataA:vm.dataA},function(ret){
                vm.ret = ret.data;
                vm.ente = vm.ret[0]['ente']
                vm.nome = vm.ret[0]['nome'];
                vm.postiTot = vm.ret[0]['postiTot'];
                vm.accolti = vm.ret[0]['Totali'];
            })

            api.reportmc.tipoSoggiornoMonitoraggio({id:vm.selected['progetti'],dataDa:vm.dataDa,dataA:vm.dataA},function(ret){
                vm.tipoSoggiorno = ret.data;
                $scope.total('tipSogg');
                vm.keyTipoSoggiorno =  Object.keys(vm.tipoSoggiorno[0]);
            })

            api.progettomc.serviziMonitoraggio({id:vm.selected['progetti'],dataDa:vm.dataDa,dataA:vm.dataA},function(ret) {
                vm.corsiServizi = ret;
                $scope.total('corsiServizi');
                vm.keyCorsiServizi = Object.keys(vm.corsiServizi[0]);
            })

        }

        $scope.total = function(string){
            var total = 0;
            if(string == 'tipSogg'){
                angular.forEach(vm.tipoSoggiorno,function(tipoS){
                    total += parseInt(tipoS['Totali']);
                })
                vm.totalTipoSoggiorno = total;
            }
            if(string == 'corsiServizi'){
                angular.forEach(vm.corsiServizi,function(riga){
                    total += parseInt(riga['beneficiari']);
                })
                vm.totCorsiServizi = total;
            }
        }



        $scope.exportPdf = function(){
            tipoSoggData();
            corsiServiziData();
            var docDefinition = {
                content: [
                    {text:'SCHEDA DI MONITORAGGIO',style:'header'},
                    {columns:[
                            {text:'Progetto Territoriale di: ',
                                style:'subheader',
                                alignment: 'right'
                            },
                            {
                                text:vm.nome,
                                alignment: 'left',
                                style:'subheader',
                                bold:true,
                            }
                        ]},
                    {text:'Scheda riassuntiva sui servizi erogati dal '+vm.dataDa+' al '+ vm.dataA,
                        style:'subheader'},
                    '\n',
                    {text:'Presenza Beneficiari',style:'paragraphHeader'},
                    {
                        style: 'table',
                        table: {
                            widths: [200,200],
                            body: [
                                ['', {text:'Numero Beneficiari Accoglienza Interna',style:'tableHeader'}],
                                [{text:'Posti Progetto Totali',style:'tableHeader'}, vm.postiTot],
                                [{text:'Presenti nella finestra temporale',style:'tableHeader'}, vm.accolti]
                            ]
                        }
                    },
                    {text:'Presenza per Tipo di Soggiorno',style:'paragraphHeader'},
                    {
                        style: 'table',
                        table: {
                            widths: [200,200],
                            headerRows: 1,
                            body: vm.tipoSoggBody
                        },
                        layout: {
                            fillColor: function (rowIndex, node, columnIndex) {
                                return (rowIndex === 0) ? '#CCCCCC' : null;
                            }
                        }
                    },
                    {text:'Elenco Servizi Erogati',style:'paragraphHeader'},
                    {
                        style: 'table',
                        table: {
                            widths:  [155,155,80],
                            headerRows: 1,
                            body: vm.corsiServiziBody
                        },
                        layout: {
                            fillColor: function (rowIndex, node, columnIndex) {
                                return (rowIndex === 0) ? '#CCCCCC' : null;
                            }
                        }
                    },
                    {columns:[
                            {
                                text:vm.ente+', '+vm.currentDate,
                                style:'footer',
                                alignment: 'left'
                            },
                            {
                                text:"Il Responsabile del Progetto per l'Ente Locale",
                                alignment: 'left',
                                style:'footer',
                            }
                        ]},
                ],
                styles: {
                    header: {
                        fontSize: 16,
                        bold: true,
                        alignment: 'center',
                    },
                    paragraphHeader: {
                        fontSize: 13,
                        bold: true,
                        alignment:'center',
                    },
                    subheader: {
                        fontSize: 13,
                        columnGap:0,
                        alignment: 'center',
                    },
                    table: {
                        fontSize: 13,
                        margin: [50,5] ,
                    },
                    tableHeader: {
                        fontSize: 12,
                        columnGap:0,
                        bold: true
                    },
                    tableValue: {
                        fontSize: 11,
                    },
                    footer: {
                        margin:[30,30],
                        fontSize: 10,
                    },
                },
                defaultStyle: {
                    columnGap: 20,
                }
            }
            pdfMake.createPdf(docDefinition).download('SchedaMonitoraggio-'+vm.nome+'-'+vm.currentDate+'.pdf');
        }

        function tipoSoggData() {
            if (vm.tipoSoggiorno.length > 0) {

                var header = ['TIPOLOGIA SOGGIORNO', 'ACCOLTI'];
                vm.tipoSoggBody.push(header);
                vm.tipoSoggiorno.forEach(function (tipoSoggRow) {
                    var row = [];

                    row.push(tipoSoggRow['tipSoggiorno']);
                    row.push(tipoSoggRow['Totali']);
                    vm.tipoSoggBody.push(row);
                });
                var footer = ['TOTALE', vm.totalTipoSoggiorno];
                vm.tipoSoggBody.push(footer);
            }else{
                var header = ['TIPOLOGIA SOGGIORNO', 'ACCOLTI'];
                vm.tipoSoggBody.push(header);
                var footer = ['TOTALE', 0];
                vm.tipoSoggBody.push(footer);
            }
        }

        function corsiServiziData(){
            if(vm.corsiServizi.length > 0){
                var header = ['CATEGORIA','SOTTOCATEGORIA','BENEFICIARI'];
                vm.corsiServiziBody.push(header);
                vm.corsiServizi.forEach(function(corsiSerRow){
                    var row = [];

                    row.push(corsiSerRow['TipoCategoria']);
                    row.push(corsiSerRow['Sottocategoria']);
                    row.push(corsiSerRow['beneficiari']);
                    vm.corsiServiziBody.push(row);
                });
                var footer = ['','TOTALE',vm.totCorsiServizi];
                vm.corsiServiziBody.push(footer);
            }else{
                var header = ['CATEGORIA','SOTTOCATEGORIA','BENEFICIARI'];
                vm.corsiServiziBody.push(header);
                var footer = ['','TOTALE',0];
                vm.corsiServiziBody.push(footer);
            }
        }

    }


    function ReportMinisteroController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, $filter, $mdToast) {
      var vm = this;
      vm.selected = {}
      vm.api = api;
      vm.dateReport = [];

      vm.esportaCsv = esportaCsv;
      vm.ripetiProgetti = ripetiProgetti;
      vm.ripetiStrutture = ripetiStrutture;
      vm.resetDateReport = resetDateReport;



      api.progettomc.search({attivo: 1, tipologiaAccoglienzaId: 2, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
        vm.progetti = r.data;
      });

      vm.mapReport = [
        {'tipo': 'report-beneficiari', 'label': 'Anagrafica Minori'},
        {'tipo': 'report-progetti', 'label': 'Progetti MSNA'},
        {'tipo': 'report-strutture', 'label': 'Strutture MSNA'},
      ];

      vm.selected.tipoReport = 'report-beneficiari';
      api.reportmc.dateReportMinistero({}, function(res) {
        vm.dateReport = res;

        vm.selected.dataReport = vm.dateReport[vm.selected.tipoReport][0]['dataEstrazione'];
      });

      function esportaCsv() {
        api.reportmc.reportMinisteroLavoro(vm.selected,function(res) {
          if(res.data === 0) {
            var dialog = $mdDialog.confirm()
              .title('Dati non presenti')
              .htmlContent('L\'estrazione da lei selezionata non contiene dati.')
              .ariaLabel('estrazione no dati')
              .ok('OK');
            $mdDialog.show(dialog);
            return;
          }
          $mdToast.show(
            $mdToast.simple()
              .textContent('Dati in arrivo...')
              .position('bottom right')
              .hideDelay(2000)
          );
          esportaDati(res.data,vm.selected.tipoReport);
        });
      }

      function esportaDati(data,tipoReport) {
        /* generate a worksheet */
        var ws = XLSX.utils.json_to_sheet(data);
        var ws2 = null;
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report stock");
        var nome;
        for (const item of vm.mapReport) {
          if(item.tipo === tipoReport) {
            nome = item.label;
            break;
          }
        }
        var filename = nome+" del "+vm.selected.dataReport +".xlsx"

        if(tipoReport === 'report-beneficiari') {
          api.reportmc.reportMinisteroLavoro({'progetti[]': vm.selected['progetti[]'], tipoReport: "flusso-beneficiari", dataReport: vm.selected.dataReport}, function(ret) {
            if(ret.data === 0) {
              ws2 = XLSX.utils.json_to_sheet([
                {'Non sono stati terminati beneficiari MSNA dallo scorso report': ''}
              ])
            } else {
              ws2 = XLSX.utils.json_to_sheet(ret.data);
            }
            XLSX.utils.book_append_sheet(wb, ws2, "Report di flusso");
            XLSX.writeFile(wb, filename);
          });
        } else {
          XLSX.writeFile(wb, filename);
          /* write workbook and force a download */
        }
      }

      function ripetiProgetti() {
        var confirm = $mdDialog.confirm()
          .title('Sei sicuro di rieseguire l\'estrazione per i progetti?')
          .htmlContent('La nuova estrazione andrà a sostiuire quella precedente aggiornato inoltre la data di estrazione dei dati.')
          .ariaLabel('riesegui estrazione progetti')
          .ok('OK')
          .cancel('ABBANDONA');
        $mdDialog.show(confirm).then(function () {
          api.reportmc.progettiMinori({}, function (res) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Estrazione rieseguita con successo')
                .position('bottom right')
                .hideDelay(2000)
            );
            $state.reload();
          });
        })
      }

      function ripetiStrutture() {
        var confirm = $mdDialog.confirm()
          .title('Sei sicuro di rieseguire l\'estrazione per le strutture?')
          .htmlContent('La nuova estrazione andrà a sostiuire quella precedente aggiornato inoltre la data di estrazione dei dati.')
          .ariaLabel('riesegui estrazione strutture')
          .ok('OK')
          .cancel('ABBANDONA');
        $mdDialog.show(confirm).then(function () {
          api.reportmc.struttureMinori({}, function (res) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Estrazione rieseguita con successo')
                .position('bottom right')
                .hideDelay(2000)
            );
            $state.reload();
          });
        })
      }
      function resetDateReport() {
        vm.selected.dataReport = vm.dateReport[vm.selected.tipoReport][0];
      }
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.rendicontazioni')
    .controller('RendicontazioniMcController',RendicontazioniMcController)
    .filter('formatPeriodo', formatPeriodoProvider);

  /** @ngInject */
  function RendicontazioniMcController($filter, $location, $state, api, $httpParamSerializer, $mdToast, rendicontazioniUtility, $scope){
    var vm = this;
    vm.api = api;

    vm.gotoRendicontazione = gotoRendicontazione;
    vm.onSearch = onSearch;
    vm.svuotaRicerca = svuotaRicerca;
    vm.downloadCsv = downloadCsv;
    vm.downloadCsvRegistro = downloadCsvRegistro;
    vm.downloadPdf = downloadPdf;

    vm.defaultfilterModel = {
      'progetto.nome': undefined,
      'progetto.attivo': 1,
      'progetto.tipologiaAccoglienzaId': undefined,
      'documentoRendicontazione.codiceProgetto': undefined,
      'documentoRendicontazione.anno': undefined,
      progettoRendicontazioneTipo_id: undefined,
      progettoRendicontazioneStato_id: undefined,
      modoRendicontazioneId: undefined
    };
    vm.filterModel = angular.copy(vm.defaultfilterModel);

    vm.search = {
      sort: '-id',
      'per-page': 10,
      page: 1
    };

    vm.rendicontazioni = {};
    vm.statiProgetto = [{id: 0, descrizione: "NON ATTIVO"}, {id: 1, descrizione: "ATTIVO"}];
    api.tipologiaAccoglienza.tipologie.search(function(res){
      vm.tipAccoglienza = res.data;
    });


    vm.anni = api.documentorendicontazione.anni();

    vm.rendicontazioniStati = api.rendicontazionemc.stati.query();
    vm.rendicontazioniTipi = api.rendicontazionemc.tipi.query();
    vm.rendicontazioniModi = api.rendicontazionemc.modi.query();

    initSearch();
    onSearch();
    //-----------FUNCTION IMPLEMENTATION----------------

    function gotoRendicontazione(rendicontazione)
    {
      $state.go('app.sprardb_rendicontazionimc_rendicontazione', {
        id: rendicontazione.id,
        tipoRendicontazione: rendicontazione.progettoRendicontazioneTipo_id,
        anno: rendicontazione.anno
      });
    }

    function initSearch() {
      var searchUrl = $location.search();

      angular.forEach(searchUrl, function(value, key) {
        if (vm.defaultfilterModel.hasOwnProperty(key)) {
          try {
            value = JSON.parse(value);
          } catch (e) {}
          vm.filterModel[key] = value;
        } else {
          vm.search[key] = value;
        }
      });
    }

    function onSearch() {
      $location.search($httpParamSerializer(angular.merge({}, vm.search, vm.filterModel)));

      var search = angular.merge({}, vm.search, {filter: vm.filterModel});
      vm.rendicontazioni = api.documentorendicontazione.query(search, function(res) {
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });
    }

    function svuotaRicerca() {
      vm.filterModel = {};
      onSearch();
    }

    function downloadCsv(event, rend) {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Download csv in corso...')
          .position('bottom right')
          .hideDelay(3000)
      );

      window.open(api.baseUrl +'documento-rendicontazione/'+ rend.id +'/csv-prospetto?k='+ rend.key, '_blank', '');
    }

    function downloadCsvRegistro(event, rend)
    {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Download csv in corso...')
          .position('bottom right')
          .hideDelay(3000)
      );

      window.open(api.baseUrl +'documento-rendicontazione/'+ rend.id +'/csv-registro?k='+ rend.key, '_blank', '');
    }


    function downloadPdf(event, rendicontazione) {
      var importi;
      var sal = rendicontazione.progettoRendicontazioneTipo_id === 4;
      var expand = 'modo,tipo,stato,progetto,prospetto,periodo,setup' + (sal ? ',preventivo.prospetto' : '');
      var tipi = sal ? [false, 'impegnato', 'quietanzato'] : [false];

      function riempiRiga(riga, codiceSpesa, codiceSpesaPreventivo, numberStyle, percentStyle) {
        tipi.forEach(function(tipo) {
          importi.forEach(function (importo) {
            var val;
            if (tipo) {
              val = codiceSpesa[tipo][importo];
            } else {
              if (sal) {
                val = codiceSpesaPreventivo[importo];
              } else {
                val = codiceSpesa[importo];
              }
            }
            riga.push({text: $filter('currency')(val), style: numberStyle})
          });
        });

        tipi.forEach(function(tipo) {
          if (tipo) {
            riga.push({text: $filter('number')((codiceSpesa[tipo].totale / codiceSpesaPreventivo.totale) *100, 2) +'%', style: percentStyle || numberStyle})
          }
        });

        return riga;
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent('Download pdf in corso...')
          .position('bottom right')
          .hideDelay(3000)
      );

      api.documentorendicontazione.get({id: rendicontazione.id, expand: expand}, function(rendicontazione) {
        importi = rendicontazione.modo.importiPreventivo;

        var prospetto = {
          costiDiretti: rendicontazioniUtility.serializza(rendicontazione.prospetto.costiDiretti),
          costiIndiretti: rendicontazioniUtility.serializza(rendicontazione.prospetto.costiIndiretti)
        }

        if (sal) {
          var preventivo = {
            costiDiretti: rendicontazioniUtility.serializza(rendicontazione.preventivo.prospetto.costiDiretti),
            costiIndiretti: rendicontazioniUtility.serializza(rendicontazione.preventivo.prospetto.costiIndiretti),
            prospetto: rendicontazione.preventivo.prospetto
          };
          preventivo.prospetto.get = rendicontazioniUtility.get;
        }
        var data = [];

        var header = [
          {text: 'COD.', style: 'tableHeader'},
          {text: 'DESCRIZIONE SPESA', style: 'tableHeader'}
        ];
        if (sal) {
          if (rendicontazione.modo.id < 4) {
            header = header.concat([
              {text: 'A', style: 'tableHeader'},
              {text: 'B', style: 'tableHeader'},
              {text: 'C [A+B]', style: 'tableHeader'},
              {text: 'D', style: 'tableHeader'},
              {text: 'E', style: 'tableHeader'},
              {text: 'F [D+E]', style: 'tableHeader'},
              {text: 'G', style: 'tableHeader'},
              {text: 'H', style: 'tableHeader'},
              {text: 'I [G+H]', style: 'tableHeader'},
              {text: '% (F/C)', style: 'tableHeader'},
              {text: '% (I/C)', style: 'tableHeader'}
            ]);
          } else {
            header = header.concat([
              {text: 'PIANO FINANZIARIO', style: 'tableHeader'},
              {text: 'SPESE IMPEGNATE', style: 'tableHeader'},
              {text: 'DI CUI QUIETANZIATE', style: 'tableHeader'},
              {text: '% (F/C)', style: 'tableHeader'},
              {text: '% (I/C)', style: 'tableHeader'}
            ]);
          }
        } else {
          if (rendicontazione.modo.cofinanziamento) {
            header = header.concat([{text: 'IMPORTO COFINANAZIATO', style: 'tableHeader'}]);
          }

          header = header.concat([{text: 'CONTRIBUTO RICHIESTO', style: 'tableHeader'}]);

          if (rendicontazione.modo.importiPreventivo.indexOf('totale') !== -1) {
            header = header.concat([{text: 'COSTO TOTALE PROGETTO', style: 'tableHeader'}]);
          }
        }
        data.push(header);

        //costi diretti
        angular.forEach(prospetto.costiDiretti, function (item) {
          var riga = [
            {text: item.codice[0] === '~' ? '' : item.codice, style: item.style ? item.style.textStyle : undefined},
            {text: item.descrizione.substring(0, sal ? 50 : undefined), style: item.style ? item.style.textStyle : undefined}
          ];
          var vocePreventivo = sal ? preventivo.prospetto.get('costiDiretti.'+item.path) : null;

          data.push(riempiRiga(riga, item, vocePreventivo, item.style ? item.style.numberStyle : 'tot'));
        });

        //totale costi diretti
        var costiDiretti = rendicontazione.prospetto.costiDiretti;
        var rigaCostiDiretti = sal ? [{text: 'Costi diretti', style: 'tableSubFooter'}, '']
          : ['', {text: 'TOTALE COSTI DIRETTI', style: 'tableSubFooter'}];
        var vocePreventivo = sal ? preventivo.prospetto.costiDiretti : null;

        data.push(riempiRiga(rigaCostiDiretti, costiDiretti, vocePreventivo, 'tableSubFooterTot', 'tableSubFooterTot'));

        //costi indiretti
        angular.forEach(prospetto.costiIndiretti, function (item) {
          var riga = [
            {text: item.codice, style: item.style ? item.style.textStyle : undefined},
            {text: item.descrizione.substring(0, sal ? 50 : undefined), style: item.style ? item.style.textStyle : undefined}
          ];
          var vocePreventivo = sal ? preventivo.prospetto.get('costiIndiretti.'+item.path) : null;

          data.push(riempiRiga(riga, item, vocePreventivo, item.style ? item.style.numberStyle : 'tot'));
        });

        //totale complessivo
        var costiComplessivi = rendicontazione.prospetto.costiComplessivi;
        var rigaTotaleComplessivo = sal ? [{text: 'Totale', style: 'tableSubFooter'}, '']
          : ['', {text: 'TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)', style: 'tableSubFooter'}];
        vocePreventivo = sal ? preventivo.prospetto.costiComplessivi : null;

        data.push(riempiRiga(rigaTotaleComplessivo, costiComplessivi, vocePreventivo, 'tableSubFooterTot', 'tableSubFooterTot'));

        var dataInizio = moment(rendicontazione.setup.dataInizioPeriodo).format('DD/MM/YYYY');
        var dataFine = moment(rendicontazione.setup.dataFinePeriodo).format('DD/MM/YYYY');



        var docDefinition = {
          pageOrientation: sal ? 'landscape' : 'portrait',
          content: [
            {text: 'PROGETTO ' + rendicontazione.progetto.nome, style: 'header'},
            {text: '\n'},
            {text: 'cod. ' + rendicontazione.codiceProgetto},
            {text: '\n'},
            {text: 'Bando: ' + rendicontazione.categoria},
            {text: '\n', style: 'header'},
            {text: 'Anno: ' + rendicontazione.anno, style: 'headerleft'},
            {text: 'Periodo: ' + dataInizio + ' - ' + dataFine, style: 'headerleft'}
          ]
        };

        if (!sal && rendicontazione.progettoRendicontazioneTipo_id !== 1) { //se non è sal né preventivo
          if (rendicontazione.modo.prosecuzione) {
            docDefinition.content.push({text: 'Prosecuzione: ' + (rendicontazione.prosecuzione ? 'SI' : 'NO'), style: 'headerleft'});
          }
          if (rendicontazione.modo.prorogaTecnica) {
            docDefinition.content.push({text: 'Proroga tecnica: ' + (rendicontazione.prorogaTecnica ? 'SI' : 'NO'), style: 'headerleft'});
          }
        }

        docDefinition.content.push([
          {text: 'Documento: ' + rendicontazione.tipo.descrizione, style: 'headerleft'},
          {text: 'Stato: ' + rendicontazione.stato.descrizione, style: 'headerleft'}
        ]);

        if (sal) {
          docDefinition.pageMargins = [30,30,30,30];
          if (rendicontazione.modo.id < 4) {
            docDefinition.content.push([
              {text: '\n', style: 'headerleft'},
              {text: 'GRUPPO PREVENTIVO', style: 'dida'},
              {text: 'A: IMPORTO COFINANZIATO | B: CONTRIBUTO RICHIESTO | C: COSTO TOTALE PROGETTO', style: 'dida'},
              {text: '\n', style: 'dida'},
              {text: 'GRUPPO SOMME IMPEGNATE', style: 'dida'},
              {text: 'D: IMPORTO COFINANZIATO impegnato | E: CONTRIBUTO RICHIESTO impegnato | F: COSTO TOTALE PROGETTO impegnato', style: 'dida'},
              {text: '\n', style: 'dida'},
              {text: 'GRUPPO SOMME QUIETANZATE', style: 'dida'},
              {text: 'G: IMPORTO COFINANZIATO quietanzato | H: CONTRIBUTO RICHIESTO quietanzato | I: COSTO TOTALE PROGETTO quietanzato', style: 'dida'}
            ]);
          }
        }
        docDefinition.content.push([
          {text: '\n', style: 'header'},
          {
            style: 'demoTable',
            table: {
              headerRows: 1,

              body: data
            },
            layout: 'lightHorizontalLines'
          },
          {text: '\n', style: 'header'},
          {text: '\n', style: 'header'},
          {text: '\n', style: 'header'}
        ]);

        docDefinition.styles = {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
            alignment: 'center'
          },
          headerright: {
            fontSize: sal ? 7.5 : 12,
            alignment: 'right'
          },
          headerleft: {
            fontSize: sal ? 7.5 : 12,
            alignment: 'left'
          },
          demoTable: {
            fontSize: sal ? 7.5 : 8,
            margin: [0, 10, 0, 10],
            color: 'black'

          },
          dida: {
            fontSize: 7.5,
            alignment: 'left'
          },
          tableHeader: {
            bold: true,
            fontSize: sal ? 7.5 : 8,
            color: 'black'
          },
          tableSubHeader: {
            bold: true,
            fontSize: sal ? 7.5 : 10,
            color: 'grey'
          },
          tableSubHeaderTot: {
            bold: true,
            fontSize: sal ? 7.5 : 10,
            color: 'grey',
            alignment: 'right'
          },
          tableSubFooter: {
            bold: true,
            fontSize: sal ? 7.5 : 10,
            color: 'blue'
          },
          tableSubFooterTot: {
            bold: true,
            fontSize: sal ? 7.5 : 10,
            color: 'blue',
            alignment: 'right'
          },
          tot: {
            alignment: 'right'
          }
        };
        pdfMake.createPdf(docDefinition).download("rendicontazione_" + rendicontazione.progetto.id + '.pdf');
      });
    }
  }

  function formatPeriodoProvider() {
    return function formatPeriodo(dataInizio, dataFine) {
      dataInizio = new Date(dataInizio);
      dataFine = new Date(dataFine);
      dataFine.setHours(0, 0, 0, 0);
      var ultimoGiorno = new Date(dataFine.getFullYear(), dataFine.getMonth() + 1, 0)
      ultimoGiorno.setHours(0, 0, 0, 0);

      if (dataInizio.getDate() === 1 && dataFine.getTime() === ultimoGiorno.getTime()) {
        return dataInizio.getFullYear();
      }
    }
  }




})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.rendicontazioni')
            .controller('RendicontazioniController', RendicontazioniController)
            .controller('DialogProgettiController', DialogProgettiController)
            .controller('SetupListRendicontazioneController', SetupListRendicontazioneController)
            .controller('SetupDetailBulkController', SetupDetailBulkController)
            .controller('SetupDettaglioController', SetupDettaglioController)
            .filter('filterTipo', filterTipo);

    /** @ngInject */
    function RendicontazioniController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdToast, api, $q, rendicontazioniUtility, acl)
    {
        var vm = this;
        vm.datiRendicontazione = {};
        vm.allLoaded = false;

        vm.openNewRendicontazioneDialog = openNewRendicontazioneDialog;
        vm.associaProgettoDialog = associaProgettoDialog;
        vm.gotoRendicontazione = gotoRendicontazione;
        vm.getTotal = rendicontazioniUtility.getTotal;
        vm.downloadPdf = downloadPdf;
        vm.downloadCsv = downloadCsv;
        vm.downloadCsvSAL = downloadCsvSAL;
        vm.downloadCsvRF = downloadCsvRF;
        vm.downloadPdfSAL = downloadPdfSAL;
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly
        vm.isTutor = api.isTutor;
        vm.isallowed = acl.isallowed;
        vm.selected = [];
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.limitOptions = [5, 10, 15, 20];

        vm.searched = false;
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 15;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;


        vm.rendicontazioni = null;
        vm.rendicontazioniStati = null;
        vm.rendicontazioniTipi = null;
        vm.annos = null;
        vm.statiProgetto = [{id: 0, descrizione: "NON ATTIVO"}, {id: 1, descrizione: "ATTIVO"}];

        /***
         $q.all([
         api.rendicontaziones.rendicontazione.like(vm.allsearchs),
         api.rendicontaziones.stati.get(),
         api.rendicontaziones.tipi.get(),
         ]).then(function(data){
         vm.rendicontazioni = data[0];
         vm.rendicontazioniStati = data[1];
         vm.rendicontazioniTipi = data[2];
         });
         ***/


        api.rendicontaziones.stati.get(function (res) {
            for (var i = res.data.length - 1; i >= 0;i--) {
                if (vm.isVisitatore){
                    if (res.data[i].id === 1 || res.data[i].id === 2 || res.data[i].id === 4) {
                        //Lorenzo: questo per rimuovere stati non visibili al profil visitatore
                        res.data.splice(i,1);
                    }
                }
                if (vm.isTutor){
                    if (res.data[i].id === 2) {
                        //Lorenzo: questo per rimuovere stati non visibili al profilo tutor
                        res.data.splice(i,1);
                    }
                }
            }
            vm.rendicontazioniStati = res;
        });
        api.rendicontaziones.tipi.get(function (res) {
            vm.rendicontazioniTipi = res;
        });
        api.rendicontaziones.rendicontazione.distinct({anno: 'distinct'}, function (response) {
            vm.annos = response;
        });

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.stati = null;

        if (vm.isVisitatore){
            vm.stati = [3,5];  //Lorenzo: no stati BOZZA,SALVATO e RIAPERTO
        }
        if (vm.isTutor){
            vm.stati = [1,3,4,5]; //Lorenzo: no stato SALVATO
        }

        vm.ricerca = {
            'anno': null,
            'progettoRendicontazioneTipo_id': null,
            'progettoRendicontazioneStato_id_IN': vm.stati,
            'istats-regione': null,
            'tags-id': null,
            'progetto-attivo': 1,
            'rendicontazioneFinale_id_IS': 'NULL'
        };
        vm.ricercalabel = {
            'anno': 'Anno rendicontazione: ',
            'progettoRendicontazioneTipo_id': 'Tipo di documento: ',
            'progettoRendicontazioneStato_id': 'Stato rendicontazione: ',
            'istats-regione': 'Regione: ',
            'tags-id': 'Tag: ',
            'progetto-attivo': 'Stato Progetto: '
        };
        vm.ricerca2 = "";
        vm.searched = true;
        vm.search2 = "";
        vm.mostraitag = false;
        // Methods
        vm.exists = msUtils.exists;
        vm.pager = pager;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.orderby = orderby;

        vm.colors = ['md-blue-grey-400-bg', 'md-blue-grey-600-bg', 'md-teal-300-bg', 'md-teal-700-bg', 'md-amber-300-bg', 'md-amber-700-bg', 'md-grey-400-bg', 'md-grey-800-bg', 'md-light-green-300-bg', 'md-light-green-500-bg', 'md-red-500-bg', 'md-red-900-bg', 'md-cyan-800-bg', 'md-cyan-400-bg', 'md-lime-300-bg', 'md-lime-500-bg', 'md-blue-400-bg', 'md-blue-900-bg', 'md-pink-200-bg', 'md-pink-700-bg', 'md-light-green-900-bg', 'md-lime-900-bg', 'md-blue-grey-900-bg'];

        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]['progetto-nome'] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.rendicontaziones.rendicontazione.like(vm.allsearchs, function (d) {
                vm.rendicontazioni = d;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }

        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            vm.dataFilter.sort = order + field;
            api.rendicontaziones.rendicontazione.search(vm.dataFilter, function (response) {
                vm.rendicontazioni = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }

        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['nome'] = string;
            vm.ricerca2['operatore'] = 'OR';
            api.rendicontaziones.rendicontazione.like(vm.ricerca2, function (response) {
                vm.rendicontazioni = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }

        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            if (Object.keys(vm.ricerca).length > 0) {
                api.rendicontaziones.rendicontazione.search({}, function (response) {
                    vm.rendicontazioni = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.rendicontaziones.rendicontazione.search({}, function (response) {
                    vm.rendicontazioni = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }

        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.rendicontaziones.rendicontazione.search({}, function (response) {
                vm.rendicontazioni = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }

        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }

        vm.progetti = null;
        function openNewRendicontazioneDialog(ev)
        {
            api.progettos.progetto.search({fields: "id,nome", pagination: "-1", sort: "nome", attivo: 1}, function (response) {
                vm.progetti = response;
                $mdDialog.show({
                    controller: 'DialogProgettiController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/project-dialog.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Progetti: vm.progetti
                    }
                });
            });
        }
        function associaProgettoDialog(ev, id, progn)
        {
            var currentId = id;
            var currentProgn = progn;
            api.progettos.progetto.search({fields: "id,nome, bandos", pagination: "-1", sort: "nome", attivo: 1}, function (response) {
                vm.progetti = response;
//                console.log(response);
                $mdDialog.show({
                    controller: 'DialogProgettiController',
                    controllerAs: 'vmd',
                    templateUrl: 'app/main/sprardb/rendicontazioni/dialogs/project-dialog2.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Progetti: vm.progetti
                    }
                }).then(function (item) {
                    if (item !== null) {
                        api.rendicontaziones.rendicontazionem.aggiorna({id: currentId, progetto_id: item}, function (r) {
                            api.rendicontaziones.progettoParametriRendicontazione.search({codiceProgetto: currentProgn}, function (d) {
                                var updateId = d.data[0].id;
                                api.rendicontaziones.progettoParametriRendicontazione.aggiorna({id: updateId, progetto_id: item}, function (r2) {
                                    if (r2.id === updateId) {
                                        $mdToast.show(
                                                $mdToast.simple()
                                                .textContent('Preventivo rendicontazione aggiornato.')
                                                .position('bottom right')
                                                .hideDelay(3000)
                                                ).then(
                                                $state.reload()
                                                );
                                    }
                                });
                            });
                        });
                        console.log("item", item);
                        console.log("id", currentId);
                    }
                });
            });
        }

        function gotoRendicontazione(idRendicontazione)
        {
            $state.go('app.sprardb_rendicontazioni_rendicontazione', {id: idRendicontazione});
        }

        function elaboraResocontoRendicontazioneFinale(model) {

            //console.log(vm.datiRendicontazione);
            vm.datiRendicontazione.jsonData.items.forEach(function (key) {
                var codiceSpesa = key[6].value;
                var spesaAttiva = 1;
                if (angular.isDefined(key[12])) {
                    spesaAttiva = key[12].value;
                }
//console.log("attivissimo",spesaAttiva);
                model.forEach(function (key2) {
                    key2.items.forEach(function (key3) {
                        if (key3.id == codiceSpesa && spesaAttiva == 1) {

                            key3.fields[0].value = Number(key3.fields[0].value) + Number(key[9].value);
                            key3.fields[1].value = Number(key3.fields[1].value) + Number(key[10].value);

                        }
                    });
                });
            });

            return model;
        }
        ;

        function downloadPdf(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;

                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaPdf();
                        });
                    } else
                    {
                        creaPdf();
                    }
                });
            });
        }

        function creaPdf() {

            console.log('i dati della rendicontazione', vm.datiRendicontazione);
//rimuoviamo le altre pagine del pdf, che pare non occorrano più
            /*            var tabaledata3 = [];
             tabaledata3.push([
             {text: 'COGNOME', style: 'tableHeader'},
             {text: 'NOME', style: 'tableHeader'},
             {text: 'RUOLO', style: 'tableHeader'},
             ]);
             tabaledata3.push([
             {text: "contenuto", style: 'tableSubHeader'},
             {text: "ancora da", style: 'tableSubHeader'},
             {text: "definire", style: 'tot'}
             ]);

             var tabaledata2 = [];
             tabaledata2.push([
             {text: 'COGNOME', style: 'tableHeader'},
             {text: 'NOME', style: 'tableHeader'},
             {text: 'DATA INIZIO', style: 'tableHeader'},
             {text: 'DATA FINE', style: 'tableHeader'}
             ]);
             vm.tempev.forEach(function (elements, key) {
             tabaledata2.push([{text: elements.entita1.cognome, style: 'tableSubHeader'}, {text: elements.entita1.nome, style: 'tableSubHeader'}, {text: elements.dataInizio, style: 'tot'}, {text: elements.dataFine, style: 'tot'}]);
             });
             */
            var tabaledata = [];
            tabaledata.push([
                {text: 'COD.', style: 'tableHeader'},
                {text: 'DESCRIZIONE SPESA', style: 'tableHeader'},
                {text: 'IMPORTO COFINANAZIATO', style: 'tableHeader'},
                {text: 'CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                {text: 'COSTO TOTALE PROGETTO', style: 'tableHeader'}
            ]);
            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + " €";
            };


            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                //inizio ciclo costi diretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json
                var costiDiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "P" | item.id == "L" | item.id == "B" | item.id == "G" | item.id == "S" | item.id == "T" | item.id == "I" | item.id == "A";
                });

                //console.log('nuovavariabile',costiDiretti);
                //vm.datiRendicontazioneOutput.jsonData=vm.datiRendicontazioneOutput.jsonData.filter(function(item){
                //return item.id=="P" | item.id=="L"| item.id=="G"| item.id=="S"| item.id=="T"| item.id=="I"| item.id=="A";
                //});

                costiDiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale1 = totale1.formatMoney(2, ',', '.');

                    var totale2 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale2 = totale2.formatMoney(2, ',', '.');

                    var totale3 = vm.getTotal(costiDiretti)[elements.id]['importi']['totale'];
                    var totale3 = totale3.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label, style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiDiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([items.id, items.label, {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'}, {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'}, {text: totale.formatMoney(2, ',', '.'), style: 'tot'}]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
//fine ciclo costi diretti
                //tot costi diretti
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'];
                var totale1 = totale1.formatMoney(2, ',', '.');

                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'];
                var totale2 = totale2.formatMoney(2, ',', '.');

                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['totale'];
                var totale3 = totale3.formatMoney(2, ',', '.');

                tabaledata.push(['', {text: 'TOTALE COSTI DIRETTI', style: 'tableSubFooter'}, {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}]);

                //inizio ciclo costi indiretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json

                //spezzo
                var costiIndiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "Ci";
                });
                costiIndiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale1 = totale1.formatMoney(2, ',', '.');

                    var totale2 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale2 = totale2.formatMoney(2, ',', '.');

                    var totale3 = vm.getTotal(costiIndiretti)[elements.id]['importi']['totale'];
                    var totale3 = totale3.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label, style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiIndiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([items.id, items.label, {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'}, {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'}, {text: totale.formatMoney(2, ',', '.'), style: 'tot'}]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
//fine ciclo costi indiretti




                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'];
                var totale1 = totale1.formatMoney(2, ',', '.');

                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'];
                var totale2 = totale2.formatMoney(2, ',', '.');

                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['totale'];
                var totale3 = totale3.formatMoney(2, ',', '.');

                tabaledata.push(['', {text: 'TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)', style: 'tableSubFooter'}, {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}]);

                var sezioneProrogaProsecuzione = [];
                if (vm.rendicontazione.progettoRendicontazioneTipo_id != 1) { //Preventivo
                    if (vm.rendicontazione.prosecuzione == 1) {
                        vm.rendicontazione.prosecuzione = "SI";
                    }

                    if (vm.rendicontazione.prosecuzione == 0) {
                        vm.rendicontazione.prosecuzione = "NO";
                    }

                    if (vm.rendicontazione.prorogaTecnica == 1) {
                        vm.rendicontazione.prorogaTecnica = "SI";
                    }

                    if (vm.rendicontazione.prorogaTecnica == 0) {
                        vm.rendicontazione.prorogaTecnica = "NO";
                    }

                    sezioneProrogaProsecuzione = [
                        {text: 'Prosecuzione: ' + vm.rendicontazione.prosecuzione, style: 'headerleft'},
                        {text: 'Proroga tecnica: ' + vm.rendicontazione.prorogaTecnica, style: 'headerleft'}
                    ];
                }

                var docDefinition = {
                    content: [
                        {text: 'PROGETTO ' + vm.rendicontazione.progettos.nome, style: 'header'},
                        {text: '\n'},
                        {text: 'cod. ' + vm.datiRendicontazione.codiceProgetto},
                        {text: '\n'},
                        {text: 'Bando: ' + vm.datiRendicontazione.progettos.bandos[0].descrizione},
                        {text: '\n', style: 'header'},
                        {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'}
                    ]
                };

                if (vm.rendicontazione.progettoRendicontazioneTipo_id != 1) { //Preventivo
                    docDefinition.content.push(sezioneProrogaProsecuzione);
                }

                docDefinition.content.push([
                    {text: 'Documento: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneTipo_id, vm.rendicontazioniTipi), style: 'headerleft'},
                    {text: 'Stato: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneStato_id, vm.rendicontazioniStati), style: 'headerleft'},
                    {text: '\n', style: 'header'},
                    {
                        style: 'demoTable',
                        table: {
                            headerRows: 1,
                            widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
                            body: tabaledata
                        },
                        //layout: 'lightVerticalLines'
                        layout: 'lightHorizontalLines'
                    },
                    {text: '\n', style: 'header'},
                    {text: '\n', style: 'header'},
                    {text: '\n', style: 'header'},
                    /*{text: 'LISTA PERMESSI VOLONTARI', style: 'header', pageBreak: 'before'},
                     {text: '\n', style: 'header'},
                     {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'},
                     {text: '\n', style: 'header'},
                     {
                     style: 'demoTable',
                     table: {
                     headerRows: 1,
                     widths: ['auto', 'auto', 'auto', 'auto'],
                     body: tabaledata2
                     },
                     //layout: 'lightVerticalLines'
                     layout: 'lightHorizontalLines'
                     },*/
                    /*{text: '\n', style: 'header'},
                     {text: '\n', style: 'header'},
                     {text: '\n', style: 'header'},
                     {text: 'LISTA EQUIPE DI PROGETTO', style: 'header', pageBreak: 'before'},
                     {text: '\n', style: 'header'},
                     {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'},
                     {text: '\n', style: 'header'},
                     {
                     style: 'demoTable',
                     table: {
                     headerRows: 1,
                     widths: ['auto', 'auto', 'auto'],
                     body: tabaledata3
                     },
                     //layout: 'lightVerticalLines'
                     layout: 'lightHorizontalLines'
                     },
                     {text: '\n', style: 'header'},
                     {text: '\n', style: 'header'},
                     {text: '\n', style: 'header'},
                     {text: 'Firma del responsabile', style: 'header'},*/
                ]);

                docDefinition.styles = {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10],
                        alignment: 'center'
                    },
                    headerright: {
                        fontSize: 12,
                        alignment: 'right'
                    },
                    headerleft: {
                        fontSize: 12,
                        alignment: 'left'
                    },
                    demoTable: {
                        fontSize: 8,
                        margin: [0, 10, 0, 10],
                        color: 'black'

                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 8,
                        color: 'black'
                    },
                    tableSubHeader: {
                        bold: true,
                        fontSize: 10,
                        color: 'grey',
                        //background: 'grey'
                    },
                    tableSubHeaderTot: {
                        bold: true,
                        fontSize: 10,
                        color: 'grey',
                        alignment: 'right'
                        //background: 'grey'
                    },
                    tableSubFooter: {
                        bold: true,
                        fontSize: 10,
                        color: 'blue',
                        //background: 'grey'
                    },
                    tableSubFooterTot: {
                        bold: true,
                        fontSize: 10,
                        color: 'blue',
                        alignment: 'right'
                        //background: 'grey'
                    },
                    tot: {
                        alignment: 'right'
                    }
                };
                pdfMake.createPdf(docDefinition).download("rendicontazione_" + vm.rendicontazione.progettos.id + '.pdf');
                //console.log("quisto");
                //console.log(docDefinition);
            }

        }
        function downloadPdfSAL(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;


                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3) //Rendicontazione finale
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaPdfSAL();
                        });
                    } else
                    {
                        creaPdfSAL();
                    }
                });
            });
        }

        function creaPdfSAL() {

            console.log('i dati della rendicontazione', vm.datiRendicontazione);

            var tabaledata = [];
            tabaledata.push([
                {text: 'COD.', style: 'tableHeader'},
                //{text: 'A IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'B CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'C COSTO TOTALE PROGETTO', style: 'tableHeader'},
                //{text: 'D IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'E CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'F COSTO TOTALE PROGETTO', style: 'tableHeader'},
                //{text: 'G IMPORTO COFINANAZIATO', style: 'tableHeader'},
                //{text: 'H CONTRIBUTO RICHIESTO', style: 'tableHeader'},
                //{text: 'I COSTO TOTALE PROGETTO', style: 'tableHeader'}
                {text: 'DESCRIZIONE SPESA', style: 'tableHeader'},
                {text: 'A', style: 'tableHeader'},
                {text: 'B', style: 'tableHeader'},
                {text: 'C [A+B]', style: 'tableHeader'},
                {text: 'D', style: 'tableHeader'},
                {text: 'E', style: 'tableHeader'},
                {text: 'F [D+E]', style: 'tableHeader'},
                {text: 'G', style: 'tableHeader'},
                {text: 'H', style: 'tableHeader'},
                {text: 'I [G+H]', style: 'tableHeader'},
                {text: '% (F/C)', style: 'tableHeader'},
                {text: '% (I/C)', style: 'tableHeader'}
            ]);
            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "€";
            };
            //VALERIO: Creo il metodo di formattazione della percentuale
            Number.prototype.formatPercent = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "%";
            };


            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                //inizio ciclo costi diretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json
                var costiDiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "P" | item.id == "L" | item.id == "B" | item.id == "G" | item.id == "S" | item.id == "T" | item.id == "I" | item.id == "A";
                });

                //console.log('nuovavariabile',costiDiretti);
                //vm.datiRendicontazioneOutput.jsonData=vm.datiRendicontazioneOutput.jsonData.filter(function(item){
                //return item.id=="P" | item.id=="L"| item.id=="G"| item.id=="S"| item.id=="T"| item.id=="I"| item.id=="A";
                //});

                costiDiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale2 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale3 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiesto']);
                    var totale4 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoImpegnato'];
                    var totale5 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoImpegnato'];
                    var totale6 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoImpegnato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoImpegnato']);
                    var totale7 = vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato'];
                    var totale8 = vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoQuietanziato'];
                    var totale9 = (vm.getTotal(costiDiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(costiDiretti)[elements.id]['importi']['contributoRichiestoQuietanziato']);

                    var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                    var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                    var totale1 = totale1.formatMoney(2, ',', '.');
                    var totale2 = totale2.formatMoney(2, ',', '.');
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    var totale4 = totale4.formatMoney(2, ',', '.');
                    var totale5 = totale5.formatMoney(2, ',', '.');
                    var totale6 = totale6.formatMoney(2, ',', '.');
                    var totale7 = totale7.formatMoney(2, ',', '.');
                    var totale8 = totale8.formatMoney(2, ',', '.');
                    var totale9 = totale9.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label.substring(0, 50), style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}, {text: totale4, style: 'tableSubHeaderTot'}, {text: totale5, style: 'tableSubHeaderTot'}, {text: totale6, style: 'tableSubHeaderTot'}, {text: totale7, style: 'tableSubHeaderTot'}, {text: totale8, style: 'tableSubHeaderTot'}, {text: totale9, style: 'tableSubHeaderTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiDiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([
                            items.id,
                            items.label.substring(0, 50),
                            {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[0].value) + (items.fields[1].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[2].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[3].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[2].value) + (items.fields[3].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[4].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[5].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[4].value) + (items.fields[5].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[2].value) + (items.fields[3].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[4].value) + (items.fields[5].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'}
                        ]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
                console.log("tabaletabale", tabaledata);
//fine ciclo costi diretti
                //tot costi diretti

                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'];
                var totale3 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto']);
                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoImpegnato'];
                var totale6 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoImpegnato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoImpegnato']);
                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoQuietanziato'];
                var totale9 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoQuietanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoQuietanziato']);

                var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                tabaledata.push([{text: 'Costi diretti', style: 'tableSubFooter'}, '', {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}, {text: totale4, style: 'tableSubFooterTot'}, {text: totale5, style: 'tableSubFooterTot'}, {text: totale6, style: 'tableSubFooterTot'}, {text: totale7, style: 'tableSubFooterTot'}, {text: totale8, style: 'tableSubFooterTot'}, {text: totale9, style: 'tableSubFooterTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                //inizio ciclo costi indiretti
                //per spezzare i totali come richiesto in impaginazione devo filtrare il mio json

                //spezzo
                var costiIndiretti = vm.datiRendicontazioneOutput.jsonData.filter(function (item) {
                    return item.id == "Ci";
                });
                costiIndiretti.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziato'];
                    var totale2 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiesto'];
                    var totale3 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiesto']);
                    var totale4 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoImpegnato'];
                    var totale5 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoImpegnato'];
                    var totale6 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoImpegnato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoImpegnato']);
                    var totale7 = vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato'];
                    var totale8 = vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoQuietanziato'];
                    var totale9 = (vm.getTotal(costiIndiretti)[elements.id]['importi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(costiIndiretti)[elements.id]['importi']['contributoRichiestoQuietanziato']);

                    var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                    var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                    var totale1 = totale1.formatMoney(2, ',', '.');
                    var totale2 = totale2.formatMoney(2, ',', '.');
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    var totale4 = totale4.formatMoney(2, ',', '.');
                    var totale5 = totale5.formatMoney(2, ',', '.');
                    var totale6 = totale6.formatMoney(2, ',', '.');
                    var totale7 = totale7.formatMoney(2, ',', '.');
                    var totale8 = totale8.formatMoney(2, ',', '.');
                    var totale9 = totale9.formatMoney(2, ',', '.');

                    tabaledata.push([{text: elements.id, style: 'tableSubHeader'}, {text: elements.label.substring(0, 50), style: 'tableSubHeader'}, {text: totale1, style: 'tableSubHeaderTot'}, {text: totale2, style: 'tableSubHeaderTot'}, {text: totale3, style: 'tableSubHeaderTot'}, {text: totale4, style: 'tableSubHeaderTot'}, {text: totale5, style: 'tableSubHeaderTot'}, {text: totale6, style: 'tableSubHeaderTot'}, {text: totale7, style: 'tableSubHeaderTot'}, {text: totale8, style: 'tableSubHeaderTot'}, {text: totale9, style: 'tableSubHeaderTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}]);

                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(costiIndiretti)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push([
                            items.id,
                            items.label.substring(0, 50),
                            {text: items.fields[0].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[1].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[0].value) + (items.fields[1].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[2].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[3].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[2].value) + (items.fields[3].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[4].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: items.fields[5].value.formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((items.fields[4].value) + (items.fields[5].value)).formatMoney(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[2].value) + (items.fields[3].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'},
                            {text: ((((items.fields[4].value) + (items.fields[5].value)) / ((items.fields[0].value) + (items.fields[1].value))) * 100).formatPercent(2, ',', '.'), style: 'tot'}
                        ]);
                        //precedente formattazione in stringa:
                        // var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'] + " €";
                        // tabaledata.push([items.id, items.label, {text: items.fields[0].value + " €", style: 'tot'}, {text: items.fields[1].value + " €", style: 'tot'}, {text: totale, style: 'tot'}]);
                    });

                });
//fine ciclo costi indiretti
                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'];
                var totale3 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto']);
                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoImpegnato'];
                var totale6 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoImpegnato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoImpegnato']);
                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoQuietanziato'];
                var totale9 = (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoQuietanziato']) + (vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoQuietanziato']);

                var percImpegnato = ((totale6 / totale3) * 100).formatPercent(2, ',', '.');
                var percQuietanziato = ((totale9 / totale3) * 100).formatPercent(2, ',', '.');

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                tabaledata.push([{text: 'Totale', style: 'tableSubFooter'}, '', {text: totale1, style: 'tableSubFooterTot'}, {text: totale2, style: 'tableSubFooterTot'}, {text: totale3, style: 'tableSubFooterTot'}
                    , {text: totale4, style: 'tableSubFooterTot'}, {text: totale5, style: 'tableSubFooterTot'}, {text: totale6, style: 'tableSubFooterTot'}
                    , {text: totale7, style: 'tableSubFooterTot'}, {text: totale8, style: 'tableSubFooterTot'}, {text: totale9, style: 'tableSubFooterTot'}, {text: percImpegnato, style: 'tableSubHeaderTot'}, {text: percQuietanziato, style: 'tableSubHeaderTot'}
                ]);

                var docDefinition = {
                    // a string or { width: number, height: number }
                    pageSize: 'A4',
                    // by default we use portrait, you can change it to landscape if you wish
                    pageOrientation: 'landscape',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [30, 30, 30, 30],
                    content: [
                        {text: 'PROGETTO ' + vm.rendicontazione.progettos.nome, style: 'header'},
                        {text: '\n'},
                        {text: 'cod. ' + vm.datiRendicontazione.codiceProgetto},
                        {text: '\n'},
                        {text: 'Bando: ' + vm.datiRendicontazione.progettos.bandos[0].descrizione},
                        {text: '\n', style: 'header'},
                        {text: 'Anno: ' + vm.rendicontazione.anno, style: 'headerleft'},
                        {text: 'Documento: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneTipo_id, vm.rendicontazioniTipi), style: 'headerleft'},
                        {text: 'Stato: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneStato_id, vm.rendicontazioniStati), style: 'headerleft'},
                        {text: '\n', style: 'headerleft'},
                        {text: 'GRUPPO PREVENTIVO', style: 'dida'},
                        {text: 'A: IMPORTO COFINANZIATO | B: CONTRIBUTO RICHIESTO | C: COSTO TOTALE PROGETTO', style: 'dida'},
                        {text: '\n', style: 'dida'},
                        {text: 'GRUPPO SOMME IMPEGNATE', style: 'dida'},
                        {text: 'D: IMPORTO COFINANZIATO impegnato | E: CONTRIBUTO RICHIESTO impegnato | F: COSTO TOTALE PROGETTO impegnato', style: 'dida'},
                        {text: '\n', style: 'dida'},
                        {text: 'GRUPPO SOMME QUIETANZATE', style: 'dida'},
                        {text: 'G: IMPORTO COFINANZIATO quietanzato | H: CONTRIBUTO RICHIESTO quietanzato | I: COSTO TOTALE PROGETTO quietanzato', style: 'dida'},
                        {text: '\n', style: 'header'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                body: tabaledata
                            },
                            //layout: 'lightVerticalLines'
                            layout: 'lightHorizontalLines'
                        },
                        {text: '\n', style: 'header'},
                        {text: '\n', style: 'header'},
                        {text: '\n', style: 'header'},
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 7.5,
                            alignment: 'right'
                        },
                        headerleft: {
                            fontSize: 7.5,
                            alignment: 'left'
                        },
                        demoTable: {
                            fontSize: 7.5,
                            margin: [0, 10, 0, 10],
                            color: 'black'

                        },
                        dida: {
                            fontSize: 7.5,
                            alignment: 'left'
                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'black'
                        },
                        tableSubHeader: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'grey',
                            //background: 'grey'
                        },
                        tableSubHeaderTot: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'grey',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tableSubFooter: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'blue',
                            //background: 'grey'
                        },
                        tableSubFooterTot: {
                            bold: true,
                            fontSize: 7.5,
                            color: 'blue',
                            alignment: 'right'
                                    //background: 'grey'
                        },
                        tot: {
                            alignment: 'right'
                        }
                    }

                };
                pdfMake.createPdf(docDefinition).download("rendicontazione_" + vm.rendicontazione.progettos.id + '.pdf');
                //console.log("quisto");
                //console.log(docDefinition);
            }

        }

        //VALERIO export in CSV
        function downloadCsv(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;

                api.eventos.evento.search({eventoTipo_id: 1012, progetto_id: vm.projectId, fields: "dataInizio,dataFine,entita1"}, function (d) {
                    vm.tempev = d.data;


                });
                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaCsv();
                        });
                    } else
                    {
                        creaCsv();
                    }
                });
            });
        }

        function creaCsv() {

            //console.log(vm.datiRendicontazione);
            /* disabilito la collezione dei dati aggiuntivi che eventualmente dovranno essere aggiunti al CSV oppure inseriti in una funzione a parte per altre voci contestuali di download
             var tabaledata3 = [];
             tabaledata3.push([
             {text: 'COGNOME'},
             {text: 'NOME'},
             {text: 'RUOLO'},
             ]);
             tabaledata3.push([
             {text: "contenuto"},
             {text: "ancora da"},
             {text: "definire"}
             ]);

             var tabaledata2 = [];
             tabaledata2.push([
             {text: 'COGNOME'},
             {text: 'NOME'},
             {text: 'DATA INIZIO'},
             {text: 'DATA FINE'}
             ]);
             vm.tempev.forEach(function (elements, key) {
             tabaledata2.push([{text: elements.entita1.cognome}, {text: elements.entita1.nome}, {text: elements.dataInizio}, {text: elements.dataFine}]);
             });
             fine collezione dei dati aggiuntivi*/

//Inizia il popolamento della tabella principale del CSV
            var tabaledata = [];

            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + " €";
            };


            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                vm.datiRendicontazioneOutput.jsonData.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['importoCofinanziato'];
                    var totale1 = totale1.formatMoney(2, ',', '.');

                    var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['contributoRichiesto'];
                    var totale2 = totale2.formatMoney(2, ',', '.');

                    var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['totale'];
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    //totali
                    tabaledata.push({"codice": elements.id, "descrizione spesa": elements.label, "cofinanziato": totale1, "richiesto": totale2, "progetto": totale3});
                    //corpo della tabella
                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push({"codice": items.id, "descrizione spesa": items.label, "cofinanziato": items.fields[0].value.formatMoney(2, ',', '.'), "richiesto": items.fields[1].value.formatMoney(2, ',', '.'), "progetto": totale.formatMoney(2, ',', '.')});
                    });

                });

                //tot costi diretti
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'];
                var totale1 = totale1.formatMoney(2, ',', '.');

                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'];
                var totale2 = totale2.formatMoney(2, ',', '.');

                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['totale'];
                var totale3 = totale3.formatMoney(2, ',', '.');

                tabaledata.push('', {text: 'TOTALE COSTI DIRETTI'}, {text: totale1}, {text: totale2}, {text: totale3});

                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'];
                var totale1 = totale1.formatMoney(2, ',', '.');

                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'];
                var totale2 = totale2.formatMoney(2, ',', '.');

                var totale3 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['totale'];
                var totale3 = totale3.formatMoney(2, ',', '.');

                tabaledata.push('', {text: 'TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)'}, {text: totale1}, {text: totale2}, {text: totale3});
                //tabaledata.push("{items:[");
                /* disabilito la collezione dei dati aggiuntivi che eventualmente dovranno essere aggiunti al CSV oppure inseriti in una funzione a parte per altre voci contestuali di download
                 var docDefinition = {
                 content: [
                 {text: 'PROGETTO ' + vm.rendicontazione.progettos.nome},
                 {text: '\n'},
                 {text: 'Anno: ' + vm.rendicontazione.anno},
                 {text: 'Documento: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneTipo_id, vm.rendicontazioniTipi)},
                 {text: 'Stato: ' + decodeTipo(vm.rendicontazione.progettoRendicontazioneStato_id, vm.rendicontazioniStati)},
                 {text: '\n'},
                 {
                 style: 'demoTable',
                 table: {
                 headerRows: 1,
                 widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
                 body: tabaledata
                 },
                 //layout: 'lightVerticalLines'
                 layout: 'lightHorizontalLines'
                 },
                 {text: '\n'},
                 {text: '\n'},
                 {text: '\n'},
                 {text: 'LISTA PERMESSI VOLONTARI'},
                 {text: '\n'},
                 {text: 'Anno: ' + vm.rendicontazione.anno},
                 {text: '\n'},
                 {
                 style: 'demoTable',
                 table: {
                 headerRows: 1,
                 widths: ['auto', 'auto', 'auto', 'auto'],
                 body: tabaledata2
                 },
                 //layout: 'lightVerticalLines'
                 layout: 'lightHorizontalLines'
                 },
                 {text: '\n'},
                 {text: '\n'},
                 {text: '\n'},
                 {text: 'LISTA EQUIPE DI PROGETTO'},
                 {text: '\n'},
                 {text: 'Anno: ' + vm.rendicontazione.anno},
                 {text: '\n'},
                 {
                 style: 'demoTable',
                 table: {
                 headerRows: 1,
                 widths: ['auto', 'auto', 'auto'],
                 body: tabaledata3
                 },
                 //layout: 'lightVerticalLines'
                 layout: 'lightHorizontalLines'
                 },
                 {text: '\n'},
                 {text: '\n'},
                 {text: '\n'},
                 {text: 'Firma del responsabile'},
                 ],
                 };
                 */
                //Finalizzo elaborando la variabile da spedire al file

                //pdfMake.createPdf(docDefinition).download("rendicontazione_" + vm.rendicontazione.progettos.id + '.pdf');
                //console.log(docDefinition);
                //console.log(docDefinition.content[6].table.body);
                //var tabaledata = JSON.stringify(tabaledata);

                //console.log(docDefinition);
                //var contenutocsv =  docDefinition.content[6].table.body;

                //var json = contenutocsv;

                //Tabelle principali
                var json = tabaledata;
                var fields = Object.keys(json[0])
                var replacer = function (key, value) {
                    return value === null ? '' : value
                }

                var csv = json.map(function (row)
                {
                    return fields.map(function (fieldName) { //array mappato
                        return JSON.stringify(row[fieldName], replacer)
                    }).join(';')
                })
                csv.unshift("\"" + fields.join('";"') + "\"") // heading del foglio csv

                console.log(csv.join('\r\n'));
                var csvcontents = csv.join('\r\n');
                /* disabilito la collezione dei dati aggiuntivi che eventualmente dovranno essere aggiunti al CSV oppure inseriti in una funzione a parte per altre voci contestuali di download
                 //Tabelle secondarie
                 var json2 = docDefinition.content;
                 var fields2 = Object.keys(json[0])
                 var replacer2 = function(key, value) { return value === null ? '' : value }
                 console.log("quisto");
                 console.log(json2);
                 var csv2 = json2.map(function(row)
                 {
                 return fields.map(function(fieldName){ //array mappato
                 return JSON.stringify(row[fieldName], replacer)
                 }).join(',')
                 })
                 console.log(csv2);
                 csv2.unshift("\"" + fields.join('","') + "\"") // heading del foglio csv

                 console.log(csv2.join('\r\n'));
                 var csvcontents2 = csv2.join('\r\n');*/
            }
            //BOM serve a forzare la codifica ANSI per massimizzare la compatibilità con excel
            var universalBOM = "\uFEFF";
            //Infine passo alla creazione del file
            var data, filename, link;
            var csv = csvcontents;
            if (csv == null)
                return;
            console.log(csv);
            filename = "rendicontazione_" + vm.rendicontazione.progettos.id + ".csv";

            //if (!csv.match(/^data:text\/csv/i)) {
            //    csv = 'data:text/csv;charset=utf-8,' + csv;
            // }
            data = encodeURI(csv);

            link = document.createElement('a');
            document.body.appendChild(link); //required in FF, optional for Chrome
            link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csv));
            link.setAttribute('download', filename);
            link.target = "_self"; //required in FF, optional for Chrome;
            link.click();

        }
//End export CSV

        function downloadCsvSAL(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;

                api.eventos.evento.search({eventoTipo_id: 1012, progetto_id: vm.projectId, fields: "dataInizio,dataFine,entita1"}, function (d) {
                    vm.tempev = d.data;


                });
                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    //                console.log(res.jsonModel);
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaCsvSAL();
                        });
                    } else
                    {
                        creaCsvSAL();
                    }
                });
            });
        }

        function creaCsvSAL() {

//Inizia il popolamento della tabella principale del CSV
            var tabaledata = [];

            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + " €";
            };
            //VALERIO: Creo il metodo di formattazione della percentuale
            Number.prototype.formatPercent = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "%";
            };
            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                vm.datiRendicontazioneOutput.jsonData.forEach(function (elements, key) {
                    //VALERIO: rigiro le variabili applicando il nuovo metodo di formattazione della valuta
                    var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['importoCofinanziato'];
                    var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['contributoRichiesto'];
                    var totale3 = totale1 + totale2;

                    var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['importoCofinanziatoImpegnato'];
                    var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['contributoRichiestoImpegnato'];
                    var totale6 = totale4 + totale5;

                    var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['importoCofinanziatoQuietanziato'];
                    var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id]['importi']['contributoRichiestoQuietanziato'];
                    var totale9 = totale7 + totale8;

                    var percImpegnato = (totale6 / totale3) * 100;
                    var percQuietanziato = (totale9 / totale3) * 100;

                    var totale1 = totale1.formatMoney(2, ',', '.');
                    var totale2 = totale2.formatMoney(2, ',', '.');
                    var totale3 = totale3.formatMoney(2, ',', '.');
                    var totale4 = totale4.formatMoney(2, ',', '.');
                    var totale5 = totale5.formatMoney(2, ',', '.');
                    var totale6 = totale6.formatMoney(2, ',', '.');
                    var totale7 = totale7.formatMoney(2, ',', '.');
                    var totale8 = totale8.formatMoney(2, ',', '.');
                    var totale9 = totale9.formatMoney(2, ',', '.');

                    var percImpegnato = percImpegnato.formatPercent(2, ',', '.');
                    var percQuietanziato = percQuietanziato.formatPercent(2, ',', '.');

                    //totali
                    tabaledata.push({"codice": elements.id, "descrizione spesa": elements.label, "cofinanziato": totale1, "richiesto": totale2, "progetto": totale3, "cofinanziatoImpegnato": totale4, "richiestoImpegnato": totale5, "progettoImpegnato": totale6, "cofinanziatoQuietanziato": totale7, "richiestoQuietanziato": totale8, "progettoQuietanziato": totale9, "perImpegnato": percImpegnato, "percQuietanziato": percQuietanziato});
                    //corpo della tabella
                    elements.items.forEach(function (items, key) {
                        var totale = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)[elements.id][items.id]['importi']['totale'];
                        tabaledata.push({"codice": items.id, "descrizione spesa": items.label,
                            "cofinanziato": items.fields[0].value.formatMoney(2, ',', '.'),
                            "richiesto": items.fields[0].value.formatMoney(2, ',', '.'),
                            "progetto": ((items.fields[0].value) + (items.fields[0].value)).formatMoney(2, ',', '.'),
                            "cofinanziatoImpegnato": items.fields[2].value.formatMoney(2, ',', '.'),
                            "richiestoImpegnato": items.fields[3].value.formatMoney(2, ',', '.'),
                            "progettoImpegnato": ((items.fields[2].value) + (items.fields[3].value)).formatMoney(2, ',', '.'),
                            "cofinanziatoQuietanziato": items.fields[4].value.formatMoney(2, ',', '.'),
                            "richiestoQuietanziato": items.fields[5].value.formatMoney(2, ',', '.'),
                            "progettoQuietanziato": ((items.fields[4].value) + (items.fields[5].value)).formatMoney(2, ',', '.'),
                            "percImpegnato": (((items.fields[2].value) + (items.fields[3].value)) / ((items.fields[0].value) + (items.fields[0].value))) * 100,
                            "percQuietanziato": (((items.fields[4].value) + (items.fields[5].value)) / ((items.fields[0].value) + (items.fields[0].value))) * 100

                        });
                    });

                });

                //tot costi diretti
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiesto'];
                var totale3 = totale1 + totale2;

                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoImpegnato'];
                var totale6 = totale4 + totale5;

                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiDiretti']['contributoRichiestoQuietanziato'];
                var totale9 = totale7 + totale8;

                var percImpegnato = (totale6 / totale3) * 100;
                var perQuietanziato = (totale9 / totale3) * 100;

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                var percImpegnato = percImpegnato.formatPercent(2, ',', '.');
                var perQuietanziato = perQuietanziato.formatPercent(2, ',', '.');

                tabaledata.push('', {text: 'TOTALE COSTI DIRETTI'}, {text: totale1}, {text: totale2}, {text: totale3}, {text: totale4}, {text: totale5}, {text: totale6}, {text: totale7}, {text: totale8}, {text: totale9}, {text: percImpegnato}, {text: perQuietanziato});

                //tot complessivo
                var totale1 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziato'];
                var totale2 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiesto'];
                var totale3 = totale1 + totale2;

                var totale4 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoImpegnato'];
                var totale5 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoImpegnato'];
                var totale6 = totale4 + totale5;

                var totale7 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['importoCofinanziatoQuietanziato'];
                var totale8 = vm.getTotal(vm.datiRendicontazioneOutput.jsonData)['importi']['totaleCostiComplessivi']['contributoRichiestoQuietanziato'];
                var totale9 = totale7 + totale8;

                var percImpegnato = (totale6 / totale3) * 100;
                var perQuietanziato = (totale9 / totale3) * 100;

                var totale1 = totale1.formatMoney(2, ',', '.');
                var totale2 = totale2.formatMoney(2, ',', '.');
                var totale3 = totale3.formatMoney(2, ',', '.');
                var totale4 = totale4.formatMoney(2, ',', '.');
                var totale5 = totale5.formatMoney(2, ',', '.');
                var totale6 = totale6.formatMoney(2, ',', '.');
                var totale7 = totale7.formatMoney(2, ',', '.');
                var totale8 = totale8.formatMoney(2, ',', '.');
                var totale9 = totale9.formatMoney(2, ',', '.');

                var percImpegnato = percImpegnato.formatPercent(2, ',', '.');
                var perQuietanziato = perQuietanziato.formatPercent(2, ',', '.');

                tabaledata.push('', {text: 'TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)'}, {text: totale1}, {text: totale2}, {text: totale3}, {text: totale4}, {text: totale5}, {text: totale6}, {text: totale7}, {text: totale8}, {text: totale9}, {text: percImpegnato}, {text: perQuietanziato});

                //Tabelle principali
                var json = tabaledata;
                var fields = Object.keys(json[0])
                var replacer = function (key, value) {
                    return value === null ? '' : value
                }

                var csv = json.map(function (row)
                {
                    return fields.map(function (fieldName) { //array mappato
                        return JSON.stringify(row[fieldName], replacer)
                    }).join(';')
                })
                csv.unshift("\"" + fields.join('";"') + "\"") // heading del foglio csv

                console.log(csv.join('\r\n'));
                var csvcontents = csv.join('\r\n');
            }

            //Infine passo alla creazione del file
            //BOM serve a forzare la codifica ANSI per massimizzare la compatibilità con excel
            var universalBOM = "\uFEFF";
            var data, filename, link;
            var csv = csvcontents;
            if (csv == null)
                return;
            console.log(csv);
            filename = "rendicontazione_" + vm.rendicontazione.progettos.id + ".csv";

            //if (!csv.match(/^data:text\/csv/i)) {
            //    csv = 'data:text/csv;charset=utf-8,' + csv;
            //}
            data = encodeURI(csv);

            link = document.createElement('a');
            document.body.appendChild(link); //required in FF, optional for Chrome
            link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csv));
            link.setAttribute('download', filename);
            link.target = "_self"; //required in FF, optional for Chrome;
            link.click();

        }
//End export CSV

// creazione dello script per il download della rendicontazione finale

        function downloadCsvRF(event, rendicontazione) {

            vm.allLoaded = false;
            vm.rendicontazione = rendicontazione;

            api.rendicontaziones.rendicontazione.get({id: vm.rendicontazione.id}, function (res) {

                vm.datiRendicontazione = res;
//                console.log(res);
                vm.tipoRendicontazione = res.progettoRendicontazioneTipo_id;
                vm.parametriRendicontazione = res.progettos.progettoparametrirendicontaziones;
                vm.projectId = res.progettos.id;

                api.eventos.evento.search({eventoTipo_id: 1012, progetto_id: vm.projectId, fields: "dataInizio,dataFine,entita1"}, function (d) {
                    vm.tempev = d.data;


                });
                api.rendicontaziones.jsonInput.get({id: res.progettoRendicontazioneTipo_id}, function (res) {
                    console.log("cicciofrizzo", res.jsonModel);
                    console.log("cicciodati", res)
                    vm.jsonModel = res.jsonModel;

                    if (vm.rendicontazione.progettoRendicontazioneTipo_id == 3)
                    {
                        vm.datiRendicontazioneRecap = {};
                        //recuperiamo lo schema di tipo 1 per rivalidare i conteggi
                        api.rendicontaziones.jsonInput.get({id: 1}, function (res2) {
                            vm.datiRendicontazioneRecap.jsonData = elaboraResocontoRendicontazioneFinale(res2.jsonModel);
                            creaCsvRF();
                        });
                    } else
                    {
                        creaCsvRF();
                    }
                });
            });
        }

// Script di creazione del CSV rendicontazione finale
        function creaCsvRF() {

//Inizia il popolamento della tabella principale del CSV
            var tabaledata = [];

            //VALERIO: Creo il metodo di formattazione della valuta in €
            Number.prototype.formatMoney = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + " €";
            };
            //VALERIO: Creo il metodo di formattazione della percentuale
            Number.prototype.formatPercent = function (c, d, t) {
                var n = this,
                        c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "," : d,
                        t = t == undefined ? "." : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + "%";
            };
            if (vm.rendicontazione.progettoRendicontazioneTipo_id != 3)
            {
                vm.datiRendicontazioneOutput = vm.datiRendicontazione;
            } else
            {
                //devo eseguire qui la modifica con lo schema dati relativo a rendicontazione finale
                //vm.datiRendicontazioneOutput = vm.datiRendicontazioneRecap;
                vm.datiRendicontazioneOutput = vm.datiRendicontazione.jsonData.items;
                console.log("datiRendicontazioneRECAP", vm.datiRendicontazioneRecap);
                console.log("datiRendicontazione", vm.datiRendicontazione);

            }

            if (vm.datiRendicontazioneOutput !== undefined)
            {
                var j = 0;
                for (var i = vm.datiRendicontazioneOutput.length; i-- > 0; j++) {
                    var elements = vm.datiRendicontazioneOutput[i];
                    //preparazione o formattazione delle variabili
                    //1. natura del documento
                    var natura = elements[1].value;
                    if (natura == 1) {
                        natura = "Bollettino postale";
                    }
                    ;
                    if (natura == 2) {
                        natura = "Cedolino";
                    }
                    ;
                    if (natura == 3) {
                        natura = "Dichiarazione sostitutiva";
                    }
                    ;
                    if (natura == 4) {
                        natura = "Fattura";
                    }
                    ;
                    if (natura == 5) {
                        natura = "Mod. F23 quietanzato";
                    }
                    ;
                    if (natura == 6) {
                        natura = "Mod. F24 quietanzato";
                    }
                    ;
                    if (natura == 7) {
                        natura = "Nota di debito";
                    }
                    ;
                    if (natura == 8) {
                        natura = "Nota spese";
                    }
                    ;
                    if (natura == 9) {
                        natura = "Perizia tecnica";
                    }
                    ;
                    if (natura == 10) {
                        natura = "Polizza";
                    }
                    ;
                    if (natura == 11) {
                        natura = "Registro erogazioni";
                    }
                    ;
                    if (natura == 12) {
                        natura = "Ricevuta";
                    }
                    ;
                    if (natura == 13) {
                        natura = "Ricevuta fiscale";
                    }
                    ;
                    if (natura == 14) {
                        natura = "Scheda carburante";
                    }
                    ;
                    if (natura == 15) {
                        natura = "Scontrino fiscale";
                    }
                    ;
                    if (natura == 17) {
                        natura = "Altro";
                    }
                    ;

                    //2. formattazione data documento
                    var datadocumento = new Date(elements[2].value);
                    //new Date(datapagamento);
                    datadocumento = datadocumento.toLocaleDateString();

                    //4. pagamento
                    var pagamento = elements[4].value;
                    if (pagamento == 1) {
                        pagamento = "Bonifico bancario";
                    }
                    ;
                    if (pagamento == 2) {
                        pagamento = "Assegno circolare";
                    }
                    ;
                    if (pagamento == 3) {
                        pagamento = "Estratto conto";
                    }
                    ;
                    if (pagamento == 4) {
                        pagamento = "Contante";
                    }
                    ;
                    if (pagamento == 5) {
                        pagamento = "Mandato di pagamento e quietanza";
                    }
                    ;

                    //5. formattazione data di pagamento
                    var datapagamento = new Date(elements[5].value);
                    //new Date(datapagamento);
                    datapagamento = datapagamento.toLocaleDateString();
                    if (datapagamento == "1/1/1970") {
                        datapagamento = "nd";
                    }
                    ;

                    //8-9-10-11 formattazione dei totali
                    var totaledocumento = elements[8].value; 			//8
                    var totalecofinanziato = elements[9].value; 		//9
                    var totalefinanziato = elements[10].value; 			//10
                    var totaleimputato = elements[11].value;	//11

                    var totaledocumento = totaledocumento.formatMoney(2, ',', '.'); 			//8
                    var totalecofinanziato = totalecofinanziato.formatMoney(2, ',', '.'); 		//9
                    var totalefinanziato = totalefinanziato.formatMoney(2, ',', '.'); 			//10
                    var totaleimputato = totaleimputato.formatMoney(2, ',', '.');	//11
                    //12. attivo o disattivo
                    var attivo = elements[12].value;
                    if (attivo == 1) {
                        attivo = "Spesa attiva";
                    } else if (attivo == 0) {
                        attivo = "Spesa non attiva";
                    }
                    ;

                    //da rivedere perché non ha un valore di riferimento 0
                    //13. proroga tecnica
                    var proroga = elements[13].value;
                    if (proroga == 1) {
                        proroga = "Si";
                    }
                    if (proroga == 0) {
                        proroga = "No";
                    }
                    ;

                    //13. programma
                    var programma = elements[14].value;
                    switch (programma) {
                        case 0:
                            programma = "standard";
                            break;
                        case 1:
                            programma = "isaf";
                            break;
                        case 2:
                            programma = "resettlement";
                            break;
                        case 3:
                            programma = "fami";
                            break;
                    }

                    //composizione della tabella
                    //console.log("attivoProva",attivo);
                    tabaledata.push({
                        "Pagina": ((j / 25) >> 0)+1,
                        "Id": elements[0].value, //0
                        "Natura documento": natura, //1
                        "Data": datadocumento, //2
                        "Numero": elements[3].value, //3
                        "Pagamento": pagamento, //4
                        "Data pagamento": datapagamento, //5
                        "Codice di spesa": elements[6].value, //6
                        "Descrizione": elements[7].value, //7
                        "Tot. documento": totaledocumento, //8
                        "Tot. cofinanziato": totalecofinanziato, //9
                        "Tot. finanziato": totalefinanziato, //10
                        "Tot. imputato progetto": totaleimputato, //11
                        "Attivo": attivo, //12
                        //rivedere la proroga tecnica che non ha un valore di default
                        "Proroga tecnica": proroga, //13
                        "Programma": programma			//14
                                //if (attivo = 1) {
                                //"Attivo": "Spesa attiva"
                                //}
                                //,"In proroga tecnica": elements[13].value
                    });
                    //corpo della tabella
                    //fine ciclo dati corpo tabella
                }
                console.log("tabaleData", tabaledata);
                //Tabelle principali
                var json = tabaledata;
                var fields = Object.keys(json[0])
                var replacer = function (key, value) {
                    return value === null ? '' : value
                }

                var csv = json.map(function (row)
                {
                    return fields.map(function (fieldName) { //array mappato
                        return JSON.stringify(row[fieldName], replacer)
                    }).join(';')
                })
                csv.unshift("\"" + fields.join('";"') + "\"") // heading del foglio csv

                console.log(csv.join('\r\n'));
                var csvcontents = csv.join('\r\n');
            }

            //Infine passo alla creazione del file
            var universalBOM = "\uFEFF";
            var data, filename, link;
            var csv = csvcontents;
            if (csv == null)
                return;
            console.log(csv);
            filename = "rendicontazioneRegistroSpese" + vm.rendicontazione.progettos.id + ".csv";

            //if (!csv.match(/^data:text\/csv/i)) {
            //    csv = 'data:text/csv;charset=utf-8,' + csv;
            //}
            data = encodeURI(csv);

            link = document.createElement('a');
            document.body.appendChild(link); //required in FF, optional for Chrome
            link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csv));
            link.setAttribute('download', filename);
            link.target = "_self"; //required in FF, optional for Chrome;
            link.click();

        }
//End export CSV


        function decodeTipo(input, dictionary)
        {
            var output = "";
            dictionary.data.forEach(function (value, key) {
                if (value.id == input)
                {
                    output = value.descrizione;
                }
            });
            return output;
        }

    }


    function DialogProgettiController($scope, $state, $mdDialog, Progetti)
    {
        var vmd = this;
        vmd.progetti = Progetti;
        vmd.gestisciRendicontazione = gestisciRendicontazione;
        vmd.selected = {};

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        vmd.azione = azione;
        function azione(item) {
            $mdDialog.hide(item);
        }
        function gestisciRendicontazione() {
            //console.log(vmd.selected);
            $mdDialog.hide();
            $state.go('app.sprardb_rendicontazioni_progetto', {projectId: vmd.selected.projectId});
        }
    }

    function filterTipo()
    {
        return function (input, dictionary) {
            if (!dictionary)
            {
                return input;
            }
            var output = "";
            dictionary.data.forEach(function (value, key) {
                if (value.id == input)
                {
                    output = value.descrizione;
                }
            });
            return output;
        }
    }

    function SetupListRendicontazioneController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, $mdMedia, api, ricerca, acl, $filter, $mdToast, $cookieStore)
    {
        var vm = this;
        acl.reload();
        vm.filtroconsetup = [{id: ">0", descrizione: "CON SETUP"}, {id: "<0", descrizione: "SENZA SETUP"}];
        vm.annoadesso = parseInt(moment(new Date()).format("YYYY"));
        vm.filtroanno = [];
        vm.annomin = (vm.annoadesso - 3);
        vm.annomax = (vm.annoadesso + 1);

        for (i = vm.annomin; i <= vm.annomax; i++) {
            var jsont = {};
            jsont.id = i;
            jsont.descrizione = i;
            vm.filtroanno.push(jsont);
        }
        vm.searchForms = {
            "id": {
                type: "string",
                title: "id",
                description: "id",
                callbackModel: "ricerca",
                dbfield: "id",
                formtype: "text",
                style: "display:none;"
            },
            "codiceMinistero": {
                type: "string",
                title: "Codice progetto",
                description: "Codice progetto...",
                callbackModel: "ricerca",
                dbfield: "codiceMinistero",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.filtrap()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "entes-nome": {
                type: "string",
                title: "Nome Ente Gestore/Titolare/Partner",
                description: "Nome Ente Gestore/Titolare/Partner...",
                callbackModel: "ricerca",
                dbfield: "entes-nome",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "select",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.statoattivo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "bandos-id_IN": {
                type: "string",
                title: "Categoria/Bando",
                description: "Categoria/Bando...",
                callbackModel: "ricerca",
                dbfield: "bandos-id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "bandos-anni_LIKE": {
                type: "string",
                title: "Anno categoria",
                description: "Anno categoria",
                callbackModel: "ricerca",
                dbfield: "bandos-anni_LIKE",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.anni",
                chiave: "id",
                valore: ["id", "descrizione"]
            },
            "postiLiberi": {
                type: "string",
                title: "Numero posti liberi",
                description: "Numero posti liberi...",
                callbackModel: "ricerca",
                dbfield: "postiLiberi",
                formtype: "text",
                multiple: true,
                onchange: "vm.onSearch()",
                style: ""
            },
            "tags-id": {
                type: "string",
                title: "Tags",
                description: "Con tags...",
                callbackModel: "ricerca",
                dbfield: "tags-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tags",
                chiave: "id",
                valore: "tag|uppercase"
            },
            "tags-tag": {
                type: "string",
                title: "Tags specifici",
                description: "Tags specifici...",
                callbackModel: "ricerca",
                dbfield: "tags-tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            },
            "progettoparametrirendicontaziones-id": {
                type: "string",
                title: "Progetto parametri rendicontazione",
                description: "Progetto parametri rendicontazione...",
                callbackModel: "ricerca",
                dbfield: "progettoparametrirendicontaziones-id",
                formtype: "select",
                onchange: "vm.onSearch()",
                data: "vm.filtroconsetup",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettoparametrirendicontaziones-anno_IN": {
                type: "string",
                title: "Anno setup",
                description: "Anno setup...",
                callbackModel: "ricerca",
                dbfield: "progettoparametrirendicontaziones-anno_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.filtroanno",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettoparametrirendicontaziones-id_IS": {
                type: "string",
                title: "Progetto parametri rendicontazione",
                description: "Progetto parametri rendicontazione...",
                callbackModel: "ricerca",
                dbfield: "progettoparametrirendicontaziones-id_IS",
                formtype: "hidden"
            }
        };



        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Email', 'telefono': 'Telefono', 'postiTotali': 'Posti totali'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo2;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.enteruoloprogettos = ricerca.enteruoloprogettos;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;

        vm.limitOptions = [25];

        vm.searched = true;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.pagination = 10;
        vm.colors = ricerca.colors;


        // Data
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.ricerca.attivo = 1;
        vm.ricerca.operatore = "AND";
        vm.preselezione = $cookieStore.get('progetto_id');
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.ricerca.id = vm.preselezione;
        }
        vm.allsearchs['query[]'][1] = vm.ricerca;
        //vm.entetipos = ricerca.enteprimosettores;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.Bandi = ricerca.bandos;
        vm.bandos = ricerca.bandos;
        vm.anni = ricerca.anni();
        // Dati
        vm.Progetti = null;
        vm.Tags = null;
        vm.Bandi = null;
        vm.contacts = []
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];
        vm.annos = [];

        vm.loadprogettos = function () {
            api.progettos.progetto.search(vm.allsearchs, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                angular.forEach(vm.contacts, function (obj) {
                    obj.entetitolare = {};
                    obj.entegestore = {};
                    obj.tot = 0;
                    obj.benefAttivi = 0;
                    obj.benefTotali = 0;
                    obj.benefT = [];
                    angular.forEach(obj.strutturas, function (subobj) {
                        obj.tot = obj.tot + subobj.numeroPosti;
                        angular.forEach(subobj.strutturahasbeneficiarios, function (subsubobj) {
                            obj.benefT.push(subsubobj.beneficiario_id);
                            obj.benefTotali++;
                        });
                    });
                    angular.forEach(obj.entes, function (subobj1) {
                        angular.forEach(subobj1.enteruolos, function (subobj2) {
                            if (subobj2.id === 1) {
                                //ENTE GESTORE
                                obj.entegestore = subobj1;
                                obj.entegestore.enteruolo = subobj2.descrizione;
                                if (subobj1.istat) {
                                    obj.entegestore.regione = subobj1.istat.regione;
                                    obj.entegestore.provincia = subobj1.istat.provincia;
                                    obj.entegestore.comune = subobj1.istat.comune;
                                }

                            }
                            if (subobj2.id === 8) {
                                //ENTE TITOLARE
                                obj.entetitolare = subobj1;
                                obj.entetitolare.enteruolo = subobj2.descrizione;
                                if (subobj1.istat) {
                                    obj.entetitolare.regione = subobj1.istat.regione;
                                    obj.entetitolare.provincia = subobj1.istat.provincia;
                                    obj.entetitolare.comune = subobj1.istat.comune;
                                }
                            }
                        });
                    });
                    var insearch = obj.benefT.join();
                    if (insearch !== "") {
                        api.beneficiarios.beneficiario.search({id_IN: insearch, stato: 'BENEFICIARIO', operatore: 'AND', fields: 'id'}, function (d) {
                            obj.benefAttivi = d.data.length;
                        });
                    }
                });
                console.log("PROGETTI:", vm.contacts);

            }, function (response) {
                //console.log(response);
            });
            return vm.contacts;
        };
        vm.loadprogettos();

        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.Tags = response;
                vm.tags = response.data;
                vm.users = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadbandos = function () {
            api.bandi.bando.distinct({dataFine: 'distinct'}).$promise.then(function (response) {
                vm.annos = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.annos;
        };
        vm.loadbandos();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "progetto"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;


        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoProgetto = gotoProgetto;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
//
        vm.orderby = orderby;
        vm.searchServerNome = searchServerNome;
        vm.searchServer = searchServer;
        vm.searchEmpty = searchEmpty;
        vm.remove = remove;
        vm.aggiungiTag = aggiungiTag;
//
        vm.openDialogFull = openDialogFull;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.deleteContact = deleteContact;
        vm.selectAllContacts = selectAllContacts;
//
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.pager = pager;
        vm.compareDates = compareDates;

        console.log(vm.contacts);
        function compareDates(a, b) {
            // Converte le stringhe di data in oggetti
            /*
            var dateA = new Date(a.dataInizioPeriodo);
            var dateB = new Date(b.dataInizioPeriodo);
        vm.Progetti.data[0].progettoparametrirendicontaziones.dataInizioPeriodo
            return dateA - dateB;
            */

        }


        //////////


        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Email', 'telefono': 'Telefono', 'postiTotali': 'Posti totali'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 10000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,postiTotali';
            api.progettos.progetto.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
//                if (angular.isDate(value)) {
//                    return moment(date).format('DD/MM/YYYY');
//                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }

        function onSearch() {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';

                if (vm.ricerca2.indexOf(",") > -1) {
                    vm.allsearchs['query[]'][0]["codiceMinistero_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["nome_IN"] = vm.ricerca2;
                } else {
                    vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].codiceMinistero = vm.ricerca2;
                }

            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });

            if (angular.isDefined(vm.ricerca["progettoparametrirendicontaziones-id"])) {
                if (vm.ricerca["progettoparametrirendicontaziones-id"] === ">0") {
                    delete vm.ricerca["progettoparametrirendicontaziones-id_IS"];
                }
                if (vm.ricerca["progettoparametrirendicontaziones-id"] === "<0") {
                    delete vm.ricerca["progettoparametrirendicontaziones-id"];
                    vm.ricerca["progettoparametrirendicontaziones-id_IS"] = "NULL";
                }

            }

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }


            if (tiporicerca == 'like') {
                api.progettos.progetto.like(vm.allsearchs, function (d) {
                    //console.log(d);
                    vm.Progetti = d;
                    vm.contacts = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                    angular.forEach(vm.contacts, function (obj) {
                        obj.entetitolare = {};
                        obj.entegestore = {};
                        obj.tot = 0;
                        obj.benefAttivi = 0;
                        obj.benefTotali = 0;
                        obj.benefT = [];
                        angular.forEach(obj.strutturas, function (subobj) {
                            obj.tot = obj.tot + subobj.numeroPosti;
                            angular.forEach(subobj.strutturahasbeneficiarios, function (subsubobj) {
                                obj.benefT.push(subsubobj.beneficiario_id);
                                obj.benefTotali++;
                            });
                        });
                        angular.forEach(obj.entes, function (subobj1) {
                            angular.forEach(subobj1.enteruolos, function (subobj2) {
                                if (subobj2.id === 1) {
                                    //ENTE GESTORE
                                    obj.entegestore = subobj1;
                                    obj.entegestore.enteruolo = subobj2.descrizione;
                                    obj.entegestore.regione = subobj1.istat.regione;
                                    obj.entegestore.provincia = subobj1.istat.provincia;
                                    obj.entegestore.comune = subobj1.istat.comune;

                                }
                                if (subobj2.id === 8) {
                                    //ENTE TITOLARE
                                    obj.entetitolare = subobj1;
                                    obj.entetitolare.enteruolo = subobj2.descrizione;
                                    obj.entetitolare.regione = subobj1.istat.regione;
                                    obj.entetitolare.provincia = subobj1.istat.provincia;
                                    obj.entetitolare.comune = subobj1.istat.comune;

                                }
                            });
                        });
                        var insearch = obj.benefT.join();
                        api.beneficiarios.beneficiario.search({id_IN: insearch, stato: 'BENEFICIARIO', operatore: 'AND'}, function (d) {
                            obj.benefAttivi = d.data.length;
                        });
                    });
                }
                );
            }
            if (tiporicerca == "search") {
                vm.loadprogettos();
            }
            vm.searched = true;
        }

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }


        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            vm.dataFilter.sort = order + field;
            api.progetti.progetto.search(vm.dataFilter, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['bandos-descrizione'] = string;
            //vm.ricerca2['strutturas-nome'] = string;
            vm.ricerca2['email'] = string;
            vm.ricerca2['nome'] = string;
            vm.ricerca2['operatore'] = 'OR';
            api.progetti.progetto.like(vm.ricerca2, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            //console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.progetti.progetto.like(vm.ricerca, function (response) {
                    vm.Progetti = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.progetti.progetto.search({}, function (response) {
                    vm.Progetti = response;
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.progetti.progetto.search({}, function (response) {
                vm.Progetti = response;
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        function remove(item) {
            //var index = array.indexOf(item);
            //if(index>=0) array.splice(index, 1);
            delete vm.ricerca[item];
        }
        function aggiungiTag(tstring) {
            api.tags.tag.save({tag: tstring}, function (response) {
                $state.reload();
            });
        }


        function openDialogFull(ev, progetto) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && ($mdMedia('xs') || $mdMedia('sm'));
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/contact/dialog1.tmpl.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: useFullScreen,
                locals: {
                    Progetto: progetto,
                    Tags: vm.tags,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller: 'ProgettoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/progetti/progetti/dialogs/contact/contact-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Contact: contact,
                    User: vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare il progetto?')
                    .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' sarà disattivato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler disattivare i progetti?')
                    .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' saranno disattivati.')
                    .ariaLabel('delete contacts')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }


        function toggleSelectContact(contact, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedContacts.indexOf(contact) > -1) {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            } else {
                vm.selectedContacts.push(contact);
            }
        }
        function deselectContacts() {
            vm.selectedContacts = [];
        }
        function selectAllContacts() {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if (vm.newGroupName === '')
            {
                return;
            }

            var newGroup = {
                'id': msUtils.guidGenerator(),
                'name': vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                    .title('Are you sure want to delete the group?')
                    .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                    .ariaLabel('delete group')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }
        function pager(uri) {
            msApi.register('pager.page', [uri]);
            msApi.resolve('pager.page@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
        }

        vm.filtrap = filtrap;
        function filtrap() {
            var regioni = vm.ricerca.codRegione_IN;
            var allprovincias = ricerca.provincias;
            var provinciasfiltered = [];
            angular.forEach(regioni, function (regione) {
                angular.forEach(allprovincias, function (allprovincia) {
                    if (allprovincia.codRegione === regione) {
                        provinciasfiltered.push(allprovincia);
                    }
                });
            });
            vm.provincias = provinciasfiltered;
            if (angular.isUndefined(vm.ricerca.codRegione_IN)) {
                vm.provincias = allprovincias;
            }
        }

        vm.gotobulk = gotobulk;
        function gotobulk(items) {
            $state.go('app.sprardb_rendicontazioni_setupdetailb', {ids: items});
        }

        vm.editSetup = editSetup;
        function editSetup(isnew, progetto_id, data) {
            var oggetto = {};
            oggetto.isnew = isnew;
            oggetto.progetto_id = progetto_id;
            oggetto.data = data;

            $state.go('app.sprardb_rendicontazioni_setupdetail', {obj: oggetto});
        }
        vm.newSetup = newSetup;
        function newSetup(isnew, progetto_id, data) {
            var oggetto = {};
            oggetto.isnew = isnew;
            oggetto.progetto_id = progetto_id;
            oggetto.data = data;

            $state.go('app.sprardb_rendicontazioni_setupdetail', {obj: oggetto});
        }

    }

    function SetupDettaglioController($state, $document, $filter,$window, api, msUtils, $mdDialog, $stateParams, $mdToast, ricerca, eventi, acl)
    {
        console.log("$stateParams", $stateParams);
        //deleted injects: Progetto, Tags, Bandi
        var vm = this;
        console.log(vm);
        vm.isnew = true;
        vm.params = {};
        if ($stateParams) {
            vm.params = angular.copy($stateParams);

        }
        vm.periodo = 0;
        console.log(vm.params);
        vm.annuale = 6;
        vm.semestrale = 5;
        vm.quadrimestrale = 3;
        vm.temporale = 1;

        if (vm.params.obj) {
            if (vm.params.obj.progetto_id) {

                vm.progetto_id = vm.params.obj.progetto_id;
            } else {
                $state.go('app.sprardb_rendicontazioni_setup');
            }
            if (angular.isDefined(vm.params.obj.isnew)) {
                vm.isnew = vm.params.obj.isnew;
            }
        } else {
            $state.go('app.sprardb_rendicontazioni_setup');
        }
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.isallowed = acl.isallowed;
        vm.oggi = new Date();
        vm.annoadesso = parseInt(moment(new Date()).format("YYYY"));
        vm.filtroanno = [];
        vm.annomin = (vm.annoadesso - 3);
        vm.annomax = (vm.annoadesso + 1);

        for (i = vm.annomin; i <= vm.annomax; i++) {
            var jsont = {};
            jsont.id = i;
            jsont.descrizione = i;
            vm.filtroanno.push(jsont);
        }
        vm.datas = {};
        vm.periodoId = null;
        vm.datas.dataFinePeriodo = null;
        vm.datas.dataInizioPeriodo = null;
        vm.datas.dataPreventivoFine = null;
        vm.datas.dataPreventivoInizio = null;
        vm.datas.dataSALFine = null;
        vm.datas.dataSALInizio = null;
        vm.datas.dataRendicontazioneFine = null;
        vm.datas.dataRendicontazioneInizio = null;
        vm.datas.dataRimodulazioneFine = null;
        vm.datas.dataRimodulazioneInizio = null;
        vm.datas.progetto_id = vm.progetto_id;
        if (vm.params.obj) {
            if (vm.params.obj.data) {
                if (vm.params.obj.data.length > 0) {
                    vm.alldatas = angular.copy(vm.params.obj.data);
                    if (!vm.isnew) {
                        vm.filtroanno = [];
                        angular.forEach(vm.alldatas, function (d) {
                          var jsont = {};
                          jsont.id = d.id;
                          jsont.descrizione = d.mesiAnniRendicontazione;
                          vm.filtroanno.push(jsont);

                        });

                    }
                }
            }
        }


        vm.round = round;

        function round(decimal) {
            return Math.round(decimal);
        }

        vm.selectdatas = selectdatas;
        function selectdatas() {
            if (!vm.isnew) {
                var indice = 0;
                angular.forEach(vm.alldatas, function (d) {
                    if (d.id === vm.datas.id) {
                        angular.forEach(d, function (v, k) {
                            if (k.indexOf("data") > -1) {
                                d[k] = new Date(v);
                            }
                        });
                        vm.datas = angular.copy(d);
                    }
                    indice++;
                });

            }
        }

        vm.saveRendicontazioneData = saveRendicontazioneData;
        function saveRendicontazioneData() {
            var tempdata = angular.copy(vm.datas);
            angular.forEach(tempdata, function (v, k) {
                if (k.indexOf("data") > -1) {
                    tempdata[k] = moment(v).format("YYYY-MM-DD");
                }
            });


            tempdata.periodo = vm.periodo;
            if (vm.isnew) {
                tempdata.anno = tempdata.id;
                delete tempdata.id;
                api.progetti.progettoParametriRendicontazione.save(tempdata, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati inseriti correttamente')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.go('app.sprardb_rendicontazioni_setup')
                            );
                });
            } else {
                tempdata.anno = moment(vm.datas.dataInizioPeriodo).year();
                vm.datas.anno = tempdata.anno;
                api.progetti.progettoParametriRendicontazione.aggiorna(tempdata, function (response) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati aggiornati correttamente')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.go('app.sprardb_rendicontazioni_setup')
                            );
                });
            }
        }


        function gotoProgetti() {
            $state.go('app.sprardb_progetti_progetti');
        }
        function gotoDettaglios(id, progetto_id)
        {
            $state.go('app.sprardb_progetti_strutture_struttura', {id: id, progetto_id: progetto_id});
        }


    }

    function SetupDetailBulkController($state, $document, $filter, api, msUtils, $mdDialog, $stateParams, $mdToast, ricerca, eventi, acl) {
        var vm = this;
        vm.annoadesso = parseInt(moment(new Date()).format("YYYY"));
        vm.filtroanno = [];
        vm.annomin = (vm.annoadesso - 3);
        vm.annomax = (vm.annoadesso + 1);

        for (i = vm.annomin; i <= vm.annomax; i++) {
            var jsont = {};
            jsont.id = i;
            jsont.descrizione = i;
            vm.filtroanno.push(jsont);
        }
        vm.bulkIds = $stateParams.ids.split(",");

        vm.savebulk = savebulk;
        function savebulk() {
            var bulksetupdata = angular.copy(vm.datas);
            bulksetupdata = bulksetupdata;
            bulksetupdata.ids = vm.bulkIds;
            bulksetupdata.dataPreventivoFine = moment(bulksetupdata.dataPreventivoFine).format('YYYY-MM-DD');
            bulksetupdata.dataPreventivoInizio = moment(bulksetupdata.dataPreventivoInizio).format('YYYY-MM-DD');
            bulksetupdata.dataSALFine = moment(bulksetupdata.dataPreventivoFine).format('YYYY-MM-DD');
            bulksetupdata.dataSALInizio = moment(bulksetupdata.dataPreventivoInizio).format('YYYY-MM-DD');
            bulksetupdata.dataRendicontazioneFine = moment(bulksetupdata.dataRendicontazioneFine).format('YYYY-MM-DD');
            bulksetupdata.dataRendicontazioneInizio = moment(bulksetupdata.dataRendicontazioneInizio).format('YYYY-MM-DD');
            bulksetupdata.dataRimodulazioneFine = moment(bulksetupdata.dataRimodulazioneFine).format('YYYY-MM-DD');
            bulksetupdata.dataRimodulazioneInizio = moment(bulksetupdata.dataRimodulazioneInizio).format('YYYY-MM-DD');




            api.progetti.progettoParametriRendicontazione.savebulk(bulksetupdata, function (response) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati salvati correttamente')
                        .position('bottom right')
                        .hideDelay(3000)
                        ).then(
                        $state.go('app.sprardb_rendicontazioni_setup')
                        );
            });



        }
    }




})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.protocollo', ['flow'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        // State
        $stateProvider.state('app.sprardb_protocollo', {
            url: '/sprardb/protocollo/firma/:evento_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/protocollo/protocollo.html',
                    controller: 'ProtocolloController as vm'
                }
            }
        });
        $stateProvider.state('app.protocollo_segnalatienti', {
            url: '/sprardb/modellosegnalazionee/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/protocollo/eventiprotocollo.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
                statoiniziale: ["1"]
            }
        });
        $stateProvider.state('app.protocollo_segnalatiprogetto', {
            url: '/sprardb/modellosegnalazionep/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/protocollo/eventiprotocollo.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
                statoiniziale: ["1"]
            }
        });
        $stateProvider.state('app.protocollo_segnalatiarrivo', {
            url: '/sprardb/letterainserimento/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/protocollo/eventiprotocollo.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
                statoiniziale: ["1"]
            }
        });
        $stateProvider.state('app.protocollo_trasferimenti', {
            url: '/sprardb/letteratrasferimento/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/protocollo/eventiprotocollo.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
                statoiniziale: ["3"]
            }
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/protocollo');

        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;


        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';


        //scadmin
        /*
         msNavigationServiceProvider.saveItem('scadmin.protocolloentrata', {
         title: 'Protocollo entrata',
         weight: 90
         });
         msNavigationServiceProvider.saveItem('scadmin.protocolloentrata.segnalazionienti', {
         title: 'Mod.segnalaz. ente',
         icon: 'icon-receipt',
         state: 'app.protocollo_segnalatienti({eventoTipo_id:1003})',
         weight: 1
         });
         
         msNavigationServiceProvider.saveItem('scadmin.protocolloentrata.segnalazioneprogetto', {
         title: 'Mod.segnalaz. progetto',
         icon: 'icon-receipt',
         state: 'app.protocollo_segnalatiprogetto({eventoTipo_id:1002})',
         weight: 2
         });
         
         msNavigationServiceProvider.saveItem('scadmin.protocollouscita', {
         title: 'Protocollo uscita',
         weight: 91
         });
         msNavigationServiceProvider.saveItem('scadmin.protocollouscita.segnalazionearrivo', {
         title: 'Lettera inserimento',
         icon: 'icon-receipt',
         state: 'app.protocollo_segnalatiarrivo({eventoTipo_id:1004})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.protocollouscita.trasferimento', {
         title: 'Lettera trasferimento',
         icon: 'icon-receipt',
         state: 'app.protocollo_trasferimenti({eventoTipo_id:1013})',
         weight: 2
         });
         */
        /*
         //protocollo
         msNavigationServiceProvider.saveItem('scsegreteria.protocolloentrata', {
         title: 'Protocollo entrata',
         weight: 90
         });
         msNavigationServiceProvider.saveItem('scsegreteria.protocolloentrata.segnalazionienti', {
         title: 'Mod.segnalaz. ente',
         icon: 'icon-receipt',
         state: 'app.protocollo_segnalatienti({eventoTipo_id:1003})',
         weight: 1
         });
         */
//        msNavigationServiceProvider.saveItem('scsegreteria.protocolloentrata.segnalazioneprogetto', {
//            title: 'Mod.segnalaz. progetto',
//            icon: 'icon-receipt',
//            state: 'app.protocollo_segnalatiprogetto({eventoTipo_id:1002})',
//            weight: 2
//        });
        /*
         msNavigationServiceProvider.saveItem('scsegreteria.protocollouscita', {
         title: 'Protocollo uscita',
         weight: 91
         });
         msNavigationServiceProvider.saveItem('scsegreteria.protocollouscita.segnalazionearrivo', {
         title: 'Lettera inserimento',
         icon: 'icon-receipt',
         state: 'app.protocollo_segnalatiarrivo({eventoTipo_id:1004})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scsegreteria.protocollouscita.trasferimento', {
         title: 'Lettera trasferimento',
         icon: 'icon-receipt',
         state: 'app.protocollo_trasferimenti({eventoTipo_id:1013})',
         weight: 2
         });
         */


    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.protocollo')
            .controller('ProtocolloController', ProtocolloController);

    /** @ngInject */
    function ProtocolloController($mdSidenav, $state, msUtils, $mdDialog, $document, api, eventi, $filter, $mdToast, acl)
    {
        var vm = this;
        vm.isallowed = acl.isallowed2;
        vm.bufferpdf = bufferpdf;//eventi.modellosegnalazione;
        vm.ms = eventi.modellosegnalazione;
        vm.li = eventi.letterainserimento;
        vm.lt = eventi.letteratrasferimento;
        vm.parametristato = $state.params;
        vm.evento_id = vm.parametristato.evento_id;
        vm.eventos = null;
        vm.notselectable = [];
        vm.pdf = null;
        vm.lettera_id = 0;
        vm.show = false;
        vm.tipoProtocollo = "O";
        vm.protocollo = {};
        vm.oggi = new Date();
        vm.protocollo.dataProtocollo = vm.oggi;//moment(vm.oggi).format("llll");
        vm.isprotocollato = false;
        vm.eventopadre_id = [];
        vm.tutti_i_collegati = [];
        vm.filename = null;
        vm.segnalazione_id = 0;
        vm.documentoTipo_id = 0;
        vm.eventoTipo_id = 0;
        vm.protocollo.descrizioneFirma = '';
        vm.protocollo.firmaProtocollo = '';
        vm.api = api;


        api.beneficiarios.attributi.cerca({gruppo: "FIRMA", pagination: "50", sort: "descrizione"}, function (response) {
            vm.firmas = response.data;
        });

        api.eventos.evento.get({id: vm.evento_id}, function (d) {
            vm.eventos = d;
            console.log("vm.eventos", vm.eventos);
            vm.eventoTipo_id = vm.eventos.eventoTipo_id;
            //documento protocollare modello segnalazione
            if (vm.eventos.protocollo !== null) {
                vm.isprotocollato = true;
                vm.protocollo.dataProtocollo = new Date(vm.eventos.dataProtocollo);
                vm.protocollo.protocollo = vm.eventos.protocollo;
                vm.protocollo.destinatari = vm.eventos.a;
                vm.protocollo.idFirma = vm.eventos.idFirma;
                vm.protocollo.firmaProtocollo = vm.eventos.firmaProtocollo;
            }
            if (vm.eventos.eventoTipo_id == 1003 || vm.eventos.eventoTipo_id == 1002) {

                vm.lettera_id = vm.eventos.entita1.segnalazione_id;
                vm.segnalazione_id = vm.lettera_id;
                vm.documentoTipo_id = 26;
                vm.filename = 'modellosegnalazione_' + vm.lettera_id;
                vm.tipoProtocollo = "O";
                vm.protocollo.destinatari = vm.eventos.a + ";emailaccoglienza@kubique.com;" + vm.eventos.entita1.segnalaziones.entes.email;
//                if (vm.eventos.eventopadre_id > 0) {
//                    vm.eventopadre_id.push(vm.eventos.eventopadre_id);
//                }
//                api.eventos.evento.get({id: vm.eventos.eventopadre_id}, function (p) {
//                    if (p.eventopadre_id > 0) {
//                        vm.eventopadre_id.push(p.eventopadre_id);
//                    }
//                    console.log("vm.eventopadre_id", vm.eventopadre_id);
//                });
                vm.recuperatutticollegati(vm.eventos);

            }
            //documento protocollare lettera inserimento
            if (vm.eventos.eventoTipo_id == 1004) {

                vm.lettera_id = vm.eventos.entita1.letteraInserimento;
                vm.segnalazione_id = vm.eventos.entita1.segnalazione_id;
                vm.documentoTipo_id = 27;
                vm.filename = 'letterainserimento_' + vm.lettera_id;
                vm.tipoProtocollo = "I";
                vm.protocollo.destinatari = vm.eventos.a + ";" + vm.eventos.entita1.progettos.email + ";emailaccoglienza@kubique.com;emailunicaprogetto@kubique.com;";


                vm.recuperatutticollegati(vm.eventos);
            }
            //documento protocollare lettera trasferimento
            if (vm.eventos.eventoTipo_id == 1013) {

                vm.lettera_id = vm.eventos.entita1.id;//vm.eventos.entita1.letteratrasferimento_id;
                vm.segnalazione_id = vm.eventos.entita1.id;
                vm.documentoTipo_id = 28;
                vm.filename = 'letteratrasferimento_' + vm.lettera_id;
                vm.tipoProtocollo = "I";
                vm.protocollo.destinatari = vm.eventos.a + ";" + vm.eventos.entita1.progettos.email + ";emailaccoglienza@kubique.com;emailunicaprogetto@kubique.com;";


                vm.recuperatutticollegati(vm.eventos);
            }

            console.log("vm.lettera_id", vm.lettera_id);

            vm.title = JSON.parse(vm.eventos.eventoTipo.extra).title;
            if (vm.eventos.extra) {
                vm.eventos.extra = JSON.parse(vm.eventos.extra);
            } else {
                vm.eventos.extra = {};
            }
            console.log("title:", vm.title);

            vm.processi = vm.eventos.eventoTipo.processo.split("|");
            if (vm.eventos.eventoStato_id < 4) {
                vm.notselectable.push(vm.eventos.eventoTipo_id);
            }
            console.log("processi:", vm.processi);
            console.log("notselectable:", vm.notselectable);
            vm.bufferpdf("EventoBot", vm.lettera_id);
        });


        vm.showpdf = showpdf;
        function showpdf() {
            console.log("vm.tutti_i_collegati", vm.tutti_i_collegati);
            vm.pdf = "data:application/pdf;base64," + eventi.buffer;
            //console.log(eventi.buffer);
            vm.show = !vm.show;
        }


        vm.protocolla = protocolla;
        function protocolla(evento_id) {
            /// CONTROLLARE
            var payload = {};
            payload.id = evento_id;
            payload.protocollo = vm.protocollo.descrizioneFirma + ' ' + vm.protocollo.protocollo;
            payload.dataProtocollo = moment(vm.protocollo.dataProtocollo).format('YYYY-MM-DD');
            payload.firmaProtocollo = vm.protocollo.firmaProtocollo;
            payload.idFirma = vm.protocollo.idFirma;
            payload.a = vm.protocollo.destinatari;
            vm.isprotocollato = true;
            api.eventos.evento.aggiorna(payload, function (r) {

                if (r.id == evento_id) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Protocollo inserito con successo!')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(function () {
                        vm.aggiornatutti(payload);
                        //$state.reload();
                    });
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Errore durante inserimento procollo!')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(function () {
                        $state.reload();
                    });
                }
            });

        }

        vm.recuperatutticollegati = recuperatutticollegati;
        function recuperatutticollegati(questo_eventos) {
            vm.tutti_i_collegati = [];
            if (questo_eventos.eventoTipo_id == 1002 || questo_eventos.eventoTipo_id == 1003) {
                var tempeventopadre = 0;

                //devo tornare indietro sui 1001,1000 e 999 per recuperare tutti i segnalati
                if (questo_eventos.eventopadre_id > 0) {
                    api.eventos.evento.get({id: questo_eventos.eventopadre_id}, function (p) {
                        //questo è un evento 1001 o 1000
                        if (p.eventopadre_id > 0) {
                            //questo padre è l'evento 999 il generatore di tutto
                            tempeventopadre = p.eventopadre_id;
                            vm.tutti_i_collegati.push(tempeventopadre);
                            var primolivello = [];
                            var secondolivello = [];
                            api.eventos.evento.search({eventopadre_id: tempeventopadre, fields: "id,eventopadre_id,eventoTipo_id"}, function (pl) {
                                primolivello = pl.data;
                                angular.forEach(primolivello, function (obj1) {
                                    vm.tutti_i_collegati.push(obj1.id);
                                    tempeventopadre = obj1.id;
                                    api.eventos.evento.search({eventopadre_id: tempeventopadre, fields: "id,eventopadre_id,eventoTipo_id"}, function (sl) {
                                        secondolivello = sl.data;
                                        angular.forEach(secondolivello, function (obj2) {
                                            vm.tutti_i_collegati.push(obj2.id);
                                        });
                                    });
                                });
                            });
                        }
                        console.log("vm.tutti_i_collegati", vm.tutti_i_collegati);
                    });
                }


            }

            if (questo_eventos.eventoTipo_id == 1004) {
                //devo recuperare tutti i segnalati con la stessa lettera di inserimento
                var tempeventopadre = 0;
                var segnalati = [];
                api.segnalatos.segnalato.search({letteraInserimento: vm.lettera_id, fields: "id,letteraInserimento"}, function (seg) {

                    segnalati = angular.copy(seg.data);
                    angular.forEach(segnalati, function (s) {
                        api.eventos.evento.search({entita1_id: s.id, eventoTipo_id: 1004, eventoStato_id_IN: "1,2"}, function (p) {
                            var evento = p.data[0];
                            vm.tutti_i_collegati.push(evento.id);
                            console.log("vm.tutti_i_collegati", vm.tutti_i_collegati);
                        });
                    });
                });
            }
            if (questo_eventos.eventoTipo_id == 1013) {
                vm.tutti_i_collegati.push(questo_eventos.id);

            }
        }

        vm.aggiornatutti = aggiornatutti;
        function aggiornatutti(payload) {
            var tutticollegati = [];
            var contatore = 0;
            var totale_da_aggiornare = vm.tutti_i_collegati.length;
            var payload2 = angular.copy(payload);
            payload2.id = vm.lettera_id;
            if (vm.eventoTipo_id == 1013) {
                payload2.id = vm.eventos.entita1.letteratrasferimento_id;
            }
            api.letterainserimentors.letterainserimentor.aggiorna(payload2, function (r2) {
                console.log("Aggiornamento payload2: ", angular.copy(payload2));
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Aggiornamento lettera inserimento rasterizzata!')
                        .position('bottom right')
                        .hideDelay(1000)
                        );
            });

            angular.forEach(vm.tutti_i_collegati, function (id_evento) {
                payload.id = id_evento;
                console.log("Aggiornamento payload: ", angular.copy(payload));
                api.eventos.evento.aggiorna(payload, function (r) {
                    if (r.eventoTipo_id == vm.eventoTipo_id) {
                        //
                        tutticollegati.push(r.id);
                    }

                    console.log("r.id: ", angular.copy(r.id));
                    //console.log("payload.id: ", angular.copy(payload.id));
                    contatore = contatore + 1;
                    //console.log("Contatore: ", angular.copy(contatore));
                    //console.log("Totale da aggiornare: ", angular.copy(totale_da_aggiornare));

                    if (contatore == totale_da_aggiornare) {
                        vm.bufferpdf("EventoBot", vm.lettera_id);
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Protocollo inserito con successo!')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(function () {

                            var uploadpayload = {};
                            uploadpayload.fileb64 = eventi.buffer;
                            uploadpayload.filename = vm.filename;
                            uploadpayload.extension = 'pdf';
                            uploadpayload.segnalazione_id = vm.segnalazione_id;
                            uploadpayload.documentoTipo_id = vm.documentoTipo_id;

                            api.documentos.documento.uploadb64(uploadpayload, function (upl) {
                                $mdToast.show(
                                        $mdToast.simple()
                                        .textContent('Documento protocollato caricato con successo!')
                                        .position('bottom right')
                                        .hideDelay(3000)
                                        ).then(function () {
                                    var contatore_due = 0;
                                    var totale_due = tutticollegati.length;
                                    angular.forEach(tutticollegati, function (evento_id) {
                                        var statopayload = {};
                                        statopayload.id = evento_id;
                                        statopayload.eventoStato_id = 2;
                                        api.eventos.evento.aggiorna(statopayload, function (ultimo) {
                                            contatore_due = contatore_due + 1;
                                            if (contatore_due == totale_due) {
                                                $state.reload();
                                            }
                                        });
                                    });
                                });
                            });


                        });
                    }
                });
            });
        }

        function bufferpdf(evento, lettera_id) {
            if (vm.eventoTipo_id == 1002 || vm.eventoTipo_id == 1003) {
                vm.ms(evento, lettera_id);
            }
            if (vm.eventoTipo_id == 1004) {
                vm.li(evento, lettera_id);
            }
            if (vm.eventoTipo_id == 1013) {
                vm.lt(evento, lettera_id);
            }
            //if (vm.eventoTipo_id==1002 ||vm.eventoTipo_id==1003){}
        }

        vm.letteraDialog = letteraDialog;
        function letteraDialog($event, letterainserimento) {


            api.segnalatos.segnalatomag.search({letteraInserimento: letterainserimento}, function (d) {
                var segnalatos = d.data;
                var segnalaziones = d.data[0].segnalaziones;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    //console.log("renderizzato", renderizzato);
                    //delete renderizzato["nota0"];
                    console.log("renderizzato", renderizzato);
                    var templater = rend.template.split("|");
                    //console.log("templater", templater);
                    //delete templater[0];
                    console.log("templater", templater);
                    var etichette = [];
                    etichette["ente1"] = "ente segnalatore/ente titolare auto";
                    etichette["ente2"] = "prefettura ente segnalatore/auto";
                    etichette["ente3"] = "ministero degli interni";
                    etichette["ente4"] = "ente titolare";
                    etichette["ente5"] = "ente gestore";
                    etichette["ente6"] = "prefettura ente titolare";
                    etichette["ente7"] = "ente titolare partenza";
                    etichette["ente8"] = "prefettura ente titolare partenza";
                    etichette["ente9"] = "ente gestore partenza";
                    etichette["nota1"] = "Nota dopo mittente";
                    etichette["nota2"] = "Nota dopo EPC";
                    etichette["nota3"] = "Oggetto";
                    etichette["nota4"] = "Nota dopo tabella";
                    etichette["nota5"] = "Note chiusura";
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'letteraDialogController',
                        controllerAs: 'vm',
                        focusOnOpen: false,
                        locals: {
                            segnalatos: segnalatos,
                            segnalaziones: segnalaziones,
                            renderizzato: renderizzato,
                            templater: templater,
                            etichette: etichette,
                        },
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: event,
                        templateUrl: 'app/main/sprardb/eventi/dialogs/lettera-dialog.html',
                    }).then(function (renderizzatoresponse) {
                        api.letterainserimentors.letterainserimentor.aggiorna(renderizzatoresponse, function (s) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Lettera inserimento modificata con successo!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(function () {
                                $state.reload();
                            });
                        });
                    });
                });
            });
        }
        vm.letteraDialog2 = letteraDialog2;
        function letteraDialog2($event, letterainserimento) {

            api.beneficiarios.beneficiario.search({letteratrasferimento_id: letterainserimento}, function (d) {
                var segnalatos = d.data;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    //console.log("renderizzato", renderizzato);
                    //delete renderizzato["nota0"];
                    console.log("renderizzato", renderizzato);
                    var templater = rend.template.split("|");
                    //console.log("templater", templater);
                    //delete templater[0];
                    console.log("templater", templater);
                    var etichette = [];
                    etichette["ente1"] = "ente segnalatore/ente titolare auto";
                    etichette["ente2"] = "prefettura ente segnalatore/auto";
                    etichette["ente3"] = "ministero degli interni";
                    etichette["ente4"] = "ente titolare";
                    etichette["ente5"] = "ente gestore";
                    etichette["ente6"] = "prefettura ente titolare";
                    etichette["ente7"] = "ente titolare partenza";
                    etichette["ente8"] = "prefettura ente titolare partenza";
                    etichette["ente9"] = "ente gestore partenza";
                    etichette["nota1"] = "Nota dopo mittente";
                    etichette["nota2"] = "Nota dopo EPC";
                    etichette["nota3"] = "Oggetto";
                    etichette["nota4"] = "Nota dopo tabella";
                    etichette["nota5"] = "Note chiusura";
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'letteraDialogController',
                        controllerAs: 'vm',
                        focusOnOpen: false,
                        locals: {
                            segnalatos: segnalatos,
                            renderizzato: renderizzato,
                            templater: templater,
                            etichette: etichette,
                        },
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: event,
                        templateUrl: 'app/main/sprardb/eventi/dialogs/lettera-dialog.html',
                    }).then(function (renderizzatoresponse) {
                        api.letterainserimentors.letterainserimentor.aggiorna(renderizzatoresponse, function (s) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Lettera trasferimento modificata con successo!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    ).then(function () {
                                $state.reload();
                            });
                        });
                    });
                });
            });
        }

        vm.gotolist = gotolist;
        function gotolist() {
            console.log("click");
            if (vm.eventoTipo_id == 1002) {
                $state.go("app.protocollo_segnalatienti", {eventoTipo_id: 1002});
            }
            if (vm.eventoTipo_id == 1003) {
                $state.go("app.protocollo_segnalatiprogetto", {eventoTipo_id: 1003});
            }
            if (vm.eventoTipo_id == 1004) {
                $state.go("app.protocollo_segnalatiarrivo", {eventoTipo_id: 1004});
            }
            if (vm.eventoTipo_id == 1013) {
                $state.go("app.protocollo_trasferimenti", {eventoTipo_id: 1013});
            }
        }

        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.sceglifirma = sceglifirma;
        function sceglifirma() {
            api.beneficiarios.attributi.get({id: vm.protocollo.idFirma}, function (response) {

                vm.protocollo.descrizioneFirma = response.descrizione;
                vm.protocollo.firmaProtocollo = response.note;
                console.log(vm.protocollo);


            });



        }

    }

})();
(function ()
{
    'use strict';

    angular
      .module('app.sprardb.proroghe')
      .service('proroghe', prorogheService);

    /** @ngInject */
    function prorogheService()
    {
      function isEligible(beneficiario) {
        if (beneficiario.stato !== 'BENEFICIARIO') {
          beneficiario.errorMsgProroga = 'È possibile richiedere proroghe solo per i beneficiari presenti';
          return false;
        }

        let id = beneficiario.tipoProtezione_id || beneficiario.tipoProtezione?.id;
        if ([594, 595, 590, 961].includes(id)) {
          beneficiario.errorMsgProroga = 'La tipologia di soggiorno '+beneficiario.tipoProtezione.descrizione+' non consente di richiedere proroghe. Aggiornare lo status giuridico per continuare.';
          return false;
        }
        return true;
      }

      this.isEligible = isEligible;
      return this;
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.proroghe')
            .controller('ProrogheController', ProrogheController)
            .filter('highlight', highlight)
            .filter('highlight2', highlight2);

    function highlight($sce) {
        return function (text, phrase) {
            if (phrase)
                text = $sce.getTrusted($sce.HTML, text);
            var result = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                    '<span class="highlighted">$1</span>')
            return $sce.trustAsHtml(result)
        }
    }
    function highlight2($sce) {
        return function (text, phrase) {
            if (phrase)
                text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                        '<span class="highlighted2">$1</span>')
            return $sce.trustAsHtml(text)
        }
    }

    /** @ngInject */
    function ProrogheController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca,
                                $filter, $mdToast, acl, $cookieStore, $rootScope, $q, proroghe)
    {
        var vm = this;
        // Data
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly;
        vm.api = api;
        vm.isallowed = acl.isallowed2;
        vm.def = ($state.params.def) ? $state.params.def : null;
        var searchpayload = {};
        if (vm.def !== null) {
            searchpayload.def = vm.def;
        }
        vm.datascadenza = ricerca.datascadenzaIntervallo2;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.benefstatos = ricerca.statobeneficiarios;
        vm.nazioneb = ricerca.naziones;

        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        })

        if (vm.api.isAdmin || vm.api.isAccoglienza) {
            vm.progettos = ricerca.progettos;
        } else {
            vm.progettos = ricerca.autorizzatoprogettos;
        }

        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();

        api.tipologiaAccoglienza.tipologie.search(function(res){
          vm.tipAccoglienza = res.data;
        });

        vm.enterilascio = function () {
            console.log('Ente rilascio ');
            api.entes.ente.search({enteTipo_id: 7, sort: 'nome', pagination: "200", fields: "id,nome"}).$promise.then(function (response) {
                vm.enterilascios = response.data;
            }, function (response) {
                console.log('Ente rilascio caricata');
            });
        };
        vm.enterilascio();

        vm.searchForms = {
            "dataNulla": {
                type: "string",
                title: "Fine beneficio",
                description: "Fine beneficio...",
                callbackModel: "ricerca",
                dbfield: "dataNulla",
                formtype: "select",
                multiple: false,
                onchange: "vm.setIntervallo()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataUscita_IS": {
                type: "string",
                title: "Data Uscita",
                description: "Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita_IS",
                formtype: "text",
                style: "display:none;"
            },
            "dataFine_BETWEEN": {
                type: "string",
                title: "Data Fine _BETWEEN",
                description: "Data fine _BETWEEN",
                callbackModel: "ricerca",
                dbfield: "dataFine_BETWEEN",
                formtype: "text",
                multiple: false,
                style: "display:none;"
                        //,onchange: "vm.onSearch()"
                        //,data: "vm.datascadenza2"
            },
          "cancellato_IN": {
            type: "string",
            title: "Cancellato",
            description: "Cancellato...",
            callbackModel: "ricerca",
            dbfield: "cancellato_IN",
            multiple: true,
            style: "display:none;"
          },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "codiceEaso|uppercase"
            },
            "def_IN": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "cancellato_IN": {
              type: "string",
              title: "Cancellato",
              description: "Cancellato...",
              callbackModel: "ricerca",
              dbfield: "cancellato_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.sino",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "progettomcs-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettomcs-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "progettomcs-tipologiaAccoglienzaId_IN": {
              type: "string",
              title: "Tipologia Progetto",
              description: "Tipologia Progetto...",
              callbackModel: "ricerca",
              dbfield: "progettomcs-tipologiaAccoglienzaId_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipAccoglienza",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "progettomcs-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettomcs-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "tipologia_id_IN": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "tipologia_id_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Protezione",
                description: "Tipo Protezione...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "codice": {
                type: "string",
                title: "Codice Beneficiario",
                description: "Codice Beneficiario...",
                callbackModel: "ricerca",
                dbfield: "codice",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "eventos-dataInserimento": {
                type: "string",
                title: "Data Richiesta",
                description: "Data Richiesta",
                callbackModel: "ricerca",
                dbfield: "eventos-dataInserimento",
                formtype: "datepickerv",
                onchange: "vm.ricerca['eventos-eventoTipo_id']=1011;vm.onSearch()"
            }

        };

        vm.notselectable = [];
        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};

        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = false;
        vm.options.multiSelect = false;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.ricerca = {};
        vm.ricerca2 = "";

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.colors = eventi.colors;
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;
        vm.work = eventi.work;
        vm.viewEvento = eventi.viewDetails;

        vm.loadbeneficiarios = function () {
            vm.defricerca = angular.copy(vm.ricerca);
            vm.preselezione = $cookieStore.get('progetto_id');
            console.log("vm.preselezione", vm.preselezione);
            vm.autostart = true;
            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                vm.defricerca["progetto_id_IN"] = [vm.preselezione.toString()];
                vm.autostart = false;
            }
            vm.defricerca.def_IN = [1];
            vm.defricerca.stato_IN = ["BENEFICIARIO"];
            vm.defricerca.cancellato_IN = [0];
            // var oggi = new Date();
            // vm.defricerca.dataNulla = moment(oggi).add(-15, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD');
            // var date = vm.defricerca.dataNulla.split("|");
            // vm.defricerca["dataFine_BETWEEN"] = date;
            vm.defricerca["dataUscita_IS"] = 'NULL';
            vm.defricerca.operatore = 'AND';
            vm.ricerca = angular.copy(vm.defricerca);




        };
        vm.loadbeneficiarios();

        vm.selectedContacts = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;
        vm.editparentela = editparentela;
        vm.trasferiscib = nevento;
        vm.cessab = nevento;
        vm.permessob = nevento;
        vm.richiediproroga = nevento2;
        vm.btnNewProrogaDisabled = btnNewProrogaDisabled;
        vm.countProroghe = countProroghe;
        vm.lavoraProroga = lavoraProroga;
        vm.showProroghe = showProroghe;
        vm.isEligible = proroghe.isEligible;
        //vm.lavoraproroga = nevento3;
        vm.letteraTrasf = eventi.letteraTrasf;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 1000;
            vm.allsearchsTemp.sort = 'cognome';
            vm.allsearchsTemp.fields = 'id,codiceVestanet,cognome,nome,dataNascita,documentoNumero,dataIngresso,dataFine';
            api.beneficiarios.v.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                console.log("vm.entesexport", vm.entesexport);
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            if (key == 'nome'){
              vm.ricercaNome = null;
            }
            if (key == 'cognome'){
              vm.ricercaCognome = null;
            }
            if (key == 'codice'){
              vm.ricercaCodice = null;
            }
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key]?.data)) {
//                if (angular.isDate(value)) {
//                    return moment(date).format('DD/MM/YYYY');
//                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            if (angular.isUndefined(results[0])) {
                return "-";
            }
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoDettaglio(id)
        {
            $state.go('app.sprardb_beneficiario', {id: id});
        }

        function calcolaGiorniPermanenza() {

        }

        vm.loaditems = function (tiporicerca) {
            vm.searching = true;
            $rootScope.loadingProgress = true;
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "search";
            }

            if (vm.prequery !== null) {
                vm.prequery = angular.fromJson(vm.prequery);
                angular.forEach(vm.prequery, function (v, k) {
                    vm.allsearchs['query[]'][1][k] = v;
                    vm.ricerca[k] = v;
                });
            }

            const beneficiarioAttributes = ['id','codice','nome','cognome','parentela','progetto.nome','tipoProtezione'];

            let params = {...vm.allsearchs,
              expand: 'parenti.parentela,parenti.tipoProtezione,strutturahasbeneficiarios,' + api.fields('proroghe',['entita1','eventoTipo','eventoStato']),
              fields:'*,strutturas.nome,strutturas.id,proroghe.*,' + api.fields('proroghe.b', beneficiarioAttributes) +','
                + api.fields('parenti',beneficiarioAttributes)
            };
            vm.searchPromise = api.beneficiarios.v[tr](params).$promise;
            vm.searchPromise.then(function (d) {
                $rootScope.loadingProgress = false;
                vm.searching = false;
                vm.Beneficiari = d;
                vm.beneficiari = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
                vm.giorniPermanenza= [];
                angular.forEach(vm.beneficiari, function (beneficiario) {
                  vm.giorniPermanenza[beneficiario.id] = 0
                  angular.forEach(beneficiario.strutturahasbeneficiarios, function (struttura) {
                    let dataInizio = moment(struttura.dataInserimento);
                    let dataFine = struttura.dataCessazione ? moment(struttura.dataCessazione) : moment();
                    vm.giorniPermanenza[beneficiario.id] += dataFine.diff(dataInizio, 'days');
                  })
                })
                var ii = 0;
                // angular.forEach(vm.beneficiari, function (mainobj) {
                //     //console.log("mainobj", mainobj);
                //     angular.forEach(mainobj.prorogas, function (obj) {
                //         //console.log("obj", obj);
                //         vm.title = JSON.parse(obj.eventoTipo.extra).title;
                //         mainobj.title = JSON.parse(obj.eventoTipo.extra).title;
                //         mainobj.eventoStato_id = obj.eventoStato_id;
                //         mainobj.proroga = obj;
                //         if (obj.extra) {
                //             mainobj.extra = JSON.parse(obj.extra);
                //         } else {
                //             mainobj.extra = {};
                //         }
                //
                //         mainobj.processi = obj.eventoTipo.processo.split("|");
                //         if (obj.eventoStato_id < 4) {
                //             vm.notselectable.push(obj.eventoTipo_id);
                //         }
                //
                //     });
                //     ii++;
                // });
                vm.searched = true;
            }, function (d) {
                //console.log(response);
            });
            return vm.beneficiari;
        };

        vm.ricercaNome = null;
        vm.ricercaCognome = null;
        vm.ricercaCodice = null;
        vm.onSearch = onSearch;
        function onSearch() {
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            var tiporicerca = 'search';
            if(vm.ricercaNome){
              tiporicerca = 'like';
              vm.searchForms['nome'] = {title: 'nome'};
              vm.ricerca['nome'] = vm.ricercaNome;
            }else{
              delete vm.ricerca['nome'];
            }
            if(vm.ricercaCognome){
              tiporicerca = 'like';
              vm.searchForms['cognome'] = {title: 'cognome'};
              vm.ricerca['cognome'] = vm.ricercaCognome;
            }else {
              delete vm.ricerca['cognome'];
            }
            if(vm.ricercaCodice){
              vm.searchForms['codice'] = {title: 'codice'};
              vm.ricerca['codice'] = vm.ricercaCodice;
            }else {
              delete vm.ricerca['codice'];
            }
            if (vm.def !== null) {
                vm.ricerca.def_IN = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
            });
            var ricercaPayload = angular.copy(vm.ricerca);
//            if (vm.ricerca) {
//                vm.ricerca.operatore = 'AND';
//                vm.allsearchs['query[]'][1] = vm.ricerca;
//            }
            if (ricercaPayload) {
                delete ricercaPayload['dataNulla'];
                ricercaPayload.operatore = 'AND';
                vm.allsearchs['query[]'][1] = ricercaPayload;
            }
            if (!vm.searching) {
                vm.loaditems(tiporicerca);
            }
        }

        vm.setIntervallo = setIntervallo;
        function setIntervallo() {
            var date = vm.ricerca.dataNulla.split("|");

            vm.ricerca["dataFine_BETWEEN"] = date;
            onSearch();
        }

        vm.prorogaAperta = prorogaAperta;
        function prorogaAperta(beneficiario) {
            var found = false;
            angular.forEach(beneficiario.proroghe, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3) {
                    found = true;
                    beneficiario.errorMsgProroga = 'Esiste già una richiesta di proroga da completare'
                }
            });
            return found;

        }
        vm.prorogaApertaId = prorogaApertaId;
        function prorogaApertaId(beneficiario) {
            var found = 0;
            angular.forEach(beneficiario.prorogas, function (proroga) {
                if (proroga.eventoStato_id === 1 || proroga.eventoStato_id === 3 || proroga.eventoStato_id === 4) {
                    found = proroga.id;
                }
            });
            return found;

        }

        vm.richestaprorogaottenibile = eventi.richestaprorogaottenibile;
        vm.statoprorogaok = statoprorogaok;
        function statoprorogaok(item) {
            //controllo eventi
            angular.forEach(item.prorogas, function (pr, i) {
                console.log("pr:" + i, pr.eventoStato_id);
                if (pr.eventoStato_id == 3) {
                    return false;
                }
            });
            return true;
        }


        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
//            oggi.setHours(0);
//            oggi.setMinutes(0);
//            oggi.setSeconds(0);
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }

        function editparentela() {
            var selected = vm.selected;
            console.log(selected);
            $mdDialog.show({
                controller: 'ParentelaDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/beneficiari/dialog/dialog_parentela.html',
                clickOutsideToClose: true,
                locals: {
                    items: selected,
                    parentelas: vm.parentelas

                }
            });
        }

        function nevento(ide) {
            // 1013 EVETNO TRASFERIMENTO
            var selected = vm.selected;
            var stato = 4;
            var item = {};
            item.eventoTipo = {};

            api.eventos.tipo.get({id: ide}).$promise.then(function (d) {
                item.eventoTipo = angular.copy(d);
                var statip = item.eventoTipo.statiPossibili.split(",");
                stato = statip[1];
                var payload = {};
                payload.self = {};
                payload.self.entita1_id = [];
                payload.self.entita2_id = [];
                payload.entita1_id = [];
                payload.self.eventoTipo_id = item.eventoTipo.id;
                angular.forEach(selected, function (s) {
                    payload.self.entita1_id.push(s.id);
                    payload.self.entita2_id.push(s.strutturas[0]['id']);
                    payload.entita1_id.push(s.id);

                });
                payload.isnew = true;
                payload.parent = {};
                payload.extra = {};
                payload.eventoTipo_id = item.eventoTipo.id;
                var oggi = new Date();
                payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
                var extrasetup = JSON.parse(item.eventoTipo.extra);
                var openpopup = angular.isDefined(extrasetup.properties[stato]);
                console.log("payload: ", payload);
                api.processi.processo.lavora(payload, function (response) {
                    if (response.status == 200) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Evento inserito correttamente!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        if (openpopup) {
                            //item.id = response.id;
                            api.eventos.evento.get({id: response.id}, function (r) {
                                var newitem = r;
                                //apri popoup per lavorazione
                                eventi.work("completa", newitem, stato, "completa", false);
                            });
                        } else {
                            $state.reload();
                        }
                    }
                });
            });

        }

        function btnNewProrogaDisabled(beneficiario)
        {
          return !vm.isEligible(beneficiario) || (vm.prorogaAperta(beneficiario) && !vm.isAdmin);
        }

        function countProroghe(beneficiario)
        {
          return $filter('filter')(beneficiario.proroghe, {eventoStato_id: '!1'}).length;
        }

        function showProroghe(beneficiario)
        {
          const showDialogPromise = $q.defer();
          showDialogPromise.resolve = onSearch;

          $mdDialog.show({
            controller: 'ProrogheShowController',
            controllerAs: 'vmd',
            bindToController: true,
            templateUrl: 'app/main/sprardb/proroghe/dialogs/proroghe.show.html',
            clickOutsideToClose: false,
            locals: {
              beneficiario: beneficiario,
              showDialogPromise: showDialogPromise
            }
          });
        }

        function lavoraProroga(model, action)
        {
          const showDialogPromise = $q.defer();
          showDialogPromise.resolve = onSearch;

          $mdDialog.show({
            controller: 'ProrogaDialogController',
            controllerAs: 'vmd',
            bindToController: true,
            templateUrl: 'app/main/sprardb/proroghe/dialogs/proroga.dialog.html',
            clickOutsideToClose: false,
            locals: {
              action: action,
              model: model,
              showDialogPromise: showDialogPromise
            }
          }).then(onSearch);
        }

        function nevento2(idte, beneficiario, oldProrogaId) {
            // 1011 EVETNO PROROGA
            var s = beneficiario;
            var stato = 4;
            var item = {};
            item.eventoTipo = {};

            api.eventos.tipo.get({id: idte}).$promise.then(function (d) {
                item.eventoTipo = angular.copy(d);
                var statip = item.eventoTipo.statiPossibili.split(",");
                stato = statip[1];
                var payload = {};
                payload.self = {};
                payload.self.entita1_id = [];
                payload.self.entita2_id = [];
                payload.entita1_id = [];
                payload.self.eventoTipo_id = item.eventoTipo.id;
                payload.self.entita1_id.push(s.id);
                payload.self.entita2_id.push(s.strutturas[0]['id']);
                payload.entita1_id.push(s.id);
                payload.isnew = true;
                payload.parent = {};
                payload.extra = {
                    idProrogaPrecedente: oldProrogaId
                };
                payload.eventoTipo_id = item.eventoTipo.id;
                payload.self.progetto_id = s.progetto_id;
                var oggi = new Date();
                //payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
                var extrasetup = JSON.parse(item.eventoTipo.extra);
                var openpopup = angular.isDefined(extrasetup.properties[stato]);
                //console.log("payload: ", payload);
                api.processi.processo.lavora(payload, function (response) {
                    if (response.status == 200) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Proroga richiesta correttamente !!')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        if (openpopup) {
                            //item.id = response.id;
                            api.eventos.evento.get({id: response.id}, function (r) {
                                var newitem = r;
                                //apri popoup per lavorazione
                                eventi.work("completa", newitem, stato, "completa", false);
                            });
                        } else {
                            $state.reload();
                        }
                    }
                });
            });

        }

        vm.letteraDialog = letteraDialog;
        function letteraDialog($event, letterainserimento) {

            api.beneficiarios.beneficiario.search({letteratrasferimento_id: letterainserimento}, function (d) {
                var segnalatos = d.data;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    //console.log("renderizzato", renderizzato);
                    //delete renderizzato["nota0"];
                    console.log("renderizzato", renderizzato);
                    var templater = rend.template.split("|");
                    //console.log("templater", templater);
                    //delete templater[0];
                    console.log("templater", templater);
                    var etichette = [];
                    etichette["ente1"] = "ente segnalatore/ente titolare auto";
                    etichette["ente2"] = "prefettura ente segnalatore/auto";
                    etichette["ente3"] = "ministero degli interni";
                    etichette["ente4"] = "ente titolare";
                    etichette["ente5"] = "ente gestore";
                    etichette["ente6"] = "prefettura ente titolare";
                    etichette["ente7"] = "ente titolare partenza";
                    etichette["ente8"] = "prefettura ente titolare partenza";
                    etichette["ente9"] = "ente gestore partenza";
                    etichette["nota1"] = "Nota dopo mittente";
                    etichette["nota2"] = "Nota dopo EPC";
                    etichette["nota3"] = "Oggetto";
                    etichette["nota4"] = "Nota dopo tabella";
                    etichette["nota5"] = "Note chiusura";
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'letteraDialogController',
                        controllerAs: 'vm',
                        focusOnOpen: false,
                        locals: {
                            segnalatos: segnalatos,
                            renderizzato: renderizzato,
                            templater: templater,
                            etichette: etichette,
                        },
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: event,
                        templateUrl: 'app/main/sprardb/eventi/dialogs/lettera-dialog.html',
                    }).then(function (renderizzatoresponse) {
                        api.letterainserimentors.letterainserimentor.aggiorna(renderizzatoresponse, function (s) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Lettera trasferimento modificata con successo!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    );
                        });
                    });
                });
            });
        }

    }

})();

(function ()
{
    'use strict';
    angular
            .module('app.sprardb.postlogin')
            .controller('PostloginController', PostloginController)
            .controller('Postlogin2Controller', Postlogin2Controller)
            .directive('datepickerValidationFix', datepickerValidationFix);
    function datepickerValidationFix() {
        return {
            restrict: 'A',
            require: 'mdDatepicker',
            link: function (scope, element, attrs, mdDatepickerCtrl) {
                // Fix to run validation when a datepicker's minDate changes
                // Bug #5938
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.minDate;
                }, function () {
                    if (mdDatepickerCtrl.dateUtil.isValidDate(mdDatepickerCtrl.date)) {
                        mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    }
                });
                // Fix to clear error state when setting date programatically from null
                // Bug #6086
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.date;
                }, function (newVal, oldVal) {

                    // if (newVal && !oldVal) {
                    mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    // }
                });
            }
        }
    }
    /** @ngInject */
    function PostloginController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast, $rootScope, $cookieStore, $cookies)
    {

        var vm = this;
        //sidenavs popolamento
        vm.api = api;
        ricerca.reloadCS();
        vm.options = ricerca.options;
        vm.options.rowSelection = false;
        vm.options.multiSelect = false;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.oggi = $filter('date')(new Date(), 'yyyy-MM-dd');

        vm.options2 = ricerca.options;
        vm.options2.rowSelection = false;
        vm.options2.multiSelect = false;
        vm.options2.autoSelect = false;
        vm.limitOptions2 = ricerca.limitOptions;

        vm.searched = false;
        vm.isRequired = [];

        vm.searched2 = false;
        //benef
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.operatore = "OR";
        //strutture
        vm.allsearchs2 = ricerca.begin_allsearchs();
        vm.allsearchs2.operatore = "AND";
        vm.colors = ricerca.colors;

        vm.ricerca = {};
//        vm.ricercaAggiuntiva = {};
        vm.ricercaS = {};
        vm.ricercaSAggiuntiva = {};
        vm.ricerca.operatore = "AND";
//        vm.ricercaAggiuntiva.operatore = "AND";
        vm.ricercaS.operatore = "AND";
//        vm.ricercaSAggiuntiva.operatore = "AND";
        vm.ricerca2 = "";
        vm.selected = [];
        vm.selected2 = [];
        vm.pidString = "";
        vm.pidIndice = 1;
        var oggi = new Date();
        vm.maxDate = new Date(oggi.getFullYear(),oggi.getMonth() , oggi.getDate());

        //vm.preselezione = 751;
        vm.autostart = true;


        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];

        vm.Strutture = null;
        vm.strutture = [];
        vm.links2 = [];
        vm.meta2 = [];
        vm.finito = false;

        vm.lista = [];
        vm.mostraAggiornati = false;
        vm.mostraAggiornati2 = false;
        vm.titolarita = [591, 592, 593, 596, 3001, 3002, 3003, 3004, 3005, 3006];
        vm.ricerca.tipoProtezione_id_IN = [590, 593, 597, 961, 962,0]; //Lorenzo: aggiunto 593(Titolare protezione umanitaria)
        vm.ricerca.dataUscita_IS = 'NULL';
//        vm.ricercaAggiuntiva.operatore = 'AND';
//        vm.ricercaAggiuntiva.tipoProtezione_id_IN = [594, 595];\
//        vm.ricercaAggiuntiva.dataUscita_IS = 'NULL';
//        vm.ricercaAggiuntiva.dataNascita = '<2000-10-31';


        vm.ricerca['stato_IN'] = "BENEFICIARIO,TERMINATO";

        vm.ricerca['postlogins-valido_fino'] = '<2020-11-30';
//        vm.ricercaAggiuntiva['stato_IN'] = "BENEFICIARIO,TERMINATO";
        if (!vm.mostraAggiornati) {
           // vm.ricerca['postlogin2s-id_IS'] = 'NULL';
//            vm.ricercaAggiuntiva['postlogin2s-id_IS'] = 'NULL';
        }

        vm.allsearchs.fields = "id,codice,cognome,nome,dataNascita,codNazionalita,def,nazionalita,sesso,stato,tipoProtezione_id,dataAvvenutaNotifica,protezioneTipo,struttura_id,progetto_id,postlogin2s";
        vm.bAggiornati = [];
        vm.baggiorna = [];
        vm.bconferma = [];
        vm.btrasferito = [];

        vm.mostraAggiornati2 = false;
        vm.ricercaS.attivo = 1;
        //vm.ricercaS.daattivare = 0;
        vm.ricercaS.esterna = 0;
        vm.allsearchs2.fields = "id,nome,attivo,daattivare,istats,progetto_id,strutturaAlloggio_id,strutturaAlloggios,progettos,s,postlogin3s,indirizzo,numeroPosti,codComune";
        vm.saggiorna = [];
        vm.sconferma = [];
        if (!vm.mostraAggiornati2) {
            vm.ricercaS['postlogin3s-id_IS'] = 'NULL';
        }


        vm.allsearchs['query[]'][1] = vm.ricerca;
//        vm.allsearchs['query[]'][2] = vm.ricercaAggiuntiva;
        vm.allsearchs2['query[]'][1] = vm.ricercaS;

        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();

        vm.istats = [];
        vm.caricaComuni = caricaComuni;

        api.istats.regioni.get({sort: "regione", pagination: -1}, function (response) {
            vm.regiones = response.data;
        });
        api.istats.province.get({pagination: -1, sort: "provincia"}, function (response) {
            vm.provincias = response.data;
        });
        api.strutturas.alloggio.search({pagination: -1, sort: "descrizione"}, function (d) {
            vm.alloggios = d.data;
        });


        function caricaComuni(codProv, indice) {
            if (codProv) {
                api.istats.istat.cerca({codProvincia: codProv, pagination: -1, sort: "comune"}, function (response) {
                    vm.istats[indice] = response.data;
                });
            }
        }




        vm.onSearch = onSearch;
        function onSearch() {
            console.log("1");
            var tiporicerca = "distinct";
            vm.ricerca['id_NOTIN'] = vm.id;
            //vm.ricerca['id'] = 'distinct';
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            //vm.allsearchs['query[]'][0]['postlogin2s-id_IS'] = 'NULL';
            //vm.allsearchs['query[]'][0]['postlogins-valido_fino'] = '2020-11-30';
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["codice"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["nome"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["cognome"] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }

            });
            if (!vm.mostraAggiornati) {
               // vm.ricerca['postlogin2s-id_IS'] = 'NULL';
//                vm.ricercaAggiuntiva['postlogin2s-id_IS'] = 'NULL';
            } else {
               // delete vm.ricerca['postlogin2s-id_IS'];
//                delete vm.ricercaAggiuntiva['postlogin2s-id_IS'];
            }
            vm.allsearchs['query[]'][1] = vm.ricerca;
//            vm.allsearchs['query[]'][2] = vm.ricercaAggiuntiva;
            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }

            if ($cookieStore.get('progetto_id')) {
                if ($cookieStore.get('progetto_id') != null) {
                    vm.preselezione = $cookieStore.get('progetto_id');
                }
            }
            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                vm.ricerca['progetto_id_IN'] = vm.preselezione.toString();
//                vm.ricercaAggiuntiva['progetto_id_IN'] = vm.preselezione.toString();
                vm.ricercaS['progetto_id_IN'] = vm.preselezione.toString();
            }

            vm.loadbeneficiarios(tiporicerca);
        }


        vm.loadbeneficiarios = function (tiporicerca) {
            $rootScope.loadingProgress = true;
            //console.log(vm.allsearchs);
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "distinct";

            }

            vm.searchParam = {
                sort: '-id',
                'per-page': vm.allsearchs['pagination'],
                page: vm.allsearchs['page']
            };

            api.beneficiarios.beneficiario.searchPostlogin(vm.searchParam).$promise.then(function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.searched = true;
                $rootScope.loadingProgress = false;
                vm.ts = null;
                vm.ts = [];
                vm.dataNotifica = null;
                vm.dataNotifica = [];
                vm.baggiorna = null;
                vm.bconferma = null;
                vm.btrasferito = null;
                vm.baggiorna = [];
                vm.bconferma = [];
                vm.btrasferito = [];
                var ii;
                for (ii = 0; ii < vm.allsearchs.pagination; ii++) {
                    vm.dataNotifica[ii] = vm.beneficiari[ii].dataAvvenutaNotifica? new Date(vm.beneficiari[ii].dataAvvenutaNotifica):null;
                    vm.ts[ii] = null;
                    vm.baggiorna[ii] = false;
                    vm.bconferma[ii] = true;
                    vm.btrasferito[ii] = true;
                    vm.isRequired[ii] = false;
                    if (vm.beneficiari[ii]) {
                        if (vm.beneficiari[ii].tipoProtezione_id == 0) {
                            vm.baggiorna[ii] = false;
                            vm.bconferma[ii] = false;
                            vm.btrasferito[ii] = true;
                        }
                    }

                }
                if (vm.meta == null && vm.meta2 == null) {
                    vm.finito = true;
                }
            }, function (response) {
            });

            //return vm.beneficiari;
        };
        vm.controllaOption = controllaOption;
        function controllaOption(protezioneIdB, protezioneId) {  // Lorenzo: Controlla stato finale in relazione con quello iniziale
            var esito = false;
            if (protezioneIdB != 0) {
                if (protezioneId == 597 || protezioneId == protezioneIdB || protezioneId == 962) {
                    esito = true;
                }
            } else {
                if (protezioneId == 597 || protezioneId == 962) {
                    esito = true;
                }
            }
            return esito;
        }



        vm.cambiaTs = cambiaTs;
        function cambiaTs(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = vm.dataNotifica[indice];
            var tipoProtezione_id = vm.ts[indice];

            if(vm.titolarita.indexOf(vm.ts[indice]) == -1){
                vm.dataNotifica[indice] = null;
            }else{
                vm.dataNotifica[indice] = dataNotifica;
            }

            if (beneficiario.tipoProtezione_id == tipoProtezione_id) {
                vm.baggiorna[indice] = false;
                vm.bconferma[indice] = true;
                vm.btrasferito[indice] = true;
                vm.isRequired[indice] = false;
                if (beneficiario.tipoProtezione_id == 0) {
                    vm.baggiorna[indice] = false;
                    vm.bconferma[indice] = false;
                    vm.btrasferito[indice] = false;
                    return 1;
                }
                return 1;
            }
            if (beneficiario.tipoProtezione_id != tipoProtezione_id) {

                vm.baggiorna[indice] = true;
                vm.bconferma[indice] = false;
                vm.btrasferito[indice] = false;
                if (vm.titolarita.indexOf(tipoProtezione_id) > -1){
                    vm.isRequired[indice] = true;
                }else{
                    vm.isRequired[indice] = false;
                }
                return 1;
            }

        }

        vm.confermaB = confermaB;
        vm.trasferitoB = trasferitoB;
        vm.aggiornaB = aggiornaB;
        function confermaB(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = vm.dataNotifica[indice];
            var tipoProtezione_id = vm.ts[indice];
            var pid = vm.beneficiari[indice].progetto_id;
            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'beneficiario';
            payload.pkId = beneficiario.id;
            payload.campo = 'tutti';
            payload.azione = 'C';
            payload.valido_fino = '2020-11-30';
            payload.vecchioValore = beneficiario.tipoProtezione_id.toString();
            payload.nuovoValore = beneficiario.tipoProtezione_id.toString();
            payload.progetto_id = pid;
            if (dataNotifica) {
                payload.dataNotifica = moment(dataNotifica).format('YYYY-MM-DD');
            }
            payload.azione = 'conferma';
            api.postlogins.postlogin.save(payload, function (c) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Beneficiario confermato')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
            });
            api.postlogins.postlogin.azione1(payload, function (a) {
            if (a['data'] != 'NO DATA'){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Aggiornata Data Notifica')
                            .position('bottom right')
                            .hideDelay(5000)
                    );
                }
                vm.onSearch();
            });
        }
        function trasferitoB(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = vm.dataNotifica[indice];
            var tipoProtezione_id = vm.ts[indice];
            var pid = vm.beneficiari[indice].progetto_id;
            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'beneficiario';
            payload.pkId = beneficiario.id;
            payload.campo = 'tipoProtezione_id';
            payload.azione = 'T';
            payload.valido_fino = '2020-11-30';
            payload.vecchioValore = beneficiario.tipoProtezione_id.toString();
            payload.nuovoValore = beneficiario.tipoProtezione_id.toString();
            payload.progetto_id = pid;
            api.postlogins.postlogin.save(payload, function (c) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati di soggiorno non modificati')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch();
            });
        }
        function aggiornaB(indice) {


            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = vm.dataNotifica[indice];
            var tipoProtezione_id = vm.ts[indice];
            var pid = vm.beneficiari[indice].progetto_id;
            var payload = {};
            if(vm.isRequired[indice] && !dataNotifica){
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Dati di soggiorno non modificati. Verificare la data inserita")
                        .position('top right')
                        .hideDelay(9000)
                );
                return;
            }
            payload.userId = api.user.id;
            payload.tabella = 'beneficiario';
            payload.pkId = beneficiario.id;
            payload.campo = 'tipoProtezione_id';
            payload.azione = 'A';
            payload.vecchioValore = beneficiario.tipoProtezione_id.toString();
            payload.nuovoValore = tipoProtezione_id.toString();
            payload.progetto_id = pid;
            payload.azione = 'aggiorna';
            if (dataNotifica) {
                payload.dataNotifica = moment(dataNotifica).format('YYYY-MM-DD');
            }
            api.postlogins.postlogin.azione1(payload, function (a) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Beneficiario aggiornato con successo')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch();
            });
        }

        vm.submitStepper = submitStepper;
        function submitStepper(event) {
            //console.log("stepper:", "eccolo");
            //console.log("vm.finito:", vm.finito);
            console.log("finito:", vm.finito);
            if (vm.finito == true) {
                api.users.user2.update({id: api.user.id, postlogin: 1}, function (u) {
                    $state.go('app.sprardb_notification');
                });
            } else {

                if (vm.finito == false) {
                    $state.go('app.sprardb_notification');
                }
            }
//vai da qualche parte

        }

        vm.onSearch2 = onSearch2;
        function onSearch2()
        {
            var tiporicerca = "search";
            vm.allsearchs2['query[]'] = [];
            vm.allsearchs2['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs2['query[]'][0].operatore = 'OR';
                vm.allsearchs2['query[]'][0]["codice"] = vm.ricerca2;
                vm.allsearchs2['query[]'][0]["nome"] = vm.ricerca2;
                vm.allsearchs2['query[]'][0]["cognome"] = vm.ricerca2;
            }

            angular.forEach(vm.ricercaS, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricercaS[key];
                }
                if (angular.isDate(value)) {
                    vm.ricercaS[key] = moment(value).format("YYYY-MM-DD");
                }

            });
            if (!vm.mostraAggiornati2) {
                vm.ricercaS['postlogin3s-id_IS'] = 'NULL';
            } else {
                delete vm.ricercaS['postlogin3s-id_IS'];
            }
            vm.allsearchs2['query[]'][1] = vm.ricercaS;
            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }

            if ($cookieStore.get('progetto_id')) {
                if ($cookieStore.get('progetto_id') != null) {
                    vm.preselezione = $cookieStore.get('progetto_id');
                }
            }
            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                vm.ricerca['progetto_id_IN'] = vm.preselezione.toString();
//                vm.ricercaAggiuntiva['progetto_id_IN'] = vm.preselezione.toString();
                vm.ricercaS['progetto_id_IN'] = vm.preselezione.toString();
            }

            vm.loadstrutturas(tiporicerca);
        }

        vm.loadstrutturas = function (tiporicerca) {
            $rootScope.loadingProgress = true;
            //console.log(vm.allsearchs2);
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "search";
            }

            api.strutturas.strutturamin[tr](vm.allsearchs2).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                vm.Strutture = response;
                vm.strutture = response.data;
                vm.links2 = response._links;
                vm.meta2 = response._meta;
                vm.searched2 = true;

                vm.regione = null;
                vm.regione = [];
                vm.provincia = null;
                vm.provincia = [];
                vm.comune = null;
                vm.comune = [];
                vm.ta = null;
                vm.ta = [];
                vm.indirizzo = null;
                vm.indirizzo = [];
                vm.np = null;
                vm.np = [];



                vm.saggiorna = null;
                vm.sconferma = null;
                vm.saggiorna = [];
                vm.sconferma = [];
                var ii;
                for (ii = 0; ii < vm.allsearchs2.pagination; ii++) {
                    vm.regione[ii] = null;
                    vm.provincia[ii] = null;
                    if (vm.strutture[ii]) {
                        if (vm.strutture[ii].codComune) {
                            vm.comune[ii] = vm.strutture[ii].codComune;
                        }
                        if (vm.strutture[ii].indirizzo) {
                            vm.indirizzo[ii] = vm.strutture[ii].indirizzo.trim();
                        }
                        vm.ta[ii] = vm.strutture[ii].strutturaAlloggio_id;
                        vm.np[ii] = vm.strutture[ii].numeroPosti;
                    }
                    vm.saggiorna[ii] = false;
                    vm.sconferma[ii] = false;


                }
                if (vm.meta == null && vm.meta2 == null) {
                    vm.finito = true;
                }

                //console.log(vm.strutture);
            }, function (response) {
                //console.log(response);
            });
            return vm.strutture;
        };

        vm.cambiaS = cambiaS;
        function cambiaS(indice) {
            vm.messaggio = "";
            var struttura = vm.strutture[indice];
            var regione = vm.regione[indice];
            var provincia = vm.provincia[indice];
            var comune = vm.comune[indice];
            var indirizzo = vm.indirizzo[indice];
            if (indirizzo) {
                indirizzo = vm.indirizzo[indice].trim();
            }
            var ta = vm.ta[indice];
            var np = vm.np[indice];
            var differenzaPosti = np - struttura.numeroPosti;
            var postiProgetto = struttura.progettos.postiTotali;
            var postiOccupati = 0;
            var exit = false;
            angular.forEach(vm.presentistrutture, function (o) {
                if (!exit) {
                    if (o.struttura_id == struttura.id) {
                        postiOccupati = o.occupati;
                        exit = true;
                    }
                }

            });


//            console.log("struttura", struttura);
//            console.log("comune", comune);
//            console.log("indirizzo", indirizzo);
//            console.log("ta", ta);
            var vcomune = true;
            var vindirizzo = true;
            var vta = true;
            var vnp = true;


            if (comune == "" || comune == null || comune == '000000' || angular.isUndefined(comune)) {
                vcomune = false;
//                console.log("vcomune:", vcomune);

            }
            if (indirizzo == "" || indirizzo == null || angular.isUndefined(indirizzo)) {
                vindirizzo = false;
//                console.log("vindirizzo:", vindirizzo);
            }
            if (ta == "" || ta == null || angular.isUndefined(ta)) {
                vta = false;
//                console.log("vta:", vta);
            }
//            if ((vm.statistiche.riepilogo[struttura.progettos.id].postiStrutturaTotali + differenzaPosti) > postiProgetto) {
//                vm.messaggio = "Numero di posti maggiori del limite: " + (vm.statistiche.riepilogo[struttura.progettos.id].postiStrutturaTotali + differenzaPosti).toString() + " su " + postiProgetto.toString();
//                vnp = false;
//            }
//            if (postiOccupati > np) {
//                vm.messaggio = "Numero di posti occupati maggiori: " + postiOccupati.toString() + " su " + np.toString();
//                vnp = false;
//            }
//            console.log("vnp:", vnp);

            if (vcomune && vindirizzo && vta && vnp) {
                vm.saggiorna[indice] = true;
                vm.sconferma[indice] = false;
                if (comune == struttura.codComune && indirizzo.trim() == struttura.indirizzo.trim() && ta == struttura.strutturaAlloggio_id && np == struttura.numeroPosti) {
                    vm.saggiorna[indice] = false;
                    vm.sconferma[indice] = true;
                }

            } else {
                vm.saggiorna[indice] = false;
                vm.sconferma[indice] = false;
            }


            return 1;

        }

        vm.confermaS = confermaS;
        vm.aggiornaS = aggiornaS;
        function confermaS(indice) {
            var struttura = vm.strutture[indice];
            var regione = vm.regione[indice];
            var provincia = vm.provincia[indice];
            var comune = vm.comune[indice];
            var indirizzo = vm.indirizzo[indice].trim();
            var pid = vm.strutture[indice].progetto_id;
            var ta = vm.ta[indice];
            var np = vm.np[indice];
            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'struttura';
            payload.pkId = struttura.id;
            payload.campo = 'tutti';
            payload.azione = 'C';
            payload.vecchioValore = "-";
            payload.nuovoValore = "-";
            payload.progetto_id = pid;
            api.postlogins.postlogin.save(payload, function (c) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Struttura confermata')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch2();
            });
        }

        function aggiornaS(indice) {


            var struttura = vm.strutture[indice];
            var regione = vm.regione[indice];
            var provincia = vm.provincia[indice];
            var comune = vm.comune[indice];
            var indirizzo = vm.indirizzo[indice].trim();
            var ta = vm.ta[indice];
            var np = vm.np[indice];
            var pid = vm.strutture[indice].progetto_id;

            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'struttura';
            payload.pkId = struttura.id;
            payload.progetto_id = pid;
            payload.nuovoValore = {codComune: comune, indirizzo: indirizzo, strutturaAlloggio_id: ta};
            payload.vecchioValore = {codComune: struttura.codComune, indirizzo: struttura.indirizzo, strutturaAlloggio_id: struttura.strutturaAlloggio_id};
            payload.azione = 'A';
            api.postlogins.postlogin.azione2(payload, function (a) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Struttura aggiornata con successo')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch2();
            });
        }

        //bootstrap
        if (api.loginPersonas.length == 0) {
            $cookies.remove('user');
            $cookies.remove('ente_id');
            $cookies.remove('progetto_id');
            $cookies.remove('ALL_p_id');
            $cookies.remove('ALL_s_id');
            $cookies.putObject('user', {autorizzato: 0});
            $state.go('app.sprardb_auth_login');
        }
        angular.forEach(api.loginPersonas, function (persona) {
            api.personas.hasprogetto.search({persona_id: persona.id, accessPermission: 1}, function (prog) {
                var temp = [];
                var ix = 1;
                angular.forEach(prog.data, function (p) {
                    if (temp.indexOf(p.progetto_id) == -1) {
                        temp.push(p.progetto_id);
                    }
//                    console.log("contatore IX", ix.toString() + ' di ' + prog.data.length);
                    if (ix == prog.data.length) {
                        vm.pidString = temp.toString();
//                        console.log("pidString", vm.pidString);
//                        console.log("contatore pidIndice", vm.pidIndice.toString() + ' di ' + api.loginPersonas.length);
                        if (vm.pidIndice == api.loginPersonas.length) {
                            //ultima iterazione
                            vm.preselezione = temp.toString();

                            console.log("vm.preselezione :", vm.preselezione);

                            api.strutturas.strutturamin.search({fields: "id,numeroPosti,progetto_id", progetto_id_IN: vm.preselezione.toString(), attivo: 1, esterna: 0, pagination: -1}, function (stat) {
                                vm.struttureStat = stat.data;
//            console.log(vm.struttureStat);
                                vm.statistiche = {};
                                vm.statistiche.data = angular.copy(vm.struttureStat);
                                vm.statistiche.riepilogo = [];
                                vm.occupati = [];
                                var indicest = 1;
                                angular.forEach(vm.struttureStat, function (obj) {
                                    if (!vm.statistiche.riepilogo[obj.progetto_id]) {
                                        vm.statistiche.riepilogo[obj.progetto_id] = {};
                                        vm.statistiche.riepilogo[obj.progetto_id].postiStrutturaTotali = 0;
                                        vm.statistiche.riepilogo[obj.progetto_id].postiOccupatiStruttura = [];
                                    }
                                    vm.statistiche.riepilogo[obj.progetto_id].postiStrutturaTotali = (vm.statistiche.riepilogo[obj.progetto_id].postiStrutturaTotali + obj.numeroPosti);

//                                    console.log("contatore indicest: ", indicest);
                                    if (indicest === vm.struttureStat.length) {
                                        api.strutturas.presenti.search({progetto_id_IN: vm.preselezione.toString(), pagination: -1}, function (stat) {
                                            vm.presentistrutture = stat.data;

                                            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                                                vm.ricerca['progetto_id_IN'] = vm.preselezione.toString();
//                                                vm.ricercaAggiuntiva['progetto_id_IN'] = vm.preselezione.toString();

                                                vm.ricercaS['progetto_id_IN'] = vm.preselezione.toString();
                                                vm.autostart = false;
                                            }
                                            //bootstrap
                                            vm.onSearch();
                                            vm.onSearch2();
                                        });
                                    }
                                    indicest++;
                                });

                            });

                        }
                    }


                    ix++;
                });
//                console.log("temp", temp.toString());
                vm.pidIndice++;
            });
//            console.log("indice: ", vm.pidIndice);
//            console.log("tot: ", api.loginPersonas.length);



        });




    }
    function Postlogin2Controller($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast, $rootScope, $cookieStore, $cookies)
    {


        var vm = this;
        //sidenavs popolamento
        vm.api = api;
        ricerca.reloadCS();
        vm.options = ricerca.options;
        vm.options.rowSelection = false;
        vm.options.multiSelect = false;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;

        vm.searched = false;

        vm.searched2 = false;
        //benef
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.operatore = "OR";

        vm.colors = ricerca.colors;

        vm.ricerca = {};
//        vm.ricercaAggiuntiva = {};
        vm.ricercaSAggiuntiva = {};
        vm.ricerca.operatore = "AND";
        vm.selected = [];
        vm.pidString = "";
        vm.pidIndice = 1;

        vm.arraynstatus = {tipo: [1999], stato: [1]};
        vm.nsg = {
            entita1_id: vm.beneficiario_id,
            eventoFiltro: {crea: 1, id_IN: vm.arraynstatus.tipo.join(), sort: "nome"},
            titolo: "Nuova Tipologia Soggiorno",
            numeroEventi: vm.arraynstatus.tipo.length
        };

        //vm.preselezione = 751;
        vm.autostart = true;


        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];

        vm.finito = false;

        vm.lista = [];
        vm.mostraAggiornati = false;
        vm.titolarita = [591, 592, 593];
        vm.ricerca.tipoProtezione_id_IN = [590, 594, 595, 597, 961, 962, 0, 3006];
        vm.ricerca.dataUscita_IS = 'NULL';

        vm.ricerca['stato_IN'] = "BENEFICIARIO,TERMINATO";
//        vm.ricercaAggiuntiva['stato_IN'] = "BENEFICIARIO,TERMINATO";
        if (!vm.mostraAggiornati) {
            //vm.ricerca['postlogin2s-id_IS'] = 'NULL';
//            vm.ricercaAggiuntiva['postlogin2s-id_IS'] = 'NULL';
        }

        vm.allsearchs.fields = "id,codice,cognome,nome,dataNascita,codNazionalita,def,nazionalita,sesso,stato,tipoProtezione_id,protezioneTipo,struttura_id,progetto_id";
        vm.bAggiornati = [];
        vm.baggiorna = [];
        vm.bconferma = [];
        vm.btrasferito = [];

        vm.allsearchs['query[]'][1] = vm.ricerca;

        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();



        vm.onSearch = onSearch;
        function onSearch() {
            console.log("1");
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["codice"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["nome"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["cognome"] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }

            });
            if (!vm.mostraAggiornati) {
                //vm.ricerca['postlogin2s-id_IS'] = 'NULL';
//                vm.ricercaAggiuntiva['postlogin2s-id_IS'] = 'NULL';
            } else {
               // delete vm.ricerca['postlogin2s-id_IS'];
//                delete vm.ricercaAggiuntiva['postlogin2s-id_IS'];
            }
            vm.allsearchs['query[]'][1] = vm.ricerca;
//            vm.allsearchs['query[]'][2] = vm.ricercaAggiuntiva;
            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }

            if ($cookieStore.get('progetto_id')) {
                if ($cookieStore.get('progetto_id') != null) {
                    vm.preselezione = $cookieStore.get('progetto_id');
                }
            }
            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                vm.ricerca['progetto_id_IN'] = vm.preselezione.toString();
//                vm.ricercaAggiuntiva['progetto_id_IN'] = vm.preselezione.toString();
                vm.ricercaS['progetto_id_IN'] = vm.preselezione.toString();
            }

            vm.loadbeneficiarios(tiporicerca);
        }


        vm.loadbeneficiarios = function (tiporicerca) {
            $rootScope.loadingProgress = true;
            //console.log(vm.allsearchs);
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "search";
            }

            api.beneficiarios.beneficiario[tr](vm.allsearchs).$promise.then(function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.searched = true;
                $rootScope.loadingProgress = false;
                vm.ts = null;
                vm.ts = [];
                vm.dataNotifica = null;
                vm.dataNotifica = [];
                vm.baggiorna = null;
                vm.bconferma = null;
                vm.btrasferito = null;
                vm.baggiorna = [];
                vm.bconferma = [];
                vm.btrasferito = [];
                vm.nsg = [];
                var ii;
                for (ii = 0; ii < vm.allsearchs.pagination; ii++) {
                    vm.dataNotifica[ii] = null;
                    vm.ts[ii] = null;
                    vm.baggiorna[ii] = false;
                    vm.bconferma[ii] = true;
                    vm.btrasferito[ii] = true;
                    if (vm.beneficiari[ii]) {
                        if (vm.beneficiari[ii].tipoProtezione_id == 0) {
                            vm.baggiorna[ii] = false;
                            vm.bconferma[ii] = false;
                            vm.btrasferito[ii] = false;
                        }
                    }
                    vm.nsg[ii] = {
                        entita1_id: vm.beneficiari[ii].id,
                        eventoFiltro: {crea: 1, id_IN: vm.arraynstatus.tipo.join(), sort: "nome"},
                        titolo: "Aggiorna Tipologia Soggiorno",
                        numeroEventi: vm.arraynstatus.tipo.length
                    };

                }
                if (vm.meta == null) {
                    vm.finito = true;
                }
                //console.log(vm.beneficiari);
            }, function (response) {
                //console.log(response);
            });
            //return vm.beneficiari;
        };

        onSearch();

        vm.controllaOption = controllaOption;
        function controllaOption(protezioneIdB, protezioneId) {
            var esito = false;
            if (protezioneIdB != 0) {
                if (protezioneId == 597 || protezioneId == protezioneIdB || protezioneId == 962) {
                    esito = true;
                }
            } else {
                if (protezioneId == 597 || protezioneId == 962) {
                    esito = true;
                }
            }
            return esito;
        }



        vm.cambiaTs = cambiaTs;
        function cambiaTs(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = vm.dataNotifica[indice];
            var tipoProtezione_id = vm.ts[indice];


            if (beneficiario.tipoProtezione_id == tipoProtezione_id) {
                vm.baggiorna[indice] = false;
                vm.bconferma[indice] = true;
                vm.btrasferito[indice] = true;
                if (beneficiario.tipoProtezione_id == 0) {
                    vm.baggiorna[indice] = false;
                    vm.bconferma[indice] = false;
                    vm.btrasferito[indice] = false;
                    return 1;
                }
                return 1;
            }
            if (beneficiario.tipoProtezione_id != tipoProtezione_id) {

                vm.baggiorna[indice] = true;
                vm.bconferma[indice] = false;
                vm.btrasferito[indice] = false;
                if (vm.titolarita.indexOf(tipoProtezione_id) > -1 && !dataNotifica) {
                    vm.baggiorna[indice] = false;
                }

                return 1;
            }

        }

        vm.confermaB = confermaB;
        vm.trasferitoB = trasferitoB;
        function confermaB(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = '-';
            var tipoProtezione_id = vm.beneficiari[indice].tipoProtezione_id;
            var pid = vm.beneficiari[indice].progetto_id;
            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'beneficiario';
            payload.pkId = beneficiario.id;
            payload.campo = 'tutti';
            payload.azione = 'C';
            payload.vecchioValore = beneficiario.tipoProtezione_id.toString();
            payload.nuovoValore = beneficiario.tipoProtezione_id.toString();
            payload.progetto_id = pid;
            payload.job = 1;
            api.postlogins.postlogin.save(payload, function (c) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Beneficiario confermato')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch();
            });
        }
        function trasferitoB(indice) {
            var beneficiario = vm.beneficiari[indice];
            var dataNotifica = '-';
            var tipoProtezione_id = vm.beneficiari[indice].tipoProtezione_id;
            var pid = vm.beneficiari[indice].progetto_id;
            var payload = {};
            payload.userId = api.user.id;
            payload.tabella = 'beneficiario';
            payload.pkId = beneficiario.id;
            payload.campo = 'tipoProtezione_id';
            payload.azione = 'T';
            payload.vecchioValore = beneficiario.tipoProtezione_id.toString();
            payload.nuovoValore = beneficiario.tipoProtezione_id.toString();
            payload.progetto_id = pid;
            payload.job = 1;
            api.postlogins.postlogin.save(payload, function (c) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Beneficiario segnato come trasferito')
                        .position('bottom right')
                        .hideDelay(3000)
                        );
                vm.onSearch();
            });
        }


        vm.submitStepper = submitStepper;
        function submitStepper(event) {
            //console.log("stepper:", "eccolo");
            //console.log("vm.finito:", vm.finito);
            console.log("finito:", vm.finito);
            if (vm.finito == true) {
                api.users.user2.update({id: api.user.id, postlogin: 1}, function (u) {
                    $state.go('app.sprardb_notification');
                });
            } else {

                if (vm.finito == false) {
                    $state.go('app.sprardb_notification');
                }
            }
//vai da qualche parte

        }

    }


})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas2')
            .controller('Personas2Controller', Personas2Controller);


    /** @ngInject */
    function Personas2Controller($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        vm.isReadOnly = api.isReadOnly;
        //sidenavs popolamento
        console.log($state.params);
        vm.api = api;
        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "personahasprogettos-personaRuolo_id_IN": {
                type: "string",
                title: "Ruolo nel progetto",
                description: "Ruolo nel progetto...",
                callbackModel: "ricerca",
                dbfield: "personahasprogettos-personaRuolo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.personaruoloprogettos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personahasprogettos-personaRuolo_id": {
                type: "string",
                title: "Ambito nel progetto",
                description: "Ambito nel progetto",
                callbackModel: "ricerca",
                dbfield: "personahasprogettos-personaRuolo_id",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.personaruoloambitos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personahasentes-personaRuolo_id": {
                type: "string",
                title: "Incarico nell'ente",
                description: "Incarico nell'ente",
                callbackModel: "ricerca",
                dbfield: "personahasentes-personaRuolo_id",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.personaruoloentes",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-id": {
                type: "string",
                title: "Con progetti",
                description: "Con progetti...",
                callbackModel: "ricerca",
                dbfield: "progettos-id_IS",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tags-id": {
                type: "string",
                title: "Tags",
                description: "Con tags...",
                callbackModel: "ricerca",
                dbfield: "tags-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.tags",
                chiave: "id",
                valore: "tag|uppercase"
            },
            "tags-tag": {
                type: "string",
                title: "Lista distribuzione",
                description: "In lista...",
                callbackModel: "ricerca",
                dbfield: "tags-tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            },
            "codiceFiscale_LIKE": {
                type: "string",
                title: "Codice Fiscale",
                description: "Codice Fiscale",
                callbackModel: "ricerca",
                dbfield: "codiceFiscale_LIKE",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "users-status": {
                type: "string",
                title: "Profilo utente",
                description: "Profilo utente...",
                callbackModel: "ricerca",
                dbfield: "users-status",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.profilostatus",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;
        vm.profilostatus = [
            {id: 0, descrizione: "Disattivo"},
            {id: 10, descrizione: "Attivo"}
        ];

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.ricercaApi = ricerca;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
//            console.log(vm.allsearchs);
//            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
//                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
//            }
//            console.log(vm.allsearchs);
            api.personas.persona3.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listapersona"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 1000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.personas.persona3.search(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }
        ;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_personasdettaglio2', {id: obj});

        }


        function onSearch() {




            var tiporicerca = 'search';
            //nome
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.allsearchs['query[]'][1] = {};
            vm.allsearchs['query[]'][1]['operatore'] = 'AND';
            //vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
            if (vm.ricerca2) {
                tiporicerca = 'like';
                vm.allsearchs['query[]'][0].operatore = 'AND';
                vm.allsearchs['query[]'][0]['nome'] = vm.ricerca2.nome;
                vm.allsearchs['query[]'][0]['cognome'] = vm.ricerca2.cognome;
                vm.allsearchs['query[]'][0]['email'] = vm.ricerca2.email;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            if (tiporicerca == 'like') {
                api.personas.persona3.like(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            } else {
                api.personas.persona3.search(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            }

            vm.searched = true;

        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }


})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.personas')
            .controller('PersonasController', PersonasController)
            .controller('DettaglioPController', DettaglioPController);

    /** @ngInject */
    function PersonasController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);

        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "personahasprogettos-personaRuolo_id_IN": {
                type: "string",
                title: "Ruolo",
                description: "Ruolo...",
                callbackModel: "ricerca",
                dbfield: "personahasprogettos-personaRuolo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.enteruolos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-id": {
                type: "string",
                title: "Con progetti",
                description: "Con progetti...",
                callbackModel: "ricerca",
                dbfield: "progettos-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tags-id": {
                type: "string",
                title: "Tags",
                description: "Con tags...",
                callbackModel: "ricerca",
                dbfield: "tags-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tags",
                chiave: "id",
                valore: "tag|uppercase"
            },
            "tags-tag": {
                type: "string",
                title: "Lista distribuzione",
                description: "In lista...",
                callbackModel: "ricerca",
                dbfield: "tags-tag",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.lista",
                chiave: "tag",
                valore: "tag|uppercase"
            }

        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        vm.entetipos = ricerca.enteprimosettores;
        vm.regiones = ricerca.regiones;
        vm.enteruolos = ricerca.personaruoloprogettos;
        vm.provincias = ricerca.provincias;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
//            console.log(vm.allsearchs);
//            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
//                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
//            }
//            console.log(vm.allsearchs);
            api.personas.persona.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listapersona"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.valuesearched = valuesearched;
        vm.deletefiltersearch = deletefiltersearch;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.toggleSelect = toggleSelect;
        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.personas.persona.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }
        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }
        ;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_personasdettaglio', {id: obj});

        }


        function onSearch() {

            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }

            api.personas.persona.like(vm.allsearchs, function (d) {
                //console.log(d);
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

    function DettaglioPController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;
        vm.id = $state.params.id;
        vm.isnew = false;
        if (vm.id == '0') {
            vm.isnew = true;
        }
        console.log(vm.isnew);
        vm.evento = "update";
        vm.loadpersona = function () {
            var Persona = {};
            api.personas.persona.get({id: vm.id}).$promise.then(function (response) {
                Persona = response;
                vm.contact = angular.copy(Persona);
                if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
                    vm.caricaProvince(vm.contact.codRegione);
                }
                if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
                    vm.caricaComuni(vm.contact.codProvincia);
                }
            }, function (response) {
            });
            return Persona;
        };
        vm.loadpersona();




        vm.provincias = [];
        vm.istats = [];
        //vm.tags = Tags.data;
        api.tags.tag.cerca({pagination: 50, sort: "tag", tipo: "generico"}, function (response) {
            vm.tags = response.data;
        });

        vm.provincias2 = [];
        vm.istats2 = [];
        vm.regiones = null;
        vm.regiones2 = null;

        api.istats.regioni.get({}, function (response) {
            vm.regiones = response.data;
            vm.regiones2 = response.data;
        });
        vm.personaruolos = null;
        api.personaruolos.personaruolo.get({}, function (response) {
            vm.personaruolos = response.data;
        });

        vm.nazioni = null;

        api.beneficiarioattributis.beneficiarioattributi.cerca({gruppo: "NAZIONE", pagination: 200}, function (response) {
            vm.nazioni = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        });






        if (!vm.contact)
        {
            vm.evento = "new";
            vm.contact = {
                id: null,
                nome: null,
                cognome: null,
                sesso: null,
                codRegione: null,
                codProvincia: null,
                codComune: null,
                indirizzo: null,
                cap: null,
                email: null,
                telefono: null,
                dataNascita: "2013-08-08",
                dataNascita2: null,
                codComuneNascita: null,
                codNazionalita: null,
                codiceFiscale: null,
                tags: [],
                progettos: [],
                entes: [],
                ruolos: [],
                personahasprogettos: [],
                personahasentes: []
            };
            vm.title = 'Nuovo Contatto';
            vm.newContact = true;
            vm.contact.tags = [];

        }

        vm.contact.dataNascita2 = new Date(vm.contact.dataNascita);
        vm.contact2 = {
            'codRegione': null,
            'codProvincia': null,
            'codComune': null,
            'codComuneNascita': null,
        };


// Methods
        vm.caricaComuni = caricaComuni;
        vm.caricaProvince = caricaProvince;
        vm.caricaComuni2 = caricaComuni2;
        vm.caricaProvince2 = caricaProvince2;
        vm.gotoPersona = gotoPersona;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.gotoProgetto = gotoProgetto;
        vm.gotoEnte = gotoEnte;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;
        vm.openEntiDialog = openEntiDialog;



        vm.ruolitotali = vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasentes.length;
        if (vm.contact.codRegione !== null || vm.contact.codRegione !== '') {
            vm.caricaProvince(vm.contact.codRegione);
        }
        if (vm.contact.codProvincia !== null || vm.contact.codProvincia !== '') {
            vm.caricaComuni(vm.contact.codProvincia);
        }
        if (!angular.isUndefined(vm.contact.nascita)) {
            if (vm.contact.nascita !== null) {
                vm.caricaProvince2(vm.contact.nascita.codRegione);
                vm.caricaComuni2(vm.contact.nascita.codProvincia);
            }
        }


        console.log('isnew:' + vm.isnew);
        console.log('contact:');
        console.log(vm.contact);
        console.log('contact.tags:');
        console.log(vm.contact.tags);




        ////////////////////////////////////////////////

        function caricaComuni(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats = {};
            });
        }



        function caricaComuni2(codprovincia) {
            api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
                vm.istats2 = response.data;
                //vm.contact.codComune = null;
            });
        }
        function caricaProvince2(codregione) {
            api.istats.province.get({codRegione: codregione}, function (response) {
                vm.provincias2 = response.data;
                //vm.contact.codProvincia = null;
                //vm.contact.codComune = null;
                vm.istats2 = {};
            });
        }









        /**
         * Save contact
         */
        function saveContact()
        {

            console.log('isnew:' + vm.isnew);
            console.log('contact:');
            console.log(vm.contact);
            console.log('contact.tags:');
            console.log(vm.contact.tags);


            var m = moment(vm.contact.dataNascita2);
            vm.contact.dataNascita = m.format("YYYY-MM-DD");
            if (vm.isnew) {
                api.personas.persona.save(vm.contact, function (response) {
                    var contact_id = response.id;
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: response.id, tag_id: obj.id});
                    });
                    //
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: contact_id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload,
                        delete: false
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            console.log(response);
                            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                        });
                    } else {
                        $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: contact_id});
                    }
                });
            }
            if (!vm.isnew) {
                api.personas.persona.aggiorna(vm.contact, function (response) {
                    console.log(response);
                    var payload = [];
                    angular.forEach(vm.contact.tags, function (obj) {
                        payload.push({persona_id: vm.contact.id, tag_id: obj.id});
                    });
                    //delete: false,
                    var hasmany = {
                        modelrelation: 'Personahastag',
                        idname: 'persona_id',
                        idvalue: vm.contact.id,
                        idnamefk: 'tag_id',
                        idnamePayload: 'tag_id',
                        payload: payload
                    };
                    if (payload.length > 0) {
                        api.personas.persona.hasmany(hasmany, function (response) {
                            $state.reload();
                        });
                    } else {
                        $state.reload();
                    }
                });
            }
        }

        /**
         * Delete Contact Dialog
         */

        function gotoPersona() {
            $state.go('app.sprardb_contatti');
        }

        function gotoProgetto(id)
        {
            $state.go('app.sprardb_progetti_progetti_progetto', {id: id});
        }


        function gotoEnte(id)
        {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: id});
        }

        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + vm.contact.nome + ' ' + vm.contact.cognome + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                api.personas.persona.remove({id: contact.id}, function (response) {
                    $state.reload();
                    closeDialog();
                    gotoPersona();
                });

            });

        }


        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

        vm.tempruolo = null;
        vm.tempentetipo = null;
        function openEntiDialog(ev, item, index, newlink) {
            api.personaruolos.personaruolo.cerca({gruppo: 'ENTE'}, function (response) {
                vm.tempruolo = response;
                console.log(vm.tempruolo);
                api.entetipos.entetipo.cerca({pagination: 50}, function (response) {
                    vm.tempentetipo = response;
                    console.log(vm.tempentetipo);
                    $mdDialog.show({
                        controller: 'DialogEnti2Controller',
                        controllerAs: 'vmd',
                        templateUrl: 'app/main/sprardb/form/dialogEntiForm.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        locals: {
                            AllRuolo: vm.tempruolo,
                            AllEnteTipo: vm.tempentetipo,
                            Persona: item,
                            index: index,
                            Regioni: vm.regiones,
                            newlink: newlink
                        }
                    });
                });

            });
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.selectedItem = null;
        vm.searchText = null;
        vm.selectedItem2 = null;
        vm.searchText2 = null;
        vm.selectedItem3 = null;
        vm.searchText3 = null;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for vegetables.
         */
        function querySearch(query, obj, nomecampo) {
            var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
            return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query, nomecampo) {
            //var lowercaseQuery = angular.lowercase(query);

            return function filterFn(collection) {
                return (collection[nomecampo].indexOf(query) === 0);
            };

        }


    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.notification')
            .controller('oooSegnalatoriController', oooSegnalatoriController);

    /** @ngInject */
    function oooSegnalatoriController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api)
    {

        var vm = this;

        // Data
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.loadentes = function () {
            api.entes.ente.search({segnalatore: 1}).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.get().$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);
        vm.ricerca = {};
        vm.entetipos = null;
        vm.regiones = null;
        api.entetipos.entetipo.get({}, function (response) {
            vm.entetipos = response.data;
        });
        api.istats.istat.distinct({regione: 'distinct'}, function (response) {
            vm.regiones = response.data;
        });

        vm.gotoDettaglio = gotoDettaglio;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: obj});

        }
        vm.ricerca2 = {};
        vm.searched = false;
        vm.search2 = "";
        vm.mostraitag = false;

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.ricercalabel = {
            'bandos-id': 'Bando: ',
            'bandos-dataFine': 'Anno Bando: ',
            'istats-regione': 'Regione: ',
            'postiLiberi': 'Posti liberi: ',
            'attivo': 'Progetto attivo: ',
            'tags-id': 'Tag: ',
            'progettos-id': 'Progetti: ',
            'strutturas-id': 'Strutture: ',
            'personas-id': 'Persone: ',
            'entes-id': 'Enti: ',
            'enteTipo_id': 'Tipo di ente: '
        };
        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        //vm.getEntes = getEntes;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.orderby = orderby;
        vm.searchServerNome = searchServerNome;
        vm.searchEmpty = searchEmpty;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.entes.ente.search({sort: order + field, segnalatore: 1}, function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['nome'] = string;
            //vm.ricerca2['istats-comune'] = string;
            vm.ricerca2['operatore'] = 'AND';
            vm.ricerca2['segnalatore'] = '1';
            api.entes.ente.like(vm.ricerca2, function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.entes.ente.search({segnalatore: 1}, function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        function searchServer() {
            vm.ricerca['segnalatore'] = '1';
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.entes.ente.like(vm.ricerca, function (response) {
                    vm.entes = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.entes.ente.search({segnalatore: 1}, function (response) {
                    vm.entes = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }

        function searchServer2() {
            vm.ricerca['segnalatore'] = '1';
            vm.ricerca.descrizione = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.entes.ente.like(vm.ricerca, function (response) {
                    vm.entes = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.entes.ente.search({segnalatore: 1}, function (response) {
                    vm.entes = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }


//        function getEntes() {
//            //$rootScope.loadingProgress = true;
//            msApi.register('entes.entes',
//                    ['http://localhost/sprardb/app-server/web/entes',
//                        {segnalatore: 1},
//                        {'get': {method: 'GET'}}
//                    ]
//                    );
//            msApi.resolve('entes.entes@get').then(function (d) {
//                vm.entes = d.data;
//            });
//        }
//
//
//        getEntes();


        function pagerNext(uri) {
            msApi.register('entes.next', [uri]);
            msApi.resolve('entes.next@get').then(function (d) {
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('entes.prev', [uri]);
            msApi.resolve('entes.prev@get').then(function (d) {
                vm.entes = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function ()
{
    'use strict';
    angular
            .module('app.sprardb.notification')
            .controller('NotificationController', NotificationController)
            .controller('RsegnalatiController', RsegnalatiController)
            .controller('ParentelasDialogController', ParentelasDialogController);
    function NotificationController($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, msApi, api, $http, $base64, $mdToast, $filter, eventi, acl, ricerca, $cookieStore) {

        var vm = this;
        acl.reload();
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.params = $state.params;
        vm.paramsdata = $state.current.datas;
        vm.title = vm.paramsdata.title;
        vm.searchForms = {
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "entes-enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "Ente Tipo",
                callbackModel: "ricerca",
                dbfield: "entes-enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "eventos-eventoStato_id": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventos-eventoStato_id",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            },
            "idTipoSegnalazione_IN": {
                type: "string",
                title: "Modello Segnalazione",
                description: "Modello Segnalazione",
                callbackModel: "ricerca",
                dbfield: "idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tiposegnalazione",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "data>": {
                type: "string",
                title: "Da Data",
                description: "Da data",
                callbackModel: "ricerca",
                dbfield: "data>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()",
            },
            "data<": {
                type: "string",
                title: "A Data",
                description: "a data",
                callbackModel: "ricerca",
                dbfield: "data<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()",
            }

        };

        vm.tipologie = $state.current.datas.tipologie;

        vm.controlla = 5;
        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];
            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];
            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }


        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.progettosa = ricerca.progettos;
        vm.nazioneb = ricerca.naziones;
        api.segnalaziones.segnalazione.tipologieSegnalazione({},function (res) {
          vm.tiposegnalazione = res.data;
        });
        // vm.tipoasegnalazione = ricerca.tipoasegnalazione;
        //vm.tipoall =
        vm.sino = ricerca.sino;
        vm.ente1 = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        vm.entetipos = angular.copy(ricerca.enteprimosettores);
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        });
        //angular.extend(vm.entetipos, vm.ente3);
        //vm.statoeventos = ricerca.segnalazionestatoeventos;
        vm.statoeventos = [{
                id: '<0',
                stato: 'BOZZA',
                iniziali: 'BO'
            },
            {
                id: '>0',
                stato: 'INVIATO',
                iniziali: 'I'
            }
        ];
        vm.baseUrl = api.baseUrl;
        vm.nazioni = null;
        vm.documentotipo = null;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();
        vm.enterilascio = function () {
            api.entes.ente.search({enteTipo_id: 7, sort: 'nome', pagination: "200", fields: "id,nome"}).$promise.then(function (response) {
                vm.enterilascios = response.data;
            }, function (response) {
                console.log('Ente rilascio caricata');
            });
        };
        vm.enterilascio();
        vm.autoinsert = false;
        if (angular.isDefined($state.current.datas)) {
            if ($state.current.datas.autoinsert === 'true' || $state.current.datas.autoinsert === true) {
                vm.autoinsert = true;
            }
        }
        var user = $cookies.getObject('user');
        var authorization = $base64.encode(user.access_token + ':');
        vm.persona = {};
        vm.persona = angular.copy(user);
        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        vm.selected = [];
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.query = {
            sort: '-id',
            perPage: 5,
            page: 1
        };
        vm.search = null;
        vm.limitOptions = [5, 10, 15];
//        vm.apiUrl = 'http://localhost/sprardb/app-server/web/segnalaziones';
//        vm.apiRequest = {
//            method: 'GET',
//            url: vm.apiUrl,
//            params: {'sort': vm.query.sort, 'per-page': vm.query.perPage, 'page': vm.query.page},
//            headers: {
//                'Authorization': 'Basic ' + authorization
//            }
//        }
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND', idTipoSegnalazione_IN: vm.tipologie};

        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 15;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;
        vm.preselezione = $cookieStore.get('ente_id');
        if (vm.autoinsert) {
            vm.preselezione = $cookieStore.get('progetto_id');
        }
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            if (vm.autoinsert) {
                vm.allsearchs['query[]'][1].progetto_id = vm.preselezione.toString();
            } else {
                vm.allsearchs['query[]'][1].ente_id = vm.preselezione.toString();
            }
        }
        vm.notifications = [];
        vm.links = [];
        vm.meta = [];
        vm.colors = ricerca.colors;
        vm.scolors = ricerca.scolors;
        vm.ricerca = {
            'bandos-id': null,
            'bandos-dataFine': null,
            'istats-regione': null,
            'postiLiberi': null,
            'attivo': null,
            'tags-id': null
        };
        vm.ricercalabel = {
            'ente_id': 'Ente: ',
            'eventos-eventoStato_id': 'Stato: ',
            'tipo': 'Modello: ',
        };
        vm.ricerca2 = "";
        vm.searched = false;
        vm.loadnotifications = function () {
            vm.allsearchs.expand = 'entes, personas, segnalatos, eventos, progettos'
            api.segnalaziones.segnalazione.search(vm.allsearchs).$promise.then(function (response) {
                vm.notifications = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.notifications;
        };
        vm.loadnotifications();
        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            console.log(vm.ricerca2);
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]['segnalati-nome'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['segnalati-cognome'] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            if (vm.ricerca) {
              vm.ricerca.operatore = 'AND';
              if (angular.isUndefined(vm.ricerca['idTipoSegnalazione_IN'])) {
                vm.ricerca['idTipoSegnalazione_IN'] = "605,606,607,608,609,610";
                if (vm.autoinsert) {
                  vm.ricerca['idTipoSegnalazione_IN'] = vm.tipologie;
                }
              }
              vm.allsearchs['query[]'][1] = vm.ricerca;
            }


            vm.allsearchs.expand = 'entes, personas, segnalatos, eventos, progettos';
            if (vm.ricerca2) {
                //se inserita ricerca testuale allora LIKE
                api.segnalaziones.segnalazione.like(vm.allsearchs, function (d) {
                    vm.Notifications = d;
                    vm.notifications = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            } else {
                api.segnalaziones.segnalazione.search(vm.allsearchs, function (d) {
                    vm.Notifications = d;
                    vm.notifications = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            }
            vm.searched = true;
        }

//#####################################################################
        vm.editPerson = function (event) {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaEditController',
                controllerAs: 'vm',
                focusOnOpen: false,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {notification: vm.selected},
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/edit-dialog.html',
            }).then(function (res) {
                if (res !== undefined) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Segnalazione modificata con successo!')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    getNotifications();
                }
            });
        };
        vm.toggleLimitOptions = function () {
            vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 15];
        };
        vm.getTypes = function () {
            return ['Candy', 'Ice cream', 'Other', 'Pastry'];
        };
        vm.onPaginate = function (page, perPage) {
            vm.promise = $timeout(function () {
                if (vm.search === null || vm.search === '') {
                    vm.apiRequest.params = {'sort': vm.query.sort, 'per-page': perPage, 'page': page}
                    vm.promise = $http(vm.apiRequest).success(success).$promise;
                    console.log(vm.promise);
                }
            }, 2000);
        };
        vm.deselect = function (item) {
            console.log(item.id, 'was deselected');
        };
        vm.segnalatos = null;
        vm.log = function (item) {
            vm.segnalatos = item.segnalatos;
            console.log(item.id, 'was selected');
        };
        vm.loadStuff = function () {
            vm.promise = $timeout(function () {
                vm.promise = $http(vm.apiRequest).success(success).$promise;
            }, 2000);
        };
        vm.onReorder = function (sort) {
            vm.promise = $timeout(function () {

            }, 2000);
        };
        vm.states = function () {
            api.eventos.stato.get({}).$promise.then(function (response) {
                //vm.state = response.data;
                var temp = angular.copy(response.data);
                var tempnew = [];
                angular.forEach(temp, function (t) {
                    if (t.id === -1) {
                        tempnew.push(t);
                    } else {
                        var linetemp = {};
                        linetemp.id = t.id;
                        linetemp.stato = 'INVIATO';
                        linetemp.iniziali = 'I';
                        tempnew.push(linetemp);
                    }
                });
                vm.state = tempnew;
            }, function (response) {
                console.log(response);
            });
        };
        vm.states();
        vm.segnalats = function () {
            api.entes.ente.search({segnalatore: 1, fields: 'id,nome'}).$promise.then(function (response) {
                vm.segnalat = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.segnalats();
        vm.viewDetails = viewDetails;
        function viewDetails(event, id) {
            if (!vm.autoinsert) {
                $state.go('app.sprardb_notification.editreport', {id: id});
            }
            if (vm.autoinsert) {
                $state.go('app.sprardb_notification.editareport', {id: id});
            }
        }

        vm.trashSegn = function (index, notification) {

            vm.progress = true;
            var confirm = $mdDialog.confirm()
                    .title('Cancellazione')
                    .textContent('Vuoi cancellare la segnalazione?')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (angular.isUndefined(notification.id)) {
                    vm.progress = false;
                    return;
                }

                var segnalati = notification.segnalatos;

            	var segnalatosCtrl = 0;

            	for (var i=0; i<segnalati.length; i++){
            		if(segnalati[i].beneficiario_id !=0 ){
            			segnalatosCtrl ++;
            		}
            	}

                // if(segnalatosCtrl==0){

	            	api.segnalaziones.segnalazione.rimuovisegnalazione({id: notification.id}, function (u) {
	            		$mdToast.show(
		                        $mdToast.simple()
		                        .textContent('Segnalazione cancellata!!')
		                        .position('bottom right')
		                        .hideDelay(3000)
		                        );
                  var index = vm.notifications.indexOf(notification);
                  vm.notifications.splice(index,1);
                  vm.progress = false;
	            	 });
                }, function () {
                    vm.progress = false;
                });
        };



        vm.newReport = newReport;
        function newReport() {
            if (!vm.autoinsert) {
                $state.go('app.sprardb_notification.newreport', {auto: vm.autoinsert});
            }
            if (vm.autoinsert) {
                $state.go('app.sprardb_newautoinsert', {auto: vm.autoinsert});
            }
        }
        vm.downloadPdf = eventi.letteraSeg;
        vm.downloadPdf2 = downloadPdf2;
        function downloadPdf2(event, notification) {
            console.log(notification);
            var tabaledata = [];
            tabaledata.push([{text: 'Nome', style: 'tableHeader'},
                {text: 'Cognome', style: 'tableHeader'},
                {text: 'Sesso', style: 'tableHeader'},
                {text: 'Data Nascita', style: 'tableHeader'},
                {text: 'Nazionalita', style: 'tableHeader'},
                {text: 'Note', style: 'tableHeader'},
                {text: 'Note San.', style: 'tableHeader'}
            ]);
            var json = notification.segnalatos;
            for (var i = 0; i < json.length; i++) {
                var obj = json[i];
                if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
                    var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tabaledata.push([obj.nome, obj.cognome, obj.sesso, obj.dataNascita, nation, obj.note, obj.noteSanitarie]);
                }
            }
            var enti = [];
            var enteprint = [];
            var entes = null;
            if (notification.segnalatos[0].letterai) {
                enti.push(notification.segnalatos[0].letterai.ente1_id);
                enti.push(notification.segnalatos[0].letterai.ente2_id);
                enti.push(notification.segnalatos[0].letterai.ente3_id);
                enti.push(notification.segnalatos[0].letterai.ente4_id);
            } else {
                enti.push(null);
                enti.push(null);
                enti.push(null);
                enti.push(null);
            }
            api.entes.ente.search({id_IN: enti.join()}, function (d) {
                entes = d.data;
                angular.forEach(entes, function (obj) {
                    enteprint.push(
                            {text: obj.nome, style: 'headerrightb'},
                            {text: obj.entetipo.descrizione, style: 'headerright'},
                            {text: (obj.indirizzo !== null) ? obj.indirizzo : 'NA', style: 'headerright'},
                            {text: (obj.cap !== null) ? obj.cap : 'NA', style: 'headerright'},
                            {text: (obj.email !== null) ? obj.email : 'NA', style: 'headerright'},
                            {text: (obj.telefono !== null) ? obj.telefono : 'NA', style: 'headerright'},
                            {text: '\n', style: 'headerright'}
                    );
                });
                console.log(enteprint);
                var docDefinition = {
                    content: [
                        {text: 'Segnalazione', style: 'header'},
                        {text: 'MODELLO ' + notification.tipo, style: 'header'},
                        {text: '\n', style: 'header'},
                        {text: 'Da:', style: 'headerright'},
                        {text: notification.enti.nome, style: 'headerrightb'},
                        {text: notification.enti.entetipo.descrizione, style: 'headerright'},
                        {text: (notification.enti.indirizzo !== null) ? notification.enti.indirizzo : 'NA', style: 'headerright'},
                        {text: (notification.enti.cap !== null) ? notification.enti.cap : 'NA', style: 'headerright'},
                        {text: (notification.enti.email !== null) ? notification.enti.email : 'NA', style: 'headerright'},
                        {text: (notification.enti.telefono !== null) ? notification.enti.telefono : 'NA', style: 'headerright'},
                        {text: '\n', style: 'headerright'},
                        {text: 'A:', style: 'headerright'},
                        {text: 'Servizio Centrale', style: 'headerrightb'},
                        {text: '\n', style: 'headerright'},
                        {text: 'Cc:', style: 'headerright'},
                        enteprint,
                        {text: '\n', style: 'headerright'},
                        {text: ['Data : ', {text: (notification.data !== null) ? notification.data : ''}]},
                        {text: ['Tipo segnalazione : ', {text: (notification.tipo !== null) ? notification.tipo : ''}]},
                        {text: ['Note : ', {text: (notification.note !== null) ? notification.note : ''}]},
                        {text: '\n', style: 'headerright'},
                        {text: '\n', style: 'headerright'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                body: tabaledata
                            },
                            layout: 'lightHorizontalLines'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 9,
                            alignment: 'right'
                        },
                        headerrightb: {
                            fontSize: 13,
                            alignment: 'right',
                            bold: true,
                        },
                        demoTable: {
                            margin: [0, 10, 0, 10]

                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 12,
                            color: 'black'
                        }
                    },
                };
                pdfMake.createPdf(docDefinition).download("report_details_" + notification.id + '.pdf');
            });
        }
        function downloadPdf1(event) {
            html2canvas(document.getElementById('segnalati'), {
                onrendered: function (canvas) {
                    var data = canvas.toDataURL();
                    var docDefinition = {
                        content: [{
                                image: data,
                                width: 500
                            }]
                    };
                    pdfMake.createPdf(docDefinition).open();
                }
            });
        }

        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            //vm.filtrap(vm.searchForms, key);
            onSearch();
        }

        function valuesearched(key, value) {
            //console.log("key", key);
            //console.log("value", value);
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        vm.abilitaModifica = abilitaModifica;
        function abilitaModifica(notification) {
            //restituisce
            // 0=no mofica, altro utente senza particolari diritti
            // 1=si modifica, stesso utente che ha creato
            // 2=si modfiica, utente gruppo Admin,Accoglienza,Segreteria


            var esito = 0;
            var persona_id = notification.personas.id;
            var gruppiPersona = {};
            if (notification.personas && notification.personas.users && notification.personas.users.user.groups) {
                gruppiPersona = notification.personas.users.user.groups;
            }
            var gruppiSuper = [1, 2, 3];

            if (persona_id == vm.api.userlogged.persona_id) {
                esito = 1;
            } else {
                angular.forEach(gruppiPersona, function (g) {
                    if (gruppiSuper.indexOf(g.group_id) > -1) {
                        esito = 2;
                    }

                });
            }
            return esito;
        }
    }

    function ParentelasDialogController($scope, msUtils, $mdDialog, $state, api, $mdToast, $q, locals) {
        var vmd = this;
        console.log("locals");
        console.log(locals);
        vmd.items = locals.items;
        vmd.parentelas = locals.parentelas;
        vmd.cancel = cancel;
        function cancel() {
            $mdDialog.hide();
        }
        vmd.assegna = assegna;
        function assegna() {
            var nc = 0;
            var cp = vmd.capofamiglia;
            if (vmd.items.length > 1) {
                nc = 1;
            }

            var payloads = [];
            angular.forEach(vmd.items, function (obj) {
                var payload = {};
                payload.id = obj.id;
                payload.parentela_id = obj.parentela_id;
                payload.nucleoFamiliare = nc;
                payload.capof_id = cp;
                if (obj.id == cp) {
                    payload.capof_id = 0;
                }
                if (nc === 0) {
                    //solo 1 persona
                    payload.id = obj.id;
                    payload.parentela_id = 589; // monoparentale
                    payload.nucleoFamiliare = 0;
                    payload.capof_id = obj.id; //me stesso
                }
                payloads.push(payload);
            });
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Assegnazione parentela')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            console.log("payloads", payloads);
            angular.forEach(payloads, function (pl) {
                api.segnalatos.segnalato.aggiorna(pl, function (d) {
                    console.log("aggiornamento", d);
                });
            });
            setTimeout(function () {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Assegnazione parentela completato')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
                $mdDialog.hide();
            }, 4000);
        }
    }

    function RsegnalatiController($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, msApi, api, $http, $base64, $mdToast, $filter, eventi, acl, ricerca, $cookieStore) {

        var vm = this;
        acl.reload();
        console.log("myUser", api.user);
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.params = $state.params;
        vm.paramsdata = $state.current.datas;
        vm.hasgroup = api.hasgroup;
        console.log("gruppo", vm.hasgroup);
        vm.searchForms = {
            "entes-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "entes-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "entes-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "entes-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "entes-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "nucleoFamiliare": {
                type: "string",
                title: "Nucleo Familiare",
                description: "Nucleo Familiare...",
                callbackModel: "ricerca",
                dbfield: "nucleoFamiliare",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nucleoFamiliare",
                chiave: "codice",
                valore: "descrizione|uppercase"
            },
            "capof_id": {
                type: "string",
                title: "Identificativo Capofamiglia",
                description: "Identificativo Capofamiglia",
                callbackModel: "ricerca",
                dbfield: "capof_id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "entes-enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "Ente Tipo",
                callbackModel: "ricerca",
                dbfield: "entes-enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "eventos-eventoStato_id": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventos-eventoStato_id",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            },
            "segnalaziones-idTipoSegnalazione_IN": {
                type: "string",
                title: "Tipo Segnalazione",
                description: "Tipo Segnalazione",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tiposegnalazione",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };
        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];
            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];
            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }



        if (vm.api.isOperatore) {
            vm.searchForms["segnalaziones-idTipoSegnalazione_IN"] = {
                type: "string",
                title: "Tipo Segnalazione",
                description: "Tipo Segnalazione",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoasegnalazione",
                chiave: "id",
                valore: "descrizione|uppercase"
            };
        }
        if (vm.api.isAdmin || vm.api.isSegreteria || vm.api.isAccoglienza) {
            vm.searchForms["segnalaziones-idTipoSegnalazione_IN"] = {
                type: "string",
                title: "Tipo Segnalazione",
                description: "Tipo Segnalazione",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tiposegnalazioneall",
                chiave: "id",
                valore: "descrizione|uppercase"
            };
        }


        vm.viewPerson = eventi.viewDetails;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.progettosa = ricerca.progettos;
        vm.nazioneb = ricerca.naziones;
        vm.tiposegnalazione = ricerca.tiposegnalazione;
        vm.tipoasegnalazione = ricerca.tipoasegnalazione;
        vm.tiposegnalazioneall = angular.copy(vm.tiposegnalazione);
        vm.tiposegnalazioneall = vm.tiposegnalazioneall.concat(vm.tipoasegnalazione);
        console.log("tipos:", vm.tiposegnalazione);
        console.log("tipoas:", vm.tipoasegnalazione);
        console.log("tipoall:", vm.tiposegnalazioneall);
        vm.sino = ricerca.sino;
        vm.nucleoFamiliare = ricerca.nucleoFamiliare;
        vm.ente1 = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        vm.entetipos = angular.copy(ricerca.enteprimosettores);
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        });
        vm.entetipos = ricerca.enteprimosettores;
        //vm.statoeventos = ricerca.statoeventos;
        vm.statoeventos = [{
                id: '-1',
                stato: 'BOZZA',
                iniziali: 'BO'
            },
            {
                id: '4',
                stato: 'INVIATO',
                iniziali: 'I'
            }
        ];
        vm.baseUrl = api.baseUrl;
        vm.nazioni = null;
        vm.documentotipo = null;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
                console.log(vm.tipoproteziones);
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();
        vm.enterilascio = function () {
            api.entes.ente.search({enteTipo_id: 7, sort: 'nome', pagination: "200", fields: "id,nome"}).$promise.then(function (response) {
                vm.enterilascios = response.data;
            }, function (response) {
                console.log('Ente rilascio caricata');
            });
        };
        vm.enterilascio();
        vm.autoinsert = false;
        if ($state.current.datas.autoinsert) {
            vm.autoinsert = vm.paramsdata.autoinsert;
        }
        var user = $cookies.getObject('user');
        var authorization = $base64.encode(user.access_token + ':');
        vm.persona = {};
        vm.persona = angular.copy(user);
        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        vm.selected = [];
        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.query = {
            sort: '-id',
            perPage: 5,
            page: 1
        };
        vm.search = null;
        vm.limitOptions = [5, 10, 15];
//        vm.apiUrl = 'http://localhost/sprardb/app-server/web/segnalaziones';
//        vm.apiRequest = {
//            method: 'GET',
//            url: vm.apiUrl,
//            params: {'sort': vm.query.sort, 'per-page': vm.query.perPage, 'page': vm.query.page},
//            headers: {
//                'Authorization': 'Basic ' + authorization
//            }
//        }
        vm.allsearchs = {};
        vm.allsearchs['query[]'] = [];
        vm.allsearchs['query[]'][0] = {operatore: 'OR'};
        vm.allsearchs['query[]'][1] = {operatore: 'AND'};
        if (vm.autoinsert) {
            vm.allsearchs['query[]'][1] = {operatore: 'AND'};
            vm.searchForms["idTipoSegnalazione_IN"] = {
                type: "string",
                title: "Tipo Segnalazione",
                description: "Tipo Segnalazione",
                callbackModel: "ricerca",
                dbfield: "idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoasegnalazione",
                chiave: "id",
                valore: "descrizione|uppercase"
            };
        }
        vm.allsearchs.operatore = 'AND';
        vm.allsearchs.pagination = 15;
        vm.allsearchs.sort = '-id';
        vm.allsearchs.page = 1;

        vm.preselezione = $cookieStore.get('ente_id');
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.allsearchs['query[]'][1]['segnalaziones-ente_id'] = vm.preselezione.toString();

        } else {
            vm.preselezione = $cookieStore.get('progetto_id');
            if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
                vm.allsearchs['query[]'][1].progetto_id = vm.preselezione.toString();
            }
        }


        vm.notifications = [];
        vm.links = [];
        vm.meta = [];
        vm.colors = eventi.colors3;
        vm.scolors = eventi.scolors;
        vm.ricerca = {
            'bandos-id': null,
            'bandos-dataFine': null,
            'istats-regione': null,
            'postiLiberi': null,
            'attivo': null,
            'tags-id': null
        };
        vm.ricercalabel = {
            'ente_id': 'Ente: ',
            'eventos-eventoStato_id': 'Stato: ',
            'tipo': 'Modello: ',
        };
        vm.ricerca2 = "";
        vm.searched = false;
        vm.loadnotifications = function () {
            api.segnalatos.segnalatomag.search(vm.allsearchs).$promise.then(function (response) {
                vm.Notifications = response;
                vm.notifications = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.notifications;
        };
        vm.loadnotifications();
        vm.onSearch = onSearch;
        function onSearch() {
            //nome
            console.log(vm.ricerca2);
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]['nome'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['cognome'] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }


            console.log(vm.allsearchs);
            if (vm.ricerca2) {
                //se inserita ricerca testuale allora LIKE
                api.segnalatos.segnalatomag.like(vm.allsearchs, function (d) {
                    vm.Notifications = d;
                    vm.notifications = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            } else {
                api.segnalatos.segnalatomag.search(vm.allsearchs, function (d) {
                    vm.Notifications = d;
                    vm.notifications = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            }




            vm.searched = true;
        }

//#####################################################################
        vm.editPerson = function (event) {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaEditController',
                controllerAs: 'vm',
                focusOnOpen: false,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {notification: vm.selected},
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/edit-dialog.html',
            }).then(function (res) {
                if (res !== undefined) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Segnalazione modificata con successo!')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    getNotifications();
                }
            });
        };
        vm.toggleLimitOptions = function () {
            vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 15];
        };
        vm.getTypes = function () {
            return ['Candy', 'Ice cream', 'Other', 'Pastry'];
        };
        vm.onPaginate = function (page, perPage) {
            vm.promise = $timeout(function () {
                if (vm.search === null || vm.search === '') {
                    vm.apiRequest.params = {'sort': vm.query.sort, 'per-page': perPage, 'page': page}
                    vm.promise = $http(vm.apiRequest).success(success).$promise;
                    console.log(vm.promise);
                }
            }, 2000);
        };
        vm.deselect = function (item) {
            console.log(item.id, 'was deselected');
        };
        vm.segnalatos = null;
        vm.log = function (item) {
            vm.segnalatos = item.segnalatos;
            console.log(item.id, 'was selected');
        };
        vm.loadStuff = function () {
            vm.promise = $timeout(function () {
                vm.promise = $http(vm.apiRequest).success(success).$promise;
            }, 2000);
        };
        vm.onReorder = function (sort) {
            vm.promise = $timeout(function () {

            }, 2000);
        };
        vm.states = function () {
            api.eventos.stato.get({}).$promise.then(function (response) {
                //vm.state = response.data;
                var temp = angular.copy(response.data);
                var tempnew = [];
                angular.forEach(temp, function (t) {
                    tempnew.push(t);
//                    if (t.id === -1) {
//                        tempnew.push(t);
//                    } else {
//                        var linetemp = {};
//                        linetemp.id = t.id;
//                        linetemp.stato = 'INVIATO';
//                        linetemp.iniziali = 'I';
//                        tempnew.push(linetemp);
//                    }
                });
                vm.state = tempnew;
            }, function (response) {
                console.log(response);
            });
        };
        vm.states();
        vm.segnalats = function () {
            api.entes.ente.search({segnalatore: 1, fields: 'id,nome'}).$promise.then(function (response) {
                vm.segnalat = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.segnalats();
        vm.viewDetails = viewDetails;
        function viewDetails(event, id) {
            if (!vm.autoinsert) {
                $state.go('app.sprardb_notification.editreport', {id: id});
            }
            if (vm.autoinsert) {
                $state.go('app.sprardb_notification.editareport', {id: id});
            }
        }

        vm.newReport = newReport;
        function newReport() {
            if (!vm.autoinsert) {
                $state.go('app.sprardb_notification.newreport', {auto: vm.autoinsert});
            }
            if (vm.autoinsert) {
                $state.go('app.sprardb_newautoinsert', {auto: vm.autoinsert});
            }
        }
        vm.downloadPdf = eventi.letteraSeg;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            //vm.filtrap(vm.searchForms, key);
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                return valore;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        vm.dettaglisegnalato = dettaglisegnalato;
        function dettaglisegnalato(item) {
            $mdDialog.show({
                controllerAs: 'vm',
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaAddController',
                focusOnOpen: false,
                locals: {
                    minori: (item.segnalaziones.idTipoSegnalazione === 607),
                    isnew: false,
                    nucleoFamiliare: true,
                    segnalato: item,
                    readonly: true
                },
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/add-dialog.html',
            })
        }
    }

})();


(function () {
    'use strict';

    angular.module('app.sprardb.notification')
            .controller('NotificationDetailController', NotificationDetailController)
            .controller('NotificationUploadController', NotificationUploadController)
            .controller('OmonimiController', OmonimiController);

    function NotificationDetailController($scope, $mdSidenav, $mdDialog, $state, $document, $cookies, $base64, $http, api, $mdToast, $stateParams, $localStorage, ricerca) {
        var vm = this;
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.userLogged = api.userlogged;
        vm.segnalatorecambia = false;
        vm.params = $state.params;
        vm.paramsdata = $state.current.datas;
        vm.maxtabs = 2;
        vm.changedform2 = false;
        vm.myEntes = $cookies.getObject('ALL_s_id');
        vm.myEnte = $cookies.getObject('ente_id');
        vm.myProgetto = $cookies.getObject('progetto_id');


        vm.parametricaricamento = {
            documentoTipo_id: 0,
            gruppo: 'SEGNALAZIONE',
            dettaglio: false,
            dettagliomin: true,
            entita: 'segnalazione',
            entitakey: 'segnalazione_id',
            caricato: 0,
            mincaricato: 0,
            mostratutti: true
        }

        if (vm.api.isAdmin || vm.api.isSegreteria || vm.api.isAccoglienza) {
            vm.entesegnalatores = ricerca.entesegnalatoresafes;
        } else {
            api.entes.ente.search({segnalatore: 1, fields: "id,nome", id_IN: vm.myEntes}, function (r) {
                vm.entesegnalatores = r.data;
            });
        }

        vm.entesegnalatoreid = 0;
        vm.segnalatores = [];
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.pagination = -1;
        vm.ricerca = {};

        vm.autoinsert = false;
        vm.minori = false;
        if (angular.isDefined(vm.paramsdata.autoinsert)) {
            vm.autoinsert = vm.paramsdata.autoinsert;
        }
        var user = $cookies.getObject('user');
        var authorization = $base64.encode(user.access_token + ':');
        vm.persona = {};
        vm.persona = angular.copy(user);
        vm.progettos = null;
        vm.strutturas = null;
        vm.letterainserimento = null;
        vm.segnalaziones = {};

        vm.addeditnoti = [];
        vm.reportid = null;
        vm.apiUrl = api.baseUrl + 'segnalaziones';
        vm.progress = false;
        vm.apiRequest = {
            method: 'GET',
            url: vm.apiUrl,
            params: {},
            headers: {
                'Authorization': 'Basic ' + authorization
            }
        }

        vm.isnew = true;
        if ($stateParams.id !== undefined) {
            vm.apiRequest.params = {id: $stateParams.id};
            vm.reportid = $stateParams.id;
            vm.isnew = false;
        }
      vm.title = vm.isnew? vm.paramsdata.title:'Registrazione';

        vm.selected = [];
        vm.segnalazione = {};
        vm.segnalazione.progetto_id = 0;
        vm.segnalazione.struttura_id = 0;
        vm.segnalazione.auto = vm.autoinsert;
        vm.segnalazione.nuovodomicilioesterno = "";
        vm.segnalazione.esterna = 0;
        vm.notification = [];
        vm.statos = -1;
        vm.options = {
            rowSelection: true,
            multiSelect: true,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vm.limitOptions = [5, 10, 15, {
                label: 'Tutti',
                value: function () {
                    return vm.notification ? vm.notification.count : 0;
                }
            }];
        vm.query = {
            sort: '-id',
            perPage: 10,
            page: 1
        };
        vm.colors = ricerca.colors;
        vm.scolors = ricerca.scolors;
        vm.oggi = new Date();
        vm.maxDate = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.minDate = new Date((vm.oggi.getFullYear() - 99) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.maxDatem = vm.oggi;
        vm.minDatem = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());

        var dataMaxModelloC = new Date(vm.oggi);
        dataMaxModelloC.setDate(vm.oggi.getDate() + 15);

        vm.dataMaxModelloC = dataMaxModelloC;
        //blocco date segnalazione
        var m4 = moment.duration({'days': 120});
        var a1 = moment.duration({'years': 1});
        vm.minDataSegnalazione = new Date(moment(vm.oggi).subtract(a1).format('YYYY-MM-DD'));
        if (!vm.isAdmin) {
            vm.minDataSegnalazione = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
        }
        if (vm.segnalazione.progetto_id) {
          searchStrutturas()
        }

        vm.loadsegnalaziones = loadsegnalaziones;
        function loadsegnalaziones(id) {
          api.segnalaziones.segnalazione.get({id: id, expand:'entes, personas, segnalatos, eventos, progettos, requiredFields'}, function (r) {
            vm.segnalaziones = r;
            vm.isnew = false;
            //vecchie variabili
            vm.segnalazione.id = r.id;
            vm.segnalazione.ente_id = r.ente_id;
            vm.segnalazione.persona_id = r.persona_id;
            vm.segnalazione.data = new Date(r.data);
            vm.segnalazione.esterna = r.esterna;
            vm.segnalazione.nuovodomicilioesterno = r.nuovodomicilioesterno;
            vm.segnalazione.tipo = r.tipo;
            vm.segnalazione.requiredFields = r.requiredFields;
            vm.segnalazione.note = r.note;
            vm.segnalazione.progetto_id = r.progetto_id;
            vm.segnalazione.idTipoSegnalazione = r.idTipoSegnalazione;
            vm.segnalazione.nucleoFamiliare = r.nucleoFamiliare;
            vm.segnalazione.struttura_id = r.struttura_id;
            vm.segnalazione.auto = false;
            vm.hascapofamiglia = false;
            vm.capof_id = 0;
            vm.tipofamiglia = null;
            vm.persona = r.personas;
            // vgiac: cosa rappresenta?
            // vm.autoinsert = false;

            /*
                  656 => modello C
                  689 => modello C minori
                 */
            if (r.idTipoSegnalazione == 656 || r.tipo == '656' || r.tipo == 'C' || r.idTipoSegnalazione == 689 || r.tipo == '689') {
              vm.autoinsert = true;
              vm.segnalazione.auto = true;
            }

                /*
                 606 => modello F
                 607 => modello FAMI/MINORI
                 689 => modello C minori
                 */
            (vm.segnalazione.tipo == 606) ? vm.parametricaricamento.mincaricato = 3 : vm.parametricaricamento.mincaricato = 0;
            if (vm.segnalazione.tipo == 607 || vm.segnalazione.tipo == 689) {
              vm.minori = true;
              vm.maxtabs = 3;
            } else {
              vm.minori = false;
              vm.maxtabs = 2;
            }

            vm.parametricaricamento.segnalazione_id = r.id
            vm.parametricaricamento.entita_id = r.id
            vm.statos = r.eventos.eventoStato_id;

            var segnalatos = r.segnalatos;
            if (vm.autoinsert) {
              api.strutturas.strutturamin.cerca({'progetto_id': r.progetto_id, pagination: 400, attivo: 1}, function (response) {
                vm.strutturas = response.data;
              });
            }
            api.progettos.hasente.cerca({ 'progetto_id': vm.segnalazione.progetto_id, pagination: 400, enteRuolo_id: 1 }, function (response) {
                vm.enteAttuatore = response.data;
                console.log(response);

                // Chiamata per ottenere i dettagli dell'ente per ogni elemento in vm.enteAttuatore
                vm.enteAttuatore.forEach(function (ente) {
                loadEnte(ente.ente_id);
                });
            });

            let needCapofamiglia = false;
            vm.notification = segnalatos;
            angular.forEach(vm.notification, function (seg) {
              if (seg.nucleoFamiliare == 0 || seg.nucleoFamiliare == 1) {
                needCapofamiglia = true;
                vm.tipofamiglia = seg.nucleoFamiliare;
              }
              if (seg.parentela_id === 674) {
                vm.hascapofamiglia = true;
                vm.capof_id = seg.id;
              }
              vm.notification.parametricaricamento = {
                documentoTipo_id: 0,
                gruppo: 'SEGNALATO',
                dettaglio: false,
                dettagliomin: false,
                entita: 'segnalato',
                entitakey: 'segnalato_id',
                caricato: 0,
                mincaricato: 0,
                mostratutti: false,
                segnalato_id: seg.id,
                entita_id: seg.id
              };

            });
            vm.capofamigliaWarning = needCapofamiglia && !vm.hascapofamiglia;
            vm.allegatiNecessari = false;

          }, function(error) {
            if (error.status === 404) {
              $state.go(api.primapagina, api.primapagina_attributi);
            }
          });
        }

        if (vm.autoinsert) { //carico progetti se autoinserimento
            api.progettos.progetto.cerca({attivo: 1, fields: "id,nome,postiLiberi,postiPrenotati", sort: "nome", pagination: -1}, function (response) {
                vm.progettos = response.data;
            });
        }

        vm.searchStrutturas = searchStrutturas;
        function searchStrutturas() {
            vm.listaEntiAttuatori = [];
            api.strutturas.strutturamin.cerca({'progetto_id': vm.segnalazione.progetto_id, pagination: 400, attivo: 1}, function (response) {
                //console.log("strutturamin", response.data);
                vm.strutturas = response.data;
//                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
//                	vm.strutturas.push(r1.data[0]);
//                    //console.log("strutturamin", angular.copy(vm.strutturas));
//                });

            });
            getEnte();


        }

        vm.enteAttuatore = [];
        vm.listaEntiAttuatori = [];

        vm.getEnte = getEnte;

        function getEnte() {
          api.progettoentemc.get({filter: {progetto_id: vm.segnalazione.progetto_id, enteRuolo_id: 1}, expand:'ente', pagination: 400 }, function (response) {
            vm.listaEntiAttuatori = response.data;
          });
        }

        if (!vm.isnew) {
            loadsegnalaziones(vm.params.id);
        } else {
            // se nuovo controllo selezione filtro generale
            if (vm.myEnte && !vm.autoinsert) {
                vm.segnalazione.ente_id = vm.myEnte;
            }
            if (vm.myProgetto && vm.autoinsert) {
                vm.segnalazione.progetto_id = vm.myProgetto;
                vm.searchStrutturas();
            }
        }


        vm.states = function () {
            api.eventos.stato.get({}).$promise.then(function (response) {
                vm.state = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.states();

        function success(response) {
//            vm.segnalazione = {
//                id: response.data[0].id,
//                persona_id: response.data[0].persona_id,
//                data: new Date(response.data[0].data),
//                tipo: response.data[0].tipo,
//                note: response.data[0].note
//            };
            vm.segnalazione.id = response.data[0].id;
            vm.segnalazione.persona_id = response.data[0].persona_id;
            vm.segnalazione.data = new Date(response.data[0].data);
            vm.segnalazione.tipo = response.data[0].tipo;
            vm.segnalazione.note = response.data[0].note;
            vm.parametricaricamento.segnalazione_id = vm.segnalazione.id
            vm.parametricaricamento.entita_id = vm.segnalazione.id

            vm.statos = response.data[0].eventos.eventoStato_id;
            var segnalatos = response.data[0].segnalatos;
            if (vm.autoinsert) {
                vm.segnalazione.progetto_id = segnalatos[0].progetto_id;
                vm.searchStrutturas();
                vm.segnalazione.struttura_id = segnalatos[0].struttura_id;
                //vm.segnalazione.letterai_id = segnalatos[0].letterai.id;
            }
            //console.log(vm.segnalazione);
            vm.notification = segnalatos;
            //vm.notification.totalCount = segnalatos.length;
        }

        function getNotification(reportid) {
            vm.apiRequest.params = {id: reportid};
            vm.apiRequest.url = vm.apiUrl + '/search';
            vm.promise = $http(vm.apiRequest).success(success).$promise;
        }


        vm.newPerson = newPerson;
        function newPerson(event) {
            $localStorage.$reset();
            $mdDialog.show({
                controllerAs: 'vm',
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaAddController',
                focusOnOpen: false,
                locals: {
                    minori: vm.minori,
                    isnew: vm.isnew,
                    nucleoFamiliare: vm.segnalazione.nucleoFamiliare,
                    hascapofamiglia: vm.hascapofamiglia,
                    capof_id: vm.capof_id,
                    tipofamiglia: vm.tipofamiglia,
                    esterna: vm.segnalazione.esterna,
                    tipoSegnalazione: vm.segnalazione.idTipoSegnalazione,
                    autoinsert: vm.autoinsert,
                    segnalazione_id : vm.segnalazione.id
                },
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/add-dialog.html',
            }).then(function (segnalato) {
                if (segnalato !== undefined) {
                  api.segnalatos.segnalato.ss(segnalato,function (res) {
                    loadsegnalaziones(vm.segnalazione.id);
                  })
                }
            });
        }

        vm.editPerson = editPerson;
        function editPerson(event, segnalati) {
            $localStorage.$reset();
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaAddController',
                controllerAs: 'vm',
                focusOnOpen: false,
                locals: {
                    minori: vm.minori,
                    isnew: vm.isnew,
                    nucleoFamiliare: vm.segnalazione.nucleoFamiliare,
                    esterna: vm.segnalazione.esterna,
                    segnalato: segnalati,
                    hascapofamiglia: vm.hascapofamiglia,
                    capof_id: vm.capof_id,
                    tipofamiglia: vm.tipofamiglia,
                    tipoSegnalazione: vm.segnalazione.idTipoSegnalazione,
                    autoinsert: vm.autoinsert
                },
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/add-dialog.html',
            }).then(function (segnalato) {
                if (segnalato !== undefined) {
                  api.segnalatos.segnalato.updateSegnalato(segnalato,function (res) {
                    loadsegnalaziones(vm.segnalazione.id);
                  })
                }
            });
        }

        vm.omonimi = omonimi;
        function omonimi(item){
          api.segnalatos.segnalato.omonimia(item,function (res) {
            var omonimi = res.data;
            var templateUrl = 'app/main/sprardb/beneficiari/dialog/omonimi.html'
            $mdDialog.show({
              controller: 'OmonimiController',
              controllerAs: 'vmd',
              templateUrl: templateUrl,
              clickOutsideToClose: true,
              locals: {
                omonimi : omonimi,
                item : item
              }
            }).then(function () {
              vm.loadsegnalaziones(vm.segnalazione.id);
            });
          })
        }

        vm.omonimiac = omonimiac;
        function omonimiac(item) {
            api.segnalatos.segnalato2.omonimia(item, function (r) {
                var apertura = $mdDialog.confirm()
                        .title('Omonimia')
                        .htmlContent(r.messaggio)
                        .ariaLabel('Confirmmation Box')
                        .ok('DETTAGLI')
                        .cancel('CHIUDI');
                $mdDialog.show(apertura).then(function () {
                    item.results = 1;
                    api.segnalatos.segnalato2.omonimia(item, function (r) {
                        var risultati = "";
                        angular.forEach(r.data, function (om) {
                            var importato = (om.beneficiario_id) ? "SEGNALATO" : "BENEFICIARIO";
                            risultati = risultati + "#" + om.id + " <b>" + om.cognome.toUpperCase() + " " + om.nome.toUpperCase() + "</b>, " + om.dataNascita + " " + " - " + importato + "<br>";
                        });
                        var apertura2 = $mdDialog.alert()
                                .title('Dettaglio Omonimia')
                                .htmlContent(risultati)
                                .ariaLabel('ConfirmmationBox')
                                .ok('CHIUDI');
                        $mdDialog.show(apertura2);
                        item.results = 0;

                    });
                });
            });
        }

        vm.trashPerson = function (index, segnalatos) {

            vm.progress = true;
            var confirm = $mdDialog.confirm()
                    .title('Cancellazione')
                    .textContent('Vuoi cancellare il segnalato?')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (angular.isUndefined(segnalatos.id)) {
                    loadsegnalaziones(vm.segnalazione.id);
                    vm.progress = false;
                    return;
                }
                api.segnalatos.segnalato.elimina({id: segnalatos.id}, function (r) {
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Segnalato cancellato!!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  vm.progress = false;
                  loadsegnalaziones(vm.segnalazione.id);
                });
            }, function () {
                vm.progress = false;
            });
        };

        vm.saveNotification = saveNotification;
        function saveNotification() {
            var messaggioconfirm = 'Si sta tentando di salvare la segnalazione con un nuovo operatore.<br>L\'operatore:<br><br><b><big>' + vm.persona.cognome + ' ' + vm.persona.nome + '</big></b><br><br>verrà sostituito dall\'operatore:<br><br><b><big>' + vm.userLogged.cognome + ' ' + vm.userLogged.nome + '</big></b>';

            var cambioop = vm.segnalazione.persona_id != vm.userLogged.persona_id && !vm.isnew;

            if(vm.segnalazione.esterna==-1){
            	vm.segnalazione.ente_id = 0;
            	vm.segnalazione.struttura_id = 1;
            }
            vm.progress = true;
            vm.addeditnoti = [];

            var vmsegnalazione = angular.copy(vm.segnalazione);

            vmsegnalazione.data = moment(vm.segnalazione.data).format("YYYY-MM-DD");
            var payload = {};
            payload.segnalazione = vmsegnalazione;//vm.segfnalazione;
            payload.segnalatos = vm.addeditnoti;
            payload.ente_id = vm.segnalazione.ente_id;

            if (cambioop) {
                //cambio operatore
                // cambio payload
                payload.segnalazione.persona_id = vm.userLogged.persona_id;

            }
            payload.progetto_id = vm.segnalazione.progetto_id;
            if (cambioop){
              confirm = $mdDialog.confirm()
                .title('Salvataggio con sostituzione operatore')
                .htmlContent(messaggioconfirm)
                .ariaLabel('Confirmation Box')
                .ok('HO CAPITO, SOTITUISCI OPERATORE')
                .cancel('ABBANDONA SALVATAGGIO');
              $mdDialog.show(confirm).then(function () {
                api.segnalaziones.segnalazione.create(payload, function (r) {

                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Segnalazione salvata correttamente!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  vm.progress = false;
                  loadsegnalaziones(r.id);
                },function (r) {
                  vm.progress = false;
                });
              });
            }else{
              api.segnalaziones.segnalazione.create(payload, function (r) {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent('Segnalazione salvata correttamente!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                vm.progress = false;
                loadsegnalaziones(r.id);
              },function (r) {
                vm.progress = false;
              });
            }
        }


        vm.sendReport = sendReport;
        function sendReport(event) {
            vm.progress = true;
            var confirm = $mdDialog.confirm()
                    .title('Invio segnalazione')
                    .textContent('Vuoi inviare la segnalazione al Servizio Centrale?')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');
            var confirm2 = $mdDialog.confirm()
                    .title('Segnalazione con allegati obbligatori')
                    .htmlContent('Per la segnalazione di <b>casi vulnerabili</b> è necessario <b>allegare documentazione specifica</b>.<br>Per ulteriori informazioni leggere il messaggio che si apre cliccando su &quot;CLICCA PER MAGGIORI INFORMAZIONI&quot; (etichetta in azzurro)<br><br>Vuoi inviare la segnalazione al Servizio Centrale?')
                    .ariaLabel('Conferma allegati')
                    .ok('Ok, ho allegato i documenti quindi invio la segnalazione')
                    .cancel('Non ho inserito allegati');
            var confirmBox = confirm;
            if (vm.allegatiNecessari) {
                confirmBox = confirm2;
            }
            $mdDialog.show(confirmBox).then(function () {
                api.segnalaziones.segnalazione.send({segnalazione_id: vm.segnalazione.id,note:vm.segnalazione.note}, function (r) {
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Segnalazione inviata al SC!!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  loadsegnalaziones(vm.segnalazione.id);
                  vm.progress = false;
                },function (res) {
                  vm.progress = false;
                });
            });

        }

        vm.sendReportTerritorio = sendReportTerritorio;
        function sendReportTerritorio(event) {
            vm.progress = true;
            var confirm = $mdDialog.confirm()
                    .title('Invio Registrazione')
                    .textContent('Confermi la registrazione del presente sul territorio? Nel caso sia presente un omonimia con un altro presente sul territorio verrai reinderizzato alla pagina di lavorazione dei segnalati sul territorio.')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');
                    var confirm2 = $mdDialog.confirm()
                    .title('Registrazione con allegati obbligatori')
                    .htmlContent('Per la registrazione di <b>casi vulnerabili</b> è necessario <b>allegare documentazione specifica</b>.<br>Per ulteriori informazioni leggere il messaggio che si apre cliccando su &quot;CLICCA PER MAGGIORI INFORMAZIONI&quot; (etichetta in azzurro)<br>')
                    .ariaLabel('Conferma allegati')
                    .ok('Ok, ho allegato i documenti quindi invio la segnalazione')
                    .cancel('Non ho inserito allegati');
            var confirmBox = confirm;
            if (vm.allegatiNecessari) {
                confirmBox = confirm2;
            }
            $mdDialog.show(confirmBox).then(function () {
                api.segnalaziones.segnalazione.send({segnalazione_id: vm.segnalazione.id,note:vm.segnalazione.note}, function (r) {
                  vm.notification.forEach(function (segnalato) {
                    if(segnalato.omonimo) {
                      $mdToast.simple('Registrazione effettuata con successo!')
                        .position('bottom right')
                        .hideDelay(3000)
                      $state.go('app.segnalatiterritorio', {eventoTipo_id:1017, segnalazioneId:vm.segnalazione.id})
                    }
                  })
                  $mdToast.show(
                    $mdToast.simple('Registrazione effettuata con successo!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  loadsegnalaziones(vm.segnalazione.id);
                  vm.progress = false;
                },function (res) {
                  vm.progress = false;
                });
            });

        }


        vm.country = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'NAZIONE', sort: 'descrizione', pagination: 400}).$promise.then(function (response) {
                vm.nazionalitas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.country();

        vm.tipoasegnalazione = [];
        vm.tipoaseg = function () {
            api.segnalaziones.segnalazione.tipologieSegnalazione({},function (res) {
              vm.tipoasegnalazione = res.data;
              console.log(vm.tipoasegnalazione);
            });
        };
        vm.tipoaseg();

        vm.loadsegnalatores = loadsegnalatores;
        function loadsegnalatores() {
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.ricerca.operatore = 'AND';
            vm.ricerca['personahasentes-personaRuolo_id_IN'] = 26; //segnalatore ruolo
            vm.ricerca['personahasentes-ente_id_IN'] = vm.entesegnalatoreid;
            vm.allsearchs['query[]'][1] = vm.ricerca;
            vm.allsearchs.sort = "cognome";
            api.personas.persona.search(vm.allsearchs, function (response) {
                vm.segnalatores = response.data;
            });


        }

        vm.cambiasegnalatore = cambiasegnalatore;
        function cambiasegnalatore() {
            if (angular.isDefined(vm.entesegnalatoreid)) {
                vm.persona = vm.userLogged;
                vm.segnalazione.persona_id = vm.userLogged.id;
                vm.segnalazione.ente_id = vm.entesegnalatoreid;
            }

            vm.segnalatorecambia = !vm.segnalatorecambia;
            vm.changedform2 = true;
        }



        vm.sceglisegnalazione = sceglisegnalazione;
        function sceglisegnalazione() {
          api.segnalaziones.segnalazione.selectSegnalazione({idTipoSegnalazione: vm.segnalazione.idTipoSegnalazione, expand: 'requiredFields'}, function (r) {
            vm.segnalazione.requiredFields = r.requiredFields
          })
          vm.parametricaricamento.mincaricato = vm.segnalazione.tipo == 606 ?  3 : 0;
          if (vm.segnalazione.tipo == 607 || vm.segnalazione.tipo == 689) {
            vm.minori = true;
            vm.maxtabs = 3;
          } else {
            vm.minori = false;
            vm.maxtabs = 2;
          }
        }

        vm.editparentela = editparentela;
        function editparentela() {
            var selected = vm.selected;
            console.log(selected);
            $mdDialog.show({
                controller: 'ParentelasDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/beneficiari/dialog/dialog_parentela.html',
                clickOutsideToClose: true,
                locals: {
                    items: selected,
                    parentelas: vm.parentelas

                }
            });
        }
        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log(response);
            });
        };
        vm.parentela();

        vm.searchOperatori = searchOperatori;
        function searchOperatori() {
            api.progettos.progetto.get({attivo: 1, fields: "id,nome,personas,entes", id: vm.autoprogetto_id, sort: "nome", pagination: -1}, function (r) {
                vm.cambioProgettos = r;
                vm.entesegnalatoreid = 0;
                angular.forEach(vm.cambioProgettos.entes, function (e) {
                    if (angular.isDefined(e.enteruolos)) {
                        angular.forEach(e.enteruolos, function (er) {
                            if (er.id == 8) {
                                //se titolare lo seleziono
                                vm.entesegnalatoreid = e.id;
                            }
                        });
                    }
                });
                vm.progettooperatoris = [];
                angular.forEach(vm.cambioProgettos.personas, function (p) {
                    console.log("p", p);
                    if (angular.isDefined(p.users) && p.users.user.groups[0].group_id === 6) {
                        //esiste utente è utente è operatore progetto
                        vm.progettooperatoris.push(p);
                    }
                });

            });
        }

        vm.alertNomenclatura = alertNomenclatura;
        function alertNomenclatura(ev) {
            $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title('Informazioni sui files')
                    .htmlContent('Qualora i files si riferiscano a diversi segnalati, <br><b>rinominare preventivamente</b> i files in questo modo:<br><br>- <b>nome_cognome.estensione</b><br><br>Grazie<br>Servizio Centrale')
                    .ariaLabel('nomenclatura')
                    .ok('Ok ho capito')
                    .targetEvent(ev)
                    );
        }
        vm.alertAllegati = alertAllegati;
        function alertAllegati(ev, segnalazione_tipo) {
            console.log(segnalazione_tipo);
            var titolo_default = 'Allegati per vulnerabilità';
            var testo_default = 'Per questo segnalato, avendo specificato una vulnerabilità, <br>è necessario <b>inserire obbligatoriamente degli allegati</b>.<br>Cliccare sui <b>tre punti</b><i class="icon-dots-vertical s16"></i> del menù azioni e scegliere la <b>voce <br> <i class="icon-attachment s16"></i> ALLEGATI</b>.<br><br>Grazie<br>Servizio Centrale';
            if (segnalazione_tipo == 606) {
                titolo_default = 'Allegati per segnalazioni disagio mentale';
                testo_default = 'Per questa segnalazione è necessario compilare e allegare<br>il questionario corredato delle relazioni ivi richieste.<br><br>Il questionario è scaricabile cliccando sul link presente nella pagina sottostante.<br><img src="data:image/png;base64,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" class="border" /><br><br>Grazie<br>Servizio Centrale';

            }
            $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(false)
                    .parent(angular.element(document.body))
                    .title(titolo_default)
                    .htmlContent(testo_default)
                    .ariaLabel('alertAllegati')
                    .ok('Ok ho capito')
                    .targetEvent(ev)
                    );
        }


        vm.allegatiNecessari = false;
        vm.mostraLinkModelloF = false;

        vm.controllaAllegatoNecessario = function (segnalato, segnalazione) {
            var risultato = false;
            if (angular.isDefined(segnalato.idVulnerabilita) && segnalato.idVulnerabilita > 0) {
                risultato = true;
            }
            if (segnalazione.tipo == 606) {
                risultato = true;
                vm.mostraLinkModelloF = true;
            }
            //console.log("vm.allegatiNecessari", vm.allegatiNecessari);
            //console.log("risultato", risultato);
            if (!vm.allegatiNecessari && risultato) {
                vm.allegatiNecessari = risultato;
            }
            return risultato;
        };

        vm.uploadAttachment = uploadAttachment;
        function uploadAttachment(event, segnalatos) {
            //console.log("segnalatos", segnalatos);
            $mdDialog.show({
                controllerAs: 'vmd',
                clickOutsideToClose: true,
                controller: 'NotificationUploadController',
                focusOnOpen: false,
                locals: {
                    segnalatos: segnalatos
                },
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                templateUrl: 'app/main/sprardb/form/upload-dialog.html',
            }).then(function (upload) {
                if (upload) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Upload correttamente effettuato!')
                            .position('bottom right')
                            .hideDelay(3000)
                            );

                }
            });
        }

        vm.abilitaModifica = abilitaModifica;
        function abilitaModifica() {
            //restituisce
            // 0=no mofica, altro utente senza particolari diritti
            // 1=si modifica, stesso utente che ha creato
            // 2=si modfiica, utente gruppo Admin,Accoglienza,Segreteria

            var notification = vm.segnalaziones;
            var esito = 0;
            if (notification.length > 0) {
                var persona_id = notification.personas.id;
                var gruppiPersona = notification.personas.users.user.groups;
                var gruppiSuper = [1, 2, 3];

                if (persona_id === vm.api.userlogged.persona_id) {
                    esito = 1;
                } else {
                    angular.forEach(gruppiPersona, function (g) {
                        if (gruppiSuper.indexOf(g.group_id) > -1) {
                            esito = 2;
                        }

                    });
                }
            }
            return esito;
        }

    }

    function NotificationUploadController($scope, $mdSidenav, $mdDialog, $state, api, $mdToast, $stateParams, ricerca, locals) {

        var vmd = this;
        vmd.segnalato = locals.segnalatos;
        vmd.parametricaricamento = {
            documentoTipo_id: 0,
            gruppo: 'SEGNALATO',
            dettaglio: false,
            dettagliomin: true,
            entita: 'segnalato',
            entitakey: 'segnalato_id',
            caricato: 0,
            mincaricato: 0,
            mostratutti: true
        };
        vmd.parametricaricamento.segnalato_id = vmd.segnalato.id;
        vmd.parametricaricamento.entita_id = vmd.segnalato.id;

        vmd.closeDialog = closeDialog;
        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }

    function OmonimiController($scope,$mdDialog,locals) {
      var vmd = this;
      vmd.omonimi = locals.omonimi;
      vmd.item = locals.item;


      vmd.closeDialog = function () {
        $mdDialog.hide();
      }
    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.monitoraggio')
    .controller('searchFormController', searchFormController)
    .directive('searchForm', searchForm);

  /** @ngInject */
  function searchFormController($scope, api, $filter, ricerca,$location,$httpParamSerializer)
  {
    var fc = this;

    fc.buildFilter = buildFilter;
    fc.reset = reset;

    fc.searchModel = $scope.ngModel || {};
    fc.isCruscotto = $scope.cruscotto;

    fc.ricerca = ricerca;
    fc.periodo = {1:"Quadrimestre",2:"Semestre" }
    fc.selectedPeriodo = {}
    fc.quadrimestri = {1:'Q1',2:'Q2',3:'Q3'};
    fc.semestri = {4:'S1',5:'S2'};
    fc.areaGeografica = {1:'Nord',3:'Centro',4:'Sud e Isole'};
    fc.tipoMonitoraggio = ['AMMINISTRATIVO','QUALITATIVO','CONGIUNTO'];
    fc.tipologieAccoglienza = api.tipologiaAccoglienza.tipologie.search({pagination:-1});
    fc.anniMonitoraggio = api.monitoraggio.anniMonitoraggio();

    var p = fc.p = api.user.permissions;
    fc.visitatore = p.includes('visit-rendicontazione') && !p.includes('sc-monitoraggio') && !p.includes('tutor-monitoraggio');
    fc.statoMonitoraggio = api.monitoraggio.stato.query(function (res){
      if (fc.visitatore) {
        fc.statoMonitoraggio = $filter('filter')(res, function (value) {
          return value.id > 2;
        });
      }
    });

    if (p.includes('view-tutor')) {
      fc.tutorAmministrativi = api.monitoraggio.tutor.tutorAmministrativi({}, function (res) {
        return pushTutorAssegnato(res, fc.visita?.tutorAmm);
      });
      fc.tutorQualitativi = api.monitoraggio.tutor.tutorQualitativi({}, function (res) {
        return pushTutorAssegnato(res, fc.visita?.tutorQual);
      });
    }

   // Parametri che devono essere trattati come array
    var arrayParams = ['periodoMonitoraggioId', 'categoria', 'codRipartGeo', 'regione', 'provincia', 'esitoId', 'statoId', 'giudizioId', 'tutorAmmId', 'tutorQualId', 'anno'];

    // Funzione per assicurarsi che i valori specificati siano array o oggetti e che le date siano nel formato corretto
    function assicuraArrayParams(params) {
      angular.forEach(arrayParams, function(key) {
        if (params[key] && !Array.isArray(params[key])) {
          // Controlla se il valore non è dataInizio o dataFine
          if (key !== 'dataInizio' && key !== 'dataFine') {
            if (!(params[key] instanceof Date)) {
              params[key] = [params[key]];
            }
          }
        }
      });
      // Converti dataInizio e dataFine in oggetti Date, se necessario
      if (params.dataInizio && !(params.dataInizio instanceof Date)) {
        params.dataInizio = new Date(params.dataInizio);
      }

      if (params.dataFine && !(params.dataFine instanceof Date)) {
        params.dataFine = new Date(params.dataFine);
      }

      return params;
    }

    function initSearch() {
      fc.savedParams = angular.copy($location.search());
      delete(fc.savedParams.page);
      delete(fc.savedParams['per-page']);
      delete(fc.savedParams.sort);
      delete(fc.savedParams.nomeVisita);
      delete(fc.savedParams.codiceMinistero);

      if(fc.savedParams.periodoMonitoraggioId) {
        if([1,2,3].includes(parseInt(fc.savedParams.periodoMonitoraggioId))){
          fc.selectedPeriodo = 'Quadrimestre';
        } else {
          fc.selectedPeriodo = 'Semestre';
        }
      }
      // Assicurati che i parametri specificati siano sempre array
      fc.searchModel = assicuraArrayParams(fc.savedParams);
    }

    // Chiamata alla funzione per inizializzare i filtri quando la pagina viene caricata
    initSearch();

    buildFilter();

    function pushTutorAssegnato(listaTutor, tutorAssegnato)
    {
      if (!tutorAssegnato) return listaTutor;
      var found = false;
      listaTutor.forEach(function(tutor) {
        if (tutor.id === tutorAssegnato.id) {
          found = true;
        }
      });

      return found ? listaTutor : listaTutor.push(tutorAssegnato);
    }

    function buildFilter()
    {

      var ripartGeo = {
        1: [1,2],
        3: [3],
        4: [4,5]
      }

      var tipo = {
        'AMMINISTRATIVO': {and:[{not: {tutorAmmId: null}},{tutorQualId: null}]},
        'QUALITATIVO':  {and:[{tutorAmmId: null},{not: {tutorQualId: null}}]},
        'CONGIUNTO': {and:[{not: {tutorAmmId: null}},{not: {tutorQualId: null}}]},
      }

      var filter = {
        and: [
        ]
      }
      var copyModel = angular.copy(fc.searchModel);

      if (fc.searchModel.nomeProgetto) {
        filter.and.push({or: [{'progetto.nome': {xlike: fc.searchModel.nomeProgetto+'%'}},
            {'progetto.nome': {like: ' '+fc.searchModel.nomeProgetto}}]
        });
      }

      if (fc.searchModel.tipo) {
        filter.and.push(tipo[fc.searchModel.tipo]);
      }

      if (fc.searchModel.codRipartGeo){
        var orCod = [];
        angular.forEach(fc.searchModel.codRipartGeo,function(value, key){
          angular.merge(orCod,ripartGeo[value]);
        })
        filter.and.push({codRipartGeo: orCod});
      }

      if (fc.searchModel.confermato) {
        filter.and.push({not: {confermato: null}});
      }

      if(fc.searchModel.monitoraggioScaduto == 0 || fc.searchModel.monitoraggioScaduto == 1) {
        filter ={};
        filter.monitoraggioScaduto = fc.searchModel.monitoraggioScaduto;
      }


      //TODO: Probabilmente Migrazione per aggiungere il campo monitoraggioScaduto alla tabella.
      //Utilizzandolo come flag per la ricerca.

      delete(copyModel.nomeProgetto);
      delete(copyModel.tipo);
      delete(copyModel.codRipartGeo);
      delete(copyModel.confermato);
      delete(copyModel.dataInizio);
      delete(copyModel.dataFine);
      delete(copyModel.monitoraggioScaduto);


      angular.forEach(copyModel, function(value, key){
        if (!isEmpty(value)){
          filter.and.push({[key]: value});
        }
      })

      $location.search(angular.merge($location.search(), fc.searchModel))
      $scope.filter = filter;
    }

    function isEmpty(value) {
      return !value || (Array.isArray(value) && !value.length);
    }

    function reset() {
      fc.searchModel = {};
      fc.buildFilter();
    }
  }

  function searchForm($compile)
  {
    return {
      require: ['ngModel', 'filter', 'cruscotto'],
      restrict: 'E',
      scope: {
        ngModel: '<',
        filter: '=',
        cruscotto: '='
      },
      controller: 'searchFormController as fc',
      templateUrl: 'app/main/sprardb/monitoraggio/search-form.html'
    };

  }

})();


(function ()
{
  'use strict';


  angular
        .module('app.sprardb.monitoraggio')
        .controller('MonitoraggioController', MonitoraggioController)
        .controller('EsitoController', EsitoController)
        .controller('SegnalaController', SegnalaController)
        .controller('RapportoDialogController', RapportoDialogController);

  /** @ngInject */
  function MonitoraggioController($scope, $mdSidenav, $mdDialog, $state, $stateParams, api, $mdToast, $filter, $location)
  {
    var vm = this;
    vm.isAdmin = api.isAdmin;
    vm.isTutor = api.isTutor;

    vm.toggleSidenav = toggleSidenav;
    vm.cancelDialog = cancelDialog;
    vm.hideDialog = hideDialog;
    vm.salvaDettaglio = salvaDettaglio;
    vm.nuovoDettaglio = nuovoDettaglio;
    vm.salvaVisita = salvaVisita;
    vm.salvaSintesi = salvaSintesi;
    vm.checkRichieste = checkRichieste;
    vm.inviaReport = inviaReport;
    vm.assegnaEsito = assegnaEsito;
    vm.segnalaMinint = segnalaMinint;
    vm.esportaPdf = esportaPdf;
    vm.showRapportoDialog = showRapportoDialog;
    vm.cercaEnti = cercaEnti;
    vm.salvaEnte = salvaEnte;
    vm.rimuoviEnte = rimuoviEnte;
    vm.displayMultiple = displayMultiple;
    vm.selectedText = selectedText;
    vm.disabled = disabled;
    vm.switchTab = switchTab;
    vm.salvaReport = salvaReport;
    vm.loadDettagli = loadDettagli;
    vm.loadVisita = loadVisita;
    vm.controllaDataScadenza = controllaDataScadenza;
    vm.changeGiorniScadenza = changeGiorniScadenza;
    vm.annullaInvioReport = annullaInvioReport;

    vm.user = api.user;
    vm.id = $stateParams.visitaId;
    var validTabs = ['principale', 'enti', 'dettagli', 'report'];
    var hash = $state.params['#'] || $location.hash();
    vm.activeTab = validTabs.includes(hash) ? hash : 'principale';
    vm.showTipoSelect = true;
    vm.selected = [];
    vm.dettagliValidati = {};
    vm.newEnte = {};
    vm.maxDate = new Date();


    vm.pagination = {};
    vm.quadrimestri = {1:'Q1',2:'Q2',3:'Q3'};
    vm.colorMap = {
      6: '#588939',
      7: '#6fac47',
      8: '#b6d4a3',
      9: '#fddd7f',
      10: '#ef9c64'
    };

    vm.statoMonitoraggio = api.monitoraggio.stato.query();
    vm.tipologieAccoglienza = api.monitoraggio.tipAccoglienza.query();

    loadVisita();
    initPagination();

    function loadVisita()
    {
      vm.visita = api.monitoraggio.get({id:vm.id,expand:'safeAttributes,progettoMonitoraggio.progetto.tipologiaAccoglienza,' +
          'progettoMonitoraggio.progetto.istats,enti,punteggio,giudizio,tutorAmm.persona,tutorQual.persona,stato,esito,richieste,' +
          'validita,report'
        }, function(res) {
          vm.visita = res;
          if(vm.visita.numeroGiorni === null){
            vm.visita.numeroGiorni = 1;
          }
          vm.tipoDettaglio = getTipoDettaglio();
        });
      loadDettagli();
    }

    function mergeVisita(old, visita)
    {
      angular.forEach(visita, function(v,k) {
        if (angular.isArray(v)) {
          old[k] = [];
        }
      });
      angular.merge(old,visita);
    }

    function checkRichieste(d)
    {
      d.disabled = true;
      var payload = {id: d.id, richieste: d.richieste, version: d.version}
      api.monitoraggio.dettaglio.save(payload, function(res) {
        loadDettagli();
      });
    }

    function assegnaEsito(ev)
    {
      $mdDialog.show({
        controller: 'EsitoController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/monitoraggio/dialogs/assegna-esito.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          statoMonitoraggio: vm.statoMonitoraggio,
          richieste: vm.visita.richieste
        }
      }).then(function(esitoId){
        api.monitoraggio.assegnaEsito({id: vm.visita.id, esitoId: esitoId, version: vm.visita.version}, function(res) {
          mergeVisita(vm.visita, res);
          $mdToast.show(
            $mdToast.simple()
              .textContent('Esito correttamente assegnato.')
              .position('bottom right')
              .hideDelay(3000)
          )
        })
      });
    }
    function segnalaMinint(ev)
    {
      $mdDialog.show({
        controller: 'SegnalaController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/monitoraggio/dialogs/segnala-minint.html',
        targetEvent: ev,
        clickOutsideToClose: true,
      }).then(function(data){
        api.monitoraggio.segnalaMinint({id: vm.visita.id, dataSegnalazione: data, version: vm.visita.version}, function(res) {
          mergeVisita(vm.visita, res);
          $mdToast.show(
            $mdToast.simple()
              .textContent('Segnalato al MININT')
              .position('bottom right')
              .hideDelay(3000)
          )
        })
      });
    }
    function changeGiorniScadenza() {
      var payload = angular.copy(vm.visita);
      payload.giorniScadenza = vm.visita.giorniScadenza;
      vm.dataForm.$setPristine()
      if(vm.visita.esito) return;
      api.monitoraggio.save(payload, function(res) {
        mergeVisita(vm.visita,res);
        $mdToast.show(
          $mdToast.simple()
            .textContent('Informazioni Salvate')
            .position('bottom right')
            .hideDelay(3000)
        )
        controllaDataScadenza(true)
      });

    }
    function controllaDataScadenza(change)
    {
      var dataOdierna = new Date().setHours(0,0,0,0);
      if(!vm.visita.report || !vm.visita.dataScadenza) return;

      if(!change && vm.visita.dataScadenza < dataOdierna) {
        vm.dataForm.dataScadenza.$setValidity("dateDiff", false)
        vm.dataForm.dataScadenza.$setTouched(true);
      } else {
        vm.dataForm.dataScadenza.$setValidity("dateDiff", true);
      }
    }

    $scope.$watch('vm.dataForm.dataScadenza', function (dataScadenza) {
      if(dataScadenza && vm.visita.report && vm.visita.report.dataInvio) {
        console.log("in")
        controllaDataScadenza(false);
      }
    })

    function toDataURL(src, callback, outputFormat) {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function() {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.naturalHeight;
        canvas.width = this.naturalWidth;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        callback(dataURL);
      };
      img.src = src;
      // if (img.complete || img.complete === undefined) {
      //   img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      //   img.src = src;
      // }
    }

    async function esportaPdf(ev) {
      if (!vm.visita.giudizio) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('Per poter generare il report è necessario che sia stato generato un giudizio')
            .position('bottom right')
            .hideDelay(3000)
        )
        return null;
      }
      var data = $filter('date')(vm.visita.data, 'dd/MM/yyyy') || '';
      var inizioFinanziamento = $filter('date')(vm.visita.progettoMonitoraggio.dataInizioFinanziamento);
      var fineFinanziamento = $filter('date')(vm.visita.progettoMonitoraggio.dataFineFinanziamento);
      var entePartner = $filter('filter')(vm.visita.enti, {ruolo: 'partner'});
      var enteAderente = $filter('filter')(vm.visita.enti, {ruolo: 'aderente'});
      var enteAttuatore = $filter('filter')(vm.visita.enti, {ruolo: 'attuatore'});
      var contrRichiesto = $filter('currency')(vm.visita.importoFinanziato, '€');

      var defaultHtml = "<style>" + getCss() + "</style>" +
        "<img src=\"assets/images/logos/sc.png\">" + "<hr/>"+
        "<h2><b>REPORT DI MONITORAGGIO</b></h2>" +
        "<h3>MONITORAGGIO DEL PROGETTO DEL COMUNE DI: <b>" + vm.visita.progettoMonitoraggio.enteLocale+ "</b>" +
        "<br>ESEGUITO IN DATA: <b>"+ data +"</b></h3>" +
        "<h3><b>Anagrafica</b></h3>" +
        "Codice Progetto: <b>" +vm.visita.progettoMonitoraggio.codiceProgetto+ "</b><br/>" +
        "Ente Locale Capofila: <b>" +vm.visita.progettoMonitoraggio.enteLocale+ "</b><br/>" +
        "Denominazione: <b>"+ vm.visita.nome + "</b><br/>" +
        "Enti locali partner o consorziati: <b>" + vm.displayMultiple(entePartner, 'nomeEnte') +"</b><br/>" +
        "Enti locali aderenti al progetto: <b>" + vm.displayMultiple(enteAderente, 'nomeEnte') + "</b><br/>" +
        "Enti attuatori: <b>" + vm.displayMultiple(enteAttuatore, 'nomeEnte') + "</b><br/>" +
        "Categoria di progetto: <b>" +vm.visita.progettoMonitoraggio.progetto.tipologiaAccoglienza.descrizione+ "</b><br/>" +
        "Periodo di finanziamento: <b>" + inizioFinanziamento + ' - ' + fineFinanziamento + "</b><br/>" +
        "Tipologia di accoglienza: <b>" + vm.displayMultiple(vm.visita.tipAccoglienza, 'descrizione') + "</b><br/>" +
        "Numero Posti finanziati al momento della visita: <b>" +vm.visita.numeroPosti+ "</b><br/>" +
        "Numero Posti attivi al momento della visita: <b>" +vm.visita.numeroPostiAttivi+ "</b><br/>" +
        (vm.visita.importoFinanziatoTemporaneo ? "" : "Contributo Assegnato: <b>" + contrRichiesto + "</b>") + "<br/>" +
        "Finanziato a valere su Fondo FAMI: <b>" +(vm.visita.finanziatoFondoFami ? 'SI' : 'NO')+ "</b><br/>" +
        "Strutture di accoglienza (numero): <b>" +vm.visita.numeroStrutture+ "</b><br/>" +
        "Strutture di accoglienza visitate(numero): <b>" +vm.visita.numeroStruttureVisitate+ "</b><br/>" +
        "Beneficiari presenti alla data della missione: <b>" +vm.visita.numeroBeneficiari+ "</b><br/>" +
        "Nominativi dei Referenti incontrati dell'ente locale /partner/consorziati/aderenti e dell'ente attuatore: <b>" +(vm.visita.nomiReferenti ?? '')+ "</b><br/>" +
        "Nominativi dei Referenti di altri enti presenti alla visita di monitoraggio: <b>" +(vm.visita.nomiReferentiExtra ?? '')+ "</b><br/>" +
        "Presenza Prefettura: <b>" + (vm.visita.presenzaPrefettura ? "SI" : "NO") + "</b><br/>" +
        "Presenza Ministero/DLCI : <b>" + (vm.visita.presenzaMinistero ? 'SI' : 'NO') + "</b><br/>" +
        "In loco/A distanza: <b>" + (vm.visita.daRemoto ? 'D' : 'L') + "</b><br/>" +
        "Numero giorni: <b>" +vm.visita.numeroGiorni+ "</b><br/>" +
        "<h3><b>" +
        "VALUTAZIONE SINTETICA<br>ANDAMENTO PROGETTUALE RISPETTO ALLE LINEE GUIDA SAI, ALLA DATA DEL" + data +
        "</b></h3>" + "<div style=\"background-color:" + vm.colorMap[vm.visita.giudizio.id] + "\">ANDAMENTO PROGETTUALE " + vm.visita.giudizio.descrizione + " </div>";

      var opt = {
        filename: 'Report_visita.pdf',
        margin: [15,15],
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2, letterRendering: true },
        jsPDF:        { unit: 'pt', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      };
      var sintesi = "<div class=\"ql-editor\">" +
        vm.visita.sintesi +
       "</div>";
      html2pdf().from(defaultHtml+sintesi).set(opt).save()
    }

    function switchTab(tab)
    {
      vm.activeTab = tab;
      $location.hash(tab).replace();
    }

    function cercaEnti(nome)
    {
      vm.newEnte.nomeEnte = null;
      if (vm.nomiEnte && vm.nomiEnte.$cancelRequest) {
        vm.nomiEnte.$cancelRequest();
      }
      vm.nomiEnte = api.monitoraggio.enti({nome: nome});
    }

    function salvaEnte()
    {
      var payload = angular.merge({visitaMonitoraggioId: vm.visita.id}, vm.newEnte);
      if (payload.nomeEnte === null) {
        payload.nomeEnte = vm.enteSearch;
      }

      var request = api.monitoraggio.aggiungiEnte(payload, function(res) {
        vm.visita.enti = res.enti;
        vm.newEnte = {};
        vm.enteSearch = null;
        $mdToast.show(
          $mdToast.simple()
            .textContent('Ente aggiunto.')
            .position('bottom right')
            .hideDelay(3000)
        )
      });

      request.$promise.finally(function() {
        vm.enteForm.$setPristine();
        vm.enteForm.$setUntouched();
      })
    }

    function rimuoviEnte(enteMonitoraggio)
    {
      api.monitoraggio.rimuoviEnte(enteMonitoraggio, function(res) {
        vm.visita.enti = res.enti;
        $mdToast.show(
          $mdToast.simple()
            .textContent('Ente rimosso.')
            .position('bottom right')
            .hideDelay(3000)
        )
      })
    }

    function selectedText()
    {
      if (vm.visita.tipAccoglienza && vm.visita.tipAccoglienza[0]) {
        return vm.displayMultiple(vm.visita.tipAccoglienza, 'descrizione');
      } else {
        return "Seleziona Tipologia Accoglienza...";
      }
    }

    function displayMultiple(array, displayName)
    {
      if (angular.isArray(array)) {
        return array.map(function(val) {
          return val[displayName];
        }).join(', ');
      }
    }

    function mostraSelezionati(dettagli)
    {
      vm.selected = [];
      var p = api.user.permissions;

      angular.forEach(dettagli, function(dettaglio) {
        if (dettaglio.validato) {
          vm.selected.push(dettaglio);
          vm.dettagliValidati[dettaglio.tipo] = dettaglio;
        }
      })
    }

    function disabled(field)
    {
      if (!vm.visita.safeAttributes) return true;
      return !vm.visita.safeAttributes.includes(field);
    }

    function salvaVisita()
    {
      var payload = angular.copy(vm.visita);
      delete(payload.sintesi);
      payload.expand = "validita";
      api.monitoraggio.save(payload, function(res) {
        mergeVisita(vm.visita,res);
        vm.tipoDettaglio = getTipoDettaglio();
        vm.visitaForm.$setPristine();
        $mdToast.show(
          $mdToast.simple()
            .textContent('Informazioni Salvate')
            .position('bottom right')
            .hideDelay(3000)
        )
      });
    }

    function salvaSintesi()
    {
      var payload = (({id,sintesi,version}) => ({id,sintesi,version}))(vm.visita);
      api.monitoraggio.save(payload, function(res) {
        mergeVisita(vm.visita,res);
        vm.sintesiForm.$setPristine();
        $mdToast.show(
          $mdToast.simple()
            .textContent('Informazioni Salvate')
            .position('bottom right')
            .hideDelay(3000)
        )
      });
    }


    function inviaReport() {
      console.log(vm.visita.statoId);
      var confirm = $mdDialog.confirm()
        .title('Sei sicuro di voler confermare e inviare il report?')
        .htmlContent('Non sarà più possibile modificare le informazioni di questa visita, ma si potrà assegnare un esito.')
        .ok('CONFERMA')
        .cancel('ANNULLA');

      $mdDialog.show(confirm).then(function () {
        api.monitoraggio.inviaReport(vm.visita, function(res) {
          mergeVisita(vm.visita, res);
          loadDettagli();
          vm.visita.report = {dataInvio: null};
          $mdToast.show(
            $mdToast.simple()
              .textContent('Report confermato.')
              .position('bottom right')
              .hideDelay(3000)
          ).then(
            $state.reload()
          );
        });
      });
    }

    function annullaInvioReport()
     {
        console.log(api);
        console.log(vm.visita.statoId);

        var confirm = $mdDialog.confirm()
          .title('Sei sicuro di voler rimuovere la conferma del Report?')
          .htmlContent('Premi il tasto SI per rimuovere la conferma del Report')
          .ok('SI')
          .cancel('NO');

        $mdDialog.show(confirm).then(function () {
          api.monitoraggio.annullaInvioReport(vm.visita, function(res) {
            mergeVisita(vm.visita, res);
            loadDettagli();
            vm.visita.report = {dataInvio: null};

          $mdToast.show(
          $mdToast.simple()
          .textContent('Report Annullato.')
            .position('bottom right')
            .hideDelay(3000)
            ).then(
            $state.reload()
            );
          });
        });
     }



    function salvaReport()
    {
      var payload = (({id,version}) => ({id,version,giorniScadenza: vm.visita.giorniScadenza}))(vm.visita);
      payload.ReportMonitoraggio = {dataInvio: vm.visita.report.dataInvio};

      api.monitoraggio.inviaReport(payload, function(res) {
        mergeVisita(vm.visita, res);
        vm.dataForm.$setPristine();
        controllaDataScadenza(false)
        loadDettagli();
        $mdToast.show(
          $mdToast.simple()
            .textContent('Informazioni salvate correttamente.')
            .position('bottom right')
            .hideDelay(3000)
        )
      });
    }

    function loadDettagli()
    {
      var params = {filter: {visitaId: vm.id}};
      angular.merge(params, vm.pagination);
      api.monitoraggio.dettaglio.query(params, function (res) {
        vm.dettagli = res.data;
        mostraSelezionati(res.data);
        vm.creatingDettaglio = false;
      });
    }

    function showRapportoDialog(ev, tipo)
    {
      $mdDialog.show({
        controller: 'RapportoDialogController',
        controllerAs: 'vmd',
        templateUrl: 'app/main/sprardb/monitoraggio/dialogs/show-rapporto.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dettaglio: vm.dettagliValidati[tipo]
        }
      });
    }

    function nuovoDettaglio()
    {
      var tipo = getTipoDettaglio();
      if (!tipo) {
        vm.showTipoSelect = true;
      } else {
        salvaDettaglio(tipo);
      }

    }

    function salvaDettaglio(tipo)
    {
      vm.creatingDettaglio = true;
      api.monitoraggio.dettaglio.save({visitaId: vm.id, tipo: $filter('lowercase')(tipo), expand:'primo'}, function(res) {
        if (res.primo) {
          loadVisita();
        } else {
          loadDettagli();
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent('Dettaglio aggiunto.')
            .position('bottom right')
            .hideDelay(2000)
        );
      });
    }

    function getTipoDettaglio()
    {
      var p = api.user.permissions;
      var amm = ['CONGIUNTO','AMMINISTRATIVO'].includes(vm.visita.tipo)
        && (vm.visita.tutorAmmId === api.user.id  || p.includes('add-checklist-uff-amm'));
      var qual = ['CONGIUNTO','QUALITATIVO'].includes(vm.visita.tipo)
        && (vm.visita.tutorQualId === api.user.id || p.includes('add-checklist-uff-qual'));

      if (amm && qual) return 'entrambi';
      if (amm) return 'amministrativo';
      if (qual) return 'qualitativo';
      return false;
    }

    function toggleSidenav(sidenavId)
    {
      $mdSidenav(sidenavId).toggle();
    }

    function initPagination()
    {
      vm.pagination.page = 1;
      vm.pagination['per-page'] = 10;
    }

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide();
    }

    function getCss() {
      return ".ql-indent-1:not(.ql-direction-rtl) {" +
        "padding-left: 3em;" +
        "}" +
        " li.ql-indent-1:not(.ql-direction-rtl) {" +
        "padding-left: 4.5em;" +
        "}" +
        ".ql-indent-1.ql-direction-rtl.ql-align-right {" +
        "padding-right: 3em;" +
        "}" +
        " li.ql-indent-1.ql-direction-rtl.ql-align-right {" +
        "padding-right: 4.5em;" +
        "}" +
        ".ql-indent-2:not(.ql-direction-rtl) {" +
        "padding-left: 6em;" +
        "}" +
        " li.ql-indent-2:not(.ql-direction-rtl) {" +
        "padding-left: 7.5em;" +
        "}" +
        ".ql-indent-2.ql-direction-rtl.ql-align-right {" +
        "padding-right: 6em;" +
        "}" +
        " li.ql-indent-2.ql-direction-rtl.ql-align-right {" +
        "padding-right: 7.5em;" +
        "}" +
        ".ql-indent-3:not(.ql-direction-rtl) {" +
        "padding-left: 9em;" +
        "}" +
        " li.ql-indent-3:not(.ql-direction-rtl) {" +
        "padding-left: 10.5em;" +
        "}" +
        ".ql-indent-3.ql-direction-rtl.ql-align-right {" +
        "padding-right: 9em;" +
        "}" +
        " li.ql-indent-3.ql-direction-rtl.ql-align-right {" +
        "padding-right: 10.5em;" +
        "}" +
        ".ql-indent-4:not(.ql-direction-rtl) {" +
        "padding-left: 12em;" +
        "}" +
        " li.ql-indent-4:not(.ql-direction-rtl) {" +
        "padding-left: 13.5em;" +
        "}" +
        ".ql-indent-4.ql-direction-rtl.ql-align-right {" +
        "padding-right: 12em;" +
        "}" +
        " li.ql-indent-4.ql-direction-rtl.ql-align-right {" +
        "padding-right: 13.5em;" +
        "}" +
        ".ql-indent-5:not(.ql-direction-rtl) {" +
        "padding-left: 15em;" +
        "}" +
        " li.ql-indent-5:not(.ql-direction-rtl) {" +
        "padding-left: 16.5em;" +
        "}" +
        ".ql-indent-5.ql-direction-rtl.ql-align-right {" +
        "padding-right: 15em;" +
        "}" +
        " li.ql-indent-5.ql-direction-rtl.ql-align-right {" +
        "padding-right: 16.5em;" +
        "}" +
        ".ql-indent-6:not(.ql-direction-rtl) {" +
        "padding-left: 18em;" +
        "}" +
        " li.ql-indent-6:not(.ql-direction-rtl) {" +
        "padding-left: 19.5em;" +
        "}" +
        ".ql-indent-6.ql-direction-rtl.ql-align-right {" +
        "padding-right: 18em;" +
        "}" +
        " li.ql-indent-6.ql-direction-rtl.ql-align-right {" +
        "padding-right: 19.5em;" +
        "}" +
        ".ql-indent-7:not(.ql-direction-rtl) {" +
        "padding-left: 21em;" +
        "}" +
        " li.ql-indent-7:not(.ql-direction-rtl) {" +
        "padding-left: 22.5em;" +
        "}" +
        ".ql-indent-7.ql-direction-rtl.ql-align-right {" +
        "padding-right: 21em;" +
        "}" +
        " li.ql-indent-7.ql-direction-rtl.ql-align-right {" +
        "padding-right: 22.5em;" +
        "}" +
        ".ql-indent-8:not(.ql-direction-rtl) {" +
        "padding-left: 24em;" +
        "}" +
        " li.ql-indent-8:not(.ql-direction-rtl) {" +
        "padding-left: 25.5em;" +
        "}" +
        ".ql-indent-8.ql-direction-rtl.ql-align-right {" +
        "padding-right: 24em;" +
        "}" +
        " li.ql-indent-8.ql-direction-rtl.ql-align-right {" +
        "padding-right: 25.5em;" +
        "}" +
        ".ql-indent-9:not(.ql-direction-rtl) {" +
        "padding-left: 27em;" +
        "}" +
        " li.ql-indent-9:not(.ql-direction-rtl) {" +
        "padding-left: 28.5em;" +
        "}" +
        ".ql-indent-9.ql-direction-rtl.ql-align-right {" +
        "padding-right: 27em;" +
        "}" +
        " li.ql-indent-9.ql-direction-rtl.ql-align-right {" +
        "padding-right: 28.5em;" +
        "}" +
        ".ql-video {" +
        "display: block;" +
        "max-width: 100%;" +
        "}" +
        ".ql-video.ql-align-center {" +
        "margin: 0 auto;" +
        "}" +
        ".ql-video.ql-align-right {" +
        "margin: 0 0 0 auto;" +
        "}" +
        ".ql-bg-black {" +
        "background-color: #000;" +
        "}" +
        ".ql-bg-red {" +
        "background-color: #e60000;" +
        "}" +
        ".ql-bg-orange {" +
        "background-color: #f90;" +
        "}" +
        ".ql-bg-yellow {" +
        "background-color: #ff0;" +
        "}" +
        ".ql-bg-green {" +
        "background-color: #008a00;" +
        "}" +
        ".ql-bg-blue {" +
        "background-color: #06c;" +
        "}" +
        ".ql-bg-purple {" +
        "background-color: #93f;" +
        "}" +
        ".ql-color-white {" +
        "color: #fff;" +
        "}" +
        ".ql-color-red {" +
        "color: #e60000;" +
        "}" +
        ".ql-color-orange {" +
        "color: #f90;" +
        "}" +
        ".ql-color-yellow {" +
        "color: #ff0;" +
        "}" +
        ".ql-color-green {" +
        "color: #008a00;" +
        "}" +
        ".ql-color-blue {" +
        "color: #06c;" +
        "}" +
        ".ql-color-purple {" +
        "color: #93f;" +
        "}" +
        ".ql-font-serif {" +
        "font-family: Georgia, Times New Roman, serif;" +
        "}" +
        ".ql-font-monospace {" +
        "font-family: Monaco, Courier New, monospace;" +
        "}" +
        ".ql-size-small {" +
        "font-size: 0.75em;" +
        "}" +
        ".ql-size-large {" +
        "font-size: 1.5em;" +
        "}" +
        ".ql-size-huge {" +
        "font-size: 2.5em;" +
        "}" +
        ".ql-direction-rtl {" +
        "direction: rtl;" +
        "text-align: inherit;" +
        "}" +
        ".ql-align-center {" +
        "text-align: center;" +
        "}" +
        ".ql-align-justify {" +
        "text-align: justify;" +
        "}" +
        ".ql-align-right {" +
        "text-align: right;" +
        "}" +
        ".ql-blank::before {" +
        "color: rgba(0,0,0,0.6);" +
        "content: attr(data-placeholder);" +
        "font-style: italic;" +
        "left: 15px;" +
        "pointer-events: none;" +
        "position: absolute;" +
        "right: 15px;}" +
        ".ql-editor p,\n" +
        ".ql-editor ol,\n" +
        ".ql-editor ul,\n" +
        ".ql-editor pre,\n" +
        ".ql-editor blockquote,\n" +
        ".ql-editor h1,\n" +
        ".ql-editor h2,\n" +
        ".ql-editor h3,\n" +
        ".ql-editor h4,\n" +
        ".ql-editor h5,\n" +
        ".ql-editor h6 {\n" +
        "  margin: 0;\n" +
        "  padding: 0;\n" +
        "  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n" +
        "}\n";
    }
  }

  /** @ngInject */
  function EsitoController($scope, $mdDialog, statoMonitoraggio, richieste) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;

    vmd.statoMonitoraggio = statoMonitoraggio;
    vmd.richieste = richieste;

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide(vmd.esitoId);
    }
  }

  /** @ngInject */
  function SegnalaController($scope, $mdDialog) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;

    vmd.data = new Date();

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide(vmd.data);
    }

  }

  /** @ngInject */
  function RapportoDialogController($scope, $mdDialog, dettaglio) {
    var vmd = this;

    vmd.cancelDialog = cancelDialog;
    vmd.hideDialog = hideDialog;
    vmd.copy = copy;

    vmd.dettaglio = dettaglio;

    function copy()
    {
      const type = "text/html";
      var dettaglioDaCopiare = vmd.dettaglio.rapporto;
      const blob = new Blob([dettaglioDaCopiare], { type });
      const data = [new ClipboardItem({ [type]: blob })];

      navigator.clipboard.write(data).then(
        () => {
          hideDialog()
        }
      );
    }

    function cancelDialog()
    {
      $mdDialog.cancel();
    }

    function hideDialog()
    {
      $mdDialog.hide();
    }

  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.monitoraggio')
    .controller('monitoraggioFormController', monitoraggioFormController)
    .directive('monitoraggioForm', monitoraggioForm);

  /** @ngInject */
  function monitoraggioFormController($scope, api)
  {
    var fc = this;

    fc.cambiaTipo = cambiaTipo;
    fc.disabled = disabled;
    fc.user = api.user;

    fc.quadrimestri = {1:'1° QUADRIMESTRE',2:'2° QUADRIMESTRE',3:'3° QUADRIMESTRE'};
    fc.semestri = {4:'1° SEMESTRE',5:'2° SEMESTRE'}
    fc.visita = $scope.ngModel;
    console.log(fc.visita);


    if (api.user.permissions.includes('view-tutor')) {
      api.monitoraggio.tutor.tutorAmministrativi({}, function (res) {
        fc.listaTutorAmministrativi = res;
        buildListaTutor();
      });
      api.monitoraggio.tutor.tutorQualitativi({}, function (res) {
        fc.listaTutorQualitativi = res;
        buildListaTutor();
      });
    }

    $scope.$watch('ngModel', function(visita){
      fc.visita = visita;

      if (visita?.$promise) {
        if (visita.$promise.resolved) {
          buildListaTutor();
        } else {
          visita.$promise.then(buildListaTutor);
        }
      }
    })

    function buildListaTutor()
    {
      fc.tutorAmministrativi = [];
      fc.tutorQualitativi = [];

      if (angular.isArray(fc.listaTutorAmministrativi)) {
        fc.tutorAmministrativi = fc.tutorAmministrativi.concat(fc.listaTutorAmministrativi);
      }
      if (angular.isArray(fc.listaTutorQualitativi)) {
        fc.tutorQualitativi = fc.tutorQualitativi.concat(fc.listaTutorQualitativi);
      }

      pushTutorAssegnato(fc.tutorAmministrativi, fc.visita?.tutorAmm);
      pushTutorAssegnato(fc.tutorQualitativi, fc.visita?.tutorQual);

    }

    console.log(fc.visita);
    function disabled(field) {
      
      if (!fc.visita?.safeAttributes) {
          return true;
      }
  
      return !fc.visita.safeAttributes.includes(field);
  }
  

    // function initData(visita)
    // {
    //   visita.data = visita.data ? new Date(visita.data) : new Date();
    //   calcolaQuadrimestre(visita.data);
    // }

    function pushTutorAssegnato(listaTutor, tutorAssegnato)
    {
      if (!tutorAssegnato) return listaTutor;
      var found = false;
      listaTutor.forEach(function(tutor) {
        if (tutor.id === tutorAssegnato.id) {
          found = true;
        }
      });

      return found ? listaTutor : listaTutor.push(tutorAssegnato);
    }

    function cambiaTipo()
    {
      fc.visita.tutorAmmId = null;
      fc.visita.tutorQualId = null;
    }

  }

  function monitoraggioForm($compile)
  {
    return {
      require: ['ngModel'],
      restrict: 'E',
      scope: {
        ngModel: '='
      },
      controller: 'monitoraggioFormController as fc',
      templateUrl: 'app/main/sprardb/monitoraggio/monitoraggio-form.html'
    };

  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('MonitoraggiController', MonitoraggiController)
        .controller('NuovoMonitoraggioController', NuovoMonitoraggioController);

  /** @ngInject */
  function MonitoraggiController($scope, $mdSidenav, $mdDialog, api,$mdToast,$location,$httpParamSerializer)
  {
    var vm = this;

    vm.toggleSidenav = toggleSidenav;
    vm.nuovoMonitoraggio = nuovoMonitoraggio;
    vm.loadMonitoraggi = loadMonitoraggi;
    vm.onSearch = onSearch;
    vm.controllaScadenza = controllaScadenza;
    vm.eliminaVisita = eliminaVisita;

    vm.api = api;
    vm.search = {
      sort: '-id',
      'per-page': 10,
      page: 1
    };
    vm.periodi = {1:'Q1',2:'Q2',3:'Q3',4:'S1',5:'S2'};
    var oggi = new Date();
    vm.dataOggi = moment(oggi).format('YYYY-MM-DD')
    vm.isCruscotto = false;

    var removeWatchFilter = $scope.$watch('vm.filter', function(newVal, oldVal, scope){
      vm.savedParams = $location.search();
      if(Object.keys(vm.savedParams).length > 0) {
        vm.search.page =  parseInt(vm.savedParams.page);
        vm.search['per-page'] = parseInt(vm.savedParams['per-page']);
        vm.search.sort = vm.savedParams.sort;
        vm.nomeSearch = vm.savedParams.nomeVisita;
        vm.codiceMinistero = vm.savedParams.codiceMinistero
      }
      if (vm.filter) { //vgiacomini: evita il caricamento prima che il filtro sia inizializzato
        onSearch();
      }
    })

    $scope.$on('$destroy', function(){
      removeWatchFilter();
    })

    function loadMonitoraggi()
    {
      var params = {filter: angular.copy(vm.filter)};

      if (vm.nomeSearch) {
        params.filter.and.push({or: [{nomeVisita: {xlike: vm.nomeSearch+'%'}},
          {nomeVisita: {like: ' '+vm.nomeSearch}}]});
      }
      if(vm.codiceMinistero) {
        params.filter.and.push({codiceMinistero: {like: vm.codiceMinistero}})
      }

      angular.merge(params, vm.search, {expand: 'progettoMonitoraggio.progetto, tutorAmm.persona, tutorQual.persona, periodoMonitoraggio'});
      vm.monitoraggi = api.monitoraggio.index(params,function(res){
        // vgiacomini: necessario per un bug paginazione md-data-table
        vm.totalCount = res._meta.totalCount;
      });

      console.log(vm.savedParams)
      $location.search(angular.merge($location.search(), {codiceMinistero: vm.codiceMinistero, nomeVisita: vm.nomeSearch}, vm.search));
    }

    function onSearch()
    {
      loadMonitoraggi();
    }

    function controllaScadenza(item) {
      if(item.dataScadenza) {
        // console.log(vm);
        // console.log(item);
        return item.statoId !== 4 && moment(item.dataScadenza).format('YYYY-MM-DD') <= vm.dataOggi
      }
      return false;
    }

    function toggleSidenav(sidenavId)
    {
        $mdSidenav(sidenavId).toggle();
    }

    vm.user = vm.api.user;


    function eliminaVisita(item) {
      // Mostra un messaggio di conferma
      var confirm = $mdDialog.confirm()
          .title('Conferma cancellazione')
          .textContent('Sei sicuro di voler eliminare la visita?')
          .ariaLabel('Conferma eliminazione')
          .ok('Sì, elimina')
          .cancel('Annulla');

      $mdDialog.show(confirm).then(function () {
          // Se l'utente conferma, procedi con l'eliminazione
          api.monitoraggio.remove({ id: item.id }, function (risposta) {
              // Gestisci la risposta dopo l'eliminazione con successo
              console.log('Visita eliminata con successo');
              $mdToast.show(
                  $mdToast.simple()
                      .textContent('Visita correttamente eliminata.')
                      .position('bottom right')
                      .hideDelay(5000)
              );
              loadMonitoraggi(); // Aggiorna la lista di monitoraggi dopo l'eliminazione
          }, function (errore) {
              // Gestisci l'errore durante l'eliminazione
              console.error('Errore durante l\'eliminazione della visita:', errore);
          });
      }, function () {
          // Se l'utente annulla, non fare nulla
          console.log('Cancellazione annullata');
      });
  }







    function nuovoMonitoraggio(ev)
    {
      $mdDialog.show({
          controller: 'NuovoMonitoraggioController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/monitoraggio/dialogs/new-monitoraggio.html',
          targetEvent: ev,
          clickOutsideToClose: true
      }).then(loadMonitoraggi);
    }
  }

  /** @ngInject */
  function NuovoMonitoraggioController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, msApi, $state, $mdMedia, api)
  {
    var vmd = this;
    vmd.close = close;
    vmd.cercaProgetti = cercaProgetti;
    vmd.cercaEnti = cercaEnti;
    vmd.caricaMonitoraggio = caricaMonitoraggio;
    vmd.salva = salva;

    vmd.anno = new Date().getFullYear();
    vmd.anni = [vmd.anno -1, vmd.anno, vmd.anno +1];

    function salva()
    {
      vmd.saving = true;
      var payload = {
        VisitaMonitoraggio: vmd.visita,
        ProgettoMonitoraggio: vmd.progettoMonitoraggio
      };

      if (vmd.progettoMonitoraggio.enteLocale === null) {
        payload.ProgettoMonitoraggio.enteLocale = vmd.progettoMonitoraggio.enteLocaleSearch;
      }

      api.monitoraggio.save(payload, function(response){
        $mdDialog.hide().then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent('Visita correttamente salvata.')
              .position('bottom right')
              .hideDelay(5000)
          )
        });
      });
    }

    function caricaMonitoraggio()
    {
      if (vmd.progetto) {
        vmd.progettoMonitoraggio = null;
        vmd.visita = null;

        api.monitoraggio.new({progettoId: vmd.progetto.id, anno: vmd.anno}, function(res) {
          vmd.progettoMonitoraggio = res.progettoMonitoraggio;
          vmd.progettoMonitoraggio.data = new Date(vmd.progettoMonitoraggio.data);
          vmd.progettoMonitoraggio.dataInizioFinanziamento = new Date(vmd.progettoMonitoraggio.dataInizioFinanziamento);
          vmd.progettoMonitoraggio.dataFineFinanziamento = new Date(vmd.progettoMonitoraggio.dataFineFinanziamento);

          vmd.visita = res.visita;
        });
      }
    }

    function cercaProgetti(nome)
    {
      if (vmd.progetti && vmd.progetti.$cancelRequest) {
        vmd.progetti.$cancelRequest();
      }
      var params = {
        filter: {
          or: [{nome: {xlike: nome+'%'}}, {nome: {like: ' '+nome}}],
          attivo: 1
        },
        fields: "id,nome",
        pagination: "-1",
        sort: "nome"
      }
      vmd.progetti = api.progettomc.query(params);
    }

    function cercaEnti(nome)
    {
      vmd.progettoMonitoraggio.enteLocale = null;
      if (vmd.nomiEnte && vmd.nomiEnte.$cancelRequest) {
        vmd.nomiEnte.$cancelRequest();
      }
      vmd.nomiEnte = api.monitoraggio.enti({nome: nome});
    }

    function close() {
      $mdDialog.cancel();
    }


  }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('DashboardMonitoraggioController', DashboardMonitoraggioController);

    /** @ngInject */
    function DashboardMonitoraggioController($scope, $mdSidenav, $interval, $mdDialog, api, $mdToast)
    {
      var vm = this;
      

      vm.checkRichieste = checkRichieste;
      vm.toggleSidenav = toggleSidenav;
      vm.loadMonitoraggi = loadMonitoraggi;
      vm.loadMonitoraggiAssegnati = loadMonitoraggiAssegnati;
      vm.loadMonitoraggiInLavorazione = loadMonitoraggiInLavorazione;
      vm.loadMonitoraggiDaConfermare = loadMonitoraggiDaConfermare;
      vm.loadMonitoraggiInAttesa = loadMonitoraggiInAttesa;
      vm.loadDettagli = loadDettagli;
      vm.controllaScadenza = controllaScadenza;

      vm.vistaTutor = api.user.permissions.includes('tutor-monitoraggio');
      vm.vistaSc = api.user.permissions.includes('sc-monitoraggio');

      var oggi = new Date();
      vm.dataOggi = moment(oggi).format('YYYY-MM-DD');

      vm.tipiDettaglio = {
        'CONGIUNTO': ['amministrativo','qualitativo'],
        'AMMINISTRATIVO': ['amministrativo'],
        'QUALITATIVO': ['qualitativo']
      };


      vm.elaborazioniDisplay = {};
      vm.periodi = {1:'Q1',2:'Q2',3:'Q3',4:'S1',5:'S2'};
      vm.search = {};
      vm.search.assegnati = initPagination();
      vm.search.inLavorazione = initPagination();
      vm.search.daConfermare = initPagination();
      vm.search.inAttesa = initPagination();
      vm.search.dettagli = initPagination();

      vm.monitoraggi = {};
      vm.totalCount = {};

      if (vm.vistaTutor) {
        loadMonitoraggiAssegnati();
        loadMonitoraggiInLavorazione();
        loadMonitoraggiInAttesa();
      }
      if (vm.vistaSc) {
        loadMonitoraggiDaConfermare();
        loadDettagli();
      }


      function checkRichieste(d)
      {
        d.disabled = true;
        var payload = {id: d.id, richieste: d.richieste, version: d.version}
        api.monitoraggio.dettaglio.save(payload, function(res) {
          loadDettagli();
        });
      }

      function loadMonitoraggi(tipo)
      {
        var filter = {
          assegnati: {and: [{statoId: [1]}, {or: [{tutorAmmId: [api.user.id]},{tutorQualId: [api.user.id]}]}]},
          inLavorazione: {and: [{statoId: [2]}, {or: [{tutorAmmId: [api.user.id]},{tutorQualId: [api.user.id]}]}]},
          inAttesa: {statoId: [3]},
          daConfermare: {daConfermare: 1}
        }
        var params = {
          filter: filter[tipo]
        };

        angular.merge(params, vm.search[tipo], {expand: 'progettoMonitoraggio.progetto,dettagli,periodoMonitoraggio,tutorAmm.persona, tutorQual.persona,'});
        return vm.monitoraggi[tipo] = api.monitoraggio.index(params,function(res){
          // vgiacomini: necessario per un bug paginazione md-data-table
          vm.totalCount[tipo] = res._meta.totalCount;
        });
      }

      function loadDettagli()
      {
        var params = {filter: {statoId: 15}}; //Stato Inviato

        angular.merge(params, vm.search.dettagli, {expand: 'visita.progettoMonitoraggio.progetto,owner.persona'});
        vm.dettagli = api.monitoraggio.dettaglio.query(params,function(res){
          // vgiacomini: necessario per un bug paginazione md-data-table
          vm.totalCount.dettagli = res._meta.totalCount;
        });
      }

      function initPagination()
      {
        return {
          sort: '-id',
          'per-page': 10,
          page: 1
        };
      }

      function loadMonitoraggiAssegnati()
      {
        loadMonitoraggi('assegnati');
      }

      function loadMonitoraggiInLavorazione()
      {
        loadMonitoraggi('inLavorazione').$promise.then(calcolaDisplayElaborazioni);
      }

      function loadMonitoraggiDaConfermare()
      {
        loadMonitoraggi('daConfermare');
      }

      function loadMonitoraggiInAttesa()
      {
        loadMonitoraggi('inAttesa');
      }

      function controllaScadenza(item) {
                 
            if(item.dataScadenza) {
            console.log(item); //stampa l'elemento corrente
            console.log(moment(item.dataScadenza).format('YYYY-MM-DD') <= vm.dataOggi);
            if(moment(item.dataScadenza).format('YYYY-MM-DD') <= vm.dataOggi){
              return true;
            }
            return false;
          }
          return false;
       
      }
      

      function calcolaDisplayElaborazioni(response)
      {
        const prio = {
          Validato: 0,
          Inviato: 1,
          Rifiutato: 2,
          Creato: 3
        }

        response.data.forEach(function(visita) {
          let rows = {
            amministrativo: {},
            qualitativo: {}
          };
          let ret = rows;

          visita.dettagli.forEach(function(dettaglio) {
            const tipo = dettaglio.tipo;
            // se per questo tipo esiste già un dettaglio VALIDATO ignoro tutti gli altri
            if (rows[tipo]['0VALIDATO'] === 1) return;

            const text = dettaglio.stato.descrizione;
            // key contiene il text dello stato più la priority in testa, così da poter fare il sort sotto
            const key = prio[text] + text;

            // se VALIDATO ignoro tutto gli altri stati, altrimenti conto le occorrenze di ciascuno stato
            if (text === 'Validato') {
              rows[tipo] = {[key]: 1};
            } else {
              rows[tipo][key] = (rows[tipo][key] || 0) +1;
            }
          });

          angular.forEach(rows, function(row, tipo) {
            ret[tipo] = Object.keys(row).sort().reduce(function(rowText, key, index){
              return rowText                                  // riga precedentemente prodotta
                + (index ? ',\xa0' : '')                      // se non è il primo statusText separa con virgola-spazio
                + key.substring(1)                            // scrivi lo statusText (senza la priority)
                + (row[key] > 1 ? '\xa0('+row[key]+')' : ''); // se esistono più occorrenze di statusText metti il conteggio
            }, '');
          })

          vm.elaborazioniDisplay[visita.id] = ret;
        })
      }
      /**
       * Toggle sidenav
       *
       * @param sidenavId
       */
      function toggleSidenav(sidenavId)
      {
        $mdSidenav(sidenavId).toggle();
      }
    }

})();

(function ()
{
  'use strict';

  angular
        .module('app.sprardb.monitoraggio')
        .controller('CruscottoMonitoraggioController', CruscottoMonitoraggioController);

    /** @ngInject */
    function CruscottoMonitoraggioController($scope, $mdSidenav, $interval, $mdDialog, api, $filter)
    {
      var vm = this;

      vm.toggleSidenav = toggleSidenav;
      vm.loadDashboard = loadDashboard;
      vm.exportCsv = exportCsv;
      vm.isNaN = isNaN;
      vm.exportSal = exportSal;
      vm.loadSal = loadSal;
      vm.isCruscotto = true;

      vm.anno = new Date().getFullYear();
      vm.anni = [vm.anno -1, vm.anno, vm.anno +1];
      vm.searchModel = {statoId: [3,4,5]}

      vm.nomeBreve = "S";
      vm.nMesiPeriodo = 2;
      vm.descrizione = "SEMESTRE";

      vm.pagination = {
        sort: 'codiceProgetto',
        'per-page': 10,
        page: 1
      };

      //
      // vm.colorMap = {
      //   6: '#588939',
      //   7: '#6fac47',
      //   8: '#b6d4a3',
      //   9: '#fddd7f',
      //   10: '#ef9c64'
      // };

      vm.barChart = {
        config : {
          refreshDataOnly: true,
          deepWatchData  : true
        },
        options: {
          chart: {
            type        : 'multiBarChart',
            color       : ['#1c3aff', '#ff8835', '#3c830e'],
            height      : 310,
            margin      : {
              top   : 8,
              right : 16,
              bottom: 32,
              left  : 16
            },
            clipEdge    : true,
            groupSpacing: 0.3,
            reduceXTicks: false,
            stacked     : false,
            duration    : 250,
            x           : function (d)
            {
              return d.x;
            },
            y           : function (d)
            {
              return d.y;
            },
            yAxis       : {
              tickFormat: d3.format("d")
            },
            legend      : {
              margin: {
                top   : 8,
                bottom: 32
              }
            },
            controls    : {
              margin: {
                top   : 8,
                bottom: 32
              }
            },
            tooltip     : {
              gravity: 's',
              classes: 'gravity-s'
            },
            controlLabels: {
              grouped: 'Separati',
              stacked: 'Sommati'
            }
          }
        },
        data   : []
      };
      var pieChart = {
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4'],
            height: 220,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            noData: 'Non ci sono dati',
            labelType: 'percent',
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            valueFormat: d3.format('d'),
            // legendPosition: 'right',
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          },
        }
      }

      vm.pieChart = {
        tipo: angular.merge({}, pieChart, {options: {title: {enable: true, text: 'TIPOLOGIA'}}}),

        stato: angular.merge({}, pieChart, {options: {
          chart: {color: undefined},
        }}),

        periodo: angular.merge({}, pieChart, {options: {
          chart: {color: ['#b7de9e', '#fddd7f', '#75c2e8']},
          title: {enable: true, text: 'PERIODO'}
        }}),
      }

      vm.esitoChartData = [];
      vm.giudizioChartData = [];
      vm.pieChartData = {};

      var expand = 'totaleProgettiMonitorati,totaleProgettiAttivi,totaleMonitoraggi,dettagli,dettagliProgettiMultipli,' +
        'stato,giudizio,esitoGeo,esitoTip,esitoPeriodo,periodoMonitoraggio';

      var removeWatchFilter = $scope.$watch('vm.filter', function(){
        if (vm.filter) { //vgiacomini: evita il caricamento prima che il filtro sia inizializzato
          loadDashboard();
        }
      })

      $scope.$on('$destroy', function(){
        removeWatchFilter();
      })

      function loadDashboard()
      {
        var params = {
          filter: angular.copy(vm.filter),
          anno: vm.anno,
          expand: expand
        };
        vm.dashboard = api.monitoraggio.dashboard(params, function(res) {
          if (res.scAccess) {
            loadSal();
          }
          let primoPeriodo = vm.dashboard.dettagli.periodi[0]
          vm.nomeBreve = primoPeriodo.nomeBreve
          vm.nMesiPeriodo = primoPeriodo.nMesiPeriodo
          vm.descrizione = primoPeriodo.descrizione
          buildGiudizioChartData(res);
          buildEsitoChartData(res);
          buildPieChartData(res);

          vm.tables = {
            riepilogo_numerico: {
              riepilogo_numerico: {
                columns: {
                  periodo: vm.descrizione,
                  strutture_totale: "N. strutture visitate",
                  giorni_totale: "N. giorni di visita",
                  monitoraggi_totale: "N. monitoraggi effettuati",
                  monitoraggiQual_totale: "di cui Qualitativi",
                  monitoraggiAmm_totale: "Amministrativi",
                  monitoraggiCong_totale: "Congiunti"
                }
              }
            },
            monitoraggi_composti: {
              monitoraggi_composti: {
                columns: {
                  nome: "Progetto",
                  categoria: "Categoria",
                  numeroVisite: "Visite",
                  ripartGeo: "Area"
                }
              }
            },
            tipologia_accoglienza: {
              monitoraggi: {
                columns: {
                  periodo: vm.descrizione,
                  monitoraggi_tipologia_Ordinari: "Ordinari",
                  monitoraggi_tipologia_MSNA: "MSNA",
                  'monitoraggi_tipologia_DM-DS': "DM-DS",
                }
              },
              progetti: {
                columns: {
                  periodo: vm.descrizione,
                  progetti_tipologia_Ordinari: "Ordinari",
                  progetti_tipologia_MSNA: "MSNA",
                  'progetti_tipologia_DM-DS': "DM-DS",
                }
              },
              visite: {
                columns: {
                  periodo: vm.descrizione,
                  visite_tipologia_Ordinari: "Ordinari",
                  visite_tipologia_MSNA: "MSNA",
                  'visite_tipologia_DM-DS': "DM-DS",
                }
              },
            },
            area_geografica: {
              monitoraggi: {
                columns: {
                  periodo: vm.descrizione,
                  monitoraggi_geo_Nord: "Nord",
                  monitoraggi_geo_Centro: "Centro",
                  'monitoraggi_geo_Sud-Isole': "Sud-Isole",
                }
              },
              progetti: {
                columns: {
                  periodo: vm.descrizione,
                  progetti_geo_Nord: "Nord",
                  progetti_geo_Centro: "Centro",
                  'progetti_geo_Sud-Isole': "Sud-Isole",
                }
              },
              visite: {
                columns: {
                  periodo: vm.descrizione,
                  visite_geo_Nord: "Nord",
                  visite_geo_Centro: "Centro",
                  'visite_geo_Sud-Isole': "Sud-Isole",
                }
              },
            },
            stato_visite: {
              Nord: {
                columns: generaColonneStato
              },
              Centro: {
                columns: generaColonneStato
              },
              'Sud-Isole': {
                columns: generaColonneStato
              },
            },
            valutazione_visite: {
              valutazione_visite: {
                columns: {
                  descrizioneBreve: "Andamento Progettuale",
                  Nord: "Nord",
                  Centro: "Centro",
                  'Sud-Isole': "Sud-Isole",
                }
              }
            },
            esito_visite: {
              periodi: {
                columns: {
                  descrizione: "Esito",

                }
              },
              area_geografica: {
                columns: {
                  descrizione: "Esito",
                  Nord: "Nord",
                  Centro: "Centro",
                  'Sud-Isole': "Sud-Isole",
                }
              },
              tipologia_accoglienza: {
                columns: {
                  descrizione: "Esito",
                  Ordinari: "Ordinari",
                  MSNA: "MSNA",
                  'DM-DS': "DM-DS",
                }
              },
            },
            sal: {
              sal: {
                columns: {
                  areaGeografica: "AREA GEOGRAFICA",
                  n: "N°",
                  codiceProgetto: "CODICE PROGETTO",
                  regione: "REGIONE",
                  siglaAut: "PROV",
                  enteLocale: "ENTE LOCALE TITOLARE",
                  categoria: "CATEGORIA",
                  numeroPosti: "NR POSTI",
                  data: {
                    label: "DATA MONITORAGGIO",
                    value: function (originalValue) {
                      return $filter('date')(originalValue, 'dd/MM/yyyy');
                    }
                  },
                  periodo: "PERIODO",
                  daRemoto: {
                    label: "IN LOCO / DISTANZA",
                    value: function (originalValue) {
                      return originalValue ? 'D' : 'L';
                    }
                  },
                  dataInvio: {
                    label: "DATA INVIO REPORT",
                    value: function (originalValue) {
                      return $filter('date')(originalValue, 'dd/MM/yyyy');
                    }
                  },
                  presenzaPrefettura: {
                    label: "VISITA CON PREFETT.",
                    value: function (originalValue) {
                      return originalValue ? 'Si' : 'No';
                    }
                  },
                  presenzaMinistero: {
                    label: "PRESENZA DLCI",
                    value: function (originalValue) {
                      return originalValue ? 'Si' : 'No';
                    }
                  },
                  stato: "STATO DEL MONITORAGGIO",
                  esito: "ESITO MONITORAGGIO",
                  numeroStruttureVisitate: "STRUTTURE VISITATE"
                }
              }
            }
          }

          switch (vm.descrizione) {
            case('SEMESTRE'):
              vm.tables.monitoraggi_composti.monitoraggi_composti.columns = {
                ...vm.tables.monitoraggi_composti.monitoraggi_composti.columns,
                monitoraggi_S1: "Monitoraggi S1",
                monitoraggi_S2: "Monitoraggi S2",
              }
              vm.tables.esito_visite.periodi.columns = {
                ...vm.tables.esito_visite.periodi.columns,
                S1: "S1",
                S2: "S2",
              }


              break;
            case('QUADRIMESTRE'):
              vm.tables.monitoraggi_composti.monitoraggi_composti.columns = {
                ...vm.tables.monitoraggi_composti.monitoraggi_composti.columns,
                monitoraggi_Q1: "Monitoraggi Q1",
                monitoraggi_Q2: "Monitoraggi Q2",
                monitoraggi_Q3: "Monitoraggi Q3"
              }
              vm.tables.esito_visite.periodi.columns = {
                ...vm.tables.esito_visite.periodi.columns,
                Q1: "Q1",
                Q2: "Q2",
                Q3: "Q3",
              }
              break;
          }

          vm.tables.riepilogo_numerico.riepilogo_numerico.data = res.dettagli.periodi;
          vm.tables.tipologia_accoglienza.data = res.dettagli.periodi;
          vm.tables.area_geografica.data = res.dettagli.periodi;
          vm.tables.monitoraggi_composti.data = res.dettagliProgettiMultipli;
          vm.tables.stato_visite.data = res.stato.periodi;
          vm.tables.valutazione_visite.data = res.giudizio.giudizi;
          vm.tables.esito_visite.periodi.data = res.esitoPeriodo.esiti;
          vm.tables.esito_visite.area_geografica.data = res.esitoGeo.esiti;
          vm.tables.esito_visite.tipologia_accoglienza.data = res.esitoTip.esiti;
        });
      }

      function loadSal()
      {
        var params = angular.merge({}, vm.pagination, {
          filter: angular.copy(vm.filter),
          anno: vm.anno
        });
        vm.sal = api.monitoraggio.sal(params, function(res) {
          vm.totalCount = res._meta.totalCount;
        });
      }

      function buildGiudizioChartData(res)
      {
        vm.giudizioChartData = [];
        angular.forEach(res.giudizio.columns, function(area){
          var obj = {key: area, values:[]};
          angular.forEach(res.giudizio.giudizi, function(giudizio) {
            obj.values.push({x: giudizio.descrizioneBreve, y: giudizio[area]});
          })
          vm.giudizioChartData.push(obj);
        })
      }

      function buildEsitoChartData(res)
      {
        vm.esitoChartData = [];
        angular.forEach(res.esitoTip.columns, function(tipologia){
          var obj = {key: tipologia, values:[]};
          angular.forEach(res.esitoTip.esiti, function(esito) {
            obj.values.push({x: esito.descrizione, y: esito[tipologia]});
          })
          vm.esitoChartData.push(obj);
        })
      }

      function buildPieChartData(res)
      {
        vm.pieChartData = {};
        vm.pieChartData.tipo = [
          {label: 'Amministrativo', value: res.dettagli.totali.monitoraggiAmm_totale},
          {label: 'Congiunto', value: res.dettagli.totali.monitoraggiCong_totale},
          {label: 'Qualitativo', value: res.dettagli.totali.monitoraggiQual_totale},
        ];

        vm.pieChartData.stato = [];
        angular.forEach(res.stato.columns, function(stato) {
            vm.pieChartData.stato.push({label: stato, value: res.stato.totali[stato]});
        });

        vm.pieChartData.periodo = [];
        angular.forEach(res.dettagli.periodi, function(periodo){
          vm.pieChartData.periodo.push({label: periodo.nomeBreve+periodo.periodo, value: periodo.monitoraggi_totale})
        })
      }

      /**
       * Toggle sidenav
       *
       * @param sidenavId
       */
      function toggleSidenav(sidenavId)
      {
        $mdSidenav(sidenavId).toggle();
      }

      function exportCsv(nome) {
        var wb = XLSX.utils.book_new();
        var columns = vm.tables[nome].columns;
        if (typeof columns === 'function') {
          columns = columns();
        }
        var data = vm.tables[nome].data;

        angular.forEach(vm.tables[nome], function(table, sheetName) {
          if (sheetName === 'data' || sheetName === 'columns') return;

          var sheetColumns = table.columns || columns;

          var ws = XLSX.utils.json_to_sheet([filterLabels(sheetColumns)], {skipHeader: true});
          ws = XLSX.utils.sheet_add_json(ws, filterData(table.data || data, sheetColumns), {origin: 'A2', skipHeader: true});
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
        })

        var date = moment(new Date()).format('_YYYY-MM-DD_hh.mm');
        XLSX.writeFile(wb, nome + date +".xlsx");
      }

      function exportSal()
      {
        var params = {
          filter: angular.copy(vm.filter),
          anno: vm.anno,
          'per-page': 0
        };

        api.monitoraggio.sal(params, function(res) {
          vm.tables.sal.sal.data = res.data;
          exportCsv('sal');
        });
      }

      function filterLabels(columns, sheetName)
      {
        if (typeof columns === 'function') {
          return columns(sheetName);
        }

        var ret = [];
        angular.forEach(columns, function (col, k) {
          if (angular.isObject(col)) {
            ret.push(col.label);
          } else {
            ret.push(col);
          }
        });
        return ret;
      }

      function filterData(data, columns)
      {
        var res = [];
        angular.forEach(data, function(row) {
          var r = {};
          angular.forEach(columns, function (col, k) {
            if (angular.isObject(col)) {
              r[k] = col.value(row[k]);
            } else {
              r[k] = row[k];
            }
          });
          res.push(r);
        });

        return res;
      }

      function generaColonneStato(sheetName)
      {
        var ret = {periodo: 'Periodo'};
        angular.forEach(vm.dashboard.stato.columns, function(col){
          ret[sheetName +'_'+ col] = col;
        })
        return ret;
      }


    }

})();

function DialogTemplateController($scope, $state, $mdDialog, Progetto, api, AllRuolo, index, AllEnteTipo, Regioni, newlink)
{
    var vmd = this;
    vmd.progetto_id = Progetto.id;
    vmd.index = index;
    vmd.progetto_nome = Progetto.nome;
    vmd.ente_id = null;
    vmd.ente_nome = null;
    vmd.entes = angular.copy(Progetto.entes);
    vmd.ente = {
        id: null,
        enteTipo_id: null,
        enteTipoPadre_id: null,
        nome: null,
        codRegione: null,
        codProvincia: null,
        codComune: null,
        indirizzo: null,
        cap: null,
        email: null,
        telefono: null,
        attivo: '1',
        enteruolos: [],
    };
    vmd.allentes = {};
    vmd.links = {};
    vmd.meta = {};
    vmd.isnewente = false;
    vmd.newlink = newlink;
    if (!vmd.newlink && vmd.index === null) {
        vmd.isnewente = true;
    }
    vmd.ruolosSelected = [];

    if (vmd.index !== null) {
        vmd.ente_id = Progetto.entes[index].id;
        vmd.ente_nome = Progetto.entes[index].nome;
        vmd.ente = angular.copy(Progetto.entes[index]);
        angular.forEach(vmd.ente.enteruolos, function (obj) {
            vmd.ruolosSelected.push(obj.id);
        });
    }
    vmd.allentetipos = AllEnteTipo.data;
    vmd.allruolo = AllRuolo.data;
    vmd.regiones = Regioni;
    vmd.provincias = [];
    vmd.istats = [];


    vmd.progettohasente = {
        progetto_id: vmd.progetto_id,
        ente_id: vmd.ente_id,
    };

    vmd.ricerca = {
        nome: null,
        enteTipo_id: null,
        codRegione: null,
    };
    vmd.enteselezionato = {
        id: null
    };


    vmd.save = save;
    vmd.delete = del;
    vmd.cercaEnte = cercaEnte;
    vmd.caricaProvince = caricaProvince;
    vmd.caricaComuni = caricaComuni;
    vmd.restituisciEnte = restituisciEnte;
    if (vmd.ente.codRegione !== null || vmd.ente.codRegione !== '') {
        //vmd.caricaProvince(vmd.ente.codRegione);
    }
    if (vmd.ente.codProvincia !== null || vmd.ente.codProvincia !== '') {
        //vmd.caricaComuni(vmd.ente.codProvincia);
    }

    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    function cercaEnte() {
        angular.forEach(vmd.ricerca, function (value, key) {
            if (value === null || value === 'null') {
                delete vmd.ricerca[key];
            }
        });
        if (Object.keys(vmd.ricerca).length > 0) {
            api.entes.ente.like(vmd.ricerca, function (response) {
                vmd.allentes = response.data;
                vmd.links = response._links;
                vmd.meta = response._meta;
            });
        } else {
            api.entes.ente.get({}, function (response) {
                vmd.allentes = response.data;
                vmd.links = response._links;
                vmd.meta = response._meta;
            });
        }
        //console.log(vmd.ricerca);
    }
    function restituisciEnte() {
        api.entes.ente.get({id: vmd.enteselezionato.id}, function (response) {
            vmd.enteselezionato = response;
            //console.log(vmd.enteselezionato);
        });
    }

    function caricaComuni(codprovincia) {
        api.istats.istat.cerca({codProvincia: codprovincia, pagination: 400}, function (response) {
            vmd.istats = response.data;
        });
    }
    function caricaProvince(codregione) {
        api.istats.province.get({codRegione: codregione}, function (response) {
            vmd.provincias = response.data;
        });
    }


    function save() {
        var payload = [];
        angular.forEach(vmd.entes, function (obj) {
            angular.forEach(obj.enteruolos, function (obj2) {
                var pushpayload = {
                    progetto_id: vmd.progetto_id,
                    ente_id: obj.id,
                    enteRuolo_id: obj2.id};
                payload.push(pushpayload);
            });
        });

        if (!vmd.isnewente && !vmd.newlink) {
            var newpayload = [];
            angular.forEach(payload, function (value, key) {
                if (value.ente_id !== vmd.enteselezionato.id) {
                    newpayload.push(value);
                }
            });
            payload = newpayload;
            vmd.newlink = true;
            //così rigenera i links della nuova asociazione
        }
        if (vmd.isnewente && !vmd.newlink) {
            api.entes.ente.save(vmd.ente, function (response) {
                angular.forEach(vmd.ruolosSelected, function (ruolo) {
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        ente_id: response.id,
                        enteRuolo_id: ruolo};
                    payload.push(pushpayload);
                });
                var hasmanyentes = {modelrelation: 'Progettohasente', idname: 'progetto_id', idvalue: vmd.progetto_id, idnamefk: 'ente_id', idnamefk2: 'enteRuolo_id', idnamePayload: 'ente_id', payload: payload};
                api.entes.ente.hasmany(hasmanyentes, function (response) {
                    console.log(response);
                    $state.reload();
                    $scope.hide();
                });
            });
        }

        if (vmd.newlink) {
            angular.forEach(vmd.ruolosSelected, function (ruolo) {
                var pushpayload = {
                    progetto_id: vmd.progetto_id,
                    ente_id: vmd.enteselezionato.id,
                    enteRuolo_id: ruolo};
                payload.push(pushpayload);
            });
            var hasmanyentes = {modelrelation: 'Progettohasente', idname: 'progetto_id', idvalue: vmd.progetto_id, idnamefk: 'ente_id', idnamefk2: 'enteRuolo_id', idnamePayload: 'ente_id', payload: payload};
            api.entes.ente.hasmany(hasmanyentes, function (response) {
                console.log(response);
                $state.reload();
                $scope.hide();
            });

        }
    }
    function del() {
        var confirm = $mdDialog.confirm()
                .title('Sei sicuro di voler cancellare questo collegamento?')
                .htmlContent('<b>' + vmd.ente_nome + '</b>' + ' sarà cancellato.')
                .ariaLabel('cancella ente')
                .ok('OK')
                .cancel('ABBANDONA');
        var alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Attenzione')
                .textContent('Non puoi rimuovere ultimo elemento.')
                .ariaLabel('Attenzione ultimo')
                .ok('OK');

        $mdDialog.show(confirm).then(function ()
        {
            vmd.entes.splice(vmd.index, 1);
            var payload = [];
            angular.forEach(vmd.entes, function (obj) {
                angular.forEach(obj.enteruolos, function (obj2) {
                    var pushpayload = {
                        progetto_id: vmd.progetto_id,
                        ente_id: obj.id,
                        enteRuolo_id: obj2.id};
                    payload.push(pushpayload);
                });
            });
            if (payload.length === 0) {
                $mdDialog.show(alert);
            }
            //console.log(payload);
            var hasmanyentes = {modelrelation: 'Progettohasente', idname: 'progetto_id', idvalue: vmd.progetto_id, idnamefk: 'ente_id', idnamefk2: 'enteRuolo_id', idnamePayload: 'progetto_id', payload: payload};
            api.entes.ente.hasmany(hasmanyentes, function (response) {
                console.log(response);
                $state.reload();
                $scope.hide();
            });
        }, function () {
        });

    }

    vmd.selectedItem = null;
    vmd.searchText = null;
    vmd.selectedItem2 = null;
    vmd.searchText2 = null;
    vmd.selectedItem3 = null;
    vmd.searchText3 = null;
    vmd.querySearch = querySearch;
    vmd.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
        // If it is an object, it's already a known chip
        if (angular.isObject(chip)) {
            return chip;
        }
        // Otherwise, create a new one
        return {name: chip, type: 'new'}
    }

    /**
     * Search for vegetables.
     */
    function querySearch(query, obj, nomecampo) {
        var results = query ? obj.filter(createFilterFor(query, nomecampo)) : [];
        return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query, nomecampo) {
        //var lowercaseQuery = angular.lowercase(query);

        return function filterFn(collection) {
            return (collection[nomecampo].indexOf(query) === 0);
        };

    }


}
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';
    angular.module('app.sprardb.eventi', []).config(config);
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {

        $stateProvider.state('app.sprardbEventi', {
            url: '/sprardb/eventis/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventi.html',
                    controller: 'EventisController as vm'
                }
            }
        });
        $stateProvider.state('app.segnalatienti', {
            url: '/sprardb/segnalatienti/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventi.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
                statoiniziale: ["2"]
            }
        });
        $stateProvider.state('app.segnalatiprogetto', {
            url: '/sprardb/segnalatiprogetto/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventi.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
              titolo:'Inseriti Da Autosegnalazione',
              statoiniziale: ["1"]
            }
        });
        $stateProvider.state('app.segnalatisc', {
          url: '/sprardb/segnalatisc/:eventoTipo_id',
          views: {
            'content@app': {
              templateUrl: 'app/main/sprardb/eventi/eventi.html',
              controller: 'EventisController as vm'
            }
          },
          datas: {
            titolo:'Inseriti da Lettera SC',
            statoiniziale: ["1"]
          }
        });

        $stateProvider.state('app.segnalatiterritorio', {
          url: '/sprardb/segnalatiterritorio/:eventoTipo_id/:segnalazioneId',
          views: {
            'content@app': {
              templateUrl: 'app/main/sprardb/eventi/eventi.html',
              controller: 'EventisController as vm'
            }
          },
          datas: {
            titolo:'Inseriti per presenza sul territorio',
            statoiniziale: ["1"]
          }
        });
        $stateProvider.state('app.segnalatiarrivo', {
            url: '/sprardb/segnalatiarrivo/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventi.html',
                    controller: 'EventisController as vm'
                }
            },
            datas: {
              titolo:'Arrivati',
              statoiniziale: ["2"]
            }
        });
        $stateProvider.state('app.segnalatirespinti', {
            url: '/sprardb/segnalatirespinti/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventi.html',
                    controller: 'EventisController as vm'
                }
            }
            ,
            datas: {
              titolo:'Rifiutati',
              statoiniziale: ["5", "6"]
            }
        });
        $stateProvider.state('app.sprardbEventib', {
            url: '/sprardb/eventibs/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/trasferimenti.html',
                    controller: 'ListaTrasferimentiController as vm'
                }
            },
            datas: {
              titolo:'Lavora Trasferimenti',
              statoiniziale: []
            }

        });
        $stateProvider.state('app.sprardbEventisg', {
            url: '/sprardb/eventisg/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventisg.html',
                    controller: 'EventisController as vm'
                }
            }

        });
        $stateProvider.state('app.sprardbEventip', {
            url: '/sprardb/eventip/:eventoTipo_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/eventi/eventipro.html',
                    controller: 'EventisController as vm'
                }
            }

        });

//locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        // Can change week display to start on Monday.
        $mdDateLocaleProvider.firstDayOfWeek = 1;


        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/eventi');
        // Api
        // Navigation

        msNavigationServiceProvider.saveItem('sprardb.eventi.csegnalazioni.segEnte', {
            title: 'Segnalati Enti seg',
            icon: 'icon-numeric-1-box',
            state: 'app.sprardbEventi({eventoTipo_id:1003})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.csegnalazioni.segProgetto', {
            title: 'Segnalati Auto-seg',
            icon: 'icon-numeric-2-box',
            state: 'app.sprardbEventi({eventoTipo_id:1002})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.csegnalazioni.segRif', {
            title: 'Segnalati Rifiutati',
            icon: 'icon-numeric-2-box',
            state: 'app.sprardbEventi({eventoTipo_id:1005})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.asegnalati.arrivoPro', {
            title: 'Segnalati arrivati',
            icon: 'icon-numeric-3-box',
            state: 'app.sprardbEventi({eventoTipo_id:1004})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.completaBeneficiario', {
            title: 'Da completare',
            icon: 'icon-numeric-4-box',
            state: 'app.sprardbEventib({eventoTipo_id:1007})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.rinunciaBeneficiario', {
            title: 'Rinunciatari',
            icon: 'icon-numeric-5-box',
            state: 'app.sprardbEventib({eventoTipo_id:1006})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.accoglienzab', {
            title: 'Accoglienza',
            icon: 'icon-numeric-6-box',
            state: 'app.sprardbEventib({eventoTipo_id:1009})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.uscitab', {
            title: 'Uscita',
            icon: 'icon-numeric-7-box',
            state: 'app.sprardbEventib({eventoTipo_id:1010})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.prorogab', {
            title: 'Proroga accoglienza',
            icon: 'icon-numeric-8-box',
            state: 'app.sprardbEventib({eventoTipo_id:1011})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.permessib', {
            title: 'Permessi',
            icon: 'icon-numeric-9-box',
            state: 'app.sprardbEventib({eventoTipo_id:1012})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cbeneficiari.trasferimento', {
            title: 'Trasferimento',
            icon: 'icon-numeric-1-box',
            state: 'app.sprardbEventib({eventoTipo_id:1013})',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('sprardb.eventi.statusg.richiedenteprotezione', {
            title: 'Tutti',
            icon: 'icon-numeric-0-box',
            state: 'app.sprardbEventisg({eventoTipo_id:"2000,2001,2002,2003,2004,2005"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.all', {
            title: 'Tutti',
            icon: 'icon-numeric-0-box',
            state: 'app.sprardbEventip({eventoTipo_id:"3000,3001,3002,3003,3004,3005,3006"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.completa', {
            title: 'Completa',
            icon: 'icon-numeric-1-box',
            state: 'app.sprardbEventip({eventoTipo_id:3000})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.istruttura', {
            title: 'Inserisci struttura',
            icon: 'icon-numeric-2-box',
            state: 'app.sprardbEventip({eventoTipo_id:3001})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.iqp', {
            title: 'Questura, Prefettura',
            icon: 'icon-numeric-3-box',
            state: 'app.sprardbEventip({eventoTipo_id:"3002,3003"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.ammprogetto', {
            title: 'Amm. Progetto',
            icon: 'icon-numeric-4-box',
            state: 'app.sprardbEventip({eventoTipo_id:3004})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.loginprogetto', {
            title: 'Login Progetto',
            icon: 'icon-numeric-5-box',
            state: 'app.sprardbEventip({eventoTipo_id:3005})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.cprogetti.personaleprogetto', {
            title: 'PErsonale Progetto',
            icon: 'icon-numeric-6-box',
            state: 'app.sprardbEventip({eventoTipo_id:3006})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi.preventivo', {
            title: 'Preventivi',
            icon: 'icon-numeric-1-box',
            state: 'app.sprardbEventip({eventoTipo_id:"4001,4005"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi.rimo', {
            title: 'Rimodulazioni',
            icon: 'icon-numeric-2-box',
            state: 'app.sprardbEventip({eventoTipo_id:"4002,4006"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi.rendi', {
            title: 'Rendicontazione finale',
            icon: 'icon-numeric-3-box',
            state: 'app.sprardbEventip({eventoTipo_id:"4003,4007"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi.allega', {
            title: 'Allega',
            icon: 'icon-numeric-4-box',
            state: 'app.sprardbEventip({eventoTipo_id:"4004,4008"})',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('sprardb.eventi.rendi.chiusura', {
            title: 'Chiusura',
            icon: 'icon-numeric-5-box',
            state: 'app.sprardbEventip({eventoTipo_id:4009})',
            weight: 1
        });

        //scadmin
        /*
         msNavigationServiceProvider.saveItem('scadmin.lavorazione_segnalati', {
         title: 'Lavorazione segnalati',
         weight: 10
         });

         msNavigationServiceProvider.saveItem('scadmin.lavorazione_progetti', {
         title: 'Lavorazione progetti',
         weight: 20
         });
         msNavigationServiceProvider.saveItem('scadmin.lavorazione_status', {
         title: 'Lavorazione status giuridico',
         weight: 30
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi', {
         title: 'Processi lavorazione',
         weight: 10000
         });

         msNavigationServiceProvider.saveItem('scadmin.lavorazione_segnalati.segEnte', {
         title: 'Segnalati Enti segn',
         icon: 'icon-human-child',
         state: 'app.segnalatienti({eventoTipo_id:1003})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.lavorazione_segnalati.segProgetto', {
         title: 'Segnalati auto-segn',
         icon: 'icon-human-child',
         state: 'app.segnalatiprogetto({eventoTipo_id:1002})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('scadmin.lavorazione_segnalati.arrivoPro', {
         title: 'Segnalati in arrivo',
         icon: 'icon-human-child',
         state: 'app.segnalatiarrivo({eventoTipo_id:1004})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('scadmin.lavorazione_segnalati.segRif', {
         title: 'Segnalati Rifiutati',
         icon: 'icon-human-child',
         state: 'app.segnalatirespinti({eventoTipo_id:1006})',
         weight: 4
         });

         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.completaBeneficiario', {
         title: 'Da completare',
         icon: 'icon-numeric-4-box',
         state: 'app.sprardbEventib({eventoTipo_id:1007})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.rinunciaBeneficiario', {
         title: 'Rinunciatari',
         icon: 'icon-numeric-5-box',
         state: 'app.sprardbEventib({eventoTipo_id:1006})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.accoglienzab', {
         title: 'Accoglienza',
         icon: 'icon-numeric-6-box',
         state: 'app.sprardbEventib({eventoTipo_id:1009})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.uscitab', {
         title: 'Uscita',
         icon: 'icon-numeric-7-box',
         state: 'app.sprardbEventib({eventoTipo_id:1010})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.prorogab', {
         title: 'Proroga accoglienza',
         icon: 'icon-numeric-8-box',
         state: 'app.sprardbEventib({eventoTipo_id:1011})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.permessib', {
         title: 'Permessi',
         icon: 'icon-numeric-9-box',
         state: 'app.sprardbEventib({eventoTipo_id:1012})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cbeneficiari.trasferimento', {
         title: 'Trasferimento',
         icon: 'icon-numeric-1-box',
         state: 'app.sprardbEventib({eventoTipo_id:1013})',
         weight: 1
         });

         msNavigationServiceProvider.saveItem('scadmin.eventi.statusg.richiedenteprotezione', {
         title: 'Tutti',
         icon: 'icon-numeric-0-box',
         state: 'app.sprardbEventisg({eventoTipo_id:"2000,2001,2002,2003,2004,2005"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.all', {
         title: 'Tutti',
         icon: 'icon-numeric-0-box',
         state: 'app.sprardbEventip({eventoTipo_id:"3000,3001,3002,3003,3004,3005,3006"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.completa', {
         title: 'Completa',
         icon: 'icon-numeric-1-box',
         state: 'app.sprardbEventip({eventoTipo_id:3000})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.istruttura', {
         title: 'Inserisci struttura',
         icon: 'icon-numeric-2-box',
         state: 'app.sprardbEventip({eventoTipo_id:3001})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.iqp', {
         title: 'Questura, Prefettura',
         icon: 'icon-numeric-3-box',
         state: 'app.sprardbEventip({eventoTipo_id:"3002,3003"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.ammprogetto', {
         title: 'Amm. Progetto',
         icon: 'icon-numeric-4-box',
         state: 'app.sprardbEventip({eventoTipo_id:3004})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.loginprogetto', {
         title: 'Login Progetto',
         icon: 'icon-numeric-5-box',
         state: 'app.sprardbEventip({eventoTipo_id:3005})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.cprogetti.personaleprogetto', {
         title: 'PErsonale Progetto',
         icon: 'icon-numeric-6-box',
         state: 'app.sprardbEventip({eventoTipo_id:3006})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.rendi.preventivo', {
         title: 'Preventivi',
         icon: 'icon-numeric-1-box',
         state: 'app.sprardbEventip({eventoTipo_id:"4001,4005"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.rendi.rimo', {
         title: 'Rimodulazioni',
         icon: 'icon-numeric-2-box',
         state: 'app.sprardbEventip({eventoTipo_id:"4002,4006"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.rendi.rendi', {
         title: 'Rendicontazione finale',
         icon: 'icon-numeric-3-box',
         state: 'app.sprardbEventip({eventoTipo_id:"4003,4007"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.rendi.allega', {
         title: 'Allega',
         icon: 'icon-numeric-4-box',
         state: 'app.sprardbEventip({eventoTipo_id:"4004,4008"})',
         weight: 1
         });
         msNavigationServiceProvider.saveItem('scadmin.eventi.rendi.chiusura', {
         title: 'Chiusura',
         icon: 'icon-numeric-5-box',
         state: 'app.sprardbEventip({eventoTipo_id:4009})',
         weight: 1
         });
         */

        /*
         //properatore
         msNavigationServiceProvider.saveItem('properatore.lavorazione_segnalati', {
         title: 'Lavorazione segnalati',
         weight: 10
         });
         msNavigationServiceProvider.saveItem('properatore.lavorazione_segnalati.segProgetto', {
         title: 'Segnalati auto-segn',
         icon: 'icon-human-child',
         state: 'app.segnalatiprogetto({eventoTipo_id:1002})',
         weight: 2
         });
         msNavigationServiceProvider.saveItem('properatore.lavorazione_segnalati.arrivoPro', {
         title: 'Segnalati in arrivo',
         icon: 'icon-human-child',
         state: 'app.segnalatiarrivo({eventoTipo_id:1004})',
         weight: 3
         });
         msNavigationServiceProvider.saveItem('properatore.lavorazione_segnalati.segRif', {
         title: 'Segnalati Rifiutati',
         icon: 'icon-human-child',
         state: 'app.segnalatirespinti({eventoTipo_id:1006})',
         weight: 4
         });
         */
    }
})();


(function ()
{
    'use strict';
    angular.module('app.sprardb.eventi')
            .controller('EventisController', EventisController)
            .controller('ListaTrasferimentiController', ListaTrasferimentiController)
            .controller('ProcessosController', ProcessosController)
            .controller('ProcessosController2', ProcessosController2)
            .controller('EventosDialogController', EventosDialogController)
            .controller('letteraDialogController', letteraDialogController)
            .controller('omonimoDialogController', omonimoDialogController)
            .controller('OmonimiController', OmonimiController)
            .controller('InserisciController', InserisciController)
            .controller('ConfermaTrasferimentoController', ConfermaTrasferimentoController)
            .controller('RifiutaController', RifiutaController);

    function EventisController($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, api, $filter, $mdToast, eventi, ricerca, acl, $cookieStore, $rootScope) {

        var vm = this;

        vm.isAdmin = api.isAdmin;
        vm.api = api;
        //vm.tipo = $state.current.datas.tipo;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly;
        vm.permissions = api.user.permissions;
        vm.canLavora = vm.permissions.indexOf('lavora-segnalato') !== -1;
        vm.isallowed = acl.isallowed2;
        vm.statoiniziale = ["1"];
        vm.searchForms = {
            "segnalaziones-ente_id_IN": {
                type: "string",
                title: "Ente Segnalatore",
                description: "Ente Segnalatore...",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-ente_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entesegnalatores",
                chiave: "id",
                valore: "nome|uppercase",
                novalore: "null"
            },
            "entes-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione",
                callbackModel: "ricerca",
                dbfield: "entes-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                novalore: "null",
                figlio: "entes-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "entes-codProvincia_IN": {
                type: "string",
                title: "Provincia ",
                description: "Provincia",
                callbackModel: "ricerca",
                dbfield: "entes-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "segnalaziones-idTipoSegnalazione_IN": {
                type: "string",
                title: "Modello Segnalazione",
                description: "Modello Segnalazione",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoall",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-nucleoFamiliare": {
                type: "string",
                title: "Tipo Accoglienza",
                description: "Tipo Accoglienza...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-nucleoFamiliare",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nucleoFamiliare",
                chiave: "codice",
                valore: "descrizione|uppercase"
            },
            "segnalatos-tipologia_id": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "segnalatos-tipologia_id",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "segnalatos-capof_id": {
                type: "string",
                title: "Identificativo Capofamiglia",
                description: "Identificativo Capofamiglia",
                callbackModel: "ricerca",
                dbfield: "segnalatos-capof_id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "segnalatos-omonimo": {
                type: "string",
                title: "Omonimo",
                description: "Omonimo...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-omonimoRisolto",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino3",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-codNazionalita": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-codNazionalita",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "segnalatos-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "daData": {
                type: "string",
                title: "Da Data",
                description: "Da data",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-data>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "aData": {
                type: "string",
                title: "A Data",
                description: "a data",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-data<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "segnalatos-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "segnalatos-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "eventoTipo_id_IN": {
                type: "string",
                title: "Tipo Processo",
                description: "Tipo Processo",
                callbackModel: "ricerca",
                dbfield: "eventoTipo_id_IN",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.tipoeventos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            }
        };
        vm.searchForms2 = {
            "beneficiarios-id": {
                type: "string",
                title: "Codice Beneficiario",
                description: "Codice Beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "beneficiarios-dataFine": {
                type: "string",
                title: "Fine beneficio",
                description: "Fine beneficio...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataFine",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase",
                novalore: "null"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            },
//            "beneficiarios-idTipoSegnalazione_IN": {
//                type: "string",
//                title: "Tipo Segnalazione",
//                description: "Tipo Segnalazione",
//                callbackModel: "ricerca",
//                dbfield: "beneficiarios-idTipoSegnalazione_IN",
//                formtype: "select",
//                multiple: true,
//                onchange: "vm.onSearch()",
//                data: "vm.tipoall",
//                chiave: "id",
//                valore: "descrizione|uppercase"
//            },
            "beneficiarios-nucleoFamiliare": {
                type: "string",
                title: "Tipo Accoglienza",
                description: "Tipo Accoglienza...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-nucleoFamiliare",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nucleoFamiliare",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-capof_id": {
                type: "string",
                title: "Identificativo Capofamiglia",
                description: "Identificativo Capofamiglia",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-capof_id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "beneficiarios-codNazionalita": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codNazionalita",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "beneficiarios-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInserimento": {
                type: "string",
                title: "Data Richiesta",
                description: "Data Richiesta",
                callbackModel: "ricerca",
                dbfield: "dataInserimento",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "beneficiarios-idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };
        vm.baseUrl = api.baseUrl;

        vm.searchForms1013 = {
            "id": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progetto2s-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progetto2s-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progetto2s-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progetto2s-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipologia_id_IN": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-tipologia_id_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "beneficiarios-codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-def_IN": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-def_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "beneficiarios-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "beneficiarios-dataIngresso>": {
                type: "string",
                title: "Data Ingresso",
                description: "Data Ingresso",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataIngresso>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataUscita<": {
                type: "string",
                title: "Data Uscita",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-id": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase",
                style: "display: none;"
            },
            "beneficiarios-cancellato_IN": {
              type: "string",
              title: "Cancellato",
              description: "Cancellato...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-cancellato_IN",
              multiple: true,
              style: "display:none;"
            }
        };
        vm.searchForms1010 = {
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progetto2s-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progetto2s-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progetto2s-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progetto2s-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-def_IN": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-def_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "beneficiarios-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "beneficiarios-dataIngresso>": {
                type: "string",
                title: "Data Ingresso",
                description: "Data Ingresso",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataIngresso>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataUscita<": {
                type: "string",
                title: "Data Uscita",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-id": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            }
        };

        vm.searchForms1011 = {
            "progettomcs-tipologiaAccoglienzaId_IN": {
                type: "string",
                title: "Tipologia Progetto",
                description: "Tipologia Progetto...",
                callbackModel: "ricerca",
                dbfield: "progettomcs-tipologiaAccoglienzaId_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipAccoglienza",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-codice": {
                type: "string",
                title: "Codice Beneficiario",
                description: "Codice Beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codice",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "beneficiarios-dataFine": {
                type: "string",
                title: "Fine beneficio",
                description: "Fine beneficio...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataFine",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "beneficiarios-tipologia_id": {
              type: "string",
              title: "Tipo Beneficiario",
              description: "Tipo Beneficiario...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-tipologia_id",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase",
                novalore: "null"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Lavorazione",
                description: "Stato Lavorazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            },
//            "beneficiarios-idTipoSegnalazione_IN": {
//                type: "string",
//                title: "Tipo Segnalazione",
//                description: "Tipo Segnalazione",
//                callbackModel: "ricerca",
//                dbfield: "beneficiarios-idTipoSegnalazione_IN",
//                formtype: "select",
//                multiple: true,
//                onchange: "vm.onSearch()",
//                data: "vm.tipoall",
//                chiave: "id",
//                valore: "descrizione|uppercase"
//            },
            "beneficiarios-nucleoFamiliare": {
                type: "string",
                title: "Tipo Accoglienza",
                description: "Tipo Accoglienza...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-nucleoFamiliare",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nucleoFamiliare",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-capof_id": {
                type: "string",
                title: "Identificativo Capofamiglia",
                description: "Identificativo Capofamiglia",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-capof_id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "beneficiarios-codNazionalita": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codNazionalita",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "beneficiarios-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInserimento": {
                type: "string",
                title: "Data Richiesta",
                description: "Data Richiesta",
                callbackModel: "ricerca",
                dbfield: "dataInserimento",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettomcs-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettomcs-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettomcs-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettomcs-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettomcs-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "beneficiarios-idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-cancellato_IN": {
              type: "string",
              title: "Cancellato",
              description: "Cancellato...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-cancellato_IN",
              multiple: true,
              style: "display:none;"
            }
        };

        vm.searchForms3 = {
            "eventoTipo_id_IN": {
              type: "string",
              title: "Tipo Segnalazione",
              description: "Tipo Segnalazione",
              callbackModel: "ricerca",
              dbfield: "eventoTipo_id_IN",
              formtype: "select",
              multiple: false,
              onchange: "vm.onSearch()",
              data: "vm.tipoeventos",
              chiave: "id",
              valore: "nome|uppercase"
            },
            "progettomcs-tipologiaAccoglienzaId_IN": {
              type: "string",
              title: "Tipologia Progetto",
              description: "Tipologia Progetto...",
              callbackModel: "ricerca",
              dbfield: "progettomcs-tipologiaAccoglienzaId_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipAccoglienza",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "segnalaziones-ente_id_IN": {
                type: "string",
                title: "Ente Segnalatore",
                description: "Ente Segnalatore...",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-ente_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entesegnalatores",
                chiave: "id",
                valore: "nome|uppercase",
                novalore: "null"
            },
            "progetto2s-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                novalore: "null",
                figlio: "progetto2s-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progetto2s-codProvincia_IN": {
                type: "string",
                title: "Provincia ",
                description: "Provincia",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "segnalaziones-idTipoSegnalazione_IN": {
                type: "string",
                title: "Modello Segnalazione",
                description: "Modello Segnalazione",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-idTipoSegnalazione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoall",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-tipologia_id": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "segnalatos-tipologia_id",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "segnalatos-nucleoFamiliare": {
                type: "string",
                title: "Tipo Accoglienza",
                description: "Tipo Accoglienza...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-nucleoFamiliare",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nucleoFamiliare",
                chiave: "codice",
                valore: "descrizione|uppercase"
            },
            "segnalatos-capof_id": {
                type: "string",
                title: "Identificativo Capofamiglia",
                description: "Identificativo Capofamiglia",
                callbackModel: "ricerca",
                dbfield: "segnalatos-capof_id",
                formtype: "text",
                onchange: "vm.onSearch()",
            },
            "segnalatos-omonimo": {
                type: "string",
                title: "Omonimo",
                description: "Omonimo...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-omonimoRisolto",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino3",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-codNazionalita": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-codNazionalita",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "segnalatos-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "segnalatos-progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "segnalatos-progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "daData": {
                type: "string",
                title: "Da Data",
                description: "Da data",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-data>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "aData": {
                type: "string",
                title: "A Data",
                description: "a data",
                callbackModel: "ricerca",
                dbfield: "segnalaziones-data<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "segnalatos-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "segnalatos-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "extra_LIKE": {
                type: "string",
                title: "Tipo di rifiuto",
                description: "Tipo rifiuto",
                callbackModel: "ricerca",
                dbfield: "extra_LIKE",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tiporifiuto",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase"
            }
        };

        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            console.log("searchforms:", searchvariable);
            console.log("origine:", origine);
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            console.log("dataOrigine:", dataOrigine);
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.segEnte = false;
        vm.segProgetto = false;
        vm.segArrivato = false;
        vm.benCompleta = false;
        vm.segCessato = false;
        vm.benProroga = false;

        if ($state.params.eventoTipo_id == 1002) {
            vm.segProgetto = true;
        }
        if ($state.params.eventoTipo_id == 1003) {
            vm.segProgetto = true;
        }
        if ($state.params.eventoTipo_id == 1004) {
            vm.segArrivato = true;
        }
        if ($state.params.eventoTipo_id == 1005) {
            vm.benCompleta = true;
        }
        if ($state.params.eventoTipo_id == 1006) {
            vm.segCessato = true;
        }
        if ($state.params.eventoTipo_id == 1011) {
            vm.benProroga = true;
            vm.statoiniziale = [$state.params.eventoStato_id];
            vm.searchForms = angular.copy(vm.searchForms1011);
            vm.datascadenza = ricerca.datascadenza;
        }
        if ($state.params.eventoTipo_id == 1010) {
            vm.searchForms = angular.copy(vm.searchForms1010);
        }
        if ($state.params.eventoTipo_id == 1002 || $state.params.eventoTipo_id == 1003 || $state.params.eventoTipo_id == 1004 || $state.params.eventoTipo_id == 1006) {
            vm.searchForms = angular.copy(vm.searchForms3);
        }
        vm.auto = false;
        if ($state.params.auto) {
            vm.auto = $state.params.auto;
        }

        if (angular.isDefined($state.current.datas)) {
            vm.datas = $state.current.datas;
            vm.statoiniziale = vm.datas.statoiniziale;
        }

        if ($state.params.eventoTipo_id == 1013) {
          vm.searchForms = angular.copy(vm.searchForms1013);
          if (vm.api.isOperatore) {
            vm.statoiniziale = ["3"];
          }
          if (vm.api.isAdmin || vm.api.isAccoglienza) {
            vm.statoiniziale = ["1"];
          }
        }

        vm.title = $state.current.datas.titolo;
        vm.selected = [];
        vm.options = {
            rowSelection: true,
            multiSelect: true,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: false,
            limitSelect: true,
            pageSelect: true
        };
        vm.search = null;

        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.autostart = false;
        //preselezione
        vm.prericerca = {operatore: 'AND'};
        vm.preselezione = $cookieStore.get('progetto_id');
        vm.eventoTipo_id = 0;
        if (angular.isDefined($state.params.eventoTipo_id)) {
            vm.eventoTipo_id = $state.params.eventoTipo_id;
            vm.autostart = true;
        }
        vm.prericerca['eventoTipo_id_IN'] = vm.eventoTipo_id;
        if (vm.statoiniziale.length > 0) {
            vm.prericerca['eventoStato_id_IN'] = vm.statoiniziale;
            vm.autostart = true;
        }
        var campo_progetto_id = "segnalatos-progetto_id_IN";
        if (vm.eventoTipo_id == 1011 || vm.eventoTipo_id == 1013) {
            vm.prericerca['beneficiarios-cancellato_IN'] = [0]
            campo_progetto_id = "progetto_id_IN";
        }
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.prericerca[campo_progetto_id] = [vm.preselezione.toString()];
            vm.autostart = true;
        }



        vm.notifications = [];
        vm.links = [];
        vm.meta = [];
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;
        vm.ricerca = {};
        vm.ricerca = angular.copy(vm.prericerca);



        vm.ricercalabel = {};
        vm.ricerca2 = "";
        vm.searched = false;
        vm.eventos = null;
        vm.notselectable = [];


        //ricerca variabili
        vm.sesso = ricerca.sesso;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        if (vm.api.isAdmin || vm.api.isAccoglienza) {
            vm.progettosa = ricerca.progettos;
        } else {
            vm.progettosa = ricerca.autorizzatoprogettos;
        }
        vm.nazioneb = ricerca.naziones;
        vm.tiposegnalazione = ricerca.tiposegnalazione;
        vm.tipoasegnalazione = ricerca.tipoasegnalazione;
        vm.nucleoFamiliare = ricerca.nucleoFamiliare;
        vm.tipoproteziones = ricerca.tipoprotezione;
        vm.motivoprorogas = ricerca.motivoprorogas;
        vm.vulnerabilitas = ricerca.vulnerabilita;
        vm.tipoall = angular.copy(vm.tiposegnalazione);
        angular.forEach(vm.tipoasegnalazione, function (tas) {
            vm.tipoall.push(tas);
        });
        vm.sino = ricerca.sino;
        vm.sino2 = [{id: ">1", descrizione: "SI"}];
        vm.sino3 = [{id: "-1", descrizione: "OMONIMO NON RISOLTO"}, {id: "0", descrizione: "NON OMONIMO"}, {id: "1", descrizione: "OMONIMO RISOLTO"}, {id: "2", descrizione: "OMONIMO RISOLTO POSTLOGIN"}];
        vm.tiporifiuto = [{id: '"tipoRifiuto":1', descrizione: "RIFIUTO SC"}, {id: '"tipoRifiuto":2', descrizione: "RIFIUTATO OMONIMIA"}];

        vm.ente1 = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        vm.entetipos = angular.copy(vm.ente1);
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        });
        vm.bandos = ricerca.bandos;
        vm.statoeventos_temp = angular.copy(ricerca.statoeventos);
        vm.statoeventos = [];
        vm.filtrostatoeventi = [-1, 1, 2, 3, 4, 5, 6, 20];
        console.log($state.params.segnalazioneId)

        if($state.params.segnalazioneId) {
            vm.allsearchs['query[]'][1]["segnalaziones-id"] = $state.params.segnalazioneId;
            console.log(vm.allsearchs);
        }
        if ($state.params.eventoTipo_id == 1011) {
            vm.filtrostatoeventi = [-1, 1, 2, 3, 4, 5];
        }
        angular.forEach(vm.statoeventos_temp, function (se) {
            if (vm.filtrostatoeventi.indexOf(se.id) !== -1) {
                if ($state.params.eventoTipo_id == 1011 && se.id == 3) {
                    se.stato = "IN PENDENZA";
                    vm.statoeventos.push(se);
                } else {
                    vm.statoeventos.push(se);
                }
            }
        });
        vm.tipoeventos_temp = [];
        vm.tipoeventos = [];
        api.eventos.tipo.search({sort: "id", pagination: 100, fields: "id,nome,statiPossibili,entita1,entita2"}, function (r) {
            vm.tipoeventos_temp = r.data;
            vm.filtroeventi = [1002, 1003, 1004, 1006];
            angular.forEach(vm.tipoeventos_temp, function (te) {
                if (vm.filtroeventi.indexOf(te.id) !== -1) {
                    vm.tipoeventos.push(te);
                }
            });
        });
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        })

        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipAccoglienza = res.data;
        });

        vm.loaditems = function (tiporicerca) {
            vm.searching = true;
            $rootScope.loadingProgress = true;
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "search";
            }

            if (vm.prequery !== null) {
                vm.prequery = angular.fromJson(vm.prequery);
                angular.forEach(vm.prequery, function (v, k) {
                    vm.allsearchs['query[]'][1][k] = v;
                    vm.ricerca[k] = v;
                });
            }
            console.log(vm.allsearchs)
            api.eventos.evento[tr](vm.allsearchs).$promise.then(function (d) {
                $rootScope.loadingProgress = false;
                vm.searching = false;
                vm.eventos = d.data;
                vm.meta = d._meta;
                vm.links = d._links;
                angular.forEach(vm.eventos, function (obj) {
                    //vm.title = JSON.parse(obj.eventoTipo.extra).title;
                    if (obj.extra) {
                        obj.extra = JSON.parse(obj.extra);
                    } else {
                        obj.extra = {};
                    }

                    obj.processi = obj.eventoTipo.processo.split("|");
                    if (obj.eventoStato_id < 4) {
                        vm.notselectable.push(obj.eventoTipo_id);
                    }
                    if(obj.eventoTipo_id === 1011) {
                      vm.giorniPermanenza = [];
                      angular.forEach(vm.eventos, function (evento) {
                        vm.giorniPermanenza[evento.id] = 0;
                        angular.forEach(evento.entita1.strutturahasbeneficiarios, function (struttura, index) {
                          let dataInizio = moment(struttura.dataInserimento);
                          let dataFine = struttura.dataCessazione ? moment(struttura.dataCessazione) : moment();
                          vm.giorniPermanenza[evento.id] += dataFine.diff(dataInizio, 'days');
                        })
                      })
                    }
                });
                vm.searched = true;
            });
            return vm.eventos;
        };

        vm.ricercaNome = null;
        vm.ricercaCognome = null;
        vm.ricercaCodice = null;
        vm.ricercaProgetti = null;
        vm.onSearch = onSearch;
        function onSearch() {
            var tiporicerca = 'search';

            vm.eventos = null;
            if ($state.params.eventoTipo_id >= 1000 && $state.params.eventoTipo_id <= 1006) {
              if (vm.ricercaNome){
                tiporicerca = 'like';
                vm.searchForms['segnalatos-nome'] = {title: 'Nome'};
                vm.ricerca['segnalatos-nome'] = vm.ricercaNome;
              }else{
                delete vm.ricerca['segnalatos-nome'];
              }
              if (vm.ricercaCognome){
                tiporicerca = 'like';
                vm.searchForms['segnalatos-cognome'] = {title: 'cognome'};
                vm.ricerca['segnalatos-cognome'] = vm.ricercaCognome;
              }else{
                delete vm.ricerca['segnalatos-cognome'];
              }
              if(vm.ricercaProgetti) {
                vm.searchForms['segnalatos-progetto_id'] = {title: 'Progetto'};
                vm.ricerca['segnalatos-progetto_id'] = vm.ricercaProgetti.id;
              } else{
                delete vm.ricerca['segnalatos-progetto_id'];
              }
              if (vm.ricercaCodice){
                vm.searchForms['segnalatos-id'] = {title: 'codice'};
                vm.ricerca['segnalatos-id'] = vm.ricercaCodice;
              }else{
                delete vm.ricerca['segnalatos-id'];
              }
            }
            if ($state.params.eventoTipo_id >= 1007 && $state.params.eventoTipo_id <= 2999) {
              if (vm.ricercaNome){
                tiporicerca = 'like';
                vm.searchForms['beneficiarios-nome'] = {title: 'nome'};
                vm.ricerca['beneficiarios-nome'] = vm.ricercaNome;
              }else{
                delete vm.ricerca['beneficiarios-nome'];
              }
              if (vm.ricercaCognome){
                tiporicerca = 'like';
                vm.searchForms['beneficiarios-cognome'] = {title: 'cognome'};
                vm.ricerca['beneficiarios-cognome'] = vm.ricercaCognome;
              }else{
                delete vm.ricerca['beneficiarios-cognome'];
              }
              if (vm.ricercaCodice){
                vm.searchForms['beneficiarios-codice'] = {title: 'codice'};
                vm.ricerca['beneficiarios-codice'] = vm.ricercaCodice;
              }else{
                delete vm.ricerca['beneficiarios-codice'];
              }
            }
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.allsearchs['query[]'][1] = {};
            vm.allsearchs['query[]'][1]['operatore'] = 'AND';
            console.log($state.params.segnalazioneId)
            if($state.params.segnalazioneId) {
              vm.allsearchs['query[]'][1]["segnalaziones-id"] = $state.params.segnalazioneId;
            }
            //vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
            if (vm.ricerca2) {
                tiporicerca = 'like';
                vm.allsearchs['query[]'][0].operatore = 'OR';
                console.log("eventoTipo:", $state.params.eventoTipo_id);
                if ($state.params.eventoTipo_id >= 1000 && $state.params.eventoTipo_id <= 1006) {
                    vm.allsearchs['query[]'][0]['segnalatos-nome'] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]['segnalatos-cognome'] = vm.ricerca2;
                }
                if ($state.params.eventoTipo_id >= 1007 && $state.params.eventoTipo_id <= 2999) {
                    vm.allsearchs['query[]'][0]['beneficiarios-nome'] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]['beneficiarios-cognome'] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]['beneficiarios-codice'] = vm.ricerca2;
                }
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            var pagingCorrente = {};
            pagingCorrente.page = vm.allsearchs.page;
            pagingCorrente.pagination = vm.allsearchs.pagination;
            pagingCorrente.sort = vm.allsearchs.sort;

            //console.log("controllo", $cookies.getObject('reload').reload);
            var reloadCookie = $cookies.getObject('reload');
            if (!reloadCookie || angular.isUndefined(reloadCookie)) {
                $cookies.putObject('ricerca-corrente', {ricerca: vm.ricerca, paginazione: pagingCorrente});
                vm.tempSearch = $cookies.getObject('ricerca-corrente');
                vm.ricerca = vm.tempSearch.ricerca;
                vm.allsearchs.page = vm.tempSearch.paginazione.page;
                vm.allsearchs.pagination = vm.tempSearch.paginazione.pagination;
                vm.allsearchs.sort = vm.tempSearch.paginazione.sort;

                $cookies.putObject('reload', false);
            } else {
                if ($cookies.getObject('ricerca-corrente')) {
                    vm.tempSearch = $cookies.getObject('ricerca-corrente');
                    vm.ricerca = vm.tempSearch.ricerca;
                    vm.allsearchs.page = vm.tempSearch.paginazione.page;
                    vm.allsearchs.pagination = vm.tempSearch.paginazione.pagination;
                    vm.allsearchs.sort = vm.tempSearch.paginazione.sort;
                }
                $cookies.putObject('reload', false);
            }

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
                if($state.params.segnalazioneId) {
                  vm.allsearchs['query[]'][1]["segnalaziones-id"] = $state.params.segnalazioneId;
                }
                if ($state.params.eventoTipo_id == 1004) {
                    vm.allsearchs['query[]'][1]['eventoStato_id_IN'] = ['4,2'];
                }
                if (angular.isUndefined(vm.ricerca['eventoTipo_id_IN'])) {
                    vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
                }
            }
            vm.loaditems(tiporicerca);
        }

        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.test = eventi.test;
        vm.work = eventi.work;
        vm.viewPerson = eventi.viewDetails;
        vm.letteraSeg = eventi.letteraSeg;
        vm.letteraIns = eventi.letteraIns;
        vm.letteraTrasf = eventi.letteraTrasf;
        vm.deletefiltersearch = deletefiltersearch;
        vm.trashSegnalato = trashSegnalato;
        vm.valuesearched = valuesearched;
        vm.dettaglisegnalato = dettaglisegnalato;
        vm.letteraDialog = letteraDialog;
        vm.mostras = mostras;
        vm.lavoraProroga = lavoraProroga;
        vm.eliminaProroga = eliminaProroga;
        vm.canLavoraSegnalato = canLavoraSegnalato;

        function canLavoraSegnalato(segnalato) {
          return vm.permissions.includes('lavora-segnalato-all') || (segnalato.omonimo === 2 && vm.permissions.includes('lavora-segnalato-territorio'))
        }

        function lavoraProroga(model, action)
        {
          $mdDialog.show({
            controller: 'ProrogaDialogController',
            controllerAs: 'vmd',
            bindToController: true,
            templateUrl: 'app/main/sprardb/proroghe/dialogs/proroga.dialog.html',
            clickOutsideToClose: false,
            locals: {
              action: action,
              model: model
            }
          }).then(onSearch);
        }



        function eliminaProroga(model, action) {
            // Chiamata diretta alla funzione eliminaProroga di ProrogaDialogController
            console.log(model.id);

            var confirm = $mdDialog.confirm()
                .title('Conferma eliminazione proroga')
                .textContent('Sei sicuro di voler eliminare questa proroga?')
                .ok('Elimina')
                .cancel('Annulla');

            $mdDialog.show(confirm).then(function() {
                api.proroga.delete({ id: model.id }, function(response) {
                $mdToast.show($mdToast.simple()
                .textContent('Proroga Eliminata.')
                .position('bottom right')
                .hideDelay(3000));
                $mdDialog.hide();
                $state.reload();
                }, function(error) {
                console.error('Errore durante l\'eliminazione della proroga:', error);
                });
            });
        }



        function mostras(eventos) {
            var results = true;
            if (eventos.eventoTipo_id == 1004 && eventos.eventoStato_id == 1 && !(vm.api.isAdmin || vm.api.isAccoglienza)) {
                results = false;
            }
            return results;
        }
// da cancellare
        function viewPerson(event, eventos, tipo) {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'EventosDialogController',
                controllerAs: 'vm',
                focusOnOpen: false,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {
                    item: eventos,
                    tipo: tipo},
                templateUrl: 'app/main/sprardb/eventi/dialogs/eventi-dialog.html',
            }).then(function (segnalati) {

            });
        }
        function work(event, segnalato, processo, trigger, isnew) {
            var extrasetup = {};
            var callback = {};
            var segnalatos = [];
            if (angular.isArray(segnalato)) {
                segnalatos = segnalato;
                extrasetup = JSON.parse(segnalato[0].eventoTipo.extra);
                callback = JSON.parse(segnalato[0].eventoTipo.callback);
            } else {
                segnalatos.push(segnalato);
                extrasetup = JSON.parse(segnalato.eventoTipo.extra);
                callback = JSON.parse(segnalato.eventoTipo.callback);
            }

            var formDefinition = extrasetup.properties[processo].fields;
            var title = extrasetup.properties[processo].title;
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'ProcessosController',
                controllerAs: 'vm',
                focusOnOpen: true,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {
                    segnalati: segnalatos,
                    formDefinition: formDefinition,
                    title: title,
                    eventoStato_id: processo
                },
                templateUrl: 'app/main/sprardb/eventi/dialogs/processosc.html',
            });
        }

        function trashSegnalato(index, segnalato) {

            vm.progress = true;
            var confirm = $mdDialog.confirm()
                    .title('Cancellazione')
                    .textContent('Vuoi cancellare il segnalato?')
                    .ariaLabel('Confirmmation Box')
                    .ok('Si')
                    .cancel('No');

            $mdDialog.show(confirm).then(function () {

                if (angular.isUndefined(segnalato.entita1_id)) {
                    vm.progress = false;
                    return;
                }
                api.segnalatos.segnalato.elimina({id:segnalato.entita1_id},function () {
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Segnalato cancellato!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  var index = vm.eventos.indexOf(segnalato);
                  vm.eventos.splice(index,1);
                  vm.progress = false;
                },function(){
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('Errore nella cancellazione del segnalato!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
                  vm.progress = false;
                });
            }, function () {
                vm.progress = false;
            });
        }

        function letteraSeg(event, segnalazione_id) {
            //console.log(segnalazione_id);
            var notification = null;
            api.segnalaziones.segnalazione.get({id: segnalazione_id}, function (d) {
                notification = d;
                var tabaledata = [];
                tabaledata.push([{text: 'Nome', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = notification.segnalatos;
                for (var i = 0; i < json.length; i++) {
                    var obj = json[i];
                    var tmpobj = {};
                    tmpobj.nome = (obj.nome !== null) ? obj.nome : "";
                    tmpobj.cognome = (obj.cognome !== null) ? obj.cognome : "";
                    tmpobj.sesso = (obj.sesso !== null) ? obj.sesso : "";
                    tmpobj.dataNascita = (obj.dataNascita !== null) ? obj.dataNascita : "";
                    tmpobj.note = (obj.note !== null) ? obj.note : "";
                    tmpobj.noteSanitarie = (obj.noteSanitarie !== null) ? obj.noteSanitarie : "";
                    tmpobj.nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
//                    if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
//                        var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tabaledata.push([tmpobj.nome, tmpobj.cognome, tmpobj.sesso, tmpobj.dataNascita, tmpobj.nation, tmpobj.note, tmpobj.noteSanitarie]);
                    // }
                }
                console.log(tabaledata);
                console.log(notification);
                var docDefinition = {
                    content: [
                        {text: 'Lettera Inserimento', style: 'header'},
                        {text: 'MODELLO ' + notification.tipo, style: 'header'},
                        {text: '\n', style: 'header'},
                        {text: 'Da:', style: 'headerright'},
                        {text: notification.entes.nome, style: 'headerrightb'},
                        {text: notification.entes.entetipo.descrizione, style: 'headerright'},
                        {text: (notification.entes.indirizzo !== null) ? notification.entes.indirizzo : 'NA', style: 'headerright'},
                        {text: (notification.entes.cap !== null) ? notification.entes.cap : 'NA', style: 'headerright'},
                        {text: (notification.entes.email !== null) ? notification.entes.email : 'NA', style: 'headerright'},
                        {text: (notification.entes.telefono !== null) ? notification.entes.telefono : 'NA', style: 'headerright'},
                        {text: '\n', style: 'headerright'},
                        {text: 'A:', style: 'headerright'},
                        {text: 'Servizio Centrale', style: 'headerrightb'},
                        {text: '\n', style: 'headerright'},
                        {text: 'Cc:', style: 'headerright'},
                        {text: '\n', style: 'headerright'},
                        {text: ['Data : ', {text: (notification.data !== null) ? notification.data : ''}]},
                        {text: ['Tipo segnalazione : ', {text: (notification.tipo !== null) ? notification.tipo : ''}]},
                        {text: ['Note : ', {text: (notification.note !== null) ? notification.note : ''}]},
                        {text: '\n', style: 'headerright'},
                        {text: '\n', style: 'headerright'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                body: tabaledata
                            },
                            layout: 'lightHorizontalLines'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 9,
                            alignment: 'right'
                        },
                        headerrightb: {
                            fontSize: 13,
                            alignment: 'right',
                            bold: true,
                        },
                        demoTable: {
                            margin: [0, 10, 0, 10]

                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 12,
                            color: 'black'
                        }
                    },
                };
                pdfMake.createPdf(docDefinition).download("letteraSegnalazione_" + notification.id + '.pdf');
            });
        }
        function letteraIns(event, letterainserimento) {
            var segs = null;
            api.segnalatos.segnalato.search({letteraInserimento: letterainserimento}, function (d) {
                segs = d.data;
                var tabaledata = [];
                tabaledata.push([{text: 'Nome', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = segs;
                var jsonfields = ['nome', 'cognome', 'sesso', 'dataNascita', ['codNazionalitas', 'descrizione'], 'note', 'noteSanitarie'];
                angular.forEach(json, function (sjson) {
                    var tmp = [];
                    angular.forEach(jsonfields, function (jsonfield) {
                        var eacht = jsonfield;
                        if (angular.isArray(jsonfield)) {
                            var ttmp = sjson;
                            eacht = '';
                            angular.forEach(jsonfield, function (each) {
                                if (typeof ttmp[each] === undefined) {
                                    ttmp[each] = {};
                                }
                                ttmp = ttmp[each];
                                eacht = eacht + "_" + each;
                            });
                            //tmp.push((ttmp !== null) ? ttmp : "");
                            tmp[eacht] = (ttmp !== null) ? ttmp : " ";
                        } else {
                            //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
                            tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
                        }
                    });
                    tabaledata.push([tmp.nome, tmp.cognome, tmp.sesso, tmp.dataNascita, tmp['_codNazionalitas_descrizione'], tmp.note, tmp.noteSanitarie]);
                });
                console.log(tabaledata);
//                for (var i = 0; i < json.length; i++) {
//                    var obj = json[i];
//                    console.log(obj);
////                    if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
//                    var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
//                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
//                    tabaledata.push([obj.nome, obj.cognome, obj.sesso, obj.dataNascita, nation, obj.note, obj.noteSanitarie]);
////                    }
//                }
                var enti = [];
                var enteprint = [];
                var entes = null;
                if (segs[0].letterai) {
                    enti.push(segs[0].letterai.ente1_id);
                    enti.push(segs[0].letterai.ente2_id);
                    enti.push(segs[0].letterai.ente3_id);
                    enti.push(segs[0].letterai.ente4_id);
                    enti.push(segs[0].letterai.ente5_id);
                    enti.push(segs[0].letterai.ente6_id);
                } else {
                    enti.push(null);
                    enti.push(null);
                    enti.push(null);
                    enti.push(null);
                }
                api.entes.ente.search({id_IN: enti.join()}, function (d) {
                    entes = d.data;
                    angular.forEach(entes, function (obj) {
                        enteprint.push(
                                {text: obj.nome, style: 'headerrightb'},
                                {text: (obj.entetipo.descrizione !== null) ? obj.entetipo.descrizione : 'NA', style: 'headerright'},
                                {text: (obj.indirizzo !== null) ? obj.indirizzo : 'NA', style: 'headerright'},
                                {text: (obj.cap !== null) ? obj.cap : 'NA', style: 'headerright'},
                                {text: (obj.email !== null) ? obj.email : 'NA', style: 'headerright'},
                                {text: (obj.telefono !== null) ? obj.telefono : 'NA', style: 'headerright'},
                                {text: '\n', style: 'headerright'}
                        );
                    });
                    var docDefinition = {
                        content: [
                            {text: 'Lettera Inserimento', style: 'header'},
                            {text: '(intestazione grafica)', style: 'headerright'},
                            {text: '\n', style: 'header'},
                            {text: 'epc:', style: 'headercenter'},
                            {text: '\n', style: 'headerright'},
                            enteprint,
                            {text: '\n', style: 'text'},
                            {text: 'Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...', style: 'text'},
                            {text: '\n', style: 'text'},
                            {
                                style: 'demoTable',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                    body: tabaledata
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {text: '\n', style: 'text'},
                            {text: 'Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...', style: 'text'}
                        ],
                        styles: {
                            text: {
                                fontSize: 9,
                                alignment: 'left'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            headerright: {
                                fontSize: 9,
                                alignment: 'right'
                            },
                            headercenter: {
                                fontSize: 9,
                                alignment: 'center'
                            },
                            headerrightb: {
                                fontSize: 13,
                                alignment: 'right',
                                bold: true,
                            },
                            demoTable: {
                                margin: [0, 10, 0, 10]

                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 12,
                                color: 'black'
                            }
                        },
                    };
                    pdfMake.createPdf(docDefinition).download("letteraInserimento_" + letterainserimento + '.pdf');
                });
            });
        }
        function deletefiltersearch(key) {
            if (key == 'beneficiarios-nome' || key == 'segnalatos-nome'){
              vm.ricercaNome = null;
            }
            if (key == 'beneficiarios-cognome' || key == 'segnalatos-cognome'){
              vm.ricercaCognome = null;
            }
            if (key == 'beneficiarios-codice' || key == 'segnalatos-id'){
              vm.ricercaCodice = null;
            }
            if (key == 'beneficiarios-progetto_id' || key == 'segnalatos-progetto_id'){
              vm.ricercaProgetti = null;
            }
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            var isNumb = false;
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli";
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
                if (angular.isNumber(parseInt(valore))) {
                    valore = parseInt(valore);
                    isNumb = true;
                }
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;

            var jsonfilter = {};
            var jsonfilterT = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            var jsonfilterN = JSON.parse('{"' + chiave + '":' + valore + '}');
            jsonfilter = jsonfilterT;
            if (isNumb) {
                jsonfilter = jsonfilterN;
            }
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter, function(expected, actual) {return expected == actual});


            var valores = vm.searchForms[key].valore.split("|");

            return results[0][valores[0]];
        }


        function dettaglisegnalato(item) {
            $mdDialog.show({
                controllerAs: 'vm',
                clickOutsideToClose: true,
                controller: 'NotificatioPersonaAddController',
                focusOnOpen: false,
                locals: {
                    minori: (item.entita1.segnalazione.idTipoSegnalazione === 607),
                    isnew: false,
                    nucleoFamiliare: true,
                    segnalato: item.entita1,
                    readonly: true
                },
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                templateUrl: 'app/main/sprardb/notification/dialogs/notification/add-dialog.html',
            })
        }

        function letteraDialog($event, letterainserimento) {


            api.segnalatos.segnalatomag.search({letteraInserimento: letterainserimento}, function (d) {
                var segnalatos = d.data;
                var segnalaziones = d.data[0].segnalaziones;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    //console.log("renderizzato", renderizzato);
                    //delete renderizzato["nota0"];
                    console.log("renderizzato", renderizzato);
                    var templater = rend.template.split("|");
                    //console.log("templater", templater);
                    //delete templater[0];
                    console.log("templater", templater);
                    var etichette = [];
                    etichette["ente1"] = "ente segnalatore/ente titolare auto";
                    etichette["ente2"] = "prefettura ente segnalatore/auto";
                    etichette["ente3"] = "ministero degli interni";
                    etichette["ente4"] = "ente titolare";
                    etichette["ente5"] = "ente gestore";
                    etichette["ente6"] = "prefettura ente titolare";
                    etichette["ente7"] = "ente titolare partenza";
                    etichette["ente8"] = "prefettura ente titolare partenza";
                    etichette["ente9"] = "ente gestore partenza";
                    etichette["nota1"] = "Nota dopo mittente";
                    etichette["nota2"] = "Nota dopo EPC";
                    etichette["nota3"] = "Oggetto";
                    etichette["nota4"] = "Nota dopo tabella";
                    etichette["nota5"] = "Note chiusura";
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'letteraDialogController',
                        controllerAs: 'vm',
                        focusOnOpen: false,
                        locals: {
                            segnalatos: segnalatos,
                            segnalaziones: segnalaziones,
                            renderizzato: renderizzato,
                            templater: templater,
                            etichette: etichette,
                        },
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: event,
                        templateUrl: 'app/main/sprardb/eventi/dialogs/lettera-dialog.html',
                    }).then(function (renderizzatoresponse) {
                        api.letterainserimentors.letterainserimentor.aggiorna(renderizzatoresponse, function (s) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Lettera inserimento modificata con successo!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    );
                        });
                    });
                });
            });
        }

        vm.omonimi = omonimi;
        function omonimi(item){
          api.segnalatos.segnalato.omonimia(item,function (res) {
            var omonimi = res.data;
            $mdDialog.show({
              controller: 'OmonimiController',
              controllerAs: 'vmd',
              templateUrl: 'app/main/sprardb/eventi/dialogs/omonimi.html',
              clickOutsideToClose: true,
              locals: {
                omonimi : omonimi,
                item : item
              }
            }).then(function () {
              vm.loaditems();
            });
          })
        }

      vm.nuovoinserimento = nuovoinserimento;
      function nuovoinserimento(segnalato) {
        $mdDialog.show({
          controller: 'InserisciController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/eventi/dialogs/inserisci-segnalato.html',
          clickOutsideToClose: true,
          locals: {
            segnalati : [segnalato.entita1],
          }
        }).then(function (eventoRisposta) {
          if (eventoRisposta){
            api.segnalatos.segnalato.inserisciBeneficiario({id:segnalato.entita1.id,note:eventoRisposta.note,dataInizio:eventoRisposta.dataInizio},function(res){
              var index = vm.eventos.indexOf(segnalato);
              vm.eventos.splice(index,1);
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Il segnalato è stato lavorato correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            })
          }
        });
      }

      vm.rifiutasegnalato = rifiutaSegnalato;
      function rifiutaSegnalato(evento) {
        $mdDialog.show({
          controller: 'RifiutaController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/eventi/dialogs/rifiuta-segnalato.html',
          clickOutsideToClose: true,
          locals: {
            segnalati : evento,
          }
        }).then(function (res) {
          if (res){
            api.segnalatos.segnalato.rifiutaSegnalato({id:evento.entita1_id,tipoRifiuto:res.tipoRifiuto,noteRifiuto:res.noteRifiuto},function(res){
              var index=vm.eventos.indexOf(evento);
              vm.eventos.splice(index,1);
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Il segnalato è stato rifiutato correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            })
          }
        });
      }

      vm.accettaMultipli = accettaMultipli;
      function accettaMultipli(eventi){
        var segnalati = [];
        angular.forEach(eventi, function(evento) {
          segnalati.push(evento.entita1);
        })
        $mdDialog.show({
          controller: 'InserisciController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/eventi/dialogs/inserisci-segnalato.html',
          clickOutsideToClose: true,
          locals: {
            segnalati : segnalati,
          }
        }).then(function(attributes){
          if (attributes){
            api.segnalatos.segnalato.accettaMultipli({eventi:eventi,note:attributes.note,dataInizio:attributes.dataInizio},function(res){
              angular.forEach(eventi,function (value, key) {
                var index = vm.eventos.indexOf(value);
                vm.eventos.splice(index,1);
                vm.selected = [];
              })
              $mdToast.show(
                $mdToast.simple()
                  .textContent('I segnalati sono stati lavorati correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            },function(){
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Errore nella lavorazione dei segnalati')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            })
          }
        })
      }

      vm.rifiutaMultipli = rifiutaMultipli;
      function rifiutaMultipli(segnalati){
        $mdDialog.show({
          controller: 'RifiutaController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/eventi/dialogs/rifiuta-segnalato.html',
          clickOutsideToClose: true,
          locals: {
            segnalati : segnalati,
          }
        }).then(function (attributes) {
          if (attributes){
            api.segnalatos.segnalato.rifiutaMultipli({eventi:segnalati,tipoRifiuto:attributes.tipoRifiuto,noteRifiuto:attributes.noteRifiuto},function(res){
              angular.forEach(segnalati,function (value, key) {
                var index = vm.eventos.indexOf(value);
                vm.eventos.splice(index,1);
                vm.selected = [];
              })
              $mdToast.show(
                $mdToast.simple()
                  .textContent('I segnalati sono stati lavorati correttamente.')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            },function(){
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Errore nella lavorazione dei segnalati')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            })
          }
        })
      }

        vm.golink = golink;
        function golink(link, payload) {
            $state.go(link, payload);
        }

      vm.cercaProgetti = cercaProgetti;
      function cercaProgetti(nome)
      {
        if (vm.progetti && vm.progetti.$cancelRequest) {
          vm.progetti.$cancelRequest();
        }
        var params = {
          filter: {
            or: [{nome: {xlike: nome+'%'}}, {nome: {like: ' '+nome}}],
            attivo: 1
          },
          fields: "id,nome",
          pagination: "-1",
          sort: "nome"
        }
        vm.progetti = api.progettomc.query(params);
      }

    }

    function ProcessosController($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, api, $base64, $mdToast, locals, $filter, ricerca, $rootScope) {
        var vm = this;
        console.log('ProcessosController locals:', locals);

        vm.mincaricato = 0;
        vm.data = {};
        vm.title = locals.title;
        vm.titlecancel = locals.title2;
        vm.button2 = locals.button2;
        vm.extrasetup = locals.formDefinition;
        //locals.segnalti = evento/i
        vm.segnalatis = locals.segnalati;
        vm.entita1_id = vm.segnalatis[0].entita1_id;
        vm.bottoniazione = false;
        vm.payload = {};
        vm.payload.eventoStato_id = locals.eventoStato_id;
        vm.payload.evento_id = [];
        angular.forEach(vm.segnalatis, function (evento) {
            vm.payload.evento_id.push(evento.id);
        });
        vm.self = {};
        vm.parent = {};
        vm.extra = {};

        //se solo 1 evento carico gli extra qualora ci fossero
        //così non li sovrascrivo ma li aggiungo
        vm.filteraddextra = [1003, 1011, 1013, 1014, 2000, 5000, 5001, 5002, 5003, 1002, 1004];
        if (vm.payload.evento_id.length === 1 && vm.segnalatis[0].extra !== "" && vm.filteraddextra.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            //(vm.segnalatis[0].eventoTipo_id == 1011 || vm.segnalatis[0].eventoTipo_id >= 5000 || vm.segnalatis[0].eventoTipo_id == 2000)) {
            //TODO SOVRASCRIVERE ANCHE PER 1013
            if (angular.isObject(vm.segnalatis[0].extra)) {
                vm.extra = vm.segnalatis[0].extra;
            } else {
                vm.extra = JSON.parse(vm.segnalatis[0].extra);
            }
            //converto date in js date
            angular.forEach(vm.extra, function (data, key) {
                if (key.toLowerCase().indexOf("data") !== -1) {
                    if (data === '0000-00-00' || data === null) {
                        vm.extra[key] = null;
                    } else {
                        vm.extra[key] = new Date(data);
                    }
                }
            });
            if (vm.segnalatis[0].eventoTipo_id == 2000 && angular.isDefined(vm.extra.dataRichiestaProtezione)) {
                vm.parent.dataRichiestaProtezione = vm.extra.dataRichiestaProtezione;
            }
        }
        //se datepicker sono required setto data null e se non esiste un valore già definito
        angular.forEach(vm.extrasetup, function (es) {
            if ((es.formtype == "datepickerv" || es.formtype == "datepickerv") && (es.required) && angular.isUndefined(vm[es.callbackModel][es.dbfield])) {
                vm[es.callbackModel][es.dbfield] = null;
            }
        });
        vm.eventoStato_id = locals.eventoStato_id;
        vm.segnalatos_id = [];
        angular.forEach(locals.segnalati, function (obj) {
            vm.segnalatos_id.push(obj.id);
            vm.progetto_id_current = obj.entita1.progetto_id;
            if (obj.eventoTipo_id == 1013) {
                vm.progetto_id_current = obj.entita1.newprogetto_id;
                if (vm.progetto_id_current == 0 || vm.progetto_id_current == null) {
                    vm.progetto_id_current = obj.entita1.progetto_id;
                }
            }
        });

        vm.oggi = new Date();
        vm.mdmindate = null;
        vm.mdmaxdate = null;
        vm.dataMinima = null;

        if (locals.segnalati[0].eventoTipo_id == 1010) {
            locals.segnalati[0].entita1.strutturahasbeneficiarios.forEach(beneficiario => {
                // Ottieni la data di inserimento dal beneficiario corrente
                const dataInserimento = beneficiario.dataInserimento;

                // Se la data di inserimento è definita
                if (dataInserimento) {
                    // Confronta con la data di inserimento massima attuale
                    if (!vm.dataMinima || new Date(dataInserimento) > new Date(vm.dataMinima)) {
                        vm.dataMinima = new Date(dataInserimento);
                    }
                }
            });
        }

        // Ora dataInserimentoMassima conterrà la data di inserimento massima
        console.log("Data di inserimento massima:", vm.dataMinima);


        console.log(locals);
        console.log(vm.dataMinima);
        vm.maggiorenne = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.centanni = new Date((vm.oggi.getFullYear() - 100) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        var m4 = moment.duration({'days': 120});
        var a10 = moment.duration({'years': 10});
        var a5 = moment.duration({'years': 5});
        vm.oggim4 = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
        vm.oggia10 = new Date(moment(vm.oggi).subtract(a10).format('YYYY-MM-DD'));
        vm.maxScadenzaDocumento = new Date(moment(vm.oggi).add(a5).format('YYYY-MM-DD'));

        if (api.isAdmin) {
            vm.oggim4 = vm.oggia10;
        }
        //se autosegnalazione preimposto data inizio
        if (vm.segnalatis[0].eventoTipo_id == 1002) {
            vm.parent.dataInizio = vm.oggi;
            vm.tipologiaRifiuto = [{id: 1, descrizione: "Rifiuto SC"}, {id: 2, descrizione: "Rifiuto Omonimia"}];
            if (!angular.isDefined(vm.extra.tipoRifiuto)) {
                vm.extra.tipoRifiuto = 1;
            }
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}, {id: -1, descrizione: "Presenza sul territorio"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }

        if (vm.segnalatis[0].eventoTipo_id == 1003) {
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}, {id: -1, descrizione: "Presenza sul territorio"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }

        vm.cambiadisabilitato = cambiadisabilitato;
        function cambiadisabilitato() {
            vm.parent.struttura_id = "";
        }

        vm.cambiadisabilitatoStr = cambiadisabilitatoStr;
        function cambiadisabilitatoStr() {
            vm.extra.struttura_id = "";
        }

        vm.cambioIdProgetto = cambioIdProgetto;
        function cambioIdProgetto() {

            if (vm.extra.esterna == -1) {
                vm.parent.progetto_id = 1;
            }

        }

        vm.filtraStrutture = filtraStrutture;
        function filtraStrutture() {

            vm.filtra = vm.backupStruttura;

            vm.filtrato = [];

            for (var i = 0; i < vm.filtra.length; i++) {

                if (vm.filtra[i].esterna == vm.extra.esterna) {
                    vm.filtrato.push(vm.filtra[i]);
                }
            }

            vm.strutturas = vm.filtrato;

        }


//        vm.strutturas = {};
//        vm.searchStrutturas = searchStrutturas;
//        console.log('progetto selezionato corrente:' + vm.progetto_id_current);
//        function searchStrutturas() {
//            api.strutturas.strutturamin.cerca({'progetto_id': vm.progetto_id_current, pagination: 50, attivo: 1}, function (response) {
//                vm.strutturas = response.data;
//
//                angular.forEach(vm.strutturas, function (objstruttura) {
//                    var postioccupatistruttura = 0;
//                    angular.forEach(objstruttura.strutturahasbeneficiarios, function (shb) {
//                        if (shb.dataCessazione == null) {
//                            postioccupatistruttura = postioccupatistruttura + 1;
//                        }
//                    });
//                    //console.log("postioccupatistruttura", postioccupatistruttura);
//                    //console.log(objstruttura);
//                    objstruttura.numeroPostiLiberi = objstruttura.numeroPosti - postioccupatistruttura;
//                });
//                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
//                    vm.strutturas.push(r1.data[0]);
//                });
//            });
//        }





        if (vm.segnalatis[0].eventoTipo_id == 1004) {
            var datai = new Date(vm.segnalatis[0].dataInizio);
            if (datai > vm.oggim4) {
                vm.oggim4 = datai;
                datai = null;
            }
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }
        if (vm.segnalatis[0].eventoTipo_id == 1010) {
            var datai = new Date(vm.segnalatis[0].entita1.dataInizio);
            if (datai > vm.oggim4) {
                vm.oggim4 = datai;
                datai = null;
            }
        }
        if (vm.segnalatis[0].eventoTipo_id == 1014) {
            vm.extra.strutturaDiPartenza = vm.segnalatis[0].entita2.nome;
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }



        vm.datainiziomin = datainiziomin;
        function datainiziomin(dataevento) {
            console.log("vm.oggim4", dataevento);
            var data = new Date(dataevento);
            if (data < vm.oggim4) {
                vm.oggim4 = data;
            }

        }

        vm.calcoladata = calcoladata;
        function calcoladata(giorni, variabile) {
            if (vm[variabile] === null) {
                var oggi = new Date();
                var today = moment(oggi);
                var risultato = null;
                if (giorni >= 0) {
                    risultato = new Date(today.add(giorni, 'days').format('YYYY-MM-DD'));
                    vm[variabile] = risultato;
                } else {
                    giorni = giorni * -1;
                    risultato = new Date(today.subtract(giorni, 'days').format('YYYY-MM-DD'));
                    vm[variabile] = risultato;
                }
            }
            return vm[variabile];
        }

        vm.copyextra = copyextra;
        function copyextra(nome, valore) {
            if (angular.isDate(valore)) {
                valore = moment(valore).format("YYYY-MM-DD");
            }
            vm.extra[nome] = valore;
        }
        vm.copyextrafilter = copyextrafilter;
        function copyextrafilter(nome, array, payload, valore) {
            vm.extra[nome] = $filter('filter')(array, payload)[0][valore];
        }
        vm.copyparent = copyparent;
        function copyparent(nome, valore) {
            if (angular.isDate(valore)) {
                valore = moment(valore).format("YYYY-MM-DD");
            }
            vm.parent[nome] = valore;
        }
        vm.copyparentfilter = copyparentfilter;
        function copyparentfilter(nome, array, payload, valore) {
            vm.parent[nome] = $filter('filter')(array, payload)[0][valore];
        }

        vm.messaggio = {
            attenzione: '',
            errore: '',
            info: ''
        };

        vm.checkMotivoTrasferimento = checkMotivoTrasferimento;
        function checkMotivoTrasferimento() {
            vm.mincaricato = 0;
            vm.uploadParams.mostratutti = true;
            vm.lastDataBuilded.mostratutti = true;
            if (angular.isDefined(vm.lastDataBuilded.tuttidocumenti)) {
                vm.uploadParams.caricato = vm.lastDataBuilded.tuttidocumenti;
                vm.uploadParams.tuttidocumenti = vm.lastDataBuilded.tuttidocumenti;
            }
            if (angular.isDefined(vm.uploadParams.tuttidocumenti)) {
                vm.uploadParams.caricato = vm.uploadParams.tuttidocumenti;
                vm.lastDataBuilded.tuttidocumenti = vm.uploadParams.tuttidocumenti;
            }
            if (vm.lastDataBuilded.caricato > vm.uploadParams.caricato) {
                vm.uploadParams.caricato = vm.lastDataBuilded.caricato;
            }
            if (angular.isUndefined(vm.uploadParams.caricato)) {
                vm.uploadParams.caricato = 0;
            }


            if (vm.extra.motivoTrasferimento == 1061) {
                vm.messaggio.attenzione = "Allegare il modello F alla presente richiesta.<br>Il modello è disponibile a <a href=\"http:\/\/www.sprar.it\/wp-content\/uploads\/2017\/05\/SPRAR_-_Mod_F__richiesta_inserimento_DM.doc\" target=\"_blank\">questo link</a>.";

                vm.mincaricato = 0;
                vm.lastDataBuilded.mincaricato = vm.mincaricato;
                vm.uploadParams.mincaricato = vm.mincaricato;
                vm.buildUP(vm.uploadParams);
            } else {
                vm.messaggio.attenzione = "";
                vm.mincaricato = 0;
                vm.lastDataBuilded.mincaricato = vm.mincaricato;
                vm.uploadParams.mincaricato = vm.mincaricato;
                vm.buildUP(vm.uploadParams);
            }
            console.log("vm.uploadParams.caricato", angular.copy(vm.uploadParams.caricato));
            console.log("vm.lastDataBuilded.caricato", angular.copy(vm.lastDataBuilded.caricato));
            console.log("vm.uploadParams.mincaricato", angular.copy(vm.uploadParams.mincaricato));
            console.log("vm.lastDataBuilded.mincaricato", angular.copy(vm.lastDataBuilded.mincaricato));
            console.log("vm.uploadParams.tuttidocumenti", angular.copy(vm.uploadParams.tuttidocumenti));
            console.log("vm.lastDataBuilded.tuttidocumenti", angular.copy(vm.lastDataBuilded.tuttidocumenti));
        }

        vm.monitoraggio_tipo = [{id: 'PRIMA VISITA'}, {id: 'SECONDA VISITA'}, {id: 'TERZA VISITA'}];
        vm.commissiones = [
            {id: "ANCONA", competenza: "Marche, Abruzzo"},
            {id: "BARI", competenza: "Bari, Matera"},
            {id: "BOLOGNA", competenza: "Emilia Romagna"},
            {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
            {id: "CAGLIARI", competenza: "Sardegna"},
            {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
            {id: "CATANIA", competenza: "Catania, Enna"},
            {id: "CROTONE", competenza: "Calabria"},
            {id: "FIRENZE", competenza: "Toscana, Umbria"},
            {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
            {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
            {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
            {id: "MILANO", competenza: "Lombardia"},
            {id: "PALERMO", competenza: "Palermo, Messina"},
            {id: "ROMA", competenza: "Lazio"},
            {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
            {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
            {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
            {id: "TRAPANI", competenza: "Trapani, Agrigento"},
            {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
        ];

        vm.nstatusgs = [
            {id: 591, descrizione: "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO"},
            {id: 592, descrizione: "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA"},
            {id: 593, descrizione: "TITOLARE PROTEZIONE UMANITARIA"}
        ];



        vm.setupnsg = setupnsg;
        vm.alltipoProteziones = [];
        vm.nsgDataRichiestaProtezioneReq = false;
        vm.nsgDataAvvenutaNotificaReq = false;
        vm.nsgNoteReq = false;
        vm.nsgDataInizioAccoglienza = null;
        vm.nsgTipoProtezioneId = null;
        vm.nsgRuolo = '*'; //dopo modifica ruolo sempre tutti
        vm.nsgStatusOd = null;

        vm.nsgRicalcola = 0;
        vm.nsgCampi = 0;
        function setupnsg(eid) {
            //setto payload parent che mi serve per 1998 e 1999
            // 1998 modifica
            // 1999 inserimento
            //sempre id e dataRichiestaProtezione

            //tipo default = Inserimento = I
            var tipo = 'I';

            vm.parent.id = angular.copy(vm.segnalatis[0].entita1.id);
            vm.extra.dataRichiestaProtezione = angular.copy(vm.segnalatis[0].entita1.dataRichiestaProtezione);
            if (vm.extra.dataRichiestaProtezione != null) {
                vm.extra.dataRichiestaProtezione = new Date(vm.extra.dataRichiestaProtezione)
            }

            //solo 1998
            if (vm.segnalatis[0].eventoTipo_id == 1998) {
                vm.extra.tipoProtezione_id = angular.copy(vm.segnalatis[0].entita1.tipoProtezione_id);

                vm.extra.dataAvvenutaNotifica = angular.copy(vm.segnalatis[0].entita1.dataAvvenutaNotifica);
                if (vm.extra.dataAvvenutaNotifica != null) {
                    vm.extra.dataAvvenutaNotifica = new Date(vm.extra.dataAvvenutaNotifica)
                }
            }

            console.log("vm.extra::::::", vm.extra);
            vm.nsgDataInizioAccoglienza = vm.segnalatis[0].entita1.dataInizio;
            vm.nsgTipoProtezioneId = vm.segnalatis[0].entita1.tipoProtezione_id;
//            if (api.isAdmin) {
//                vm.nsgRuolo = 'A';
//            }
            var dn = new Date(vm.segnalatis[0].entita1.dataNascita);
            var m222 = moment.duration({'days': 6752});
            var today = new Date();
            var oggim222 = new Date(moment(today).subtract(m222).format('YYYY-MM-DD'));
            vm.limite = 1;
//            console.log("oggim222");
//            console.log(oggim222.getTime());
//            console.log(oggim222);
//            console.log("dn");
//            console.log(dn.getTime());
//            console.log(dn);
            if (oggim222.getTime() >= dn.getTime()) {
                //includi tc=2
                vm.limite = 2;
            }
            //se nuovo vedo solo le trasformazioni consentite
            var tc = ">1";
            //se modifica 1998 vedo tutte le trasformazioni
            if (eid == 1998) {
                //tc = ">0";
                tipo = 'U';
            }

            api.utilitas.statusod.cerca({origine: vm.nsgTipoProtezioneId, ruolo: vm.nsgRuolo, tc: tc, tipo: tipo}, function (setup) {
                vm.nsgStatusOd = setup.data;
                vm.filtraOd = [];

                angular.forEach(vm.nsgStatusOd, function (od) {
                    if (od.tc <= vm.limite) {
                        vm.filtraOd.push(od.destinazione);
                    }
                });
                api.beneficiarios.attributi.cerca({gruppo: "TIPO-PROTEZIONE", pagination: "50", sort: "ordinamento,descrizione", "id_IN": vm.filtraOd.join()}, function (response) {
                    vm.alltipoProteziones = response.data;
                });


            });

        }
        vm.cambiansg = cambiansg;
        function cambiansg() {
            console.log(vm.extra.tipoProtezione_id);
            angular.forEach(vm.nsgStatusOd, function (od) {
                if (od.destinazione == vm.extra.tipoProtezione_id) {
                    vm.nsgRicalcola = od.ricalcola;
                    vm.nsgCampi = od.campi;
                    switch (vm.nsgCampi) {
                        case 0:
                            vm.nsgDataRichiestaProtezioneReq = false;
                            vm.nsgDataAvvenutaNotificaReq = false;
                            vm.nsgNoteReq = false;
                            break;
                        case 1:
                            vm.nsgDataRichiestaProtezioneReq = false;
                            vm.nsgDataAvvenutaNotificaReq = false;
                            vm.nsgNoteReq = false;
                            break;
                        case 2:
                            vm.nsgDataRichiestaProtezioneReq = false;
                            vm.nsgDataAvvenutaNotificaReq = true;
                            vm.nsgNoteReq = false;
                            break;

                        default:
                    }

                }
            });
        }


        if (vm.segnalatis[0].eventoTipo_id == 1999 || vm.segnalatis[0].eventoTipo_id == 1998) {
            setupnsg(vm.segnalatis[0].eventoTipo_id);
            vm.utenteModifica = api.user.username + " @ " + moment(new Date()).format("DD/MM/YYYY H:m:s") + " R" + vm.nsgRuolo;
            vm.extra.utenteModifica = vm.utenteModifica;
        }






        vm.motivoprorogas = ricerca.motivoprorogas;
        vm.motivotrasferimentos = ricerca.motivitrasferimento;
        vm.loadquestura = loadquestura;
        function loadquestura() {
            api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.questuras = response.data;
            });
        }
        //vm.filterloadquestura = [2000, 2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 3002];
        vm.filterloadquestura = [2000, 3002, 2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2999, 3075, 3076, 3077, 3078, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088];
        if (vm.filterloadquestura.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            loadquestura();
        }

        vm.loadprefettura = loadprefettura;
        function loadprefettura() {
            api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.prefetturas = response.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000 || vm.segnalatis[0].eventoTipo_id == 3003) {
            loadprefettura();
        }

        if (vm.segnalatis[0].eventoTipo_id == 3001) {
            console.log(vm.segnalatis[0]);
            vm.accoglienzas = [];
            vm.alloggios = [];
            vm.istats = [];
            api.strutture.accoglienza.get({sort: 'descrizione'}, function (response) {
                vm.accoglienzas = response.data;
            });
            api.strutture.alloggio.get({sort: 'descrizione'}, function (response) {
                vm.alloggios = response.data;
            });
            api.istats.istat.cerca({codProvincia: vm.segnalatis[0].entita1.codProvincia, pagination: 400, sort: 'comune'}, function (response) {
                vm.istats = response.data;
            });
            vm.progetto_id = vm.segnalatis[0].entita1_id;
            vm.codRegione = vm.segnalatis[0].entita1.codRegione;
            vm.codProvincia = vm.segnalatis[0].entita1.codProvincia;
        }

        vm.motivods = motivods;
        function motivods() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivods = r.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000) {
            motivods();
        }

        vm.documentotipos = [];
        vm.loaddocumentotipos = loaddocumentotipos;
        function loaddocumentotipos() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DOCUMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.documentotipos = r.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000) {
            loaddocumentotipos();
        }
        if (vm.segnalatis[0].eventoTipo_id > 2600 && vm.segnalatis[0].eventoTipo_id < 3000) {
            vm.dataMinimaDocumento = new Date();
            if (angular.isDefined(vm.segnalatis[0].entita1.dataIngresso)) {
                vm.dataMinimaDocumento = new Date(vm.segnalatis[0].entita1.dataIngresso);
            }
            if (angular.isDefined(vm.segnalatis[0].entita1.dataScadenzaDocumento)) {
                vm.dataMinimaDocumento = new Date(vm.segnalatis[0].entita1.dataRilascioDocumento);
            }
        }

        vm.motivouscita = motivouscita;
        function motivouscita() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MOTIVO-USCITA", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscita = r.data;
            });
        }
        vm.filtermotiviuscita = [1010, 1016];
        if (vm.filtermotiviuscita.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            motivouscita();
            motivouscitavol();
            motivouscitains();
            motivouscitainsluo();
            motivouscitainstip();
            motivouscitainsall();
            motivouscitainscon();
            motivouscitainsfas();
            motivouscitainsallsi();
            motivouscitainsconsi();
            motivouscitainstiplav();
            motivouscitainstiplavset();
            motivouscitainstiplavpro();
            motivouscitainstiplavtip();
        }

        vm.motivouscitavol = motivouscitavol;
        function motivouscitavol() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-VOLONTARIA_PRIMA_DEI_TERMINI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitaVol = r.data;
            });
        }

        vm.motivouscitainsall = motivouscitainsall;
        function motivouscitainsall() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-ALLOGGIO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsAll = r.data;
            });
        }

        vm.motivouscitainscon = motivouscitainscon;
        function motivouscitainscon() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-CONTRIBUTO_EROGATO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsCon = r.data;
            });
        }

        vm.motivouscitains = motivouscitains;
        function motivouscitains() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INSERIMENTO_SOCIO-ECONOMICO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitaIns = r.data;
            });
        }

        vm.motivouscitainsluo = motivouscitainsluo;
        function motivouscitainsluo() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-LUOGO_DI_INSERIMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsLuo = r.data;
            });
        }

        vm.motivouscitainstip = motivouscitainstip;
        function motivouscitainstip() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIPO_INSERIMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsTip = r.data;
            });
        }

        vm.motivouscitainsfas = motivouscitainsfas;
        function motivouscitainsfas() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-FASCIA_IMPORTO_EROGATO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsFas = r.data;
            });
        }

        vm.motivouscitainstiplav = motivouscitainstiplav;
        function motivouscitainstiplav() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAVORO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstipLav = r.data;
            });
        }

        vm.motivouscitainsallsi = motivouscitainsallsi;
        function motivouscitainsallsi() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-ALLOGGIO-SI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsallSi = r.data;
            });
        }

        vm.motivouscitainsconsi = motivouscitainsconsi;
        function motivouscitainsconsi() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-CONTRIBUTO_EROGATO-SI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsconSi = r.data;
            });
        }

        vm.motivouscitainstiplavset = motivouscitainstiplavset;
        function motivouscitainstiplavset() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-SETTORE_LAVORATIVO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavSet = r.data;
            });
        }

        vm.motivouscitainstiplavpro = motivouscitainstiplavpro;
        function motivouscitainstiplavpro() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-PROFESSIONE", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavPro = r.data;
            });
        }

        vm.motivouscitainstiplavtip = motivouscitainstiplavtip;
        function motivouscitainstiplavtip() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-TIPO_CONTRATTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavTip = r.data;
            });
        }

        vm.uploadParams = {};
        vm.buildUP = buildUP;
        vm.lastDataBuilded = {};
        function buildUP(data) {
            //console.log("buildUP");
            // data = {documentoTipo_id, gruppo, dettaglio, dettagliomin, entita, entitakey}
            vm.lastDataBuilded = data;
            vm.uploadParams = {
                documentoTipo_id: data.documentoTipo_id,
                gruppo: data.gruppo,
                dettaglio: data.dettaglio,
                dettagliomin: data.dettagliomin,
                entita: data.entita,
                entitakey: data.entitakey,
                entita_id: vm.entita1_id,
                caricato: data.caricato,
                mincaricato: vm.mincaricato
            };
            vm.uploadParams[data.entitakey] = vm.entita1_id;
            //console.log(vm.uploadParams);
        }
//        vm.uploadParams = {
//            documentoTipo_id: 0,
//            gruppo: 'BENEFICIARIO',
//            dettaglio: false,
//            dettagliomin: true,
//            entita: 'beneficiario',
//            entitakey: vm.entita1_id,
//            beneficiario_id: vm.entita1_id
//        };
        //console.log('uploadParams');
        //console.log(vm.uploadParams);
        vm.progettos = null;
        vm.strutturas = null;
        vm.segnalazione = {};
        vm.segnalazione.progetto_id = 0;
        vm.segnalazione.struttura_id = 0;
        vm.loadprogetto = loadprogetto;
        function loadprogetto() {
            api.progettos.progetto.cerca({attivo: 1, fields: "id,nome,postiLiberi,postiPrenotati", pagination: -1, sort: "nome", operatore: "AND", "query[]": "{\"operatore\":\"AND\",\"attivo\":1,\"id>\":\"1\"}"}, function (response) {
                //console.log("CARICAMENTO PROGETTI");
                vm.progettos = response.data;
//                vm.progettos.tot = 0;
//                vm.progettos.benefAttivi = 0;
//                vm.progettos.benefTotali = 0;
//                vm.progettos.benefT = [];
//                angular.forEach(vm.progettos.strutturas, function (subobj) {
//                    vm.progettos.tot = vm.progettos.tot + subobj.numeroPosti;
//                    angular.forEach(subobj.strutturahasbeneficiarios, function (subsubobj) {
//                        vm.progettos.benefT.push(subsubobj.beneficiario_id);
//                        vm.progettos.benefTotali++;
//                    });
//                });
//                var insearch = vm.progettos.benefT.join();
//                api.beneficiarios.beneficiario.search({id_IN: insearch, stato: 'BENEFICIARIO', operatore: 'AND'}, function (d) {
//                    vm.progettos.benefAttivi = d.data.length;
//                    vm.progettos.postiTotali = vm.progettos.tot;
//                    vm.progettos.postiLiberi = vm.progettos.tot - vm.progettos.benefAttivi;
//                });
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 1003 || vm.segnalatis[0].eventoTipo_id == 1013) {
            loadprogetto();
        }


        if (vm.segnalatis[0].eventoTipo_id == 4001 || vm.segnalatis[0].eventoTipo_id == 4002 || vm.segnalatis[0].eventoTipo_id == 4003 || vm.segnalatis[0].eventoTipo_id == 4004 || vm.segnalatis[0].eventoTipo_id == 4005) {
            console.log(vm.entita1_id);
        }


        vm.strutturas = {};
        vm.searchStrutturas = searchStrutturas;
        console.log('progetto selezionato corrente:' + vm.progetto_id_current);
        function searchStrutturas() {
            api.strutturas.strutturamin.cerca({'progetto_id': vm.progetto_id_current, pagination: 600, attivo: 1}, function (response) {
                vm.strutturas = response.data;
                vm.backupStruttura = response.data;

                angular.forEach(vm.strutturas, function (objstruttura) {
                    var postioccupatistruttura = 0;
                    angular.forEach(objstruttura.strutturahasbeneficiarios, function (shb) {
                        if (shb.dataCessazione == null) {
                            postioccupatistruttura = postioccupatistruttura + 1;
                        }
                    });
                    //console.log("postioccupatistruttura", postioccupatistruttura);
                    //console.log(objstruttura);
                    objstruttura.numeroPostiLiberi = objstruttura.numeroPosti - postioccupatistruttura;
                });
//                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
//                    vm.strutturas.push(r1.data[0]);
//                });
                console.log("vm.strutturas:", vm.strutturas);
                if (angular.isUndefined(vm.extra.esterna)) {
                    vm.extra.esterna = 0;
                }
                filtraStrutture();
            });

        }
        if (vm.progetto_id_current > 0) {
            searchStrutturas();
        }

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
            $state.reload();
        }
        vm.save = save;
        vm.reject = reject;
        function save() {
            var parentcopy = angular.copy(vm.parent);
            angular.forEach(parentcopy, function (pv, pk) {
// da provare
//                if (pk.startsWith("data")) {
//                    if (pv === '0000-00-00' || pv === null) {
//                        parentcopy[pk] = null;
//                    } else {
//                        parentcopy[pk] = moment(pv).format('YYYY-MM-DD');
//                    }
//                }
// vecchio modo
                if (angular.isDate(pv)) {
                    parentcopy[pk] = moment(pv).format('YYYY-MM-DD');
                }
            });
            var selfcopy = angular.copy(vm.self);
            angular.forEach(selfcopy, function (sv, sk) {
                if (angular.isDate(sv)) {
                    selfcopy[sk] = moment(sv).format('YYYY-MM-DD');
                }
            });

            //vm.payload.self = vm.self;
            vm.payload.self = selfcopy;
            vm.payload.extra = vm.extra;
            //vm.payload.parent = vm.parent;
            vm.payload.parent = parentcopy;


            var oggi = new Date();
            vm.payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
            console.log('---save fx')
            console.log('Paylod da inviare');
            console.log(vm.payload);
            api.processi.processo.lavora(vm.payload, function (response) {
                    //Mostra PopUp alla modifica della tipologia di soggiorno(Informa di aggiornare anche il documento)
                if (response.status === 200) {
                    var dn = new Date(vm.segnalatis[0].entita1.dataNascita);
                    var today = new Date();
                    var m222 = moment.duration({'days': 6752});
                    var oggim222 = new Date(moment(today).subtract(m222).format('YYYY-MM-DD'));
                    if([1998,1999].includes(vm.segnalatis[0].eventoTipo_id)) {
                      var popUpDocumento = $mdDialog.confirm()
                        .title('Aggiornare Documento di Soggiorno')
                        .htmlContent('La tipologia di soggiorno del beneficiario è stata aggiornata correttamente è necessario <b> aggiornare </b>anche <b> il documento di soggiorno</b>')
                        .ok('CHIUDI');

                      $mdDialog.show(popUpDocumento);
                    }
                    if (oggim222.getTime() < dn.getTime() && [3006,3010,3011].includes(vm.extra['tipoProtezione_id'])) {
                      var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .textContent('Tipologia di soggiorno aggiornata correttamente. Ricordiamo che il prosieguo amministrativo selezionato è stato registrato su un beneficiario minorenne.')
                        .ok('OK');

                      $mdDialog.show(confirm)
                    }

                    $mdToast.show(
                      $mdToast.simple()
                        .textContent('Processo lavorato correttamente!!')
                        .position('bottom right')
                        .hideDelay(3000)
                    ).then(
                      $state.reload()
                    );
                }
            });
        }
        function reject() {
            var selfcopy = {};
            selfcopy.id = vm.segnalatis[0].id;
            selfcopy.eventoStato_id = vm.segnalatis[0].ordine;
            selfcopy.ordine = 0;

            console.log("vm.self", selfcopy);

            if (vm.segnalatis[0].eventoTipo_id = 1999 || vm.segnalatis[0].eventoTipo_id == 1998) {
                // se 1999 o 1998 cancello direttamente
                api.eventos.evento.remove(selfcopy, function (r) {

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Processo cancellato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );

                });
            } else {


                api.eventos.evento.update(selfcopy, function (r) {
                    if (r.id == selfcopy.id) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Processo annullato.')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(
                                $state.reload()
                                );
                    }
                });
            }


        }
        vm.dataLimite = {};
        vm.cambiaData = cambiaData;
        function cambiaData(nomeData) {
            var dataLimiteMinimo = null;
            if (angular.isDefined(vm.dataLimite[nomeData]) && angular.isDate(vm.dataLimite[nomeData])) {
                return  vm.dataLimite[nomeData];
            }
            if (vm.segnalatis[0].eventoTipo_id == 2000 || vm.segnalatis[0].eventoTipo_id == 1999 || vm.segnalatis[0].eventoTipo_id == 1998) {
                var beneficiario = vm.segnalatis[0].entita1;
                var controlli = [
                    'dataIngresso',
                    'dataInteresseExArt',
                    'dataC3',
                    'dataRichiestaProtezione',
                    'dataAudizione',
                    'dataNotificaDiniego',
                    'dataNotificaRicorso'
                ];
                vm.finoA = controlli.indexOf(nomeData);
                for (i = 0; i < vm.finoA; i++) {
                    if (beneficiario[controlli[i]] !== null) {
                        dataLimiteMinimo = new Date(beneficiario[controlli[i]]);

                    }

                }
                vm.dataLimite[nomeData] = dataLimiteMinimo;

            }
            return dataLimiteMinimo;



        }

        vm.dataMinimoTrasferimento = dataMinimoTrasferimento;
        vm.setupDataMinimoTrasferimento = false;
        function dataMinimoTrasferimento() {

            if (vm.setupDataMinimoTrasferimento === false) {
                vm.setupDataMinimoTrasferimento = true;
                var b_id = vm.segnalatis[0].entita1.id;
                var s_id = vm.segnalatis[0].entita1.struttura_id;
                api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                    angular.forEach(st.data, function (shb) {
                        //console.log("shb", shb);
                        vm.setupDataMinimoTrasferimento = new Date(shb.dataInserimento);
                    });
                });

            }
            //console.log("cccc", vm.setupDataMinimoTrasferimento);
            return vm.setupDataMinimoTrasferimento;

        }
        vm.dataMinimoCTrasferimento = dataMinimoCTrasferimento;
        vm.setupDataMinimoCTrasferimento = false;
        function dataMinimoCTrasferimento() {

            if (vm.setupDataMinimoCTrasferimento === false) {
                vm.setupDataMinimoCTrasferimento = true;
                var b_id = vm.segnalatis[0].entita1.id;
                var s_id = vm.segnalatis[0].entita1.struttura_id;
                api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                    angular.forEach(st.data, function (shb) {
                        //console.log("shb", shb);
                        vm.setupDataMinimoCTrasferimento = new Date(shb.dataInserimento);
                    });
                    console.log("setupDataMinimoCTrasferimento:", vm.setupDataMinimoCTrasferimento);
//                    api.strutturas.strutturamin.get({id: s_id}, function (std) {
//                        console.log("std:", std.dataInizio);
//                        if (angular.isDefined(std.dataInizio)) {
//                            var dataInizioStruttura = new Date(std.dataInizio);
//                            if (dataInizioStruttura > vm.setupDataMinimoCTrasferimento) {
//                                vm.setupDataMinimoCTrasferimento = dataInizioStruttura;
//                            }
//                        }
//
//                    });
                });

            }
            //console.log("cccc", vm.setupDataMinimoCTrasferimento);
            return vm.setupDataMinimoCTrasferimento;

        }
        vm.dataMinimoCTrasferimento2 = dataMinimoCTrasferimento2;
        function dataMinimoCTrasferimento2() {
            var b_id = vm.segnalatis[0].entita1.id;
            var s_id = vm.segnalatis[0].entita1.struttura_id;
            api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                angular.forEach(st.data, function (shb) {
                    //console.log("shb", shb);
                    vm.setupDataMinimoCTrasferimento = new Date(shb.dataInserimento);
                });
                console.log("setupDataMinimoCTrasferimento:", vm.setupDataMinimoCTrasferimento);
                api.strutturas.strutturamin.get({id: vm.extra.struttura_id}, function (std) {
                    console.log("std:", std.dataInizio);
                    if (angular.isDefined(std.dataInizio)) {
                        var dataInizioStruttura = new Date(std.dataInizio);
                        if (dataInizioStruttura > vm.setupDataMinimoCTrasferimento) {
                            vm.setupDataMinimoCTrasferimento = dataInizioStruttura;
                        }
                    }

                });
            });


        }
        vm.dataMinimoTrasferimentoArrivo = dataMinimoTrasferimentoArrivo;
        vm.setupDataMinimoTrasferimentoArrivo = false;
        function dataMinimoTrasferimentoArrivo() {

            if (vm.setupDataMinimoTrasferimentoArrivo === false) {
                vm.setupDataMinimoTrasferimentoArrivo = true;
                vm.setupDataMinimoTrasferimentoArrivo = new Date(vm.extra.dataTrasferimento);

            }
            //console.log("cccc", vm.setupDataMinimoTrasferimento);

            return vm.setupDataMinimoTrasferimentoArrivo;
        }
        vm.dataMinimoTrasferimentoArrivo2 = dataMinimoTrasferimentoArrivo2;
        function dataMinimoTrasferimentoArrivo2() {
            vm.setupDataMinimoTrasferimentoArrivo = new Date(vm.extra.dataTrasferimento);
            api.strutturas.strutturamin.get({id: vm.extra.struttura_id}, function (std) {
                console.log("std:", std.dataInizio);
                if (angular.isDefined(std.dataInizio)) {
                    var dataInizioStruttura = new Date(std.dataInizio);
                    if (dataInizioStruttura > vm.setupDataMinimoTrasferimentoArrivo) {
                        vm.setupDataMinimoTrasferimentoArrivo = dataInizioStruttura;
                    }
                }

            });
        }


    }

    function ProcessosController2($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, api, $base64, $mdToast, locals, $filter, ricerca, $rootScope) {
        var vm = this;
        console.log('ProcessosController2 locals:', locals);

        vm.mincaricato = 0;
        vm.data = {};
        vm.title = locals.title;
        vm.titlecancel = locals.title2;
        vm.button2 = locals.button2;
        vm.extrasetup = locals.formDefinition;
        vm.allproperties = locals.properties;
        //locals.segnalti = evento/i
        vm.segnalatis = locals.segnalati;
        vm.entita1_id = vm.segnalatis[0].entita1_id;
        vm.bottoniazione = false;
        vm.payload = {};
        vm.payload.eventoStato_id = locals.eventoStato_id;
        vm.payload.evento_id = [];
        angular.forEach(vm.segnalatis, function (evento) {
            vm.payload.evento_id.push(evento.id);
        });
        vm.self = {};
        vm.parent = {};
        vm.extra = {};

        //inizializza properties
        vm.indiceProcessoAttivo = 0;
        vm.statiDisponibili = [];
        vm.processiDisponibili = [];
        vm.titoliDisponibili = [];
        angular.forEach(vm.allproperties, function (p, k) {
            vm.statiDisponibili.push(k);
            vm.processiDisponibili.push(p.fields);
            vm.titoliDisponibili.push(p.title);


        });
        angular.forEach(vm.processiDisponibili, function (v, k) {
            angular.forEach(v, function (v1, k1) {
                v1.required = false;
                if (k1 == "tipoProtezione_id" || k1 == "dataAvvenutaNotificaEsitoPositivo" || k1 == "dataAvvenutaNotificaAccoglimentoRicorso" || k1 == "tipoProtezione_id2") {
                    v1.disabled = true;
                }
                if (k1 == "dataRichiestaProtezione") {
                    v1.callbackModel = "extra";
                }
                vm.processiDisponibili[k][k1] = v1;

            });

        });
        vm.extrasetup = vm.processiDisponibili[vm.indiceProcessoAttivo];
        vm.title = vm.titoliDisponibili[vm.indiceProcessoAttivo];
        vm.statoCorrente = vm.statiDisponibili[vm.indiceProcessoAttivo];
        vm.tuttiprocessi0 = locals.tuttiprocessi;
        vm.tuttiprocessi1 = locals.tuttiprocessi.split("|");

        vm.tuttiprocessi = [];
        angular.forEach(vm.tuttiprocessi1, function (tp) {
            vm.tuttiprocessi.push(tp.replace("(", "").replace(")", "").split(","));

        });

        //se solo 1 evento carico gli extra qualora ci fossero
        //così non li sovrascrivo ma li aggiungo
        vm.filteraddextra = [1003, 1011, 1013, 1014, 2000, 5000, 5001, 5002, 5003, 1002, 1004];
        if (vm.payload.evento_id.length === 1 && vm.segnalatis[0].extra !== "" && vm.filteraddextra.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            //(vm.segnalatis[0].eventoTipo_id == 1011 || vm.segnalatis[0].eventoTipo_id >= 5000 || vm.segnalatis[0].eventoTipo_id == 2000)) {
            //TODO SOVRASCRIVERE ANCHE PER 1013
            if (angular.isObject(vm.segnalatis[0].extra)) {
                vm.extra = vm.segnalatis[0].extra;
            } else {
                vm.extra = JSON.parse(vm.segnalatis[0].extra);
            }
            //converto date in js date
            angular.forEach(vm.extra, function (data, key) {
                if (key.toLowerCase().indexOf("data") !== -1) {
                    if (data === '0000-00-00' || data === null) {
                        vm.extra[key] = null;
                    } else {
                        vm.extra[key] = new Date(data);
                    }
                }
            });
            if (vm.segnalatis[0].eventoTipo_id == 2000 && angular.isDefined(vm.extra.dataRichiestaProtezione)) {
                vm.parent.dataRichiestaProtezione = vm.extra.dataRichiestaProtezione;
            }
        }
        //se datepicker sono required setto data null e se non esiste un valore già definito
        angular.forEach(vm.extrasetup, function (es) {
            if ((es.formtype == "datepickerv" || es.formtype == "datepickerv") && (es.required) && angular.isUndefined(vm[es.callbackModel][es.dbfield])) {
                vm[es.callbackModel][es.dbfield] = null;
            }
        });
        vm.eventoStato_id = locals.eventoStato_id;
        vm.segnalatos_id = [];
        angular.forEach(locals.segnalati, function (obj) {
            vm.segnalatos_id.push(obj.id);
            vm.progetto_id_current = obj.entita1.progetto_id;
            if (obj.eventoTipo_id == 1013) {
                vm.progetto_id_current = obj.entita1.newprogetto_id;
                if (vm.progetto_id_current == 0 || vm.progetto_id_current == null) {
                    vm.progetto_id_current = obj.entita1.progetto_id;
                }
            }
        });

        vm.parent = angular.copy(vm.segnalatis[0].entita1);
        vm.idEvento = vm.segnalatis[0].id;

        console.log("vm.parent", vm.parent);
        console.log("vm.extra", vm.extra);
        console.log("vm.segnalatis", vm.segnalatis);



        vm.oggi = new Date();
        vm.mdmindate = null;
        vm.mdmaxdate = null;
        vm.maggiorenne = new Date((vm.oggi.getFullYear() - 18) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        vm.centanni = new Date((vm.oggi.getFullYear() - 100) + "-" + (vm.oggi.getMonth() + 1) + "-" + vm.oggi.getDate());
        var m4 = moment.duration({'days': 120});
        var a10 = moment.duration({'years': 10});
        var a5 = moment.duration({'years': 5});
        vm.oggim4 = new Date(moment(vm.oggi).subtract(m4).format('YYYY-MM-DD'));
        vm.oggia10 = new Date(moment(vm.oggi).subtract(a10).format('YYYY-MM-DD'));
        vm.maxScadenzaDocumento = new Date(moment(vm.oggi).add(a5).format('YYYY-MM-DD'));

        if (api.isAdmin) {
            vm.oggim4 = vm.oggia10;
        }
        //se autosegnalazione preimposto data inizio
        if (vm.segnalatis[0].eventoTipo_id == 1002) {
            vm.parent.dataInizio = vm.oggi;
            vm.tipologiaRifiuto = [{id: 1, descrizione: "Rifiuto SC"}, {id: 2, descrizione: "Rifiuto Omonimia"}];
            if (!angular.isDefined(vm.extra.tipoRifiuto)) {
                vm.extra.tipoRifiuto = 1;
            }
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}, {id: -1, descrizione: "Presenza sul territorio"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }

        if (vm.segnalatis[0].eventoTipo_id == 1003) {
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}, {id: -1, descrizione: "Presenza sul territorio"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }


        vm.avantiP = avantiP;
        function avantiP() {

            vm.indiceProcessoAttivo++;
            vm.extrasetup = vm.processiDisponibili[vm.indiceProcessoAttivo];
            vm.title = vm.titoliDisponibili[vm.indiceProcessoAttivo];
            vm.statoCorrente = vm.statiDisponibili[vm.indiceProcessoAttivo];
        }
        vm.indietroP = indietroP;
        function indietroP() {

            vm.indiceProcessoAttivo--;
            vm.extrasetup = vm.processiDisponibili[vm.indiceProcessoAttivo];
            vm.title = vm.titoliDisponibili[vm.indiceProcessoAttivo];
            vm.statoCorrente = vm.statiDisponibili[vm.indiceProcessoAttivo];
        }

        vm.salvaedesci = salvaedesci;
        function salvaedesci() {
            var payload = {};
            payload.id = vm.idEvento;
            payload.extra = JSON.stringify(vm.extra);
            var beneficiarioUpdate = {};
            beneficiarioUpdate.id = vm.parent.id;
            beneficiarioUpdate.v_genSingMinori = 1;
            beneficiarioUpdate.v_grav = 1;

            api.beneficiarios.beneficiario.aggiorna(beneficiarioUpdate, function (response) {
                api.eventos.evento.update(payload, function (upd) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Dati status giuridico aggiornati!!')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                });

            });


        }


        vm.avanti = avanti;
        function avanti(p) {
            p = p.replace('(', '').replace(')', '').split(',');
            var statoFuturo = p[1];
            var indiceFuturo = vm.statiDisponibili.indexOf(statoFuturo);
            if (indiceFuturo == -1) {
                indiceFuturo = vm.indiceProcessoAttivo;
            }
            vm.indiceProcessoAttivo = indiceFuturo;
            vm.extrasetup = vm.processiDisponibili[vm.indiceProcessoAttivo];
            vm.title = vm.titoliDisponibili[vm.indiceProcessoAttivo];
            vm.statoCorrente = vm.statiDisponibili[vm.indiceProcessoAttivo];

        }
        vm.indietro = indietro;
        function indietro() {
            var statoAttuale = 0;
            var statoPrecedente = 0;
            statoAttuale = vm.statiDisponibili[vm.indiceProcessoAttivo];
            var trovato = false;
            angular.forEach(vm.tuttiprocessi, function (tp) {
                if (tp[1] == statoAttuale && !trovato) {
                    statoPrecedente = tp[0];
                    trovato = true;
                }
            });
            var indicePrecedente = vm.statiDisponibili.indexOf(statoPrecedente);
            if (indicePrecedente == -1) {
                indicePrecedente = vm.indiceProcessoAttivo;
            }
            vm.indiceProcessoAttivo = indicePrecedente;
            vm.extrasetup = vm.processiDisponibili[vm.indiceProcessoAttivo];
            vm.title = vm.titoliDisponibili[vm.indiceProcessoAttivo];
            vm.statoCorrente = vm.statiDisponibili[vm.indiceProcessoAttivo];

        }
        vm.nomeProcessoPulsante = nomeProcessoPulsante;
        function nomeProcessoPulsante(p) {
            var newp = p.replace('(', '').replace(')', '').split(',');
            return newp[2];
        }


        vm.cambiadisabilitato = cambiadisabilitato;
        function cambiadisabilitato() {
            vm.parent.struttura_id = "";
        }

        vm.cambiadisabilitatoStr = cambiadisabilitatoStr;
        function cambiadisabilitatoStr() {
            vm.extra.struttura_id = "";
        }

        vm.cambioIdProgetto = cambioIdProgetto;
        function cambioIdProgetto() {

            if (vm.extra.esterna == -1) {
                vm.parent.progetto_id = 1;
            }

        }

        vm.filtraStrutture = filtraStrutture;
        function filtraStrutture() {

            vm.filtra = vm.backupStruttura;

            vm.filtrato = [];

            for (var i = 0; i < vm.filtra.length; i++) {

                if (vm.filtra[i].esterna == vm.extra.esterna) {
                    vm.filtrato.push(vm.filtra[i]);
                }
            }

            vm.strutturas = vm.filtrato;
            console.log("vm.strutturas filtrato:", vm.strutturas);

        }


        if (vm.segnalatis[0].eventoTipo_id == 1004) {
            var datai = new Date(vm.segnalatis[0].dataInizio);
            if (datai > vm.oggim4) {
                vm.oggim4 = datai;
                datai = null;
            }
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }
        if (vm.segnalatis[0].eventoTipo_id == 1010) {
            var datai = new Date(vm.segnalatis[0].entita1.dataInizio);
            if (datai > vm.oggim4) {
                vm.oggim4 = datai;
                datai = null;
            }
        }
        if (vm.segnalatis[0].eventoTipo_id == 1014) {
            vm.extra.strutturaDiPartenza = vm.segnalatis[0].entita2.nome;
            vm.tipologiaAccoglienza = [{id: 0, descrizione: "Interna"}, {id: 1, descrizione: "Esterna"}];
            if (!angular.isDefined(vm.extra.esterna)) {
                vm.extra.esterna = 0;
            }
        }



        vm.datainiziomin = datainiziomin;
        function datainiziomin(dataevento) {
            console.log("vm.oggim4", dataevento);
            var data = new Date(dataevento);
            if (data < vm.oggim4) {
                vm.oggim4 = data;
            }

        }

        vm.calcoladata = calcoladata;
        function calcoladata(giorni, variabile) {
            if (vm[variabile] === null) {
                var oggi = new Date();
                var today = moment(oggi);
                var risultato = null;
                if (giorni >= 0) {
                    risultato = new Date(today.add(giorni, 'days').format('YYYY-MM-DD'));
                    vm[variabile] = risultato;
                } else {
                    giorni = giorni * -1;
                    risultato = new Date(today.subtract(giorni, 'days').format('YYYY-MM-DD'));
                    vm[variabile] = risultato;
                }
            }
            return vm[variabile];
        }

        vm.copyextra = copyextra;
        function copyextra(nome, valore) {
            if (angular.isDate(valore)) {
                valore = moment(valore).format("YYYY-MM-DD");
            }
            vm.extra[nome] = valore;
        }
        vm.copyextrafilter = copyextrafilter;
        function copyextrafilter(nome, array, payload, valore) {
            vm.extra[nome] = $filter('filter')(array, payload)[0][valore];
        }
        vm.copyparent = copyparent;
        function copyparent(nome, valore) {
            if (angular.isDate(valore)) {
                valore = moment(valore).format("YYYY-MM-DD");
            }
            vm.parent[nome] = valore;
        }
        vm.copyparentfilter = copyparentfilter;
        function copyparentfilter(nome, array, payload, valore) {
            vm.parent[nome] = $filter('filter')(array, payload)[0][valore];
        }

        vm.messaggio = {
            attenzione: '',
            errore: '',
            info: ''
        };

        vm.checkMotivoTrasferimento = checkMotivoTrasferimento;
        function checkMotivoTrasferimento() {
//            console.log("vm.uploadParams.caricato", angular.copy(vm.uploadParams.caricato));
//            console.log("vm.lastDataBuilded.caricato", angular.copy(vm.lastDataBuilded.caricato));
//            console.log("vm.uploadParams.mincaricato", angular.copy(vm.uploadParams.mincaricato));
//            console.log("vm.lastDataBuilded.mincaricato", angular.copy(vm.lastDataBuilded.mincaricato));
//            console.log("vm.uploadParams.tuttidocumenti", angular.copy(vm.uploadParams.tuttidocumenti));
//            console.log("vm.lastDataBuilded.tuttidocumenti", angular.copy(vm.lastDataBuilded.tuttidocumenti));
            vm.mincaricato = 0;
            vm.uploadParams.mostratutti = true;
            vm.lastDataBuilded.mostratutti = true;
            if (angular.isDefined(vm.lastDataBuilded.tuttidocumenti)) {
                vm.uploadParams.caricato = vm.lastDataBuilded.tuttidocumenti;
                vm.uploadParams.tuttidocumenti = vm.lastDataBuilded.tuttidocumenti;
            }
            if (angular.isDefined(vm.uploadParams.tuttidocumenti)) {
                vm.uploadParams.caricato = vm.uploadParams.tuttidocumenti;
                vm.lastDataBuilded.tuttidocumenti = vm.uploadParams.tuttidocumenti;
            }
            if (vm.lastDataBuilded.caricato > vm.uploadParams.caricato) {
                vm.uploadParams.caricato = vm.lastDataBuilded.caricato;
            }
            if (angular.isUndefined(vm.uploadParams.caricato)) {
                vm.uploadParams.caricato = 0;
            }


            if (vm.extra.motivoTrasferimento == 1061) {
                vm.messaggio.attenzione = "Allegare il modello F alla presente richiesta.<br>Il modello è disponibile a <a href=\"http:\/\/www.sprar.it\/wp-content\/uploads\/2017\/05\/SPRAR_-_Mod_F__richiesta_inserimento_DM.doc\" target=\"_blank\">questo link</a>.";

                vm.mincaricato = 0;
                vm.lastDataBuilded.mincaricato = vm.mincaricato;
                vm.uploadParams.mincaricato = vm.mincaricato;
                vm.buildUP(vm.uploadParams);
            } else {
                vm.messaggio.attenzione = "";
                vm.mincaricato = 0;
                vm.lastDataBuilded.mincaricato = vm.mincaricato;
                vm.uploadParams.mincaricato = vm.mincaricato;
                vm.buildUP(vm.uploadParams);
            }
            console.log("vm.uploadParams.caricato", angular.copy(vm.uploadParams.caricato));
            console.log("vm.lastDataBuilded.caricato", angular.copy(vm.lastDataBuilded.caricato));
            console.log("vm.uploadParams.mincaricato", angular.copy(vm.uploadParams.mincaricato));
            console.log("vm.lastDataBuilded.mincaricato", angular.copy(vm.lastDataBuilded.mincaricato));
            console.log("vm.uploadParams.tuttidocumenti", angular.copy(vm.uploadParams.tuttidocumenti));
            console.log("vm.lastDataBuilded.tuttidocumenti", angular.copy(vm.lastDataBuilded.tuttidocumenti));
        }

        vm.monitoraggio_tipo = [{id: 'PRIMA VISITA'}, {id: 'SECONDA VISITA'}, {id: 'TERZA VISITA'}];
        vm.commissiones = [
            {id: "ANCONA", competenza: "Marche, Abruzzo"},
            {id: "BARI", competenza: "Bari, Matera"},
            {id: "BOLOGNA", competenza: "Emilia Romagna"},
            {id: "BRESCIA", competenza: "Brescia, Bergamo, Cremona. Mantova"},
            {id: "CAGLIARI", competenza: "Sardegna"},
            {id: "CASERTA", competenza: "Caserta, Avellino, Benevento"},
            {id: "CATANIA", competenza: "Catania, Enna"},
            {id: "CROTONE", competenza: "Calabria"},
            {id: "FIRENZE", competenza: "Toscana, Umbria"},
            {id: "FOGGIA", competenza: "Foggia, Barletta-Andria-Trani"},
            {id: "GORIZIA", competenza: "Friuli Venezia Giulia"},
            {id: "LECCE", competenza: "Lecce, Brindisi, Taranto"},
            {id: "MILANO", competenza: "Lombardia"},
            {id: "PALERMO", competenza: "Palermo, Messina"},
            {id: "ROMA", competenza: "Lazio"},
            {id: "SALERNO", competenza: "Salerno, Napoli, Potenza, Molise"},
            {id: "SIRACUSA", competenza: "Siracusa, Caltanissetta, Ragusa"},
            {id: "TORINO", competenza: "Piemonte, Liguria, Valle D'Aosta"},
            {id: "TRAPANI", competenza: "Trapani, Agrigento"},
            {id: "VERONA", competenza: "Veneto, Trentino Alto Adige"}
        ];

        vm.nstatusgs = [
            {id: 591, descrizione: "TITOLARE PROTEZIONE INT.LE - STATUS RIFUGIATO"},
            {id: 592, descrizione: "TITOLARE PROTEZIONE INT.LE - PROT.NE SUSSIDIARIA"},
            {id: 593, descrizione: "TITOLARE PROTEZIONE UMANITARIA"}
        ];
        vm.motivoprorogas = ricerca.motivoprorogas;
        vm.motivotrasferimentos = ricerca.motivitrasferimento;
        vm.loadquestura = loadquestura;
        function loadquestura() {
            api.entes.ente.cerca({'enteTipo_id': 7, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.questuras = response.data;
            });
        }
        //vm.filterloadquestura = [2000, 2020, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 3002];
        vm.filterloadquestura = [2000, 3002, 2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2999];
        if (vm.filterloadquestura.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            loadquestura();
        }

        vm.loadprefettura = loadprefettura;
        function loadprefettura() {
            api.entes.ente.cerca({'enteTipo_id': 8, pagination: 200, attivo: 1, sort: "nome", fields: "id,nome", dacl: 1}, function (response) {
                vm.prefetturas = response.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000 || vm.segnalatis[0].eventoTipo_id == 3003) {
            loadprefettura();
        }

        if (vm.segnalatis[0].eventoTipo_id == 3001) {
            console.log(vm.segnalatis[0]);
            vm.accoglienzas = [];
            vm.alloggios = [];
            vm.istats = [];
            api.strutture.accoglienza.get({sort: 'descrizione'}, function (response) {
                vm.accoglienzas = response.data;
            });
            api.strutture.alloggio.get({sort: 'descrizione'}, function (response) {
                vm.alloggios = response.data;
            });
            api.istats.istat.cerca({codProvincia: vm.segnalatis[0].entita1.codProvincia, pagination: 400, sort: 'comune'}, function (response) {
                vm.istats = response.data;
            });
            vm.progetto_id = vm.segnalatis[0].entita1_id;
            vm.codRegione = vm.segnalatis[0].entita1.codRegione;
            vm.codProvincia = vm.segnalatis[0].entita1.codProvincia;
        }

        vm.motivods = motivods;
        function motivods() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DINIEGO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivods = r.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000) {
            motivods();
        }

        vm.documentotipos = [];
        vm.loaddocumentotipos = loaddocumentotipos;
        function loaddocumentotipos() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DOCUMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.documentotipos = r.data;
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 2000) {
            loaddocumentotipos();
        }
        if (vm.segnalatis[0].eventoTipo_id > 2600 && vm.segnalatis[0].eventoTipo_id < 3000) {
            vm.dataMinimaDocumento = new Date();
            if (angular.isDefined(vm.segnalatis[0].entita1.dataIngresso)) {
                vm.dataMinimaDocumento = new Date(vm.segnalatis[0].entita1.dataIngresso);
            }
            if (angular.isDefined(vm.segnalatis[0].entita1.dataScadenzaDocumento)) {
                vm.dataMinimaDocumento = new Date(vm.segnalatis[0].entita1.dataRilascioDocumento);
            }
        }

        vm.motivouscita = motivouscita;
        function motivouscita() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MOTIVO-USCITA", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscita = r.data;
            });
        }
        vm.filtermotiviuscita = [1010, 1016];
        if (vm.filtermotiviuscita.indexOf(vm.segnalatis[0].eventoTipo_id) >= 0) {
            motivouscita();
            motivouscitavol();
            motivouscitains();
            motivouscitainsluo();
            motivouscitainstip();
            motivouscitainsall();
            motivouscitainscon();
            motivouscitainsfas();
            motivouscitainsallsi();
            motivouscitainsconsi();
            motivouscitainstiplav();
            motivouscitainstiplavset();
            motivouscitainstiplavpro();
            motivouscitainstiplavtip();
        }

        vm.motivouscitavol = motivouscitavol;
        function motivouscitavol() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-VOLONTARIA_PRIMA_DEI_TERMINI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitaVol = r.data;
            });
        }

        vm.motivouscitainsall = motivouscitainsall;
        function motivouscitainsall() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-ALLOGGIO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsAll = r.data;
            });
        }

        vm.motivouscitainscon = motivouscitainscon;
        function motivouscitainscon() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-CONTRIBUTO_EROGATO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsCon = r.data;
            });
        }

        vm.motivouscitains = motivouscitains;
        function motivouscitains() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INSERIMENTO_SOCIO-ECONOMICO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitaIns = r.data;
            });
        }

        vm.motivouscitainsluo = motivouscitainsluo;
        function motivouscitainsluo() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-LUOGO_DI_INSERIMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsLuo = r.data;
            });
        }

        vm.motivouscitainstip = motivouscitainstip;
        function motivouscitainstip() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIPO_INSERIMENTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsTip = r.data;
            });
        }

        vm.motivouscitainsfas = motivouscitainsfas;
        function motivouscitainsfas() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-FASCIA_IMPORTO_EROGATO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsFas = r.data;
            });
        }

        vm.motivouscitainstiplav = motivouscitainstiplav;
        function motivouscitainstiplav() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAVORO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstipLav = r.data;
            });
        }

        vm.motivouscitainsallsi = motivouscitainsallsi;
        function motivouscitainsallsi() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-ALLOGGIO-SI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsallSi = r.data;
            });
        }

        vm.motivouscitainsconsi = motivouscitainsconsi;
        function motivouscitainsconsi() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-CONTRIBUTO_EROGATO-SI", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainsconSi = r.data;
            });
        }

        vm.motivouscitainstiplavset = motivouscitainstiplavset;
        function motivouscitainstiplavset() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-SETTORE_LAVORATIVO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavSet = r.data;
            });
        }

        vm.motivouscitainstiplavpro = motivouscitainstiplavpro;
        function motivouscitainstiplavpro() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-PROFESSIONE", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavPro = r.data;
            });
        }

        vm.motivouscitainstiplavtip = motivouscitainstiplavtip;
        function motivouscitainstiplavtip() {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MU-INS-TIP-LAV-TIPO_CONTRATTO", sort: "ordinamento,descrizione"}, function (r) {
                vm.motivouscitainstiplavTip = r.data;
            });
        }

        vm.uploadParams = {};
        vm.buildUP = buildUP;
        vm.lastDataBuilded = {};
        function buildUP(data) {
            //console.log("buildUP");
            // data = {documentoTipo_id, gruppo, dettaglio, dettagliomin, entita, entitakey}
            vm.lastDataBuilded = data;
            vm.uploadParams = {
                documentoTipo_id: data.documentoTipo_id,
                gruppo: data.gruppo,
                dettaglio: data.dettaglio,
                dettagliomin: data.dettagliomin,
                entita: data.entita,
                entitakey: data.entitakey,
                entita_id: vm.entita1_id,
                caricato: data.caricato,
                mincaricato: vm.mincaricato
            };
            vm.uploadParams[data.entitakey] = vm.entita1_id;
            //console.log(vm.uploadParams);
        }
//        vm.uploadParams = {
//            documentoTipo_id: 0,
//            gruppo: 'BENEFICIARIO',
//            dettaglio: false,
//            dettagliomin: true,
//            entita: 'beneficiario',
//            entitakey: vm.entita1_id,
//            beneficiario_id: vm.entita1_id
//        };
        //console.log('uploadParams');
        //console.log(vm.uploadParams);
        vm.progettos = null;
        vm.strutturas = null;
        vm.segnalazione = {};
        vm.segnalazione.progetto_id = 0;
        vm.segnalazione.struttura_id = 0;
        vm.loadprogetto = loadprogetto;
        function loadprogetto() {
            api.progettos.progetto.cerca({attivo: 1, fields: "id,nome,postiLiberi,postiPrenotati", pagination: -1, sort: "nome"}, function (response) {
                //console.log("CARICAMENTO PROGETTI");
                vm.progettos = response.data;
//                vm.progettos.tot = 0;
//                vm.progettos.benefAttivi = 0;
//                vm.progettos.benefTotali = 0;
//                vm.progettos.benefT = [];
//                angular.forEach(vm.progettos.strutturas, function (subobj) {
//                    vm.progettos.tot = vm.progettos.tot + subobj.numeroPosti;
//                    angular.forEach(subobj.strutturahasbeneficiarios, function (subsubobj) {
//                        vm.progettos.benefT.push(subsubobj.beneficiario_id);
//                        vm.progettos.benefTotali++;
//                    });
//                });
//                var insearch = vm.progettos.benefT.join();
//                api.beneficiarios.beneficiario.search({id_IN: insearch, stato: 'BENEFICIARIO', operatore: 'AND'}, function (d) {
//                    vm.progettos.benefAttivi = d.data.length;
//                    vm.progettos.postiTotali = vm.progettos.tot;
//                    vm.progettos.postiLiberi = vm.progettos.tot - vm.progettos.benefAttivi;
//                });
            });
        }
        if (vm.segnalatis[0].eventoTipo_id == 1003 || vm.segnalatis[0].eventoTipo_id == 1013) {
            loadprogetto();
        }


        if (vm.segnalatis[0].eventoTipo_id == 4001 || vm.segnalatis[0].eventoTipo_id == 4002 || vm.segnalatis[0].eventoTipo_id == 4003 || vm.segnalatis[0].eventoTipo_id == 4004 || vm.segnalatis[0].eventoTipo_id == 4005) {
            console.log(vm.entita1_id);
        }


        vm.strutturas = {};
        vm.searchStrutturas = searchStrutturas;
        console.log('progetto selezionato corrente:' + vm.progetto_id_current);
        function searchStrutturas() {
            api.strutturas.strutturamin.cerca({'progetto_id': vm.progetto_id_current, pagination: 600, attivo: 1}, function (response) {
                vm.strutturas = response.data;
                vm.backupStruttura = response.data;

                angular.forEach(vm.strutturas, function (objstruttura) {
                    var postioccupatistruttura = 0;
                    angular.forEach(objstruttura.strutturahasbeneficiarios, function (shb) {
                        if (shb.dataCessazione == null) {
                            postioccupatistruttura = postioccupatistruttura + 1;
                        }
                    });
                    //console.log("postioccupatistruttura", postioccupatistruttura);
                    //console.log(objstruttura);
                    objstruttura.numeroPostiLiberi = objstruttura.numeroPosti - postioccupatistruttura;
                });
//                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
//                    vm.strutturas.push(r1.data[0]);
//                });
                console.log("vm.strutturas:", vm.strutturas);
                if (angular.isUndefined(vm.extra.esterna)) {
                    vm.extra.esterna = 0;
                }
                filtraStrutture();
            });

        }
        if (vm.progetto_id_current > 0) {
            searchStrutturas();
        }

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
            //$state.reload();
        }
        vm.save = save;
        vm.reject = reject;
        function save() {
            var parentcopy = angular.copy(vm.parent);
            angular.forEach(parentcopy, function (pv, pk) {
// da provare
//                if (pk.startsWith("data")) {
//                    if (pv === '0000-00-00' || pv === null) {
//                        parentcopy[pk] = null;
//                    } else {
//                        parentcopy[pk] = moment(pv).format('YYYY-MM-DD');
//                    }
//                }
// vecchio modo
                if (angular.isDate(pv)) {
                    parentcopy[pk] = moment(pv).format('YYYY-MM-DD');
                }
            });
            var selfcopy = angular.copy(vm.self);
            angular.forEach(selfcopy, function (sv, sk) {
                if (angular.isDate(sv)) {
                    selfcopy[sk] = moment(sv).format('YYYY-MM-DD');
                }
            });

            //vm.payload.self = vm.self;
            vm.payload.self = selfcopy;
            vm.payload.extra = vm.extra;
            //vm.payload.parent = vm.parent;
            vm.payload.parent = parentcopy;


            var oggi = new Date();
            vm.payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
            console.log('---save fx')
            console.log('Paylod da inviare');
            console.log(vm.payload);
            api.processi.processo.lavora(vm.payload, function (response) {
                console.log(response);
                closeDialog();
                if (response.status == 200) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Processo lavorato correttamente!!')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });
        }
        function reject() {
            var selfcopy = {};
            selfcopy.id = vm.segnalatis[0].id;
            selfcopy.eventoStato_id = vm.segnalatis[0].ordine;
            selfcopy.ordine = 0;

            console.log("vm.self", selfcopy);

            api.eventos.evento.update(selfcopy, function (r) {
                if (r.id == selfcopy.id) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Processo annullato.')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.reload()
                            );
                }
            });


        }
        vm.dataLimite = {};
        vm.cambiaData = cambiaData;
        function cambiaData(nomeData) {
            var dataLimiteMinimo = null;
            if (angular.isDefined(vm.dataLimite[nomeData]) && angular.isDate(vm.dataLimite[nomeData])) {
                return  vm.dataLimite[nomeData];
            }
            if (vm.segnalatis[0].eventoTipo_id == 2000) {
                var beneficiario = vm.segnalatis[0].entita1;
                var controlli = [
                    'dataIngresso',
                    'dataInteresseExArt',
                    'dataC3',
                    'dataRichiestaProtezione',
                    'dataAudizione',
                    'dataNotificaDiniego',
                    'dataNotificaRicorso'
                ];
                vm.finoA = controlli.indexOf(nomeData);
                for (i = 0; i < vm.finoA; i++) {
                    if (beneficiario[controlli[i]] !== null) {
                        dataLimiteMinimo = new Date(beneficiario[controlli[i]]);

                    }

                }
                vm.dataLimite[nomeData] = dataLimiteMinimo;

            }
            return dataLimiteMinimo;



        }

        vm.dataMinimoTrasferimento = dataMinimoTrasferimento;
        vm.setupDataMinimoTrasferimento = false;
        function dataMinimoTrasferimento() {

            if (vm.setupDataMinimoTrasferimento === false) {
                vm.setupDataMinimoTrasferimento = true;
                var b_id = vm.segnalatis[0].entita1.id;
                var s_id = vm.segnalatis[0].entita1.struttura_id;
                api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                    angular.forEach(st.data, function (shb) {
                        //console.log("shb", shb);
                        vm.setupDataMinimoTrasferimento = new Date(shb.dataInserimento);
                    });
                });

            }
            //console.log("cccc", vm.setupDataMinimoTrasferimento);
            return vm.setupDataMinimoTrasferimento;

        }
        vm.dataMinimoCTrasferimento = dataMinimoCTrasferimento;
        vm.setupDataMinimoCTrasferimento = false;
        function dataMinimoCTrasferimento() {

            if (vm.setupDataMinimoCTrasferimento === false) {
                vm.setupDataMinimoCTrasferimento = true;
                var b_id = vm.segnalatis[0].entita1.id;
                var s_id = vm.segnalatis[0].entita1.struttura_id;
                api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                    angular.forEach(st.data, function (shb) {
                        //console.log("shb", shb);
                        vm.setupDataMinimoCTrasferimento = new Date(shb.dataInserimento);
                    });
                    console.log("setupDataMinimoCTrasferimento:", vm.setupDataMinimoCTrasferimento);
//                    api.strutturas.strutturamin.get({id: s_id}, function (std) {
//                        console.log("std:", std.dataInizio);
//                        if (angular.isDefined(std.dataInizio)) {
//                            var dataInizioStruttura = new Date(std.dataInizio);
//                            if (dataInizioStruttura > vm.setupDataMinimoCTrasferimento) {
//                                vm.setupDataMinimoCTrasferimento = dataInizioStruttura;
//                            }
//                        }
//
//                    });
                });

            }
            //console.log("cccc", vm.setupDataMinimoCTrasferimento);
            return vm.setupDataMinimoCTrasferimento;

        }
        vm.dataMinimoCTrasferimento2 = dataMinimoCTrasferimento2;
        function dataMinimoCTrasferimento2() {
            var b_id = vm.segnalatis[0].entita1.id;
            var s_id = vm.segnalatis[0].entita1.struttura_id;
            api.strutturas.hasbeneficiario.search({beneficiario_id: b_id, struttura_id: s_id, sort: "dataInserimento"}, function (st) {
                angular.forEach(st.data, function (shb) {
                    //console.log("shb", shb);
                    vm.setupDataMinimoCTrasferimento = new Date(shb.dataInserimento);
                });
                console.log("setupDataMinimoCTrasferimento:", vm.setupDataMinimoCTrasferimento);
                api.strutturas.strutturamin.get({id: vm.extra.struttura_id}, function (std) {
                    console.log("std:", std.dataInizio);
                    if (angular.isDefined(std.dataInizio)) {
                        var dataInizioStruttura = new Date(std.dataInizio);
                        if (dataInizioStruttura > vm.setupDataMinimoCTrasferimento) {
                            vm.setupDataMinimoCTrasferimento = dataInizioStruttura;
                        }
                    }

                });
            });


        }
        vm.dataMinimoTrasferimentoArrivo = dataMinimoTrasferimentoArrivo;
        vm.setupDataMinimoTrasferimentoArrivo = false;
        function dataMinimoTrasferimentoArrivo() {

            if (vm.setupDataMinimoTrasferimentoArrivo === false) {
                vm.setupDataMinimoTrasferimentoArrivo = true;
                vm.setupDataMinimoTrasferimentoArrivo = new Date(vm.extra.dataTrasferimento);

            }
            //console.log("cccc", vm.setupDataMinimoTrasferimento);

            return vm.setupDataMinimoTrasferimentoArrivo;
        }
        vm.dataMinimoTrasferimentoArrivo2 = dataMinimoTrasferimentoArrivo2;
        function dataMinimoTrasferimentoArrivo2() {
            vm.setupDataMinimoTrasferimentoArrivo = new Date(vm.extra.dataTrasferimento);
            api.strutturas.strutturamin.get({id: vm.extra.struttura_id}, function (std) {
                console.log("std:", std.dataInizio);
                if (angular.isDefined(std.dataInizio)) {
                    var dataInizioStruttura = new Date(std.dataInizio);
                    if (dataInizioStruttura > vm.setupDataMinimoTrasferimentoArrivo) {
                        vm.setupDataMinimoTrasferimentoArrivo = dataInizioStruttura;
                    }
                }

            });
        }


    }

    function EventosDialogController($mdDialog, locals, msUtils, msApi, $state, api, item, tipo, $filter, eventi)
    {
        var vm = this;
        vm.item = angular.copy(item);
        vm.tipo = tipo;
        vm.items = eventi.eventiDetails;
        vm.getDataModel = DataModel;
        function DataModel(path) {
            //console.log(path);
            var paths = path.split('.');
            var root = vm.item;
            angular.forEach(paths, function (obj) {
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                    } catch (err) {
                    }
                    angular.forEach(root, function (rd, rk) {
                        if (rk.toLowerCase().indexOf("data") !== -1) {
                            root[rk] = new Date(rd);
                            root[rk] = moment(root[rk]).format("DD/MM/YYYY");
                        }

                    })
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
        }
    }

    function letteraDialogController($mdDialog, api, ricerca, $mdToast, $scope, locals) {
        var vm = this;
        vm.data = locals;
        vm.saveLettera = saveLettera;
        function saveLettera() {
            $mdDialog.hide(vm.data.renderizzato);
        }

        vm.closeDialog = closeLettera;
        function closeLettera() {
            $mdDialog.hide();
        }
    }
    function omonimoDialogController($mdDialog, api, ricerca, $mdToast, $scope, locals) {
        var vmd = this;
        vmd.data = locals;
        vmd.documentotipo = function () {
            api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}).$promise.then(function (response) {
                vmd.documentotipos = response.data;
            }, function (response) {
                console.log('documenti caricata');
            });
        };
        vmd.documentotipo();
        vmd.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vmd.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vmd.parentela();
        vmd.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vmd.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vmd.vulnerabilita();
        vmd.nazione = function () {
            api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "NAZIONE", sort: "ordinamento,descrizione", pagination: 500}).$promise.then(function (response) {
                vmd.naziones = response.data;
                //console.log("naziones",vmd.naziones)
            }, function (response) {
                console.log('Nazioni caricata');
            });
        };
        vmd.nazione();

        vmd.progettos = vmd.data.progettos;

        vmd.nuovoinserimento = nuovoinserimento;
        function nuovoinserimento() {
            var payload = {
                id: vmd.data.omonimo.id,
                omonimoRisolto: 1,
                omonimo: 0
            }
            console.log("payload nuovo", payload);
            $mdDialog.hide(payload);
        }

        vmd.rifiutoDiretto = rifiutoDiretto;

        function rifiutoDiretto() {

            var diretto = {};
            diretto.segnalato = vmd.data.segnalato
            diretto.controllo = "diretto";
            $mdDialog.hide(diretto);

        }

        vmd.conserva = conserva;
        function conserva(item) {
            //sovrascrivi segnalazione con dati beneficiario
            var progettoTemp = vmd.data.omonimo.progetto_id;
            var strutturaTemp = vmd.data.omonimo.struttura_id;
            var isAuto = false;
            if (vmd.data.omonimo.segnalaziones.idTipoSegnalazione == 656 || vmd.data.omonimo.segnalaziones.idTipoSegnalazione == 689) {
                isAuto = true;
            }

            var campiDaIgnorare = [
                'dataIngresso',
                'dataInserimento',
                'def',
                'esterna',
                'omonimo',
                'omonimoRisolto',
                'dataInizio',
                'progetto_id',
                'struttura_id',
                'idTipoDocumento',
                'enteDocumento_id',
                'documentoNumero',
                'dataRilascioDocumento',
                'dataScadenzaDocumento',
                'cambioQPC',
                'noteCambioQPC',
                'tipoProtezione_id',
                'interesseExArt',
                'dataInteresseExArt',
                'c3',
                'dataC3',
                'dataRichiestaProtezione',
                'dataRichiestaPds',
                'extraCommissione'
            ];
            var campiDaAggiungere = [
                'note',
                'noteSanitarie'
            ];
            var payload = {};
            angular.forEach(item, function (valore, campo) {
                if (angular.isDefined(vmd.data.omonimo[campo]) && campiDaIgnorare.indexOf(campo) == -1) {
                    payload[campo] = valore;
                }
                if (angular.isDefined(vmd.data.omonimo[campo]) && campiDaAggiungere.indexOf(campo) > -1) {
                    payload[campo] = vmd.data.omonimo[campo] + " " + valore;
                }
            });
            if (isAuto) {
                payload.progetto_id = progettoTemp;
                payload.struttura_id = strutturaTemp;
            }

            payload.segnalazione_id = vmd.data.omonimo.segnalazione_id;
            payload.id = vmd.data.omonimo.id;
            payload.omonimoRisolto = 1;
            payload.omonimo = item.id;
            if (item.pl == 1) {
                //omonimia con postLogin
                payload.omonimoRisolto = 2;
            }
            console.log("payload conserva", payload);
            $mdDialog.hide(payload);
            $state.reload();
        }
        vmd.sovrascrivi = sovrascrivi;
        function sovrascrivi(item) {
            //sovrascrivi beneficiario con segnalazione
            var payload = {
                id: vmd.data.omonimo.id,
                omonimoRisolto: 1,
                omonimo: item.id
            }
            $mdDialog.hide(payload);
        }

        vmd.closeDialog = function () {
          $mdDialog.hide();
        };
    }

    function OmonimiController($scope,$mdDialog,locals,api,$mdToast, $state) {
      var vmd = this;
      vmd.omonimi = locals.omonimi;
      vmd.item = locals.item;
      vmd.isModelloC = [656,689].includes(vmd.item.segnalazione.idTipoSegnalazione);

      vmd.nuovoinserimento = nuovoinserimento;
      function nuovoinserimento() {
        if (!vmd.isModelloC){
          $mdDialog.show({
              controller: 'InserisciController',
              controllerAs: 'vmd',
              templateUrl: 'app/main/sprardb/eventi/dialogs/inserisci-segnalato.html',
              clickOutsideToClose: true,
            locals: {
              segnalati : [vmd.item],
            }
          }).then(function (res) {
            if (res){
              api.segnalatos.segnalato.inserisciBeneficiario({id:vmd.item.id,note:res.note,dataInizio:res.dataInizio},function(res){
                $mdToast.show(
                  $mdToast.simple()
                    .textContent('Il segnalato è stato lavorato correttamente.')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $state.reload()
              })

            }

          });
        }else {
          api.segnalatos.segnalato.inserisciBeneficiario({id:vmd.item.id},function(res){
            $mdToast.show(
              $mdToast.simple()
                .textContent('Il segnalato è stato lavorato correttamente.')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
          $mdDialog.hide();
        }

      }

      vmd.cancellaSegnalato = cancellaSegnalato
      function cancellaSegnalato() {
        api.segnalatos.segnalato.elimina({id: vmd.item.id}, function(res) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Il segnalato è stato rimosso correttamente.')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
      }

      vmd.rifiutasegnalato = rifiutaSegnalato;
      function rifiutaSegnalato() {
        $mdDialog.show({
          controller: 'RifiutaController',
          controllerAs: 'vmd',
          templateUrl: 'app/main/sprardb/eventi/dialogs/rifiuta-segnalato.html',
          clickOutsideToClose: true,
          locals: {
            segnalati : vmd.item,
          }
        }).then(function (payload) {
          payload.id = vmd.item.id;
          api.segnalatos.segnalato.rifiutaSegnalato(payload,function(res){
            $mdToast.show(
              $mdToast.simple()
                .textContent('Il segnalato è stato rifiutato correttamente.')
                .position('bottom right')
                .hideDelay(3000)
            );
            $mdDialog.hide();
            $state.reload();
          })
        });
      }

      vmd.conservaDati = conservaDati;
      function conservaDati(item) {
        var conferma =  $mdDialog.confirm()
          .title('Reinserimento')
          .textContent('Sei sicuro di voler reinserire il beneficiario?')
          .ariaLabel('Confirmation Box')
          .ok('CONFERMA')
          .cancel('ANNULLA');
        $mdDialog.show(conferma).then(function (){
          var params = {
            id: vmd.item.id,
            omonimo_id: item.omonimo.id,
            tipo: item.tipo
          }
          api.segnalatos.segnalato.reinserimento(params, function (res) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Reinserimento effettuato con successo')
                .position('bottom right')
                .hideDelay(3000)
            );
          })

        });

      }

      vmd.closeDialog = function () {
        $mdDialog.hide();
      }
    }

    function ListaTrasferimentiController($scope, $mdSidenav, $mdDialog, $timeout, $cookies, $state, $document, api, $filter, $mdToast, eventi, ricerca, acl, $cookieStore, $rootScope) {
        var vm = this;

        vm.isAdmin = api.isAdmin;
        vm.api = api;
        //vm.tipo = $state.current.datas.tipo;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly;
        vm.permissions = api.user.permissions;
        vm.canLavora = vm.permissions.indexOf('lavora-segnalato') !== -1;
        vm.isallowed = acl.isallowed2;
        vm.statoiniziale = ["1"];
        vm.baseUrl = api.baseUrl;

        vm.searchForms1013 = {
            "id": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progetto2s-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progetto2s-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progetto2s-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.progettosa",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progetto2s-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progetto2s-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipologia_id_IN": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-tipologia_id_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "beneficiarios-codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-def_IN": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-def_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "beneficiarios-idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "beneficiarios-dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "beneficiarios-dataIngresso>": {
                type: "string",
                title: "Data Ingresso",
                description: "Data Ingresso",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataIngresso>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataUscita<": {
                type: "string",
                title: "Data Uscita",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-id": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-id",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "beneficiarios-dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "beneficiarios-dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "eventoStato_id_IN": {
                type: "string",
                title: "Stato Segnalazione",
                description: "Stato Segnalazione",
                callbackModel: "ricerca",
                dbfield: "eventoStato_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoeventos",
                chiave: "id",
                valore: "stato|uppercase",
                style: "display: none;"
            },
            "beneficiarios-cancellato_IN": {
              type: "string",
              title: "Cancellato",
              description: "Cancellato...",
              callbackModel: "ricerca",
              dbfield: "beneficiarios-cancellato_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.sino",
              chiave: "id",
              valore: "descrizione|uppercase"
            }
        };
        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.segEnte = false;
        vm.segProgetto = false;
        vm.segArrivato = false;
        vm.benCompleta = false;
        vm.segCessato = false;
        vm.benProroga = false;
        vm.auto = false;
        if ($state.params.auto) {
            vm.auto = $state.params.auto;
        }

        if (angular.isDefined($state.current.datas)) {
            vm.datas = $state.current.datas;
            vm.statoiniziale = vm.datas.statoiniziale;
        }
        vm.searchForms = angular.copy(vm.searchForms1013);

        vm.title = $state.current.datas.titolo;
        vm.selected = [];
        vm.options = {
            rowSelection: true,
            multiSelect: true,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: false,
            limitSelect: true,
            pageSelect: true
        };
        vm.search = null;

        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.autostart = false;
        //preselezione
        vm.prericerca = {operatore: 'AND'};
        vm.preselezione = $cookieStore.get('progetto_id');
        vm.eventoTipo_id = 0;
        if (angular.isDefined($state.params.eventoTipo_id)) {
            vm.eventoTipo_id = $state.params.eventoTipo_id;
            vm.autostart = true;
        }
        vm.prericerca['eventoTipo_id_IN'] = vm.eventoTipo_id;
        var campo_progetto_id = "progetto_id_IN";
        vm.prericerca['beneficiarios-cancellato_IN'] = [0];
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.prericerca[campo_progetto_id] = [vm.preselezione.toString()];
            vm.autostart = true;
        }

        vm.notifications = [];
        vm.links = [];
        vm.meta = [];
        vm.scolors = eventi.scolors;
        vm.colors = eventi.colors2;
        vm.icons = eventi.icons;
        vm.ricerca = {};
        vm.ricerca = angular.copy(vm.prericerca);



        vm.ricercalabel = {};
        vm.ricerca2 = "";
        vm.searched = false;
        vm.eventos = null;
        vm.notselectable = [];


        //ricerca variabili
        vm.sesso = ricerca.sesso;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        if (vm.api.isAdmin || vm.api.isAccoglienza) {
            vm.progettosa = ricerca.progettos;
        } else {
            vm.progettosa = ricerca.autorizzatoprogettos;
        }
        vm.nazioneb = ricerca.naziones;
        vm.tiposegnalazione = ricerca.tiposegnalazione;
        vm.tipoasegnalazione = ricerca.tipoasegnalazione;
        vm.nucleoFamiliare = ricerca.nucleoFamiliare;
        vm.tipoproteziones = ricerca.tipoprotezione;
        vm.motivoprorogas = ricerca.motivoprorogas;
        vm.vulnerabilitas = ricerca.vulnerabilita;
        vm.tipoall = angular.copy(vm.tiposegnalazione);
        angular.forEach(vm.tipoasegnalazione, function (tas) {
            vm.tipoall.push(tas);
        });
        vm.sino = ricerca.sino;
        vm.sino2 = [{id: ">1", descrizione: "SI"}];
        vm.sino3 = [{id: "-1", descrizione: "OMONIMO NON RISOLTO"}, {id: "0", descrizione: "NON OMONIMO"}, {id: "1", descrizione: "OMONIMO RISOLTO"}, {id: "2", descrizione: "OMONIMO RISOLTO POSTLOGIN"}];
        vm.tiporifiuto = [{id: '"tipoRifiuto":1', descrizione: "RIFIUTO SC"}, {id: '"tipoRifiuto":2', descrizione: "RIFIUTATO OMONIMIA"}];

        vm.ente1 = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        vm.entetipos = angular.copy(vm.ente1);
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        });
        vm.bandos = ricerca.bandos;
        vm.statoeventos_temp = angular.copy(ricerca.statoeventos);
        vm.statoeventos = [];
        vm.filtrostatoeventi = [20];
        angular.forEach(vm.statoeventos_temp, function (se) {
            if (vm.filtrostatoeventi.indexOf(se.id) !== -1) {
                  vm.statoeventos.push(se);
            }
        });
        vm.tipoeventos_temp = [];
        vm.tipoeventos = [];
        api.eventos.tipo.search({sort: "id", pagination: 100, fields: "id,nome,statiPossibili,entita1,entita2"}, function (r) {
            vm.tipoeventos_temp = r.data;
            vm.filtroeventi = [1002, 1003, 1004, 1006];
            angular.forEach(vm.tipoeventos_temp, function (te) {
                if (vm.filtroeventi.indexOf(te.id) !== -1) {
                    vm.tipoeventos.push(te);
                }
            });
        });
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        })

        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipAccoglienza = res.data;
        });

        vm.loaditems = function (tiporicerca) {
            vm.searching = true;
            $rootScope.loadingProgress = true;
            var tr = tiporicerca;
            if (angular.isUndefined(tr)) {
                tr = "search";
            }

            if (vm.prequery !== null) {
                vm.prequery = angular.fromJson(vm.prequery);
                angular.forEach(vm.prequery, function (v, k) {
                    vm.allsearchs['query[]'][1][k] = v;
                    vm.ricerca[k] = v;
                });
            }
            api.eventos.evento[tr](vm.allsearchs).$promise.then(function (d) {
                $rootScope.loadingProgress = false;
                vm.searching = false;
                vm.eventos = d.data;
                vm.meta = d._meta;
                vm.links = d._links;
                angular.forEach(vm.eventos, function (obj) {
                    //vm.title = JSON.parse(obj.eventoTipo.extra).title;
                    if (obj.extra) {
                        obj.extra = JSON.parse(obj.extra);
                    } else {
                        obj.extra = {};
                    }

                    obj.processi = obj.eventoTipo.processo.split("|");
                    if (obj.eventoStato_id < 4) {
                        vm.notselectable.push(obj.eventoTipo_id);
                    }
                });
                vm.searched = true;
            });
            return vm.eventos;
        };

        vm.ricercaNome = null;
        vm.ricercaCognome = null;
        vm.ricercaCodice = null;
        vm.ricercaProgetti = null;
        vm.onSearch = onSearch;
        function onSearch() {
            var tiporicerca = 'search';

            vm.eventos = null;
            if (vm.ricercaNome){
              tiporicerca = 'like';
              vm.searchForms['beneficiarios-nome'] = {title: 'nome'};
              vm.ricerca['beneficiarios-nome'] = vm.ricercaNome;
            }else{
              delete vm.ricerca['beneficiarios-nome'];
            }
            if (vm.ricercaCognome){
              tiporicerca = 'like';
              vm.searchForms['beneficiarios-cognome'] = {title: 'cognome'};
              vm.ricerca['beneficiarios-cognome'] = vm.ricercaCognome;
            }else{
              delete vm.ricerca['beneficiarios-cognome'];
            }
            if (vm.ricercaCodice){
              vm.searchForms['beneficiarios-codice'] = {title: 'codice'};
              vm.ricerca['beneficiarios-codice'] = vm.ricercaCodice;
            }else{
              delete vm.ricerca['beneficiarios-codice'];
            }
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.allsearchs['query[]'][1] = {};
            vm.allsearchs['query[]'][1]['operatore'] = 'AND';
            //vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
            if (vm.ricerca2) {
                tiporicerca = 'like';
                vm.allsearchs['query[]'][0].operatore = 'OR';
                if ($state.params.eventoTipo_id >= 1007 && $state.params.eventoTipo_id <= 2999) {
                    vm.allsearchs['query[]'][0]['beneficiarios-nome'] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]['beneficiarios-cognome'] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]['beneficiarios-codice'] = vm.ricerca2;
                }
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            var pagingCorrente = {};
            pagingCorrente.page = vm.allsearchs.page;
            pagingCorrente.pagination = vm.allsearchs.pagination;
            pagingCorrente.sort = vm.allsearchs.sort;

            //console.log("controllo", $cookies.getObject('reload').reload);
            var reloadCookie = $cookies.getObject('reload');
            if (!reloadCookie || angular.isUndefined(reloadCookie)) {
                $cookies.putObject('ricerca-corrente', {ricerca: vm.ricerca, paginazione: pagingCorrente});
                vm.tempSearch = $cookies.getObject('ricerca-corrente');
                vm.ricerca = vm.tempSearch.ricerca;
                vm.allsearchs.page = vm.tempSearch.paginazione.page;
                vm.allsearchs.pagination = vm.tempSearch.paginazione.pagination;
                vm.allsearchs.sort = vm.tempSearch.paginazione.sort;

                $cookies.putObject('reload', false);
            } else {
                if ($cookies.getObject('ricerca-corrente')) {
                    vm.tempSearch = $cookies.getObject('ricerca-corrente');
                    vm.ricerca = vm.tempSearch.ricerca;
                    vm.allsearchs.page = vm.tempSearch.paginazione.page;
                    vm.allsearchs.pagination = vm.tempSearch.paginazione.pagination;
                    vm.allsearchs.sort = vm.tempSearch.paginazione.sort;
                }
                $cookies.putObject('reload', false);
            }

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
                if (angular.isUndefined(vm.ricerca['eventoTipo_id_IN'])) {
                    vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
                }
            }
            if (!vm.searching) {
                vm.loaditems(tiporicerca);
            }
        }

        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.test = eventi.test;
        vm.work = eventi.work;
        vm.viewPerson = eventi.viewDetails;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        function deletefiltersearch(key) {
            if (key == 'beneficiarios-nome' || key == 'segnalatos-nome'){
              vm.ricercaNome = null;
            }
            if (key == 'beneficiarios-cognome' || key == 'segnalatos-cognome'){
              vm.ricercaCognome = null;
            }
            if (key == 'beneficiarios-codice' || key == 'segnalatos-id'){
              vm.ricercaCodice = null;
            }
            if (key == 'beneficiarios-progetto_id' || key == 'segnalatos-progetto_id'){
              vm.ricercaProgetti = null;
            }
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            var isNumb = false;
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
                if (angular.isNumber(parseInt(valore))) {
                    valore = parseInt(valore);
                    isNumb = true;
                }
            }

            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;

            var jsonfilter = {};
            var jsonfilterT = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            var jsonfilterN = JSON.parse('{"' + chiave + '":' + valore + '}');
            jsonfilter = jsonfilterT;
            if (isNumb) {
                jsonfilter = jsonfilterN;
            }
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);

            var valores = vm.searchForms[key].valore.split("|");

            return results[0][valores[0]];
        }

        vm.golink = golink;
        function golink(link, payload) {
            $state.go(link, payload);
        }

      vm.cercaProgetti = cercaProgetti;
      function cercaProgetti(nome)
      {
        if (vm.progetti && vm.progetti.$cancelRequest) {
          vm.progetti.$cancelRequest();
        }
        var params = {
          filter: {
            or: [{nome: {xlike: nome+'%'}}, {nome: {like: ' '+nome}}],
            attivo: 1
          },
          fields: "id,nome",
          pagination: "-1",
          sort: "nome"
        }
        vm.progetti = api.progettomc.query(params);
      }



        vm.openDialog = openDialog;

        function openDialog(ev) {
            //  logica per la ricerca del beneficiario e progettiAttivi
            //  servizio API per ottenere i dati del beneficiario
            vm.beneficiari = [];
            vm.progettiAttivi = [];

            // fatto questo posso passare i dati del beneficiario come parametro al dialog
            $mdDialog.show({
                controller: 'ConfermaTrasferimentoController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/eventi/dialogs/dialogConfermaTrasferimento.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                     // Passo i dati del beneficiario al controller del dialog
                }
            });
        }

    }


    function ConfermaTrasferimentoController($scope,$mdDialog,api,locals,$mdToast,$state,ricerca){
        var vmd = this;

        vmd.dataFine = null;
        vmd.api = api;
        vmd.ricerca = ricerca;
        vmd.locals = locals;
        vmd.cancel = function() { $mdDialog.cancel();}
        vmd.salva = salva;
        vmd.cercaBeneficiario = cercaBeneficiario;

        vmd.userCan = api.user.can;

        vmd.strutturas = [];
        vmd.progettoNome = null;
        vmd.progetti = [];
        vmd.cercaModel = {};


        //Carica Tutti i Progetti Attivi
        vmd.loadprogetto = loadprogetto;
        function loadprogetto() {
            api.progettos.progetto.cerca({attivo: 1, fields: "id,nome,codiceMinistero", pagination: -1, sort: "nome"}, function (response) {
                //console.log("CARICAMENTO PROGETTI");
                vmd.progettiTotali = response.data;
            });
        }
        vmd.loadprogetto();

        vmd.cercaProgetti = cercaProgetti;

        //Cerca progetti e ricava il nome
        function cercaProgetti(progettoNome) {
            // Se vmd.progetti non è stato inizializzato, carica tutti i progetti attivi
            if (!vmd.progettiTotali) {
              loadprogetto();
            }

            // Filtra i progetti basati sul nome digitato
            if (progettoNome && vmd.progettiTotali) {
              vmd.progetti = vmd.progettiTotali.filter(function (progetto) {
                return progetto.nome.toLowerCase().includes(progettoNome.toLowerCase()) || progetto.codiceMinistero.toLowerCase().includes(progettoNome.toLowerCase());
              });
            }

          }

        ///////////////


        function cercaBeneficiario() {
          // Creare un oggetto filtro per la ricerca
          var dataNascita = vmd.cercaModel.dataNascita ? moment(vmd.cercaModel.dataNascita).format('YYYY-MM-DD') : null;
          let filter = {
            operatore: 'AND',
            'query[]': [
              { operatore: 'AND', cognome: vmd.cercaModel.cognome },
              { operatore: 'AND', nome: vmd.cercaModel.nome },
              { operatore: 'AND', codNazionalita: vmd.cercaModel.nazione },
              { operatore: 'AND', dataNascita: dataNascita },
              { operatore: 'AND', codice: vmd.cercaModel.codice },
              { operatore: 'AND', progetto_id: vmd.cercaModel.progetto_id },
              { operatore: 'AND', stato: "BENEFICIARIO"},
              { operatore: 'AND', cancellato: 0}
            ],
          };

          // Eseguire la ricerca dei beneficiari utilizzando il filtro
          vmd.beneficiari = api.beneficiarios.m.like(filter);
        }

        vmd.searchStrutturas = searchStrutturas;
            // Definizione della funzione searchStrutturas
        function searchStrutturas(progettoId) {
            if(progettoId) {
                api.strutturas.strutturamin.cerca({
                  pagination: 10000,
                    progetto_id: progettoId, //In questo modo prendo l'id del progetto selezionato
                    attivo: 1 // Filtra per strutture attive
                }, function (response) {

                    // Assegna le strutture filtrate a vmd.strutturas
                    vmd.strutturas = response.data;
                });
            }
        }

        vmd.checkDataMin = function(){
            if(vmd.beneficiario){
                var dateInizioStrutture = [];
                vmd.beneficiario.strutturahasbeneficiarios.map((struttura) => {
                  dateInizioStrutture.push(struttura.dataInserimento);
                })

                vmd.dataMin = dateInizioStrutture.length > 0 ? new Date(dateInizioStrutture.reduce(function (a, b) { return a > b ? a : b; })) : '';
            }
        }
        vmd.checkDataMin();

        function salva() {
            vmd.dataFineFormat = new moment(vmd.dataFine).format('YYYY-MM-DD');
            var payload = {
                progetto_id: vmd.progetto.id,
                progettoNome: vmd.progetto.nome,
                strutturaNome: vmd.struttura.nome,
                struttura_id: vmd.struttura.id,
                beneficiario_id: vmd.beneficiario.id,
                dataArrivo: vmd.dataFineFormat
            }
            api.evento2.completaTrasferimento(payload, function (res) {
                $mdDialog.hide();
                    $mdToast.show(
                    $mdToast.simple()
                        .textContent('Informazioni salvate')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                    $state.reload();
            })
        }



    }

    function InserisciController($scope,$mdDialog,locals) {
      var vmd = this;

      vmd.segnalati = locals.segnalati;
      var dataMinimaIngresso = getDataMinima('dataIngresso');
      var dataMinima = getDataMinima('dataInizio');

      vmd.minDate = new Date(dataMinimaIngresso);
      vmd.isModelloC = vmd.segnalati.some((item) => item.segnalazione.idTipoSegnalazione === 656 || item.segnalazione.idTipoSegnalazione === 689);
      vmd.oggi = new Date();

      if(vmd.isModelloC) {
        vmd.oggi.setDate(vmd.oggi.getDate() + 15);
      }

      vmd.uscitaOmonimo =  null;
      vmd.res = {
        dataInizio : null,
        note: null
      }
      vmd.res.dataInizio = dataMinima !== null ? moment(dataMinima)._d : null;
      vmd.inserisci = function () {
        vmd.res.dataInizio = moment(vmd.res.dataInizio).format('YYYY-MM-DD');

        $mdDialog.hide(vmd.res);
      }
      vmd.closeDialog = function () {
        $mdDialog.hide();
      }

      function getDataMinima(data) {
        var dataMinima = null;
        angular.forEach(vmd.segnalati,function (segnalato) {
          if (dataMinima === null || dataMinima < segnalato[data]){
            dataMinima = segnalato[data];
          }
        })
        return dataMinima;
      }
    }

    function RifiutaController($scope,$mdDialog,locals) {
      var vmd = this;

      vmd.res = {
        tipoRifiuto : null,
        noteRifiuto: null
      }
      vmd.segnalati = locals.segnalati;
      vmd.tipoRifiuto = [{id: '1', descrizione: "RIFIUTO SC"}, {id: '2', descrizione: "RIFIUTATO OMONIMIA"}];

      vmd.rifiuta = function(){
        $mdDialog.hide(vmd.res);
      }

      vmd.closeDialog = function () {
        $mdDialog.hide();
      }
    }

})();


(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entisegnalatori')
            .controller('EntisegnalatoriController', EntisegnalatoriController);

    /** @ngInject */
    function EntisegnalatoriController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);
        vm.isAdmin = api.isAdmin;
        vm.isSegnalatore = api.isSegnalatore;
        vm.api = api;
        vm.apiuser = api.user;
        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "attivo": {
                type: "string",
                title: "Ente attivo",
                description: "Ente attivo...",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.statoattivo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "Ente Tipo",
                callbackModel: "ricerca",
                dbfield: "enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personas-id": {
                type: "string",
                title: "Con persone",
                description: "Con persone...",
                callbackModel: "ricerca",
                dbfield: "personas-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "piva": {
                type: "string",
                title: "P.Iva Cod.Fiscale",
                description: "inserisci partita iva",
                callbackModel: "ricerca",
                dbfield: "piva",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:24px",
                required: false
            },
            "telefono": {
                type: "string",
                title: "Telefono",
                description: "inserisci il telefono",
                callbackModel: "ricerca",
                dbfield: "telefono",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:0px",
                required: false
            },
            "email": {
                type: "string",
                title: "Email",
                description: "inserisci email",
                callbackModel: "ricerca",
                dbfield: "email",
                formtype: "text",
                onchange: "vm.onSearch()",
                debounce: 1500,
                style: "margin-top:0px",
                required: false
            },
            "dataInserimento>": {
                type: "string",
                title: "Data Inserimento",
                description: "Data Inserimento",
                callbackModel: "ricerca",
                dbfield: "dataInserimento>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            }
        };
        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            console.log("searchforms:", searchvariable);
            console.log("origine:", origine);
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            console.log("dataOrigine:", dataOrigine);
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;
        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();

        vm.colors = ricerca.colors;

        vm.alias = api.entes.ente;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        //filtro segnalatore sempre attivo
        vm.ricerca.operatore = 'AND';
        vm.ricerca.segnalatore = 1;
        vm.allsearchs['query[]'][1] = vm.ricerca;
        vm.ente1 = ricerca.enteprimosettores;
        vm.ente3 = ricerca.enteterzosettores;
        vm.entetipos = angular.copy(vm.ente1);
        angular.forEach(vm.ente3, function (eee) {
            vm.entetipos.push(eee);
        });
        //angular.extend(vm.entetipos, vm.ente3);

        vm.regiones = ricerca.regiones;
        vm.enteruolos = ricerca.enteruoloprogettos;
        vm.provincias = ricerca.provincias;
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
            api.entes.ente.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();



        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listaente"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.attivaente = attivaente;
        vm.spediscicodice = spediscicodice;
        vm.aggiungientes = aggiungientes;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.entes.ente.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                return valore;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


        function onSearch() {
            /*
             vm.allsearchs['query[]'] = [];
             vm.allsearchs['query[]'][0] = {operatore: 'OR'};
             if (vm.ricerca2) {
             vm.allsearchs['query[]'][0].operatore = 'OR';
             vm.allsearchs['query[]'][0].nome = vm.ricerca2;
             }
             
             angular.forEach(vm.ricerca, function (value, key) {
             if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
             delete vm.ricerca[key];
             }
             });
             if (vm.ricerca) {
             vm.ricerca.operatore = 'AND'
             vm.allsearchs['query[]'][1] = vm.ricerca;
             }
             
             api.entes.ente.like(vm.allsearchs, function (d) {
             //console.log(d);
             vm.entes = d.data;
             vm.links = d._links;
             vm.meta = d._meta;
             }
             );
             vm.searched = true;
             */

            var tiporicerca = 'search';
            //nome
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            vm.allsearchs['query[]'][1] = {};
            vm.allsearchs['query[]'][1]['operatore'] = 'AND';
            //vm.allsearchs['query[]'][1]['eventoTipo_id_IN'] = $state.params.eventoTipo_id;
            if (vm.ricerca2) {
                tiporicerca = 'like';
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]['nome'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['email'] = vm.ricerca2;
                vm.allsearchs['query[]'][0]['codice'] = vm.ricerca2;
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (angular.isArray(value) && value.length === 0) {
                    delete vm.ricerca[key];
                }
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });

            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
            if (tiporicerca == 'like') {
                api.entes.ente.like(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            } else {
                api.entes.ente.search(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.meta = d._meta;
                    vm.links = d._links;

                });
            }

            vm.searched = true;
        }

        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            //vm.filtrap(vm.searchForms, key);
            onSearch();
        }
        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);

            var valores = vm.searchForms[key].valore.split("|");

            return results[0][valores[0]];
        }

        function attivaente(item) {
            console.log(item);
            var items = [];
            if (!angular.isArray(item)) {
                var tempitem = item;
                item = {};
                items.push(tempitem);
            } else {
                items = item;
            }
            console.log(item);
            console.log(items);
            angular.forEach(items, function (item) {

                var confirm = $mdDialog.confirm()
                        .title('Attivazione Ente')
                        .htmlContent('Sei sicuro di voler attivare l\'ente <b>' + item.nome + '</b>?<br>' + 'Clicca Ok per procedere.')
                        .ariaLabel('attivaes')
                        .ok('OK')
                        .cancel('ANNULLA');

                $mdDialog.show(confirm).then(function ()
                {
                    api.entes.ente.aggiorna({id: item.id, attivo: 1}, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Ente correttamente attivato')
                                .position('bottom right')
                                .hideDelay(2000)
                                );
                        $state.reload();
                        $mdDialog.hide();
                    });

                });
            });
        }
        function spediscicodice(item) {
            console.log(item);
            var items = [];
            if (!angular.isArray(item)) {
                var tempitem = item;
                item = {};
                items.push(tempitem);
            } else {
                items = item;
            }
            console.log(item);
            console.log(items);
            angular.forEach(items, function (item) {
                var confirm = $mdDialog.confirm()
                        .title('Spedisci Codice')
                        .htmlContent('Sei sicuro di voler spedire il codice segnalatore a <b>' + item.email + '</b>?<br>' + 'Clicca Ok per procedere.')
                        .ariaLabel('spediscies')
                        .ok('SPEDISCI')
                        .cancel('ANNULLA');

                $mdDialog.show(confirm).then(function ()
                {
                    var email = {};
                    email.to = item.email;
                    email.to = ["emailentesegnalatore@kubique.com", "emailentesegnalatore@serviziocentrale.it", ];
                    email.oggetto = "Codice Segnalatore";
                    email.corpo = "Salve <b>" + item.nome + "</b>,<br>le abbiamo inviato il codice di registrazione da fornire ai soggetti \"segnalatori afferenti alla vostra Area di competenza\" che invieranno al SC i modelli di segnalazione dalla piattaforma BancaDati Sprar.<br>Vi invitiamo dunque a conservare adeguatamente tale codice e di contattare il SC per problematiche in merito alla procedura di accesso all’indirizzo https://assistenza.serviziocentrale.it/<br><br><b>Il vostro codice è: " + item.codiceSegnalatore + "</b><br><br>Ringraziamo per la collaborazione<br>Cordiali Saluti";
                    console.log(email);
                    api.emails.send.send(email, function (response) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Codice segnalatore spedito')
                                .position('bottom right')
                                .hideDelay(2000)
                                );
                        $mdDialog.hide();
                    });

                });
            });



        }

        function aggiungientes() {
            $state.go('app.sprardb_entisegnalatori_dettaglio', {id: 0})

        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }




    }


})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.enti')
            .controller('EntiController', EntiController);

    /** @ngInject */
    function EntiController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca)
    {
      var vm = this;

      vm.toggleSidenav = toggleSidenav;
      vm.loadEnti = loadEnti;
      vm.filtraRuoli = filtraRuoli;
      vm.deletefiltersearch = deletefiltersearch;
      vm.displayLabel = displayLabel;
      vm.gotoDettaglio = gotoDettaglio;
      vm.nuovoEnte = nuovoEnte;

      vm.isAdmin = api.isAdmin;
      vm.isVisitatore = api.isVisitatore;
      vm.isReadOnly = api.isReadOnly;
      vm.api = api;
      vm.ricerca = {};
      vm.maxLabelsPerChip = 3;
      vm.search = {
        sort: '-id',
        'per-page': 10,
        page: 1,
        expand: 'istats,progettohasentes.progetto,personahasentes.persona,entetipo'
      };
      vm.ricercaApi = ricerca;
      vm.booleanOptions = [
        {id: 0, label: 'Sì'},
        {id: null, label: 'No'},
      ];

      vm.optionsProgetto = angular.copy(vm.booleanOptions);
      vm.optionsProgetto.push({id: 1, label:"Solo Attivi"});

      function loadEnti() {
        var filter = buildFilter();
        var payload = angular.merge({}, {filter: filter}, vm.search);

        api.entemc.index(payload).$promise.then(function (response) {
            vm.enti = response.data;
            vm.links = response._links;
            vm.meta = response._meta;
        }, function (response) {
            //console.log(response);
        });
        return vm.enti;
      }
      loadEnti();

      function toggleSidenav(sidenavId)
      {
          $mdSidenav(sidenavId).toggle();
      }

      function gotoDettaglio(ente) {
          $state.go('app.sprardb_enti.dettaglio', {id: ente.id});
      }

      function nuovoEnte()
      {
        $state.go('app.sprardb_enti.new');
      }

      function buildFilter() {
        var filter = {and: []};
        var filters = getFilters();

        buildChips();

        angular.forEach(vm.ricerca, function (value, attribute) {
          if(!isEmpty(value)) {
            var filterObj;

            if (filters[attribute]) {
              filterObj = filters[attribute](value);
            } else {
              filterObj = {[attribute]: value.id};
            }

            filter.and.push(filterObj);
          }
        });

        return filter;
      }

      function getExistsFilter(attribute)
      {
        return function(value) {
          if(value.id === null) {
            return {[attribute]: null}
          }
          return value.id ? {[attribute]: value.id} : {not: {[attribute]: null}}
        }
      }

      function getArrayFilter(attribute)
      {
        return function(values) {
          var filter = {[attribute]: []}
          values.forEach(function(v){
            filter[attribute].push(v.id);
          })
          return filter;
        }
      }

      function getFilters()
      {
        return {
          nome: nomeFilter,
          progetti: getExistsFilter('progetti'),
          regione: getArrayFilter('regione'),
          provincia: getArrayFilter('provincia'),
          tipo: getArrayFilter('tipo'),
          ruolo: getArrayFilter('ruolo'),
          persone: getExistsFilter('persone'),
        }
      }

      function nomeFilter(nome)
      {
        return {
          or: [
            {'nome': {xlike: nome + '%'}},
            {'nome': {like: ' ' + nome}}
          ]
        };
      }

      function buildChips()
      {
        vm.filterChips = [];

        angular.forEach(vm.ricerca, function (values, attribute) {
          if (!isEmpty(values)) {
            var chipItem = {
              key: attribute,
              value: values[displayLabel(attribute)] || values
            };

            if (angular.isArray(values)) {
              var display = [];
              values.forEach(function(val) {
                display.push(val[displayLabel(attribute)]);
              });

              chipItem.value = display.slice(0,vm.maxLabelsPerChip).join(',') + (display.length > vm.maxLabelsPerChip ? ',...' : '');
            }

            vm.filterChips.push(chipItem);
          }
        });
      }

      function isEmpty(value)
      {
        return (value && (value.length !== undefined && value.length === 0)) || (!value && value !== 0);
      }

      function filtraRuoli (progettoEnte) {
        var ret = true;
        var enteRuoli = vm.ricerca.ruolo;
        if (enteRuoli && enteRuoli.length !== 0) {
          ret = false;
          angular.forEach(enteRuoli, function (value, key) {
            if(progettoEnte.enteRuolo_id === value.id) {
              ret = true;
            }
          })

        }
        return ret;
      }

      function deletefiltersearch(chip) {
        vm.ricerca[chip.key] = null;
        loadEnti();
      }

      function displayLabel(key) {
        var map = {
          ruolo: 'descrizione',
          tipo: 'descrizione',
          regione: 'regione',
          provincia: 'provincia',
        }
        return map[key] || 'label';
      }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.entes')
            .controller('EntesController', EntesController)
            .controller('TagsVController', TagsVController);

    /** @ngInject */
    function EntesController($scope, $state, $mdSidenav, msApi, msUtils, $mdDialog, $document, api, ricerca, $filter, $mdToast, eventi)
    {

        var vm = this;
        //sidenavs popolamento
        console.log($state.params);
        vm.isAdmin = api.isAdmin;
        vm.isVisitatore = api.isVisitatore;
        vm.isReadOnly = api.isReadOnly;
        vm.api = api;

        vm.searchForms = {
            "codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.regiones",
                chiave: "id",
                valore: "regione|uppercase"
            },
            "codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "attivo": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.statoattivo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasentes-enteRuolo_id_IN": {
                type: "string",
                title: "Ruolo",
                description: "Ruolo...",
                callbackModel: "ricerca",
                dbfield: "progettohasentes-enteRuolo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.enteruoloprogettos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "enteTipo_id_IN": {
                type: "string",
                title: "Ente Tipo",
                description: "enteTipo...",
                callbackModel: "ricerca",
                dbfield: "enteTipo_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.entetipos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettos-id": {
                type: "string",
                title: "Con progetti",
                description: "Con progetti...",
                callbackModel: "ricerca",
                dbfield: "progettos-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "strutturas-id": {
                type: "string",
                title: "Con strutture",
                description: "Con strutture...",
                callbackModel: "ricerca",
                dbfield: "strutturas-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "personas-id": {
                type: "string",
                title: "Con persone",
                description: "Con persone...",
                callbackModel: "ricerca",
                dbfield: "personas-id",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.ricercaApi.contasino",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
            , "personas-cognome": {
                type: "string",
                title: "Cognome",
                description: "Cognome",
                callbackModel: "ricerca",
                dbfield: "personas-cognome",
                formtype: "text",
                onchange: "vm.onSearch()",
            }
            , "personas-codiceFiscale": {
                type: "string",
                title: "Codice Fiscale",
                description: "Codice Fiscale",
                callbackModel: "ricerca",
                dbfield: "personas-codiceFiscale",
                formtype: "text",
                onchange: "vm.onSearch()",
            }
            , "progettos-nome_LIKE": {
                type: "string",
                title: "Nome Progetto",
                description: "Nome Progetto",
                callbackModel: "ricerca",
                dbfield: "progettos-nome_LIKE",
                formtype: "text",
                onchange: "vm.onSearch()",
            }
        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};

        vm.id = null;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();

        vm.alias = api.entes.ente;
        vm.ricercaApi = ricerca;

        //Dati ricerca
        vm.ricerca = {};
        vm.ricerca2 = "";
        // Dati
        vm.entes = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadentes = function () {
//            console.log(vm.allsearchs);
//            if (angular.isDefined($state.params.parametro) && angular.isDefined($state.params.valore)) {
//                vm.allsearchs['query[]'][1][$state.params.parametro] = $state.params.valore;
//            }
//            console.log(vm.allsearchs);


            api.entes.ente.search(vm.allsearchs).$promise.then(function (response) {
                vm.entes = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.entes;
        };
        vm.loadentes();

        vm.filter = filter;
        function filter (progettoEnte) {
            var enteRuoli = vm.ricerca["progettohasentes-enteRuolo_id_IN"];

            if(!enteRuoli?.length) {
              return true;
            }
            var risultato = false;
            angular.forEach(enteRuoli, function (value, key) {
                if(progettoEnte.enteRuolo_id === value) {
                  risultato = true;
                }
            })
            return risultato;
        }


        //vm.entes = Entes.data;
        //vm.links = Entes._links;
        //vm.meta = Entes._meta;
        vm.loadtags = function () {
            api.tags.tag.search({tipo: "generico"}).$promise.then(function (response) {
                vm.tags = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.tags;
        };
        vm.loadtags();
        vm.loadlista = function () {
            api.tags.tag.search({tipo: "listaente"}).$promise.then(function (response) {
                vm.lista = response.data;
            }, function (response) {
                //console.log(response);
            });
            return vm.lista;
        };
        vm.loadlista();

        //vm.tags = Tags.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        //console.log(vm.entes);

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;

        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'nome': 'Progetto', 'codComune': 'Istat', 'indirizzo': 'Indirizzo', 'cap': 'Cap', 'email': 'Emial', 'telefono': 'Telefono', 'piva': 'P.Iva'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,nome,codComune,indirizzo,cap,email,telefono,piva';
            api.entes.ente.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            //vm.filtrap(vm.searchForms, key);
            onSearch();
        }
        function valuesearched(key, value) {
            var isNumb = false;
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
                if (angular.isNumber(parseInt(valore))) {
                    valore = parseInt(valore);
                    isNumb = true;
                }
            }

            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
//            console.log("key:", key);
//            console.log("value:", value);
//            console.log("datas:", datas);
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;

            var jsonfilter = {};
            var jsonfilterT = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            var jsonfilterN = JSON.parse('{"' + chiave + '":' + valore + '}');
            jsonfilter = jsonfilterT;
            if (isNumb) {
                jsonfilter = jsonfilterN;
            }
//            console.log("jsonfilter:", jsonfilter);
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter, true);
//            console.log("results", results);

            var valores = vm.searchForms[key].valore.split("|");


            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_entes_dettaglio_dettaglio', {id: obj});

        }


        function onSearch() {
            var tiporicerca = 'search';
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                tiporicerca = 'like';
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
            }
            if (tiporicerca == 'like') {
                api.entes.ente.like(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            }
            if (tiporicerca == 'search') {
                api.entes.ente.search(vm.allsearchs, function (d) {
                    vm.entes = d.data;
                    vm.links = d._links;
                    vm.meta = d._meta;
                });
            }

            vm.searched = true;
        }






        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, ente)
        {
            $mdDialog.show({
                controller: 'EnteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/entes/dialogs/ente/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Ente: ente,
                    User: vm.user,
                    Entes: vm.entes
                }
            });
        }




    }
    function TagsVController($scope, msUtils, $mdDialog, api, $filter, $mdToast, locals)
    {
        console.log('controller tags');
        var vmd = this;
//        vmd.tags = Tags;
//        vmd.tipotag = Tipotag;
//        vmd.alltags = null;
//        api.tags.tag.search({tipo_IN: vm.tipotag}, function (d) {
//            vmd.alltags = d.data;
//        });

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.documento', ['flow'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    {

        // State
        $stateProvider.state('app.sprardb_documento', {
            url: '/sprardb/documento/segnalazione/:segnalazione_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/documenti/documento.html',
                    controller: 'DocumentoController as vm'
                }
            }
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sprardb/documenti');

        //locale
        $mdDateLocaleProvider.months = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        $mdDateLocaleProvider.shortMonths = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        $mdDateLocaleProvider.days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        $mdDateLocaleProvider.shortDays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];

        $mdDateLocaleProvider.firstDayOfWeek = 1;


        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

        $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
            return 'Settimana ' + weekNumber;
        };

        $mdDateLocaleProvider.msgCalendar = 'Calendario';
        $mdDateLocaleProvider.msgOpenCalendar = 'Apri il calendario';


    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.documento')
            .controller('DocumentoController', DocumentoController);

    /** @ngInject */
    function DocumentoController($mdSidenav, $state, msUtils, $mdDialog, $document, api, eventi, $filter, $mdToast)
    {
        var vm = this;
        vm.modellosegnalazione = eventi.modellosegnalazione;
        vm.parametristato = $state.params;

        console.log(vm.parametristato);
        vm.modellosegnalazione("EventoBot", vm.parametristato.segnalazione_id);


    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.sprardb.cruscotto', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.sprardb_cruscotto', {
            url: '/sprardb/cruscotto',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sprardb/cruscottooperatori/cruscotto.html',
                    controller: 'CruscottoController as vm'
                }
            }
        });
    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.sprardb.cruscotto')
    .controller('searchFormCruscottoController', searchFormCruscottoController)
    .directive('searchFormCruscotto', searchFormCruscotto);

  /** @ngInject */
  function searchFormCruscottoController($scope, api)
  {
    var fc = this;

    fc.cambiaProgetto = cambiaProgetto;

    fc.listaProgetti = api.personas.hasprogetto.progettiPersona({expand: 'progetto'}, function (res){
      fc.progetto = res[0].progetto;
      cambiaProgetto();
      return res;
    });


    function cambiaProgetto()
    {
      console.log(fc.progetto)
      $scope.progetto = fc.progetto;
    }

  }

  function searchFormCruscotto($compile)
  {
    return {
      require: ['progetto'],
      restrict: 'E',
      scope: {
        progetto: '='
      },
      controller: 'searchFormCruscottoController as fc',
      templateUrl: 'app/main/sprardb/cruscottooperatori/search-form.html'
    };

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sprardb.cruscotto')
        .controller('CruscottoController', CruscottoController)


    /** @ngInject */
    function CruscottoController($scope, $stateParams, api, $mdSidenav, $cookies)
    {
      var vm = this;
      vm.struttureProgetto = {
        sort: 'id',
        'per-page': 10,
        page: 1
      };

      vm.paginationIncompleti = {
        sort: 'codice',
        'per-page': 10,
        page: 1
      };

      vm.paginationInScadenza = {
        sort: 'codice',
        'per-page': 10,
        page: 1
      };

      vm.paginationScaduti = {
        sort: 'codice',
        'per-page': 10,
        page: 1
      };

      vm.paginationProrogheCompletare = {
        sort: 'id',
        'per-page': 10,
        page: 1
      };

      vm.paginationProrogheLavorare = {
        sort: 'id',
        'per-page': 10,
        page: 1
      };
      const expand = 'totalePresenti, totalePresentiIncompleti';
      if($cookies.get('progetto_id') == null || $cookies.get('progetto_id') === "null") {
        vm.progetto = {
          id: null,
          nome: "NESSUNA SELEZIONE"
        }
        onSearch();
      } else {
        api.progettomc.get({id: $cookies.get('progetto_id')}, function(res) {
          vm.progetto= res;
          onSearch();
        });
      }


      vm.loadDashboard = loadDashboard;
      vm.loadBeneficiariIncompleti = loadBeneficiariIncompleti;
      vm.loadBeneficiariInScadenza = loadBeneficiariInScadenza;
      vm.loadBeneficiariScaduti = loadBeneficiariScaduti;
      vm.loadProrogheDaCompletare = loadProrogheDaCompletare;
      vm.loadProrogheDaLavorare = loadProrogheDaLavorare;
      vm.loadStrutture = loadStrutture;
      vm.onSearch = onSearch;
      vm.toggleSidenav = toggleSidenav;

      function loadDashboard() {
        vm.beneficiari = api.beneficiariomc.dashboard({expand: expand, progetto_id: vm.progetto.id}, function(res) {
          vm.totPresenti = res.totalePresenti;
          vm.totPresentiIncompleti = res.totalePresentiIncompleti;
        })
      }


      function onSearch() {
        loadDashboard();
        loadBeneficiariIncompleti();
        loadBeneficiariInScadenza();
        loadBeneficiariScaduti();
        loadProrogheDaCompletare();
        loadProrogheDaLavorare();
        loadStrutture();
      }


      function loadBeneficiariIncompleti() {
          var params = angular.merge({}, vm.paginationIncompleti, {progetto_id: vm.progetto.id})
          vm.beneficiariIncompleti = api.beneficiariomc.beneficiariIncompleti(params, function (res) {
            vm.totalCountIncompleti = res._meta.totalCount;
          })
      }

      function loadBeneficiariInScadenza() {
        var params = angular.merge({}, vm.paginationInScadenza, {progetto_id: vm.progetto.id})
        vm.beneficiariInScadenza = api.beneficiariomc.beneficiariInScadenza(params, function (res) {
          vm.totalCountInScadenza = res._meta.totalCount;
        })
      }

      function loadBeneficiariScaduti() {
        var params = angular.merge({}, vm.paginationScaduti, {progetto_id: vm.progetto.id});
        vm.beneficiariScaduti = api.beneficiariomc.beneficiariScaduti(params, function (res) {
          vm.totalCountScaduti = res._meta.totalCount;
        })
      }

      function loadProrogheDaCompletare() {
        var params = angular.merge({}, vm.paginationProrogheCompletare, {progetto_id: vm.progetto.id});
        vm.prorogheDaCompletare = api.beneficiariomc.prorogheDaCompletare(params, function (res) {
          vm.totalCountProrogheCompletare = res._meta.totalCount;
        })
      }

      function loadProrogheDaLavorare() {
        var params = angular.merge({}, vm.paginationProrogheLavorare, {progetto_id: vm.progetto.id});
        vm.prorogheDaLavorare = api.beneficiariomc.prorogheDaLavorare(params, function (res) {
          vm.totalCountProrogheLavorare = res._meta.totalCount;
        })
      }
      function loadStrutture() {
        var params = angular.merge({}, vm.struttureProgetto, {progetto_id: vm.progetto.id, expand: 'progetto'});
        vm.strutture = api.beneficiariomc.struttureProgetto(params, function (res) {
          vm.totalCountStrutture = res._meta.totalCount;
          vm.countStrutture = api.beneficiariomc.countStrutture({progetto_id: vm.progetto.id})
        })
      }

      function toggleSidenav(sidenavId)
      {
        $mdSidenav(sidenavId).toggle();
      }


    }


})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.contatti')
            .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $state, $mdSidenav, Contacts, msApi, msUtils, $mdDialog, $document, api, Tags)
    {

        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.links = Contacts._links;
        vm.meta = Contacts._meta;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.mostraitag = false;
        vm.tags = Tags.data;
        vm.regiones = null;
        api.istats.istat.distinct({regione: 'distinct'}, function (response) {
            vm.regiones = response.data;
        });

        vm.ricerca = {};
        vm.ricerca2 = {};
        vm.searched = false;
        vm.search2 = "";
        vm.mostraitag = false;
        vm.ricercalabel = {
            'bandos-id': 'Bando: ',
            'bandos-dataFine': 'Anno Bando: ',
            'istats-regione': 'Regione: ',
            'postiLiberi': 'Posti liberi: ',
            'attivo': 'Progetto attivo: ',
            'tags-id': 'Tag: ',
            'progettos-id': 'Progetti: ',
            'strutturas-id': 'Strutture: ',
            'personas-id': 'Persone: ',
            'entes-id': 'Enti: ',
            'enteTipo_id': 'Tipo di ente: '
        };

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.openExtraDialog = openExtraDialog;


        vm.gotoDettaglio = gotoDettaglio;

        function gotoDettaglio(obj) {
            $state.go('app.sprardb_contatti_dettaglio_dettaglio', {id: obj});

        }

        //////////

        vm.pagerNext = pagerNext;
        vm.pagerPrev = pagerPrev;
        vm.getPersonas = getPersonas;
        vm.id = null;
        vm.searchServer = searchServer;
        vm.searchServer2 = searchServer2;
        vm.aggiungiTag = aggiungiTag;
        vm.orderby = orderby;
        vm.searchServerNome = searchServerNome;
        vm.searchEmpty = searchEmpty;

        function orderby(field, order) {
            vm.listOrder = field;
            if (order == '') {
                vm.listOrderAsc = true;
            }
            if (order == '-') {
                vm.listOrderAsc = false;
            }
            api.personas.persona.get({sort: order + field}, function (response) {
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            });
        }
        function searchServerNome(string) {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            vm.ricerca2['cognome'] = string;
            vm.ricerca2['nome'] = string;
            vm.ricerca2['email'] = string;
            vm.ricerca2['indirizzo'] = string;
            vm.ricerca2['istats-comune'] = string;
            vm.ricerca2['operatore'] = 'OR';
            api.personas.persona.like(vm.ricerca2, function (response) {
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
            vm.searched = true;
        }
        function searchEmpty() {
            angular.forEach(vm.ricerca, function (value, key) {
                delete vm.ricerca[key];
            });
            api.personas.persona.get({}, function (response) {
                vm.contacts = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.search = '';
            });
        }
        function searchServer() {
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.personas.persona.like(vm.ricerca, function (response) {
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            } else {
                api.personas.persona.get({}, function (response) {
                    vm.contacts = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                    vm.search = '';
                });
            }
            vm.searched = true;
        }
        function aggiungiTag(tstring) {
            api.tags.tag.save({tag: tstring}, function (response) {
                $state.reload();
            });
        }

        function searchServer2() {
            vm.ricerca.nome = vm.search;
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null') {
                    delete vm.ricerca[key];
                }
            });
            console.log(Object.keys(vm.ricerca).length);
            if (Object.keys(vm.ricerca).length > 0) {
                api.personas.persona.like(vm.ricerca, function (response) {
                    vm.personas = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            } else {
                api.personas.persona.get({}, function (response) {
                    vm.personas = response.data;
                    vm.links = response._links;
                    vm.meta = response._meta;
                });
            }
        }


        function getPersonas() {
            //$rootScope.loadingProgress = true;
            msApi.register('personas.personas',
                    [api.baseUrl + 'personas',
                        null,
                        {'get': {method: 'GET'}}
                    ]
                    );
            msApi.resolve('personas.personas@get').then(function (d) {
                vm.contacs = d.data;
            });
        }


        getPersonas();



        function pagerNext(uri) {
            msApi.register('contacts.next', [uri]);
            msApi.resolve('contacts.next@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }

        function pagerPrev(uri) {
            //$rootScope.loadingProgress = true;
            msApi.register('contacts.prev', [uri]);
            msApi.resolve('contacts.prev@get').then(function (d) {
                vm.contacts = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            });
            //$rootScope.loadingProgress = false;
        }



        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller: 'ContactDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/contatti/dialogs/contact/contact-dialog1.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Contact: contact,
                    User: vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il contatto?')
                    .htmlContent('<b>' + contact.nome + ' ' + contact.cognome + '</b>' + ' sarè eliminato.')
                    .ariaLabel('delete contact')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
            //deletePersona(contact.id);

        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare i contatti selezionati?')
                    .htmlContent('<b>' + vm.selectedContacts.length + ' selezionati</b>' + ' saranno eliminati.')
                    .ariaLabel('delete contacts')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if (event)
            {
                event.stopPropagation();
            }

            if (vm.selectedContacts.indexOf(contact) > -1)
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            } else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if (vm.newGroupName === '')
            {
                return;
            }

            var newGroup = {
                'id': msUtils.guidGenerator(),
                'tag': vm.newGroupName,
                'contactIds': []
            };

            var nome = newGroup.tag;
            saveTag(nome);
            vm.tags.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare il gruppo?')
                    .htmlContent('<b>' + group.tags + '</b>' + ' sarà eliminato.')
                    .ariaLabel('delete group')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('ANNULLA');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function openExtraDialog(ev, progetto, index) {
            //console.log(progetto_id);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/form/dialogExtraForm.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    progetto: progetto,
                    index: index,
                    tabella: 'persona',
                }
            });
        }

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.sprardb.beneficiari')
            .controller('BeneficiariController', BeneficiariController)
            .controller('RicercaBeneficiariSegnalatiController', RicercaBeneficiariSegnalatiController)
            .controller('BeneficiariOmController', BeneficiariOmController)
            .controller('ParentelaDialogController', ParentelaDialogController)
            .filter('highlight', highlight)
            .filter('highlight2', highlight2);

    function highlight($sce) {
        return function (text, phrase) {
            if (phrase)
                text = $sce.getTrusted($sce.HTML, text);
            var result = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                    '<span class="highlighted">$1</span>')
            return $sce.trustAsHtml(result)
        }
    }
    function highlight2($sce) {
        return function (text, phrase) {
            if (phrase)
                text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                        '<span class="highlighted2">$1</span>')
            return $sce.trustAsHtml(text)
        }
    }

    /** @ngInject */
    function BeneficiariController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast, $cookieStore, $rootScope)
    {
        var vm = this;
        // Data
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.prequery = ($state.params.prequery) ? $state.params.prequery : null;
        vm.letteraIns = eventi.letteraIns;
        vm.oggi = new Date();
        //vm.viewEvento = eventi.viewDetails;
        var searchpayload = {};
        if (vm.def !== null) {
            searchpayload.def = vm.def;
        }

        vm.datas = angular.copy($state.current.datas);
        vm.title = "Ricerca beneficiario";
        if (angular.isDefined(vm.datas.titolo)) {
            vm.title = vm.datas.titolo;
        }

        vm.datascadenza = ricerca.datascadenza;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.benefstatos = ricerca.statobeneficiarios;
        vm.progettosa = ricerca.progettos;
        vm.bandos = ricerca.bandos;
        api.tipologiaAccoglienza.tipologie.search(function(res){
            vm.tipAccoglienza = res.data;
        });
        //console.log(vm.progettosa);
        vm.nazioneb = ricerca.naziones;
        vm.nazioni = null;
        vm.religioni = null;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "400"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.progettos.progetto.cerca({sort: "nome", pagination: "-1", attivo: 1, fields: "id,nome"}, function (response) {
            vm.progettos = response.data;
        });
        api.tipologiaBeneficiario.tipologie.search(function (res) {
          vm.tipologiaBenficiario = res.data;
        });

        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
                console.log(vm.tipoproteziones)
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();

        vm.searchStrutturas = searchStrutturas;
        function searchStrutturas() {
            api.strutturas.strutturamin.cerca({'progetto_id': vm.ricerca.progetto_id_IN, pagination: 100, attivo: 1}, function (response) {
                //console.log("strutturamin", response.data);
                vm.strutturas = response.data;
                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
                    vm.strutturas.push(r1.data[0]);
                    //console.log("strutturamin", angular.copy(vm.strutturas));
                });

            });

        }
        vm.nullsi = [{id: 1, descrizione: "SI"}, {id: 0, descrizione: "NO"}];
        vm.raggruppaProgetto = [{id: 'Accoglienza', descrizione: "Accoglienza"}, {id: 'Presenza', descrizione: "Presenza"}, {id: false, descrizione: "Nessuno"}];

//ente rilascio penso non serva più
//        vm.enterilascio = function () {
//            api.entes.ente.search({enteTipo_id: 7, sort: 'nome', pagination: "200"}).$promise.then(function (response) {
//                vm.enterilascios = response.data;
//            }, function (response) {
//                console.log('Ente rilascio caricata');
//            });
//        };
//        vm.enterilascio();


        vm.searchFormsA = {
            "codice": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "codice",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-anno": {
                type: "string",
                title: "Anno categoria",
                description: "Anno...",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-anno",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.searchStrutturas()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progettos-tipologiaAccoglienzaId_IN": {
                type: "string",
                title: "Tipologia Progetto",
                description: "Tipologia Progetto...",
                callbackModel: "ricerca",
                dbfield: "progettos-tipologiaAccoglienzaId_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.searchStrutturas()",
                data: "vm.tipAccoglienza",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "struttura_id_IN": {
                type: "string",
                title: "Struttura",
                description: "Struttura...",
                callbackModel: "ricerca",
                dbfield: "struttura_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.strutturas",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "tipologiaBeneficiario_IN": {
              type: "string",
              title: "Tipologia ingresso protetto",
              description: "Tipologia ingresso protetto...",
              callbackModel: "ricerca",
              dbfield: "tipologia_id_IN",
              formtype: "select",
              multiple: true,
              onchange: "vm.onSearch()",
              data: "vm.tipologiaBenficiario",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.resetStato();vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "codiceEaso|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "def": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "cancellato_IN": {
              type: "string",
              title: "Cancellato",
              description: "Cancellato...",
              callbackModel: "ricerca",
              dbfield: "cancellato",
              formtype: "select",
              multiple: false,
              onchange: "vm.onSearch()",
              data: "vm.sino",
              chiave: "id",
              valore: "descrizione|uppercase"
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataInizio>": {
                type: "string",
                title: "Data Inizio maggiore uguale",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInizio<": {
                type: "string",
                title: "Data Inizio minore uguale",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataUscita<": {
                type: "string",
                title: "Data Uscita minore uguale",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataUscita>": {
                type: "string",
                title: "Data Uscita maggiore uguale",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "string",
                title: "Includi i non usciti",
                description: "Includi i non usciti",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.nullsi",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "trasferimento": {
                type: "string",
                title: "Trasferimento",
                description: "Trasferiti...",
                callbackModel: "ricerca",
                dbfield: "trasferimento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "esterna": {
                type: "string",
                title: "Tipologia Accoglienza in Struttura",
                description: "Tipologia Accoglienza in Struttura...",
                callbackModel: "ricerca",
                dbfield: "esterna",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.accoglienze",
                chiave: "id",
                valore: "descrizione|uppercase"
            }

        };
        vm.searchFormsB = {
            "codice": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "codice",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-anno": {
                type: "string",
                title: "Anno categoria",
                description: "Anno...",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-anno",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.searchStrutturas()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "struttura_id_IN": {
                type: "string",
                title: "Struttura",
                description: "Struttura...",
                callbackModel: "ricerca",
                dbfield: "struttura_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.strutturas",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.resetStato();vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "codiceEaso|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "def": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataUscita>": {
                type: "string",
                title: "Data Inizio Permanenza",
                description: "Data Inizio Permanenza",
                callbackModel: "ricerca",
                dbfield: "dataUscita>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInizio<": {
                type: "string",
                title: "Data Fine Permanenza",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "string",
                title: "Includi i non usciti",
                description: "Includi i non usciti",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.nullsi",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "raggruppa": {
                type: "string",
                title: "Tipo raggruppamento",
                description: "Tipo raggruppamento",
                callbackModel: "ricerca",
                dbfield: "raggruppa",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.raggruppaProgetto",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "trasferimento": {
                type: "string",
                title: "Trasferimento",
                description: "Trasferiti...",
                callbackModel: "ricerca",
                dbfield: "trasferimento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "esterna": {
                type: "string",
                title: "Tipologia Accoglienza in Struttura",
                description: "Tipologia Accoglienza in Struttura...",
                callbackModel: "ricerca",
                dbfield: "esterna",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.accoglienze",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };
        vm.searchForms = angular.copy(vm.searchFormsA);
        if (vm.datas.api) {
//            if (vm.datas.api == 'a') {
//                vm.searchForms = angular.copy(vm.searchFormsB);
//            }
        }

        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'codice': 'Codice', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'dataInizio': 'Inizio Sprar', 'dataFine': 'Fine Accoglienza', 'stato': 'Stato del beneficiario'};

        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.sesso = ricerca.sesso;
        vm.accoglienze = [{id: 0, descrizione: "Accoglienza Interna"}, {id: 1, descrizione: "Accoglienza Esterna"}];
        vm.vulnerabilitas = ricerca.vulnerabilita;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.allsearchs.sort = "-id,-dataInizio";
        vm.colors = ricerca.colors;

        vm.ricerca = {};
        vm.ricerca.dataNascita = null;
        vm.ricerca['dataInizio>'] = null;
        vm.ricerca['dataInizio<'] = null;
        vm.ricerca['dataUscita>'] = null;
        vm.ricerca['dataUscita<'] = null;
        vm.ricerca2 = "";
        vm.ricerca.operatore = "AND";
        vm.preselezione = $cookieStore.get('progetto_id');
        vm.autostart = true;
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.ricerca["progetto_id_IN"] = [vm.preselezione.toString()];
            vm.autostart = false;
        }
        vm.allsearchs['query[]'][1] = vm.ricerca;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.loadbeneficiarios = function (tiporicerca) {

            $rootScope.loadingProgress = true;
            console.log(vm.allsearchs);
//            if (angular.isDefined($state.params.def)) {
//                vm.allsearchs['query[]'][1]['def'] = $state.params.def;
//                if ($state.params.def == 0) {
//                    vm.allsearchs['query[]'][1]['stato'] = 'BENEFICIARIO';
//                }
//            }
            var tr = tiporicerca;
            var sapi = "v";
            if (angular.isUndefined(tr)) {
                tr = "search";
            }
            if (angular.isDefined(vm.datas.api)) {
                sapi = vm.datas.api;
                if (sapi === 'v') {
                    vm.allsearchs['query[]'][1]['groupby'] = "id";
                }
                if (sapi === 'a') {
                    //vm.allsearchs['query[]'][1]['groupby'] = "uniquepr";
                }
            }
            if (angular.isDefined(vm.datas.def)) {
                vm.allsearchs['query[]'][1]['def'] = vm.datas.def;
            }
            if (angular.isDefined(vm.datas.cancellato)) {
              vm.allsearchs['query[]'][1]['cancellato'] = vm.datas.cancellato;
            }
            if (angular.isDefined(vm.datas.stato)) {
                vm.allsearchs['query[]'][1]['stato_IN'] = vm.datas.stato;
            }
            if (angular.isDefined(vm.datas.trasferimento)) {
                vm.allsearchs['query[]'][1]['trasferimento'] = vm.datas.trasferimento;
            }
            if (vm.prequery !== null) {
                vm.prequery = angular.fromJson(vm.prequery);
                angular.forEach(vm.prequery, function (v, k) {
                    vm.allsearchs['query[]'][1][k] = v;
                    vm.ricerca[k] = v;
                });
            }
            api.beneficiarios[sapi][tr](vm.allsearchs).$promise.then(function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.searched = true;
                $rootScope.loadingProgress = false;
                if (!vm.ricerca.dataNascita)
                {
                    vm.ricerca.dataNascita = null;
                }
                if (!vm.ricerca['dataInizio>']) {
                    vm.ricerca['dataInizio>'] = null;
                }
                if (!vm.ricerca['dataInizio<']) {
                    vm.ricerca['dataInizio<'] = null;
                }
                if (!vm.ricerca['dataUscita>']) {
                    vm.ricerca['dataUscita>'] = null;
                }
                if (!vm.ricerca['dataUscita<']) {
                    vm.ricerca['dataUscita<'] = null;
                }
                if (vm.allsearchs.groupby) {
                    vm.allsearchs['query[]'][1].raggruppa = vm.r1;
                }
                vm.calcolamontante();
                if (vm.autostart) {
                    vm.autostart = false;
                }
            }, function (response) {
                //console.log(response);
            });
            
            return vm.beneficiari;
        };
        if (vm.autostart) {
            vm.loadbeneficiarios();
        }


        vm.beneficiario = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneNascita: null,
            idNazioneProvenienza: null,
            idNazioneCittadinanza: null,
            gruppoEtnico: null,
            idReligione: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            note: null,
            noteSanitarie: null,
            beneficiarioAttributis: [],
            strutturas: [],
            beneficiarioextras: [],
            idTipoIngresso: '28',
            idTipoDocumento: '581',
            dataIngresso: null,
            dataIngresso2: null,
            dataInserimento: null,
            dataInserimento2: null,
            tipoIngresso: 'SC',
            nucleoFamiliare: '0',
            stato: 'LIBERO'
        };

        vm.selectedBeneficiarios = [];
        vm.selectedContacts = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;
        vm.editparentela = editparentela;
        vm.trasferiscib = nevento;
        vm.cessab = nevento;
        vm.permessob = nevento;
        vm.letteraTrasf = eventi.letteraTrasf;
        vm.dataAdOggi = dataAdOggi;

        //////////
        function dataAdOggi(dataInizio) {
            var di = new Date(dataInizio);
            var adesso = moment();
//            console.log("di:", di);
//            console.log("adesso:", adesso);
//            console.log("diff:", adesso.diff(di, 'days'));
            return adesso.diff(di, 'days');
        }

        vm.calcolamontante = calcolamontante;

        vm.calcolomontanteeffettuato = null;
        vm.calcolomontanteeffettuato = [];
        vm.calcolomontanteeffettuato2 = null;
        vm.calcolomontanteeffettuato2 = [];
        vm.calcolomontante2iniziato = false;
        function calcolamontante() {
            vm.calcolomontanteeffettuato = null;
            vm.calcolomontanteeffettuato = [];
            vm.calcolomontanteeffettuato2 = null;
            vm.calcolomontanteeffettuato2 = [];
            vm.calcoloultimapresenza = null;
            vm.calcoloultimapresenza = [];
            vm.dip = null;
            vm.dip = [];

            angular.forEach(vm.beneficiari, function (b) {
                vm.pidAttuale = b.progetto_id;
                var dip = b.dataInizio;
                var did = b.progressivo;
                //console.log("did:", did);
                if (vm.datas.api == 'a') {
                    var dup = b.dataUscitaB;
                    var bid = b.beneficiario_id;
                    var nmontante = b.nmontante;
                }
                if (vm.datas.api == 'v') {
                    var dup = b.dataUscita;
                    var bid = b.id;
                    var did = b.id;
                    var nmontante = 0;
                }
                //console.log("dup: ", dup);
                //console.log("b.dataUscita: ", b.dataUscita);
                if (angular.isUndefined(vm.calcolomontanteeffettuato[bid])) {
                    vm.calcolomontanteeffettuato[bid] = 0;
                    if (dup !== null) {
                        //esiste data uscita
                        if (vm.datas.api == 'a') {
                            vm.calcolomontanteeffettuato[bid] = nmontante;
                        }
                        if (vm.datas.api == 'v') {
                            api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante,progetto_id', beneficiario_id: bid}).$promise.then(function (r) {
                                if (r.data.length > 0) {
                                    var data = r.data;
                                    angular.forEach(data, function (d) {
                                        if (d.dataUscita == null && d.dataUscitaB == null) {
                                            var di = new Date(d.dataInizio);
                                            var adesso = moment();
                                            vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                            vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                                        } else {
                                            vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        if (vm.datas.api == 'a') {
                            api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante', beneficiario_id: bid, dataUscitaB_IS: 'NULL', dataUscita_IS: 'NULL'}).$promise.then(function (r) {
                                if (r.data.length > 0) {
                                    var data = r.data[0];
                                    var di = new Date(data.dataInizio);
                                    var adesso = moment();
                                    //console.log(bid, adesso.diff(di, 'days'))
                                    vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                    vm.calcolomontanteeffettuato[bid] = nmontante + adesso.diff(di, 'days');
                                }
                                //console.log(r);
                            });
                        }
                        if (vm.datas.api == 'v') {
                            api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,dataInizioB,dataUscitaB,n,nmontante,progetto_id', beneficiario_id: bid}).$promise.then(function (r) {
                                if (r.data.length > 0) {
                                    var data = r.data;
                                    angular.forEach(data, function (d) {
                                        if (d.dataUscita == null && d.dataUscitaB == null) {
                                            var di = new Date(d.dataInizio);
                                            var adesso = moment();
                                            if (b.progetto_id == d.progetto_id) {
                                                vm.dip[bid] = d.dataInizio;
                                            }
                                            vm.calcoloultimapresenza[bid] = adesso.diff(di, 'days');
                                            vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + adesso.diff(di, 'days');
                                        } else {
                                            vm.calcolomontanteeffettuato[bid] = vm.calcolomontanteeffettuato[bid] + d.n;
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
                if (angular.isUndefined(vm.calcolomontanteeffettuato2[did])) {
                    api.beneficiarios.a.search({fields: 'id,beneficiario_id,dataInizio,dataUscita,n,progressivo', beneficiario_id: bid, sort: "dataInizio", dacl: 1}).$promise.then(function (r2) {
                        var mon = 0;
                        angular.forEach(r2.data, function (daticalcolomontante2) {
                            //console.log("daticalcolomontante2:", daticalcolomontante2);
                            //mon = mon + daticalcolomontante2.n;
                            if (daticalcolomontante2.dataUscita == null) { //(daticalcolomontante2.n == 0 && daticalcolomontante2.dataUscita == null) {
                                var di2 = new Date(daticalcolomontante2.dataInizio);
                                var adesso2 = moment();
                                mon = mon + adesso2.diff(di2, 'days');
                            } else {
                                mon = mon + daticalcolomontante2.n;
                            }
                            if (vm.datas.api == 'v') {
                                daticalcolomontante2.progressivo = daticalcolomontante2.beneficiario_id;
                            }
                            //console.log("mon " + daticalcolomontante2.progressivo + ":", mon);
                            vm.calcolomontanteeffettuato2[daticalcolomontante2.progressivo] = mon;
                        });
                    });
                }

            });
            

            console.log(vm);
            console.log("vm.calcolomontanteeffettuato2: ", vm.calcolomontanteeffettuato2);
            console.log("vm.calcoloultimapresenza: ", vm.calcoloultimapresenza);
            console.log("vm.calcolomontanteeffettuato: ", vm.calcolomontanteeffettuato);
        }
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'codice': 'Codice', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'dataInizio': 'Inizio Sprar', 'dataFine': 'Fine Accoglienza', 'stato': 'Stato del beneficiario'};
            vm.entesexport = null;
            console.log(vm.allsearchs);

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricerca3 = null;
            if (vm.ricerca['attivo'] === 1) {


                vm.ricerca3 = angular.copy(vm.ricerca);
                //delete vm.ricerca['dataUscita_IS'];
                delete vm.ricerca3['dataUscita>'];
                vm.ricerca3['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                //vm.allsearchs.groupby = 'uniquepr';
                vm.ricerca3.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricerca3;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                //delete vm.allsearchs.groupby;
                vm.ricerca3 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    //vm.ricerca.groupby = 'id';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }

            console.log(vm.allsearchs);


            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'cognome';
            vm.allsearchsTemp.fields = 'id,codice,cognome,nome,dataNascita,dataInizio,dataFine,stato';
            var sapi = "v";
            if (angular.isDefined(vm.datas.api)) {
                sapi = vm.datas.api;
                if (sapi === 'v') {
                    vm.allsearchsTemp['query[]'][1]['groupby'] = "id";
                }
                if (sapi === 'a') {
                    //vm.allsearchsTemp['query[]'][1]['groupby'] = "uniquepr";
                }
            }
            api.beneficiarios[sapi].search(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                console.log("vm.entesexport", vm.entesexport);
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            if (key == 'nome'){
              vm.ricercaNome = null;
            }
            if (key == 'cognome'){
              vm.ricercaCognome = null;
            }
            if (key == 'codice' || key == 'id'){
              vm.ricercaCodice = null;
            }

            delete vm.ricerca[key];
            onSearch();
        }
        vm.cachesearched = {};
        function valuesearched(key, value) {
            if (key == 'groupby') {
                return "RAGGRUPPATO " + value;
            }

            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            if (!vm.searchForms[key]) {
                return "-"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];

            }

            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');


            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            if (results.length == 0) {
                return "-";
            }
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoDettaglio(id)
        {
            $state.go('app.sprardb_beneficiario', {id: id});
        }

        vm.ricercaNome = null;
        vm.ricercaCognome = null;
        vm.ricercaCodice = null;

        vm.onSearch = onSearch;
        function onSearch() {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if(vm.ricercaNome){
              tiporicerca = 'like';
              vm.searchForms['nome'] = {title: 'nome'};
              vm.ricerca['nome'] = vm.ricercaNome;
            }else{
              delete vm.ricerca['nome'];
            }
            if(vm.ricercaCognome){
              tiporicerca = 'like';
              vm.searchForms['cognome'] = {title: 'cognome'};
              vm.ricerca['cognome'] = vm.ricercaCognome;
            }else {
              delete vm.ricerca['cognome'];
            }
            if(vm.ricercaCodice){
              if (vm.datas.def == 1){
                vm.searchForms['codice'] = {title: 'codice'};
                vm.ricerca['codice'] = vm.ricercaCodice;
              }else{
                vm.searchForms['id'] = {title: 'id'};
                vm.ricerca['id'] = vm.ricercaCodice;
              }

            }else {
              delete vm.ricerca['codice'];
              delete vm.ricerca['id'];
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricerca3 = null;
            if (vm.ricerca['attivo'] === 1) {


                vm.ricerca3 = angular.copy(vm.ricerca);
                //delete vm.ricerca['dataUscita_IS'];
                //delete vm.ricerca3['dataUscita>'];
                delete vm.ricerca3['dataUscita<'];
                delete vm.ricerca3['dataInizio>'];
                vm.ricerca3['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                //vm.allsearchs.groupby = 'uniquepr';
                vm.ricerca3.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricerca3;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                //delete vm.allsearchs.groupby;
                vm.ricerca3 = null;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    //vm.ricerca.groupby = 'id';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }


            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            if (!vm.autostart) {
                vm.loadbeneficiarios(tiporicerca);
            }
//            api.beneficiarios.v.search(vm.allsearchs, function (d) {
//                //console.log(d);
//                vm.Beneficiari = d;
//                vm.beneficiari = d.data;
//                vm.links = d._links;
//                vm.meta = d._meta;
//            }
//            );
//            vm.searched = true;
        }

        vm.onSearchNome = onSearchNome;
        function onSearchNome(ricercaNome) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaNome) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';

                vm.allsearchs['query[]'][0]["nome"] = ricercaNome;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaNome2 = null;
            if (vm.ricerca['attivo'] === 1) {
                vm.ricercaNome2 = angular.copy(vm.ricerca);
                delete vm.ricercaNome2['dataUscita<'];
                delete vm.ricercaNome2['dataInizio>'];
                vm.ricercaNome2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaNome2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaNome2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            } else {
                vm.ricercaNome2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["nome"] = ricercaNome;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }

            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {
            }
            vm.loadbeneficiarios(tiporicerca);
        }

        vm.onSearchCognome = onSearchCognome;
        function onSearchCognome(ricercaCognome) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaCognome) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["cognome"] = ricercaCognome;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaCognome2 = null;
            if (vm.ricerca['attivo'] === 1) {

                vm.ricercaCognome2 = angular.copy(vm.ricerca);
                delete vm.ricercaCognome2['dataUscita<'];
                delete vm.ricercaCognome2['dataInizio>'];
                vm.ricercaCognome2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaCognome2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaCognome2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                vm.ricercaCognome2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["cognome"] = ricercaCognome;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }

            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            vm.loadbeneficiarios(tiporicerca);
        }

        vm.onSearchCodice = onSearchCodice;
        function onSearchCodice(ricercaCodice) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaCodice) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["codice"] = ricercaCodice;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaCodice2 = null;
            if (vm.ricerca['attivo'] === 1) {

                vm.ricercaCodice2 = angular.copy(vm.ricerca);
                delete vm.ricercaCodice2['dataUscita<'];
                delete vm.ricercaCodice2['dataInizio>'];
                vm.ricercaCodice2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaCodice2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaCodice2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                vm.ricercaCodice2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["codice"] = ricercaCodice;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }


            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            vm.loadbeneficiarios(tiporicerca);
        }

        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
//            oggi.setHours(0);
//            oggi.setMinutes(0);
//            oggi.setSeconds(0);
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }

        function editparentela() {
            var selected = vm.selected;
            console.log(selected);
            $mdDialog.show({
                controller: 'ParentelaDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/beneficiari/dialog/dialog_parentela.html',
                clickOutsideToClose: true,
                locals: {
                    items: selected,
                    parentelas: vm.parentelas

                }
            });
        }

        function nevento(ide) {
            // 1013 EVETNO TRASFERIMENTO
            var selected = vm.selected;
            var stato = 4;
            var item = {};
            item.eventoTipo = {};

            api.eventos.tipo.get({id: ide}).$promise.then(function (d) {
                item.eventoTipo = angular.copy(d);
                var statip = item.eventoTipo.statiPossibili.split(",");
                stato = statip[1];
                var payload = {};
                payload.self = {};
                payload.self.entita1_id = [];
                payload.self.entita2_id = [];
                payload.entita1_id = [];
                payload.self.eventoTipo_id = item.eventoTipo.id;
                angular.forEach(selected, function (s) {
                    payload.self.entita1_id.push(s.id);
                    payload.self.entita2_id.push(s.strutturas[0]['id']);
                    payload.entita1_id.push(s.id);

                });
                payload.isnew = true;
                payload.parent = {};
                payload.extra = {};
                payload.eventoTipo_id = item.eventoTipo.id;
                var oggi = new Date();
                payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
                var extrasetup = JSON.parse(item.eventoTipo.extra);
                var openpopup = angular.isDefined(extrasetup.properties[stato]);
                console.log("payload: ", payload);
                api.processi.processo.lavora(payload, function (response) {
                    if (response.status == 200) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Evento inserito correttamente!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                );
                        if (openpopup) {
                            //item.id = response.id;
                            api.eventos.evento.get({id: response.id}, function (r) {
                                var newitem = r;
                                //apri popoup per lavorazione
                                eventi.work("completa", newitem, stato, "completa", false);
                            });
                        } else {
                            $state.reload();
                        }
                    }
                });
            });

        }

        vm.letteraDialog = letteraDialog;
        function letteraDialog($event, letterainserimento) {

            api.beneficiarios.beneficiario.search({letteratrasferimento_id: letterainserimento}, function (d) {
                var segnalatos = d.data;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    //console.log("renderizzato", renderizzato);
                    //delete renderizzato["nota0"];
                    console.log("renderizzato", renderizzato);
                    var templater = rend.template.split("|");
                    //console.log("templater", templater);
                    //delete templater[0];
                    console.log("templater", templater);
                    var etichette = [];
                    etichette["ente1"] = "ente segnalatore/ente titolare auto";
                    etichette["ente2"] = "prefettura ente segnalatore/auto";
                    etichette["ente3"] = "ministero degli interni";
                    etichette["ente4"] = "ente titolare";
                    etichette["ente5"] = "ente gestore";
                    etichette["ente6"] = "prefettura ente titolare";
                    etichette["ente7"] = "ente titolare partenza";
                    etichette["ente8"] = "prefettura ente titolare partenza";
                    etichette["ente9"] = "ente gestore partenza";
                    etichette["nota1"] = "Nota dopo mittente";
                    etichette["nota2"] = "Nota dopo EPC";
                    etichette["nota3"] = "Oggetto";
                    etichette["nota4"] = "Nota dopo tabella";
                    etichette["nota5"] = "Note chiusura";
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'letteraDialogController',
                        controllerAs: 'vm',
                        focusOnOpen: false,
                        locals: {
                            segnalatos: segnalatos,
                            renderizzato: renderizzato,
                            templater: templater,
                            etichette: etichette,
                        },
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: event,
                        templateUrl: 'app/main/sprardb/eventi/dialogs/lettera-dialog.html',
                    }).then(function (renderizzatoresponse) {
                        api.letterainserimentors.letterainserimentor.aggiorna(renderizzatoresponse, function (s) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Lettera trasferimento modificata con successo!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    );
                        });
                    });
                });
            });
        }

        vm.resetStato = resetStato;
        function resetStato() {
            delete(vm.datas.stato);
        }

    }

    function RicercaBeneficiariSegnalatiController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast)
    {

        var vm = this;
        // Data
        vm.isAdmin = api.isAdmin;
        vm.api = api;
        vm.def = ($state.params.def) ? $state.params.def : null;
        vm.prequery = ($state.params.prequery) ? $state.params.prequery : null;
        vm.oggi = new Date();
        //vm.viewEvento = eventi.viewDetails;
        var searchpayload = {};
        if (vm.def !== null) {
            searchpayload.def = vm.def;
        }

        vm.datas = angular.copy($state.current.datas);
        vm.title = "Ricerca beneficiari e segnalati";

        vm.datascadenza = ricerca.datascadenza;
        vm.regiones = ricerca.regiones;
        vm.provincias = ricerca.provincias;
        vm.entesegnalatores = ricerca.entesegnalatoresafes;
        vm.benefstatos = ricerca.statobeneficiarios;
        vm.progettosa = ricerca.progettos;
        vm.bandos = ricerca.bandos;
        //console.log(vm.progettosa);
        vm.nazioneb = ricerca.naziones;
        vm.nazioni = null;
        vm.religioni = null;
        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "RELIGIONE", pagination: "400"}, function (response) {
            vm.religioni = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        api.progettos.progetto.cerca({sort: "nome", pagination: "-1", attivo: 1, fields: "id,nome"}, function (response) {
            vm.progettos = response.data;
        });

        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();
        vm.vulnerabilita = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.vulnerabilitas = response.data;
            }, function (response) {
                console.log('Vulnerabilita caricata');
            });
        };
        vm.vulnerabilita();
        vm.tipoprotezione = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}).$promise.then(function (response) {
                vm.tipoproteziones = response.data;
            }, function (response) {
                console.log('Tipo protezione caricata');
            });
        };
        vm.tipoprotezione();

        vm.searchStrutturas = searchStrutturas;
        function searchStrutturas() {
            api.strutturas.strutturamin.cerca({'progetto_id': vm.ricerca.progetto_id_IN, pagination: 100, attivo: 1}, function (response) {
                //console.log("strutturamin", response.data);
                vm.strutturas = response.data;
                api.strutturas.strutturamin.cerca({'nome': 'LIBERI SUL TERRITORIO'}, function (r1) {
                    vm.strutturas.push(r1.data[0]);
                    //console.log("strutturamin", angular.copy(vm.strutturas));
                });

            });

        }
        vm.nullsi = [{id: 1, descrizione: "SI"}, {id: 0, descrizione: "NO"}];
        vm.raggruppaProgetto = [{id: 'Accoglienza', descrizione: "Accoglienza"}, {id: 'Presenza', descrizione: "Presenza"}, {id: false, descrizione: "Nessuno"}];

        vm.searchFormsA = {
            "codice": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "codice",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-anno": {
                type: "string",
                title: "Anno categoria",
                description: "Anno...",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-anno",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.searchStrutturas()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "struttura_id_IN": {
                type: "string",
                title: "Struttura",
                description: "Struttura...",
                callbackModel: "ricerca",
                dbfield: "struttura_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.strutturas",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.resetStato();vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "codiceEaso|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "def": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataInizio>": {
                type: "string",
                title: "Data Inizio maggiore uguale",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInizio<": {
                type: "string",
                title: "Data Inizio minore uguale",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataUscita<": {
                type: "string",
                title: "Data Uscita minore uguale",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataUscita>": {
                type: "string",
                title: "Data Uscita maggiore uguale",
                description: "Data Uscita",
                callbackModel: "ricerca",
                dbfield: "dataUscita>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "string",
                title: "Includi i non usciti",
                description: "Includi i non usciti",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.nullsi",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "trasferimento": {
                type: "string",
                title: "Trasferimento",
                description: "Trasferiti...",
                callbackModel: "ricerca",
                dbfield: "trasferimento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "esterna": {
                type: "string",
                title: "Tipologia Accoglienza in Struttura",
                description: "Tipologia Accoglienza in Struttura...",
                callbackModel: "ricerca",
                dbfield: "esterna",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.accoglienze",
                chiave: "id",
                valore: "descrizione|uppercase"
            }

        };
        vm.searchFormsB = {
            "codice": {
                type: "string",
                title: "Codice beneficiario",
                description: "Codice beneficiario...",
                callbackModel: "ricerca",
                dbfield: "codice",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettohasbandos-bando_id_IN": {
                type: "string",
                title: "Categoria Progetto",
                description: "Categoria Progetto",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-bando_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.bandos",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "progettohasbandos-anno": {
                type: "string",
                title: "Anno categoria",
                description: "Anno...",
                callbackModel: "ricerca",
                dbfield: "progettohasbandos-anno",
                formtype: "text",
                onchange: "vm.onSearch()"
            },
            "progettos-codRegione_IN": {
                type: "string",
                title: "Regione",
                description: "Regione...",
                callbackModel: "ricerca",
                dbfield: "progettos-codRegione_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.regiones",
                chiave: "id",
                valore: "regione|uppercase",
                figlio: "progettos-codProvincia_IN",
                figliocampofiltro: "codRegione"
            },
            "progettos-codProvincia_IN": {
                type: "string",
                title: "Provincia",
                description: "Provincia...",
                callbackModel: "ricerca",
                dbfield: "progettos-codProvincia_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.provincias",
                chiave: "id",
                valore: "provincia|uppercase"
            },
            "progetto_id_IN": {
                type: "string",
                title: "Progetto",
                description: "Progetto...",
                callbackModel: "ricerca",
                dbfield: "progetto_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch();vm.searchStrutturas()",
                data: "vm.progettos",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "struttura_id_IN": {
                type: "string",
                title: "Struttura",
                description: "Struttura...",
                callbackModel: "ricerca",
                dbfield: "struttura_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.strutturas",
                chiave: "id",
                valore: "nome|uppercase"
            },
            "progettos-attivo_IN": {
                type: "string",
                title: "In progetti attivi",
                description: "In progetti attivi...",
                callbackModel: "ricerca",
                dbfield: "progettos-attivo_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "stato_IN": {
                type: "string",
                title: "Stato",
                description: "Stato...",
                callbackModel: "ricerca",
                dbfield: "stato_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.resetStato();vm.onSearch()",
                data: "vm.benefstatos",
                chiave: "descrizione",
                valore: "codiceEaso|uppercase"
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioneb",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "def": {
                type: "string",
                title: "Completo",
                description: "Completo...",
                callbackModel: "ricerca",
                dbfield: "def",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "sesso",
                valore: "sesso|uppercase",
                style: ""
            },
            "idTipoDocumento_IN": {
                type: "string",
                title: "Documento",
                description: "Documento...",
                callbackModel: "ricerca",
                dbfield: "idTipoDocumento_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.documentotipo",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "tipoProtezione_id_IN": {
                type: "string",
                title: "Tipo Soggiorno",
                description: "Tipo Soggiorno...",
                callbackModel: "ricerca",
                dbfield: "tipoProtezione_id_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.tipoproteziones",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "idVulnerabilita_IN": {
                type: "string",
                title: "Vulnerabilità",
                description: "Vulnerabilità...",
                callbackModel: "ricerca",
                dbfield: "idVulnerabilita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.vulnerabilitas",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataScadenzaDocumento": {
                type: "string",
                title: "Scadenza Documento",
                description: "Scadenza Documento...",
                callbackModel: "ricerca",
                dbfield: "dataScadenzaDocumento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.datascadenza",
                chiave: "id",
                valore: "descrizione|uppercase",
                novalore: "null"
            },
            "dataUscita>": {
                type: "string",
                title: "Data Inizio Permanenza",
                description: "Data Inizio Permanenza",
                callbackModel: "ricerca",
                dbfield: "dataUscita>",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "dataInizio<": {
                type: "string",
                title: "Data Fine Permanenza",
                description: "Data Inizio",
                callbackModel: "ricerca",
                dbfield: "dataInizio<",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "attivo": {
                type: "string",
                title: "Includi i non usciti",
                description: "Includi i non usciti",
                callbackModel: "ricerca",
                dbfield: "attivo",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.nullsi",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "raggruppa": {
                type: "string",
                title: "Tipo raggruppamento",
                description: "Tipo raggruppamento",
                callbackModel: "ricerca",
                dbfield: "raggruppa",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.raggruppaProgetto",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
            "trasferimento": {
                type: "string",
                title: "Trasferimento",
                description: "Trasferiti...",
                callbackModel: "ricerca",
                dbfield: "trasferimento",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sino",
                chiave: "id",
                valore: "descrizione|uppercase"
            },
            "esterna": {
                type: "string",
                title: "Tipologia Accoglienza in Struttura",
                description: "Tipologia Accoglienza in Struttura...",
                callbackModel: "ricerca",
                dbfield: "esterna",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.accoglienze",
                chiave: "id",
                valore: "descrizione|uppercase"
            }
        };
        vm.searchForms = angular.copy(vm.searchFormsA);
        if (vm.datas.api) {
//            if (vm.datas.api == 'a') {
//                vm.searchForms = angular.copy(vm.searchFormsB);
//            }
        }

        vm.filtrap = filtrap;
        function filtrap(searchvariable, origine) {
            var dataOrigine = searchvariable[origine]['data'].split(".")[1];
            var destinazione = searchvariable[origine]['figlio'];
            var figliocampofiltro = searchvariable[origine]['figliocampofiltro'];
            var dataDestinazione = searchvariable[destinazione]['data'].split(".")[1];
            var callbackmodel = searchvariable[origine]['callbackModel'];

            var selezionati = vm[callbackmodel][origine];
            var primaFiltro = ricerca[dataDestinazione];
            var risultato = [];

            if (angular.isDefined(destinazione) && angular.isDefined(figliocampofiltro) && angular.isDefined(selezionati)) {
                angular.forEach(selezionati, function (selezionato) {
                    angular.forEach(primaFiltro, function (item) {
                        if (item[figliocampofiltro] === selezionato) {
                            risultato.push(item);
                        }
                    });
                });
            } else {
                risultato = angular.copy(primaFiltro);
            }

            vm[dataDestinazione] = risultato;
        }

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'codice': 'Codice', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'dataInizio': 'Inizio Sprar', 'dataFine': 'Fine Accoglienza', 'stato': 'Stato del beneficiario'};

        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.accoglienze = [{id: 0, descrizione: "Accoglienza Interna"}, {id: 1, descrizione: "Accoglienza Esterna"}];
        vm.contasino = ricerca.contasino;
        vm.sesso = ricerca.sesso;
        vm.vulnerabilitas = ricerca.vulnerabilita;

        vm.selected = [];
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.ricerca = {};
        vm.ricerca.dataNascita = null;
        vm.ricerca['dataInizio>'] = null;
        vm.ricerca['dataInizio<'] = null;
        vm.ricerca['dataUscita>'] = null;
        vm.ricerca['dataUscita<'] = null;
        vm.ricerca2 = "";
        vm.ricerca.operatore = "AND";
        vm.autostart = true;
        if (vm.preselezione !== null && vm.preselezione !== "" && angular.isDefined(vm.preselezione)) {
            vm.ricerca["progetto_id_IN"] = [vm.preselezione.toString()];
            vm.autostart = false;
        }
        vm.allsearchs['query[]'][1] = vm.ricerca;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];

        vm.loadbeneficiarios = function (tiporicerca) {
            var tr = tiporicerca;
            var sapi = "v";
            if (angular.isUndefined(tr)) {
                tr = "search";
            }
            if (angular.isDefined(vm.datas.api)) {
                sapi = vm.datas.api;
                if (sapi === 'v') {
                    vm.allsearchs['query[]'][1]['groupby'] = "id";
                }
                if (sapi === 'a') {
                    //vm.allsearchs['query[]'][1]['groupby'] = "uniquepr";
                }
            }
            if (angular.isDefined(vm.datas.def)) {
                vm.allsearchs['query[]'][1]['def'] = vm.datas.def;
            }
            if (angular.isDefined(vm.datas.stato)) {
                vm.allsearchs['query[]'][1]['stato_IN'] = [vm.datas.stato];
            }
            if (angular.isDefined(vm.datas.trasferimento)) {
                vm.allsearchs['query[]'][1]['trasferimento'] = vm.datas.trasferimento;
            }
            if (vm.prequery !== null) {
                vm.prequery = angular.fromJson(vm.prequery);
                angular.forEach(vm.prequery, function (v, k) {
                    vm.allsearchs['query[]'][1][k] = v;
                    vm.ricerca[k] = v;
                });
            }
            api.beneficiarios.tutti.cerca(vm.allsearchs, function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
                vm.searched = true;
                if (!vm.ricerca.dataNascita)
                {
                    vm.ricerca.dataNascita = null;
                }
                if (!vm.ricerca['dataInizio>']) {
                    vm.ricerca['dataInizio>'] = null;
                }
                if (!vm.ricerca['dataInizio<']) {
                    vm.ricerca['dataInizio<'] = null;
                }
                if (!vm.ricerca['dataUscita>']) {
                    vm.ricerca['dataUscita>'] = null;
                }
                if (!vm.ricerca['dataUscita<']) {
                    vm.ricerca['dataUscita<'] = null;
                }
                if (vm.allsearchs.groupby) {
                    vm.allsearchs['query[]'][1].raggruppa = vm.r1;
                }
            }, function (response) {
                //console.log(response);
            });
            return vm.beneficiari;
        };
        if (vm.autostart) {
            vm.loadbeneficiarios();
        }


        vm.beneficiario = {
            id: null,
            nome: null,
            cognome: null,
            sesso: null,
            idNazioneNascita: null,
            idNazioneProvenienza: null,
            idNazioneCittadinanza: null,
            gruppoEtnico: null,
            idReligione: null,
            email: null,
            telefono: null,
            dataNascita: '1980-01-01',
            dataNascita2: null,
            codComuneNascita: null,
            codNazionalita: null,
            codiceFiscale: null,
            note: null,
            noteSanitarie: null,
            beneficiarioAttributis: [],
            strutturas: [],
            beneficiarioextras: [],
            idTipoIngresso: '28',
            idTipoDocumento: '581',
            dataIngresso: null,
            dataIngresso2: null,
            dataInserimento: null,
            dataInserimento2: null,
            tipoIngresso: 'SC',
            nucleoFamiliare: '0',
            stato: 'LIBERO'
        };

        vm.selectedBeneficiarios = [];
        vm.selectedContacts = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;
        vm.dataAdOggi = dataAdOggi;
        vm.dettaglisegnalato = dettaglisegnalato;

        function dettaglisegnalato(item) {
            api.segnalatos.segnalato.get({id: item}, function (d) {
                vm.segnalato = d;
                vm.segnalatoMinori = d.segnalaziones.idTipoSegnalazione;

                $mdDialog.show({
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    controller: 'NotificatioPersonaAddController',
                    focusOnOpen: false,
                    locals: {
                        minori: (vm.segnalatoMinori === 607),
                        isnew: false,
                        nucleoFamiliare: true,
                        segnalato: vm.segnalato,
                        readonly: true
                    },
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    templateUrl: 'app/main/sprardb/notification/dialogs/notification/add-dialog.html',
                })
            });
        }

        //////////
        function dataAdOggi(dataInizio) {
            var di = new Date(dataInizio);
            var adesso = moment();
//            console.log("di:", di);
//            console.log("adesso:", adesso);
//            console.log("diff:", adesso.diff(di, 'days'));
            return adesso.diff(di, 'days');
        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }
        vm.cachesearched = {};
        function valuesearched(key, value) {
            if (key == 'groupby') {
                return "RAGGRUPPATO " + value;
            }

            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            if (!vm.searchForms[key]) {
                console.log("key:", key);
                return "-"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];

            }

            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');


            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            if (results.length == 0) {
                return "-";
            }
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoDettaglio(id)
        {
            $state.go('app.sprardb_beneficiario', {id: id});
        }

        vm.onSearch = onSearch;
        function onSearch() {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';

                //if (vm.ricerca2.indexOf(",") > -1) {
                vm.allsearchs['query[]'][0]["codice"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["nome"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["cognome"] = vm.ricerca2;
//                } else {
//                    vm.allsearchs['query[]'][0].nome = vm.ricerca2;
//                    vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
//                    vm.allsearchs['query[]'][0].id = vm.ricerca2;
//                }
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricerca3 = null;
            if (vm.ricerca['attivo'] === 1) {


                vm.ricerca3 = angular.copy(vm.ricerca);
                //delete vm.ricerca['dataUscita_IS'];
                //delete vm.ricerca3['dataUscita>'];
                delete vm.ricerca3['dataUscita<'];
                delete vm.ricerca3['dataInizio>'];
                vm.ricerca3['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                //vm.allsearchs.groupby = 'uniquepr';
                vm.ricerca3.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricerca3;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                //delete vm.allsearchs.groupby;
                vm.ricerca3 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["codice"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["nome"] = vm.ricerca2;
                vm.allsearchs['query[]'][0]["cognome"] = vm.ricerca2;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    //vm.ricerca.groupby = 'id';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }


            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            vm.loadbeneficiarios(tiporicerca);
        }

        vm.onSearchNome = onSearchNome;
        function onSearchNome(ricercaNome) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaNome) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';

                vm.allsearchs['query[]'][0]["nome"] = ricercaNome;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaNome2 = null;
            if (vm.ricerca['attivo'] === 1) {
                vm.ricercaNome2 = angular.copy(vm.ricerca);
                delete vm.ricercaNome2['dataUscita<'];
                delete vm.ricercaNome2['dataInizio>'];
                vm.ricercaNome2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaNome2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaNome2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;
            } else {
                vm.ricercaNome2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["nome"] = ricercaNome;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }

            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {
            }
            vm.loadbeneficiarios(tiporicerca);
        }

        vm.onSearchCognome = onSearchCognome;
        function onSearchCognome(ricercaCognome) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaCognome) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["cognome"] = ricercaCognome;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaCognome2 = null;
            if (vm.ricerca['attivo'] === 1) {

                vm.ricercaCognome2 = angular.copy(vm.ricerca);
                delete vm.ricercaCognome2['dataUscita<'];
                delete vm.ricercaCognome2['dataInizio>'];
                vm.ricercaCognome2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaCognome2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaCognome2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                vm.ricercaCognome2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["cognome"] = ricercaCognome;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }

            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            vm.loadbeneficiarios(tiporicerca);
        }

        vm.onSearchCodice = onSearchCodice;
        function onSearchCodice(ricercaCodice) {
            var tiporicerca = "search";
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (ricercaCodice) {
                tiporicerca = "like";
                vm.allsearchs['query[]'][0].operatore = 'OR';
                vm.allsearchs['query[]'][0]["codice"] = ricercaCodice;
            }
            if (vm.def !== null) {
                vm.ricerca.def = vm.def;
            }
            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
                if (angular.isDefined(vm.searchForms[key])) {
                    if (angular.isDefined(vm.searchForms[key]['figlio']) && angular.isDefined(vm.searchForms[key]['figliocampofiltro'])) {
                        vm.filtrap(vm.searchForms, key);
                    }
                }
            });
            //permanenza
            vm.ricercaCodice2 = null;
            if (vm.ricerca['attivo'] === 1) {

                vm.ricercaCodice2 = angular.copy(vm.ricerca);
                delete vm.ricercaCodice2['dataUscita<'];
                delete vm.ricercaCodice2['dataInizio>'];
                vm.ricercaCodice2['dataUscita_IS'] = 'NULL';
                vm.allsearchs.operatore = 'OR';
                vm.ricercaCodice2.operatore = 'AND';
                vm.allsearchs['query[]'][0] = {};
                vm.allsearchs['query[]'][0] = {operatore: 'AND'};
                vm.allsearchs['query[]'][0] = vm.ricercaCodice2;
                vm.ricerca.operatore = 'AND';
                vm.allsearchs['query[]'][1] = vm.ricerca;

            } else {
                vm.ricercaCodice2 = null;
                vm.allsearchs['query[]'][0] = {operatore: 'OR'};
                vm.allsearchs['query[]'][0]["codice"] = ricercaCodice;
                //ricerca classica
                if (vm.ricerca) {
                    vm.ricerca.operatore = 'AND';
                    vm.allsearchs['query[]'][1] = vm.ricerca;
                }
            }
            delete vm.r1;
            vm.r1 = vm.ricerca.raggruppa;
            if (vm.r1) {
                if (vm.r1 == 'Accoglienza') {
                    vm.allsearchs.groupby = "codicePresenza";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }
                if (vm.r1 == 'Presenza') {
                    vm.allsearchs.groupby = "id";
                    delete vm.allsearchs['query[]'][0].raggruppa;
                    delete vm.allsearchs['query[]'][1].raggruppa;
                }

            } else {
                delete vm.allsearchs.groupby;
                delete vm.allsearchs['query[]'][0].raggruppa;
                delete vm.allsearchs['query[]'][1].raggruppa;
                vm.r1 = "Nessuno";
            }


            if (tiporicerca == "like") {
            }
            if (tiporicerca == "search") {

            }
            vm.loadbeneficiarios(tiporicerca);
        }

        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
//            oggi.setHours(0);
//            oggi.setMinutes(0);
//            oggi.setSeconds(0);
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }

        vm.resetStato = resetStato;
        function resetStato() {
            delete(vm.datas.stato);
        }
    }

    function BeneficiariOmController($scope, $mdSidenav, msUtils, $mdDialog, $document, msApi, $state, eventi, api, ricerca, $filter, $mdToast)
    {
        var vm = this;
        // Data

        vm.def = ($state.params.def) ? $state.params.def : null;
        var searchpayload = {};
        if (vm.def !== null) {
            searchpayload.def = vm.def;
        }
        vm.datascadenza = ricerca.datascadenza;
        vm.regiones = ricerca.regiones;
        vm.benefstatos = ricerca.statobeneficiarios;
        vm.progettosa = ricerca.progettos;
        vm.nazioneb = ricerca.naziones;
        vm.nazioni = null;
//        vm.segnalatiomonimi = null;
//        api.segnalatos.segnalato.search({omonimo: ">1", beneficiario_id: 0, sort: "nome"}, function (r) {
//            vm.segnalatiomonimi = r.data;
//        });

        api.beneficiarios.attributi.cerca({gruppo: "NAZIONE", pagination: "400"}, function (response) {
            vm.nazioni = response.data;
        });

        api.progettos.progetto.cerca({sort: "nome", pagination: "400", fields: "id,nome"}, function (response) {
            vm.progettos = response.data;
        });
        api.beneficiarios.attributi.cerca({gruppo: "DOCUMENTO", pagination: "400"}, function (response) {
            vm.documentotipo = response.data;
        });
        vm.sesso = [{id: "M", descrizione: "MASCHIO"}, {id: "F", descrizione: "FEMMINA"}];

        vm.parentela = function () {
            api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'descrizione'}).$promise.then(function (response) {
                vm.parentelas = response.data;
            }, function (response) {
                console.log('Parentela caricata');
            });
        };
        vm.parentela();


        vm.searchForms = {
            nome: {
                type: "string",
                title: "Nome",
                description: "Nome...",
                callbackModel: "ricerca",
                dbfield: "nome",
                formtype: "text",
                multiple: false,
                onchange: "vm.onSearch()",
                style: ""
            },
            cognome: {
                type: "string",
                title: "Cognome",
                description: "Cognome...",
                callbackModel: "ricerca",
                dbfield: "cognome",
                formtype: "text",
                multiple: false,
                onchange: "vm.onSearch()",
                style: ""
            },
            "sesso": {
                type: "string",
                title: "Sesso",
                description: "Sesso...",
                callbackModel: "ricerca",
                dbfield: "sesso",
                formtype: "select",
                multiple: false,
                onchange: "vm.onSearch()",
                data: "vm.sesso",
                chiave: "id",
                valore: "descrizione|uppercase",
                style: ""
            },
            "codNazionalita_IN": {
                type: "string",
                title: "Nazionalita",
                description: "Nazionalita...",
                callbackModel: "ricerca",
                dbfield: "codNazionalita_IN",
                formtype: "select",
                multiple: true,
                onchange: "vm.onSearch()",
                data: "vm.nazioni",
                chiave: "id",
                valore: "descrizione|uppercase",
                style: ""
            },
            "dataNascita": {
                type: "string",
                title: "Data Nascita",
                description: "Data Nascita",
                callbackModel: "ricerca",
                dbfield: "dataNascita",
                formtype: "datepickerv",
                onchange: "vm.onSearch()"
            },
        };

        vm.preparati = false;
        vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};

        vm.statoattivo = ricerca.statoattivo;
        vm.sino = ricerca.sino;
        vm.contasino = ricerca.contasino;
        vm.accoglienze = [{id: 0, descrizione: "Accoglienza Interna"}, {id: 1, descrizione: "Accoglienza Esterna"}];

        vm.selected = [];
        vm.selectedSegnalato = {};
        vm.selectedSegnalato.id = ($state.params.om) ? $state.params.om : null;
        vm.selectedIds = [];
        vm.options = ricerca.options;
        vm.options.rowSelection = true;
        vm.options.multiSelect = true;
        vm.options.autoSelect = false;
        vm.limitOptions = ricerca.limitOptions;
        vm.searched = false;
        vm.allsearchs = ricerca.begin_allsearchs();
        vm.colors = ricerca.colors;

        vm.ricerca = {};
        vm.ricerca2 = "";

        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'nome';
        vm.listOrderAsc = false;
        vm.selectedEnti = [];
        vm.newGroupName = '';
        vm.mostraitag = false;

// Dati
        vm.Beneficiari = null;
        vm.beneficiari = [];
        vm.links = [];
        vm.meta = [];
        vm.tags = [];
        vm.lista = [];


        vm.loadbeneficiarios = function () {
            console.log(vm.allsearchs);
            if (angular.isDefined($state.params.def)) {
                vm.allsearchs['query[]'][1]['def'] = $state.params.def;
            }
            console.log(vm.allsearchs);
            api.beneficiarios.m.search(vm.allsearchs).$promise.then(function (response) {
                vm.Beneficiari = response;
                vm.beneficiari = response.data;
                vm.links = response._links;
                vm.meta = response._meta;
            }, function (response) {
                //console.log(response);
            });
            return vm.beneficiari;
        };
        vm.loadbeneficiarios();


        vm.selectedBeneficiarios = [];
        vm.selectedContacts = [];

        // Methods
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        vm.exportcsvente = exportcsvente;
        vm.viewtags = viewtags;
        vm.edittags = edittags;
        vm.toggleSelect = toggleSelect;
        vm.deletefiltersearch = deletefiltersearch;
        vm.valuesearched = valuesearched;
        vm.toggleSidenav = toggleSidenav;
        vm.gotoDettaglio = gotoDettaglio;
        vm.onSearch = onSearch;
        vm.filterChange = filterChange;
        vm.diffdate = diffdate;
        vm.letteraTrasf = eventi.letteraTrasf;


        //////////
        function exportcsvente() {
            vm.preparati = false;
            console.log('preparazione');
            vm.entesfileds = {'id': 'Id', 'codiceVestanet': 'Vestanet', 'cognome': 'Cognome', 'nome': 'Nome', 'dataNascita': 'Data Nascita', 'documentoNumero': 'Documento numero', 'dataIngresso': 'Ingresso Sprar', 'dataFine': 'Fine Accoglienza'};
            vm.entesexport = null;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Dati per esportazione in preparazione')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            vm.allsearchsTemp = angular.copy(vm.allsearchs);
            vm.allsearchsTemp.pagination = 100000;
            vm.allsearchsTemp.sort = 'nome';
            vm.allsearchsTemp.fields = 'id,codiceVestanet,cognome,nome,dataNascita,documentoNumero,dataIngresso,dataInizio,dataFine';
            api.beneficiarios.m.like(vm.allsearchsTemp, function (d) {
                console.log('lancio');
                vm.entesexport = d.data;
                vm.preparati = true;
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Dati pronti per esportazione')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
            });

        }

        function viewtags(tags, tipotag) {
            console.log(tags);
            console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_visualizza_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: false
                }
            });
        }

        function edittags(selected, tipotag) {
            var tags = [];
            angular.forEach(selected, function (objs) {
                var tagss = objs.tags;
                angular.forEach(tagss, function (tag) {
                    //console.log(tag);
                    tags.push(tag);
                });

            });
            //console.log(tags);

            //console.log(tipotag);
            $mdDialog.show({
                controller: 'TagsEDialogController',
                controllerAs: 'vmd',
                templateUrl: 'app/main/sprardb/tags/dialog_modifica_tags.html',
                clickOutsideToClose: true,
                locals: {
                    Tags: tags,
                    TipoTag: tipotag,
                    isnew: true,
                    selected: selected
                }
            });
        }

        function toggleSelect(item) {

            if (vm.selectedIds.indexOf(item.id) > -1) {
                vm.selectedIds.splice(vm.selectedIds.indexOf(item.id), 1);
            } else {
                vm.selectedIds.push(item.id);
            }
            console.log("selected:");
            console.log(vm.selected);
            console.log(vm.selectedIds);
        }

        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            onSearch();
        }

        function valuesearched(key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }
            if (angular.isUndefined(vm.searchForms[key].data)) {
//                if (angular.isDate(value)) {
//                    return moment(date).format('DD/MM/YYYY');
//                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function gotoDettaglio(id)
        {
            $state.go('app.sprardb_beneficiario', {id: id});
        }

        vm.onSearch = onSearch;
        function onSearch() {
            vm.allsearchs['query[]'] = [];
            vm.allsearchs['query[]'][0] = {operatore: 'OR'};
            if (vm.ricerca2) {
                vm.allsearchs['query[]'][0].operatore = 'OR';

                if (vm.ricerca2.indexOf(",") > -1) {
                    vm.allsearchs['query[]'][0]["id_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["nome_IN"] = vm.ricerca2;
                    vm.allsearchs['query[]'][0]["cognome_IN"] = vm.ricerca2;
                } else {
                    vm.allsearchs['query[]'][0].nome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].cognome = vm.ricerca2;
                    vm.allsearchs['query[]'][0].id = vm.ricerca2;
                }
            }

            angular.forEach(vm.ricerca, function (value, key) {
                if (value === null || value === 'null' || (angular.isArray(value) && value.length === 0)) {
                    delete vm.ricerca[key];
                }
                if (angular.isDate(value)) {
                    vm.ricerca[key] = moment(value).format("YYYY-MM-DD");
                }
            });
            if (vm.ricerca) {
                vm.ricerca.operatore = 'AND'
                vm.allsearchs['query[]'][1] = vm.ricerca;
                //vm.ricerca.results = 1;
                //vm.ricerca.extends = 0;
            }

            api.beneficiarios.m.like(vm.allsearchs, function (d) {
                console.log(d);
                vm.Beneficiari = d;
                vm.beneficiari = d.data;
                vm.links = d._links;
                vm.meta = d._meta;
            }
            );
            vm.searched = true;
        }

        function filterChange(type)
        {

            vm.listType = type;

            if (type === 'all')
            {
                vm.filterIds = null;
            } else if (type === 'frequent')
            {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred')
            {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type))
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        function diffdate(item) {
            var oggi = new Date();
//            oggi.setHours(0);
//            oggi.setMinutes(0);
//            oggi.setSeconds(0);
            var di = item.dataInserimento;
            var du = item.dataUscita;
            if (item.dataUscita === null) {
                du = moment(oggi).format('YYYY-MM-DD');
            }
            var d1 = moment(di);
            var d2 = moment(du);
            var days = moment.duration(d2.diff(d1)).asDays();
            return days;
        }




        vm.goomonimia = goomonimia;
        vm.risolviom = risolviom;
        function goomonimia() {
            var item = vm.selectedSegnalato;
            vm.ricerca.nome = item.nome;
            vm.ricerca.cognome = item.cognome;
            vm.ricerca.sesso = item.sesso;
            onSearch();
        }
        function risolviom() {
            var selected = vm.selected[0];
            var omonimo = vm.selectedSegnalato;

            var confirm = $mdDialog.confirm()
                    .title('Risolvi omonimia')
                    .htmlContent('Vuoi sovrascrivere i dati anagrafici già in archivio con quelli inseriti nella segnalazione?<br><b>' + selected.cognome + ' ' + selected.nome + ' </b>sostituira<b> ' + omonimo.cognome + ' ' + omonimo.nome + '</b><br><br><b>Risolvendo l\'omonimia</b> sarà possibile <b>inserire la segnalazione bloccata</b>.<br><br><b>Ho capito e desidero procedere.</b><br><br>Verranno sovrascritti i dati relativi a nome, cognome, sesso e data di nascita')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Sovrascrivi e Sblocca omonimia!')
                    .cancel('Abbandona');
            $mdDialog.show(confirm).then(function () {
                var payload = {};
                payload.id = omonimo.id;
                payload.cognome = selected.cognome;
                payload.nome = selected.nome;
                payload.sesso = selected.sesso;
                payload.dataNascita = selected.dataNascita;
                payload.omonimo = -1;

                var goto = {};
                goto.eventoTipo_id = (selected.progetto_id == 0) ? 1002 : 1003;

                api.segnalatos.segnalato.aggiorna(payload, function (d) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Omonimia risolta!!')
                            .position('bottom right')
                            .hideDelay(3000)
                            ).then(
                            $state.go('app.sprardbEventi', goto)
                            );
                });
            }, function () {
                //$state.go('app.sprardbEventi', {eventoTipo_id: 1002})
            });

        }

    }

    function ParentelaDialogController($scope, msUtils, $mdDialog, $state, api, $mdToast, $q, locals) {
        var vmd = this;
        console.log("locals");
        console.log(locals);
        vmd.items = locals.items;
        vmd.parentelas = locals.parentelas;

        vmd.cancel = cancel;
        function cancel() {
            $mdDialog.hide();
        }
        vmd.assegna = assegna;
        function assegna() {
            var nc = 0;
            var cp = vmd.capofamiglia;
            if (vmd.items.length > 1) {
                nc = 1;
            }

            var payloads = [];

            angular.forEach(vmd.items, function (obj) {
                var payload = {};
                payload.id = obj.id;
                payload.parentela_id = obj.parentela_id;
                payload.nucleoFamiliare = nc;
                payload.capof_id = cp;
                if (obj.id == cp) {
                    payload.capof_id = 0;
                }
                if (nc === 0) {
                    //solo 1 persona
                    payload.id = obj.id;
                    payload.parentela_id = 589; // monoparentale
                    payload.nucleoFamiliare = 0;
                    payload.capof_id = obj.id; //me stesso
                }
                payloads.push(payload);
            });

            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Assegnazione parentela')
                    .position('bottom right')
                    .hideDelay(2000)
                    );
            console.log("payloads", payloads);
            angular.forEach(payloads, function (pl) {
                api.beneficiarios.beneficiario.aggiorna(pl, function (d) {
                    console.log("aggiornamento", d);
                });
            });

            setTimeout(function () {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Assegnazione parentela completato')
                        .position('bottom right')
                        .hideDelay(2000)
                        );
                $mdDialog.hide();

            }, 4000);


//            var requests = payloads.map(function (pl) {
//                console.log("payload:", pl);
//                var deferred = $q.defer();
//                conslole.log("def", deferred);
//                api.beneficiarios.beneficiario.aggiorna(pl, function (d) {
//                    deferred.resolve();
//                    console.log(d);
//                });
//                return deferred;
//            });
//
//            $q.all(requests).then(function () {
//                $mdToast.show(
//                        $mdToast.simple()
//                        .textContent('Assegnazione parentela completato')
//                        .position('bottom right')
//                        .hideDelay(2000)
//                        );
//            });



//            var loopPromises = [];
//            angular.forEach(payloads, function (pl) {
//                var deferred = $q.defer();
//                loopPromises.push(deferred.promise);
//                api.beneficiarios.beneficiario.update(pl, function (d) {
//                    deferred.resolve();
//                    console.log(d);
//                });
//            });
//            $q.all(loopPromises).then(function () {
//                $mdToast.show(
//                        $mdToast.simple()
//                        .textContent('Assegnazione parentela completato')
//                        .position('bottom right')
//                        .hideDelay(2000)
//                        );
//                $mdDialog.hide();
//                $state.reload();
//            });

        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbUploaddocuments5Controller', sprardbUploaddocuments5Controller)
            .controller('uploadDialogController5', uploadDialogController5)
            .directive('sprardbUploaddocuments5', sprardbUploaddocuments5Directive);
    /** @ngInject */
    function uploadDialogController5(locals, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;

        vmdd.documentoTipos = locals.documentoTipos;
        vmdd.params = locals.params;
        vmdd.sceglitipo = locals.sceglitipo;
        //console.log(locals);
        vmdd.ngFlowOptions = {
            target: api.baseUrl + 'documentos/upload',
            chunkSize: 64 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 100,
            headers: {'Authorization': 'Basic ' + locals.authB, 'X-Requested-With': 'XMLHttpRequest', },
            query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };
        vmdd.caricamentook = false;


        // Methods
        vmdd.upload = upload;
        function upload()
        {
            console.log("file submitted");
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            //console.log("file added");

        }

        vmdd.fileSuccess = fileSuccess;

        function fileSuccess(file, message)
        {
            //console.log("file success");
            vmdd.caricamentook = true;
        }

        vmdd.inprogress = false;
        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            //console.log("upload in progress");
            $rootScope.loadingProgress = true;
            vmdd.inprogress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            //console.log("upload complete");
            vmdd.inprogress = false;
            $rootScope.loadingProgress = false;
            if (vmdd.caricamentook) {
                $mdDialog.hide();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('File caricato correttamente')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $state.reload();

            }
            if (!vmdd.caricamentook) {
                $mdDialog.hide();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Errore durante il caricamento del file')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $state.reload();
            }





            vmdd.caricamentook = false;
        }

        vmdd.fileerror = fileerror;
        function fileerror() {
            vmdd.caricamentook = false;
            //console.log("file error");
        }
    }
    function sprardbUploaddocuments5Controller($scope, api, $mdToast, fuseGenerator, $mdDialog, $state) {
        var vmd = this;


        vmd.api = api;
        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documentos = [];
        vmd.baseUrl = api.baseUrl;
        vmd.readonly = api.isReadOnly;



        vmd.visibile = 1;
        vmd.moduloupload = {};
        vmd.moduloupload.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vmd.moduloupload.limitOptions = [25];
        vmd.moduloupload.pagination = 25;
        vmd.moduloupload.page = 1;
        vmd.moduloupload.sort = "-id";
        vmd.moduloupload.meta = {};
        vmd.moduloupload.meta.perPage = vmd.moduloupload.pagination;
        vmd.moduloupload.meta.currentPage = vmd.moduloupload.page;
        vmd.moduloupload.meta.pageCount = vmd.moduloupload.page;
        vmd.moduloupload.meta.totalCount = vmd.moduloupload.page;


        vmd.loadDT = loadDT;
        function loadDT() {
            //console.log(vmd.uploadCfg);
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "ordine"}, function (d) {
                vmd.documentoTipos = d.data;
                if (angular.isDefined(vmd.uploadCfg.entita_id) && vmd.uploadCfg.entita_id != null && vmd.uploadCfg.entita_id > 0) {
                    if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                        if (vmd.uploadCfg.progettoRendicontazioneStato_id == 3 || vmd.uploadCfg.progettoRendicontazioneStato_id == 5) {
                            vmd.readonly = true;
                        }
                        var searchpayload = {};
                        searchpayload["query[]"] = {};
                        searchpayload["query[]"]["operatore"] = "AND";
                        searchpayload["query[]"][vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                        searchpayload["query[]"]["visibile"] = vmd.visibile;
                        if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                            //searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                            searchpayload["query[]"][vmd.uploadCfg.entitakey2 + "_IN"] = vmd.uploadCfg.entita2_id + ",-1";
                        }
                        //console.log("verifica lista", searchpayload);
                        searchpayload.pagination = vmd.moduloupload.pagination;
                        searchpayload.sort = vmd.moduloupload.sort;
                        searchpayload.page = vmd.moduloupload.page;

                        searchpayload.expand = 'key'

                        api.hasdocumento.rendicontaziones.search(searchpayload, function (d) {
                            vmd.documentos = d.data;
                            vmd.moduloupload.meta = d._meta;
                            //console.log("verifica elenco",vmd.documentos);
                        });
                    }
                }
            });

        }



        // Script di creazione del CSV elenco file
        vmd.downloadFileList = downloadFileList;
        function downloadFileList() {
            //Inizia il popolamento della tabella principale del CSV
            var tableinfo = [];
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "ordine"}, function (d) {
                vmd.documentoTipos = d.data;
                if (angular.isDefined(vmd.uploadCfg.entita_id) && vmd.uploadCfg.entita_id != null && vmd.uploadCfg.entita_id > 0) {
                    if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                        if (vmd.uploadCfg.progettoRendicontazioneStato_id == 3 || vmd.uploadCfg.progettoRendicontazioneStato_id == 5) {
                            vmd.readonly = true;
                        }
                        var searchpayload = {};
                        searchpayload["query[]"] = {};
                        searchpayload["query[]"]["operatore"] = "AND";
                        searchpayload["query[]"][vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                        searchpayload["query[]"]["visibile"] = vmd.visibile;
                        if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                            //searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                            searchpayload["query[]"][vmd.uploadCfg.entitakey2 + "_IN"] = vmd.uploadCfg.entita2_id + ",-1";
                        }
                        //console.log("verifica lista", searchpayload);
                        searchpayload.pagination = false;
                        searchpayload.sort = vmd.moduloupload.sort;
                        searchpayload.page = vmd.moduloupload.page;
                        if (vmd.api.user.id === 3) { // user admin3
                            searchpayload.expand = 'key';
                        }

                        api.hasdocumento.rendicontaziones.search(searchpayload, function (d) {
                            vmd.documentos2 = d.data;
                            //vmd.moduloupload.meta = d._meta;
                            var idDocumento = vmd.documentos2[0].progettoRendicontazione_id;
                            if (vmd.documentos2 !== undefined)
                            {
                                var i = 0;
                                vmd.documentos2.forEach(function (elements, key) {
                                    //preparazione o formattazione delle variabili
                                    var nomeFile = elements.documento.nomefile;

                                    //formattazione data documento
                                    var dataDocumento = new Date(elements.documento.data);
                                    dataDocumento = dataDocumento.toLocaleDateString();

                                    //tipo di documento
                                    var tipoDocumento = elements.documento.documentotipo.tipo;

                                    var riga = {
                                        "Pagina":  ((i/ 25) >> 0)+1,
                                        "Id": elements.documento.documentotipo.id, //0
                                        "Nome file": nomeFile, //1
                                        "Data del documento": dataDocumento, //2
                                        "Tipo documento": tipoDocumento, //3
                                        "Tipo file": elements.documento.tipoFile, //4
                                        "Visibile": elements.visibile
                                    };
                                    if (vmd.api.user.id === 3) { //user admin3
                                        riga["Percorso"] = "documentos/show/"+elements.documento.id+"?k="+elements.key;
                                    }

                                    tableinfo.push(riga);
                                    //corpo della tabella

                                    i++;
                                    //fine ciclo dati corpo tabella
                                });

                                //Tabelle principali
                                var json = tableinfo;
                                var fields = Object.keys(json[0])
                                var replacer = function (key, value) {
                                    return value === null ? '' : value
                                }

                                var csv = json.map(function (row)
                                {
                                    return fields.map(function (fieldName) { //array mappato
                                        return JSON.stringify(row[fieldName], replacer)
                                    }).join(';')
                                })
                                csv.unshift("\"" + fields.join('";"') + "\"") // heading del foglio csv

                                console.log(csv.join('\r\n'));
                                csv = encodeURIComponent(csv.join('\r\n'));
                            }

                            //Infine passo alla creazione del file
                            var filename, link;
                            filename = "allegati_prID-" + idDocumento + ".csv";
                            if (!csv.match(/^data:text\/csv/i)) {
                                csv = 'data:text/csv;charset=utf-8,' + csv;
                            }

                            link = document.createElement('a');
                            document.body.appendChild(link); //required in FF, optional for Chrome
                            link.setAttribute('href', csv);
                            link.setAttribute('download', filename);
                            link.target = "_self"; //required in FF, optional for Chrome;
                            link.click();
                        });
                    }
                }
            });




        }
//End export CSV


        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {
            //console.log(progetto_id);
            var st = true;
            if (params.documentoTipo_id > 0) {
                st = false;
            }
            $mdDialog.show({
                controller: 'uploadDialogController5',
                controllerAs: 'vmdd',
                templateUrl: 'app/core/directives/sprardb-uploaddocuments5/sprardb-uploaddocumentsDialog5.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    authorizationB: authB,
                    params: params,
                    documentoTipos: vmd.documentoTipos,
                    sceglitipo: st
                }
            });
        }
        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }



        vmd.cancelladocumento = cancelladocumento;
        function cancelladocumento(did, stato) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var confirm2 = $mdDialog.confirm()
                    .title('Sei sicuro di voler ripristinare?')
                    .htmlContent('Il documento sarà ripristinato.')
                    .ariaLabel('ripristina doc')
                    .ok('OK')
                    .cancel('ABBANDONA');
            var msg = 'File cancellato';
            var msg2 = 'File ripristinato';
            if (stato == 1) {
                confirm = angular.copy(confirm2);
                msg = angular.copy(msg2);
            }

            $mdDialog.show(confirm).then(function ()
            {
                api.hasdocumento.rendicontaziones.aggiorna({id: did, visibile: stato}, function (d) {
                    if (d.id == did) {
                        $state.reload();
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(msg)
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    }

                });

            }, function () {
            });
        }

        /**
         * Initialize / Watch model changes
         */
        //$scope.$watch('ngModel', setSelectedColor);
    }

    function sprardbUploaddocuments5Directive($compile)
    {
        return {
            require: ['sprardbUploaddocuments5', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbUploaddocuments5Controller as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-uploaddocuments5/sprardb-uploaddocuments5.html',
            link: function (scope, element, attrs, controllers, transclude)
            {

                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;
                ctrl.loadDT();


            }
        };

    }


})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbUploaddocuments4Controller', sprardbUploaddocuments4Controller)
            .controller('uploadDialogController4', uploadDialogController4)
            .directive('sprardbUploaddocuments4', sprardbUploaddocuments4Directive);
    /** @ngInject */
    function uploadDialogController4(locals, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;
        vmdd.documentoTipos = locals.documentoTipos;
        vmdd.params = locals.params;
        vmdd.sceglitipo = locals.sceglitipo;
        //console.log(locals);
        vmdd.ngFlowOptions = {
            target: api.baseUrl + 'documentos/upload',
            chunkSize: 64 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            headers: {'Authorization': 'Basic ' + locals.authB, 'X-Requested-With': 'XMLHttpRequest', },
            query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };

        // Methods
        vmdd.upload = upload;
        function upload()
        {
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
//            var uploadingFile = {
//                id       : file.uniqueIdentifier,
//                file     : file,
//                type     : '',
//                owner    : 'Emily Bennett',
//                size     : '',
//                modified : moment().format('MMMM D, YYYY'),
//                opened   : '',
//                created  : moment().format('MMMM D, YYYY'),
//                extention: '',
//                location : 'My Files > Documents',
//                offline  : false,
//                preview  : 'assets/images/etc/sample-file-preview.jpg'
//            };

            // Append it to the file list
//            vm.files.push(uploadingFile);
        }

        vmdd.fileSuccess = fileSuccess;
        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {


            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
//            angular.forEach(vm.files, function (item, index)
//            {
//                if ( item.id && item.id === file.uniqueIdentifier )
//                {
//                    // Normally you would update the file from
//                    // database but we are cheating here!
//
//                    // Update the file info
//                    item.name = file.file.name;
//                    item.type = 'document';
//
//                    // Figure out & upddate the size
//                    if ( file.file.size < 1024 )
//                    {
//                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
//                    }
//                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
//                    {
//                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
//                    }
//                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
//                    }
//                    else
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
//                    }
//                }
//            });
        }

        vmdd.inprogress = false;
        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            $rootScope.loadingProgress = true;
            vmdd.inprogress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            vmdd.inprogress = false;
            $rootScope.loadingProgress = false;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('File caricato correttamente')
                    .position('bottom right')
                    .hideDelay(3000)
                    ).then(function () {
                $mdDialog.hide();
                $state.reload();
            }
            );
            ;
        }
    }
    function sprardbUploaddocuments4Controller($scope, api, $mdToast, fuseGenerator, $mdDialog, $state) {
        var vmd = this;
        //console.log(vmd);
        //vmd.uploadCfg
        //Esempio configurazione
//        vm.uploadParams = {
//            documentoTipo_id: 0,
//            gruppo: 'PROGETTO',
//            dettaglio: true,
//            entita: 'progetto',
//            entitakey: 'progetto_id'
//            entita_id: valore,
//            {{nome entita}} es progetto_id: valore
//        };


        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documentos = [];
        vmd.baseUrl = api.baseUrl;

        vmd.loadDT = loadDT;
        function loadDT() {
            //console.log(vmd.uploadCfg);
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "ordine"}, function (d) {
                vmd.documentoTipos = d.data;
                if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                    var searchpayload = {};
                    searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                    if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                        searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                    }
                    //console.log("verifica lista4", searchpayload);
                    searchpayload.pagination = 8000;
                    api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                        vmd.documentos = d.data;
                        //console.log("verifica elenco",vmd.documentos);
                    });
                }
            });

        }

        // Script di creazione del CSV elenco file
        vmd.downloadFileList = downloadFileList;
        function downloadFileList() {
            //Inizia il popolamento della tabella principale del CSV
            var tableinfo = [];
            var idDocumento = vmd.documentos[0].progettoRendicontazione_id;
            if (vmd.documentos !== undefined)
            {
                vmd.documentos.forEach(function (elements, key) {

                    //preparazione o formattazione delle variabili
                    var nomeFile = elements.documento.nomefile;

                    //formattazione data documento
                    var dataDocumento = new Date(elements.documento.data);
                    dataDocumento = dataDocumento.toLocaleDateString();

                    //tipo di documento
                    var tipoDocumento = elements.documento.documentotipo.tipo;

                    console.log("vmdSet", vmd.documentos);
                    //composizione della tabella
                    //console.log("attivoProva",attivo);
                    tableinfo.push({
                        "Id": elements.documento.documentotipo.id, //0
                        "Nome file": nomeFile, //1
                        "Data del documento": dataDocumento, //2
                        "Tipo documento": tipoDocumento, //3
                        "Tipo file": elements.documento.tipoFile, //4
                        "Percorso": elements.documento.unomefile		//5
                    });
                    //corpo della tabella

                    /*elements.forEach(function (item, key) {
                     
                     tableinfo.push({
                     "id": item.value, 
                     "natura documento": item.label, 
                     "data del documento":"test data"
                     
                     });
                     });*/

                    //fine ciclo dati corpo tabella
                });
                console.log("tableinfo", tableinfo);
                //Tabelle principali
                var json = tableinfo;
                var fields = Object.keys(json[0])
                var replacer = function (key, value) {
                    return value === null ? '' : value
                }

                var csv = json.map(function (row)
                {
                    return fields.map(function (fieldName) { //array mappato
                        return JSON.stringify(row[fieldName], replacer)
                    }).join(';')
                })
                csv.unshift("\"" + fields.join('";"') + "\"") // heading del foglio csv

                console.log(csv.join('\r\n'));
                var csvcontents = csv.join('\r\n');
            }

            //Infine passo alla creazione del file
            var data, filename, link;
            var csv = csvcontents;
            if (csv == null)
                return;
            //console.log("miocsv", csv);
            filename = "allegati_prID-" + idDocumento + ".csv";
            if (!csv.match(/^data:text\/csv/i)) {
                csv = 'data:text/csv;charset=utf-8,' + csv;
            }
            data = encodeURI(csv);

            link = document.createElement('a');
            document.body.appendChild(link); //required in FF, optional for Chrome
            link.setAttribute('href', data);
            link.setAttribute('download', filename);
            link.target = "_self"; //required in FF, optional for Chrome;
            link.click();
        }
//End export CSV


        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {
            //console.log(progetto_id);
            var st = true;
            if (params.documentoTipo_id > 0) {
                st = false;
            }
            $mdDialog.show({
                controller: 'uploadDialogController4',
                controllerAs: 'vmdd',
                templateUrl: 'app/core/directives/sprardb-uploaddocuments4/sprardb-uploaddocumentsDialog4.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    authorizationB: authB,
                    params: params,
                    documentoTipos: vmd.documentoTipos,
                    sceglitipo: st
                }
            });
        }
        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }



        vmd.cancelladocumento = cancelladocumento;
        function cancelladocumento(did, dprogettoRendicontazione_id) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {
                api.documentos.remove.save({id: did, progettoRendicontazione_id: dprogettoRendicontazione_id}, function (d) {
                    if (d.id == did) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Files cancellato!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(function () {
                            $state.reload();
                        });
                    }
                });
            }, function () {
            });



        }

        /**
         * Initialize / Watch model changes
         */
        //$scope.$watch('ngModel', setSelectedColor);
    }

    function sprardbUploaddocuments4Directive($compile)
    {
        return {
            require: ['sprardbUploaddocuments4', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbUploaddocuments4Controller as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-uploaddocuments4/sprardb-uploaddocuments4.html',
            link: function (scope, element, attrs, controllers, transclude)
            {
//                console.log("scope into linker");
//                console.log(scope);
//                console.log("ele into linker");
//                console.log(element);
//                console.log("attrs into linker");
//                console.log(attrs);
//                console.log("transclude into linker");
//                console.log(transclude);
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;
                ctrl.loadDT();

//                transclude(scope, function (clone)
//                {
//                    clone = clone.filter(function (i, el)
//                    {
//                        return ( el.nodeType === 1 ) ? true : false;
//                    });
//
//                    if ( clone.length )
//                    {
//                        element.find('ms-color-picker-button').replaceWith(clone);
//                    }
//                });
            }
        };
//        console.log('-----directive upload');
//
//        var configUpload = function (uploadParams) {
//            var params = uploadParams;
//            params.ngFlowOptions = {
//                target: 'http://localhost/sprardb/app-server/web/documentos/upload',
//                chunkSize: 15 * 1024 * 1024,
//                maxChunkRetries: 1,
//                simultaneousUploads: 1,
//                testChunks: false,
//                progressCallbacksInterval: 1000,
//                headers: {'Authorization': 'Basic ' + params.api, 'X-Requested-With': 'XMLHttpRequest', },
//                query: params.parameters //{documentoTipo_id: 3, progetto_id: 30},
//            };
//            console.log(params.parameters);
//            params.ngFlow = {
//                flow: {}
//            };
//            return params;
//
//        };
//        var test = function ($mdToast) {
//            $mdToast.show(
//                    $mdToast.simple()
//                    .textContent('Dati salvati correttamente')
//                    .position('bottom right')
//                    .hideDelay(3000)
//                    )
//        }
//        var getButton = function () {
//            var template = '<div id="file" \n\
//                flow-init="vm.uploadParams.ngFlowOptions" \n\
//                flow-name="vm.uploadParams.ngFlow" \n\
//                flow-files-submitted="vm.uploadParams.upload()" \n\
//                >\n\
//                <md-button flow-btn \n\
//                    class="add-file-button md-fab md-warn" \n\
//                    aria-label="Add file" translate \n\
//                    translate-attr-aria-label="FM.ADD_FILE" ng-click="test()">\n\
//                    <md-icon md-font-icon="icon-plus"></md-icon>\n\
//                </md-button>\n\
//                </div>';
//            return template;
//
//        };
//
//
//        var linker = function (scope, element, attrs) {
//            console.log('---linker');
//            scope.vm.uploadParams = configUpload(scope.vm.uploadParams);
//            element.html(getButton()).show();
//            $compile(element.contents())(scope);
//        }
//        return {
//            restrict: "E",
//            link: linker,
//            scope: {
//                vm: '=',
//                uploadParams: '=',
//                action: '&'
//            }
//        };
    }


})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbUploaddocuments3Controller', sprardbUploaddocuments3Controller)
            .controller('uploadDialog3Controller', uploadDialog3Controller)
            .directive('sprardbUploaddocuments3', sprardbUploaddocuments3Directive);
    /** @ngInject */
    function uploadDialog3Controller(locals, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;
        vmdd.documentoTipos = locals.documentoTipos; //lista tipologie caricate
        vmdd.params = locals.params; //uploadParams
        vmdd.sceglitipo = locals.sceglitipo; //flag per scelta tipo documento
        //console.log(locals);
        vmdd.ngFlowOptions = {
            target: api.baseUrl + 'documentos/upload',
            chunkSize: 64 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            headers: {'Authorization': 'Basic ' + locals.authorizationB, 'X-Requested-With': 'XMLHttpRequest', },
            query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };

        // Methods
        vmdd.upload = upload;
        function upload()
        {
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
//            var uploadingFile = {
//                id       : file.uniqueIdentifier,
//                file     : file,
//                type     : '',
//                owner    : 'Emily Bennett',
//                size     : '',
//                modified : moment().format('MMMM D, YYYY'),
//                opened   : '',
//                created  : moment().format('MMMM D, YYYY'),
//                extention: '',
//                location : 'My Files > Documents',
//                offline  : false,
//                preview  : 'assets/images/etc/sample-file-preview.jpg'
//            };

            // Append it to the file list
//            vm.files.push(uploadingFile);
        }

        vmdd.fileSuccess = fileSuccess;
        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {


            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
//            angular.forEach(vm.files, function (item, index)
//            {
//                if ( item.id && item.id === file.uniqueIdentifier )
//                {
//                    // Normally you would update the file from
//                    // database but we are cheating here!
//
//                    // Update the file info
//                    item.name = file.file.name;
//                    item.type = 'document';
//
//                    // Figure out & upddate the size
//                    if ( file.file.size < 1024 )
//                    {
//                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
//                    }
//                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
//                    {
//                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
//                    }
//                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
//                    }
//                    else
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
//                    }
//                }
//            });
        }

        vmdd.inprogress = false;
        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            $rootScope.loadingProgress = true;
            vmdd.inprogress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            vmdd.inprogress = false;
            $rootScope.loadingProgress = false;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('File caricato correttamente!!')
                    .position('bottom right')
                    .hideDelay(3000)
                    ).then(function () {
                $mdDialog.hide();

            }
            );
        }
    }
    function sprardbUploaddocuments3Controller(api, $mdToast, $mdDialog, $state, ricerca) {
        var vmd = this;
        vmd.api = api;
        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documentos = [];
        vmd.baseUrl = api.baseUrl;


        vmd.loadDT = loadDT;
        function loadDT() {
            console.log("vmd.uploadCfg:", vmd.uploadCfg);
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "ordine"}, function (d) {
                vmd.cancellati = 1;
                vmd.documentoTipos = d.data;
                if (angular.isDefined(vmd.uploadCfg.entita_id) && vmd.uploadCfg.entita_id != null && vmd.uploadCfg.entita_id > 0) {
                    if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                        var searchpayload = {};
                        searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                        if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                            searchpayload[vmd.uploadCfg.entitakey2 + "_IN"] = vmd.uploadCfg.entita2_id + ",-1";
                        }
                        searchpayload.pagination = 10000;
                        searchpayload.expand = 'key';

                        api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                            vmd.documentos = d.data;
                        });
                    }
                }
            });

        }

        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {
            var st = true;
            if (params.documentoTipo_id > 0) {
                st = false;
            }
            $mdDialog.show({
                controller: 'uploadDialog3Controller',
                controllerAs: 'vmdd',
                templateUrl: 'app/core/directives/sprardb-uploaddocuments3/sprardb-uploaddocuments3Dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    authorizationB: authB,
                    params: params,
                    documentoTipos: vmd.documentoTipos,
                    sceglitipo: st
                }
            });
        }
        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }


        vmd.cancelladocumento = cancelladocumento;
        function cancelladocumento(did) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {
                api.hasdocumento[vmd.uploadCfg.entita].aggiorna({id: did, visibile: 0}, function (d) {
                    if (d.id == did) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('File cancellato!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(function () {
                            $state.reload();
                        });
                    }

                });

            }, function () {
            });



        }

        /**
         * Initialize / Watch model changes
         */
        //$scope.$watch('ngModel', setSelectedColor);
    }

    function sprardbUploaddocuments3Directive($compile)
    {
        return {
            require: ['sprardbUploaddocuments3', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbUploaddocuments3Controller as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-uploaddocuments3/sprardb-uploaddocuments3.html',
            link: function (scope, element, attrs, controllers, transclude)
            {

                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;
                ctrl.loadDT();


            }
        };

    }
})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbUploaddocuments2Controller', sprardbUploaddocuments2Controller)
            .directive('sprardbUploaddocuments2', sprardbUploaddocuments2Directive);
    /** @ngInject */

    function sprardbUploaddocuments2Controller($scope, api, $mdToast, fuseGenerator, $mdDialog) {
        var vmd = this;
        vmd.api = api;

        vmd.step1 = true;
        vmd.step2 = false;
        vmd.d = {};
        vmd.contatore = 0;


        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documentos = [];
        vmd.baseUrl = api.baseUrl;

        vmd.d.documentoTipos = [];
        vmd.d.params = {};
        vmd.d.sceglitipo = true;
        vmd.d.ngFlowOptions = {};
        vmd.d.ngFlow = {
            flow: {}
        };
        vmd.messageresult = "Files caricato correttamente!!";

        vmd.loadDT = loadDT;
        function loadDT() {
            //console.log("loadDT", vmd.uploadCfg);
            vmd.step1 = true;
            vmd.step2 = false;
            vmd.d = {};
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "tipo"}, function (d) {
                vmd.documentoTipos = d.data;
                vmd.d.documentoTipos = vmd.documentoTipos;
                vmd.d.params = vmd.uploadCfg;
                if (vmd.uploadCfg.documentoTipo_id > 0) {
                    vmd.d.sceglitipo = false;
                }
                vmd.d.ngFlowOptions = {
                    target: api.baseUrl + 'documentos/upload',
                    chunkSize: 15 * 1024 * 1024,
                    maxChunkRetries: 1,
                    simultaneousUploads: 1,
                    testChunks: false,
                    progressCallbacksInterval: 1000,
                    headers: {'Authorization': 'Basic ' + vmd.authb, 'X-Requested-With': 'XMLHttpRequest', },
                    query: vmd.d.params //{documentoTipo_id: 3, progetto_id: 30},
                };
                vmd.d.ngFlow = {
                    flow: {}
                };
                if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                    //console.log('cfg upload 2');


                    var searchpayload = {};
                    searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                    if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                        searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                    }
                    searchpayload.expand = 'key';

                    api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                        vmd.documentos = d.data;
                        vmd.uploadCfg.tuttidocumenti = d.data.length;
                        if (angular.isUndefined(d.data.length)) {
                            vmd.uploadCfg.tuttidocumenti = 0;
                        }
                        vmd.uploadCfg.caricato = vmd.contatore;
                        if (vmd.uploadCfg.mostratutti) {
                            vmd.uploadCfg.caricato = vmd.uploadCfg.tuttidocumenti;
                        }
                    });
                }
            });

        }
        vmd.reloadDT = reloadDT;
        function reloadDT() {

            vmd.step1 = true;
            vmd.step2 = false;
            vmd.messageresult = "Files caricato correttamente!!";

            console.log("reload: ", vmd.uploadCfg);
            if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                //console.log('cfg upload 2');
                //console.log(vmd.uploadCfg);
                var searchpayload = {};
                searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                    searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                }
                console.log("prima API!!!!!");
                api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                    console.log("dentro API!!!!!");
                    vmd.documentos = d.data;
                    vmd.uploadCfg.tuttidocumenti = d.data.length;
                    if (angular.isUndefined(d.data.length)) {
                        vmd.uploadCfg.tuttidocumenti = 0;
                    }
                    vmd.uploadCfg.caricato = vmd.contatore;
                    if (vmd.uploadCfg.mostratutti) {
                        vmd.uploadCfg.caricato = vmd.uploadCfg.tuttidocumenti;
                    }
                    console.log("reload2: ", vmd.uploadCfg);

                });
            }


        }

        //console.log(locals);



        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {

            vmd.step1 = false;
            vmd.step2 = true;

        }
        vmd.closeUpload = closeUpload;
        function closeUpload()
        {
            vmd.step1 = true;
            vmd.step2 = false;
        }


        vmd.d.closeDialog = closeDialog;
        function closeDialog()
        {
            vmd.step1 = true;
            vmd.step2 = false;
        }


        vmd.upload = upload;
        function upload()
        {
            console.log('upload');
            vmd.d.ngFlow.flow.upload();
        }

        vmd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            //console.log("FileAdded", file);
        }

        vmd.fileSuccess = fileSuccess;
        function fileSuccess(file, message)
        {

//            console.log('File Sucess');
//            console.log("File", file);
//            console.log("Message", message);
        }

        vmd.fileError = fileError;
        function fileError(file, message, flow)
        {
            var mess = angular.fromJson(message);
            vmd.messageresult = mess.message;
            console.log('File Error');
            console.log("File", file);
            console.log("Message", mess);
            console.log("Flow", flow);
        }

        vmd.uploadComplete = uploadComplete;
        function uploadComplete() {

            $mdToast.show(
                    $mdToast.simple()
                    .textContent(vmd.messageresult)
                    .position('bottom right')
                    .hideDelay(3000)
                    ).then(function () {
                //vmd.uploadCfg.caricato = vmd.uploadCfg.caricato + 1;
                //vmd.uploadCfg.contatore = vmd.uploadCfg.contatore + 1;
                vmd.contatore = vmd.contatore + 1;
                reloadDT();
            }
            );
            ;
        }



        /**
         * Initialize / Watch model changes
         */
        //$scope.$watch('ngModel', setSelectedColor);
    }

    function sprardbUploaddocuments2Directive($compile)
    {
        return {
            require: ['sprardbUploaddocuments2', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbUploaddocuments2Controller as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-uploaddocuments2/sprardb-uploaddocuments2.html',
            link: function (scope, element, attrs, controllers, transclude)
            {
//                console.log("scope into linker");
//                console.log(scope);
//                console.log("ele into linker");
//                console.log(element);
//                console.log("attrs into linker");
//                console.log(attrs);
//                console.log("transclude into linker");
//                console.log(transclude);
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;
                //console.log("leggo Model", scope.ngModel);

                ctrl.loadDT();

            }
        };

    }
})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbUploaddocumentsController', sprardbUploaddocumentsController)
            .controller('uploadDialogController', uploadDialogController)
            .directive('sprardbUploaddocuments', sprardbUploaddocumentsDirective);
    /** @ngInject */
    function uploadDialogController(locals, api, $mdDialog, $mdToast, $state, $rootScope) {
        var vmdd = this;
        vmdd.documentoTipos = locals.documentoTipos;
        vmdd.params = locals.params;
        vmdd.sceglitipo = locals.sceglitipo;
        //console.log(locals);
        vmdd.ngFlowOptions = {
            target: api.baseUrl + 'documentos/upload',
            chunkSize: 64 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            headers: {'Authorization': 'Basic ' + locals.authB, 'X-Requested-With': 'XMLHttpRequest', },
            query: vmdd.params //{documentoTipo_id: 3, progetto_id: 30},
        };
        vmdd.ngFlow = {
            flow: {}
        };

        // Methods
        vmdd.upload = upload;
        function upload()
        {
            vmdd.ngFlow.flow.upload();
        }
        vmdd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }

        vmdd.fileAdded = fileAdded;
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
//            var uploadingFile = {
//                id       : file.uniqueIdentifier,
//                file     : file,
//                type     : '',
//                owner    : 'Emily Bennett',
//                size     : '',
//                modified : moment().format('MMMM D, YYYY'),
//                opened   : '',
//                created  : moment().format('MMMM D, YYYY'),
//                extention: '',
//                location : 'My Files > Documents',
//                offline  : false,
//                preview  : 'assets/images/etc/sample-file-preview.jpg'
//            };

            // Append it to the file list
//            vm.files.push(uploadingFile);
        }

        vmdd.fileSuccess = fileSuccess;
        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {


            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
//            angular.forEach(vm.files, function (item, index)
//            {
//                if ( item.id && item.id === file.uniqueIdentifier )
//                {
//                    // Normally you would update the file from
//                    // database but we are cheating here!
//
//                    // Update the file info
//                    item.name = file.file.name;
//                    item.type = 'document';
//
//                    // Figure out & upddate the size
//                    if ( file.file.size < 1024 )
//                    {
//                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
//                    }
//                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
//                    {
//                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
//                    }
//                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
//                    }
//                    else
//                    {
//                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
//                    }
//                }
//            });
        }

        vmdd.inprogress = false;
        vmdd.fileprogress = fileprogress;
        function fileprogress() {
            $rootScope.loadingProgress = true;
            vmdd.inprogress = true;
        }

        vmdd.uploadComplete = uploadComplete;
        function uploadComplete() {
            vmdd.inprogress = false;
            $rootScope.loadingProgress = false;
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Files caricato correttamente!!')
                    .position('bottom right')
                    .hideDelay(3000)
                    ).then(function () {
                $mdDialog.hide();
                $state.reload();
            }
            );
            ;
        }
    }
    function sprardbUploaddocumentsController($scope, api, $mdToast, fuseGenerator, $mdDialog, $state) {
        var vmd = this;
        //console.log(vmd);
        //vmd.uploadCfg
        //Esempio configurazione
//        vm.uploadParams = {
//            documentoTipo_id: 0,
//            gruppo: 'PROGETTO',
//            dettaglio: true,
//            entita: 'progetto',
//            entitakey: 'progetto_id'
//            entita_id: valore,
//            {{nome entita}} es progetto_id: valore
//        };


        vmd.authb = api.authorizationB;
        vmd.documentoTipos = [];
        vmd.documentos = [];
        vmd.baseUrl = api.baseUrl;

        vmd.loadDT = loadDT;
        function loadDT() {
            //console.log(vmd.uploadCfg);
            api.documentotipos.documentotipo.search({gruppo: vmd.uploadCfg.gruppo, sort: "ordine"}, function (d) {
                vmd.documentoTipos = d.data;
                if (vmd.uploadCfg.dettaglio || vmd.uploadCfg.dettagliomin) {
                    var searchpayload = {};
                    searchpayload[vmd.uploadCfg.entitakey] = vmd.uploadCfg.entita_id;
                    if (!angular.isUndefined(vmd.uploadCfg.entitakey2)) {
                        searchpayload[vmd.uploadCfg.entitakey2] = vmd.uploadCfg.entita2_id;
                    }
                    console.log(searchpayload);
                    searchpayload.pagination = 8000;
                    api.hasdocumento[vmd.uploadCfg.entita].search(searchpayload, function (d) {
                        vmd.documentos = d.data;
                    });
                }
            });

        }

        vmd.openUpload = openUpload;
        function openUpload(ev, authB, params) {
            //console.log(progetto_id);
            var st = true;
            if (params.documentoTipo_id > 0) {
                st = false;
            }
            $mdDialog.show({
                controller: 'uploadDialogController',
                controllerAs: 'vmdd',
                templateUrl: 'app/core/directives/sprardb-uploaddocuments/sprardb-uploaddocumentsDialog.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    authorizationB: authB,
                    params: params,
                    documentoTipos: vmd.documentoTipos,
                    sceglitipo: st
                }
            });
        }
        vmd.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide();
        }


        vmd.cancelladocumento = cancelladocumento;
        function cancelladocumento(did, dprogettoRendicontazione_id) {
            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler cancellare?')
                    .htmlContent('Il documento sarà cancellato. L\'operazione è irreversibile.')
                    .ariaLabel('cancella doc')
                    .ok('OK')
                    .cancel('ABBANDONA');

            $mdDialog.show(confirm).then(function ()
            {
                api.documentos.remove.save({id: did, progettoRendicontazione_id: dprogettoRendicontazione_id}, function (d) {
                    if (d.id == did) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Files cancellato!!')
                                .position('bottom right')
                                .hideDelay(3000)
                                ).then(function () {
                            $state.reload();
                        });
                    }
                });
            }, function () {
            });



        }

        /**
         * Initialize / Watch model changes
         */
        //$scope.$watch('ngModel', setSelectedColor);
    }

    function sprardbUploaddocumentsDirective($compile)
    {
        return {
            require: ['sprardbUploaddocuments', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbUploaddocumentsController as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-uploaddocuments/sprardb-uploaddocuments.html',
            link: function (scope, element, attrs, controllers, transclude)
            {
//                console.log("scope into linker");
//                console.log(scope);
//                console.log("ele into linker");
//                console.log(element);
//                console.log("attrs into linker");
//                console.log(attrs);
//                console.log("transclude into linker");
//                console.log(transclude);
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.uploadCfg = scope.ngModel;
                ctrl.loadDT();

//                transclude(scope, function (clone)
//                {
//                    clone = clone.filter(function (i, el)
//                    {
//                        return ( el.nodeType === 1 ) ? true : false;
//                    });
//
//                    if ( clone.length )
//                    {
//                        element.find('ms-color-picker-button').replaceWith(clone);
//                    }
//                });
            }
        };
//        console.log('-----directive upload');
//
//        var configUpload = function (uploadParams) {
//            var params = uploadParams;
//            params.ngFlowOptions = {
//                target: 'http://localhost/sprardb/app-server/web/documentos/upload',
//                chunkSize: 15 * 1024 * 1024,
//                maxChunkRetries: 1,
//                simultaneousUploads: 1,
//                testChunks: false,
//                progressCallbacksInterval: 1000,
//                headers: {'Authorization': 'Basic ' + params.api, 'X-Requested-With': 'XMLHttpRequest', },
//                query: params.parameters //{documentoTipo_id: 3, progetto_id: 30},
//            };
//            console.log(params.parameters);
//            params.ngFlow = {
//                flow: {}
//            };
//            return params;
//
//        };
//        var test = function ($mdToast) {
//            $mdToast.show(
//                    $mdToast.simple()
//                    .textContent('Dati salvati correttamente')
//                    .position('bottom right')
//                    .hideDelay(3000)
//                    )
//        }
//        var getButton = function () {
//            var template = '<div id="file" \n\
//                flow-init="vm.uploadParams.ngFlowOptions" \n\
//                flow-name="vm.uploadParams.ngFlow" \n\
//                flow-files-submitted="vm.uploadParams.upload()" \n\
//                >\n\
//                <md-button flow-btn \n\
//                    class="add-file-button md-fab md-warn" \n\
//                    aria-label="Add file" translate \n\
//                    translate-attr-aria-label="FM.ADD_FILE" ng-click="test()">\n\
//                    <md-icon md-font-icon="icon-plus"></md-icon>\n\
//                </md-button>\n\
//                </div>';
//            return template;
//
//        };
//
//
//        var linker = function (scope, element, attrs) {
//            console.log('---linker');
//            scope.vm.uploadParams = configUpload(scope.vm.uploadParams);
//            element.html(getButton()).show();
//            $compile(element.contents())(scope);
//        }
//        return {
//            restrict: "E",
//            link: linker,
//            scope: {
//                vm: '=',
//                uploadParams: '=',
//                action: '&'
//            }
//        };
    }
})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbTabellasController', sprardbTabellasController)
            .directive('sprardbTabellas', sprardbTabellasDirective);
    /** @ngInject */

    function sprardbTabellasController($scope, api, $mdToast, eventi, ricerca, $state, $filter) {
        var vmd = this;
        //vmd.items -> ngModel 
        vmd.options = ricerca.options;
        vmd.selected = ricerca.selected;
        vmd.limitOptions = ricerca.limitOptions;
        vmd.allsearchs = ricerca.begin_allsearchs();
        vmd.query = {
            sort: '-id',
            perPage: 15,
            page: 1
        };
        vmd.colors = eventi.colors2;
        vmd.icons = eventi.icons;
        vmd.today = new Date();
        vmd.work = eventi.work;
        vmd.viewEvento = eventi.viewDetails;
        vmd.eventoTipo = {};
        vmd.entita1 = "";
        vmd.entita2 = "";


        vmd.initTabellar = initTabellar;
        function initTabellar() {
            vmd.items = $scope.ngModel;
            vmd.attrs.struttura = JSON.parse(vmd.attrs.struttura);
            console.log("vmd.attrs.struttura", vmd.attrs.struttura);

        }
        vmd.reloadTabellar = reloadTabellar;
        function reloadTabellar() {
            vmd.items = $scope.ngModel;
            vmd.attrs.struttura = JSON.parse(vmd.attrs.struttura);
            console.log("vmd.attrs.struttura", vmd.attrs.struttura);

            console.log("vmd.items", vmd.items);

        }

    }

    function sprardbTabellasDirective($compile)
    {
        console.log("tabellas");
        return {
            require: ['sprardbTabellas', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbTabellasController as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-tabellas/sprardb-tabellas.html',
            link: function (scope, element, attrs, controllers, transclude)
            {


                var ctrl = controllers[0];
                ctrl.modelCtrl = controllers[1];
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.items = scope.ngModel;
                ctrl.attrs = attrs;
                console.log("attrs", attrs);
                console.log("scope", scope);
                ctrl.initTabellar();
            }
        };
    }
})();



(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbTabellarController', sprardbTabellarController)
            .directive('sprardbTabellar', sprardbTabellarDirective);
    /** @ngInject */

    function sprardbTabellarController($scope, api,$mdDialog, $mdToast, eventi, ricerca, $state, $filter, acl) {
        var vmd = this;
        vmd.api = api;
        vmd.isAdmin = vmd.api.isAdmin;
        console.log(api);
        //vmd.items -> ngModel 
        vmd.options = ricerca.options;
        vmd.selected = ricerca.selected;
        vmd.limitOptions = ricerca.limitOptions;
        vmd.allsearchs = ricerca.begin_allsearchs();
        vmd.query = {
            sort: '-id',
            perPage: 15,
            page: 1
        };
        vmd.colors = eventi.colors2;
        vmd.icons = eventi.icons;
        vmd.today = new Date();
        vmd.work = eventi.work;
        vmd.viewEvento = eventi.viewDetails;
        vmd.eventoTipo = {};
        vmd.entita1 = "";
        vmd.entita2 = "";

        vmd.isallowed = acl.isallowed2;

        vmd.uscitaBeneficiarioCorrotto = function (event, eventoid) {
            var confirmDialog = $mdDialog.confirm()
                .title('Conferma ripetizione Uscita Beneficiario')
                .htmlContent("Sicuro di volere ripetere il processo di uscita per questo beneficiario?")
                .ok('CONFERMA')
                .cancel('ABBANDONA');
        
            $mdDialog.show(confirmDialog).then(function () {
                // Chiamata alla funzione del backend per ripetere l'uscita problematica
                api.beneficiariomc.ripetiUscita({ id: eventoid }, function (res) {
                    if (res) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Ripetizione Uscita Beneficiario Avvenuta Con Successo.')
                                .position('bottom right')
                                .hideDelay(3000)
                        ).then(function () {
                            $state.reload();
                        });
                    } else {
                        console.error('Errore nella ripetizione dell\'uscita del beneficiario.');
                    }
                }, function (error) {
                    console.error('Errore nella chiamata API: ', error);
                });
            });
        };
        
        



        vmd.initTabellar = initTabellar;
        function initTabellar() {
            vmd.items = $scope.ngModel;
            if (vmd.items.length > 0) {
                vmd.eventoTipo = vmd.items[0].eventoTipo;
                vmd.entita1 = $filter('limitTo')(vmd.eventoTipo.model1, 20, 11).toLowerCase();
                vmd.entita2 = $filter('limitTo')(vmd.eventoTipo.model2, 20, 11).toLowerCase();
            }
        }
        vmd.reloadTabellar = reloadTabellar;
        function reloadTabellar() {
            vmd.items = $scope.ngModel;
            if (vmd.items.length > 0) {
                vmd.eventoTipo = vmd.items[0].eventoTipo;
                vmd.entita1 = $filter('limitTo')(vmd.eventoTipo.model1, 20, 11).toLowerCase();
                vmd.entita2 = $filter('limitTo')(vmd.eventoTipo.model2, 20, 11).toLowerCase();
            }
            console.log("vmd.items", vmd.items);

        }

    }

    function sprardbTabellarDirective($compile)
    {
        return {
            require: ['sprardbTabellar', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbTabellarController as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-tabellar/sprardb-tabellar.html',
            link: function (scope, element, attrs, controllers, transclude)
            {


                var ctrl = controllers[0];
                ctrl.modelCtrl = controllers[1];
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.items = scope.ngModel;
                ctrl.attrs = attrs;
                //console.log("attrs", attrs);
                ctrl.initTabellar();
            }
        };
    }
})();



(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbProcessController', sprardbProcessController)
            .directive('sprardbProcess', sprardbProcessDirective)
            .filter('filterByArray', filterByArray);
    /** @ngInject */

    function filterByArray($filter) {
        return function (list, arrayFilter, element) {

            if (arrayFilter.length === 0) {
                return list;
            }
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    return arrayFilter.indexOf(listItem[element]) != -1;
                });
            }
        };
    }

    function sprardbProcessController($scope, api, $mdToast, fuseGenerator, $mdDialog, eventi, acl) {
        var vmd = this;
        console.log("controller");
        vmd.evs = "eventos"
        vmd.evsearch = "";
        vmd.selected = [];
        vmd.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vmd.query = {
            sort: '-id',
            perPage: 20,
            page: 1
        };
        vmd.limitOptions = [5, 10, 15, 20];
        vmd.allFields = true;

        vmd.viewEvento = eventi.viewDetails;
        vmd.letteraVisita = eventi.letteraVisita;
        vmd.work = eventi.work;
        vmd.colors = eventi.colors;
        vmd.scolors = eventi.scolors;
        vmd.colors = eventi.colors2;
        vmd.icons = eventi.icons;
        vmd.today = new Date();

        vmd.isallowed = acl.isallowed2;

        vmd.activeFilter = {};
        vmd.activeFilter.tipo = [];
        vmd.activeFilter.stato = [];
        vmd.toggleFilter = function (datas, tipo) {
            //console.log(datas);
            //console.log(tipo);
            angular.forEach(datas, function (data) {
                var found = vmd.activeFilter[tipo].indexOf(data);

                if (found >= 0) {
                    vmd.activeFilter[tipo].splice(found, 1);
                } else {
                    vmd.activeFilter[tipo].push(data);
                }
            });
        };

        vmd.reload = reload;
        function reload() {
            vmd.items = $scope.ngModel;
            console.log(vmd.items);
            vmd.filters = $scope.filters;
            vmd.newprocess = $scope.newprocess;
            vmd.titolo = $scope.titolo;
            vmd.evs = "eventos"
            if (angular.isDefined($scope.evs)) {
                vmd.evs = $scope.evs;
            }

        }
    }

    function sprardbProcessDirective($compile)
    {
        return {
            require: ['sprardbProcess', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                filters: '=',
                newprocess: '=',
                titolo: '=',
                msModelType: '@?'
            },
            controller: 'sprardbProcessController as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-process/sprardb-process.html',
            link: function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];
                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.items = scope.ngModel;
                ctrl.filters = scope.filters;
                ctrl.newprocess = scope.newprocess;
                ctrl.titolo = scope.titolo;
                ctrl.evs = scope.evs;
                //ctrl.loadDT();
            }
        };
    }
})();


(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbNewprocess2Controller', sprardbNewprocess2Controller)
            .directive('sprardbNewprocess2', sprardbNewprocess2Directive);
    /** @ngInject */

    function sprardbNewprocess2Controller($scope, api, $mdToast, fuseGenerator, $mdDialog, eventi, $state) {
        var vmd = this;
        vmd.evsearch = "";
        //vmd.items -> ngModel = vm.{{entita}}.eventos
        vmd.eventoTipos = [];
        vmd.loadEventos = loadEventos;
        function loadEventos() {
            //console.log("vmd.items.eventoFiltro", vmd.items.eventoFiltro);
            api.eventos.tipo.search(vmd.items.eventoFiltro, function (d) {
                vmd.eventoTipos = d.data;
            });
        }

        vmd.updates = updates;
        function updates() {
            //console.log("updates");
            vmd.items = $scope.ngModel;
            api.eventos.tipo.search(vmd.items.eventoFiltro, function (d) {
                vmd.eventoTipos = d.data;
            });
        }

        vmd.newwork = newwork;
        function newwork(itemEventoTipo) {
            var stato = 4;
            var item = {};
            item.eventoTipo = itemEventoTipo;
            if (angular.isUndefined(itemEventoTipo)) {
                item.eventoTipo = vmd.eventoTipo;
            }
            console.log("newwork item.eventoTipo:", item.eventoTipo);
            var statip = item.eventoTipo.statiPossibili.split(",");
            stato = statip[1];
            var payload = {};
            payload.self = {};
            payload.self.entita1_id = [vmd.items.entita1_id];
            payload.self.entita2_id = [vmd.items.entita2_id];
            payload.self.eventoTipo_id = item.eventoTipo.id;
            //payload.self.eventoStato_id = stato;
            payload.isnew = true;
            payload.parent = {};
            payload.extra = {};
            payload.eventoTipo_id = item.eventoTipo.id;
            payload.entita1_id = vmd.items.entita1_id;
            var oggi = new Date();
            payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
            var extrasetup = JSON.parse(item.eventoTipo.extra);
            var openpopup = angular.isDefined(extrasetup.properties[stato]);


            api.processi.processo.lavora(payload, function (response) {
                if (response.status == 200) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Processo inserito correttamente!!')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    if (openpopup) {
                        //item.id = response.id;
                        api.eventos.evento.get({id: response.id}, function (r) {
                            var newitem = r;
                            //apri popoup per lavorazione
                            eventi.work("completa", newitem, stato, "completa", false);
                        });



                    } else {
                        $state.reload();
                    }
                }
            });





        }


        vmd.selected = [];
        vmd.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vmd.query = {
            sort: '-id',
            perPage: 5,
            page: 1
        };
        vmd.limitOptions = [5, 10, 15, 20];
        vmd.allFields = true;
        vmd.colors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg', 'md-orange-800-bg'];
        vmd.icons = ['icon-drag', 'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close', 'icon-exclamation'];
        vmd.today = new Date();
    }

    function sprardbNewprocess2Directive($compile)
    {
        return {
            require: ['sprardbNewprocess2', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbNewprocess2Controller as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-newprocess2/sprardb-newprocess2.html',
            link: function (scope, element, attrs, controllers, transclude)
            {

                var ctrl = controllers[0];
                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.items = scope.ngModel;
                //console.log("new process ngModel", scope.ngModel);
                ctrl.loadEventos();
            }
        };
    }
})();


(function ()
{
    'use strict';
    angular
            .module('app.core')
            .controller('sprardbNewprocessController', sprardbNewprocessController)
            .directive('sprardbNewprocess', sprardbNewprocessDirective);
    /** @ngInject */

    function sprardbNewprocessController($scope, api, $mdToast, fuseGenerator, $mdDialog, eventi, $state) {
        var vmd = this;
        console.log(vmd);
        vmd.evsearch = "";
        //vmd.items -> ngModel = vm.{{entita}}.eventos
        vmd.eventoTipos = [];
        vmd.loadEventos = loadEventos;
        vmd.disabled = false;
        function loadEventos() {
            //console.log("vmd.items.eventoFiltro", vmd.items.eventoFiltro);
            api.eventos.tipo.search(vmd.items.eventoFiltro, function (d) {
                vmd.eventoTipos = d.data;
            });
        }

        vmd.updates = updates;
        function updates() {
            vmd.items = $scope.ngModel;
            api.eventos.tipo.search(vmd.items.eventoFiltro, function (d) {
                vmd.eventoTipos = d.data;
            });
        }

        vmd.newwork = newwork;
        function newwork(itemEventoTipo) {
            vmd.disabled = true;
            var stato = 4;
            var item = {};
            item.eventoTipo = itemEventoTipo;
            if (angular.isUndefined(itemEventoTipo)) {
                item.eventoTipo = vmd.eventoTipo;
            }
            console.log("newwork item.eventoTipo:", item.eventoTipo);
            var statip = item.eventoTipo.statiPossibili.split(",");
            stato = statip[1];
            var payload = {};
            payload.self = {};
            payload.self.entita1_id = [vmd.items.entita1_id];
            payload.self.entita2_id = [vmd.items.entita2_id];
            payload.self.eventoTipo_id = item.eventoTipo.id;
            //payload.self.eventoStato_id = stato;
            payload.isnew = true;
            payload.parent = {};
            payload.extra = {};
            payload.eventoTipo_id = item.eventoTipo.id;
            payload.entita1_id = vmd.items.entita1_id;
            var oggi = new Date();
            payload.self.dataFine = moment(oggi).format("YYYY-MM-DD");
            var extrasetup = JSON.parse(item.eventoTipo.extra);
            var openpopup = angular.isDefined(extrasetup.properties[stato]);


            api.processi.processo.lavora(payload, function (response) {
                if (response.status == 200) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Processo inserito correttamente!!')
                            .position('bottom right')
                            .hideDelay(3000)
                            );
                    if (openpopup) {
                        //item.id = response.id;
                        api.eventos.evento.get({id: response.id}, function (r) {
                            var newitem = r;
                            //apri popoup per lavorazione
                            eventi.work("completa", newitem, stato, "completa", false);
                        });



                    } else {
                        $state.reload();
                    }
                }
            });





        }


        vmd.selected = [];
        vmd.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        vmd.query = {
            sort: '-id',
            perPage: 5,
            page: 1
        };
        vmd.limitOptions = [5, 10, 15, 20];
        vmd.allFields = true;
        vmd.colors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg', 'md-orange-800-bg'];
        vmd.icons = ['icon-drag', 'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close', 'icon-exclamation'];
        vmd.today = new Date();
    }

    function sprardbNewprocessDirective($compile)
    {
        return {
            require: ['sprardbNewprocess', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'sprardbNewprocessController as vmd',
            transclude: true,
            templateUrl: 'app/core/directives/sprardb-newprocess/sprardb-newprocess.html',
            link: function (scope, element, attrs, controllers, transclude)
            {

                var ctrl = controllers[0];
                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];
                //console.log(ctrl.modelCtrl);
                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';
                ctrl.items = scope.ngModel;
                //console.log("new process ngModel", scope.ngModel);
                ctrl.loadEventos();
            }
        };
    }
})();


(function ()
{
  'use strict';
  angular
    .module('app.core')
    .directive('sprardbJsonform4', sprardbJsonformDirective);
  /** @ngInject */
  function sprardbJsonformDirective($compile)
  {

    var getTemplate = function (schema, scope) {
//            console.log('--schema');
      var template = '';
      angular.forEach(schema, function (obj) {
//                console.log('---oggetto form');
        var validationmessage = 'Campo richiesto';
        var required = '';
        var valore = '';
        var multiple = '';
        var novalore = '';
        var pattern = '';
        var mini = 0;
        var debounce = '';
        var defaultstyle = ' style="margin-top:24px;" ';
        var mdmaxdate = '';
        var mdmindate = '';
        var disabled = '';
        var ngif = '';

        if (!angular.isUndefined(obj.validationMessage)) {
          validationmessage = obj.validationMessage;
        }
        if (angular.isDefined(obj.debounce)) {
          debounce = ' ng-model-options="{debounce: ' + obj.debounce + '}" ';
        }
        if (angular.isDefined(obj.style)) {
          defaultstyle = ' style="' + obj.style + '" ';
        }
        if (angular.isDefined(obj.required)) {
          //required = 'required';
          required = ' ng-required = "' + obj.required + '" ';
          mini = 1;
        }
        if (angular.isDefined(obj.ngif)) {
          ngif = ' ng-if = "' + obj.ngif + '" ';
        }
        if (!angular.isUndefined(obj.data)) {
          if (angular.isArray(obj.data)) {
            scope.vm.data[obj.dbfield] = obj.data;
            obj.data = "vm.data['" + obj.dbfield + "']";
          }
        }
        //console.log("obj.data");
        //console.log(obj.data);
        if (!angular.isUndefined(obj.valore)) {
          var minheigth = 0;
          //obj.valore = JSON.parse(obj.valore);
          if (angular.isArray(obj.valore)) {
//                        console.log('array');
            minheigth = 24 * obj.valore.length;
            valore = '<div layout="column" style="min-height:' + minheigth + 'px;">';
            var iii = 0;
            angular.forEach(obj.valore, function (v) {
              if (iii === 0) {
                valore += '<span><b style="text-transform: uppercase;">{{item.' + v + '}}</b></span>';
              } else {
                valore += '<span><small><small style="text-transform: uppercase;">' + v + ': {{item.' + v + '}}</small></small></span>';
              }
              iii++;
            });
            valore += '</div>';
          } else {
            valore = '<small><b style="text-transform: uppercase;">{{item.' + obj.valore + '}}</b></small>';
          }
        }
        if (!angular.isUndefined(obj.multiple)) {
          if (obj.multiple) {
            multiple = 'multiple';
          }
        }
        if (!angular.isUndefined(obj.novalore)) {
          novalore = '<md-option value="' + obj.novalore + '">Nessuno</md-option>';
        }
        if (!angular.isUndefined(obj.pattern)) {
          pattern = ' ng-pattern="' + obj.pattern + '" ';
        }
        if (angular.isDefined(obj.mdmaxdate)) {
          mdmaxdate = ' md-max-date="' + obj.mdmaxdate + '" ';
        }
        if (angular.isDefined(obj.mdmindate)) {
          mdmindate = ' md-min-date="' + obj.mdmindate + '" ';
        }
        if (angular.isDefined(obj.disabled)) {
          //disabled = ' ng-disabled = "true" ';
          disabled = ' ng-disabled = "' + obj.disabled + '" ';
        }

        switch (obj.formtype) {
          case 'textarea':

            template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + '>\n\
                            <md-input-container flex>\n\
                                <label>' + obj.title + '</label>\n\
                                <textarea name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '" aria-label="' + obj.description + '" ' + required + ' rows="3" ng-change="' + obj.onchange + '" ' + disabled + ' ></textarea>\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
            break;
          case 'text':
            template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + ' >\n\
                        <md-input-container flex>\n\
                            <label>' + obj.title + '</label>\n\
                            <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '"  ' + required + ' ' + pattern + ' ng-change="' + obj.onchange + '" ' + debounce + ' ' + disabled + ' >\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                            <div ng-message="pattern"><span>Formato invalido</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
            break;
          case 'textNR':
            template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + ' >\n\
                        <md-input-container flex>\n\
                            <label>' + obj.title + '</label>\n\
                            <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '"  ' + required + ' ' + pattern + ' ng-change="' + obj.onchange + '" ' + debounce + ' ' + disabled + ' >\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
            break;
          case 'select':
            template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row">\n\
                            <md-input-container flex>\n\
                                <md-select-label>' + obj.title + '</md-select-label>\n\
                                <md-select ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" ng-change="' + obj.onchange + '" placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ' + required + ' ' + multiple + '  ' + disabled + '  >\n\
                                    ' + novalore + '\n\
                                    <md-option class="small" ng-repeat="item in ' + obj.data + '" ng-value="item.' + obj.chiave + '"  style="min-height:' + minheigth + 'px;">' + valore + '</md-option>\n\
                                </md-select>\n\
                                <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                                    <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                                </div>\n\
                            </md-input-container>\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
          case 'datepicker':
            template += '\n\
                        <div layout="column" flex ' + ngif + '>\n\
                        <div layout="row" flex class="datepicker-container">\n\
                            <div flex="50" class="margin-top-8 text-right">\n\
                                <small><b>' + obj.title + '</b></small>\n\
                            </div>\n\
                            <div flex="50" class="margin-left-32">\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
          case 'datepickerv':
            template += '\n\
                        <div layout="column" flex style="margin-bottom:16px;" class="datepicker-container" ' + ngif + '>\n\
                            <label flex >\n\
                                ' + obj.title + '\n\
                            </label>\n\
                            <div flex >\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        ';
            break;
          case 'checkbox':
            template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                            <md-checkbox ng-checked="' + obj.data + '" ng-click="' + obj.onchange + '" aria-label="' + obj.dbfield + '" name="' + obj.dbfield + '" ng-required="' + obj.required + '" style="margin-top: 16px;margin-right:4px;" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\'] "></md-checkbox>\n\
                            <div flex="75" class="padding-top-16">\n\
                                <span >' + obj.description + '</span>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
          case 'hidden':
            template += '\n\
                        <input type="hidden" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" value="' + obj.valore + '" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" ' + ngif + '/>\n\
                        ';
            break;
          case 'label':
            template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                                ' + obj.description + '\n\
                        </div>\n\
                        <div class="row" flex ng-bind-html="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" >\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
          case 'upload':
            //console.log(obj.data);
            //console.log('vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore);
            scope.vm.buildUP(obj.data);
            template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" value="{{vm.uploadParams.caricato}}" min="' + mini + '" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" />\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
          case 'uploadmindynamic':
            scope.vm.buildUP(obj.data);
            template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" ng-value="vm.uploadParams.caricato" ng-min="vm.uploadParams.mincaricato" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '"/>\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
            break;
        }
      });
      return template;
    }
    var linker = function (scope, element, attrs) {
//            console.log('---linker');
      element.html(getTemplate(scope.formschema, scope)).show();
      $compile(element.contents())(scope);


    }
    return {
      restrict: "E",
      link: linker,
      scope: {
        vm: '=',
        formschema: '=',
        action: '&'
      }
    };
  }
})();

(function ()
{
    'use strict';
    angular
            .module('app.core')
            .directive('sprardbJsonform3', sprardbJsonform3Directive);
    /** @ngInject */
    function sprardbJsonform3Directive($compile)
    {

        console.log('-----directive sprardbjsonform3');
        var getTemplate = function (schema, scope) {
//            console.log('--schema');
            var template = '';
            angular.forEach(schema, function (obj) {
//                console.log('---oggetto form');
                var validationmessage = 'Campo richiesto';
                var required = '';
                var valore = '';
                var multiple = '';
                var novalore = '';
                var pattern = '';
                var mini = 0;
                var debounce = '';
                var defaultstyle = ' style="margin-top:24px;" ';
                var mdmaxdate = '';
                var mdmindate = '';
                var disabled = '';
                var ngif = '';

                if (!angular.isUndefined(obj.validationMessage)) {
                    validationmessage = obj.validationMessage;
                }
                if (angular.isDefined(obj.debounce)) {
                    debounce = ' ng-model-options="{debounce: ' + obj.debounce + '}" ';
                }
                if (angular.isDefined(obj.style)) {
                    defaultstyle = ' style="' + obj.style + '" ';
                }
                if (angular.isDefined(obj.required)) {
                    //required = 'required';
                    required = ' ng-required = "' + obj.required + '" ';
                    mini = 1;
                }
                if (angular.isDefined(obj.ngif)) {
                    ngif = ' ng-if = "' + obj.ngif + '" ';
                }
                if (!angular.isUndefined(obj.data)) {
                    if (angular.isArray(obj.data)) {
                        scope.vm.data[obj.dbfield] = obj.data;
                        obj.data = "vm.data['" + obj.dbfield + "']";
                    }
                }
                //console.log("obj.data");
                //console.log(obj.data);
                if (!angular.isUndefined(obj.valore)) {
                    var minheigth = 0;
                    //obj.valore = JSON.parse(obj.valore);
                    if (angular.isArray(obj.valore)) {
//                        console.log('array');
                        minheigth = 24 * obj.valore.length;
                        valore = '<div layout="column" style="min-height:' + minheigth + 'px;">';
                        var iii = 0;
                        angular.forEach(obj.valore, function (v) {
                            if (iii === 0) {
                                valore += '<span><b style="text-transform: uppercase;">{{item.' + v + '}}</b></span>';
                            } else {
                                valore += '<span><small><small style="text-transform: uppercase;">' + v + ': {{item.' + v + '}}</small></small></span>';
                            }
                            iii++;
                        });
                        valore += '</div>';
                    } else {
                        valore = '<small><b style="text-transform: uppercase;">{{item.' + obj.valore + '}}</b></small>';
                    }
                }
                if (!angular.isUndefined(obj.multiple)) {
                    if (obj.multiple) {
                        multiple = 'multiple';
                    }
                }
                if (!angular.isUndefined(obj.novalore)) {
                    novalore = '<md-option value="' + obj.novalore + '">Nessuno</md-option>';
                }
                if (!angular.isUndefined(obj.pattern)) {
                    pattern = ' ng-pattern="' + obj.pattern + '" ';
                }
                if (angular.isDefined(obj.mdmaxdate)) {
                    mdmaxdate = ' md-max-date="' + obj.mdmaxdate + '" ';
                }
                if (angular.isDefined(obj.mdmindate)) {
                    mdmindate = ' md-min-date="' + obj.mdmindate + '" ';
                }
                if (angular.isDefined(obj.disabled)) {
                    //disabled = ' ng-disabled = "true" ';
                    disabled = ' ng-disabled = "' + obj.disabled + '" ';
                }

                switch (obj.formtype) {
                    case 'textarea':

                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + '>\n\
                            <md-input-container flex>\n\
                                <label>' + obj.title + '</label>\n\
                                <textarea name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '" aria-label="' + obj.description + '" ' + required + ' rows="3" ng-change="' + obj.onchange + '" ' + disabled + ' ></textarea>\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
                        break;
                    case 'text':
                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + ' >\n\
                        <md-input-container flex>\n\
                            <label>' + obj.title + '</label>\n\
                            <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '"  ' + required + ' ' + pattern + ' ng-change="' + obj.onchange + '" ' + debounce + ' ' + disabled + ' >\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                            <div ng-message="pattern"><span>Formato invalido</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
                        break;
                    case 'select':
                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row">\n\
                            <md-input-container flex>\n\
                                <label>' + obj.title + '</label>\n\
                                <md-select ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" ng-change="' + obj.onchange + '" placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ' + required + ' ' + multiple + '  ' + disabled + '  >\n\
                                    ' + novalore + '\n\
                                    <md-option class="small" ng-repeat="item in ' + obj.data + '" ng-value="item.' + obj.chiave + '"  style="min-height:' + minheigth + 'px;">' + valore + '</md-option>\n\
                                </md-select>\n\
                                <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                                    <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                                </div>\n\
                            </md-input-container>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'datepicker':
                        template += '\n\
                        <div layout="column" flex ' + ngif + '>\n\
                        <div layout="row" flex class="datepicker-container">\n\
                            <div flex="50" class="margin-top-8 text-right">\n\
                                <small><b>' + obj.title + '</b></small>\n\
                            </div>\n\
                            <div flex="50" class="margin-left-32">\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + disabled + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'datepickerv':
                        template += '\n\
                        <div layout="column" flex style="margin-bottom:16px;" class="datepicker-container" ' + ngif + '>\n\
                            <label flex >\n\
                                ' + obj.title + '\n\
                            </label>\n\
                            <div flex >\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + disabled + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'checkbox':
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                            <md-checkbox ng-checked="' + obj.data + '" ng-click="' + obj.onchange + '" aria-label="' + obj.dbfield + '" name="' + obj.dbfield + '" ng-required="' + obj.required + '" style="margin-top: 16px;margin-right:4px;" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\'] "></md-checkbox>\n\
                            <div flex="75" class="padding-top-16">\n\
                                <span >' + obj.description + '</span>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'hidden':
                        template += '\n\
                        <input type="hidden" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" value="' + obj.valore + '" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" ' + ngif + '/>\n\
                        ';
                        break;
                    case 'label':
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                                ' + obj.description + '\n\
                        </div>\n\
                        <div class="row" flex ng-bind-html="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" >\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'upload':
                        //console.log(obj.data);
                        //console.log('vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore);
                        scope.vm.buildUP(obj.data);
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" value="{{vm.uploadParams.caricato}}" min="' + mini + '" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" />\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'uploadmindynamic':
                        scope.vm.buildUP(obj.data);
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" ng-value="vm.uploadParams.caricato" ng-min="vm.uploadParams.mincaricato" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '"/>\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                }
            });
            return template;
        }
        var linker = function (scope, element, attrs) {
//            console.log('---linker');
            element.html(getTemplate(scope.formschema, scope)).show();
            $compile(element.contents())(scope);
            console.log('sprardb-jsonform3 finito');
            scope.$watch('formschema', function (newVal, oldVal) {
//                console.log("test");
//                console.log("newVal", newVal);
//                console.log("oldVal", oldVal);
                if (newVal !== oldVal) {
                    element.html(getTemplate(scope.formschema, scope)).show();
                    $compile(element.contents())(scope);
//                    console.log("differente");
//                    console.log("newVal", newVal);
//                    console.log("oldVal", oldVal);

                }
            });

        }
        return {
            restrict: "E",
            link: linker,
            scope: {
                vm: '=',
                formschema: '=',
                action: '&'
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .directive('sprardbJsonform2', sprardbJsonform2Directive);
    /** @ngInject */
    function sprardbJsonform2Directive($compile)
    {
        //divosore riga
        var row = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = {
                open: '<div layout="row" ' + obj.style + obj.ngif + ' >\n',
                close: '</div>\n',
                closeopen: '</div>\n<div layout="row">\n'
            }
            return itemHtml[obj.status];
        };
        //divosore riga con titolo
        var divider = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = '<md-divider class="md-grey-100-bg padding-8 margin-bottom-16" flex><small><b>' + obj.description.toUpperCase() + '</b></small></md-divider></div>\n<div layout="row">\n';
            return itemHtml;
        };
        //md-select
        var select = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = "";
            itemHtml = '\
            <md-input-container flex ' + obj.ngif + '>\n\
                        <md-select-label ng-class="{\'md-warn-fg\': (' + obj.formName + '.' + obj.dbfield + '.$invalid)}">' + obj.title + '</md-select-label>\n\
                        <md-select name="' + obj.dbfield + '" placeholder="' + obj.description + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" ng-required="' + obj.required + '" ng-change="' + obj.onchange + '" aria-label="' + obj.description + '" ' + obj.multiple + ' ' + obj.style + ' ng-disabled="' + obj.disabled + '" >\n\
                            ' + obj.novalore + '\n\
                            <md-option ng-repeat="item in ' + obj.data + '" ng-value="item.' + obj.chiave + '" >\n\
                                ' + obj.valore + '\n\
                            </md-option>\n\
                        </md-select>\n\
                        <div ng-messages="' + obj.formName + '.' + obj.dbfield + '.$error" role="alert">\n\
                            <div ng-message="required"><span>' + obj.validationmessage + '</span></div>\n\
                        </div>\n\
            </md-input-container>';
            return itemHtml;
        };
        //md-datepicker
        var datepicker = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = "";
            itemHtml = '\
                <div flex layout="column" class="datepicker-container" ' + obj.ngif + '>\n\
                    <label  flex style ="max-height: 22px;" ng-class="{\'md-warn-fg\': (' + obj.formName + '.' + obj.dbfield + '.$invalid)}">' + obj.title + '</label>\n\
                    <md-datepicker class="md-block" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '" md-max-date="' + obj.mdmaxdate + '" md-min-date="' + obj.mdmindate + '" ng-required="' + obj.required + '" ng-change="' + obj.onchange + '" aria-label="' + obj.description + '" ' + obj.style + '  ng-disabled="' + obj.disabled + '" ></md-datepicker>\n\
                </div>';
            return itemHtml;
        };
        //input text
        var text = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = "";
            itemHtml = '\
                <md-input-container flex ' + obj.ngif + '>\n\
                    <label ng-class="{\'md-warn-fg\': (' + obj.formName + '.' + obj.dbfield + '.$invalid)}">' + obj.title + '</label>\n\
                    <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '" ng-required="' + obj.required + '" ng-change="' + obj.onchange + '" aria-label="' + obj.description + '" ' + obj.pattern + ' ' + obj.style + ' ng-disabled="' + obj.disabled + '" >\n\
                    <div ng-messages="' + obj.formName + '.' + obj.dbfield + '.$error" role="alert" multiple>\n\
                        <div ng-message="required">\n\
                            <div ng-message="required"><span>' + obj.validationmessage + '</span></div>\n\
                            <div ng-message="pattern"><span>Formato invalido</span></div>\n\
                        </div>\n\
                    </div>\n\
                </md-input-container>';
            return itemHtml;
        };
        //input textarea
        var texta = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = "";
            itemHtml = '\
                <md-input-container flex ' + obj.ngif + '>\n\
                    <label ng-class="{\'md-warn-fg\': (' + obj.formName + '.' + obj.dbfield + '.$invalid)}">' + obj.title + '</label>\n\
                    <textarea name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '" ng-required="' + obj.required + '" ng-change="' + obj.onchange + '" aria-label="' + obj.description + '" rows="' + obj.rows + '" ' + obj.style + '  ng-disabled="' + obj.disabled + '" ></textarea>\n\
                    <div ng-messages="' + obj.formName + '.' + obj.dbfield + '.$error" role="alert" multiple>\n\
                        <div ng-message="required">\n\
                            <div ng-message="required"><span>' + obj.validationmessage + '</span></div>\n\
                        </div>\n\
                    </div>\n\
                </md-input-container >';
            return itemHtml;
        };
        //checkbox
        var checkbox = function (oggetto) {
            var obj = angular.copy(oggetto);
            var itemHtml = "";
            itemHtml = '\
                <md-input-container flex ' + obj.ngif + '>\n\
                    <md-checkbox \n\
                        ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" \n\
                        aria-label="' + obj.description + '" \n\
                        ng-required="' + obj.required + '" \n\
                        ng-checked="' + obj.data + '" \n\
                        ng-click="' + obj.onchange + '" \n\
                        class="md-align-top-left" flex ' + obj.style + ' ng-disabled="' + obj.disabled + '" > \n\
                            <small >' + obj.title + '</small> \n\
                    </md-checkbox>\n\
                </md-input-container>';
            return itemHtml;
        };
        console.log('-----directive sprardbjsonform2');
        var getTemplate = function (schema, scope) {
//            console.log('--schema');
            var template = '';
            angular.forEach(schema, function (obj) {
                var oggettoHtml = {
                    validationmessage: 'Il campo è richiesto',
                    required: 'false',
                    valore: '',
                    multiple: '',
                    novalore: '',
                    pattern: '',
                    mini: 0,
                    debounce: '',
                    defaultstyle: ' style="margin-top:24px;" ',
                    mdmaxdate: '',
                    mdmindate: '',
                    data: null,
                    formName: 'form',
                    style: '',
                    disabled: 'false'
                };
                angular.forEach(obj, function (vv, kk) {
                    oggettoHtml[kk] = vv;
                });
//                console.log('---oggetto form');
                var validationmessage = 'Campo richiesto';
                var required = '';
                var valore = '';
                var multiple = '';
                var novalore = '';
                var pattern = '';
                var mini = 0;
                var debounce = '';
                var defaultstyle = ' style="margin-top:24px;" ';
                var mdmaxdate = '';
                var mdmindate = '';
                var ngif = '';

                if (!angular.isUndefined(obj.validationMessage)) {
                    validationmessage = obj.validationMessage;
                    oggettoHtml.validationmessage = obj.validationMessage;
                }
                if (angular.isDefined(obj.debounce)) {
                    debounce = ' ng-model-options="{debounce: ' + obj.debounce + '}" ';
                    oggettoHtml.debounce = ' ng-model-options="{debounce: ' + obj.debounce + '}" ';
                }
                if (angular.isDefined(obj.style)) {
                    defaultstyle = ' style="' + obj.style + '" ';
                    oggettoHtml.style = ' style="' + obj.style + '" ';
                }
                if (obj.required) {
                    required = 'required';
                    oggettoHtml.required = 'true';
                    mini = 1;
                    oggettoHtml.mini = 1;
                }
                if (!angular.isUndefined(obj.data)) {
                    if (angular.isArray(obj.data)) {
                        scope.vm.data[obj.dbfield] = obj.data;
                        obj.data = "vm.data['" + obj.dbfield + "']";
                        oggettoHtml.data = "vm.data['" + obj.dbfield + "']";
                    }
                }
                //console.log("obj.data");
                //console.log(obj.data);
                if (!angular.isUndefined(obj.valore)) {
                    var minheigth = 0;
                    //obj.valore = JSON.parse(obj.valore);
                    if (angular.isArray(obj.valore)) {
//                        console.log('array');
                        minheigth = 24 * obj.valore.length;
                        valore = '<div layout="column" style="min-height:' + minheigth + 'px;">';
                        var iii = 0;
                        angular.forEach(obj.valore, function (v) {
                            if (iii === 0) {
                                valore += '<small><b style="text-transform: uppercase;">{{item.' + v + '}}</b></small>';
                            } else {
                                valore += '<span><small><small style="text-transform: uppercase;">' + v + ': {{item.' + v + '}}</small></small></span>';
                            }
                            iii++;
                        });
                        valore += '</div>';
                    } else {
                        valore = '<small><b style="text-transform: uppercase;">{{item.' + obj.valore + '}}</b></small>';
                    }
                    oggettoHtml.valore = valore;
                }
                if (!angular.isUndefined(obj.multiple)) {
                    if (obj.multiple) {
                        multiple = 'multiple';
                        oggettoHtml.multiple = 'multiple';
                    }
                }
                if (!angular.isUndefined(obj.novalore)) {
                    novalore = '<md-option value="' + obj.novalore + '">Nessuno</md-option>';
                    oggettoHtml.novalore = '<md-option value="' + obj.novalore + '">Nessuno</md-option>';
                }
                if (!angular.isUndefined(obj.pattern)) {
                    pattern = ' ng-pattern="' + obj.pattern + '" ';
                    oggettoHtml.pattern = ' ng-pattern="' + obj.pattern + '" ';
                }
                if (angular.isDefined(obj.mdmaxdate)) {
                    mdmaxdate = ' md-max-date="' + obj.mdmaxdate + '" ';
                    oggettoHtml.mdmaxdate = obj.mdmaxdate;
                }
                if (angular.isDefined(obj.mdmindate)) {
                    mdmindate = ' md-min-date="' + obj.mdmindate + '" ';
                    oggettoHtml.mdmindate = obj.mdmindate;
                }
                if (angular.isDefined(obj.formName)) {
                    oggettoHtml.formName = obj.formName;
                }
                if (angular.isDefined(obj.disabled)) {
                    oggettoHtml.disabled = obj.disabled;
                }
                if (angular.isDefined(obj.ngif)) {
                    ngif = ' ng-if="' + obj.ngif + '" ';
                    oggettoHtml.ngif = obj.ngif;
                }

                switch (obj.formtype) {
                    case 'row':
                        template += row(oggettoHtml);
                        break;
                    case 'divider':
                        template += divider(oggettoHtml);
                        break;
                    case 'textarea':
                        template += texta(oggettoHtml);
                        break;
                    case 'text':
                        template += text(oggettoHtml);
                        break;
                    case 'select':
                        template += select(oggettoHtml);
                        break;
                    case 'datepicker':
                        template += datepicker(oggettoHtml);
                        break;
                    case 'datepickerv':
                        template += datepicker(oggettoHtml);
                        break;
                    case 'checkbox':
                        template += checkbox(oggettoHtml);
                        break;
                    case 'hidden':
                        template += '\n\
                        <input type="hidden" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" value="' + obj.valore + '" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '"/>\n\
                        ';
                        break;
                    case 'label':
                        template += '\n\
                        <div class="column" flex>\n\
                            <div class="row" flex>\n\
                                    ' + obj.description + '\n\
                            </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'upload':
                        //console.log(obj.data);
                        scope.vm.buildUP(obj.data);
                        template += '\n\
                        <div class="column" flex>\n\
                            <div class="row" flex>\n\
                            <input type="number" ng-model="vm.uploadParams.caricato" value="{{vm.uploadParams.caricato}}" min="' + mini + '" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '"/>\n\
                                <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                            </div>\n\
                        </div>\n\
                        ';
                        break;
                }
            });
            return template;
        }
        var linker = function (scope, element, attrs) {
//            console.log('---linker');
            element.html(getTemplate(scope.formschema, scope)).show();
            $compile(element.contents())(scope);
            console.log('sprardb-jsonform2 finito');
            if (angular.isDefined(scope.vm.callbackfunc) && scope.vm.callbackfunc === true) {
                scope.vm.callbackjsonform2();
            }
        }
        return {
            restrict: "E",
            link: linker,
            scope: {
                vm: '=',
                formschema: '=',
                action: '&'
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .directive('sprardbJsonform', sprardbJsonformDirective);
    /** @ngInject */
    function sprardbJsonformDirective($compile)
    {

        console.log('-----directive sprardbjsonfomr');
        var getTemplate = function (schema, scope) {
//            console.log('--schema');
            var template = '';
            angular.forEach(schema, function (obj) {
//                console.log('---oggetto form');
                var validationmessage = 'Campo richiesto';
                var required = '';
                var valore = '';
                var multiple = '';
                var novalore = '';
                var pattern = '';
                var mini = 0;
                var debounce = '';
                var defaultstyle = ' style="margin-top:24px;" ';
                var mdmaxdate = '';
                var mdmindate = '';
                var disabled = '';
                var ngif = '';

                if (!angular.isUndefined(obj.validationMessage)) {
                    validationmessage = obj.validationMessage;
                }
                if (angular.isDefined(obj.debounce)) {
                    debounce = ' ng-model-options="{debounce: ' + obj.debounce + '}" ';
                }
                if (angular.isDefined(obj.style)) {
                    defaultstyle = ' style="' + obj.style + '" ';
                }
                if (angular.isDefined(obj.required)) {
                    //required = 'required';
                    required = ' ng-required = "' + obj.required + '" ';
                    mini = 1;
                }
                if (angular.isDefined(obj.ngif)) {
                    ngif = ' ng-if = "' + obj.ngif + '" ';
                }
                if (!angular.isUndefined(obj.data)) {
                    if (angular.isArray(obj.data)) {
                        scope.vm.data[obj.dbfield] = obj.data;
                        obj.data = "vm.data['" + obj.dbfield + "']";
                    }
                }
                //console.log("obj.data");
                //console.log(obj.data);
                if (!angular.isUndefined(obj.valore)) {
                    var minheigth = 0;
                    //obj.valore = JSON.parse(obj.valore);
                    if (angular.isArray(obj.valore)) {
//                        console.log('array');
                        minheigth = 24 * obj.valore.length;
                        valore = '<div layout="column" style="min-height:' + minheigth + 'px;">';
                        var iii = 0;
                        angular.forEach(obj.valore, function (v) {
                            if (iii === 0) {
                                valore += '<span><b style="text-transform: uppercase;">{{item.' + v + '}}</b></span>';
                            } else {
                                valore += '<span><small><small style="text-transform: uppercase;">' + v + ': {{item.' + v + '}}</small></small></span>';
                            }
                            iii++;
                        });
                        valore += '</div>';
                    } else {
                        valore = '<small><b style="text-transform: uppercase;">{{item.' + obj.valore + '}}</b></small>';
                    }
                }
                if (!angular.isUndefined(obj.multiple)) {
                    if (obj.multiple) {
                        multiple = 'multiple';
                    }
                }
                if (!angular.isUndefined(obj.novalore)) {
                    novalore = '<md-option value="' + obj.novalore + '">Nessuno</md-option>';
                }
                if (!angular.isUndefined(obj.pattern)) {
                    pattern = ' ng-pattern="' + obj.pattern + '" ';
                }
                if (angular.isDefined(obj.mdmaxdate)) {
                    mdmaxdate = ' md-max-date="' + obj.mdmaxdate + '" ';
                }
                if (angular.isDefined(obj.mdmindate)) {
                    mdmindate = ' md-min-date="' + obj.mdmindate + '" ';
                }
                if (angular.isDefined(obj.disabled)) {
                    //disabled = ' ng-disabled = "true" ';
                    disabled = ' ng-disabled = "' + obj.disabled + '" ';
                }

                switch (obj.formtype) {
                    case 'textarea':

                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + '>\n\
                            <md-input-container flex>\n\
                                <label>' + obj.title + '</label>\n\
                                <textarea name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '" aria-label="' + obj.description + '" ' + required + ' rows="3" ng-change="' + obj.onchange + '" ' + disabled + ' ></textarea>\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
                        break;
                    case 'text':
                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + ' >\n\
                        <md-input-container flex>\n\
                            <label>' + obj.title + '</label>\n\
                            <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '"  ' + required + ' ' + pattern + ' ng-change="' + obj.onchange + '" ' + debounce + ' ' + disabled + ' >\n\
                        <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                            <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                            <div ng-message="pattern"><span>Formato invalido</span></div>\n\
                        </div>\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
                        break;
                    case 'textNR':
                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row" flex ' + defaultstyle + ' >\n\
                        <md-input-container flex>\n\
                            <label>' + obj.title + '</label>\n\
                            <input type="text" name="' + obj.dbfield + '" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" placeholder="' + obj.description + '"  ' + required + ' ' + pattern + ' ng-change="' + obj.onchange + '" ' + debounce + ' ' + disabled + ' >\n\
                        </md-input-container>\n\
                        </div>\n\
                        </div>\n';
                        break;
                    case 'select':
                        template += '\n\
                        <div layout="column" ' + ngif + '>\n\
                        <div layout="row">\n\
                            <md-input-container flex>\n\
                                <label>' + obj.title + '</label>\n\
                                <md-select ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" ng-change="' + obj.onchange + '" placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ' + required + ' ' + multiple + '  ' + disabled + '  >\n\
                                    ' + novalore + '\n\
                                    <md-option class="small" ng-repeat="item in ' + obj.data + '" ng-value="item.' + obj.chiave + '"  style="min-height:' + minheigth + 'px;">' + valore + '</md-option>\n\
                                </md-select>\n\
                                <div ng-messages="processoForm.' + obj.dbfield + '.$error" role="alert" >\n\
                                    <div ng-message="required"><span>' + validationmessage + '</span></div>\n\
                                </div>\n\
                            </md-input-container>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'datepicker':
                        template += '\n\
                        <div layout="column" flex ' + ngif + '>\n\
                        <div layout="row" flex class="datepicker-container">\n\
                            <div flex="50" class="margin-top-8 text-right">\n\
                                <small><b>' + obj.title + '</b></small>\n\
                            </div>\n\
                            <div flex="50" class="margin-left-32">\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'datepickerv':
                        template += '\n\
                        <div layout="column" flex style="margin-bottom:16px;" class="datepicker-container" ' + ngif + '>\n\
                            <label flex >\n\
                                ' + obj.title + '\n\
                            </label>\n\
                            <div flex >\n\
                                <md-datepicker ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" md-placeholder="' + obj.description + '"  name="' + obj.dbfield + '" ng-required="' + obj.required + '" flex ng-change="' + obj.onchange + '" ' + mdmindate + ' ' + mdmaxdate + ' ></md-datepicker>\n\
                            </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'checkbox':
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                            <md-checkbox ng-checked="' + obj.data + '" ng-click="' + obj.onchange + '" aria-label="' + obj.dbfield + '" name="' + obj.dbfield + '" ng-required="' + obj.required + '" style="margin-top: 16px;margin-right:4px;" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\'] "></md-checkbox>\n\
                            <div flex="75" class="padding-top-16">\n\
                                <span >' + obj.description + '</span>\n\
                            </div>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'hidden':
                        template += '\n\
                        <input type="hidden" ng-model="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" value="' + obj.valore + '" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" ' + ngif + '/>\n\
                        ';
                        break;
                    case 'label':
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                                ' + obj.description + '\n\
                        </div>\n\
                        <div class="row" flex ng-bind-html="vm.' + obj.callbackModel + '[\'' + obj.dbfield + '\']" >\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'upload':
                        //console.log(obj.data);
                        //console.log('vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore);
                        scope.vm.buildUP(obj.data);
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" value="{{vm.uploadParams.caricato}}" min="' + mini + '" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '" />\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                    case 'uploadmindynamic':
                        scope.vm.buildUP(obj.data);
                        template += '\n\
                        <div class="column" flex ' + ngif + '>\n\
                        <div class="row" flex>\n\
                        <input type="number" ng-model="vm.uploadParams.caricato" ng-value="vm.uploadParams.caricato" ng-min="vm.uploadParams.mincaricato" ng-show="false" ng-init="vm.' + obj.callbackModel + '.' + obj.dbfield + '=' + obj.valore + '"/>\n\
                            <sprardb-uploaddocuments2 ng-model="vm.uploadParams"></sprardb-uploaddocuments2>\n\
                        </div>\n\
                        </div>\n\
                        ';
                        break;
                }
            });
            return template;
        }
        var linker = function (scope, element, attrs) {
//            console.log('---linker');
            element.html(getTemplate(scope.formschema, scope)).show();
            $compile(element.contents())(scope);
            console.log('sprardb-jsonform finito');


        }
        return {
            restrict: "E",
            link: linker,
            scope: {
                vm: '=',
                formschema: '=',
                action: '&'
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .controller('MsShortcutsController', MsShortcutsController)
            .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                    // Success
                            function (response)
                            {
                                vm.shortcuts = response;

                                // Add shortcuts as results by default
                                if (vm.shortcuts.length > 0)
                                {
                                    vm.results = response;
                                }
                            }
                    );

                    // Watch the model changes to trigger the search
                    $scope.$watch('MsShortcuts.query', function (current, old)
                    {
                        if (angular.isUndefined(current))
                        {
                            return;
                        }

                        if (angular.equals(current, old))
                        {
                            return;
                        }

                        // Show the loader
                        vm.resultsLoading = true;

                        // Populate the results
                        vm.populateResults().then(
                                // Success
                                        function (response)
                                        {
                                            vm.results = response;
                                        },
                                        // Error
                                                function ()
                                                {
                                                    vm.results = [];
                                                }
                                        ).finally(
                                                function ()
                                                {
                                                    // Hide the loader
                                                    vm.resultsLoading = false;
                                                }
                                        );
                                    });
                        }

                /**
                 * Populate the results
                 */
                function populateResults()
                {
                    var results = [],
                            flatNavigation = msNavigationService.getFlatNavigation(),
                            deferred = $q.defer();

                    // Iterate through the navigation array and
                    // make sure it doesn't have any groups or
                    // none ui-sref items
                    for (var x = 0; x < flatNavigation.length; x++)
                    {
                        if (flatNavigation[x].uisref)
                        {
                            results.push(flatNavigation[x]);
                        }
                    }

                    // If there is a query, filter the results
                    if (vm.query)
                    {
                        results = results.filter(function (item)
                        {
                            if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1)
                            {
                                return true;
                            }
                        });

                        // Iterate through one last time and
                        // add required properties to items
                        for (var i = 0; i < results.length; i++)
                        {
                            // Add false to hasShortcut by default
                            results[i].hasShortcut = false;

                            // Test if the item is in the shortcuts list
                            for (var y = 0; y < vm.shortcuts.length; y++)
                            {
                                if (vm.shortcuts[y]._id === results[i]._id)
                                {
                                    results[i].hasShortcut = true;
                                    break;
                                }
                            }
                        }
                    } else
                    {
                        // If the query is empty, that means
                        // there is nothing to search for so
                        // we will populate the results with
                        // current shortcuts if there is any
                        if (vm.shortcuts.length > 0)
                        {
                            results = vm.shortcuts;
                        }
                    }

                    // Reset the selected result
                    vm.selectedResultIndex = 0;

                    // Fake the service delay
                    $timeout(function ()
                    {
                        // Resolve the promise
                        deferred.resolve(results);
                    }, 250);

                    // Return a promise
                    return deferred.promise;
                }

                /**
                 * Load shortcuts
                 */
                function loadShortcuts()
                {
                    var deferred = $q.defer();

                    // For the demo purposes, we will
                    // load the shortcuts from the cookies.
                    // But here you can make an API call
                    // to load them from the DB.
                    var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

                    // No cookie available. Generate one
                    // for the demo purposes...
                    if (angular.isUndefined(shortcuts))
                    {
                        shortcuts = [
                            {
                                'title': 'Progetti',
                                'icon': 'icon-apps',
                                'state': 'app.sprardb_progetti_progetti',
                                'weight': 1,
                                'children': [],
                                '_id': 'progetti',
                                '_path': 'app.sprardb_progetti_progetti',
                                'uisref': 'app.sprardb_progetti_progetti',
                                'hasShortcut': true
                            }
                        ];

                        $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
                    }

                    // Resolve the promise
                    deferred.resolve(shortcuts);

                    return deferred.promise;
                }

                /**
                 * Save the shortcuts
                 */
                function saveShortcuts()
                {
                    var deferred = $q.defer();

                    // For the demo purposes, we will
                    // keep the shortcuts in the cookies.
                    // But here you can make an API call
                    // to save them to the DB.
                    $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

                    // Fake the service delay
                    $timeout(function ()
                    {
                        deferred.resolve({'success': true});
                    }, 250);

                    return deferred.promise;
                }

                /**
                 * Add item as shortcut
                 *
                 * @param item
                 */
                function addShortcut(item)
                {
                    // Update the hasShortcut status
                    item.hasShortcut = true;

                    // Add as a shortcut
                    vm.shortcuts.push(item);

                    // Save the shortcuts
                    vm.saveShortcuts();
                }

                /**
                 * Remove item from shortcuts
                 *
                 * @param item
                 */
                function removeShortcut(item)
                {
                    // Update the hasShortcut status
                    item.hasShortcut = false;

                    // Remove the shortcut
                    for (var x = 0; x < vm.shortcuts.length; x++)
                    {
                        if (vm.shortcuts[x]._id === item._id)
                        {
                            // Remove the x-th item from the array
                            vm.shortcuts.splice(x, 1);

                            // If we aren't searching for anything...
                            if (!vm.query)
                            {
                                // If all the shortcuts have been removed,
                                // null-ify the results
                                if (vm.shortcuts.length === 0)
                                {
                                    vm.results = null;
                                }
                                // Otherwise update the selected index
                                else
                                {
                                    if (x >= vm.shortcuts.length)
                                    {
                                        vm.selectedResultIndex = vm.shortcuts.length - 1;
                                    }
                                }
                            }
                        }
                    }

                    // Save the shortcuts
                    vm.saveShortcuts();
                }

                /**
                 * Handle the result click
                 *
                 * @param item
                 */
                function handleResultClick(item)
                {
                    // Add or remove the shortcut
                    if (item.hasShortcut)
                    {
                        vm.removeShortcut(item);
                    } else
                    {
                        vm.addShortcut(item);
                    }
                }

                /**
                 * Absorb the given event
                 *
                 * @param event
                 */
                function absorbEvent(event)
                {
                    event.preventDefault();
                }

                /**
                 * Handle keydown
                 *
                 * @param event
                 */
                function handleKeydown(event)
                {
                    var keyCode = event.keyCode,
                            keys = [38, 40];

                    // Prevent the default action if
                    // one of the keys are pressed that
                    // we are listening
                    if (keys.indexOf(keyCode) > -1)
                    {
                        event.preventDefault();
                    }

                    switch (keyCode)
                    {
                        // Enter
                        case 13:

                            // Trigger result click
                            vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                            break;

                            // Up Arrow
                        case 38:

                            // Decrease the selected result index
                            if (vm.selectedResultIndex - 1 >= 0)
                            {
                                // Decrease the selected index
                                vm.selectedResultIndex--;

                                // Make sure the selected result is in the view
                                vm.ensureSelectedResultIsVisible();
                            }

                            break;

                            // Down Arrow
                        case 40:

                            // Increase the selected result index
                            if (vm.selectedResultIndex + 1 < vm.results.length)
                            {
                                // Increase the selected index
                                vm.selectedResultIndex++;

                                // Make sure the selected result is in the view
                                vm.ensureSelectedResultIsVisible();
                            }

                            break;

                        default:
                            break;
                    }
                }

                /**
                 * Handle mouseenter
                 *
                 * @param index
                 */
                function handleMouseenter(index)
                {
                    if (vm.ignoreMouseEvents)
                    {
                        return;
                    }

                    // Update the selected result index
                    // with the given index
                    vm.selectedResultIndex = index;
                }

                /**
                 * Set a variable for a limited time
                 * to make other functions to ignore
                 * the mouse events
                 */
                function temporarilyIgnoreMouseEvents()
                {
                    // Set the variable
                    vm.ignoreMouseEvents = true;

                    // Cancel the previous timeout
                    $timeout.cancel(vm.mouseEventIgnoreTimeout);

                    // Set the timeout
                    vm.mouseEventIgnoreTimeout = $timeout(function ()
                    {
                        vm.ignoreMouseEvents = false;
                    }, 250);
                }

                /**
                 * Ensure the selected result will
                 * always be visible on the results
                 * area
                 */
                function ensureSelectedResultIsVisible()
                {
                    var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                            selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

                    if (resultsEl && selectedItemEl)
                    {
                        var top = selectedItemEl.position().top - 8,
                                bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                        // Start ignoring mouse events
                        vm.temporarilyIgnoreMouseEvents();

                        if (resultsEl.scrollTop() > top)
                        {
                            resultsEl.scrollTop(top);
                        }

                        if (bottom > (resultsEl.height() + resultsEl.scrollTop()))
                        {
                            resultsEl.scrollTop(bottom - resultsEl.height());
                        }
                    }
                }

                /**
                 * Toggle mobile bar
                 */
                function toggleMobileBar()
                {
                    vm.mobileBarActive = !vm.mobileBarActive;
                }
            }

            /** @ngInject */
            function msShortcutsDirective()
            {
                return {
                    restrict: 'E',
                    scope: {},
                    require: 'msShortcuts',
                    controller: 'MsShortcutsController as MsShortcuts',
                    bindToController: {},
                    templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
                    compile: function (tElement)
                    {
                        // Add class
                        tElement.addClass('ms-shortcuts');

                        return function postLink(scope, iElement)
                        {
                            // Data

                        };
                    }
                };
            }
        })();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '1px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular
            .module('app.core')
            .directive('datepickerValidationFix', datepickerValidationFixDirective);

    function datepickerValidationFixDirective() {
        return {
            restrict: 'A',
            require: 'mdDatepicker',
            link: function (scope, element, attrs, mdDatepickerCtrl) {
                // Fix to run validation when a datepicker's minDate changes
                // Bug #5938
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.minDate;
                }, function () {
                    if (mdDatepickerCtrl.dateUtil.isValidDate(mdDatepickerCtrl.date)) {
                        mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    }
                });

                // Fix to clear error state when setting date programatically from null
                // Bug #6086
                mdDatepickerCtrl.$scope.$watch(function () {
                    return mdDatepickerCtrl.date;
                }, function (newVal, oldVal) {

                    // if (newVal && !oldVal) {
                    mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
                    // }
                });
            }
        }
    }
});



(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('fuse', [
                // Common 3rd Party Dependencies
                'uiGmapgoogle-maps',
                'textAngular',
                'xeditable',
                'angular.filter',
                'fixed.table.header',
                'ngCsv',
                'ngMaterialCollapsible',
                // Core
                'app.core',
                // Navigation
                'app.navigation',
                // Toolbar
                'app.toolbar',
                // Quick Panel
                //'app.quick-panel',

                // Apps
                //'app.dashboards',
                //'app.calendar',
                //'app.e-commerce',
                //'app.mail',
                //'app.chat',
                //'app.file-manager',
                //'app.gantt-chart',
                //'app.scrumboard',
                //'app.todo',
                //'app.contacts',
                //'app.notes',

                // Pages
                //'app.pages',

                // User Interface
                //'app.ui',

                // Components
                //'app.components'
                'app.sprardb'
            ]);
})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, msNavigationService, api, $timeout)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if (event.targetScope.$id === $scope.$id)
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
        //console.log(msNavigationService);
        //$scope.menuroot = msNavigationService.getNavigation('sprardb');
        //$scope.reloadmenu = function () {
//        $scope.currentgruppos = api.userlogged.gruppos;
//        $scope.gruppi = [
//            {guid: "26df70705a3111e6b790b8ca3ab72b30", id: "1", gruppo: "SC-ACCOGLIENZA"},
//            {guid: "26df76715a3111e6b790b8ca3ab72b30", id: "2", gruppo: "SC-SEGRETERIA"},
//            {guid: "57c186545a3111e6b790b8ca3ab72b30", id: "3", gruppo: "SC-ADMIN"},
//            {guid: "57c18d255a3111e6b790b8ca3ab72b30", id: "4", gruppo: "SC-RENDICONTAZIONE"},
//            {guid: "609d2d2b5a3111e6b790b8ca3ab72b30", id: "5", gruppo: "PR-AMMINISTRATORE"},
//            {guid: "609d332e5a3111e6b790b8ca3ab72b30", id: "6", gruppo: "PR-OPERATORE"},
//            {guid: "69a161b85a3111e6b790b8ca3ab72b30", id: "7", gruppo: "SC-TUTOR"},
//            {guid: "69a167c75a3111e6b790b8ca3ab72b30", id: "8", gruppo: "SC-FRONTEND"},
//            {guid: "9ece399b5a3111e6b790b8ca3ab72b30", id: "9", gruppo: "PR-ENTEGESTORE"},
//            {guid: "9ece3f965a3111e6b790b8ca3ab72b30", id: "10", gruppo: "PR-RENDICONTAZIONE"},
//            {guid: "ed721ee15a3011e6b790b8ca3ab72b30", id: "11", gruppo: "SEGNALATORE"}
//        ];
//        var menuroot = msNavigationService.getNavigation('sprardb');
//        var menutree = menuroot[0].children;
//        //console.log(menutree);
//        if (!api.isAdmin) {
//            angular.forEach(menutree, function (l1) {
//                console.log(l1);
//                if (angular.isDefined(l1.deny)) {
//                    //console.log(l1.deny);
//                    angular.forEach($scope.currentgruppos, function (g) {
//                        if (l1.deny.indexOf(g.id) >= 0) {
//                            //msNavigationService.deleteItem(l1._path);
//                        }
//                    });
//                }
//                if (angular.isDefined(l1.allow)) {
//                    //console.log('ALLOW')
//                    //console.log(l1.allow);
//                    angular.forEach($scope.currentgruppos, function (g) {
//                        //console.log(g.id);
//                        console.log(l1.allow.indexOf(g.id));
//                        if (l1.allow.indexOf(g.id) < 0) {
//                            console.log('cancella: ' + l1.title)
//                            //msNavigationService.deleteItem(l1._path);
//                        }
//                    });
//                }
//            });
//        }
        //};
        $scope.testme = function () {
            console.log("test");
        };
        $scope.reloadmenu = function () {
            $scope.currentgruppos = api.userlogged.gruppos;
            $scope.gruppi = [
                {guid: "26df70705a3111e6b790b8ca3ab72b30", id: "1", gruppo: "SC-ACCOGLIENZA"},
                {guid: "26df76715a3111e6b790b8ca3ab72b30", id: "2", gruppo: "SC-SEGRETERIA"},
                {guid: "57c186545a3111e6b790b8ca3ab72b30", id: "3", gruppo: "SC-ADMIN"},
                {guid: "57c18d255a3111e6b790b8ca3ab72b30", id: "4", gruppo: "SC-RENDICONTAZIONE"},
                {guid: "609d2d2b5a3111e6b790b8ca3ab72b30", id: "5", gruppo: "PR-AMMINISTRATORE"},
                {guid: "609d332e5a3111e6b790b8ca3ab72b30", id: "6", gruppo: "PR-OPERATORE"},
                {guid: "69a161b85a3111e6b790b8ca3ab72b30", id: "7", gruppo: "SC-TUTOR"},
                {guid: "69a167c75a3111e6b790b8ca3ab72b30", id: "8", gruppo: "SC-FRONTEND"},
                {guid: "9ece399b5a3111e6b790b8ca3ab72b30", id: "9", gruppo: "PR-ENTEGESTORE"},
                {guid: "9ece3f965a3111e6b790b8ca3ab72b30", id: "10", gruppo: "PR-RENDICONTAZIONE"},
                {guid: "ed721ee15a3011e6b790b8ca3ab72b30", id: "11", gruppo: "SEGNALATORE"},
                {guid: "fae9778956d911e98138704d7b485820", id: "12", gruppo: "VISITATORE"}
            ];
            var menutree = $scope.menuroot[0].children;
            //console.log(menutree);
            if (!api.isAdmin) {
                angular.forEach(menutree, function (l1) {
                    //console.log(l1);
                    if (angular.isDefined(l1.deny)) {
                        //console.log(l1.deny);
                        angular.forEach($scope.currentgruppos, function (g) {
                            if (l1.deny.indexOf(g.id) >= 0) {
                                //msNavigationService.deleteItem(l1._path);
                            }
                        });
                    }
                    if (angular.isDefined(l1.allow)) {
                        //console.log('ALLOW')
                        //console.log(l1.allow);
                        angular.forEach($scope.currentgruppos, function (g) {
                            //console.log(g.id);
                            //console.log(l1.allow.indexOf(g.id));
                            if (l1.allow.indexOf(g.id) < 0) {
                                console.log('cancella: ' + l1.title);
                                console.log('cancella: ' + l1._path);

                                msNavigationService.deleteItem(l1._path);
                            }
                        });
                    }
                });
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('yeardrop', yeardropDirective);

    /** @ngInject */
    function yeardropDirective()
    {
    function getYears(offset, range){
            var currentYear = new Date().getFullYear();
            var years = [];
            for (var i = 0; i < range + 1; i++){
                years.push(currentYear + offset + i);
            }
            return years;
        }
        return {
            link: function(scope,element,attrs){
                scope.years = getYears(+attrs.offset, +attrs.range);
                scope.selected = scope.years[0];
            },
            template: '<select ng-model="selected" ng-options="y for y in years"></select>'
        }
    }
})();
(function ()
{

    'use strict';

    var injectParams = ['$q', 'api'];

    var wcUniqueDirective = function ($q, api) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.uniqueun = function (modelValue, viewValue) {
                    var deferred = $q.defer(),
                            currentValue = modelValue || viewValue,
                            key = attrs.ngUniqueunKey,
                            property = attrs.ngUniqueunProperty;
                    var postdata = {
                        'email': null,
                        'username': null,
                        'passwordc': null
                    };
                    if (key && property) {
                        if (property == 'email') {
                            postdata.email = currentValue;
                        }
                        if (property == 'username') {
                            postdata.username = currentValue;
                        }

                        api.users.log.preregister(postdata,
                                function (response) {
                                    if (response.status != undefined && response.status == 200) {
                                        deferred.resolve('uniqueun'); //It's unique
                                    } else {
                                        if (response.username != undefined) {
                                            deferred.reject('uniqueun'); //Add unique to $errors
                                        }
                                    }
                                },
                                function (response) {
                                    deferred.reject('uniqueun'); //Add unique to $errors
                                });
                    } else {
                        deferred.reject('uniqueun'); //Add unique to $errors
                    }
                    return deferred.promise;
                }
            }
        }
    };
    wcUniqueDirective.$inject = injectParams;
    angular.module('app.core').directive('ngUniqueun', wcUniqueDirective);

})();


(function ()
{
    'use strict';

    var injectParams = ['$q', 'api'];

    var ngUnique = function ($q, api) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
                    var deferred = $q.defer(),
                            currentValue = modelValue || viewValue,
                            key = attrs.ngUniqueKey,
                            property = attrs.ngUniqueProperty;
                    var postdata = {
                        'email': null,
                        'username': null,
                        'passwordc': null
                    };
                    if (key && property) {
                        if (property == 'email') {
                            postdata.email = currentValue;
                        }
                        if (property == 'username') {
                            postdata.username = currentValue;
                        }

                        api.users.log.preregister(postdata,
                                function (response) {
                                    if (response.status != undefined && response.status == 200) {
                                        deferred.resolve('unique'); //It's unique
                                    } else {
                                        if (response.email != undefined) {
                                            deferred.reject('unique'); //Add unique to $errors
                                        }
                                    }
                                },
                                function (response) {
                                    deferred.reject('unique'); //Add unique to $errors
                                });
                    } else {
                        deferred.reject('unique'); //Add unique to $errors
                    }
                    return deferred.promise;
                }
            }
        }
    }
    ngUnique.$inject = injectParams;

    angular.module('app.core').directive('ngUnique', ngUnique)

})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
'use strict';
/*jshint globalstrict: true*/
/*jshint undef:false */

angular.module('unsavedChanges', ['resettable'])

.provider('unsavedWarningsConfig', function() {

    var _this = this;

    // defaults
    var logEnabled = false;
    var useTranslateService = true;
    var routeEvent = ['$locationChangeStart', '$stateChangeStart'];
    var navigateMessage = 'You will lose unsaved changes if you leave this page';
    var reloadMessage = 'You will lose unsaved changes if you reload this page';

    Object.defineProperty(_this, 'navigateMessage', {
        get: function() {
            return navigateMessage;
        },
        set: function(value) {
            navigateMessage = value;
        }
    });

    Object.defineProperty(_this, 'reloadMessage', {
        get: function() {
            return reloadMessage;
        },
        set: function(value) {
            reloadMessage = value;
        }
    });

    Object.defineProperty(_this, 'useTranslateService', {
        get: function() {
            return useTranslateService;
        },
        set: function(value) {
            useTranslateService = !! (value);
        }
    });

    Object.defineProperty(_this, 'routeEvent', {
        get: function() {
            return routeEvent;
        },
        set: function(value) {
            if (typeof value === 'string') value = [value];
            routeEvent = value;
        }
    });
    Object.defineProperty(_this, 'logEnabled', {
        get: function() {
            return logEnabled;
        },
        set: function(value) {
            logEnabled = !! (value);
        }
    });

    this.$get = ['$injector',
        function($injector) {

            function translateIfAble(message) {
                if ($injector.has('$translate') && useTranslateService) {
                    return $injector.get('$translate').instant(message);
                } else {
                    return false;
                }
            }

            var publicInterface = {
                // log function that accepts any number of arguments
                // @see http://stackoverflow.com/a/7942355/1738217
                log: function() {
                    if (console.log && logEnabled && arguments.length) {
                        var newarr = [].slice.call(arguments);
                        if (typeof console.log === 'object') {
                            log.apply.call(console.log, console, newarr);
                        } else {
                            console.log.apply(console, newarr);
                        }
                    }
                }
            };

            Object.defineProperty(publicInterface, 'useTranslateService', {
                get: function() {
                    return useTranslateService;
                }
            });

            Object.defineProperty(publicInterface, 'reloadMessage', {
                get: function() {
                    return translateIfAble(reloadMessage) || reloadMessage;
                }
            });

            Object.defineProperty(publicInterface, 'navigateMessage', {
                get: function() {
                    return translateIfAble(navigateMessage) || navigateMessage;
                }
            });

            Object.defineProperty(publicInterface, 'routeEvent', {
                get: function() {
                    return routeEvent;
                }
            });

            Object.defineProperty(publicInterface, 'logEnabled', {
                get: function() {
                    return logEnabled;
                }
            });

            return publicInterface;
        }
    ];
})

.service('unsavedWarningSharedService', ['$rootScope', 'unsavedWarningsConfig', '$injector', '$window',
    function($rootScope, unsavedWarningsConfig, $injector, $window) {

        // Controller scopped variables
        var _this = this;
        var allForms = [];
        var areAllFormsClean = true;
        var removeFunctions = [];

        // @note only exposed for testing purposes.
        this.allForms = function() {
            return allForms;
        };

        // Check all registered forms
        // if any one is dirty function will return true

        function allFormsClean() {
            areAllFormsClean = true;
            angular.forEach(allForms, function(item, idx) {
                unsavedWarningsConfig.log('Form : ' + item.$name + ' dirty : ' + item.$dirty);
                if (item.$dirty) {
                    areAllFormsClean = false;
                }
            });
            return areAllFormsClean; // no dirty forms were found
        }

        // adds form controller to registered forms array
        // this array will be checked when user navigates away from page
        this.init = function(form) {
            if (allForms.length === 0) setup();
            unsavedWarningsConfig.log("Registering form", form);
            allForms.push(form);
        };

        this.removeForm = function(form) {
            var idx = allForms.indexOf(form);

            // this form is not present array
            // @todo needs test coverage
            if (idx === -1) return;

            allForms.splice(idx, 1);
            unsavedWarningsConfig.log("Removing form from watch list", form);

            if (allForms.length === 0) tearDown();
        };

        function tearDown() {
            unsavedWarningsConfig.log('No more forms, tearing down');
            angular.forEach(removeFunctions, function(fn) {
                fn();
            });
            removeFunctions = [];
            $window.onbeforeunload = null;
        }

        // Function called when user tries to close the window
        this.confirmExit = function() {
            if (!allFormsClean()) return unsavedWarningsConfig.reloadMessage;
            $rootScope.$broadcast('resetResettables');
            tearDown();
        };

        // bind to window close
        // @todo investigate new method for listening as discovered in previous tests

        function setup() {
            unsavedWarningsConfig.log('Setting up');

            $window.onbeforeunload = _this.confirmExit;

            var eventsToWatchFor = unsavedWarningsConfig.routeEvent;

            angular.forEach(eventsToWatchFor, function(aEvent) {
                //calling this function later will unbind this, acting as $off()
                var removeFn = $rootScope.$on(aEvent, function(event, next, current) {
                    unsavedWarningsConfig.log("user is moving with " + aEvent);
                    // @todo this could be written a lot cleaner!
                    if (!allFormsClean()) {
                        unsavedWarningsConfig.log("a form is dirty");
                        if (!confirm(unsavedWarningsConfig.navigateMessage)) {
                            unsavedWarningsConfig.log("user wants to cancel leaving");
                            event.preventDefault(); // user clicks cancel, wants to stay on page
                        } else {
                            unsavedWarningsConfig.log("user doesn't care about loosing stuff");
                            $rootScope.$broadcast('resetResettables');
                        }
                    } else {
                        unsavedWarningsConfig.log("all forms are clean");
                    }

                });
                removeFunctions.push(removeFn);
            });
        }
    }
])

.directive('unsavedWarningClear', ['unsavedWarningSharedService',
    function(unsavedWarningSharedService) {
        return {
            scope: {},
            require: '^form',
            priority: 10,
            link: function(scope, element, attrs, formCtrl) {
                element.bind('click', function(event) {
                    formCtrl.$setPristine();
                });

            }
        };
    }
])

.directive('unsavedWarningForm', ['unsavedWarningSharedService', '$rootScope',
    function(unsavedWarningSharedService, $rootScope) {
        return {
            scope: {},
            require: '^form',
            link: function(scope, formElement, attrs, formCtrl) {

                // @todo refactor, temp fix for issue #22
                // where user might use form on element inside a form
                // we shouldnt need isolate scope on this, but it causes the tests to fail
                // traverse up parent elements to find the form.
                // we need a form element since we bind to form events: submit, reset
                var count = 0;
                while(formElement[0].tagName !== 'FORM' && count < 3) {
                    count++;
                    formElement = formElement.parent();
                }
                if(count >= 3) {
                    throw('unsavedWarningForm must be inside a form element');
                }

                // register this form
                unsavedWarningSharedService.init(formCtrl);

                // bind to form submit, this makes the typical submit button work
                // in addition to the ability to bind to a seperate button which clears warning
                formElement.bind('submit', function(event) {
                    if (formCtrl.$valid) {
                        formCtrl.$setPristine();
                    }
                });

                // bind to form submit
                // developers can hook into resetResettables to do
                // do things like reset validation, present messages, etc.
                formElement.bind('reset', function(event) {
                    event.preventDefault();
                    
                    // trigger resettables within this form or element 
                    var resettables = angular.element(formElement[0].querySelector('[resettable]'));
                    if(resettables.length) {
                        scope.$apply(resettables.triggerHandler('resetResettables'));    
                    }

                    // sets for back to valid and pristine states
                    formCtrl.$setPristine();
                });

                // @todo check destroy on clear button too?
                scope.$on('$destroy', function() {
                    unsavedWarningSharedService.removeForm(formCtrl);
                });
            }
        };
    }
]);


/**
 * --------------------------------------------
 * resettable models adapted from vitalets lazy model
 * @see https://github.com/vitalets/lazy-model/
 *
 * The main difference is that we DO set the model value
 * as the user changes the inputs. However we provide a hook
 * to reset the model to original value. This we can then
 * broadcast on from reset which triggers resettable to revert
 * to original value.
 * --------------------------------------------
 *
 * @note we don't create a seperate scope so the model value
 * is still available onChange within the controller scope. 
 * This fixes https://github.com/facultymatt/angular-unsavedChanges/issues/19
 *
 */
angular.module('resettable', [])

.directive('resettable', ['$parse', '$compile', '$rootScope',
    function($parse, $compile, $rootScope) {

        return {
            restrict: 'A',
            link: function postLink(scope, elem, attr, ngModelCtrl) {

                var setter, getter, originalValue;

                // save getters and setters and store the original value.
                attr.$observe('ngModel', function(newValue) {
                    getter = $parse(attr.ngModel);
                    setter = getter.assign;
                    originalValue = getter(scope);
                });

                // reset our form to original value
                var resetFn = function() {
                    setter(scope, originalValue);
                };

                elem.on('resetResettables', resetFn);

                // @note this doesn't work if called using
                // $rootScope.on() and $rootScope.$emit() pattern
                var removeListenerFn = scope.$on('resetResettables', resetFn);
                scope.$on('$destroy', removeListenerFn);

            }
        };
    }
]);

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.toolbar')
            .controller('ToolbarController', ToolbarController)
            .controller('ModalController', ModalController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdDialog, $q, $state, $cookies, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, api, $cookieStore)
    {
        var vm = this;
        vm.api = api;




        // Data
        $rootScope.searchQuery = '';

        $rootScope.global = {
            search: ''
        };
        if (!$cookies.getObject('user')) {
            $state.go('app.sprardb_auth_login');
        }
        var user = $cookies.getObject('user');
        if (angular.isUndefined(user.persona_id) || angular.isUndefined(user.primoAccessoEffettuato)) {
            $state.go('app.sprardb_auth_login');
        }
        if (user.primoAccessoEffettuato === 0 || user.privacy === 0 || user.postlogin === 0) {
            $state.go('app.sprardb_personasdettaglio2', {id: user.persona_id});
        }
        vm.userNome = user.nome + ' ' + user.cognome;
        vm.persona_id = user.persona_id;

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            it: {
                'title': 'Italiano',
                'translation': 'TOOLBAR.ITALIAN',
                'code': 'it',
                'flag': 'it'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };


        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            vm.api.users.log.out(user.id,function (r){
                    $cookies.remove('user');
                    $cookies.remove('ente_id');
                    $cookies.remove('progetto_id');
                    $cookies.remove('ALL_p_id');
                    $cookies.remove('ALL_s_id');
                    $cookies.putObject('user', {autorizzato: 0});
                    $state.go('app.sprardb_auth_login');
            })
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en')
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                    flatNavigation = msNavigationService.getFlatNavigation(),
                    deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++)
            {
                if (flatNavigation[x].uisref)
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query)
            {
                navigation = navigation.filter(function (item)
                {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1)
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if (item.uisref)
            {
                // If there are state params,
                // use them...
                if (item.stateParams)
                {
                    $state.go(item.state, item.stateParams);
                } else
                {
                    $state.go(item.state);
                }
            }
        }

        vm.disableTel = true;
        if(user.telefono == null || user.telefono == ''){
            vm.disableTel = false;
        }
        ////////////////
        vm.ticket = {
            parent: '',
            topicId: 0,
            phone: user.telefono,
            email: user.email,
            name: vm.userNome,
            subject: '',
            message: '',
            ip: '127.0.0.1'
        };


        vm.parentTopics = {0:'Gestione Progetto/Beneficiari',1:'Gestione Rendicontazione'};
        vm.childrenTopics = {};
        vm.resultTicket = '';
        vm.resetTicket = resetTicket;
        vm.chooseParentTopic = chooseParentTopic;
        vm.sendTicket = sendTicket;
        vm.openDialog = openDialog;
        ///////////////


        function openDialog(ev) {
            $mdDialog.show({
                controller: 'ModalController',
                controllerAs: 'vmd',
                templateUrl: 'app/toolbar/layouts/dialogs/dialogTrasferimenti.html',
                //parent: angular.element($document.find('#progetto-extras')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    userNome: vm.userNome
                }
            });
        }



        function resetTicket() {
            vm.ticket = {
                phone: user.telefono,
                email: user.email,
                name: vm.userNome,
                ip: '127.0.0.1'
            };
            var mydata = ['SPRAR', 0, 1, 1];
            //api.tickets.categorie.get({'data[]': mydata}, function (d) {
              //  vm.parentTopics = d;
            //});
            //vm.childrenTopics = {};
            vm.resultTicket = '';

            vm.caricaProfili();
        }
        function chooseParentTopic() {
            if(vm.ticket.parent == 'Gestione Rendicontazione'){
                vm.childrenTopics = {1:'Segnalazione/Richiesta chiarimenti'};
            }else if (vm.ticket.parent =='Gestione Progetto/Beneficiari'){
                vm.childrenTopics = {1:'Rettifiche Anagrafiche Beneficiari',2: 'Aggiornamento Status Giuridico',
                                     3:'Problemi Richiesta Proroghe',4:'Aggiornamento Progetto',
                                     5: 'Problemi sperimentazione SIM',
                                     6:'Gestione Corsi e Servizi',7:'Altro'};
            }

        }
        function sendTicket() {
            api.ticketmc.crea(vm.ticket,function(d){
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Segnalazione inviata!')
                        .textContent('La sua richiesta di supporto è stata creata ed inviata correttamente al Servizio Centrale.')
                        .ariaLabel('Segnalazione')
                        .ok('OK')
                );
            });
        }

        //---------------------------------

        vm.profileForm = {
            progetto_id: ($cookies.getObject('progetto_id') ? $cookies.getObject('progetto_id') : null),
            ente_id: ($cookies.getObject('ente_id') ? $cookies.getObject('ente_id') : null)
        };
        vm.profileProgettos = [];
        vm.profileEntes = [];
        vm.profileBeneficiari =[];
        vm.progettos = [];
        vm.caricaProfili = caricaprofili;
        vm.chooseProgettoId = chooseProgettoId;
        vm.chooseEnteId = chooseEnteId;
        vm.chooseProgettoId2 = chooseProgettoId2;
        vm.chooseEnteId2 = chooseEnteId2;
        vm.caricaProgetti = caricaProgetti;
        vm.epp = false;
        vm.epe = false;
        vm.opp = 1;
        vm.ope = 1;
        vm.profileName = null;

        ///////////////

        function caricaProgetti(){
            api.progettomc.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1, dacl: 1}, function (r) {
                vm.progettos = r.data;
            });
        }

        function caricaprofili() {
            var query = {
                'query[]': [],
                pagination: 30,
                page: 1,
                operatore: 'AND',
                sort: '-id',
                dacl: 1
            };
            query['query[]'].push({operatore: 'OR'});
            if ($cookies.getObject('ALL_s_id') !== "" && angular.isDefined($cookies.getObject('ALL_s_id'))) {
                query['query[]'].push({operatore: 'AND', 'id_IN': $cookies.getObject('ALL_s_id')});
            } else {
                query['query[]'].push({operatore: 'AND', 'id_IN': [-10000]});
            }

            var query2 = {
                'query[]': [],
                pagination: 30,
                page: 1,
                operatore: 'AND',
                sort: '-id',
            };
            query2['query[]'].push({operatore: 'OR'});
            if ($cookies.getObject('ALL_p_id') !== "" && angular.isDefined($cookies.getObject('ALL_p_id'))) {
                query2['query[]'].push({operatore: 'AND', 'id_IN': $cookies.getObject('ALL_p_id')});
            } else {
                query2['query[]'].push({operatore: 'AND', 'id_IN': [-10000]});
            }

            api.entes.ente.search(query, function (es) {
                vm.profileEntes = es.data;
                //visualizza nome
                vm.profileName = null;
                var indexTrovato = vm.profileEntes.map(function (o) {
                    return o.id;
                }).indexOf(vm.profileForm.ente_id);
                if (indexTrovato > -1) {
                    vm.profileName = vm.profileEntes[indexTrovato].nome;
                }
                if (es.data.length > 0) {
                    vm.profileEntes.push({id: null, nome: 'NESSUNA SELEZIONE'});
                    vm.epe = true;
                }
            });

            api.beneficiarios.beneficiario.search(query, function (response) {
                vm.profileBeneficiari = response.data;
                vm.selectedBeneficiarioName = null;
                // Trova l'indice del beneficiario selezionato
                var indexTrovato = vm.profileBeneficiari.findIndex(function (beneficiario) {
                    return beneficiario.id === vm.profileForm.beneficiario_id;
                });

                // Se il beneficiario selezionato è stato trovato, assegna il nome
                if (indexTrovato > -1) {
                    vm.selectedBeneficiarioName = vm.profileBeneficiari[indexTrovato].nome;
                    vm.selectedBeneficiarioCognome = vm.profileBeneficiari[indexTrovato].cognome;
                }

                // Aggiungi un'opzione "NESSUNA SELEZIONE" se ci sono beneficiari
                if (response.data.length > 0) {
                    vm.profileBeneficiari.push({ id: null, nome: 'NESSUNA SELEZIONE' });
                    vm.hasBeneficiari = true;
                }
            });

            api.progettomc.search(query2, function (ps) {
                vm.profileProgettos = ps.data;
                //visualizza nome
                vm.profileName = null;
                var indexTrovato = vm.profileProgettos.map(function (o) {
                    return o.id;
                }).indexOf(vm.profileForm.progetto_id);
                if (indexTrovato > -1) {
                    vm.profileName = vm.profileProgettos[indexTrovato].nome;
                }
                if (ps.data.length > 0) {
                    vm.profileProgettos.push({id: null, nome: 'NESSUNA SELEZIONE'});
                    vm.epp = true;
                }
            });
        }
        vm.caricaProfili();
        vm.caricaProgetti();

        function chooseProgettoId() {
            vm.profileForm.ente_id = null;
            vm.opp = 1;
            vm.ope = 0.5;
            $cookies.putObject('progetto_id', vm.profileForm.progetto_id);
            $cookies.remove('ente_id');

            angular.forEach(vm.profileProgettos, function (v) {
                if (v.id == vm.profileForm.progetto_id) {
                    vm.profileName = v.nome;
                    vm.ticket.progetto = v.nome;
                }
            });
            api.reloadm();
            $state.reload();

        }

        function chooseEnteId() {
            vm.profileForm.progetto_id = null;
            vm.opp = 0.5;
            vm.ope = 1;
            $cookies.putObject('ente_id', vm.profileForm.ente_id);
            $cookies.remove('progetto_id');
            angular.forEach(vm.profileEntes, function (v) {
                if (v.id == vm.profileForm.ente_id) {
                    vm.profileName = v.nome;
                    vm.ticket.ente = v.nome;
                }
            });
            api.reloadm();
            $state.reload();
        }
        function chooseProgettoId2() {
            angular.forEach(vm.profileProgettos, function (v) {
                if (v.id == vm.ticket.progetto_id) {
                    vm.ticket.progetto = v.nome;
                }
            });
            api.reloadm();


        }

        function chooseEnteId2() {
            angular.forEach(vm.profileEntes, function (v) {
                if (v.id == vm.ticket.ente_id) {
                    vm.ticket.ente = v.nome;
                }
            });
            api.reloadm();

        }

        vm.gotoProfilo = gotoProfilo;
        function gotoProfilo() {
            $state.go('app.sprardb_personasdettaglio2', {id: vm.persona_id});

        }
    }

    function ModalController($rootScope, $scope, $mdDialog,$filter, $q, $state, $cookies, api, locals) {
        // Inizializza variabili e funzioni necessarie per la finestra modale

        $scope.closeModal = function () {
          $mdDialog.hide(); // Chiudi la finestra modale quando necessario
        };

        var vmd = this;
        vmd.api = api;
        vmd.locals = locals;
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "NAZIONE", sort: "descrizione", pagination: -1}, function (r) {
          vmd.nazioni = r.data;
        });

        $rootScope.searchQuery = '';

        $rootScope.global = {
            search: ''
        };
        if (!$cookies.getObject('user')) {
            $state.go('app.sprardb_auth_login');
        }
        var user = $cookies.getObject('user');
        if (angular.isUndefined(user.persona_id) || angular.isUndefined(user.primoAccessoEffettuato)) {
            $state.go('app.sprardb_auth_login');
        }
        if (user.primoAccessoEffettuato === 0 || user.privacy === 0 || user.postlogin === 0) {
            $state.go('app.sprardb_personasdettaglio2', {id: user.persona_id});
        }
        vmd.dataArrivo = null;
        vmd.userNome = vmd.locals.userNome;
        vmd.persona_id = user.persona_id;
        vmd.userEmail = user.email;
        vmd.userPhone = user.telefono;
        vmd.bodyEl = angular.element('body');
        vmd.disableTel = !(user.telefono == null || user.telefono === '');

        vmd.ticketConferma = {
            parent:'Beneficiario Trasferito',
            topicId: 0,
            phone: vmd.userPhone,
            email: vmd.userEmail,
            name: vmd.userNome,
            subject: '',
            message: '',
            nome: '',
            cognome : '',
            progettoPartenza:'',
            progettoDestinazione: '',
            codice: '',
            struttura: '',
            dataArrivo: '',
            ip: '127.0.0.1'
        };
        vmd.parentTopics = {0:'Gestione Progetto/Beneficiari',1:'Gestione Rendicontazione'};
        vmd.childrenTopics = {};
        vmd.resultTicket = '';
        $scope.formatDate = function (name) {
            // Verifica se vmd.ticketConferma.dataArrivo è una data valida
            if (vmd.ticketConferma[name] instanceof Date) {
                // Formatta la data nel formato desiderato ('yyyy-MM-dd')
                vmd.ticketConferma[name] = $filter('date')(vmd.ticketConferma[name], 'dd/MM/yyyy');
            }
        };


        vmd.sendTicketTrasferimento = sendTicketTrasferimento;
        ///////////////
        function sendTicketTrasferimento() {
            //Sviluppo data

            vmd.ticketConferma.progettoDestinazione = vmd.progettoDestinazione.id;
            api.ticketmc.crea(vmd.ticketConferma,function(d){
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Richiesta di trasferimento inviata all\'assistenza banca dati')
                        .textContent('Richiesta inviata correttamente al Servizio Centrale, nei prossimi giorni il servizio di Help Desk provvederà ad effettuare il trasferimento del beneficiario in banca dati.')
                        .ariaLabel('Conferma')
                        .ok('OK')
                );
            });
        }

        //---------------------------------

        vmd.profileForm = {
            progetto_id: ($cookies.getObject('progetto_id') ? $cookies.getObject('progetto_id') : null),
            ente_id: ($cookies.getObject('ente_id') ? $cookies.getObject('ente_id') : null)
        };
        vmd.ricerca = {};
        vmd.profileProgettos = [];
        vmd.profileEntes = [];
        vmd.profileBeneficiari =[];
        vmd.progettos = [];
        vmd.strutturas = [];
        vmd.epp = false;
        vmd.epe = false;
        vmd.opp = 1;
        vmd.ope = 1;
        vmd.profileName = null;

        vmd.searchStrutturas = searchStrutturas;
        vmd.caricaProfili = caricaprofili;

        function caricaprofili() {
          var query = {
              'query[]': [],
              pagination: 30,
              page: 1,
              operatore: 'AND',
              sort: '-id',
              dacl: 1
          };
          query['query[]'].push({operatore: 'OR'});
          if ($cookies.getObject('ALL_s_id') !== "" && angular.isDefined($cookies.getObject('ALL_s_id'))) {
              query['query[]'].push({operatore: 'AND', 'id_IN': $cookies.getObject('ALL_s_id')});
          } else {
              query['query[]'].push({operatore: 'AND', 'id_IN': [-10000]});
          }

          var query2 = {
              'query[]': [],
              pagination: 30,
              page: 1,
              operatore: 'AND',
              sort: '-id',
          };
          query2['query[]'].push({operatore: 'OR'});
          if ($cookies.getObject('ALL_p_id') !== "" && angular.isDefined($cookies.getObject('ALL_p_id'))) {
              query2['query[]'].push({operatore: 'AND', 'id_IN': $cookies.getObject('ALL_p_id')});
          } else {
              query2['query[]'].push({operatore: 'AND', 'id_IN': [-10000]});
          }

          api.entes.ente.search(query, function (es) {
              vmd.profileEntes = es.data;
              //visualizza nome
              vmd.profileName = null;
              var indexTrovato = vmd.profileEntes.map(function (o) {
                  return o.id;
              }).indexOf(vmd.profileForm.ente_id);
              if (indexTrovato > -1) {
                  vmd.profileName = vmd.profileEntes[indexTrovato].nome;
              }
              if (es.data.length > 0) {
                  vmd.profileEntes.push({id: null, nome: 'NESSUNA SELEZIONE'});
                  vmd.epe = true;
              }

          });


          api.progettomc.search(query2, function (ps) {
              vmd.profileProgettos = ps.data;
              //visualizza nome
              vmd.profileName = null;
              var indexTrovato = vmd.profileProgettos.map(function (o) {
                  return o.id;
              }).indexOf(vmd.profileForm.progetto_id);
              if (indexTrovato > -1) {
                  vmd.profileName = vmd.profileProgettos[indexTrovato].nome;
              }
              if (ps.data.length > 0) {
                  vmd.profileProgettos.push({id: null, nome: 'NESSUNA SELEZIONE'});
                  vmd.epp = true;
              }
          });
        }

        // vmd.prendiBen = function(){
        //     if(vmd.ticketConferma.codice.length > 5){
        //         api.beneficiarios.beneficiario.get({id: vmd.ticketConferma.codice}, function (d) {
        //             console.log(d);
        //             vmd.dataInserimentoBen = d.dataInserimento;
        //             console.log(vmd.dataInserimentoBen);

        //             // Aggiorna md-min-date solo se la data di inserimento del beneficiario è stata recuperata con successo
        //             if (vmd.dataInserimentoBen) {
        //                 // Imposta md-min-date sulla data di inserimento del beneficiario
        //                 $scope.minData = new Date(vmd.dataInserimentoBen);
        //             }
        //         });
        //     }
        // }



        // Definizione della funzione searchStrutturas
        function searchStrutturas() {
            // Verifica se vmd.profileProgettos è definito e diverso da null
            if (vmd.profileProgettos != null && vmd.profileProgettos != undefined && vmd.progettoDestinazione && vmd.progettoDestinazione.id !== null) {
                // Esegui una chiamata API per ottenere le strutture in base ai progetti territoriali selezionati
              api.strutturas.strutturamin.cerca({
                pagination: 10000,
                progetto_id: vmd.progettoDestinazione.id, //In questo modo prendo l'id del progetto selezionato
                attivo: 1 // Filtra per strutture attive
              }, function (response) {
                // Assegna le strutture filtrate a vmd.strutturas
                vmd.strutturas = response.data;
              });
            } else {
                // In caso contrario, imposta vmd.strutturas a un array vuoto
                vmd.strutturas = [];
            }
        }
        vmd.caricaProfili();
      }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';
    angular
            .module('app.navigation', [
                'app.config'
            ])
            .config(config);
    /** @ngInject */
    function config(msNavigationServiceProvider, ENV_DEV)
    {
        var menus = {
            "scadmin": {
                "title": "",
                "group": true
            },
            "scaccoglienza": {
                "title": "",
                "group": true
            },
            "scsegreteria": {
                "title": "",
                "group": true
            },
            "screndicontazione": {
                "title": "",
                "group": true
            },
            "scconsulente di rendicontazione": {
                "title": "",
                "group": true
            },
            "sctutor": {
                "title": "",
                "group": true
            },
            "scconsulente assistenza": {
                "title": "",
                "group": true
            },
            "scfrontend": {
                "title": "",
                "group": true
            },
            "segnalatore": {
                "title": "",
                "group": true
            },
            "pramministratore": {
                "title": "",
                "group": true
            },
            "properatore": {
                "title": "",
                "group": true
            },
            "prrendicontazione": {
                "title": "",
                "group": true
            },
            "prentegestore": {
                "title": "",
                "group": true
            },
            "visitatore": {
                "title": "",
                "group": true
            },
            "revisorecontabile": {
              "title": "",
              "group": true
            },
            "revisorecontabile.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scadmin.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            /*"scadmin.segnalazioni.ricercasegnalazioni": {  //LOR: commentate come richiesta Maurenzi
                "title": "Ricerca segnalazioni",
                "icon": "icon-view-list",
                "state": "app.sprardb_notification",
                "weight": 1
            },
            "scadmin.segnalazioni.nuovasegnalazione": {
                "title": "Nuova segnalazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovasegnalazione",
                "weight": 2
            },*/
            "scadmin.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "scadmin.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "scadmin.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
            /*"scadmin.segnalazioni.ricercasegnalati": {  //LOR: commentate come richiesta Maurenzi
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
           /* "scadmin.entisegnalatori": {
                "title": "ENTISEGNALATORI",            //LOR: commentate come richiesta Maurenzi
                "weight": 20
            },
            "scadmin.entisegnalatori.entes": {
                "title": "Enti Segnalatori",
                "icon": "icon-sign-caution",
                "state": "app.sprardb_entisegnalatori",
                "weight": 1
            },
            "scadmin.entisegnalatori.segnalatori": {
                "title": "Segnalatori",
                "icon": "icon-account-check",
                "state": "app.sprardb_segnalatori",
                "weight": 2
            },*/
            "scadmin.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            /*"scadmin.lavorazione_segnalati.segEnte": {       //LOR: commentate come richiesta Maurenzi
                "title": "Segnalati Enti segn",
                "icon": "icon-human-child",
                "state": "app.segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },*/
            "scadmin.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "scadmin.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "scadmin.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "scadmin.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 5
            },
            "scadmin.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "scadmin.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },

            "scadmin.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "scadmin.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            /*"scadmin.beneficiari.incompletil": {       //LOR: commentate come richiesta Maurenzi
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "scadmin.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            "scadmin.beneficiari.trasferimento": {
                "title": "Lavora trasferimenti",
                "icon": "icon-account-switch",
                "state": "app.sprardbEventib({eventoTipo_id:1013})",
                "weight": 5
            },
           /* "scadmin.beneficiari.uscitab": {        //LOR: commentate come richiesta Maurenzi
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "scadmin.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "scadmin.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scadmin.progetti.new": {
                "title": "Nuovo Progetto",
                "icon": "icon-plus-network",
                "state": "app.sprardb_progetti_nuovo",
                "weight": 2
            },
            "scadmin.progetti.rendicontazioni": {
                "title": "RENDICONTAZIONI",
                "weight": 3
            },
            "scadmin.progetti.rendicontazioni.setup": {
                "title": "Setup",
                "icon": "icon-cog",
                "state": "app.sprardb_rendicontazioni_setup({attivo:1})",
                "weight": 2
            },
           /* "scadmin.progetti.monitoraggio": {
                "title": "Monitoraggio",
                "weight": 4
            },
            "scadmin.progetti.monitoraggio.all": {
                "title": "Ricerca",
                "icon": "icon-image-filter-center-focus",
                "state": "app.sprardb_monitoraggio",
                "weight": 1
            },*/
            "scadmin.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "scadmin.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "scadmin.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "scadmin.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "scadmin.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "scadmin.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
            /*"scadmin.protocolloentrata": {         //LOR: commentate come richiesta Maurenzi
                "title": "Protocollo entrata",
                "weight": 70
            },
            "scadmin.protocolloentrata.segnalazionienti": {
                "title": "Mod.segnalaz. ente",
                "icon": "icon-basket-fill",
                "state": "app.protocollo_segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },
            "scadmin.protocollouscita": {
                "title": "Protocollo uscita",
                "weight": 80
            },
            "scadmin.protocollouscita.segnalazionearrivo": {
                "title": "Lettera inserimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 1
            },
            "scadmin.protocollouscita.trasferimento": {
                "title": "Lettera trasferimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_trasferimenti({eventoTipo_id:1013})",
                "weight": 2
            },*/
            "scadmin.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "scadmin.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "scadmin.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
            /*"scadmin.documenti": {
                "title": "Documenti",
                "weight": 100
            },
            "scadmin.documenti.new": {
                "title": "Carica documento",
                "icon": "icon-box-upload",
                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
                "weight": 1
            },
            "scadmin.documenti.my": {
                "title": "I miei documenti",
                "icon": "icon-heart-outline",
                "state": "app.sprardb_documenti",
                "weight": 2
            },*/
            "scadmin.report": {
                "title": "Report",
                "weight": 500
            },
            "scadmin.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "scadmin.report.schedamonitoraggioNuovo": {
                "title": "Visite Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggioNuovo",
                "weight": 1
            },
            "scadmin.report.schedasalnuovo": {
                "title": "SAL - MONITORAGGIO",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedasalnuovo",
                "weight": 1
            },
            "scadmin.report.reportbgenere": {
                "title": "Beneficiari per genere",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbgenere",
                "weight": 3
            },
            "scadmin.report.reportbpermessi": {
                "title": "Ben. per tipo soggiorno",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbpermessi",
                "weight": 5
            },
            "scadmin.report.reportbnuclei":{
                "title": "Ben. per nuclei familiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportreportbnuclei",
                "weight": 6
            },
            "scadmin.report.reportbprogetti":{
                "title": "Ben. per progetti",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbprogetti",
                "weight": 7
            },
            "scadmin.report.reportbnazionalita":{
                "title": "Ben. per nazionalita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbnazionalita",
                "weight": 8
            },
            "scadmin.report.reportmotiviuscita":{
                "title": "Ben. per motivi uscita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmotiviuscita",
                "weight": 9
            },
            "scadmin.report.reportbmodlitaingresso":{
                "title": "Ben. per mod. ingresso",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmodalitaingresso",
                "weight": 10
            },
            "scadmin.report.reportbclassieta": {
                "title": "Ben. per classi eta",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbclassieta",
                "weight": 11
            },
            "scadmin.report.reportcorsi": {
                "title": "Corsi e Servizi",
                "icon": "icon-book-open",
                "state": "app.sprardb_reportcorsi",
                "weight": 12
            },
            "scadmin.report.reportcomunistruttura":{
                "title": "Comuni Sede Struttura",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportcomunistruttura",
                "weight": 13
            },
            "scadmin.report.reportbeneficiarinumerico":{
                "title": "Numerico Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportbeneficiarinumerico",
                "weight": 14
            },
            "scadmin.report.reportstrutturetipologia":{
                "title": "Strutture per Tipologia",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportstrutturetipologia",
                "weight": 15
            },
            "scadmin.report.reportpostidisponibili":{
                 "title": "Posti diponibili per centro",
                 "icon": "icon-account-multiple-outline",
                 "state": "app.reportpostidisponibili",
                 "weight": 16
            },
            "scadmin.report.reportbeneficiaridettgli":{
                "title": "Dettaglio Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaridettgli",
                "weight": 17
            },
            "scadmin.report.reportbeneficiaricovid":{
                "title": "Beneficiari Covid",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaricovid",
                "weight": 18
            },
            "scadmin.report.reportministero":{
              "title": "Numerico Nuclei Ucraini",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportministero",
              "weight": 21
            },
            "scadmin.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "scadmin.report.reportproroghelavorate":{
              "title": "Proroghe Lavorate",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghelavorate",
              "weight": 20
            },
            "scadmin.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "scadmin.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },
            "scadmin.report.reportchecklistmonitoraggio": {
              "title": "check list monitoraggio",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportchecklistmonitoraggio",
              "weight": 32
            },
            "scsegreteria.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
           /* "scsegreteria.segnalazioni.ricercasegnalazioni": {   //LOR: commentate come richiesta Maurenzi
                "title": "Ricerca segnalazioni",
                "icon": "icon-view-list",
                "state": "app.sprardb_notification",
                "weight": 1
            },
            "scsegreteria.segnalazioni.nuovasegnalazione": {
                "title": "Nuova segnalazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovasegnalazione",
                "weight": 2
            },*/
            "scsegreteria.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "scsegreteria.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "scsegreteria.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
           /* "scsegreteria.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
           /* "scsegreteria.entisegnalatori": {     //LOR: commentate come richiesta Maurenzi
                "title": "ENTISEGNALATORI",
                "weight": 20
            },
            "scsegreteria.entisegnalatori.entes": {
                "title": "Enti Segnalatori",
                "icon": "icon-sign-caution",
                "state": "app.sprardb_entisegnalatori",
                "weight": 1
            },
            "scsegreteria.entisegnalatori.segnalatori": {
                "title": "Segnalatori",
                "icon": "icon-account-check",
                "state": "app.sprardb_segnalatori",
                "weight": 2
            },*/
            "scsegreteria.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "scsegreteria.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scsegreteria.protocolloentrata": {
                "title": "Protocollo entrata",
                "weight": 70
            },
            "scsegreteria.protocolloentrata.segnalazionienti": {
                "title": "Mod.segnalaz. ente",
                "icon": "icon-basket-fill",
                "state": "app.protocollo_segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },
            "scsegreteria.protocollouscita": {
                "title": "Protocollo uscita",
                "weight": 80
            },
            "scsegreteria.protocollouscita.segnalazionearrivo": {
                "title": "Lettera inserimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 1
            },
            "scsegreteria.protocollouscita.trasferimento": {
                "title": "Lettera trasferimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_trasferimenti({eventoTipo_id:1013})",
                "weight": 2
            },
            "scsegreteria.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "scsegreteria.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "scsegreteria.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
           /* "scsegreteria.documenti": {
                "title": "Documenti",
                "weight": 100
            },
            "scsegreteria.documenti.new": {
                "title": "Carica documento",
                "icon": "icon-box-upload",
                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
                "weight": 1
            },
            "scsegreteria.documenti.my": {
                "title": "I miei documenti",
                "icon": "icon-heart-outline",
                "state": "app.sprardb_documenti",
                "weight": 2
            },*/
            "scaccoglienza.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            /*"scaccoglienza.segnalazioni.ricercasegnalazioni": {
                "title": "Ricerca segnalazioni",
                "icon": "icon-view-list",
                "state": "app.sprardb_notification",
                "weight": 1
            },
            "scaccoglienza.segnalazioni.nuovasegnalazione": {
                "title": "Nuova segnalazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovasegnalazione",
                "weight": 2
            },*/
            "scaccoglienza.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "scaccoglienza.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "scaccoglienza.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
           /* "scaccoglienza.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
            /*"scaccoglienza.entisegnalatori": {
                "title": "ENTISEGNALATORI",
                "weight": 20
            },
            "scaccoglienza.entisegnalatori.entes": {
                "title": "Enti Segnalatori",
                "icon": "icon-sign-caution",
                "state": "app.sprardb_entisegnalatori",
                "weight": 1
            },
            "scaccoglienza.entisegnalatori.segnalatori": {
                "title": "Segnalatori",
                "icon": "icon-account-check",
                "state": "app.sprardb_segnalatori",
                "weight": 2
            },*/
            "scaccoglienza.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            /*"scaccoglienza.lavorazione_segnalati.segEnte": {
                "title": "Segnalati Enti segn",
                "icon": "icon-human-child",
                "state": "app.segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },*/
            "scaccoglienza.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "scaccoglienza.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "scaccoglienza.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 3
            },
            "scaccoglienza.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "scaccoglienza.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "scaccoglienza.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "scaccoglienza.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "scaccoglienza.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            /*"scaccoglienza.beneficiari.incompletil": {    //LOR: commentate come richiesta Maurenzi
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "scaccoglienza.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            "scaccoglienza.beneficiari.trasferimento": {
                "title": "Lavora trasferimenti",
                "icon": "icon-account-switch",
                "state": "app.sprardbEventib({eventoTipo_id:1013})",
                "weight": 5
            },
            /*"scaccoglienza.beneficiari.uscitab": {   //LOR: commentate come richiesta Maurenzi
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "scaccoglienza.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "scaccoglienza.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scaccoglienza.progetti.new": {
                "title": "Nuovo Progetto",
                "icon": "icon-plus-network",
                "state": "app.sprardb_progetti_nuovo",
                "weight": 2
            },
            "scaccoglienza.progetti.rendicontazioni": {
                "title": "RENDICONTAZIONI",
                "weight": 3
            },
            "scaccoglienza.progetti.rendicontazioni.setup": {
                "title": "Setup",
                "icon": "icon-cog",
                "state": "app.sprardb_rendicontazioni_setup({attivo:1})",
                "weight": 2
            },
           /* "scaccoglienza.progetti.monitoraggio": {     //LOR: commentate come richiesta Maurenzi
                "title": "Monitoraggio",
                "weight": 4
            },
            "scaccoglienza.progetti.monitoraggio.all": {
                "title": "Ricerca",
                "icon": "icon-image-filter-center-focus",
                "state": "app.sprardb_monitoraggio",
                "weight": 1
            },*/
            "scaccoglienza.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "scaccoglienza.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "scaccoglienza.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "scaccoglienza.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "scaccoglienza.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "scaccoglienza.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
           /* "scaccoglienza.protocolloentrata": {
                "title": "Protocollo entrata",
                "weight": 70
            },
            "scaccoglienza.protocolloentrata.segnalazionienti": {
                "title": "Mod.segnalaz. ente",
                "icon": "icon-basket-fill",
                "state": "app.protocollo_segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },
            "scaccoglienza.protocollouscita": {
                "title": "Protocollo uscita",
                "weight": 80
            },
            "scaccoglienza.protocollouscita.segnalazionearrivo": {
                "title": "Lettera inserimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 1
            },
            "scaccoglienza.protocollouscita.trasferimento": {
                "title": "Lettera trasferimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_trasferimenti({eventoTipo_id:1013})",
                "weight": 2
            },*/
            "scaccoglienza.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "scaccoglienza.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "scaccoglienza.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
           /* "scaccoglienza.documenti": {
                "title": "Documenti",
                "weight": 100
            },
            "scaccoglienza.documenti.new": {
                "title": "Carica documento",
                "icon": "icon-box-upload",
                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
                "weight": 1
            },
            "scaccoglienza.documenti.my": {
                "title": "I miei documenti",
                "icon": "icon-heart-outline",
                "state": "app.sprardb_documenti",
                "weight": 2
            },*/
            "scaccoglienza.report": {
                "title": "Report",
                "weight": 500
            },
            "scaccoglienza.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "scaccoglienza.report.reportbgenere": {
                "title": "Beneficiari per genere",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbgenere",
                "weight": 3
            },
            "scaccoglienza.report.reportbpermessi": {
                "title": "Ben. per tipo documento",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbpermessi",
                "weight": 5
            },
            "scaccoglienza.report.reportbnuclei": {
                "title": "Ben. per nuclei familiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportreportbnuclei",
                "weight": 6
            },
            "scaccoglienza.report.reportbprogetti": {
                "title": "Ben. per progetti",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbprogetti",
                "weight": 7
            },
            "scaccoglienza.report.reportbnazionalita": {
                "title": "Ben. per nazionalita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbnazionalita",
                "weight": 8
            },
            "scaccoglienza.report.reportmotiviuscita":{
                "title": "Ben. per motivi uscita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmotiviuscita",
                "weight": 9
            },
            "scaccoglienza.report.reportbclassieta": {
                "title": "Ben. per classi eta",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbclassieta",
                "weight": 11
            },
            "scaccoglienza.report.reportcomunistruttura": {
                "title": "Comuni Sede Struttura",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportcomunistruttura",
                "weight": 12
            },
            "scaccoglienza.report.reportcorsi": {
                "title": "Corsi e Servizi",
                "icon": "icon-book-open",
                "state": "app.sprardb_reportcorsi",
                "weight": 13
            },
            "scaccoglienza.report.reportbeneficiarinumerico": {
                "title": "Numerico Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportbeneficiarinumerico",
                "weight": 14
            },
            "scaccoglienza.report.reportstrutturetipologia": {
                "title": "Strutture per Tipologia",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportstrutturetipologia",
                "weight": 15
            },
             "scaccoglienza.report.reportpostidisponibili":{
                 "title": "Posti diponibili per centro",
                 "icon": "icon-account-multiple-outline",
                 "state": "app.reportpostidisponibili",
                 "weight": 16
             },
            "scaccoglienza.report.reportbeneficiaridettgli": {
                "title": "Dettaglio Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaridettgli",
                "weight": 17
            },
            "scaccoglienza.report.reportbeneficiaricovid":{
              "title": "Beneficiari Covid",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbeneficiaricovid",
              "weight": 18
            },
            "scaccoglienza.report.reportministero":{
              "title": "Numerico Nuclei Ucraini",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportministero",
              "weight": 21
            },
            "scaccoglienza.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "scaccoglienza.report.reportproroghelavorate":{
              "title": "Proroghe Lavorate",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghelavorate",
              "weight": 20
            },
            "scaccoglienza.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "scaccoglienza.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },
            "scaccoglienza.report.reportchecklistmonitoraggio": {
              "title": "check list monitoraggio",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportchecklistmonitoraggio",
              "weight": 32
            },
            "properatore.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            "properatore.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "properatore.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "properatore.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
            /*"properatore.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
            "properatore.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            "properatore.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "properatore.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "properatore.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "properatore.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "properatore.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "properatore.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "properatore.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "properatore.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
           /* "properatore.beneficiari.incompletil": {
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "properatore.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            /*"properatore.beneficiari.uscitab": {
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "properatore.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "properatore.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "properatore.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "properatore.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "properatore.proroga.richiesteautorizzare": {
                "title": "Pendenti",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "properatore.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "properatore.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "properatore.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
//            "properatore.documenti": {
//                "title": "Documenti",
//                "weight": 100
//            },
//            "properatore.documenti.new": {
//                "title": "Carica documento",
//                "icon": "icon-box-upload",
//                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
//                "weight": 1
//            },
//            "properatore.documenti.my": {
//                "title": "I miei documenti",
//                "icon": "icon-heart-outline",
//                "state": "app.sprardb_documenti",
//                "weight": 2
//            },
            "properatore.report": {
                "title": "Report",
                "weight": 500
            },
            "properatore.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "segnalatore.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            "segnalatore.segnalazioni.ricercasegnalazioni": {
                "title": "Ricerca segnalazioni",
                "icon": "icon-view-list",
                "state": "app.sprardb_notification",
                "weight": 1
            },
            "segnalatore.segnalazioni.nuovasegnalazione": {
                "title": "Nuova segnalazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovasegnalazione",
                "weight": 2
            },
            /*"segnalatore.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
            /*"segnalatore.entisegnalatori": {
                "title": "ENTISEGNALATORI",
                "weight": 20
            },
            "segnalatore.entisegnalatori.entes": {
                "title": "Enti Segnalatori",
                "icon": "icon-sign-caution",
                "state": "app.sprardb_entisegnalatori",
                "weight": 1
            },
            "segnalatore.entisegnalatori.segnalatori": {
                "title": "Segnalatori",
                "icon": "icon-account-check",
                "state": "app.sprardb_segnalatori",
                "weight": 2
            },*/
            "segnalatore.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            /*"segnalatore.lavorazione_segnalati.segEnte": {
                "title": "Segnalati Enti segn",
                "icon": "icon-human-child",
                "state": "app.segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },*/
            "segnalatore.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "segnalatore.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "prrendicontazione.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            "prrendicontazione.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "prrendicontazione.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "prrendicontazione.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
           /* "prrendicontazione.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
            "prrendicontazione.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            "prrendicontazione.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "prrendicontazione.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "prrendicontazione.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "prrendicontazione.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "prrendicontazione.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "prrendicontazione.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "prrendicontazione.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "prrendicontazione.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            /*"prrendicontazione.beneficiari.incompletil": {
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "prrendicontazione.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            "prrendicontazione.beneficiari.trasferimento": {
                "title": "Lavora trasferimenti",
                "icon": "icon-account-switch",
                "state": "app.sprardbEventib({eventoTipo_id:1013})",
                "weight": 5
            },
           /* "prrendicontazione.beneficiari.uscitab": {
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "prrendicontazione.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "prrendicontazione.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "prrendicontazione.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "prrendicontazione.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "prrendicontazione.proroga.richiesteautorizzare": {
                "title": "Pendenti",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "prrendicontazione.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "prrendicontazione.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "prrendicontazione.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
//            "prrendicontazione.documenti": {
//                "title": "Documenti",
//                "weight": 100
//            },
//            "prrendicontazione.documenti.new": {
//                "title": "Carica documento",
//                "icon": "icon-box-upload",
//                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
//                "weight": 1
//            },
//            "prrendicontazione.documenti.my": {
//                "title": "I miei documenti",
//                "icon": "icon-heart-outline",
//                "state": "app.sprardb_documenti",
//                "weight": 2
//            },
            "prrendicontazione.report": {
                "title": "Report",
                "weight": 500
            },
            "prrendicontazione.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "pramministratore.segnalazioni": {
                "title": "INSERIMENTI",
                "weight": 10
            },
            "pramministratore.segnalazioni.ricercaauto": {
                "title": "Ricerca modello C",
                "icon": "icon-view-list",
                "state": "app.sprardb_autoinserimento",
                "weight": 2
            },
            "pramministratore.segnalazioni.ricercasc": {
              "title": "Ricerca Inserimento SC",
              "icon": "icon-view-list",
              "state": "app.sprardb_ricercasc",
              "weight": 3
            },
            "pramministratore.segnalazioni.nuovaasegnalazione": {
                "title": "Nuova Registrazione",
                "icon": "icon-playlist-plus",
                "state": "app.sprardb_nuovaautosegnalazione",
                "weight": 4
            },
           /* "pramministratore.segnalazioni.ricercasegnalati": {
                "title": "Ricerca Segnalati",
                "icon": "icon-view-list",
                "state": "app.sprardb_rsegnalati",
                "weight": 5
            },*/
            "pramministratore.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
            "pramministratore.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "pramministratore.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "pramministratore.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "pramministratore.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "pramministratore.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "pramministratore.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "pramministratore.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "pramministratore.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            /*"pramministratore.beneficiari.incompletil": {
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "pramministratore.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            "pramministratore.beneficiari.trasferimento": {
                "title": "Lavora trasferimenti",
                "icon": "icon-account-switch",
                "state": "app.sprardbEventib({eventoTipo_id:1013})",
                "weight": 5
            },
            /*"pramministratore.beneficiari.uscitab": {
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "pramministratore.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "pramministratore.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "pramministratore.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "pramministratore.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "pramministratore.proroga.richiesteautorizzare": {
                "title": "Pendenti",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "pramministratore.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "pramministratore.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "pramministratore.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
//            "pramministratore.documenti": {
//                "title": "Documenti",
//                "weight": 100
//            },
//            "pramministratore.documenti.new": {
//                "title": "Carica documento",
//                "icon": "icon-box-upload",
//                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
//                "weight": 1
//            },
//            "pramministratore.documenti.my": {
//                "title": "I miei documenti",
//                "icon": "icon-heart-outline",
//                "state": "app.sprardb_documenti",
//                "weight": 2
//            },
            "pramministratore.report": {
                "title": "Report",
                "weight": 500
            },
            "pramministratore.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "screndicontazione.lavorazione_segnalati": {
                "title": "Lavorazione inserimenti",
                "weight": 30
            },
           /* "screndicontazione.lavorazione_segnalati.segEnte": {
                "title": "Segnalati Enti segn",
                "icon": "icon-human-child",
                "state": "app.segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },*/
            "screndicontazione.lavorazione_segnalati.segProgetto": {
                "title": "Inseriti autosegnalazione",
                "icon": "icon-human-child",
                "state": "app.segnalatiprogetto({eventoTipo_id:1002})",
                "weight": 2
            },
            "screndicontazione.lavorazione_segnalati.segSC": {
              "title": "Inseriti da lettera SC",
              "icon": "icon-human-child",
              "state": "app.segnalatisc({eventoTipo_id:1003})",
              "weight": 3
            },
            "screndicontazione.lavorazione_segnalati.arrivoPro": {
                "title": "Arrivati",
                "icon": "icon-arrow-right-bold-hexagon-outline",
                "state": "app.segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 4
            },
            "screndicontazione.lavorazione_segnalati.segRif": {
                "title": "Rifiutati",
                "icon": "icon-repeat-off",
                "state": "app.segnalatirespinti({eventoTipo_id:1006})",
                "weight": 4
            },
            "screndicontazione.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "screndicontazione.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "screndicontazione.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "screndicontazione.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            /*"screndicontazione.beneficiari.incompletil": {
                "title": "Pres.Territorio Incompl.",
                "icon": "icon-disk-alert",
                "state": "app.sprardb_beneficiariil({def:0})",
                "weight": 7
            },
            "screndicontazione.beneficiari.ricercal": {
                "title": "Pres.Territorio Completi",
                "icon": "icon-map-marker-radius",
                "state": "app.sprardb_beneficiaril({def:1})",
                "weight": 8
            },*/
            "screndicontazione.beneficiari.trasferimento": {
                "title": "Lavora trasferimenti",
                "icon": "icon-account-switch",
                "state": "app.sprardbEventib({eventoTipo_id:1013})",
                "weight": 5
            },
            /*"screndicontazione.beneficiari.uscitab": {
                "title": "In Uscita",
                "icon": "icon-account-remove",
                "state": "app.sprardbEventib({eventoTipo_id:1010})",
                "weight": 6
            },*/
            "screndicontazione.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "screndicontazione.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "screndicontazione.progetti.new": {
                "title": "Nuovo Progetto",
                "icon": "icon-plus-network",
                "state": "app.sprardb_progetti_nuovo",
                "weight": 2
            },
            "screndicontazione.progetti.rendicontazioni": {
                "title": "RENDICONTAZIONI",
                "weight": 3
            },
            "screndicontazione.progetti.rendicontazioni.setup": {
                "title": "Setup",
                "icon": "icon-cog",
                "state": "app.sprardb_rendicontazioni_setup({attivo:1})",
                "weight": 2
            },
            /*"screndicontazione.progetti.monitoraggio": {
                "title": "Monitoraggio",
                "weight": 4
            },
            "screndicontazione.progetti.monitoraggio.all": {
                "title": "Ricerca",
                "icon": "icon-image-filter-center-focus",
                "state": "app.sprardb_monitoraggio",
                "weight": 1
            },*/
            "screndicontazione.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "screndicontazione.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "screndicontazione.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "screndicontazione.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "screndicontazione.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "screndicontazione.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
            "screndicontazione.protocolloentrata": {
                "title": "Protocollo entrata",
                "weight": 70
            },
            "screndicontazione.protocolloentrata.segnalazionienti": {
                "title": "Mod.segnalaz. ente",
                "icon": "icon-basket-fill",
                "state": "app.protocollo_segnalatienti({eventoTipo_id:1003})",
                "weight": 1
            },
            "screndicontazione.protocollouscita": {
                "title": "Protocollo uscita",
                "weight": 80
            },
            "screndicontazione.protocollouscita.segnalazionearrivo": {
                "title": "Lettera inserimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_segnalatiarrivo({eventoTipo_id:1004})",
                "weight": 1
            },
            "screndicontazione.protocollouscita.trasferimento": {
                "title": "Lettera trasferimento",
                "icon": "icon-basket-unfill",
                "state": "app.protocollo_trasferimenti({eventoTipo_id:1013})",
                "weight": 2
            },
            "screndicontazione.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "screndicontazione.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "screndicontazione.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
            /*"screndicontazione.documenti": {
                "title": "Documenti",
                "weight": 100
            },
            "screndicontazione.documenti.new": {
                "title": "Carica documento",
                "icon": "icon-box-upload",
                "state": "app.sprardb_nuovodocumento({azione:'nuovo'})",
                "weight": 1
            },
            "screndicontazione.documenti.my": {
                "title": "I miei documenti",
                "icon": "icon-heart-outline",
                "state": "app.sprardb_documenti",
                "weight": 2
            },*/
            "screndicontazione.report": {
                "title": "Report",
                "weight": 500
            },
            "screndicontazione.report.schedamonitoraggio": {
              "title": "Scheda Monitoraggio",
              "icon": "icon-bulletin-board",
              "state": "app.sprardb_reportschedamonitoraggio",
              "weight": 1
            },
            "screndicontazione.report.reportbgenere": {
              "title": "Beneficiari per genere",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbgenere",
              "weight": 3
            },
            "screndicontazione.report.reportbpermessi": {
              "title": "Ben. per tipo soggiorno",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbpermessi",
              "weight": 5
            },
            "screndicontazione.report.reportbnuclei":{
              "title": "Ben. per nuclei familiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportreportbnuclei",
              "weight": 6
            },
            "screndicontazione.report.reportbprogetti":{
              "title": "Ben. per progetti",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbprogetti",
              "weight": 7
            },
            "screndicontazione.report.reportbnazionalita":{
              "title": "Ben. per nazionalita",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbnazionalita",
              "weight": 8
            },
            "screndicontazione.report.reportmotiviuscita":{
              "title": "Ben. per motivi uscita",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportmotiviuscita",
              "weight": 9
            },
            "screndicontazione.report.reportbmodlitaingresso":{
              "title": "Ben. per mod. ingresso",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportmodalitaingresso",
              "weight": 10
            },
            "screndicontazione.report.reportbclassieta": {
              "title": "Ben. per classi eta",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbclassieta",
              "weight": 11
            },
            "sscrendicontazione.report.reportcorsi": {
              "title": "Corsi e Servizi",
              "icon": "icon-book-open",
              "state": "app.sprardb_reportcorsi",
              "weight": 12
            },
            "sscrendicontazione.report.reportcomunistruttura":{
              "title": "Comuni Sede Struttura",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportcomunistruttura",
              "weight": 13
            },
            "screndicontazione.report.reportbeneficiarinumerico":{
              "title": "Numerico Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportbeneficiarinumerico",
              "weight": 14
            },
            "screndicontazione.report.reportstrutturetipologia":{
              "title": "Strutture per Tipologia",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportstrutturetipologia",
              "weight": 15
            },
            "sscrendicontazione.report.reportpostidisponibili":{
              "title": "Posti diponibili per centro",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportpostidisponibili",
              "weight": 16
            },
            "screndicontazione.report.reportbeneficiaridettgli":{
              "title": "Dettaglio Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbeneficiaridettgli",
              "weight": 17
            },
            "screndicontazionereport.reportbeneficiaricovid":{
              "title": "Beneficiari Covid",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportbeneficiaricovid",
              "weight": 18
            },
            "screndicontazione.report.reportministero":{
              "title": "Numerico Nuclei Ucraini",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportministero",
              "weight": 21
            },
            "screndicontazione.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "screndicontazione.report.reportproroghelavorate":{
              "title": "Proroghe Lavorate",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghelavorate",
              "weight": 20
            },
            "screndicontazione.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "screndicontazione.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },


            "scconsulente di rendicontazione.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "scconsulente di rendicontazione.beneficiari.incompleti": {
                "title": "Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "scconsulente di rendicontazione.beneficiari.ricerca": {
                "title": "Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "scconsulente di rendicontazione.beneficiari.accolti": {
                "title": "Accolti",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 3
            },

            "scconsulente di rendicontazione.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "scconsulente di rendicontazione.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scconsulente di rendicontazione.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "scconsulente di rendicontazione.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "scconsulente di rendicontazione.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "scconsulente di rendicontazione.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "scconsulente di rendicontazione.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "scconsulente di rendicontazione.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
            "scconsulente di rendicontazione.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "scconsulente di rendicontazione.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "scconsulente di rendicontazione.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
            "scconsulente di rendicontazione.report": {
                "title": "Report",
                "weight": 500
            },
            "scconsulente di rendicontazione.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "scconsulente di rendicontazione.report.reportbgenere": {
                "title": "Beneficiari per genere",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbgenere",
                "weight": 3
            },
            "scconsulente di rendicontazione.report.reportbpermessi": {
                "title": "Ben. per tipo soggiorno",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbpermessi",
                "weight": 5
            },
            "scconsulente di rendicontazione.report.reportbnuclei":{
                "title": "Ben. per nuclei familiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportreportbnuclei",
                "weight": 6
            },
            "scconsulente di rendicontazione.report.reportbprogetti":{
                "title": "Ben. per progetti",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbprogetti",
                "weight": 7
            },
            "scconsulente di rendicontazione.report.reportbnazionalita":{
                "title": "Ben. per nazionalita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbnazionalita",
                "weight": 8
            },
            "scconsulente di rendicontazione.report.reportmotiviuscita":{
                "title": "Ben. per motivi uscita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmotiviuscita",
                "weight": 9
            },
            "scconsulente di rendicontazione.report.reportbmodlitaingresso":{
                "title": "Ben. per mod. ingresso",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmodalitaingresso",
                "weight": 10
            },
            "scconsulente di rendicontazione.report.reportbclassieta": {
                "title": "Ben. per classi eta",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbclassieta",
                "weight": 11
            },
            "scconsulente di rendicontazione.report.reportcorsi": {
                "title": "Corsi e Servizi",
                "icon": "icon-book-open",
                "state": "app.sprardb_reportcorsi",
                "weight": 12
            },
            "scconsulente di rendicontazione.report.reportcomunistruttura":{
                "title": "Comuni Sede Struttura",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportcomunistruttura",
                "weight": 13
            },
            "scconsulente di rendicontazione.report.reportbeneficiarinumerico":{
                "title": "Numerico Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportbeneficiarinumerico",
                "weight": 14
            },
            "scconsulente di rendicontazione.report.reportstrutturetipologia":{
                "title": "Strutture per Tipologia",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportstrutturetipologia",
                "weight": 15
            },
            "scconsulente di rendicontazione.report.reportpostidisponibili":{
                "title": "Posti diponibili per centro",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportpostidisponibili",
                "weight": 16
            },
            "scconsulente di rendicontazione.report.reportbeneficiaridettgli":{
                "title": "Dettaglio Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaridettgli",
                "weight": 17
            },
            "scconsulente di rendicontazione.report.reportbeneficiaricovid":{
                "title": "Beneficiari Covid",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaricovid",
                "weight": 18
            },
            "scconsulente di rendicontazione.report.reportministero":{
              "title": "Numerico Nuclei Ucraini",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportministero",
              "weight": 21
            },
            "scconsulente di rendicontazione.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "scconsulente di rendicontazione.report.reportproroghelavorate":{
              "title": "Proroghe Lavorate",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghelavorate",
              "weight": 20
            },
            "scconsulente di rendicontazione.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "scconsulente di rendicontazione.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },
            //---------------TUTOR
            "sctutor.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "sctutor.beneficiari.incompleti": {
                "title": "Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "sctutor.beneficiari.ricerca": {
                "title": "Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "sctutor.beneficiari.accolti": {
                "title": "Accolti",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 3
            },
            "sctutor.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "sctutor.progetti.new": {
                "title": "Nuovo Progetto",
                "icon": "icon-plus-network",
                "state": "app.sprardb_progetti_nuovo",
                "weight": 2
            },
            "sctutor.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "sctutor.progetti.monitoraggio": {
                "title": "Monitoraggio",
                "weight": 4
            },
            "sctutor.progetti.monitoraggio.all": {
                "title": "Ricerca",
                "icon": "icon-image-filter-center-focus",
                "state": "app.sprardb_monitoraggio",
                "weight": 1
            },
            "sctutor.progetti.rendicontazioni": {
                "title": "RENDICONTAZIONI",
                "weight": 3
            },
            "sctutor.progetti.rendicontazioni.setup": {
                "title": "Setup",
                "icon": "icon-cog",
                "state": "app.sprardb_rendicontazioni_setup({attivo:1})",
                "weight": 2
            },
            "sctutor.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "sctutor.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "sctutor.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "sctutor.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "sctutor.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "sctutor.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
            "sctutor.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "sctutor.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "sctutor.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },

            //---------------assistenza
            "scconsulente assistenza.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "scconsulente assistenza.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "scconsulente assistenza.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "scconsulente assistenza.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            "scconsulente assistenza.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "scconsulente assistenza.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "scconsulente assistenza.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "scconsulente assistenza.proroga.richiestecompletare": {
                "title": "da completare",
                "icon": "icon-timelapse",
                "state": "app.richiestecompletare({eventoTipo_id:1011,eventoStato_id:1})",
                "weight": 1
            },
            "scconsulente assistenza.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "scconsulente assistenza.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "scconsulente assistenza.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "scconsulente assistenza.proroga.ricercaproroga": {
                "title": "Ricerca",
                "icon": "icon-file-find",
                "state": "app.sprardb_proroghe",
                "weight": 6
            },
            "scconsulente assistenza.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "scconsulente assistenza.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "scconsulente assistenza.rubrica.personas2": {
                "title": "Persone",
                "icon": "icon-clipboard-account",
                "state": "app.sprardb_personas2",
                "weight": 2
            },
            "scconsulente assistenza.report": {
                "title": "Report",
                "weight": 500
            },
            "scconsulente assistenza.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "scconsulente assistenza.report.reportbgenere": {
                "title": "Beneficiari per genere",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbgenere",
                "weight": 3
            },
            "scconsulente assistenza.report.reportbpermessi": {
                "title": "Ben. per tipo soggiorno",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbpermessi",
                "weight": 5
            },
            "scconsulente assistenza.report.reportbnuclei":{
                "title": "Ben. per nuclei familiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportreportbnuclei",
                "weight": 6
            },
            "scconsulente assistenza.report.reportbprogetti":{
                "title": "Ben. per progetti",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbprogetti",
                "weight": 7
            },
            "scconsulente assistenza.report.reportbnazionalita":{
                "title": "Ben. per nazionalita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbnazionalita",
                "weight": 8
            },
            "scconsulente assistenza.report.reportmotiviuscita":{
                "title": "Ben. per motivi uscita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmotiviuscita",
                "weight": 9
            },
            "scconsulente assistenza.report.reportbmodlitaingresso":{
                "title": "Ben. per mod. ingresso",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmodalitaingresso",
                "weight": 10
            },
            "scconsulente assistenza.report.reportbclassieta": {
                "title": "Ben. per classi eta",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbclassieta",
                "weight": 11
            },
            "scconsulente assistenza.report.reportcorsi": {
                "title": "Corsi e Servizi",
                "icon": "icon-book-open",
                "state": "app.sprardb_reportcorsi",
                "weight": 12
            },
            "scconsulente assistenza.report.reportcomunistruttura":{
                "title": "Comuni Sede Struttura",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportcomunistruttura",
                "weight": 13
            },
            "scconsulente assistenza.report.reportbeneficiarinumerico":{
                "title": "Numerico Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportbeneficiarinumerico",
                "weight": 14
            },
            "scconsulente assistenza.report.reportstrutturetipologia":{
                "title": "Strutture per Tipologia",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportstrutturetipologia",
                "weight": 15
            },
            "scconsulente assistenza.report.reportpostidisponibili":{
                "title": "Posti diponibili per centro",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportpostidisponibili",
                "weight": 16
            },
            "scconsulente assistenza.report.reportbeneficiaridettgli":{
                "title": "Dettaglio Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaridettgli",
                "weight": 17
            },
            "scconsulente assistenza.report.reportbeneficiaricovid":{
                "title": "Beneficiari Covid",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaricovid",
                "weight": 18
            },
            "scconsulente assistenza.report.reportministero":{
              "title": "Numerico Nuclei Ucraini",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportministero",
              "weight": 21
            },
            "scconsulente assistenza.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "scconsulente assistenza.report.reportproroghelavorate":{
              "title": "Proroghe Lavorate",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghelavorate",
              "weight": 20
            },
            "scconsulente assistenza.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "scconsulente assistenza.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },
            "visitatore.beneficiari": {
                "title": "Beneficiari",
                "weight": 40
            },
            "visitatore.report.reportproroghebeneficiari":{
              "title": "Proroghe Beneficiari",
              "icon": "icon-account-multiple-outline",
              "state": "app.sprardb_reportproroghebeneficiari",
              "weight": 19
            },
            "visitatore.report.reportproroghelavorate":{
                "title": "Proroghe Lavorate",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportproroghelavorate",
                "weight": 20
            },
            "visitatore.beneficiari.incompleti": {
                "title": "Ben. Presenti Incompleti",
                "icon": "icon-account-alert",
                "state": "app.sprardb_beneficiarii({def:0})",
                "weight": 1
            },
            "visitatore.beneficiari.ricerca": {
                "title": "Beneficiari Presenti",
                "icon": "icon-account-multiple",
                "state": "app.sprardb_beneficiari({def:1})",
                "weight": 2
            },
            "visitatore.beneficiari.accolti": {
                "title": "Permanenze",
                "icon": "icon-account-box",
                "state": "app.sprardb_accolti({def:1})",
                "weight": 4
            },
            "visitatore.progetti": {
                "title": "Progetti",
                "weight": 50
            },
            "visitatore.progetti.listap": {
                "title": "Ricerca progetti",
                "icon": "icon-apps",
                "state": "app.sprardb_progetti_progetti",
                "weight": 1
            },
            "visitatore.proroga": {
                "title": "Proroghe",
                "weight": 60
            },
            "visitatore.proroga.richiesteautorizzare": {
                "title": "Da Autorizzare",
                "icon": "icon-calendar-clock",
                "state": "app.richiesteautorizzare({eventoTipo_id:1011,eventoStato_id:3})",
                "weight": 2
            },
            "visitatore.proroga.prorogheautorizzate": {
                "title": "Autorizzate",
                "icon": "icon-thumb-up-outline",
                "state": "app.prorogheautorizzate({eventoTipo_id:1011,eventoStato_id:4})",
                "weight": 3
            },
            "visitatore.proroga.prorogherifiutate": {
                "title": "Rifiutate",
                "icon": "icon-thumb-down-outline",
                "state": "app.prorogherifiutate({eventoTipo_id:1011,eventoStato_id:5})",
                "weight": 4
            },
            "visitatore.rubrica": {
                "title": "Rubrica",
                "weight": 90
            },
            "visitatore.rubrica.entes": {
                "title": "Enti",
                "icon": "icon-castle",
                "state": "app.sprardb_enti",
                "weight": 1
            },
            "visitatore.report": {
                "title": "Report",
                "weight": 500
            },
            "visitatore.report.schedamonitoraggio": {
                "title": "Scheda Monitoraggio",
                "icon": "icon-bulletin-board",
                "state": "app.sprardb_reportschedamonitoraggio",
                "weight": 1
            },
            "visitatore.report.reportbgenere": {
                "title": "Beneficiari per genere",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbgenere",
                "weight": 3
            },
            "visitatore.report.reportbpermessi": {
                "title": "Ben. per tipo soggiorno",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbpermessi",
                "weight": 5
            },
            "visitatore.report.reportbnuclei":{
                "title": "Ben. per nuclei familiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportreportbnuclei",
                "weight": 6
            },
            "visitatore.report.reportbprogetti":{
                "title": "Ben. per progetti",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbprogetti",
                "weight": 7
            },
            "visitatore.report.reportbnazionalita":{
                "title": "Ben. per nazionalita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbnazionalita",
                "weight": 8
            },
            "visitatore.report.reportmotiviuscita":{
                "title": "Ben. per motivi uscita",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmotiviuscita",
                "weight": 9
            },
            "visitatore.report.reportbmodlitaingresso":{
                "title": "Ben. per mod. ingresso",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportmodalitaingresso",
                "weight": 10
            },
            "visitatore.report.reportbclassieta": {
                "title": "Ben. per classi eta",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbclassieta",
                "weight": 11
            },
            "visitatore.report.reportcorsi": {
                "title": "Corsi e Servizi",
                "icon": "icon-book-open",
                "state": "app.sprardb_reportcorsi",
                "weight": 12
            },
            "visitatore.report.reportcomunistruttura":{
                "title": "Comuni Sede Struttura",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportcomunistruttura",
                "weight": 13
            },
            "visitatore.report.reportbeneficiarinumerico":{
                "title": "Numerico Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportbeneficiarinumerico",
                "weight": 14
            },
            "visitatore.report.reportstrutturetipologia":{
                "title": "Strutture per Tipologia",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportstrutturetipologia",
                "weight": 15
            },
            "visitatore.report.reportpostidisponibili":{
                "title": "Posti diponibili per centro",
                "icon": "icon-account-multiple-outline",
                "state": "app.reportpostidisponibili",
                "weight": 16
            },
            "visitatore.report.reportbeneficiaridettgli":{
                "title": "Dettaglio Beneficiari",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaridettgli",
                "weight": 17
            },
            "visitatore.report.reportbeneficiaricovid":{
                "title": "Beneficiari Covid",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reportbeneficiaricovid",
                "weight": 18
            },
            "visitatore.report.reporteaso1": {
                "title": "Report Easo 1",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso1",
                "weight": 30
            },
            "visitatore.report.reporteaso2": {
                "title": "Report Easo 2",
                "icon": "icon-account-multiple-outline",
                "state": "app.sprardb_reporteaso2",
                "weight": 31
            },
            "visitatore.report.reportchecklistmonitoraggio": {
              "title": "check list monitoraggio",
              "icon": "icon-account-multiple-outline",
              "state": "app.reportchecklistmonitoraggio",
              "weight": 32
            },


        };
        angular.forEach(menus, function (v, k) {
            if (v !== undefined) msNavigationServiceProvider.saveItem(k, v);
        });
    }

})();

(function ()
{
    'use strict';
    angular
            .module('app.navigation')
            .controller('NavigationController', NavigationController);
    /** @ngInject */
    function NavigationController($scope, api, $cookies, msNavigationService)
    {
      var vm = this;
      var user = $cookies.getObject('user');
      console.log(user);

      // Data
      vm.bodyEl = angular.element('body');
      vm.folded = false;
      vm.msScrollOptions = {
          suppressScrollX: true
      };
      vm.root = "scadmin"; //ok per admin, ho tutto
      var rootacl = "";
      var gruppo_prioritario = angular.copy(api.user.gruppos[0]);
      console.log("gruppo_prioritario:", gruppo_prioritario);
      console.log("gruppo_prioritario:", gruppo_prioritario.gruppo.replace("-", "").toLowerCase());
      rootacl = angular.copy(gruppo_prioritario.gruppo);
      rootacl = rootacl.replace("-", "").toLowerCase();

//        angular.forEach(api.user.gruppos, function (gruppo) {
//            if (gruppo.gruppo !== "SC-ADMIN") {
//                rootacl = angular.copy(gruppo.gruppo);
//                rootacl = rootacl.replace("-", "").toLowerCase();
//            }
//        });
      if (!api.isAdmin) {
          vm.root = rootacl;
      }
      //console.log("rootacl:", angular.copy(vm.root));
      if (user.primoAccessoEffettuato === 0 || user.privacy === 0 || user.postlogin === 0) {
          vm.root = 'empty';
      }

      // Methods
      vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
      //////////

      var menu = {
        'view-rendicontazione': {
          "progetti.rendicontazioni": {
            "title": "RENDICONTAZIONI",
            "weight": 3
          },
          "progetti.rendicontazioni.all": {
            "title": "Lista Rendicontazioni",
            "icon": "icon-calculator",
            "state": "app.sprardb_rendicontazionimc",
            "weight": 1
          }
        },

        'view-monitoraggio': {
          "progetti.monitoraggio": {
            "title": "MONITORAGGIO",
            "state": "app.sprardb_monitoraggio_dashboard",
            "weight": 4
          },
          "progetti.monitoraggio.all": {
            "title": "Lista Visite",
            "icon": "icon-view-list",
            "state": "app.sprardb_monitoraggio",
            "weight": 2
          }
        },

        'view-tutor': {
          "progetti.monitoraggio.tutor": {
            "title": "Cruscotto Tutor",
            "icon": "icon-account-multiple",
            "state": "app.sprardb_monitoraggio_tutor",
            "weight": 3
          }
        },

        'view-cruscotto-monitoraggio': {
          "progetti.monitoraggio.cruscotto": {
            "title": "Cruscotto",
            "icon": "icon-view-dashboard",
            "state": "app.sprardb_monitoraggio_cruscotto",
            "weight": 1
          }
        },

        'visit-monitoraggio': {
          "progetti.monitoraggio": {
            "title": "MONITORAGGIO",
            "state": "app.sprardb_monitoraggio_cruscotto",
            "weight": 4
          }
        },

        'gestione-bandi': {
          "amministrazione.bando": {
            "title": "BANDI",
            "icon": "icon-view-list",
            "state": "app.sprardb_amministrazione_bando",
            "weight": 1
          }
        },

        'edit-corsi': {
          "amministrazione.corsi": {
            "title": "CORSI",
            "icon": "icon-view-list",
            "state": "app.sprardb_amministrazione_corsi",
            "weight": 1
          }
        },

        'edit-servizi': {
          "amministrazione.servizi": {
            "title": "SERVIZI",
            "icon": "icon-view-list",
            "state": "app.sprardb_amministrazione_servizi",
            "weight": 2
          }
        },

        'view-dashboard-progetto': {
          "cruscotto": {
            'title': "Dashboard",
            "state": "app.sprardb_cruscotto",
            "weight": 0
          }
        },

        'lavora-segnalato': {
          "segnalazioni.presenti": {
            "title": "Ricerca Pres. Territorio",
            "icon": "icon-view-list",
            "state": "app.sprardb_notification_presenti",
            "weight": 3
          }
        },
        'view-beneficiario': {
          "beneficiaril": {
            "title": "PRESENTI SUL TERRITORIO",
            "state": "app.sprardb_beneficiaril",
            "weight": 40
          },
          "lavorazione_segnalati.segnalatiterritorio": {
            "title": "Inseriti Pres. Territorio",
            "icon": "icon-human-child",
            "state": "app.segnalatiterritorio({eventoTipo_id:1017})",
            "weight": 3
          }
        },

        'cancella-beneficiario': {
          'beneficiari.beneficiari_cancellati': {
            'title': 'Beneficiari Cancellati',
            'state': 'app.sprardb_beneficiari_cancellati',
            'weight': 5,
            "icon": "icon-account-minus",
          }
        },

        "report-ministero": {
          "report.estrazioniministero": {
            "title": "Estrazione SIM",
            "icon": "icon-bulletin-board",
            "state": "app.sprardb_estrazioniministero",
            "weight": 1
          }
        },
      }

      angular.forEach(user.permissions, function(permission) {
        if (menu[permission] !== undefined) {
          angular.forEach(menu[permission], function (v, k){
            msNavigationService.saveItem(rootacl +'.'+ k, v);
          })
        }
      })

      /**
       * Toggle folded status
       */
      function toggleMsNavigationFolded()
      {
          vm.folded = !vm.folded;
      }

      // Close the mobile menu on $stateChangeSuccess
      $scope.$on('$stateChangeSuccess', function ()
      {
          vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
      });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes, $mdDialog, api, $cookies)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        var stateChangeCancelEvent = $rootScope.$on('$stateChangeCancel', function ()
        {
            $timeout(function ()
            {
              $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            stateChangeCancelEvent();
        });

        $rootScope.$on('httpValidationError', function (event, eventData)
        {
            $mdDialog.show({
                controller: 'GenericDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dataValidationErrorForm.html',
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    errorResponse: eventData,
                }
            });
        });
        $rootScope.$on('httpAllowedError', function (event, eventData)
        {
            var addmessage = "";
            if (angular.isDefined(eventData.message)) {
                addmessage = "  " + eventData.message;
            }
            $mdDialog.show({
                controller: 'GenericDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/sprardb/form/dataValidationErrorForm.html',
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    errorResponse: [{message: "Accesso alla risorsa non consentito." + addmessage}],
                }
            });
        });


        $rootScope.progetti = [];
        $rootScope.segnalatori = [];

        $rootScope.progettiesegnalatori = function (personas) {
            $rootScope.segnalatori = [];
            $rootScope.progetti = [];
            $cookies.remove('ente_id');
            $cookies.remove('progetto_id');
            angular.forEach(personas, function (persona) {
                //TODO modifica Corrado per persone e profili attivi SI/NO, rivedere chiamate

                api.personas.hasente.search({persona_id: persona.id, personaRuolo_id: 26}, function (segn) {
                    $rootScope.segnalatori = segn.data;
                    $rootScope.segnalatori_id = "";
                    var temp = [];
                    angular.forEach(segn.data, function (s) {
                        if (temp.indexOf(s.ente_id) == -1) {
                            temp.push(s.ente_id);
                        }
                    });
                    $rootScope.segnalatori_id = temp.toString();
                    $cookies.putObject('ALL_s_id', $rootScope.segnalatori_id);
                    console.log("$rootScope.segnalatori", $rootScope.segnalatori);
                    console.log("$rootScope.segnalatori_id", $rootScope.segnalatori_id);

                    //test cookiestore poi sostituire tendina
//                    if (angular.isDefined($rootScope.segnalatori[0])) {
//                        $cookies.putObject('ente_id', $rootScope.segnalatori[0].ente_id);
//                        api.selezionaProfilo();
//                    }
                });

                api.personas.persona3.get({id: persona.id, expand:'personahasprogettos'}, function(res) {
                    $rootScope.progetti = res.personahasprogettos;
                    //console.log("$rootScope.progetti", $rootScope.progetti);
                    $rootScope.progetto_id = "";
                    var temp = [];
                    var tempp = null;
                    angular.forEach($rootScope.progetti, function (p) {
                        if (temp.indexOf(p.progetto_id) == -1 && p.accessPermission) {
                            tempp = p.progetto_id;
                            temp.push(p.progetto_id);
                        }
                    });
                    $rootScope.progetto_id = temp.toString();
                    $cookies.putObject('ALL_p_id', $rootScope.progetto_id);
                    //console.log("$rootScope.progetti", $rootScope.progetti);
                    //console.log("$rootScope.progetto_id", $rootScope.progetto_id);

                    api.strutturas.strutturamin.cerca({'progetto_id_IN': temp.toString(), codComune: '000000'}, function (response) {
                        api.aggiornadacompletare(response.data.length);

                    });

                    //test cookiestore poi sostituire tendina
//                    if (angular.isDefined($rootScope.progetti[0])) {
//                        $cookies.putObject('progetto_id', $rootScope.progetti[0].progetto_id);
//                        api.selezionaProfilo();
//                    }

                });
            });



        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/sprardb/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    //'quickPanel@app': {
                    //    templateUrl: 'app/quick-panel/quick-panel.html',
                    //    controller : 'QuickPanelController as vm'
                    //}
                }
            });
    }

})();
(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('ricerca', ricercaService);
    /** @ngInject */

    function ricercaService(api, $filter, $cookies)
    {
        var ricerca = this;
        var oggi = new Date();
        if (!$cookies.getObject('user')) {
            $cookies.putObject('user', {autorizzato: 0});
        }

        ricerca.autorizzato = $cookies.getObject('user').autorizzato;//api.user.autorizzato;

        //senza autorizzazioni
        ricerca.entesegnalatoresafes = [];


        api.istats.regioni.get({sort: "regione", pagination: -1}, function (r) {
            ricerca.regiones = r.data;
        });
        api.istats.province.get({pagination: -1, sort: "provincia"}, function (r) {
            ricerca.provincias = r.data;
        });
        api.entesafes.ente.search({segnalatore: 1, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
            ricerca.entesegnalatoresafes = r.data;
        });

        //statico
        ricerca.sesso = [{sesso: "M"}, {sesso: "F"}];
        ricerca.statogenerico = [{id: 1, descrizione: "ATTIVO"}, {id: -1, descrizione: "DISATTIVO"}];
        ricerca.statoattivo = [{id: 0, descrizione: "NON ATTIVO"}, {id: 1, descrizione: "ATTIVO"}];
        ricerca.statoattivo2 = [{id: 0, descrizione: "NON ATTIVO"}, {id: 1, descrizione: "ATTIVO"}, {id: -1, descrizione: "INCOMPLETO"}];
        ricerca.sino = [{id: 0, descrizione: "NO"}, {id: 1, descrizione: "SI"}];
        ricerca.contasino = [{id: "NULL", descrizione: "NO"}, {id: "NOT NULL", descrizione: "SI"}];
        ricerca.tipolista = [{id: "listaente", descrizione: "LISTA ENTI"}, {id: "listapersona", descrizione: "LISTA PERSONE"}];
        ricerca.genere = [{id: "M", descrizione: "MASCHIO"}, {id: "F", descrizione: "FEMMINA"}];
        ricerca.datascadenza = [
            {id: "<" + moment(oggi).add(-60, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI DA +60 GG"},
            {id: "<" + moment(oggi).add(-30, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI DA +30 GG"},
            {id: "<" + moment(oggi).add(-15, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI DA +15 GG"},
            {id: "<" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI AD OGGI"},
            {id: ">" + moment(oggi).format('YYYY-MM-DD'), descrizione: "IN SCADENZA DA OGGI"},
            {id: ">" + moment(oggi).add(15, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA TRA 15 GG"},
            {id: ">" + moment(oggi).add(30, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA TRA 30 GG"},
            {id: ">" + moment(oggi).add(60, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA TRA 60 GG"}];
        ricerca.datascadenzaIntervallo = [
            {id: moment(oggi).add(-36500, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(-365, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI: -60GG -365GG"},
            {id: moment(oggi).add(-60, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(-30, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI: -30GG -60GG"},
            {id: moment(oggi).add(-30, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(-15, 'd').format('YYYY-MM-DD'), descrizione: "SCADUTI: -15GG -30GG"},
            {id: moment(oggi).add(-15, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: OGGI -15GG"},
            {id: moment(oggi).format('YYYY-MM-DD') + "|" + moment(oggi).add(15, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OGGI +15GG"},
            {id: moment(oggi).add(15, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(30, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: +15GG +30GG"},
            {id: moment(oggi).add(30, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(60, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: +30GG +60GG"},
            {id: moment(oggi).add(60, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(365, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: +60GG +365GG"}];
        ricerca.datascadenzaIntervallo2 = [
            {id: moment(oggi).add(-365, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: PRIMA -365GG"},
            {id: moment(oggi).add(-365, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: OGGI -365GG"},
            {id: moment(oggi).add(-60, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: OGGI -60GG"},
            {id: moment(oggi).add(-30, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: OGGI -30GG"},
            {id: moment(oggi).add(-15, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).format('YYYY-MM-DD'), descrizione: "SCADUTI: OGGI -15GG"},
            {id: moment(oggi).format('YYYY-MM-DD') + "|" + moment(oggi).add(15, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OGGI +15GG"},
            {id: moment(oggi).format('YYYY-MM-DD') + "|" + moment(oggi).add(30, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OGGI +30GG"},
            {id: moment(oggi).format('YYYY-MM-DD') + "|" + moment(oggi).add(60, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OGGI +60GG"},
            {id: moment(oggi).format('YYYY-MM-DD') + "|" + moment(oggi).add(365, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OGGI +365GG"},
            {id: moment(oggi).add(365, 'd').format('YYYY-MM-DD') + "|" + moment(oggi).add(36500, 'd').format('YYYY-MM-DD'), descrizione: "IN SCADENZA: OLTRE +365GG"}

        ];
        //ricerca.nucleoFamiliare = [{id: 0, descrizione: "NUCLEO MONOPARENTALE"}, {id: 1, descrizione: "NUCLEO FAMILIARE"}, {id: 2, descrizione: "NON SO"}];
        ricerca.lcolors = {};
        ricerca.lcolors = {generico: 'md-blue-grey-400-bg', progetto: 'md-teal-300-bg', ente: 'md-amber-300-bg', persona: 'md-grey-400-bg', struttura: 'md-light-green-300-bg', listaente: 'md-red-500-bg', listapersona: 'md-cyan-800-bg'};
        ricerca.colors = ['md-blue-grey-400-bg', 'md-blue-grey-600-bg', 'md-teal-300-bg', 'md-teal-700-bg', 'md-amber-300-bg', 'md-amber-700-bg', 'md-grey-400-bg', 'md-grey-800-bg', 'md-light-green-300-bg', 'md-light-green-500-bg', 'md-red-500-bg', 'md-red-900-bg', 'md-cyan-800-bg', 'md-cyan-400-bg', 'md-lime-300-bg', 'md-lime-500-bg', 'md-blue-400-bg', 'md-blue-900-bg', 'md-pink-200-bg', 'md-pink-700-bg', 'md-light-green-900-bg', 'md-lime-900-bg', 'md-blue-grey-900-bg'];
        ricerca.scolors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'];
        ricerca.colors2 = [
            'md-blue-grey-200-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-orange-800-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'
        ];
        ricerca.icons = [
            'icon-drag',
            'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close',
            'icon-exclamation', 'icon-calendar-clock', 'icon-drag', 'icon-drag', 'icon-code-tags',
            'icon-drag', 'icon-drag', 'icon-drag', 'icon-check', 'icon-close',
            'icon-drag', 'icon-drag', 'icon-drag', 'icon-drag', 'icon-stop'
        ];
        ricerca.corr_doc_processi = {
            657: 2657,
            658: 2658,
            659: 2659,
            660: 2660,
            661: 2661,
            662: 2662,
            663: 2663,
            664: 2664,
            665: 2665,
            666: 2666,
            667: 2667,
            668: 2668,
            669: 2669,
            670: 2670,
            1074: 2999,
            1075: 3075,
            1076: 3076,
            1077: 3077,
            1078: 3078,
            1080: 3080,
            1081: 3081,
            1082: 3082,
            1083: 3083,
            1084: 3084,
            1085: 3085,
            1086: 3086,
            1087: 2671,
            1088: 2672,
            1089: 2673,
            1090: 3087,
            1091: 3088
        };
        ricerca.corr_tiprot_processi = {
            590: 2000,
            591: 2001,
            592: 2002,
            593: 2003,
            594: 2000,
            595: 2005,
            596: 2004,
            961: 2000,
            962: 2000,
            597: 2000,
            598: 2012,
            599: 2013,
            3001: 2006,
            3002: 2007,
            3003: 2008,
            3004: 2009,
            3005: 2010,
            3006: 2011,
            3009: 2014
        };
        ricerca.corr_doc_tiprot = {
            657: [590, 594, 3010],
            658: [961, 3010],
            659: [590, 594, 3010],
            660: [590, 594, 3010],
            661: [595],
            662: [590, 594, 3010],
            663: [596],
            664: [591, 594, 3011],
            665: [592, 594, 3011],
            666: [593, 594, 3011],
            667: [595],
            668: [590, 594, 3010],
            669: [590, 594],
            670: [590],
            1074: [591, 592, 593, 594, 599, 3011],
            1075: [594, 3001, 3011],
            1076: [594, 3001, 3011],
            1077: [594, 3002, 3011],
            1078: [594, 3002, 3011],
            1080: [594, 3003, 3011],
            1081: [594, 3003, 3011],
            1082: [594, 3004, 3011],
            1083: [594, 3004, 3011],
            1084: [594, 3005, 3011],
            1085: [594, 3005, 3011],
            1086: [3006,3011, 3011],
            1087: [598, 3011],
            1088: [598, 3011],
            1089: [3006],
            1090: [3009, 3011],
            1091: [3009, 3011]
        };
        ricerca.corr_tiprot_doc = {
            590: [657, 659, 660, 662, 668, 669, 670],
            591: [664, 1074],
            592: [665, 1074],
            593: [666, 1074],
            594: [657, 659, 660, 662, 664, 665, 666, 668, 1074],
            595: [661, 667],
            596: [663],
            597: [],
            598: [1087,1088],
            599: [1074],
            961: [658],
            962: [],
            3001: [1075, 1076],
            3002: [1077, 1078],
            3003: [1080, 1082],
            3004: [1083, 1084],
            3005: [1084, 1085],
            3006: [1086, 1089],
            3009: [1090,1091],
            3010: [657, 658, 659, 660, 662, 668],
            3011: [664, 665, 666, 1074, 1075, 1076, 1077, 1078, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1090, 1091]
        };
        ricerca.oggi = new Date();
        ricerca.aaaa = ricerca.oggi.getFullYear();
        ricerca.anni = function () {
            var aaaa = ricerca.oggi.getFullYear();
            console.log("aaaa:", aaaa);
            var aa;
            var risultato = [];
            var temp = {};
            for (aa = (aaaa - 5); aa < (aaaa + 3); aa++) {
                temp = {};
                temp.id = aa;
                temp.descrizione = "ANNO " + aa;
                risultato.push(temp);
            }
            console.log("risultato", risultato);
            return risultato;
        };
        ricerca.selected = [];
        ricerca.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };
        ricerca.limitOptions = [5, 10, 15, 20];
        ricerca.begin_allsearchs = function () {

            ricerca.allsearchs = {};
            ricerca.allsearchs['query[]'] = [];
            ricerca.allsearchs['query[]'][0] = {operatore: 'OR'};
            ricerca.allsearchs['query[]'][1] = {operatore: 'AND'};
            ricerca.allsearchs.operatore = 'AND';
            ricerca.allsearchs.pagination = 10;
            ricerca.allsearchs.sort = '-id';
            ricerca.allsearchs.page = 1;
            return ricerca.allsearchs;
        };
        ricerca.valuesearched = function (key, value) {
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
            }

            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;
            var jsonfilter = {};
            jsonfilter = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter);
            var valores = vm.searchForms[key].valore.split("|");
            return results[0][valores[0]];
        };

        //dinamico
        //set vuoto
        ricerca.entesegnalatores = [];
        ricerca.progettos = [];
        ricerca.progettiReport = [];
        ricerca.progettocodices = [];
        ricerca.autorizzatoprogettos = [];
        ricerca.statobeneficiarios = [];
        ricerca.naziones = [];
        ricerca.nazione = ricerca.naziones;
        ricerca.provenienza = [];
        ricerca.dublino = [];
        ricerca.tiposegnalazione = [];
        ricerca.tipoasegnalazione = [];
        ricerca.ingresso = [];
        ricerca.religione = [];
        ricerca.nucleoFamiliare = [];
        ricerca.tipoprotezione = [];
        ricerca.tipodocumento = [];
        ricerca.parentela = [];
        ricerca.vulnerabilita = [];
        ricerca.statoeventos = [];
        ricerca.segnalazionestatoeventos = [];
        ricerca.tipoeventos = [];
        ricerca.bandos = [];
        ricerca.allbandos = [];
        ricerca.corsi = [];
        ricerca.entetipos = [];
        ricerca.enteprimosettores = [];
        ricerca.entesecondosettores = [];
        ricerca.enteterzosettores = [];
        ricerca.enteruoloprogettos = [];
        ricerca.personaruoloprogettos = [];
        ricerca.motivoprorogas = [];
        ricerca.corsicategoria = [];
        ricerca.servizicategoria = [];
        ricerca.corsitutti = [];
        ricerca.servizitutti = [];
        ricerca.enti = [];  //Lor:per riceca ente titolare
        ricerca.gruppos = [];
        ricerca.personaruoloentes = [];
        ricerca.personaruoloambitos = [];
        ricerca.personastudis = [];

        ricerca.motivouscita = [];

        api.gruppos.gruppi.search({sort: "gruppo", pagination: -1}, function (r) {
            ricerca.gruppos = r.data;
        });

        ricerca.corsi = function (keyfilter) {
            api.corsi.index({filter: {corsi_id: keyfilter}, sort: "descrizione", 'per-page': 0}, function (r) {
                return r.data;
            });
        };
        ricerca.servizi = function (keyfilter) {
            api.servizi.index({filter: {servizi_id: keyfilter}, sort: "descrizione", 'per-page': 50}, function (r) {
                ricerca.servizicategoria = r.data;
            });
        };
        ricerca.motivitrasferimento = [];

//        api.progettos.progetto.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
//            ricerca.autorizzatoprogettos = r.data;
//        });

        //faccio query db
        if (ricerca.autorizzato) {
            api.progettomc.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1, dacl: 1}, function (r) {
                ricerca.progettos = r.data;
            });


        }



//        api.eventos.tipo.search({sort: "id", pagination: 100, fields: "id,nome,statiPossibili,entita1,entita2", dacl: 1}, function (r) {
//            ricerca.tipoeventos = r.data;
//        });


        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "STATO", sort: "ordinamento,descrizione"}, function (r) {
            ricerca.statobeneficiarios = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "NAZIONE", sort: "descrizione", pagination: -1}, function (r) {
            ricerca.naziones = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "TIPO-PROVENIENZA", sort: "ordinamento,descrizione", pagination: 100}, function (r) {
            ricerca.provenienza = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "DUBLINO", sort: "descrizione", pagination: 100}, function (r) {
            ricerca.dublino = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "TIPO-SEGNALAZIONE", sort: "ordinamento,descrizione", pagination: 100}, function (r) {
            ricerca.tiposegnalazione = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "TIPO-ASEGNALAZIONE", sort: "ordinamento,descrizione", pagination: 100}, function (r) {
            ricerca.tipoasegnalazione = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "INGRESSO", sort: "ordinamento,descrizione", pagination: 100}, function (r) {
            ricerca.ingresso = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "RELIGIONE", sort: "ordinamento,descrizione", pagination: 400}, function (r) {
            ricerca.religione = r.data;
        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "NUCLEOFAMILIARE", sort: "ordinamento,descrizione", pagination: 30}, function (r) {
            ricerca.nucleoFamiliare = r.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'TIPO-PROTEZIONE', sort: 'ordinamento,descrizione'}, function (response) {
            ricerca.tipoprotezione = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'DOCUMENTO', sort: 'ordinamento'}, function (response) {
            ricerca.tipodocumento = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'PARENTELA', sort: 'ordinamento,descrizione'}, function (response) {
            ricerca.parentela = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'VULNERABILITA', sort: 'ordinamento,descrizione'}, function (response) {
            ricerca.vulnerabilita = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'MOTIVO-PROROGA', sort: 'ordinamento,descrizione'}, function (response) {
            ricerca.motivoprorogas = response.data;
        });
        api.eventos.stato.search({sort: "id", pagination: 20}, function (r) {
            ricerca.statoeventos = r.data;
        });
        api.eventos.stato.search({sort: "id", pagination: 6}, function (r) {
            ricerca.segnalazionestatoeventos = r.data;
        });

        api.entetipos.entetipov.search({sort: "descrizione", pagination: 50}, function (r) {
            ricerca.entetipos = r.data;
        });
        api.entetipos.entetipo.search({enteTipo_id: 1, sort: "descrizione", pagination: -1}, function (response) {
            ricerca.enteprimosettores = response.data;
        });
        api.entetipos.entetipo.search({enteTipo_id: 2, sort: "descrizione", pagination: -1}, function (response) {
            ricerca.entesecondosettores = response.data;
        });
        api.entetipos.entetipo.search({enteTipo_id: 3, sort: "descrizione", pagination: -1}, function (response) {
            ricerca.enteterzosettores = response.data;
        });
        api.enteruolos.enteruolo.search({gruppo: "PROGETTO", sort: "descrizione"}, function (response) {
            ricerca.enteruoloprogettos = response.data;
        });
        api.personaruolos.personaruolo.search({gruppo: "PROGETTO", sort: "descrizione"}, function (response) {
            ricerca.personaruoloprogettos = response.data;
        });
        api.personaruolos.personaruolo.search({gruppo: "ENTE", sort: "descrizione"}, function (response) {
            ricerca.personaruoloentes = response.data;
        });
        api.personaruolos.personaruolo.search({gruppo: "AMBITO", sort: "descrizione"}, function (response) {
            ricerca.personaruoloambitos = response.data;
        });
        api.beneficiarioattributis.beneficiario.search({gruppo: 'MOTIVO-USCITA', sort: 'ordinamento,descrizione'}, function (response) {
            ricerca.motivouscita = response.data;
        });

//        api.personastudis.personastudi.search({sort: "descrizione", pagination: -1}, function (response) {
//            ricerca.personastudis = response.data;
//        });
//        api.cs.corso.search({corsi_id: 0, sort: "descrizione", pagination: -1}, function (r) {
//            ricerca.corsicategoria = r.data;
//        });
//        api.cs.servizio.search({servizi_id: 0, sort: "descrizione", pagination: -1}, function (r) {
//            ricerca.servizicategoria = r.data;
//        });
//        api.cs.corso.search({sort: "descrizione", pagination: -1}, function (r) {
//            ricerca.corsitutti = r.data;
//        });
//        api.cs.servizio.search({sort: "descrizione", pagination: -1}, function (r) {
//            ricerca.servizitutti = r.data;
//        });
        api.beneficiarioattributis.beneficiarioattributi.search({gruppo: "MOTIVO-TRASFERIMENTO", sort: "ordinamento,descrizione"}, function (r) {
            ricerca.motivitrasferimento = r.data;
        });

        ricerca.reloadCS = function () {
            api.bando.index({sort: "descrizione,-dataFine", 'per-page': -1, filter: {attivo: 1}}, function (r) {
              ricerca.bandos = r.data;
            });
            api.bando.index(function (r) {
              ricerca.allbandos = r.data;
            });
            api.corsi.index({filter: {corsi_id: null}, sort: "descrizione", 'per-page': 50}, function (r) {
                ricerca.corsicategoria = r.data;
            });
            api.servizi.index({filter: {servizi_id: null}, sort: "descrizione", 'per-page': 0}, function (r) {
                ricerca.servizicategoria = r.data;
            });
            api.corsi.index({sort: "descrizione", 'per-page': 0}, function (r) {
                ricerca.corsitutti = r.data;
            });
            api.servizi.index({sort: "descrizione", 'per-page': 0}, function (r) {
                ricerca.servizitutti = r.data;
            });
            api.personastudis.personastudi.search({sort: "descrizione", pagination: -1}, function (response) {
                ricerca.personastudis = response.data;
            });
            api.enteruolos.enteruolo.search({gruppo: "PROGETTO", sort: "descrizione"}, function (response) {
                ricerca.enteruoloprogettos = response.data;
            });
            api.personaruolos.personaruolo.search({gruppo: "PROGETTO", sort: "descrizione"}, function (response) {
                ricerca.personaruoloprogettos = response.data;
            });
            api.personaruolos.personaruolo.search({gruppo: "ENTE", sort: "descrizione"}, function (response) {
                ricerca.personaruoloentes = response.data;
            });
            api.personaruolos.personaruolo.search({gruppo: "AMBITO", sort: "descrizione"}, function (response) {
                ricerca.personaruoloambitos = response.data;
            });
            api.progettos.progetto.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1}, function (r) {
                ricerca.autorizzatoprogettos = r.data;
            });

        }

        ricerca.reloadUnauthorized = function () {
            api.progettos.progetto.search({attivo: 1, fields: "id,nome", sort: "nome", pagination: -1, dacl: 1}, function (r) {
                ricerca.progettos = r.data;
                return ricerca;
            });
        };

        return ricerca;
    }


})();


(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('groups', groupsService);
    /** @ngInject */

    function groupsService($cookieStore, $base64, $mdDialog, $mdToast, api, $document, $state)
    {
        var groups = this;


        return groups;
    }


})();


(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('extra', extraService);
    /** @ngInject */

    function extraService(api, $filter, $state, $mdDialog)
    {
        var extra = this;
        extra.init = init;
        extra.saveExtra = null;
        extra.deleteExtra = null;
        extra.hide = function () {
            $mdDialog.hide();
        };



        function init(tabella, item, index) {
            extra.nomeModello = tabella + 'extras';
            extra.nomeModelloChiave = tabella + '_id';
            extra.nomeModelloApi = tabella + 's';
            extra[extra.nomeModello] = angular.copy(item[extra.nomeModello]);
            extra.isnew = true;
            extra.extra = {
                id: null,
                chiave: null,
                valore: null,
            };
            extra.extra[extra.nomeModelloChiave] = item.id;
            console.log(extra.extra);

            if (index !== null) {
                extra.isnew = false;
                extra.extra = {
                    id: extra[extra.nomeModello][index].id,
                    chiave: extra[extra.nomeModello][index].chiave,
                    valore: extra[extra.nomeModello][index].valore,
                };
                extra.extra[extra.nomeModelloChiave] = extra[extra.nomeModello][index][extra.nomeModelloChiave]
            }

            extra.saveExtra = function () {
                if (extra.isnew) {
                    api[extra.nomeModelloApi].extra.save(extra.extra, function (response) {
                        $mdDialog.hide();
                        $state.reload();
                    });
                }
                if (!extra.isnew) {
                    api[extra.nomeModelloApi].extra.aggiorna(extra.extra, function (response) {
                        console.log(response);
                        $mdDialog.hide();
                        $state.reload();
                    });
                }

            };

            extra.deleteExtra = function () {
                var confirm = $mdDialog.confirm()
                        .title('Sei sicuro di voler cancellare?')
                        .htmlContent('<b>' + extra.extra.chiave + ' ' + extra.extra.valore + '</b>' + ' sarà cancellato.')
                        .ariaLabel('cancella extra')
                        .ok('OK')
                        .cancel('ABBANDONA');

                $mdDialog.show(confirm).then(function ()
                {
                    api[extra.nomeModelloApi].extra.delete(extra.extra, function (response) {
                        console.log(response);
                        $mdDialog.hide();
                        $state.reload();
                    });
                }, function () {
                });

            };
        }

        return extra;
    }


})();


(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('eventi', eventiService);
    /** @ngInject */

    function eventiService($cookieStore, $base64, $mdDialog, $mdToast, api, $document, $state, $cookies)
    {
        var eventi = this;
        eventi.authorizationB = '';
        if ($cookieStore.get('user')) {
            eventi.userlogged = $cookieStore.get('user');
            eventi.authorizationB = $base64.encode(eventi.userlogged.access_token + ':');
        }
        eventi.test = function () {
            console.log('test');
        }
        eventi.work = work;
        function work(event, item, processo, trigger, isnew) {


//            console.log('vm.work da index.eventi.js');
            var opendialog = true;
            var extrasetup = {};
            var callback = {};
            var items = [];
            var statopartenza = 0;
            if (angular.isArray(item)) {
                items = item;
                extrasetup = JSON.parse(item[0].eventoTipo.extra);
                callback = JSON.parse(item[0].eventoTipo.callback);
                statopartenza = item[0].eventoStato_id;
            } else {
                items.push(item);
                extrasetup = JSON.parse(item.eventoTipo.extra);
                callback = JSON.parse(item.eventoTipo.callback);
                statopartenza = item.eventoStato_id;
            }
//            console.log("extrasetup:", extrasetup);
//            console.log("callback:", callback);
//            console.log("oggetto processo:", item);
//            console.log("processo:", processo);
//            console.log("trigger:", trigger);
//            console.log("nuovo:", isnew);
            var formDefinition = extrasetup.properties[processo].fields;
            if (angular.isDefined(formDefinition.link)) {
                opendialog = false;
                $state.go(formDefinition.link, {evento_id: item.id});
            }
            var title = extrasetup.properties[processo].title;
            if (statopartenza == 17 && processo == 14) {
                title = "Cassazione accetta ricorso";
            }

            var button2 = extrasetup.properties[processo].cancelbutton;
            var title2 = extrasetup.properties[processo].titlecancel;
//            console.log(formDefinition);
//            console.log(title);
            if (opendialog) {
                //console.log("aperta");
                $cookies.putObject('reload', true);
                $mdDialog.show({
                    clickOutsideToClose: false,
                    controller: 'ProcessosController',
                    controllerAs: 'vm',
                    focusOnOpen: true,
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    locals: {
                        segnalati: items,
                        formDefinition: formDefinition,
                        title: title,
                        eventoStato_id: processo,
                        title2: title2,
                        button2: button2
                    },
                    templateUrl: 'app/main/sprardb/eventi/dialogs/processosc.html',
                });
            }
        }

        eventi.work2 = work2;
        function work2(event, item, processo, trigger, isnew) {
            var opendialog = true;
            var extrasetup = {};
            var callback = {};
            var items = [];
            var statopartenza = 0;
            if (angular.isArray(item)) {
                items = item;
                extrasetup = JSON.parse(item[0].eventoTipo.extra);
                callback = JSON.parse(item[0].eventoTipo.callback);
                statopartenza = item[0].eventoStato_id;
            } else {
                items.push(item);
                extrasetup = JSON.parse(item.eventoTipo.extra);
                callback = JSON.parse(item.eventoTipo.callback);
                statopartenza = item.eventoStato_id;
            }
            var formDefinition = extrasetup.properties[processo].fields;
            if (angular.isDefined(formDefinition.link)) {
                opendialog = false;
                $state.go(formDefinition.link, {evento_id: item.id});
            }
            var title = extrasetup.properties[processo].title;
            if (statopartenza == 17 && processo == 14) {
                title = "Cassazione accetta ricorso";
            }

            var button2 = extrasetup.properties[processo].cancelbutton;
            var title2 = extrasetup.properties[processo].titlecancel;
            if (opendialog) {
                $cookies.putObject('reload', true);
                $mdDialog.show({
                    clickOutsideToClose: false,
                    controller: 'ProcessosController2',
                    controllerAs: 'vm',
                    focusOnOpen: true,
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    locals: {
                        segnalati: items,
                        formDefinition: formDefinition,
                        title: title,
                        eventoStato_id: processo,
                        title2: title2,
                        button2: button2,
                        properties: extrasetup.properties,
                        tuttiprocessi: item.eventoTipo.processo
                    },
                    templateUrl: 'app/main/sprardb/eventi/dialogs/processosc2.html',
                });
            }
        }


        eventi.getExtra = getExtra;
        function getExtra(path, data) {
            //console.log(path);
            var paths = path.split('.');
            var root = data;
            angular.forEach(paths, function (obj) {
                //return obj;
                if (typeof root[obj] === 'undefined') {
                    root[obj] = {};
                }
                root = root[obj];
                if (obj == 'extra') {
                    try {
                        root = JSON.parse(root);
                    } catch (err) {
                    }
                    root = $filter('json')(root);
                    root = root.replace("{", "").replace("}", "");
                    root = root.replace(/"/g, "").replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([a-z])/g, ' $1$2').replace(/\ +/g, ' ');
                    if (root.length === 0) {
                        root = 'Nessun dato';
                    }
                }
            });
            return root;
        }

        eventi.viewDetails = viewDetails;
        function viewDetails(event, eventos, tipo) {
            console.log(eventos);
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: 'EventosDialogController',
                controllerAs: 'vm',
                focusOnOpen: false,
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                locals: {
                    item: eventos,
                    tipo: tipo},
                templateUrl: 'app/main/sprardb/eventi/dialogs/eventi-dialog.html',
            }).then(function (segnalati) {

            });
        }

        eventi.letteraSeg = letteraSeg;
        function letteraSeg(event, segnalazione_id) {
            //console.log(segnalazione_id);
            var notification = null;
            var docjson = null;
            var eventos = null;
            api.segnalaziones.segnalazione.get({id: segnalazione_id}, function (d) {
                notification = d;
                eventos = d.eventos;
                var protocollo = "NS.RIF. " + eventos.protocollo + " del " + moment(eventos.dataProtocollo).format('DD/MM/YYYY');
                if (eventos.protocollo == null) {
                    protocollo = "";
                }
                docjson = d.documentos;
                console.log("docjson", docjson);
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Minore', style: 'tableHeader'},
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'PdS Date', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = notification.segnalatos;
                var allegati = [];
                for (var ii = 0; ii < docjson.length; ii++) {
                    allegati.push(docjson[ii].nomefile);
                }
                console.log("docjson", allegati);
                for (var i = 0; i < json.length; i++) {
                    var obj = json[i];
                    var tmpobj = {};
                    tmpobj.nome = '';
                    tmpobj.cognome = '';
                    tmpobj.dataNascita = '';
                    tmpobj.nation = '';
                    tmpobj.doctipo = '';
                    tmpobj.docnumero = '';
                    tmpobj.docdate = '';
                    tmpobj.protezione = '';
                    tmpobj.parentela = '';
                    tmpobj.vulnerabilita = '';
                    tmpobj.note = '';
                    tmpobj.noteSanitarie = '';
                    tmpobj.nome = (obj.nome !== null) ? obj.nome : "";
                    tmpobj.cognome = (obj.cognome !== null) ? obj.cognome : "";
                    tmpobj.sesso = (obj.sesso !== null) ? obj.sesso : "";
                    tmpobj.dataNascita = (obj.dataNascita !== null) ? moment(obj.dataNascita).format("DD/MM/YYYY") : "";
                    tmpobj.note = (obj.note !== null) ? obj.note : "";
                    tmpobj.noteSanitarie = (obj.noteSanitarie !== null) ? obj.noteSanitarie : "";
                    tmpobj.nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tmpobj.doctipo = (obj.documentoTipo !== null) ? obj.documentoTipo.descrizione : '';
                    tmpobj.docnumero = (obj.documentoNumero !== null) ? obj.documentoNumero : '';
                    tmpobj.docdate = (obj.dataRilascioDocumento !== null && obj.dataScadenzaDocumento !== null) ? (moment(obj.dataRilascioDocumento).format("DD/MM/YYYY") + "\n" + moment(obj.dataScadenzaDocumento).format("DD/MM/YYYY")) : '';
                    tmpobj.protezione = (obj.protezioneTipo !== null) ? obj.protezioneTipo.descrizione : '';
                    tmpobj.parentela = (obj.parentelaTipo !== null) ? obj.parentelaTipo.descrizione : '';
                    tmpobj.vulnerabilita = (obj.vulnerabilitas !== null) ? obj.vulnerabilitas.descrizione : '';
                    tmpobj.minore = "SI";
                    if (obj.dataNascita !== null) {
                        var oggi = new Date();
                        var datan = new Date(obj.dataNascita);
                        //var eighteenYearsAgo = new Date((oggi.getFullYear() - 18) + "-" + (oggi.getMonth() + 1) + "-" + oggi.getDate());
                        var eighteenYearsAgo = moment().subtract(18, "years");
                        var birthday = moment(datan);
                        console.log("datan", datan);
                        console.log("eighteenYearsAgo", eighteenYearsAgo);
                        if (eighteenYearsAgo.isAfter(birthday)) {
                            //if (datan >= eighteenYearsAgo) {
                            tmpobj.minore = "NO";
                        }
                    }

//                    if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
//                        var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tabaledata.push([
                        tmpobj.minore,
                        tmpobj.parentela,
                        tmpobj.cognome,
                        tmpobj.nome,
                        tmpobj.sesso,
                        tmpobj.dataNascita,
                        tmpobj.nation,
                        tmpobj.doctipo,
                        tmpobj.docnumero,
                        tmpobj.docdate,
                        tmpobj.protezione,
                        tmpobj.vulnerabilita,
                        tmpobj.note,
                        tmpobj.noteSanitarie
                    ]);
                    // }
                }
                var docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'landscape',
                    content: [
                        {text: 'MODELLO DI SEGNALAZIONE UNIFICATO', style: 'headerrightsmallbold'},
                        {text: 'TIPO: ' + notification.modellos.descrizione, style: 'headerrightsmall'},
                        {text: 'VER. 2017/03', style: 'headerrightsmall'},
                        {canvas:
                                    [{
                                            type: 'line',
                                            x1: 0, y1: 4,
                                            x2: 765, y2: 4,
                                            lineWidth: 0.5
                                        }]
                        },
                        {text: 'SERVIZIO CENTRALE // SPRAR', style: 'headerrightsmall2'},
                        {text: protocollo + '\n', style: 'headerrightsmall2'},
                        {text: 'ENTE SEGNALANTE: ', style: 'headersmallboldg'},
                        {text: '' + notification.entes.nome, style: 'mittentebold'},
                        {text: 'Tipo: ' + notification.entes.entetipo.descrizione, style: 'mittente'},
                        {text: 'Indirizzo: ' + notification.entes.indirizzo, style: 'mittente'},
                        {text: 'Cap: ' + notification.entes.cap + ' ' + notification.entes.istat.comune + " (" + notification.entes.istat.provincia + ")", style: 'mittente'},
                        {text: 'Email: ' + notification.entes.email + ' - Telefono: ' + notification.entes.telefono, style: 'mittente'},
                        {text: '\n', style: 'mittentebold'},
                        {text: 'REFERENTE:\n', style: 'headersmallbold'},
                        {text: '' + notification.personas.cognome + ' ' + notification.personas.nome, style: 'mittente'},
                        {text: 'Email: ' + notification.personas.email, style: 'mittente'},
                        {text: 'Telefono: ' + notification.personas.telefono, style: 'mittente'},
                        {text: '\n', style: 'mittenteboldr'},
                        {text: ['Note segnalazione: ', {text: (notification.note !== null) ? notification.note : ''}], style: 'mittente'},
                        {text: '\n', style: 'headerright'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
                                body: tabaledata
                            },
                            layout: 'lightHorizontalLines'
                        },
                        {text: '\n', style: 'mittentebold'},
                        {text: '\n', style: 'mittentebold'},
                        {text: 'ALLEGATI AL DOCUMENTO: ' + allegati.length + '\n', style: 'headersmallbold'},
                        {text: '- ' + allegati.join('\n- '), style: 'headersmallboldg'},
                    ],
                    styles: {
                        headerrightsmallbold: {
                            fontSize: 8,
                            bold: true,
                            alignment: 'right'
                        },
                        headersmallboldg: {
                            fontSize: 7,
                            bold: true,
                            alignment: 'left',
                            color: 'grey'
                        },
                        headersmallbold: {
                            fontSize: 7,
                            bold: true,
                            alignment: 'left'
                        },
                        headerrightsmall: {
                            fontSize: 8,
                            alignment: 'right',
                            color: 'grey'
                        },
                        headerrightsmall2: {
                            fontSize: 8,
                            alignment: 'right'
                        },
                        mittentebold: {
                            fontSize: 10,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 5]
                        },
                        mittenteboldr: {
                            fontSize: 10,
                            bold: true,
                            alignment: 'right',
                            margin: [0, 0, 0, 5]
                        },
                        mittente: {
                            fontSize: 8,
                            alignment: 'left',
                            color: 'grey'
                        },
                        mittenter: {
                            fontSize: 8,
                            alignment: 'right',
                            color: 'grey'
                        },
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 9,
                            alignment: 'right'
                        },
                        headerrightb: {
                            fontSize: 13,
                            alignment: 'right',
                            bold: true,
                        },
                        demoTable: {
                            margin: [0, 6, 0, 6],
                            fontSize: 7
                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 7,
                            color: 'black',
                            fillColor: '#d8d8d8'
                        }
                    },
                };
                pdfMake.createPdf(docDefinition).download("letteraSegnalazione_" + notification.id + '.pdf');
            });
        }

        eventi.letteraVisita = letteraVisita;
        function letteraVisita(evento_id) {
            console.log(evento_id);
            var evento = null;
            var progetto = null;
            var monitoraggio = null;
            api.eventos.evento.get({id: evento_id}, function (d) {
                console.log(d);
                evento = d;
                progetto = evento.entita2;
                monitoraggio = evento.entita1;
                console.log(progetto);
                var entes = null;
                var enteprint = [];
                api.progettos.progetto.get({id: progetto.id, fields: "id,nome,entes"}, function (d) {
                    entes = d.entes;
                    console.log(entes);
                    var found = false;
                    angular.forEach(entes, function (obj) {
                        found = false;
                        angular.forEach(obj.enteruolos, function (obj2) {
                            if (obj2.id == 1 && found == false) {
                                found = true;
                            }
                        });
                        if (found) {
                            enteprint.push(
                                    {text: obj.nome, style: 'mittenteboldr'},
                                    {text: (obj.indirizzo !== null) ? obj.indirizzo : 'NA', style: 'mittenter'},
                                    {text: (obj.cap !== null) ? obj.cap : 'NA', style: 'mittenter'},
                                    {text: (obj.email !== null) ? obj.email : 'NA', style: 'mittenter'},
                                    {text: (obj.telefono !== null) ? obj.telefono : 'NA', style: 'mittenter'},
                                    {text: '\n', style: 'mittenter'}
                            );
                        }
                    });
                    var docDefinition = {
//                        header: {
//                            columns: [
//                                {
//                                    image: api.baseUrl + 'files/headersprar.jpg',
//                                    width: 550
//                                }
////                                {
////                                    margin: [10, 0, 0, 0],
////                                    text: 'Servizio Centrale - Via delle Quattro Fontane ,116 – 00184 Roma tel. +39 06 76980811 fax +39 066792962-www.serviziocentrale.it  - e-mail: info@serviziocentrale.it',
////                                    style: 'headerrightsmall'
////                                }
//                            ]
//                        },
                        content: [
                            {text: 'BANNER GRAFICO SPRAR', style: 'tableHeader'},
                            {text: 'LETTERA DI VISITA', style: 'headerrightsmallbold'},
                            {text: 'VER. 2016/12', style: 'headerrightsmall'},
                            {canvas:
                                        [{
                                                type: 'line',
                                                x1: 0, y1: 4,
                                                x2: 515, y2: 4,
                                                lineWidth: 0.5
                                            }]
                            },
                            {text: '\n', style: 'mittenteboldr'},
                            {text: 'Destinatario:', style: 'mittenteboldr'},
                            {text: progetto.nome, style: 'mittenteboldr'},
                            {text: 'Indirizzo: ' + progetto.indirizzo, style: 'mittenter'},
                            {text: 'Cap: ' + progetto.cap + ' ' + progetto.istat.comune + " (" + progetto.istat.provincia + ")", style: 'mittenter'},
                            {text: 'Email: ' + progetto.email + ' - Telefono: ' + progetto.telefono, style: 'mittenter'},
                            {text: '\n', style: 'mittenteboldr'},
                            {text: 'epc:', style: 'mittenteboldr'},
                            enteprint,
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: 'Oggetto: visita al progetto SPRAR ' + progetto.nome, style: 'mittentebold'},
                            {text: '\n', style: 'text'},
                            {text: 'Con la presente La informo che nei giorni dal ' + monitoraggio.dataInizio + ' al ' + monitoraggio.dataFine + ', nell’ambito delle attività di monitoraggio e consulenza tecnica che il Servizio Centrale effettuata per gli Enti Locali del Sistema di protezione per richiedenti asilo e rifugiati, un nostro incaricato si recherà in visita al vostro progetto.', style: 'mittente'},
                            {text: 'Vi sarei grata se poteste riceverla nei modi e nei tempi concordati.', style: 'mittente'},
                            {text: 'Ringraziando anticipatamente per la collaborazione, porgo cordiali saluti.', style: 'mittente'},
                            {text: '\n', style: 'mittente'},
                            {text: '\n', style: 'mittente'},
                            {text: 'Daniela Di Capua', style: 'mittentebold'},
                            {text: 'Direttrice del Servizio Centrale', style: 'mittente'}
                        ],
                        styles: {
                            headerrightsmallbold: {
                                fontSize: 8,
                                bold: true,
                                alignment: 'right'
                            },
                            headerrightsmall: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            mittentebold: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 5]
                            },
                            mittenteboldr: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'right',
                                margin: [0, 0, 0, 5]
                            },
                            mittente: {
                                fontSize: 8,
                                alignment: 'left',
                                color: 'grey'
                            },
                            mittenter: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            headerright: {
                                fontSize: 9,
                                alignment: 'right'
                            },
                            headerrightb: {
                                fontSize: 13,
                                alignment: 'right',
                                bold: true,
                            },
                            demoTable: {
                                margin: [0, 10, 0, 10],
                                fontSize: 8
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 9,
                                color: 'black',
                                fillColor: '#d8d8d8'
                            }
                        },
                    };
                    pdfMake.createPdf(docDefinition).download("letteraVisita_" + evento_id + '.pdf');
                });
            });
        }

        eventi.letteraIns = letteraIns;
        function letteraIns(event, letterainserimento) {
            console.log("letterainserimento:", letterainserimento);
            var segs = null;
            var segnalaziones = null;
            api.segnalatos.segnalatomag.search({letteraInserimento: letterainserimento, dacl: 1}, function (d) {
                segs = d.data;
                segnalaziones = segs[0].segnalaziones;
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = segs;
                var jsonfields = [
                    ['parentelaTipo', 'descrizione'],
                    'cognome', 'nome', 'sesso', 'dataNascita',
                    ['codNazionalitas', 'descrizione'],
                    ['documentoTipo', 'descrizione'],
                    'documentoNumero',
                    ['protezioneTipo', 'descrizione'],
                    ['vulnerabilitas', 'descrizione'],
                    'note',
                    'noteSanitarie'
                ];
                angular.forEach(json, function (sjson) {
                    var tmp = [];
                    angular.forEach(jsonfields, function (jsonfield) {
                        var eacht = jsonfield;
                        if (angular.isArray(jsonfield)) {
                            var ttmp = sjson;
                            eacht = '';
                            angular.forEach(jsonfield, function (each, idx, array) {
                                console.log("ttmp", ttmp);
                                console.log("each", each);
                                if (angular.isUndefined(ttmp[each]) || ttmp[each] === null) {
                                    if (idx === array.length - 1) {
                                        ttmp[each] = " ";
                                    } else {
                                        ttmp[each] = {};
                                    }
                                }
                                ttmp = ttmp[each];
                                console.log("ttmp risultato: ", ttmp);
                                eacht = eacht + "_" + each;
                            });
                            //tmp.push((ttmp !== null) ? ttmp : "");
                            tmp[eacht] = (ttmp !== null) ? ttmp : " ";
                        } else {
                            //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
                            tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
                        }
                    });
                    tabaledata.push([
                        tmp['_parentelaTipo_descrizione'],
                        tmp.cognome, tmp.nome, tmp.sesso, moment(tmp.dataNascita).format("DD/MM/YYYY"),
                        tmp['_codNazionalitas_descrizione'],
                        tmp['_documentoTipo_descrizione'],
                        tmp.documentoNumero,
                        tmp['_protezioneTipo_descrizione'],
                        tmp['_vulnerabilitas_descrizione'],
                        tmp.note,
                        tmp.noteSanitarie
                    ]);
                });
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    var templater = rend.template.split("|");
                    var enteprint = [];
                    var keepGoing = true;
                    angular.forEach(templater, function (tt) {
                        if (keepGoing) {
                            if (tt !== "nota0" && renderizzato[tt] != null) {
                                enteprint.push({text: '' + renderizzato[tt] + '\n\n', style: 'headerright'});
                            }
                            if (tt === "nota2") {
                                keepGoing = false;
                            }
                        }
                    });
                    var testImageDataUrl = renderizzato["nota0"];
                    var docDefinition = {
                        background: function (page) {
                            return [
                                {
                                    image: testImageDataUrl,
                                    width: 520,
                                    absolutePosition: {x: 40, y: 20}
                                }
                            ];
                        },
                        content: [
                            {text: 'LETTERA INSERIMENTO UNIFICATA', style: 'headerrightsmallbold'},
                            {text: 'TIPO: ' + segnalaziones.modellos.descrizione, style: 'headerrightsmall'},
                            {text: 'VER. 2017/03', style: 'headerrightsmall'},
//                            {
//                                image: testImageDataUrl,
//                                width: 530
//                            },
                            {canvas:
                                        [{
                                                type: 'line',
                                                x1: 0, y1: 53,
                                                x2: 520, y2: 53,
                                                lineWidth: 1.5
                                            }]
                            },
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            enteprint,
                            {text: 'Roma ' + moment(segnalaziones.data).format("DD/MM/YYYY") + '\n', style: 'text'},
                            {text: 'NS.RIF. ' + renderizzato.protocollo + ' \n\n', style: 'text'},
                            {text: '' + renderizzato.nota3, style: 'textb'},
                            {text: '\n', style: 'text'},
                            {text: 'Con la presente si dispone l\'inserimento di:\n', style: 'text'},
                            {
                                style: 'demoTable',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                    body: tabaledata
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {text: '\n', style: 'text'},
                            {text: '' + renderizzato.nota4 + '\n\n', style: 'text'},
                            {text: '' + renderizzato.nota5, style: 'textb'}
                        ],
                        styles: {
                            text: {
                                fontSize: 8,
                                alignment: 'left'
                            },
                            textb: {
                                fontSize: 8,
                                alignment: 'left',
                                bold: true
                            },
                            headerright: {
                                fontSize: 7,
                                alignment: 'right',
                                bold: true
                            },
                            headercenter: {
                                fontSize: 9,
                                alignment: 'center'
                            },
                            headerrightb: {
                                fontSize: 10,
                                alignment: 'right',
                                bold: true,
                            },
                            headerrightsmallbold: {
                                fontSize: 6,
                                bold: true,
                                alignment: 'right'
                            },
                            headersmallboldg: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left',
                                color: 'grey'
                            },
                            headersmallbold: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left'
                            },
                            headerrightsmall: {
                                fontSize: 6,
                                alignment: 'right',
                                color: 'grey'
                            },
                            headerrightsmall2: {
                                fontSize: 8,
                                alignment: 'right'
                            },
                            mittentebold: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 5]
                            },
                            mittenteboldr: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'right',
                                margin: [0, 0, 0, 5]
                            },
                            mittente: {
                                fontSize: 8,
                                alignment: 'left',
                                color: 'grey'
                            },
                            mittenter: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            demoTable: {
                                margin: [0, 6, 0, 6],
                                fontSize: 6,
                                bold: true
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 7,
                                color: 'black',
                                fillColor: '#d8d8d8'
                            }
                        },
                    };
                    pdfMake.createPdf(docDefinition).download("letteraInserimento_" + letterainserimento + '.pdf');
                });
            });
        }

        eventi.letteraTrasf = letteraTrasf;
        function letteraTrasf(event, beneficiario_id) {
            console.log(beneficiario_id);
            var segnalaziones = null;
            api.beneficiarios.beneficiario.get({id: beneficiario_id}, function (d) {
                var seg = d;
                var dataTrasferimento = null;
                angular.forEach(seg.eventos, function (eventoSingolo) {
                    if (eventoSingolo.eventoTipo_id == 1013) {
                        dataTrasferimento = eventoSingolo.dataInizio;
                    }
                })
                var segs = [];
                segs.push(d);
                console.log("SEGS", segs);
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = segs;
                var jsonfields = [
                    ['parentelas', 'descrizione'],
                    'cognome', 'nome', 'sesso', 'dataNascita',
                    ['nazionalita', 'descrizione'],
                    ['tipoDocumento', 'descrizione'],
                    'documentoNumero',
                    ['protezioneTipo', 'descrizione'],
                    ['vulnerabilitas', 'descrizione'],
                    'note',
                    'noteSanitarie'
                ];
                angular.forEach(json, function (sjson) {
                    var tmp = [];
                    angular.forEach(jsonfields, function (jsonfield) {
                        var eacht = jsonfield;
                        if (angular.isArray(jsonfield)) {
                            var ttmp = sjson;
                            eacht = '';
                            angular.forEach(jsonfield, function (each, idx, array) {
                                console.log("ttmp", ttmp);
                                console.log("each", each);
                                if (angular.isUndefined(ttmp[each]) || ttmp[each] === null) {
                                    if (idx === array.length - 1) {
                                        ttmp[each] = " ";
                                    } else {
                                        ttmp[each] = {};
                                    }
                                }
                                ttmp = ttmp[each];
                                console.log("ttmp risultato: ", ttmp);
                                eacht = eacht + "_" + each;
                            });
                            //tmp.push((ttmp !== null) ? ttmp : "");
                            tmp[eacht] = (ttmp !== null) ? ttmp : " ";
                        } else {
                            //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
                            tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
                        }
                    });
                    tabaledata.push([
                        tmp['_parentelas_descrizione'],
                        tmp.cognome, tmp.nome, tmp.sesso, moment(tmp.dataNascita).format("DD/MM/YYYY"),
                        tmp['_nazionalita_descrizione'],
                        tmp['_tipoDocumento_descrizione'],
                        tmp.documentoNumero,
                        tmp['_protezioneTipo_descrizione'],
                        tmp['_vulnerabilitas_descrizione'],
                        tmp.note,
                        tmp.noteSanitarie
                    ]);
                });
                var letterainserimento = segs[0].letteratrasferimento_id;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    var templater = rend.template.split("|");
                    var enteprint = [];
                    var keepGoing = true;
                    angular.forEach(templater, function (tt) {
                        if (keepGoing) {
                            if (tt !== "nota0" && renderizzato[tt] != null) {
                                enteprint.push({text: '' + renderizzato[tt] + '\n\n', style: 'headerright'});
                            }
                            if (tt === "nota2") {
                                keepGoing = false;
                            }
                        }
                    });
                    var testImageDataUrl = renderizzato["nota0"];
                    var docDefinition = {
                        pageMargins: [30, 230, 30, 30],
                        background: function (currentPage, pageCount) {
                            if (currentPage == 0) {
                                return [
                                    {
                                        image: testImageDataUrl,
                                        width: 520,
                                        absolutePosition: {x: 40, y: 20}
                                    }
                                ];
                            }
                        },
                        header: function (currentPage, pageCount) {
                            if (currentPage > 0) {
                                return [
                                    {image: testImageDataUrl, width: 550, margin: [20, 20, 20, 0]},
                                    {text: '\n', style: 'headerright'},
                                    {text: 'LETTERA TRASFERIMENTO UNIFICATA', style: 'headerrightsmallbold', margin: [0, 0, 30, 0]},
                                    {text: 'TIPO: TRASF/B - VER. 2017/03', style: 'headerrightsmall', margin: [0, 0, 30, 0]},
                                    {text: 'ID: ' + beneficiario_id + '/' + letterainserimento, style: 'headerrightsmall', margin: [0, 0, 30, 0]},
                                    {text: '------------------------------------------------------', style: 'headerrightsmallbold', margin: [0, 0, 30, 0]}
                                ]
                            }


                        },
                        content: [
//                            {text: 'LETTERA TRASFERIMENTO UNIFICATA', style: 'headerrightsmallbold'},
//                            {text: 'TIPO: TRASF/B - VER. 2017/03', style: 'headerrightsmall'},
//                            {text: 'ID: ' + beneficiario_id + '/' + letterainserimento, style: 'headerrightsmall'},
//                            {
//                                image: testImageDataUrl,
//                                width: 530
//                            },
//                            {canvas:
//                                        [{
//                                                type: 'line',
//                                                x1: 0, y1: 53,
//                                                x2: 520, y2: 53,
//                                                lineWidth: 1.5
//                                            }]
//                            },
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
                            enteprint,
                            {text: 'Roma ' + moment(dataTrasferimento).format("DD/MM/YYYY") + '\n', style: 'text'},
                            {text: 'Ns.Rif.DDra/n. ' + renderizzato.protocollo + '  del  ' + moment(renderizzato.dataProtocollo).format("DD/MM/YYYY") + ' \n\n', style: 'text'},
                            {text: '' + renderizzato.nota3, style: 'textb'},
                            {text: '\n', style: 'text'},
                            {text: 'Con la presente si dispone il trasferimento di:\n', style: 'text'},
                            {
                                style: 'demoTable',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                    body: tabaledata
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {text: '\n', style: 'text'},
                            {text: '' + renderizzato.nota4 + '\n\n', style: 'text'},
                            {text: '' + renderizzato.nota5, style: 'textb'}
                        ],
                        styles: {
                            text: {
                                fontSize: 8,
                                alignment: 'left'
                            },
                            textb: {
                                fontSize: 8,
                                alignment: 'left',
                                bold: true
                            },
                            headerright: {
                                fontSize: 7,
                                alignment: 'right',
                                bold: true
                            },
                            headercenter: {
                                fontSize: 9,
                                alignment: 'center'
                            },
                            headerrightb: {
                                fontSize: 10,
                                alignment: 'right',
                                bold: true,
                            },
                            headerrightsmallbold: {
                                fontSize: 6,
                                bold: true,
                                alignment: 'right'
                            },
                            headersmallboldg: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left',
                                color: 'grey'
                            },
                            headersmallbold: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left'
                            },
                            headerrightsmall: {
                                fontSize: 6,
                                alignment: 'right',
                                color: 'grey'
                            },
                            headerrightsmall2: {
                                fontSize: 8,
                                alignment: 'right'
                            },
                            mittentebold: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 5]
                            },
                            mittenteboldr: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'right',
                                margin: [0, 0, 0, 5]
                            },
                            mittente: {
                                fontSize: 8,
                                alignment: 'left',
                                color: 'grey'
                            },
                            mittenter: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            demoTable: {
                                margin: [0, 6, 0, 6],
                                fontSize: 6,
                                bold: true
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 7,
                                color: 'black',
                                fillColor: '#d8d8d8'
                            }
                        },
                    };
                    pdfMake.createPdf(docDefinition).download("letteraTrasf_" + beneficiario_id + '.' + letterainserimento + '.pdf');
                });
            });
        }
        /*
         function letteraTrasf0(event, letterainserimento) {
         console.log(letterainserimento);
         var segs = null;
         api.beneficiarios.beneficiario.search({letteratrasferimento_id: letterainserimento, fields: "id,nome,cognome,sesso,dataNascita,codNazionalita,nazionalita,documentoNumero"}, function (d) {
         segs = d.data;
         console.log(segs);
         var tabaledata = [];
         tabaledata.push([
         {text: 'Nome', style: 'tableHeader'},
         {text: 'Cognome', style: 'tableHeader'},
         {text: 'Sesso', style: 'tableHeader'},
         {text: 'Data Nascita', style: 'tableHeader'},
         {text: 'Nazionalita', style: 'tableHeader'},
         {text: 'Documento', style: 'tableHeader'},
         {text: 'Codice.', style: 'tableHeader'}
         ]);
         var json = segs;
         var jsonfields = ['nome', 'cognome', 'sesso', 'dataNascita', ['nazionalita', 'descrizione'], 'documentoNumero', 'id'];
         angular.forEach(json, function (sjson) {
         var tmp = [];
         angular.forEach(jsonfields, function (jsonfield) {
         var eacht = jsonfield;
         if (angular.isArray(jsonfield)) {
         var ttmp = sjson;
         eacht = '';
         angular.forEach(jsonfield, function (each) {
         if (typeof ttmp[each] === undefined) {
         ttmp[each] = {};
         }
         ttmp = ttmp[each];
         eacht = eacht + "_" + each;
         });
         //tmp.push((ttmp !== null) ? ttmp : "");
         tmp[eacht] = (ttmp !== null) ? ttmp : " ";
         } else {
         //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
         tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
         }
         });
         tabaledata.push([tmp.nome, tmp.cognome, tmp.sesso, tmp.dataNascita, tmp['_nazionalita_descrizione'], tmp.documentoNumero, tmp.id]);
         });
         console.log(tabaledata);
         //                for (var i = 0; i < json.length; i++) {
         //                    var obj = json[i];
         //                    console.log(obj);
         ////                    if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
         //                    var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
         //                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
         //                    tabaledata.push([obj.nome, obj.cognome, obj.sesso, obj.dataNascita, nation, obj.note, obj.noteSanitarie]);
         ////                    }
         //                }
         var enti = [];
         var enteprint = [];
         var entes = null;
         var letterai = null;
         api.letterainserimentos.letterainserimento.get({id: letterainserimento}, function (r) {
         letterai = r;
         enti.push(letterai.ente1_id);
         enti.push(letterai.ente2_id);
         enti.push(letterai.ente3_id);
         enti.push(letterai.ente4_id);
         enti.push(letterai.ente5_id);
         enti.push(letterai.ente6_id);
         enti.push(letterai.ente7_id);
         enti.push(letterai.ente8_id);
         enti.push(letterai.ente9_id);
         console.log("enti", enti.join());
         api.entes.ente.search({id_IN: enti.join()}, function (d) {
         entes = d.data;
         angular.forEach(entes, function (obj) {
         enteprint.push(
         {text: obj.nome, style: 'headerrightb'},
         {text: (obj.entetipo.descrizione !== null) ? obj.entetipo.descrizione : 'NA', style: 'headerright'},
         {text: (obj.indirizzo !== null) ? obj.indirizzo : 'NA', style: 'headerright'},
         {text: (obj.cap !== null) ? obj.cap : 'NA', style: 'headerright'},
         {text: (obj.email !== null) ? obj.email : 'NA', style: 'headerright'},
         {text: (obj.telefono !== null) ? obj.telefono : 'NA', style: 'headerright'},
         {text: '\n', style: 'headerright'}
         );
         });
         var docDefinition = {
         content: [
         {text: 'Lettera Trasferimento', style: 'header'},
         {text: '(intestazione grafica)', style: 'headerright'},
         {text: '\n', style: 'header'},
         {text: 'epc:', style: 'headercenter'},
         {text: '\n', style: 'headerright'},
         enteprint,
         {text: '\n', style: 'text'},
         {text: 'Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...', style: 'text'},
         {text: '\n', style: 'text'},
         {
         style: 'demoTable',
         table: {
         headerRows: 1,
         widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
         body: tabaledata
         },
         layout: 'lightHorizontalLines'
         },
         {text: '\n', style: 'text'},
         {text: 'Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...Lorem ipsum dolor...', style: 'text'}
         ],
         styles: {
         text: {
         fontSize: 9,
         alignment: 'left'
         },
         header: {
         fontSize: 18,
         bold: true,
         margin: [0, 0, 0, 10],
         alignment: 'center'
         },
         headerright: {
         fontSize: 9,
         alignment: 'right'
         },
         headercenter: {
         fontSize: 9,
         alignment: 'center'
         },
         headerrightb: {
         fontSize: 13,
         alignment: 'right',
         bold: true,
         },
         demoTable: {
         margin: [0, 10, 0, 10]

         },
         tableHeader: {
         bold: true,
         fontSize: 12,
         color: 'black'
         }
         },
         };
         pdfMake.createPdf(docDefinition).download("letteraTrasferimento_" + letterainserimento + '.pdf');
         });
         });
         });
         }
         */
        eventi.eventiDetails = {
            segnalato: [
                {
                    guid: "Codice",
                    cognome: 'Cognome',
                    nome: 'Nome'
                }, {
                    sesso: "Sesso",
                    dataNascita: "Data di nascita",
                    "codNazionalitas.descrizione": "Nazionalità",
                }, {
                    note: "Note",
                    noteSanitarie: "Note Sanitarie"

                }, {
                    "segnalaziones.personas.cognome": "Cognome Segnalatore",
                    "segnalaziones.personas.nome": "Nome Segnalatore",
                    "segnalaziones.personas.telefono": "Tel Segnalatore"
                }, {
                    "progettos.nome": "Identificativo progetto",
                    "struttura_id": "Identificativo struttura",
                    segnalazione_id: "Identificativo segnalazione"
                }],
            segnalazione: [{
                    id: "#",
//                    guid: "Codice",
                    data: 'Data Segnalazione'
                }, {
                    "modellos.descrizione": 'Tipo Segnalazione',
                    progetto_id: "Identificativo progetto"
                }, {
                    "entes.nome": "Ente Segnalatore",
                    "entes.entetipo.descrizione": "Tipologia Ente S.",
                }, {
                    "entes.email": "Email Segnalatore",
                    "entes.telefono": "Tel Segnalatore",
                }, {
                    note: "Note"
                }],
            progetto: [{
                    id: "Codice",
                    nome: 'Nome Progetto'
                }, {
                    "istat.regione": "Regione",
                    "istat.provincia": "Provincia",
                    "istat.comune": "Comune",
                }, {
                    indirizzo: "Indirizzo",
                    email: "Email"
                }, {
                    dataInizio: "Data Inizio Progetto",
                    postiTotali: "Posti Totali",
                    telefono: "Telefono"
                }],
            extra: [{
                    extra: "Parametri extra"
                }, {
                    dataProtocollo: "Data Protocollazione",
                    protocollo: "Numero di protocollo"
                }],
            evento: [
                {
                    "eventoTipo.nome": "Evento"
                }, {
                    "eventoStato.stato": "Stato"
                },
                {
                    dataInserimento: "Data Inserimento",
                    dataInizio: "Data Inizio"
                }, {
                    dataFine: "Data Fine",
                    dataAlert: "Data Alert"
                }, {
                    dataProtocollo: "Data Protocollazione",
                    protocollo: "Numero di protocollo"
                },
                , {
                    "entita1.cognome": "Cognome",
                    "entita1.nome": "Nome"
                },
                {
                    extra: "Dati"
                }

            ],
            beneficiario: [
                {
                    "id": "Codice",
                    "cognome": 'Cognome',
                    "nome": 'Nome'
                }, {
                    "sesso": "Sesso",
                    "dataNascita": "Data di nascita",
                    "nazionalita.descrizione": "Nazionalità",
                }, {
                    "stato": "Stato",
                    "dataInserimento": "Data Inserimento"

                }, {
                    "dataIngresso": "Data Ingresso",
                    "dataFine": "Data Fine",
                    "dataUscita": "Data Uscita"
                }, {
                    "progettos.nome": "Progetto",
                    "religione": "Religione"
                }, {
                    "documentoNumero": "Documento Numero",
                    "tipoDocumento.descrizione": "Documento Tipo"
                }],
            struttura: [
                {
                    "id": "Codice",
                    "nome": 'Nome'
                }, {
                    "progettos.nome": 'Progetto'
                }, {
                    "indirizzo": "Indirizzo",
                    "istats.comune": "Comune",
                    "istats.provincia": "Provincia",
                }, {
                    "numeroIgienici": "Servizi Igienici",
                    "numeroStanze": "Numero Stanze",
                    "numeroPosti": "Numero Posti"

                }, {
                    "strutturaAccoglienzas.descrizione": "Tipo Accoglienza",
                    "strutturaAlloggios.descrizione": "Tipo Alloggio"
                }]
        };
        eventi.colors = ['md-blue-grey-400-bg', 'md-blue-grey-600-bg', 'md-teal-300-bg', 'md-teal-700-bg', 'md-amber-300-bg', 'md-amber-700-bg', 'md-grey-400-bg', 'md-grey-800-bg', 'md-light-green-300-bg', 'md-light-green-500-bg', 'md-red-500-bg', 'md-red-900-bg', 'md-cyan-800-bg', 'md-cyan-400-bg', 'md-lime-300-bg', 'md-lime-500-bg', 'md-blue-400-bg', 'md-blue-900-bg', 'md-pink-200-bg', 'md-pink-700-bg', 'md-light-green-900-bg', 'md-lime-900-bg', 'md-blue-grey-900-bg'];
        eventi.scolors = ['md-blue-grey-200-bg', 'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'];
        eventi.colors2 = [
            'md-blue-grey-200-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-orange-800-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-blue-grey-200-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'
        ];
        eventi.colors3 = [
            'md-blue-grey-200-bg', 'md-blue-grey-600-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-amber-700-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-orange-800-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg',
            'md-teal-400-bg', 'md-amber-200-bg', 'md-grey-300-bg', 'md-light-green-500-bg', 'md-red-900-bg'
        ];
        eventi.icons = [
            'icon-drag',
            'icon-code-tags', 'icon-star-circle', 'icon-cog', 'icon-check', 'icon-close',
            'icon-exclamation', 'icon-calendar-clock', 'icon-drag', 'icon-drag', 'icon-code-tags',
            'icon-drag', 'icon-drag', 'icon-drag', 'icon-check', 'icon-close',
            'icon-drag', 'icon-drag', 'icon-drag', 'icon-drag', 'icon-stop'
        ];
        eventi.richestaprorogaottenibile = richestaprorogaottenibile;
        function richestaprorogaottenibile(item) {
            if (item.dataUscita !== null || angular.isUndefined(item.dataUscita)) {
                //console.log('proroga NO 1');
                return false;
            }
            if (item.stato === 'TERMINATO') {
                //console.log('proroga NO 2');
              item.errorMsgProroga = 'Beneficiario terminato'
              return false;
            }
            if (item.dataFine === null || item.dataFine == '') {
                //console.log('proroga NO 2');
              item.errorMsgProroga = 'Data fine accoglienza indefinita'
                return false;
            }

	//proroghe 365g
            var dataf = moment(item.dataFine);
            var dataf2 = moment(item.dataFine);
            var datainiziovalidita = dataf.subtract(365, 'days');
            var scadenzadataf = dataf2.add(365, 'days');
            var o = new Date();
            var oggi = moment(o);

            if (datainiziovalidita <= oggi && oggi <= scadenzadataf) {
                return true;
            } else {
              item.errorMsgProroga = 'Data fine accoglienza troppo lontana'
              return false;
            }
        }

        eventi.uscitaottenibile = uscitaottenibile;
        function uscitaottenibile(item) {
            var esito = true;
            if (item.dataUscita !== null) {
                esito = false;
            }
            if (item.stato === 'TERMINATO') {
                esito = false;
            }
            return esito;
        }

        eventi.buffer = undefined;
        eventi.modellosegnalazione = modellosegnalazione;
        function modellosegnalazione(event, segnalazione_id) {
            //console.log(segnalazione_id);
            var notification = null;
            var docjson = null;
            var eventos = null;
            api.segnalaziones.segnalazione.get({id: segnalazione_id}, function (d) {

                notification = d;
                eventos = d.eventos;
                var protocollo = "NS.RIF. " + eventos.protocollo + " del " + eventos.dataProtocollo;
                if (eventos.protocollo == null) {
                    protocollo = "";
                }
                docjson = d.documentos;
                console.log("docjson", docjson);
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Minore', style: 'tableHeader'},
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'PdS Date', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = notification.segnalatos;
                var allegati = [];
                for (var ii = 0; ii < docjson.length; ii++) {
                    allegati.push(docjson[ii].nomefile);
                }
                console.log("docjson", allegati);
                for (var i = 0; i < json.length; i++) {
                    var obj = json[i];
                    var tmpobj = {};
                    tmpobj.nome = '';
                    tmpobj.cognome = '';
                    tmpobj.dataNascita = '';
                    tmpobj.nation = '';
                    tmpobj.doctipo = '';
                    tmpobj.docnumero = '';
                    tmpobj.docdate = '';
                    tmpobj.protezione = '';
                    tmpobj.parentela = '';
                    tmpobj.vulnerabilita = '';
                    tmpobj.note = '';
                    tmpobj.noteSanitarie = '';
                    tmpobj.nome = (obj.nome !== null) ? obj.nome : "";
                    tmpobj.cognome = (obj.cognome !== null) ? obj.cognome : "";
                    tmpobj.sesso = (obj.sesso !== null) ? obj.sesso : "";
                    tmpobj.dataNascita = (obj.dataNascita !== null) ? moment(obj.dataNascita).format("DD/MM/YYYY") : "";
                    tmpobj.note = (obj.note !== null) ? obj.note : "";
                    tmpobj.noteSanitarie = (obj.noteSanitarie !== null) ? obj.noteSanitarie : "";
                    tmpobj.nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tmpobj.doctipo = (obj.documentoTipo !== null) ? obj.documentoTipo.descrizione : '';
                    tmpobj.docnumero = (obj.documentoNumero !== null) ? obj.documentoNumero : '';
                    tmpobj.docdate = (obj.dataRilascioDocumento !== null && obj.dataScadenzaDocumento !== null) ? (moment(obj.dataRilascioDocumento).format("DD/MM/YYYY") + "\n" + moment(obj.dataScadenzaDocumento).format("DD/MM/YYYY")) : '';
                    tmpobj.protezione = (obj.protezioneTipo !== null) ? obj.protezioneTipo.descrizione : '';
                    tmpobj.parentela = (obj.parentelaTipo !== null) ? obj.parentelaTipo.descrizione : '';
                    tmpobj.vulnerabilita = (obj.vulnerabilitas !== null) ? obj.vulnerabilitas.descrizione : '';
                    tmpobj.minore = "SI";
                    if (obj.dataNascita !== null) {
                        var oggi = new Date();
                        var datan = new Date(obj.dataNascita);
                        //var eighteenYearsAgo = new Date((oggi.getFullYear() - 18) + "-" + (oggi.getMonth() + 1) + "-" + oggi.getDate());
                        var eighteenYearsAgo = moment().subtract(18, "years");
                        var birthday = moment(datan);
                        console.log("datan", datan);
                        console.log("eighteenYearsAgo", eighteenYearsAgo);
                        if (eighteenYearsAgo.isAfter(birthday)) {
                            //if (datan >= eighteenYearsAgo) {
                            tmpobj.minore = "NO";
                        }
                    }

//                    if (obj.nome !== null && obj.cognome !== null && obj.sesso !== null && obj.dataNascita !== null && obj.note !== null && obj.noteSanitarie !== null) {
//                        var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    // var nation = (obj.codNazionalitas !== null) ? obj.codNazionalitas.descrizione : '';
                    tabaledata.push([
                        tmpobj.minore,
                        tmpobj.parentela,
                        tmpobj.cognome,
                        tmpobj.nome,
                        tmpobj.sesso,
                        tmpobj.dataNascita,
                        tmpobj.nation,
                        tmpobj.doctipo,
                        tmpobj.docnumero,
                        tmpobj.docdate,
                        tmpobj.protezione,
                        tmpobj.vulnerabilita,
                        tmpobj.note,
                        tmpobj.noteSanitarie
                    ]);
                    // }
                }
                var docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'landscape',
                    content: [
                        {text: 'MODELLO DI SEGNALAZIONE UNIFICATO', style: 'headerrightsmallbold'},
                        {text: 'TIPO: ' + notification.modellos.descrizione, style: 'headerrightsmall'},
                        {text: 'VER. 2017/03', style: 'headerrightsmall'},
                        {canvas:
                                    [{
                                            type: 'line',
                                            x1: 0, y1: 4,
                                            x2: 765, y2: 4,
                                            lineWidth: 0.5
                                        }]
                        },
                        {text: 'SERVIZIO CENTRALE // SPRAR', style: 'headerrightsmall2'},
                        {text: protocollo + '\n', style: 'headerrightsmall2'},
                        {text: 'ENTE SEGNALANTE: ', style: 'headersmallboldg'},
                        {text: '' + notification.entes.nome, style: 'mittentebold'},
                        {text: 'Tipo: ' + notification.entes.entetipo.descrizione, style: 'mittente'},
                        {text: 'Indirizzo: ' + notification.entes.indirizzo, style: 'mittente'},
                        {text: 'Cap: ' + notification.entes.cap + ' ' + notification.entes.istat.comune + " (" + notification.entes.istat.provincia + ")", style: 'mittente'},
                        {text: 'Email: ' + notification.entes.email + ' - Telefono: ' + notification.entes.telefono, style: 'mittente'},
                        {text: '\n', style: 'mittentebold'},
                        {text: 'REFERENTE:\n', style: 'headersmallbold'},
                        {text: '' + notification.personas.cognome + ' ' + notification.personas.nome, style: 'mittente'},
                        {text: 'Email: ' + notification.personas.email, style: 'mittente'},
                        {text: 'Telefono: ' + notification.personas.telefono, style: 'mittente'},
                        {text: '\n', style: 'mittenteboldr'},
                        {text: ['Note segnalazione: ', {text: (notification.note !== null) ? notification.note : ''}], style: 'mittente'},
                        {text: '\n', style: 'headerright'},
                        {
                            style: 'demoTable',
                            table: {
                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
                                body: tabaledata
                            },
                            layout: 'lightHorizontalLines'
                        },
                        {text: '\n', style: 'mittentebold'},
                        {text: '\n', style: 'mittentebold'},
                        {text: 'ALLEGATI AL DOCUMENTO: ' + allegati.length + '\n', style: 'headersmallbold'},
                        {text: '- ' + allegati.join('\n- '), style: 'headersmallboldg'},
                    ],
                    styles: {
                        headerrightsmallbold: {
                            fontSize: 8,
                            bold: true,
                            alignment: 'right'
                        },
                        headersmallboldg: {
                            fontSize: 7,
                            bold: true,
                            alignment: 'left',
                            color: 'grey'
                        },
                        headersmallbold: {
                            fontSize: 7,
                            bold: true,
                            alignment: 'left'
                        },
                        headerrightsmall: {
                            fontSize: 8,
                            alignment: 'right',
                            color: 'grey'
                        },
                        headerrightsmall2: {
                            fontSize: 8,
                            alignment: 'right'
                        },
                        mittentebold: {
                            fontSize: 10,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 5]
                        },
                        mittenteboldr: {
                            fontSize: 10,
                            bold: true,
                            alignment: 'right',
                            margin: [0, 0, 0, 5]
                        },
                        mittente: {
                            fontSize: 8,
                            alignment: 'left',
                            color: 'grey'
                        },
                        mittenter: {
                            fontSize: 8,
                            alignment: 'right',
                            color: 'grey'
                        },
                        header: {
                            fontSize: 18,
                            bold: true,
                            margin: [0, 0, 0, 10],
                            alignment: 'center'
                        },
                        headerright: {
                            fontSize: 9,
                            alignment: 'right'
                        },
                        headerrightb: {
                            fontSize: 13,
                            alignment: 'right',
                            bold: true,
                        },
                        demoTable: {
                            margin: [0, 6, 0, 6],
                            fontSize: 7
                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 7,
                            color: 'black',
                            fillColor: '#d8d8d8'
                        }
                    },
                };
                //pdfMake.createPdf(docDefinition).download("letteraSegnalazione_" + notification.id + '.pdf');
                var pdfDocGenerator = pdfMake.createPdf(docDefinition);
                pdfDocGenerator.getBase64(function (data) {
                    eventi.buffer = data;
                });


            });
        }

        eventi.letterainserimento = letterainserimento;
        function letterainserimento(event, letterainserimento) {
            console.log("letterainserimento:", letterainserimento);
            var segs = null;
            var segnalaziones = null;
            api.segnalatos.segnalatomag.search({letteraInserimento: letterainserimento}, function (d) {
                segs = d.data;
                segnalaziones = segs[0].segnalaziones;
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = segs;
                var jsonfields = [
                    ['parentelaTipo', 'descrizione'],
                    'cognome', 'nome', 'sesso', 'dataNascita',
                    ['codNazionalitas', 'descrizione'],
                    ['documentoTipo', 'descrizione'],
                    'documentoNumero',
                    ['protezioneTipo', 'descrizione'],
                    ['vulnerabilitas', 'descrizione'],
                    'note',
                    'noteSanitarie'
                ];
                angular.forEach(json, function (sjson) {
                    var tmp = [];
                    angular.forEach(jsonfields, function (jsonfield) {
                        var eacht = jsonfield;
                        if (angular.isArray(jsonfield)) {
                            var ttmp = sjson;
                            eacht = '';
                            angular.forEach(jsonfield, function (each, idx, array) {
                                //console.log("ttmp", ttmp);
                                //console.log("each", each);
                                if (angular.isUndefined(ttmp[each]) || ttmp[each] === null) {
                                    if (idx === array.length - 1) {
                                        ttmp[each] = " ";
                                    } else {
                                        ttmp[each] = {};
                                    }
                                }
                                ttmp = ttmp[each];
                                //console.log("ttmp risultato: ", ttmp);
                                eacht = eacht + "_" + each;
                            });
                            //tmp.push((ttmp !== null) ? ttmp : "");
                            tmp[eacht] = (ttmp !== null) ? ttmp : " ";
                        } else {
                            //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
                            tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
                        }
                    });
                    tabaledata.push([
                        tmp['_parentelaTipo_descrizione'],
                        tmp.cognome, tmp.nome, tmp.sesso, moment(tmp.dataNascita).format("DD/MM/YYYY"),
                        tmp['_codNazionalitas_descrizione'],
                        tmp['_documentoTipo_descrizione'],
                        tmp.documentoNumero,
                        tmp['_protezioneTipo_descrizione'],
                        tmp['_vulnerabilitas_descrizione'],
                        tmp.note,
                        tmp.noteSanitarie
                    ]);
                });
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    var templater = rend.template.split("|");
                    var enteprint = [];
                    var keepGoing = true;
                    angular.forEach(templater, function (tt) {
                        if (keepGoing) {
                            if (tt !== "nota0" && renderizzato[tt] != null) {
                                enteprint.push({text: '' + renderizzato[tt] + '\n\n', style: 'headerright'});
                            }
                            if (tt === "nota2") {
                                keepGoing = false;
                            }
                        }
                    });
                    var testImageDataUrl = renderizzato["nota0"];
                    var firmaProtocollo = renderizzato["firmaProtocollo"];
                    var docDefinition = {
                        background: function (page) {
                            return [
                                {
                                    image: testImageDataUrl,
                                    width: 520,
                                    absolutePosition: {x: 40, y: 20}
                                }
                            ];
                        },
                        content: [
                            {text: 'LETTERA INSERIMENTO UNIFICATA', style: 'headerrightsmallbold'},
                            {text: 'TIPO: ' + segnalaziones.modellos.descrizione, style: 'headerrightsmall'},
                            {text: 'VER. 2017/03', style: 'headerrightsmall'},
                            {canvas:
                                        [{
                                                type: 'line',
                                                x1: 0, y1: 53,
                                                x2: 520, y2: 53,
                                                lineWidth: 1.5
                                            }]
                            },
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            {text: '\n', style: 'headerright'},
                            enteprint,
                            {text: 'Roma ' + moment(segnalaziones.data).format("DD/MM/YYYY") + '\n', style: 'text'},
                            {text: 'NS.RIF. ' + renderizzato.protocollo + '  del  ' + moment(renderizzato.dataProtocollo).format("DD/MM/YYYY") + ' \n\n', style: 'text'},
                            {text: '' + renderizzato.nota3, style: 'textb'},
                            {text: '\n', style: 'text'},
                            {text: 'Con la presente si dispone l\'inserimento di:\n', style: 'text'},
                            {
                                style: 'demoTable',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                    body: tabaledata
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {text: '\n', style: 'text'},
                            {text: '' + renderizzato.nota4 + '\n\n', style: 'text'},
                            {text: '' + renderizzato.nota5 + '\n\n', style: 'textb'}
                            , {image: firmaProtocollo, width: 85}
                        ],
                        styles: {
                            text: {
                                fontSize: 8,
                                alignment: 'left'
                            },
                            textb: {
                                fontSize: 8,
                                alignment: 'left',
                                bold: true
                            },
                            headerright: {
                                fontSize: 7,
                                alignment: 'right',
                                bold: true
                            },
                            headercenter: {
                                fontSize: 9,
                                alignment: 'center'
                            },
                            headerrightb: {
                                fontSize: 10,
                                alignment: 'right',
                                bold: true,
                            },
                            headerrightsmallbold: {
                                fontSize: 6,
                                bold: true,
                                alignment: 'right'
                            },
                            headersmallboldg: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left',
                                color: 'grey'
                            },
                            headersmallbold: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left'
                            },
                            headerrightsmall: {
                                fontSize: 6,
                                alignment: 'right',
                                color: 'grey'
                            },
                            headerrightsmall2: {
                                fontSize: 8,
                                alignment: 'right'
                            },
                            mittentebold: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 5]
                            },
                            mittenteboldr: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'right',
                                margin: [0, 0, 0, 5]
                            },
                            mittente: {
                                fontSize: 8,
                                alignment: 'left',
                                color: 'grey'
                            },
                            mittenter: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            demoTable: {
                                margin: [0, 6, 0, 6],
                                fontSize: 6,
                                bold: true
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 7,
                                color: 'black',
                                fillColor: '#d8d8d8'
                            }
                        },
                    };
                    //pdfMake.createPdf(docDefinition).download("letteraInserimento_" + letterainserimento + '.pdf');
                    var pdfDocGenerator = pdfMake.createPdf(docDefinition);
                    pdfDocGenerator.getBase64(function (data) {
                        eventi.buffer = data;
                    });
                });
            });
        }

        eventi.letteratrasferimento = letteratrasferimento;
        function letteratrasferimento(event, beneficiario_id) {
            console.log(beneficiario_id);
            var segnalaziones = null;
            api.beneficiarios.beneficiario.get({id: beneficiario_id}, function (d) {
                var seg = d;
                var dataTrasferimento = null;
                angular.forEach(seg.eventos, function (eventoSingolo) {
                    if (eventoSingolo.eventoTipo_id == 1013) {
                        dataTrasferimento = eventoSingolo.dataInizio;
                    }
                })
                var segs = [];
                segs.push(d);
                console.log("SEGS", segs);
                var tabaledata = [];
                tabaledata.push([
                    {text: 'Parentela', style: 'tableHeader'},
                    {text: 'Cognome', style: 'tableHeader'},
                    {text: 'Nome', style: 'tableHeader'},
                    {text: 'Sesso', style: 'tableHeader'},
                    {text: 'Data Nascita', style: 'tableHeader'},
                    {text: 'Nazionalita', style: 'tableHeader'},
                    {text: 'PdS Tipo', style: 'tableHeader'},
                    {text: 'PdS Numero', style: 'tableHeader'},
                    {text: 'Protezione', style: 'tableHeader'},
                    {text: 'Vulnerabilità', style: 'tableHeader'},
                    {text: 'Note', style: 'tableHeader'},
                    {text: 'Note San.', style: 'tableHeader'}
                ]);
                var json = segs;
                var jsonfields = [
                    ['parentelas', 'descrizione'],
                    'cognome', 'nome', 'sesso', 'dataNascita',
                    ['nazionalita', 'descrizione'],
                    ['tipoDocumento', 'descrizione'],
                    'documentoNumero',
                    ['protezioneTipo', 'descrizione'],
                    ['vulnerabilitas', 'descrizione'],
                    'note',
                    'noteSanitarie'
                ];
                angular.forEach(json, function (sjson) {
                    var tmp = [];
                    angular.forEach(jsonfields, function (jsonfield) {
                        var eacht = jsonfield;
                        if (angular.isArray(jsonfield)) {
                            var ttmp = sjson;
                            eacht = '';
                            angular.forEach(jsonfield, function (each, idx, array) {
                                console.log("ttmp", ttmp);
                                console.log("each", each);
                                if (angular.isUndefined(ttmp[each]) || ttmp[each] === null) {
                                    if (idx === array.length - 1) {
                                        ttmp[each] = " ";
                                    } else {
                                        ttmp[each] = {};
                                    }
                                }
                                ttmp = ttmp[each];
                                console.log("ttmp risultato: ", ttmp);
                                eacht = eacht + "_" + each;
                            });
                            //tmp.push((ttmp !== null) ? ttmp : "");
                            tmp[eacht] = (ttmp !== null) ? ttmp : " ";
                        } else {
                            //tmp.push((sjson[jsonfield] != null) ? sjson[jsonfield] : "");
                            tmp[eacht] = (sjson[jsonfield] != null) ? sjson[jsonfield] : " ";
                        }
                    });
                    tabaledata.push([
                        tmp['_parentelas_descrizione'],
                        tmp.cognome, tmp.nome, tmp.sesso, moment(tmp.dataNascita).format("DD/MM/YYYY"),
                        tmp['_nazionalita_descrizione'],
                        tmp['_tipoDocumento_descrizione'],
                        tmp.documentoNumero,
                        tmp['_protezioneTipo_descrizione'],
                        tmp['_vulnerabilitas_descrizione'],
                        tmp.note,
                        tmp.noteSanitarie
                    ]);
                });
                var letterainserimento = segs[0].letteratrasferimento_id;
                api.letterainserimentors.letterainserimentor.get({id: letterainserimento}, function (rend) {
                    var renderizzato = rend;
                    var templater = rend.template.split("|");
                    var enteprint = [];
                    var keepGoing = true;
                    angular.forEach(templater, function (tt) {
                        if (keepGoing) {
                            if (tt !== "nota0" && renderizzato[tt] != null) {
                                enteprint.push({text: '' + renderizzato[tt] + '\n\n', style: 'headerright'});
                            }
                            if (tt === "nota2") {
                                keepGoing = false;
                            }
                        }
                    });
                    var testImageDataUrl = renderizzato["nota0"];
                    var docDefinition = {
                        pageMargins: [30, 230, 30, 30],
                        background: function (currentPage, pageCount) {
                            if (currentPage == 0) {
                                return [
                                    {
                                        image: testImageDataUrl,
                                        width: 520,
                                        absolutePosition: {x: 40, y: 20}
                                    }
                                ];
                            }
                        },
                        header: function (currentPage, pageCount) {
                            if (currentPage > 0) {
                                return [
                                    {image: testImageDataUrl, width: 550, margin: [20, 20, 20, 0]},
                                    {text: '\n', style: 'headerright'},
                                    {text: 'LETTERA TRASFERIMENTO UNIFICATA', style: 'headerrightsmallbold', margin: [0, 0, 30, 0]},
                                    {text: 'TIPO: TRASF/B - VER. 2017/03', style: 'headerrightsmall', margin: [0, 0, 30, 0]},
                                    {text: 'ID: ' + beneficiario_id + '/' + letterainserimento, style: 'headerrightsmall', margin: [0, 0, 30, 0]},
                                    {text: '------------------------------------------------------', style: 'headerrightsmallbold', margin: [0, 0, 30, 0]}
                                ]
                            }


                        },
                        content: [
//                            {text: 'LETTERA TRASFERIMENTO UNIFICATA', style: 'headerrightsmallbold'},
//                            {text: 'TIPO: TRASF/B - VER. 2017/03', style: 'headerrightsmall'},
//                            {text: 'ID: ' + beneficiario_id + '/' + letterainserimento, style: 'headerrightsmall'},
//                            {
//                                image: testImageDataUrl,
//                                width: 530
//                            },
//                            {canvas:
//                                        [{
//                                                type: 'line',
//                                                x1: 0, y1: 53,
//                                                x2: 520, y2: 53,
//                                                lineWidth: 1.5
//                                            }]
//                            },
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
//                            {text: '\n', style: 'headerright'},
                            enteprint,
                            {text: 'Roma ' + moment(dataTrasferimento).format("DD/MM/YYYY") + '\n', style: 'text'},
                            {text: 'Ns.Rif.DDra/n. ' + renderizzato.protocollo + '  del  ' + moment(renderizzato.dataProtocollo).format("DD/MM/YYYY") + ' \n\n', style: 'text'},
                            {text: '' + renderizzato.nota3, style: 'textb'},
                            {text: '\n', style: 'text'},
                            {text: 'Con la presente si dispone il trasferimento di:\n', style: 'text'},
                            {
                                style: 'demoTable',
                                table: {
                                    headerRows: 1,
                                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                                    body: tabaledata
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {text: '\n', style: 'text'},
                            {text: '' + renderizzato.nota4 + '\n\n', style: 'text'},
                            {text: '' + renderizzato.nota5, style: 'textb'}
                        ],
                        styles: {
                            text: {
                                fontSize: 8,
                                alignment: 'left'
                            },
                            textb: {
                                fontSize: 8,
                                alignment: 'left',
                                bold: true
                            },
                            headerright: {
                                fontSize: 7,
                                alignment: 'right',
                                bold: true
                            },
                            headercenter: {
                                fontSize: 9,
                                alignment: 'center'
                            },
                            headerrightb: {
                                fontSize: 10,
                                alignment: 'right',
                                bold: true,
                            },
                            headerrightsmallbold: {
                                fontSize: 6,
                                bold: true,
                                alignment: 'right'
                            },
                            headersmallboldg: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left',
                                color: 'grey'
                            },
                            headersmallbold: {
                                fontSize: 7,
                                bold: true,
                                alignment: 'left'
                            },
                            headerrightsmall: {
                                fontSize: 6,
                                alignment: 'right',
                                color: 'grey'
                            },
                            headerrightsmall2: {
                                fontSize: 8,
                                alignment: 'right'
                            },
                            mittentebold: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 5]
                            },
                            mittenteboldr: {
                                fontSize: 10,
                                bold: true,
                                alignment: 'right',
                                margin: [0, 0, 0, 5]
                            },
                            mittente: {
                                fontSize: 8,
                                alignment: 'left',
                                color: 'grey'
                            },
                            mittenter: {
                                fontSize: 8,
                                alignment: 'right',
                                color: 'grey'
                            },
                            header: {
                                fontSize: 18,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                alignment: 'center'
                            },
                            demoTable: {
                                margin: [0, 6, 0, 6],
                                fontSize: 6,
                                bold: true
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 7,
                                color: 'black',
                                fillColor: '#d8d8d8'
                            }
                        },
                    };
                    //pdfMake.createPdf(docDefinition).download("letteraTrasf_" + beneficiario_id + '.' + letterainserimento + '.pdf');
                    var pdfDocGenerator = pdfMake.createPdf(docDefinition);
                    pdfDocGenerator.getBase64(function (data) {
                        eventi.buffer = data;
                    });
                });
            });
        }

        eventi.deletefiltersearch = deletefiltersearch;
        function deletefiltersearch(key) {
            delete vm.ricerca[key];
            //vm.filtrap(vm.searchForms, key);
            onSearch();
        }

        eventi.valuesearched = valuesearched;
        function valuesearched(key, value) {
            var isNumb = false;
            if (angular.isArray(value) && value.length > 1) {
                return "valori multipli"
            }
            var valore = value;
            if (angular.isArray(value)) {
                valore = value[0];
                if (angular.isNumber(parseInt(valore))) {
                    valore = parseInt(valore);
                    isNumb = true;
                }
            }

            if (angular.isUndefined(vm.searchForms[key].data)) {
                if (angular.isDate(value)) {
                    return moment(value).format('DD/MM/YYYY');
                }
                return value;
            }
            var tempcollection = vm.searchForms[key].data.replace("vm.", "");
            var datas = vm[tempcollection];
//            console.log("key:", key);
//            console.log("value:", value);
//            console.log("datas:", datas);
            var jsonfilters = [];
            var chiave = vm.searchForms[key].chiave;

            var jsonfilter = {};
            var jsonfilterT = JSON.parse('{"' + chiave + '":"' + valore + '"}');
            var jsonfilterN = JSON.parse('{"' + chiave + '":' + valore + '}');
            jsonfilter = jsonfilterT;
            if (isNumb) {
                jsonfilter = jsonfilterN;
            }
//            console.log("jsonfilter:", jsonfilter);
            jsonfilters.push(jsonfilter);
            var results = $filter('filter')(datas, jsonfilter, true);
//            console.log("results", results);

            var valores = vm.searchForms[key].valore.split("|");


            return results[0][valores[0]];
        }


        return eventi;
    }


})();


(function ()
{
    'use strict';

    angular
            .module('fuse')
            .controller('GenericDialogController', GenericDialogController)
            .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        //////////
    }

    function GenericDialogController($state, msUtils, $mdDialog, locals, $mdToast)
    {
        var vm = this;
        vm.errorResponse = []
        if (angular.isDefined(locals.errorResponse)) {
          if (angular.isArray(locals.errorResponse)) { //singolo model con errori
            vm.errorResponse = {errors: locals.errorResponse};
          } else { //model multipli possibilmente con errori
            angular.forEach(locals.errorResponse, function(v, k){
              if (angular.isArray(v) && angular.isDefined(v[0].message)) {
                vm.errorResponse.push(v);
              }
            })
          }
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide)
    {
        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v: '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('it');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('api', apiService)
            .service('authInterceptor', function ($q, $injector, $cookies, $rootScope) {
                var service = this;
                service.responseError = function (response) {
                    if (response.status == 401) {


                        var currentcookies = angular.copy($cookies.getObject('user'));
                        if (angular.isUndefined(currentcookies)) {
                            currentcookies = {};
                        }
                        if (currentcookies.autorizzato === 1) {
                            $cookies.remove('user');
                            currentcookies.autorizzato = 0;
                            $cookies.putObject('user', currentcookies);
                            window.location = "/sprardb/auth/login";
                            console.log($cookies.getObject('user'));
                        }
                        //alert("non autorizzato");
                    }
                    if (!$rootScope.ignoraErrori) {
                        if (response.status == 400) {
                          $rootScope.$broadcast('httpAllowedError', response.data);
                        }
                        if (response.status == 403) {
                            $rootScope.$broadcast('httpAllowedError', response.data);
                        }
                        if (response.status == 422) {
                            $rootScope.$broadcast('httpValidationError', response.data);
                        }
                        if (response.status == 405) {
                            $rootScope.$broadcast('httpAllowedError', response.data);
                        }
                        if (response.status == 500) {
                            $rootScope.$broadcast('httpAllowedError', response.data);
                        }
                    }
                    return $q.reject(response);
                };

//                service.response = function (response) {
//                    //autorizzato
//                    console.log("responseOK", response.data);
//                    if (response.status == 200) {
//
//                        //$cookies.putObject('user', {autorizzato: 1});
//                    }
//                    return response;
//                };
            })
            .config(['$httpProvider', function ($httpProvider) {
                    $httpProvider.interceptors.push('authInterceptor');
                }]);

    /**
     * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma consente di specificare una function
     * reviver (key, value) da applicare ricorsivamente alle proprietà del JSON
     *
     * @param data
     * @param headers
     * @param reviver la funzione da passare a JSON.parse() per convertire i valori
     * @returns {*}
     *
     * @author v.giacomini
     * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
     */
    function genericResponseTransform(data, headers, reviver) {
        var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
        var APPLICATION_JSON = 'application/json';
        var JSON_START = /^\[|^\{(?!\{)/;
        var JSON_ENDS = {
            '[': /]$/,
            '{': /}$/
        };

        function isJsonLike(str) {
            var jsonStart = str.match(JSON_START);
            return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
        }

        if (angular.isString(data)) {
            // Strip json vulnerability protection prefix and trim whitespace
            var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

            if (tempData) {
                var contentType = headers('Content-Type');
                if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
                    data = JSON.parse(tempData, reviver);
                }
            }
        }

        return data;
    }

    /**
     * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma converte le proprietà numeriche
     * nella stringa json di risposta in veri e propri Number
     *
     * @param data
     * @param headers
     * @returns {*}
     *
     * @author v.giacomini
     * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
     */
    function convertNumbersResponseTransform(data, headers) {
        var reviver = function (key, value) {
            if(value === null){
                return value;
            }
            var n = Number(value);
            return isNaN(n) ? value : n;
        };

        return genericResponseTransform(data, headers, reviver);
    }

    /**
     * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma converte le stringhe in integer
     *
     * @param data
     * @param headers
     * @returns {*}
     *
     * @author v.giacomini
     * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
     */
    function convertIntegersResponseTransform(data, headers) {
      var reviver = function (key, value) {
        if(value === null){
          return value;
        }
        var n = parseInt(value);
        return isNaN(n) ? value : n;
      };

      return genericResponseTransform(data, headers, reviver);
    }


  /**
   * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma converte le stringhe in date o integer
   *
   * @param data
   * @param headers
   * @returns {*}
   *
   * @author v.giacomini
   * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
   */
  function convertDateIntegersResponseTransform(data, headers) {
    var reviver = function (key, value) {
      if (/^data([A-Z])?/.test(key)) {
        var m = moment.utc(value);
        if (m.isValid())
          return m.toDate();
      }
      if(value === null){
        return value;
      }
      var n = parseInt(value);
      return isNaN(n) ? value : n;
    };

    return genericResponseTransform(data, headers, reviver);
  }

    /**
     * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma converte le proprietà numeriche e le date
     * nei loro corrispondenti oggetti javascript
     *
     * @param data
     * @param headers
     * @returns {*}
     *
     * @author v.giacomini
     * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
     */
    function convertiDateImportiResponseTransform(data, headers) {
        var reviver = function (key, value) {
            if (/^data([A-Z])?/.test(key)) {
                var m = moment.utc(value);
                if (m.isValid())
                    return m.toDate();
            }
            if (/^importo[A-Z]/.test(key)) {
                var n = Number(value);
                if (!isNaN(n))
                    return n;
            }
            return value;
        };

        return genericResponseTransform(data, headers, reviver);
    }

    /**
     * Questa funzione reimplementa defaultHttpResponseTransform in angular.js ma converte le date in oggetti Date() per
     * md-datepicker
     *
     * @param data
     * @param headers
     * @returns {*}
     *
     * @author v.giacomini
     * @see https://code.angularjs.org/1.5.8/docs/api/ngResource/service/$resource
     */
    function convertiDateResponseTransform(data, headers) {
      var reviver = function (key, value) {
        if (/^data([A-Z])?/.test(key) && !Array.isArray(value)) {
          var m = moment.utc(value);
          if (m.isValid())
            return m.toDate();
        }
        return value;
      };

      return genericResponseTransform(data, headers, reviver);
    }

    /** @ngInject */
    function apiService($resource, $cookieStore, $base64, $http)
    {
        var api = this;

        api.defaultActions = {
          get:    {method:'GET', transformResponse: convertiDateImportiResponseTransform},
          save:   {method:'POST', transformResponse: convertiDateImportiResponseTransform},
          query:  {method:'GET', transformResponse: convertiDateResponseTransform},
          index:  {method:'GET', transformResponse: convertiDateResponseTransform},
          remove: {method:'DELETE'},
          delete: {method:'DELETE'}
        };

        api.dacompletare = 0;
        api.authorizationB = '';

        api.baseUrl = 'app-server/web/';
        api.baseUrl2 = 'limesurvey/index.php/';

        api.ticketUrl = 'support/api/';
        api.xapikey = '004CB4390CC5A5951BFD1EC888B6800F';
//        api.ticketUrl = 'https://assistenza.serviziocentrale.it/helpdesk/api/';
//        api.xapikey = '628CE87F087DDCA0BFB7BCEB80EB703D';

        api.reloadm = function () {

            api.isAccoglienza = false;
            api.isSegreteria = false;
            api.isAdmin = false;
            api.isRendicontazione = false;
            api.isAmministratore = false;
            api.isOperatore = false;
            api.isTutor = false;
            api.isFrontEnd = false;
            api.isEnteGestore = false;
            api.isRendicontatore = false;
            api.isSegnalatore = false;
            api.isVisitatore = false;
            api.isRevisore = false;
            api.isOperatoreG = false;
            api.isAdminG = false;
            api.isReadOnly = false;

            /*
             1	SC-ACCOGLIENZA
             2	SC-SEGRETERIA
             3	SC-ADMIN
             4	SC-RENDICONTAZIONE
             5	PR-AMMINISTRATORE
             6	PR-OPERATORE
             7	SC-TUTOR
             8	SC-FRONTEND
             9	PR-ENTEGESTORE
             10	PR-RENDICONTAZIONE
             11	SEGNALATORE
             */

            api.primapagina = "app.sprardb_autoinserimento";
            api.primapagina_attributi = {};
            api.hasgroup = "";
            api.hasgroup2 = [];

            api.user = api.userlogged = $cookieStore.get('user');

            if (api.user) {
                api.user.can = function(permissionName) {return api.user.permissions.includes(permissionName)}

                api.authorizationB = $base64.encode(api.user.access_token + ':');
                $http.defaults.headers.common['Authorization'] = 'Basic ' + api.authorizationB;

                angular.forEach(api.user.gruppos, function (gruppo) {
                    if (!api.isAdmin) {
                        switch (gruppo.id) {
                            case 1:
                                api.isAccoglienza = true;
                                api.isAdminG = true;
                                api.isOperatoreG = false;
                                break;
                            case 2:
                                api.isSegreteria = true;
                                api.isAdminG = true;
                                api.isOperatoreG = false;
                                api.primapagina_attributi = {eventoTipo_id: 1003};
                                break;
                            case 3:
                                api.isAdmin = true;
                                api.isAdminG = true;
                                api.isOperatoreG = false;
                                break;
                            case 4:
                                api.isRendicontazione = true;
                                api.isAdminG = true;
                                api.isOperatoreG = false;
                                break;
                            case 5:
                                api.isAmministratore = true;
                                api.isAdminG = false;
                                api.isOperatoreG = true;
                                break;
                            case 6:
                                api.isOperatore = true
                                api.isAdminG = false;
                                api.isOperatoreG = true;
                                break;
                            case 7:
                                api.isAdminG = true;
                                api.isReadOnly = true;
                                api.isOperatoreG = false;
                                api.primapagina = "app.sprardb_progetti_progetti";
                                break;
                            case 8:
                                api.isFrontEnd = true;
                                api.isAdminG = true;
                                api.isOperatoreG = false;
                                break;
                            case 9:
                                api.isEnteGestore = true;
                                api.isAdminG = false;
                                api.isOperatoreG = true;
                                break;
                            case 10:
                                api.isRendicontatore = true;
                                api.isAdminG = false;
                                api.isOperatoreG = true;
                                break;
                            case 11:
                                api.isSegnalatore = true;
                                api.primapagina = "app.sprardb_notification";
                                break;
                            case 12:
                                api.isVisitatore = true;
                                api.isReadOnly = true;
                                api.isAdminG = false;
                                api.primapagina = "app.sprardb_progetti_progetti";
                                break;
                            case 13:
                              api.isRevisore = true;
                              api.isReadOnly = true;
                              api.isAdminG = false;
                              api.primapagina = "app.sprardb_rendicontazionimc";
                              break;
                            case 16:
                              api.isTutor = true;
                              api.isAdminG = true;
                              api.isReadOnly = false;
                              api.isOperatoreG = false;
                              api.primapagina = "app.sprardb_progetti_progetti";
                              break;
                            default:
                        }
                    }
                    api.hasgroup2.push(gruppo.gruppo);
                    if (api.hasgroup.length === 0) {
                        api.hasgroup = gruppo.gruppo;
                    } else {
                        api.hasgroup = api.hasgroup + ',' + gruppo.gruppo;
                    }
                });
            }

            api.documentorendicontazione = $resource(api.baseUrl + 'documento-rendicontazione/:id/:action', {id: '@id'}, {
                get: {
                    method: 'GET',
                    transformResponse: convertNumbersResponseTransform
                },
                query: {
                    method: 'GET',
                    params: {expand:'progetto,tipo,stato,modo,periodo,setup'}
                },
                createValidation: {
                    method: 'POST',
                    params: {action: 'create-validation'}
                },
                valida: {
                    method: 'POST',
                    params: {action: 'valida'}
                },
                invia: {
                    method: 'POST',
                    params: {action: 'invia'}
                },
                annullaInvio: {
                    method: 'POST',
                    params: {action: 'annulla-invio'}
                },
                confermaValidazione: {
                  method: 'POST',
                  params: {action: 'conferma-validazione'}
                },
                updateRevisione: {
                  method: 'POST',
                  params: {action: 'update-revisione'}
                },
                riapri: {
                    method: 'POST',
                    params: {action: 'riapri'}
                },
                apriIntegrazione: {
                    method: 'POST',
                    params: {action: 'apri-integrazione'}
                },
                chiudiIntegrazione: {
                    method: 'POST',
                    params: {action: 'chiudi-integrazione'}
                },
                updateVociCosto: {
                    method: 'POST',
                    params: {action: 'update-voci-costo'},
                    transformResponse: convertNumbersResponseTransform
                },
                anni: {
                    method: 'GET',
                    params: {action: 'anni'},
                    isArray: true
                },
                messaggi: {
                    method: 'GET',
                    params: {action: 'messaggi','per-page': 0}
                },
                creaMessaggio: {
                    method: 'POST',
                    params: {action: 'crea-messaggio'}
                },
                checkAccess: {
                    method: 'GET',
                    params: {action: 'check-access'}
                },
                aggiornaDataScadenza: {
                    method: 'POST',
                    params: {action: 'aggiorna-data-scadenza'}
                },
                archiviaAnnoRendicontazione: {
                    method: 'POST',
                    params: {action: 'archivia-anno-rendicontazione'}
                }
            });

            api.vociSpesa = $resource(api.baseUrl + 'documento-rendicontazione/:rendicontazioneId/voci-spesa', {rendicontazioneId:'@id'}, {
                query: {
                    method: 'GET',
                    transformResponse: convertiDateImportiResponseTransform,
                    cancellable: true
                }
            });

            api.periodo = $resource(api.baseUrl + 'periodo/:id', { id: '@id' }, {
                query: {
                  method: 'GET',
                  isArray: false,
                  transformResponse: convertiDateImportiResponseTransform,
                },
                get: {
                  method: 'GET',
                  transformResponse: convertiDateImportiResponseTransform,
                },
                save: {
                  method: 'POST'
                },
              });


            api.allegatorendicontazione = $resource(api.baseUrl + 'allegato-rendicontazione/:id/:action', {id: '@id'}, {
                update: {
                    method: 'PATCH'
                },
                query: {
                    method: 'GET',
                    headers: {'Authorization': 'Basic '+api.authorizationB},
                    transformResponse: convertiDateImportiResponseTransform,
                    cancellable: true
                },
                checkAccess: {
                    method: 'GET',
                    params: {action: 'check-access'}
                }
            })

            api.rendicontazionemc = {
                stati: $resource(api.baseUrl + 'rendicontazionemc-stato/:id', {}, {
                    query: {
                        method: 'GET',
                        headers: {Authorization: 'Basic '+api.authorizationB},
                        isArray: true
                    }
                }),
                tipi: $resource(api.baseUrl + 'rendicontazionemc-tipo/:id'),
                modi: $resource(api.baseUrl + 'rendicontazionemc-modo/:id'),
                codiciSpesa: $resource(api.baseUrl + 'codice-spesa/:id'),
                naturaDocumento: $resource(api.baseUrl + 'natura-documento/:id'),
                tipoPagamento: $resource(api.baseUrl + 'tipo-pagamento/:id'),
                programma: $resource(api.baseUrl + 'programma/:id'),
                voceSpesa: $resource(api.baseUrl + 'voce-spesa/:id')
            }

            api.ticketMetodiGenerali = {
                get: {
                    method: 'GET',
                    headers: {
                        'x-api-key': api.xapikey
                    }
                },
                post: {
                    method: 'POST',
                    headers: {
                        'x-api-key': api.xapikey
                    }
                }
            };
            api.tickets = {
                crea: $resource(api.baseUrl + 'crea-segnalazione', {},
                        api.ticketMetodiGenerali
                        ),
                categorie: $resource(api.ticketUrl + 'topics.json', {},
                        api.ticketMetodiGenerali
                        )
            };

            api.metodigenerali = {
                get: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                save: {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                remove: {
                    method: 'DELETE',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                search: {
                    method: 'GET',
                    params: {
                        id: null,
                        verb: 'search'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB,
                        'progetto_id': $cookieStore.get('progetto_id'),
                        'ente_id': $cookieStore.get('ente_id')
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                cerca: {
                    method: 'GET',
                    params: {
                        id: null,
                        verb: 'search'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB,
                        'progetto_id': $cookieStore.get('progetto_id'),
                        'ente_id': $cookieStore.get('ente_id')
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                like: {
                    method: 'GET',
                    params: {
                        verb: 'like'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB,
                        'progetto_id': $cookieStore.get('progetto_id'),
                        'ente_id': $cookieStore.get('ente_id')
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                aggiorna: {
                    method: 'PUT',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                update: {
                    method: 'PUT',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                distinct: {
                    method: 'GET',
                    params: {
                        verb: 'distinct'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                hasmany: {
                    method: 'POST',
                    params: {
                        verb: 'hasmany'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                cambiapassword: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'cambiapassword'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                ss: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'save'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                omonimia: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'omonimia'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                send: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'send'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                uploadb64: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'uploadb64'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                savebulk: {
                    method: 'POST',
                    params: {
                        verb: 'savebulk'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                rimuovisegnalazione: {
                    method: 'POST',
                    params: {
                        verb: 'rimuovisegnalazione'
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                azione1: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'azione1'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                azione2: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'azione2'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                azione3: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'azione3'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                itemsjsondata: {
                    method: 'POST',
                    params: {
                        id: null,
                        verb: 'itemsjsondata'
                    },
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    interceptor: {
                        response: function (data) {
                            return data.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                }
            };

            api.tipologiaAccoglienza = {
                tipologie: $resource(api.baseUrl + 'tipologia-accoglienza/:id/:verb', {id: '@id'},
                    api.metodigenerali
                )
            }

            api.tipologiaBeneficiario = {
              tipologie: $resource(api.baseUrl + 'tipologia-beneficiario/:id/:verb', {id: '@id'},
                api.metodigenerali
              )
            }

            api.bandi = {
                bando: $resource(api.baseUrl + 'bandos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.bandos = {
                bando: $resource(api.baseUrl + 'bandos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };

            api.bando = $resource(api.baseUrl + 'bando/:id/:verb', {id: '@id'}, api.defaultActions);
            api.corsi = $resource(api.baseUrl + 'corsimc/:id/:verb', {id: '@id'},angular.merge({
                clonaCorsi: {
                    method: 'POST',
                    params: {
                        verb: 'clona-corsi'
                    }
                }
            },api.defaultActions));
            api.servizi = $resource(api.baseUrl + 'servizimc/:id/:verb', {id: '@id'},angular.merge({
                clonaServizi: {
                    method: 'POST',
                    params: {
                        verb: 'clona-servizi'
                    }
                }
            },api.defaultActions));

            api.paeseTerzoProvenienza = $resource(api.baseUrl + 'paese-terzo-provenienza/:id/:verb', {id: '@id'}, api.defaultActions);

            api.postlogin = {
              nucleiFamiliari23: $resource(api.baseUrl + 'postlogin-nuclei-familiari23/:id/:verb', {id: '@id'}, angular.merge({
                uscitaModel: {method:'GET',params:{verb:'uscita-model'}},
                uscita: {method:'POST',params:{verb:'uscita'}},
                confermaPresenza: {method:'POST',params:{verb:'conferma-presenza'}},
                confermaNucleo: {method:'POST',params:{verb:'conferma-nucleo'}},
                report: {method:'POST',params:{verb:'report'}},
                fine: {method:'POST',params:{verb:'fine'}}
              }, api.defaultActions), {cancellable: true}),
              cancellazioneBeneficiari: $resource(api.baseUrl + 'postlogin-cancellazione-beneficiari/:id/:verb', {id: '@id'}, angular.merge({
                cancella: {method:'POST', params:{verb:'cancella'}},
                report: {method:'POST',params:{verb:'report'}},
                conferma: {method: 'POST', params:{verb:'conferma'}},
                annulla: {method: 'POST', params:{verb:'annulla'}},
                fine: {method: 'POST', params:{verb:'fine'}},
                beneficiariDuplicati: {method: 'GET', params:{verb: 'beneficiari-duplicati'}}
              }, api.defaultActions), {cancellable: true})
            };

            api.postlogins = {
                postlogin: $resource(api.baseUrl + 'postlogins/:id/:verb', {id: '@id'},
                    angular.merge(api.metodigenerali, {
                        benpost: {
                            method: 'GET',
                            headers: {
                                'Authorization': 'Basic ' + api.authorizationB
                            },
                            params: {
                                verb: 'benpost'
                            },
                            interceptor: {
                                response: function (response) {
                                    return response.data.data;
                                },
                                responseError: function (data) {
                                    console.log('error in interceptor', data);
                                }
                            }
                        },
                    }),
                    {cancellable: true}
                        ),

            };
            api.beneficiarioattributis = {
                beneficiarioattributi: $resource(api.baseUrl + 'beneficiarioattributis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                beneficiario: $resource(api.baseUrl + 'beneficiarioattributis/:verb', null,
                        {
                            search: {
                                method: 'GET',
                                params: {
                                    verb: 'search'
                                }
                            }
                        }
                )
            };

            api.beneficiariomc = $resource(api.baseUrl + 'beneficiariomc/:id/:verb', {id: '@id'}, angular.merge({}, api.defaultActions, {
              cambiaDataInizio: {
                method: 'POST',
                params: {verb: 'cambio-data-inizio'}
              },
                rimuoveEventoUscita: {
                method: 'POST',
                params: {verb: 'rimuove-evento-uscita'}
              },
              ripetiUscita : {method: 'POST', params: {verb: 'ripeti-uscita'}},
              cancellaBeneficiario : {method: 'POST', params: {verb: 'cancella-beneficiario'}},
              reintegraBeneficiario : {method: 'POST', params: {verb: 'reintegra-beneficiario'}},
              dashboard: {method: 'GET', params: {verb: 'dashboard'}, transformResponse: convertIntegersResponseTransform},
              beneficiariIncompleti: {method: 'GET', params: {verb: 'beneficiari-incompleti'}, transformResponse: convertDateIntegersResponseTransform},
              beneficiariInScadenza: {method: 'GET', params: {verb: 'beneficiari-in-scadenza'}, transformResponse: convertDateIntegersResponseTransform},
              prorogheDaCompletare: {method: 'GET', params: {verb: 'proroghe-da-completare'}, transformResponse: convertDateIntegersResponseTransform},
              prorogheDaLavorare: {method: 'GET', params: {verb: 'proroghe-da-lavorare'}, transformResponse: convertDateIntegersResponseTransform},
              beneficiariScaduti: {method: 'GET', params: {verb: 'beneficiari-scaduti'}, transformResponse: convertDateIntegersResponseTransform},
              struttureProgetto: {method: 'GET', params: {verb: 'strutture-progetto'}, transformResponse: convertDateIntegersResponseTransform},
              countStrutture: {method: 'GET', params: {verb: 'count-strutture'}, transformResponse: convertDateIntegersResponseTransform},
              cambioStruttura: {method:'POST',params:{verb:'cambio-struttura'}}
            }));

            api.beneficiarios = {
                beneficiario: $resource(api.baseUrl + 'beneficiarios/:id/:verb', {id: '@id'},
                    angular.merge(api.metodigenerali, {
                      searchPostlogin: {
                            method: 'GET',
                            headers: {
                                'Authorization': 'Basic ' + api.authorizationB
                            },
                            params: {
                                verb: 'search-postlogin'
                            },
                            interceptor: {
                                response: function (response) {
                                    return response.data;
                                },
                                responseError: function (data) {
                                    console.log('error in interceptor', data);
                                }
                            }
                        },
                      cercaCapifamiglia: {
                          method: 'GET',
                          headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                          },
                          params: {
                            verb: 'cerca-capifamiglia'
                          },
                          interceptor: {
                            response: function (response) {
                              return response.data;
                            },
                            responseError: function (data) {
                              console.log('error in interceptor', data);
                            }
                          }
                        },
                      capofamiglia: {
                          method: 'GET',
                          headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                          },
                          params: {
                            verb: 'capofamiglia'
                          },
                          interceptor: {
                            response: function (response) {
                              return response.data;
                            },
                            responseError: function (data) {
                              console.log('error in interceptor', data);
                            }
                          }
                        },
                      canSetCapofamiglia: {
                        method: 'GET',
                        headers: {
                          'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                          verb: 'can-set-capofamiglia'
                        },
                        interceptor: {
                          response: function (response) {
                            return response.data;
                          },
                          responseError: function (data) {
                            console.log('error in interceptor', data);
                          }
                        }
                      },
                      cambioStruttura: {method:'POST',params:{verb:'cambio-struttura'}},
                      liberaBeneficiario: {method:'POST',params:{verb:'libera-beneficiario'}},
                      accogliInStruttura: {method:'POST',params:{verb:'accogli-in-struttura'}},
                      terminaNelTerritorio: {method:'POST',params:{verb:'termina-nel-territorio'}},

                })),
                extra: $resource(api.baseUrl + 'beneficiarioextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                attributi: $resource(api.baseUrl + 'beneficiarioattributis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                minimal: $resource(api.baseUrl + 'beneficiariominimals/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                m: $resource(api.baseUrl + 'beneficiariom/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                v: $resource(api.baseUrl + 'beneficiariov/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                a: $resource(api.baseUrl + 'accoltiv/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasservizi: $resource(api.baseUrl + 'beneficiariohasservizis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hascorsi: $resource(api.baseUrl + 'beneficiariohascorsis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                tutti: $resource(api.baseUrl + 'tuttis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                storico: $resource(api.baseUrl + 'accoltivtemps/:id/:verb', {id: '@progressivo'},
                        api.metodigenerali
                        )

            };
            api.cs = {
                corso: $resource(api.baseUrl + 'corsis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                servizio: $resource(api.baseUrl + 'servizis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.counties = {
                country: $resource(api.baseUrl + 'counties'),
                search: $resource(api.baseUrl + 'counties/like')
            };
            api.documentos = {
                documento: $resource(api.baseUrl + 'documentos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                tipo: $resource(api.baseUrl + 'documentotipos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                remove: $resource(api.baseUrl + 'documentos/removeupload', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.documentotipos = {
                documentotipo: $resource(api.baseUrl + 'documentotipos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.emails = {
                send: $resource(api.baseUrl + 'emails/:verb', null, {
                    send: {
                        method: 'POST',
                        params: {
                            verb: 'send'
                        },
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        interceptor: {
                            response: function (data) {
                                return data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    }
                }),
                send2: $resource(api.baseUrl + 'email2/:verb', null, {
                    send: {
                        method: 'POST',
                        params: {
                            verb: 'send'
                        },
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        interceptor: {
                            response: function (data) {
                                return data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    }
                })
            };
            api.entes = {
                ente: $resource(api.baseUrl + 'entes/:id/:verb', {id: '@id'}, //api.metodigenerali
                    angular.merge(api.metodigenerali, {
                        searchReport: {
                            method: 'GET',
                            headers: {
                                'Authorization': 'Basic ' + api.authorizationB
                            },
                            params: {
                                verb: 'search-report'
                            },
                            interceptor: {
                                response: function (response) {
                                    return response.data;
                                },
                                responseError: function (data) {
                                    console.log('error in interceptor', data);
                                }
                            }
                        },
                    })
                ),
                extra: $resource(api.baseUrl + 'enteextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.entesafes = {
                ente: $resource(api.baseUrl + 'entesicuros/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.entetipos = {
                entetipo: $resource(api.baseUrl + 'entetipos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                entetipov: $resource(api.baseUrl + 'entetipov/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.enteruolos = {
                enteruolo: $resource(api.baseUrl + 'enteruolos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.eventos = {
                evento: $resource(api.baseUrl + 'eventos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'eventoextrass/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                tipo: $resource(api.baseUrl + 'eventotipos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                stato: $resource(api.baseUrl + 'eventostatos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.evento2 = $resource(api.baseUrl + 'evento2/:id/:verb', {id: '@id'}, angular.merge({}, api.defaultActions, {
                completaTrasferimento: {method: 'POST', params: {verb: 'completa-trasferimento'}},
              }));
            api.gruppos = {
                gruppi: $resource(api.baseUrl + 'groups/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.hasdocumento = {
                progetto: $resource(api.baseUrl + 'progettohasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                struttura: $resource(api.baseUrl + 'strutturahasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                beneficiario: $resource(api.baseUrl + 'beneficiariohasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                ente: $resource(api.baseUrl + 'entehasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                persona: $resource(api.baseUrl + 'personahasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                segnalato: $resource(api.baseUrl + 'segnalatohasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                segnalazione: $resource(api.baseUrl + 'segnalazionehasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                rendicontazione: $resource(api.baseUrl + 'progettorendicontazionehasdocumento/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                rendicontaziones: $resource(api.baseUrl + 'progettorendicontazionehasdocumentos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.istats = {
                istat: $resource(api.baseUrl + 'istats/:id/:verb', null, {
                    cerca: {
                        method: 'GET',
                        params: {
                            id: null,
                            verb: 'search'
                        }
                    },
                    like: {
                        method: 'GET',
                        params: {
                            verb: 'like'
                        }
                    },
                    search: {
                        method: 'GET',
                        params: {
                            verb: 'search'
                        }
                    },
                    aggiorna: {
                        method: 'PUT',
                    },
                    distinct: {
                        method: 'GET',
                        params: {
                            verb: 'distinct'
                        }
                    }
                }),
                regioni: $resource(api.baseUrl + 'regiones'),
                province: $resource(api.baseUrl + 'provincias/search')
            };
            api.letterainserimentos = {
                letterainserimento: $resource(api.baseUrl + 'letterainserimentos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.letterainserimentors = {
                letterainserimentor: $resource(api.baseUrl + 'letterainserimentors/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.letterainserimentots = {
                letterainserimentot: $resource(api.baseUrl + 'letterainserimentots/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.listedistribuzione = {
                lista: $resource(api.baseUrl + 'listadistribuziones/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.limesurvey = {
                login: $resource(api.baseUrl2 + 'admin/remotecontrol', {},
                        {
                            do: {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            }
                        }
                ),
                pdf: $resource(api.baseUrl2 + 'admin/remotecontrol', {},
                        {
                            all: {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            }
                        }
                )
            };
            api.progetti = {
                progetto: $resource(api.baseUrl + 'progettos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'progettoextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                progettoParametriRendicontazione: $resource(api.baseUrl + 'progettoparametrirendicontaziones/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.progettos = {
                progetto: $resource(api.baseUrl + 'progettos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'progettoextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasservizi: $resource(api.baseUrl + 'progettohasservizis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hascorsi: $resource(api.baseUrl + 'progettohascorsis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasente: $resource(api.baseUrl + 'progettohasentes/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };

            api.ticketmc = $resource(api.baseUrl + "ticket/:verb",{},{
                crea:{
                    method: 'POST',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'crea-ticket',
                    },
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
            });

            api.progettomc = $resource(api.baseUrl + 'progettomc/:id/:verb', {id: '@id'}, //api.metodigenerali
                angular.merge({}, api.metodigenerali, {
                    get: {method:'GET', transformResponse: convertiDateResponseTransform},
                    strutture: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                            verb: 'strutture'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },
                    corsi: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                            verb: 'corsi'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },
                    servizi: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                            verb: 'servizi'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },
                    persone: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        transformResponse: convertiDateResponseTransform,
                        params: {
                            verb: 'persone'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },
                    revisori: {
                      method: 'GET',
                      headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                      },
                      params: {
                        verb: 'revisori'
                      },
                      interceptor: {
                        response: function (response) {
                          return response.data.data;
                        },
                        responseError: function (data) {
                          console.log('error in interceptor', data);
                        }
                      }
                    },
                    beneficiariProgetto: {
                        method: 'GET',
                        headers: {
                          'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                          verb: 'beneficiari-progetto'
                        },
                      },
                    revisoriNonAssociati: {
                      method: 'GET',
                      headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                      },
                      params: {
                        verb: 'revisori-non-associati'
                      },
                      interceptor: {
                        response: function (response) {
                          return response.data.data;
                        },
                        responseError: function (data) {
                          console.log('error in interceptor', data);
                        }
                      }
                    },
                    anniRendicontazioni: {
                      method: 'GET',
                      isArray: true,
                      headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                      },
                      params: {
                        verb: 'anni-rendicontazioni'
                      },
                    },
                    associaServizi: {
                        method: 'POST',
                        headers: {
                          'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                          verb: 'associa-servizi'
                        },
                      },
                    associaCorsi: {
                        method: 'POST',
                        headers: {
                          'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                          verb: 'associa-corsi'
                        },
                      },
                    associaRevisore: {
                      method: 'POST',
                      headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                      },
                      params: {
                        verb: 'associa-revisore'
                      },
                      interceptor: {
                        response: function (response) {
                          return response.data.data;
                        },
                        responseError: function (data) {
                          console.log('error in interceptor', data);
                        }
                      }
                    },
                    dissociaRevisore: {
                      method: 'POST',
                      headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                      },
                      params: {
                        verb: 'dissocia-revisore'
                      },
                      interceptor: {
                        response: function (response) {
                          return response.data.data;
                        },
                        responseError: function (data) {
                          console.log('error in interceptor', data);
                        }
                      }
                    },
                    eventi: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                            verb: 'eventi'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },

                    serviziMonitoraggio: {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        },
                        params: {
                            verb: 'servizi-monitoraggio'
                        },
                        interceptor: {
                            response: function (response) {
                                return response.data.data;
                            },
                            responseError: function (data) {
                                console.log('error in interceptor', data);
                            }
                        }
                    },
                    accessPermission: {
                      method: 'POST',
                      params: {verb: 'access-permission', id: '@progetto_id'}
                    }
                }),
                {cancellable: true}
            );

            api.progettomc.hascorsi = $resource(api.baseUrl + 'progettohascorsimc/:id/:verb', {id: '@id'}, api.defaultActions)
            api.progettomc.hasservizi = $resource(api.baseUrl + 'progettohasservizimc/:id/:verb', {id: '@id'}, api.defaultActions)

            api.monitoraggio = $resource(api.baseUrl + 'monitoraggio/:id/:verb', {id: '@id'}, angular.merge({}, api.defaultActions, {
              new: {method: 'GET', params: {verb: 'new'}, transformResponse: convertiDateImportiResponseTransform},
              index: {method: 'GET'},
              dashboard: {method: 'GET', params: {verb: 'dashboard'}, transformResponse: convertIntegersResponseTransform},
              sal: {method: 'GET', params: {verb: 'sal'}, transformResponse: convertDateIntegersResponseTransform},
              anniMonitoraggio: {method: 'GET', params: {verb: 'anni-monitoraggio'}, transformResponse: convertDateIntegersResponseTransform},
              enti: {method: 'GET', isArray: true, params: {verb: 'enti'}},
              inviaReport: {method: 'POST', params: {verb: 'invia-report'}, transformResponse: convertiDateImportiResponseTransform},
              annullaInvioReport: {method: 'POST', params: {verb: 'annulla-invio-report'}, transformResponse: convertiDateImportiResponseTransform},
              assegnaEsito: {method: 'POST', params: {verb: 'assegna-esito'}, transformResponse: convertiDateImportiResponseTransform},
              segnalaMinint: {method: 'POST', params: {verb: 'segnala-minint'}, transformResponse: convertiDateImportiResponseTransform},
              aggiungiEnte: {method: 'POST', params: {verb: 'aggiungi-ente', id: '@visitaMonitoraggioId'}},
              rimuoviEnte: {method: 'POST', params: {verb: 'rimuovi-ente', id: '@visitaMonitoraggioId'}}
            }));
            api.monitoraggio.dettaglio = $resource(api.baseUrl + 'dettaglio-monitoraggio/:id/:verb', {id: '@id'},  angular.merge({}, api.defaultActions, {
              invia: {method: 'POST', params: {verb: 'invia'}},
              valida: {method: 'POST', params: {verb: 'valida'}},
              rifiuta: {method: 'POST', params: {verb: 'rifiuta'}},
              duplica: {method: 'POST', params: {verb: 'duplica'}},
              invalida: {method: 'POST', params: {verb: 'invalida'}},
            }));
            api.monitoraggio.stato = $resource(api.baseUrl + 'stato-monitoraggio');
            api.monitoraggio.tipAccoglienza = $resource(api.baseUrl + 'tip-accoglienza', {}, {query: {method: 'GET', isArray: true}});
            api.monitoraggio.tutor = $resource(api.baseUrl + 'tutor-monitoraggio/:id/:verb', {id: '@id'}, angular.merge({}, api.defaultActions, {
              tutorAmministrativi: {method: 'GET', isArray: true, params: {verb: 'tutor-amministrativi'}},
              tutorQualitativi: {method: 'GET', isArray: true, params: {verb: 'tutor-qualitativi'}},
              cerca: {method: 'GET', isArray: true, params: {verb: 'cerca'}}
            }));

            api.progettoentemc = $resource(api.baseUrl + 'progettohasentemc/:id', {id: '@id'}, api.defaultActions);
            api.personaentemc = $resource(api.baseUrl + 'personahasentemc/:id', {id: '@id'});

            api.proroga = $resource(api.baseUrl+'proroga/:id/:verb', {id: '@id'}, {
              save: {method: 'POST'},
              conferma: {method: 'POST', params: {verb: 'conferma'}},
              approva: {method: 'POST', params: {verb: 'approva'}},
              rifiuta: {method: 'POST', params: {verb: 'rifiuta'}}
            })

            api.reportmc = $resource(api.baseUrl+'report/:verb',{},{
                beneficiariPerGenere: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-per-genere'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariPerNazione: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-per-nazione'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariPerProgetto: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-per-progetto'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariCorsiServizi: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-corsi-servizi'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariTipologiaSoggiorno: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-tipologia-soggiorno'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariNucleiFamiliari: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-nuclei-familiari'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariMotiviUscita: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-motivi-uscita'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariFasceEta: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-fasce-eta'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariModalitaIngresso: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-modalita-ingresso'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariComuniStruttura: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-comuni-struttura'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariNumerico: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-numerico'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                struttureTipologia: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'strutture-tipologia'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                postiDisponibili: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'posti-disponibili'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariDettagli: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-dettagli'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                beneficiariCovid: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'beneficiari-covid'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                reportMinistero: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'report-ministero'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                prorogheBeneficiari: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'proroghe-beneficiari'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                prorogheLavorate: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'proroghe-lavorate'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                tipoSoggiornoMonitoraggio: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'tipo-soggiorno-monitoraggio'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                postiProgettoMonitoraggio: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'posti-progetto-monitoraggio'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                reportChecklistMonitoraggio: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'checklist-monitoraggio'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                reportNuovaMonitoraggio: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'nuova-monitoraggio'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                reportSalNuovo: {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + api.authorizationB
                    },
                    params: {
                        verb: 'sal-nuovo'
                    },
                    transformResponse: convertNumbersResponseTransform,
                    interceptor: {
                        response: function (response) {
                            return response.data;
                        },
                        responseError: function (data) {
                            console.log('error in interceptor', data);
                        }
                    }
                },
                reportMinisteroLavoro: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'report-ministero-lavoro'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                progettiMinori: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'progetti-minori'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                struttureMinori: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'strutture-minori'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                },
                dateReportMinistero: {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Basic ' + api.authorizationB
                  },
                  params: {
                    verb: 'date-report-ministero'
                  },
                  transformResponse: convertNumbersResponseTransform,
                  interceptor: {
                    response: function (response) {
                      return response.data;
                    },
                    responseError: function (data) {
                      console.log('error in interceptor', data);
                    }
                  }
                }
            });
            api.persone = {
                persona: $resource(api.baseUrl + 'personas/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'personaextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.personas = {
                persona: $resource(api.baseUrl + 'personas/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                persona2: $resource(api.baseUrl + 'persona2s/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                persona3: $resource(api.baseUrl + 'persona3s/:id/:verb', {id: '@id'},
                    angular.merge( api.metodigenerali, {
                            associa:{
                                method: 'POST',
                                params: {
                                    verb: 'associa'
                                },
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                },
                                interceptor: {
                                    response: function (data) {
                                        return data.data;
                                    },
                                    responseError: function (data) {
                                        console.log('error in interceptor', data);
                                    }
                                }
                            }
                    })
                        ),
                extra: $resource(api.baseUrl + 'personaextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasente: $resource(api.baseUrl + 'personahasentes/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasprogetto: $resource(api.baseUrl + 'personahasprogetto/:id/:verb', {id: '@id'},
                        angular.merge (api.defaultActions, {
                          aggiorna: {
                            method: 'PUT',
                            headers: {
                              'Authorization': 'Basic ' + api.authorizationB
                            },
                            interceptor: {
                              response: function (data) {
                                return data.data;
                              },
                              responseError: function (data) {
                                console.log('error in interceptor', data);
                              }
                            }
                          }
                        },
                        {
                          progettiPersona: {method: 'GET', isArray: true, params: {verb: 'progetti-persona'}}
                        }
                        )
                      ),

            };
            api.entemc = $resource(api.baseUrl + 'entemc/:id/:verb', {id: '@id'}, angular.merge({}, api.defaultActions, {
              list: {method:'GET', isArray: true, params: {verb: 'list'}, cancellable: true},
            }));

          api.personaruolos = {
                personaruolo: $resource(api.baseUrl + 'personaruolos/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.personastudis = {
                personastudi: $resource(api.baseUrl + 'personastudis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.processi = {
                processo: $resource(api.baseUrl + 'processo/:id/:verb', {id: '@id'},
                        {
                            lavora: {
                                method: 'POST',
                                params: {
                                    id: null,
                                    verb: 'lavora'
                                },
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                },
                                interceptor: {
                                    response: function (data) {
                                        return data.data;
                                    },
                                    responseError: function (data) {
                                        console.log('error in interceptor', data);
                                    }
                                }
                            },
                            update: {
                                method: 'PUT',
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                },
                                interceptor: {
                                    response: function (data) {
                                        return data.data;
                                    },
                                    responseError: function (data) {
                                        console.log('error in interceptor', data);
                                    }
                                }
                            },
                            elimina: {
                                method: 'POST',
                                params: {
                                    id: null,
                                    verb: 'elimina'
                                },
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                },
                                interceptor: {
                                    response: function (data) {
                                        return data.data;
                                    },
                                    responseError: function (data) {
                                        console.log('error in interceptor', data);
                                    }
                                }
                            }
                        }
                )
            };
            api.rendicontaziones = {
                rendicontazione: $resource(api.baseUrl + 'progettorendicontaziones/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                rendicontazionem: $resource(api.baseUrl + 'progettorendicontazionems/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                stati: $resource(api.baseUrl + 'progettorendicontazionestato/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                tipi: $resource(api.baseUrl + 'progettorendicontazionetipo/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                jsonInput: $resource(api.baseUrl + 'progettorendicontazionejsoninputs/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                progettoParametriRendicontazione: $resource(api.baseUrl + 'progettoparametrirendicontaziones/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.strutture = {
                struttura: $resource(api.baseUrl + 'strutturas/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                struttura2: $resource(api.baseUrl + 'strutturas/:verb', null,
                        api.metodigenerali
                        ),
                alloggio: $resource(api.baseUrl + 'strutturaalloggios/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                accoglienza: $resource(api.baseUrl + 'strutturaaccoglienzas/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'strutturaextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.strutturas = {
                struttura: $resource(api.baseUrl + 'strutturas/:id/:verb', {id: '@id'},
                          api.metodigenerali
                        ),
                struttura2: $resource(api.baseUrl + 'strutturas/:verb', null,
                        api.metodigenerali
                        ),
                alloggio: $resource(api.baseUrl + 'strutturaalloggios/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                accoglienza: $resource(api.baseUrl + 'strutturaaccoglienzas/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                extra: $resource(api.baseUrl + 'strutturaextras/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hasbeneficiario: $resource(api.baseUrl + 'strutturahasbeneficiarios/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                strutturamin: $resource(api.baseUrl + 'strutturamins/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                presenti: $resource(api.baseUrl + 'presentistruttures/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.strutturaMc = $resource(api.baseUrl + 'strutturamc/:id/:verb', {id: '@id'},
              {
                saveEsterna: {
                  method:'POST',
                  params:{
                    verb:'save-esterna'
                  }
                }
              });
            api.tipoModelloStruttura = $resource(api.baseUrl + 'tipo-modello-struttura/:id', {id: '@id'});
            api.destinazione = $resource(api.baseUrl + 'destinazione/');
            api.stagingarea = {
                register: $resource(api.baseUrl + 'stagingarea/:verb', null, {
                    save: {
                        method: 'POST',
                        params: {
                            verb: 'save'
                        }
                    },
                    savees: {
                        method: 'POST',
                        params: {
                            verb: 'savees'
                        }
                    }
                })
            };
            api.segnalaziones = {
                segnalazione: $resource(api.baseUrl + 'segnalaziones/:id/:verb', {id: '@id'},
                  angular.merge(api.metodigenerali, {
                    tipologieSegnalazione: {method: 'GET', params: {verb: 'tipologie-segnalazione'}},
                    create: {method: 'POST', params: {verb: 'save',progetto_id:'@progetto_id'}},
                    selectSegnalazione: {method: 'GET', params: {verb: 'select-segnalazione'}},
                  })
                )
            };
            api.segs = {
                save: $resource(api.baseUrl + 'segnalazione/save/:id/:verb', {id: '@id'},
                        {
                            do: {
                                method: 'POST',
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                }
                            }
                        }
                ),
                lettera: $resource(api.baseUrl + 'segnalazione/letterainserimento/:id/:verb', {id: '@id'},
                        {
                            do: {
                                method: 'POST',
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                }
                            }
                        }
                ),
                accetta: $resource(api.baseUrl + 'segnalazione/accetta/:id/:verb', {id: '@id'},
                        {
                            do: {
                                method: 'POST',
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                }
                            }
                        }
                ),
                rifiuta: $resource(api.baseUrl + 'segnalazione/rifiuta/:id/:verb', {id: '@id'},
                        {
                            do: {
                                method: 'POST',
                                headers: {
                                    'Authorization': 'Basic ' + api.authorizationB
                                }
                            }
                        }
                ),
            };
            api.segnalatos = {
                segnalato: $resource(api.baseUrl + 'segnalatos/:id/:verb', {id: '@id'},
                    angular.merge(api.metodigenerali, {
                      updateSegnalato: {
                        method: 'POST',
                        params: {
                          verb: 'update-segnalato'
                        },
                      },
                      inserisciBeneficiario: {
                        method: 'POST',
                        params: {
                          verb: 'inserisci-beneficiario'
                        },
                      },
                      rifiutaSegnalato: {
                        method: 'POST',
                        params: {
                          verb: 'rifiuta-segnalato'
                        },
                      },
                      reinserimento: {
                        method: 'POST',
                        params: {
                          verb: 'reinserimento'
                        },
                      },
                      elimina: {
                        method: 'POST',
                        params: {
                          verb: 'elimina'
                        },
                      },
                      rifiutaMultipli:{
                        method:'POST',
                        params : {
                          verb:'rifiuta-multipli'
                        }
                      },
                      accettaMultipli:{
                        method:'POST',
                        params : {
                          verb:'accetta-multipli'
                        }
                      }
                    })
                ),
                segnalato2: $resource(api.baseUrl + 'segnalato/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                hassegnalazione: $resource(api.baseUrl + 'segnalatohassegnalaziones/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                segnalatomag: $resource(api.baseUrl + 'segnalatomags/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.tags = {
                tag: $resource(api.baseUrl + 'tags/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                liste: $resource(api.baseUrl + 'tagls/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.tokens = {
                token: $resource(api.baseUrl + 'tokens/:verb', null, {
                    sendcode: {
                        method: 'POST',
                        params: {
                            verb: 'sendcode'
                        }
                    },
                    validatecode: {
                        method: 'POST',
                        params: {
                            verb: 'validatecode'
                        }
                    }
                })
            };
            api.users = {
                role: $resource(api.baseUrl + 'user/:action', null, {
                  assegnaRuoli: {
                    method: 'POST',
                    params: {
                      action: 'assegna-ruoli'
                    }
                  },
                  roleNames: {
                    method: 'GET',
                    params: {
                      action: 'role-names'
                    },
                    isArray: true
                  }
                }),
                login: $resource(api.baseUrl + 'user/login'),
                register: $resource(api.baseUrl + 'user/register'),
                log: $resource(api.baseUrl + 'user/:verb', null, {
                    in: {
                        method: 'POST',
                        params: {
                            verb: 'login'
                        }
                    },
                    out: {
                        method: 'POST',
                        params: {
                            verb: 'logout'
                        },
                        headers: {
                            'Authorization': 'Basic ' + api.authorizationB
                        }
                    },
                    preregister: {
                        method: 'POST',
                        params: {
                            verb: 'preregister'
                        }
                    },
                    register: {
                        method: 'POST',
                        params: {
                            verb: 'register'
                        }
                    },
                    createuser: {
                        method: 'POST',
                        params: {
                            verb: 'createuser'
                        }
                    },
                    toggleuser: {
                        method: 'POST',
                        params: {
                            verb: 'toggleuser'
                        }
                    },
                    startreset: {
                        method: 'POST',
                        params: {
                            verb: 'startreset'
                        }
                    },
                    openreset: {
                        method: 'GET',
                        params: {
                            verb: 'openreset'
                        }
                    },
                    passwordreset: {
                        method: 'POST',
                        params: {
                            verb: 'passwordreset'
                        }
                    },
                    checkcodice: {
                        method: 'POST',
                        params: {
                            verb: 'checkcodice'
                        }
                    },
                    checkcf: {
                        method: 'POST',
                        params: {
                            verb: 'checkcf'
                        }
                    },
                    checktelefono: {
                        method: 'POST',
                        params: {
                            verb: 'checktelefono'
                        }
                    },
                    checkemail: {
                        method: 'POST',
                        params: {
                            verb: 'checkemail'
                        }
                    },
                    validatepassword: {
                        method: 'POST',
                        params: {
                            verb: 'validatepassword'
                        }
                    },
                    checkemail2: {
                        method: 'POST',
                        params: {
                            verb: 'checkemail2'
                        }
                    },
                    userupdate: {
                        method: 'POST',
                        params: {
                            verb: 'userupdate'
                        }
                    },
                    changegroup: {
                        method: 'POST',
                        params: {
                            verb: 'changegroup'
                        }
                    }

                }),
                user2: $resource(api.baseUrl + 'user2s/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.utilitas = {
                statusod: $resource(api.baseUrl + 'statusods/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        )
            };
            api.report = {
                beneficiario: $resource(api.baseUrl + 'beneficiariostarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                beneficiariot: $resource(api.baseUrl + 'beneficiariotrasferimentistarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                progetto: $resource(api.baseUrl + 'progettostarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                progetto2: $resource(api.baseUrl + 'progettostart2/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                corsiusufruiti: $resource(api.baseUrl + 'corsiusufruitistarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                serviziusufruiti: $resource(api.baseUrl + 'serviziusufruitistarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                corsierogati: $resource(api.baseUrl + 'corsierogatistarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                servizierogati: $resource(api.baseUrl + 'servizierogatistarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                evento2000: $resource(api.baseUrl + 'evento2000starts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                struttura: $resource(api.baseUrl + 'strutturastarts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                easo1: $resource(api.baseUrl + 'easo1starts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                easo2: $resource(api.baseUrl + 'easo2starts/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                postidisponibili: $resource(api.baseUrl + 'postidisponibilivs/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                schedamonitoraggio: $resource(api.baseUrl + 'schedamonitoraggios/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
                postidisponibilieattivi: $resource(api.baseUrl + 'postidisponibilieattivis/:id/:verb', {id: '@id'},
                        api.metodigenerali
                        ),
            };

        }

        api.makeid = function (lunghezza) {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < lunghezza; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

        api.aggiornadacompletare = function (valore) {
            api.dacompletare = valore;
        }

        api.selezionaProfilo = function () {
            api.progetto_id = $cookieStore.get('progetto_id');
            api.ente_id = $cookieStore.get('ente_id');
            api.reloadm();
            console.log("API ADESSO:", api);
        }
        api.loginPersonas = [];
        api.immagazzinaPersone = function (obj) {
            api.loginPersonas = obj;
        }

        api.fields = function(resource, fields) {
          return fields.reduce(function(result, f) {return (result ? result+',':'') + resource +'.'+ f }, '');
        }

        api.reloadm();
        return api;
    }


})();


//(function ()
//{
//    'use strict';
//    angular
//            .module('app-core')
//            .provider('acl', aclProvider);
//
//    function aclProvider() {
//
//        this.name = 'Default';
//
//        this.$get = function (acl) {
//            var name = this.name;
//            return {
//                sayHello: function () {
//                    return "Hello, " + name + "!"
//                }
//            }
//        };
//
//        this.setName = function (name) {
//            this.name = name;
//        };
//    }
//})();



//            .service('acl', aclService);
//    /** @ngInject */
//
//    function aclService($cookieStore, $base64, $mdDialog, $mdToast, api, $document)
//    {
//        var acl = this;
//        acl.currentgruppos = api.userlogged.gruppos;
//        acl.gruppi = [
//            {guid: "26df70705a3111e6b790b8ca3ab72b30", id: "1", gruppo: "SC-ACCOGLIENZA"},
//            {guid: "26df76715a3111e6b790b8ca3ab72b30", id: "2", gruppo: "SC-SEGRETERIA"},
//            {guid: "57c186545a3111e6b790b8ca3ab72b30", id: "3", gruppo: "SC-ADMIN"},
//            {guid: "57c18d255a3111e6b790b8ca3ab72b30", id: "4", gruppo: "SC-RENDICONTAZIONE"},
//            {guid: "609d2d2b5a3111e6b790b8ca3ab72b30", id: "5", gruppo: "PR-AMMINISTRATORE"},
//            {guid: "609d332e5a3111e6b790b8ca3ab72b30", id: "6", gruppo: "PR-OPERATORE"},
//            {guid: "69a161b85a3111e6b790b8ca3ab72b30", id: "7", gruppo: "SC-TUTOR"},
//            {guid: "69a167c75a3111e6b790b8ca3ab72b30", id: "8", gruppo: "SC-FRONTEND"},
//            {guid: "9ece399b5a3111e6b790b8ca3ab72b30", id: "9", gruppo: "PR-ENTEGESTORE"},
//            {guid: "9ece3f965a3111e6b790b8ca3ab72b30", id: "10", gruppo: "PR-RENDICONTAZIONE"},
//            {guid: "ed721ee15a3011e6b790b8ca3ab72b30", id: "11", gruppo: "SEGNALATORE"}
//        ];
//
//        acl.rules = rules;
//        function rules(array) {
//            angular.forEach(array, function (g) {});
//            return true;
//        }
//
//
//        return acl;
//    }
//
//
//})();

(function ()
{
    'use strict';
    angular
            .module('fuse')
            .service('acl', aclService);
    /** @ngInject */
    function aclService($cookieStore, $base64, $mdDialog, $mdToast, api, $document)
    {
        var acl = this;
        acl.currentgruppos = api.userlogged.gruppos;
        acl.isallowed = isallowed;
        function isallowed(allowedgroup) {
            //console.log(allowedgroup);
            var trovato = false;
            if (angular.isUndefined(allowedgroup)) {
                allowedgroup = [];
                trovato = true;
            }

            //allowedgroup = array esempio [1,11,3]
            angular.forEach(acl.currentgruppos, function (cg) {
                //console.log(cg);
                if (allowedgroup.indexOf(cg.id) !== -1 && !trovato) {
                    trovato = true;
                }
            });
            return trovato;
        }
        acl.isallowed2 = isallowed2;
        function isallowed2(allowedgroup) {
            var trovato = false;
            if (angular.isUndefined(allowedgroup)) {
                allowedgroup = [];
                trovato = true;
            } else {
                var allowedgrouptemp = null;
                allowedgrouptemp = allowedgroup.replace('(', '').replace(')', '').split(',');

                allowedgroup = [];
                if (allowedgrouptemp.length > 4) {
                    trovato = false;
                    allowedgroup = allowedgrouptemp[4].split(";").map(Number);
                } else {
                    allowedgroup = [];
                    trovato = true;
                }
            }
            //allowedgroup = array esempio [1,11,3]
            angular.forEach(acl.currentgruppos, function (cg) {
                if (allowedgroup.indexOf(cg.id) !== -1 && !trovato) {
                    trovato = true;
                }
            });
            return trovato;
        }


        acl.reload = aclreload;
        function aclreload() {
            acl.currentgruppos = api.userlogged.gruppos;
        }

        return acl;
    }


})();

angular.module("app.config", [])
.constant("ENV", "prod")
.constant("ENV_DEV", false);

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/register-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content ui-view=\"content\" flex>\n</md-content></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Cerca\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">\nNessun risultato!</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" \nng-click=\"MsSearchBar.handleResultClick(result)\" ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" \nng-mousedown=\"MsSearchBar.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" \nlayout-align=\"center center\"><i ng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" \nclass=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div><div class=\"description\" \nng-if=\"result.description\">{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick per aggiungere o rimuovere scorciatoie</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\">\n<div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Cerca\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/sprardb-newprocess/sprardb-newprocess.html","<div layout=\"row\" flex ng-if=\"(vmd.eventoTipos.length > 1)\"><md-input-container flex><md-select-label>\n{{vmd.items.titolo}}</md-select-label><md-select name=\"eventoTipo_id\" ng-model=\"vmd.eventoTipo\" flex \nplaceholder=\"{{vmd.items.titolo}}\" ng-click=\"vmd.updates()\"><md-option ng-repeat=\"item in vmd.eventoTipos\" \nng-value=\"item\"><strong><small>{{item.nome}}</small></strong></md-option></md-select></md-input-container><md-button \nng-click=\"vmd.newwork()\" ng-disabled=\"!vmd.eventoTipo\" class=\"md-button md-button-small-n md-accent-bg\"><b><small>OK\n</small></b></md-button></div><div layout=\"row\" flex ng-if=\"(vmd.eventoTipos.length === 1)\"><md-button \nng-click=\"vmd.newwork(vmd.eventoTipos[0])\" class=\"md-button md-accent-bg\" flex ng-disabled=\"vmd.disabled\"><b><i \nclass=\"icon-play s16\"></i>&nbsp;{{vmd.eventoTipos[0].nome}}</b></md-button></div>");
$templateCache.put("app/core/directives/sprardb-newprocess2/sprardb-newprocess2.html","<div layout=\"row\" flex ng-if=\"(vmd.eventoTipos.length > 1)\"><md-input-container flex><md-select-label>\n{{vmd.items.titolo}}</md-select-label><md-select name=\"eventoTipo_id\" ng-model=\"vmd.eventoTipo\" flex \nplaceholder=\"{{vmd.items.titolo}}\" ng-click=\"vmd.updates()\"><md-option ng-repeat=\"item in vmd.eventoTipos\" \nng-value=\"item\"><strong><small>{{item.nome}}</small></strong></md-option></md-select></md-input-container><md-button \nng-click=\"vmd.newwork()\" ng-disabled=\"!vmd.eventoTipo\" class=\"md-button md-button-small-n md-accent-bg\"><b><small>OK\n</small></b></md-button></div><div layout=\"row\" flex ng-if=\"(vmd.eventoTipos.length === 1)\"><md-button \nng-click=\"vmd.newwork(vmd.eventoTipos[0])\" class=\"md-button md-accent-bg\" flex><b><i class=\"icon-play s16\"></i>\n&nbsp;{{vmd.items.titolo}}</b></md-button></div>");
$templateCache.put("app/core/directives/sprardb-process/sprardb-process.html","<md-button class=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.reload()\"><small>RICARICA\n</small></md-button><span class=\"md-title\">Ricerca rapida {{vmd.titolo}}</span><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca negli eventi {{vmd.titolo}}\" type=\"text\" ng-model=\"vmd.thissearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card><md-table-container><table data-md-table><thead ng-if=\"!vmd.options.decapitate\" md-head \nmd-order=\"vmd.query.sort\"><tr md-row><th md-column md-order-by=\"id\"><span>#</span></th><th md-column \nmd-order-by=\"eventoTipo_id\" style=\"text-align: center\">TIPO</th><th md-column md-order-by=\"eventoStato_id\" \nstyle=\"text-align: center\">STATO</th><th md-column md-order-by=\"\"></th><th md-column md-order-by=\"dataInizio\">DATE</th>\n<th md-column md-order-by=\"\">PROGETTO</th><th md-column md-order-by=\"\" style=\"text-align: center\">PROCESSO</th><th \nmd-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\'item in vmd.items[vmd.evs]| filter: vmd.thissearch | filterByArray:vmd.filters:\"eventoTipo_id\" | filterByArray:vmd.activeFilter.stato:\"eventoStato_id\" | orderBy: vmd.query.order | limitTo: vmd.query.perPage : (vmd.query.page -1) * vmd.query.limit track by item.id\'>\n<td md-cell>{{item.id}}</td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell><md-button \nclass=\"md-fab md-mini {{vmd.colors[item.eventoStato_id]}}\" aria-label=\"status\">{{item.eventoStato.stato| limitTo:1 }}\n<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b> // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td \nmd-cell><small><b>{{item.eventoStato.stato|uppercase}}</b></small></td><td md-cell><div layout=\"column\"><div \nlayout=\"row\"><b>{{item.dataInizio}}</b></div><div layout=\"row\">{{item.dataFine}}</div><div layout=\"row\" \nng-if=\"(item.dataFine == null)\"><small>NON LAVORATO</small></div></div></td><td md-cell><b><small><b>\n{{item.entita1.nome|uppercase}}</b></small> <small ng-if=\"(item.entita1.id == 0)\">N/A</small></b></td><td md-cell \nstyle=\"text-align: center\"><div class=\"row\"><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small {{vmd.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vmd.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vmd.isallowed(proc)\"><md-icon \nmd-font-icon=\"{{vmd.isallowed(proc) ? vmd.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s18\">\n</md-icon><md-tooltip><span>{{vmd.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip>\n</md-button><md-button ng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n</div></td><td md-cell style=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Segnalazione\" ng-click=\"vmd.viewEvento($event, item, \'evento\')\"><md-icon\n md-font-icon=\"icon-comment-text-outline\"></md-icon><span>Evento</span></md-button></md-menu-item><md-menu-item \nng-if=\"(item.eventoTipo_id == 5000)\"><md-button aria-label=\"Visita\" ng-click=\"vmd.letteraVisita(item.id)\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon><span>Lettera Visita</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vmd.query.perPage\" \nmd-limit-options=\"vmd.limitOptions\" md-page=\"vmd.query.page\" md-total=\"{{vmd.items.count}}\" \nmd-page-select=\"vmd.options.pageSelect\" md-boundary-links=\"vmd.options.boundaryLinks\" md-on-paginate=\"vmd.query.page\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card>");
$templateCache.put("app/core/directives/sprardb-tabellar/sprardb-tabellar.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>{{vmd.attrs.titolo}}</b></small><div layout=\"row\" flex></div><div flex></div>\n<md-button class=\"md-button md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.reloadTabellar()\"><i \nclass=\"icon-refresh s16\"></i> <small>CARICA/AGGIORNA DATI</small></md-button></div></md-toolbar><md-toolbar \nclass=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"></div></md-toolbar><md-table-container id=\"tabellar\"><table data-md-table><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\"><tr md-row><th md-column md-order-by=\"id\">\n<span>#</span></th><th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">STATO</th><th md-column \nstyle=\"text-align: left\" md-order-by=\"eventoTipo_id\">EVENTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\" ng-if=\"!vmd.attrs.mostradate\">INIZIO</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\" ng-if=\"!vmd.attrs.mostradate\">FINE</th><th md-column md-order-by=\"entita1_id\" \nstyle=\"text-align: left\">{{vmd.entita1|uppercase}}</th><th md-column style=\"text-align: center\">PROCESSO</th><th \nmd-column style=\"text-align: right\" ng-if=\"!vmd.attrs.mostrazioni\">AZIONI</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.items| orderBy: vmd.allsearchs.sort  track by item.id\"><td md-cell>{{item.id}}</td><td md-cell>\n<md-button class=\"md-fab md-mini {{vmd.colors[item.eventoStato_id]}}\" aria-label=\"status\">\n{{item.eventoStato.stato| limitTo:2 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell \nng-if=\"!vmd.attrs.mostradate\"><div layout=\"column\"><div layout=\"row\"><b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b>\n</div></div></td><td md-cell ng-if=\"!vmd.attrs.mostradate\"><div layout=\"column\"><div layout=\"row\"><b>\n{{item.dataFine| date: \"dd/MM/yyyy\"}}</b></div><div layout=\"row\" ng-if=\"(item.dataFine == null)\"><small>NON LAVORATO\n</small></div></div></td><td md-cell><div layout=\"column\"><small><b>{{item.entita1.cognome|uppercase}}</b></small> \n<small><b>{{item.entita1.nome|uppercase}}</b></small> <small><b>{{item.entita1.anno|uppercase}}</b></small> <small><b>\n{{item.entita1.eventoTipo_id|uppercase}}</b></small> <small><b>{{item.entita1.idTipoSegnalazione|uppercase}}</b>\n</small> <small><b>{{item.entita1.questionarioTipo|uppercase}}</b></small> <small ng-if=\"vmd.entita1 == \'struttura\'\">\n{{item.entita2.progettos.nome|uppercase}}</small> <small ng-if=\"(item.entita1.id == 0)\">N/A</small></div></td><td \nmd-cell style=\"text-align: center\" ng-if=\"!vmd.attrs.mostrazioni\"><div layout=\"row\"><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-smallN {{vmd.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vmd.work($event, item, processo[1], processo[2], false)\" style=\"line-height: 18px\" \nng-disabled=\"!vmd.isallowed(proc)\"><div layout=\"column\"><md-icon \nmd-font-icon=\"{{vmd.isallowed(proc) ? vmd.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><span><small><small>{{processo[2]|uppercase}}</small></small></span></div><md-tooltip><span>\n{{vmd.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-Nx2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n</div></td><td md-cell style=\"text-align: right\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"DettaglioEvento\" ng-click=\"vmd.viewEvento($event, item, \'evento\')\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><b><small>DETTAGLIO EVENTO</small></b></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"DettaglioExtra\" ng-click=\"vmd.viewEvento($event, item, \'extra\')\">\n<md-icon md-font-icon=\"icon-details\"></md-icon><b><small>DETTAGLI EXTRA</small></b></md-button></md-menu-item>\n<md-menu-item ng-if=\"vmd.entita1.length > 0\"><md-button aria-label=\"Entita1\" \nng-click=\"vmd.viewEvento($event, item.entita1, vmd.entita1)\"><md-icon md-font-icon=\"icon-human-child\"></md-icon><b>\n<small>{{vmd.entita1|uppercase}}</small></b></md-button></md-menu-item><md-menu-item ng-if=\"vmd.entita2.length > 0\">\n<md-button aria-label=\"Entita2\" ng-click=\"vmd.viewEvento($event, item.entita2, vmd.entita2)\"><md-icon \nmd-font-icon=\"icon-store-24-hour\"></md-icon><b><small>{{vmd.entita2|uppercase}}</small></b></md-button></md-menu-item>\n<md-menu-item ng-show=\" vmd.eventoTipo.id == 1010\"><md-button aria-label=\"Uscita Beneficiario Corrotto\" \nng-click=\"vmd.uscitaBeneficiarioCorrotto($event, item.id)\" ng-disabled=\"!vmd.isAdmin\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon><b><small>RIPETI USCITA</small></b></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/core/directives/sprardb-tabellas/sprardb-tabellas.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>{{vmd.attrs.titolo}}</b></small><div layout=\"row\" flex></div><div flex></div>\n<md-button class=\"md-button md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.reloadTabellar()\"><i \nclass=\"icon-refresh s16\"></i> <small>CARICA/AGGIORNA DATI</small></md-button></div></md-toolbar><md-toolbar \nclass=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"></div></md-toolbar><md-table-container id=\"tabellar\"><table data-md-table><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\"><tr md-row><th md-column \nng-repeat=\"intestazione in vmd.attrs.struttura track by $index\" style=\"{{intestazione.style}}\" \nmd-order-by=\"{{intestazione.mdorderby}}\"><span>{{intestazione.etichetta|uppercase}}</span></th></tr></thead><tbody \nmd-body><tr md-row ng-repeat=\"item in vmd.items| orderBy: vmd.allsearchs.sort  track by item.id\"><td md-cell \nng-repeat=\"corpo in vmd.attrs.struttura track by $index\"><div layout=\"column\"><span \nng-repeat=\"c in ::corpo.campo track by $index\" ng-class=\"{\'text-bold\':corpo.b}\" ng-if=\"!corpo.icona\">\n{{$eval(\"item.\" + c + \"|uppercase\")}} </span><span ng-repeat=\"(k,v) in ::corpo.icona track by $index\" \nng-if=\"corpo.icona\"><md-icon class=\"{{v}}\" style=\"font-size:20px\" ng-if=\"item[corpo.campo[0]] == k\"></md-icon></span>\n<md-menu ng-if=\"corpo.a\"><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-repeat=\"bottone in ::corpo.bottoni\" ng-if=\"bottone.ngif\"><md-button ng-init=\"link = bottone.uisref + \'(item)\';\" \naria-label=\"{{bottone.etichetta}}\" ng-click=\"bottone.ngclick\" ui-sref=\"{{link}}\"><md-icon \nmd-font-icon=\"{{bottone.icona}}\"></md-icon><b><small>{{bottone.etichetta|uppercase}}</small></b></md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments/sprardb-uploaddocuments.html","<md-button class=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.loadDT()\"><small>AGGIORNA\n</small></md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>\nCARICA UN FILE</md-button><md-card style=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\"><md-table-container><table \ndata-md-table><thead ng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\" \nmd-on-reorder=\"vmd.onSearch\"><tr md-row><th md-column md-order-by=\"id\">#</th><th md-column>NOME FILE</th><th md-column>\nTIPO</th><th md-column>CARICAMENTO</th><th md-column ng-if=\"vmd.uploadCfg.cancellazione\">CANCELLA</th></tr></thead>\n<tbody md-body><tr md-row ng-repeat=\"item in vmd.documentos\"><td md-cell><div layout=\"column\"><span>\n{{item.documento.id}}</span><span>({{$index + 1}})</span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}{{item.documento.unomefile}}\" target=\"_blank\">{{ item.documento.nomefile | uppercase|limitTo:20}}\n</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.documento.documentotipo.tipo | uppercase}}</td>\n<td md-cell>{{ item.documento.data}}</td><td md-cell ng-if=\"vmd.uploadCfg.cancellazione\"><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancella\" ng-if=\"vmd.uploadCfg.cancellazione\" \nng-click=\"vmd.cancelladocumento(item.documento.id, 0)\"><md-icon md-font-icon=\"icon-table-row-remove\"></md-icon>\nCancella il file</md-button></td></tr></tbody></table></md-table-container></md-card><div layout=\"column\" \nng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div layout=\"row\" ng-repeat=\"item in vmd.documentos\"><small>\n<b><a title=\"{{item.documento.nomefile}}\" href=\"{{vmd.baseUrl}}{{item.documento.unomefile}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></b> ({{ item.documento.documentotipo.tipo | uppercase}})\n</small></div></div>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments/sprardb-uploaddocumentsDialog.html","<md-dialog aria-label=\"uploadDialog\" id=\"uploaddialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.params.gruppo}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\">\n<div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un tipo documento</label><md-select name=\"nome\" ng-model=\"vmdd.params.documentoTipo_id\" required flex><md-option\n ng-repeat=\"item in vmdd.documentoTipos\" value=\"{{item.id}}\" ng-selected=\"item.id == vmdd.params.documentoTipo_id\">\n<small><strong>{{item.tipo}}</strong></small></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div id=\"file\" flow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" \nflow-files-submitted=\"vmdd.upload()\" flow-file-added=\"vmdd.fileAdded($file)\" \nflow-file-success=\"vmdd.fileSuccess($file, $message)\" flow-complete=\"vmdd.uploadComplete()\" \nflow-progress=\"vmdd.fileprogress()\" flex><md-button flow-btn class=\"add-file-button md-accent md-grey-100-bg\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" style=\"width: 100%\" \nng-disabled=\"!vmdd.params.documentoTipo_id\" ng-if=\"!vmdd.inprogress\"><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon>Allega un file</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" id=\"toolbar-progress\" \nclass=\"md-accent\" ng-disabled=\"!vmdd.inprogress\"></md-progress-linear></form></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments2/sprardb-uploaddocuments2.html","<div ng-if=\"vmd.step1\"><md-button class=\"add-file-button md-accent\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\" ng-if=\"!vmd.api.isReadOnly\">CARICA UN FILE<md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><small>Files caricati: <b ng-if=\"!vmd.uploadCfg.mostratutti\">\n{{vmd.uploadCfg.caricato}}</b><b ng-if=\"vmd.uploadCfg.mostratutti\">{{vmd.uploadCfg.tuttidocumenti}}</b> <span \nng-if=\"vmd.uploadCfg.mincaricato\">di <b>{{vmd.uploadCfg.mincaricato}}</b></span></small><md-card \nstyle=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\"><md-table-container><table data-md-table><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\" md-on-reorder=\"vmd.onSearch\"><tr md-row><th\n md-column md-order-by=\"id\">#</th><th md-column>NOME FILE</th><th md-column>TIPO</th><th md-column>CARICAMENTO</th>\n</tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vmd.documentos\"><td md-cell>{{item.documento.id}}</td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ item.documento.documentotipo.tipo | uppercase}}</td><td md-cell>{{ item.documento.data}}</td></tr></tbody></table>\n</md-table-container></md-card><div layout=\"column\" ng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div \nlayout=\"row\" ng-repeat=\"item in vmd.documentos track by $index\"><small><small>{{$index + 1}})</small>&nbsp;&nbsp;<b><a \ntitle=\"{{item.documento.nomefile}}\" href=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" \ntarget=\"_blank\">{{ item.documento.nomefile | uppercase|limitTo:20}}.{{item.documento.tipoFile}}</a></b>\n&nbsp;&nbsp;&nbsp;<small>({{ item.documento.documentotipo.tipo | uppercase}})</small></small></div></div></div><div \nng-if=\"vmd.step2\"><div layout=\"column\" layout-gt-md=\"row\" class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\" flex><label>Scegli un tipo documento</label><md-select name=\"nome\" \nng-model=\"vmd.d.params.documentoTipo_id\" required flex><md-option ng-repeat=\"item in vmd.d.documentoTipos\" \nvalue=\"{{item.id}}\" ng-selected=\"item.id == vmd.d.params.documentoTipo_id\"><small><strong>{{item.tipo}}</strong>\n</small></md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div id=\"file\" \nflow-init=\"vmd.d.ngFlowOptions\" flow-name=\"vmd.d.ngFlow.flow\" flow-files-submitted=\"vmd.upload()\" \nflow-file-added=\"vmd.fileAdded($file)\" flow-file-success=\"vmd.fileSuccess($file, $message)\" \nflow-file-error=\"vmd.fileError($file, $message, $flow )\" flow-complete=\"vmd.uploadComplete()\" flex><div layout=\"row\">\n<md-button class=\"add-file-button md-accent\" aria-label=\"Back\" ng-click=\"vmd.closeUpload()\" flex><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon>INDIETRO</md-button><md-button flow-btn class=\"add-file-button md-accent\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" flex><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon>Allega un file</md-button></div></div></div></div>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments2/sprardb-uploaddocumentsDialog2.html","<md-dialog aria-label=\"uploadDialog\" id=\"uploaddialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.params.gruppo}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>Scegli un tipo documento</label><md-select \nname=\"nome\" ng-model=\"vmdd.params.documentoTipo_id\" required flex><md-option ng-repeat=\"item in vmdd.documentoTipos\" \nvalue=\"{{item.id}}\" ng-selected=\"item.id == vmdd.params.documentoTipo_id\"><small><strong>{{item.tipo}}</strong></small>\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div id=\"file\" \nflow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" flow-files-submitted=\"vmdd.upload()\" \nflow-file-added=\"vmdd.fileAdded($file)\" flow-file-success=\"vmdd.fileSuccess($file, $message)\" \nflow-complete=\"vmdd.uploadComplete()\" flex><md-button flow-btn class=\"add-file-button md-accent md-grey-100-bg\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" style=\"width: 100%\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon>Allega un file</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments3/sprardb-uploaddocuments3.html","<md-button class=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.loadDT()\"><small>AGGIORNA\n</small></md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\" ng-if=\"!vmd.api.isReadOnly && !vmd.api.isTutor\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon>CARICA UN FILE</md-button><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancellati\" \nng-click=\"vmd.cancellati = (vmd.cancellati == 0) ? 1 : 0\" ng-if=\"false\"><md-icon ng-if=\"!vmd.cancellati\" \nmd-font-icon=\"icon-eye\"></md-icon><md-icon ng-if=\"vmd.cancellati\" md-font-icon=\"icon-eye-off\"></md-icon><span \nng-if=\"vmd.cancellati\">MOSTRA CANCELLATI</span> <span ng-if=\"!vmd.cancellati\">MOSTRA VISIBILI</span></md-button><div \nlayout=\"row\" layout-align=\"space-between center\" flex><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca\" type=\"text\" ng-model=\"vmd.fsearch\" ng-model-options=\"{debounce: 700}\">\n</md-input-container></div><md-card style=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\"><md-table-container><table \ndata-md-table><thead ng-if=\"!vmd.options.decapitate\" md-head><tr md-row><th md-column>Progressivo</th><th md-column>\nIdentificativo</th><th md-column>Nome FIle</th><th md-column>Tipologia</th><th md-column>Data Caricamento</th><th \nmd-column>Progetto</th><th md-column ng-if=\"false\">&nbsp;</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.documentos| filter: vmd.fsearch | filter: {visibile: vmd.cancellati}\"><td md-cell><div \nlayout=\"column\"><span>{{$index + 1}}</span></div></td><td md-cell><div layout=\"column\"><span>{{item.documento.id}}\n</span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ item.documento.documentotipo.tipo | uppercase}}</td><td md-cell>{{ item.documento.data}}</td><td md-cell><div \nlayout=\"column\"><span ng-if=\"item.pid <= 0\">-- NON DEFINITO --</span> <span ng-if=\"item.pid > 0\"><strong>\n{{item.progetto.nome|uppercase}}</strong> - {{item.progetto.codiceMinistero}}</span></div></td><td md-cell \nng-if=\"false\"><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancella\" \nng-if=\"vmd.uploadCfg.cancellazione\" ng-click=\"vmd.cancelladocumento(item.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon>Cancella</md-button></td></tr></tbody></table></md-table-container></md-card><div layout=\"column\" \nng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div layout=\"row\" ng-repeat=\"item in vmd.documentos\"><small>\n<b><a title=\"{{item.documento.nomefile}}\" href=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" \ntarget=\"_blank\">{{ item.documento.nomefile | uppercase|limitTo:20}}</a></b>\n ({{ item.documento.documentotipo.tipo | uppercase}})</small></div></div>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments3/sprardb-uploaddocuments3Dialog.html","<md-dialog aria-label=\"uploadDialog\" id=\"uploaddialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.params.gruppo}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\">\n<div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un tipo documento</label><md-select name=\"nome\" ng-model=\"vmdd.params.documentoTipo_id\" required flex><md-option\n ng-repeat=\"item in vmdd.documentoTipos\" value=\"{{item.id}}\" ng-selected=\"item.id == vmdd.params.documentoTipo_id\">\n<small><strong>{{item.tipo}}</strong></small></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div id=\"file\" flow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" \nflow-files-submitted=\"vmdd.upload()\" flow-file-added=\"vmdd.fileAdded($file)\" \nflow-file-success=\"vmdd.fileSuccess($file, $message)\" flow-complete=\"vmdd.uploadComplete()\" \nflow-progress=\"vmdd.fileprogress()\" flex><md-button flow-btn class=\"add-file-button md-accent md-grey-100-bg\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" style=\"width: 100%\" \nng-disabled=\"!vmdd.params.documentoTipo_id\" ng-if=\"!vmdd.inprogress\"><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon>Allega un file</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" id=\"toolbar-progress\" \nclass=\"md-accent\" ng-disabled=\"!vmdd.inprogress\"></md-progress-linear></form></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments4/sprardb-uploaddocuments4.html","<md-button class=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.loadDT()\"><small>AGGIORNA\n</small></md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>\nCARICA UN FILE</md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Add file\" \nng-click=\"vmd.downloadFileList()\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>scarica lista file</md-button>\n<md-card style=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\">{{vmd.downloadFileList}}<md-table-container><table \ndata-md-table><thead ng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\" \nmd-on-reorder=\"vmd.onSearch\"><tr md-row><th md-column md-order-by=\"id\">#</th><th md-column>NOME FILE</th><th md-column>\nTIPO</th><th md-column>CARICAMENTO</th><th md-column ng-if=\"vmd.uploadCfg.cancellazione\">CANCELLA</th></tr></thead>\n<tbody md-body><tr md-row ng-repeat=\"item in vmd.documentos\"><td md-cell><div layout=\"column\"><span>\n{{item.documento.id}}</span><span>({{$index + 1}})</span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}{{item.documento.unomefile}}\" target=\"_blank\">{{ item.documento.nomefile | uppercase|limitTo:20}}\n</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.documento.documentotipo.tipo | uppercase}}</td>\n<td md-cell>{{ item.documento.data}}</td><td md-cell ng-if=\"vmd.uploadCfg.cancellazione\"><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancella\" ng-if=\"vmd.uploadCfg.cancellazione\" \nng-click=\"vmd.cancelladocumento(item.documento.id, 0)\"><md-icon md-font-icon=\"icon-table-row-remove\"></md-icon>\nCancella il file</md-button></td></tr></tbody></table></md-table-container></md-card><div layout=\"column\" \nng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div layout=\"row\" ng-repeat=\"item in vmd.documentos\"><small>\n<b><a title=\"{{item.documento.nomefile}}\" href=\"{{vmd.baseUrl}}{{item.documento.unomefile}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></b> ({{ item.documento.documentotipo.tipo | uppercase}})\n</small></div></div>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments4/sprardb-uploaddocumentsDialog4.html","<md-dialog aria-label=\"uploadDialog4\" id=\"uploaddialog4\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.params.gruppo}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\">\n<div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un tipo documento</label><md-select name=\"nome\" ng-model=\"vmdd.params.documentoTipo_id\" required flex><md-option\n ng-repeat=\"item in vmdd.documentoTipos\" value=\"{{item.id}}\" ng-selected=\"item.id == vmdd.params.documentoTipo_id\">\n<small><strong>{{item.tipo}}</strong></small></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div id=\"file\" flow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" \nflow-files-submitted=\"vmdd.upload()\" flow-file-added=\"vmdd.fileAdded($file)\" \nflow-file-success=\"vmdd.fileSuccess($file, $message)\" flow-complete=\"vmdd.uploadComplete()\" \nflow-progress=\"vmdd.fileprogress()\" flex><md-button flow-btn class=\"add-file-button md-accent md-grey-100-bg\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" style=\"width: 100%\" \nng-disabled=\"!vmdd.params.documentoTipo_id\" ng-if=\"!vmdd.inprogress\"><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon>Allega un file</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" id=\"toolbar-progress\" \nclass=\"md-accent\" ng-disabled=\"!vmdd.inprogress\"></md-progress-linear></form></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments5/sprardb-uploaddocuments5.html","<md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.loadDT()\" \nng-if=\"!vmd.uploadCfg.dettagliomin\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>AGGIORNA</md-button><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" ng-if=\"!vmd.readonly\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>\nCARICA UN FILE</md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Add file\" \nng-click=\"vmd.downloadFileList()\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon>scarica lista file</md-button>\n<md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancellati\" \nng-click=\"vmd.visibile = (vmd.visibile == 0) ? 1 : 0;vmd.loadDT();\" \nng-if=\"!vmd.uploadCfg.dettagliomin && !vmd.readonly\"><md-icon ng-if=\"!vmd.visibile\" md-font-icon=\"icon-eye\"></md-icon>\n<md-icon ng-if=\"vmd.visibile\" md-font-icon=\"icon-eye-off\"></md-icon><span ng-if=\"vmd.visibile\">MOSTRA CANCELLATI</span>\n <span ng-if=\"!vmd.visibile\">MOSTRA VISIBILI</span></md-button><div layout=\"row\" layout-align=\"space-between center\" \nflex ng-if=\"!vmd.uploadCfg.dettagliomin\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca\" type=\"text\" ng-model=\"vmd.fsearch\" ng-model-options=\"{debounce: 700}\"></md-input-container></div>\n<md-card style=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\">{{vmd.downloadFileList}}<md-table-container><table \ndata-md-table md-progress=\"vmd.documentos\"><thead ng-if=\"!vmd.options.decapitate\" md-head><tr md-row><th md-column>PROG\n</th><th md-column>IDENTIF</th><th md-column>NOME FILE</th><th md-column>TIPOLOGIA</th><th md-column>DATA CARICAMENTO\n</th><th md-column ng-if=\"!vmd.readonly\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.documentos| filter: vmd.fsearch\"><td md-cell><div layout=\"column\"><span>\n{{((vmd.moduloupload.page - 1) * vmd.moduloupload.pagination) + ($index + 1)}}</span></div></td><td md-cell><div \nlayout=\"column\"><span>{{item.documento.id}}.{{item.id}}</span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ item.documento.documentotipo.tipo | uppercase}}</td><td md-cell>{{ item.documento.data}}</td><td md-cell \nng-if=\"!vmd.readonly\"><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancella\" \nng-if=\"(item.visibile == 1)\" ng-click=\"vmd.cancelladocumento(item.id, 0)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\nCancella il file</md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Ripristina\" \nng-if=\"(vmd.api.isAdmin && item.visibile == 0)\" ng-click=\"vmd.cancelladocumento(item.id, 1)\"><md-icon \nmd-font-icon=\"icon-undo\"></md-icon>Ripristina il file</md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vmd.moduloupload.pagination\" md-limit-options=\"vmd.moduloupload.limitOptions\" \nmd-page=\"vmd.moduloupload.page\" md-total=\"{{vmd.moduloupload.meta.totalCount}}\" md-on-paginate=\"vmd.loadDT\" \nmd-page-select=\"vmd.moduloupload.options.pageSelect\" md-boundary-links=\"vmd.moduloupload.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"column\" ng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div layout=\"row\" \nng-repeat=\"item in vmd.documentos\"><small><b><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></b> ({{ item.documento.documentotipo.tipo | uppercase}})\n<md-button class=\"md-mini\" ng-style=\"{\'min-width\':\'35px\'}\" aria-label=\"Cancella\" ng-if=\"(item.visibile == 1)\" \nng-click=\"vmd.cancelladocumento(item.id, 0)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></small></div>\n</div>");
$templateCache.put("app/core/directives/sprardb-uploaddocuments5/sprardb-uploaddocumentsDialog5.html","<md-dialog aria-label=\"uploadDialog4\" id=\"uploaddialog4\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.params.gruppo}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\">\n<div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un tipo documento</label><md-select name=\"nome\" ng-model=\"vmdd.params.documentoTipo_id\" required flex><md-option\n ng-repeat=\"item in vmdd.documentoTipos\" value=\"{{item.id}}\" ng-selected=\"item.id == vmdd.params.documentoTipo_id\">\n<small><strong>{{item.tipo}}</strong></small></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div id=\"file\" flow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" \nflow-files-submitted=\"vmdd.upload()\" flow-file-added=\"vmdd.fileAdded($file)\" \nflow-file-success=\"vmdd.fileSuccess($file, $message)\" flow-complete=\"vmdd.uploadComplete()\" \nflow-progress=\"vmdd.fileprogress()\" flow-error=\"vmdd.fileerror()\" flex><md-button flow-btn \nclass=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" \nstyle=\"width: 100%\" ng-disabled=\"!vmdd.params.documentoTipo_id\" ng-if=\"!vmdd.inprogress\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon>Allega un file</md-button></div></div><md-progress-linear \nmd-mode=\"indeterminate\" id=\"toolbar-progress\" class=\"md-accent\" ng-disabled=\"!vmdd.inprogress\"></md-progress-linear>\n</form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiari.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button \nlayout=\"row\" layout-align=\"start center\"><span class=\"small\"><i class=\"icon icon-arrow-left s14\"></i> Indietro</span>\n</md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span class=\"small\">SELEZIONATO</span>\n</span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\">Seleziona tutti</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\">Seleziona nessuno</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float \nclass=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Codice</b></small> <input id=\"search\" placeholder=\"Codice\" \ntype=\"text\" ng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricercaCognome\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Nome</b></small> \n<input id=\"search\" placeholder=\"Nome\" type=\"text\" ng-model=\"vm.ricercaNome\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex><md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata\n</small><md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card\n style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>{{vm.title}}</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && ricercato != null && key !== \'cancellato_IN\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'beneficiari selezionati\' : \'beneficiario selezionato\'}} :</span><div\n flex></div><md-button aria-label=\"Nucleo\" ng-click=\"vm.editparentela()\" class=\"md-button\" \nng-disabled=\"(vm.selected.length == 0) || vm.api.isReadOnly\"><md-icon md-font-icon=\"icon-account-multiple-outline\" \nstyle=\"color: rgba(255, 255, 255, 0.87)\"></md-icon>Nucleo Familiare</md-button></div></md-toolbar><md-table-container>\n<table data-md-table data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\"><thead ng-if=\"!vm.options.decapitate\" \nmd-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" \nstyle=\"text-align:center;padding-right:4px\">Cod.</th><th md-column md-order-by=\"stato\" \nstyle=\"text-align:center;padding-right:8px\">STATO</th><th md-column style=\"text-align:center;padding-right:8px\">DOCUM\n</th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\"><span>COGNOME</span></th><th md-column \nmd-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column style=\"padding-right:8px\">NAZIONE</th><th \nmd-column style=\"padding-right:8px\" md-order-by=\"progetto_id\">PROGETTO</th><th md-column \nstyle=\"text-align:center;padding-right:4px\" ng-if=\"vm.def != null\">ACCOGLIENZA</th><th md-column \nstyle=\"text-align:center;padding-right:4px\" md-order-by=\"sesso\">G</th><th md-column \nstyle=\"text-align:center;padding-right:8px\" ng-if=\"(vm.datas.api == \'v\' && vm.api.isAdmin && vm.def != null)\"><div \nlayout=\"column\"><span>INIZIO</span> <span>ACCOGLIENZA</span></div></th><th md-column \nstyle=\"text-align:center;padding-right:8px\" ng-if=\"(vm.datas.api == \'v\' && vm.api.isAdmin && vm.def == null)\"><div \nlayout=\"column\"><span>INIZIO PRESENZA</span> <span>SUL TERRITORIO</span></div></th><th md-column \nstyle=\"text-align:center;padding-right:8px\" \nng-if=\"(vm.datas.api == \'v\' && vm.def == 1) || (vm.datas.api == \'v\' && vm.api.isOperatoreG)\"><div layout=\"column\">\n<span>INGRESSO</span> <span>PROGETTO</span></div></th><th md-column style=\"text-align:center;padding-right:8px\" \nng-if=\"vm.datas.api == \'v\' && vm.def != null\"><div layout=\"column\"><span>FINE</span> <span>ACCOGLIENZA</span></div>\n</th><th md-column style=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'v\' && vm.def == null\"><div \nlayout=\"column\"><span>FINE PRESENZA</span> <span>SUL TERRITORIO</span></div></th><th md-column \nstyle=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'a\'\"><div layout=\"column\"><span>INGRESSO</span> \n<span>PROGETTO</span></div></th><th md-column style=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'a\'\">\n<div layout=\"column\"><span>FINE</span> <span>ACCOGLIENZA</span></div></th><th md-column \nstyle=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'a\'\"><div layout=\"column\"><span>USCITA</span> <span>\nPROGETTO</span></div></th><th md-column style=\"text-align:center;padding-right:4px\">Num.</th><th md-column \nmd-order-by=\"nucleoFamiliare\" style=\"text-align:center;padding-right:4px\">F</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" \nmd-select-id=\"beneficiario\" ng-disabled=\"(beneficiario.def === 0)\" data-md-on-select=\"vm.toggleSelect\" \nmd-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"beneficiario in vm.beneficiari\" \nng-class=\"{\'md-light-blue-50-bg\': beneficiario.def === 0,\'md-deep-orange-50-bg\': beneficiario.trasferimento === 1}\"><td\n md-cell style=\"text-align:center;padding-right:4px\"><div layout=\"column\"><span ng-if=\"beneficiario.def == 1\">\n{{beneficiario.codice}}</span> <span ng-if=\"beneficiario.def == 0\">{{beneficiario.id}}</span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><div layout=\"column\"><small \nng-if=\"beneficiario.stato !== \'TERMINATO\' && beneficiario.stato !== \'PRESENTE SUL TERRITORIO TERMINATO\'\"><strong>\n{{beneficiario.stato}}</strong></small> <small ng-if=\"beneficiario.dataUscita\">{{beneficiario.stato}}</small> <small \nng-if=\"!beneficiario.dataUscita\">ATTIVO</small></div></td><td md-cell style=\"text-align:center;padding-right:8px\"><span\n ng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}:true\"><md-button \nclass=\"md-fab md-mini {{vm.colors[item.codice]}}\" aria-label=\"status\">{{ item.descrizione|limitTo:2}}<md-tooltip>\n{{ item.descrizione}} - {{beneficiario.dataRilascioDocumento|date: \"dd/MM/yyyy\"}} - {{beneficiario.dataScadenzaDocumento|date: \"dd/MM/yyyy\"}}\n</md-tooltip></md-button></span><md-button ng-if=\"beneficiario.idTipoDocumento == \'0\'\" \nclass=\"md-fab md-mini md-blue-grey-800-bg\" aria-label=\"status\">-<md-tooltip><span>NESSUN DOCUMENTO</span></md-tooltip>\n</md-button></td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\"><div layout=\"row\">\n<span>{{beneficiario.cognome|uppercase}}</span> <span class=\"red-700-fg s14\" \nng-if=\"(beneficiario.idVulnerabilita > 0)\">&nbsp;(V)</span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">{{beneficiario.nome|uppercase}}</td><td md-cell \nstyle=\"padding-right:8px\">{{ beneficiario.nazionalita.descrizione}}<br>\n{{beneficiario.dataNascita| date : \"dd/MM/yyyy\"}}</td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span>\n<strong>{{ beneficiario.progettos.nome|uppercase}}</strong></span> <span><small>\n{{ beneficiario.ultimastrutturas.nome|uppercase}}</small></span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:4px\" ng-if=\"vm.def != null\"><md-icon ng-if=\"beneficiario.esterna\" \nmd-font-icon=\"icon-domain\"></md-icon></td><td md-cell style=\"text-align:center;padding-right:4px\"><b>\n{{beneficiario.sesso}}</b></td><td md-cell style=\"text-align:center;padding-right:8px\" \nng-if=\"(vm.datas.api == \'v\' && vm.api.isAdmin)\"><div layout=\"column\"><span>\n{{beneficiario.dataInizio| date : \"dd/MM/yyyy\"}}</span> <span ng-if=\"beneficiario.dataInizio == null\">---</span></div>\n</td><td md-cell style=\"text-align:center;padding-right:8px\" \nng-if=\"(vm.datas.api == \'v\' && vm.def == 1) || (vm.datas.api == \'v\' && vm.api.isOperatoreG)\"><div layout=\"column\">\n<span>{{vm.dip[beneficiario.id]| date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\" \nng-if=\"vm.datas.api == \'v\' && beneficiario.stato != \'PRESENTE SUL TERRITORIO\'\"><div layout=\"column\"><span>\n{{beneficiario.dataFine| date : \"dd/MM/yyyy\"}}</span> <span ng-if=\"beneficiario.dataFine == null\">---</span></div></td>\n<td md-cell style=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'a\'\"><div layout=\"column\"><span>\n{{beneficiario.dataInizio| date : \"dd/MM/yyyy\"}}</span> <span ng-if=\"beneficiario.dataInizio == null\">---</span></div>\n</td><td md-cell style=\"text-align:center;padding-right:8px\" ng-if=\"vm.datas.api == \'a\'\"><div layout=\"column\"><span>\n{{beneficiario.dataFine| date : \"dd/MM/yyyy\"}}</span> <span ng-if=\"beneficiario.dataFine == null\">---</span></div></td>\n<td md-cell style=\"text-align:center;padding-right:8px\" \nng-if=\"vm.datas.api == \'a\' || beneficiario.stato == \'PRESENTE SUL TERRITORIO\'\"><div layout=\"column\"><span>\n{{beneficiario.dataUscita| date : \"dd/MM/yyyy\"}}</span> <span ng-if=\"beneficiario.dataUscita == null\">---</span></div>\n</td><td md-cell style=\"text-align:right;padding-right:4px\"><div layout=\"column\"><span \nng-if=\"(beneficiario.dataUscita == null && vm.datas.api == \'a\')\">\n{{vm.calcolomontanteeffettuato2[beneficiario.progressivo]}} <span ng-if=\"vm.api.isAdminG\">\n/ {{vm.calcolomontanteeffettuato[beneficiario.id]}}</span> </span><span \nng-if=\"(beneficiario.dataUscita == null && vm.datas.api == \'v\')\">{{vm.calcolomontanteeffettuato2[beneficiario.id]}} \n<span ng-if=\"vm.api.isAdminG && vm.datas.api != \'v\'\">/ {{vm.calcolomontanteeffettuato[beneficiario.id]}}</span> </span>\n<span ng-if=\"(beneficiario.dataUscita != null)\">{{vm.calcolomontanteeffettuato2[beneficiario.progressivo]}} <span \nng-if=\"vm.api.isAdminG\">/ {{vm.calcolomontanteeffettuato[beneficiario.beneficiario_id]}}</span></span></div></td><td \nmd-cell style=\"text-align:right;padding-right:4px\"><i class=\"icon-account-multiple-outline\" \nng-if=\"(beneficiario.nucleoFamiliare === 1 && beneficiario.parentela_id !== null)\"><md-tooltip>\n{{beneficiario.parentela.descrizione|uppercase}}</md-tooltip></i></td><td md-cell \nstyle=\"text-align:right;padding-right:8px\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-if=\"beneficiario.stato === \'PRESENTE SUL TERRITORIO\'\"><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiariop({codicePresenza:beneficiario.codicePresenza})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Apri</span></md-button>-</md-menu-item><md-menu-item \nng-if=\"beneficiario.def == 1 && beneficiario.dataUscita == null && beneficiario.stato !== \'PRESENTE SUL TERRITORIO\'\">\n<md-button aria-label=\"Dettaglio\" ui-sref=\"app.sprardb_beneficiario({id:beneficiario.id})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Apri</span></md-button>-</md-menu-item><md-menu-item \nng-if=\"beneficiario.def == 1 && beneficiario.dataUscita != null\"><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiariostorico({id:beneficiario.progressivo})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Apri</span></md-button></md-menu-item><md-menu-item \nng-if=\"beneficiario.def == 0\"><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiarioi({id:beneficiario.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\">\n</md-icon><span>Apri</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.api.isReadOnly && !vm.api.isTutor\">\n<md-button aria-label=\"Nucleo\" ng-click=\"vm.editparentela()\" \nng-disabled=\"(vm.selected.length == 0) || beneficiario.cancellato == 1\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon><span>Nucleo Familiare</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"!vm.api.isReadOnly && !vm.api.isTutor\"><md-button aria-label=\"Trasferisci\" \nng-click=\"vm.trasferiscib(1013)\" \nng-disabled=\"(vm.selected.length !== 1 || vm.selected[0].trasferimento == 1) || beneficiario.cancellato == 1\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\"></md-icon><span>Trasferisci</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"!vm.api.isReadOnly && !vm.api.isTutor\"><md-button aria-label=\"Uscita\" ng-click=\"vm.cessab(1010)\" \nng-disabled=\"(vm.selected.length !== 1) || beneficiario.cancellato == 1\"><md-icon md-font-icon=\"icon-exit-to-app\">\n</md-icon><span>Uscita</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.api.isReadOnly && !vm.api.isTutor\">\n<md-button aria-label=\"Permesso\" ng-click=\"vm.permessob(1012)\" \nng-disabled=\"(vm.selected.length !== 1) || beneficiario.cancellato == 1\"><md-icon md-font-icon=\"icon-fullscreen-exit\">\n</md-icon><span>Permesso</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiariom.html","<div id=\"beneficiari\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/beneficiari/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Ricerca Omonimie</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei beneficiari\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Omonimie</span><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'beneficiari selezionati\' : \'beneficiario selezionato\'}} :</span><div\n flex></div></div></md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\"><thead ng-if=\"!vm.options.decapitate\" \nmd-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" \nstyle=\"text-align:center;padding-right:4px\">Cod</th><th md-column md-order-by=\"stato\" \nstyle=\"text-align:center;padding-right:8px\">STATO</th><th md-column style=\"text-align:center;padding-right:8px\">DOCUM\n</th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\"><span>COGNOME</span></th><th md-column \nmd-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column style=\"padding-right:8px\">NAZIONE</th><th \nmd-column style=\"padding-right:8px\">PROGETTO</th><th md-column md-order-by=\"sesso\" \nstyle=\"text-align:center;padding-right:8px\">G</th><th md-column md-order-by=\"dataNascita\" \nstyle=\"text-align:center;padding-right:8px\">NASCITA</th><th md-column md-order-by=\"dataUscita\" \nstyle=\"text-align:center;padding-right:8px\">USCITA</th><th md-column md-order-by=\"n\" \nstyle=\"text-align:center;padding-right:4px\">Num</th><th md-column md-order-by=\"nucleoFamiliare\" \nstyle=\"text-align:center;padding-right:4px\">F</th><th md-column style=\"text-align:right;padding-right:16px\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" \nng-disabled=\"(beneficiario.def === 0)\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"beneficiario in vm.beneficiari\" \nng-class=\"{\'md-light-blue-50-bg\': beneficiario.def === 0,\'md-deep-orange-50-bg\': beneficiario.trasferimento === 1}\"><td\n md-cell style=\"text-align:center;padding-right:4px\">{{beneficiario.id}}</td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><span \nng-repeat=\"item in vm.benefstatos| filter: {descrizione:beneficiario.stato}\"><md-button \nclass=\"md-fab md-mini {{vm.colors[(item.codice + 5)]}}\" aria-label=\"status\">{{ item.descrizione|limitTo:1}}<md-tooltip>\n{{ item.descrizione}}</md-tooltip></md-button></span></td><td md-cell style=\"text-align:center;padding-right:8px\"><span\n ng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}:true\"><md-button \nclass=\"md-fab md-mini {{vm.colors[item.codice]}}\" aria-label=\"status\">{{ item.descrizione|limitTo:2}}<md-tooltip>\n{{ item.descrizione}} - {{beneficiario.dataRilascioDocumento|date: \"dd/MM/yy\"}} - {{beneficiario.dataScadenzaDocumento|date: \"dd/MM/yy\"}}\n</md-tooltip></md-button></span><md-button ng-if=\"beneficiario.idTipoDocumento == \'0\'\" \nclass=\"md-fab md-mini md-blue-grey-800-bg\" aria-label=\"status\">-<md-tooltip><span>NESSUN DOCUMENTO</span></md-tooltip>\n</md-button></td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\" \nmd-highlight-text=\"vm.ricerca.cognome\" md-highlight-flags=\"i\">{{beneficiario.cognome|uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\" md-highlight-text=\"vm.ricerca.nome\" \nmd-highlight-flags=\"i\">{{beneficiario.nome|uppercase}}</td><td md-cell style=\"padding-right:8px\">\n{{ beneficiario.nazionalita.descrizione}}</td><td md-cell style=\"padding-right:8px\"><b>\n{{ beneficiario.progettos.nome|uppercase}}</b><br><span ng-repeat=\"stru in ::beneficiario.strutturas\"><small>\n{{ stru.nome|uppercase}}</small></span></td><td md-cell style=\"text-align:center;padding-right:8px\" \nmd-highlight-text=\"vm.ricerca.sesso\" md-highlight-flags=\"i\">{{beneficiario.sesso|uppercase}}</td><td md-cell \nstyle=\"text-align:center;padding-right:8px\" md-highlight-text=\"vm.ricerca.dataNAscita\" md-highlight-flags=\"i\">\n{{beneficiario.dataNascita| date : \"dd/MM/yy\"}}</td><td md-cell style=\"text-align:center;padding-right:8px\" \nng-if=\"beneficiario.dataUscita != \'0000-00-00\'\">{{beneficiario.dataUscita| date : \"dd/MM/yy\"}}</td><td md-cell \nstyle=\"text-align:right;padding-right:4px\">{{beneficiario.n}}</td><td md-cell \nstyle=\"text-align:right;padding-right:4px\"><i class=\"icon-account-multiple-outline\" \nng-if=\"(beneficiario.nucleoFamiliare === 1)\"><md-tooltip>{{beneficiario.parentelas.descrizione|uppercase}}</md-tooltip>\n</i></td><td md-cell style=\"text-align:right;padding-right:8px\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiario({id:beneficiario.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\">\n</md-icon><span>Apri beneficiario</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/beneficiari/ricercabeneficiarisegnalati.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nRicerca Beneficiari e Segnalati</span></div></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button layout=\"row\" layout-align=\"start center\">\n<span class=\"small\"><i class=\"icon icon-arrow-left s14\"></i> Indietro</span></md-button></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float \nclass=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Nome</b></small> <input id=\"search\" placeholder=\"Nome\" \ntype=\"text\" ng-model=\"vm.ricercaNome\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearchNome(vm.ricercaNome)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricercaCognome\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearchCognome(vm.ricercaCognome)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Codice</b></small> <input id=\"search\" placeholder=\"Codice\" type=\"text\" \nng-model=\"vm.ricercaCodice\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearchCodice(vm.ricercaCodice)\"></md-input-container></div></div><md-card style=\"padding-top:0px\">\n<md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>{{vm.title}}</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\' && ricercato != null\"><md-icon \nclass=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table data-md-table \nmd-progress=\"vm.beneficiari\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"stato\" style=\"padding-right:8px\"><span>STATO</span>\n</th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\"><span>COGNOME</span></th><th md-column \nmd-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column style=\"padding-right:8px\">NAZIONE</th><th \nmd-column style=\"padding-right:8px\">DATA DI NASCITA</th><th md-column style=\"text-align:center;padding-right:4px\" \nmd-order-by=\"sesso\">G</th><th md-column style=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-disabled=\"(beneficiario.def === 0)\" \ndata-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"beneficiario in vm.beneficiari\" \nng-class=\"{\'md-light-blue-50-bg\': beneficiario.def === 0,\'md-deep-orange-50-bg\': beneficiario.trasferimento === 1}\"><td\n md-cell style=\"text-align:center;padding-right:4px\" ng-if=\"beneficiario.tipo==\'B\'\"><b>BENEFICIARIO</b></td><td \nmd-cell style=\"text-align:center;padding-right:4px\" ng-if=\"beneficiario.tipo==\'S\'\"><b>SEGNALATO</b></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\"><div layout=\"row\"><span>\n{{beneficiario.cognome|uppercase}}</span> <span class=\"red-700-fg s14\" ng-if=\"(beneficiario.idVulnerabilita > 0)\">\n&nbsp;(V)</span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">\n{{beneficiario.nome|uppercase}}</td><td md-cell style=\"padding-right:8px\" \nng-repeat=\"nazione in vm.nazioni| filter: {id:beneficiario.codNazionalita}\"><span><small>{{ nazione.descrizione}}\n</small></span></td><td md-cell style=\"padding-right:8px\">{{beneficiario.dataNascita| date : \"dd/MM/yyyy\"}}</td><td \nmd-cell style=\"text-align:center;padding-right:4px\"><b>{{beneficiario.sesso}}</b></td><td md-cell \nstyle=\"text-align:right;padding-right:8px\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-if=\"beneficiario.def == 1 && beneficiario.tipo==\'B\'\"><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiario({id:beneficiario.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\">\n</md-icon><span>Apri beneficiario</span></md-button></md-menu-item><md-menu-item \nng-if=\"beneficiario.def == 0 && beneficiario.tipo==\'B\'\"><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiarioi({id:beneficiario.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\">\n</md-icon><span>Apri beneficiario</span></md-button></md-menu-item><md-menu-item ng-if=\"beneficiario.tipo==\'S\'\">\n<md-button aria-label=\"View Detailed\" ng-click=\"vm.dettaglisegnalato(beneficiario.id)\"><md-icon \nmd-font-icon=\"icon-human-child\"></md-icon><span>Dettagli segnalato</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/contatti/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Ricerca Persone</span></div></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"CONTACTS.BACK\">Back</span></md-button>\n</div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{vm.selectedContacts.length}}</span> <span translate=\"CONTACTS.SELECTED\">selected</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectContacts()\" translate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll>\n<md-list class=\"contacts-list\"><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\">\n<md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" \nng-model=\"vm.search2\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.searchServerNome(vm.search2)\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-button \nng-click=\"vm.searchServerNome(vm.search)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small>\n</md-button><md-button ng-click=\"vm.allFields = !vm.allFields\"><small>Ricerca avanzata</small><md-icon \nng-if=\"!vm.allFields\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"vm.allFields\" \nmd-font-icon=\"icon-chevron-up\"></md-icon><md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata\n</md-tooltip></md-button></div></div><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.search2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>Parola chiave: {{vm.search2| uppercase}} \n</span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex \nng-if=\"vm.allFields\"><md-input-container flex><label>Regione residenza</label><md-select \nng-model=\"vm.ricerca[\'istats-regione\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option>\n<md-option ng-repeat=\"regione in vm.regiones\" value=\"{{regione.regione}}\">{{regione.regione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Con progetti</label><md-select \nng-model=\"vm.ricerca[\'progettos-id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option>\n<md-option value=\">1\">Si</md-option></md-select></md-input-container><md-input-container flex><label>Con enti</label>\n<md-select ng-model=\"vm.ricerca[\'entes-id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option>\n<md-option value=\">1\">Si</md-option></md-select></md-input-container><md-button \nng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small></md-button></div><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span>Risultati: </span><span>:</span> </span>\n<span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>{{vm.meta.pageCount}}</span> <span>di\n</span> <span>{{vm.meta.totalCount}}</span></span></div><div class=\"pager\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button disabled\" aria-label=\"previous page\" translate \ntranslate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" ng-click=\"vm.pager(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"next page\" translate translate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" \nng-click=\"vm.pager(vm.links.next.href)\" ng-if=\"vm.links.next.href\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" layout=\"row\"><div \nclass=\"secondary-text padding-8 align-vertical-middle\" flex=\"15\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'cognome\', ((vm.listOrderAsc) ? \'-\' : \'\'));\"></md-icon></a><strong>COGNOME</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"15\"><strong>NOME</strong></div><div class=\"secondary-text padding-8\" flex=\"5\">\n<strong>SESSO</strong></div><div class=\"secondary-text padding-8\" flex=\"20\"><strong>RESIDENZA</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"20\"><strong>RECAPITI</strong></div><div class=\"secondary-text padding-8\" \nflex=\"25\"><strong>COLLEGAMENTI</strong></div></div><md-list-item class=\"contact-item md-white-bg h-120\" md-ink-ripple \nng-repeat=\"contact in vm.contacts| filter: vm.search track by contact.id \" ng-click=\"vm.gotoDettaglio(contact.id)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 120+\'px, 0px)\', \'z-index\': vm.contacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><div flex=\"15\"><span \nclass=\"secondary-text light-blue-900-fg font-weight-600 line-height-12\">{{ contact.cognome | uppercase}}</span></div>\n<div flex=\"15\"><span class=\"secondary-text light-blue-900-fg font-weight-600 line-height-12\">\n{{ contact.nome | uppercase}}</span></div><div flex=\"5\"><md-icon md-font-icon=\"icon-gender-female\" \nng-if=\"contact.sesso == \'F\'\"></md-icon><md-icon md-font-icon=\"icon-gender-male\" ng-if=\"contact.sesso == \'M\'\"></md-icon>\n</div><div flex=\"20\"><dl class=\"text-truncate\"><dd class=\"line-height-12\"><span class=\"text-boxed\">\n{{contact.residenza.provincia| uppercase}}</span></dd><dd class=\"line-height-12\"><span class=\"text-boxed\">\n{{contact.residenza.comune}}</span></dd></dl></div><div flex=\"20\"><dl class=\"text-truncate\"><dd class=\"line-height-12\">\n<span class=\"text-boxed\">{{contact.email}}</span></dd><dd class=\"line-height-12\"><span class=\"text-boxed\">\n{{contact.telefono}}</span></dd></dl></div><div flex=\"20\"><span class=\"text-boxed md-primary-bg\"><small><b>PROGETTI: \n</b></small></span><small><b>{{contact.personahasprogettos.length}}</b></small> <span class=\"text-boxed md-primary-bg\">\n<small><b>ENTI: </b></small></span><small><b>{{contact.personahasentes.length}}</b></small></div></md-list-item>\n</md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"!vm.meta.totalCount\"><p>Nessun risultato...</p>\n</md-list-item></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.gotoDettaglio(0)\" aria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/documenti/documento.html","<div id=\"documento\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Documenti</span></div></div></div><div class=\"main\" \nms-scroll><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"80\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei files\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex>\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n</div></div></div></div></div>");
$templateCache.put("app/main/sprardb/cruscottooperatori/cruscotto.html","<div id=\"cruscotto\" class=\"monitoraggio page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Cruscotto beneficiari per {{vm.progetto.nome}}</span></div></div>\n</div><div class=\"content\"><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\">\n<span>Beneficiari presenti</span></div></md-toolbar><md-table-container class=\"pl-16 pr-16 pb-16\"><table data-md-table \nmd-progress=\"vm.beneficiari.$promise\"><thead md-head><tr md-row><th md-column>N. presenti</th><th md-column>\nN. presenti incompleti</th><th md-column>Totale</th></tr></thead><tbody md-body><tr md-row><td md-cell><b>\n{{vm.totPresenti}}</b></td><td md-cell><b>{{vm.totPresentiIncompleti}}</b></td><td md-cell><b>\n{{vm.totPresenti + vm.totPresentiIncompleti}}</b></td></tr></tbody></table></md-table-container></md-card><md-card \nstyle=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>Beneficiari Presenti incompleti</span> <span \nng-if=\"vm.totalCountIncompleti \">Totale: {{vm.totalCountIncompleti}}</span></div></md-toolbar><md-table-container \nclass=\"pl-16 pr-16 pb-16\" style=\"text-align: left !important\"><table data-md-table \nmd-progress=\"vm.beneficiariIncompleti.$promise\" style=\"text-align: left !important\"><thead md-head \nstyle=\"text-align: left !important\"><tr md-row><th md-column>Nome</th><th md-column>Cognome</th><th md-column>Sesso\n</th><th md-column>Data Di Nascita</th><th md-column>Progetto</th><th md-column></th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"item in vm.beneficiariIncompleti.data\"><td md-cell><b>{{item.nome}}</b></td><td md-cell><b>\n{{item.cognome}}</b></td><td md-cell><b>{{item.sesso}}</b></td><td md-cell><b>{{item.dataNascita|date:\"dd/MM/yyyy\"}}\n</b></td><td md-cell><b>{{item.progetto.nome}}</b></td><td md-cell><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiarioi({id:item.id})\"><span>Apri beneficiario</span></md-button></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.paginationIncompleti[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.paginationIncompleti.page\" md-total=\"{{vm.totalCountIncompleti}}\" \nmd-on-paginate=\"vm.loadBeneficiariIncompleti\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-card \nstyle=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>\nBeneficiari non titolati a permanere in accoglienza entro 30 giorni</span> <span ng-if=\"vm.totalCountInScadenza \">\nTotale: {{vm.totalCountInScadenza}}</span></div></md-toolbar><md-table-container class=\"pl-16 pr-16 pb-16\" \nstyle=\"text-align: left !important\"><table data-md-table md-progress=\"vm.beneficiariInScadenza.$promise\" \nstyle=\"text-align: left !important\"><thead md-head style=\"text-align: left !important\"><tr md-row><th md-column>Codice\n</th><th md-column>Nome</th><th md-column>Cognome</th><th md-column>Sesso</th><th md-column>Data Di Nascita</th><th \nmd-column>Data Fine Accoglienza</th><th md-column>Progetto</th><th md-column></th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"item in vm.beneficiariInScadenza.data\"><td md-cell><b>{{item.codice}}</b></td><td md-cell><b>\n{{item.nome}}</b></td><td md-cell><b>{{item.cognome}}</b></td><td md-cell><b>{{item.sesso}}</b></td><td md-cell><b>\n{{item.dataNascita|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>{{item.dataFine|date:\"dd/MM/yyyy\"}}</b></td><td md-cell>\n<b>{{item.progetto.nome}}</b></td><td md-cell><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_beneficiario({id:item.id})\" ng-if=\"item.def == 0\"><span>Apri beneficiario</span></md-button>\n<md-button aria-label=\"Dettaglio\" ui-sref=\"app.sprardb_beneficiarioi({id:item.id})\" ng-if=\"item.def == 1\"><span>\nApri beneficiario</span></md-button></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.paginationInScadenza[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.paginationInScadenza.page\" \nmd-total=\"{{vm.totalCountInScadenza}}\" md-on-paginate=\"vm.loadBeneficiariInScadenza\" md-boundary-links=\"true\" \nmd-page-select=\"true\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination>\n</md-card><md-card style=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>Beneficiari non titolati a permanere in accoglienza\n</span> <span ng-if=\"vm.totalCountScaduti \">Totale: {{vm.totalCountScaduti}}</span></div></md-toolbar>\n<md-table-container class=\"pl-16 pr-16 pb-16\" style=\"text-align: left !important\"><table data-md-table \nmd-progress=\"vm.beneficiariScaduti.$promise\" style=\"text-align: left !important\"><thead md-head \nstyle=\"text-align: left !important\"><tr md-row><th md-column>Codice</th><th md-column>Nome</th><th md-column>Cognome\n</th><th md-column>Sesso</th><th md-column>Data Di Nascita</th><th md-column>Data Fine Accoglienza</th><th md-column>\nProgetto</th><th md-column></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.beneficiariScaduti.data\">\n<td md-cell><b>{{item.codice}}</b></td><td md-cell><b>{{item.nome}}</b></td><td md-cell><b>{{item.cognome}}</b></td><td\n md-cell><b>{{item.sesso}}</b></td><td md-cell><b>{{item.dataNascita|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{item.dataFine|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>{{item.progetto.nome}}</b></td><td md-cell><md-button \naria-label=\"Dettaglio\" ui-sref=\"app.sprardb_beneficiario({id:item.id})\" ng-if=\"item.def == 0\"><span>Apri beneficiario\n</span></md-button><md-button aria-label=\"Dettaglio\" ui-sref=\"app.sprardb_beneficiarioi({id:item.id})\" \nng-if=\"item.def == 1\"><span>Apri beneficiario</span></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.paginationScaduti[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" \nmd-page=\"vm.paginationScaduti.page\" md-total=\"{{vm.totalCountScaduti}}\" md-on-paginate=\"vm.loadBeneficiariScaduti\" \nmd-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-card \nstyle=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>Proroghe in bozza da completare</span> <span \nng-if=\"vm.totalCountProrogheCompletare \">Totale: {{vm.totalCountProrogheCompletare}}</span></div></md-toolbar>\n<md-table-container class=\"pl-16 pr-16 pb-16\" style=\"text-align: left !important\"><table data-md-table \nmd-progress=\"vm.prorogheDaCompletare.$promise\" style=\"text-align: left !important\"><thead md-head \nstyle=\"text-align: left !important\"><tr md-row><th md-column>Codice</th><th md-column>Nome</th><th md-column>Cognome\n</th><th md-column>Sesso</th><th md-column>Data Di Nascita</th><th md-column>Data Fine Accoglienza</th><th md-column>\nProgetto</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.prorogheDaCompletare.data\"><td md-cell><b>\n{{item.codice}}</b></td><td md-cell><b>{{item.nome}}</b></td><td md-cell><b>{{item.cognome}}</b></td><td md-cell><b>\n{{item.sesso}}</b></td><td md-cell><b>{{item.dataNascita|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{item.dataFine|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>{{item.progetto.nome}}</b></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.paginationProrogheCompletare[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.paginationProrogheCompletare.page\" \nmd-total=\"{{vm.totalCountProrogheCompletare}}\" md-on-paginate=\"vm.loadProrogheDaCompletare\" md-boundary-links=\"true\" \nmd-page-select=\"true\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination>\n</md-card><md-card style=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>\nProroghe in attesa di lavorazione da parte del Servizio Centrale</span> <span ng-if=\"vm.totalCountProrogheLavorare\">\nTotale: {{vm.totalCountProrogheLavorare}}</span></div></md-toolbar><md-table-container class=\"pl-16 pr-16 pb-16\" \nstyle=\"text-align: left !important\"><table data-md-table md-progress=\"vm.prorogheDaLavorare.$promise\" \nstyle=\"text-align: left !important\"><thead md-head style=\"text-align: left !important\"><tr md-row><th md-column>Codice\n</th><th md-column>Nome</th><th md-column>Cognome</th><th md-column>Sesso</th><th md-column>Data Di Nascita</th><th \nmd-column>Data Fine Accoglienza</th><th md-column>Progetto</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.prorogheDaLavorare.data\"><td md-cell><b>{{item.codice}}</b></td><td md-cell><b>{{item.nome}}</b>\n</td><td md-cell><b>{{item.cognome}}</b></td><td md-cell><b>{{item.sesso}}</b></td><td md-cell><b>\n{{item.dataNascita|date:\"dd/MM/yyyy\"}}</b></td><td md-cell><b>{{item.dataFine|date:\"dd/MM/yyyy\"}}</b></td><td md-cell>\n<b>{{item.progetto.nome}}</b></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.paginationProrogheLavorare[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" \nmd-page=\"vm.paginationProrogheLavorare.page\" md-total=\"{{vm.totalCountProrogheLavorare}}\" \nmd-on-paginate=\"vm.loadProrogheDaLavorare\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-card \nstyle=\"padding-top:0px;padding-bottom:32px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools row layout-align-space-between\"><span>Strutture attive nel progetto</span> <small \nng-if=\"vm.countStrutture\">Nr. strutture attive {{vm.totalCountStrutture}}</small> <small ng-if=\"vm.countStrutture\">\nTotale Posti Attivi: {{vm.countStrutture.postiTotali}}</small> <small ng-if=\"vm.countStrutture\">\nTotale Posti Occupati: {{vm.countStrutture.postiOccupati}}</small></div></md-toolbar><md-table-container \nclass=\"pl-16 pr-16 pb-16\" style=\"text-align: left !important\"><table data-md-table md-progress=\"vm.strutture.$promise\" \nstyle=\"text-align: left !important\"><thead md-head style=\"text-align: left !important\"><tr md-row><th md-column>id</th>\n<th md-column>Nome struttura</th><th md-column>Nome progetto</th><th md-column>Numero posti Attivi</th><th md-column>\nNumero posti Occupati</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.strutture.data\"><td md-cell><b>\n{{item.id}}</b></td><td md-cell><b>{{item.nome}}</b></td><td md-cell><b>{{item.progetto.nome}}</b></td><td md-cell><b>\n{{item.numeroPosti}}</b></td><td md-cell><b>{{item.numeroBeneficiariPresenti}}</b></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.struttureProgetto[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" \nmd-page=\"vm.struttureProgetto.page\" md-total=\"{{vm.totalCountStrutture}}\" md-on-paginate=\"vm.loadStrutture\" \nmd-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>");
$templateCache.put("app/main/sprardb/cruscottooperatori/search-form.html","<div layout=\"column\"><md-input-container flex style=\"max-height: 70px\"><label>Progetto</label><md-select \nng-model=\"fc.progetto\" placeholder=\"Scegliere progetto...\" required ng-change=\"fc.cambiaProgetto()\"><md-option \nng-repeat=\"php in fc.listaProgetti\" ng-value=\"php.progetto\"><div layout=\"column\"><b>\n{{php.progetto.nome|uppercase|unique:\"progetto.id\"}}</b></div></md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/sprardb/enti/enti.html","<div id=\"entisegnalatori\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/enti/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Enti</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca per nome\" type=\"text\" ng-model=\"vm.ricerca.nome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.loadEnti()\"></md-input-container><md-input-container flex><label>Ruolo Ente</label><md-select \nng-model=\"vm.ricerca.ruolo\" ng-change=\"vm.loadEnti()\" multiple=\"true\"><md-option ng-value=\"enteruolo\" \nng-repeat=\"enteruolo in vm.ricercaApi.enteruoloprogettos\"><b><small>{{ enteruolo[vm.displayLabel(\'ruolo\')]|uppercase }}\n</small></b></md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-button ng-click=\"vm.loadEnti()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small>\n</md-button><md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip \nmd-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\" layout-wrap><span class=\"mr-5\">Ricerca Enti</span> <span \nng-repeat=\"chip in vm.filterChips\" class=\"text-boxed\" style=\"margin: 2px\"><i class=\"icon-delete s16\" \nng-click=\"vm.deletefiltersearch(chip)\"></i> {{chip.key | uppercase}}: {{chip.value}}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.loadEnti()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.entes\" multiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th \nmd-column md-order-by=\"enteTipo_id\">TIPO</th><th md-column md-order-by=\"nome\">NOME</th><th md-column \nmd-order-by=\"codComune\"><span>CITTA</span></th><th md-column md-order-by=\"email\">RECAPITI</th><th md-column \nmd-order-by=\"attivo\" style=\"text-align: center\">ATTIVO</th><th md-column style=\"text-align: center\" \nng-if=\"!vm.isReadOnly\">PROGETTO/RUOLO</th><th md-column style=\"text-align: center\" ng-if=\"!vm.isVisitatore\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row md-select=\"item\" ng-disabled=\"item.attivo == 0\" \ndata-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.enti\"><td md-cell>{{item.id}}</td><td md-cell><md-button \nclass=\"md-fab md-mini {{vm.colors[item.enteTipo_id]}}\" aria-label=\"tipos\">{{item.entetipo.descrizione|limitTo: 1}}\n<md-tooltip><span>{{item.entetipo.descrizione}}</span></md-tooltip></md-button></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.istats.comune| uppercase}}</b><br>{{item.istats.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:20}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: center\"><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"!item.attivo\">\n</md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"item.attivo\"></md-icon></td><td md-cell \nstyle=\"text-align: center\"><div layout=\"column\"><span layout=\"column\" \nng-repeat=\"pe in item.progettohasentes | filter: vm.filtraRuoli\"><small><b>{{pe.progetto.nome|uppercase}}</b></small> \n<small>{{pe.ruolo|uppercase}}</small> </span><span ng-if=\"item.progettohasentes.length == 0\">N/A</span></div></td><td \nmd-cell style=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item><md-button class=\"md-accent md-button-icon md-button-small\" \naria-label=\"View Detailed\" ng-click=\"vm.gotoDettaglio(item)\"><i class=\"icon-arrow-right\"></i> <span>Dettaglio Ente\n</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isReadOnly\"><md-button aria-label=\"Visualizza tags\" \nng-click=\"vm.viewtags(item.tags, [\'generico\'])\"><md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>\nVisualizza tags</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isReadOnly\"><md-button \naria-label=\"Visualizza lista\" ng-click=\"vm.viewtags(item.tags, [\'listaente\'])\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza lista</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.search[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.loadEnti\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.nuovoEnte()\" aria-label=\"add contact\" \ntranslate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/sprardb/entisegnalatori/entisegnalatori.html","<div id=\"entisegnalatori\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Enti Segnalatori</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca negli enti segnalatori\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca Enti Segnalatori</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex><span\n class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\';vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"(key != \'operatore\' && key != \'segnalatore\')\">\n<md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\" \naria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar \nclass=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'Segnalatori selezionati\' : \'Segnalatore selezionato\'}} :</span><div \nflex></div><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" ng-click=\"vm.attivaente(vm.selected)\">\n<i class=\"icon-check-bookmark s16\"></i> ATTIVA ENTE</md-button><md-button class=\"md-button\" \nstyle=\"color: rgba(255, 255, 255, 0.87)\" ng-click=\"vm.spediscicodice(vm.selected)\"><i class=\"icon-email-secure s16\">\n</i> SPEDISCI CODICE SEGNALATORE</md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"enteTipo_id\">\nTIPO</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\"><span>CITTA</span></th><th \nmd-column md-order-by=\"email\">RECAPITI</th><th md-column md-order-by=\"attivo\" style=\"text-align: center\">ATT</th><th \nmd-column style=\"text-align: center\">CODICE</th><th md-column style=\"text-align: center\">SEGNALATORI</th><th md-column \nstyle=\"text-align: center\" ng-if=\"!vm.api.isReadOnly\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"item\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell>\n<md-button class=\"md-fab md-mini {{vm.colors[item.enteTipo_id]}}\" aria-label=\"tipos\">\n{{item.entetipo.descrizione|limitTo: 1}}<md-tooltip><span>{{item.entetipo.descrizione}}</span></md-tooltip></md-button>\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.istats.comune| uppercase}}</b><br>{{item.istats.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:12}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: left\"><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"!item.attivo\">\n</md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"item.attivo\"></md-icon></td><td md-cell \nstyle=\"text-align: center\"><b>{{ item.codiceSegnalatore}}</b></td><td md-cell style=\"text-align: center\">\n{{(item.personahasentes| filter: {personaRuolo_id: 26}).length}}</td><td md-cell \nstyle=\"text-align: right; padding-right: 0px\" ng-if=\"!vm.api.isReadOnly\"><div layout=\"row\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"ApriEnteSegnalatore\" \nui-sref=\"app.sprardb_entisegnalatori_dettaglio({id:item.id})\"><md-icon md-font-icon=\"icon-sign-caution\"></md-icon>\n<span>Apri ente segnalatore</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.api.isReadOnly\"><md-button \naria-label=\"VisualizzaSegnalatori\" \nui-sref=\"app.sprardb_segnalatorifiltra({parametro: \'personahasentes-ente_id\', valore: item.id})\"><md-icon \nmd-font-icon=\"icon-human-child\"></md-icon><span>Visualizza Segnalatori</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.api.isReadOnly\"><md-button aria-label=\"Visualizza tags\" ng-click=\"vm.attivaente(item)\"><md-icon \nmd-font-icon=\"icon-check-bookmark\"></md-icon><span>Attiva Ente</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.api.isReadOnly\"><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.spediscicodice(item)\"><md-icon \nmd-font-icon=\"icon-email-secure\"></md-icon><span>Spedisci Codice</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.aggiungientes()\" aria-label=\"addnew\" ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>INSERIRE NUOVO ENTE SEGNALATORE</md-tooltip></md-button></div></div>\n</div>");
$templateCache.put("app/main/sprardb/eventi/eventi.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Codice</b></small> <input id=\"search\" placeholder=\"Codice\" type=\"text\" \nng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"column\" layout-align=\"space-between center\" \nflex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Cognome</b></small>\n <input id=\"search\" placeholder=\"Cognome\" type=\"text\" ng-model=\"vm.ricercaCognome\"></md-input-container></div><div \nlayout=\"column\" layout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small>\n<b class=\"ng-binding\">Ricerca per Nome</b></small> <input id=\"search\" placeholder=\"Nome\" type=\"text\" \nng-model=\"vm.ricercaNome\"></md-input-container></div><div layout=\"column\" flex=\"20\"><md-autocomplete \nmd-floating-label=\"Progetti\" md-no-cache=\"1\" md-selected-item=\"vm.ricercaProgetti\" \nmd-search-text-change=\"vm.cercaProgetti(vm.progettoSearch)\" md-search-text=\"vm.progettoSearch\" \nmd-selected-item-change=\"vm.onSearch()\" md-items=\"progetto in vm.progetti.$promise\" md-item-text=\"progetto.nome\" \nmd-min-length=\"3\" ng-model-options=\"{debounce: 200}\" name=\"progettoNome\"><md-item-template><span \nmd-highlight-text=\"vm.progettoSearch\" md-highlight-flags=\"i\">{{progetto.nome}}</span></md-item-template>\n</md-autocomplete></div><div layout=\"row\" layout-align=\"space-between center\" flex><md-button ng-click=\"vm.onSearch()\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>{{vm.title}}</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key !== \'beneficiarios-cancellato_IN\' && key != \'def\' && key !== \'eventoTipo_id_IN\' && key !== \'eventoTipo_id\')\">\n<md-icon name=\"{{key}}\" class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\">\n<div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalati selezionati\' : \'segnalato selezionato\'}} :</span><div \nflex></div><md-button class=\"md-button {{vm.colors[4]}}\" aria-label=\"rsc\" ng-click=\"vm.accettaMultipli(vm.selected)\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>\nACCETTA I SELEZIONATI</md-button><md-button class=\"md-button {{vm.colors[5]}}\" aria-label=\"rsc\" \nng-click=\"vm.rifiutaMultipli(vm.selected)\" ng-disabled=\"(vm.selected.length == 0)\"><md-icon \nmd-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>RIFIUTA I SELEZIONATI</md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\"><span>Cod</span></th><th md-column style=\"text-align: center\">STATO</th><th md-column \nmd-order-by=\"\">COGNOME</th><th md-column md-order-by=\"\">NOME</th><th md-column md-order-by=\"\">NAZIONALITA<br>NASCITA\n</th><th md-column md-order-by=\"\">ENTE SEGN.</th><th md-column md-order-by=\"\">PROGETTO</th><th md-column \nmd-order-by=\"dataInizio\">DATE</th><th md-column md-order-by=\"\">OM</th><th md-column md-order-by=\"\">NUCLEO</th><th \nmd-column>Id Capof.</th><th md-column md-order-by=\"\" style=\"text-align: center\">PROCESSO</th><th md-column \nmd-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead><tbody md-body><tr md-row md-select=\"segnalato\" \nmd-select-id=\"segnalato\" \nng-disabled=\"(segnalato.eventoStato.id == 4 || segnalato.eventoStato.id == 5) || segnalato.entita1.omonimoRisolto == 0\" \ndata-md-on-select=\"segnalato.entita1.omonimoRisolto != 0\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"segnalato in vm.eventos\" \nclass=\"{{(segnalato.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\" ng-if=\"vm.mostras(segnalato)\"><td md-cell>\n<div layout=\"column\"><span>{{segnalato.id}}.{{segnalato.entita1.id}}</span> <span \nng-if=\"segnalato.entita1.beneficiario_id != 0 && segnalato.eventoStato_id == 4\"><small><b>ACCETTATO</b></small></span> \n<span ng-if=\"segnalato.eventoStato_id == 5 && segnalato.extra.tipoRifiuto == 1\"><small><b>RIFIUTATO SC</b></small>\n</span> <span ng-if=\"segnalato.eventoStato_id == 5 && segnalato.extra.tipoRifiuto == 2\"><small><b>RIFIUTATO OMONIMIA\n</b></small></span></div></td><td md-cell><div layout=\"row\"><md-button \nclass=\"md-fab md-mini {{vm.colors[segnalato.eventoStato_id]}}\" aria-label=\"status\">{{segnalato.eventoStato.iniziali}}\n<md-tooltip><b>{{segnalato.eventoStato.stato|uppercase}}</b> // {{segnalato.eventoTipo.nome}}</md-tooltip></md-button>\n</div></td><td md-cell><div layout=\"row\"><span><b>{{segnalato.entita1.cognome|uppercase}}</b></span> <span \nclass=\"red-700-fg s14\" ng-if=\"(segnalato.entita1.idVulnerabilita > 0)\">&nbsp;(V)</span></div></td><td md-cell><b>\n{{segnalato.entita1.nome|uppercase}}</b></td><td md-cell><div layout=\"column\"><span><b>\n{{segnalato.entita1.nazionalita.descrizione}}</b></span> <span>{{segnalato.entita1.dataNascita| date : \"dd/MM/y\"}}\n</span></div></td><td md-cell><div layout=\"column\"><span><b>\n{{segnalato.entita1.segnalazione.modellos.descrizione|uppercase}}</b></span> <span>\n{{segnalato.entita1.segnalazione.data|date:\"dd/MM/yyyy\"}}</span> <span><b>\n{{segnalato.entita1.segnalazione.entes.nome|uppercase}}</b></span></div></td><td md-cell><div layout=\"column\"><small \nng-if=\"(segnalato.entita1.progetto_id > 0)\"><b>{{segnalato.entita1.progetto.nome|uppercase}}</b></small> <small \nng-if=\"(segnalato.entita1.progetto_id == 0)\">N/A</small> <small ng-if=\"(segnalato.entita1.struttura_id > 0)\">\n{{segnalato.entita1.strutturas.nome|uppercase}}</small></div></td><td md-cell><div layout=\"column\"><div layout=\"row\">\n<b>{{segnalato.dataInizio|date:\"dd/MM/yyyy\"}}</b></div><div layout=\"row\">{{segnalato.dataFine|date:\"dd/MM/yyyy\"}}</div>\n<div layout=\"row\" ng-if=\"(segnalato.dataFine == null)\"><small>NON LAVORATO</small></div></div></td><td md-cell><md-icon\n md-font-icon=\"icon-checkbox-marked\" class=\"green-600-fg s16\" ng-if=\"(segnalato.entita1.omonimoRisolto === -1)\">\n</md-icon><md-icon md-font-icon=\"icon-alert-box\" class=\"red-700-fg s16\" \nng-if=\"(segnalato.entita1.omonimoRisolto === 0)\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" \nclass=\"grey-500-fg s16\" ng-if=\"(segnalato.entita1.omonimoRisolto === 1)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"grey-500-fg s16\" ng-if=\"(segnalato.entita1.omonimoRisolto === 2)\"></md-icon>\n</td><td md-cell><div layout=\"column\"><i class=\"icon-account-multiple-outline\" \nng-if=\"(segnalato.entita1.nucleoFamiliare === 1)\"><md-tooltip>{{segnalato.entita1.parentelaTipo.descrizione}}\n</md-tooltip></i><small ng-if=\"(segnalato.entita1.nucleoFamiliare === 0)\"><b>MONOPAREN.</b></small> <small \nng-if=\"(segnalato.entita1.nucleoFamiliare === 2)\"><b>NON SA</b></small></div></td><td md-cell><div layout=\"column\" \nng-if=\"segnalato.entita1.capof_id > 0\"><small><b>{{segnalato.entita1.capof_id}}</b></small></div></td><td md-cell><div \nlayout=\"row\" \nng-if=\"(segnalato.entita1.omonimoRisolto === 1 || segnalato.entita1.omonimoRisolto === -1 || segnalato.entita1.omonimoRisolto === 2) && !vm.segCessato && segnalato.eventoStato_id == 1 && vm.canLavoraSegnalato(segnalato.entita1)\" \nlayout-align=\"end center\"><md-button aria-label=\"Nuovo Inserimento\" ng-click=\"vm.nuovoinserimento(segnalato)\" \nclass=\"md-button-small md-light-green-500-bg\"><div layout=\"column\" layout-align=\"center\"><md-icon \nmd-font-icon=\"icon-human-child\"></md-icon><small><small>Accetta</small></small></div></md-button><md-button \naria-label=\"Rifiuta segnalato\" ng-click=\"vm.rifiutasegnalato(segnalato)\" class=\"md-button-small md-red-900-bg\"><div \nlayout=\"column\" layout-align=\"center\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><small><small>Rifiuta</small>\n</small></div></md-button></div><div layout=\"row\" \nng-if=\"segnalato.entita1.omonimoRisolto == 0 && vm.canLavoraSegnalato(segnalato.entita1) && !vm.segCessato && segnalato.eventoStato_id == 1\">\n<md-button class=\"md-button-small-x2 md-amber-200-bg\" aria-label=\"nessuno\" ng-click=\"vm.omonimi(segnalato.entita1)\">\n<small>OMONIMIA</small></md-button></div></td><td md-cell style=\"text-align: center\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"View Detailed\" \nng-click=\"vm.dettaglisegnalato(segnalato)\"><md-icon md-font-icon=\"icon-human-child\"></md-icon><span>Dettagli</span>\n</md-button></md-menu-item><md-divider></md-divider><md-menu-item \nng-if=\"vm.api.isAdmin && (segnalato.eventoStato.id == 1 || segnalato.eventoStato.id == 2) && (segnalato.eventoTipo_id == 1002 || segnalato.eventoTipo_id == 1003)\">\n<md-button class=\"md-warn md-button-icon\" ng-click=\"vm.trashSegnalato($event, segnalato)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Elimina</span></md-button></md-menu-item></md-menu-content></md-menu></td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/eventi/eventiben.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\">\n<md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Codice</b></small> <input \nid=\"search\" placeholder=\"Codice\" type=\"text\" ng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricercaCognome\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Nome</b></small> \n<input id=\"search\" placeholder=\"Nome\" type=\"text\" ng-model=\"vm.ricercaNome\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div></div><md-card \nstyle=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>{{vm.title}}</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key != \'def\' && key !== \'eventoTipo_id_IN\' && key !== \'eventoTipo_id\' && key != \'beneficiarios-cancellato_IN\')\">\n<md-icon name=\"{{key}}\" class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" \nstyle=\"padding-left:0px\"><span>Cod</span></th><th md-column md-order-by=\"\" ng-if=\"vm.segEnte\">ENTE SEGN.</th><th \nmd-column style=\"text-align: center\">STATO</th><th md-column md-order-by=\"dataInizio\">DATE</th><th md-column \nmd-order-by=\"\">COGNOME</th><th md-column md-order-by=\"\">NOME</th><th md-column md-order-by=\"\">DATA NASCITA</th><th \nmd-column md-order-by=\"\">NAZIONALITÀ</th><th md-column md-order-by=\"\">R</th><th md-column ng-if=\"vm.benProroga\" \nmd-order-by=\"entita1-dataFine\">DATA FINE</th><th md-column md-order-by=\"\">PROGETTO</th><th md-column md-order-by=\"\" \nstyle=\"text-align: center\">PROCESSO</th><th md-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead>\n<tbody md-body><tr md-row ng-repeat=\"segnalato in vm.eventos\"><td md-cell style=\"padding-left:0px;padding-right:4px\">\n<div layout=\"column\"><span>{{segnalato.entita1.codice}}</span></div></td><td md-cell ng-if=\"vm.segEnte\" \nstyle=\"padding-right:4px\"><div class=\"column\"><div class=\"row\"><small><b>\n{{segnalato.entita1.segnalaziones.entes.nome|uppercase}}</b></small></div><div class=\"row\"><small>\nMODELLO {{segnalato.entita1.segnalaziones.tipo|uppercase}}</small></div></div></td><td md-cell \nstyle=\"padding-right:4px\"><div layout=\"row\"><md-button class=\"md-fab md-mini {{vm.colors[segnalato.eventoStato_id]}}\" \naria-label=\"status\">{{segnalato.eventoStato.iniziali}}<md-tooltip><b>{{segnalato.eventoStato.stato|uppercase}}</b>\n // {{segnalato.eventoTipo.nome}}</md-tooltip></md-button></div></td><td md-cell style=\"padding-right:4px\"><div \nlayout=\"column\"><div layout=\"row\"><b>{{segnalato.dataInizio| date : \"dd/MM/yyyy\"}}</b></div><div layout=\"row\">\n{{segnalato.dataFine| date : \"dd/MM/yyyy\"}}</div><div layout=\"row\" ng-if=\"(segnalato.dataFine == null)\"><small>\nNON LAVORATO</small></div></div></td><td md-cell style=\"padding-right:4px\"><b>{{segnalato.entita1.cognome|uppercase}}\n</b></td><td md-cell style=\"padding-right:4px\"><b>{{segnalato.entita1.nome|uppercase}}</b></td><td md-cell \nstyle=\"padding-right:4px\">{{segnalato.entita1.dataNascita| date : \"dd/MM/y\"}}</td><td md-cell>\n{{segnalato.entita1.nazionalita.descrizione}}</td><td md-cell style=\"padding-right:4px\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-600-fg s16\" ng-if=\"(segnalato.entita1.reinserimento == 0)\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" class=\"red-700-fg s16\" ng-if=\"(segnalato.entita1.reinserimento > 0)\"></md-icon></td><td \nmd-cell ng-if=\"vm.benProroga\" style=\"padding-right:4px\">{{segnalato.entita1.dataFine| date : \"dd/MM/y\"}}</td><td \nmd-cell style=\"padding-right:4px\"><small><b>{{segnalato.entita1.progettos.nome|uppercase}}</b></small> <small \nng-if=\"(segnalato.entita1.progetto_id == 0)\">N/A</small></td><td md-cell style=\"text-align: center\"><div class=\"row\">\n<md-button ng-repeat=\"proc in segnalato.processi| filter: \'(\' + segnalato.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b1 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, segnalato, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{vm.isallowed(proc) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in segnalato.processi| filter: \'(END,\' + segnalato.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n</div></td><td md-cell style=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Extra\" ng-click=\"vm.viewPerson($event, segnalato, \'extra\')\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Extra</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, segnalato, \'evento\')\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><span>Evento</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, segnalato.entita1, \'beneficiario\')\"><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span>Beneficiario</span></md-button></md-menu-item><md-menu-item\n ng-if=\"segnalato.entita1.progetto_id > 0\"><md-button aria-label=\"Progetto\" \nng-click=\"vm.viewPerson($event, segnalato.entita1.progettos, \'progetto\')\"><md-icon md-font-icon=\"icon-apps\"></md-icon>\n<span>Progetto</span></md-button></md-menu-item><md-menu-item ng-if=\"segnalato.entita1.letteraInserimento > 0\">\n<md-button aria-label=\"Inserimento\" ng-click=\"vm.letteraIns($event, segnalato.entita1.segnalazione_id)\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"md-warn-fg\"></md-icon><span>Lettera Inserimento</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"(segnalato.entita1.trasferimento == 1)\"><md-button aria-label=\"LettTrasferimento\" \nng-click=\"vm.letteraTrasf($event, segnalato.entita1.letteratrasferimento_id)\" \nng-disabled=\"(segnalato.entita1.trasferimento == 0)\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"md-warn-fg\">\n</md-icon><span>Lettera Trasferimento</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/eventi/eventipro.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/eventi/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><md-input-container md-no-float class=\"m-0\" flex style=\"padding-top:20px\">\n<input id=\"search\" placeholder=\"Ricerca progetto\" type=\"text\" ng-model=\"vm.ricerca2\" ng-change=\"vm.onSearch()\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\">\n</md-input-container></div></div><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && key != \'def\' && key != \'beneficiarios-cancellato_IN\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><md-card><md-table-container>\n<table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.eventos\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"padding-left:0px\"><span>Cod</span></th><th\n md-column style=\"text-align: center\">TIPO</th><th md-column style=\"text-align: center\">STATO</th><th md-column \nmd-order-by=\"dataInizio\">DATE</th><th md-column md-order-by=\"\">PROGETTO</th><th md-column md-order-by=\"\">UBICAZIONE\n</th><th md-column md-order-by=\"\">RECAPITI</th><th md-column md-order-by=\"\" style=\"text-align: center\">PROCESSO</th><th\n md-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nmd-select-id=\"item\" ng-disabled=\"true\" data-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.eventos\" \nclass=\"{{(item.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\"><td md-cell \nstyle=\"padding-left:0px;padding-right:4px\">{{item.id}}</td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell>\n<md-button class=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">\n{{item.eventoStato.stato| limitTo:1 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><div layout=\"column\"><div layout=\"row\"><b>\n{{item.dataInizio}}</b></div><div layout=\"row\">{{item.dataFine}}</div><div layout=\"row\" \nng-if=\"(item.dataFine == null)\"><small>NON LAVORATO</small></div></div></td><td md-cell><b><small><b>\n{{item.entita1.nome|uppercase}}</b></small> <small ng-if=\"(item.entita1.id == 0)\">N/A</small></b></td><td md-cell><b>\n{{item.entita1.istat.regione|uppercase}}</b> - {{item.entita1.istat.provincia|uppercase}}<br>\n{{item.entita1.istat.comune|uppercase}}</td><td md-cell><a title=\"{{item.entita1.email}}\" \nhref=\"mailto:{{item.entita1.email}}\">{{item.entita1.email|limitTo:22}}...</a><br>{{item.entita1.telefono}}</td><td \nmd-cell style=\"text-align: center\"><div class=\"row\"><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\"><md-icon \nmd-font-icon=\"{{vm.icons[processo[1]]}} md-background-fg\" class=\"s18\"></md-icon><md-tooltip><span>\n{{processo[2]|uppercase}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n</div></td><td md-cell style=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Extra\" ng-click=\"vm.viewPerson($event, item, \'extra\')\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Extra</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, item.entita1, \'progetto\')\"><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span>Progetto</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"Segnalazione\" ng-click=\"vm.viewPerson($event, item, \'evento\')\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><span>Evento</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination><div class=\"row\" \nstyle=\"text-align: left\"><md-button class=\"md-button {{vm.colors[4]}}\" aria-label=\"rsc\" \nng-click=\"vm.work($event, vm.selected, 4, \'A\', false)\" ng-disabled=\"(vm.selected.length == 0)\"><md-icon \nmd-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>ACCETTA I SELEZIONATI</md-button><md-button \nclass=\"md-button {{vm.colors[5]}}\" aria-label=\"rsc\" ng-click=\"vm.work($event, vm.selected, 5, \'R\', false)\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>\nRIFIUTA I SELEZIONATI</md-button></div></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/eventi/eventisg.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/eventi/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><md-input-container md-no-float class=\"m-0\" flex style=\"padding-top:20px\">\n<input id=\"search\" placeholder=\"Ricerca segnalato (nome cognome segnalato)\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-change=\"vm.onSearch()\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\">\n</md-input-container></div></div><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && key != \'def\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\n{{vm.ricercalabel[key]}}{{ricercato}}</span></div><md-card><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"padding-left:0px\"><span>Cod</span></th><th\n md-column md-order-by=\"\">TIPO</th><th md-column style=\"text-align: center\">STATO</th><th md-column \nmd-order-by=\"dataInizio\">DATE</th><th md-column md-order-by=\"\">COGNOME</th><th md-column md-order-by=\"\">NOME</th><th \nmd-column md-order-by=\"\">NAZIONALITÀ</th><th md-column md-order-by=\"\">PROGETTO</th><th md-column md-order-by=\"\" \nstyle=\"text-align: center\">PROCESSO</th><th md-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"segnalato\" md-select-id=\"segnalato\" ng-disabled=\"true\" data-md-on-select=\"vm.log\" \nmd-on-deselect=\"vm.deselect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"segnalato in vm.eventos\" \nclass=\"{{(segnalato.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\"><td md-cell \nstyle=\"padding-left:0px;padding-right:4px\">{{segnalato.id}}</td><td md-cell><div class=\"row\"><small><b>\n{{segnalato.eventoTipo.nome}}</b></small></div></td><td md-cell><md-button \nclass=\"md-fab md-mini {{vm.colors[segnalato.eventoStato_id]}}\" aria-label=\"status\">\n{{segnalato.eventoStato.stato| limitTo:1 }}<md-tooltip><b>{{segnalato.eventoStato.stato|uppercase}}</b>\n // {{segnalato.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><div layout=\"column\"><div layout=\"row\"><b>\n{{segnalato.dataInizio}}</b></div><div layout=\"row\">{{segnalato.dataFine}}</div><div layout=\"row\" \nng-if=\"(segnalato.dataFine == null)\"><small>NON LAVORATO</small></div></div></td><td md-cell><b>\n{{segnalato.entita1.cognome|uppercase}}</b></td><td md-cell><b>{{segnalato.entita1.nome|uppercase}}</b></td><td \nmd-cell>{{segnalato.entita1.nazionalita.descrizione}}</td><td md-cell><small><b>\n{{segnalato.entita1.progettos.nome|uppercase}}</b></small> <small ng-if=\"(segnalato.entita1.progetto_id == 0)\">N/A\n</small></td><td md-cell style=\"text-align: center\"><div class=\"row\"><md-button \nng-repeat=\"proc in segnalato.processi| filter: \'(\' + segnalato.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, segnalato, processo[1], processo[2], false)\"><md-icon \nmd-font-icon=\"{{vm.icons[processo[1]]}} md-background-fg\" class=\"s18\"></md-icon><md-tooltip><span>\n{{processo[2]|uppercase}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in segnalato.processi| filter: \'(END,\' + segnalato.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n</div></td><td md-cell style=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Extra\" ng-click=\"vm.viewPerson($event, segnalato, \'extra\')\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Extra</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, segnalato.entita1, \'segnalato\')\"><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span>Segnalato</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"Segnalazione\" ng-click=\"vm.viewPerson($event, segnalato.entita1.segnalaziones, \'segnalazione\')\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><span>Segnalazione</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Lettera di segnalazione\" \nng-click=\"vm.letteraSeg($event, segnalato.entita1.segnalazione_id)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>\n<span>Lettera Segnalazione</span></md-button></md-menu-item><md-menu-item ng-if=\"segnalato.entita1.progetto_id > 0\">\n<md-button aria-label=\"Progetto\" ng-click=\"vm.viewPerson($event, segnalato.entita1.progettos, \'progetto\')\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon><span>Progetto</span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.entita1.letteraInserimento > 0\"><md-button aria-label=\"Inserimento\" \nng-click=\"vm.letteraIns($event, segnalato.entita1.segnalazione_id)\"><md-icon md-font-icon=\"icon-file-pdf\" \nclass=\"md-warn-fg\"></md-icon><span>Lettera Inserimento</span></md-button></md-menu-item></md-menu-content></md-menu>\n</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination><div class=\"row\" \nstyle=\"text-align: left\"><md-button class=\"md-button {{vm.colors[4]}}\" aria-label=\"rsc\" \nng-click=\"vm.work($event, vm.selected, 4, \'A\', false)\" ng-disabled=\"(vm.selected.length == 0)\"><md-icon \nmd-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>ACCETTA I SELEZIONATI</md-button><md-button \nclass=\"md-button {{vm.colors[5]}}\" aria-label=\"rsc\" ng-click=\"vm.work($event, vm.selected, 5, \'R\', false)\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>\nRIFIUTA I SELEZIONATI</md-button></div></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/eventi/trasferimenti.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Lavora Trasferimenti</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\">\n<md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Codice</b></small> <input \nid=\"search\" placeholder=\"Codice\" type=\"text\" ng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricercaCognome\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Nome</b></small> \n<input id=\"search\" placeholder=\"Nome\" type=\"text\" ng-model=\"vm.ricercaNome\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div></div><md-card \nstyle=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>{{vm.title}}</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key != \'def\' && key !== \'eventoTipo_id_IN\' && key !== \'eventoTipo_id\' && key !== \'beneficiarios-cancellato_IN\')\">\n<md-icon name=\"{{key}}\" class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.segnalatos\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"padding-left:0px\"><span>Cod</span></th><th\n md-column md-order-by=\"dataInizio\">DATA TRASFERIMENTO</th><th md-column md-order-by=\"\">COGNOME</th><th md-column \nmd-order-by=\"\">NOME</th><th md-column md-order-by=\"\">DATA NASCITA</th><th md-column md-order-by=\"\">NAZIONALITÀ</th><th \nmd-column ng-if=\"vm.benProroga\" md-order-by=\"entita1-dataFine\">DATA FINE</th><th md-column md-order-by=\"\">PROGETTO</th>\n<th md-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"segnalato in vm.eventos\"><td md-cell style=\"padding-left:0px;padding-right:4px\"><div layout=\"column\"><span>\n{{segnalato.entita1.codice}}</span></div></td><td md-cell style=\"padding-right:4px\"><div layout=\"column\"><div \nlayout=\"row\">{{segnalato.dataFine| date : \"dd/MM/yyyy\"}}</div><div layout=\"row\" ng-if=\"(segnalato.dataFine == null)\">\n<small>NON LAVORATO</small></div></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\" \nstyle=\"padding-right:4px\"><b>{{segnalato.entita1.cognome|uppercase}}</b></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:4px\"><b>{{segnalato.entita1.nome|uppercase}}</b></td><td\n md-cell style=\"padding-right:4px\">{{segnalato.entita1.dataNascita| date : \"dd/MM/y\"}}</td><td md-cell>\n{{segnalato.entita1.nazionalita.descrizione}}</td><td md-cell ng-if=\"vm.benProroga\" style=\"padding-right:4px\">\n{{segnalato.entita1.dataFine| date : \"dd/MM/y\"}}</td><td md-cell style=\"padding-right:4px\"><small><b>\n{{segnalato.entita1.progettos.nome|uppercase}}</b></small> <small ng-if=\"(segnalato.entita1.progetto_id == 0)\">N/A\n</small></td><td md-cell style=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Extra\" ng-click=\"vm.viewPerson($event, segnalato, \'extra\')\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Extra</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, segnalato, \'evento\')\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><span>Evento</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"Segnalato\" ng-click=\"vm.viewPerson($event, segnalato.entita1, \'beneficiario\')\"><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span>Beneficiario</span></md-button></md-menu-item><md-menu-item\n ng-if=\"segnalato.entita1.progetto_id > 0\"><md-button aria-label=\"Progetto\" \nng-click=\"vm.viewPerson($event, segnalato.entita1.progettos, \'progetto\')\"><md-icon md-font-icon=\"icon-apps\"></md-icon>\n<span>Progetto</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button pb-10\" ng-click=\"vm.openDialog($ev)\" \naria-label=\"nuovo trasferimento\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/sprardb/form/beneficiario-step-1.html","<div class=\"md-inline-form\"><div layout=\"row\" class=\"margin-top-24\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\" class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required><div ng-messages=\"personaNForm.cognome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container \nflex=\"50\" class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" ng-model=\"vm.beneficiario.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\" class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso</label><md-select name=\"sesso\" \nng-model=\"vm.beneficiario.sesso\"><md-option value=\"M\"><strong><small>MASCHIO</small></strong></md-option><md-option \nvalue=\"F\"><strong><small>FEMMINA</small></strong></md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><label>\nNazionità</label><md-select name=\"nazionalita\" ng-model=\"vm.beneficiario.codNazionalita\"><md-option \nng-repeat=\"naz in vm.nazioni| orderBy:\'descrizione\'\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.codNazionalita == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select><div ng-messages=\"personaNForm.nazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-32\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex=\"33\" class=\"margin-top-8 text-right\"><small><b>DATA DI NASCITA</b></small></div><div \nflex=\"66\" class=\"margin-left-32\"><md-datepicker ng-model=\"vm.beneficiario.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"true\" flex></md-datepicker></div></div></div><div layout=\"row\" \nclass=\"margin-top-8\"><md-button ng-click=\"vm.searchExisting()\" flex class=\"md-raised md-primary\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-accent\"></md-icon>Ricerca beneficiario</md-button><input type=\"hidden\" \nname=\"searched\" ng-model=\"vm.beneficiario.searched\" required></div><md-divider></md-divider><div \nng-if=\"vm.beneficiari.length > 0\"><div layout=\"row\" class=\"margin-top-32\"><p class=\"md-warn-fg\"><md-icon \nmd-font-icon=\"icon-account-alert\" class=\"md-warn-fg\"></md-icon><strong>Attenzione il beneficiario è già esistente.\n</strong></p></div><div layout=\"row\" class=\"margin-top-16\"><p>Puoi proseguire modificando un <b>beneficiario esistente\n</b> o procedere ad un <b>nuovo inserimento</b>\n. Tutti i beneficiari simili trovati sono riepilogati nella seguente tabella.</p></div><div layout=\"row\" \nng-if=\"!vm.closetable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cognome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nazionalita</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Stato</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo Ingresso</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Ingresso</span></div></th><th \nclass=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"ben in ::vm.beneficiari\"><td><small>{{ ben.cognome}}\n</small></td><td><small>{{ ben.nome}}</small></td><td><small>{{ ben.nazionalita.descrizione}}</small></td><td><small>\n{{ ben.stato}}</small></td><td><small>{{ ben.tipoIngresso.descrizione}}</small></td><td><small>{{ ben.dataIngresso}}\n</small></td><td><md-button class=\"md-primary md-hue-1\" ng-disabled=\"ben.stato == \'BENEFICIARIO\'\" \nng-click=\"vm.selectExisting(ben.id, 0)\">Reinserisci</md-button></td></tr></tbody></table></div><div layout=\"row\" \nng-if=\"!vm.closetable\"><md-button ng-click=\"vm.selectNew()\" flex class=\"md-raised md-primary\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" class=\"md-accent\"></md-icon>Inserisci nuovo beneficiario con stesso nome\n</md-button></div></div><div layout=\"row\" class=\"margin-top-32\" ng-if=\"vm.beneficiari.length == 0\"><span \nclass=\"green-500-fg\"><md-icon md-font-icon=\"icon-check-bookmark\" class=\"green-500-fg\"></md-icon>\nIl beneficiario non è presente, puoi continuare l\'inserimento.</span></div></div>");
$templateCache.put("app/main/sprardb/form/beneficiario-step-2.html","<div class=\"md-inline-form\"><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"33\" class=\"margin-bottom-0\"><label>Tipo Segnalazione</label><md-select \nname=\"tipoSegnalazione\" ng-model=\"vm.beneficiario.tipoSegnalazione\"><md-option value=\"SC\" \nng-selected=\"vm.beneficiario.tipoIngresso == \'SC\'\"><strong><small>SERVIZIO CENTRALE</small></strong></md-option>\n<md-option value=\"PROGETTO\" ng-selected=\"vm.beneficiario.tipoIngresso == \'PROGETTO\'\"><strong><small>PROGETTO</small>\n</strong></md-option></md-select><div ng-messages=\"personaNForm.tipoSegnalazione.$error\" role=\"alert\"><div \nng-message=\"required\"><span>richiesto</span></div></div></md-input-container><md-input-container flex=\"33\" \nclass=\"margin-bottom-0\"><label>Tipo Documento</label><md-select name=\"idTipoDocumento\" \nng-model=\"vm.beneficiario.idTipoDocumento\"><md-option ng-repeat=\"naz in vm.tipoDocumento| orderBy:\'descrizione\'\" \nng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idTipoDocumento == naz.id\"><strong><small>{{naz.descrizione}}</small>\n</strong></md-option></md-select><div ng-messages=\"personaNForm.idTipoDocumento.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container flex=\"33\" \nclass=\"margin-bottom-0\"><label>Tipo Ingresso</label><md-select name=\"idTipoIngresso\" \nng-model=\"vm.beneficiario.idTipoIngresso\"><md-option ng-repeat=\"naz in vm.tipoIngresso| orderBy:\'descrizione\'\" \nng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idTipoIngresso == naz.id\"><strong><small>{{naz.descrizione}}</small>\n</strong></md-option></md-select><div ng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"33\" \nclass=\"margin-bottom-0\"><label>Tipo Permesso</label><md-select name=\"tipoPermesso\" placeholder=\"Tipo di permesso\" \nng-model=\"vm.nevento.eventoTipo_id\" ng-change=\"vm.extraoptions();\" required><md-option \nng-repeat=\"item in vm.eventotipos\" ng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.tipoPermesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>richiesto</span></div>\n</div></md-input-container><div flex=\"33\" class=\"margin-bottom-0\"><small>DATA RILASCIO</small><md-datepicker \nng-model=\"vm.evento.dataInizio\" md-placeholder=\"Data Rilascio\" ng-required=\"true\" flex></md-datepicker></div><div \nflex=\"33\" class=\"margin-bottom-0\"><small>DATA SCADENZA</small><md-datepicker ng-model=\"vm.evento.dataFine\" \nmd-placeholder=\"Data Scadenza\" ng-required=\"true\" flex></md-datepicker></div></div></div><div layout=\"row\" \nng-repeat=\"(key, value) in vm.nevento.extra\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\" class=\"margin-bottom-0\"><label><strong>{{key|uppercase}}</strong></label><input \nng-if=\"key != \'questura\'\" type=\"text\" name=\"{{key}}\" ng-model=\"vm.nevento.extra[key]\" placeholder=\"{{key}}\" \nng-disabled=\"vm.view\"><md-select ng-if=\"key == \'questura\'\" name=\"{{key}}\" ng-model=\"vm.nevento.extra[key]\" \nclass=\"margin-top-0\" ng-disabled=\"vm.view\"><md-option ng-value=\"\"><strong><small>Nessuna</small></strong></md-option>\n<md-option ng-repeat=\"item in vm.questuras\" ng-value=\"item.nome\"><strong><small>{{item.nome}}</small></strong>\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex=\"33\" class=\"margin-top-16\"><md-switch ng-model=\"vm.beneficiario.nucleoFamiliare\" \naria-label=\"Attivo\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"margin-top: 0px\"><small>\n{{((!vm.beneficiario.nucleoFamiliare) ? \'NESSUN \' : \'HA \')}}NUCLEO FAMILIARE</small></md-switch></div><div flex=\"33\" \nclass=\"margin-top-16\"><small>DATA DI INSERIMENTO</small><md-datepicker ng-model=\"vm.beneficiario.dataInserimento2\" \nmd-placeholder=\"Data di Inserimento\" ng-required=\"false\" flex></md-datepicker></div><div flex=\"33\" \nclass=\"margin-top-16 margin-left-32\"><small>DATA INGRESSO ITALIA</small><md-datepicker \nng-model=\"vm.beneficiario.dataIngresso2\" md-placeholder=\"Data di Ingresso\" ng-required=\"false\" flex></md-datepicker>\n</div></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"33\" class=\"margin-bottom-0\"><label>Stato</label><md-select name=\"stato\" \nng-model=\"vm.beneficiario.stato\"><md-option ng-repeat=\"naz in vm.stato| orderBy:\'descrizione\'\" \nng-value=\"naz.descrizione\" ng-selected=\"vm.beneficiario.stato == naz.descrizione\"><strong><small>{{naz.descrizione}}\n</small></strong></md-option></md-select><div ng-messages=\"personaNForm.stato.$error\" role=\"alert\"><div \nng-message=\"required\"><span>richiesto</span></div></div></md-input-container></div></div></div>");
$templateCache.put("app/main/sprardb/form/beneficiario-step-3.html","<div class=\"md-inline-form\"><div layout=\"row\" class=\"margin-top-8\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-select ng-model=\"vm.ricercaProgetti.codRegione\" \nng-change=\"vm.searchProgettos();\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"regione in ::vm.regiones\" value=\"{{regione.id}}\">{{regione.regione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Cat.Accoglienza</label><md-select \nng-model=\"vm.ricercaProgetti[\'bandos-id\']\" ng-change=\"vm.searchProgettos();\"><md-option value=\"null\">Tutti</md-option>\n<md-option class=\"small\" ng-repeat=\"bando in ::vm.bandos\" value=\"{{bando.id}}\">{{bando.descrizione}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" class=\"margin-top-8\"><md-input-container flex><label>\nProgetti ({{vm.progettos.length}})</label><md-select ng-model=\"vm.progettoSelezionato\" \nng-change=\"vm.searchStrutturas();\"><md-option class=\"small\" ng-repeat=\"pro in vm.progettos\" value=\"{{pro.id}}\"><small>\n<b>{{pro.nome}}</b> in {{pro.istats.comune}} ({{pro.postiLiberi}})</small></md-option></md-select></md-input-container>\n</div><div layout=\"row\" class=\"margin-top-8\"><md-input-container flex><label>Strutture ({{vm.strutturas.length}})\n</label><md-select ng-model=\"vm.strutturaSelezionata\" ng-change=\"vm.selStrututra();\" required><md-option class=\"small\" \nng-repeat=\"pro in vm.strutturas\" value=\"{{pro.id}}\"><small><b>{{pro.nome}}</b>\n in {{pro.istats.comune}} ({{(pro.numeroPosti - pro.beneficiarios.length)}}) - {{pro.strutturaAccoglienzas.descrizione}} {{pro.strutturaAlloggios.descrizione}}\n</small></md-option></md-select></md-input-container></div><div layout=\"row\" class=\"margin-top-8\"><span \nng-repeat=\"pro in vm.strutturas| filter: {id: vm.strutturaSelezionata}\"><small ng-repeat=\"ex in ::pro.strutturaextras\" \nclass=\"text-boxed\">{{ex.chiave}}: {{ex.valore}}</small></span></div></div>");
$templateCache.put("app/main/sprardb/form/beneficiario-step-4.html","<div class=\"md-inline-form\"><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\" class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-map\"></md-icon><label>\nNazione di nascita</label><md-select name=\"nascita\" ng-model=\"vm.beneficiario.idNazioneNascita\"><md-option \nng-repeat=\"naz in vm.nazioni| orderBy:\'descrizione\'\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.idNazioneNascita == naz.id\"><strong><small>{{naz.descrizione}}</small></strong>\n</md-option></md-select><div ng-messages=\"personaNForm.nascita.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container><md-input-container flex=\"50\" class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-map\"></md-icon><label>Cittadinanza</label><md-select name=\"cittadinanza\" \nng-model=\"vm.beneficiario.idNazioneCittadinanza\"><md-option ng-repeat=\"naz in vm.nazioni| orderBy:\'descrizione\'\" \nng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idNazioneCittadinanza == naz.id\"><strong><small>{{naz.descrizione}}\n</small></strong></md-option></md-select><div ng-messages=\"personaNForm.cittadinanza.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\" \nclass=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-church\"></md-icon><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\"><md-option \nng-repeat=\"naz in vm.religioni| orderBy:\'descrizione\'\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select><div ng-messages=\"personaNForm.religione.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container><md-input-container flex=\"50\" class=\"margin-bottom-0\"><label>Gruppo Etnico\n</label><input type=\"text\" name=\"gruppoEtnico\" ng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.gruppoEtnico.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Altro</strong></h2>\n<md-divider></md-divider><div layout=\"row\" flex class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\">\n<label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input type=\"email\" name=\"email\" \nng-model=\"vm.beneficiario.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Telefono</label><md-icon md-font-icon=\"icon-phone\"></md-icon>\n<input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" placeholder=\"Telefono\" class=\"font-size-12\">\n</md-input-container></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale\n</label><input type=\"text\" name=\"codicefiscale\" ng-model=\"vm.beneficiario.codiceFiscale\" placeholder=\"Note\" \nclass=\"font-size-12\" ng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" \nmd-minlength=\"16\"><div ng-messages=\"personaNForm.codiceFiscale.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Codice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>\nDeve essere lungo 16 caratteri</span></div><div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span>\n</div></div></md-input-container><md-input-container flex><label>Note</label><input type=\"text\" name=\"note\" \nng-model=\"vm.beneficiario.note\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" md-maxlength=\"150\"><div \nng-messages=\"personaNForm.note.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\"><span>\nDeve essere lungo massimo 150 caratteri</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Note Sanitarie\n</label><textarea ng-model=\"vm.beneficiario.noteSanitarie\" md-maxlength=\"200\" rows=\"3\" md-select-on-focus \nclass=\"font-size-12\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/main/sprardb/form/beneficiario-step-5.html","<div class=\"md-inline-form\"><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" flex><h2>\nConfermi l\'inserimento di {{vm.beneficiario.cognome}} {{vm.beneficiario.nome}} ?</h2><md-divider></md-divider><p>\nProj: {{vm.progettoSelezionato}} - Struct: {{vm.strutturaSelezionata}} - Nuovo: {{vm.isnew}}</p></div></div></div>");
$templateCache.put("app/main/sprardb/form/beneficiario-steps.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/sprardb/form/cambiaStrutturaFormMc.html","<md-dialog aria-label=\"Cambia Struttura dialog\" class=\"struttura-dialog\" id=\"dialogcambiastruttura\" \nstyle=\"min-width: 50% !important\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Cambia Struttura</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\"><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" class=\"margin-top-16\" flex><md-input-container flex><label>Data Cambio Struttura\n</label><md-datepicker ng-model=\"vmd.res.dataCambioStruttura\" md-min-date=\"vmd.min_date\" md-max-date=\"vmd.maxDate\" \nmd-placeholder=\"GG/MM/AAAA\" required flex-auto></md-datepicker></md-input-container><md-input-container flex><label>\nTipo Accoglienza</label><md-select ng-model=\"vmd.res.esterna\" required><md-select-header>Tipo Accoglienza\n</md-select-header><md-option ng-value=\"0\">INTERNA</md-option><md-option ng-value=\"1\">ESTERNA</md-option></md-select>\n</md-input-container><md-input-container flex><label>Struttura</label><md-select ng-model=\"vmd.res.struttura\" \nng-disabled=\"vmd.res.esterna == null\" required><md-select-header>Scegli Struttura</md-select-header><md-option \nng-repeat=\"pro in vmd.strutture| filter:{esterna:vmd.res.esterna,id:\'!\'+vmd.struttura_id}\" value=\"{{pro.id}}\"><b>\n{{pro.nome|uppercase}}</b></md-option></md-select></md-input-container><md-input-container flex><label>Note</label>\n<textarea ng-model=\"vmd.res.note\"></textarea></md-input-container></div></form></md-dialog-content><md-dialog-actions>\n<md-button type=\"submit\" ng-click=\"vmd.save()\" class=\"md-raised md-accent\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" ng-if=\"!vm.api.isReadOnly\" aria-label=\"SALVA\"><span>SALVA\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dataValidationErrorForm.html","<md-dialog aria-label=\"Data validation error form\" class=\"datavalidation-dialog\" id=\"datavalidation\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Errore validazione dei dati</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\"><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div ng-repeat=\"model in vm.errorResponse\"><ul><li \nng-repeat=\"item in model\"><small><b>{{item.message}}</b></small></li></ul><md-divider \nng-if=\"$index < vm.errorResponse.length -1\"></md-divider></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" class=\"md-raised md-accent\" aria-label=\"CHIUDI\">\n<span>CHIUDI</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogAssCorsiBenForm.html","<md-dialog aria-label=\"Associa Corsi\" id=\"associaCorsiDialog\" flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAssocia Corsi</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-card class=\"md-padding\"><div layout=\"column\" \nlayout-padding><md-input-container flex><label>Ricerca Beneficiari</label><input ng-model=\"vmd.ricerca\" \nplaceholder=\"Inserisci nome, cognome o codice\" ng-change=\"vmd.getBeneficiari()\" ng-model-options=\"{debounce: 400}\">\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex><label>\nSeleziona Beneficiari</label><md-select ng-model=\"vmd.selectedBeneficiari\" placeholder=\"Seleziona Beneficiari\" \nmultiple=\"multiple\"><md-option ng-value=\"beneficiario.id\" ng-repeat=\"beneficiario in vmd.beneficiariProgetto\">\n{{ beneficiario.nome + \' \' + beneficiario.cognome + \' - \' + beneficiario.nazionalita + \' - \' + (beneficiario.dataNascita | date:\'dd / MM / yyyy\')}}\n</md-option></md-select></md-input-container></div><md-card class=\"md-padding\" \nng-show=\"vmd.selectedBeneficiari.length > 0\"><div layout=\"row\" layout-align=\"space-between\" flex><h2>Corsi da associare\n</h2><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.inizializzaModel()\"><md-icon \nmd-font-icon=\"icon-plus-circle green-700-fg\"></md-icon><md-tooltip>Aggiungi corso</md-tooltip></md-button></div><form \nnovalidate name=\"vmd.corsiForm\"><div ng-repeat=\"model in vmd.models\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-around center\"><md-input-container flex><label>Corso nel progetto</label><md-select \nng-model=\"model.selectedCorsi\" placeholder=\"Seleziona Corsi\" ng-click=\"vmd.getCorsiPerAnno()\" required><md-optgroup \nlabel=\"corso\"><md-option ng-value=\"corso.corsi_id\" ng-repeat=\"corso in vmd.corsiPerAnno\">{{corso.corsi.descrizione}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-around center\">\n<md-input-container flex class=\"m-10\"><label>Data Inizio</label><md-datepicker name=\"dataInizio\" \nng-model=\"model.dataInizio\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\"></md-datepicker>\n</md-input-container><md-input-container flex class=\"m-10\" ng-click=\"vmd.checkYear()\"><label>Data Fine</label>\n<md-datepicker name=\"dataFine\" ng-model=\"model.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\" md-min-date=\"model.dataInizio\" md-max-date=\"model.maxDateFine\"></md-datepicker>\n</md-input-container><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.cancellaModel(model)\" \nng-show=\"vmd.models.length > 1\"><md-icon md-font-icon=\"icon-close-circle md-warn\"></md-icon><md-tooltip><span>Cancella\n</span></md-tooltip></md-button></div></div></form></md-card></div></md-card></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"vmd.selectedBeneficiari.length < 1 || !vmd.models[0].dataInizio || !vmd.models[0].dataFine\" \nng-click=\"vmd.associaCorsi()\">Associa Corsi</md-button><md-button class=\"md-raised\" ng-click=\"vmd.cancel()\">Annulla\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogAssServiziBenForm.html","<md-dialog aria-label=\"Associa Servizi\" id=\"associaServiziiDialog\" flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAssocia Servizi</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-card class=\"md-padding\"><div layout=\"column\" \nlayout-padding><md-input-container flex><label>Ricerca Beneficiari</label><input ng-model=\"vmd.ricerca\" \nplaceholder=\"Inserisci nome, cognome o codice\" ng-change=\"vmd.getBeneficiari()\" ng-model-options=\"{debounce: 400}\">\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex><label>\nSeleziona Beneficiari</label><md-select ng-model=\"vmd.selectedBeneficiari\" placeholder=\"Seleziona Beneficiari\" \nmultiple=\"multiple\"><md-option ng-value=\"beneficiario.id\" ng-repeat=\"beneficiario in vmd.beneficiariProgetto\">\n{{ beneficiario.nome + \' \' + beneficiario.cognome + \' - \' + beneficiario.nazionalita + \' - \' + (beneficiario.dataNascita | date:\'dd / MM / yyyy\')}}\n</md-option></md-select></md-input-container></div><md-card class=\"md-padding\" \nng-show=\"vmd.selectedBeneficiari.length > 0\"><div layout=\"row\" layout-align=\"space-between\" flex><h2>\nServizi da associare</h2><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.inizializzaModel()\"><md-icon \nmd-font-icon=\"icon-plus-circle green-700-fg\"></md-icon><md-tooltip>Aggiungi servizio</md-tooltip></md-button></div>\n<form novalidate name=\"vmd.serviziForm\"><div ng-repeat=\"model in vmd.models\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-around center\"><md-input-container flex><label>Servizio nel progetto</label><md-select \nng-model=\"model.selectedServizi\" placeholder=\"Seleziona Servizi\" ng-click=\"vmd.getServiziPerAnno()\" required>\n<md-optgroup label=\"servizio\"><md-option ng-value=\"servizio.servizi_id\" ng-repeat=\"servizio in vmd.serviziPerAnno\">\n{{servizio.servizi.descrizione}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\"><md-input-container flex class=\"m-10\"><label>Data Inizio</label><md-datepicker \nname=\"dataInizio\" ng-model=\"model.dataInizio\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\">\n</md-datepicker></md-input-container><md-input-container flex class=\"m-10\" ng-click=\"vmd.checkYear()\"><label>Data Fine\n</label><md-datepicker name=\"dataFine\" ng-model=\"model.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\" md-min-date=\"model.dataInizio\" md-max-date=\"model.maxDateFine\"></md-datepicker>\n</md-input-container><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.cancellaModel(model)\" \nng-show=\"vmd.models.length > 1\"><md-icon md-font-icon=\"icon-close-circle md-warn\"></md-icon><md-tooltip><span>Cancella\n</span></md-tooltip></md-button></div></div></form></md-card></div></md-card></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"vmd.selectedBeneficiari.length < 1 || !vmd.models[0].dataInizio || !vmd.models[0].dataFine\" \nng-click=\"vmd.associaServizi()\">Associa Servizi</md-button><md-button class=\"md-raised\" ng-click=\"vmd.cancel()\">Annulla\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogAttributiBForm.html","<md-dialog aria-label=\"Attributi B Form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Attributi beneficiario\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" style=\"min-width: 350px;min-height: 300px\"><div \nclass=\"md-dialog-content\"><div class=\"form-wrapper\" flex=\"100\"><form name=\"attributiForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-16\"><md-icon \nmd-font-icon=\"icon-tag-outline\"></md-icon><label>Tipo di attributo</label><md-select name=\"gruppo\" \nng-model=\"vmd.payload.gruppo\" ng-change=\"vmd.caricaAttributi(vmd.payload.gruppo)\"><md-option \nng-repeat=\"item in vmd.attributiLabel| orderBy:\'etichetta\'\" ng-value=\"item.gruppo\" \nng-selected=\"vmd.payload.gruppo == item.gruppo\"><strong><small>{{item.etichetta| uppercase}}</small></strong>\n</md-option></md-select><div ng-messages=\"attributiForm.gruppo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container \nflex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-tag-outline\"></md-icon><label>Inserisci attributo</label>\n<md-select name=\"gruppo\" ng-model=\"vmd.payload.id\"><md-option \nng-repeat=\"attributo in vmd.attributis| orderBy:\'descrizione\'\" ng-value=\"attributo.id\" \nng-selected=\"vmd.payload.id == attributo.id\"><strong><small>{{attributo.descrizione}}</small></strong></md-option>\n</md-select><div ng-messages=\"attributiForm.gruppo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-if=\"vmd.isnew\" type=\"button\" ng-click=\"vmd.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"\" aria-label=\"SAVE\">SALVA<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button \nng-if=\"!vmd.isnew\" class=\"md-icon-button md-secondary\" ng-click=\"vmd.delete()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogCapofamigliaForm.html","<md-dialog aria-label=\"dialog struttura Form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAssocia Capofamiglia</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form layout=\"row\" novalidate \nng-submit=\"vmd.search(vmd.ricercaNome,vmd.ricercaCognome,vmd.ricercaCodice)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Nome</b></small> <input id=\"searchNome\" placeholder=\"Nome\" type=\"text\" \nng-model=\"vmd.ricercaNome\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"searchCognome\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vmd.ricercaCognome\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Codice</b></small> <input id=\"searchCodice\" placeholder=\"Codice\" type=\"text\" \nng-model=\"vmd.ricercaCodice\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><md-button \nclass=\"md-raised\" type=\"submit\">CERCA</md-button></form><div layout=\"row\" class=\"margin-top-16\"><b>\nCapofamiglia attuale:&nbsp;</b> <span ng-if=\"vmd.capoFamiglia\">\n{{vmd.capoFamiglia.nome}} {{vmd.capoFamiglia.cognome}} - codice: {{vmd.capoFamiglia.codice}}</span></div><md-card>\n<table data-md-table><thead md-head><tr md-row><td md-column style=\"text-align:center\">CODICE</td><td md-column \nstyle=\"text-align:center\">NOME</td><td md-column style=\"text-align:center\">COGNOME</td><td md-column \nstyle=\"text-align:center\">AZIONE</td></tr></thead><tbody md-body><tr md-row ng-repeat=\"capoF in vmd.capifamiglia\"><td \nmd-cell class=\"light-blue-900-fg font-weight-600 md-cell\" style=\"text-align:center\">{{capoF.codice}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600 md-cell\" style=\"text-align:center\">{{capoF.nome}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600 md-cell\" style=\"text-align:center\">{{capoF.cognome}}</td><td md-cell \nstyle=\"text-align:center\"><md-button class=\"md-raised\" ng-if=\"capoF.id != vmd.capoFamiglia.id\" \nng-click=\"vmd.seleziona(capoF)\">Associa</md-button><md-button ng-if=\"capoF.id == vmd.capoFamiglia.id\" \ndisabled=\"disabled\">Associato</md-button></td></tr></tbody></table></md-card></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogClonaCorsiForm.html","<md-dialog aria-label=\"Clona e Modifica Corsi\" id=\"clonaEModificaCorsiDialog\"><form name=\"clonaEModificaCorsiForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Clona Corsi</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 650px\" \nclass=\"no-padding\"><div layout=\"column\" layout-padding><label><strong>Clona corsi dall\'anno</strong></label><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select \nng-model=\"vmd.corsearchYear\" placeholder=\"Anno corsi\" ng-change=\"vmd.getCorsiPerAnno(vmd.corsearchYear)\"><md-option \nng-value=\"year.id\" ng-repeat=\"year in vmd.years\">{{ year.id}}</md-option></md-select></md-input-container></div><label>\n<strong>Per l\'anno</strong></label><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-input-container \nmd-no-float class=\"m-0\" flex><label>Anno di destinazione</label><md-select ng-model=\"vmd.corcloneYear\" \nplaceholder=\"Anno di destinazione\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vmd.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><ul ng-if=\"vmd.corsiPerAnno.length > 0\" layout-margin><h3><strong>\nElenco corsi da clonare</strong></h3><li ng-repeat=\"corso in vmd.corsiPerAnno\"><md-checkbox ng-model=\"corso.selected\">\n{{ corso.corsi.descrizione }}</md-checkbox><p>Anno: {{ corso.annoCorso }}</p></li></ul><md-button \nclass=\"send-button md-accent md-raised\" ng-click=\"vmd.clonaCorsi()\" \nng-disabled=\"vmd.corsiPerAnno.length <= 0 || !vmd.corcloneYear\">Clona Corsi</md-button><div \nng-if=\"vmd.corsiClonati.length > 0\" layout-margin><h3>Corsi Clonati</h3><ul><li \nng-repeat=\"corsoClonato in vmd.corsiClonati\">{{ corsoClonato.descrizione }}</li></ul></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vmd.cancel()\">Annulla</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogClonaServiziForm.html","<md-dialog aria-label=\"Clona e Modifica Servizi\" id=\"clonaEModificaServiziDialog\"><form \nname=\"clonaEModificaServiziForm\" class=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nClona Servizi</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" style=\"max-width:800px;min-width: 500px\"><div \nlayout=\"column\" layout-padding><label><strong>Clona servizi dall\'anno</strong></label><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select \nng-model=\"vmd.corsearchYear\" placeholder=\"Anno Servizi\" ng-change=\"vmd.getServiziPerAnno(vmd.corsearchYear)\"><md-option\n ng-value=\"year.id\" ng-repeat=\"year in vmd.years\">{{ year.id}}</md-option></md-select></md-input-container></div>\n<label><strong>Per l\'anno</strong></label><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-input-container md-no-float class=\"m-0\" flex><label>Anno di destinazione</label><md-select \nng-model=\"vmd.corcloneYear\" placeholder=\"Anno di destinazione\"><md-option ng-value=\"year.id\" \nng-repeat=\"year in vmd.years\">{{ year.id}}</md-option></md-select></md-input-container></div><ul \nng-if=\"vmd.serviziPerAnno.length > 0\" layout-margin><h3><strong>Elenco servizi da clonare</strong></h3><li \nng-repeat=\"servizio in vmd.serviziPerAnno\"><md-checkbox ng-model=\"servizio.selected\">{{ servizio.servizi.descrizione }}\n</md-checkbox><p>Data di inizio: {{ servizio.dataInizio }}</p><p>Data di fine: {{ servizio.dataFine }}</p></li></ul>\n<md-button class=\"send-button md-accent md-raised\" ng-click=\"vmd.clonaServizi()\" \nng-disabled=\"vmd.serviziPerAnno.length <= 0\">Clona Servizi</md-button><div ng-if=\"vmd.serviziClonati.length > 0\" \nlayout-margin><h3>Servizi Clonati</h3><ul><li ng-repeat=\"servizioClonato in vmd.serviziClonati\">\n{{ servizioClonato.descrizione }}</li></ul></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised\" ng-click=\"vmd.cancel()\">Annulla</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogCorsiBenForm.html","<md-dialog aria-label=\"corsi Form\" id=\"dettagliop\"><form name=\"corsoForm\" class=\"md-inline-form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 ng-if=\"!vmd.isnew\">Modifica Corso</h2><h2 ng-if=\"vmd.isnew\">Nuovo Corso</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\" style=\"max-width:800px;min-width: 500px\"><div \nng-if=\"!vmd.isnew\"><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>\nNome beneficiario</label><input type=\"text\" name=\"beneficiario_nome\" ng-model=\"vmd.beneficiario_nome\" \nplaceholder=\"Nome beneficiario\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Categoria</label><input \ntype=\"text\" name=\"cat_nome\" ng-model=\"vmd.nomecategoria\" placeholder=\"Categoria\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nNome Corso</label><md-select name=\"corso\" ng-model=\"vmd.selezionato.index\" \nng-change=\"vmd.selezioneItem(vmd.selezionato.index)\" disabled=\"disabled\"><md-option ng-repeat=\"corso in vmd.allcorsi\" \nvalue=\"{{$index}}\" ng-selected=\"corso.id == vmd.corso_id\"><b>{{corso.descrizione|uppercase}}</b><br><small>\n{{corso.note|uppercase}}</small></md-option></md-select><div ng-messages=\"corsoForm.corso.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>Data Inizio</label><md-datepicker \nname=\"dataInizio\" ng-model=\"vmd.mySelezionato.dataInizio\" md-placeholder=\"Data Inizio\" required flex \nmd-max-date=\"vmd.mySelezionato.dataFine\" md-min-date=\"vmd.mySelezionato.da\" ng-change=\"vmd.cambiaData()\">\n</md-datepicker><div class=\"validation-messages\" ng-messages=\"corsoForm.dataInizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></div></div><div layout=\"column\" layout-gt-md=\"row\" flex><div \nflex class=\"datepicker-container\"><label>Data Fine</label><md-datepicker name=\"dataFine\" \nng-model=\"vmd.mySelezionato.dataFine\" md-placeholder=\"Data Fine\" required flex md-max-date=\"vmd.mySelezionato.a\" \nmd-min-date=\"vmd.mySelezionato.dataInizio\" ng-change=\"vmd.cambiaData()\"></md-datepicker><div \nclass=\"validation-messages\" ng-messages=\"corsoForm.dataFine.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></div></div></div><div ng-if=\"vmd.isnew\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Nome beneficiario</label><input type=\"text\" \nname=\"beneficiario_nome\" ng-model=\"vmd.beneficiario_nome\" placeholder=\"Nome beneficiario\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nCategoria Corsi</label><md-select name=\"corsocategoria\" ng-model=\"vmd.corsocategoria\" \nng-change=\"vmd.selezioneCat(vmd.corsocategoria)\"><md-option ng-repeat=\"corso in vmd.allcategoria\" value=\"{{corso.id}}\">\n<b>{{corso.descrizione|uppercase}}</b><br><small>{{corso.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"corsoForm.corsocategoria.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container \nng-if=\"vmd.noService == false\" flex><label>Nome Corso</label><md-select name=\"corso\" ng-model=\"vmd.selezionato.id\" \nng-change=\"vmd.selezioneItem(vmd.selezionato.id)\" required ng-disabled=\"!vmd.corsocategoria\"><md-option \nng-repeat=\"corso in vmd.allcorsi|filter: {corsi_id: vmd.corsocategoria}\" value=\"{{corso.id}}\" \nng-if=\"corso.corsi_id == vmd.corsocategoria\"><b>{{corso.descrizione|uppercase}}</b><br><small>in {{corso.cat}}</small>\n</md-option></md-select><div ng-messages=\"corsoForm.corso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container ng-if=\"vmd.noService == true\" flex><label>\nNessun corso disponibile</label><input type=\"text\" disabled=\"disabled\"><div ng-messages=\"corsoForm.corso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>Data Inizio</label><md-datepicker\n name=\"dataInizio\" ng-model=\"vmd.mySelezionato.dataInizio\" md-placeholder=\"Data Inizio\" required flex \nmd-max-date=\"vmd.mySelezionato.dataFine\" md-min-date=\"vmd.mySelezionato.da\" ng-disabled=\"vmd.noService == true\" \nng-change=\"vmd.cambiaData()\"></md-datepicker><div class=\"validation-messages\" \nng-messages=\"corsoForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</div></div><div layout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>Data Fine\n</label><md-datepicker name=\"dataFine\" ng-model=\"vmd.mySelezionato.dataFine\" md-placeholder=\"Data Fine\" required flex \nmd-max-date=\"vmd.mySelezionato.a\" md-min-date=\"vmd.mySelezionato.dataInizio\" ng-disabled=\"vmd.noService == true\" \nng-change=\"vmd.cambiaData()\"></md-datepicker><div class=\"validation-messages\" ng-messages=\"corsoForm.dataFine.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div><div ng-message=\"min\"><span>Troppo piccola</span>\n</div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\"!vmd.isnew && (vmd.api.isAdmin || vmd.api.isAccoglienza)\" class=\"md-button md-secondary orange-700-fg\" \nng-click=\"vmd.delete()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon>ELIMINA</md-button><md-button \ntype=\"button\" ng-click=\"vmd.save()\" class=\"md-accent md-raised\" ng-if=\"vmd.isnew\" aria-label=\"SAVE\" \nng-disabled=\"corsoForm.$invalid || corsoForm.$pristine || vmd.noService == true\">SALVA<md-tooltip><span>Salva</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.aggiornaCorso()\" class=\"md-accent md-raised\" \naria-label=\"SAVE\" ng-if=\"!vmd.isnew\" ng-disabled=\"corsoForm.$invalid || corsoForm.$pristine\">AGGIORNA<md-tooltip><span>\nSalva</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogCorsiForm.html","<md-dialog aria-label=\"servizi Form\" id=\"dettagliop\"><form name=\"corsoForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Corsi del progetto</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 520px\" \nclass=\"no-padding\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"modifica collegamento\" \nng-if=\"!vmd.isnew && !vmd.newlink\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Nome Progetto</label><input type=\"text\" name=\"progetto_nome\" \nng-model=\"vmd.progetto_nome\" placeholder=\"Nome Progetto\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Categoria</label>\n<input type=\"text\" name=\"cat_nome\" ng-model=\"vmd.nomecategoria\" placeholder=\"Categoria\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><input type=\"hidden\" ng-model=\"vmd.progettohascorsi.progetto_id\"><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Nome Corso</label><md-select name=\"corso\" \nng-model=\"vmd.selezionato.id\" disabled=\"disabled\"><md-option ng-repeat=\"corso in vmd.allcorsi\" value=\"{{corso.id}}\" \nng-selected=\"corso.id == vmd.corso_id\"><b>{{corso.descrizione|uppercase}}</b><br><small>{{corso.note|uppercase}}\n</small></md-option></md-select><div ng-messages=\"corsoForm.corso.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Anno</label><md-select name=\"anno\" ng-model=\"vmd.progettohascorsi.anno\" required>\n<md-option ng-repeat=\"anno in vmd.anni\" value=\"{{anno.id}}\" ng-selected=\"anno.id == vmd.anno\" \nmd-placeholder=\"Inserisci un anno\"><b>{{anno.id}}</b></md-option></md-select></md-input-container></div></md-content>\n</md-tab><md-tab label=\"nuovo collegamento\" ng-if=\"!vmd.isnew && vmd.newlink\"><md-content class=\"md-padding\"><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Nome Progetto</label><input \ntype=\"text\" name=\"progetto_nome\" ng-model=\"vmd.progetto_nome\" placeholder=\"Nome Progetto\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><input type=\"hidden\" ng-model=\"vmd.progettohascorsi.progetto_id\"><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Categoria Corso</label><md-select \nname=\"corsocategoria\" ng-model=\"vmd.selezionato.corsi_id\"><md-option ng-repeat=\"corso in vmd.allcategoria\" \nvalue=\"{{corso.id}}\"><b>{{corso.descrizione|uppercase}}</b><br><small>{{corso.note|uppercase}}</small></md-option>\n</md-select><div ng-messages=\"corsoForm.corsocategoria.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nNome Corso</label><md-select name=\"corso\" ng-model=\"vmd.selezionato.id\"><md-option \nng-repeat=\"corso in vmd.allcorsi|filter: {corsi_id: vmd.selezionato.corsi_id}\" value=\"{{corso.id}}\"><b>\n{{corso.descrizione|uppercase}}</b><br><small>{{corso.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"corsoForm.corso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Anno</label>\n<md-select name=\"anno\" ng-model=\"vmd.progettohascorsi.anno\" required><md-option ng-repeat=\"anno in vmd.anni\" \nvalue=\"{{anno.id}}\" ng-selected=\"anno.id == vmd.anno\" md-placeholder=\"Inserisci un anno\"><b>{{anno.id}}</b></md-option>\n</md-select></md-input-container></div></md-content></md-tab><md-tab label=\"aggiungi corso\" \nng-if=\"vmd.isnew && !vmd.newlink\"><md-content class=\"no-padding\"><md-content class=\"md-padding\"><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Categoria Corso</label><md-select name=\"corsocategoria\" \nng-model=\"vmd.corso.corsi_id\"><md-option ng-repeat=\"corso in vmd.allcategoria\" value=\"{{corso.id}}\"><b>\n{{corso.descrizione|uppercase}}</b><br><small>{{corso.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"corsoForm.corsocategoria.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Nome Corso\n</label><input type=\"text\" name=\"descrizione\" ng-model=\"vmd.corso.descrizione\" placeholder=\"Nome Corso\" required><div \nng-messages=\"corsoForm.descrizione.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Note</label>\n<textarea ng-model=\"vmd.corso.note\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea></md-input-container>\n</div></md-content></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\"!vmd.isnew && !vmd.newlink && (vmd.api.isAdmin || vmd.api.isAccoglienza)\" \nclass=\"md-button md-secondary orange-700-fg\" ng-click=\"vmd.delete()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\">\n</md-icon>ELIMINA RELAZIONE</md-button><md-button type=\"button\" ng-click=\"vmd.save()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"(!vmd.isnew && vmd.newlink)\" aria-label=\"SAVE\" \nng-disabled=\"corsoForm.$invalid || corsoForm.$pristine && !(vmd.api.isAdmin || vmd.api.isOperatore)\">SALVA<md-tooltip>\n<span>Salva</span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.insertnew()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"(vmd.isnew && !vmd.newlink)\" aria-label=\"SAVE\" \nng-disabled=\"corsoForm.$invalid || corsoForm.$pristine && !(vmd.api.isAdmin || vmd.api.isOperatore)\">INSERISCI\n<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.aggiornaCorso()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"corsoForm.$invalid || corsoForm.$pristine || !vmd.api.user.permissions.includes(\'associa-corsi-servizi\')\" \naria-label=\"SAVE\" ng-if=\"!vmd.isnew && !vmd.newlink\">AGGIORNA<md-tooltip><span>Salva</span></md-tooltip></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogEntiForm.html","<md-dialog aria-label=\"enti Form\" id=\"personedialog\" class=\"persone-dialog\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Enti collegati</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 650px\" \nclass=\"no-padding\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"modifica ente\" \nng-if=\"!vmd.isnewente && !vmd.newlink\"><md-content class=\"md-padding\"><span class=\"text-boxed\">\n{{vmd.progetto_nome|uppercase}}</span> collegato con <span class=\"text-boxed\">{{vmd.ente_nome|uppercase}}</span>\n<md-button class=\"md-button md-secondary orange-700-fg\" ng-click=\"vmd.delete()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon>ELIMINA RELAZIONE</md-button><md-divider></md-divider><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Ente Tipo</label><md-select \nname=\"entetipoR\" ng-model=\"vmd.ricerca.enteTipo_id\" ng-change=\"vmd.cercaEnte()\"><md-option value=\"null\">Tutti\n</md-option><md-option ng-repeat=\"entetipos in vmd.allentetipos\" value=\"{{entetipos.id}}\" \nng-selected=\"entetipos.id == vmd.ricerca.enteTipo_id\" ng-if=\"entetipos.enteTipo_id > 0\"><b>{{entetipos.descrizione}}\n</b><br><small>{{entetipos.enteTipo_id}}° SETTORE</small></md-option></md-select></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca ente per nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.ricerca.nome\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaEnte()\" \nplaceholder=\"Inserisci il testo da cercare\"></md-input-container></div><form name=\"enteNForm\" novalidate><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>\nScegli un Ente [<span class=\"text-boxed\">{{vmd.allentes.length}}</span>]</label><md-select name=\"nome\" \nng-model=\"vmd.enteselezionato.id\" ng-change=\"vmd.restituisciEnte()\" aria-label=\"nome ente selezionato\"><md-option \nng-repeat=\"ente in vmd.allentes\" value=\"{{ente.id}}\" ng-selected=\"vmd.ente_id == ente.id\">{{ente.nome}}</md-option>\n</md-select></md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><md-select-label>\nRuolo nel progetto</md-select-label><md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\" aria-label=\"r\">\n<md-option ng-repeat=\"ruolo in vmd.allruolo\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.ruolosSelected.length == 1 && vmd.ruolosSelected.indexOf(ruolo.id) == 0)\">{{ruolo.descrizione}}\n</md-option></md-select></md-input-container></div></form></md-content></md-tab><md-tab label=\"inserisci ente\" \nng-if=\"!vmd.isnewente && vmd.newlink\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Ente Tipo</label><md-select name=\"entetipoR\" \nng-model=\"vmd.ricerca.enteTipo_id\" ng-change=\"vmd.cercaEnte()\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"entetipos in vmd.allentetipos\" value=\"{{entetipos.id}}\" \nng-selected=\"entetipos.id == vmd.ricerca.enteTipo_id\" ng-if=\"entetipos.enteTipo_id > 0\"><b>{{entetipos.descrizione}}\n</b><br><small>{{entetipos.enteTipo_id}}° SETTORE</small></md-option></md-select></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca ente per nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.ricerca.nome_LIKE\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaEnte()\" \nplaceholder=\"Inserisci il testo da cercare\"></md-input-container></div><form name=\"enteNForm\" novalidate><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>\nScegli un Ente [<span class=\"text-boxed\">{{vmd.allentes.length}}</span>]</label><md-select name=\"nome\" \nng-model=\"vmd.enteselezionato.id\" ng-change=\"vmd.restituisciEnte()\" aria-label=\"nome ente selezionato\"><md-option \nng-repeat=\"ente in vmd.allentes\" value=\"{{ente.id}}\">{{ente.nome}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"margin-bottom-0 margin-top-4\"><md-select-label>Ruolo nel progetto</md-select-label>\n<md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\" aria-label=\"r\"><md-option \nng-repeat=\"ruolo in vmd.allruolo| filter: {id: vmd.ruolo_passato}\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.ruolosSelected.length == 1 && vmd.ruolosSelected.indexOf(ruolo.id) == 0)\">{{ruolo.descrizione}}\n</md-option></md-select></md-input-container></div></form></md-content></md-tab><md-tab label=\"crea nuovo ente\" \nng-if=\"vmd.isnewente && !vmd.newlink\"><md-content class=\"padding-16\"><form name=\"enteNForm\" novalidate><h2 \nclass=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider></md-divider><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label>Nome Ente</label><input type=\"text\" name=\"nome\" ng-model=\"vmd.ente.nome\" \nplaceholder=\"Nome Ente\" required><div ng-messages=\"enteNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex=\"20\" \nclass=\"margin-bottom-0 margin-top-0\" flex-offset=\"5\"><md-switch ng-model=\"vm.ente.attivo\" aria-label=\"Attivo\" \nng-true-value=\"1\" ng-false-value=\"0\"><small>Ente {{((!vm.ente.attivo) ? \'non\' : \'\')}} attivo</small></md-switch>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><label>Tipo Padre</label><md-select \nname=\"tipopadre\" ng-model=\"vmd.ente.enteTipoPadre_id\"><md-option \nng-repeat=\"entetipos in vmd.allentetipos| filter: {enteTipo_id: 0}\" value=\"{{entetipos.id}}\" \nng-selected=\"entetipos.id == vmd.ente.enteTipoPadre_id\">{{entetipos.descrizione}}</md-option></md-select><div \nng-messages=\"enteNForm.tipopadre.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex class=\"margin-top-0\"><label>Ente Tipo</label>\n<md-select name=\"entetipo\" ng-model=\"vmd.ente.enteTipo_id\"><md-option \nng-repeat=\"entetipos in vmd.allentetipos| filter: {enteTipo_id: vmd.ente.enteTipoPadre_id}\" value=\"{{entetipos.id}}\" \nng-selected=\"entetipos.id == vmd.ente.enteTipo_id\">{{entetipos.descrizione}}</md-option></md-select><div \nng-messages=\"enteNForm.entetipo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon md-font-icon=\"icon-phone\"></md-icon><label>\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vmd.ente.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\"></md-input-container><md-input-container flex><label>Email</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input type=\"email\" name=\"email\" ng-model=\"vmd.ente.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required class=\"font-size-12\"><div ng-messages=\"enteNForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email richiesta</span></div><div \nng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container></div></div><h2 class=\"no-padding\">\n<strong>Ruolo</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-16 margin-top-4\">\n<md-select-label>Ruolo nel progetto</md-select-label><md-select name=\"ruoloente\" ng-model=\"vmd.ruolosSelected\" \nmultiple=\"multiple\" aria-label=\"r\"><md-option ng-repeat=\"ruolo in vmd.allruolo\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.ruolosSelected.length == 1 && vmd.ruolosSelected.indexOf(ruolo.id) == 0)\">{{ruolo.descrizione}}\n</md-option></md-select><div ng-messages=\"enteNForm.ruoloente.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl ruolo è richiesto</span></div></div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Localizzazione\n</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon>\n<md-select name=\"reg\" ng-model=\"vmd.ente.codRegione\" ng-change=\"vmd.caricaProvince(vmd.ente.codRegione)\"><md-option \nng-repeat=\"regione in vmd.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.ente.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"enteNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<label>Provincia</label><md-select name=\"prov\" ng-model=\"vmd.ente.codProvincia\" ng-disabled=\"!vmd.ente.codRegione\" \nng-change=\"vmd.caricaComuni(vmd.ente.codProvincia)\"><md-option ng-repeat=\"provincia in vmd.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vmd.ente.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"enteNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select name=\"com\" \nng-model=\"vmd.ente.codComune\" ng-disabled=\"!vmd.ente.codProvincia\"><md-option ng-repeat=\"istat in vmd.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.ente.codComune\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"enteNForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" \nname=\"indirizzo\" ng-model=\"vmd.ente.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container>\n<md-input-container flex><label>codice Postale</label><input name=\"cap\" ng-model=\"vmd.ente.cap\" placeholder=\"00100\" \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div ng-messages=\"enteNForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container></div></div><br><br></form>\n</md-content></md-tab></md-tabs>{{enteNForm.$error}}</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"button\" ng-click=\"vmd.save()\" class=\"md-button md-accent md-raised\" aria-label=\"SAVE\" ng-if=\"!vmd.isstore\" \nng-disabled=\"enteNForm.$invalid\">SALVA<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button type=\"button\" \nng-click=\"vmd.store()\" class=\"md-button md-accent md-raised\" aria-label=\"STORE\" ng-if=\"vmd.isstore\">REGISTRA\n<md-tooltip><span>Salva</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogEventoForm.html","<md-dialog aria-label=\"extra Form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Extra Campi</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div class=\"md-dialog-content\"><div \nclass=\"form-wrapper\" flex=\"100\"><form name=\"extraForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"chiave\" ng-model=\"vmd.extra.chiave\" \nplaceholder=\"Nome Campo\" required><div ng-messages=\"extraForm.chiave.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Nome campo è obbligatorio.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex><input type=\"text\" name=\"valore\" ng-model=\"vmd.extra.valore\" placeholder=\"Valore Campo\" \nrequired><div ng-messages=\"extraForm.valore.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nValore campo è obbligatorio.</span></div></div></md-input-container></div></form></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vmd.saveExtra()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\">SALVA<md-tooltip><span>Salva</span>\n</md-tooltip></md-button><md-button ng-if=\"!vmd.isnew\" class=\"md-icon-button md-secondary\" \nng-click=\"vmd.deleteExtra()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella\n</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogExtraForm.html","<md-dialog aria-label=\"extra Form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Extra Campi</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div class=\"md-dialog-content\"><div \nclass=\"form-wrapper\" flex=\"100\"><form name=\"extraForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"chiave\" ng-model=\"vmd.extra.chiave\" \nplaceholder=\"Nome Campo\" required><div ng-messages=\"extraForm.chiave.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Nome campo è obbligatorio.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex><input type=\"text\" name=\"valore\" ng-model=\"vmd.extra.valore\" placeholder=\"Valore Campo\" \nrequired><div ng-messages=\"extraForm.valore.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nValore campo è obbligatorio.</span></div></div></md-input-container></div></form></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vmd.saveExtra()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SAVE\">SALVA<md-tooltip><span>Salva</span></md-tooltip></md-button>\n<md-button ng-if=\"!vmd.isnew\" class=\"md-icon-button md-secondary\" ng-click=\"vmd.deleteExtra()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogPersoneAttivaForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"persone Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Ruoli Ambiti e Incarichi</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"modifica\" ng-if=\"!vmd.isnewpersona && !vmd.newlink\"><md-content \nclass=\"md-padding\"><span class=\"text-boxed\">{{vmd.progetto_nome}}</span> collegato con <span class=\"text-boxed\">\n{{vmd.persona_nome}}</span><br><form name=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0 margin-top-4\"><md-select name=\"nome\" \nng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" aria-label=\"nome persona selezionato\" \ndisabled=\"disabled\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\" \nng-selected=\"vmd.persona_id == persona.id\"><span><strong>{{persona.cognome|uppercase}} {{persona.nome|uppercase}}\n</strong></span></md-option></md-select></md-input-container></div><br><div layout=\"column\" \nng-repeat=\"e in vmd.enti_collegati\"><div layout=\"row\" ng-repeat=\"e1 in vmd.phe2[e.id]\"><md-input-container flex \nclass=\"margin-bottom-4 margin-top-4\"><label>Nome Ente</label><input type=\"text\" name=\"en\" placeholder=\"en\" \nclass=\"font-size-12\" value=\"{{e.nome|uppercase}}\" aria-label=\"en{{e.id}}\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-4 margin-top-4\" \nng-repeat=\"ruolo in vmd.personaruoloentes|filter: {id: e1.personaRuolo_id} : true\"><label>Funzione/incarico</label>\n<input type=\"text\" name=\"ren\" placeholder=\"ren\" class=\"font-size-12\" value=\"{{ruolo.descrizione|uppercase}}\" \naria-label=\"en{{ruolo.id}}\" disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><md-checkbox ng-model=\"e1.attivo\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo\n</md-checkbox></md-input-container></div></div><div layout=\"column\" ng-repeat=\"p in vmd.progetti_collegati\"><div \nlayout=\"row\" ng-repeat=\"p1 in vmd.php2[p.id]\"><md-input-container flex class=\"margin-bottom-4 margin-top-4\" \nng-repeat=\"progetto in vmd.tuttipersonaruolos|filter: {id: p1.personaRuolo_id} : true \"><label><span \nng-if=\"!progetto.ambito\">Ruolo nel progetto selezionato</span> <span ng-if=\"progetto.ambito\">\nAmbito operativo nel progetto selezionato</span></label><input type=\"text\" name=\"lren\" placeholder=\"lren\" \nclass=\"font-size-12\" value=\"{{progetto.descrizione|uppercase}}\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0 margin-top-4\"><md-checkbox ng-model=\"p1.attivo\" ng-true-value=\"1\" \nng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div></div><div layout=\"column\" class=\"margin-bottom-4\">\n<small>Ruoli e ambiti associati ad altri progetti (non modificabili)</small> <small layout=\"row\" \nng-repeat=\"item in vmd.ruolosSelected_ro\"><b>{{item.ruolo}}</b></small></div><div layout=\"column\" \nclass=\"margin-bottom-4\"><small>Incarichi associati ad altri enti (non modificabili)</small> <small layout=\"row\" \nng-repeat=\"item in vmd.incaricosSelected_ro\"><b>{{item.ruolo}}</b></small></div><div layout=\"row\" \nclass=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small \nclass=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.attivaDisattiva()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" \naria-label=\"salva\" flex>SALVA</md-button></div></form></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogPersoneEnteForm.html","<md-dialog aria-label=\"personeente Form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Persone collegate</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 650px\" \nclass=\"no-padding\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"modifica persona\" \nng-if=\"!vmd.isnewpersona && !vmd.newlink\"><md-content class=\"md-padding\"><span class=\"text-boxed\">{{vmd.ente_nome}}\n</span> collegato con <span class=\"text-boxed\">{{vmd.persona_nome}}</span><md-button \nclass=\"md-icon-button md-secondary\" ng-click=\"vmd.delete()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\">\n</md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button><h2 class=\"no-padding\"><strong>\nCerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca persona per cognome, città ed ente</label><input \ntype=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\"></md-input-container></div><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\" \nng-selected=\"vmd.persona_id == persona.id\"><small><strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.entes[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nel ente</label>\n<md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\"><md-option ng-repeat=\"ruolo in vmd.allruolo\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select></md-input-container></div></form></md-content>\n</md-tab><md-tab label=\"inserisci persona\" ng-if=\"!vmd.isnewpersona && vmd.newlink\"><md-content class=\"md-padding\"><h2 \nclass=\"no-padding\"><strong>Cerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Ricerca persona per cognome, città ed ente\n</label><input type=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\"></md-input-container></div><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\"><small>\n<strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.entes[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nel ente</label>\n<md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\"><md-option ng-repeat=\"ruolo in vmd.allruolo\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select></md-input-container></div></form></md-content>\n</md-tab><md-tab label=\"crea nuovo persona\" ng-if=\"vmd.isnewpersona && !vmd.newlink\"><md-content class=\"padding-16\">\n<form name=\"personaNForm\" novalidate><h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vmd.persona.cognome\" placeholder=\"Cognome\" required><div ng-messages=\"personaNForm.cognome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" ng-model=\"vmd.persona.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso</label><md-select name=\"sesso\" \nng-model=\"vmd.persona.sesso\"><md-option value=\"M\">Maschio</md-option><md-option value=\"F\">Femmina</md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" \nng-model=\"vmd.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container\n flex><md-icon md-font-icon=\"icon-phone\"></md-icon><label>Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vmd.persona.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \ntype=\"email\" name=\"email\" ng-model=\"vmd.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Ruoli</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex class=\"margin-bottom-16 margin-top-4\"><label>Ruolo nel ente</label><md-select name=\"enteruolo\" \nng-model=\"vmd.ruolosSelected\" multiple=\"multiple\" required><md-option ng-repeat=\"ruolo in vmd.allruolo\" \nng-value=\"ruolo.id\"><small>{{ruolo.descrizione}}</small></md-option></md-select><div \nng-messages=\"personaNForm.enteruolo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il ruolo è richiesto</span>\n</div></div></md-input-container><md-input-container flex class=\"margin-bottom-16 margin-top-4\"><label>Ruolo generale\n</label><md-select name=\"personaruolo\" ng-model=\"vmd.ruolosSelected2\" multiple=\"multiple\" required><md-option \nng-repeat=\"ruolo in vmd.allpersonaruolo\" ng-value=\"ruolo.id\"><small><strong>{{ruolo.descrizione}}</strong>\n ({{ruolo.gruppo}})</small></md-option></md-select><div ng-messages=\"personaNForm.personaruolo.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il ruolo generale è richiesto</span></div></div></md-input-container></div></div><h2 \nclass=\"no-padding\"><strong>Residenza</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Regione</label>\n<md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" ng-model=\"vmd.persona.codRegione\" \nng-change=\"vmd.caricaProvince(vmd.persona.codRegione)\"><md-option ng-repeat=\"regione in vmd.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label><md-select \nname=\"prov\" ng-model=\"vmd.persona.codProvincia\" ng-disabled=\"!vmd.persona.codRegione\" \nng-change=\"vmd.caricaComuni(vmd.persona.codProvincia)\"><md-option ng-repeat=\"provincia in vmd.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vmd.persona.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vmd.persona.codComune\" ng-disabled=\"!vmd.persona.codProvincia\"><md-option \nng-repeat=\"istat in vmd.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" ng-model=\"vmd.persona.indirizzo\" \nplaceholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container><md-input-container flex><label>codice Postale\n</label><input name=\"cap\" ng-model=\"vmd.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container></div></div><h2 class=\"no-padding\">\n<strong>Nascita</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Regione</label><md-icon \nmd-font-icon=\"icon-map\"></md-icon><md-select name=\"reg2\" ng-model=\"vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaProvince2(vmd.persona.nascita.codRegione)\"><md-option ng-repeat=\"regione in vmd.regiones2\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.nascita.codRegione\">{{regione.regione}}</md-option>\n</md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label>\n<md-select name=\"prov2\" ng-model=\"vmd.persona.nascita.codProvincia\" ng-disabled=\"!vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaComuni2(vmd.persona.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vmd.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vmd.persona.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vmd.persona.codComuneNascita\" ng-disabled=\"!vmd.persona.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vmd.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vmd.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label>Nazione</label><md-select name=\"nazionalita\" \nng-model=\"vmd.persona.codNazionalita\"><md-option ng-repeat=\"naz in vmd.nazionalitas\" value=\"{{naz.id}}\" \nng-selected=\"naz.id == vmd.persona.codNazionalita\"><small>{{naz.descrizione}}</small></md-option></md-select>\n</md-input-container><div flex><md-datepicker ng-model=\"vm.ente.dataNascita2\" md-placeholder=\"Data di Nascita\" \nng-required=\"false\" flex></md-datepicker></div></div></div></form></md-content></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"vmd.save()\" class=\"send-button md-accent md-raised\" \naria-label=\"SAVE\">SALVA<md-tooltip><span>Salva</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogPersoneEnteSForm.html","<md-dialog aria-label=\"personeente Form\" id=\"registerentes\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Segnalatore\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 650px\" \nid=\"register-form-wrapper\"><form name=\"registerForm\" novalidate id=\"register-form\"><div id=\"firststep\" \nng-if=\"!vmd.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\"><p>\nPrima di effettuare la tua registrazione nella Banca Dati, inserisci il codice del tuo <b>Ente Segnalatore</b>\n di riferimento.<br>Se non lo hai ancora ricevuto, <b>richiedilo al tuo Ente</b>.</p></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Codice Ente Segnalatore</label><md-icon \nmd-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input type=\"codiceSegnalatore\" \nname=\"codiceSegnalatore\" ng-model=\"vmd.persondata.codiceSegnalatore\" ng-change=\"vmd.resetCodice()\" required><div \nng-messages=\"registerForm.codiceSegnalatore.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl codice segnalatore è richiesto</span></div><ng-message class=\"help-block\" when=\"notexists\"><span>\nCodice inserito è inesistente.</span></ng-message></div></md-input-container></div></div><div id=\"secondstep\" \nng-if=\"vmd.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Ente Riferimento</label><md-icon md-font-icon=\"icon-sign-caution\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"nomeEnte\" name=\"nomeEnte\" ng-model=\"vmd.responseCodice.nome\" \nreadonly=\"readonly\" class=\"strong\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Cognome</label><md-icon md-font-icon=\"icon-clipboard-account\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"cognome\" name=\"cognome\" ng-model=\"vmd.persondata.cognome\" \nplaceholder=\"Last Name\" translate translate-attr-placeholder=\"REGISTER.COGNAME\" required><div \nng-messages=\"registerForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.COGNAME_REQUIRED\">Cognome field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float flex><label>Nome</label><md-icon \nmd-font-icon=\"icon-clipboard-account\" class=\"blue-grey-800-fg\"></md-icon><input name=\"nome\" \nng-model=\"vmd.persondata.nome\" placeholder=\"First Name\" translate translate-attr-placeholder=\"REGISTER.NOME\" required>\n<div ng-messages=\"registerForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.NOME_REQUIRED\">Name field is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Codice Fiscale</label><md-icon \nmd-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"codiceFiscale\" \nng-model=\"vmd.persondata.codiceFiscale\" placeholder=\"Codice Fiscale\" \nng-pattern=\"/^[a-zA-Z]{6}[a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{3}[a-zA-Z]$/\" \nng-change=\"vmd.checkCf($event)\" required><div ng-messages=\"registerForm.codiceFiscale.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Codice Fiscale è richiesto</span></div><div ng-message=\"pattern\">\n<span>Codice Fiscale invalido</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nCodice Fiscale già in uso. Contattare SC.</span></ng-message></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float flex><label>Genere</label><md-icon md-font-icon=\"icon-gender-male-female\" \nclass=\"blue-grey-800-fg\"></md-icon><md-select ng-model=\"vmd.persondata.sesso\" name=\"sesso\" placeholder=\"Genere\" \nrequired><md-option ng-repeat=\"n in [{id: \'M\', value: \'MASCHIO\'}, {id: \'F\', value: \'FEMMINA\'}]\" ng-value=\"n.id\" \nng-selected=\"{{vmd.persondata.sesso == n.id}}\">{{ n.value}}</md-option></md-select><div class=\"errors\" \nng-messages=\"registerForm.sesso.$error\"><div ng-message=\"required\">Genere richiesto</div></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><div layout=\"column\" flex style=\"margin-bottom:16px\" class=\"datepicker-container\" \nmd-no-float flex><label flex>Data di nascita *</label><div flex><md-datepicker ng-model=\"vmd.persondata.dataNascita\" \nmd-max-date=\"vmd.maxDate\" md-min-date=\"vmd.minDate\" ng-required=\"true\" md-placeholder=\"Data di nascita obbligatoria\" \nname=\"dataNascita\" flex></md-datepicker><div ng-messages=\"registerForm.dataNascita.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><small class=\"md-warn-fg\">* Data nascita richiesta</small></div></div>\n</div></div><md-input-container class=\"md-block\" md-no-float flex><label>Telefono mobile</label><md-icon \nmd-font-icon=\"icon-cellphone-android\" class=\"blue-grey-800-fg\"></md-icon><input name=\"telefono\" \nng-model=\"vmd.persondata.telefono\" ng-pattern=\"/^\\+?\\d+$/im\" minlength=\"10\" maxlength=\"13\" placeholder=\"Telefono\" \nng-change=\"vmd.checkTelefono($event)\" required><div ng-messages=\"registerForm.telefono.$error\" multiple=\"multiple\" \nmd-auto-hide=\"true\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span \ntranslate=\"REGISTER.ERRORS.TELEPHONE_REQUIRED\">\nYour Telephone must be between 10 and 13 digit long and look like an Zipcode.</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Telefono esistente contattare SC.</span></ng-message></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Ruolo nell\'ente</label>\n<md-select name=\"designation\" ng-model=\"vmd.persondata.designation\" placeholder=\"Ruolo nell\'ente\" \nstyle=\"padding-bottom: 24px\" required><md-option ng-repeat=\"parentorg in vmd.roles\" ng-value=\"parentorg.id\"><small><b>\n{{parentorg.descrizione}}</b></small></md-option></md-select><div ng-messages=\"registerForm.designation.$error\" \nng-if=\"registerForm.birthcity.$touched\"><div ng-message=\"required\">Ruolo richiesto</div></div></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"center center\" style=\"margin-bottom: 24px\"><b>Dati per autenticazione</b>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Email</label><md-icon \nmd-font-icon=\"icon-email\" class=\"blue-grey-800-fg\"></md-icon><input type=\"email\" name=\"email\" \nng-model=\"vmd.persondata.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"vmd.checkEmail($event)\" required><div ng-messages=\"registerForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email è richiesta</span></div><div \nng-message=\"pattern\"><span>Email invalida</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nEmail già in uso oppure non inserita. Contattare SC.</span></ng-message></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float show-errors flex><label>Nome utente</label><md-icon\n md-font-icon=\"icon-account-key\" class=\"blue-grey-800-fg\"></md-icon><input name=\"username\" \nng-model=\"vmd.persondata.username\" \nng-model-options=\"{\n                                    debounce: 1500\n                                }\" \nng-change=\"vmd.preregister($event)\" placeholder=\"Username\" maxlength=\"15\" minlength=\"5\" translate \ntranslate-attr-placeholder=\"REGISTER.USERNAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Nome utente è richiesto</span></div><ng-message class=\"help-block\" when=\"unique\">\n<span>Nome utente già in uso</span></ng-message><div ng-message=\"minlength\"><span>\nIl nome utente deve essere di almeno 5 caratteri.</span></div><div ng-message=\"maxlength\"><span>\nIl nome utente deve essere al massimo di 15 caratteri.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Password</label><input type=\"password\" \nname=\"password\" ng-model=\"vmd.persondata.password\" placeholder=\"Password\" minlength=\"8\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password obbligatoria</span>\n</div><div ng-message=\"minlength\"><span>La password deve essere di almeno 8 caratteri.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Password conferma</label><input \ntype=\"password\" name=\"passwordc\" ng-model=\"vmd.persondata.passwordc\" placeholder=\"Password conferma\" \nng-change=\"vmd.resetConfirmpass($event)\" required><div ng-messages=\"registerForm.passwordc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password di conferma è obbligatoria.</span></div><div ng-message=\"passwordVerify\"><span>\nPassword di conferma non coincide</span></div></div></md-input-container></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"button\" class=\"md-raised submit-button\" aria-label=\"BACK_LOGIN\" \nui-sref=\"app.sprardb_auth_login\" ng-show=\"vmd.showfarebut2\">TORNA LOGIN</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CONTROLLACODICE\" ng-click=\"vmd.checkCodice($event)\" \nng-show=\"vmd.showfarebut2\">CONTROLLA CODICE</md-button><md-button type=\"button\" class=\"md-raised md-accent md-primary\" \nng-disabled=\"registerForm.$valid\" aria-label=\"INDIETRO\" ng-click=\"vmd.indietro($event)\" ng-show=\"vmd.showfarebut1\">\nINDIETRO</md-button><md-button type=\"submit\" ng-show=\"vmd.showfarebut1\" class=\"md-raised md-accent md-primary\" \naria-label=\"FORWARD\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" ng-click=\"vmd.register($event)\" \nng-show=\"vmd.showfarebut1\">REGISTRAMI</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogPersoneForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"persone Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Operatori collegati</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"modifica operatore\" ng-if=\"!vmd.isnewpersona && !vmd.newlink\">\n<md-content class=\"md-padding\"><span class=\"text-boxed\">{{vmd.progetto_nome}}</span> collegato con <span \nclass=\"text-boxed\">{{vmd.persona_nome}}</span><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.delete()\">\n<md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button>\n<h2 class=\"no-padding\"><strong>Cerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Ricerca operatore per cognome, città ed ente\n</label><input type=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\"></md-input-container></div><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\" \nng-selected=\"vmd.persona_id == persona.id\"><small><strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nel progetto</label>\n<md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\"><md-option ng-repeat=\"ruolo in vmd.allruolo\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small \nclass=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.save()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" flex>\nSALVA</md-button></div></form></md-content></md-tab><md-tab label=\"inserisci operatore\" \nng-if=\"!vmd.isnewpersona && vmd.newlink\"><md-content class=\"md-padding\"><h2 class=\"no-padding\"><strong>\nCerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca operatore per cognome, città ed ente</label><input \ntype=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\"></md-input-container></div><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\"><small>\n<strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nel progetto</label>\n<md-select ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\"><md-option ng-repeat=\"ruolo in vmd.allruolo\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small \nclass=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.save()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" flex>\nSALVA</md-button></div></form></md-content></md-tab><md-tab label=\"crea nuovo operatore\" \nng-if=\"vmd.isnewpersona && !vmd.newlink\"><md-content class=\"padding-16\"><form name=\"personaNForm\" novalidate>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>ANAGRAFICA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label ng-class=\"{\'md-warn-fg\': (personaNForm.cognone.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vmd.persona.cognome\" placeholder=\"Cognome\" required><div ng-messages=\"personaNForm.cognome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input \ntype=\"text\" name=\"nome\" ng-model=\"vmd.persona.nome\" placeholder=\"Nome\" required><div \nng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso</md-select-label><md-select name=\"sesso\" \nng-model=\"vmd.persona.sesso\" required><md-option value=\"M\"><small><b>MASCHILE</b></small></md-option><md-option \nvalue=\"F\"><small><b>FEMMINILE</b></small></md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codicefiscale.$invalid)}\">Codice Fiscale</label><input type=\"text\" \nname=\"codicefiscale\" ng-model=\"vmd.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\" \nrequired><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (personaNForm.telefono.$invalid)}\">Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vmd.persona.telefono\" placeholder=\"Telefono\" class=\"font-size-12\" required><div \nng-messages=\"personaNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email</label><input type=\"email\" name=\"email\" \nng-model=\"vmd.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\" required \nng-change=\"vmd.checkEmail($event)\"><div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n<ng-message class=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span>\n</ng-message></div></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>RUOLI\n</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-16 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.progettoruolo.$invalid)}\">Ruolo nel progetto</md-select-label><md-select \nname=\"progettoruolo\" ng-model=\"vmd.ruolosSelected\" multiple=\"multiple\" required><md-option \nng-repeat=\"ruolo in vmd.allruolo\" ng-value=\"ruolo.id\"><small>{{ruolo.descrizione}}</small></md-option></md-select><div \nng-messages=\"personaNForm.progettoruolo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il ruolo è richiesto\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-16 margin-top-4\"><md-select-label\n ng-class=\"{\'md-warn-fg\': (personaNForm.personaruolo.$invalid)}\">Ruolo generale</md-select-label><md-select \nname=\"personaruolo\" ng-model=\"vmd.ruolosSelected2\" multiple=\"multiple\" required><md-option \nng-repeat=\"ruolo in vmd.allpersonaruolo\" ng-value=\"ruolo.id\"><small><strong>{{ruolo.descrizione}}</strong>\n ({{ruolo.gruppo}})</small></md-option></md-select><div ng-messages=\"personaNForm.personaruolo.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il ruolo generale è richiesto</span></div></div></md-input-container></div></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>RESIDENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Regione\n</md-select-label><md-select name=\"reg\" ng-model=\"vmd.persona.codRegione\" \nng-change=\"vmd.caricaProvince(vmd.persona.codRegione)\"><md-option ng-repeat=\"regione in vmd.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia</md-select-label>\n<md-select name=\"prov\" ng-model=\"vmd.persona.codProvincia\" ng-disabled=\"!vmd.persona.codRegione\" \nng-change=\"vmd.caricaComuni(vmd.persona.codProvincia)\"><md-option ng-repeat=\"provincia in vmd.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vmd.persona.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune\n</md-select-label><md-select name=\"com\" ng-model=\"vmd.persona.codComune\" ng-disabled=\"!vmd.persona.codProvincia\">\n<md-option ng-repeat=\"istat in vmd.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Indirizzo</label>\n<input type=\"text\" name=\"indirizzo\" ng-model=\"vmd.persona.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\">\n</md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vmd.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>NASCITA</b></small>\n</md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><md-select-label>Regione</md-select-label><md-select name=\"reg2\" ng-model=\"vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaProvince2(vmd.persona.nascita.codRegione)\"><md-option ng-repeat=\"regione in vmd.regiones2\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.nascita.codRegione\">{{regione.regione}}</md-option>\n</md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia\n</md-select-label><md-select name=\"prov2\" ng-model=\"vmd.persona.nascita.codProvincia\" \nng-disabled=\"!vmd.persona.nascita.codRegione\" ng-change=\"vmd.caricaComuni2(vmd.persona.nascita.codProvincia)\">\n<md-option ng-repeat=\"provincia in vmd.provincias2\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.nascita.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com2\" ng-model=\"vmd.persona.codComuneNascita\" ng-disabled=\"!vmd.persona.nascita.codProvincia\"><md-option \nng-repeat=\"istat in vmd.istats2\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComuneNascita\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Nazione\n</md-select-label><md-select name=\"nazionalita\" ng-model=\"vmd.persona.codNazionalita\"><md-option \nng-repeat=\"naz in vmd.nazionalitas\" value=\"{{naz.id}}\" ng-selected=\"naz.id == vmd.persona.codNazionalita\"><small>\n{{naz.descrizione}}</small></md-option></md-select></md-input-container><div flex><md-datepicker \nng-model=\"vm.progetto.dataNascita2\" md-placeholder=\"Data di Nascita\" ng-required=\"false\" flex></md-datepicker></div>\n</div></div><div layout=\"row\" class=\"margin-top-16\"><span \nng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" ng-click=\"vmd.save()\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"personaNForm.$invalid\" aria-label=\"salva\" flex>SALVA</md-button>\n</div></form></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogPersoneNewForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"persone Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Ruoli Ambiti e Incarichi</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"modifica\" ng-if=\"!vmd.isnewpersona && !vmd.newlink\"><md-content \nclass=\"md-padding\"><span class=\"text-boxed\">{{vmd.progetto_nome}}</span> collegato con <span class=\"text-boxed\">\n{{vmd.persona_nome}}</span><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.delete()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\" \nng-selected=\"vmd.persona_id == persona.id\"><span><strong>{{persona.cognome|uppercase}} {{persona.nome|uppercase}}\n</strong></span></md-option></md-select></md-input-container></div><div layout=\"column\" \nng-repeat=\"p in vmd.progetti_collegati\"><div layout=\"row\"><small flex><b>{{p.nome|uppercase}}</b></small><md-checkbox \nflex ng-model=\"vmd.persona_has_progetto.accessPermission\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Accesso\">\n<small>Accesso consentito</small></md-checkbox></div><div layout=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><md-select-label>Ruolo nel progetto selezionato</md-select-label><md-select \nng-model=\"vmd.php[p.id]\" multiple=\"multiple\" aria-label=\"r{{p.id}}\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloprogettos\" ng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><md-select-label>\nAmbito operativo nel progetto selezionato</md-select-label><md-select ng-model=\"vmd.php[p.id]\" multiple=\"multiple\" \naria-label=\"a{{p.id}}\"><md-option ng-repeat=\"ruolo in vmd.personaruoloambitos\" ng-value=\"ruolo.id\">\n{{ruolo.descrizione}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" \nclass=\"margin-bottom-4\"><small>Ruoli e ambiti associati ad altri progetti (non modificabili)</small> <small \nlayout=\"row\" ng-repeat=\"item in vmd.persona.altriProgetti | orderBy: \'progetto_id\'\"><b>\n{{item.personaRuolo.descrizione}}</b>&nbsp;(<span class=\"md-accent-fg\">{{item.progetto.nome}}</span>)</small></div><div\n layout=\"row\" class=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\">\n<small class=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.savenew()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" \nflex>SALVA</md-button></div></form></md-content></md-tab><md-tab label=\"associa\" \nng-if=\"!vmd.isnewpersona && vmd.newlink\"><md-content class=\"md-padding\"><h2 class=\"no-padding margin-bottom-4\"><strong>\nCerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" class=\"margin-top-16\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca operatore per cognome, città ed ente</label><input \ntype=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il cognome da cercare\" aria-label=\"\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Comune ente collegato</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.ricerca[\'istats-comune\']\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" \nplaceholder=\"Inserisci il comune da cercare\" aria-label=\"\"></md-input-container></div><div layout=\"row\" \nclass=\"margin-top-8\"><md-input-container flex class=\"margin-bottom-0\"><label>Codice Fiscale</label><input type=\"text\" \nname=\"nome\" ng-model=\"vmd.ricerca.codiceFiscale\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" \nplaceholder=\"Inserisci il codice fiscale da cercare\" aria-label=\"\"></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Nascita<sup>*</sup></label><md-datepicker \nclass=\"md-block\" name=\"dataNascita\" ng-model=\"vmd.dataNascitaB\" md-placeholder=\"Data di Nascita\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\"></md-datepicker></div></div><form name=\"personaForm\" \nnovalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\">\n<label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}</span>]</label><md-select name=\"nome\" \nng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" aria-label=\"nome persona selezionato\" \naria-label=\"\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\"><span><strong>\n{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</span></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nel progetto</label>\n<md-select ng-model=\"vmd.php[vmd.progetto_id]\" multiple=\"multiple\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloprogettos\" ng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"margin-top-16\"><span \nng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" ng-click=\"vmd.savenew()\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" flex>SALVA</md-button>\n</div></form></md-content></md-tab><md-tab label=\"inserisci\" ng-if=\"vmd.isnewpersona && !vmd.newlink\"><md-content \nclass=\"padding-16\"><form name=\"personaNForm\" novalidate><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nANAGRAFICA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" \nflex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.cognone.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vmd.persona.cognome\" placeholder=\"Cognome\" required aria-label=\"cognome\"><div \nng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.persona.nome\" placeholder=\"Nome\" required aria-label=\"\"><div ng-messages=\"personaNForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vmd.persona.sesso\" required aria-label=\"sesso\"><md-option \nvalue=\"M\"><small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codicefiscale.$invalid)}\">Codice Fiscale</label><input type=\"text\" \nname=\"codicefiscale\" ng-model=\"vmd.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\" \nrequired aria-label=\"codicefiscale\" ng-change=\"vmd.checkCF()\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Codice fiscale non valido</span></div><div \nng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div><div ng-message=\"md-minlength\"><span>\nDeve essere lungo 16 caratteri</span></div><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div><div\n ng-if=\"!vmd.validcf\" class=\"md-warn-fg\"><small>Una persona con questo codice fiscale è già presente in banca dati\n</small></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label ng-class=\"{\'md-warn-fg\': (personaNForm.telefono.$invalid)}\">\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vmd.persona.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" required aria-label=\"telefono\"><div ng-messages=\"personaNForm.telefono.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vmd.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\" required ng-change=\"vmd.checkEmail($event)\" aria-label=\"email\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span></ng-message></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nINCARICO / FUNZIONE, RUOLI e AMBITI OPERATIVI</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\" \nng-repeat=\"indice in vmd.indexEnte\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-4 margin-top-4\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.phe.$invalid)}\">Nome Ente\n</md-select-label><md-select name=\"phe\" ng-model=\"vmd.phe[indice].ente_id\" required fle aria-label=\"ente\"><md-option \nng-repeat=\"item in vmd.enti_collegati\" ng-value=\"item.id\"><div layout=\"column\"><b>{{item.nome|uppercase}}</b> <small>\n<b>Tipo:</b> {{item.entetipo.descrizione|uppercase}}, <b>Ruolo: </b><span ng-repeat=\"r in item.enteruolos\">\n{{r.descrizione}},</span></small></div></md-option></md-select><div ng-messages=\"personaNForm.phe.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto il primo incarico</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.incarico.$invalid)}\">Incarico Funzione</md-select-label><md-select \nname=\"incarico\" ng-model=\"vmd.phe[indice].ruolo_id\" multiple=\"multiple\" required aria-label=\"incarico\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloentes\" ng-value=\"ruolo.id\" \nng-disabled=\"(!(vmd.api.isAdmin || vmd.api.isAccoglienza) && ruolo.id == 26) || (vmd.phe[0].ruolo_id.length >= 1 && vmd.phe[0].ruolo_id.indexOf(ruolo.id) == -1 && !(vmd.api.isAdmin || vmd.api.isAccoglienza))\">\n<div layout=\"column\"><small><strong>{{ruolo.descrizione|uppercase}}</strong> </small><span>&nbsp;</span></div>\n</md-option></md-select><div ng-messages=\"personaNForm.incarico.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesto il primo incarico</span></div></div></md-input-container><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"-\" ng-if=\"indice > 0\" \nng-click=\"vmd.aggrimuoviente(indice)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></div></div><small \nng-if=\"(vmd.api.isAdmin || vmd.api.isAccoglienza)\" ng-click=\"vmd.aggrimuoviente()\" class=\"text-boxed cursor-pointer\"><b\n class=\"cursor-pointer\">+ AGGIUNGI INCARICO</b></small><br><br><div layout=\"row\" class=\"margin-top-4\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><label>\nNome Progetto</label><input type=\"text\" name=\"pro\" laceholder=\"pro\" class=\"font-size-12\" value=\"{{vmd.progetto_nome}}\" \naria-label=\"pro\" disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-4 margin-top-4\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.personaruolo.$invalid)}\">\nRuolo nel progetto</md-select-label><md-select name=\"personaruolo\" ng-model=\"vmd.php[0].ruolo_id\" multiple=\"multiple\" \nrequired aria-label=\"personaruolo\"><md-option ng-repeat=\"ruolo in vmd.personaruoloprogettos\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.php[0].ruolo_id.length >= 2 && vmd.php[0].ruolo_id.indexOf(ruolo.id) == -1)\"><div layout=\"column\">\n<small><strong>{{ruolo.descrizione|uppercase}}</strong></small></div></md-option></md-select><div \nng-messages=\"personaNForm.personaruolo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto ruolo</span></div><div ng-message=\"min\"><span>Minimo 1 ruolo</span></div><div ng-message=\"max\"><span>\nMassimo 2 ruoli</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-4 margin-top-4\">\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.ambitoruolo.$invalid)}\">Ambito operativo nel progetto\n</md-select-label><md-select name=\"ambitoruolo\" ng-model=\"vmd.php[1].ruolo_id\" multiple=\"multiple\" required \naria-label=\"ambitoruolo\"><md-option ng-repeat=\"ruolo in vmd.personaruoloambitos\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.php[1].ruolo_id.length >= 2 && vmd.php[1].ruolo_id.indexOf(ruolo.id) == -1)\"><div layout=\"column\">\n<small><strong>{{ruolo.descrizione|uppercase}}</strong></small></div></md-option></md-select><div \nng-messages=\"personaNForm.ambitoruolo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto ruolo</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-4\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.studi_id.$invalid)}\">Titolo di studi</md-select-label><md-select \nname=\"studi_id\" ng-model=\"vmd.persona.studi_id\" aria-label=\"studi_id\"><md-option ng-repeat=\"item in vmd.personastudis\" \nng-value=\"item.id\"><div layout=\"column\"><small><strong>{{item.descrizione|uppercase}}</strong></small></div>\n</md-option></md-select><div ng-messages=\"personaNForm.studi_id.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Titolo studi richiesto</span></div></div></md-input-container></div></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>RESIDENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Regione\n</md-select-label><md-select name=\"reg\" ng-model=\"vmd.persona.codRegione\" \nng-change=\"vmd.caricaProvince(vmd.persona.codRegione)\" aria-label=\"regione\"><md-option \nng-repeat=\"regione in vmd.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<md-select-label>Provincia</md-select-label><md-select name=\"prov\" ng-model=\"vmd.persona.codProvincia\" \nng-disabled=\"!vmd.persona.codRegione\" ng-change=\"vmd.caricaComuni(vmd.persona.codProvincia)\" aria-label=\"provncia\">\n<md-option ng-repeat=\"provincia in vmd.provincias\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com\" ng-model=\"vmd.persona.codComune\" ng-disabled=\"!vmd.persona.codProvincia\" aria-label=\"comune\"><md-option \nng-repeat=\"istat in vmd.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Indirizzo</label>\n<input type=\"text\" name=\"indirizzo\" ng-model=\"vmd.persona.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\" \naria-label=\"indirizzi\"></md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vmd.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\" \naria-label=\"cap\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\">\n<span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.\n</span></div></div></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nNASCITA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Regione</md-select-label><md-select name=\"reg2\" \nng-model=\"vmd.persona.nascita.codRegione\" ng-change=\"vmd.caricaProvince2(vmd.persona.nascita.codRegione)\" \naria-label=\"regione\"><md-option ng-repeat=\"regione in vmd.regiones2\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vmd.persona.nascita.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia</md-select-label>\n<md-select name=\"prov2\" ng-model=\"vmd.persona.nascita.codProvincia\" ng-disabled=\"!vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaComuni2(vmd.persona.nascita.codProvincia)\" aria-label=\"prov\"><md-option \nng-repeat=\"provincia in vmd.provincias2\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.nascita.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com2\" ng-model=\"vmd.persona.codComuneNascita\" ng-disabled=\"!vmd.persona.nascita.codProvincia\" \naria-label=\"comune\"><md-option ng-repeat=\"istat in vmd.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vmd.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Nazione</md-select-label><md-select name=\"nazionalita\" \nng-model=\"vmd.persona.codNazionalita\" aria-label=\"naz\"><md-option ng-repeat=\"naz in vmd.nazionalitas\" \nvalue=\"{{naz.id}}\" ng-selected=\"naz.id == vmd.persona.codNazionalita\"><small>{{naz.descrizione}}</small></md-option>\n</md-select></md-input-container><div flex><md-datepicker ng-model=\"vm.progetto.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex aria-label=\"nascita\"></md-datepicker></div></div></div><div \nlayout=\"row\" class=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\">\n<small class=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.savenew()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaNForm.$invalid\" aria-label=\"salva\" \nflex>SALVA</md-button></div></form></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogProfiloNewForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"Profilo Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Operatori collegati</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"crea nuovo operatore\"><md-content class=\"padding-16\"><form \nname=\"personaNForm\" novalidate><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.username.$invalid)}\">\nUsername</label><input type=\"text\" name=\"username\" ng-model=\"vmd.user.username\" ng-change=\"vmd.resetErrors()\" \nplaceholder=\"username\" required aria-label=\"username\"><div ng-messages=\"personaNForm.username.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Richiesto</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nNome utente già esistente</span></ng-message></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label ng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email</label><input type=\"text\" name=\"email\" \nng-model=\"vmd.user.email\" placeholder=\"email\" required aria-label=\"email\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"vmd.resetErrors()\"><div ng-messages=\"personaNForm.email.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Email è richiesta</span></div><div ng-message=\"pattern\"><span>\nEmail non è un indirizzo email valido</span></div><ng-message class=\"help-block\" when=\"unique\"><span>Email già esiste\n</span></ng-message></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.password.$invalid)}\">Email</label><input type=\"password\" name=\"password\" \nng-model=\"vmd.user.password\" placeholder=\"password\" required aria-label=\"password\" minlength=\"8\"><div \nng-messages=\"personaNForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password richiesta</span>\n</div><div ng-message=\"minlength\"><span>Password troppo corta.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Password (Conferma)</label><input type=\"password\" \nname=\"passwordc\" ng-model=\"vmd.user.passwordc\" placeholder=\"Password (Conferma)\" \nng-change=\"vmd.resetConfirmpass($event)\" required><div ng-messages=\"registerForm.passwordc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password (Conferma) è richiesta</span></div><div ng-message=\"passwordVerify\"><span>\nPassword (Conferma) non corrisponde</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Profilo</label><md-select \nng-model=\"vmd.user.gruppo_id\" multiple=\"multiple\" name=\"gruppo_id\" required><md-option ng-repeat=\"item in vmd.gruppi\" \nng-value=\"item.id\">{{item.gruppo}}</md-option></md-select><div ng-messages=\"personaNForm.gruppo_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\"><small \nclass=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div></form></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"button\" ng-click=\"vmd.createuser()\" class=\"send-button md-accent md-raised\" \nng-if=\"vmd.isnewuser\" ng-disabled=\"registerForm.$invalid\" aria-label=\"SAVE\">SALVA</md-button><md-button type=\"button\" \nng-click=\"vmd.changepassword()\" class=\"send-button md-accent md-raised\" ng-if=\"!vmd.isnewuser\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" aria-label=\"SAVE\">CAMBIA PASSWORD</md-button><md-button \ntype=\"button\" ng-click=\"vmd.disableuser()\" class=\"send-button md-accent md-secondary\" ng-if=\"!vmd.isnewuser\" \naria-label=\"DISAB\">{{(vmd.user.status===10)?\"DISABILITA\":\"ABILITA\"}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogProgettiForm.html","<md-dialog aria-label=\"\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Seleziona Progetti</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"form-wrapper\"><form \nname=\"vmd.projectSelectionForm\" class=\"md-inline-form\" novalidate><div layout=\"row\"><div layout=\"column\" flex=\"50\">\n<md-input-container><label>Seleziona le regioni</label><md-select name=\"regioni\" ng-model=\"vmd.selectedRegions\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\" ng-change=\"vmd.getProvinces(vmd.selectedRegions)\">\n<md-option ng-value=\"{id: \'Tutti\'}\">Seleziona tutti</md-option><md-option ng-value=\"region\" \nng-repeat=\"region in vmd.regions\">{{ region.regione }}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"50\"><md-input-container><label>Seleziona le province</label><md-select \nng-model=\"vmd.selectedProvinces\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-value=\"{id: \'Tutti\'}\">Seleziona tutte</md-option><md-option ng-repeat=\"province in vmd.provincesByRegion\" \nng-value=\"province\">{{ province.provincia }}</md-option></md-select></md-input-container></div></div><div layout=\"row\">\n<div layout=\"column\" flex=\"60\"><md-input-container><label>Seleziona Categoria di Progetto</label><md-select \nng-model=\"vmd.selectedAccoglienza\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-value=\"{id: \'Tutti\'}\">Seleziona tutte</md-option><md-option ng-value=\"accoglienza\" \nng-repeat=\"accoglienza in vmd.accoglienza\">{{ accoglienza.descrizione }}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"30\"><md-input-container><label>Progetti Attivi</label><md-select \nng-model=\"vmd.attivo\"><md-option ng-value=\"null\">TUTTI</md-option><md-option ng-value=\"1\">SI</md-option><md-option \nng-value=\"0\">NO</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"10\" \nlayout-align=\"center center\"><md-button ng-click=\"vmd.resetForm()\" class=\"md-icon-button md-secondary\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button></div>\n</div><md-divider></md-divider><div layout=\"row\"><div layout=\"column\" flex=\"50\"><md-autocomplete \nmd-floating-label=\"Ricerca un progetto per nome o codice ministero\" md-no-cache=\"1\" md-selected-item=\"vmd.progetto\" \nmd-selected-item-change=\"vmd.aggiungiProgetto(progetto)\" md-search-text-change=\"vmd.cambiaStatoProgetti()\" \nmd-search-text=\"vmd.nomeProgetto\" md-items=\"progetto in vmd.listProgetti.$promise\" md-item-text=\"progetto.nome\" \nmd-min-length=\"2\" ng-model-options=\"{debounce: 500, trackBy: \'$value.id\'}\"><md-item-template><span \nmd-highlight-text=\"vmd.nomeProgetto\" md-highlight-flags=\"i\">{{progetto.nome}} - {{progetto.codiceMinistero}}</span>\n</md-item-template></md-autocomplete></div><div layout=\"column\" flex=\"50\"><md-input-container flex><label>\nMostra solo progetti aggiuntivi:</label><md-select ng-model=\"vmd.selectedStatoProgetti\" \nng-change=\"vmd.cambiaStatoProgetti()\"><md-option ng-value=\"null\">Tutti</md-option><md-option ng-value=\"1\">Solo Attivi\n</md-option><md-option ng-value=\"0\">Solo Disattivi</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\"><div layout=\"column\" flex=\"90\"><md-input-container flex><label>Progetti aggiuntivi</label><md-select \nng-model=\"vmd.selectedProgetti\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-value=\"progetto\" ng-repeat=\"progetto in vmd.progetti\">{{progetto.nome}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"10\" layout-align=\"center center\"><md-button ng-click=\"vmd.resetProgetti()\" \nclass=\"md-icon-button md-secondary\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>\nCancella</span></md-tooltip></md-button></div></div></form><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between\" flex><h2>Periodi di rendicontazione</h2></div><form novalidate name=\"vmd.periodoForm\"><div\n layout=\"row\" layout-align=\"space-around center\"><md-input-container flex><label>Anno</label><md-select \nng-model=\"vmd.periodiRendicontazione\" ng-model-options=\"{trackBy: \'$value.anno\'}\" multiple=\"multiple\"><md-option \nng-value=\"{anno:\'Tutti\'}\">Tutti</md-option><md-option ng-repeat=\"annoRendicontazioni in vmd.anni\" \nng-value=\"annoRendicontazioni\">{{annoRendicontazioni.anno}}</md-option></md-select></md-input-container></div></form>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vmd.salvaDati()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"projectSelectionForm.$invalid || (vmd.selectedRegions.length > 0 && vmd.selectedProvinces.length <= 0)\">\nSALVA<md-tooltip><span>Salva</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogRegisterForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"Profilo Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 ng-if=\"vm.registerdata.isnew\">Nuovo profilo utente</h2><h2 ng-if=\"!vm.registerdata.isnew\">\nModifica profilo utente</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 540px\" \nclass=\"padding padding-top-8\"><form name=\"registerForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<div ng-messages=\"registerForm\" role=\"alert\" multiple=\"multiple\"><div ng-repeat=\"(k,error) in vm.errors\" \nlayout=\"column\"><span><small>{{error}}</small></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float show-errors ng-if=\"vm.registerdata.isnew\"><label>Nome utente</label><input \nname=\"username\" ng-model=\"vm.registerdata.username\" placeholder=\"Nome utente\" required ng-disabled=\"vm.disabled\" \nng-change=\"vm.resetErrors()\"><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Nome utente richiesto</span></div><ng-message class=\"help-block\" when=\"unique\"><span>Nome utente già esistente\n</span></ng-message></div></md-input-container><md-input-container class=\"md-block\" md-no-float show-errors \nng-if=\"!vm.registerdata.isnew\"><label>Nome utente</label><input name=\"username\" ng-model=\"vm.registerdata.username\" \nng-disabled=\"true\"></md-input-container><div layout=\"row\"><md-input-container flex><label>Password</label><input \ntype=\"{{vm.passwordvisible}}\" name=\"password\" ng-model=\"vm.registerdata.password\" placeholder=\"Password\" minlength=\"8\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword richiesta</span></div><div ng-message=\"minlength\"><span>Password troppo corta.</span></div></div>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"vm.passwordvisible\" aria-label=\"Checkbox 2\" \nng-true-value=\"\'text\'\" ng-false-value=\"\'password\'\" flex=\"20\"><small>Mostra</small></md-checkbox></md-input-container>\n</div><md-input-container class=\"md-block\" md-no-float><label>Password (Conferma)</label><input \ntype=\"{{vm.passwordvisible}}\" name=\"passwordc\" ng-model=\"vm.registerdata.passwordc\" placeholder=\"Password (Conferma)\" \nng-change=\"vm.resetConfirmpass($event)\" required><div ng-messages=\"registerForm.passwordc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password (Conferma) è richiesta</span></div><div ng-message=\"passwordVerify\"><span>\nPassword (Conferma) non corrisponde</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float ng-if=\"vm.registerdata.isnew\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.registerdata.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required ng-disabled=\"vm.disabled\" \nng-change=\"vm.resetErrors()\"><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email è richiesta</span></div><div ng-message=\"pattern\"><span>\nEmail non è un indirizzo email valido</span></div><ng-message class=\"help-block\" when=\"unique\"><span>Email già esiste\n</span></ng-message></div></md-input-container></form><form name=\"registerForm2\" novalidate><md-input-container \nclass=\"md-block\" md-no-float ng-if=\"vm.isAdmin\"><label>Gruppo di appartenenza</label><md-select name=\"gruppo_id\" \nng-model=\"vm.registerdata.gruppo_id\" multiple=\"multiple\" required ng-change=\"vm.modificag = true\"><md-option \nng-repeat=\"item in vm.gruppi\" value=\"{{item.id}}\"><small><b>{{item.gruppo}}</b></small></md-option></md-select><div \nng-messages=\"registerForm2.gruppo_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" \nng-click=\"vm.createuser()\" class=\"send-button md-accent md-raised\" ng-if=\"vm.registerdata.isnew && vm.isAdmin\" \nng-disabled=\"registerForm.$invalid\" aria-label=\"SAVE\">SALVA</md-button><md-button type=\"button\" \nng-click=\"vm.changepassword()\" class=\"send-button md-accent md-raised\" ng-if=\"!vm.registerdata.isnew\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" aria-label=\"SAVE\">CAMBIA PASSWORD e SALVA</md-button>\n<md-button type=\"button\" ng-click=\"vm.changeGruop()\" class=\"send-button md-accent md-raised\" \nng-if=\"!vm.registerdata.isnew\" ng-disabled=\"registerForm2.$invalid || registerForm2.$pristine\" aria-label=\"SAVE\">\nCAMBIA GRUPPO DI APPARTENENZA e SALVA</md-button><md-button type=\"button\" ng-click=\"vm.disableuser()\" \nclass=\"send-button md-accent md-secondary\" ng-if=\"!vm.registerdata.isnew && vm.isAdmin\" aria-label=\"DISAB\">\n{{(vm.registerdata.status===10)?\"DISABILITA\":\"ABILITA\"}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogRevisoreForm.html","<md-dialog id=\"revisoridialog\" class=\"revisori-dialog\" aria-label=\"revisori Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{vmd.progetto.nome}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-content \nclass=\"md-padding\"><md-table-container class=\"tabellar\" ng-if=\"!vmd.isnew\"><table data-md-table><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column>COGNOME</th><th md-column>NOME</th><th md-column>ANNO</th><th md-column>ATTIVO</th><th md-column \nstyle=\"padding-right:8px;text-align: right\" ng-if=\"!vm.isReadOnly\"></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.progetto.revisori\" \nng-class=\"{\'md-grey-200-bg\': item.persona.user.status !== 10 || item.attivo == 0}\"><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.persona.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.persona.nome | uppercase}}</td><td md-cell>{{item.anno}}</td><td \nmd-cell><div layout=\"column\"><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px;padding-right:8px\" \nng-if=\"item.attivo == 0\"></md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px;padding-right:8px\" \nng-if=\"item.attivo == 1\"></md-icon></div></td><td md-cell style=\"padding-right:8px;text-align: right\" \nng-if=\"!vmd.isReadOnly\"><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.dissocia(item.anno)\" \nng-if=\"item.attivo == 1\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.associa(item.anno)\" \nng-if=\"item.attivo == 0\"><md-icon md-font-icon=\"icon-plus-box orange-700-fg\"></md-icon><md-tooltip><span>Associa</span>\n</md-tooltip></md-button></td></tr></tbody></table></md-table-container><div layout=\"row\" ng-if=\"vmd.isnew\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input \nplaceholder=\"Cognome\" type=\"search\" ng-model=\"vmd.searchCognome\" ng-model-options=\"{debounce: 500}\">\n</md-input-container><md-input-container md-no-float class=\"m-0\" flex><input placeholder=\"Nome\" type=\"search\" \nng-model=\"vmd.searchNome\" ng-model-options=\"{debounce: 500}\"></md-input-container><md-input-container md-no-float \nclass=\"m-0\" flex><input placeholder=\"Codice Fiscale\" type=\"search\" ng-model=\"vmd.searchCF\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div></div><form name=\"revisoreForm\" novalidate><div \nlayout=\"column\" layout-gt-md=\"row\" ng-show=\"vmd.isnew\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\">\n<label>Revisore da associare</label><md-select name=\"persona_id\" ng-model=\"vmd.persona_id\" aria-label=\"persona\">\n<md-option \nng-repeat=\"item in vmd.revisori | filter:{cognome:vmd.searchCognome,nome:vmd.searchNome,codiceFiscale:vmd.searchCF} track by item.id\" \nvalue=\"{{item.id}}\"><small><strong>{{item.nome}} {{item.cognome}}</strong></small></md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli l\'annualità da associare a</label><md-select name=\"anno\" \nng-model=\"vmd.anno\" aria-label=\"anno\" multiple=\"true\"><md-option \nng-repeat=\"anno in vmd.anniRend | filter:{\'attivo\':\'!1\'}\" value=\"{{anno.anno}}\"><small><strong>{{anno.anno}}</strong>\n</small></md-option></md-select></md-input-container></div><div layout=\"row\" class=\"margin-top-16\"><span \nng-repeat=\"(key, errors) in revisoreForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!revisoreForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><div layout=\"row\" class=\"margin-top-16\"><md-button types=\"button\" ng-click=\"vmd.associa(null)\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"revisoreForm.$invalid\" aria-label=\"salva\" flex>SALVA</md-button>\n</div></form></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogSegnalatoriNewForm.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"persone Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Incarichi nell\'ente</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"modifica\" ng-if=\"!vmd.isnewpersona && !vmd.newlink\"><md-content \nclass=\"md-padding\"><span class=\"text-boxed\">{{vmd.ente_nome}}</span> collegato con <span class=\"text-boxed\">\n{{vmd.persona_nome}}</span><md-button class=\"md-icon-button md-secondary\" ng-click=\"vmd.delete()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button><form \nname=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\" \nng-selected=\"vmd.persona_id == persona.id\"><span><strong>{{persona.cognome|uppercase}} {{persona.nome|uppercase}}\n</strong></span></md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" \nng-repeat=\"e in vmd.enti_collegati\"><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><label>Nome Ente\n</label><input type=\"text\" name=\"en\" laceholder=\"en\" class=\"font-size-12\" value=\"{{e.nome|uppercase}}\" \naria-label=\"en{{e.id}}\" disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><md-select-label>Funzione/incarico</md-select-label><md-select \nng-model=\"vmd.phe[e.id]\" multiple=\"multiple\" aria-label=\"fi{{e.id}}\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloentes\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.phe[vmd.ente_id].length == 1 && vmd.phe[vmd.ente_id].indexOf(ruolo.id) == 26)\">{{ruolo.descrizione}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" class=\"margin-bottom-4\"><small>\nIncarichi associati ad altri enti (non modificabili)</small> <small layout=\"row\" \nng-repeat=\"item in vmd.incaricosSelected_ro\"><b>{{item.ruolo}}</b></small></div><div layout=\"row\" \nclass=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small \nclass=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small \nng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></small></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.savenew()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" \nflex>SALVA</md-button></div></form></md-content></md-tab><md-tab label=\"associa\" \nng-if=\"!vmd.isnewpersona && vmd.newlink\"><md-content class=\"md-padding\"><h2 class=\"no-padding\"><strong>\nCerca nuovo collegamento</strong></h2><md-divider></md-divider><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Ricerca operatore per cognome, città ed ente</label><input \ntype=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\" aria-label=\"\"></md-input-container></div>\n<form name=\"personaForm\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.personaselezionato.id\" ng-change=\"vmd.restituisciPersona()\" \naria-label=\"nome persona selezionato\" aria-label=\"\"><md-option ng-repeat=\"persona in vmd.allpersonas\" \nvalue=\"{{persona.id}}\"><small><strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0 margin-top-4\"><label>Ruolo nell\'ente</label>\n<md-select ng-model=\"vmd.phe[vmd.ente_id]\" multiple=\"multiple\"><md-option ng-repeat=\"ruolo in vmd.personaruoloentes\" \nng-value=\"ruolo.id\" ng-disabled=\"(vmd.phe[vmd.ente_id].length == 1 && vmd.phe[vmd.ente_id].indexOf(ruolo.id) == 26)\">\n{{ruolo.descrizione}}</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"margin-top-16\"><span \nng-repeat=\"(key, errors) in personaForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" ng-click=\"vmd.savenew()\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" flex>SALVA</md-button>\n</div></form></md-content></md-tab><md-tab label=\"inserisci\" ng-if=\"vmd.isnewpersona && !vmd.newlink\"><md-content \nclass=\"padding-16\"><form name=\"personaNForm\" novalidate><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nANAGRAFICA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" \nflex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.cognone.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vmd.persona.cognome\" placeholder=\"Cognome\" required aria-label=\"cognome\"><div \nng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.persona.nome\" placeholder=\"Nome\" required aria-label=\"\"><div ng-messages=\"personaNForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vmd.persona.sesso\" required aria-label=\"sesso\"><md-option \nvalue=\"M\"><small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codicefiscale.$invalid)}\">Codice Fiscale</label><input type=\"text\" \nname=\"codicefiscale\" ng-model=\"vmd.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\" \nrequired aria-label=\"codicefiscale\" ng-change=\"vmd.checkCF()\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Codice fiscale non valido</span></div><div \nng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div><div ng-message=\"md-minlength\"><span>\nDeve essere lungo 16 caratteri</span></div><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div><div\n ng-if=\"!vmd.validcf\" class=\"md-warn-fg\"><small>Una persona con questo codice fiscale è già presente in banca dati\n</small></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label ng-class=\"{\'md-warn-fg\': (personaNForm.telefono.$invalid)}\">\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vmd.persona.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" required aria-label=\"telefono\"><div ng-messages=\"personaNForm.telefono.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vmd.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\" required ng-change=\"vmd.checkEmail($event)\" aria-label=\"email\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span></ng-message></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nINCARICO / FUNZIONE, RUOLI e AMBITI OPERATIVI</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\" \nng-repeat=\"indice in vmd.indexEnte\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-4 margin-top-4\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.phe.$invalid)}\">Nome Ente\n</md-select-label><md-select name=\"phe\" ng-model=\"vmd.phe[indice].ente_id\" required fle aria-label=\"ente\"><md-option \nng-repeat=\"item in vmd.enti_collegati\" ng-value=\"item.id\"><div layout=\"column\"><b>{{item.nome|uppercase}}</b> <small>\n<b>Tipo:</b> {{item.entetipo.descrizione|uppercase}}, <b>Ruolo: </b><span ng-repeat=\"r in item.enteruolos\">\n{{r.descrizione}},</span></small></div></md-option></md-select><div ng-messages=\"personaNForm.phe.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto il primo incarico</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.incarico.$invalid)}\">Incarico Funzione</md-select-label><md-select \nname=\"incarico\" ng-model=\"vmd.phe[indice].ruolo_id\" multiple=\"multiple\" required aria-label=\"incarico\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloentes\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.phe[indice].length == 1 && vmd.phe[indice].indexOf(ruolo.id) == 26)\"><div layout=\"column\"><small>\n<strong>{{ruolo.descrizione|uppercase}}</strong> </small><span>&nbsp;</span></div></md-option></md-select><div \nng-messages=\"personaNForm.incarico.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto il primo incarico</span></div></div></md-input-container><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"-\" ng-if=\"indice > 0\" \nng-click=\"vmd.aggrimuoviente(indice)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></div></div><small \nng-click=\"vmd.aggrimuoviente()\" class=\"text-boxed cursor-pointer\"><b class=\"cursor-pointer\">+ AGGIUNGI INCARICO</b>\n</small><br><br><div layout=\"row\" class=\"margin-top-4\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container\n flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.studi_id.$invalid)}\">Titolo di studi</md-select-label><md-select \nname=\"studi_id\" ng-model=\"vmd.persona.studi_id\" aria-label=\"studi_id\"><md-option ng-repeat=\"item in vmd.personastudis\" \nng-value=\"item.id\"><div layout=\"column\"><small><strong>{{item.descrizione|uppercase}}</strong></small></div>\n</md-option></md-select><div ng-messages=\"personaNForm.studi_id.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Titolo studi richiesto</span></div></div></md-input-container></div></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>RESIDENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Regione\n</md-select-label><md-select name=\"reg\" ng-model=\"vmd.persona.codRegione\" \nng-change=\"vmd.caricaProvince(vmd.persona.codRegione)\" aria-label=\"regione\"><md-option \nng-repeat=\"regione in vmd.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<md-select-label>Provincia</md-select-label><md-select name=\"prov\" ng-model=\"vmd.persona.codProvincia\" \nng-disabled=\"!vmd.persona.codRegione\" ng-change=\"vmd.caricaComuni(vmd.persona.codProvincia)\" aria-label=\"provncia\">\n<md-option ng-repeat=\"provincia in vmd.provincias\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com\" ng-model=\"vmd.persona.codComune\" ng-disabled=\"!vmd.persona.codProvincia\" aria-label=\"comune\"><md-option \nng-repeat=\"istat in vmd.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Indirizzo</label>\n<input type=\"text\" name=\"indirizzo\" ng-model=\"vmd.persona.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\" \naria-label=\"indirizzi\"></md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vmd.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\" \naria-label=\"cap\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\">\n<span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.\n</span></div></div></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nNASCITA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Regione</md-select-label><md-select name=\"reg2\" \nng-model=\"vmd.persona.nascita.codRegione\" ng-change=\"vmd.caricaProvince2(vmd.persona.nascita.codRegione)\" \naria-label=\"regione\"><md-option ng-repeat=\"regione in vmd.regiones2\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vmd.persona.nascita.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia</md-select-label>\n<md-select name=\"prov2\" ng-model=\"vmd.persona.nascita.codProvincia\" ng-disabled=\"!vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaComuni2(vmd.persona.nascita.codProvincia)\" aria-label=\"prov\"><md-option \nng-repeat=\"provincia in vmd.provincias2\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.nascita.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com2\" ng-model=\"vmd.persona.codComuneNascita\" ng-disabled=\"!vmd.persona.nascita.codProvincia\" \naria-label=\"comune\"><md-option ng-repeat=\"istat in vmd.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vmd.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Nazione</md-select-label><md-select name=\"nazionalita\" \nng-model=\"vmd.persona.codNazionalita\" aria-label=\"naz\"><md-option ng-repeat=\"naz in vmd.nazionalitas\" \nvalue=\"{{naz.id}}\" ng-selected=\"naz.id == vmd.persona.codNazionalita\"><small>{{naz.descrizione}}</small></md-option>\n</md-select></md-input-container><div flex><md-datepicker ng-model=\"vm.progetto.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex aria-label=\"nascita\"></md-datepicker></div></div></div><div \nlayout=\"row\" class=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\">\n<span class=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></span> <span \nng-if=\"errors.length < 10\"><span class=\"md-warn-fg\">Campi obbligatori da riempire:</span><span class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </span></span></span><span ng-if=\"!personaNForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></span></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.savenew()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaNForm.$invalid\" aria-label=\"salva\" \nflex>SALVA</md-button></div></form></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogServiziBenForm.html","<md-dialog aria-label=\"servizi Form\" id=\"dettagliop\"><form name=\"servizioForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vmd.isnew\">Modifica Servizio</h2><h2 ng-if=\"vmd.isnew\">\nNuovo Servizio</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\" style=\"max-width:800px;min-width: 500px\"><div \nng-if=\"!vmd.isnew\"><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>\nNome beneficiario</label><input type=\"text\" name=\"beneficiario_nome\" ng-model=\"vmd.beneficiario_nome\" \nplaceholder=\"Nome beneficiario\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Categoria</label><input \ntype=\"text\" name=\"cat_nome\" ng-model=\"vmd.nomecategoria\" placeholder=\"Categoria\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nNome Servizio</label><md-select name=\"servizio\" ng-model=\"vmd.selezionato.index\" \nng-change=\"vmd.selezioneItem(vmd.selezionato.index)\" disabled=\"disabled\"><md-option \nng-repeat=\"servizio in vmd.allservizi\" value=\"{{$index}}\" ng-selected=\"servizio.id == vmd.servizio_id\"><b>\n{{servizio.descrizione|uppercase}}</b><br><small>{{servizio.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"servizioForm.servizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>\nData Inizio</label><md-datepicker name=\"dataInizio\" ng-model=\"vmd.mySelezionato.dataInizio\" \nmd-placeholder=\"Data Inizio\" required flex md-max-date=\"vmd.mySelezionato.dataFine\" md-min-date=\"vmd.mySelezionato.da\" \nng-change=\"vmd.cambiaData()\"></md-datepicker><div class=\"validation-messages\" \nng-messages=\"servizioForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</div></div><div layout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>Data Fine\n</label><md-datepicker name=\"dataFine\" ng-model=\"vmd.mySelezionato.dataFine\" md-placeholder=\"Data Fine\" required flex \nmd-max-date=\"vmd.mySelezionato.a\" md-min-date=\"vmd.mySelezionato.dataInizio\" ng-change=\"vmd.cambiaData()\">\n</md-datepicker><div class=\"validation-messages\" ng-messages=\"servizioForm.dataFine.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></div></div></div><div ng-if=\"vmd.isnew\"><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Nome beneficiario</label><input type=\"text\" \nname=\"beneficiario_nome\" ng-model=\"vmd.beneficiario_nome\" placeholder=\"Nome beneficiario\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nCategoria Servizi</label><md-select name=\"serviziocategoria\" ng-model=\"vmd.serviziocategoria\" \nng-change=\"vmd.selezioneCat(vmd.serviziocategoria)\"><md-option ng-repeat=\"servizio in vmd.allcategoria\" \nvalue=\"{{servizio.id}}\"><b>{{servizio.descrizione|uppercase}}</b><br><small>{{servizio.note|uppercase}}</small>\n</md-option></md-select><div ng-messages=\"servizioForm.serviziocategoria.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container ng-if=\"vmd.noService == false\" flex><label>Nome Servizio</label><md-select \nname=\"servizio\" ng-model=\"vmd.selezionato.id\" ng-change=\"vmd.selezioneItem(vmd.selezionato.id)\" required \nng-disabled=\"!vmd.serviziocategoria\"><md-option \nng-repeat=\"servizio in vmd.allservizi|filter: {servizi_id: vmd.serviziocategoria}\" value=\"{{servizio.id}}\" \nng-if=\"servizio.servizi_id == vmd.serviziocategoria\"><b>{{servizio.descrizione|uppercase}}</b><br><small>\nin {{servizio.cat}}</small></md-option></md-select><div ng-messages=\"servizioForm.servizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container \nng-if=\"vmd.noService == true\" flex><label>Nessun servizio disponibile</label><input type=\"text\" disabled=\"disabled\">\n<div ng-messages=\"servizioForm.servizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\">\n<label>Data Inizio</label><md-datepicker name=\"dataInizio\" ng-model=\"vmd.mySelezionato.dataInizio\" \nmd-placeholder=\"Data Inizio\" required flex md-max-date=\"vmd.mySelezionato.dataFine\" md-min-date=\"vmd.mySelezionato.da\" \nng-disabled=\"vmd.noService == true\" ng-change=\"vmd.cambiaData()\"></md-datepicker><div class=\"validation-messages\" \nng-messages=\"servizioForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</div></div><div layout=\"column\" layout-gt-md=\"row\" flex><div flex class=\"datepicker-container\"><label>Data Fine\n</label><md-datepicker name=\"dataFine\" ng-model=\"vmd.mySelezionato.dataFine\" md-placeholder=\"Data Fine\" required flex \nmd-max-date=\"vmd.mySelezionato.a\" md-min-date=\"vmd.mySelezionato.dataInizio\" ng-disabled=\"vmd.noService == true\" \nng-change=\"vmd.cambiaData()\"></md-datepicker><div class=\"validation-messages\" \nng-messages=\"servizioForm.dataFine.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div><div \nng-message=\"min\"><span>Troppo piccola</span></div></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-if=\"!vmd.isnew && (vmd.api.isAdmin || vmd.api.isAccoglienza)\" \nclass=\"md-button md-secondary orange-700-fg\" ng-click=\"vmd.delete()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\">\n</md-icon>ELIMINA</md-button><md-button type=\"button\" ng-click=\"vmd.save()\" class=\"md-accent md-raised\" \nng-if=\"vmd.isnew\" aria-label=\"SAVE\" \nng-disabled=\"servizioForm.$invalid || servizioForm.$pristine || vmd.noService == true\">SALVA<md-tooltip><span>Salva\n</span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.aggiornaServizio()\" class=\"md-accent md-raised\" \naria-label=\"SAVE\" ng-if=\"!vmd.isnew\" ng-disabled=\"servizioForm.$invalid || servizioForm.$pristine\">AGGIORNA<md-tooltip>\n<span>Salva</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogServiziForm.html","<md-dialog aria-label=\"servizi Form\" id=\"dettagliop\"><form name=\"servizioForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Servizi del progetto</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 520px\" \nclass=\"no-padding\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"modifica collegamento\" \nng-if=\"!vmd.isnew && !vmd.newlink\"><md-content class=\"md-padding\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Nome Progetto</label><input type=\"text\" name=\"progetto_nome\" \nng-model=\"vmd.progetto_nome\" placeholder=\"Nome Progetto\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label>Categoria</label>\n<input type=\"text\" name=\"cat_nome\" ng-model=\"vmd.nomecategoria\" placeholder=\"Categoria\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container></div><input type=\"hidden\" ng-model=\"vmd.progettohasservizi.progetto_id\"><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Nome Servizio</label><md-select name=\"servizio\" \nng-model=\"vmd.selezionato.id\" disabled=\"disabled\"><md-option ng-repeat=\"servizio in vmd.allservizi\" \nvalue=\"{{servizio.id}}\" ng-selected=\"servizio.id == vmd.servizio_id\"><b>{{servizio.descrizione|uppercase}}</b><br>\n<small>{{servizio.note|uppercase}}</small></md-option></md-select><div ng-messages=\"servizioForm.servizio.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Anno</label><md-select name=\"anno\" \nng-model=\"vmd.progettohasservizi.anno\" required><md-option ng-repeat=\"anno in vmd.anni\" value=\"{{anno.id}}\" \nng-selected=\"anno.id == vmd.anno\" md-placeholder=\"Inserisci un anno\"><b>{{anno.id}}</b></md-option></md-select>\n</md-input-container></div></md-content></md-tab><md-tab label=\"nuovo collegamento\" ng-if=\"!vmd.isnew && vmd.newlink\">\n<md-content class=\"md-padding\"><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Nome Progetto</label><input type=\"text\" name=\"progetto_nome\" \nng-model=\"vmd.progetto_nome\" placeholder=\"Nome Progetto\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container>\n</div><input type=\"hidden\" ng-model=\"vmd.progettohasservizi.progetto_id\"><div layout=\"column\" layout-gt-md=\"row\">\n<md-input-container flex><label>Categoria Servizi</label><md-select name=\"serviziocategoria\" \nng-model=\"vmd.selezionato.servizi_id\"><md-option ng-repeat=\"servizio in vmd.allcategoria\" value=\"{{servizio.id}}\"><b>\n{{servizio.descrizione|uppercase}}</b><br><small>{{servizio.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"servizioForm.serviziocategoria.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nNome Servizio</label><md-select name=\"servizio\" ng-model=\"vmd.selezionato.id\"><md-option \nng-repeat=\"servizio in vmd.allservizi|filter: {servizi_id: vmd.selezionato.servizi_id}\" value=\"{{servizio.id}}\"><b>\n{{servizio.descrizione|uppercase}}</b><br><small>{{servizio.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"servizioForm.servizio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Anno</label>\n<md-select name=\"anno\" ng-model=\"vmd.progettohasservizi.anno\" required><md-option ng-repeat=\"anno in vmd.anni\" \nvalue=\"{{anno.id}}\" ng-selected=\"anno.id == vmd.anno\" md-placeholder=\"Inserisci un anno\"><b>{{anno.id}}</b></md-option>\n</md-select></md-input-container></div></md-content></md-tab><md-tab label=\"aggiungi servizio\" \nng-if=\"vmd.isnew && !vmd.newlink\"><md-content class=\"no-padding\"><md-content class=\"md-padding\"><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Categoria Servizi</label><md-select name=\"serviziocategoria\" \nng-model=\"vmd.servizio.servizi_id\"><md-option ng-repeat=\"servizio in vmd.allcategoria\" value=\"{{servizio.id}}\"><b>\n{{servizio.descrizione|uppercase}}</b><br><small>{{servizio.note|uppercase}}</small></md-option></md-select><div \nng-messages=\"servizioForm.serviziocategoria.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nNome Servizio</label><input type=\"text\" name=\"descrizione\" ng-model=\"vmd.servizio.descrizione\" \nplaceholder=\"Nome Servizio\" required><div ng-messages=\"servizioForm.descrizione.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Note</label><textarea ng-model=\"vmd.servizio.note\" \nmd-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea></md-input-container></div></md-content></md-content>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\"!vmd.isnew && !vmd.newlink && (vmd.api.isAdmin || vmd.api.isAccoglienza)\" \nclass=\"md-button md-secondary orange-700-fg\" ng-click=\"vmd.delete()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\">\n</md-icon>ELIMINA RELAZIONE</md-button><md-button type=\"button\" ng-click=\"vmd.save()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"(!vmd.isnew && vmd.newlink)\" aria-label=\"SAVE\" \nng-disabled=\"servizioForm.$invalid || servizioForm.$pristine || !(vmd.api.isAdmin || vmd.api.isOperatore)\">SALVA\n<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.insertnew()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"(vmd.isnew && !vmd.newlink)\" aria-label=\"SAVE\" \nng-disabled=\"servizioForm.$invalid || servizioForm.$pristine || !(vmd.api.isAdmin || vmd.api.isOperatore)\">INSERISCI\n<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vmd.aggiornaServizio()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"servizioForm.$invalid || servizioForm.$pristine || !vmd.api.user.permissions.includes(\'associa-corsi-servizi\')\" \naria-label=\"SAVE\" ng-if=\"!vmd.isnew && !vmd.newlink\">AGGIORNA<md-tooltip><span>Salva</span></md-tooltip></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogStrutturaForm.html","<md-dialog aria-label=\"dialog struttura Form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Collega Struttura\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div class=\"md-dialog-content\"><div \nclass=\"form-wrapper\" flex=\"100\"><form name=\"strutturaForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"chiave\" ng-model=\"vmd.extra.chiave\" \nplaceholder=\"Nome Campo\" required><div ng-messages=\"strutturaForm.chiave.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Nome campo è obbligatorio.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"valore\" \nng-model=\"vmd.extra.valore\" placeholder=\"Valore Campo\" required><div ng-messages=\"strutturaForm.valore.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Valore campo è obbligatorio.</span></div></div></md-input-container>\n</div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" \nng-click=\"vmd.saveExtra()\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\">SALVA<md-tooltip>\n<span>Salva</span></md-tooltip></md-button><md-button ng-if=\"!vmd.isnew\" class=\"md-icon-button md-secondary\" \nng-click=\"vmd.deleteExtra()\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella\n</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/dialogUploadForm.html","<md-dialog aria-label=\"documentiForm\" id=\"dettagliop\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nNuovo utente / Modifica utente</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 520px\" \nclass=\"padding\"><form name=\"registerForm\" novalidate><md-input-container class=\"md-block\" md-no-float show-errors>\n<label>Nome utente</label><input name=\"username\" ng-model=\"vm.registerdata.username\" \nng-change=\"vm.resetUsername($event)\" placeholder=\"Username\" translate translate-attr-placeholder=\"REGISTER.USERNAME\" \nrequired ng-disabled=\"vm.disabled\"><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div>\n<ng-message class=\"help-block\" when=\"unique\"><span translate=\"REGISTER.ERRORS.USERNAME_ALREADY_EXIST\">\nUsername already exist</span></ng-message></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<label>Password</label><input type=\"password\" name=\"password\" ng-model=\"vm.registerdata.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" minlength=\"5\" required \nng-disabled=\"vm.disabled\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span\n translate=\"REGISTER.ERRORS.SHORT\">Your entry is not long enough.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float ng-if=\"!vm.disabled\"><label>Password reinserisci</label><input \ntype=\"password\" name=\"passwordc\" ng-model=\"vm.registerdata.passwordc\" placeholder=\"Password (Confirm)\" \nng-change=\"vm.resetConfirmpass($event)\" translate translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordc.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"passwordVerify\"><span translate=\"REGISTER.ERRORS.CONFIRMPASSWORD\">Password (Confirm) didn\'t match</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><label>Email</label><input \ntype=\"email\" name=\"email\" ng-change=\"vm.resetEmail($event)\" ng-model=\"vm.registerdata.email\" placeholder=\"Email\" \ntranslate translate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required ng-disabled=\"vm.disabled\">\n<div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span translate=\"REGISTER.ERRORS.EMAIL_ALREADY_EXIST\">Email already exist</span>\n</ng-message></div></md-input-container><md-input-container class=\"md-block\" md-no-float><label>Ruolo</label><md-select\n name=\"gruppo_id\" ng-model=\"vm.registerdata.gruppo_id\" required ng-disabled=\"vm.disabled\"><md-option \nng-repeat=\"item in vm.gruppi\" value=\"{{item.id}}\">{{item.gruppo}}</md-option></md-select><div \nng-messages=\"registerForm.gruppo_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><div ng-messages=\"registerForm\" role=\"alert\" \nmultiple=\"multiple\"><div ng-show=\"registerForm.email.$error.unique || registerForm.username.$error.unique\"><p \ntranslate=\"REGISTER.ERRORS.EMAIL_ALREADY_TAKEN\">EMAIL/USERNAME ALREADY EXISTS</p></div></div></md-input-container>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.createuser()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" \naria-label=\"SAVE\">SALVA<md-tooltip><span>Salva</span></md-tooltip></md-button><md-button type=\"button\" \nng-click=\"vm.toggleuser()\" class=\"send-button md-accent md-raised\" ng-if=\"vm.disabled\" aria-label=\"SAVE\">DISABILITA\n<md-tooltip><span>Disabilita</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/generic-sidenav-ricerca.html","<div id=\"pannelloricercagenerica\"><h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-file-find\"></md-icon>\n<strong>Ricerca avanzata</strong></h3><md-divider class=\"margin-top-10\"></md-divider><div ms-scroll \nstyle=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" \nformschema=\"vm.searchForms\"></sprardb-jsonform></form></div></div>");
$templateCache.put("app/main/sprardb/form/progettoForm.html","<form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-md=\"row\"><md-input-container \nflex><input type=\"text\" name=\"nome\" ng-model=\"vm.progetto.nome\" placeholder=\"Nome Progetto\" required><div \nng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il nome del progetto è richiesto.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>\nEmail</label><input type=\"email\" name=\"email\" ng-model=\"vm.progetto.email\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"basicForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Regione\n</label><md-select name=\"reg\" ng-model=\"vm.progetto.codRegione\" required \nng-change=\"vm.caricaProvince(vm.progetto.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.progetto.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"basicForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container><md-input-container \nflex required><label>Provincia</label><md-select name=\"prov\" ng-model=\"vm.progetto.codProvincia\" \nng-disabled=\"!vm.progetto.codRegione\" ng-change=\"vm.caricaComuni(vm.progetto.codProvincia)\"><md-option \nng-repeat=\"provincia in vm.provincias\" value=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.progetto.codProvincia\">\n{{provincia.provincia}}</md-option></md-select><div ng-messages=\"basicForm.prov.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida\n</span></div></div></md-input-container><md-input-container flex required><label>Comune</label><md-select name=\"com\" \nng-model=\"vm.progetto.codComune\" ng-disabled=\"!vm.progetto.codProvincia\"><md-option ng-repeat=\"istat in vm.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.progetto.codComune\">{{istat.comune}}</md-option></md-select><div\n ng-messages=\"basicForm.com.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.progetto.indirizzo\" \nplaceholder=\"Indirizzo\"></md-input-container><md-input-container flex><label>codice Postale</label><input name=\"cap\" \nng-model=\"vm.progetto.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"basicForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Telefono</label>\n<input type=\"text\" name=\"telefono\" ng-model=\"vm.progetto.telefono\" placeholder=\"Telefono\"></md-input-container></div>\n<div layout=\"column\" layout-gt-md=\"row\" class=\"center-block\"><label class=\"small\">Data Inizio Progetto</label>\n<md-datepicker ng-model=\"vm.progetto.dataInizio\" md-placeholder=\"data Inizio\" ng-required=\"false\" flex=\"50\">\n</md-datepicker><label class=\"small\">Data Fine Progetto</label><md-datepicker ng-model=\"vm.progetto.dataFine\" \nmd-placeholder=\"data Fine\" ng-required=\"false\" flex=\"50\"></md-datepicker></div><br><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Durata complessiva</label><input type=\"number\" name=\"durata\" \nng-model=\"vm.progetto.durata\"></md-input-container><md-input-container flex><label>Budget stimato</label><input \ntype=\"number\" name=\"budget\" ng-model=\"vm.progetto.budget\"></md-input-container><md-input-container flex><label>\nOperatori impiegabili</label><input type=\"number\" name=\"operatori\" ng-model=\"vm.progetto.operatori\">\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Posti Totali</label>\n<input type=\"number\" name=\"postiTotali\" ng-model=\"vm.progetto.postiTotali\"></md-input-container><md-input-container \nflex><label>Posti Finanziati</label><input type=\"number\" name=\"postiFinanziati\" ng-model=\"vm.progetto.postiFinanziati\">\n</md-input-container><md-input-container flex><label>Posti Riservati SC</label><input type=\"number\" \nname=\"postiRiservatiSC\" ng-model=\"vm.progetto.postiRiservatiSC\"></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Posti Riservati Asilo</label><input type=\"number\" name=\"postiAsilo\" \nng-model=\"vm.progetto.postiAsilo\"></md-input-container><md-input-container flex><label>Posti Riservati Umanitari\n</label><input type=\"number\" name=\"postiUmanitari\" ng-model=\"vm.progetto.postiUmanitari\"></md-input-container>\n<md-input-container flex><label>Posti Riservati Rifugiati</label><input type=\"number\" name=\"postiRifugiati\" \nng-model=\"vm.progetto.postiRifugiati\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-button \ntype=\"button\" ng-click=\"\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\"></md-button></div>\n</form>");
$templateCache.put("app/main/sprardb/form/sidenav-ricerca.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchForms\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/form/strutturaForm.html","<md-dialog aria-label=\"Struttura dialog\" class=\"struttura-dialog\" id=\"dialogstruttura\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span ng-if=\"!vm.isnew\">Modifica </span>Struttura {{vm.struttura.nome}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\"><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI GENERALI</b></small></md-divider>\n<div layout=\"row\" class=\"margin-top-16\" flex><div ng-if=\"!vm.newStruttura || (vm.progetto_id > 0)\" layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.progetto.$invalid)}\"><b>Nome Progetto</b></label><input type=\"text\" \nname=\"progetto\" ng-model=\"vm.struttura.progettos.nome\" placeholder=\"Nome Progetto\" aria-label=\"progetto\" \nreadonly=\"readonly\" disabled=\"disabled\"></md-input-container></div><div \nng-if=\"vm.newStruttura && (vm.progetto_id == 0)\" layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (basicForm.progetto.$invalid)}\"><b>Nome Progetto</b></label>\n<md-select name=\"progetto\" ng-model=\"vm.struttura.progetto_id\" ng-change=\"vm.caricaComuni2()\" aria-label=\"progetto\">\n<md-option ng-repeat=\"progetto in vm.progettos\" value=\"{{progetto.id}}\">{{progetto.nome}}</md-option></md-select><div \nng-messages=\"basicForm.accoglienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label \nng-class=\"{\n                                \'md-warn-fg\'\n                                : (basicForm.nome.$invalid)}\">\n<b>Nome Struttura</b></label><input type=\"text\" name=\"nome\" ng-model=\"vm.struttura.nome\" placeholder=\"Nome Struttura\" \naria-label=\"nome\" required><div ng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl nome è richiesto.</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\" flex>\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.accoglienza.$invalid)}\"><b>Tipo Accoglienza</b></md-select-label><md-select \nname=\"accoglienza\" ng-model=\"vm.struttura.strutturaAccoglienza_id\" aria-label=\"accoglienza\" required><md-option \nng-repeat=\"accoglienza in vm.accoglienzas\" value=\"{{accoglienza.id}}\" \nng-selected=\"accoglienza.id == vm.struttura.strutturaAccoglienza_id\"><small>{{accoglienza.descrizione}}</small>\n</md-option></md-select><div ng-messages=\"basicForm.accoglienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.alloggio.$invalid)}\"><b>Tipo Alloggio</b></md-select-label><md-select \nname=\"alloggio\" ng-model=\"vm.struttura.strutturaAlloggio_id\" aria-label=\"alloggio\" required><md-option \nng-repeat=\"alloggio in vm.alloggios\" value=\"{{alloggio.id}}\" \nng-selected=\"alloggio.id == vm.struttura.strutturaAlloggio_id\"><small>{{alloggio.descrizione}}</small></md-option>\n</md-select><div ng-messages=\"basicForm.alloggio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span>\n</div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\" flex><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex=\"50\"><md-select-label>Regione</md-select-label><md-select \nname=\"regione\" ng-model=\"vm.struttura.istats.regione\" \nng-change=\"vm.caricaProvince(vm.struttura.istats.regione); vm.struttura.codComune = undefined;\" aria-label=\"regione\">\n<md-option ng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vm.struttura.istats.regione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container><md-input-container flex=\"50\"><md-select-label>Provincia</md-select-label><md-select \nname=\"provincia\" ng-model=\"vm.struttura.istats.provincia\" ng-disabled=\"!vm.struttura.istats.regione\" \nng-change=\"vm.caricaComuni(vm.struttura.istats.provincia); vm.struttura.codComune = undefined;\" aria-label=\"provincia\">\n<md-option ng-repeat=\"provincia in vm.provincias| filter: {codRegione:vm.struttura.istats.regione}\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.struttura.istats.provincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex=\"50\"><md-select-label \nng-class=\"{\n                                \'md-warn-fg\'\n                                        : (basicForm.com.$invalid)}\">\n<b>Comune</b></md-select-label><md-select name=\"com\" ng-model=\"vm.struttura.codComune\" \nng-disabled=\"!vm.struttura.istats.provincia\" aria-label=\"com\"><md-option ng-repeat=\"istat in vm.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.struttura.codComune\">{{istat.comune}}</md-option></md-select>\n<div ng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\" flex><md-input-container flex \nclass=\"margin-top-0\"><label ng-class=\"{\n                            \'md-warn-fg\' : (basicForm.indirizzo.$invalid)}\"><b>\nIndirizzo</b></label><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.struttura.indirizzo\" placeholder=\"Indirizzo\" \naria-label=\"indirizzo\" ng-required=\"!vm.api.isAdmin\"><div ng-messages=\"basicForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Indirizzo è richiesto.</span></div></div></md-input-container></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>POSTI STRUTTURA &AMP; ATTIVAZIONE</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-0\" flex><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.dataInizio.$invalid)}\" flex style=\"max-height: 22px\"><b>Data Inizio</b></label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataInizio\" ng-model=\"vm.struttura.dataInizio\" \nmd-placeholder=\"Data Inizio (obbligatoria)\" required md-max-date=\"vm.maxInizio\" md-min-date=\"vm.minInizio\">\n</md-datepicker><div ng-messages=\"basicForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><small><span \nclass=\"md-warn-fg\">Data inizio obbligatoria.</span></small></div><div ng-message=\"mindate\"><small><span \nclass=\"md-warn-fg\">Data troppo piccola.</span></small></div><div ng-message=\"maxdate\"><small><span class=\"md-warn-fg\">\nData troppo grande.</span></small></div></div></div><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data Fine</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataFine\" \nng-model=\"vm.struttura.dataFine\" md-placeholder=\"Data Fine (non obbligatoria)\" \nng-disabled=\"vm.struttura.beneficiariAttivi > 0 || (!(vm.api.isAdmin || vm.api.isAccoglienza) && vm.struttura.wasDataFine != null)\" \nmd-max-date=\"vm.maxFine\" md-min-date=\"vm.minFine\"></md-datepicker><div ng-messages=\"basicForm.dataFine.$error\" \nrole=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">Data fine richiesta</span></small></div><div \nng-message=\"mindate\"><small><span class=\"md-warn-fg\">Data troppo piccola.</span></small></div><div \nng-message=\"maxdate\"><small><span class=\"md-warn-fg\">Data troppo grande.</span></small></div></div></div></div><div \nlayout=\"row\" class=\"margin-top-16\" flex><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\">\n<label ng-class=\"{\n                                \'md-warn-fg\': (basicForm.posti.$invalid)}\"><b>Numero Posti</b>\n</label><input type=\"number\" name=\"posti\" ng-model=\"vm.struttura.numeroPosti\" required ng-min=\"0\" \nng-disabled=\"!vm.isnew && !(vm.api.isAdmin || vm.api.isAccoglienza)\"><div ng-messages=\"basicForm.posti.$error\" \nrole=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">Numero Posti richiesto</span></small></div><div\n ng-message=\"min\"><span class=\"md-warn-fg\">E\' possibile inserire solo un numero intero positivo.</span></div></div>\n</md-input-container><md-input-container flex=\"50\"><label>Numero Stanze</label><input type=\"number\" name=\"stanze\" \nng-model=\"vm.struttura.numeroStanze\"></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\" flex><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\" class=\"margin-top-0\"><label>\nNumero Servizi Igienici</label><input type=\"number\" name=\"operatori\" ng-model=\"vm.struttura.numeroIgienici\">\n</md-input-container><md-input-container flex=\"50\" class=\"margin-top-0\"><md-switch ng-model=\"vm.struttura.attivo\" \naria-label=\"Attivo\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"margin: 0px 0px 0px 20px\" \nng-disabled=\"(!(vm.api.isAdmin || vm.api.isAccoglienza) || (vm.parametricaricamento.caricato < vm.parametricaricamento.mincaricato) || vm.parametricaricamento.caricato == null || vm.struttura.beneficiariAttivi > 0)\">\n<small \nng-class=\"{\'disabled-text\':(!(vm.api.isAdmin || vm.api.isAccoglienza) || (vm.parametricaricamento.caricato < vm.parametricaricamento.mincaricato) || vm.parametricaricamento.caricato == null)}\">\n<b>STRUTTURA {{((!vm.struttura.attivo) ? \'NON\' : \'\')}} ATTIVA</b></small></md-switch><small \nng-if=\"vm.struttura.attivo && vm.struttura.beneficiariAttivi > 0\"><b>\nStruttura non disattivabile perchè collegata con {{vm.struttura.beneficiariAttivi}} beneficiari attivi</b></small>\n</md-input-container></div></div><div flex layout=\"column\"><div class=\"row margin-top-8\" flex>\n<sprardb-documenti-struttura ng-model=\"vm.parametricaricamento\" ng-if=\"vm.parametricaricamento.struttura_id\">\n</sprardb-documenti-struttura><span flex id=\"op\" \nstyle=\"color: rgba(0,0,0,0.38);font-size:90%;padding:0px 2px 0px 2px;border-bottom: 1px solid rgba(0,0,0,0.12);font-weight: bold;border-position: -4px;max-height: 24px;margin-top:8px\" \nng-if=\"!vm.parametricaricamento.struttura_id\">Attendo primo salvataggio</span></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-if=\"vm.view !== true\"><md-button type=\"submit\" \nng-click=\"vm.save(); vm.closeDialog()\" class=\"md-raised md-accent\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" ng-if=\"!vm.api.isReadOnly\" aria-label=\"SALVA\"><span>SALVA\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/strutturaFormMc.html","<md-dialog aria-label=\"Struttura dialog\" class=\"struttura-dialog\" id=\"dialogstruttura\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span ng-if=\"!vm.isnew\">Modifica </span>Struttura {{vm.struttura.nome}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-top-8\"><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI GENERALI</b></small></md-divider>\n<div layout=\"row\" class=\"margin-top-16\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': !basicForm.nome.$valid}\"><b>Nome Struttura</b></label><input type=\"text\" name=\"nome\" \nng-model=\"vm.struttura.nome\" placeholder=\"Nome Struttura\" aria-label=\"nome\" ng-disabled=\"vm.isDisabled(\'nome\')\" \nrequired><div ng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il nome è richiesto.\n</span></div></div></md-input-container></div><div layout=\"row\" class=\"margin-top-0\" flex><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.accoglienza.$invalid)}\"><b>Tipo Accoglienza</b></md-select-label><md-select \nname=\"accoglienza\" ng-model=\"vm.struttura.strutturaAccoglienza_id\" aria-label=\"accoglienza\" \nng-disabled=\"vm.isDisabled(\'strutturaAccoglienza_id\')\" required><md-option \nng-repeat=\"accoglienza in vm.accoglienze | filter: {esterna : vm.esterna} \" value=\"{{accoglienza.id}}\" \nng-selected=\"accoglienza.id == vm.struttura.strutturaAccoglienza_id\"><small>{{accoglienza.descrizione}}</small>\n</md-option></md-select><div ng-messages=\"basicForm.accoglienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.alloggio.$invalid)}\"><b>Tipo Alloggio</b></md-select-label><md-select \nname=\"alloggio\" ng-model=\"vm.struttura.strutturaAlloggio_id\" aria-label=\"alloggio\" \nng-disabled=\"vm.isDisabled(\'strutturaAlloggio_id\')\" required><md-option ng-repeat=\"alloggio in vm.alloggi\" \nvalue=\"{{alloggio.id}}\" ng-selected=\"alloggio.id == vm.struttura.strutturaAlloggio_id\"><small>{{alloggio.descrizione}}\n</small></md-option></md-select><div ng-messages=\"basicForm.alloggio.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\" flex>\n<md-input-container flex class=\"margin-top-0\"><md-select-label>Destinazione esclusiva struttura</md-select-label>\n<md-select name=\"destinazione\" ng-model=\"vm.struttura.destinazione\" ng-disabled=\"vm.isDisabled(\'destinazione\')\" \naria-label=\"destinazione\"><md-option ng-value=\"null\">NESSUNA</md-option><md-option \nng-repeat=\"destinazione in vm.destinazioni | filter: filtraId\" value=\"{{destinazione.id}}\" \nng-selected=\"destinazione.id == vm.struttura.destinazione\">{{destinazione.descrizione}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"margin-top-16\" flex><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\"><md-select-label ng-class=\"{\'md-warn-fg\': (basicForm.com.$invalid)}\"><b>Regione</b>\n</md-select-label><md-select name=\"regione\" ng-model=\"vm.struttura.istats.regione\" \nng-disabled=\"vm.isDisabled(\'codComune\')\" \nng-change=\"vm.caricaProvince(vm.struttura.istats.regione); vm.struttura.codComune = undefined;\" aria-label=\"regione\" \nrequired><md-option ng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vm.struttura.istats.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container><md-input-container flex=\"50\"><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.com.$invalid)}\"><b>Provincia</b></md-select-label><md-select name=\"provincia\" \nng-model=\"vm.struttura.istats.provincia\" ng-disabled=\"vm.isDisabled(\'codComune\')\" \nng-change=\"vm.caricaComuni(vm.struttura.istats.provincia); vm.struttura.codComune = undefined;\" aria-label=\"provincia\" \nrequired><md-option ng-repeat=\"provincia in vm.provincias| filter: {codRegione:vm.struttura.istats.regione}\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.struttura.istats.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex=\"50\"><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.com.$invalid)}\"><b>Comune</b></md-select-label><md-select name=\"com\" \nng-model=\"vm.struttura.codComune\" ng-disabled=\"vm.isDisabled(\'codComune\')\" aria-label=\"com\" required><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.struttura.istats.istat\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"basicForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\" flex><md-input-container flex class=\"margin-top-0\"><label \nng-class=\"{\n                            \'md-warn-fg\' : (basicForm.indirizzo.$invalid)}\"><b>Indirizzo</b></label><input \ntype=\"text\" name=\"indirizzo\" ng-model=\"vm.struttura.indirizzo\" placeholder=\"Indirizzo\" aria-label=\"indirizzo\" \nng-required=\"!vm.api.isAdmin\" ng-disabled=\"vm.isDisabled(\'indirizzo\')\"><div ng-messages=\"basicForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Indirizzo è richiesto.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex class=\"margin-top-0\"><textarea ng-if=\"vm.esterna == 0\" disabled=\"disabled\">\nINTERNA</textarea><textarea ng-if=\"vm.esterna == 1\" disabled=\"disabled\">ESTERNA</textarea></md-input-container></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>POSTI STRUTTURA &AMP; ATTIVAZIONE</b></small></md-divider>\n<div layout=\"row\" class=\"margin-top-0\" flex><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.dataInizio.$invalid)}\" flex style=\"max-height: 22px\"><b>Data Inizio</b></label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataInizio\" ng-model=\"vm.struttura.dataInizio\" \nmd-max-date=\"vm.currDate\" md-placeholder=\"Data Inizio (obbligatoria)\" ng-disabled=\"vm.isDisabled(\'dataInizio\')\" \nrequired ng-model-options=\"{timezone: \'GMT\'}\"></md-datepicker><div ng-messages=\"basicForm.dataInizio.$error\" \nrole=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">Data inizio obbligatoria.</span></small></div>\n</div></div><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Fine\n</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataFine\" ng-model=\"vm.struttura.dataFine\" \nmd-placeholder=\"Data Fine (non obbligatoria)\" ng-disabled=\"vm.isDisabled(\'dataFine\')\" \nng-model-options=\"{timezone: \'GMT\'}\" ng-change=\"vm.struttura.attivo = 0;\" md-max-date=\"vm.currDate\" \nmd-min-date=\"vm.struttura.dataInizio\"></md-datepicker><div ng-messages=\"basicForm.dataFine.$error\" role=\"alert\"><div \nng-message=\"required\"><small><span class=\"md-warn-fg\">Data fine richiesta</span></small></div><div \nng-message=\"mindate\"><small><span class=\"md-warn-fg\">Data troppo piccola.</span></small></div><div \nng-message=\"maxdate\"><small><span class=\"md-warn-fg\">Data troppo grande.</span></small></div></div></div></div><div \nlayout=\"row\" class=\"margin-top-16\" flex><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\">\n<label ng-class=\"{\n                                \'md-warn-fg\': (basicForm.posti.$invalid)}\"><b>Numero Posti</b>\n</label><input type=\"number\" name=\"posti\" ng-model=\"vm.struttura.numeroPosti\" required ng-min=\"0\" \nng-disabled=\"vm.isDisabled(\'numeroPosti\')\"><div ng-messages=\"basicForm.posti.$error\" role=\"alert\"><div \nng-message=\"required\"><small><span class=\"md-warn-fg\">Numero Posti richiesto</span></small></div><div ng-message=\"min\">\n<span class=\"md-warn-fg\">E\' possibile inserire solo un numero intero positivo.</span></div></div></md-input-container>\n<md-input-container flex=\"50\" ng-if=\"!vm.esterna\"><label>Numero Stanze</label><input type=\"number\" name=\"stanze\" \nng-model=\"vm.struttura.numeroStanze\" ng-disabled=\"vm.isDisabled(\'numeroStanze\')\"></md-input-container></div></div><div \nlayout=\"row\" class=\"margin-top-0\" flex><div layout=\"column\" layout-gt-md=\"row\" flex ng-if=\"!vm.esterna\">\n<md-input-container flex=\"50\" class=\"margin-top-0\"><label>Numero Servizi Igienici</label><input type=\"number\" \nname=\"operatori\" ng-model=\"vm.struttura.numeroIgienici\" ng-disabled=\"vm.isDisabled(\'numeroIgienici\')\">\n</md-input-container></div><div layout=\"column\" layout-align-gt-md=\"column\" flex><md-input-container flex=\"50\" \nclass=\"margin-top-0\"><md-switch ng-model=\"vm.struttura.attivo\" ng-disabled=\"vm.isDisabled(\'attivo\')\" ng-true-value=\"1\">\n<small ng-class=\"{\'disabled-text\': vm.isDisabled(\'attivo\')}\"><b>\nSTRUTTURA {{((!vm.struttura.attivo) ? \'NON\' : \'\')}} ATTIVA</b></small></md-switch><small \nng-if=\"vm.struttura.attivo && vm.struttura.numeroBeneficiariPresenti > 0\"><b>\nStruttura non disattivabile perchè collegata con {{vm.struttura.numeroBeneficiariPresenti}} beneficiari attivi</b>\n</small></md-input-container></div></div><div flex layout=\"column\" ng-if=\"!vm.esterna\"><div class=\"row\" flex>\n<sprardb-documenti-struttura ng-model=\"vm.parametricaricamento\" ng-if=\"vm.struttura_id\"></sprardb-documenti-struttura>\n<span flex id=\"op\" \nstyle=\"color: rgba(0,0,0,0.38);font-size:90%;padding:0px 2px 0px 2px;border-bottom: 1px solid rgba(0,0,0,0.12);font-weight: bold;border-position: -4px;max-height: 24px;margin-top:8px\" \nng-if=\"!vm.struttura_id\">Attendo primo salvataggio</span></div></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" ng-if=\"vm.view !== true\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"md-raised md-accent\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine || vm.api.user.gruppos[0].gruppo == \'SC-TUTOR\'\" \nng-if=\"!vm.api.isReadOnly\" aria-label=\"SALVA\"><span>SALVA</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/form/tabellar.html","");
$templateCache.put("app/main/sprardb/form/upload-dialog.html","<md-dialog id=\"uploaddialog\" class=\"upload-dialog\" aria-label=\"UploadDiaolod\"><form name=\"uploadForm\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \nng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button><h2>\nCaricamento allegati</h2><span flex></span></div></md-toolbar><md-dialog-content><div flex layout=\"column\" \nclass=\"datepicker-container\" style=\"margin-top:0px\"><label flex style=\"max-height: 22px\">Allegati al segnalato <b>\n{{vmd.segnalato.cognome|uppercase}} {{vmd.segnalato.nome|uppercase}}</b></label><div class=\"row margin-top-8\" flex>\n<input type=\"number\" ng-model=\"vmd.parametricaricamento.caricato\" min=\"{{vmd.parametricaricamento.mincaricato}}\" \nng-show=\"false\" ng-required=\"true\" name=\"min\"><sprardb-uploaddocuments2 ng-model=\"vmd.parametricaricamento\" \nng-if=\"vmd.parametricaricamento.segnalato_id\"></sprardb-uploaddocuments2></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-if=\"!vm.readonly\"><md-button type=\"button\" ng-click=\"vmd.closeDialog()\" \nclass=\"md-button md-accent md-raised\" aria-label=\"Fatto\" flex>CHIUDI</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/entes/entes.html","<div id=\"entisegnalatori\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Enti</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Enti</span><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\';vm.onSearch();\">\n</md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.deletefiltersearch(key)\"></md-icon>{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}\n</span></div><div flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\">\n</i></md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"enteTipo_id\">\nTIPO</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\"><span>CITTA</span></th><th \nmd-column md-order-by=\"email\">RECAPITI</th><th md-column md-order-by=\"attivo\" style=\"text-align: center\">ATTIVO</th><th\n md-column style=\"text-align: center\" ng-if=\"!vm.isReadOnly\">PROGETTO/RUOLO</th><th md-column \nstyle=\"text-align: center\" ng-if=\"!vm.isReadOnly\">PERSONE</th><th md-column style=\"text-align: center\" \nng-if=\"!vm.isVisitatore\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell>\n<md-button class=\"md-fab md-mini {{vm.colors[item.enteTipo_id]}}\" aria-label=\"tipos\">\n{{item.entetipo.descrizione|limitTo: 1}}<md-tooltip><span>{{item.entetipo.descrizione}}</span></md-tooltip></md-button>\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.istats.comune| uppercase}}</b><br>{{item.istats.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:20}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: center\"><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"!item.attivo\">\n</md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"item.attivo\"></md-icon></td><td md-cell \nstyle=\"text-align: center\" ng-if=\"!vm.isReadOnly\"><div layout=\"column\"><span layout=\"column\" \nng-repeat=\"pe in item.progettohasentes | filter: vm.filter\"><small><b>{{pe.progetto.nome|uppercase}}</b></small> \n<small>{{pe.ruolo|uppercase}}</small> </span><span ng-if=\"item.progettohasentes.length == 0\">N/A</span></div></td><td \nmd-cell style=\"text-align: center\" ng-if=\"!vm.isReadOnly\"><div layout=\"column\"><span ng-repeat=\"p in ::item.personas\">\n<small><b>{{p.cognome|uppercase}}</b> {{p.nome|uppercase}} </small></span><span ng-if=\"item.personas.length == 0\">N/A\n</span></div></td><td md-cell style=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nclass=\"md-accent md-button-icon md-button-small\" aria-label=\"View Detailed\" ng-click=\"vm.gotoDettaglio(item.id)\"><i \nclass=\"icon-arrow-right\"></i> <span>Dettaglio Ente</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.isReadOnly\"><md-button aria-label=\"Visualizza tags\" ng-click=\"vm.viewtags(item.tags, [\'generico\'])\"><md-icon\n md-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza tags</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.isReadOnly\"><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.viewtags(item.tags, [\'listaente\'])\">\n<md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza lista</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.gotoDettaglio(0)\" aria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\" \nng-if=\"!vm.isReadOnly\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/cruscotto.html","<div id=\"monitoraggio\" class=\"monitoraggio page-layout simple fullwidth\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/monitoraggio/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Cruscotto Monitoraggio\n</span><md-select class=\"ml-5 pt-5 md-no-underline\" ng-model=\"vm.anno\" required ng-change=\"vm.loadDashboard()\" \naria-label=\"anno\"><md-option ng-value=\"anno\" ng-repeat=\"anno in vm.anni\"><span class=\"logo-text\">{{anno}}</span>\n</md-option></md-select></div></div></div><div class=\"content\"><ms-widget flippable=\"true\" layout=\"column\" class=\"m-8\" \nstyle=\"padding:0 !important; min-height: 350px\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-16 pt-24 pb-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-headline\">Riepilogo Numerico</div><div><md-button \nclass=\"md-icon-button\" aria-label=\"grafico\" ng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-chart-pie\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exportCsv(\'riepilogo_numerico\')\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button>\n</div></div><md-table-container class=\"pl-16 pr-16 pb-16\"><table data-md-table md-progress=\"vm.dashboard.$promise\" \nflex><thead md-head><tr md-row><th md-column>{{vm.descrizione}}</th><th md-column md-numeric>N. strutture visitate</th>\n<th md-column md-numeric>N. giorni di visita</th><th md-column md-numeric>N. monitoraggi effettuati</th><th md-column \nmd-numeric>di cui Qualitativi</th><th md-column md-numeric>Amministrativi</th><th md-column md-numeric>Congiunti</th>\n</tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.dashboard.dettagli.periodi\"><td md-cell>\n{{item.nomeBreve}}{{item.periodo}}</td><td md-cell>{{item.strutture_totale}}</td><td md-cell>{{item.giorni_totale}}\n</td><td md-cell>{{item.monitoraggi_totale}}</td><td md-cell>{{item.monitoraggiQual_totale}}</td><td md-cell>\n{{item.monitoraggiAmm_totale}}</td><td md-cell>{{item.monitoraggiCong_totale}}</td></tr><tr md-row><td md-cell><b>\nTotale</b></td><td md-cell><b>{{vm.dashboard.dettagli.totali.strutture_totale}}</b></td><td md-cell><b>\n{{vm.dashboard.dettagli.totali.giorni_totale}}</b></td><td md-cell><b>\n{{vm.dashboard.dettagli.totali.monitoraggi_totale}}</b></td><td md-cell><b>\n{{vm.dashboard.dettagli.totali.monitoraggiQual_totale}}</b></td><td md-cell><b>\n{{vm.dashboard.dettagli.totali.monitoraggiAmm_totale}}</b></td><td md-cell><b>\n{{vm.dashboard.dettagli.totali.monitoraggiCong_totale}}</b></td></tr></tbody></table></md-table-container>\n</ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"pl-16 pr-24 pt-24\"><span class=\"md-headline\">\nTotale Monitoraggi Effettuati</span><div layout=\"row\" class=\"pt-16\"><nvd3 class=\"remove-x-lines\" \noptions=\"vm.pieChart.tipo.options\" data=\"vm.pieChartData.tipo\"></nvd3><nvd3 class=\"remove-x-lines\" \noptions=\"vm.pieChart.periodo.options\" data=\"vm.pieChartData.periodo\"></nvd3><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div></div></div></ms-widget-back></ms-widget><div ng-if=\"vm.dashboard.scAccess\"><md-card>\n<md-card-title layout=\"row\" layout-align=\"space-between\"><md-card-title-text><span class=\"md-headline\">\nMonitoraggi Composti</span></md-card-title-text><md-button class=\"md-icon-button\" \nng-click=\"vm.exportCsv(\'monitoraggi_composti\')\"><md-icon md-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\">\n</md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button></md-card-title><md-card-content><md-table-container>\n<table data-md-table md-progress=\"vm.dashboard.$promise\" flex><thead md-head><tr md-row><th md-column></th><th \nmd-column></th><th md-column></th><th md-column colspan=\"3\">N° MONITORAGGI PER {{vm.descrizione}}</th><th md-column>\n</th></tr><tr md-row><th md-column>PROGETTO</th><th md-column>CATEGORIA</th><th md-column md-numeric>VISITE</th><th \nmd-column md-numeric ng-if-start=\"vm.descrizione === \'QUADRIMESTRE\'\">Q1</th><th md-column>Q2</th><th md-column \nng-if-end>Q3</th><th md-column md-numeric ng-if-start=\"vm.descrizione === \'SEMESTRE\'\">S1</th><th md-column ng-if-end>S2\n</th><th md-column>AREA</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.dashboard.dettagliProgettiMultipli\"><td md-cell><b>{{item.nome}}</b></td><td md-cell>\n{{item.categoria}}</td><td md-cell>{{item.numeroVisite}}</td><td md-cell \nng-if-start=\"vm.descrizione == \'QUADRIMESTRE\'\">{{item.monitoraggi_Q1}}</td><td md-cell>{{item.monitoraggi_Q2}}</td><td \nmd-cell ng-if-end>{{item.monitoraggi_Q3}}</td><td md-cell ng-if-start=\"vm.descrizione == \'SEMESTRE\'\">\n{{item.monitoraggi_S1}}</td><td md-cell ng-if-end>{{item.monitoraggi_S2}}</td><td md-cell>{{item.monitoraggi_S2}}</td>\n<td md-cell>{{item.ripartGeo}}</td></tr></tbody></table></md-table-container></md-card-content></md-card><md-card>\n<md-card-title layout=\"row\" layout-align=\"space-between\"><md-card-title-text><span class=\"md-headline\">\nTipologia Accoglienza</span></md-card-title-text><md-button class=\"md-icon-button\" \nng-click=\"vm.exportCsv(\'tipologia_accoglienza\')\"><md-icon md-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\">\n</md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button></md-card-title><md-card-content><md-tabs \nmd-dynamic-height md-no-pagination><md-tab ng-repeat=\"info in [\'monitoraggi\',\'progetti\',\'visite\']\"><md-tab-label>\n{{info}}</md-tab-label><md-tab-body><md-table-container><table data-md-table md-progress=\"vm.dashboard.$promise\"><thead\n md-head><tr md-row><th md-column>{{vm.descrizione}}</th><th md-column md-numeric \nng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'tipologia\' | filter : info\">\n{{column.split(\'_\').slice(-1)[0]}}</th><th md-column md-numeric>TOTALE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.dashboard.dettagli.periodi\"><td md-cell><b>{{item.nomeBreve}}{{item.periodo}}</b></td><td \nmd-cell ng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'tipologia\' | filter : info\" \nng-style=\"item.periodo == \'Totale\' ? {\'font-weight\': \'bold\'} : {}\">{{item[column]}}</td><td md-cell><b>\n{{item[info+\'_totale\']}}</b></td></tr><tr md-row ng-if=\"info !== \'progetti\'\"><td md-cell><b>Totale</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'tipologia\' | filter : info\"><b>\n{{vm.dashboard.dettagli.totali[column]}}</b></td><td md-cell><b>{{vm.dashboard.dettagli.totali[info+\'_totale\']}}</b>\n</td></tr></tbody></table></md-table-container></md-tab-body></md-tab></md-tabs></md-card-content></md-card><md-card>\n<md-card-title layout=\"row\" layout-align=\"space-between\"><md-card-title-text><span class=\"md-headline\">Area Geografica\n</span></md-card-title-text><md-button class=\"md-icon-button\" ng-click=\"vm.exportCsv(\'area_geografica\')\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button>\n</md-card-title><md-card-content><md-tabs md-dynamic-height md-no-pagination><md-tab \nng-repeat=\"info in [\'monitoraggi\',\'progetti\',\'visite\']\"><md-tab-label>{{info}}</md-tab-label><md-tab-body>\n<md-table-container><table data-md-table md-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th md-column>\n{{vm.descrizione}}</th><th md-column md-numeric \nng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'geo\' | filter : info\">{{column.split(\'_\').slice(-1)[0]}}\n</th><th md-column md-numeric>TOTALE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.dashboard.dettagli.periodi\"><td md-cell><b>{{vm.nomeBreve}}{{item.periodo}}</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'geo\' | filter : info\">{{item[column]}}</td><td md-cell>\n<b>{{item[info+\'_totale\']}}</b></td></tr><tr md-row ng-if=\"info !== \'progetti\'\"><td md-cell><b>Totale</b></td><td \nmd-cell ng-repeat=\"column in vm.dashboard.dettagli.columns | filter : \'geo\' | filter : info\"><b>\n{{vm.dashboard.dettagli.totali[column]}}</b></td><td md-cell><b>{{vm.dashboard.dettagli.totali[info+\'_totale\']}}</b>\n</td></tr></tbody></table></md-table-container></md-tab-body></md-tab></md-tabs></md-card-content></md-card></div>\n<ms-widget flippable=\"true\" layout=\"column\" class=\"m-8\" style=\"padding:0 !important; min-height: 350px\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-16 pt-24 pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-headline\">Stato delle Visite</div><div><md-button \nclass=\"md-icon-button\" aria-label=\"grafico\" ng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-chart-pie\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exportCsv(\'stato_visite\')\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button>\n</div></div><md-table-container><table data-md-table md-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th \nmd-column>{{vm.descrizione}}</th><th md-column md-numeric md-numeric ng-repeat=\"column in vm.dashboard.stato.columns\" \nstyle=\"text-align: center\"><span ng-if=\"column != \'In Attesa di Risposta\'\">{{column}}</span> <span \nng-if=\"column == \'In Attesa di Risposta\'\"><span>Con Richieste</span><br><span>In Attesa di risposta</span></span></th>\n<th colspan=\"2\" md-column>TOTALE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.dashboard.stato.periodi\"><td md-cell layout=\"row\" layout-align=\"space-around center\"><b>\n{{vm.nomeBreve}}{{item.periodo}}</b> <b layout=\"column\"><span>N</span> <span>C</span> <span>SI</span></b></td><td \nmd-cell ng-repeat=\"column in vm.dashboard.stato.columns\">{{item[\'Nord_\'+column]}}<br>{{item[\'Centro_\'+column]}}<br>\n{{item[\'Sud-Isole_\'+column]}}</td><td md-cell><b layout=\"column\"><span>{{item[\'totale_Nord\']}}</span> <span>\n{{item[\'totale_Centro\']}}</span> <span>{{item[\'totale_Sud-Isole\']}}</span></b></td><td md-cell><b>\n{{item.monitoraggi_totale}}</b></td></tr><tr md-row><td md-cell><b>Totale</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.stato.columns\"><b>{{vm.dashboard.stato.totali[column]}}</b></td><td md-cell><b>\n{{vm.dashboard.stato.totali.totale}}</b></td></tr></tbody></table></md-table-container></ms-widget-front>\n<ms-widget-back class=\"white-bg\"><div class=\"pl-16 pr-24 pt-24 pb-16\"><div class=\"md-headline\">Stato delle Visite</div>\n<nvd3 class=\"h-280 remove-x-lines\" options=\"vm.pieChart.stato.options\" data=\"vm.pieChartData.stato\"></nvd3><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" class=\"m-8\" style=\"min-height:400px; padding:0 !important\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-16 pt-24 pb-16\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-headline\">Valutazione Visite</div><div><md-button class=\"md-icon-button\" aria-label=\"grafico\" \nng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-chart-bar\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.exportCsv(\'valutazione_visite\')\"><md-icon md-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\">\n</md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button></div></div><md-table-container class=\"pl-16 pr-16 pb-16\">\n<table data-md-table md-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th md-column>ANDAMENTO PROGETTUALE\n</th><th md-column md-numeric md-numeric ng-repeat=\"column in vm.dashboard.giudizio.columns\">{{column}}</th><th \nmd-column md-numeric md-numeri>TOTALE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.dashboard.giudizio.giudizi\"><td md-cell><b>{{item.descrizioneBreve}}</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.giudizio.columns\">{{item[column]}}</td><td md-cell><b>{{item.totale}}</b></td></tr>\n<tr md-row><td md-cell><b>Totale</b></td><td md-cell ng-repeat=\"column in vm.dashboard.giudizio.columns\"><b>\n{{vm.dashboard.giudizio.totali[column]}}</b></td><td md-cell><b>{{vm.dashboard.giudizio.totali.totale}}</b></td></tr>\n</tbody></table></md-table-container></ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div class=\"pl-16 pr-24 pt-24 pb-16\"><div class=\"md-headline\">\nRIEPILOGO NUMERICO VALUTAZIONE VISITE SUDDIVISO PER ZONA</div><nvd3 class=\"h-380 remove-x-lines\" \nconfig=\"vm.barChart.config\" options=\"vm.barChart.options\" data=\"vm.giudizioChartData\"></nvd3></div></ms-widget-back>\n</ms-widget><div layout=\"row\"><ms-widget flippable=\"true\" layout=\"column\" class=\"m-8\" \nstyle=\"padding:0 !important; min-height: 450px\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-16 pt-24 pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-headline\">\nEsito delle Visite Chiuse</div><div><md-button class=\"md-icon-button\" aria-label=\"grafico\" ng-click=\"flipWidget()\">\n<md-icon md-font-icon=\"icon-chart-bar\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.exportCsv(\'esito_visite\')\"><md-icon md-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\"></md-icon>\n<md-tooltip>Esporta i dati</md-tooltip></md-button></div></div><md-tabs md-dynamic-height md-no-pagination><md-tab>\n<md-tab-label>{{vm.descrizione}}</md-tab-label><md-tab-body><md-table-container><table data-md-table \nmd-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th md-column>ESITO</th><th md-column md-numeric \nmd-numeric ng-repeat=\"column in vm.dashboard.esitoPeriodo.columns\">{{column}}</th><th md-column md-numeric md-numeri>\nTOTALE</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.dashboard.esitoPeriodo.esiti\"><td md-cell><b>\n{{item.descrizione}}</b></td><td md-cell ng-repeat=\"column in vm.dashboard.esitoPeriodo.columns\">{{item[column]}}</td>\n<td md-cell><b>{{item.totale}}</b></td></tr><tr md-row><td md-cell><b>Totale</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.esitoPeriodo.columns\"><b>{{vm.dashboard.esitoPeriodo.totali[column]}}</b></td><td \nmd-cell><b>{{vm.dashboard.esitoPeriodo.totali.totale}}</b></td></tr></tbody></table></md-table-container></md-tab-body>\n</md-tab><md-tab><md-tab-label>Area Geografica</md-tab-label><md-tab-body><md-table-container><table data-md-table \nmd-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th md-column>ESITO</th><th md-column md-numeric \nmd-numeric ng-repeat=\"column in vm.dashboard.esitoGeo.columns\">{{column}}</th><th md-column md-numeric md-numeri>TOTALE\n</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.dashboard.esitoGeo.esiti\"><td md-cell><b>\n{{item.descrizione}}</b></td><td md-cell ng-repeat=\"column in vm.dashboard.esitoGeo.columns\">{{item[column]}}</td><td \nmd-cell><b>{{item.totale}}</b></td></tr><tr md-row><td md-cell><b>Totale</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.esitoGeo.columns\"><b>{{vm.dashboard.esitoGeo.totali[column]}}</b></td><td md-cell><b>\n{{vm.dashboard.esitoGeo.totali.totale}}</b></td></tr></tbody></table></md-table-container></md-tab-body></md-tab>\n<md-tab><md-tab-label>Tipologia Accoglienza</md-tab-label><md-tab-body><md-table-container><table data-md-table \nmd-progress=\"vm.dashboard.$promise\"><thead md-head><tr md-row><th md-column>ESITO</th><th md-column md-numeric \nmd-numeric ng-repeat=\"column in vm.dashboard.esitoTip.columns\">{{column}}</th><th md-column md-numeric md-numeri>TOTALE\n</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.dashboard.esitoTip.esiti\"><td md-cell><b>\n{{item.descrizione}}</b></td><td md-cell ng-repeat=\"column in vm.dashboard.esitoTip.columns\">{{item[column]}}</td><td \nmd-cell><b>{{item.totale}}</b></td></tr><tr md-row><td md-cell><b>Totale</b></td><td md-cell \nng-repeat=\"column in vm.dashboard.esitoTip.columns\"><b>{{vm.dashboard.esitoTip.totali[column]}}</b></td><td md-cell><b>\n{{vm.dashboard.esitoTip.totali.totale}}</b></td></tr></tbody></table></md-table-container></md-tab-body></md-tab>\n</md-tabs></ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div class=\"pl-16 pr-24 pt-24 pb-16\"><div class=\"md-headline\">\nEsito delle Visite Chiuse per Tipologia</div><nvd3 class=\"h-380 remove-x-lines\" config=\"vm.barChart.config\" \noptions=\"vm.barChart.options\" data=\"vm.esitoChartData\"></nvd3></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" class=\"m-8\" style=\"padding:0 !important\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"end center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.dashboard.totaleProgettiMonitorati}}\n</div><div class=\"h3 secondary-text font-weight-500\">Progetti Monitorati</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Totale Progetti Attivi:</span> <span class=\"h4 ml-8\">\n{{vm.dashboard.totaleProgettiAttivi}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>details</div></ms-widget-back></ms-widget></div>\n<md-card ng-if=\"vm.dashboard.scAccess\"><md-card-title layout=\"row\" layout-align=\"space-between\"><md-card-title-text>\n<span class=\"md-headline\">SAL</span></md-card-title-text><md-button class=\"md-icon-button\" ng-click=\"vm.exportSal()\">\n<md-icon md-font-icon=\"icon-file-excel\" class=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip>\n</md-button></md-card-title><md-card-content><md-table-container><table data-md-table md-progress=\"vm.sal.$promise\" \nflex><thead md-head><tr md-row><th md-column>AREA GEOGRAFICA</th><th md-column>CODICE PROGETTO</th><th md-column>\nREGIONE</th><th md-column>PROV</th><th md-column>ENTE LOCALE TITOLARE</th><th md-column>CATEGORIA</th><th md-column>\nNR POSTI</th><th md-column>DATA MONITORAGGIO</th><th md-column md-numeric ng-if=\"vm.descrizione === \'QUADRIMESTRE\'\">\nQUAD</th><th md-column md-numeric ng-if=\"vm.descrizione === \'SEMESTRE\'\">SEMESTRE</th><th md-column>IN LOCO / DISTANZA\n</th><th md-column>DATA INVIO REPORT</th><th md-column>VISITA CON PREFETT.</th><th md-column>PRESENZA DLCI</th><th \nmd-column>STATO DEL MONITORAGGIO</th><th md-column>ESITO MONITORAGGIO</th><th md-column>STRUTTURE VISITATE</th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"item in vm.sal.data\"><td md-cell><b>{{item.areaGeografica}}</b></td><td \nmd-cell><b>{{item.codiceProgetto}}</b></td><td md-cell>{{item.regione}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.siglaAut}}</td><td md-cell>{{item.enteLocale}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.categoria}}</td><td md-cell style=\"text-align: center !important\">\n{{item.numeroPosti}}</td><td md-cell style=\"text-align: center !important\">{{item.data | date : \'dd/MM/yyyy\'}}</td><td \nmd-cell style=\"text-align: center !important\">{{item.nomeBreve}}{{item.periodo}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.daRemoto ? \'D\' : \'L\'}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.dataInvio | date : \'dd/MM/yyyy\'}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.presenzaPrefettura ? \'SI\' : \'NO\'}}</td><td md-cell \nstyle=\"text-align: center !important\">{{item.presenzaMinistero ? \'SI\' : \'NO\'}}</td><td md-cell>{{item.stato}}</td><td \nmd-cell>{{item.esito}}</td><td md-cell style=\"text-align: center !important\">{{item.numeroStruttureVisitate}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.pagination[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.pagination.page\" md-total=\"{{vm.totalCount}}\" md-on-paginate=\"vm.loadSal\" \nmd-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/dashboard.html","<div id=\"monitoraggio\" class=\"monitoraggio page-layout simple fullwidth layout-column\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Monitoraggio</span></div></div></div><div class=\"content\"><md-card \nng-if=\"vm.vistaSc\"><md-card-title><md-card-title-text><span class=\"md-headline\">Visite da Confermare</span>\n</md-card-title-text><md-button class=\"md-icon-button\" ng-click=\"vm.loadMonitoraggiDaConfermare()\" \naria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button></md-card-title><md-card-content><md-table-container>\n<table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.monitoraggi.daConfermare.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column \nmd-order-by=\"questionario_tipo\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">CODICE MINISTERO</th><th md-column \nmd-order-by=\"progetto_id\">ENTE LOCALE</th><th md-column md-order-by=\"progetto_id\">ANNO</th><th md-column \nmd-order-by=\"confermato\">NOME VISITA</th><th md-column md-order-by=\"confermato\">TIPO</th><th md-column \nmd-order-by=\"followup_risposta\">PERIODO</th><th md-column md-order-by=\"followup\">DATA</th><th md-column \nmd-order-by=\"followup\">TUTOR</th><th md-column class=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.monitoraggi.daConfermare.data\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId:item.id})\"><td \nmd-cell><b>{{item.progettoMonitoraggio.progetto.nome}}</b></td><td md-cell><b>\n{{item.progettoMonitoraggio.codiceProgetto}}</b></td><td md-cell>{{item.progettoMonitoraggio.enteLocale}}</td><td \nmd-cell>{{item.progettoMonitoraggio.anno}}</td><td md-cell>{{item.nome}}</td><td md-cell>{{item.tipo | uppercase}}</td>\n<td md-cell>{{item.periodoMonitoraggio.nomeBreve}}{{item.periodoMonitoraggio.periodo}}</td><td md-cell>\n{{item.data| date:\'dd/MM/yyyy\'}}</td><td md-cell><p ng-if=\"item.tutorAmm != null\">\nT.Amm.: {{item.tutorAmm.persona.cognomeNome}}</p><p ng-if=\"item.tutorQual != null\">\nT.Qual.: {{item.tutorQual.persona.cognomeNome}}</p></td><td md-cell><md-button class=\"md-accent md-button-icon\" \naria-label=\"View Detailed\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\">VAI >></md-button></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.search.daConfermare[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.daConfermare.page\" md-total=\"{{vm.totalCount.daConfermare}}\" \nmd-on-paginate=\"vm.loadMonitoraggiDaConfermare\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card><md-card ng-if=\"vm.vistaSc\"><md-card-title><md-card-title-text><span class=\"md-headline\">\nElaborazioni da Validare</span></md-card-title-text><md-button class=\"md-icon-button\" ng-click=\"vm.loadDettagli()\" \naria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button></md-card-title><md-card-content><md-table-container>\n<table data-md-table md-progress=\"vm.dettagli.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">PROGETTO</th>\n<th md-column md-order-by=\"id\">CODICE MINISTERO</th><th md-column md-order-by=\"id\">DATA VISITA</th><th md-column \nmd-order-by=\"id\">NOME VISITA</th><th md-column md-order-by=\"id\">ID</th><th md-column md-order-by=\"questionario_tipo\">\nTIPO</th><th md-column md-order-by=\"dataInizio\">RICHIESTE</th><th md-column md-order-by=\"dataInizio\">INVIATO</th><th \nmd-column class=\"text-center\">AZIONI</th></tr></thead><tbody md-body><tr md-row ng-disabled=\"true\" \nng-repeat=\"item in vm.dettagli.data\"><td md-cell><b>{{item.visita.progettoMonitoraggio.progetto.nome}}</b></td><td \nmd-cell><b>{{item.visita.progettoMonitoraggio.codiceProgetto}}</b></td><td md-cell>\n{{item.visita.data | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{item.visita.nome}}</td><td md-cell>{{item.id}}</td><td \nmd-cell><b>{{item.tipo | uppercase}}</b></td><td md-cell><md-checkbox ng-model=\"item.richieste\" \nng-change=\"vm.checkRichieste(item)\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"richieste\" \nng-disabled=\"item.disabled\"></md-checkbox></td><td md-cell><b>{{item.owner.persona.nomeCognome | uppercase}}</b><br>\n{{item.timeInvio *1000 | date : \'medium\'}}</td><td md-cell><azioni-dettaglio ng-model=\"item\" duplica=\"false\">\n</azioni-dettaglio></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.search.dettagli[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.dettagli.page\" \nmd-total=\"{{vm.totalCount.dettagli}}\" md-on-paginate=\"vm.loadDettagli\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card><md-card ng-if=\"vm.vistaTutor\"><md-card-title><md-card-title-text><span class=\"md-headline\">Visite Assegnate\n</span></md-card-title-text><md-button class=\"md-icon-button\" ng-click=\"vm.loadMonitoraggiAssegnati()\" \naria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button></md-card-title><md-card-content><md-table-container>\n<table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.monitoraggi.assegnati.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column \nmd-order-by=\"questionario_tipo\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">CODICE MINISTERO</th><th md-column \nmd-order-by=\"progetto_id\">ENTE LOCALE</th><th md-column md-order-by=\"progetto_id\">ANNO</th><th md-column \nmd-order-by=\"confermato\">NOME VISITA</th><th md-column md-order-by=\"confermato\">TIPO</th><th md-column \nmd-order-by=\"followup_risposta\">PERIODO</th><th md-column md-order-by=\"followup\">DATA</th><th md-column \nclass=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.monitoraggi.assegnati.data\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\"><td \nmd-cell><b>{{item.progettoMonitoraggio.progetto.nome}}</b></td><td md-cell><b>\n{{item.progettoMonitoraggio.codiceProgetto}}</b></td><td md-cell>{{item.progettoMonitoraggio.enteLocale}}</td><td \nmd-cell>{{item.progettoMonitoraggio.anno}}</td><td md-cell>{{item.nome}}</td><td md-cell>{{item.tipo | uppercase}}</td>\n<td md-cell>{{item.periodoMonitoraggio.nomeBreve}}{{item.periodoMonitoraggio.periodo}}</td><td md-cell>\n{{item.data| date:\'dd/MM/yyyy\'}}</td><td md-cell><md-button class=\"md-accent md-button-icon\" \naria-label=\"View Detailed\" ui-sref=\"app.sprardb_monitoraggio.view({id: item.id})\">VAI >></md-button></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.search.assegnati[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.assegnati.page\" md-total=\"{{vm.totalCount.assegnati}}\" \nmd-on-paginate=\"vm.loadMonitoraggiAssegnati\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card><md-card ng-if=\"vm.vistaTutor\"><md-card-title><md-card-title-text><span class=\"md-headline\">\nVisite in Lavorazione</span></md-card-title-text><md-button class=\"md-icon-button\" \nng-click=\"vm.loadMonitoraggiInLavorazione()\" aria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button>\n</md-card-title><md-card-content><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.monitoraggi.inLavorazione.$promise\"><thead ng-if=\"!vm.options.decapitate\" \nmd-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column \nmd-order-by=\"questionario_tipo\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">CODICE MINISTERO</th><th md-column \nmd-order-by=\"progetto_id\">ENTE LOCALE</th><th md-column md-order-by=\"progetto_id\">ANNO</th><th md-column \nmd-order-by=\"confermato\">NOME VISITA</th><th md-column md-order-by=\"confermato\">TIPO</th><th md-column \nmd-order-by=\"confermato\">STATO ELABORAZIONI</th><th md-column md-order-by=\"followup_risposta\">PERIODO</th><th \nmd-column md-order-by=\"followup\">DATA</th><th md-column class=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"item in vm.monitoraggi.inLavorazione.data\" \nui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\"><td md-cell><b>{{item.progettoMonitoraggio.progetto.nome}}\n</b></td><td md-cell><b>{{item.progettoMonitoraggio.codiceProgetto}}</b></td><td md-cell>\n{{item.progettoMonitoraggio.enteLocale}}</td><td md-cell>{{item.progettoMonitoraggio.anno}}</td><td md-cell>\n{{item.nome}}</td><td md-cell>{{item.tipo | uppercase}}</td><td md-cell><div layout=\"row\" \nng-repeat=\"(tipoDettaglio,rowText) in vm.elaborazioniDisplay[item.id]\"><span ng-if=\"item.tipo === \'CONGIUNTO\'\">\n{{tipoDettaglio | uppercase | limitTo : 1}}:&nbsp;</span> <span ng-if=\"rowText.length\">{{rowText}}</span> <span \nng-if=\"item.tipo === \'CONGIUNTO\' && !rowText.length\">ND</span></div></td><td md-cell>\n{{item.periodoMonitoraggio.nomeBreve}}{{item.periodoMonitoraggio.periodo}}</td><td md-cell>\n{{item.data| date:\'dd/MM/yyyy\'}}</td><td md-cell><md-button class=\"md-accent md-button-icon\" \naria-label=\"View Detailed\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\">VAI >></md-button></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.search.inLavorazione[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.inLavorazione.page\" md-total=\"{{vm.totalCount.inLavorazione}}\" \nmd-on-paginate=\"vm.loadMonitoraggiInLavorazione\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card><md-card ng-if=\"vm.vistaTutor\"><md-card-title><md-card-title-text><span class=\"md-headline\">\nVisite in Attesa di Risposta</span></md-card-title-text><md-button class=\"md-icon-button\" \nng-click=\"vm.loadMonitoraggiInAttesa()\" aria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button>\n</md-card-title><md-card-content><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.monitoraggi.inAttesa.$promise\"><thead ng-if=\"!vm.options.decapitate\" \nmd-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column \nmd-order-by=\"questionario_tipo\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">CODICE MINISTERO</th><th md-column \nmd-order-by=\"progetto_id\">ENTE LOCALE</th><th md-column md-order-by=\"progetto_id\">ANNO</th><th md-column \nmd-order-by=\"confermato\">NOME VISITA</th><th md-column md-order-by=\"confermato\">TIPO</th><th md-column \nmd-order-by=\"followup_risposta\">PERIODO</th><th md-column md-order-by=\"followup\">DATA</th><th md-column \nclass=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.monitoraggi.inAttesa.data\" \nui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\" \nng-class=\"{\'md-deep-orange-50-bg\': vm.controllaScadenza(item)}\"><td md-cell><b>\n{{item.progettoMonitoraggio.progetto.nome}}</b></td><td md-cell><b>{{item.progettoMonitoraggio.codiceProgetto}}</b>\n</td><td md-cell>{{item.progettoMonitoraggio.enteLocale}}</td><td md-cell>{{item.progettoMonitoraggio.anno}}</td><td \nmd-cell>{{item.nome}}</td><td md-cell>{{item.tipo | uppercase}}</td><td md-cell>\n{{item.periodoMonitoraggio.nomeBreve}}{{item.periodoMonitoraggio.periodo}}</td><td md-cell>\n{{item.data| date:\'dd/MM/yyyy\'}}</td><td md-cell><md-button class=\"md-accent md-button-icon\" \naria-label=\"View Detailed\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\">VAI >></md-button></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.search.inAttesa[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.inAttesa.page\" md-total=\"{{vm.totalCount.inAttesa}}\" \nmd-on-paginate=\"vm.loadMonitoraggiInAttesa\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card-content>\n</md-card></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/monitoraggi.html","<div id=\"monitoraggio\" class=\"monitoraggio page-layout simple fullwidth\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/monitoraggio/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Lista Visite</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main scrollable\" ms-scroll><div layout=\"row\"><md-input-container \nflex=\"30\"><input placeholder=\"Ricerca per nome\" type=\"text\" ng-model=\"vm.nomeSearch\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch()\"></md-input-container><md-input-container flex=\"30\"><input \nplaceholder=\"Codice Ministero\" ng-model=\"vm.codiceMinistero\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.onSearch()\" name=\"codiceMinistero\" type=\"text\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><small>Cerca</small></md-button><md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata\n</small><md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card\n style=\"padding-top:0px\"><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.monitoraggi.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column \nmd-order-by=\"questionario_tipo\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">CODICE MINISTERO</th><th md-column \nmd-order-by=\"progetto_id\">ENTE LOCALE</th><th md-column md-order-by=\"progetto_id\">ANNO</th><th md-column \nmd-order-by=\"confermato\">NOME VISITA</th><th md-column md-order-by=\"confermato\">TIPO</th><th md-column \nmd-order-by=\"followup_risposta\">PERIODO</th><th md-column md-order-by=\"followup\">DATA</th><th md-column \nmd-order-by=\"followup\">TUTOR</th><th md-column class=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.monitoraggi.data track by $index\" ui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\" \nng-class=\"{\'md-deep-orange-50-bg\': vm.controllaScadenza(item)}\"><td md-cell><b>\n{{item.progettoMonitoraggio.progetto.nome}}</b></td><td md-cell><b>{{item.progettoMonitoraggio.codiceProgetto}}</b>\n</td><td md-cell>{{item.progettoMonitoraggio.enteLocale}}</td><td md-cell>{{item.progettoMonitoraggio.anno}}</td><td \nmd-cell>{{item.nome}}</td><td md-cell>{{item.tipo | uppercase}}</td><td md-cell>\n{{item.periodoMonitoraggio.nomeBreve}}{{item.periodoMonitoraggio.periodo}}</td><td md-cell>\n{{item.data| date:\'dd/MM/yyyy\'}}</td><td md-cell><p ng-if=\"item.tutorAmm != null\">\nT.Amm.: {{item.tutorAmm.persona.cognomeNome}}</p><p ng-if=\"item.tutorQual != null\">\nT.Qual.: {{item.tutorQual.persona.cognomeNome}}</p></td><td md-cell style=\"text-align: right\"><div><md-menu \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly\"><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button class=\"md-accent md-button-icon\" aria-label=\"View Detailed\" \nui-sref=\"app.sprardb_monitoraggio.view({visitaId: item.id})\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon>\nVAI ALLA VISITA</md-button></md-menu-item><md-menu-item><md-button class=\"md-warn md-button-icon\" \nng-click=\"vm.eliminaVisita(item)\" ng-disabled=\"!vm.isReadOnly && !vm.user.can(\'invia-report\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>ELIMINA VISITA</md-button></md-menu-item></md-menu-content></md-menu></div></td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.search[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" md-total=\"{{vm.totalCount}}\" \nmd-on-paginate=\"vm.loadMonitoraggi\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button pb-10\" \nng-click=\"vm.nuovoMonitoraggio($event)\" aria-label=\"nuovo monitoraggio\" \nng-if=\"vm.api.user.permissions.includes(\'assegna-monitoraggio\')\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/monitoraggio-form.html","<div layout=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (wizardStep3.nome.$invalid)}\"><b>Nome Visita</b></label><input type=\"text\" \nng-model=\"fc.visita.nome\" name=\"nome\" required ng-disabled=\"fc.disabled(\'nome\')\"><div \nng-messages=\"wizardStep3.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il nome della visita è richiesto.\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (wizardStep3.numeroMonitoraggi.$invalid)}\"><b>Numero Monitoraggi</b></label><input \ntype=\"text\" ng-model=\"fc.visita.numeroMonitoraggi\" name=\"numeroMonitoraggi\" required \nng-disabled=\"fc.visita.statoId == 3 || fc.visita.statoId == 4\"><div ng-messages=\"wizardStep3.numeroMonitoraggi.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il numero monitoraggi è richiesto.</span></div></div>\n</md-input-container><md-input-container flex><label><b>PERIODO</b></label><md-select \nng-model=\"fc.visita.periodoMonitoraggioId\" name=\"periodoMonitoraggioId\" required \nng-disabled=\"fc.disabled(\'periodoMonitoraggioId\')\"><md-option ng-value=\"key\" ng-repeat=\"(key, periodo) in fc.semestri\">\n{{periodo}}</md-option><md-option ng-value=\"key\" ng-repeat=\"(key, periodo) in fc.quadrimestri\" \nng-if=\"fc.disabled(\'periodoMonitoraggioId\')\">{{periodo}}</md-option></md-select></md-input-container><div flex \nlayout=\"row\" layout-align=\"center\"><md-radio-group ng-model=\"fc.visita.daRemoto\" name=\"daRemoto\" required \nng-disabled=\"fc.disabled(\'daRemoto\')\"><md-radio-button value=\"0\"><small>In loco</small></md-radio-button>\n<md-radio-button value=\"1\"><small>A distanza</small></md-radio-button></md-radio-group></div></div><ng-form \nname=\"fc.tutorForm\" novalidate layout=\"row\"><md-input-container><label><b>Tipo</b></label><md-select \nng-model=\"fc.visita.tipo\" required ng-change=\"fc.cambiaTipo()\" name=\"tipo\" ng-disabled=\"fc.disabled(\'tipo\')\"><md-option\n ng-value=\"tipo\" ng-repeat=\"tipo in [\'AMMINISTRATIVO\',\'QUALITATIVO\',\'CONGIUNTO\']\">{{tipo}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"[\'AMMINISTRATIVO\',\'CONGIUNTO\'].includes(fc.visita.tipo)\" flex><label>\n<b>Tutor Amministrativo</b></label><md-select ng-model=\"fc.visita.tutorAmmId\" required name=\"tutorAmmId\" \nng-disabled=\"fc.disabled(\'tutorAmmId\')\"><md-option md-option-empty \nng-if=\"![\'AMMINISTRATIVO\',\'CONGIUNTO\'].includes(fc.visita.tipo)\" ng-value=\"null\"></md-option><md-option \nng-value=\"tutor.id\" ng-repeat=\"tutor in fc.tutorAmministrativi | orderBy: \'persona.cognomeNome\' track by tutor.id\">\n{{tutor.persona.cognomeNome | uppercase}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"[\'QUALITATIVO\',\'CONGIUNTO\'].includes(fc.visita.tipo)\" flex><label><b>Tutor Qualitativo</b></label><md-select \nng-model=\"fc.visita.tutorQualId\" required name=\"tutorQualId\" ng-disabled=\"fc.disabled(\'tutorQualId\')\"><md-option \nmd-option-empty ng-if=\"![\'QUALITATIVO\',\'CONGIUNTO\'].includes(fc.visita.tipo)\" ng-value=\"null\"></md-option><md-option \nng-value=\"tutor.id\" ng-repeat=\"tutor in fc.tutorQualitativi | orderBy: \'persona.cognomeNome\' track by tutor.id\">\n{{tutor.persona.cognomeNome | uppercase}}</md-option></md-select></md-input-container></ng-form>");
$templateCache.put("app/main/sprardb/monitoraggio/monitoraggio.html","<div id=\"monitoraggio\" class=\"page-layout simple tabbed ng-scope layout-column\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\"><md-button class=\"goto-products-button md-icon-button\" aria-label=\"indietro\" \nonclick=\"history.go(-1)\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" flex><span \nclass=\"h2\">\nVisita: {{vm.visita.progettoMonitoraggio.codiceProgetto}} \"{{vm.visita.nome}}\" {{vm.visita.progettoMonitoraggio.anno}}\n</span><div layout=\"row\"><span class=\"h3\" flex>Stato: {{vm.visita.stato.descrizione}} <span \nng-if=\"vm.visita.statoId == 5\">il {{vm.visita.dataSegnalazione | date}}</span> <span ng-if=\"vm.visita.statoId == 4\">\n{{vm.visita.richieste ? \'con\' : \'senza\'}} richieste</span> </span><span ng-if=\"vm.visita.esito\" class=\"h3\" flex=\"auto\">\nEsito: {{vm.visita.esito.descrizione}}</span></div></div></div><div class=\"content\" ms-scroll><md-tabs \nmd-dynamic-height><md-tab label=\"Principale\" md-on-select=\"vm.switchTab(\'principale\')\" \nmd-active=\"vm.activeTab == \'principale\'\"><div ng-repeat=\"(key, errors) in vm.visitaForm.$error track by $index\" \nflex=\"75\"><small class=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> \n<small ng-if=\"errors.length < 10\"><small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small \nclass=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>,</small></small></div><small \nng-if=\"!vm.visitaForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small><md-card flex><div layout=\"row\" \nlayout-align=\"space-around\"><div layout=\"column\"><b>Progetto</b> <span>{{vm.visita.progettoMonitoraggio.progetto.nome}}\n</span></div><div layout=\"column\"><b>Regione</b> <span>{{vm.visita.progettoMonitoraggio.progetto.istats.regione}}\n</span></div><div layout=\"column\"><b>Provincia</b> <span>{{vm.visita.progettoMonitoraggio.progetto.istats.provincia}}\n</span></div><div layout=\"column\"><b>Categoria</b> <span>\n{{vm.visita.progettoMonitoraggio.progetto.tipologiaAccoglienza.descrizione}}</span></div><div layout=\"column\"><b>\nInizio Finanziamento</b> <span>{{vm.visita.progettoMonitoraggio.dataInizioFinanziamento | date}}</span></div><div \nlayout=\"column\"><b>Fine Finanziamento</b> <span>{{vm.visita.progettoMonitoraggio.dataFineFinanziamento | date}}</span>\n</div></div></md-card><md-card flex><form name=\"vm.visitaForm\" class=\"content md-inline-form p-15\" novalidate \nlayout=\"column\" unsaved-warning-form><monitoraggio-form ng-model=\"vm.visita\"></monitoraggio-form><md-divider \nclass=\"padding-vertical-15\"></md-divider><div layout=\"row\"><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.visitaForm.numeroStrutture.$invalid)}\"><b>Numero Strutture</b></label><input type=\"text\" \nng-model=\"vm.visita.numeroStrutture\" name=\"numeroStrutture\" ng-disabled=\"vm.disabled(\'numeroStrutture\')\"><div \nng-messages=\"vm.visitaForm.numeroStrutture.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il numero è richiesto.\n</span></div></div></md-input-container><md-input-container flex class=\"p-8\"><label><b>Numero Posti Attivi</b></label>\n<input type=\"text\" ng-model=\"vm.visita.numeroPostiAttivi\" name=\"numeroPosti\"></md-input-container><md-input-container \nflex class=\"p-8\"><label ng-class=\"{\'md-warn-fg\': (vm.visitaForm.numeroPosti.$invalid)}\"><b>Numero Posti Finanziati</b>\n</label><input type=\"text\" ng-model=\"vm.visita.numeroPosti\" name=\"numeroPosti\" \nng-disabled=\"vm.disabled(\'numeroPosti\')\"><div ng-messages=\"vm.visitaForm.numeroPosti.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il numero è richiesto.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"p-8\" \nng-if=\"!vm.visita.importoFinanziatoTemporaneo || vm.user.permissions.includes(\'vedi-importo-temp-monitoraggio\')\"><label\n ng-class=\"{\'md-warn-fg\': (vm.visitaForm.importoFinanziato.$invalid)}\"><b>Contributo Assegnato</b></label><input \nname=\"importoFinanziato\" ng-model=\"vm.visita.importoFinanziato\" ng-disabled=\"vm.disabled(\'importoFinanziato\')\" \ntype=\"text\" lang=\"it_IT\" required ui-money-mask ui-negative-number ui-currency-after><div \nng-messages=\"vm.visitaForm.importoFinanziato.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl numero è richiesto.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.user.permissions.includes(\'vedi-importo-temp-monitoraggio\')\"><md-checkbox \nng-model=\"vm.visita.importoFinanziatoTemporaneo\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.disabled(\'importoFinanziatoTemporaneo\')\"><small>Nascondi Contributo Assegnato</small></md-checkbox>\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.visitaForm.numeroStruttureVisitate.$invalid)}\"><b>Numero Strutture Visitate</b></label>\n<input type=\"text\" ng-model=\"vm.visita.numeroStruttureVisitate\" name=\"numeroStruttureVisitate\" \nng-disabled=\"vm.disabled(\'numeroStruttureVisitate\')\"><div ng-messages=\"vm.visitaForm.numeroStruttureVisitate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il numero è richiesto.</span></div></div></md-input-container>\n<md-input-container flex class=\"p-8\"><label ng-class=\"{\'md-warn-fg\': (vm.visitaForm.numeroBeneficiari.$invalid)}\"><b>\nNumero Beneficiari Presenti</b></label><input type=\"text\" ng-model=\"vm.visita.numeroBeneficiari\" \nname=\"numeroBeneficiari\" ng-disabled=\"vm.disabled(\'numeroBeneficiari\')\"><div \nng-messages=\"vm.visitaForm.numeroBeneficiari.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl numero è richiesto.</span></div></div></md-input-container><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.visitaForm.numeroGiorni.$invalid)}\"><b>Numero Giorni</b></label><input type=\"text\" \nng-model=\"vm.visita.numeroGiorni\" name=\"numeroGiorni\" ng-disabled=\"vm.disabled(\'numeroGiorni\')\"><div \nng-messages=\"vm.visitaForm.numeroGiorni.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il numero è richiesto.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Tiplogia Accoglienza\n</label><md-select name=\"tipAccoglienza\" ng-model=\"vm.visita.tipAccoglienza\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\" md-selected-text=\"vm.selectedText\" ng-disabled=\"vm.disabled(\'tipAccoglienza\')\"><md-option \nng-value=\"tipAccoglienza\" ng-repeat=\"tipAccoglienza in vm.tipologieAccoglienza\">{{tipAccoglienza.descrizione}}\n</md-option></md-select></md-input-container><md-input-container flex=\"20\"><label>Data Inzio Visita</label>\n<md-datepicker name=\"dataInizioVisita\" ng-model=\"vm.visita.data\" md-max-date=\"vm.maxDate\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required ng-disabled=\"vm.disabled(\'data\')\">\n</md-datepicker><div ng-messages=\"vm.visitaForm.dataInizioVisita.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLa data inizio visita è richiesto.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex><md-checkbox ng-model=\"vm.visita.finanziatoFondoFami\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.disabled(\'finanziatoFondoFami\')\"><small>Finanziato fondo FAMI</small></md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"vm.visita.presenzaPrefettura\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"vm.disabled(\'presenzaPrefettura\')\"><small>Presenza Prefettura</small></md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"vm.visita.presenzaMinistero\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"vm.disabled(\'presenzaMinistero\')\"><small>Presenza Ministero</small></md-checkbox>\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.visitaForm.nomiReferenti.$invalid)}\"><b>Nomi Referenti</b></label><input type=\"text\" \nname=\"nomiReferenti\" ng-model=\"vm.visita.nomiReferenti\" ng-disabled=\"vm.disabled(\'nomiReferenti\')\">\n</md-input-container><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.visitaForm.nomiReferentiExtra.$invalid)}\"><b>Nomi Referenti Altri Enti</b></label><input \ntype=\"text\" name=\"nomiReferentiExtra\" ng-model=\"vm.visita.nomiReferentiExtra\" \nng-disabled=\"vm.disabled(\'nomiReferentiExtra\')\"></md-input-container></div><div layout=\"row\" layout-align=\"end\">\n<md-button type=\"submit\" ng-click=\"vm.salvaVisita()\" class=\"md-raised md-accent\" \nng-disabled=\"vm.visitaForm.$submitted || vm.visitaForm.$pristine\">SALVA</md-button></div></form></md-card></md-tab>\n<md-tab label=\"Enti\" md-on-select=\"vm.switchTab(\'enti\')\" md-active=\"vm.activeTab == \'enti\'\"><md-card \nng-if=\"!vm.disabled(\'enti\')\"><form name=\"vm.enteForm\" class=\"content md-inline-form p-15\" novalidate layout=\"row\">\n<md-autocomplete md-floating-label=\"Nome ente\" md-no-cache=\"1\" md-selected-item=\"vm.newEnte.nomeEnte\" \nmd-search-text-change=\"vm.cercaEnti(vm.enteSearch)\" md-search-text=\"vm.enteSearch\" \nmd-items=\"nomeEnte in vm.nomiEnte.$promise\" md-item-text=\"nomeEnte\" md-min-length=\"3\" \nng-model-options=\"{debounce: 200}\" name=\"nomeEnte\" required><md-item-template><span md-highlight-text=\"vm.enteSearch\" \nmd-highlight-flags=\"i\">{{nomeEnte}}</span></md-item-template></md-autocomplete><md-input-container class=\"md-block\">\n<label>Ruolo</label><md-select ng-model=\"vm.newEnte.ruolo\" required><md-option ng-value=\"ruolo\" \nng-repeat=\"ruolo in [\'partner\',\'aderente\',\'attuatore\']\">{{ruolo | uppercase}}</md-option></md-select>\n</md-input-container><md-button type=\"submit\" ng-click=\"vm.salvaEnte()\" class=\"m-15 md-raised md-accent\" \nng-disabled=\"vm.enteForm.$submitted || vm.enteForm.$invalid || vm.enteForm.$pristine\">SALVA</md-button><span \nstyle=\"align-self: center;color: darkgrey\"><small>* Inserire ente manualmente</small></span></form></md-card><md-card>\n<md-card-title><md-card-title-text><span class=\"md-headline\">Partner</span></md-card-title-text></md-card-title>\n<md-card-content><ul ng-class=\"!vm.disabled(\'enti\') ? \'no-bullets\' : \'\'\"><li \nng-repeat=\"ente in vm.visita.enti | filter : {ruolo: \'partner\'}\"><md-button class=\"md-icon-button\" \naria-label=\"Cancella\" ng-click=\"vm.rimuoviEnte(ente)\" ng-if=\"!vm.disabled(\'enti\')\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon></md-button><span>{{ente.nomeEnte}}</span></li></ul></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Aderenti</span></md-card-title-text></md-card-title><md-card-content><ul \nng-class=\"!vm.disabled(\'enti\') ? \'no-bullets\' : \'\'\"><li \nng-repeat=\"ente in vm.visita.enti | filter : {ruolo: \'aderente\'}\"><md-button class=\"md-icon-button\" \naria-label=\"Cancella\" ng-click=\"vm.rimuoviEnte(ente)\" ng-if=\"!vm.disabled(\'enti\')\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon></md-button><span>{{ente.nomeEnte}}</span></li></ul></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Attuatori</span></md-card-title-text></md-card-title><md-card-content><ul\n ng-class=\"!vm.disabled(\'enti\') ? \'no-bullets\' : \'\'\"><li \nng-repeat=\"ente in vm.visita.enti | filter : {ruolo: \'attuatore\'}\"><md-button class=\"md-icon-button\" \naria-label=\"Cancella\" ng-click=\"vm.rimuoviEnte(ente)\" ng-if=\"!vm.disabled(\'enti\')\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon></md-button><span>{{ente.nomeEnte}}</span></li></ul></md-card-content></md-card></md-tab><md-tab \nlabel=\"Elaborazione\" md-on-select=\"vm.switchTab(\'dettagli\')\" md-active=\"vm.activeTab == \'dettagli\'\"><div \nng-repeat=\"(key, errors) in vm.visitaForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>,</small></small></div><small ng-if=\"!vm.visitaForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n<md-card class=\"md-padding\"><md-table-container><table data-md-table md-row-select=\"true\" multiple=\"true\" \nng-model=\"vm.selected\" md-progress=\"vm.monitoraggi.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column>ID</th><th md-column>TIPO</th>\n<th md-column>RICHIESTE</th><th md-column>STATO</th><th md-column>CREATO</th><th md-column>INVIATO</th><th md-column \nclass=\"text-center\">AZIONI</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" md-select-id=\"id\" \nng-disabled=\"true\" ng-repeat=\"item in vm.dettagli\"><td md-cell>{{item.id}}</td><td md-cell><b>{{item.tipo | uppercase}}\n</b></td><td md-cell><md-checkbox ng-model=\"item.richieste\" ng-change=\"vm.checkRichieste(item)\" ng-true-value=\"1\" \nng-false-value=\"0\" aria-label=\"richieste\" ng-disabled=\"item.disabled\"></md-checkbox></td><td md-cell><b>\n{{item.stato.descrizione | uppercase}}</b><br><small>{{item.stato.by.persona.nomeCognome | uppercase}}<br>\n{{item.stato.at ? (item.stato.at *1000 | date : \'medium\') : null}}</small></td><td md-cell><b>\n{{item.owner.persona.nomeCognome | uppercase}}</b><br>{{item.created_at *1000 | date : \'medium\'}}</td><td md-cell><b \nng-if=\"item.tutorInviato\">{{ item.tutorInviato | uppercase }} - </b><span ng-if=\"item.inviato\">\n{{ item.dataInvio *1000 | date : \'medium\' }}</span></td><td md-cell><azioni-dettaglio ng-model=\"item\" duplica=\"true\">\n</azioni-dettaglio></td></tr></tbody></table></md-table-container></md-card><div layout=\"row\" layout-align=\"end\" \nng-if=\"vm.visita.statoId < 3 && vm.tipoDettaglio\"><md-button \nng-if=\"vm.tipoDettaglio === \'amministrativo\' || vm.tipoDettaglio === \'qualitativo\'\" id=\"add-dettaglio-button\" \nclass=\"md-button md-fab md-accent md-icon-button mt-15\" ng-click=\"vm.nuovoDettaglio($event)\" \naria-label=\"nuovo dettaglio\" ng-disabled=\"vm.creatingDettaglio\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\n</md-button><md-select class=\"md-no-underline\" style=\"margin:0\" id=\"tipoNuovoDettaglio\" aria-label=\"seleziona tipo\" \nng-show=\"vm.showTipoSelect\" ng-model=\"vm.tipoNuovoDettaglio\" ng-if=\"vm.tipoDettaglio === \'entrambi\'\" \nng-disabled=\"vm.creatingDettaglio\" placeholder=\"Aggiungi...\"><md-option ng-click=\"vm.salvaDettaglio(tipo)\" \nng-repeat=\"tipo in [\'amministrativo\',\'qualitativo\']\">{{tipo | uppercase}}</md-option></md-select></div></md-tab><md-tab\n label=\"Report\" layout=\"column\" md-on-select=\"vm.switchTab(\'report\')\" md-active=\"vm.activeTab == \'report\'\"><div \nlayout=\"row\" layout-align=\"end\"><md-button type=\"submit\" ng-click=\"vm.salvaReport()\" class=\"md-raised md-accent\" \nng-disabled=\"(vm.dataForm.$submitted || vm.dataForm.$invalid || vm.dataForm.$pristine || vm.visita.statoId < 3)\">\nSALVA REPORT</md-button></div><md-card flex><md-card-content><form name=\"vm.dataForm\" class=\"content md-inline-form\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between\"><img src=\"assets/images/logos/sc.png\">\n<md-input-container flex=\"20\" ng-if=\"vm.visita.report\"><label>Data Invio</label><md-datepicker \nng-model=\"vm.visita.report.dataInvio\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" \nng-disabled=\"!vm.user.permissions.includes(\'invia-report\')\"></md-datepicker></md-input-container><md-input-container>\n<label>Giorni Scadenza</label><input type=\"number\" ng-model=\"vm.visita.giorniScadenza\" \nng-model-options=\"{debounce: 500}\" required></md-input-container><md-input-container ng-if=\"vm.visita.report\" \nflex=\"20\"><label>Data Scadenza</label><md-datepicker ng-model=\"vm.visita.dataScadenza\" \nng-model-options=\"{timezone: \'GMT\'}\" disabled=\"disabled\" name=\"dataScadenza\" md-placeholder=\"GG/MM/AAAA\">\n</md-datepicker><div class=\"validation-messages\" ng-messages=\"vm.dataForm.dataScadenza.$error\" role=\"alert\"><div \nng-message=\"dateDiff\"><span>La data scadenza è stata superata</span></div></div></md-input-container></div></form>\n<md-divider class=\"mt-15\"></md-divider><h2><b>REPORT DI MONITORAGGIO</b></h2><h3>\nMONITORAGGIO DEL PROGETTO DEL COMUNE DI: <b>{{vm.visita.progettoMonitoraggio.enteLocale}}</b><br>ESEGUITO IN DATA: <b>\n{{vm.visita.data | date: \'dd/MM/yyyy\'}}</b></h3><h3>Anagrafica</h3><ul class=\"no-bullets\"><li>Codice Progetto: <b>\n{{vm.visita.progettoMonitoraggio.codiceProgetto}}</b></li><li>Ente Locale Capofila: <b>\n{{vm.visita.progettoMonitoraggio.enteLocale}}</b></li><li>Denominazione: <b>{{vm.visita.nome}}</b></li><li>\nEnti locali partner o consorziati: <b>{{vm.displayMultiple(vm.visita.enti | filter : {ruolo: \'partner\'}, \'nomeEnte\')}}\n</b></li><li>Enti locali aderenti al progetto: <b>\n{{vm.displayMultiple(vm.visita.enti | filter : {ruolo: \'aderente\'}, \'nomeEnte\')}}</b></li><li>Enti attuatori: <b>\n{{vm.displayMultiple(vm.visita.enti | filter : {ruolo: \'attuatore\'}, \'nomeEnte\')}}</b></li><li>Categoria di progetto: \n<b>{{vm.visita.progettoMonitoraggio.progetto.tipologiaAccoglienza.descrizione}}</b></li><li>Periodo di finanziamento: \n<b>\n{{vm.visita.progettoMonitoraggio.dataInizioFinanziamento | date}} - {{vm.visita.progettoMonitoraggio.dataFineFinanziamento | date}}\n</b></li><li>Tipologia di accoglienza: <b>{{vm.displayMultiple(vm.visita.tipAccoglienza, \'descrizione\')}}</b></li><li>\nNumero Posti finanziati al momento della visita: <b>{{vm.visita.numeroPosti}}</b></li><li>\nNumero Posti attivi al momento della visita: <b>{{vm.visita.numeroPostiAttivi}}</b></li><li \nng-if=\"!vm.visita.importoFinanziatoTemporaneo\">Contributo Assegnato: <b>{{vm.visita.importoFinanziato | currency}}</b>\n</li><li>Finanziato a valere su Fondo FAMI: <b>{{vm.visita.finanziatoFondoFami ? \'SI\' : \'NO\'}}</b></li><li>\nStrutture di accoglienza (numero): <b>{{vm.visita.numeroStrutture}}</b></li><li>\nStrutture di accoglienza visitate(numero): <b>{{vm.visita.numeroStruttureVisitate}}</b></li><li>\nBeneficiari presenti alla data della missione: <b>{{vm.visita.numeroBeneficiari}}</b></li><li>\nNominativi dei Referenti incontrati dell\'ente locale /partner/consorziati/aderenti e dell\'ente attuatore: <b>\n{{vm.visita.nomiReferenti}}</b></li><li>Nominativi dei Referenti di altri enti presenti alla visita di monitoraggio: \n<b>{{vm.visita.nomiReferentiExtra}}</b></li><li>Presenza Prefettura: <b>{{vm.visita.presenzaPrefettura ? \'SI\' : \'NO\'}}\n</b></li><li>Presenza Ministero/DLCI : <b>{{vm.visita.presenzaMinistero ? \'SI\' : \'NO\'}}</b></li><li>\nIn loco/A distanza: <b>{{vm.visita.daRemoto ? \'D\' : \'L\'}}</b></li><li>Numero giorni: <b>{{vm.visita.numeroGiorni}}</b>\n</li></ul><h3>VALUTAZIONE SINTETICA<br>\nANDAMENTO PROGETTUALE RISPETTO ALLE LINEE GUIDA SAI, ALLA DATA DEL {{vm.visita.data | date: \'dd/MM/yyyy\'}}</h3>\n<md-table-container ng-if=\"vm.visita.giudizio\"><table md-table \nng-style=\"{\'background-color\': vm.colorMap[vm.visita.giudizio.id]}\"><tbody><tr><td md-cell>\nANDAMENTO PROGETTUALE {{vm.visita.giudizio.descrizione}}</td></tr></tbody></table></md-table-container><form \nname=\"vm.sintesiForm\" class=\"content md-inline-form p-8\" novalidate layout=\"column\" unsaved-warning-form>\n<ng-quill-editor ng-model=\"vm.visita.sintesi\" read-only=\"vm.disabled(\'sintesi\')\"></ng-quill-editor><div layout=\"row\" \nng-if=\"vm.user.permissions.includes(\'view-rapporto\')\"><md-button \nng-if=\"vm.dettagliValidati.amministrativo !== undefined\" ng-click=\"vm.showRapportoDialog($event, \'amministrativo\')\" \nclass=\"md-raised\">RAPPORTO AMMINISTRATIVO</md-button><md-button ng-if=\"vm.dettagliValidati.qualitativo !== undefined\" \nng-click=\"vm.showRapportoDialog($event, \'qualitativo\')\" class=\"md-raised\">RAPPORTO QUALITATIVO</md-button><div \nlayout=\"row\" layout-align=\"end\" flex ng-if=\"!vm.disabled(\'sintesi\')\"><md-button type=\"submit\" \nng-click=\"vm.salvaSintesi()\" class=\"md-raised md-accent\" \nng-disabled=\"(vm.sintesiForm.$submitted || vm.sintesiForm.$invalid || vm.sintesiForm.$pristine)\">SALVA</md-button>\n</div></div></form></md-card-content></md-card><div layout=\"row\"><md-button ng-click=\"vm.inviaReport($event)\" \nclass=\"md-raised md-accent\" ng-if=\"vm.user.permissions.includes(\'invia-report\')\" ng-disabled=\"!vm.visita.validita.ok\">\n<div style=\"pointer-events: auto\"><md-tooltip ng-if=\"!vm.visita.validita.ok\">{{vm.visita.validita.message}}\n</md-tooltip>CONFERMA REPORT</div></md-button><md-button ng-click=\"vm.annullaInvioReport()\" class=\"md-raised\" \nng-style=\"{\'background-color\': \'red\', \'color\': \'white\'}\" \nng-if=\"vm.user.permissions.includes(\'invia-report\') && !vm.visita.esitoId && vm.visita.statoId != 2\" \nng-disabled=\"vm.visita.esitoId || vm.visita.statoId == 2\">RIMUOVI CONFERMA</md-button><md-button \nng-click=\"vm.assegnaEsito($event)\" class=\"md-raised md-accent\" ng-if=\"vm.user.permissions.includes(\'assegna-esito\')\" \nng-disabled=\"vm.visita.esitoId || vm.visita.statoId < 3 || (vm.visita.richieste == true && vm.visita.report.dataInvio == null)\">\nASSEGNA ESITO</md-button><md-button ng-click=\"vm.segnalaMinint($event)\" class=\"md-raised md-accent\" \nng-if=\"vm.user.permissions.includes(\'segnala-minint\')\" \nng-disabled=\"vm.visita.dataSegnalazione || vm.visita.statoId < 3\">SEGNALA AL MININT</md-button><md-button \nng-click=\"vm.esportaPdf($event)\" class=\"md-raised md-accent\" ng-disabled=\"false\">ESPORTA IN PDF</md-button></div>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/search-form.html","<div layout=\"column\"><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"fc.buildFilter()\">Cerca\n</md-button><md-button type=\"submit\" ng-click=\"fc.reset()\">Reset</md-button></div><md-input-container flex \nng-if=\"fc.isCruscotto == false\"><label><b>Anno monitoraggio</b></label><md-select ng-model=\"fc.searchModel.anno\" \nmultiple=\"multiple\"><md-option ng-value=\"opt\" ng-repeat=\"opt in fc.anniMonitoraggio\">{{opt}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><b>Periodo</b></label><md-select ng-model=\"fc.selectedPeriodo\" \nng-change=\"fc.searchModel.periodoMonitoraggioId = []\"><md-option ng-value=\"opt\" ng-repeat=\"opt in fc.periodo\">{{opt}}\n</md-option></md-select></md-input-container><md-input-container flex ng-if=\"fc.selectedPeriodo == \'Quadrimestre\'\">\n<label><b>Quadrimestre</b></label><md-select ng-model=\"fc.searchModel.periodoMonitoraggioId\" multiple=\"multiple\">\n<md-option ng-value=\"key*1\" ng-repeat=\"(key,quad) in fc.quadrimestri\">{{quad}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"fc.selectedPeriodo == \'Semestre\'\"><label><b>Semestre</b></label>\n<md-select ng-model=\"fc.searchModel.periodoMonitoraggioId\" multiple=\"multiple\"><md-option ng-value=\"key*1\" \nng-repeat=\"(key,sem) in fc.semestri\">{{sem}}</md-option></md-select></md-input-container><md-input-container flex>\n<label><b>Tipo</b></label><md-select ng-model=\"fc.searchModel.tipo\"><md-option md-option-empty></md-option><md-option \nng-value=\"tipo\" ng-repeat=\"tipo in fc.tipoMonitoraggio\">{{tipo}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"fc.p.includes(\'view-tutor\')\"><label><b>Tutor Amministrativo</b></label><md-select \nng-model=\"fc.searchModel.tutorAmmId\" name=\"tutorAmmId\" multiple=\"multiple\"><md-option ng-value=\"tutor.id\" \nng-repeat=\"tutor in fc.tutorAmministrativi track by tutor.id\">{{tutor.persona.nomeCognome | uppercase}}</md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"fc.p.includes(\'view-tutor\')\"><label><b>\nTutor Qualitativo</b></label><md-select ng-model=\"fc.searchModel.tutorQualId\" name=\"tutorQualId\" multiple=\"multiple\">\n<md-option ng-value=\"tutor.id\" ng-repeat=\"tutor in fc.tutorQualitativi track by tutor.id\">\n{{tutor.persona.nomeCognome | uppercase}}</md-option></md-select></md-input-container><md-input-container flex><label>\n<b>Area Geografica</b></label><md-select ng-model=\"fc.searchModel.codRipartGeo\" name=\"areaGeografica\" \nmultiple=\"multiple\"><md-option ng-value=\"key\" ng-repeat=\"(key, area) in fc.areaGeografica \">{{area}}</md-option>\n</md-select></md-input-container><md-input-container flex><label><b>Regione</b></label><md-select \nng-model=\"fc.searchModel.regione\" name=\"regione\" multiple=\"multiple\"><md-option ng-value=\"regione.id\" \nng-repeat=\"regione in fc.ricerca.regiones | filter:{regione:\'!-\'}:true\">{{regione.regione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><b>Provincia</b></label><md-select \nng-model=\"fc.searchModel.provincia\" name=\"provincia\" multiple=\"multiple\"><md-option ng-value=\"provincia.id\" \nng-repeat=\"provincia in fc.ricerca.provincias | filter:{provincia:\'!-\'}:true\">{{provincia.provincia}}</md-option>\n</md-select></md-input-container><md-input-container flex><label><b>Categoria</b></label><md-select \nng-model=\"fc.searchModel.categoria\" name=\"categoria\" multiple=\"multiple\"><md-option ng-value=\"tip.id\" \nng-repeat=\"tip in fc.tipologieAccoglienza.data \">{{tip.descrizione | uppercase}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><b>Stato</b></label><md-select ng-model=\"fc.searchModel.statoId\" \nname=\"stato\" multiple=\"multiple\"><md-option ng-value=\"stato.id\" \nng-repeat=\"stato in fc.statoMonitoraggio | filter:{gruppo:\'STATO\'}:true\">{{stato.descrizione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><b>Esito</b></label><md-select ng-model=\"fc.searchModel.esitoId\" \nname=\"esito\" multiple=\"multiple\"><md-option ng-value=\"esito.id\" \nng-repeat=\"esito in fc.statoMonitoraggio | filter:{gruppo:\'ESITO\'}\">{{esito.descrizione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><b>Giudizio</b></label><md-select \nng-model=\"fc.searchModel.giudizioId\" name=\"giudizio\" multiple=\"multiple\"><md-option ng-value=\"giudizio.id\" \nng-repeat=\"giudizio in fc.statoMonitoraggio | filter:{gruppo:\'GIUDIZIO\'}\">{{giudizio.descrizione}}</md-option>\n</md-select></md-input-container><md-input-container flex><label><b>Monitoraggio Scaduto</b></label><md-select \nng-model=\"fc.searchModel.monitoraggioScaduto\" name=\"monitoraggioScaduto\"><md-option md-option-empty ng-value=\"null\">\n</md-option><md-option ng-value=\"0\">NO</md-option><md-option ng-value=\"1\">SI</md-option></md-select>\n</md-input-container><div layout=\"row\"><md-input-container flex ng-if=\"!fc.visitatore\"><label><b>Validato</b></label>\n<md-select ng-model=\"fc.searchModel.confermato\" name=\"confermato\"><md-option md-option-empty></md-option><md-option \nng-value=\"0\">NO</md-option><md-option ng-value=\"1\">SI</md-option></md-select></md-input-container><md-input-container \nflex><label><b>Richieste</b></label><md-select ng-model=\"fc.searchModel.richieste\" name=\"richieste\"><md-option \nmd-option-empty></md-option><md-option ng-value=\"0\">NO</md-option><md-option ng-value=\"1\">SI</md-option></md-select>\n</md-input-container></div></div>");
$templateCache.put("app/main/sprardb/notification/autoinserimento-details.html","<div id=\"notification\" class=\"page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding:32px 24px 24px 24px\"><form name=\"reportForm\" novalidate><input type=\"text\" name=\"id\" hidden=\"\" \nng-model=\"vm.segnalazione.id\"> <input type=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.segnalazione.persona_id\">\n<div layout=\"row\" layout-xs=\"column\"><div flex=\"30\"><div flex><label><small>Data Segnalazione</small></label>\n<md-datepicker class=\"md-block\" ng-disabled=\"vm.statos > 1\" md-no-float ng-model=\"vm.segnalazione.data\" \nmd-placeholder=\"Data di Nascita\" readonly=\"readonly\" ng-required=\"false\"></md-datepicker></div><md-input-container \nflex style=\"width: 95%;top:38px\"><label>Tipo Segnalazione</label><md-select ng-model=\"vm.segnalazione.tipo\" \nname=\"tipo\" placeholder=\"Tipo Segnalazione\" ng-disabled=\"vm.statos > 0\" required flex><md-option value=\"C\">Modello C\n</md-option></md-select><div ng-messages=\"reportForm.tipo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.TYPE\">Notification type is required</span></div></div></md-input-container></div><div \nflex=\"40\"><md-input-container flex style=\"width: 95%\"><label>Note</label><textarea name=\"note\" \nng-model=\"vm.segnalazione.note\" placeholder=\"Inserire una nota...\" rows=\"4\" ng-readonly=\"vm.statos > 0\" required flex>\n</textarea><div ng-messages=\"reportForm.note.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.NOTE\">Notification type is required</span></div></div></md-input-container></div><div \nflex=\"15\"><md-input-container flex><label>Operatore Nome</label><input type=\"text\" placeholder=\"Nome\" name=\"nome\" \nng-model=\"vm.persona.nome\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container><md-input-container flex \nstyle=\"top:16px\"><input type=\"text\" name=\"cognome\" placeholder=\"Cognome\" ng-model=\"vm.persona.cognome\" \nreadonly=\"readonly\" disabled=\"disabled\"></md-input-container></div><div flex=\"15\"><md-input-container flex><label>\nMobile</label><input type=\"text\" name=\"Mobile\" ng-model=\"vm.persona.telefono\" readonly=\"readonly\" disabled=\"disabled\">\n</md-input-container><md-input-container flex style=\"top:0px;widht:100%\"><md-button \nng-repeat=\"state in vm.state| filter: {id: vm.statos}: true\" class=\"{{vm.scolors[(vm.statos + 1)]}}\" \naria-label=\"status\" flex>{{state.stato}}<md-tooltip><span>{{state.stato}}</span></md-tooltip></md-button>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex><label>\nProgetto territoriale ({{vm.progettos.length}})</label><md-select ng-model=\"vm.segnalazione.progetto_id\" \nng-change=\"vm.searchStrutturas();\" placeholder=\"Scegliere progetto...\" ng-disabled=\"vm.statos > 0\" \nng-required=\"vm.isnew\" name=\"pter\"><md-option class=\"small\" ng-repeat=\"pro in vm.progettos\" value=\"{{pro.id}}\" \nng-selected=\"(vm.segnalazione.progetto_id == pro.id)\"><small><b>{{pro.nome}}</b> in {{pro.istats.comune}}</small>\n</md-option></md-select><div ng-messages=\"reportForm.pter.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto!!!</span></div></div></md-input-container><md-input-container flex><label>\nStrutture ({{vm.strutturas.length}})</label><md-select ng-model=\"vm.segnalazione.struttura_id\" \nng-change=\"vm.selStrututra();\" placeholder=\"Scegliere struttura...\" ng-disabled=\"vm.statos > 0\" ng-required=\"vm.isnew\" \nname=\"stru\"><md-option class=\"small\" ng-repeat=\"pro in vm.strutturas\" value=\"{{pro.id}}\"><small><b>{{pro.nome}}</b>\n in {{pro.istats.comune}} ({{(pro.numeroPosti - pro.beneficiarios.length)}}) - {{pro.strutturaAccoglienzas.descrizione}} {{pro.strutturaAlloggios.descrizione}}\n</small></md-option></md-select><div ng-messages=\"reportForm.stru.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesto!!!</span></div></div></md-input-container></div></form></md-card><div layout=\"row\" layout-sm=\"column\" \nng-show=\"vm.progress\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><md-card><input type=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span flex></span><form name=\"filterForm\">\n<md-input-container style=\"top:20px\"><md-icon md-font-icon=\"icon-account-search\" class=\"icon\"></md-icon><input \ntype=\"text\" name=\"search\" placeholder=\"Ricerca\" ng-model=\"vm.search\"></md-input-container></form></div></md-toolbar>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.query.order\" md-on-reorder=\"vm.getNotification\"><tr md-row><th md-column md-order-by=\"id\"><span>Cod\n</span></th><th md-column md-order-by=\"nome\"><span>NOME</span></th><th md-column md-order-by=\"cognome\">COGNOME</th><th \nmd-column md-order-by=\"sesso\">SESSO</th><th md-column>DATA NASCITA</th><th md-column>NAZIONALITA</th><th md-column>\nAZIONI</th></tr></thead><tbody md-body><tr md-row md-select=\"segnalatos\" x-md-auto-select=\"vm.options.autoSelect\" \nmd-select-id=\"segnalatos.id\" data-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"segnalatos in vm.notification| filter: vm.search | orderBy: vm.query.sort | limitTo: vm.query.perPage : ((vm.query.page - 1) * vm.query.perPage) track by $index\">\n<td md-cell>{{segnalatos.id}}</td><td md-cell editable-field>{{segnalatos.nome}}</td><td md-cell editable-field>\n{{segnalatos.cognome}}</td><td md-cell editable-field>{{segnalatos.sesso}}</td><td md-cell editable-field>\n{{segnalatos.dataNascita|date:\'yyyy-MM-dd\'}}</td><td md-cell><div ng-repeat=\"state in vm.nazionalitas\"><span \nng-if=\"segnalatos.codNazionalita == state.id\">{{state.descrizione}}</span></div></td><td md-cell><md-button \nclass=\"md-icon-button\" aria-label=\"Edit\" \nng-disabled=\"vm.statos > 0 || segnalatos.id === null || segnalatos.id === undefined\" \nng-click=\"vm.editPerson($event, segnalatos)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Modifica\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"trash\" ng-disabled=\"vm.statos > 0\" \nng-click=\"vm.trashPerson($event, segnalatos)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Cancella\n</md-tooltip></md-button><md-button ng-if=\"!segnalatos.id\" class=\"md-icon-button\" aria-label=\"alert\"><md-icon \nmd-font-icon=\"icon-alert\"></md-icon><md-tooltip>Persona da salvare!</md-tooltip></md-button></td></tr></tbody></table>\n</md-table-container><md-card-actions layout=\"row\" layout-xs=\"column\" layout-align=\"start left\"><div flex=\"30\" \nstyle=\"border-top-color: rgba(0, 0, 0, 0.12);border-top-style: solid;border-top-width: 1px\"><md-button type=\"submit\" \nclass=\"md-accent\" aria-label=\"Save Person\" translate=\"NOTIFICATIONS.SAVE_PERSON\" \ntranslate-attr-aria-label=\"REGISTER.SAVE_PERSON\" ng-disabled=\"vm.statos > 0\" ng-click=\"vm.saveNotification($event)\">\nSave</md-button><md-button type=\"submit\" ng-disabled=\"vm.notification.totalCount === 0 || vm.statos > 0\" \nclass=\"md-accent\" aria-label=\"SEND REPORT\" translate=\"NOTIFICATIONS.SEND_REPORT\" \ntranslate-attr-aria-label=\"REGISTER.SEND_REPORT\" ng-click=\"vm.sendReport($event)\">New Person</md-button></div><div \nflex=\"70\"><md-table-pagination md-limit=\"vm.query.perPage\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.query.page\" \nmd-total=\"{{vm.notification.length}}\" md-on-paginate=\"vm.onPaginate\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></div></md-card-actions></md-card><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-contact-button\" ng-disabled=\"reportForm.$invalid || vm.statos > 0\" ng-click=\"vm.newPerson($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"Nuova Segnalato\"><md-tooltip md-direction=\"Top\">\nNuovo segnalato</md-tooltip><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/sprardb/notification/autoinserimento.html","<div id=\"notification\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Ricerca Autosegnalazione</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"50\"><md-input-container md-no-float class=\"m-0\" flex \nstyle=\"padding-top:20px\"><input id=\"search\" placeholder=\"Ricerca segnalazioni (nome cognome segnalato)\" type=\"text\" \nng-model=\"vm.ricerca2\" ng-change=\"vm.onSearch()\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"45\" flex-offset=\"5\"><md-input-container flex><label>\nStato autoinserimento</label><md-select ng-model=\"vm.ricerca[\'eventos-eventoStato_id\']\" ng-change=\"vm.onSearch();\">\n<md-option value=\"null\">Tutti</md-option><md-option ng-repeat=\"obj in vm.state\" \nng-if=\"[-1, 1, 4, 5].indexOf(obj.id) >= 0\" value=\"{{obj.id}}\"><small><b>{{obj.stato}}</b></small></md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' || key != \'tipo_IN\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\n{{vm.ricercalabel[key]}}{{ricercato}}</span></div><md-card><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.segnalaziones\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\"><span>Cod</span></th><th md-column>STATO</th><th md-column md-order-by=\"tipo\">TIPO</th><th \nmd-column md-order-by=\"data\"><span>DATA</span></th><th md-column>OPERATORE</th><th md-column>SEGNALATI</th><th \nmd-column>ENTE</th><th md-column>AZIONI</th></tr></thead><tbody md-body><tr md-row md-select=\"notification\" \nmd-select-id=\"notification\" ng-disabled=\"notification.personas.id !== vm.persona.persona_id\" \ndata-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"notification in vm.notifications| orderBy: vm.query.order\" \nclass=\"{{(notification.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\"><td md-cell>{{notification.id}}</td><td \nmd-cell><md-button ng-repeat=\"state in vm.state| filter: {id: notification.eventos.eventoStato_id}: true\" \nclass=\"md-fab md-mini {{vm.scolors[(notification.eventos.eventoStato_id + 1)]}}\" aria-label=\"status\">\n{{state.stato|limitTo:1}}<md-tooltip><span>{{state.stato}}</span></md-tooltip></md-button></td><td md-cell><b>\nMOD. {{notification.tipo}}</b></td><td md-cell>{{notification.data}}</td><td md-cell \nng-if=\"notification.personas.id == vm.persona.persona_id\">Me stesso</td><td md-cell \nng-if=\"notification.personas.id != vm.persona.persona_id\">\n{{notification.personas.nome}} {{notification.personas.cognome}}</td><td md-cell \nng-init=\"obj = notification.segnalatos\">{{ obj.length}}</td><td md-cell>{{notification.progettos.nome| uppercase}}</td>\n<td md-cell><md-button ui-sref=\"app.sprardb_notification.editareport({ id:notification.id , auto:vm.autoinsert})\" \nclass=\"md-accent md-button-icon\" aria-label=\"View Detailed\" ng-click=\"vm.viewDetails($event, notification.id)\" \nng-if=\"(notification.eventos.eventoStato_id != -1) || (notification.personas.id != vm.persona.persona_id)\"><i \nclass=\"icon icon-lock-outline s16\"></i> Visualizza</md-button><md-button \nui-sref=\"app.sprardb_notification.editareport({ id:notification.id , auto:vm.autoinsert})\" \nclass=\"md-accent md-button-icon\" aria-label=\"Edit Detailed\" ng-click=\"vm.viewDetails($event, notification.id)\" \nng-if=\"(notification.eventos.eventoStato_id == -1) && (notification.personas.id == vm.persona.persona_id)\"><i \nclass=\"icon icon-lock-unlocked-outline s16\"></i> Modifica</md-button><md-button class=\"md-accent md-button-icon\" \naria-label=\"PDF\" ng-click=\"vm.downloadPdf2($event, notification)\" \nng-disabled=\"notification.eventos.eventoStato_id == -1\"><i class=\"icon icon-file-pdf-box s16\"></i> PDF</md-button></td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.newReport($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"Nuova Autoinserimento\"><md-tooltip md-direction=\"Top\">\nNuova Autoinserimento</md-tooltip><md-icon md-font-icon=\"icon-auto-fix\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/sprardb/notification/notification-details.html","<div id=\"notification\" class=\"page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" \naria-label=\"b1\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\"><span ng-if=\"!vm.segnalazione.id\">{{vm.title}}</span> <span \nng-if=\"vm.segnalazione.id\">Registrazione</span></span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll style=\"padding-right:16px\"><md-card \nclass=\"padding-16\" style=\"padding:32px 16px 16px 24px\"><form name=\"reportForm\" novalidate><input type=\"text\" name=\"id\" \nhidden=\"\" ng-model=\"vm.segnalazione.id\"> <input type=\"text\" name=\"persona_id\" hidden=\"\" \nng-model=\"vm.segnalazione.persona_id\"><div layout=\"row\" layout-xs=\"column\" flex><md-input-container flex \nstyle=\"max-height: 70px\"><label>Tipo di Registrazione</label><md-select ng-model=\"vm.segnalazione.idTipoSegnalazione\" \nname=\"tipo\" placeholder=\"<b>Tipo di Registrazione</b><br><small>descrizione</small>\" ng-disabled=\"vm.statos > 0\" \nrequired style=\"min-height: 54px\" ng-change=\"vm.sceglisegnalazione()\"><md-option \nng-repeat=\"item in vm.tipoasegnalazione\" ng-value=\"item.id\" title=\"{{item.note}}\"><div layout=\"column\"><b>\n{{item.descrizione|uppercase}}</b> <small>{{item.note}}</small></div></md-option></md-select><div \nng-messages=\"reportForm.tipo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.TYPE\">Notification type is required</span></div></div></md-input-container>\n<md-input-container flex=\"25\" ng-if=\"vm.segnalazione.requiredFields.esterna\"><label>Modalità di Registrazione</label>\n<md-select ng-model=\"vm.segnalazione.esterna\" name=\"esterna\" \nplaceholder=\"<b>Modalità accoglienza segnalato</b><br><small>descrizione</small>\" required flex \nstyle=\"min-height: 54px\" ng-disabled=\"vm.statos > 1\"><md-option ng-value=\"0\" \nng-click=\"vm.segnalazione.nuovodomicilioesterno = \'\'; vm.segnalazione.struttura_id = 0;\"><div layout=\"column\"><b>\nACCOGLIENZA INTERNA</b> <small>Inserimento struttura interna allo SPRAR</small></div></md-option><md-option \nng-value=\"1\" ng-click=\"vm.segnalazione.struttura_id = 0;\"><div layout=\"column\"><b>ACCOGLIENZA ESTERNA</b> <small>\nInserimento struttura esterna allo SPRAR</small></div></md-option></md-select><div \nng-messages=\"reportForm.tipo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.TYPE\">Notification type is required</span></div></div></md-input-container><div \nflex=\"35\" layout=\"column\" class=\"datepicker-container\" style=\"margin-top:0px\"><label \nng-if=\"vm.segnalazione.idTipoSegnalazione == 605\" flex \nstyle=\"max-height: 23px;transform: translate3d(0, -12px, 0) scale(0.75)\">Data Lettera Servizio Centrale</label><label \nng-if=\"vm.segnalazione.idTipoSegnalazione != 605 && vm.segnalazione.idTipoSegnalazione != 697\" flex \nstyle=\"max-height: 23px;transform: translate3d(0, -12px, 0) scale(0.75)\">Data Modello C</label><label \nng-if=\"vm.segnalazione.idTipoSegnalazione == 697\" flex \nstyle=\"max-height: 23px;transform: translate3d(0, -12px, 0) scale(0.75)\">Data Registrazione</label><div flex>\n<md-datepicker ng-if=\"vm.segnalazione.idTipoSegnalazione == 605 || vm.segnalazione.idTipoSegnalazione == 697\" \nclass=\"md-block\" ng-disabled=\"vm.statos > 1\" md-no-float ng-model=\"vm.segnalazione.data\" \nmd-placeholder=\"Data di Segnalazione\" flex md-max-date=\"vm.oggi\" md-min-date=\"vm.minDataSegnalazione\"></md-datepicker>\n<md-datepicker ng-if=\"vm.segnalazione.idTipoSegnalazione != 605 && vm.segnalazione.idTipoSegnalazione != 697\" \nclass=\"md-block\" ng-disabled=\"vm.statos > 1\" md-no-float ng-model=\"vm.segnalazione.data\" \nmd-placeholder=\"Data di Segnalazione\" flex md-max-date=\"vm.dataMaxModelloC\" md-min-date=\"vm.minDataSegnalazione\">\n</md-datepicker></div></div><div flex=\"15\" layout=\"column\"><small><b>Stato:</b></small> <small \nng-repeat=\"state in vm.state| filter: {id: vm.statos}: true\"><i class=\"icon-timetable s16\"></i> {{state.stato}}</small>\n</div></div><div layout=\"row\" layout-xs=\"column\" style=\"margin-top:24px\"><md-input-container flex \nstyle=\"max-height: 70px\"><label>Progetto territoriale ({{vm.progettos.length}})</label><md-select \nng-model=\"vm.segnalazione.progetto_id\" ng-change=\"vm.searchStrutturas();\" placeholder=\"Scegliere progetto...\" \nng-disabled=\"vm.statos > 0\" required name=\"pter\"><md-option ng-repeat=\"pro in vm.progettos\" ng-value=\"pro.id\" \nng-if=\"pro.id > 0\"><div layout=\"column\"><b>{{pro.nome|uppercase}}</b> <small>POSTI LIBERI:<b>{{pro.postiLiberi}}</b>\n&nbsp;&nbsp;&nbsp;POSTI PRENOTATI:<b>{{pro.postiPrenotati}}</b></small></div></md-option></md-select><div \nng-messages=\"reportForm.pter.$error\" role=\"alert\"><div ng-message=\"required\"><span>Progetto richiesto</span></div>\n</div></md-input-container><md-input-container flex=\"35\" style=\"max-height: 70px\"><label>Ente Attuatore</label>\n<md-select ng-model=\"vm.segnalazione.ente_id\" placeholder=\"Scegliere ente attuatore...\" ng-disabled=\"vm.statos > 0\" \nng-required=\"vm.isnew\" name=\"enteAttuatore\"><md-option ng-repeat=\"phe in vm.listaEntiAttuatori\" ng-value=\"phe.ente.id\">\n{{phe.ente.nome}}</md-option></md-select><div ng-messages=\"reportForm.enteAttuatore.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ente attuatore richiesto</span></div></div></md-input-container><md-input-container \nflex=\"35\" style=\"max-height: 70px\" \nng-if=\"vm.segnalazione.esterna != -1 && vm.segnalazione.requiredFields.struttura_id\"><label>\nStrutture ({{vm.strutturas.length}})</label><md-select ng-model=\"vm.segnalazione.struttura_id\" \nng-change=\"vm.selStrututra();\" placeholder=\"Scegliere struttura...\" ng-disabled=\"vm.statos > 0\" \nng-required=\"!vm.segnalazione.id\" name=\"stru\"><md-option \nng-repeat=\"pro in vm.strutturas| filter:{esterna:vm.segnalazione.esterna} track by pro.id\" ng-value=\"pro.id\"><div \nlayout=\"column\"><b>{{pro.nome|uppercase}}</b> <small>in <b>{{pro.istats.comune}}</b>\n ({{(pro.numeroPosti - pro.beneficiarios.length)}}) - {{pro.strutturaAccoglienzas.descrizione}} {{pro.strutturaAlloggios.descrizione}}\n</small></div></md-option></md-select><div ng-messages=\"reportForm.stru.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Struttura richiesta</span></div></div></md-input-container><div flex=\"15\" layout=\"column\">\n<small><b>Operatore</b></small> <small ng-if=\"vm.abilitaModifica() < 2\">{{vm.persona.cognome}} {{vm.persona.nome}}\n</small> <small ng-if=\"vm.abilitaModifica() < 2\">{{vm.persona.telefono}}</small> <small \nng-if=\"vm.abilitaModifica() == 2\">Compilato da:</small> <small ng-if=\"vm.abilitaModifica() == 2\"><b>Servizio Centrale\n</b></small></div></div><div layout=\"row\" layout-xs=\"column\" style=\"margin-top:24px\" \nng-if=\"vm.segnalazione.struttura_id == -100\"><md-input-container flex class=\"margin-bottom-0\"><label><b>\nNuovo domicilio esterno</b></label><input id=\"nuovodomicilioesterno\" placeholder=\"Nuovo domicilio esterno\" type=\"text\" \nng-model=\"vm.segnalazione.nuovodomicilioesterno\"></md-input-container></div><div layout=\"row\" layout-align=\"end start\">\n<input type=\"hidden\" name=\"note\" id=\"note\" value=\"{{vm.segnalazione.note}}\"><md-button class=\"mb-button md-accent-bg\" \naria-label=\"Salva lista\" \nng-disabled=\"reportForm.$invalid || !reportForm.$dirty || vm.statos > 0 || vm.segnalazione.segnalatos.length > 0\" \nng-click=\"vm.saveNotification($event)\" ng-if=\"!vm.api.isReadOnly && vm.segnalazione.id\"><i \nclass=\"icon-content-save s16\"></i> Salva modifiche</md-button></div></form></md-card><md-button \nclass=\"mb-button md-accent-bg md-start\" aria-label=\"nuovosegnalato\" \nng-if=\"!vm.api.isReadOnly && vm.segnalazione.id && vm.segnalazione.idTipoSegnalazione == 697\" \nng-disabled=\"vm.statos > 0\" ng-click=\"vm.newPerson($event)\"><i class=\"icon-account-plus s16\"></i>\n Aggiungi Presente sul territorio</md-button><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<md-button class=\"mb-button md-accent-bg\" aria-label=\"nuovosegnalato\" \nng-if=\"!vm.api.isReadOnly && vm.segnalazione.id && vm.segnalazione.idTipoSegnalazione != 697\" \nng-disabled=\"vm.statos > 0\" ng-click=\"vm.newPerson($event)\"><i class=\"icon-account-plus s16\"></i> Aggiungi beneficiario\n</md-button><div flex></div><md-button class=\"mb-button md-accent-bg\" aria-label=\"Salva lista\" \nng-if=\"!vm.api.isReadOnly && !vm.segnalazione.id\" ng-disabled=\"reportForm.$invalid || vm.statos > 0\" \nng-click=\"vm.saveNotification($event)\"><i class=\"icon-content-save s16\"></i> Salva e Avanti</md-button><div flex></div>\n</div><div layout=\"row\" layout-sm=\"column\" ng-show=\"vm.progress\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-card ng-if=\"vm.segnalazione.id\"><input type=\"text\" \nname=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalati selezionati\' : \'segnalato selezionato\'}} :</span><div \nflex></div><md-button aria-label=\"Nucleo\" ng-click=\"vm.editparentela()\" class=\"md-button\" \nng-disabled=\"(vm.selected.length == 0 || !vm.segnalazione.nucleoFamiliare)\"><i \nclass=\"icon-account-multiple-outline s18\"></i> Nucleo Familiare</md-button></div></md-toolbar><md-table-container>\n<table md-table md-progress=\"vm.promise\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.query.order\" \nmd-on-reorder=\"vm.getNotification\"><tr md-row><th md-column><span>Cod</span></th><th md-column><span>NOME</span></th>\n<th md-column>COGNOME</th><th md-column>SESSO</th><th md-column>DATA NASCITA</th><th md-column>NAZIONALITA</th><th \nmd-column>DOCUMENTO</th><th md-column>PARENTELA</th><th md-column>OMONIMO</th><th md-column style=\"text-align: right\">\nAZIONI</th></tr></thead><tbody md-body><tr md-row md-select=\"segnalati\" \nng-repeat=\"segnalati in vm.notification| filter: vm.search | orderBy: vm.query.sort | limitTo: vm.query.perPage : ((vm.query.page - 1) * vm.query.perPage) track by $index\">\n<td md-cell><span ng-if=\"!segnalati.id || segnalati.isupdated\"><i class=\"icon-alert md-warn-fg s16\" \ntitle=\"da salvare!!!\"></i></span>{{segnalati.id}}</td><td md-cell editable-field>{{segnalati.nome}}</td><td md-cell \neditable-field>{{segnalati.cognome}}</td><td md-cell editable-field>{{segnalati.sesso}}</td><td md-cell editable-field>\n{{segnalati.dataNascita|date:\'dd/MM/yyyy\'}}</td><td md-cell><div ng-repeat=\"state in vm.nazionalitas\"><span \nng-if=\"segnalati.codNazionalita == state.id\">{{state.descrizione}}</span></div></td><td md-cell>\n{{segnalati.documentoTipo.descrizione}}</td><td md-cell><i ng-if=\"(segnalati.nucleoFamiliare === 1)\" \nng-class=\"{\'md-warn-fg\': vm.capofamigliaWarning}\" class=\"icon-account-multiple-outline\"><md-tooltip>\n{{segnalati.parentelaTipo.descrizione|uppercase}} <span ng-if=\"vm.capofamigliaWarning\">&nbsp;(CAPOFAMIGLIA MANCANTE)\n</span></md-tooltip></i><small ng-if=\"(segnalati.nucleoFamiliare === 0)\"><b>MONOPAREN.</b></small> <small \nng-if=\"(segnalati.nucleoFamiliare === 2)\"><b>NON SA</b></small></td><td md-cell><div class=\"row\" \nng-if=\"(segnalati.omonimo > 0)\"><md-button class=\"md-button-small md-amber-200-bg\" aria-label=\"nessuno\" \nng-click=\"vm.omonimi(segnalati)\"><small>SI</small></md-button></div><div class=\"row\" ng-if=\"(segnalati.omonimo == 0)\" \nng-click=\"vm.omonimiac(segnalati)\"><small>NO</small></div></td><td md-cell style=\"text-align: right\"><div layout=\"row\" \nlayout-align=\"end\"><div layout=\"column\" ng-if=\"vm.controllaAllegatoNecessario(segnalati, vm.segnalazione)\"><span \nng-click=\"vm.alertAllegati($event)\" style=\"cursor: pointer\" class=\"red-700-fg\"><i \nclass=\"icon-information s14 red-700-fg\"></i> <b>ALLEGATI OBBLIGATORI</b></span> <span style=\"cursor: pointer\"><a \nng-click=\"vm.alertAllegati($event, vm.segnalazione.tipo)\">CLICCA PER MAGGIORI INFORMAZIONI</a></span> <span \nstyle=\"cursor: pointer\" ng-if=\"vm.mostraLinkModelloF\"><a \nhref=\"http://www.sprar.it/wp-content/uploads/2017/05/SPRAR_-_Mod_F__richiesta_inserimento_DM.doc\" target=\"_blank\"><b>\nSCARICA QUESTIONARIO</b> <i class=\"icon-download s12\"></i></a></span></div><div><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-button\" aria-label=\"Edit\" \nng-disabled=\"vm.statos > 0 || segnalati.id === null || segnalati.id === undefined\" \nng-click=\"vm.editPerson($event, segnalati)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA</b>\n</small></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-warn\" aria-label=\"trash\" \nng-disabled=\"vm.statos > 0\" ng-click=\"vm.trashPerson($index, segnalati)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<small>CANCELLA</small></md-button></md-menu-item><md-menu-item><md-button class=\"md-button\" aria-label=\"Attach\" \nng-disabled=\"vm.statos > 0 || segnalati.id === null || segnalati.id === undefined\" \nng-click=\"vm.uploadAttachment($event, segnalati)\"><md-icon md-font-icon=\"icon-attachment\"></md-icon><small><b>ALLEGATI\n</b></small></md-button></md-menu-item></md-menu-content></md-menu></div></div></td></tr></tbody></table>\n</md-table-container><md-card-actions layout=\"row\" layout-xs=\"column\" layout-align=\"start left\"><div flex>\n<md-table-pagination md-limit=\"vm.query.perPage\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.query.page\" \nmd-total=\"{{vm.notification.length}}\" md-on-paginate=\"vm.onPaginate\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></div></md-card-actions></md-card><md-card class=\"padding-16\" style=\"padding:16px 24px 0px 24px\" \nng-if=\"vm.segnalazione.id\"><form name=\"reportForm2\" novalidate><h2>Note</h2><md-divider></md-divider><br><div \nlayout=\"row\" layout-xs=\"column\" flex><md-input-container flex><label \nng-style=\"vm.segnalazione.idTipoSegnalazione == 605 && {\'font-size\': \'x-large\', \'color\': \'red\'}\">Note<span \nng-if=\"vm.segnalazione.idTipoSegnalazione == 605\">\n: Per inviare è necessario inserire la data e il numero del protocollo lettera al Servizio Centrale</span></label>\n<textarea name=\"note\" ng-model=\"vm.segnalazione.note\" placeholder=\"Inserire una nota...\" rows=\"3\" \nng-readonly=\"vm.statos > 0\" flex class=\"h6\" ng-change=\"vm.changedform2 = true;\" \nng-required=\"vm.segnalazione.requiredFields.note\"></textarea><div ng-messages=\"reportForm2.note.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Note sono richieste</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end start\"><md-button class=\"mb-button md-accent-bg\" aria-label=\"Salva lista\" \nng-disabled=\"reportForm2.$invalid\" ng-if=\"!vm.api.isReadOnly\" ng-click=\"vm.saveNotification($event)\"><i \nclass=\"icon-content-save s16\"></i> Salva modifiche</md-button></div><md-divider></md-divider><div flex layout=\"row\" \nng-if=\"!vm.api.isReadOnly && vm.segnalazione.id && vm.segnalazione.idTipoSegnalazione != 697\"><md-button \nclass=\"mb-button md-accent-bg\" aria-label=\"inviasegnalazione\" \nng-disabled=\"reportForm.$invalid || reportForm2.$invalid || vm.notification.length === 0 || vm.statos > 0\" \nng-click=\"vm.sendReport($event)\"><i class=\"icon-send s16\"></i> Invia</md-button></div><div flex layout=\"row\" \nng-if=\"!vm.api.isReadOnly && vm.segnalazione.id && vm.segnalazione.idTipoSegnalazione == 697\"><md-button \nclass=\"mb-button md-accent-bg\" aria-label=\"inviasegnalazione\" \nng-disabled=\"reportForm.$invalid || reportForm2.$invalid || vm.notification.length === 0 || vm.statos > 0\" \nng-click=\"vm.sendReportTerritorio($event)\"><i class=\"icon-send s16\"></i> Invia</md-button></div></form></md-card></div>\n</div></div>");
$templateCache.put("app/main/sprardb/notification/notification.html","<div id=\"notification\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nelle segnalazioni (cognome o nome)\" type=\"text\" \nng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca <span ng-if=\"!vm.tipologie.includes(\'605\')\">Auto</span>Segnalazioni</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && key != \'idTipoSegnalazione_IN\'\" id=\"elimina-{{key}}\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\">\n<div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalazioni selezionate\' : \'segnalazione selezionata\'}} :</span>\n<div flex></div><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'progetto\'])\"><i class=\"icon-view-list s16\"></i> TAGS SPECIFICI</md-button>\n<md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i class=\"icon-flag-triangle s16\"></i> TAGS</md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.segnalaziones\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\" style=\"text-align:center;padding-right:8px\"><span>Cod</span></th><th md-column \nstyle=\"text-align:center;padding-right:8px\">STATO</th><th md-column md-order-by=\"tipo\" \nstyle=\"text-align:center;padding-right:8px\">TIPO</th><th md-column md-order-by=\"data\" \nstyle=\"text-align:center;padding-right:8px\"><span>DATA</span></th><th md-column \nstyle=\"text-align:left;padding-right:8px\">ENTE SEGN.</th><th md-column style=\"text-align:left;padding-right:8px\">\nOPERATORE</th><th md-column style=\"text-align:center;padding-right:8px\">SEGNAL.</th><th md-column \nstyle=\"text-align:center;padding-right:8px\">PROG.</th><th md-column style=\"text-align:center;padding-right:8px\">ALL.\n</th><th md-column style=\"text-align:center;padding-right:8px\">INVIO</th><th md-column \nstyle=\"text-align:right;padding-right:16px\" ng-if=\"!vm.api.isReadOnly\">AZIONI</th></tr></thead><tbody md-body><tr \nmd-row md-select=\"notification\" md-select-id=\"notification\" data-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"notification in vm.notifications| orderBy: vm.query.order\" \nclass=\"{{(vm.abilitaModifica(notification) == 0) ? \'disabled\' : \'\'}}\"><td md-cell \nstyle=\"text-align:center;padding-right:8px\">{{notification.id}}</td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><md-button \nng-repeat=\"state in vm.state| filter: {id: notification.eventos.eventoStato_id}: true\" \nclass=\"md-fab md-mini {{vm.colors[(notification.eventos.eventoStato_id + 1)]}}\" aria-label=\"status\">{{state.iniziali}}\n<md-tooltip><span>{{state.stato}}</span></md-tooltip></md-button></td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><b \nng-repeat=\"item in vm.tiposegnalazione|filter: {id: notification.idTipoSegnalazione}\">{{item.descrizione}}</b><b \nng-repeat=\"item in vm.tipoasegnalazione|filter: {id: notification.idTipoSegnalazione}\">{{item.descrizione}}</b></td><td\n md-cell style=\"text-align:left;padding-right:8px\">{{notification.data| date : \"dd/MM/yyyy\"}}</td><td md-cell \nstyle=\"text-align:left;padding-right:8px\">{{notification.entes.nome| uppercase}}</td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><div layout=\"column\" ng-if=\"vm.abilitaModifica(notification) == 2\"><span>\nCompilato da</span> <b>Servizio Centrale</b></div><div layout=\"column\" ng-if=\"vm.abilitaModifica(notification) < 2\"><b>\n{{notification.personas.cognome|uppercase}}</b> <span>{{notification.personas.nome|uppercase}}</span></div></td><td \nmd-cell style=\"text-align:center;padding-right:8px\" ng-init=\"obj = notification.segnalatos\">{{ obj.length}}</td><td \nmd-cell style=\"text-align:left;padding-right:8px\"><small>{{notification.progettos.nome| uppercase|limitTo:10}}...\n</small></td><td md-cell style=\"text-align:center;padding-right:8px\"><span ng-if=\"notification.documenti\"><b>\n{{notification.documenti.length}}</b></span> <span ng-if=\"!notification.documenti\">0</span></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><span ng-if=\"notification.eventos.dataFine\"><b>\n{{notification.eventos.dataFine|date:\"dd/MM/yyyy\"}}</b></span> <span ng-if=\"!notification.eventos.dataFine\">non inviata\n</span></td><td md-cell style=\"text-align:right;padding-right:8px\" ng-if=\"!vm.api.isReadOnly\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"((notification.eventos.eventoStato_id != -1) || (vm.abilitaModifica(notification) == 0)) && !vm.autoinsert\">\n<md-button ui-sref=\"app.sprardb_notification.editreport({ id:notification.id})\" aria-label=\"View Detailed\" \nng-click=\"vm.viewDetails($event, notification.id)\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon>\n<span>Visualizza</span></md-button></md-menu-item><md-menu-item \nng-if=\"(((notification.eventos.eventoStato_id == -1) && (vm.abilitaModifica(notification) > 0 || (vm.api.isAdmin || vm.api.isAccoglienza)))) && !vm.autoinsert\">\n<md-button ui-sref=\"app.sprardb_notification.editreport({ id:notification.id})\" class=\"md-accent md-button-icon\" \naria-label=\"Edit Detailed\" ng-click=\"vm.viewDetails($event, notification.id)\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon><span>Modifica</span></md-button></md-menu-item><md-menu-item \nng-if=\"((notification.eventos.eventoStato_id != -1) || (vm.abilitaModifica(notification) == 0)) && vm.autoinsert\">\n<md-button ui-sref=\"app.sprardb_notification.editareport({ id:notification.id })\" aria-label=\"View Detailed\" \nng-click=\"vm.viewDetails($event, notification.id)\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon>\n<span>Visualizza</span></md-button></md-menu-item><md-menu-item \nng-if=\"(((notification.eventos.eventoStato_id == -1) && (vm.abilitaModifica(notification) > 0 || (vm.api.isAdmin || vm.api.isAccoglienza)))) && vm.autoinsert\">\n<md-button ui-sref=\"app.sprardb_notification.editareport({ id:notification.id })\" class=\"md-accent md-button-icon\" \naria-label=\"Edit Detailed\" ng-click=\"vm.viewDetails($event, notification.id)\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon><span>Modifica</span></md-button></md-menu-item><md-menu-item \nng-if=\"notification.eventos.eventoStato_id >= 1\"><md-button class=\"md-accent md-button-icon\" aria-label=\"PDF\" \nng-click=\"vm.downloadPdf($event, notification.id)\"><md-icon md-font-icon=\"icon-file-pdf-box\"></md-icon><span>\nModello segnalazione</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.api.isAdmin\"><md-button \nclass=\"md-warn md-button-icon\" ng-click=\"vm.trashSegn($event, notification)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span>Elimina</span></md-button></md-menu-item><md-menu-item ng-repeat=\"item in notification.documentos\">\n<md-button class=\"md-accent md-button-icon\" aria-label=\"attachm\" href=\"{{vm.baseUrl}}{{item.unomefile}}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-attachment\"></md-icon><span><small>{{item.documentoTipo.tipo}}</small>\n</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div><md-button class=\"md-button md-grey-300-bg\" style=\"color: rgba(255, 255, 255, 0.87)\" \nui-sref=\"app.sprardb_rsegnalati\"><i class=\"icon-view-list s16\"></i> VAI AI SEGNALATI</md-button>");
$templateCache.put("app/main/sprardb/notification/rsegnalati.html","<div id=\"notification\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Ricerca Segnalati</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei segnalati (cognome o nome)\" type=\"text\" \nng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca Segnalati</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && key != \'idTipoSegnalazione_IN\'\" id=\"elimina-{{key}}\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\">\n<div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalazioni selezionate\' : \'segnalazione selezionata\'}} :</span>\n<div flex></div><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'progetto\'])\"><i class=\"icon-view-list s16\"></i> TAGS SPECIFICI</md-button>\n<md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i class=\"icon-flag-triangle s16\"></i> TAGS</md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.segnalaziones\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\" style=\"text-align:center;padding-right:8px\"><span>Cod</span></th><th md-column \nstyle=\"text-align:center;padding-right:8px\">STATO</th><th md-column style=\"text-align:left;padding-right:8px\">COGNOME\n</th><th md-column style=\"text-align:left;padding-right:8px\">NOME</th><th md-column md-order-by=\"tipo\" \nstyle=\"text-align:left;padding-right:8px\">NAZION.<br>NASCITA</th><th md-column md-order-by=\"data\" \nstyle=\"text-align:center;padding-right:8px\"><span>T.SOGGIORNO</span></th><th md-column \nstyle=\"text-align:left;padding-right:8px\">SEGNALAZ.</th><th md-column style=\"text-align:left;padding-right:8px\">\nDOCUMENTO</th><th md-column md-order-by=\"nucleoFamiliare\" style=\"text-align:center;padding-right:8px\">NUCLEO</th><th \nmd-column md-order-by=\"capof_id\" style=\"text-align:center;padding-right:8px\">Id Capof.</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONI</th></tr></thead><tbody md-body><tr md-row md-select=\"notification\" \nmd-select-id=\"notification\" data-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"notification in vm.notifications| orderBy: vm.query.order\"><td \nmd-cell style=\"text-align:center;padding-right:8px\"><div layout=\"column\"><span>{{notification.id}}</span> <span>\n<md-icon md-font-icon=\"icon-attachment\" class=\"blue-700-fg s14\" ng-if=\"(notification.documentos.length > 0)\" \ntitle=\"Allegati\"></md-icon></span></div></td><td md-cell style=\"text-align:center;padding-right:8px\"><div \nlayout=\"column\"><md-button ng-repeat=\"state in vm.state| filter: {id: notification.eventos.eventoStato_id}: true\" \nclass=\"md-fab md-mini {{vm.colors[(notification.eventos.eventoStato_id + 1)]}}\" aria-label=\"status\">{{state.iniziali}}\n<md-tooltip><span>{{state.stato|uppercase}}</span></md-tooltip></md-button></div></td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><div layout=\"row\"><b>{{notification.cognome|uppercase}}</b> <span \nclass=\"red-700-fg s14\" ng-if=\"(notification.idVulnerabilita > 0)\">&nbsp;(V)</span></div></td><td md-cell \nstyle=\"text-align:left;padding-right:8px\">{{notification.nome|uppercase}}</td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><div layout=\"column\"><b>{{notification.codNazionalitas.descrizione}}</b> \n<span>{{notification.dataNascita| date :\"dd/MM/yyyy\"}}</span></div></td><td md-cell \nstyle=\"text-align:left;padding-right:8px\">{{notification.protezioneTipo.descrizione|limitTo:25}}...</td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><div layout=\"column\"><b>{{notification.segnalaziones.modellos.descrizione}}\n</b> <span>{{notification.segnalaziones.data| date : \"dd/MM/yyyy\"}}</span> <span>\n{{notification.segnalaziones.entes.nome|uppercase}}</span></div></td><td md-cell \nstyle=\"text-align:left;padding-right:8px\"><div layout=\"column\"><b>{{notification.documentoTipo.descrizione}}</b> <span>\n{{notification.dataRilascioDocumento| date : \"dd/MM/yyyy\"}}</span> <span>\n{{notification.dataScadenzaDocumento| date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><div layout=\"column\"><i class=\"icon-account-multiple-outline\" \nng-if=\"(notification.nucleoFamiliare === 1)\"><md-tooltip>{{notification.parentelaTipo.descrizione}}</md-tooltip></i>\n<small ng-if=\"(notification.nucleoFamiliare === 0)\"><b>MONOPAREN.</b></small> <small \nng-if=\"(notification.nucleoFamiliare === 2)\"><b>NON SA</b></small></div></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><div layout=\"column\" ng-if=\"notification.capof_id > 0\"><small><b>\n{{notification.capof_id}}</b></small></div></td><td md-cell style=\"text-align:right;padding-right:8px\"><md-menu>\n<md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"View Detailed\" ng-click=\"vm.dettaglisegnalato(notification)\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Visualizza dettagli</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Extra\" ng-click=\"vm.viewPerson($event, notification.eventos, \'extra\')\"><md-icon \nmd-font-icon=\"icon-details\"></md-icon><span>Dettagli processo</span></md-button></md-menu-item><md-menu-item \nng-if=\"((notification.eventos.eventoStato_id == -1) && (notification.segnalaziones.personas.id == vm.persona.persona_id || (vm.api.isAdmin || vm.api.isAccoglienza)))\">\n<md-button class=\"md-accent md-button-icon\" aria-label=\"Edit Detailed\" \nng-click=\"vm.viewDetails($event, notification.segnalaziones.id)\"><md-icon md-font-icon=\"icon-account-multiple-outline\">\n</md-icon><span>Modifica</span></md-button></md-menu-item><md-menu-item \nng-if=\"notification.eventos.eventoStato_id >= 1\"><md-button class=\"md-accent md-button-icon\" aria-label=\"PDF\" \nng-click=\"vm.downloadPdf($event, notification.segnalaziones.id)\"><md-icon md-font-icon=\"icon-file-pdf-box\"></md-icon>\n<span>Modello segnalazione</span></md-button></md-menu-item><md-menu-item ng-repeat=\"item in notification.documentos\">\n<md-button class=\"md-accent md-button-icon\" aria-label=\"attachm\" href=\"{{vm.baseUrl}}{{item.unomefile}}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-attachment\"></md-icon><span><small><b>{{item.documentoTipo.tipo}}</b>\n</small></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.newReport($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"Nuova Segnalazione\"><md-tooltip md-direction=\"Top\">\nNuova Segnalazione</md-tooltip><md-icon md-font-icon=\"icon-message-draw\"></md-icon></md-button></div></div></div>\n<md-button class=\"md-button md-grey-300-bg\" style=\"color: rgba(255, 255, 255, 0.87)\" \nui-sref=\"app.sprardb_notification\"><i class=\"icon-view-list s16\"></i> VAI ALLE SEGNALAZIONI</md-button>");
$templateCache.put("app/main/sprardb/notification/segnalatori.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Enti Segnalatori</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.search2\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.searchServerNome(vm.search2)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.searchServerNome(vm.search)\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button \nng-click=\"vm.allFields = !vm.allFields\"><small>Ricerca avanzata</small><md-icon ng-if=\"!vm.allFields\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"vm.allFields\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.search2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>Parola chiave: {{vm.search2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>\n{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex ng-if=\"vm.allFields\"><md-input-container flex>\n<label>Regione</label><md-select ng-model=\"vm.ricerca[\'istats-regione\']\" ng-change=\"vm.searchServer();\"><md-option \nvalue=\"null\">Tutti</md-option><md-option ng-repeat=\"regione in vm.regiones\" value=\"{{regione.regione}}\">\n{{regione.regione}}</md-option></md-select></md-input-container><md-input-container flex><label>Tipo</label><md-select \nng-model=\"vm.ricerca[\'enteTipo_id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\"><small>Tutti</small>\n</md-option><md-option class=\"small\" ng-repeat=\"et in vm.entetipos| filter: {enteTipo_id : \'!0\'}\" value=\"{{et.id}}\">\n<small>{{(et.id==1)?\'PRIMO SETTORE\':((et.id==2)?\'SECONDO SETTORE\':\'TERZO SETTORE\');}} - <b>{{et.descrizione}}</b>\n</small></md-option></md-select></md-input-container><md-input-container flex><label>Con progetti</label><md-select \nng-model=\"vm.ricerca[\'progettos-id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option>\n<md-option value=\">1\">Si</md-option></md-select></md-input-container><md-input-container flex><label>Con persone\n</label><md-select ng-model=\"vm.ricerca[\'personas-id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti\n</md-option><md-option value=\">1\">Si</md-option></md-select></md-input-container><md-input-container flex><label>\nCon strutture</label><md-select ng-model=\"vm.ricerca[\'strutturas-id\']\" ng-change=\"vm.searchServer();\"><md-option \nvalue=\"null\">Tutti</md-option><md-option value=\">1\">Si</md-option></md-select></md-input-container><md-input-container \nflex><label>Attivo</label><md-select ng-model=\"vm.ricerca.attivo\" ng-change=\"vm.searchServer();\"><md-option \nvalue=\"null\">Tutti</md-option><md-option value=\">1\">Si</md-option><md-option value=\"<0\">No</md-option></md-select>\n</md-input-container><md-button ng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small>\n</md-button></div><div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span>Risultati: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span>di</span> <span>{{vm.meta.totalCount}}</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" ng-click=\"vm.pager(vm.links.prev.href)\" \nng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"next page\" translate translate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" \nng-click=\"vm.pager(vm.links.next.href)\" ng-if=\"vm.links.next.href\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" layout=\"row\"><div \nclass=\"secondary-text padding-8 align-vertical-middle\" flex=\"25\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'nome\', ((vm.listOrderAsc) ? \'-\' : \'\'));\"></md-icon></a><strong>NOME ENTE</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"20\"><strong>TIPO</strong></div><div class=\"secondary-text padding-8\" flex=\"15\">\n<strong>CITTA</strong></div><div class=\"secondary-text padding-8\" flex=\"20\"><strong>RECAPITI</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"20\"><strong>COLLEGAMENTI</strong></div></div><md-list-item \nclass=\"contact-item md-white-bg h-120\" md-ink-ripple ng-repeat=\"ente in vm.entes| filter: vm.search track by ente.id\" \nng-click=\"vm.gotoDettaglio(ente.id)\" \nng-style=\"{\'transform\': \'translate3d(0px, \' + $index * 120 + \'px, 0px)\', \'z-index\': vm.entes.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(ente)}\"><div flex=\"25\"><span ng-class=\"{\'text-strike\' : !ente.attivo}\" \nclass=\"secondary-text light-blue-900-fg font-weight-600 line-height-12\">{{ ente.nome | uppercase}}</span></div><div \nflex=\"20\"><span class=\"text-boxed\">{{ente.entetipo.descrizione}}</span></div><div flex=\"15\"><dl class=\"text-truncate\">\n<dd class=\"line-height-12\"><span class=\"text-boxed\">{{ente.istats.provincia| uppercase}}</span></dd><dd \nclass=\"line-height-12\"><span class=\"text-boxed\">{{ente.istats.comune}}</span></dd></dl></div><div flex=\"20\"><dl \nclass=\"text-truncate\"><dd class=\"line-height-12\"><span class=\"text-boxed\">{{ente.email}}</span></dd><dd \nclass=\"line-height-12\"><span class=\"text-boxed\">{{ente.telefono}}</span></dd></dl></div><div flex=\"20\"><span \nclass=\"text-boxed md-primary-bg\"><small><b>PROGETTI: </b></small></span><small><b>{{ente.progettohasentes.length}}</b>\n</small> <span class=\"text-boxed md-primary-bg\"><small><b>STRUTTURE: </b></small></span><small><b>\n{{ente.strutturahasentes.length}}</b></small> <span class=\"text-boxed md-primary-bg\"><small><b>PERSONE: </b></small>\n</span><small><b>{{ente.personahasentes.length}}</b></small></div></md-list-item></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"!vm.meta.totalCount\"><p>Nessun risultato...</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.gotoDettaglio(0)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/personas/personas.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Persone</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nelle persone\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Persona</span><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\';vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'persone selezionate\' : \'persona selezionata\'}} :</span><div flex>\n</div><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'listapersona\'])\"><i class=\"icon-view-list s16\"></i> LISTA DISTRIBUZIONE\n</md-button><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i class=\"icon-flag-triangle s16\"></i> TAGS</md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.entes\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column>TIPO</th><th md-column md-order-by=\"cognome\">COGNOME</th><th \nmd-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\"><span>CITTA</span></th><th md-column \nmd-order-by=\"email\">RECAPITI</th><th md-column style=\"text-align: center\">NR PROG</th><th md-column \nstyle=\"text-align: center\">NR ENTE</th><th md-column style=\"text-align: center\">NR RUOLI</th><th md-column \nstyle=\"text-align: center\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell \nstyle=\"text-align: center\"><i class=\"icon-account-key\" style=\"line-height: 32px\" ng-if=\"item.users\"></i></td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.residenza.comune| uppercase}}</b><br>{{item.residenza.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: center\">{{ (item.personahasprogettos | unique: \'progetto_id\').length}}</td><td md-cell \nstyle=\"text-align: center\">{{(item.personahasentes| unique: \'ente_id\').length}}</td><td md-cell \nstyle=\"text-align: center\">{{(item.personahasprogettos| unique: \'personaRuolo_id\').length}}</td><td md-cell \nstyle=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-button-small\" aria-label=\"View Detailed\" ng-click=\"vm.gotoDettaglio(item.id)\"><i \nclass=\"icon-arrow-right-bold-circle s30\"></i></md-button><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Visualizza tags\" ng-click=\"vm.viewtags(item.tags, [\'generico\'])\">\n<md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza tags</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.viewtags(item.tags, [\'listapersona\'])\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza lista</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.gotoDettaglio(0)\" aria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/sprardb/personas2/personas2.html","<div id=\"entisegnalatori\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Persone</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Nome</b></small> <input id=\"search\" placeholder=\"Nome\" type=\"text\" \nng-model=\"vm.ricerca2.nome\" ng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricerca2.cognome\" ng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Email</b></small> <input id=\"search\" placeholder=\"Email\" type=\"text\" \nng-model=\"vm.ricerca2.email\" ng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><small>Cerca</small></md-button><md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata\n</small><md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card\n style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><span>Ricerca Persona</span><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2.nome\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2.nome = \'\';vm.onSearch();\"></md-icon>\nNome: {{vm.ricerca2.nome| uppercase}} </span><span class=\"text-boxed\" ng-if=\"vm.ricerca2.cognome\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2.cognome = \'\';vm.onSearch();\"></md-icon>\nCognome: {{vm.ricerca2.cognome| uppercase}} </span><span class=\"text-boxed\" ng-if=\"vm.ricerca2.email\"><md-icon \nclass=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2.email = \'\';vm.onSearch();\"></md-icon>\nEmail: {{vm.ricerca2.email}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.entes\" multiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th \nmd-column md-order-by=\"cognome\">COGNOME</th><th md-column md-order-by=\"nome\">NOME</th><th md-column \nmd-order-by=\"email\">ALTRE INFO</th><th md-column><span>ENTE/INCARICO</span></th><th md-column>PROGETTO/RUOLO</th><th \nmd-column>PROFILO</th><th md-column style=\"text-align: center\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"item\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}...</a></span> <span>{{item.telefono}}\n</span> <span>{{item.codiceFiscale|uppercase}}</span> <span>{{item.dataNascita|date:\"dd/MM/yyyy\" }}</span></div></td>\n<td md-cell><div layout=\"column\"><small \nng-repeat-start=\"sp in item.personahasentes | filter: {personaruolo:{gruppo:\'ENTE\'}} | unique:\'ente_id\' \"><b>\n{{sp.ente.nome}}</b><br></small><small ng-repeat-end \nng-repeat=\"incarico in item.personahasentes | filter: {ente_id:sp.ente_id,personaruolo:{gruppo:\'ENTE\'}}\">\n{{incarico.personaruolo.descrizione}}</small></div></td><td md-cell><div layout=\"column\"><small \nng-repeat-start=\"sp in item.personahasprogettos | filter: {personaRuolo:{gruppo:\'PROGETTO\'}} | unique:\'progetto_id\' \">\n<span ng-class=\"sp.accessPermission ? \'md-accent-fg\' : \'hint-text\'\"><i \nng-class=\"sp.accessPermission ? \'icon-account-key\' : \'icon-key-remove\'\" class=\"font-size-14\"></i> <b>\n{{sp.progetto.nome}}</b></span><br></small><small ng-class=\"sp.accessPermission ? \'\' : \'hint-text\'\" ng-repeat-end \nng-repeat=\"ruolo in item.personahasprogettos | filter: {progetto_id:sp.progetto_id,personaRuolo:{gruppo:\'PROGETTO\'}}\">\n{{ruolo.personaRuolo.descrizione}}</small></div></td><td md-cell><div layout=\"column\"><span \nng-if=\"item.users.length > 0\" layout=\"column\"><div layout=\"row\"><span><i class=\"icon-account-key font-size-14\"></i> <b>\nESISTENTE</b>&nbsp;&nbsp; <span ng-if=\"item.users[0].status == 10\">ATTIVO</span> <span \nng-if=\"item.users[0].status == 0\" class=\"md-red-700-fg\">DISATTIVO</span></span></div><div layout=\"row\"><span \nng-repeat=\"si in ::item.personahasusergroupvs\">{{si.gruppo}},&nbsp;</span></div></span><span \nng-if=\"item.users.length == 0\" layout=\"column\"><span><i class=\"icon-close font-size-14\"></i> <b>INESISTENTE</b></span>\n</span></div></td><td md-cell style=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button class=\"md-accent md-button-icon md-button-small\" \naria-label=\"View Detailed\" ng-click=\"vm.gotoDettaglio(item.id)\"><i class=\"icon-arrow-right\"></i> <span>Apri Anagrafica\n</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isReadOnly\"><md-button aria-label=\"Visualizza tags\" \nng-click=\"vm.viewtags(item.tags, [\'generico\'])\"><md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>\nVisualizza tags</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isReadOnly\"><md-button \naria-label=\"Visualizza lista\" ng-click=\"vm.viewtags(item.tags, [\'listapersona\'])\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza lista</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.gotoDettaglio(\'\')\" aria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\" \nng-if=\"!vm.isReadOnly\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/sprardb/postlogin/postlogin.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\"></md-icon></md-button><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Aggiornamento dati importanti</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><form name=\"stepper\" \nclass=\"main\" ms-scroll ms-horizontal-stepper ng-submit=\"vm.submitStepper($event)\" ng-model=\"vm.stepper\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'01. Introduzione\'\">\nCliccando sul tasto AVANTI visualizzerete una tabella che vi permetterà di confermare o modificare la Tipologia di Soggiorno dei beneficiari presenti.\n<br><br>\nPer procedere con l’aggiornamento o per posticiparlo ad un secondo momento è necessario cliccare sul tasto FINE.<br>\nAvrete così la possibilità di proseguire con le normali attività della banca dati.<br><br>\nVi ricordiamo che gli aggiornamenti verranno proposti ad ogni sessione di accesso alla banca dati, fino al completo inserimento dei dati e comunque non oltre il 6 Novembre p.v..\n<br><br>\nPer eventuali difficoltà nella compilazione potete contattare il vostro referente del settore “accoglienza e inserimenti”.\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'02. Aggiornamento BENEFICIARI\'\"><div layout=\"row\"></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><strong>Aggiorna beneficiari</strong></small><div layout=\"row\" ng-if=\"vm.searched\" \nflex></div><div flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"ricarica\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"codice\"><div layout=\"column\"><span>CODICE</span>\n</div></th><th md-column md-order-by=\"cognome\"><div layout=\"column\"><span>COGNOME</span></div></th><th md-column \nmd-order-by=\"nome\"><div layout=\"column\"><span>NOME</span></div></th><th md-column md-order-by=\"dataNascita\"><div \nlayout=\"column\"><span>NASCITA</span> <span>NAZIONALITA</span> <span>GENERE</span></div></th><th md-column \nmd-order-by=\"tipoProtezione_id\"><div layout=\"column\"><span>T.SOGGIORNO</span></div></th><th md-column><div \nlayout=\"column\"><span>NOTIFICA</span></div></th><th md-column style=\"text-align: center\"><div layout=\"column\"><span>\nAZIONI</span></div></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" ng-disabled=\"item.attivo == 0\" \ndata-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.beneficiari\"><td md-cell><div layout=\"column\"><span ng-if=\"(item.def == 1)\">{{item.codice}}\n</span> <span ng-if=\"(item.def == 0)\">{{item.id}}</span> <span ng-if=\"(item.def == 0)\"><small>INCOMPLETO</small></span>\n</div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span>\n{{item.dataNascita|date:\"dd/MM/yyyy\" }}</span> <span>{{item.nazionalita}}</span> <span>{{item.sesso}}</span></div></td>\n<td md-cell><div layout=\"row\" layout-md=\"column\"><md-button class=\"md-icon-button padding-0\" \nng-click=\"vm.ts[$index] = item.tipoProtezione_id;vm.cambiaTs($index)\" ng-disabled=\"vm.bconferma[$index]\" \naria-label=\"undo\"><i class=\"icon-undo-variant s16\"></i></md-button><md-input-container flex class=\"margin-0\"><md-select\n name=\"tipoProtezione_id{{$index}}\" placeholder=\"Aggiorna tipologia soggiorno\" ng-model=\"vm.ts[$index]\" \nclass=\"border padding-8\" ng-change=\"vm.cambiaTs($index)\" aria-label=\"tendinats{{$index}}\"><md-option \nng-repeat=\"tp in vm.tipoproteziones\" ng-value=\"tp.id\" ng-disabled=\"vm.controllaOption(item.tipoProtezione_id, tp.id)\" \nng-selected=\"(tp.id == item.tipoProtezione_id)\"><strong>{{tp.descrizione}}</strong></md-option></md-select>\n</md-input-container></div></td><td md-cell><div layout=\"row\" layout-md=\"column\"><md-datepicker \ndatepicker-validation-fix name=\"dataNotifica{{$index}}\" ng-model=\"vm.dataNotifica[$index]\" \nmd-placeholder=\"{{(vm.titolarita.indexOf(vm.ts[$index]) > -1) ? \'Data Notifica\' : \'\'}}\" \nng-disabled=\"vm.titolarita.indexOf(vm.ts[$index]) == -1\" ng-change=\"vm.cambiaTs($index)\" \nng-required=\"vm.isRequired[$index]\" md-max-date=\"vm.maxDate\"></md-datepicker></div></td><td md-cell><div layout=\"row\" \nlayout-align=\"end center\" layout-md=\"column\" flex ng-if=\"!item.postlogin2s || vm.oggi >= item.postlogin2s.valido_fino\">\n<md-button type=\"button\" ng-click=\"vm.confermaB($index)\" ng-if=\"vm.bconferma[$index]\" class=\"md-primary md-raised\" \naria-label=\"conferma\"><md-icon md-font-icon=\"icon-check-all\"></md-icon>Conferma</md-button><md-button type=\"button\" \nng-click=\"vm.aggiornaB($index)\" ng-if=\"vm.baggiorna[$index]\" class=\"md-primary md-raised\" aria-label=\"Allow\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Modifica</md-button><md-button type=\"button\" \nng-click=\"vm.trasferitoB($index)\" class=\"md-primary md-raised\" aria-label=\"trasferito\"><md-icon \nmd-font-icon=\"icon-cursor-move\"></md-icon>Non so/Trasferito/Uscito</md-button></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step4\" step=\"3\" step-title=\"\'03. Fine\'\">\nCliccando sul tasto “FINE” la procedura di aggiornamento beneficiari si chiuderà.<br>\nVi ricordiamo che la schermata verrà proposta ad ogni sessione di accesso alla banca dati, fino al completamento di tutti i dati richiesti e comunque non oltre il 6 Novembre p.v..\n<br><br>\nPer eventuali difficoltà nella compilazione potete contattare il vostro referente del settore “Accoglienza e Inserimenti”.\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/sprardb/postlogin/postlogin2.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\"></md-icon></md-button><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Aggiornamento dati importanti</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><form name=\"stepper\" \nclass=\"main\" ms-scroll ms-horizontal-stepper ng-submit=\"vm.submitStepper($event)\" ng-model=\"vm.stepper\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'01. Introduzione\'\">\nNelle schermate che seguono visualizzerete una pagina che vi permetterà di aggiornare lo status giuridico dei beneficiari presenti.\n<br>\nLe informazioni relative al tipo di soggiorno potranno essere confermate o modificate. Per procedere con l\'aggiornamento è necessario cliccare sul tasto &quot;avanti&quot;. Per uscire dalla schermata e proseguire con le normali attività in banca dati è possibile cliccare sul tasto &quot;fine&quot;.\n<br>\nVi ricordiamo che gli aggiornamenti verranno proposti ad ogni accesso fino a completamento di tutti i dati richiesti. Per eventuali difficoltà nella compilazione potete contattare il vostro referente del settore &quot;Accoglienza e Inserimenti&quot;.\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'02. Aggiornamento BENEFICIARI\'\"><div layout=\"row\"></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><strong>Aggiorna beneficiari</strong></small><div layout=\"row\" ng-if=\"vm.searched\" \nflex></div><div flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"ricarica\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"codice\"><div layout=\"column\"><span>CODICE</span>\n</div></th><th md-column md-order-by=\"cognome\"><div layout=\"column\"><span>COGNOME</span></div></th><th md-column \nmd-order-by=\"nome\"><div layout=\"column\"><span>NOME</span></div></th><th md-column md-order-by=\"dataNascita\"><div \nlayout=\"column\"><span>NASCITA</span> <span>NAZIONALITA</span> <span>GENERE</span></div></th><th md-column \nmd-order-by=\"tipoProtezione_id\"><div layout=\"column\"><span>TIPOLOGIA SOGGIORNO</span></div></th><th md-column \nstyle=\"text-align: center\"><div layout=\"column\"><span>AZIONI</span></div></th></tr></thead><tbody md-body><tr md-row \nmd-select=\"item\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.beneficiari\"><td md-cell><div layout=\"column\"><span \nng-if=\"(item.def == 1)\">{{item.codice}}</span> <span ng-if=\"(item.def == 0)\">{{item.id}}</span> <span \nng-if=\"(item.def == 0)\"><small>INCOMPLETO</small></span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span>\n{{item.dataNascita|date:\"dd/MM/yyyy\" }}</span> <span>{{item.nazionalita.descrizione}}</span> <span>{{item.sesso}}\n</span></div></td><td md-cell><div layout=\"row\" layout-md=\"column\"><span><strong>{{item.protezioneTipo.descrizione}}\n</strong></span></div></td><td md-cell><div layout=\"row\" layout-align=\"end center\" layout-md=\"column\" flex \nng-if=\"!item.postlogin2s\"><sprardb-newprocess2 ng-model=\"vm.nsg[$index]\"></sprardb-newprocess2><md-button \ntype=\"button\" ng-click=\"vm.confermaB($index)\" ng-if=\"vm.bconferma[$index]\" class=\"md-primary md-raised\" \naria-label=\"conferma\"><md-icon md-font-icon=\"icon-check-all\"></md-icon>Conferma</md-button><md-button type=\"button\" \nng-click=\"vm.trasferitoB($index)\" ng-if=\"vm.btrasferito[$index]\" class=\"md-primary md-raised\" aria-label=\"trasferito\">\n<md-icon md-font-icon=\"icon-cursor-move\"></md-icon>Non so/Trasferito/Uscito</md-button></div><div layout=\"row\" \nlayout-align=\"end center\" flex ng-if=\"item.postlogin2s\"><md-button class=\"md-primary\" type=\"button\"><span \nng-if=\"item.postlogin2s.azione == \'A\'\">AGGIORNATO</span> <span ng-if=\"item.postlogin2s.azione == \'C\'\">CONFERMATO</span>\n <span ng-if=\"item.postlogin2s.azione == \'T\'\">NON SO / TRASFERITO / USCITO</span></md-button></div></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'03. Fine\'\">\nCliccando sul tasto &quot;fine&quot; la procedura di aggiornamento beneficiari si chiuderà. Vi ricordiamo che la schermata verrà proposta ad ogni accesso fino a completamento di tutti i dati richiesti. Per eventuali difficoltà nella compilazione potete contattare il vostro referente del settore &quot;Accoglienza e Inserimenti&quot;.\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/sprardb/proroghe/proroghe.html","<div id=\"proroghe\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/proroghe/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Ricerca Proroghe Beneficiari</span></div></div></div>\n<div ng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button \nlayout=\"row\" layout-align=\"start center\"><span class=\"small\"><i class=\"icon icon-arrow-left s14\"></i> Indietro</span>\n</md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span class=\"small\">SELEZIONATO</span>\n</span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\">Seleziona tutti</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\">Seleziona nessuno</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"80\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Codice</b></small> <input id=\"search\" placeholder=\"Codice\" type=\"text\" \nng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\">\n<md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Cognome</b></small> <input \nid=\"search\" placeholder=\"Cognome\" type=\"text\" ng-model=\"vm.ricercaCognome\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Nome</b></small> <input id=\"search\" placeholder=\"Nome\" type=\"text\" \nng-model=\"vm.ricercaNome\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex>\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" flex><md-button \nng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Proroghe</b></small><div layout=\"row\" layout-md=\"row\" ng-if=\"vm.searched\" flex><span\n class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\' && key !== \'beneficiarios-cancellato_IN\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.deletefiltersearch(key)\"></md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}\n</span></div><div flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\">\n</i></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'beneficiari selezionati\' : \'beneficiario selezionato\'}} :</span><div\n flex></div><md-button aria-label=\"Tags\" class=\"md-button\" ng-click=\"vm.edittags(vm.selected, [\'generico\'])\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"icon-flag-triangle\" \nstyle=\"color: rgba(255, 255, 255, 0.87)\"></md-icon>TAGS</md-button><md-button aria-label=\"Uscita\" \nng-click=\"vm.cessab(1010)\" ng-disabled=\"(vm.selected.length !== 1)\"><md-icon md-font-icon=\"icon-exit-to-app\" \nstyle=\"color: rgba(255, 255, 255, 0.87)\"></md-icon><span>Uscita</span></md-button></div></md-toolbar>\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.searchPromise\" multiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" \nstyle=\"text-align:center\" title=\"Codice beneficiario\">Cod</th><th md-column md-order-by=\"stato\" \nstyle=\"text-align:center\" title=\"stato beneficiario\">STATO</th><th md-column style=\"text-align:center\" \ntitle=\"documento soggiorno\">DOCUM</th><th md-column md-order-by=\"cognome\"><span>COGNOME</span></th><th md-column \nmd-order-by=\"nome\">NOME</th><th md-column>NAZIONE</th><th md-column md-order-by=\"progetto_id\" \ntitle=\"progetto appartenenza\">PROGETTO</th><th md-column style=\"text-align:center\" md-order-by=\"sesso\" title=\"sesso\">G\n</th><th md-column md-order-by=\"dataInserimento\" style=\"text-align:center\" title=\"data inserimento\">INSER.</th><th \nmd-column md-order-by=\"dataFine\" style=\"text-align:center\" title=\"data fine beneficio\">FINE</th><th md-column \nmd-order-by=\"dataUscita\" style=\"text-align:center\" title=\"data uscita progetto\">USCITA</th><th md-column \nmd-order-by=\"n\" style=\"text-align:center\" title=\"giorni permanenza\">GG</th><th md-column md-order-by=\"nucleoFamiliare\" \nstyle=\"text-align:center\" title=\"nucleo familiare/parentela\">FAM</th><th md-column md-order-by=\"prorogas\" \nstyle=\"text-align:center\" title=\"proroghe\" ng-if=\"!vm.isReadOnly\">P</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" \nmd-select-id=\"beneficiario\" ng-disabled=\"(beneficiario.def === 0)\" data-md-on-select=\"vm.toggleSelect\" \nmd-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"beneficiario in vm.beneficiari\" \nng-class=\"{\'md-light-blue-50-bg\': vm.prorogaAperta(beneficiario),\'md-deep-orange-50-bg\':(beneficiario.prorogas.length > 0 && !vm.prorogaAperta(beneficiario))}\">\n<td md-cell style=\"text-align:center\"><small>{{beneficiario.codice}}</small></td><td md-cell style=\"text-align:left\">\n<div layout=\"column\"><span><small><b>{{beneficiario.stato}}</b></small></span></div></td><td md-cell \nstyle=\"text-align:left\"><div layout=\"column\"><span class=\"nowrap\" \nng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}:true\"><small><b>\n{{ item.descrizione|limitTo:25}}...</b></small></span> <span ng-if=\"beneficiario.idTipoDocumento == \'0\'\"><small><b>\nNESSUN DOCUMENTO</b></small></span> <span><small>\n{{beneficiario.dataRilascioDocumento|date: \"dd/MM/yy\"}} - {{beneficiario.dataScadenzaDocumento|date: \"dd/MM/yy\"}}\n</small></span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{beneficiario.cognome|uppercase}}</td>\n<td md-cell class=\"light-blue-900-fg font-weight-600\">{{beneficiario.nome|uppercase}}</td><td md-cell><div \nlayout=\"column\"><small>{{ beneficiario.nazionalita.descrizione}}</small> <small>\n{{beneficiario.dataNascita| date : \"dd/MM/yy\"}}</small></div></td><td md-cell><b>\n{{ beneficiario.progettos.nome|uppercase}}</b><br><span ng-repeat=\"stru in ::beneficiario.strutturas\"><small>\n{{ stru.nome|uppercase}}</small></span></td><td md-cell style=\"text-align:center\"><b>{{beneficiario.sesso}}</b></td><td\n md-cell style=\"text-align:center\">{{beneficiario.dataInserimento| date : \"dd/MM/yy\"}}</td><td md-cell \nstyle=\"text-align:center\">{{beneficiario.dataFine| date : \"dd/MM/yy\"}}</td><td md-cell style=\"text-align:center\" \nng-if=\"beneficiario.dataUscita != \'0000-00-00\'\">{{beneficiario.dataUscita| date : \"dd/MM/yy\"}}</td><td md-cell><div \nlayout=\"column\"><b>{{vm.giorniPermanenza[beneficiario.id]}}</b></div></td><td md-cell><i \nclass=\"icon-account-multiple-outline\" \nng-if=\"(beneficiario.nucleoFamiliare === 1 && beneficiario.parentela_id !== null)\"><md-tooltip>\n{{beneficiario.parentela.descrizione|uppercase}}</md-tooltip></i></td><td md-cell ng-if=\"!vm.isReadOnly\"><div \nlayout=\"row\"><b>{{ vm.countProroghe(beneficiario) }}</b>&nbsp; <b \nng-if=\"vm.countProroghe(beneficiario) !== beneficiario.proroghe.length\">\n({{ beneficiario.proroghe.length - vm.countProroghe(beneficiario)}})</b></div></td><td md-cell \nstyle=\"text-align:right\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item \nng-if=\"beneficiario.def == 1\"><md-button aria-label=\"Dettaglio\" ui-sref=\"app.sprardb_proroga({id:beneficiario.id})\">\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><small><b>PROROGHE BENEFICIARIO</b></small></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.richestaprorogaottenibile(beneficiario) || vm.isAdmin\"><md-button \nng-click=\"vm.lavoraProroga(beneficiario, \'conferma\')\" ng-disabled=\"vm.btnNewProrogaDisabled(beneficiario)\"><div \nstyle=\"pointer-events: auto\"><md-tooltip \nng-show=\"vm.btnNewProrogaDisabled(beneficiario) && beneficiario.errorMsgProroga\">{{ beneficiario.errorMsgProroga }}\n</md-tooltip><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><small ng-if=\"beneficiario.proroghe.length == 0\"><b>\nRICHIEDI PROROGA </b></small><small ng-if=\"beneficiario.proroghe.length > 0\"><b>RINNOVA PROROGA</b></small></div>\n</md-button></md-menu-item><md-menu-item ng-if=\"!vm.richestaprorogaottenibile(beneficiario) && !vm.isAdmin\"><md-button>\n<div style=\"pointer-events: auto\"><md-tooltip ng-show=\"beneficiario.errorMsgProroga\">{{ beneficiario.errorMsgProroga }}\n</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon><small><b>PROROGA NON RICHIEDIBILE</b></small></div>\n</md-button></md-menu-item><div ng-if=\"beneficiario.proroghe.length == 1\" ng-init=\"item = beneficiario.proroghe[0]\">\n<md-menu-item ng-if=\"item.actions.includes(\'update\')\"><md-button class=\"md-grey-300-bg\" \nng-click=\"vm.lavoraProroga(item, \'conferma\', $event)\"><md-icon md-font-icon=\"icon-cog\"></md-icon><small><b>LAVORA</b>\n</small></md-button></md-menu-item><md-menu-item ng-if=\"item.actions.includes(\'approva\')\"><md-button \nclass=\"md-light-green-500-bg\" ng-click=\"vm.lavoraProroga(item, \'approva\')\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><small><b>ACCETTA PROROGA</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"item.actions.includes(\'rifiuta\')\"><md-button class=\"md-red-900-bg\" ng-click=\"vm.lavoraProroga(item, \'rifiuta\')\">\n<md-icon md-font-icon=\"icon-close\" class=\"md-background-fg\"></md-icon><small><b>RIFIUTA PROROGA</b></small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.viewEvento($event, item, \'evento\')\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><small><b>DETTAGLIO PROROGA</b></small></md-button></md-menu-item>\n</div><md-menu-item ng-if=\"beneficiario.proroghe.length > 1\"><md-button ng-click=\"vm.showProroghe(beneficiario)\">\n<md-icon md-font-icon=\"icon-view-list\"></md-icon><small><b>MOSTRA PROROGHE</b></small></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Uscita\" ng-click=\"vm.cessab(1010)\" ng-disabled=\"(vm.selected.length !== 1)\">\n<md-icon md-font-icon=\"icon-exit-to-app\"></md-icon><span>USCITA</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/proroghe/prorogherichieste.html","<div id=\"eventi\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><input \ntype=\"text\" name=\"persona_id\" hidden=\"\" ng-model=\"vm.persona_id\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\">\n<md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Codice</b></small> <input \nid=\"search\" placeholder=\"Codice\" type=\"text\" ng-model=\"vm.ricercaCodice\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b \nclass=\"ng-binding\">Ricerca per Cognome</b></small> <input id=\"search\" placeholder=\"Cognome\" type=\"text\" \nng-model=\"vm.ricercaCognome\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"20\"><md-input-container md-no-float class=\"m-0\" flex><small><b class=\"ng-binding\">Ricerca per Nome</b></small> \n<input id=\"search\" placeholder=\"Nome\" type=\"text\" ng-model=\"vm.ricercaNome\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div></div><md-card \nstyle=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>{{vm.title}}</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key != \'def\' && key !== \'eventoTipo_id_IN\' && key !== \'eventoTipo_id\' && key != \'beneficiarios-cancellato_IN\')\">\n<md-icon name=\"{{key}}\" class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.segnalatos\" multiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" \nstyle=\"text-align:center\" title=\"Codice beneficiario\">Cod</th><th md-column md-order-by=\"stato\" \nstyle=\"text-align:center\" title=\"stato beneficiario\">STATO</th><th md-column style=\"text-align:center\" \ntitle=\"documento soggiorno\">DOCUM</th><th md-column md-order-by=\"cognome\"><span>COGNOME</span></th><th md-column \nmd-order-by=\"nome\">NOME</th><th md-column>NAZIONE</th><th md-column md-order-by=\"progetto_id\" \ntitle=\"progetto appartenenza\">PROGETTO</th><th md-column style=\"text-align:center\" md-order-by=\"sesso\" title=\"sesso\">G\n</th><th md-column md-order-by=\"dataInizio\" style=\"text-align:center\" title=\"data inserimento\">INSER.</th><th \nmd-column md-order-by=\"dataFine\" style=\"text-align:center\" title=\"data fine beneficio\">FINE</th><th md-column \nmd-order-by=\"dataUscita\" style=\"text-align:center\" title=\"data uscita progetto\">USCITA</th><th md-column \nmd-order-by=\"n\" style=\"text-align:center\" title=\"giorni permanenza\">GG</th><th md-column md-order-by=\"nucleoFamiliare\" \nstyle=\"text-align:center\" title=\"nucleo familiare/parentela\">FAM</th><th md-column md-order-by=\"\" \nstyle=\"text-align: center\" ng-if=\"!vm.isReadOnly\">PROCESSO</th><th md-column md-order-by=\"\" style=\"text-align: center\">\nALTRO</th></tr></thead><tbody md-body><tr md-row md-select=\"segnalato\" md-select-id=\"segnalato\" ng-disabled=\"true\" \ndata-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.eventos\" class=\"{{(item.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\"><td md-cell \nstyle=\"text-align:center\"><small>{{item.entita1.codice}}</small></td><td md-cell style=\"text-align:left\"><div \nlayout=\"column\"><span><small><b>{{item.entita1.stato}}</b></small></span></div></td><td md-cell \nstyle=\"text-align:left\"><div layout=\"column\"><span class=\"nowrap\" \nng-repeat=\"item in vm.documentotipo| filter: {id:item.entita1.idTipoDocumento}:true\"><small><b>\n{{ item.descrizione|limitTo:25}}...</b></small></span> <span ng-if=\"item.entita1.idTipoDocumento == \'0\'\"><small><b>\nNESSUN DOCUMENTO</b></small></span> <span><small>\n{{item.entita1.dataRilascioDocumento|date: \"dd/MM/yy\"}} - {{item.entita1.dataScadenzaDocumento|date: \"dd/MM/yy\"}}\n</small></span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{item.entita1.cognome|uppercase}}</td>\n<td md-cell class=\"light-blue-900-fg font-weight-600\">{{item.entita1.nome|uppercase}}</td><td md-cell><div \nlayout=\"column\"><small>{{ item.entita1.nazionalita.descrizione}}</small> <small>\n{{item.entita1.dataNascita| date : \"dd/MM/yy\"}}</small></div></td><td md-cell><b>\n{{ item.entita1.progettos.nome|uppercase}}</b><br><span ng-repeat=\"stru in ::item.entita1.strutturas\"><small>\n{{ stru.nome|uppercase}}</small></span></td><td md-cell style=\"text-align:center\"><b>{{item.entita1.sesso}}</b></td><td\n md-cell style=\"text-align:center\">{{item.entita1.dataInizio| date : \"dd/MM/yy\"}}</td><td md-cell \nstyle=\"text-align:center\">{{item.entita1.dataFine| date : \"dd/MM/yy\"}}</td><td md-cell style=\"text-align:center\" \nng-if=\"item.entita1.dataUscita != \'0000-00-00\'\">{{item.entita1.dataUscita| date : \"dd/MM/yy\"}}</td><td md-cell><div \nlayout=\"column\"><b>{{vm.giorniPermanenza[item.id]}}</b></div></td><td md-cell><i class=\"icon-account-multiple-outline\" \nng-if=\"(item.entita1.nucleoFamiliare === 1 && item.entita1.parentela_id !== null)\"><md-tooltip>\n{{item.entita1.parentelas.descrizione|uppercase}}</md-tooltip></i></td><td md-cell><div \nng-if=\"item.eventoStato_id == 1\"><md-button class=\"md-button-small md-grey-300-bg\" \nng-click=\"vm.lavoraProroga(item, \'conferma\', $event)\" style=\"line-height: 18px\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><small><small>LAVORA</small></small></div></md-button></div><div \nng-if=\"item.eventoStato_id == 3\"><md-button class=\"md-button-small md-light-green-500-bg\" \nng-click=\"vm.lavoraProroga(item, \'approva\', $event)\" style=\"line-height: 18px\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><small><small>APPROVA</small></small></div></md-button><md-button \nclass=\"md-button-small md-red-900-bg\" ng-click=\"vm.lavoraProroga(item, \'rifiuta\', $event)\" style=\"line-height: 18px\">\n<div layout=\"column\"><md-icon md-font-icon=\"icon-close md-background-fg\"></md-icon><small><small>RIFIUTA</small>\n</small></div></md-button></div><div ng-if=\"item.eventoStato_id > 3\"><md-button \nclass=\"md-button-small-x2 md-grey-100-bg\" disabled=\"disabled\"><small><small>FINITO</small></small></md-button></div>\n</td><td md-cell style=\"text-align: right;padding-right: 4px\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_proroga({id:item.entita1.id})\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><small><b>\nPROROGHE BENEFICIARIO</b></small></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Dettagliob\" \nui-sref=\"app.sprardb_beneficiario({id:item.entita1.id})\"><md-icon md-font-icon=\"icon-account-multiple-outline\">\n</md-icon><small><b>APRI BENEFICIARIO</b></small></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Extra\" ng-click=\"vm.viewPerson($event, item, \'extra\')\"><md-icon md-font-icon=\"icon-tag-text-outline\">\n</md-icon><span>Extra</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Segnalato\" \nng-click=\"vm.viewPerson($event, item, \'evento\')\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><span>\nEvento</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Segnalato\" \nng-click=\"vm.viewPerson($event, item.entita1, \'beneficiario\')\"><md-icon md-font-icon=\"icon-comment-account-outline\">\n</md-icon><span>Beneficiario</span></md-button></md-menu-item><md-menu-item ng-if=\"item.entita1.progetto_id > 0\">\n<md-button aria-label=\"Progetto\" ng-click=\"vm.viewPerson($event, item.entita1.progettos, \'progetto\')\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon><span>Progetto</span></md-button></md-menu-item><md-menu-item \nng-if=\"item.eventoStato_id != 4 && !vm.isAdmin\"><md-button aria-label=\"Cancella Proroga\" \nng-click=\"vm.eliminaProroga(item, \'azione\')\"><md-icon md-font-icon=\"icon-delete\" class=\"md-warn-fg\"></md-icon><span>\nCancella Proroga</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.isAdmin\"><md-button \naria-label=\"Cancella Proroga\" ng-click=\"vm.eliminaProroga(item, \'azione\')\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-warn-fg\"></md-icon><span>Cancella Proroga</span></md-button></md-menu-item><md-menu-item \nng-if=\"item.entita1.letteraInserimento > 0\"><md-button aria-label=\"Inserimento\" \nng-click=\"vm.letteraIns($event, item.entita1.segnalazione_id)\"><md-icon md-font-icon=\"icon-file-pdf\" \nclass=\"md-warn-fg\"></md-icon><span>Lettera Inserimento</span></md-button></md-menu-item><md-menu-item \nng-if=\"(item.entita1.trasferimento == 1)\"><md-button aria-label=\"LettTrasferimento\" \nng-click=\"vm.letteraTrasf($event, item.entita1.letteratrasferimento_id)\" \nng-disabled=\"(item.entita1.trasferimento == 0)\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"md-warn-fg\"></md-icon>\n<span>Lettera Trasferimento</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/protocollo/eventiprotocollo.html","<div id=\"protocollo\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/form/generic-sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Protocolla {{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex><md-input-container md-no-float class=\"m-0\" \nflex style=\"padding-top:20px\"><input id=\"search\" placeholder=\"Ricerca segnalato (nome cognome segnalato)\" type=\"text\" \nng-model=\"vm.ricerca2\" ng-change=\"vm.onSearch()\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\">\n</md-input-container></div></div><md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>Protocolla {{vm.title}}\n</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon \nclass=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\';vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key != \'def\' && key !== \'eventoTipo_id_IN\' && key !== \'eventoTipo_id\')\"><md-icon \nname=\"{{key}}\" class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\" \naria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar \nclass=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalati selezionati\' : \'segnalato selezionato\'}} :</span><div \nflex></div><md-button class=\"md-button {{vm.colors[4]}}\" aria-label=\"rsc\" \nng-click=\"vm.work($event, vm.selected, 4, \'A\', false)\" ng-disabled=\"(vm.selected.length == 0)\"><md-icon \nmd-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>ACCETTA I SELEZIONATI</md-button><md-button \nclass=\"md-button {{vm.colors[5]}}\" aria-label=\"rsc\" ng-click=\"vm.work($event, vm.selected, 5, \'R\', false)\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"{{vm.icons[4]}} md-background-fg\" class=\"s18\"></md-icon>\nRIFIUTA I SELEZIONATI</md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"padding-left:8px\"><span>Cod</span></th><th\n md-column style=\"text-align: center\">STATO</th><th md-column md-order-by=\"\">COGNOME</th><th md-column md-order-by=\"\">\nNOME</th><th md-column md-order-by=\"\">NAZIONALITA<br>NASCITA</th><th md-column md-order-by=\"\">ENTE SEGN.</th><th \nmd-column md-order-by=\"\">PROGETTO</th><th md-column md-order-by=\"dataInizio\">DATE</th><th md-column md-order-by=\"\">OM\n</th><th md-column md-order-by=\"\">NUCLEO</th><th md-column>Id Capof.</th><th md-column md-order-by=\"\" \nstyle=\"text-align: center\">PROCESSO</th><th md-column md-order-by=\"\" style=\"text-align: center\">ALTRO</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"segnalato\" md-select-id=\"segnalato\" \nng-disabled=\"(segnalato.eventoStato.id == 4 || segnalato.eventoStato.id == 5)\" data-md-on-select=\"vm.log\" \nmd-on-deselect=\"vm.deselect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"segnalato in vm.eventos\" \nclass=\"{{(segnalato.personas.id !== vm.persona.persona_id)?\'disabled\':\'\'}}\"><td md-cell \nstyle=\"padding-left:8px;padding-right:4px\">{{segnalato.id}}.{{segnalato.entita1.id}}</td><td md-cell><div layout=\"row\">\n<md-button class=\"md-fab md-mini {{vm.colors[segnalato.eventoStato_id]}}\" aria-label=\"status\">\n{{segnalato.eventoStato.iniziali}}<md-tooltip><b>{{segnalato.eventoStato.stato|uppercase}}</b>\n // {{segnalato.eventoTipo.nome}}</md-tooltip></md-button></div></td><td md-cell><b>\n{{segnalato.entita1.cognome|uppercase}}</b></td><td md-cell><b>{{segnalato.entita1.nome|uppercase}}</b></td><td \nmd-cell><div layout=\"column\"><span><b>{{segnalato.entita1.codNazionalitas.descrizione}}</b></span> <span>\n{{segnalato.entita1.dataNascita| date : \"dd/MM/y\"}}</span></div></td><td md-cell><div layout=\"column\"><span><b>\n{{segnalato.entita1.segnalaziones.modellos.descrizione|uppercase}}</b></span> <span>\n{{segnalato.entita1.segnalaziones.data|date:\"dd/MM/yyyy\"}}</span> <span><b>\n{{segnalato.entita1.segnalaziones.entes.nome|uppercase}}</b></span></div></td><td md-cell><small \nng-if=\"(segnalato.entita1.progetto_id > 0)\"><b>{{segnalato.entita1.progettos.nome|uppercase}}</b></small> <small \nng-if=\"(segnalato.entita1.progetto_id == 0)\">N/A</small></td><td md-cell><div layout=\"column\"><div layout=\"row\"><b>\n{{segnalato.dataInizio|date:\"dd/MM/yyyy\"}}</b></div><div layout=\"row\">{{segnalato.dataFine|date:\"dd/MM/yyyy\"}}</div>\n<div layout=\"row\" ng-if=\"(segnalato.dataFine == null)\"><small>NON LAVORATO</small></div></div></td><td md-cell><md-icon\n md-font-icon=\"icon-checkbox-marked\" class=\"green-600-fg s16\" ng-if=\"(segnalato.entita1.omonimoRisolto === -1)\">\n</md-icon><md-icon md-font-icon=\"icon-alert-box\" class=\"red-700-fg s16\" \nng-if=\"(segnalato.entita1.omonimoRisolto === 0)\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" \nclass=\"grey-500-fg s16\" ng-if=\"(segnalato.entita1.omonimoRisolto === 1)\"></md-icon></td><td md-cell><div \nlayout=\"column\"><i class=\"icon-account-multiple-outline\" ng-if=\"(segnalato.entita1.nucleoFamiliare === 1)\"><md-tooltip>\n{{segnalato.entita1.parentelaTipo.descrizione}}</md-tooltip></i><small \nng-if=\"(segnalato.entita1.nucleoFamiliare === 0)\"><b>MONOPAREN.</b></small> <small \nng-if=\"(segnalato.entita1.nucleoFamiliare === 2)\"><b>NON SA</b></small></div></td><td md-cell><div layout=\"column\" \nng-if=\"segnalato.entita1.capof_id > 0\"><small><b>{{segnalato.entita1.capof_id}}</b></small></div></td><td md-cell \nstyle=\"text-align: center\"><div class=\"column\" \nng-if=\"(segnalato.eventoStato_id == 1 || segnalato.eventoStato_id == 4 || segnalato.eventoStato_id == 5 || segnalato.eventoStato_id == 3)\">\n<md-button ng-repeat=\"proc in segnalato.processi| filter: \'(\' + segnalato.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-x2 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, segnalato, processo[1], processo[2], false)\" style=\"line-height: 18px\" \nng-disabled=\"!vm.isallowed(proc)\"><div layout=\"column\"><md-icon \nmd-font-icon=\"{{vm.icons[processo[1]]}} md-background-fg\" class=\"s18\"></md-icon><span><small><small>\n{{processo[2]|uppercase}}</small></small></span></div><md-tooltip><span>{{processo[2]|uppercase}}</span></md-tooltip>\n</md-button><md-button \nng-repeat=\"proc in segnalato.processi| filter: \'(END,\' + segnalato.eventoStato_id + \')\' track by $index\" \nng-click=\"vm.golink(\'app.sprardb_protocollo\', {evento_id: segnalato.id})\" class=\"md-button-small-x2 md-grey-100-bg\" \naria-label=\"nessuno\"><small>FINITO</small></md-button></div></td><td md-cell style=\"text-align: center\"><md-menu>\n<md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"View Detailed\" ng-click=\"vm.dettaglisegnalato(segnalato)\"><md-icon md-font-icon=\"icon-human-child\">\n</md-icon><span>Dettagli segnalato</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Extra\" \nng-click=\"vm.viewPerson($event, segnalato, \'extra\')\"><md-icon md-font-icon=\"icon-details\"></md-icon><span>\nDettagli processo</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Segnalazione\" \nng-click=\"vm.viewPerson($event, segnalato.entita1.segnalaziones, \'segnalazione\')\"><md-icon \nmd-font-icon=\"icon-sign-caution\"></md-icon><span>Segnalazione</span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.entita1.progetto_id > 0\"><md-button aria-label=\"Progetto\" \nng-click=\"vm.viewPerson($event, segnalato.entita1.progettos, \'progetto\')\"><md-icon md-font-icon=\"icon-apps\"></md-icon>\n<span>Progetto</span></md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \naria-label=\"Lettera di segnalazione\" ng-click=\"vm.letteraSeg($event, segnalato.entita1.segnalazione_id)\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon><span>Modello Segnalazione</span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.entita1.letteraInserimento > 0\"><md-button aria-label=\"Inserimento\" \nng-click=\"vm.letteraIns($event, segnalato.entita1.letteraInserimento)\"><md-icon md-font-icon=\"icon-file-pdf-box\" \nclass=\"md-warn-fg\"></md-icon><span><b>Lettera Inserimento</b></span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.entita1.letteraInserimento > 0\"><md-button aria-label=\"modifica\" \nng-click=\"vm.letteraDialog($event, segnalato.entita1.letteraInserimento)\"><md-icon md-font-icon=\"icon-file-pdf-box\" \nclass=\"md-accent-bg\"></md-icon><span>Modifica Lettera ins</span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.letteratrasferimento_id > 0\"><md-button aria-label=\"LettTrasferimento\" \nng-click=\"vm.letteraTrasf($event, beneficiario.id)\"><md-icon md-font-icon=\"icon-file-pdf-box\" class=\"md-warn-fg\">\n</md-icon><span>Lettera Trasferimento</span></md-button></md-menu-item><md-menu-item \nng-if=\"segnalato.letteratrasferimento_id > 0\"><md-button aria-label=\"modifica\" \nng-click=\"vm.letteraDialog($event, beneficiario.letteratrasferimento_id)\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza || vm.api.isSegreteria)\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\" class=\"md-accent-bg\"></md-icon><span>Modifica Lettera T</span></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/protocollo/protocollo.html","<div id=\"protocollo\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotolist()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Protocollo : <small ng-if=\"vm.title\">{{vm.title}}\n</small></span></div></div></div><div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\" style=\"margin-top:36px\"><div flex>\n<div layout=\"column\" class=\"padding-left-16 grey-600-fg\"><section ng-if=\"vm.eventoTipo_id != 1013\"><div layout=\"row\">\n<div flex><small><b>SEGNALAZIONE NUMERO:</b></small></div><div flex><small>{{vm.eventos.entita1.segnalaziones.id}}\n</small></div></div><div layout=\"row\"><div flex><small><b>SEGNALAZIONE DEL:</b></small></div><div flex><small>\n{{vm.eventos.entita1.segnalaziones.data| date: \'dd/MM/yyyy\'}}</small></div></div><div layout=\"row\"><div flex><small><b>\nENTE SEGNALATORE:</b></small></div><div flex><small>\n{{vm.eventos.entita1.segnalaziones.entes.nome|uppercase}} ({{vm.eventos.entita1.segnalaziones.entes.email|uppercase}})\n</small></div></div><div layout=\"row\"><div flex><small><b>SEGNALATORE:</b></small></div><div flex><small>\n{{vm.eventos.entita1.segnalaziones.personas.cognome|uppercase}} {{vm.eventos.entita1.segnalaziones.personas.nome|uppercase}}\n</small></div></div><div layout=\"row\"><div flex><small><b>CONTATTI SEGNALATORE:</b></small></div><div flex><small>\n{{vm.eventos.entita1.segnalaziones.personas.email|uppercase}} // {{vm.eventos.entita1.segnalaziones.personas.telefono}}\n</small></div></div><div layout=\"row\"><div flex><small><b>TIPO SEGNALAZIONE:</b></small></div><div flex><small>\n{{vm.eventos.entita1.segnalaziones.modellos.descrizione}}</small></div></div></section><div layout=\"row\"><div flex>\n<small><b>PROGETTO:</b></small></div><div flex><small ng-if=\"(vm.eventos.entita1.progetto_id > 0)\">\n{{vm.eventos.entita1.progettos.nome|uppercase}} ({{vm.eventos.entita1.progettos.istat.provincia|uppercase}})</small> \n<small ng-if=\"(vm.eventos.entita1.progetto_id == 0)\">-</small></div></div><div layout=\"row\"><div flex><small><b>\nLETTERA INSERIMENTO NUMERO:</b></small></div><div flex><small ng-if=\"(vm.eventos.entita1.letteraInserimento > 0)\">\n{{vm.eventos.entita1.letteraInserimento}} </small><small ng-if=\"(vm.eventos.entita1.letteraInserimento == 0)\">-</small>\n</div></div><div layout=\"row\"><div flex><small><b>TIPO PROTOCOLLAZIONE:</b></small></div><div flex><small \nng-if=\"(vm.tipoProtocollo === \'O\')\">PROTOCOLLO IN ENTRATA</small> <small ng-if=\"(vm.tipoProtocollo === \'I\')\">\nPROTOCOLLO IN USCITA</small></div></div><div layout=\"row\"><div flex><small><b>TIPO DOCUMENTO:</b></small></div><div \nflex><small ng-if=\"(vm.eventoTipo_id == 1004)\">LETTERA INSERIMENTO </small><small \nng-if=\"(vm.eventoTipo_id == 1003 || vm.eventoTipo_id == 1002)\">MODELLO SEGNALAZIONE</small> <small \nng-if=\"(vm.eventoTipo_id == 1013)\">LETTERA TRASFERIMENTO</small></div></div><div layout=\"row\"><md-button \nclass=\"md-button red-900-bg\" aria-label=\"nessuno\" ng-click=\"vm.showpdf()\" flex><md-icon md-font-icon=\"icon-file-pdf\" \nclass=\"s18 white-fg\"></md-icon><small class=\"white-fg\"><span ng-if=\"!vm.show\">Mostra DOCUMENTO</span><span \nng-if=\"vm.show\">Nascondi DOCUMENTO</span></small></md-button><md-button aria-label=\"modifica\" \nng-click=\"vm.letteraDialog($event, vm.eventos.entita1.letteraInserimento)\" ng-if=\"(vm.eventoTipo_id == 1004)\" flex \nclass=\"md-accent-bg\"><md-icon md-font-icon=\"icon-file-pdf-box\" class=\"s18 white-fg\"></md-icon><small>\nModifica Lettera inserimento</small></md-button><md-button aria-label=\"modifica\" \nng-click=\"vm.letteraDialog2($event, vm.eventos.entita1.letteratrasferimento_id)\" ng-if=\"(vm.eventoTipo_id == 1013)\" \nflex class=\"md-accent-bg\"><md-icon md-font-icon=\"icon-file-pdf-box\" class=\"s18 white-fg\"></md-icon><small>\nModifica Lettera trasferimento</small></md-button></div></div><form name=\"protocolloForm\" novalidate><md-card \nclass=\"padding-24\"><h4><b><i class=\"icon-receipt s14\"></i> Inserimento dati protocollo</b></h4><div layout=\"row\" \nlayout-gt-md=\"row\" flex><md-input-container flex ng-if=\"vm.tipoProtocollo === \'I\'\"><md-select-label \nng-class=\"{\'md-warn-fg\': (protocolloForm.firma.$invalid)}\">Firma</md-select-label><md-select name=\"firma\" \nplaceholder=\"Firma\" ng-model=\"vm.protocollo.idFirma\" required ng-change=\"vm.sceglifirma()\"><md-option \nng-repeat=\"item in vm.firmas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small> <img src=\"{{item.note}}\" \nstyle=\"height: 26px;width: auto\"></md-option></md-select><div ng-messages=\"protocolloForm.firma.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-24\"><label ng-class=\"{\'md-warn-fg\': (protocolloForm.protocollo.$invalid)}\">Numero Protocollo <span\n ng-if=\"(vm.tipoProtocollo === \'O\')\">in ENTRATA</span><span ng-if=\"(vm.tipoProtocollo === \'I\')\"> in USCITA</span>\n</label><input type=\"text\" name=\"protocollo\" ng-model=\"vm.protocollo.protocollo\" \nplaceholder=\"Inserire il numero di protocollo...\" required><div ng-messages=\"protocolloForm.protocollo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il protocollo è richiesto</span></div></div></md-input-container><div \nflex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (protocolloForm.dataProtocollo.$invalid)}\">Data protocollo</label><md-datepicker \nname=\"dataProtocollo\" ng-model=\"vm.protocollo.dataProtocollo\" md-placeholder=\"Inserire la data protocollo\" \nmd-max-date=\"vm.oggi\" ng-required=\"true\" required></md-datepicker></div></div><div layout=\"row\" layout-gt-md=\"row\" \nflex><md-input-container flex class=\"margin-bottom-24\" flex><label \nng-class=\"{\'md-warn-fg\': (protocolloForm.destinatari.$invalid)}\">Destinatari</label><input type=\"text\" \nname=\"destinatari\" ng-model=\"vm.protocollo.destinatari\" placeholder=\"Inserire destinatari...\" required \nstyle=\"font-size:11px\"><div ng-messages=\"protocolloForm.destinatari.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Destinatari richiesti</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"{{(!protocolloForm.$invalid)?\'md-raised md-accent\':\'md-warn md-grey-200-bg\'}}\" \nng-disabled=\"(protocolloForm.$invalid)\" ng-click=\"vm.protocolla(vm.evento_id)\" flex><i class=\"icon-content-save s14\">\n</i> PROTOCOLLA</md-button></div></md-card></form></div><div flex ng-if=\"vm.show\"><md-card class=\"padding-24\" \nng-show=\"vm.show\"><object data=\"{{vm.pdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 418px\"></object>\n</md-card></div></div></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazioni.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-clipboard-text\" class=\"s24\"></md-icon></span><span class=\"logo-text\">Lista Rendicontazioni</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" \nms-scroll><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nome progetto\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{debounce: 500}\"></md-input-container><md-input-container flex><label>Tipo di documento</label>\n<md-select ng-model=\"vm.ricerca[\'progettoRendicontazioneTipo_id\']\"><md-option value=\"null\">Tutti</md-option><md-option \nclass=\"small\" ng-repeat=\"tipo in vm.rendicontazioniTipi.data\" value=\"{{tipo.id}}\">{{tipo.descrizione}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Anno</label><md-select ng-model=\"vm.ricerca[\'anno\']\">\n<md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"annoRendicontazioni in vm.annos.data| filter: {anno: (\'\')}\" value=\"{{annoRendicontazioni.anno}}\">\n{{annoRendicontazioni.anno| limitTo: 4}}</md-option></md-select></md-input-container><md-input-container flex><label>\nStato</label><md-select ng-model=\"vm.ricerca[\'progettoRendicontazioneStato_id\']\"><md-option value=\"null\">Tutti\n</md-option><md-option class=\"small\" ng-repeat=\"stato in vm.rendicontazioniStati.data\" value=\"{{stato.id}}\">\n{{stato.descrizione}}</md-option></md-select></md-input-container><md-input-container flex><label>Stato Progetto\n</label><md-select ng-model=\"vm.ricerca[\'progetto-attivo\']\"><md-option value=\"null\">Tutti</md-option><md-option \nclass=\"small\" ng-repeat=\"stato in vm.statiProgetto\" value=\"{{stato.id}}\">{{stato.descrizione}}</md-option></md-select>\n</md-input-container><md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button><md-button ng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small>\n</md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>Ricerca Progetti</b>\n</small><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column>NOME PROGETTO</th><th \nmd-column md-order-by=\"progettoRendicontazioneTipo_id\">DOCUMENTO FINANZIARIO</th><th md-column md-order-by=\"anno\">ANNO\n</th><th md-column md-order-by=\"progettoRendicontazioneStato_id\">STATO</th><th md-column md-order-by=\"codiceProgetto\">\nNR PROG</th><th md-column md-order-by=\"enteLocale\">NOTE</th><th md-column>AZIONI</th></tr></thead><tbody md-body><tr \nmd-row x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.rendicontazioni.data\" \nng-if=\"item.rendicontazioneFinale_id == null\"><td md-cell>{{item.id}}</td><td md-cell><b>\n{{item.progettos.nome| uppercase}}</b></td><td md-cell>\n{{ item.progettoRendicontazioneTipo_id | filterTipo:(vm.rendicontazioniTipi) | uppercase}}</td><td md-cell>\n{{ item.anno }}</td><td md-cell><b>\n{{ item.progettoRendicontazioneStato_id | filterTipo:(vm.rendicontazioniStati) | uppercase }}</b></td><td md-cell><div \nlayout=\"row\"><b>{{ item.codiceProgetto | uppercase }}</b></div></td><td md-cell>{{ item.enteLocale | uppercase }}</td>\n<td md-cell style=\"text-align: right\"><div><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button class=\"md-accent md-button-icon\" aria-label=\"dettaglio\" \nng-click=\"vm.gotoRendicontazione(item.id);\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA</b>\n</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.rendicontazioneTemp_id != null && item.progettoRendicontazioneStato_id == 1\"><md-button \nclass=\"md-accent md-button-icon\" aria-label=\"dettaglio\" ng-click=\"vm.gotoRendicontazione(item.rendicontazioneTemp_id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><small><b>Caricamento giornaliero rapido del registro delle spese</b>\n</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id !=4 && item.progettoRendicontazioneTipo_id !=3\"><md-button \nclass=\"md-button-icon\" aria-label=\"Dettaglio\" ng-click=\"vm.downloadPdf($event, item)\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon><small>PDF</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id ==4\"><md-button class=\"md-button-icon\" aria-label=\"Dettaglio\" \nng-click=\"vm.downloadPdfSAL($event, item)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><small>PDF SAL</small>\n</md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id !=4 && item.progettoRendicontazioneTipo_id !=3\"><md-button \nclass=\"md-button-icon\" aria-label=\"Dettaglio\" ng-click=\"vm.downloadCsv($event, item)\"><md-icon \nmd-font-icon=\"icon-file\"></md-icon><small>CSV</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id ==4\"><md-button class=\"md-button-icon\" aria-label=\"Dettaglio\" \nng-click=\"vm.downloadCsvSAL($event, item)\"><md-icon md-font-icon=\"icon-file\"></md-icon><small>CSV SAL</small>\n</md-button></md-menu-item><md-menu-item ng-if=\"item.progettoRendicontazioneTipo_id == 3 && item.anno > 2017\">\n<md-button class=\"md-button-icon\" aria-label=\"Dettaglio\" ng-click=\"vm.downloadCsvRF($event, item)\"><md-icon \nmd-font-icon=\"icon-file\"></md-icon><small>CSV registro spese</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id == 3 && item.anno > 2017\"><md-button class=\"md-button-icon\" \naria-label=\"Dettaglio\" ng-click=\"vm.downloadCsv($event, item)\"><md-icon md-font-icon=\"icon-file\"></md-icon><small>\nCSV prospetto rendincontazione</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id == 3 && item.anno > 2017\"><md-button class=\"md-button-icon\" \naria-label=\"Dettaglio\" ng-click=\"vm.downloadPdf($event, item)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><small>\nPDF prospetto rendincontazione</small></md-button></md-menu-item><a style=\"text-decoration:none !important\" \nui-sref=\"app.sprardb_rendicontazioni_progetto({projectId: item.progettos.id})\" ng-if=\"!vm.isVisitatore\"><md-menu-item>\n<md-button class=\"md-button-icon\" aria-label=\"Status\"><md-icon md-font-icon=\"icon-sync\"></md-icon><small>\nSTATO RENDICONTAZIONE</small></md-button></md-menu-item></a><md-menu-item ng-if=\"item.progettos.id == 0\"><md-button \nclass=\"md-button-icon\" aria-label=\"Associa\" ng-click=\"vm.associaProgettoDialog($event, item.id, item.codiceProgetto)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>ASSOCIA PROGETTO</small></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openNewRendicontazioneDialog()\" aria-label=\"Crea una nuova rendicontazione\" \nng-if=\"vm.isallowed([6, 3, 4, 5, 10])\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionimc.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple fullwidth\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-clipboard-text\" class=\"s24\"></md-icon></span><span class=\"logo-text\">Lista Rendicontazioni</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" \nms-scroll><form layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" flex><md-input-container \nmd-no-float class=\"m-0\" flex><input placeholder=\"Ricerca nome progetto\" type=\"text\" \nng-model=\"vm.filterModel[\'progetto.nome\'].like\"></md-input-container><md-input-container md-no-float class=\"m-0\" flex>\n<input placeholder=\"Ricerca codice progetto\" type=\"text\" \nng-model=\"vm.filterModel[\'documentoRendicontazione.codiceProgetto\'].like\"></md-input-container><md-input-container \nflex><label>Tipologia Progetto</label><md-select ng-model=\"vm.filterModel[\'progetto.tipologiaAccoglienzaId\']\">\n<md-option value=\"\">Tutti</md-option><md-option class=\"small\" ng-repeat=\"tipologia in vm.tipAccoglienza\" \nvalue=\"{{tipologia.id}}\">{{tipologia.descrizione}}</md-option></md-select></md-input-container><md-input-container \nflex><label>Stato Progetto</label><md-select ng-model=\"vm.filterModel[\'progetto.attivo\']\"><md-option value=\"\">Tutti\n</md-option><md-option class=\"small\" ng-repeat=\"stato in vm.statiProgetto\" value=\"{{stato.id}}\">{{stato.descrizione}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex>\n<md-input-container flex><label>Tipo di documento</label><md-select \nng-model=\"vm.filterModel[\'progettoRendicontazioneTipo_id\']\"><md-option value=\"\">Tutti</md-option><md-option \nclass=\"small\" ng-repeat=\"tipo in vm.rendicontazioniTipi\" value=\"{{tipo.id}}\">{{tipo.descrizione}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Anno</label><md-select \nng-model=\"vm.filterModel[\'documentoRendicontazione.anno\'].like\"><md-option value=\"\">Tutti</md-option><md-option \nng-repeat=\"annoRendicontazioni in vm.anni\" value=\"{{annoRendicontazioni.anno}}\">{{annoRendicontazioni.anno}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Stato</label><md-select \nng-model=\"vm.filterModel[\'progettoRendicontazioneStato_id\']\"><md-option value=\"\">Tutti</md-option><md-option \nclass=\"small\" ng-repeat=\"stato in vm.rendicontazioniStati\" value=\"{{stato.id}}\">{{stato.descrizione}}</md-option>\n</md-select></md-input-container><md-input-container \nng-if=\"vm.api.user.permissions.includes(\'view-modalita-rendicontazione\')\" flex><label>Modalità</label><md-select \nng-model=\"vm.filterModel.modoRendicontazioneId\"><md-option value=\"\">Tutti</md-option><md-option class=\"small\" \ntitle=\"{{modo.descrizione}}\" ng-repeat=\"modo in vm.rendicontazioniModi\" value=\"{{modo.id}}\">{{modo.label}}</md-option>\n</md-select></md-input-container><md-button type=\"submit\" ng-click=\"vm.onSearch();\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button ng-click=\"vm.svuotaRicerca()\"><small>\nSvuota</small></md-button></div></form><md-card style=\"padding-top:0px\"><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.rendicontazioni.$promise\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column md-order-by=\"id\">Cod</th><th md-column>NOME PROGETTO</th><th md-column>TIPOLOGIA</th><th \nmd-column ng-if=\"vm.api.user.permissions.includes(\'view-modalita-rendicontazione\')\">MODALITÀ</th><th md-column \nmd-order-by=\"progettoRendicontazioneTipo_id\">DOCUMENTO FINANZIARIO</th><th md-column>ANNO</th><th md-column>PERIODO\n</th><th md-column md-order-by=\"progettoRendicontazioneStato_id\">STATO</th><th md-column md-order-by=\"codiceProgetto\">\nNR PROG</th><th md-column>AZIONI</th></tr></thead><tbody md-body><tr md-row x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.rendicontazioni.data\"><td md-cell>{{item.id}}</td><td md-cell><b>\n{{item.progetto.nome| uppercase}}</b></td><td md-cell>{{ item.progetto.tipologiaAccoglienza.descrizione }}</td><td \nmd-cell ng-if=\"vm.api.user.permissions.includes(\'view-modalita-rendicontazione\')\">{{ item.modo.label }}</td><td \nmd-cell>{{ item.progettoRendicontazioneTipo_id | filterDescrizione:(vm.rendicontazioniTipi) | uppercase}}</td><td \nmd-cell>{{ item.anno }}</td><td md-cell>{{ item.setup.mesiAnniRendicontazione }}</td><td md-cell style=\"padding:0\"><b>\n{{ item.stato.descrizione | uppercase }}</b><md-icon ng-if=\"item.statoArchiviazioneId == 4\" \nmd-font-icon=\"icon-archive\"></md-icon></td><td md-cell><div layout=\"row\"><b>{{ item.codiceProgetto | uppercase }}</b>\n</div></td><td md-cell style=\"text-align: right\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><a style=\"text-decoration:none !important\" \nui-sref=\"app.sprardb_rendicontazionimc_rendicontazione({id: item.id})\"><md-menu-item><md-button aria-label=\"Apri\" \nclass=\"md-accent md-button-icon\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>APRI</span>\n</md-button></md-menu-item></a><md-menu-item ng-if=\"item.progettoRendicontazioneTipo_id != 5\"><md-button \nclass=\"md-button-icon\" aria-label=\"PDF\" ng-click=\"vm.downloadPdf($event, item)\"><md-icon md-font-icon=\"icon-file-pdf\">\n</md-icon><small>PDF</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id == 3 && item.anno > \'2017\'\"><md-button class=\"md-button-icon\" \naria-label=\"Dettaglio\" ng-click=\"vm.downloadCsvRegistro($event, item)\"><md-icon md-font-icon=\"icon-file\"></md-icon>\n<small>CSV registro spese</small></md-button></md-menu-item><md-menu-item \nng-if=\"item.progettoRendicontazioneTipo_id != 5\"><md-button class=\"md-button-icon\" aria-label=\"CSV\" \nng-click=\"vm.downloadCsv($event, item)\"><md-icon md-font-icon=\"icon-file\"></md-icon><small>CSV prospetto</small>\n</md-button></md-menu-item><a style=\"text-decoration:none !important\" \nui-sref=\"app.sprardb_rendicontazionimc_progetto({projectId: item.progetto_id})\" ng-if=\"!vm.api.isRevisore\">\n<md-menu-item><md-button class=\"md-button-icon\" aria-label=\"Status\"><md-icon md-font-icon=\"icon-sync\"></md-icon><small>\nSTATO RENDICONTAZIONE</small></md-button></md-menu-item></a><md-menu-item ng-if=\"item.progettos.id == 0\"><md-button \nclass=\"md-button-icon\" aria-label=\"Associa\" ng-click=\"vm.associaProgettoDialog($event, item.id, item.codiceProgetto)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>ASSOCIA PROGETTO</small></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.search[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" md-total=\"{{vm.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openNewRendicontazioneDialog()\" aria-label=\"Crea una nuova rendicontazione\" \nng-if=\"vm.isallowed([6, 3, 4, 5, 10])\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/report/estrazioniMinistero.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\"><div \nlayout=\"row\"><md-card flex=\"100\"><md-card-content><label>\nSeleziona il progetto per fare una nuova estraizone o consultare il suo storico</label><div layout=\"row\" \nlayout-align=\"start center\"><md-select layout=\"row\" ng-model=\"vm.selected[\'progetti[]\']\" placeholder=\"Progetto...\" \nname=\"progetti\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\"><small><b style=\"text-transform: uppercase\">\n{{progetto.nome}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'progetti\')\" \naria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button></div><md-radio-group \nng-model=\"vm.selected.tipoReport\" ng-change=\"vm.resetDateReport()\"><md-radio-button value=\"report-beneficiari\" \nclass=\"md-primary\" ng-if=\"!vm.api.isAdmin\">Anagrafica Minori</md-radio-button><md-radio-button \nng-repeat=\"estrazione in vm.mapReport\" ng-value=\"estrazione.tipo\" class=\"md-primary\" ng-if=\"vm.api.isAdmin\">\n{{estrazione.label}}</md-radio-button></md-radio-group><br><label>Storico delle estrazioni</label><md-select \nng-model=\"vm.selected.dataReport\" placeholder=\"Seleziona una data...\" flex><md-option \nng-if=\"vm.selected.tipoReport == \'report-beneficiari\'\" ng-repeat=\"date in vm.dateReport[vm.selected.tipoReport]\" \nng-value=\"date.dataEstrazione\"><small><b style=\"text-transform: uppercase\">{{date.dataFormattata}}</b></small>\n</md-option><md-option ng-if=\"vm.selected.tipoReport != \'report-beneficiari\'\" \nng-repeat=\"date in vm.dateReport[vm.selected.tipoReport]\" ng-value=\"date.dataEstrazione\"><small><b \nstyle=\"text-transform: uppercase\">{{date.dataEstrazione}}</b></small></md-option></md-select><div layout=\"row\" \nlayout-align=\"end\"><md-button ng-click=\"vm.esportaCsv()\" style=\"background-color: #0e90d2;color: white\">Esporta Dati\n</md-button></div></md-card-content></md-card></div><md-card ng-show=\"vm.api.isAdmin\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"row\"><md-button class=\"md-button md-accent-bg\" \nng-click=\"vm.ripetiProgetti()\">Ripeti estrazione progetti</md-button></div><div class=\"row\"><md-button \nclass=\"md-button md-accent-bg\" ng-click=\"vm.ripetiStrutture()\">Ripeti estrazione strutture</md-button></div></div>\n</md-card></div></div>");
$templateCache.put("app/main/sprardb/report/rbeneficiari.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" style=\"cursor: pointer\"><i \nng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/rbeneficiaritemplate.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-show=\"!vm.allsearchs.groupby\"><td md-cell \nng-repeat=\"(colonna,v) in vm.strutturadati\" style=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div\n layout=\"column\" ng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" \nstyle=\"cursor: pointer\"><i ng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span> <span \nng-if=\"($first && vm.allsearchs.groupby)\">&nbsp;&nbsp;&nbsp;<i class=\"icon-eye s12\" style=\"cursor: pointer\" \nng-click=\"vm.drilldown(colonna, beneficiario[colonna])\"></i></span></div></td></tr><tr md-row class=\"md-grey-200-bg\" \nng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"row\" ng-if=\"(colonna === \'cnt\')\">\n<big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/rcorsi.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" style=\"cursor: pointer\"><i \nng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/reaso.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.writeExportFile()\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-if=\"vm.datas.barragruppo\"><td md-cell \nng-repeat=\"(colonna,v) in vm.strutturadati\" style=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div\n layout=\"column\" ng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" \nstyle=\"cursor: pointer\"><i ng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/report1.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Reports</span></div></div></div><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca nei beneficiari\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca Beneficiari<span ng-if=\"(vm.def == 0)\"> incompleti</span></b></small><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ms-scroll><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"text-align:center;padding-right:4px\">Cod\n</th><th md-column md-order-by=\"stato\" style=\"text-align:center;padding-right:8px\">STATO</th><th md-column \nstyle=\"text-align:center;padding-right:8px\">DOCUM</th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\">\n<span>COGNOME</span></th><th md-column md-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column \nstyle=\"padding-right:8px\">NAZIONE</th><th md-column style=\"padding-right:8px\" md-order-by=\"progetto_id\">PROGETTO</th>\n<th md-column style=\"text-align:center;padding-right:4px\" md-order-by=\"sesso\">G</th><th md-column \nmd-order-by=\"dataInserimento\" style=\"text-align:center;padding-right:8px\">INSER.</th><th md-column \nmd-order-by=\"dataFine\" style=\"text-align:center;padding-right:8px\">FINE</th><th md-column md-order-by=\"dataUscita\" \nstyle=\"text-align:center;padding-right:8px\">USCITA</th><th md-column md-order-by=\"n\" \nstyle=\"text-align:center;padding-right:4px\">NR</th><th md-column md-order-by=\"nucleoFamiliare\" \nstyle=\"text-align:center;padding-right:4px\">F</th><th md-column style=\"text-align:right;padding-right:16px\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" \nng-disabled=\"(beneficiario.def === 0)\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"beneficiario in vm.beneficiari\" \nng-class=\"{\'md-light-blue-50-bg\': beneficiario.def === 0,\'md-deep-orange-50-bg\': beneficiario.trasferimento === 1}\"><td\n md-cell style=\"text-align:center;padding-right:4px\">{{beneficiario.id}}</td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><span \nng-repeat=\"item in vm.benefstatos| filter: {descrizione:beneficiario.stato}\"><md-button \nclass=\"md-fab md-mini {{vm.colors[(item.codice + 5)]}}\" aria-label=\"status\">{{ item.descrizione|limitTo:1}}<md-tooltip>\n{{ item.descrizione}}</md-tooltip></md-button></span></td><td md-cell style=\"text-align:center;padding-right:8px\"><span\n ng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}:true\"><md-button \nclass=\"md-fab md-mini {{vm.colors[item.codice]}}\" aria-label=\"status\">{{ item.descrizione|limitTo:2}}<md-tooltip>\n{{ item.descrizione}} - {{beneficiario.dataRilascioDocumento|date: \"dd/MM/yy\"}} - {{beneficiario.dataScadenzaDocumento|date: \"dd/MM/yy\"}}\n</md-tooltip></md-button></span><md-button ng-if=\"beneficiario.idTipoDocumento == \'0\'\" \nclass=\"md-fab md-mini md-blue-grey-800-bg\" aria-label=\"status\">-<md-tooltip><span>NESSUN DOCUMENTO</span></md-tooltip>\n</md-button></td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">\n{{beneficiario.cognome|uppercase}}</td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">\n{{beneficiario.nome|uppercase}}</td><td md-cell style=\"padding-right:8px\">{{ beneficiario.nazionalita.descrizione}}<br>\n{{beneficiario.dataNascita| date : \"dd/MM/yy\"}}</td><td md-cell style=\"padding-right:8px\"><b>\n{{ beneficiario.progettos.nome|uppercase}}</b><br><span ng-repeat=\"stru in ::beneficiario.strutturas\"><small>\n{{ stru.nome|uppercase}}</small></span></td><td md-cell style=\"text-align:center;padding-right:4px\"><b>\n{{beneficiario.sesso}}</b></td><td md-cell style=\"text-align:center;padding-right:8px\">\n{{beneficiario.dataInserimento| date : \"dd/MM/yy\"}}</td><td md-cell style=\"text-align:center;padding-right:8px\">\n{{beneficiario.dataFine| date : \"dd/MM/yy\"}}</td><td md-cell style=\"text-align:center;padding-right:8px\" \nng-if=\"beneficiario.dataUscita != \'0000-00-00\'\">{{beneficiario.dataUscita| date : \"dd/MM/yy\"}}</td><td md-cell \nstyle=\"text-align:right;padding-right:4px\">{{beneficiario.n}}</td><td md-cell \nstyle=\"text-align:right;padding-right:4px\"><i class=\"icon-account-multiple-outline\" \nng-if=\"(beneficiario.nucleoFamiliare === 1 && beneficiario.parentela_id !== null)\"><md-tooltip>\n{{beneficiario.parentelas.descrizione|uppercase}}</md-tooltip></i></td><td md-cell \nstyle=\"text-align:right;padding-right:8px\"></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/reportBeneficiariCorsiServizi.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\" \nlayout=\"row\"><div ng-style=\"{\'width\':\'60%\',\'align\':\'center\',\'background-color\':\'#f0f2f0\'}\"><md-select layout=\"row\" \nng-model=\"searchBandi\" placeholder=\"Categorie...\" name=\"bandi\" multiple=\"multiple\"><md-option \nng-repeat=\"bando in vm.bandi\" value=\"{{bando.id}}\"><small><b style=\"text-transform: uppercase\">{{bando.descrizione}}\n</b></small></md-option></md-select><md-select layout=\"row\" ng-model=\"searchRegioni\" placeholder=\"Regioni...\" \nname=\"regioni\" ng-change=\"filtrap()\" multiple=\"multiple\"><md-option ng-repeat=\"regione in vm.regioni\" \nvalue=\"{{regione.id}}\"><small><b style=\"text-transform: uppercase\">{{regione.regione}}</b></small></md-option>\n</md-select><md-select layout=\"row\" ng-model=\"searchProvince\" placeholder=\"Provincia...\" name=\"province\" \nng-change=\"filtraprogetto()\" multiple=\"multiple\"><md-option ng-repeat=\"provincia in vm.province\" \nvalue=\"{{provincia.id}}\"><small><b style=\"text-transform: uppercase\">{{provincia.provincia}}</b></small></md-option>\n</md-select><md-select layout=\"row\" ng-model=\"searchProgetti\" placeholder=\"Progetto...\" name=\"progetti\" \nng-change=\"filtraente()\" multiple=\"multiple\"><md-option ng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\">\n<small><b style=\"text-transform: uppercase\">{{progetto.nome}}</b></small></md-option></md-select><md-select \nlayout=\"row\" ng-model=\"searchEnti\" placeholder=\"Ente Titolare...\" name=\"enti\" multiple=\"multiple\"><md-option \nng-repeat=\"ente in vm.enti\" value=\"{{ente.id}}\"><small><b style=\"text-transform: uppercase\">{{ente.nome}}</b></small>\n</md-option></md-select><div><md-radio-group ng-model=\"radio\"><md-radio-button value=\"accolti\" class=\"md-primary\">\nAccolti</md-radio-button><md-radio-button value=\"presenti\" class=\"md-primary\">Presenti</md-radio-button>\n</md-radio-group><div id=\"accolti\">Da<md-datepicker ng-model=\"searchDataDa\" md-placeholder=\"Da...\"></md-datepicker>A\n<md-datepicker ng-model=\"searchDataA\" md-placeholder=\"A...\"></md-datepicker></div><div id=\"presenti\">Presenti al\n<md-datepicker ng-model=\"searchDataPresenti\" md-placeholder=\"Da...\"></md-datepicker></div></div></div></div><md-button \nng-click=\"search()\" style=\"background-color: #0e90d2;color: white\">Cerca</md-button><div \nstyle=\"margin-left: 2%;margin-right: 2%; margin-top: 7%\"><div layout=\"row\" flex><md-button class=\"md-icon-button\" \nng-click=\"exportcsv()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button></div><md-toolbar class=\"md-table-toolbar md-default\">\n</md-toolbar><md-table-container><table data-md-table md-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head><tr \nmd-r><th ng-repeat=\"key in vm.keyNames\" md-column style=\"padding-right:4px;padding-left:4px\" ng-show=\"true\">\n{{key | uppercase}}</th></tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\"><td \nmd-cell style=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key]}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.meta.perPage\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.meta.currentPage\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"paginate\" md-page-select md-label=\"{ page: \'Pagina:\', rowsPerPage: \'Righe per pagina:\', of: \'di\'}\" \nmd-boundary-links=\"vm.options.boundaryLinks\"></md-table-pagination></div></div>");
$templateCache.put("app/main/sprardb/report/reportGenerico.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\"><div \nlayout=\"row\"><md-card flex=\"{vm.tipoReport !== \'reportchecklistmonitoraggio\' ? 60 : 100}\"><md-card-content><div \nlayout=\"row\" layout-align=\"space-between center\"><md-select ng-model=\"vm.selected[\'bandi[]\']\" \nplaceholder=\"Categorie...\" name=\"bandi\" ng-change=\"disableCheckbox(\'bandi\')\" multiple=\"multiple\" flex \nng-if=\"!vm.api.isAdmin\"><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"bando in vm.bandi\" value=\"{{bando.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{bando.descrizione}}</b></small></md-option></md-select><md-select \nng-model=\"vm.selected[\'bandi[]\']\" placeholder=\"Categorie...\" name=\"bandi\" ng-change=\"disableCheckbox(\'bandi\')\" \nmultiple=\"multiple\" flex=\"60\" ng-if=\"vm.api.isAdmin\"><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option ng-repeat=\"bando in vm.bandi\" \nvalue=\"{{bando.id}}\"><small><b style=\"text-transform: uppercase\">{{bando.descrizione}}</b></small></md-option>\n</md-select><md-select ng-model=\"vm.searchParamsBando.filter.attivo\" placeholder=\"Stato categoria...\" name=\"categorie\" \nng-change=\"vm.loadBandi()\" flex=\"20\" ng-if=\"vm.api.isAdmin\"><md-option ng-value=\"Tutte\"><small><b \nstyle=\"text-transform: uppercase\">Tutte</b></small></md-option><md-option ng-value=\"1\"><small><b \nstyle=\"text-transform: uppercase\">Attive</b></small></md-option><md-option ng-value=\"0\"><small><b \nstyle=\"text-transform: uppercase\">Non Attive</b></small></md-option></md-select><md-button class=\"md-icon-button\" \nng-click=\"clear(\'bandi\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" ng-model=\"vm.selected[\'regioni[]\']\" \nplaceholder=\"Regioni...\" name=\"regioni\" ng-change=\"filtraprovincia()\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"regione in vm.regioni\" value=\"{{regione.id}}\"><small><b style=\"text-transform: uppercase\">\n{{regione.regione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'regioni\')\" \naria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button><md-select layout=\"row\" \nng-model=\"vm.selected[\'province[]\']\" placeholder=\"Provincia...\" name=\"province\" ng-change=\"filtraprogetto()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"provincia in vm.province\" value=\"{{provincia.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{provincia.provincia}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'province\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" \nng-model=\"vm.selected[\'progetti[]\']\" placeholder=\"Progetto...\" name=\"progetti\" ng-change=\"filtraente()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{progetto.nome}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'progetti\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select ng-model=\"vm.selected[\'enti[]\']\" \nplaceholder=\"Ente Titolare...\" name=\"enti\" ng-change=\"disableCheckbox(\'enti\')\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"ente in vm.enti\" value=\"{{ente.id}}\"><small><b style=\"text-transform: uppercase\">{{ente.nome}}</b></small>\n</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'enti\')\" aria-label=\"Reset\"><md-icon \nclass=\"icon-cancel\"></md-icon></md-button></div><div layout=\"row\" ng-show=\"vm.reportBeneficiario\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"50\"><md-select ng-model=\"vm.selected[\'tipBeneficiario[]\']\" \nplaceholder=\"Tipologia ingresso protetto...\" name=\"tipbeneficiario\" ng-change=\"disableCheckbox(\'tipBeneficiario\')\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"tipB in vm.tipBeneficiario\" value=\"{{tipB.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{tipB.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'tipbeneficiario\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.reportBeneficiario || vm.tipoReport === \'reportchecklistmonitoraggio\'\"><md-select layout=\"row\" \nng-model=\"vm.selected[\'tipAccoglienza[]\']\" placeholder=\"Tipologia Progetto...\" name=\"tipaccoglienza\" \nng-change=\"disableCheckbox(\'tipAccoglienza\')\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"tipAccoglienza in vm.tipAccoglienza\" value=\"{{tipAccoglienza.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{tipAccoglienza.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" style=\"width: 10%;border-width: 1px\" ng-click=\"clear(\'tipaccoglienza\')\" aria-label=\"Reset\">\n<md-icon class=\"icon-cancel\"></md-icon></md-button></div><div layout=\"row\" ng-show=\"vm.reportBeneficiario\" \nlayout-align=\"start center\"><md-select ng-model=\"vm.selected[\'nazione[]\']\" placeholder=\"Nazionalità...\" name=\"nazione\" \nng-change=\"disableCheckbox(\'nazione\')\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option ng-repeat=\"nazione in vm.nazioni\" \nvalue=\"{{nazione.id}}\"><small><b style=\"text-transform: uppercase\">{{nazione.descrizione}}</b></small></md-option>\n</md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'nazione\')\" aria-label=\"Reset\"><md-icon \nclass=\"icon-cancel\"></md-icon></md-button><md-select ng-model=\"vm.selected[\'genere[]\']\" placeholder=\"Genere...\" \nname=\"genere\" ng-change=\"disableCheckbox(\'genere\')\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small>\n<b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option ng-repeat=\"genere in vm.genere\" \nvalue=\"{{genere}}\"><small><b style=\"text-transform: uppercase\">{{genere}}</b></small></md-option></md-select><md-button\n class=\"md-icon-button\" ng-click=\"clear(\'genere\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" ng-show=\"vm.reportBeneficiario\" layout-align=\"start center\"><md-select \nlayout=\"row\" ng-model=\"vm.selected[\'tipProtezione[]\']\" placeholder=\"Tipologia di Soggiorno...\" name=\"tipprotezione\" \nng-change=\"disableCheckbox(\'tipProtezione\')\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"tipProtezione in vm.tipoProtezione\" value=\"{{tipProtezione.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{tipProtezione.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'tipProtezione\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div ng-show=\"vm.tipoReport == \'nazionalita\'\">Data Maggiorenne<md-datepicker \nng-model=\"vm.dateSelezionate.dataMaggiorenne\" md-placeholder=\"Inserire data...\"></md-datepicker></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><md-radio-group ng-model=\"vm.selected.statoB\">\n<md-radio-button \nng-show=\"!(vm.tipoReport == \'comuniStruttura\' || vm.tipoReport == \'postiDisponibili\' ||vm.tipoReport == \'struttureTipologia\' || vm.tipoReport == \'progetti\' || vm.tipoReport == \'covid\' || vm.tipoReport == \'prorogheBeneficiari\' || vm.tipoReport == \'prorogheLavorate\' || vm.tipoReport == \'reportchecklistmonitoraggio\')\" \nvalue=\"accolti\" class=\"md-primary\" ng-click=\"vm.showDateAccolti=true;vm.showDatePresenti=false\">Accolti\n</md-radio-button><md-radio-button \nng-show=\"!(vm.tipoReport == \'uscita\'|| vm.tipoReport == \'postiDisponibili\'|| vm.tipoReport == \'comuniStruttura\'|| vm.tipoReport == \'struttureTipologia\' || vm.tipoReport == \'covid\' || vm.tipoReport == \'prorogheBeneficiari\' || vm.tipoReport == \'prorogheLavorate\' || vm.tipoReport == \'reportchecklistmonitoraggio\')\" \nvalue=\"presenti\" class=\"md-primary\" ng-click=\"vm.showDateAccolti=false;vm.showDatePresenti=true\">Presenti\n</md-radio-button></md-radio-group><div ng-show=\"vm.showDateAccolti\" id=\"accolti\" layout=\"row\" \nlayout-align=\"space-around\"><md-input-container><p ng-if=\"vm.tipoReport == \'covid\' \">Data Inizio Accoglienza</p>\n</md-input-container><md-input-container><label>Da</label><md-datepicker ng-model=\"vm.dateSelezionate.dataDa\" \nmd-placeholder=\"Da...\" md-max-date=\"vm.controlDa\" ng-change=\"checkDate(\'da\')\"></md-datepicker></md-input-container>\n<md-input-container><label>A</label><md-datepicker ng-model=\"vm.dateSelezionate.dataA\" md-placeholder=\"A...\" \nmd-min-date=\"vm.controlA\" ng-change=\"checkDate(\'a\')\"></md-datepicker></md-input-container></div><div id=\"presenti\" \nng-show=\"vm.showDatePresenti\">Presenti al<md-datepicker ng-model=\"vm.dateSelezionate.dataPresenti\" \nmd-placeholder=\"Da...\"></md-datepicker></div></div><div layout=\"column\"><label>Progetti</label><md-radio-group \nng-model=\"vm.selected.attivo\"><md-radio-button value=\"1\" class=\"md-primary\">Attivi</md-radio-button><md-radio-button \nvalue=\"0\" class=\"md-primary\">Non Attivi</md-radio-button><md-radio-button ng-value=\"null\" class=\"md-primary\">Tutti\n</md-radio-button></md-radio-group></div></div><div layout=\"row\" layout-align=\"start\"><md-button ng-click=\"search()\" \nstyle=\"background-color: #0e90d2;color: white\">Cerca</md-button></div></md-card-content></md-card><md-card flex \nng-if=\"vm.tipoReport !== \'reportchecklistmonitoraggio\'\"><md-card-content><p>\nSelezionare i campi per i quali si desidera raggruppare i dati:</p><md-checkbox ng-model=\"vm.selected[\'groupBandi\']\" \nng-false-value=\"0\" ng-true-value=\"1\" ng-disabled=\"!vm.selected[\'bandi[]\'] || vm.selected[\'bandi[]\'].toString() == \'\'\">\nCategorie</md-checkbox><br><md-checkbox ng-model=\"vm.selected[\'groupRegioni\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'regioni[]\'] || vm.selected[\'regioni[]\'].toString() == \'\'\">Regione</md-checkbox><br>\n<md-checkbox ng-model=\"vm.selected[\'groupProvince\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'province[]\'] || vm.selected[\'province[]\'].toString() == \'\'\">Province</md-checkbox><br>\n<md-checkbox ng-model=\"vm.selected[\'groupProgetti\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'progetti[]\'] || vm.selected[\'progetti[]\'].toString() == \'\'\">Progetti</md-checkbox><br>\n<md-checkbox ng-model=\"vm.selected[\'groupEnti\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'enti[]\'] || vm.selected[\'enti[]\'].toString() == \'\'\">Enti</md-checkbox><br><md-checkbox \nng-model=\"vm.selected[\'groupTipBeneficiario\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'tipBeneficiario[]\'] || vm.selected[\'tipBeneficiario[]\'].toString() == \'\'\" \nng-show=\"vm.reportBeneficiario\">Tipologia ingresso protetto</md-checkbox><br><md-checkbox \nng-model=\"vm.selected[\'groupTipAccoglienza\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'tipAccoglienza[]\'] || vm.selected[\'tipAccoglienza[]\'].toString() == \'\'\">Tipologia Progetto\n</md-checkbox><br><md-checkbox ng-model=\"vm.selected[\'groupNazione\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'nazione[]\'] || vm.selected[\'nazione[]\'].toString() == \'\'\" ng-show=\"vm.reportBeneficiario\">\nNazionalità</md-checkbox><br><md-checkbox ng-model=\"vm.selected[\'groupGenere\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'genere[]\'] || vm.selected[\'genere[]\'].toString() == \'\'\" ng-show=\"vm.reportBeneficiario\">\nGenere</md-checkbox><br><md-checkbox ng-model=\"vm.selected[\'groupTipProtezione\']\" ng-false-value=\"0\" ng-true-value=\"1\" \nng-disabled=\"!vm.selected[\'tipProtezione[]\'] || vm.selected[\'tipProtezione[]\'].toString() == \'\'\" \nng-show=\"vm.reportBeneficiario\">Tipologia di soggiorno</md-checkbox><br></md-card-content></md-card></div><md-card>\n<md-card-content><span ng-show=\"vm.dati == null && !vm.progress\">Premere il tasto cerca per visualizzare i risultati\n</span><div layout=\"row\" layout-sm=\"column\" ng-show=\"vm.progress\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"vm.dati != null\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><md-button class=\"md-icon-button\" ng-click=\"exportcsv()\"><i \nclass=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button>\n</md-toolbar><md-table-container><table data-md-table md-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head><tr \nmd-row><th ng-repeat=\"key in vm.keyNames\" md-column>{{key | uppercase}}</th></tr></thead><tbody md-body><tr md-row \nclass=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\" ng-if=\"vm.tipoReport != \'reportchecklistmonitoraggio\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key] || vm.nullValue}}\n</td></tr><tr md-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\" \nng-if=\"vm.tipoReport == \'reportchecklistmonitoraggio\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key]}}</td></tr><tr \nmd-row class=\"md-grey-500-bg\" ng-if=\"vm.tipoReport == \'prorogheLavorate\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">\n{{vm.totale[key] || vm.nullValue}}</td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.meta.perPage\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.meta.currentPage\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"paginate\" md-page-select \nmd-label=\"{ page: \'Pagina:\', rowsPerPage: \'Righe per pagina:\', of: \'di\'}\" md-boundary-links=\"vm.options.boundaryLinks\">\n</md-table-pagination></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/sprardb/report/reportGenericoMonitoraggio.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\"><div \nlayout=\"row\"><md-card flex><md-card-content><div layout=\"row\" layout-align=\"start center\"><md-select \nng-model=\"vm.selected[\'bandi[]\']\" placeholder=\"Categorie...\" name=\"bandi\" ng-change=\"disableCheckbox(\'bandi\')\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"bando in vm.bandi\" value=\"{{bando.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{bando.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'bandi\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" ng-model=\"vm.selected[\'regioni[]\']\" \nplaceholder=\"Regioni...\" name=\"regioni\" ng-change=\"filtraprovincia()\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"regione in vm.regioni\" value=\"{{regione.id}}\"><small><b style=\"text-transform: uppercase\">\n{{regione.regione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'regioni\')\" \naria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button><md-select layout=\"row\" \nng-model=\"vm.selected[\'province[]\']\" placeholder=\"Provincia...\" name=\"province\" ng-change=\"filtraprogetto()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"provincia in vm.province\" value=\"{{provincia.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{provincia.provincia}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'province\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" \nng-model=\"vm.selected[\'progetti[]\']\" placeholder=\"Progetto...\" name=\"progetti\" ng-change=\"filtraente()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{progetto.nome}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'progetti\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select ng-model=\"vm.selected[\'enti[]\']\" \nplaceholder=\"Ente Titolare...\" name=\"enti\" ng-change=\"disableCheckbox(\'enti\')\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"ente in vm.enti\" value=\"{{ente.id}}\"><small><b style=\"text-transform: uppercase\">{{ente.nome}}</b></small>\n</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'enti\')\" aria-label=\"Reset\"><md-icon \nclass=\"icon-cancel\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\"!vm.api.isVisitatore\"><md-select ng-model=\"vm.selected[\'statoMonitoraggio[]\']\" placeholder=\"Stato visita...\" \nname=\"statoMonitoraggio\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"statoMonitoraggio in vm.statoMonitoraggio  | filter:{gruppo:\'STATO\'}:true\" value=\"{{statoMonitoraggio.id}}\" \nng-selected=\"[3,4,5].includes(statoMonitoraggio.id)\"><small><b style=\"text-transform: uppercase\">\n{{statoMonitoraggio.descrizione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" \nng-click=\"clear(\'statoMonitoraggio\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\"><md-select ng-model=\"vm.selected[\'tipAccoglienza[]\']\" \nplaceholder=\"Tipologia Progetto...\" name=\"tipaccoglienza\" ng-change=\"disableCheckbox(\'tipAccoglienza\')\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"tipAccoglienza in vm.tipAccoglienza\" value=\"{{tipAccoglienza.id}}\">\n<small><b style=\"text-transform: uppercase\">{{tipAccoglienza.descrizione}}</b></small></md-option></md-select>\n<md-button class=\"md-icon-button\" ng-click=\"clear(\'tipaccoglienza\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\">\n</md-icon></md-button></div></md-card-content><div layout=\"row\" layout-align=\"space-around\"><md-input-container>\n<md-select ng-model=\"vm.selected[\'periodoMonitoraggioId[]\']\" name=\"periodoMonitoraggioId\" multiple=\"multiple\" \nplaceholder=\"Periodo monitoraggio...\"><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">\nSeleziona tutti</b></small></md-option><md-option ng-value=\"key\" ng-repeat=\"(key, periodo) in vm.semestri\"><small><b \nstyle=\"text-transform: uppercase\">{{periodo}}</b></small></md-option><md-option ng-value=\"key\" \nng-repeat=\"(key, periodo) in vm.quadrimestri\"><small><b style=\"text-transform: uppercase\">{{periodo}}</b></small>\n</md-option></md-select></md-input-container><md-input-container><md-select ng-model=\"vm.selected[\'anno[]\']\" \nplaceholder=\"Anno monitoraggio...\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"anno in vm.anniMonitoraggio\" value=\"{{anno}}\"><small><b style=\"text-transform: uppercase\">{{anno}}</b>\n</small></md-option></md-select></md-input-container><md-radio-group ng-model=\"vm.selected.tipoMonitoraggio\">\n<md-radio-button value=\"qualitativo\" class=\"md-primary\">Qualitativo</md-radio-button><md-radio-button \nvalue=\"amministrativo\" class=\"md-primary\">Amministrativo</md-radio-button><md-radio-button value=\"congiunto\" \nclass=\"md-primary\">Congiunto</md-radio-button><md-radio-button value=\"\" class=\"md-primary\">Tutti</md-radio-button>\n</md-radio-group></div></md-card></div><div layout=\"row\" layout-align=\"end\"><md-button ng-click=\"search()\" \nstyle=\"background-color: #0e90d2;color: white\">Cerca</md-button></div><md-card><md-card-content><span \nng-show=\"vm.dati == null && !vm.progress\">Premere il tasto cerca per visualizzare i risultati</span><div layout=\"row\" \nlayout-sm=\"column\" ng-show=\"vm.progress\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"vm.dati != null\"><md-toolbar class=\"md-table-toolbar md-default\"><md-button \nclass=\"md-icon-button\" ng-click=\"exportcsv()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button></md-toolbar><md-table-container><table data-md-table \nmd-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head><tr md-r><th ng-repeat=\"key in vm.keyNames\" md-column>\n{{key | uppercase}}</th></tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\" \nng-if=\"vm.tipoReport != \'reportsalnuovo\'\"><td md-cell style=\"text-align:left;padding-right:4px;padding-left:4px\" \nng-repeat=\"key in vm.keyNames\">{{riga[key] || vm.nullValue}}</td></tr><tr md-row class=\"md-grey-200-bg\" \nng-repeat=\"riga in vm.dati\" ng-if=\"vm.tipoReport == \'reportsalnuovo\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key]}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.meta.perPage\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.meta.currentPage\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"paginate\" md-page-select md-label=\"{ page: \'Pagina:\', rowsPerPage: \'Righe per pagina:\', of: \'di\'}\" \nmd-boundary-links=\"vm.options.boundaryLinks\"></md-table-pagination></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/sprardb/report/reportMinistero.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\" \nlayout=\"row\"><md-card flex=\"50\"><md-card-content><form name=\"vm.reportForm\" novalidate><div><div layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.reportBeneficiario\"><md-select style=\"padding-right: 30px\" \nng-model=\"vm.selected[\'tipBeneficiario[]\']\" placeholder=\"Tipologia ingresso protetto...\" name=\"tipbeneficiario\" \nrequired flex><md-option ng-repeat=\"tipB in vm.tipBeneficiario | filter:tipologieBReportMinistero\" value=\"{{tipB.id}}\">\n<small><b style=\"text-transform: uppercase\">{{tipB.descrizione}}</b></small></md-option></md-select><md-select \nstyle=\"width: 90%\" ng-model=\"vm.selected[\'nazione[]\']\" placeholder=\"Nazionalità...\" name=\"nazione\" \nng-change=\"disableCheckbox(\'nazione\')\" multiple=\"multiple\" flex><md-option \nng-repeat=\"nazione in vm.nazioni | filter : nazioniReportMinistero\" value=\"{{nazione.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{nazione.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'nazione\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div></div><md-input-container><label>Da</label><md-datepicker ng-model=\"vm.dateSelezionate.dataDa\" \nmd-placeholder=\"Da...\" md-max-date=\"vm.controlDa\" ng-change=\"checkDate(\'da\')\" flex></md-datepicker>\n</md-input-container><md-input-container><label>A</label><md-datepicker ng-model=\"vm.dateSelezionate.dataA\" \nmd-placeholder=\"A...\" md-min-date=\"vm.controlA\" ng-change=\"checkDate(\'a\')\" flex></md-datepicker></md-input-container>\n<div layout=\"row\" layout-align=\"end\"><md-button ng-click=\"search()\" class=\"md-button md-accent md-raised\" \nng-disabled=\"vm.reportForm.$invalid || vm.reportForm.$pristine\">Cerca</md-button></div></form></md-card-content>\n</md-card></div><md-card><md-card-content><span ng-show=\"vm.dati == null && !vm.progress\">\nInserire i dati e premere il tasto cerca per visualizzare i risultati</span><div layout=\"row\" layout-sm=\"column\" \nng-show=\"vm.progress\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-show=\"vm.dati != null\"><md-toolbar class=\"md-table-toolbar md-default\"><md-button class=\"md-icon-button\" \nng-click=\"exportcsv()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button></md-toolbar><md-table-container><table data-md-table \nmd-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head><tr md-r><th ng-repeat=\"key in vm.keyNames\" md-column \nstyle=\"padding-right:4px;padding-left:4px\" ng-show=\"true\">{{key | uppercase}}</th></tr></thead><tbody md-body><tr \nmd-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key] || vm.nullValue}}\n</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.meta.perPage\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.meta.currentPage\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"paginate\" md-page-select md-label=\"{ page: \'Pagina:\', rowsPerPage: \'Righe per pagina:\', of: \'di\'}\" \nmd-boundary-links=\"vm.options.boundaryLinks\"></md-table-pagination></div></md-card-content></md-card></div>");
$templateCache.put("app/main/sprardb/report/reportMonitoraggio.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" ng-style=\"{\'overflow\':\'scroll\'}\"><div id=\"search\"><div \nlayout=\"row\"><md-card flex><md-card-content><div layout=\"row\" layout-align=\"start center\"><md-select \nng-model=\"vm.selected[\'bandi[]\']\" placeholder=\"Categorie...\" name=\"bandi\" ng-change=\"disableCheckbox(\'bandi\')\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"bando in vm.bandi\" value=\"{{bando.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{bando.descrizione}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'bandi\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" ng-model=\"vm.selected[\'regioni[]\']\" \nplaceholder=\"Regioni...\" name=\"regioni\" ng-change=\"filtraprovincia()\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"regione in vm.regioni\" value=\"{{regione.id}}\"><small><b style=\"text-transform: uppercase\">\n{{regione.regione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'regioni\')\" \naria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button><md-select layout=\"row\" \nng-model=\"vm.selected[\'province[]\']\" placeholder=\"Provincia...\" name=\"province\" ng-change=\"filtraprogetto()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"provincia in vm.province\" value=\"{{provincia.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{provincia.provincia}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'province\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select layout=\"row\" \nng-model=\"vm.selected[\'progetti[]\']\" placeholder=\"Progetto...\" name=\"progetti\" ng-change=\"filtraente()\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\"><small><b \nstyle=\"text-transform: uppercase\">{{progetto.nome}}</b></small></md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"clear(\'progetti\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-select ng-model=\"vm.selected[\'enti[]\']\" \nplaceholder=\"Ente Titolare...\" name=\"enti\" ng-change=\"disableCheckbox(\'enti\')\" multiple=\"multiple\" flex><md-option \nvalue=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"ente in vm.enti\" value=\"{{ente.id}}\"><small><b style=\"text-transform: uppercase\">{{ente.nome}}</b></small>\n</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"clear(\'enti\')\" aria-label=\"Reset\"><md-icon \nclass=\"icon-cancel\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\"!vm.api.isVisitatore\"><md-select ng-model=\"vm.selected[\'statoDettaglio[]\']\" placeholder=\"Stato Checklist...\" \nname=\"statoMonitoraggio\" multiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b \nstyle=\"text-transform: uppercase\">Seleziona tutti</b></small></md-option><md-option \nng-repeat=\"statoMonitoraggio in vm.statoMonitoraggio  | filter:{gruppo:\'STATO-DETTAGLIO\'}\" \nvalue=\"{{statoMonitoraggio.id}}\" ng-selected=\"statoMonitoraggio.id == 17\"><small><b style=\"text-transform: uppercase\">\n{{statoMonitoraggio.descrizione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" \nng-click=\"clear(\'statoMonitoraggio\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\" ng-show=\"!vm.api.isVisitatore\"><md-select \nng-model=\"vm.selected[\'statoMonitoraggio[]\']\" placeholder=\"Stato visita...\" name=\"statoMonitoraggio\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option \nng-repeat=\"statoMonitoraggio in vm.statoMonitoraggio  | filter:{gruppo:\'STATO\'}:true\" value=\"{{statoMonitoraggio.id}}\" \nng-selected=\"[3,4,5].includes(statoMonitoraggio.id)\"><small><b style=\"text-transform: uppercase\">\n{{statoMonitoraggio.descrizione}}</b></small></md-option></md-select><md-button class=\"md-icon-button\" \nng-click=\"clear(\'statoMonitoraggio\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\"><md-select ng-model=\"vm.selected[\'tipAccoglienza[]\']\" \nplaceholder=\"Tipologia Progetto...\" name=\"tipaccoglienza\" ng-change=\"disableCheckbox(\'tipAccoglienza\')\" \nmultiple=\"multiple\" flex><md-option value=\"Seleziona tutti\"><small><b style=\"text-transform: uppercase\">Seleziona tutti\n</b></small></md-option><md-option ng-repeat=\"tipAccoglienza in vm.tipAccoglienza\" value=\"{{tipAccoglienza.id}}\">\n<small><b style=\"text-transform: uppercase\">{{tipAccoglienza.descrizione}}</b></small></md-option></md-select>\n<md-button class=\"md-icon-button\" ng-click=\"clear(\'tipaccoglienza\')\" aria-label=\"Reset\"><md-icon class=\"icon-cancel\">\n</md-icon></md-button></div></md-card-content><div layout=\"row\" layout-align=\"space-around\"><md-input-container><label>\nDa</label><md-datepicker ng-model=\"vm.dateSelezionate.dataDa\" md-placeholder=\"Da...\" md-max-date=\"vm.controlDa\" \nng-change=\"checkDate(\'da\')\"></md-datepicker></md-input-container><md-input-container><label>A</label><md-datepicker \nng-model=\"vm.dateSelezionate.dataA\" md-placeholder=\"A...\" md-min-date=\"vm.controlA\" ng-change=\"checkDate(\'a\')\">\n</md-datepicker></md-input-container><md-radio-group ng-model=\"vm.selected.tipoMonitoraggio\"><md-radio-button \nvalue=\"qualitativo\" class=\"md-primary\">Qualitativo</md-radio-button><md-radio-button value=\"amministrativo\" \nclass=\"md-primary\">Amministrativo</md-radio-button></md-radio-group></div></md-card></div><div layout=\"row\" \nlayout-align=\"end\"><md-button ng-click=\"search()\" style=\"background-color: #0e90d2;color: white\">Cerca</md-button>\n</div><md-card><md-card-content><span ng-show=\"vm.dati == null && !vm.progress\">\nPremere il tasto cerca per visualizzare i risultati</span><div layout=\"row\" layout-sm=\"column\" ng-show=\"vm.progress\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.dati != null\"><md-toolbar class=\"md-table-toolbar md-default\"><md-button class=\"md-icon-button\" \nng-click=\"exportcsv()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button></md-toolbar><md-table-container><table data-md-table \nmd-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head><tr md-r><th ng-repeat=\"key in vm.keyNames\" md-column>\n{{key | uppercase}}</th></tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\" \nng-if=\"vm.tipoReport != \'reportchecklistmonitoraggio\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key] || vm.nullValue}}\n</td></tr><tr md-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.dati\" \nng-if=\"vm.tipoReport == \'reportchecklistmonitoraggio\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">{{riga[key]}}</td></tr><tr \nmd-row class=\"md-grey-500-bg\" ng-if=\"vm.tipoReport == \'prorogheLavorate\'\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyNames\">\n{{vm.totale[key] || vm.nullValue}}</td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.meta.perPage\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.meta.currentPage\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"paginate\" md-page-select \nmd-label=\"{ page: \'Pagina:\', rowsPerPage: \'Righe per pagina:\', of: \'di\'}\" md-boundary-links=\"vm.options.boundaryLinks\">\n</md-table-pagination></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/sprardb/report/rservizi.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" style=\"cursor: pointer\"><i \nng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/rstrutturatemplate.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\" ng-show=\"false\"><td md-cell \nng-repeat=\"(colonna,v) in vm.strutturadati\" style=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div\n layout=\"column\" ng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" \nstyle=\"cursor: pointer\"><i ng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/rstrutture.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiari\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar></md-card><md-card style=\"padding-top:16px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>{{vm.datas.titolo}}</b></small></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(vm.beneficiari, colonna)\" style=\"cursor: pointer\"><i \nng-class=\"{\'icon-grid\': !(vm.raggruppato),\'icon-grid-off\': (vm.raggruppato)}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[colonna] = !vm.strutturadati[colonna]\" style=\"cursor: pointer\" ng-if=\"!(vm.raggruppato)\"><i \nclass=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC</b></small></span></div></td></tr><tr \nmd-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" ng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell \nstyle=\"text-left;padding-right:4px;padding-left:4px\" ng-repeat=\"(colonna,v) in vm.strutturadati\" ng-show=\"v\"><div \nlayout=\"row\"><span ng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato)\"><td md-cell ng-repeat=\"(colonna,v) in vm.strutturadati\" \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-show=\"v\"><div layout=\"column\" \nng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(vm.beneficiari, \'cnt\')}}</b></big></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" ng-if=\"vm.searched\"></md-table-pagination>\n</md-card></div></div></div>");
$templateCache.put("app/main/sprardb/report/schedaMonitoraggioMC.html","<div id=\"report\"><div style=\"align: center\"><div layout=\"column\"><div layout=\"row\"><md-select style=\"width: 50%\" \nlayout=\"row\" ng-model=\"vm.selected[\'progetti\']\" placeholder=\"Progetto...\" name=\"progetti\"><md-option \nng-repeat=\"progetto in vm.progetti\" value=\"{{progetto.id}}\"><small><b style=\"text-transform: uppercase\">\n{{progetto.nome}}</b></small></md-option></md-select><md-input-container \nstyle=\"width: 3% ; margin-top: 10px; margin-left: 20px\" layout=\"row\"><md-checkbox ng-change=\"cambiaProgetti()\" \nng-model=\"vm.attivo\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div></div>\n<md-input-container><label>Anno</label><input type=\"year\" ng-model=\"vm.anno\" placeholder=\"Anno\" maxlength=\"4\" \nminlength=\"4\"></md-input-container><md-select style=\"width: 50%\" layout=\"row\" ng-model=\"vm.selected[\'periodo\']\" \nplaceholder=\"Periodo\" name=\"progetti\"><md-option ng-repeat=\"periodo in vm.periodi\" value=\"{{periodo}}\"><small><b \nstyle=\"text-transform: uppercase\">{{periodo}}</b></small></md-option></md-select><md-button ng-click=\"search()\" \nstyle=\"background-color: #0e90d2;color: white\">Cerca</md-button></div><div id=\"exportthis\" ng-show=\"vm.nome != null\">\n<md-button ng-click=\"exportPdf()\" style=\"background-color: darkred;color: white\">Esporta PDF</md-button><header \nstyle=\"text-align: center;border: 2px #0000ee\"><h3>Scheda di Monitoraggio</h3><h5 style=\"margin-top: -15px\">\nProgetto territoriale di <strong>{{vm.nome}}</strong></h5><h5 style=\"margin-top: -18px\">\nScheda riassuntiva sui servizi erogati dal {{vm.dataDa}} al {{vm.dataA}}</h5></header><div \nstyle=\"text-align: center;margin-right: 80px;margin-left: 80px\"><p><strong>Presenza Beneficiari</strong></p>\n<md-table-container><table data-md-table md-progress=\"promise\"><thead fix-head ng-show=\"true\" md-head>-<tr md-r><th \nmd-column style=\"padding-right:4px;padding-left:4px\" ng-show=\"true\"></th><th md-column \nstyle=\"padding-right:4px;padding-left:4px\" ng-show=\"true\"><strong>Numero Beneficiari Accoglienza Interna</strong></th>\n</tr></thead><tbody md-body><tr md-row class=\"md-grey-200-bg\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\"><strong>Posti Progetto Totali</strong></td><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\">{{vm.postiTot}}</td></tr><tr md-row class=\"md-grey-200-bg\">\n<td md-cell style=\"text-align:left;padding-right:4px;padding-left:4px\"><strong>Presenza nella finestra temporale\n</strong></td><td md-cell style=\"text-align:left;padding-right:4px;padding-left:4px\">{{vm.accolti}}</td></tr></tbody>\n</table></md-table-container></div><div style=\"text-align: center;margin-right: 80px;margin-left: 80px\"><p><strong>\nPresenza per Tipo di Soggiorno</strong></p><md-table-container><table data-md-table md-progress=\"promise\"><thead \nfix-head ng-show=\"true\" md-head><tr md-r><th ng-repeat=\"key in vm.keyTipoSoggiorno\" md-column \nstyle=\"padding-right:4px;padding-left:4px\" ng-show=\"true\">{{key | uppercase}}</th></tr></thead><tbody md-body><tr \nmd-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.tipoSoggiorno\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyTipoSoggiorno\">{{riga[key]}}</td>\n</tr></tbody><tfoot><tr md-row class=\"md-grey-400-bg\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\"><strong>Totale :</strong></td><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\">{{vm.totalTipoSoggiorno}}</td></tr></tfoot></table>\n</md-table-container></div><div style=\"text-align: center;margin-right: 80px;margin-left: 80px\"><p><strong>\nElenco Servizi Erogati</strong></p><md-table-container><table data-md-table md-progress=\"promise\"><thead fix-head \nng-show=\"true\" md-head><tr md-r><th ng-repeat=\"key in vm.keyCorsiServizi\" md-column \nstyle=\"padding-right:4px;padding-left:4px\" ng-show=\"true\">{{key | uppercase}}</th></tr></thead><tbody md-body><tr \nmd-row class=\"md-grey-200-bg\" ng-repeat=\"riga in vm.corsiServizi\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\" ng-repeat=\"key in vm.keyCorsiServizi\">{{riga[key]}}</td>\n</tr></tbody><tfoot><tr md-row class=\"md-grey-400-bg\"><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\"><strong>Totale :</strong></td><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\"></td><td md-cell \nstyle=\"text-align:left;padding-right:4px;padding-left:4px\">{{vm.totCorsiServizi}}</td></tr></tfoot></table>\n</md-table-container></div></div></div>");
$templateCache.put("app/main/sprardb/report/schedamonitoraggio.html","<div id=\"report\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/report/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.datas.titolo}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-card \nstyle=\"padding-top:16px\" ng-if=\"!vm.beneficiariProgetto\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>Scheda monitoraggio progetto</b></small>\n</div></md-toolbar></md-card><md-card style=\"padding-top:16px\" \nng-repeat=\"(parentindex,beneficiariprogetto) in vm.beneficiariProgetto track by $index\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start start\"><small><b>\nScheda monitoraggio progetto {{vm.listaProgetti[parentindex].nomeProgetto}}</b></small> <small>\nPeriodo: {{vm.tempdata.dataIngresso|date:\'dd/MM/yyyy\'}} - {{vm.tempdata.dataUscita|date:\'dd/MM/yyyy\'}}</small> <small>\nPresenze nel periodo: {{vm.presenzenelperiodo}} su Posti totali: {{vm.listaProgetti[parentindex].progettostarts.postiTotali}}\n</small></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.searched\" ng-show=\"false\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente(parentindex)\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.reportexport\" report-fields=\"vm.reportcampi\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container ng-if=\"vm.searched\"><table \ndata-md-table data-md-row-select=\"false\" data-ng-model=\"vm.selected\" md-progress=\"vm.beneficiari\" multiple=\"false\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column ng-repeat=\"(colonna,v) in vm.strutturadati[parentindex]\" md-order-by=\"{{colonna}}\" \nstyle=\"text-align:left;padding-right:4px\" ng-show=\"v\">{{(vm.leggibile(colonna)) | uppercase}}</th></tr></thead><tbody \nmd-body><tr md-row class=\"md-grey-200-bg\" ng-if=\"!vm.raggruppato[parentindex]\"><td md-cell \nng-repeat=\"(colonna,v) in vm.strutturadati[parentindex]\" style=\"text-align:left;padding-right:4px\" ng-show=\"v\"><div \nlayout=\"column\" ng-if=\"!(colonna === \'cnt\')\"><span ng-click=\"vm.groupby2(beneficiariprogetto, parentindex, colonna)\" \nstyle=\"cursor: pointer\"><i \nng-class=\"{\'icon-grid\': !(vm.raggruppato[parentindex]),\'icon-grid-off\': (vm.raggruppato[parentindex])}\" class=\"s12\" \ntitle=\"Raggruppa per campo {{colonna}}\"></i> <small><b>GRUP</b></small></span> <span \nng-click=\"vm.strutturadati[parentindex][colonna] = !vm.strutturadati[parentindex][colonna]\" style=\"cursor: pointer\" \nng-if=\"!(vm.raggruppato[parentindex])\"><i class=\"icon-eye s12\" title=\"Nascondi campo {{colonna}}\"></i> <small><b>NASC\n</b></small></span></div></td></tr><tr md-row md-select=\"beneficiario\" md-select-id=\"beneficiario\" \nng-repeat=\"beneficiario in beneficiariprogetto\"><td md-cell style=\"text-left;padding-right:4px\" \nng-repeat=\"(colonna,v) in vm.strutturadati[parentindex]\" ng-show=\"v\"><div layout=\"row\"><span \nng-if=\"!(colonna.startsWith(\'data\'))\"><b>{{beneficiario[colonna]|uppercase}}</b></span> <span \nng-if=\"(colonna.startsWith(\'data\'))\">{{beneficiario[colonna]|date: \"dd/MM/yyyy\"}}</span></div></td></tr><tr md-row \nclass=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato[parentindex])\"><td md-cell \nng-repeat=\"(colonna,v) in vm.strutturadati[parentindex]\" style=\"text-align:left;padding-right:4px\" ng-show=\"v\"><div \nlayout=\"column\" ng-if=\"(colonna === \'cnt\')\"><big><b>{{vm.somma(beneficiariprogetto, \'cnt\')}}</b></big></div></td></tr>\n<tr class=\"md-blue-grey-200-bg\" md-row ng-if=\"(vm.raggruppato[parentindex])\"><td md-cell colspan=\"2\"><div \nlayout=\"column\"><b>ELENCO SERVIZI ATTIVATI NEL PERIODO</b></div></td></tr><tr md-row \nng-repeat=\"(k,se) in vm.servizierogati\" ng-if=\"(vm.raggruppato[parentindex])\"><td md-cell \nstyle=\"text-align:left;padding-right:4px\"><div layout=\"column\"><span><b>{{k|uppercase}}</b></span></div></td><td \nmd-cell style=\"text-align:left;padding-right:4px\"><div layout=\"column\"><span>{{se.length}}</span> <span><small \nng-repeat=\"b in se track by $index\">{{b.beneficiario_id}},<br ng-if=\"($index % 15 == 0)\"></small></span></div></td>\n</tr><tr md-row class=\"md-grey-200-bg\" ng-if=\"(vm.raggruppato[parentindex])\"><td md-cell></td><td md-cell><div \nlayout=\"row\"><big><b>{{vm.tservizierogati}}</b></big></div></td></tr><tr md-row ng-if=\"(vm.raggruppato[parentindex])\">\n<td md-cell><b>{{vm.listaProgetti[parentindex].nomeProgetto}},&nbsp;{{vm.oggi| date: \'dd/MM/yyyy\'}}</b></td><td \nmd-cell><b>FIRMA</b></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\" \nng-if=\"vm.searched\" ng-show=\"false\"></md-table-pagination></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/segnalatori/segnalatori.html","<div id=\"segnalatori\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Segnalatori</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nelle persone\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca Segnalatori (persona fisica)</b></small><div layout=\"row\" \nng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"(key != \'operatore\' && key != \'personahasentes-personaRuolo_id_IN\')\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"refresh\"><i class=\"icon-refresh s18\"></i></md-button></div>\n</md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\">\n<div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'segnalatori selezionati\' : \'segnalatore selezionato\'}} :</span><div \nflex></div><md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.attivalogin(vm.selected)\"><i class=\"icon-check-bookmark s16\"></i> ATTIVA/DISATTIVA</md-button><md-button \nclass=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" ng-click=\"vm.cambiapassword(vm.selected, $event)\"><i \nclass=\"icon-key-change s16\"></i> CAMBIA PASSWORD</md-button></div></md-toolbar><md-table-container><table \ndata-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column style=\"text-align:center\">LOGIN</th><th md-column \nmd-order-by=\"cognome\">COGNOME</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\">\n<span>CITTA</span></th><th md-column md-order-by=\"email\">RECAPITI</th><th md-column>ENTE</th><th md-column \nstyle=\"text-align: center\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \ndata-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.entes\" \nng-disabled=\"!((vm.api.isAdmin || vm.api.isAccoglienza) || (vm.api.isSegnalatore && item.id === vm.apiuser.persona_id) || item.attivo > 0)\">\n<td md-cell><span layout=\"column\"><span class=\"text-boxed md-primary-bg md-light-green-600-bg\" \nng-if=\"(item.utentes[0].status === 10)\"><b>ATTIVO</b></span> <span class=\"text-boxed md-primary-bg md-red-700-bg\" \nng-if=\"(item.utentes[0].status === 0)\"><b>DISATTIVO</b></span> <span class=\"text-boxed\" ng-if=\"(!item.utentes[0])\"><b>\nNO</b></span></span></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.residenza.comune| uppercase}}</b><br>{{item.residenza.provincia| uppercase}}</td><td md-cell><span \nlayout=\"column\" layout-align=\"start start\"><span><b><a title=\"{{item.email}}\" href=\"mailto:{{item.email}}\">\n{{item.email|limitTo:25}}<span ng-if=\"(item.email.length > 25)\">...</span></a></b></span> <span>{{item.telefono}}\n</span></span></td><td md-cell><div ng-repeat=\"subitem in item.entes\" layout=\"column\"><span><small><b>\n{{subitem.nome|uppercase}}</b></small></span> <span ng-if=\"subitem.segnalatore == 1\" class=\"text-italic\"><small>\n(ENTE SEGNALATORE)</small></span> <span ng-if=\"subitem.segnalatore == 0\" class=\"text-italic\"><small>(PROGETTO)</small>\n</span></div></td><td md-cell style=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-menu \nng-if=\"((vm.api.isAdmin || vm.api.isAccoglienza) || (vm.api.isSegnalatore && item.id === vm.apiuser.persona_id))\">\n<md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"aSegnalatore\" ui-sref=\"app.sprardb_segnalatoridettaglio({id:item.id})\"><md-icon \nmd-font-icon=\"icon-human-child\"></md-icon><span>Apri segnalatore</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"DatiAutenticazione\" ng-click=\"vm.cambiapassword(item, $event)\"><md-icon \nmd-font-icon=\"icon-key-change\"></md-icon><span>Cambia password</span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"attivaDisattiva\" ng-click=\"vm.attivalogin(item)\"><md-icon md-font-icon=\"icon-check-bookmark\">\n</md-icon><span>Attiva/Disattiva Autenticazione</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/statusg/statusg-details.html","<div id=\"contacts\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/statusg/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</span><div class=\"subtitle secondary-text\">\n<span>Gestione Status Giuridico</span></div></div></div></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button layout=\"row\" layout-align=\"start center\">\n<span class=\"small\"><i class=\"icon icon-arrow-left s14\"></i> Indietro</span></md-button></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}\n</span> <span class=\"small\">SELEZIONATO</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\">Seleziona tutti</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\">Seleziona nessuno</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll>\n<md-card style=\"padding:16px\"><h2 class=\"no-padding\"><strong>Riepilogo beneficiario</strong><md-icon \nng-click=\"vm.showdetails = !vm.showdetails\" md-font-icon=\"icon-arrow-collapse\" ng-if=\"vm.showdetails\"></md-icon>\n<md-icon ng-click=\"vm.showdetails = !vm.showdetails\" md-font-icon=\"icon-arrow-expand\" ng-if=\"!vm.showdetails\">\n</md-icon></h2><span ng-if=\"vm.showdetails\"><md-divider></md-divider><div layout=\"row\" style=\"padding-top: 16px\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label>Codice</label><input \ntype=\"text\" name=\"codie\" ng-model=\"vm.beneficiario.id\" placeholder=\"Codice\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" \nname=\"cognome\" ng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" \nname=\"nome\" ng-model=\"vm.beneficiario.nome\" placeholder=\"Nome\" required disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Sesso</label><input type=\"text\" name=\"sesso\" \nng-model=\"vm.beneficiario.sesso\" placeholder=\"Sesso\" required disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Stato</label><input type=\"text\" name=\"stato\" \nng-model=\"vm.beneficiario.stato\" placeholder=\"Stato\" required disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Data Nascita</label><input type=\"text\" name=\"datanascita\" \nng-model=\"vm.beneficiario.dataNascita\" placeholder=\"Data Nascita\" required disabled=\"disabled\"></md-input-container>\n</div></div><div layout=\"row\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label>Provenienza</label><input type=\"text\" name=\"Provenienza\" \nng-model=\"vm.beneficiario.provenienza.descrizione\" placeholder=\"Provenienza\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Nazionalita</label><input type=\"text\" \nname=\"Nazionalita\" ng-model=\"vm.beneficiario.nazionalita.descrizione\" placeholder=\"Nazionalita\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Luogo Nascita</label>\n<input type=\"text\" name=\"luogonascita\" ng-model=\"vm.beneficiario.nascita.descrizione\" placeholder=\"Luogo Nascita\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Religione\n</label><input type=\"text\" name=\"Religione\" ng-model=\"vm.beneficiario.religione.descrizione\" placeholder=\"Religione\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>\nTipo Segnalazione</label><input type=\"text\" name=\"tiposegnalazione\" ng-model=\"vm.beneficiario.tipoSegnalazione\" \nplaceholder=\"Tipo Segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Data Ingresso</label><input type=\"text\" name=\"dataingresso\" \nng-model=\"vm.beneficiario.dataIngresso\" placeholder=\"Data Ingresso\" required disabled=\"disabled\"></md-input-container>\n</div></div><div layout=\"row\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label>Data Inserimento</label><input type=\"text\" name=\"datainserimento\" \nng-model=\"vm.beneficiario.dataInserimento\" placeholder=\"Data Inserimento\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Data Uscita</label><input type=\"text\" \nname=\"datauscita\" ng-model=\"vm.beneficiario.dataUscita\" placeholder=\"Data Uscita\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo Documento</label><input type=\"text\" \nname=\"tipodocumento\" ng-model=\"vm.beneficiario.tipoDocumento.descrizione\" placeholder=\"Tipo documento\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo Ingresso</label>\n<input type=\"text\" name=\"tipoingresso\" ng-model=\"vm.beneficiario.tipoIngresso.descrizione\" placeholder=\"Tipo Ingresso\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Email</label>\n<input type=\"text\" name=\"Email\" ng-model=\"vm.beneficiario.email\" placeholder=\"Email\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Gruppo Etnico</label><input type=\"text\" \nname=\"grupopetnico\" ng-model=\"vm.beneficiario.gruppoetnico\" placeholder=\"Gruppo Etnico\" required disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex class=\"margin-bottom-0\"><label>Progetto Territoriale</label><input type=\"text\" name=\"progettoterritoriale\" \nng-model=\"vm.beneficiario.strutturas.progettos.nome\" placeholder=\"Progetto Territoriale\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Struttura</label><input type=\"text\" \nname=\"struttura\" ng-model=\"vm.beneficiario.strutturas.nome\" placeholder=\"Struttura\" required disabled=\"disabled\">\n</md-input-container></div></div></span></md-card><form name=\"newsg\" novalidate><div layout=\"row\"><md-input-container \nclass=\"md-block padding-left-16\" md-no-float flex=\"50\"><md-select name=\"tipoStatus\" \nplaceholder=\"Scegli una tipologia di processo...\" ng-model=\"vm.eventoTipo_id\" required><md-option \nng-repeat=\"item in vm.eventotipos\" ng-value=\"item.id\" ng-disabled=\"!vm.notselectable.indexOf(item.id)\"><small><b>\n{{item.nome}}</b></small></md-option></md-select><div ng-messages=\"organizationForm.enteTipo_id.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Scegliere tipo di status giuridico da creare</span></div></div></md-input-container>\n<md-button type=\"submit\" flex=\"50\" ng-hide=\"newsg.$invalid || newsg.$pristine\" class=\"md-raised md-accent md-primary\" \naria-label=\"new status\" ng-disabled=\"newsg.$invalid || newsg.$pristine\" \nng-click=\"vm.work(vm.eventoTipo_id, 1, $event, true)\">CREA STATUS GIURIDICO</md-button></div></form><md-card \nstyle=\"padding-top:0px\"><md-table-container \nng-init=\"colors = [\'md-blue-grey-200-bg\', \'md-teal-400-bg\', \'md-amber-200-bg\', \'md-grey-300-bg\', \'md-light-green-500-bg\', \'md-red-900-bg\']\">\n<table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.eventi\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column md-order-by=\"eventoTipo_id\">TIPO</th><th md-column md-order-by=\"eventoStato_id\">STATO</th><th \nmd-column md-order-by=\"dataInserimento\">RICHIESTA</th><th md-column md-order-by=\"dataAlert\">ALERT</th><th md-column \nmd-order-by=\"dataInizio\"><span>RILASCIO</span></th><th md-column md-order-by=\"dataFine\"><span>SCADENZA</span></th><th \nmd-column md-order-by=\"da\">DA</th><th md-column md-order-by=\"alert\">P</th><th md-column>AZIONE</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"item\" md-select-id=\"item\" ng-disabled=\"\" data-md-on-select=\"vm.toggleSelectContact\" \nmd-on-deselect=\"vm.deselectContacts\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.eventi\"><td \nmd-cell class=\"light-blue-900-fg font-weight-600\">{{item.eventoTipo.nome}}</td><td md-cell><md-button \nclass=\"md-fab md-mini {{colors[item.eventoStato_id]}}\" aria-label=\"status\">{{item.eventoStato.stato| limitTo:1 }}\n<md-tooltip>{{item.eventoStato.stato}}</md-tooltip></md-button></td><td md-cell>\n{{item.dataInserimento| date : \"dd/MM/y\"}}</td><td md-cell ng-if=\"item.dataAlert\">\n{{ item.dataAlert | date : \"dd/MM/y\"}}</td><td md-cell ng-if=\"!item.dataAlert\">- - -</td><td md-cell \nng-if=\"item.dataInizio\">{{item.dataInizio| date : \"dd/MM/y\"}}</td><td md-cell ng-if=\"!item.dataInizio\">- - -</td><td \nmd-cell ng-if=\"item.dataFine\">{{item.dataFine| date : \"dd/MM/y\"}}</td><td md-cell ng-if=\"!item.dataFine\">- - -</td><td \nmd-cell><a href=\"mailto:{{ item.da}}\" title=\"{{ item.da}}\">{{ item.da|limitTo:12}}...</a></td><td md-cell><md-icon \nng-if=\"item.alert\" class=\"icon-alert s16 md-amber-200-fg\" style=\"font-size:20px\"></md-icon></td><td md-cell><div \nclass=\"row\"><span ng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\'\"><md-button \nclass=\"md-fab md-mini {{colors[processo[1]]}}\" aria-label=\"changestatus\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work(item, processo[1], $event, false)\"><span \nng-repeat=\"toolt in vm.eventostatos| filter: {id: processo[1]}\">{{toolt.stato|limitTo:1}}</span><md-tooltip><span \nng-repeat=\"toolt in vm.eventostatos| filter: {id: processo[1]}\">{{toolt.stato}}</span></md-tooltip></md-button></span>\n<md-button type=\"button\" class=\"md-accent\" aria-label=\"View\" \nng-click=\"vm.work(item, item.eventoStato_id, $event, \'readonly\')\">Visualizza</md-button></div></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/statusg/statusg.html","<div id=\"contacts\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/statusg/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Ricerca Beneficiari</span></div></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button \nlayout=\"row\" layout-align=\"start center\"><span class=\"small\"><i class=\"icon icon-arrow-left s14\"></i> Indietro</span>\n</md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span class=\"small\">SELEZIONATO</span>\n</span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\">Seleziona tutti</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\">Seleziona nessuno</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei beneficiari (nome o cognome)\" type=\"text\" \nng-model=\"vm.ricerca2\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.onSearch()\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><div layout=\"row\" \nng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\">\n</md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\">\n</md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex ng-if=\"vm.allFields\">\n<md-input-container flex><label>Stato</label><md-select ng-model=\"vm.ricerca.stato\" ng-change=\"vm.onSearch()\">\n<md-option value=\"null\">Tutti</md-option><md-option value=\"LIBERO\">LIBERO</md-option><md-option \nvalue=\"PRESENZA TERRITORIO\">PRESENZA TERRITORIO</md-option><md-option value=\"BENEFICIARIO\">BENEFICIARIO</md-option>\n</md-select></md-input-container><md-input-container flex><label>Progetto Territoriale</label><md-select \nname=\"provenienza\" ng-model=\"vm.ricerca[\'strutturas-progetto_id\']\" ng-change=\"vm.onSearch()\"><md-option value=\"null\">\nTutti</md-option><md-option ng-repeat=\"prog in vm.progettos\" ng-value=\"prog.id\" \nng-selected=\"vm.ricerca[\'strutturas-progetto_id\'] == prog.id\"><strong><small>{{prog.nome}}</small></strong></md-option>\n</md-select></md-input-container><md-input-container flex><label>Struttura</label><md-select name=\"struttura\" \nng-model=\"vm.ricerca[\'strutturas-id\']\" ng-change=\"vm.onSearch()\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"prog in vm.strutturas| filter: {progetto_id:vm.ricerca[\'strutturas-progetto_id\']}\" ng-value=\"prog.id\" \nng-selected=\"vm.ricerca[\'strutturas-id\'] == prog.id\"><strong><small>{{prog.nome}}</small></strong></md-option>\n</md-select></md-input-container><md-input-container flex><label>Nazione Provenienza</label><md-select \nname=\"provenienza\" ng-model=\"vm.ricerca.idNazioneProvenienza\" ng-change=\"vm.onSearch()\"><md-option value=\"null\">Tutti\n</md-option><md-option ng-repeat=\"naz in vm.nazioni| orderBy:\'descrizione\'\" ng-value=\"naz.id\" \nng-selected=\"vm.ricerca.idNazioneProvenienza == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex ng-if=\"vm.allFields\"><md-input-container flex><label>\nEntrati Prima del</label><md-select ng-model=\"vm.ricerca.dataIngresso\" ng-change=\"vm.onSearch()\"><md-option \nvalue=\"null\">Tutti</md-option><md-option \nng-repeat=\"anno in [2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007]\" value=\"<{{anno}}-12-31\">{{anno}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Nati Prima del</label><md-select \nng-model=\"vm.ricerca.dataNascita\" ng-change=\"vm.onSearch()\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"anno in [2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2000, 1999]\" \nvalue=\"<{{anno}}-12-31\">{{anno}}</md-option></md-select></md-input-container><md-input-container flex><label>Sesso\n</label><md-select ng-model=\"vm.ricerca.sesso\" ng-change=\"vm.onSearch()\"><md-option value=\"null\">Tutti</md-option>\n<md-option value=\"M\">MASCHIO</md-option><md-option value=\"F\">FEMMINA</md-option></md-select></md-input-container>\n<md-button ng-click=\"vm.searchEmpty();\"><small>svuota</small></md-button></div><md-card style=\"padding-top:0px\">\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" \nmd-progress=\"vm.beneficiari\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"stato\">STATO</th><th md-column>DOCUM</th><th \nmd-column md-order-by=\"cognome\"><span>COGNOME</span></th><th md-column md-order-by=\"nome\">NOME</th><th md-column>\nNAZIONE</th><th md-column>PROGETTO</th><th md-column>STRUTTURA</th><th md-column>INSERIMENTO</th><th md-column>USCITA\n</th><th md-column>AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" \nmd-select-id=\"beneficiario\" ng-disabled=\"\" data-md-on-select=\"vm.toggleSelectContact\" \nmd-on-deselect=\"vm.deselectContacts\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"beneficiario in vm.beneficiari\"><td md-cell><md-button ng-if=\"beneficiario.stato == \'LIBERO\'\" \nclass=\"md-fab md-mini md-light-green-400-bg\" aria-label=\"status\">L<md-tooltip><span>{{beneficiario.stato}}</span>\n</md-tooltip></md-button><md-button ng-if=\"beneficiario.stato == \'BENEFICIARIO\'\" class=\"md-fab md-mini\" \naria-label=\"status\">B<md-tooltip><span>{{beneficiario.stato}}</span></md-tooltip></md-button><md-button \nng-if=\"beneficiario.stato == \'PRESENZA TERRITORIO\'\" class=\"md-fab md-mini md-amber-400-bg\" aria-label=\"status\">PT\n<md-tooltip><span>{{beneficiario.stato}}</span></md-tooltip></md-button></td><td md-cell><md-button \nng-if=\"beneficiario.idTipoDocumento == \'581\'\" class=\"md-fab md-mini md-lime-300-bg\" aria-label=\"status\">AN<md-tooltip>\n<span ng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}\">{{ item.descrizione}}</span>\n</md-tooltip></md-button><md-button ng-if=\"beneficiario.idTipoDocumento == \'582\'\" \nclass=\"md-fab md-mini md-blue-grey-500-bg\" aria-label=\"status\">PS<md-tooltip><span \nng-repeat=\"item in vm.documentotipo| filter: {id:beneficiario.idTipoDocumento}\">{{ item.descrizione}}</span>\n</md-tooltip></md-button></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{beneficiario.cognome}}</td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\">{{beneficiario.nome}}</td><td md-cell>\n{{ beneficiario.provenienza.descrizione}}</td><td md-cell><span ng-repeat=\"stru in ::beneficiario.strutturas\">\n{{ stru.progettos.nome}}</span></td><td md-cell><span ng-repeat=\"stru in ::beneficiario.strutturas\">{{ stru.nome}}\n</span></td><td md-cell>{{beneficiario.dataInserimento| date : \"dd.MM.y\"}}</td><td md-cell \nng-if=\"beneficiario.dataUscita != \'0000-00-00\'\">{{beneficiario.dataUscita| date : \"dd.MM.y\"}}</td><td md-cell \nng-if=\"beneficiario.dataUscita == \'0000-00-00\'\">---</td><td md-cell><md-button \nui-sref=\"app.sprardb_statusgricerca.edit({ id:beneficiario.id })\" class=\"md-accent md-button-icon\" \naria-label=\"View Detailed\" ng-click=\"vm.viewDetails($event, beneficiario.id)\">VAI >></md-button></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/tags/dialog_modifica_tags.html","<md-dialog aria-label=\"Visualizza tags\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>{{vmd.titolo}} collegati:</p><span class=\"text-boxed\" \nng-repeat=\"item in vmd.tags| filter: {tipo: vmd.tipotag.join()} | unique: \'id\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-tag-text-outline\"></md-icon>{{item.tag}} </span><span class=\"text-boxed\" \nng-if=\"(vmd.tags.length === 0)\">Nessun {{vmd.entita}} collegato</span><md-input-container class=\"md-block\"><label>\nScegli un/una {{vmd.entita}}</label><md-select multiple=\"multiple\" ng-model=\"vmd.selected.tags\"><md-option \nng-value=\"tag\" ng-repeat=\"tag in vmd.alltags\" \nng-selected=\"((vmd.tags | filter: {\n                        id: tag.id}).length > 0)\">{{ tag.tag}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Crea nuovo/a {{vmd.entita}}</label><input \ntype=\"text\" ng-model=\"vmd.selected.tagnew\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"vmd.cancel()\" style=\"margin-right:20px\">Annulla</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vmd.assegna()\" style=\"margin-right:20px\" \nng-disabled=\"!(vmd.selected.tags || vmd.selected.tagnew)\">Assegna</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/tags/dialog_nuovo_tags.html","<md-dialog aria-label=\"Visualizza tags\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>{{vmd.titolo}} collegati:</p><span class=\"text-boxed\" \nng-repeat=\"item in vmd.tags| filter: {tipo: vmd.tipotag.join()} | unique: \'id\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-tag-text-outline\"></md-icon>{{item.tag}} </span><span class=\"text-boxed\" \nng-if=\"(vmd.tags.length === 0)\">Nessun {{vmd.entita}} collegato</span><md-input-container class=\"md-block\"><label>\nScegli un/una {{vmd.entita}}</label><md-select multiple=\"multiple\" ng-model=\"vmd.selected.tags\"><md-option \nng-value=\"tag\" ng-repeat=\"tag in vmd.alltags\" \nng-selected=\"((vmd.tags | filter: {\n                        id: tag.id}).length > 0)\">{{ tag.tag}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Crea nuovo/a {{vmd.entita}}</label><input \ntype=\"text\" ng-model=\"vmd.selected.tagnew\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"vmd.cancel()\" style=\"margin-right:20px\">Annulla</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vmd.assegna()\" style=\"margin-right:20px\" \nng-disabled=\"!(vmd.selected.tags || vmd.selected.tagnew)\">Assegna</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/tags/dialog_visualizza_tags.html","<md-dialog aria-label=\"Visualizza tags\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><span class=\"text-boxed\" \nng-repeat=\"item in vmd.tags| filter: {tipo: vmd.tipotag.join()}\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-tag-text-outline\"></md-icon>{{item.tag}} </span><span class=\"text-boxed\" \nng-if=\"((vmd.tags | filter: {tipo: vmd.tipotag.join()}).length === 0)\">Nessun {{vmd.entita}} collegato</span>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancel()\" \nstyle=\"margin-right:20px\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/tags/listae.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Liste distribuzione enti</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Lista \"<b>{{vm.nomelista|uppercase}}</b>\"</span><div layout=\"row\" \nng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\';vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'enti selezionati\' : \'ente selezionato\'}} :</span><div flex></div>\n<md-button class=\"md-accent md-button-icon md-grey-200-bg\" ng-click=\"vm.edittags(vm.selected, [\'listaente\'])\"><i \nclass=\"icon-view-list s16\"></i> LISTA DISTRIBUZIONE</md-button><md-button \nclass=\"md-accent md-button-icon md-grey-200-bg\" ng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i \nclass=\"icon-flag-triangle s16\"></i> TAGS</md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"enteTipo_id\">\nTIPO</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\"><span>CITTA</span></th><th \nmd-column md-order-by=\"email\">RECAPITI</th><th md-column style=\"text-align: center\">AZIONE</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"item\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" \nmd-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>\n{{item.id}}</td><td md-cell><md-button class=\"md-fab md-mini {{vm.colors[item.enteTipo_id]}}\" aria-label=\"tipos\">\n{{item.entetipo.descrizione|limitTo: 1}}<md-tooltip><span>{{item.entetipo.descrizione}}</span></md-tooltip></md-button>\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.istats.comune| uppercase}}</b><br>{{item.istats.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:45}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Visualizza tags\" \nng-click=\"vm.viewtags(item.tags, [\'generico\'])\"><md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>\nVisualizza tags</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Visualizza lista\" \nng-click=\"vm.viewtags(item.tags, [\'listaente\'])\"><md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>\nVisualizza lista</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/tags/listap.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Liste distribuzione persone</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nelle liste\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch()\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Persona</span><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\';vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>\nPrepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-json-export-excel \ndata=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'persone selezionate\' : \'persona selezionata\'}} :</span><div flex>\n</div><md-button class=\"md-accent md-button-icon md-grey-200-bg\" ng-click=\"vm.edittags(vm.selected, [\'listapersona\'])\">\n<i class=\"icon-view-list s16\"></i> LISTA DISTRIBUZIONE</md-button><md-button \nclass=\"md-accent md-button-icon md-grey-200-bg\" ng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i \nclass=\"icon-flag-triangle s16\"></i> TAGS</md-button></div></md-toolbar><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column>TIPO</th><th md-column \nmd-order-by=\"cognome\">COGNOME</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\">\n<span>CITTA</span></th><th md-column md-order-by=\"email\">RECAPITI</th><th md-column style=\"text-align: center\">NR PROG\n</th><th md-column style=\"text-align: center\">NR ENTE</th><th md-column style=\"text-align: center\">NR RUOLI</th><th \nmd-column style=\"text-align: center\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell \nstyle=\"text-align: center\"><i class=\"icon-account-key\" style=\"line-height: 32px\" ng-if=\"item.users\"></i></td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>\n{{item.residenza.comune| uppercase}}</b><br>{{item.residenza.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}...</a><br>{{item.telefono}}</td><td \nmd-cell style=\"text-align: center\">{{ (item.personahasprogettos | unique: \'progetto_id\').length}}</td><td md-cell \nstyle=\"text-align: center\">{{(item.personahasentes| unique: \'ente_id\').length}}</td><td md-cell \nstyle=\"text-align: center\">{{(item.personahasprogettos| unique: \'personaRuolo_id\').length}}</td><td md-cell \nstyle=\"text-align: right; padding-right: 0px\"><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-button-small\" aria-label=\"View Detailed\" ng-click=\"vm.gotoDettaglio(item.id)\"><i \nclass=\"icon-arrow-right-bold-circle s30\"></i></md-button><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Visualizza tags\" ng-click=\"vm.viewtags(item.tags, [\'generico\'])\">\n<md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza tags</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.viewtags(item.tags, [\'listapersona\'])\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"></md-icon><span>Visualizza lista</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/tags/tags.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/entes/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Liste distribuzione</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nelle liste\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                            debounce: 500\n                            }\" ng-change=\"vm.onSearch()\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-button \nng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button \nng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Ricerca Liste</span><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\">\n</md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.deletefiltersearch(key)\"></md-icon>{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}\n</span></div><div flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i \nclass=\"icon-file-excel light-green-900-fg s18\"></i><md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-json-export-excel data=\"vm.entesexport\" report-fields=\"vm.entesfileds\" \nng-disabled=\"(!vm.preparati)\"><i class=\"icon-download s18\" \nng-class=\"{\n                                        \'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\">\n</i><md-tooltip>Scarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar \nclass=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'liste selezionate\' : \'lista selezionata\'}} :</span><div flex></div>\n</div></md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.entes\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"tipo\" style=\"text-align: center\">TIPO</th><th md-column \nmd-order-by=\"tag\">NOME TAG</th><th md-column style=\"text-align: center\">NR ENTI</th><th md-column \nstyle=\"text-align: center\">NR PERSONE</th><th md-column md-order-by=\"user_id\" style=\"text-align: center\">PRIVATO</th>\n<th md-column style=\"text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.entes\"><td md-cell>{{item.id}}</td><td md-cell \nstyle=\"text-align: center\"><md-button class=\"md-fab md-mini {{vm.colors[item.tipo]}}\" aria-label=\"tipos\">\n{{item.tipo|limitTo: 1:5}}<md-tooltip><span>{{item.tipo}}</span></md-tooltip></md-button></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.tag | uppercase}}</td><td md-cell style=\"text-align: center\"><a \nng-if=\"((item.entehastags).length > 0)\" ui-sref=\"app.sprardb_listae({parametro:\'tags-tag\',valore:item.tag})\"><b>\n{{(item.entehastags).length}}</b></a> <span ng-if=\"((item.entehastags).length == 0)\">0</span></td><td md-cell \nstyle=\"text-align: center\"><a ng-if=\"((item.personahastags).length > 0)\" \nui-sref=\"app.sprardb_listap({parametro:\'tags-tag\',valore:item.tag})\"><b>{{(item.personahastags).length}}</b></a> <span \nng-if=\"((item.personahastags).length == 0)\">0</span></td><td md-cell style=\"text-align: center\"><md-icon \nclass=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"(item.user_id == 0)\"></md-icon><md-icon \nclass=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"(item.user_id > 0)\"></md-icon></td><td md-cell \nstyle=\"text-align: right; padding-right: 0px\"><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-button-icon md-button-small\" aria-label=\"View Detailed\" ng-click=\"vm.deletetag(item)\" \nng-disabled=\"((item.personahastags).length > 0 || (item.entehastags).length > 0)\"><i class=\"icon-trash s24\"></i>\n</md-button><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Dettaglio\" ui-sref=\"app.sprardb_listae({parametro:\'tags-tag\',valore:item.tag})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Apri lista (persone)</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Dettaglio2\" ui-sref=\"app.sprardb_listap({parametro:\'tags-tag\',valore:item.tag})\">\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><span>Apri lista (enti)</span></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"View Detailed\" ng-click=\"vm.deletetag(item)\" \nng-disabled=\"((item.personahastags).length > 0 || (item.entehastags).length > 0)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><span>Cancella Lista</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/test/test.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/sprardb/test/test0.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Pagina test</h2></div>");
$templateCache.put("app/main/sprardb/userprofile/userprofile.html","<div id=\"userprofile\" class=\"page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Apri barra\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll></div></div>");
$templateCache.put("app/main/sprardb/video/video.html","<div id=\"video\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nVideo Tutorial</span></div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll>\n<div class=\"main\" ms-scroll><md-card style=\"padding-top:0px;padding-bottom:32px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><span>Guarda i Video Tutorial</span></div></md-toolbar><div layout=\"row\" class=\"rwd-video\">\n<iframe ng-src=\"{{ vm.videoid | youtubeEmbedUrl }}\" allowfullscreen=\"\" frameborder=\"0\"></iframe></div></md-card></div>\n</div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"end end\"><md-icon class=\"fold-toggle s18 black-fg\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></div></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\" root=\"{{vm.root}}\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/dialogs/dialogTrasferimenti.html","<md-dialog id=\"confermaDialog\" class=\"add-dialog\" style=\"width: 95%; height: 95%\" aria-label=\"\" ms-scroll><form \nname=\"ticketForm\" novalidate class=\"padding-16\" id=\"formTick\"><md-dialog-content class=\"padding-0\"><div \nlayout=\"column\"><h3 class=\"margin-top-0\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon><b>\nRichiedi Trasferimento In Banca Dati</b></h3><p>\nCompilare il form sottostante per richiedere il trasferimento in banca dati del beneficiario che ha fatto ingresso nel vostro progetto a fronte di una lettera di trasferimento ricevuta dal Servizio Centrale. Indicare nel campo note numero di protocollo e data della lettera.\n</p><div layout=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                            \'md-warn-fg\'\n                            : (ticketForm.name.$invalid)}\">\nNome e Cognome</label><input type=\"text\" name=\"name\" ng-disabled=\"true\" required ng-model=\"vmd.ticketConferma.name\" \nclass=\"small\" aria-label=\"nonimativo\"><div ng-messages=\"ticketForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Inserire nome richiedente.</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label \nng-class=\"{\n                            \'md-warn-fg\'\n                                    : (ticketForm.email.$invalid)}\">\nE-mail</label><input type=\"text\" name=\"email\" ng-disabled=\"true\" required ng-model=\"vmd.ticketConferma.email\" \naria-label=\"email\"><div ng-messages=\"ticketForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInserire email richiedente.</span></div></div></md-input-container></div><div><md-input-container flex \nclass=\"margin-bottom-0\"><label>Telefono/Contatto aggiuntivo</label><input type=\"text\" name=\"phone\" \nng-model=\"vmd.ticketConferma.phone\" aria-label=\"phone\" ng-disabled=\"vmd.disableTel\"><div \nng-messages=\"ticketForm.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Inserire telefono aggiuntivo.\n</span></div></div></md-input-container></div><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                        \'md-warn-fg\': (ticketForm.nome.$invalid)}\">Progetto di Partenza</label><input \ntype=\"text\" name=\"progettoPartenza\" required ng-model=\"vmd.ticketConferma.progettoPartenza\" aria-label=\"nome\"><div \nng-messages=\"ticketForm.progettoPartenza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInserire il progetto di partenza</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{\n                        \'md-warn-fg\': (ticketForm.nome.$invalid)}\">\nNome Beneficiario</label><input type=\"text\" name=\"nome\" required ng-model=\"vmd.ticketConferma.nome\" aria-label=\"nome\">\n<div ng-messages=\"ticketForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Inserire nome beneficiario\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                        \'md-warn-fg\': (ticketForm.cognome.$invalid)}\">Cognome Beneficiario</label><input \ntype=\"text\" name=\"cognome\" required ng-model=\"vmd.ticketConferma.cognome\" aria-label=\"cognome\"><div \nng-messages=\"ticketForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Inserire Cognome beneficiario\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                        \'md-warn-fg\': (ticketForm.codice.$invalid)}\">Codice Beneficiario</label><input \ntype=\"text\" name=\"codice\" ng-model=\"vmd.ticketConferma.codice\" aria-label=\"codice\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Nazione di Nascita</label><md-select name=\"nazione\" \nng-model=\"vmd.ticketConferma.nazione\"><md-option ng-repeat=\"nazione in vmd.nazioni\" ng-value=\"nazione.descrizione\">\n{{nazione.descrizione}}</md-option></md-select></md-input-container><md-input-container flex><label>Data di Nascita\n</label><md-datepicker ng-model=\"vmd.ticketConferma.dataNascita\" name=\"dataNascita\" \nmd-placeholder=\"Seleziona la data di nascita\" ng-change=\"formatDate(\'dataNascita\')\"></md-datepicker>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\" ng-if=\"vmd.profileProgettos.length > 0\"><label \nng-class=\"{\'md-warn-fg\': (ticketForm.progetto_id.$invalid)}\">Progetto di Destinazione</label><md-select required \nname=\"progetto_id\" id=\"profileForm_progetto_id\" ng-model=\"vmd.progettoDestinazione\" ng-change=\"vmd.searchStrutturas()\" \naria-label=\"progetto id\"><md-option ng-repeat=\"item in vmd.profileProgettos\" ng-value=\"item\"><small><b>{{item.nome}}\n</b></small></md-option></md-select><div ng-messages=\"ticketForm.progetto_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Scegliere progetto.</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{ \'md-warn-fg\': (ticketForm.struttura.$invalid) }\">Struttura di accoglienza\n</label><md-select required name=\"struttura\" ng-model=\"vmd.ticketConferma.struttura\" \naria-label=\"Struttura di accoglienza\"><md-option ng-repeat=\"struttura in vmd.strutturas \" ng-value=\"struttura.id\">\n{{ struttura.nome }}</md-option></md-select><div ng-messages=\"ticketForm.struttura.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Inserire la struttura di accoglienza.</span></div></div></md-input-container>\n<md-input-container><label>Data di Arrivo</label><md-datepicker ng-model=\"vmd.ticketConferma.dataArrivo\" \nname=\"dataArrivo\" md-placeholder=\"Seleziona una data\" ng-change=\"formatDate(\'dataArrivo\')\"></md-datepicker>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                        \'md-warn-fg\'\n                        : (ticketForm.message.$invalid)}\">Note</label>\n<textarea name=\"message\" ng-model=\"vmd.ticketConferma.message\" aria-label=\"Note\" rows=\"3\" required aria-label=\"mess\" \nstyle=\"max-height: 100px; resize: none; overflow-y: scroll\"></textarea><div ng-messages=\"ticketForm.message.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Inserire note trasferimento.</span></div></div></md-input-container>\n<md-button type=\"submit\" ng-click=\"vmd.sendTicketTrasferimento()\" class=\"md-raised md-primary\" \nng-disabled=\"ticketForm.$invalid || ticketForm.$pristine\" aria-label=\"INVIA TICKET\"><span>\nInvia La Richiesta Di Trasferimento</span></md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between stretch\" class=\"h-128\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><div class=\"bottom-row\"><div id=\"horizontal-navigation\" ui-view=\"navigation\"></div>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu(); vm.caricaProfili()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\n                                             \'color\'\n                                                     : vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{vm.userNome}} <small \nng-if=\"vm.profileName\"><b ng-if=\"vm.profileForm.ente_id !== null\">{{vm.profileName}}</b><b \nng-if=\"vm.profileForm.progetto_id !== null\">{{vm.profileName}}</b></small></span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"4\"><form \nname=\"profileForm\" novalidate class=\"padding-16\" id=\"profileForm\"><div layout=\"column\"><h3 class=\"margin-top-0\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><b>Profilo di lavoro</b></h3><md-input-container flex required \nclass=\"margin-bottom-0 margin-top-0\" ng-if=\"vm.profileProgettos.length > 0\"><md-select-label><small \nstyle=\"opacity: {{vm.opp}}\">Progetto territoriale</small></md-select-label><md-select name=\"progetto_id\" \nid=\"profileForm_progetto_id\" ng-model=\"vm.profileForm.progetto_id\" ng-change=\"vm.chooseProgettoId()\" \nstyle=\"z-index:10000;opacity: {{vm.opp}}\" aria-label=\"progetto id\"><md-option ng-repeat=\"item in vm.profileProgettos\" \nng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select></md-input-container><md-input-container \nflex required class=\"margin-bottom-0 margin-top-0\" ng-if=\"vm.profileEntes.length > 0\"><md-select-label><small \nstyle=\"opacity: {{vm.ope}}\">Ente segnalatore</small></md-select-label><md-select name=\"ente_id\" \nid=\"profileForm_ente_id\" ng-model=\"vm.profileForm.ente_id\" ng-change=\"vm.chooseEnteId()\" \nstyle=\"z-index:10000;opacity: {{vm.ope}}\" aria-label=\"ente_id\"><md-option ng-repeat=\"item in vm.profileEntes\" \nng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select></md-input-container></div></form>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.gotoProfilo()\">Profilo</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Esci</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"ticket-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"vm.openDialog($ev)\" aria-label=\"transfer confirmation\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon><span \nstyle=\"text-transform: none\">&nbsp;Trasferimento</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"5\"></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"ticket-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu();\" layout=\"row\" layout-align=\"space-between center\"><md-icon \nmd-font-icon=\"icon-television-guide\"></md-icon><span class=\"m-5\" style=\"text-transform: none\">Tutorial</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></md-button><md-menu-content width=\"5\">\n<md-menu-item><md-button ui-sref=\"app.sprardb_video({id: \'UEjVsmBnE7I\'})\"><md-icon \nmd-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>1. Processo di autenticazione alla Banca Dati</md-button>\n</md-menu-item><md-menu-item><md-button ui-sref=\"app.sprardb_video({id: \'cs9k2GKc04k\'})\"><md-icon \nmd-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>\n2. Processo di segnalazione ad uso degli operatori di Progetto</md-button></md-menu-item><md-menu-item><md-button \nui-sref=\"app.sprardb_video({id: \'r8HjR2Dzc0k\'})\"><md-icon md-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>\n3. Processo di gestione segnalazioni in arrivo ad uso degli operatori di Progetto</md-button></md-menu-item>\n<md-menu-item><md-button ui-sref=\"app.sprardb_video({id: \'I4HxAyQLbDw\'})\"><md-icon \nmd-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>\n4. Processo di gestione beneficiari ad uso degli operatori di Progetto</md-button></md-menu-item><md-menu-item>\n<md-button ui-sref=\"app.sprardb_video({id: \'OoDOx1Kkqww\'})\"><md-icon md-font-icon=\"icon-television-guide\" class=\"icon\">\n</md-icon>5. Processo di gestione dello status giuridico di un beneficiario</md-button></md-menu-item><md-menu-item>\n<md-button ui-sref=\"app.sprardb_video({id: \'caJ28Bjx8Rk\'})\"><md-icon md-font-icon=\"icon-television-guide\" class=\"icon\">\n</md-icon>6. Gestione dei Progetti</md-button></md-menu-item><md-menu-item><md-button \nui-sref=\"app.sprardb_video({id: \'5aTONORTjyo\'})\"><md-icon md-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>\n7. Proroghe</md-button></md-menu-item><md-menu-item><md-button ui-sref=\"app.sprardb_video({id: \'OTwkVghh0gQ\'})\">\n<md-icon md-font-icon=\"icon-television-guide\" class=\"icon\"></md-icon>\n8. Rendicontazione: Utilizzo filtro ricerca del registro delle spese</md-button></md-menu-item><md-menu-item><md-button\n href=\"assets/docs/NOTA TECNICA - INSERIMENTO BENEFICIARI DA LETTERA SC.PDF\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>9. Inserimento beneficiari da Lettera Servizio Centrale</md-button>\n</md-menu-item><md-menu-item><md-button href=\"assets/docs/NOTA TECNICA - ACCOGLIENZA ESTERNA.PDF\" target=\"_blank\">\n<md-icon md-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>10. Accoglienza Esterna</md-button></md-menu-item>\n<md-menu-item><md-button href=\"assets/docs/NOTA TECNICA - NUCLEI FAMILIARI.pdf\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>11. Registrazione dei nuclei familiari</md-button></md-menu-item>\n<md-menu-item><md-button href=\"assets/docs/NOTA TECNICA - CODICE CUI E VESTANET.pdf\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>12. Inserimento codice CUI e codice Vestanet</md-button>\n</md-menu-item><md-menu-item><md-button href=\"assets/docs/NOTA TECNICA - PROCESSO DI TRASFERIMENTO.pdf\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>13. Processo di trasferimetno</md-button>\n</md-menu-item><md-menu-item><md-button href=\"assets/docs/NOTA TECNICA - PRESENTI SUL TERRITORIOsf.pdf\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon>\n14. Registrazione e gestione Presenti sul Territorio</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"ticket-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu(); vm.resetTicket()\" \naria-label=\"ticket settings\"><div layout=\"row\" layout-align=\"space-between center\"><md-icon \nmd-font-icon=\"icon-stethoscope\"></md-icon><span style=\"text-transform: none\">&nbsp;Assistenza</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"7\"><form \nname=\"ticketForm\" novalidate class=\"padding-16\" id=\"formTick\"><div layout=\"column\"><h3 class=\"margin-top-0\"><md-icon \nmd-font-icon=\"icon-stethoscope\"></md-icon><b>Richiesta di assistenza</b></h3><div layout=\"row\"><md-input-container \nflex class=\"margin-bottom-0\"><label \nng-class=\"{\n                                            \'md-warn-fg\'\n                                            : (ticketForm.name.$invalid)}\">\nNome e Cognome</label><input type=\"text\" name=\"name\" ng-disabled=\"true\" required ng-model=\"vm.ticket.name\" \nclass=\"small\" aria-label=\"nonimativo\"><div ng-messages=\"ticketForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Inserire nome richiedente.</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label \nng-class=\"{\n                                            \'md-warn-fg\'\n                                                    : (ticketForm.email.$invalid)}\">\nE-mail</label><input type=\"text\" name=\"email\" ng-disabled=\"true\" required ng-model=\"vm.ticket.email\" class=\"small\" \naria-label=\"email\"><div ng-messages=\"ticketForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInserire email richiedente.</span></div></div></md-input-container></div><md-input-container flex required \nclass=\"margin-bottom-0 margin-top-0\" ng-if=\"vm.profileProgettos.length > 0\"><md-select-label \nng-class=\"{\'md-warn-fg\': (ticketForm.progetto_id.$invalid)}\"><small>Progetto territoriale</small></md-select-label>\n<md-select name=\"progetto_id\" id=\"profileForm_progetto_id\" ng-model=\"vm.ticket.progetto_id\" \nng-change=\"vm.chooseProgettoId2()\" aria-label=\"progetto id\"><md-option ng-repeat=\"item in vm.profileProgettos\" \nng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select><div \nng-messages=\"ticketForm.progetto_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Scegliere progetto.</span>\n</div></div></md-input-container><md-input-container flex required class=\"margin-bottom-0 margin-top-0\" \nng-if=\"vm.profileEntes.length > 0\"><md-select-label><small>Ente segnalatore</small></md-select-label><md-select \nname=\"ente_id\" id=\"profileForm_ente_id\" ng-model=\"vm.ticket.ente_id\" ng-change=\"vm.chooseEnteId2()\" required \naria-label=\"ente id\"><md-option ng-repeat=\"item in vm.profileEntes\" ng-value=\"item.id\"><small><b>{{item.nome}}</b>\n</small></md-option></md-select><div ng-messages=\"ticketForm.ente_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Scegliere ente.</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>\nTelefono/Contatto aggiuntivo</label><input type=\"text\" name=\"phone\" ng-model=\"vm.ticket.phone\" aria-label=\"phone\" \nng-disabled=\"vm.disableTel\"><div ng-messages=\"ticketForm.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInserire telefono aggiuntivo.</span></div></div></md-input-container><md-input-container flex required \nclass=\"margin-bottom-0 margin-top-0\"><md-select-label \nng-class=\"{\n                                        \'md-warn-fg\': (ticketForm.parent.$invalid)}\"><small>\nTipo di richiesta assistenza<sup>*</sup></small></md-select-label><md-select name=\"parent\" id=\"ticketForm_parent\" \nng-model=\"vm.ticket.parent\" ng-change=\"vm.chooseParentTopic()\" required style=\"z-index:10000\" aria-label=\"parent\">\n<md-option ng-repeat=\"(pk, pt) in vm.parentTopics\" value=\"{{pt}}\" ng-selected=\"pk == vm.selectedTopic\"><small><b>{{pt}}\n</b></small></md-option></md-select><div ng-messages=\"ticketForm.parent.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Tipologia di richiesta obbligatoria.</span></div></div></md-input-container>\n<md-input-container flex required class=\"margin-bottom-0 margin-top-0\"><md-select-label \nng-class=\"{\n                                        \'md-warn-fg\': (ticketForm.topicId.$invalid)}\"><small>\nCategoria di richiesta assistenza<sup>*</sup></small></md-select-label><md-select name=\"topicId\" \nng-model=\"vm.ticket.topicId\" ng-change=\"\" required aria-label=\"topic\"><md-option \nng-repeat=\"(pk1, pt1) in vm.childrenTopics\" value=\"{{pt1}}\" ng-selected=\"pk1 == vm.ticket.topicId\"><small><b>{{pt1}}\n</b></small></md-option></md-select><div ng-messages=\"ticketForm.topicId.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Categoria obbligatoria.</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label \nng-class=\"{\n                                        \'md-warn-fg\': (ticketForm.subject.$invalid)}\">Titolo/Oggetto\n</label><input type=\"text\" name=\"subject\" required ng-model=\"vm.ticket.subject\" aria-label=\"subject\"><div \nng-messages=\"ticketForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Inserire oggetto della richiesta.\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\n                                        \'md-warn-fg\'\n                                        : (ticketForm.message.$invalid)}\">\nMessaggio</label><textarea name=\"message\" ng-model=\"vm.ticket.message\" aria-label=\"Messaggio\" rows=\"3\" required \naria-label=\"mess\" style=\"max-height: 100px; resize: none; overflow-y: scroll\"></textarea><div \nng-messages=\"ticketForm.message.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInserire messaggio della richiesta.</span></div></div></md-input-container><md-button type=\"submit\" \nng-click=\"vm.sendTicket()\" class=\"md-raised md-primary\" ng-disabled=\"ticketForm.$invalid || ticketForm.$pristine\" \naria-label=\"INVIA TICKET\"><span>Invia e-mail assistenza</span></md-button></div></form></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/main/sprardb/amministrazione/bando/bando.html","<div id=\"bando\" class=\"bando page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Bandi</span></div></div></div><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\">\n<md-input-container md-no-float class=\"m-0\" flex=\"60\"><input placeholder=\"Ricerca per descrizione\" type=\"text\" \nng-model=\"vm.descrizioneSearch\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch()\"></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top: 0px;margin-top: 30px;margin-bottom: 50px;position: relative\"><md-table-container><table \ndata-md-table md-progress=\"vm.bandi.$promise\"><thead md-head><tr md-row><th md-column>DESCRIZIONE</th><th md-column>\nDATA INIZIO</th><th md-column>DATA FINE</th><th md-column>GRUPPO</th><th md-column>ATTIVO</th></tr></thead><tbody \nmd-body><tr md-row ng-repeat=\"item in vm.bandi.data\"><td md-cell><b>{{item.descrizione}}</b></td><td md-cell><b>\n{{item.dataInizio | date:\'dd/MM/yyyy\'}}</b></td><td md-cell>{{item.dataFine | date:\'dd/MM/yyyy\'}}</td><td md-cell>\n{{item.gruppo}}</td><td md-cell class=\"text-center\"><md-icon class=\"icon-bookmark-outline\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo == 1\"></md-icon></td><td md-cell><md-button \nclass=\"md-accent md-button-icon\" aria-label=\"Update\" ng-click=\"vm.updateBando($event, item)\">MODIFICA</md-button></td>\n</tr></tbody></table></md-table-container></md-card></div></div><md-button id=\"add-contact-button\" \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.nuovoBando($event)\" aria-label=\"nuovo bando\" \nng-if=\"vm.api.user.permissions.includes(\'gestione-bandi\')\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/sprardb/amministrazione/bando/new-bando.html","<md-dialog style=\"width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"BandoForm\" novalidate layout=\"column\">\n<md-input-container><label>Descrizione</label><input type=\"text\" ng-model=\"vmd.bando.descrizione\" required>\n</md-input-container><div layout=\"row\"><div layout=\"column\" flex=\"50\"><md-input-container><label>Data Inizio</label>\n<md-datepicker name=\"DataInizio\" ng-model=\"vmd.bando.dataInizio\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\"></md-input-container><md-input-container><label>Data Fine</label><md-datepicker \nname=\"DataFine\" ng-model=\"vmd.bando.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\">\n</md-input-container></div><div layout=\"column\" flex=\"50\"><md-input-container><md-checkbox ng-model=\"vmd.bando.attivo\" \nng-true-value=\"1\" ng-false-value=\"0\"><small>Attivo</small></md-checkbox></md-input-container><md-input-container>\n<label>Gruppo</label><md-select ng-model=\"vmd.bando.gruppo\"><md-option ng-value=\"gruppo\" \nng-repeat=\"gruppo in vmd.gruppi\">{{ gruppo }}</md-option></md-select></md-input-container></div></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancel()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button type=\"button\" ng-click=\"vmd.salva()\" \nclass=\"send-button md-accent md-raised\">SALVA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/amministrazione/corsi/corsi.html","<div id=\"corsi\" class=\"corsi page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Lista Corsi</span></div></div></div><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\">\n<md-input-container flex=\"30\" class=\"mr-30\"><input placeholder=\"Ricerca per descrizione\" type=\"text\" \nng-model=\"vm.descrizioneSearch\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch()\"></md-input-container>\n<md-input-container flex=\"30\"><md-select ng-model=\"vm.selectedCategoria\" placeholder=\"Seleziona una categoria...\" \nng-change=\"vm.onSearch()\"><md-option ng-value=\"null\"></md-option><md-option ng-repeat=\"item in vm.categorie.data\" \nng-value=\"item.id\"><strong><small>{{item.descrizione}}</small></strong></md-option></md-select></md-input-container>\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n</div><md-card style=\"padding-top:0px\"><md-table-container><table data-md-table md-progress=\"vm.corsi.$promise\"><thead \nmd-head data-md-order=\"vm.allsearchs.sort\"><tr md-row><th md-column>DESCRIZIONE</th><th md-column>CATEGORIA</th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"item in vm.corsi.data\"><td md-cell><b>{{item.descrizione}}</b></td><td \nmd-cell>{{item.categoria.descrizione}}</td><td md-cell style=\"text-align: right\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-button-icon\" aria-label=\"Modifica\" \nng-click=\"vm.updateCorso($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA</b></small>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-accent md-button-icon\" aria-label=\"Cancella Corso\" \nng-click=\"vm.cancellaCorso($event, item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><small><b>CANCELLA CORSO</b>\n</small></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.search[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" \nmd-total=\"{{vm.totalCount}}\" md-on-paginate=\"vm.loadCorsi\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.nuovoCorso($event)\" \naria-label=\"nuovo corso\" ng-if=\"vm.api.user.permissions.includes(\'edit-corsi\')\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/sprardb/amministrazione/dialogs/new-corso.html","<md-dialog style=\"width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"CorsoForm\" novalidate layout=\"column\"><div layout=\"row\">\n<div layout=\"column\" flex=\"50\"><md-input-container><input ng-model=\"vmd.corso.descrizione\" placeholder=\"Descrizione\" \nrequired></md-input-container></div><div layout=\"column\" flex=\"50\"><md-input-container><md-select \nng-model=\"vmd.corso.corsi_id\" placeholder=\"Seleziona una categoria...\"><md-option \nng-repeat=\"item in vmd.categorie.data\" ng-value=\"item.id\"><strong><small>{{item.descrizione}}</small></strong>\n</md-option></md-select></md-input-container></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"vmd.close()\" style=\"margin-right:20px\">Annulla</md-button><md-button \ntype=\"button\" ng-click=\"vmd.salva()\" class=\"send-button md-accent md-raised\">SALVA</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/sprardb/amministrazione/dialogs/new-servizio.html","<md-dialog style=\"width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.titolo}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"ServizioForm\" novalidate layout=\"column\"><div \nlayout=\"row\"><div layout=\"column\" flex=\"50\"><md-input-container><input ng-model=\"vmd.servizio.descrizione\" \nplaceholder=\"Descrizione\" required></md-input-container></div><div layout=\"column\" flex=\"50\"><md-input-container>\n<md-select ng-model=\"vmd.servizio.servizi_id\" placeholder=\"Seleziona una categoria...\"><md-option \nng-repeat=\"item in vmd.categorie.data\" ng-value=\"item.id\"><strong><small>{{item.descrizione}}</small></strong>\n</md-option></md-select></md-input-container></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"vmd.close()\" style=\"margin-right:20px\">Annulla</md-button><md-button \ntype=\"button\" ng-click=\"vmd.salva()\" class=\"send-button md-accent md-raised\">SALVA</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/sprardb/amministrazione/servizi/servizi.html","<div id=\"servizi\" class=\"servizi page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Lista Servizi</span></div></div></div><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\">\n<md-input-container flex=\"30\" class=\"mr-30\"><input placeholder=\"Ricerca per descrizione\" type=\"text\" \nng-model=\"vm.descrizioneSearch\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch()\"></md-input-container>\n<md-input-container flex=\"30\"><md-select ng-model=\"vm.selectedCategoria\" placeholder=\"Seleziona una categoria...\" \nng-change=\"vm.onSearch()\"><md-option ng-value=\"null\"></md-option><md-option ng-repeat=\"item in vm.categorie.data\" \nng-value=\"item.id\"><strong><small>{{item.descrizione}}</small></strong></md-option></md-select></md-input-container>\n<md-button ng-click=\"vm.onSearch()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n</div><md-card style=\"padding-top:0px\"><md-table-container><table data-md-table md-progress=\"vm.servizi.$promise\">\n<thead md-head data-md-order=\"vm.allsearchs.sort\"><tr md-row><th md-column>DESCRIZIONE</th><th md-column>CATEGORIA</th>\n</tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.servizi.data\"><td md-cell><b>{{item.descrizione}}</b></td>\n<td md-cell>{{item.categoria.descrizione}}</td><td md-cell style=\"text-align: right\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-button-icon\" aria-label=\"Modifica\" \nng-click=\"vm.updateServizio($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA</b></small>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-accent md-button-icon\" aria-label=\"Cancella Servizio\" \nng-click=\"vm.cancellaServizio($event, item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><small><b>CANCELLA SERVIZIO\n</b></small></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.search[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" \nmd-total=\"{{vm.totalCount}}\" md-on-paginate=\"vm.loadServizi\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.nuovoServizio($event)\" \naria-label=\"nuovo servizio\" ng-if=\"vm.api.user.permissions.includes(\'edit-servizi\')\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/sprardb/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>SC</span></div><div class=\"title\">Recupera la tua password</div><p>\nInserisci il tuo nome utente e l’indirizzo e-mail qui sotto e clicca sul tasto “INVIA RESET LINK”</p><form ngnoform \nname=\"forgotPasswordForm\" novalidate><label>Username</label><md-input-container class=\"md-block\" md-no-float><input \ntype=\"username\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Nome Utente\" required><div \nng-messages=\"forgotPasswordForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nUsername è richiesta</span></div></div></md-input-container><label>Email</label><md-input-container class=\"md-block\" \nmd-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Indirizzo email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email è richiesta</span></div><div ng-message=\"pattern\"><span>\nEmail invalida</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" ng-click=\"vm.startreset($event)\">\nInvia reset link</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.sprardb_auth_login\">Torna alla login</a></div></div></div></div>");
$templateCache.put("app/main/sprardb/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"md-title\"><i class=\"icon icon-lock-unlocked-outline s18\"></i> Autenticazione</div><form \nname=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.logindata.username\" placeholder=\"Nome Utente\" required><div ng-messages=\"loginForm.user.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Nome utente richiesto</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.logindata.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.sprardb_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-click=\"vm.login($event)\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"column\" \nlayout-sm=\"column\" layout-align=\"start center\"><span class=\"text\">\nNon hai ancora le credenziali di accesso alla Banca dati SAI?</span> <a class=\"text underline\" style=\"cursor:pointer\" \nng-click=\"vm.popup($event)\">CLICCA QUI</a></div><div layout=\"column\" layout-align=\"center center\"><p>\nL’applicazione Banca Dati SAI, nella sua nuova versione, è ottimizzata per i seguenti browser:&nbsp;<b>Chrome 56</b>\n o superiore, <b>Firefox 51</b> o superiori, <b>Microsoft Edge 40</b> o superiori.&nbsp;<b>\nPer aggiornare il tuo browser visita il sito <a href=\"https://browsehappy.com/\" target=\"_blank\">\nhttps://browsehappy.com/</a></b></p></div><div style=\"visibility: hidden\" id=\"dialog\"><div class=\"md-dialog-container\" \nid=\"myDialog\"><md-dialog aria-label=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><form ng-cloak><md-dialog-content><div class=\"md-dialog-content\"><h3 \nng-style=\"{\'color\':\'#039BE5\'}\">RICHIESTA CREDENZIALI E PASSWORD</h3><p>\nSe sei un operatore di un progetto SAI e non sei in possesso delle credenziali di accesso alla banca dati, è necessario che il responsabile dell\'ente locale titolare del progetto invii una PEC all\'indirizzo PEC serviziocentrale@pec.cittalia.it.\n</p><p>Nel testo della mail dovranno essere indicati i seguenti dati:</p><p>\nnome, cognome, codice fiscale, data di nascita, numero di telefono, e-mail ad utilizzo esclusivo (a cui verranno inviati tutti i dati di accesso al sistema), codice ministeriale del progetto , ruolo svolto nel progetto.\n</p><p>Una volta richieste le credenziali vi verrà inviata la mail contente nome utente e password.</p><br><h3 \nng-style=\"{\'color\': \'#039BE5\'}\">PASSWORD DI ACCESSO DIMENTICATA?</h3><p>\nPer effettuare il Reset ed ottenere una nuova password cliccare sulla voce \"Password dimenticata?\" presente nella schermata principale della banca dati.\n</p></div></md-dialog-content></form></md-dialog></div></div></div></div></div>");
$templateCache.put("app/main/sprardb/auth/login/quick-panel.tmpl.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mango (Fruit)</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><h2>Using .md-dialog-content class that sets the padding as the spec\n</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p><img style=\"margin: auto; max-width: 100%\" alt=\"Lush mango tree\" src=\"img/mangues.jpg\"><p>\nThe highest concentration of Mangifera genus is in the western part of Malesia (Sumatra, Java and Borneo) and in Burma and India. While other Mangifera species (e.g. horse mango, M. foetida) are also grown on a more localized basis, Mangifera indica&mdash;the \"common mango\" or \"Indian mango\"&mdash;is the only mango tree commonly cultivated in many tropical and subtropical regions.\n</p><p>\nIt originated in Indian subcontinent (present day India and Pakistan) and Burma. It is the national fruit of India, Pakistan, and the Philippines, and the national tree of Bangladesh. In several cultures, its fruit and leaves are ritually used as floral decorations at weddings, public celebrations, and religious ceremonies.\n</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button href=\"http://en.wikipedia.org/wiki/Mango\" \ntarget=\"_blank\" md-autofocus>More on Wikipedia</md-button><span flex></span><md-button ng-click=\"answer(\'not useful\')\">\nNot Useful</md-button><md-button ng-click=\"answer(\'useful\')\">Useful</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/auth/register/dialog1.html","<md-dialog id=\"telephoneForm\" aria-label=\"Telephone Verification\" flex=\"30\"><form name=\"telephoneForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nVerifica mobile Segnalatore</h2><span flex></span><md-button class=\"md-icon-button\" placeholder=\"x\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><p>Un SMS contenente un codice di conferma di questa operazione è stato inviato al numero <b>\ndel SEGNALATORE {{telm}}</b>.</p><p>\nPer favore inserica il codice e validi il suo numero di telefono entro 3 minuti. Grazie</p>{{tokenauto}}<div \nlayout=\"row\" layout-align=\"space-around center\"><input name=\"telefono1\" ng-model=\"telefono1\" hidden=\"\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"token1\" ng-model=\"token1\" type=\"password\" \nplaceholder=\"Token\" translate translate-attr-placeholder=\"REGISTER.TOKEN\" required> <span flex></span><div \nng-messages=\"telephoneForm.token1.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.TOKEN_REQUIRED\">Token field is required</span></div><ng-message class=\"help-block\" \nwhen=\"validtoken\"><span translate=\"REGISTER.ERRORS.TOKEN_NOT_VALID\">Please enter valid token</span></ng-message></div>\n</md-input-container><md-button ng-click=\"verify($event)\" class=\"md-raised md-accent md-primary\" placeholder=\"Verify\" \ntranslate=\"REGISTER.VERIFY\" translate-attr-aria-label=\"REGISTER.VERIFY\">Verify</md-button></div><div \nng-if=\"tokenresend\" role=\"success\"><span>Nuovo token spedito correttamente</span></div><div ng-if=\"tokenfailed\" \nrole=\"success\"><span>Token non corretto, prova a rispedirlo.</span></div><div layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"resend($event)\" class=\"md-raised md-accent md-warn\" \nplaceholder=\"Re-send\" translate=\"REGISTER.RESEND\" translate-attr-aria-label=\"REGISTER.RESEND\">Re-Send</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/sprardb/auth/register/dialog2.html","<md-dialog id=\"telephoneForm\" aria-label=\"Telephone Verification\" flex=\"25\"><form name=\"telephoneForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nVerifica mobile Ente Segnalatore</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p>\nUn SMS contenente un codice di conferma di questa operazione è stato inviato al numero <b>dell\'ENTE {{telm}}</b>.</p>\n<p>Per favore inserica il codice e validi il suo numero di telefono entro 3 minuti. Grazie</p>{{tokenauto}}<div \nlayout=\"row\" layout-align=\"space-around center\"><input name=\"telefono1\" ng-model=\"telefono1\" hidden=\"\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"token1\" ng-model=\"token1\" placeholder=\"Token\" \ntype=\"password\" translate translate-attr-placeholder=\"REGISTER.TOKEN\" required> <span flex></span><div \nng-messages=\"telephoneForm.token1.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.TOKEN_REQUIRED\">Token field is required</span></div><ng-message class=\"help-block\" \nwhen=\"verified\"><span translate=\"REGISTER.ERRORS.TOKEN_NOT_VALID\">Please enter valid token</span></ng-message></div>\n</md-input-container><md-button ng-click=\"verify($event)\" class=\"md-raised md-accent md-primary\" placeholder=\"Verify\" \ntranslate=\"REGISTER.VERIFY\" translate-attr-aria-label=\"REGISTER.VERIFY\">Verify</md-button></div><div \nng-if=\"tokenresend\" role=\"success\"><span>Nuovo token spedito correttamente</span></div><div ng-if=\"tokenfailed\" \nrole=\"success\"><span>Token non corretto, prova a rispedirlo.</span></div><div layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"resend($event)\" class=\"md-raised md-accent md-warn\" \nplaceholder=\"Re-send\" translate=\"REGISTER.RESEND\" translate-attr-aria-label=\"REGISTER.RESEND\">Re-Send</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/sprardb/auth/register/organization.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"org-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE_ORGANIZATION\">Create new Organization</div><form \nname=\"organizationForm\" novalidate><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float \nshow-errors flex><label>Nome</label><input name=\"nome\" ng-model=\"vm.organization.nome\" placeholder=\"Nome dell\'ente\" \ntranslate translate-attr-placeholder=\"REGISTER.NAME\" ng-disabled=\"vm.orgexists\" required><div \nng-messages=\"organizationForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.NOME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float flex><label>Email</label><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input type=\"email\" name=\"email\" ng-disabled=\"vm.orgexists\" ng-model=\"vm.organization.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-blur=\"vm.validateEmail($event)\"><div ng-messages=\"organizationForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div><ng-message class=\"help-block\" when=\"unique\"><span translate=\"REGISTER.ERRORS.EMAIL_ALREADY_EXIST\">\nEmail already exist</span></ng-message></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Settore primario</label><md-select name=\"ids\" \nng-model=\"vm.organizationids.ids\" translate translate-attr-placeholder=\"REGISTER.ORGTYPEPARENT\" \nplaceholder=\"Settore primario\" ng-change=\"vm.childorg()\" ng-disabled=\"vm.orgexists\" required><md-option \nng-repeat=\"parentorg in vm.parorg\" ng-value=\"parentorg.id\" \nng-selected=\"{{ parentorg.id === vm.organizationids.ids ? \'true\' : \'false\' }}\">{{parentorg.descrizione}}</md-option>\n</md-select><div class=\"errors\" ng-messages=\"organizationForm.ids.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"REGISTER.ERRORS.ORGTYPEPARENT_REQUIRED\">Organization Type Parent field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Tipologia</label><md-select \nname=\"enteTipo_id\" translate translate-attr-placeholder=\"REGISTER.ORGTYPECHILD\" placeholder=\"Tipologia\" \nng-model=\"vm.organization.enteTipo_id\" ng-disabled=\"vm.orgexists\" required><md-option \nng-repeat=\"childorg in vm.childorgs\" ng-value=\"childorg.id\" \nng-selected=\"{{ childorg.id === vm.organization.enteTipo_id ? \'true\' : \'false\' }}\">{{childorg.descrizione}}</md-option>\n</md-select><div ng-messages=\"organizationForm.enteTipo_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.ORGTYPECHILD_REQUIRED\">Organization Type field is required</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\" style=\"margin-top: 16px\"><md-autocomplete flex \nmd-input-name=\"residencecity\" ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCity\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchTextCity)\" md-search-text=\"vm.searchTextCity\" \nmd-selected-item-change=\"vm.selectedResidencecityChange(residencecity)\" \nmd-items=\"residencecity in vm.querySearchCity(vm.searchTextCity)\" md-item-text=\"residencecity.comune\" \nmd-min-length=\"1\" ng-attr-md-floating-label=\"{{vm.comuneresidenza}}\" ng-disabled=\"vm.orgexists\" required>\n<md-item-template><span class=\"item-title\"><span>{{residencecity.comune}} </span></span><span class=\"item-metadata\">\n<span class=\"item-metastat\"><strong>{{residencecity.regione}}</strong> </span><span class=\"item-metastat\"><strong>\n{{residencecity.provincia}}</strong></span></span></md-item-template><div \nng-messages=\"organizationForm.residencecity.$error\" ng-if=\"organizationForm.residencecity.$touched\"><div \nng-message=\"required\">This field is required</div><div ng-message=\"minlength\">Your entry is not long enough.</div>\n</div></md-autocomplete></div><input name=\"codComune\" hidden=\"\" ng-model=\"vm.organization.codComune\"> <input \nname=\"codProvincia\" hidden=\"\" ng-model=\"vm.organization.codProvincia\"> <input name=\"codRegione\" hidden=\"\" \nng-model=\"vm.organization.codRegione\"> <input name=\"segnalatore\" hidden=\"\" ng-model=\"vm.organization.segnalatore\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float show-errors flex><input name=\"indirizzo\" \nng-model=\"vm.organization.indirizzo\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER.ADDRESS\" \nng-disabled=\"vm.orgexists\" required><div ng-messages=\"organizationForm.indirizzo.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.ADDRESS_REQUIRED\">Address field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><input name=\"cap\" \nng-model=\"vm.organization.cap\" placeholder=\"Zipcode\" flex translate translate-attr-placeholder=\"REGISTER.ZIPCODE\" \nng-pattern=\"/^\\+?\\d+$/im\" minlength=\"5\" maxlength=\"6\" ng-disabled=\"vm.orgexists\" required><div \nng-messages=\"organizationForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span translate=\"REGISTER.ERRORS.ZIPCODE_REQUIRED\">\nYour Zipcode must be between 5 and 6 digit long and look like an Zipcode.</span></div></div></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon><input name=\"telefono\" ng-model=\"vm.organization.telefono\" \nng-pattern=\"/^\\+?\\d+$/im\" minlength=\"10\" maxlength=\"13\" placeholder=\"Telephone\" translate \ntranslate-attr-placeholder=\"REGISTER.TELEPHONE\" ng-change=\"vm.validatePhone($event)\" ng-disabled=\"vm.orgexists\" \nrequired><div ng-messages=\"organizationForm.telefono.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span \ntranslate=\"REGISTER.ERRORS.TELEPHONE_REQUIRED\">\nYour Telephone must be between 10 and 13 digit long and look like an Zipcode.</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span translate=\"REGISTER.ERRORS.PHONE_ALREADY_EXIST\">\nMobile/Phone number already exist</span></ng-message></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float flex><label>P. Iva / Cod. Fiscale</label><md-icon class=\"email\"></md-icon><input type=\"text\" name=\"piva\" \nng-disabled=\"vm.orgexists\" ng-model=\"vm.organization.piva\" placeholder=\"Partita Iva o Codice Fiscale\" \nng-pattern=\"/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$/\" required \nng-blur=\"vm.validatePiva($event)\"><div ng-messages=\"organizationForm.piva.$error\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>Campo richiesto!!!</span></div><div ng-message=\"pattern\"><span>\nNon assomiglia ad una partita iva o codice fiscale</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nGia esiste</span></ng-message></div></md-input-container></div><md-content><div ng-show=\"mobileverification\" \nrole=\"alert\"><span class=\"help-block\"><i class=\"icon icon-message-text-outline\"></i> CONTROLLA IL TUO TELEFONO</span>\n</div></md-content><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button \ntype=\"submit\" class=\"md-raised md-accent md-primary\" ng-hide=\"organizationForm.$valid\" aria-label=\"BACKWARD\" \ntranslate=\"REGISTER.AC_BACKWARD\" translate-attr-aria-label=\"REGISTER.AC_BACKWARD\" \nng-click=\"vm.backward(\'app.sprardb_auth_register.profile\')\">BACKWARD</md-button><md-button type=\"submit\" \nng-hide=\"organizationForm.$invalid || organizationForm.$pristine\" class=\"md-raised md-accent md-primary\" \naria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"organizationForm.$invalid || organizationForm.$pristine\" \ntranslate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" \nng-click=\"vm.createProfile($event)\">FORWARD</md-button></section></form></div></div></div>");
$templateCache.put("app/main/sprardb/auth/register/profile.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"profile-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE_PROFILE\">Register new account</div><form name=\"personForm\" \nnovalidate><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Nome</label><input \nname=\"nome\" ng-model=\"vm.persondata.nome\" placeholder=\"First Name\" translate \ntranslate-attr-placeholder=\"REGISTER.NOME\" required><div ng-messages=\"personForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.NOME_REQUIRED\">Name field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Cognome</label><input type=\"cognome\" \nname=\"cognome\" ng-model=\"vm.persondata.cognome\" placeholder=\"Last Name\" translate \ntranslate-attr-placeholder=\"REGISTER.COGNAME\" required><div ng-messages=\"personForm.cognome.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.COGNAME_REQUIRED\">Cognome field is required</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Email\n</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input type=\"email\" name=\"email\" \nng-model=\"vm.persondata.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nreadonly=\"readonly\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"personForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float flex><label>Sesso</label><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon><md-select \nng-model=\"vm.persondata.sesso\" name=\"sesso\" placeholder=\"Genere\"><md-option \nng-repeat=\"n in [{id: \'M\', value: \'MASCHIO\'}, {id: \'F\', value: \'FEMMINA\'}]\" ng-value=\"n.id\" \nng-selected=\"{{vm.persondata.sesso == n.id}}\">{{ n.value}}</md-option></md-select><div class=\"errors\" \nng-messages=\"personForm.sesso.$error\"><div ng-message=\"required\">Richiesto</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><input name=\"codComune\" hidden=\"\" ng-model=\"vm.persondata.codComune\"> <input name=\"codProvincia\" \nhidden=\"\" ng-model=\"vm.persondata.codProvincia\"> <input name=\"codRegione\" hidden=\"\" \nng-model=\"vm.persondata.codRegione\"> <input name=\"id\" hidden=\"\" ng-model=\"vm.organization.id\"><div flex \nstyle=\"margin-top: -16px\"><label class=\"grey-500-fg\" style=\"font-size: 12px;text-rendering:optimizelegibility\">\nData di nascita<sup>*</sup></label><md-datepicker flex name=\"dataNascita\" md-placeholder=\"Data nascita\" \nng-model=\"vm.persondata.dataNascita\" md-max-date=\"maxDate\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"personForm.dataNascita.$error\" ng-if=\"personForm.dataNascita.$touched\"><div \nstyle=\"font-size: 12px;line-height: 14px;color:rgb(213, 0, 0)\" ng-message=\"valid\" translate=\"REGISTER.ERRORS.VAL\">\nThe entered value is not a date!</div><div style=\"font-size: 12px;line-height: 14px;color:rgb(213, 0, 0)\" \nng-message=\"required\" translate=\"REGISTER.ERRORS.REQ\">This field is required</div><div \nstyle=\"font-size: 12px;line-height: 14px;color:rgb(213, 0, 0)\" ng-message=\"maxdate\" translate=\"REGISTER.ERRORS.OUT\">\nDate is too late!</div></div></div><md-input-container class=\"md-block\" md-no-float flex><label>Telefono mobile</label>\n<md-icon md-font-icon=\"icon-cellphone-android\"></md-icon><input name=\"telefono\" ng-model=\"vm.persondata.telefono\" \nng-pattern=\"/^\\+?\\d+$/im\" minlength=\"10\" maxlength=\"13\" placeholder=\"Telephone\" translate \ntranslate-attr-placeholder=\"REGISTER.TELEPHONE\" ng-change=\"vm.checkTelephone($event)\" required><div \nng-messages=\"personForm.telefono.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span \ntranslate=\"REGISTER.ERRORS.TELEPHONE_REQUIRED\">\nYour Telephone must be between 10 and 13 digit long and look like an Zipcode.</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span translate=\"REGISTER.ERRORS.PHONE_ALREADY_EXIST\">\nMobile/Phone number already exist</span></ng-message></div></md-input-container></div><div layout-gt-sm=\"row\"><input \nname=\"codComuneNascita\" hidden=\"\" ng-model=\"vm.persondata.codComuneNascita\"></div><div layout-gt-sm=\"row\" \nng-show=\"showorganization\"><md-autocomplete flex md-input-name=\"organization\" \nng-disabled=\"personForm.telefono.$invalid || personForm.residencecity.$invalid || personForm.birthcity.$invalid\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItemOrganization\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchTextOrganization)\" md-search-text=\"vm.searchTextOrganization\" \nmd-selected-item-change=\"vm.selectedOrganizationChange(organization)\" \nmd-items=\"organization in vm.querySearchOrganization(vm.searchTextOrganization)\" md-item-text=\"organization.nome\" \nmd-min-length=\"1\" ng-attr-md-floating-label=\"{{vm.scegliunente}}\" required><md-item-template><span class=\"item-title\">\n<span>{{organization.nome}}</span></span></md-item-template><md-not-found>\n\"{{vm.searchTextOrganization}}\" non trovato!! <a ng-click=\"vm.newOrganization($event)\">CREA NUOVO</a></md-not-found>\n<div ng-messages=\"personForm.organization.$error\"><div ng-message=\"required\" translate=\"REGISTER.ERRORS.REQ\">\nThis field is required</div><div ng-message=\"minlength\" translate=\"REGISTER.ERRORS.SHORT\">\nYour entry is not long enough.</div></div></md-autocomplete><md-input-container class=\"md-block\" md-no-float flex>\n<label>Ruolo nell\'ente</label><md-select name=\"designation\" ng-model=\"vm.persondata.designation\" \nplaceholder=\"Ruolo nell\'ente\"><md-option ng-repeat=\"parentorg in vm.roles\" ng-value=\"parentorg.id\">\n{{parentorg.descrizione}}</md-option></md-select><div ng-messages=\"personForm.designation.$error\" \nng-if=\"personForm.birthcity.$touched\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.ORGTYPEPARENT_REQUIRED\">Organization Type Parent field is required</span></div></div>\n</md-input-container></div><md-content><ng-messages ng-show=\"mobileverification\" role=\"alert\"><span class=\"help-block\">\n<i class=\"icon icon-message-text-outline\"></i> CONTROLLA IL TUO TELEFONO</span></ng-messages><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around center\" layout-wrap><md-button type=\"button\" ng-hide=\"personForm.$valid\" \nclass=\"md-raised md-accent md-primary\" aria-label=\"BACKWARD\" translate=\"REGISTER.AC_BACKWARD\" \ntranslate-attr-aria-label=\"REGISTER.AC_BACKWARD\" ng-click=\"vm.backward(\'app.sprardb_auth_register\')\">BACKWARD\n</md-button><md-button type=\"submit\" ng-disabled=\"personForm.$invalid\" class=\"md-raised md-accent md-primary\" \nplacehonder=\"CREATE MY ACCOUNT\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.createProfile($event)\">FORWARD</md-button></div>\n</md-content></form></div></div></div>");
$templateCache.put("app/main/sprardb/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"md-title\"><i class=\"icon-account-network s18\"></i>\n Registrazione nuovo operatore Ente Segnalatore</div><form name=\"registerForm\" novalidate><div id=\"firststep\" \nng-if=\"!vm.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\"><p>\nPrima di effettuare la tua registrazione nella Banca Dati, inserisci il codice del tuo <b>Ente Segnalatore</b>\n di riferimento.<br>Se non lo hai ancora ricevuto, <a class=\"link\" ui-sref=\"app.sprardb_auth_register2\"><b>\nrichiedilo al tuo Ente</b></a>.</p></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex>\n<label>Codice Ente Segnalatore</label><md-icon md-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input \ntype=\"codiceSegnalatore\" name=\"codiceSegnalatore\" ng-model=\"vm.persondata.codiceSegnalatore\" \nng-change=\"vm.resetCodice()\" required><div ng-messages=\"registerForm.codiceSegnalatore.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il codice segnalatore è richiesto</span></div><ng-message class=\"help-block\" \nwhen=\"notexists\"><span>Codice inserito è inesistente.</span></ng-message></div></md-input-container></div></div><div \nid=\"secondstep\" ng-if=\"vm.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 24px\"><label>Ente di riferimento:</label>&nbsp;<b>{{vm.responseCodice.nome}}</b></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Cognome</label><md-icon \nmd-font-icon=\"icon-clipboard-account\" class=\"blue-grey-800-fg\"></md-icon><input type=\"cognome\" name=\"cognome\" \nng-model=\"vm.persondata.cognome\" placeholder=\"Last Name\" translate translate-attr-placeholder=\"REGISTER.COGNAME\" \nrequired><div ng-messages=\"registerForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.COGNAME_REQUIRED\">Cognome field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float flex><label>Nome</label><md-icon \nmd-font-icon=\"icon-clipboard-account\" class=\"blue-grey-800-fg\"></md-icon><input name=\"nome\" \nng-model=\"vm.persondata.nome\" placeholder=\"First Name\" translate translate-attr-placeholder=\"REGISTER.NOME\" required>\n<div ng-messages=\"registerForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.NOME_REQUIRED\">Name field is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Codice Fiscale</label><md-icon \nmd-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"codiceFiscale\" \nng-model=\"vm.persondata.codiceFiscale\" placeholder=\"Codice Fiscale\" \nng-pattern=\"/^[a-zA-Z]{6}[a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{3}[a-zA-Z]$/\" \nng-change=\"vm.checkCf($event)\" required><div ng-messages=\"registerForm.codiceFiscale.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Codice Fiscale è richiesto</span></div><div ng-message=\"pattern\">\n<span>Codice Fiscale invalido</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nCodice Fiscale già in uso. Contattare SC.</span></ng-message></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float flex><label>Genere</label><md-icon md-font-icon=\"icon-gender-male-female\" \nclass=\"blue-grey-800-fg\"></md-icon><md-select ng-model=\"vm.persondata.sesso\" name=\"sesso\" placeholder=\"Genere\" \nrequired><md-option ng-repeat=\"n in [{id: \'M\', value: \'MASCHIO\'}, {id: \'F\', value: \'FEMMINA\'}]\" ng-value=\"n.id\" \nng-selected=\"{{vm.persondata.sesso == n.id}}\">{{ n.value}}</md-option></md-select><div class=\"errors\" \nng-messages=\"registerForm.sesso.$error\"><div ng-message=\"required\">Genere richiesto</div></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><div layout=\"column\" flex style=\"margin-bottom:16px\" class=\"datepicker-container\" \nmd-no-float flex><label flex>Data di nascita *</label><div flex><md-datepicker ng-model=\"vm.persondata.dataNascita\" \nmd-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" ng-required=\"true\" md-placeholder=\"Data di nascita\" \nname=\"dataNascita\" flex></md-datepicker></div></div><md-input-container class=\"md-block\" md-no-float flex><label>\nTelefono mobile</label><md-icon md-font-icon=\"icon-cellphone-android\" class=\"blue-grey-800-fg\"></md-icon><input \nname=\"telefono\" ng-model=\"vm.persondata.telefono\" ng-pattern=\"/^\\+?\\d+$/im\" minlength=\"10\" maxlength=\"13\" \nplaceholder=\"Telephone\" translate translate-attr-placeholder=\"REGISTER.TELEPHONE\" required><div \nng-messages=\"registerForm.telefono.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span>\nTelefono deve essere lungo tra 10 e 13 caratteri, iniziare con +39, senza spazi.</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Telefono esistente contattare SC.</span></ng-message></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Ruolo nell\'ente</label>\n<md-select name=\"designation\" ng-model=\"vm.persondata.designation\" placeholder=\"Ruolo nell\'ente\" \nstyle=\"padding-bottom: 24px\" required><md-option ng-repeat=\"parentorg in vm.roles| filter: {id: 26}\" \nng-value=\"parentorg.id\">{{parentorg.descrizione}}</md-option></md-select><div \nng-messages=\"registerForm.designation.$error\" ng-if=\"registerForm.birthcity.$touched\"><div ng-message=\"required\">\nRuolo richiesto</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 24px\"><b>Dati per autenticazione</b></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"blue-grey-800-fg\">\n</md-icon><input type=\"email\" name=\"email\" ng-model=\"vm.persondata.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"vm.checkEmail($event)\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail è richiesta</span></div><div ng-message=\"pattern\"><span>Email invalida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span></ng-message></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float show-errors flex>\n<label>Nome utente</label><md-icon md-font-icon=\"icon-account-key\" class=\"blue-grey-800-fg\"></md-icon><input \nname=\"username\" ng-model=\"vm.persondata.username\" \nng-model-options=\"{\n                                        debounce: 1500\n                                    }\" \nng-change=\"vm.preregister($event)\" placeholder=\"Username\" maxlength=\"15\" minlength=\"5\" translate \ntranslate-attr-placeholder=\"REGISTER.USERNAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Nome utente è richiesto</span></div><ng-message class=\"help-block\" when=\"unique\">\n<span>Nome utente già in uso</span></ng-message><div ng-message=\"minlength\"><span>\nIl nome utente deve essere di almeno 5 caratteri.</span></div><div ng-message=\"maxlength\"><span>\nIl nome utente deve essere al massimo di 15 caratteri.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Password</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.persondata.password\" placeholder=\"Password\" minlength=\"8\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password obbligatoria</span>\n</div><div ng-message=\"minlength\"><span>La password deve essere di almeno 8 caratteri.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Password conferma</label><input \ntype=\"password\" name=\"passwordc\" ng-model=\"vm.persondata.passwordc\" placeholder=\"Password conferma\" \nng-change=\"vm.resetConfirmpass($event)\" required><div ng-messages=\"registerForm.passwordc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password di conferma è obbligatoria.</span></div><div ng-message=\"passwordVerify\"><span>\nPassword di conferma non coincide</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-align=\"center center\" style=\"padding: 16px 0px\" class=\"md-amber-50-bg\" \nng-show=\"registerForm.email.$error.unique || registerForm.username.$error.unique || registerForm.codiceFiscale.$error.unique\">\n<span><i class=\"icon-help-circle s18\"></i>&nbsp;&nbsp;Hai dimenticato le tue credenziali?</span><div \nng-messages=\"registerForm\" role=\"alert\" multiple=\"multiple\"><small><a ui-sref=\"app.sprardb_auth_forgot-password\">\nRecupera le tue credenziali</a></small></div><div ng-messages=\"registerForm\" role=\"alert\" multiple=\"multiple\"><small><a\n ui-sref=\"app.sprardb_auth_login\">Vai alla pagina di Login</a></small></div><span>Oppure</span><div \nng-if=\"registerForm.username.$error.unique\"><small><a class=\"link\" href=\"https://assistenza.serviziocentrale.it/\" \ntarget=\"_blank\">Clicca qui per contattare l\'assistenza Tecnica del Servizio Centrale.</a></small></div><div \nng-if=\"registerForm.email.$error.unique\"><small><a class=\"link\" href=\"https://assistenza.serviziocentrale.it/\" \ntarget=\"_blank\">Clicca qui per contattare l\'assistenza Tecnica del Servizio Centrale.</a></small></div><div \nng-if=\"registerForm.codiceFiscale.$error.unique\"><small><a class=\"link\" href=\"https://assistenza.serviziocentrale.it/\" \ntarget=\"_blank\">Clicca qui per contattare l\'assistenza Tecnica del Servizio Centrale.</a></small></div></div><div \nclass=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"vm.data.cb1\" \naria-label=\"I read and accept\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span>\nHo letto e accetto </span><a href=\"{{vm.baseUrl}}privacy.pdf\" class=\"md-accent-color\" target=\"_blank\">privacy policy\n</a></div></div></div><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap \nng-show=\"vm.showfarebut2\"><md-button type=\"button\" class=\"md-raised submit-button\" aria-label=\"BACKLOGIN\" \nui-sref=\"app.sprardb_auth_login\">TORNA LOGIN</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CONTROLLA_CODICE\" ng-click=\" vm.checkCodice($event)\">\nPROSEGUI LA REGISTRAZIONE</md-button></section><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" \nlayout-wrap ng-show=\"vm.showfarebut1\"><md-button type=\"button\" class=\"md-raised md-accent md-primary\" \nng-disabled=\"registerForm.$valid\" aria-label=\"INDIETRO\" ng-click=\"vm.indietro($event)\">INDIETRO</md-button><md-button \ntype=\"submit\" ng-show=\"vm.showfarebut1\" class=\"md-raised md-accent md-primary\" aria-label=\"FORWARD\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" ng-click=\"vm.register($event)\">REGISTRAMI</md-button>\n</section></form></div></div></div>");
$templateCache.put("app/main/sprardb/auth/register/register2.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"md-title\"><i class=\"icon-account-network s18\"></i> Registrazione Ente Segnalatore</div><form \nname=\"registerForm\" novalidate><div id=\"firststep\" ng-if=\"!vm.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\" \nstyle=\"margin-bottom: 16px\"><small>\nPrima di effettuare la registrazione di un nuovo ente nella Banca Dati, cerca il tuo <b>Ente Segnalatore</b>\n di riferimento.<br>Se presente cliccare su <b>\'Richiedilo al tuo Ente\'</b>\n per ottenere le indicazioni per il recupero del <b>codice di autorizzazione dell’Ente</b>\n necessario per effettuare le registrazioni delle persone autorizzate all’invio delle segnalazioni.<br>\nSe non presente cliccare <b>\'Ente non presente\'</b> per continuare con la registrazione del nuovo Ente.<br><br>\nUtilizza i <u>filtri messi a disposizione</u> oppure la <u>ricerca libera</u>.</small></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Regione</label><md-icon \nmd-font-icon=\"icon-map-marker-radius\" class=\"blue-grey-800-fg\"></md-icon><md-select name=\"regione\" \nng-model=\"vm.ricerca.codRegione\" placeholder=\"Regione\" style=\"padding-bottom: 24px\" ng-change=\"vm.onSearch()\">\n<md-option ng-repeat=\"item in vm.regiones\" ng-value=\"item.id\"><small>{{item.regione|uppercase}}</small></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Ente Tipo</label><md-icon\n md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"blue-grey-800-fg\"></md-icon><md-select name=\"comune\" \nng-model=\"vm.ricerca.enteTipo_id\" placeholder=\"Ente tipo\" style=\"padding-bottom: 24px\" ng-change=\"vm.onSearch()\" \nmultiple=\"multiple\"><md-option ng-repeat=\"item in vm.entetipos| filterByArray:[1, 3]:\'settore_id\'\" ng-value=\"item.id\">\n<small><b>{{item.descrizione|uppercase}}</b></small></md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Ricerca libera per nome</label><md-icon\n md-font-icon=\"icon-format-color\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"nome\" \nng-model=\"vm.ricerca.nome\" ng-change=\"vm.onSearch()\" ng-model-options=\"{debounce: 500}\" \nplaceholder=\"Inserisci il nome\"></md-input-container></div><md-list flex><md-subheader class=\"md-no-sticky\"><b>\n{{vm.counts}}</b> Enti segnalatori trovati</md-subheader><md-divider></md-divider><md-list-item \nng-repeat=\"item in vm.entesegnalatores\" ng-if=\"vm.searched\"><md-button \nclass=\"md-fab md-mini {{vm.colors[item.enteTipo_id]}} no-margin\" aria-label=\"tipos\">\n{{item.entetipo.descrizione|limitTo: 1}}<md-tooltip><span>{{item.entetipo.descrizione}} </span></md-tooltip>\n</md-button><div class=\"md-list-item-text\" style=\"margin-left: 16px\"><h3 style=\"margin-bottom: 0px\">{{ item.nome}}</h3>\n<p style=\"margin-top: 0px;margin-bottom: 0px\">{{item.indirizzo}} - {{item.cap}} - <b>{{item.istats.comune}}</b></p><p \nstyle=\"margin-top: 0px\"><b><a href=\"mailto:{{item.email}}\">{{item.email}}</a></b> - Tel: <b>{{item.telefono}}</b></p>\n<md-button class=\"md-secondary\" ng-click=\"vm.dettaglio(item)\">Richiedilo al tuo ente</md-button></div></md-list-item>\n</md-list></div><div id=\"secondstep\" ng-if=\"vm.checkCodiceSegnalatore\"><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><md-select-label ng-class=\"{\'md-warn-fg\': (registerForm.enteTipo_id.$invalid)}\">\nCategoria Ente</md-select-label><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"blue-grey-800-fg\">\n</md-icon><md-select name=\"enteTipo_id\" ng-model=\"vm.persondata.enteTipo_id\" placeholder=\"Categoria Ente\" required>\n<md-option ng-repeat=\"item in vm.entetipos| filterByArray:[1, 3]:\'settore_id\'\" ng-value=\"item.id\"><small><b>\n{{item.descrizione|uppercase}}</b></small></md-option></md-select><div ng-messages=\"registerForm.enteTipo_id.$error\" \nrole=\"alert\"><div ng-message=\"required\">Ente Tipo richiesto</div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float flex><label ng-class=\"{\'md-warn-fg\': (registerForm.nome.$invalid)}\">Nome Ente</label>\n<md-icon md-font-icon=\"icon-clipboard-account\" class=\"blue-grey-800-fg\"></md-icon><input name=\"nome\" \nng-model=\"vm.persondata.nome\" placeholder=\"Nome ente\" required><div ng-messages=\"registerForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.NOME_REQUIRED\">Name field is required</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float flex>\n<label>Cod.Fiscale / P. Iva</label><md-icon md-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input \ntype=\"text\" name=\"piva\" ng-model=\"vm.persondata.piva\" placeholder=\"Codice Fiscale\" \nng-pattern=\"/^[a-zA-Z0-9]{6}[a-zA-Z0-9]{2}[a-zA-Z0-9][a-zA-Z0-9]{2}[a-zA-Z]{0,1}[0-9]{0,3}[a-zA-Z]{0,1}$/\" \nminlength=\"11\" maxlength=\"16\" ng-change=\"vm.checkCf($event)\"><div ng-messages=\"registerForm.piva.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Cod.Fiscale / P. Iva è richiesto</span></div><div \nng-message=\"pattern\"><span>Cod.Fiscale / P. Iva invalido</span></div><ng-message class=\"help-block\" when=\"unique\">\n<span>Cod.Fiscale / P. Iva già in uso. Contattare SC.</span></ng-message><div ng-message=\"minlength,maxlength\"><span>\nIl cap deve essere di 11 o 16 caratteri.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" md-no-float show-errors flex><label \nng-class=\"{\'md-warn-fg\': (registerForm.indirizzo.$invalid)}\">Indirizzo</label><md-icon md-font-icon=\"icon-google-maps\" \nclass=\"blue-grey-800-fg\"></md-icon><input name=\"indirizzo\" ng-model=\"vm.persondata.indirizzo\" placeholder=\"indirizzo\" \nrequired><div ng-messages=\"registerForm.indirizzo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIndirizzo è richiesto</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float \nshow-errors flex><label ng-class=\"{\'md-warn-fg\': (registerForm.cap.$invalid)}\">Cap</label><md-icon \nmd-font-icon=\"icon-numeric\" class=\"blue-grey-800-fg\"></md-icon><input name=\"cap\" ng-model=\"vm.persondata.cap\" \nplaceholder=\"Cap\" minlength=\"5\" maxlength=\"5\" required><div ng-messages=\"registerForm.cap.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Cap è richiesto</span></div><div ng-message=\"minlength,maxlength\"><span>\nIl cap deve essere di 5 caratteri.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label \nng-class=\"{\'md-warn-fg\': (registerForm.telefono.$invalid)}\">Telefono</label><md-icon md-font-icon=\"icon-phone-dots\" \nclass=\"blue-grey-800-fg\"></md-icon><input name=\"telefono\" ng-model=\"vm.persondata.telefono\" ng-pattern=\"/^\\+?\\d+$/im\" \nminlength=\"10\" maxlength=\"13\" placeholder=\"Telefono\" required><div ng-messages=\"registerForm.telefono.$error\" \nmultiple=\"multiple\" md-auto-hide=\"true\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><span \ntranslate=\"REGISTER.ERRORS.TELEPHONE_REQUIRED\">\nYour Telephone must be between 10 and 13 digit long and look like an Zipcode.</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Telefono esistente contattare SC.</span></ng-message></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float flex><label ng-class=\"{\'md-warn-fg\': (registerForm.email.$invalid)}\">\nEmail</label><md-icon md-font-icon=\"icon-email\" class=\"blue-grey-800-fg\"></md-icon><input type=\"email\" name=\"email\" \nng-model=\"vm.persondata.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"vm.checkEmail($event)\" required><div ng-messages=\"registerForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email è richiesta</span></div><div \nng-message=\"pattern\"><span>Email invalida</span></div><ng-message class=\"help-block\" when=\"unique\"><span>\nEmail già in uso oppure non inserita. Contattare SC.</span></ng-message></div></md-input-container></div><div \nlayout=\"row\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (registerForm.codRegione.$invalid)}\">Regione</md-select-label><md-icon \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><md-select name=\"codRegione\" ng-model=\"vm.persondata.codRegione\" \nng-change=\"vm.caricaProvince(vm.persondata.codRegione)\" required><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\"><small>{{regione.regione|uppercase}}</small></md-option></md-select><div \nng-messages=\"registerForm.codRegione.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex required><md-select-label \nng-class=\"{\'md-warn-fg\': (registerForm.codProvincia.$invalid)}\">Provincia</md-select-label><md-select \nname=\"codProvincia\" ng-model=\"vm.persondata.codProvincia\" ng-disabled=\"!vm.persondata.codRegione\" \nng-change=\"vm.caricaComuni(vm.persondata.codProvincia)\" required><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\"><small>{{provincia.provincia|uppercase}}</small></md-option></md-select><div \nng-messages=\"registerForm.codProvincia.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (registerForm.codComune.$invalid)}\">Comune</md-select-label><md-select name=\"codComune\" \nng-model=\"vm.persondata.codComune\" ng-disabled=\"!vm.persondata.codProvincia\" required><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\"><small>{{istat.comune|uppercase}}</small></md-option>\n</md-select><div ng-messages=\"registerForm.codComune.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container></div></div></div><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap ng-show=\"vm.showfarebut2\"><md-button type=\"button\" class=\"md-raised\" \naria-label=\"BACKLOGIN\" ui-sref=\"app.sprardb_auth_login\">INDIETRO</md-button><md-button type=\"button\" \nng-if=\"vm.searched && !vm.showfarebut1\" class=\"md-raised md-accent md-primary\" aria-label=\"CONTROLLA_CODICE\" \nng-click=\" vm.checkCodice($event)\">ENTE NON PRESENTE</md-button></section><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap ng-show=\"vm.showfarebut1\"><md-button type=\"button\" \nclass=\"md-raised md-accent md-primary\" ng-disabled=\"registerForm.$valid\" aria-label=\"INDIETRO\" \nng-click=\"vm.indietro($event)\">INDIETRO</md-button><md-button type=\"submit\" ng-show=\"vm.showfarebut1\" \nclass=\"md-raised md-accent md-primary\" aria-label=\"FORWARD\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" ng-click=\"vm.register($event)\">REGISTRAMI</md-button>\n</section></form></div></div></div>");
$templateCache.put("app/main/sprardb/auth/register/success.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>SC\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><md-content flex layout-padding><p>\nRegistrazione conclusa con successo</p><p><a class=\"link\" ui-sref=\"app.sprardb_auth_login\" translate=\"REGISTER.LOGIN\">\nLog in</a></p></md-content></div></div></div>");
$templateCache.put("app/main/sprardb/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.sprardb_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> {{vm.form.username}}</span></a></div></div></div></div>");
$templateCache.put("app/main/sprardb/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>SC</span></div><div class=\"title\">Reset password</div><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" layout-wrap ng-show=\"showfarebut1\"><p><a class=\"link\" \nui-sref=\"app.sprardb_auth_login\">Vai alla pagina per la LogIn</a></p></section><form name=\"resetPasswordForm\" \nnovalidate><md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" required><div ng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password richiesta</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" \nplaceholder=\"Password (Conferma)\" ng-change=\"vm.resetConfirmpass($event)\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Conferma) è richiesta</span></div><div ng-message=\"passwordVerify\"><span>Password (Conferma) non coincide\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \nng-click=\"vm.resetPass($event)\">RESET PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/dettaglio.html","<div id=\"beneficiario\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.returnBeneficiari()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Beneficiario :&nbsp;</span> <span class=\"logo-text\"><b>\n{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</b></span> <span class=\"logo-text\">&nbsp;&nbsp;<b>\ncod.&nbsp;{{vm.beneficiario.codice}}</b></span></div></div></div><div><md-button type=\"submit\" \nng-click=\"vm.save(vm.isnew)\" class=\"md-raised md-background\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza) || personaNForm.$invalid || personaNForm.$pristine || vm.isomonimo\" \nng-if=\"vm.beneficiario.def == 1 && !vm.isReadOnly && !vm.api.isReadOnly && !vm.beneficiario.cancellato\" \naria-label=\"SALVA\"><span>SALVA</span></md-button><md-button type=\"submit\" ng-click=\"vm.save(vm.isnew)\" \nclass=\"md-raised md-background\" \nng-if=\"vm.beneficiario.def == 1 && !vm.isReadOnly && (vm.api.isOperatore || vm.api.isAmministratore) && !vm.isomonimo && !vm.beneficiario.cancellato\" \naria-label=\"SALVA\"><span>AGGIORNA</span></md-button></div></div><div class=\"content dettaglio\" ms-scroll><form \nname=\"personaNForm\" novalidate \nng-style=\"{\'background-color\': vm.beneficiario.cancellato ? \'rgba(255,0,0,0.2)\' : \'rgba(255,255,255,1)\'}\"><div><span \nng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">ERRORI NEL FORM: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\"><small \nclass=\"md-warn-fg\">{{vm.genericValidationError[key]}}</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><md-tabs md-dynamic-height><md-tab label=\"PRINCIPALE\"><div id=\"principaletab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>PROGETTO ACCOGLIENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><b>PROGETTO</b></label><input type=\"text\" name=\"progetto_id\" value=\"{{vm.beneficiario.progetto.nome}}\" \nplaceholder=\"Progetto\" disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.beneficiario.strutturas| filter: {id:vm.beneficiario.struttura_id}: true  track by item.id\">\n<label><b>STRUTTURA</b></label><input type=\"text\" name=\"struttura_id\" value=\"{{item.nome}}\" placeholder=\"Struttura\" \ndisabled=\"disabled\"><md-button class=\"md-accent md-raised\" \nng-if=\"vm.strutturaCorr.isDisattivabileEsterna && vm.beneficiario.dataUscita !== null\" ng-click=\"vm.popupEsterna()\">\nCHIUDI STRUTTURA</md-button></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label><b>\nTIPO SEGNALAZIONE</b></label><input type=\"text\" name=\"idTipoSegnalazione\" \nvalue=\"{{vm.beneficiario.segnalaziones.tiposegnalazione.descrizione}}\" placeholder=\"Segnalazione\" disabled=\"disabled\">\n</md-input-container></div></div><div flex layout=\"row\" class=\"margin-top-0\" \nng-if=\"vm.beneficiario.trasferimento === 1\"><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.allprogettos| filter:{id:vm.beneficiario.newprogetto_id}:true\"><label><b>PROGETTO DI DESTINAZIONE\n</b></label><input type=\"text\" value=\"{{item.nome}}\" placeholder=\"Progetto\" disabled=\"disabled\"></md-input-container>\n</div><div flex layout=\"row\" class=\"margin-top-0\" \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly && vm.beneficiario.stato === \'BENEFICIARIO\' && !vm.beneficiario.cancellato\">\n<div class=\"row padding-top-8\" ng-repeat=\"item in vm.beneficiario.eventotrasferimentoAs\" flex \nng-if=\"vm.api.isAdmin || vm.beneficiario.eventotrasferimentoAs[0].eventoStato_id == -1\"><md-select-label \nclass=\"light-blue-800-fg\"><b>{{item.eventoTipo.nome}}</b></md-select-label><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b1 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{vm.isallowed(proc) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n<md-button aria-label=\"Segnalazione\" ng-click=\"vm.viewEvento($event, item, \'evento\')\" class=\"md-button-small-n\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><md-tooltip>DETTAGLI</md-tooltip></md-button></div></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>DATI BENEFICIARIO</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cognome.$invalid)}\">Cognome</label><input \ntype=\"text\" name=\"cognome\" ng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" class=\"text-uppercase\" ng-model-options=\"{debounce: 1000}\"><div\n ng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il cognome è richiesto</span>\n</div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.beneficiario.nome\" placeholder=\"Nome\" required ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" \nclass=\"text-uppercase\" ng-model-options=\"{debounce: 1000}\"><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il nome è richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"space-between-center\" class=\"margin-top-16\"><md-input-container flex=\"50\"><label \nng-class=\"{\'md-warn-fg\': (personaForm.codiceVestanet.$invalid)}\">Codice Vestanet</label><input type=\"text\" \nid=\"formDialogVestanet\" name=\"Vestanet\" \nng-init=\"vm.beneficiario.codiceVestanet = vm.beneficiario.codiceVestanet || \'\'\" \nng-model=\"vm.beneficiario.codiceVestanet\" placeholder=\"Codice Vestanet\" onfocus=\"this.value = \'\'\" \nng-disabled=\"vm.checkboxVestanet\" ng-required=\"vm.beneficiario.codiceVestanet !== null\"></md-input-container><div \nflex=\"50\"><label>Codice Vestanet non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxVestanet\" \nng-change=\"vm.checkboxVestanetOnClick()\"></label></div></div><div layout=\"row\" layout-align=\"space-between-center\" \nclass=\"margin-top-16\"><md-input-container flex=\"50\"><label ng-class=\"{\'md-warn-fg\': (personaForm.cui.$invalid)}\">\nCodice Unico di Identificazione</label><input type=\"text\" id=\"formDialogCui\" name=\"Cui\" \nng-init=\"vm.beneficiario.cui = vm.beneficiario.cui || \'\'\" ng-model=\"vm.beneficiario.cui\" placeholder=\"Codice CUI\" \nonfocus=\"this.value = \'\'\" ng-disabled=\"vm.checkboxCui\" ng-required=\"vm.beneficiario.cui !== null\"></md-input-container>\n<div flex=\"50\"><label>Codice CUI non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxCui\" \nng-change=\"vm.checkboxCuiOnClick()\"></label></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso</md-select-label><md-select name=\"sesso\" \nng-model=\"vm.beneficiario.sesso\" placeholder=\"Sesso\" required ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\">\n<md-option value=\"M\"><small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nazionalita.$invalid)}\">Nazionalita</md-select-label><md-select \nname=\"nazionalita\" placeholder=\"Nazionalita\" ng-model=\"vm.beneficiario.codNazionalita\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-option ng-repeat=\"item in vm.nazionalitas\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.nazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nazionalita richiesta\n</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataNascita == null)}\" flex style=\"max-height: 22px\">Data Nascita<sup>*</sup>\n</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataNascita\" \nng-model=\"vm.beneficiario.dataNascita\" md-placeholder=\"Data di Nascita\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker><div \nng-messages=\"personaNForm.dataNascita.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData nascita richiesta</span></small></div></div></div><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.tipoProteziones| filter:{id:vm.beneficiario.tipoProtezione_id}\"><label>Tipo di soggiorno</label>\n<input type=\"text\" name=\"tipop\" value=\"{{item.descrizione}}\" placeholder=\"Tipo di soggiorno...\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo di segnalazione\n</label><input type=\"text\" name=\"tipoSegnalazione\" value=\"{{vm.beneficiario.tipoSegnalazione}}\" \nplaceholder=\"Tipo di segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Stato beneficiario</label><md-select name=\"statob\" placeholder=\"Stato beneficiario\" \nng-model=\"vm.beneficiario.stato\" required disabled=\"disabled\"><md-option \nng-repeat=\"item in vm.ricercaService.statobeneficiarios\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b>\n</small></md-option></md-select><div ng-messages=\"personaNForm.statob.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il campo è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\" \nng-if=\"vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\" ng-if=\"vm.api.isAdminG\">\n<b><label ng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataInizio == null)}\" style=\"pointer-events: all\"><small>\nData Inizio Accoglienza</small> <small ng-if=\"vm.eventiCambioData.length\">(<a ng-click=\"vm.mostraStoricoAccoglienza()\" \nstyle=\"cursor: pointer\">modifiche</a>)</small></label></b><md-icon style=\"color:rgba(0,0,0,0.54); cursor: pointer\" \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==\" \nng-click=\"vm.cambiaDataAccoglienza()\"></md-icon><input readonly=\"readonly\" \nng-model=\"vm.beneficiario.dataInizioDisplay\" name=\"dataInizio\" required ng-click=\"vm.cambiaDataAccoglienza()\" \nplaceholder=\"{{vm.dataOggiDisplay}}\"><div ng-messages=\"personaNForm.dataInizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Data richiesta</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dip.getFullYear() !== 3000\"><label flex style=\"max-height: 22px\">\nData ingresso progetto</label><md-datepicker disabled=\"disabled\" datepicker-validation-fix class=\"md-block\" \nname=\"dataIngressoProgetto\" ng-model=\"vm.beneficiario.dip\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dip.getFullYear() === 3000\"><label flex style=\"max-height: 22px\">\nData ingresso progetto</label><md-datepicker disabled=\"disabled\" datepicker-validation-fix class=\"md-block\" \nname=\"dataIngressoProgettoAlt\"></md-datepicker></div><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data fine accoglienza</label><md-datepicker datepicker-validation-fix class=\"md-block\" \nname=\"dataFine\" ng-model=\"vm.beneficiario.dataFine\" md-min-date=\"vm.beneficiario.dataIngresso\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dup.getFullYear() !== 1900\"><label flex style=\"max-height: 22px\">\nData uscita progetto</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscitaProgetto\" \nng-model=\"vm.beneficiario.dup\" ng-disabled=\"true\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dup.getFullYear() === 1900\"><label flex style=\"max-height: 22px\">\nData uscita progetto</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscitaProgettoAlt\" \nng-disabled=\"true\"></md-datepicker></div><div flex layout=\"column\" class=\"datepicker-container\" \nng-if=\"vm.api.isAdminG\"><label flex style=\"max-height: 22px\">Data Uscita Accoglienza</label><md-datepicker \ndatepicker-validation-fix class=\"md-block\" name=\"dataUscita\" ng-model=\"vm.beneficiario.dataUscita\" \nmd-min-date=\"vm.beneficiario.dataUscita\" ng-disabled=\"(vm.api.isOperatoreG || vm.beneficiario.dataUscita == null)\">\n</md-datepicker></div></div></div><div layout=\"row\" class=\"margin-top-16\" \nng-if=\"vm.beneficiario.stato == \'PRESENTE SUL TERRITORIO\' || vm.beneficiario.stato == \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Inizio Presenza Sul Territorio</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataInizio\" \nng-model=\"vm.beneficiario.dataInizio\" md-min-date=\"vm.beneficiario.dataIngresso\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data fine Presenza Sul Territorio</label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscita\" ng-model=\"vm.beneficiario.dataUscita\" \nmd-min-date=\"vm.beneficiario.dataIngresso\" ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker>\n</div></div><div layout=\"row\" class=\"margin-top-16\"><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataIngresso == null && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\')}\" \nflex style=\"max-height: 22px\">Data Ingresso in Italia<sup>*</sup></label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataIngresso\" ng-model=\"vm.beneficiario.dataIngresso\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker><div \nng-messages=\"personaNForm.dataIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData richiesta</span></small></div></div></div><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.tipologia.$invalid)}\">Tipologia ingresso protetto</md-select-label><md-select \nname=\"tipologia\" placeholder=\"Tipologia ingresso protetto\" ng-model=\"vm.beneficiario.tipologia_id\" \nng-disabled=\"vm.canUpdateTipologia\" required><md-option ng-repeat=\"item in vm.tipologiaBenficiario\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.tipologia.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Tipologia ingresso protetto richiesta</span></div>\n</div></md-input-container><md-input-container flex ng-if=\"[3,7].includes(vm.beneficiario.tipologia_id)\">\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.paeseTerzoProvenienza.$invalid)}\">Paese Terzo Provenienza\n</md-select-label><md-select name=\"paeseTerzoProvenienza\" placeholder=\"Paese Terzo Provenienza...\" \nng-model=\"vm.beneficiario.paeseTerzoProvenienzaId\" required ng-disabled=\"!vm.api.isAdmin\"><md-option \nng-repeat=\"item in vm.paeseProvenienza | filter: {\'tipologiaId\': vm.beneficiario.tipologia_id}\" ng-value=\"item.id\">\n<small><b>{{item.nazione.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.paeseTerzoProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.idTipoIngresso.$invalid)}\">Modalità ingresso in Italia\n</md-select-label><md-select name=\"idTipoIngresso\" ng-model=\"vm.beneficiario.idTipoIngresso\" \nng-required=\"!vm.api.isAdmin\"><md-option ng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.idTipoIngresso == item.id\"><strong><small>{{item.descrizione}}</small></strong>\n</md-option></md-select><div ng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesto</span></div></div></md-input-container></div><div layout=\"row\" class=\"margin-top-16\">\n<md-input-container flex=\"25\" class=\"margin-bottom-0\" \nng-if=\"vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<label>Giorni Totali di Accoglienza</label><input type=\"text\" name=\"gta\" \nvalue=\"{{vm.calcolomontanteeffettuato[vm.beneficiario.id]}}\" required disabled=\"disabled\" class=\"text-uppercase\">\n</md-input-container><md-input-container flex=\"25\" class=\"margin-bottom-0\" \nng-if=\"vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<label>Reinserimento</label><md-select name=\"reinserimento\" ng-model=\"vm.beneficiario.reinserimento\" \nng-disabled=\"!vm.isnew\"><md-option ng-value=\"1\" ng-selected=\"vm.beneficiario.reinserimento == 1\"><strong><small>\nSi, Reinserimento</small></strong></md-option><md-option ng-value=\"0\" ng-selected=\"vm.beneficiario.reinserimento == 0\">\n<strong><small>No</small></strong></md-option></md-select></md-input-container></div><div layout=\"row\"><div \nng-if=\"vm.beneficiario.stato !== \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato !== \'PRESENTE SUL TERRITORIO TERMINATO\'\" \nflex=\"33\"><div class=\"column padding-top-8\" flex><div layout=\"row\" flex><md-button class=\"md-button md-accent-bg\" \naria-label=\"Libera sul territorio\" ng-click=\"vm.liberaBeneficiario()\" flex>Registra come presente sul territorio\n</md-button></div></div></div><div ng-if=\"!vm.isReadOnly && !vm.api.isReadOnly\" flex=\"33\"><div flex \nng-if=\"vm.uscitaottenibile(vm.beneficiario) && !vm.tuttoDisabilitato\"><div class=\"column padding-top-8\" \nng-repeat=\"item in vm.beneficiario.eventouscitas\" flex><md-select-label class=\"light-blue-800-fg\"><b>\n{{item.eventoTipo.nome}}</b></md-select-label><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b1 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{vm.isallowed(proc) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \naria-label=\"Elimina Processo\" ng-style=\"{\'background-color\':\'red\',\'color\':\'white\'}\" \nng-click=\"vm.eliminaProcesso($event, item)\"><small>ELIMINA</small></md-button><md-button aria-label=\"Segnalazione\" \nng-click=\"vm.viewEvento($event, item, \'evento\')\" class=\"md-button-small-n\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><md-tooltip>DETTAGLI</md-tooltip></md-button></div><div \nclass=\"column padding-top-8\" ng-if=\"vm.beneficiario.eventouscitas.length == 0\" flex><sprardb-newprocess \nng-model=\"vm.uscita\"></sprardb-newprocess></div></div><div ng-if=\"vm.beneficiario.stato === \'PRESENTE SUL TERRITORIO\'\" \nflex=\"33\"><div class=\"column padding-top-8\" flex><div layout=\"row\" flex><md-button \naria-label=\"Termina presenza nel territorio\" ng-click=\"vm.terminaNelTerritorio()\" \nclass=\"md-button md-raised md-accent\" flex>TERMINA PRESENZA NEL TERRITORIO</md-button></div></div></div></div><div \nng-if=\"vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"33\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button class=\"md-button md-accent-bg\" ng-click=\"vm.reintegraBeneficiario()\" flex><b>\nRipristina scheda Beneficiario</b></md-button></div></div></div><div \nng-if=\"!vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"33\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button class=\"md-button\" ng-style=\"{\'background-color\': \'red\', \'color\': \'white\'}\" \nng-click=\"vm.cancellaBeneficiario()\" ng-show=\"vm.api.isAdmin\" flex><b>Elimina scheda beneficiario</b></md-button></div>\n</div></div></div></div></md-tab><md-tab label=\"DETTAGLIO\"><div id=\"anagraficatab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>NUCLEI, PARENTELA E NOTE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nucleoFamiliare.$invalid)}\">Stato Parentela</md-select-label><md-select \nname=\"nucleoFamiliare\" placeholder=\"Stato Parentela\" ng-model=\"vm.beneficiario.nucleoFamiliare\" required \nng-change=\"vm.beneficiario.parentela_id = null\"><md-option ng-value=\"item.codice\" \nng-repeat=\"item in vm.nucleofamiliares | filter : {id : \'!694\'}\"><div layout=\"column\"><small><b>{{item.descrizione}}\n</b></small> <small>{{item.note}}</small></div></md-option></md-select><div \nng-messages=\"personaNForm.nucleoFamiliare.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div>\n</div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Parentela</label><md-select \nname=\"parentela_id\" ng-model=\"vm.beneficiario.parentela_id\" ng-required=\"!vm.api.isAdmin\"><md-option \nng-repeat=\"item in vm.parentelas | filtraparentele:[vm.beneficiario.nucleoFamiliare]:\'id\'\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.parentela_id == item.id\"><div layout=\"column\"><small><b>{{item.descrizione}}</b></small> \n<small>{{item.note}} <span ng-if=\"(item.note == \'Nucleo familiare\' && vm.beneficiario.nucleoFamiliare == 0)\">\no monoparentale</span></small></div></md-option></md-select><div ng-messages=\"personaNForm.parentela_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div><div layout=\"row\">\n<ng-form name=\"vm.capofamigliaForm\" ng-if=\"[0,1].indexOf(vm.beneficiario.nucleoFamiliare) !== -1\" flex><span flex \nclass=\"margin-bottom-0\"><label><b>Capofamiglia</b></label><input type=\"text\" name=\"capof_id\" \nng-value=\"vm.beneficiario.capof_id\" placeholder=\"Capofamiglia\" hidden required> <span \nng-if=\"vm.beneficiario.capoFamiglia != null\">\n{{vm.beneficiario.capoFamiglia.cognome}} {{vm.beneficiario.capoFamiglia.nome}} ({{vm.beneficiario.capoFamiglia.codice}})\n</span> <span ng-if=\"vm.beneficiario.capoFamiglia == null\">Capofamiglia non presente</span><md-button \nng-click=\"vm.cambiaCapofamigliaDialog($event,vm.beneficiario.capof_id)\" class=\"md-raised md-background\" \nng-if=\"vm.canSetCapofamiglia\">Associa ad un nucleo</md-button></span></ng-form><md-input-container flex><label>\nVulnerabilita</label><md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" \nng-model=\"vm.beneficiario.idVulnerabilita\"><md-option ng-value=\"0\"><small class=\"text-italic\">Nessuna/o</small>\n</md-option><md-option ng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b>\n</small></md-option></md-select><div ng-messages=\"personaNForm.vulnerabilita_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Note</label><textarea name=\"note\" ng-model=\"vm.beneficiario.note\" \nplaceholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\"></textarea></md-input-container><md-input-container flex>\n<label>Note Sanitarie</label><textarea name=\"noteSanitarie\" ng-model=\"vm.beneficiario.noteSanitarie\" \nplaceholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\"></textarea></md-input-container></div>\n<div layout=\"row\" \nng-if=\"vm.extraSegnalazione !=                                                                       \'{}\'\">\n<md-input-container flex><label>Note dalla segnalazione</label><textarea name=\"note\" ng-model=\"vm.extraSegnalazione\">\n</textarea></md-input-container></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>FAMIGLIA</b></small>\n</md-divider><div layout=\"row\" class=\"margin-top-16\"><md-card><md-table-container><table data-md-table><thead md-head>\n<tr md-row><th md-column></th><th md-column md-order-by=\"nome\">NOME</th><th md-column>COGNOME</th><th md-column>CODICE\n</th><th md-column>PARENTELA</th></tr></thead><tbody md-body ng-repeat=\"item in vm.famiglia\"><tr md-row><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><md-icon ng-if=\"item.capof_id == 0\" \nmd-font-icon=\"icon-account-circle\"><md-tooltip>CAPOFAMIGLIA</md-tooltip></md-icon></div></td><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.nome | uppercase}}</span></div>\n</td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.cognome | uppercase}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.codice}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>\n{{ item.parentelas.descrizione}}</span></div></td></tr></tbody></table></md-table-container></md-card></div><md-divider\n class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI FACOLTATIVE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\"><md-option ng-repeat=\"naz in vm.religioni\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Gruppo Etnico</label><input \ntype=\"text\" name=\"gruppoEtnico\" ng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" \nclass=\"font-size-12\"></md-input-container></div><div layout=\"row\" flex class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.beneficiario.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\"><div ng-messages=\"personaNForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email richiesta</span></div><div \nng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Telefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" \nplaceholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" ng-model=\"vm.beneficiario.codiceFiscale\" \nplaceholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.codiceFiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n</md-tab><md-tab label=\"STATUS GIURIDICO\"><div id=\"statustab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 red-500-fg\"><small><b>STATUS GIURIDICO E PROTEZIONE</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex><label>Manifestazione volontà protezione internazionale\n</label><md-select name=\"interesseExArt\" placeholder=\"Manifestazione volontà protezione internazionale\" \nng-model=\"vm.beneficiario.interesseExArt\" ng-required=\"!vm.api.isAdmin\"><md-option ng-repeat=\"item in vm.sino\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.interesseExArt.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data Manifestazione volontà</label><md-datepicker datepicker-validation-fix \nname=\"dataInteresseExArt\" ng-model=\"vm.beneficiario.dataInteresseExArt\" md-placeholder=\"Data Manifestazione volontà\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\" ng-disabled=\"!vm.beneficiario.interesseExArt && !vm.api.isAdmin\">\n</md-datepicker></div><md-input-container flex><label>Compilazione C3</label><md-select name=\"c3\" \nplaceholder=\"Compilazione C3\" ng-model=\"vm.beneficiario.c3\" ng-required=\"!vm.api.isAdmin\"><md-option \nng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.c3.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div>\n</div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData compilazione C3</label><md-datepicker datepicker-validation-fix name=\"dataC3\" ng-model=\"vm.beneficiario.dataC3\" \nmd-placeholder=\"Data compilazione C3\" md-min-date=\"vm.beneficiario.dataInteresseExArt\" md-max-date=\"vm.oggi\" \nng-disabled=\"(!vm.beneficiario.c3)\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Soggiorno</label><md-select name=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" \nng-model=\"vm.beneficiario.tipoProtezione_id\" ng-required=\"!vm.api.isAdmin\" ng-disabled=\"true\"><md-option \nng-repeat=\"item in vm.tipoProteziones\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.tipoProtezione_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><div flex=\"25\" layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data richiesta protezione</label><md-datepicker \ndatepicker-validation-fix name=\"dataRichiestaProtezione\" ng-model=\"vm.beneficiario.dataRichiestaProtezione\" \nmd-placeholder=\"Data richiesta protezione\" md-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\"></md-datepicker></div>\n<div flex=\"25\" layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data avvenuta notifica\n</label><md-datepicker datepicker-validation-fix name=\"dataAvvenutaNotifica\" \nng-model=\"vm.beneficiario.dataAvvenutaNotifica\" md-placeholder=\"Data avvenuta notifica\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.minDatesafe\" ng-disabled=\"true\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label>Provenienza</label><md-select name=\"idProvenienza\" placeholder=\"Provenienza\" \nng-model=\"vm.beneficiario.idProvenienza\" ng-required=\"!vm.api.isAdmin\"><md-option \nng-repeat=\"item in vm.provenienza.data\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.idProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex><label>Stato Dublino</label>\n<md-select name=\"idDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.beneficiario.idDublino\" \nng-disabled=\"(vm.beneficiario.idProvenienza != 624) && !vm.api.isAdmin\" \nng-required=\"(vm.beneficiario.idProvenienza == 624) && !vm.api.isAdmin\"><md-option ng-repeat=\"item in vm.dublino\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.idDublino.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span>\n</div></div></md-input-container><div layout=\"column\" class=\"datepicker-container\" flex=\"50\"><label flex \nstyle=\"max-height: 22px\">Data richiesta Pds</label><md-datepicker datepicker-validation-fix name=\"dataRichiestaPds\" \nng-model=\"vm.beneficiario.dataRichiestaPds\" md-placeholder=\"Data richiesta Pds\" \nmd-min-date=\"vm.beneficiario.dataInteresseExArt\" md-max-date=\"vm.oggi\"></md-datepicker></div></div><div id=\"nsg\" \nclass=\"margin-top-16\" ng-if=\"!vm.isVisitatore && !vm.beneficiario.cancellato\"><div \nclass=\"row padding-top-8 padding-bottom-8\" ng-repeat=\"item in vm.beneficiario.eventonstatusgs\" flex><md-select-label \nclass=\"light-blue-800-fg\"><b>{{item.eventoTipo.nome}}</b></md-select-label>-<md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b2 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{(vm.isallowed(proc)) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\"><small>FINITO</small></md-button><md-button \naria-label=\"Segnalazione\" ng-click=\"vm.viewEvento($event, item, \'evento\')\" class=\"md-button-small-n\" ng-if=\"item\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><md-tooltip>DETTAGLI</md-tooltip></md-button></div><div \nclass=\"row padding-top-8 padding-bottom-8\" ng-repeat=\"item in vm.beneficiario.eventonstatusg2s\" \nng-if=\"!vm.api.isVisitatore\" flex><md-select-label class=\"light-blue-800-fg\"><b>{{item.eventoTipo.nome}}</b>\n</md-select-label><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b2 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{(vm.isallowed(proc)) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\"><small>FINITO</small></md-button><md-button \naria-label=\"Segnalazione\" ng-click=\"vm.viewEvento($event, item, \'evento\')\" class=\"md-button-small-n\" ng-if=\"item\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><md-tooltip>DETTAGLI</md-tooltip></md-button></div><div \nclass=\"row\" flex=\"25\" ng-if=\"!vm.api.isReadOnly && !vm.api.isTutor\"><sprardb-newprocess2 ng-model=\"vm.nsg\">\n</sprardb-newprocess2></div><div class=\"row\" flex=\"25\" ng-if=\"vm.api.isAdmin\"><sprardb-newprocess2 ng-model=\"vm.nsg2\">\n</sprardb-newprocess2></div></div><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg margin-top-16\"><small>\n<b>ULTIMO DOCUMENTO BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container \nflex><label>Documento di soggiorno</label><md-select name=\"idTipoDocumento\" placeholder=\"Documento di soggiorno...\" \nng-model=\"vm.beneficiario.idTipoDocumento\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-change=\"vm.cambiaDocumento()\"><md-option \nng-repeat=\"item in vm.tipoDocumento\" ng-value=\"item.id\" \nng-disabled=\"vm.documentoAbilitato(item, vm.beneficiario.tipoProtezione_id)\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.idTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il campo è richiesto</span></div></div></md-input-container><div class=\"row padding-top-8\" \nng-repeat=\"item in vm.beneficiario.eventodocumentos\" flex ng-if=\"!vm.isReadOnly && !vm.api.isReadOnly\"><md-select-label\n class=\"light-blue-800-fg\"><b>{{item.eventoTipo.nome}}</b></md-select-label><md-button \nng-repeat=\"proc in item.processi| filter: \'(\' + item.eventoStato_id + \',\' track by $index\" \nclass=\"md-button-small-b1 {{vm.colors[processo[1]]}}\" aria-label=\"changestatus-{{$index}}\" \nng-init=\"processo = proc.replace(\'(\', \'\').replace(\')\', \'\').split(\',\')\" \nng-click=\"vm.work($event, item, processo[1], processo[2], false)\" ng-disabled=\"!vm.isallowed(proc)\"><div \nlayout=\"column\" style=\"line-height: 16px\"><md-icon \nmd-font-icon=\"{{vm.isallowed(proc) ? vm.icons[processo[1]] : \'icon-lock-outline\'}} md-background-fg\" class=\"s14\">\n</md-icon><small>{{processo[2]|uppercase}}</small></div><md-tooltip><span>\n{{vm.isallowed(proc) ? (processo[2] | uppercase) : \'NON PERMESSO\'}}</span></md-tooltip></md-button><md-button \nng-repeat=\"proc in item.processi| filter: \'(END,\' + item.eventoStato_id + \')\' track by $index\" \nclass=\"md-button-small-x2 md-grey-100-bg\" aria-label=\"nessuno\" ng-disabled=\"true\"><small>FINITO</small></md-button>\n<md-button aria-label=\"Segnalazione\" ng-click=\"vm.viewEvento($event, item, \'evento\')\" class=\"md-button-small-n\">\n<md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><md-tooltip>DETTAGLI</md-tooltip></md-button></div><div \nclass=\"row\" ng-if=\"vm.beneficiario.eventodocumentos.length == 0 && !vm.isReadOnly && !vm.api.isReadOnly\" flex>\n<sprardb-newprocess ng-model=\"vm.newdoc\"></sprardb-newprocess></div><md-input-container flex=\"25\"><label>\nDocumento rilasciato da</label><md-select name=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" \nng-model=\"vm.beneficiario.enteDocumento_id\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-option ng-repeat=\"item in vm.enteDocumentoids\" \nng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.enteDocumento_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><md-input-container flex=\"25\"><label>Documento Numero</label><input \ntype=\"text\" name=\"documentoNumero\" ng-model=\"vm.beneficiario.documentoNumero\" \nplaceholder=\"Inserire numero documento...\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><div ng-messages=\"personaNForm.documentoNumero.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Rilascio documento</label><md-datepicker datepicker-validation-fix name=\"dataRilascioDocumento\" \nng-change=\"vm.cambiaDataR(vm.beneficiario.dataRilascioDocumento, vm.beneficiario.dataInizio, vm.beneficiario.dataFine)\" \nng-model=\"vm.beneficiario.dataRilascioDocumento\" md-placeholder=\"Data Rilascio Documento\" \nmd-min-date=\"vm.beneficiario.dataNascita\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Scadenza documento</label><md-datepicker \ndatepicker-validation-fix name=\"dataScadenzaDocumento\" ng-model=\"vm.beneficiario.dataScadenzaDocumento\" \nmd-placeholder=\"Data Scadenza Documento\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.beneficiario.dataRilascioDocumento\" \nng-required=\"!vm.api.isAdmin\" ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div>\n<md-input-container flex><label>Cambio questura, prefettura, commissione</label><md-select name=\"cambioQPC\" \nplaceholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.beneficiario.cambioQPC\"><md-option \nng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.cambioQPC.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote cambio questura, prefettura, commissione</label><textarea name=\"noteCambioQPC\" \nng-model=\"vm.beneficiario.noteCambioQPC\" placeholder=\"Note cambio questura, prefettura, commissione...\" \naria-label=\"Notecqpc\" rows=\"1\"></textarea></md-input-container></div></div></md-tab><md-tab label=\"IDENTITA E TUTELA\" \nng-if=\"vm.minori\"><div id=\"identitatab\"><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nIDENTITA\' MINORE E TUTELA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex>\n<label>Tipo Documento Identità</label><md-select name=\"iTipoDocumento\" placeholder=\"Tipo Documento Identità\" \nng-model=\"vm.beneficiario.iTipoDocumento\" required><md-option ng-repeat=\"item in vm.iTipoDocumento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><md-input-container flex><label>Luogo Rilascio Documento</label><md-select \nname=\"iLuogoDocumento\" placeholder=\"Luogo Rilascio Documento\" ng-model=\"vm.beneficiario.iLuogoDocumento\" required>\n<md-option ng-repeat=\"item in vm.iLuogoDocumento\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b>\n</small></md-option></md-select><div ng-messages=\"personaNForm.iLuogoDocumento.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex>\n<label>Modalità di Accertamento</label><md-select name=\"iModalitaAccertamento\" placeholder=\"Modalità di Accertamento\" \nng-model=\"vm.beneficiario.iModalitaAccertamento\" required><md-option ng-repeat=\"item in vm.iModalitaAccertamento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iModalitaAccertamento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote Accertamento età</label><textarea name=\"iNoteAccertamento\" ng-model=\"vm.beneficiario.iNoteAccertamento\" \nplaceholder=\"Note Accertamento età...\" aria-label=\"iNoteAccertamento\" rows=\"1\"></textarea></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><label>Richiesta Apertura Tutela</label><md-select name=\"iRichiestaTutela\" \nplaceholder=\"Richiesta Apertura Tutela\" ng-model=\"vm.beneficiario.iRichiestaTutela\" required><md-option \nng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iRichiestaTutela.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data Richiesta Apertura Tutela</label><md-datepicker datepicker-validation-fix \nname=\"iDataRichiestaTutela\" ng-model=\"vm.beneficiario.iDataRichiestaTutela\" \nmd-placeholder=\"Data Richiesta Apertura Tutela\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.minDated\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" ng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div>\n<div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Apertura Tutela\n</label><md-datepicker datepicker-validation-fix name=\"iDataAperturaTutela\" \nng-model=\"vm.beneficiario.iDataAperturaTutela\" md-placeholder=\"Data Apertura Tutela\" md-max-date=\"vm.maxDated\" \nmd-min-date=\"vm.beneficiario.iDataRichiestaTutela\" ng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" \nng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label>Cognome e Nome Tutore</label><input type=\"text\" name=\"iTutore\" ng-model=\"vm.beneficiario.iTutore\" \nplaceholder=\"Cognome e Nome Tutore\" required><div ng-messages=\"personaNForm.iTutore.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container>\n<md-input-container flex><label>Qualifica del Tutore</label><md-select name=\"iQualifica\" \nplaceholder=\"Qualifica del Tutore\" ng-model=\"vm.beneficiario.iQualifica\" required><md-option \nng-repeat=\"item in vm.iQualifica\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.iQualifica.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nCognome e Nome Responsabile Struttura</label><input type=\"text\" name=\"iResponsabile\" \nng-model=\"vm.beneficiario.iResponsabile\" placeholder=\"Cognome e Nome Responsabile Struttura\" \nng-disabled=\"(vm.beneficiario.iRichiestaTutela)\"><div ng-messages=\"personaNForm.iResponsabile.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container>\n<md-input-container flex><label>Tribunale Compentente</label><input type=\"text\" name=\"iTribunale\" \nng-model=\"vm.beneficiario.iTribunale\" placeholder=\"Tribunale Compentente\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\"><div ng-messages=\"personaNForm.iTribunale.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div>\n</md-tab><md-tab label=\"STRUTTURE\" ng-if=\"!vm.isnew && vm.beneficiario.def == 1\"><div id=\"strutturetab\"><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nelle strutture\" type=\"text\" ng-model=\"vm.ssearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card style=\"padding-top:0px\" ng-if=\"vm.beneficiario.struttura_id\"><md-table-container id=\"tabellar\"><table \ndata-md-table><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod.</th><th md-column md-order-by=\"nome\">NOME</th><th md-column>DATA INSERIMENTO</th><th \nmd-column>DATA CESSAZIONE</th><th md-column md-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>ACCOGLIENZA</th><th \nmd-column>TIPOLOGIA</th><th md-column md-order-by=\"attivo\" style=\"text-align: center\">ATTIVO</th><th md-column \nstyle=\"text-align: center\" md-order-by=\"numeroStanze\">STANZE</th><th md-column style=\"text-align: center\" \nmd-order-by=\"numeroPosti\">POSTI</th><th md-column style=\"text-align: right\"></th></tr></thead><tbody md-body \nng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios track by preitem.id\"><tr md-row \nng-repeat=\"item in vm.beneficiario.strutturas| filter: {id:preitem.struttura_id} | filter: {id: vm.beneficiario.struttura_id}\" \nng-if=\"preitem.dataCessazione == null\"><td md-cell>{{item.id}}</td><td class=\"light-blue-900-fg font-weight-600\" \nmd-cell><div layout=\"column\"><span>{{ item.nome | uppercase}}</span><md-progress-linear md-mode=\"determinate\" \nclass=\"md-accent-fg\" value=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\">\n</md-progress-linear><span>{{item.progettos.nome|uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{item.indirizzo|uppercase|limitTo:25}}...</span> <span><b>{{item.istats.comune| uppercase}}</b></span> <span>\n{{item.istats.provincia| uppercase}}</span></div></td><td md-cell style=\"text-align:center;padding-right:4px\"><span \nng-if=\"item.esterna\">ESTERNA</span></td><td md-cell><div layout=\"column\"><span><b>\n{{item.strutturaAccoglienzas.descrizione}}</b></span> <span>{{item.strutturaAlloggios.descrizione}}</span></div></td>\n<td md-cell style=\"text-align: center\"><div layout=\"column\"><md-icon class=\"icon-bookmark-outline\" \nstyle=\"font-size:20px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px\" \nng-if=\"item.attivo == 1\"></md-icon></div></td><td md-cell style=\"text-align: center\"><div layout=\"column\">\n{{item.numeroStanze}}</div></td><td md-cell style=\"text-align: center\"><div layout=\"column\">\n{{item.benefT}} / {{item.numeroPosti}}</div></td><td md-cell style=\"text-align: right\"><div><md-menu \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly\"><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"modifica\" ng-click=\"vm.openDialogs($event, item.id, item.progetto_id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><b><small>MODIFICA STRUTTURA</small></b></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-card><md-card \nng-if=\"!vm.beneficiario.struttura_id\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>Presenze Sul Territorio\n</b></small><div flex></div></div></md-toolbar><md-table-container><table data-md-table><thead md-head><tr md-row><th \nmd-column md-order-by=\"id\"><span>#</span></th><th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">\nSTATO</th><th md-column style=\"text-align: left\" md-order-by=\"eventoTipo_id\">EVENTO</th><th md-column \nmd-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\">FINE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.eventiPresenze track by item.id\"><td md-cell>{{item.id}}</td><td md-cell><md-button \nclass=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">{{item.eventoStato.stato| limitTo:2 }}\n<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b> // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td \nmd-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell><b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell>\n<b>{{item.dataFine| date: \"dd/MM/yyyy\"}}</b></td></tr></tbody></table></md-table-container></md-card><div flex \nlayout=\"row\" class=\"margin-top-16\" ng-if=\"(!vm.isReadOnly && !vm.api.isReadOnly) || !vm.beneficiario.cancellato\"><div \nflex ng-if=\"vm.beneficiario.struttura_id && !vm.beneficiario.cancellato\"><md-button class=\"md-accent md-raised\" \nstyle=\"min-width: fit-content\" aria-label=\"Cambia Struttura\" ng-click=\"vm.cambioStruttura()\">CAMBIA STRUTTURA\n</md-button></div></div></div></md-tab><md-tab ng-if=\"!vm.isnew && vm.beneficiario.def == 1\" label=\"CORSI SERVIZI\"><div\n id=\"strutturecorsiservizitab\"><div id=\"sectionservizi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>SERVIZI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei servizi\" type=\"text\" ng-model=\"vm.sersearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.sersearchYear\" \nplaceholder=\"Anno servizi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">\nNOME SERVIZIO</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\" ng-if=\"!vm.api.isTutor\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.servizios| filter: vm.sersearch | filter: {dataFine:vm.sersearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.servizi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.servizicat\" ng-if=\"sitem.id === item.servizi.servizi_id\"><small>\n{{ sitem.descrizione|uppercase}}</small></span> <span class=\"light-blue-900-fg font-weight-600\">\n{{ item.servizi.descrizione | uppercase}}</span> <span><small>{{ item.servizi.note|uppercase}}</small></span></div>\n</td><td md-cell><div layout=\"column\"><span class=\"light-blue-900-fg font-weight-600\">\n{{ item.progetto.nome | uppercase}}</span> <span><small>{{ item.progetto.istat.comune|uppercase}}</small></span></div>\n</td><td md-cell style=\"text-align: left\"><b>{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell \nstyle=\"text-align: left\"><b>{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phs.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phs.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"><div><md-menu \nng-if=\"!vm.isReadOnly && !vm.api.isTutor\"><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-click=\"vm.openServiziBenDialog($event, vm.beneficiario, item.id, false)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><b><small>MODIFICA</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody>\n</table></md-table-container><div layout=\"row\" \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly && !vm.beneficiario.cancellato && vm.beneficiario.strutturahasbeneficiarios.length !== 0\">\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openServiziBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO SERVIZIO</md-button></div></md-card></div><div id=\"sectioncorsi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>CORSI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei corsi\" type=\"text\" ng-model=\"vm.corsearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.corsearchYear\" \nplaceholder=\"Anno corsi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">NOME CORSO\n</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\" ng-if=\"!vm.api.isTutor\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.corsos| filter: vm.corsearch | filter: {dataFine:vm.corsearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.corsi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.corsicat\" ng-if=\"sitem.id === item.corsi.corsi_id\"><small>{{ sitem.descrizione|uppercase}}\n</small></span> <span class=\"light-blue-900-fg font-weight-600\">{{ item.corsi.descrizione | uppercase}}</span> <span>\n<small>{{ item.corsi.note|uppercase}}</small></span></div></td><td md-cell><div layout=\"column\"><span \nclass=\"light-blue-900-fg font-weight-600\">{{ item.progetto.nome | uppercase}}</span> <span><small>\n{{ item.progetto.istat.comune|uppercase}}</small></span></div></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phc.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phc.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"><div><md-menu \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly\"><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-click=\"vm.openCorsiBenDialog($event, vm.beneficiario, item.id, false)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><b><small>MODIFICA</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody>\n</table></md-table-container><div layout=\"row\" \nng-if=\"!vm.isReadOnly && !vm.api.isReadOnly && !vm.beneficiario.cancellato && vm.beneficiario.strutturahasbeneficiarios.length !== 0\">\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openCorsiBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO CORSO</md-button></div></md-card></div></div></md-tab><md-tab label=\"STORICI\" \nng-if=\"!vm.isnew && vm.beneficiario.def == 1\"><div id=\"storicostatustab\"><div id=\"storicoeventi\"><sprardb-tabellar \ntitolo=\"Storico status giuridico\" ng-model=\"vm.beneficiario.eventoAnstatusgs\" mostrazioni=\"0\" mostradate=\"0\">\n</sprardb-tabellar><md-divider style=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico documenti\" \nng-model=\"vm.beneficiario.eventoAdocumentos\" mostrazioni=\"0\"></sprardb-tabellar><md-divider style=\"margin: 24px 0px\">\n</md-divider><sprardb-tabellar titolo=\"Storico trasferimenti\" ng-model=\"vm.beneficiario.eventoAtrasferimentoCs\" \nmostrazioni=\"0\"></sprardb-tabellar><md-divider style=\"margin: 24px 0px\"></md-divider><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Storico proroghe</b></small><div flex></div></div></md-toolbar><md-table-container>\n<table data-md-table><thead md-head><tr md-row><th md-column md-order-by=\"id\"><span>#</span></th><th md-column \nstyle=\"text-align: center\" md-order-by=\"eventoStato_id\">STATO</th><th md-column style=\"text-align: left\" \nmd-order-by=\"eventoTipo_id\">EVENTO</th><th md-column md-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th \nmd-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th md-column style=\"text-align: center\">PROCESSO\n</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.beneficiario.eventoAprorogas track by item.id\"><td \nmd-cell>{{item.id}}</td><td md-cell><md-button class=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" \naria-label=\"status\">{{item.eventoStato.stato| limitTo:2 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell>\n<b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{(item.eventoStato_id == 4 ? item.extra.dataConcessioneProroga : item.dataFine)| date: \"dd/MM/yyyy\"}}</b> <small \nng-if=\"(item.dataFine == null)\">NON LAVORATO</small></td><td md-cell style=\"text-align: right\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"DettaglioEvento\" \nng-click=\"vm.viewEvento($event, item, \'evento\')\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><b><small>\nDETTAGLIO EVENTO</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"DettaglioExtra\" \nng-click=\"vm.viewEvento($event, item, \'extra\')\"><md-icon md-font-icon=\"icon-details\"></md-icon><b><small>DETTAGLI EXTRA\n</small></b></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n</md-card><md-divider style=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico uscite\" \nng-model=\"vm.beneficiario.eventoAuscitas\" mostrazioni=\"0\"></sprardb-tabellar><md-divider style=\"margin: 24px 0px\">\n</md-divider></div><md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><b>Storico strutture</b></small><div layout=\"row\" flex></div><div flex></div></div>\n</md-toolbar><md-table-container id=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr \nmd-row><th md-column md-order-by=\"nome\">NOME</th><th md-column>DATA INSERIMENTO</th><th md-column>DATA CESSAZIONE</th>\n<th md-column>ACCOGLIENZA</th><th md-column md-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th></tr>\n</thead><tbody md-body ng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios track by preitem.id\"><tr md-row \nng-repeat=\"item in vm.beneficiario.strutturas| filter: {id:preitem.struttura_id}\" \nng-if=\"vm.possovisualizzare(item.progettos.id)\"><td class=\"light-blue-900-fg font-weight-600\" md-cell><div \nlayout=\"column\"><span>{{ vm.nascondiStringa(item.nome, item.progettos.id) | uppercase}}</span><md-progress-linear \nmd-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\"></md-progress-linear>\n<span>{{vm.nascondiStringa(item.progettos.nome, item.progettos.id) | uppercase}}</span></div></td><td md-cell><div \nlayout=\"column\"><span>{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div \nlayout=\"column\"><span>{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><span \nng-if=\"preitem.esterna\">ESTERNA</span></td><td md-cell><div layout=\"column\"><span>\n{{vm.nascondiStringa(item.indirizzo, item.progettos.id) | uppercase | limitTo:25}}...</span> <span><b>\n{{vm.nascondiStringa(item.istats.comune, item.progettos.id) | uppercase}}</b></span> <span>\n{{vm.nascondiStringa(item.istats.provincia, item.progettos.id) | uppercase}}</span></div></td><td md-cell><div \nlayout=\"column\"><span><b>{{vm.nascondiStringa(item.strutturaAccoglienzas.descrizione, item.progettos.id)}}</b></span> \n<span>{{vm.nascondiStringa(item.strutturaAlloggios.descrizione, item.progettos.id)}}</span></div></td></tr></tbody>\n</table></md-table-container></md-card></div></md-tab><md-tab label=\"DOCUMENTI\" \nng-if=\"!vm.isnew && vm.beneficiario.def == 1\"><div id=\"doctab\" ng-if=\"vm.caricamentoultimato\"><sprardb-uploaddocuments3\n ng-model=\"vm.uploadParams\"></sprardb-uploaddocuments3></div></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/dettaglioi.html","<div id=\"beneficiarioi\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" onclick=\"window.history.back()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Beneficiario da completare:&nbsp;</span> <span \nclass=\"logo-text\"><b>{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</b></span></div></div></div><div><md-button \ntype=\"submit\" ng-click=\"vm.completaB()\" \nclass=\"{{(!personaNForm.$invalid)?\'md-raised md-accent\':\'md-warn md-grey-200-bg\'}}\" \nng-if=\"vm.beneficiario.def == 0 && !vm.api.isReadOnly && !vm.api.isTutor\"><i class=\"icon-content-save s14\"></i>\n {{(!personaNForm.$invalid && !vm.isomonimo)?\'SALVA E COMPLETA\':\'DATA ENTRY DA COMPLETARE\'}}</md-button></div></div>\n<div class=\"content dettaglio\" ms-scroll><form name=\"personaNForm\" novalidate class=\"md-background-bg\"><div><span \nng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small>\n</div><md-tabs md-dynamic-height><md-tab class=\"md-background-bg\"><md-tab-label class=\"padding-right-4\"><span>\nPRINCIPALE</span></md-tab-label><md-tab-body class=\"md-background-bg\"><div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>PROGETTO ACCOGLIENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><b>PROGETTO</b></label><input type=\"text\" name=\"progetto_id\" \nvalue=\"{{vm.beneficiario.strutturas[0].progettos.nome}}\" placeholder=\"Progetto\" disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label><b>STRUTTURA</b></label><input \ntype=\"text\" name=\"struttura_id\" value=\"{{vm.beneficiario.strutturas[0].nome}}\" placeholder=\"Struttura\" \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label><b>TIPO SEGNALAZIONE\n</b></label><input type=\"text\" name=\"idTipoSegnalazione\" \nvalue=\"{{vm.beneficiario.segnalaziones.tiposegnalazione.descrizione}}\" placeholder=\"Segnalazione\" disabled=\"disabled\">\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>DATI BENEFICIARIO</b>\n</small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cognome.$invalid)}\">\nCognome</label><input type=\"text\" name=\"cognome\" ng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" class=\"text-uppercase\" ng-model-options=\"{debounce: 1000}\"><div\n ng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il cognome è richiesto</span>\n</div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.beneficiario.nome\" placeholder=\"Nome\" required ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" \nclass=\"text-uppercase\" ng-model-options=\"{debounce: 1000}\"><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il nome è richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"space-between-center\" class=\"margin-top-16\"><md-input-container flex=\"50\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codiceVestanet.$invalid)}\">Codice Vestanet</label><input type=\"text\" \nid=\"formDialogVestanet\" name=\"Vestanet\" \nng-init=\"vm.beneficiario.codiceVestanet = vm.beneficiario.codiceVestanet || \'\'\" \nng-model=\"vm.beneficiario.codiceVestanet\" placeholder=\"Codice Vestanet\" onfocus=\"this.value = \'\'\" \nng-disabled=\"vm.checkboxVestanet\" ng-required=\"vm.beneficiario.codiceVestanet !== null\"></md-input-container><div \nflex=\"50\"><label>Codice Vestanet non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxVestanet\" \nng-change=\"vm.checkboxVestanetOnClick()\"></label></div></div><div layout=\"row\" layout-align=\"space-between-center\" \nclass=\"margin-top-16\"><md-input-container flex=\"50\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cui.$invalid)}\">\nCodice Unico di Identificazione</label><input type=\"text\" id=\"formDialogCui\" name=\"Cui\" \nng-init=\"vm.beneficiario.cui = vm.beneficiario.cui || \'\'\" ng-model=\"vm.beneficiario.cui\" placeholder=\"Codice CUI\" \nonfocus=\"this.value = \'\'\" ng-disabled=\"vm.checkboxCui\" ng-required=\"vm.beneficiario.cui !== null\"></md-input-container>\n<div flex=\"50\"><label>Codice CUI non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxCui\" \nng-change=\"vm.checkboxCuiOnClick()\" ng-init=\"vm.checkboxCui\"></label></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso</md-select-label><md-select name=\"sesso\" \nng-model=\"vm.beneficiario.sesso\" placeholder=\"Sesso\" required ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\">\n<md-option value=\"M\"><small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILELE</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nazionalita.$invalid)}\">Nazionalita</md-select-label><md-select \nname=\"nazionalita\" placeholder=\"Nazionalita\" ng-model=\"vm.beneficiario.codNazionalita\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-option ng-repeat=\"item in vm.nazionalitas\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.nazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nazionalita riciesta</span>\n</div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataNascita == null)}\" flex style=\"max-height: 22px\">Data Nascita<sup>*</sup>\n</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataNascita\" \nng-model=\"vm.beneficiario.dataNascita\" md-placeholder=\"Data di Nascita\" ng-required=\"true\"></md-datepicker><div \nng-messages=\"personaNForm.dataNascita.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData nascita richiesta</span></small></div></div></div><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.tipoProteziones| filter:{id:vm.beneficiario.tipoProtezione_id}\"><label>Tipo di soggiorno</label>\n<input type=\"text\" name=\"tipop\" value=\"{{item.descrizione}}\" placeholder=\"Tipo di soggiorno...\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo di segnalazione\n</label><input type=\"text\" name=\"tipoSegnalazione\" value=\"{{vm.beneficiario.tipoSegnalazione}}\" \nplaceholder=\"Tipo di segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Stato beneficiario</label><input type=\"text\" name=\"statob\" \nvalue=\"{{vm.beneficiario.stato}}\" placeholder=\"Stato beneficiario...\" required disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\" ng-if=\"vm.api.isAdminG\"><label>Data Inizio accoglienza</label><input \ntype=\"text\" name=\"dataInizio\" value=\"{{vm.beneficiario.dataInizio|date:\'dd/MM/yyyy\'}}\" placeholder=\"Data inizio...\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>\nData Ingresso nel Progetto</label><input type=\"text\" name=\"dataIngressoProgetto\" \nvalue=\"{{vm.beneficiario.dip|date:\'dd/MM/yyyy\'}}\" placeholder=\"Data inizio...\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Data fine accoglienza</label><input \ntype=\"text\" name=\"dataFine\" \nvalue=\"{{(vm.beneficiario.dataFine)?(vm.beneficiario.dataFine | date:\'dd/MM/yyyy\'):\'nessuna\'}}\" \nplaceholder=\"Data fine\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Data Uscita nel Progetto</label><input type=\"text\" name=\"dataUscitaProgetto\" \nvalue=\"{{vm.beneficiario.dup|date:\'dd/MM/yyyy\'}}\" placeholder=\"Data uscita...\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\" ng-if=\"vm.api.isAdminG\"><label>Data uscita\n</label><input type=\"text\" name=\"dataUscita\" \nvalue=\"{{(vm.beneficiario.dataUscita)?(vm.beneficiario.dataUscita | date:\'dd/MM/yyyy\'):\'nessuna\'}}\" \nplaceholder=\"Data Uscita\" required disabled=\"disabled\"></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataIngresso == null)}\" flex style=\"max-height: 22px\">Data Ingresso in Italia\n<sup>*</sup></label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataIngresso\" \nng-model=\"vm.beneficiario.dataIngresso\" required></md-datepicker><div ng-messages=\"personaNForm.dataIngresso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">Data richiesta</span></small></div></div></div>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.tipologia.$invalid)}\">\nTipologia ingresso protetto</md-select-label><md-select name=\"tipologia\" placeholder=\"Tipologia ingresso protetto\" \nng-model=\"vm.beneficiario.tipologia_id\" required><md-option ng-repeat=\"item in vm.tipologiaBenficiario\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.tipologia.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nTipologia ingresso protetto richiesta</span></div></div></md-input-container><md-input-container flex \nng-if=\"[3,7].includes(vm.beneficiario.tipologia_id)\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.paeseTerzoProvenienza.$invalid)}\">Paese Terzo Provenienza</md-select-label>\n<md-select name=\"paeseTerzoProvenienza\" placeholder=\"Paese Terzo Provenienza...\" \nng-model=\"vm.beneficiario.paeseTerzoProvenienzaId\" required><md-option \nng-repeat=\"item in vm.paeseProvenienza | filter: {\'tipologiaId\': vm.beneficiario.tipologia_id}\" ng-value=\"item.id\">\n<small><b>{{item.nazione.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.paeseTerzoProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.idTipoIngresso.$invalid)}\">Modalità ingresso in Italia\n</md-select-label><md-select name=\"idTipoIngresso\" ng-model=\"vm.beneficiario.idTipoIngresso\" \nng-disabled=\"!vm.isnew && vm.beneficiario.def == 1\" required placeholder=\"Modalità ingresso in Italia\"><md-option \nng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\" ng-selected=\"vm.beneficiario.idTipoIngresso == item.id\"><strong>\n<small>{{item.descrizione}}</small></strong></md-option></md-select><div \nng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div>\n</div></md-input-container></div><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Giorni Totali di Accoglienza</label><input type=\"text\" name=\"gta\" \nvalue=\"{{vm.calcolomontanteeffettuato[vm.beneficiario.id]}}\" required disabled=\"disabled\" class=\"text-uppercase\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Reinserimento</label><md-select \nname=\"reinserimento\" ng-model=\"vm.beneficiario.reinserimento\" ng-disabled=\"!vm.isnew\"><md-option ng-value=\"1\" \nng-selected=\"vm.beneficiario.reinserimento == 1\"><strong><small>Si, Reinserimento</small></strong></md-option>\n<md-option ng-value=\"0\" ng-selected=\"vm.beneficiario.reinserimento == 0\"><strong><small>No</small></strong></md-option>\n</md-select></md-input-container></div></div></md-tab-body></md-tab><md-tab label=\"DETTAGLIO\"><div id=\"anagraficatab\">\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>DATI DA COMPLETARE</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nucleoFamiliare.$invalid)}\">Stato Parentela</md-select-label><md-select \nname=\"nucleoFamiliare\" placeholder=\"Stato Parentela\" ng-model=\"vm.beneficiario.nucleoFamiliare\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-option ng-value=\"item.codice\" \nng-repeat=\"item in vm.nucleofamiliares| filtranucleo:vm.filternucleo:vm.beneficiario.nucleoFamiliare:\'codice\'\"><div \nlayout=\"column\"><small><b>{{item.descrizione}}</b></small> <small>{{item.note}}</small></div></md-option></md-select>\n<div ng-messages=\"personaNForm.nucleoFamiliare.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span>\n</div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.parentela_id.$invalid)}\">Parentela</md-select-label><md-select \nname=\"parentela_id\" placeholder=\"Parentela\" ng-model=\"vm.beneficiario.parentela_id\" required \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-option \nng-repeat=\"item in vm.parentelas| filtraparentele:[vm.beneficiario.nucleoFamiliare]:\'id\'\" ng-value=\"item.id\"><div \nlayout=\"column\"><small><b>{{item.descrizione}}</b></small> <small>{{item.note}} <span \nng-if=\"(item.note == \'Nucleo familiare\' && vm.beneficiario.nucleoFamiliare == 0)\">o monoparentale</span></small></div>\n</md-option></md-select><div ng-messages=\"personaNForm.parentela_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><ng-form \nname=\"vm.capofamigliaForm\" ng-if=\"[0,1].indexOf(vm.beneficiario.nucleoFamiliare) !== -1\" flex><span flex \nclass=\"margin-bottom-0\"><label><b>Capofamiglia:</b></label><input type=\"text\" name=\"capof_id\" \nng-value=\"vm.beneficiario.capof_id\" placeholder=\"Capofamiglia\" hidden required> <span \nng-if=\"vm.beneficiario.capoFamiglia != null\">\n{{vm.beneficiario.capoFamiglia.cognome}} {{vm.beneficiario.capoFamiglia.nome}} ({{vm.beneficiario.capoFamiglia.codice}})\n</span> <span ng-if=\"vm.beneficiario.capoFamiglia == null\">Capofamiglia non presente</span></span></ng-form>\n<md-input-container flex><label>Vulnerabilita</label><md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" \nng-model=\"vm.beneficiario.idVulnerabilita\"><md-option ng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small>\n<b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.vulnerabilita_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Note</label><textarea name=\"note\" ng-model=\"vm.beneficiario.note\" \nplaceholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\"></textarea></md-input-container><md-input-container flex>\n<label>Note Sanitarie</label><textarea name=\"noteSanitarie\" ng-model=\"vm.beneficiario.noteSanitarie\" \nplaceholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\"></textarea></md-input-container></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI FACOLTATIVE</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\"><md-option ng-repeat=\"naz in vm.religioni\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Gruppo Etnico</label><input \ntype=\"text\" name=\"gruppoEtnico\" ng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" \nclass=\"font-size-12\"></md-input-container></div><div layout=\"row\" flex class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.beneficiario.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\"><div ng-messages=\"personaNForm2.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email richiesta</span></div><div \nng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Telefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" \nplaceholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" ng-model=\"vm.beneficiario.codiceFiscale\" \nplaceholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm2.codiceFiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n</md-tab><md-tab label=\"Status\"><div id=\"statustab\"><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg\">\n<small><b>STATUS GIURIDICO E PROTEZIONE</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\">\n<md-input-container flex><label ng-class=\"{\'md-warn-fg\': (personaNForm.interesseExArt.$invalid)}\">\nManifestazione volontà protezione internazionale</label><md-select name=\"interesseExArt\" \nplaceholder=\"Manifestazione volontà protezione internazionale\" ng-model=\"vm.beneficiario.interesseExArt\" required>\n<md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.interesseExArt.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\">\n<label flex style=\"max-height: 22px\" ng-class=\"{\'md-warn-fg\': (personaNForm.dataManifestazioneVolonta.$invalid)}\">\nData Manifestazione volontà</label><md-datepicker datepicker-validation-fix name=\"dataManifestazioneVolonta\" \nng-model=\"vm.beneficiario.dataInteresseExArt\" md-placeholder=\"Data Manifestazione volontà\" md-max-date=\"vm.oggi\" \nmd-min-date=\"(vm.cambiaData(\'dataInteresseExArt\'))\" ng-required=\"(vm.beneficiario.interesseExArt)\" \nng-disabled=\"!vm.beneficiario.interesseExArt\"></md-datepicker></div><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (personaNForm.c3.$invalid)}\">Compilazione C3</label><md-select name=\"c3\" \nplaceholder=\"Compilazione C3\" ng-model=\"vm.beneficiario.c3\" required><md-option ng-repeat=\"item in vm.sino\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.c3.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div>\n</div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (personaNForm.dataC3.$invalid)}\">Data compilazione C3</label><md-datepicker \ndatepicker-validation-fix name=\"dataC3\" ng-model=\"vm.beneficiario.dataC3\" md-placeholder=\"Data compilazione C3\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.cambiaData(\'dataC3\')\" ng-disabled=\"(!vm.beneficiario.c3)\" \nng-required=\"vm.beneficiario.c3\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex><label \nclass=\"md-warn-fg\"><b>Tipo di Soggiorno</b> (campo da ricontrollare/aggiornare)</label><md-select \nname=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" ng-model=\"vm.beneficiario.tipoProtezione_id\" required \nng-disabled=\"true\"><md-option ng-repeat=\"item in vm.tipoProteziones\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select><div ng-messages=\"personaNForm.tipoProtezione_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex=\"25\" layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (personaNForm.dataRichiestaProtezione.$invalid)}\">Data richiesta protezione</label>\n<md-datepicker datepicker-validation-fix name=\"dataRichiestaProtezione\" \nng-model=\"vm.beneficiario.dataRichiestaProtezione\" md-placeholder=\"Data richiesta protezione\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.cambiaData(\'dataRichiestaProtezione\')\"></md-datepicker><div \nng-messages=\"personaNForm.dataRichiestaProtezione.$error\" role=\"alert\"><div ng-message=\"required\" class=\"md-warn-fg\">\n<small>Il campo è richiesto.</small></div></div></div><div flex=\"25\" layout=\"column\" class=\"datepicker-container\">\n<label flex style=\"max-height: 22px\">Data avvenuta notifica</label><md-datepicker datepicker-validation-fix \nname=\"dataAvvenutaNotifica\" ng-model=\"vm.beneficiario.dataAvvenutaNotifica\" md-placeholder=\"Data avvenuta notifica\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\" ng-disabled=\"true\"></md-datepicker></div></div><div layout=\"row\">\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.idProvenienza.$invalid)}\">Provenienza\n</md-select-label><md-select name=\"idProvenienza\" placeholder=\"Provenienza\" ng-model=\"vm.beneficiario.idProvenienza\" \nrequired placeholder=\"Provenienza\"><md-option ng-repeat=\"item in vm.provenienza.data\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.idProvenienza.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container>\n<md-input-container flex><label ng-class=\"{\'md-warn-fg\': (personaNForm.idDublino.$invalid)}\">Stato Dublino</label>\n<md-select name=\"idDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.beneficiario.idDublino\" \nng-disabled=\"(vm.beneficiario.idProvenienza != 624)\" ng-required=\"(vm.beneficiario.idProvenienza == 624)\"><md-option \nng-repeat=\"item in vm.dublino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select>\n<div ng-messages=\"personaNForm.idDublino.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><div layout=\"column\" class=\"datepicker-container\" flex=\"50\"><label flex \nstyle=\"max-height: 22px\" ng-class=\"{\'md-warn-fg\': (personaNForm.dataRichiestaPds.$invalid)}\">Data richiesta Pds</label>\n<md-datepicker datepicker-validation-fix name=\"dataRichiestaPds\" ng-model=\"vm.beneficiario.dataRichiestaPds\" \nmd-placeholder=\"Data richiesta Pds\" md-max-date=\"vm.oggi\" md-min-date=\"vm.beneficiario.dataInteresseExArt\">\n</md-datepicker></div></div><div class=\"row\" flex=\"25\" ng-if=\"!vm.isVisitatore && !vm.api.isTutor\"><sprardb-newprocess2\n ng-model=\"vm.nsg\"></sprardb-newprocess2></div><div class=\"row\" flex=\"25\" ng-if=\"!vm.isVisitatore && !vm.api.isTutor\">\n<sprardb-newprocess2 ng-model=\"vm.nsg2\"></sprardb-newprocess2></div><md-divider \nclass=\"md-light-blue-100-bg padding-8 red-500-fg\"><small><b>ULTIMO DOCUMENTO BENEFICIARIO</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex><label class=\"md-warn-fg\"><b>Tipo di Documento</b>\n (campo da ricontrollare/aggiornare)</label><md-select name=\"idTipoDocumento\" placeholder=\"Tipo di documento...\" \nng-model=\"vm.beneficiario.idTipoDocumento\" required ng-change=\"vm.cambiaDocumento()\"><md-option \nng-repeat=\"item in vm.tipoDocumento\" ng-value=\"item.id\" \nng-disabled=\"vm.documentoAbilitato(item, vm.beneficiario.tipoProtezione_id)\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.idTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il campo è richiesto</span></div></div><i ng-click=\"vm.alertDocumento()\" \nclass=\"icon-information red-900-fg s18 cursor-pointer\"></i></md-input-container><md-input-container flex=\"25\" \nng-class=\"{\'md-input-has-value\': false}\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.enteDocumento_id.$invalid)}\">Documento rilasciato da</md-select-label><md-select\n name=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" ng-model=\"vm.beneficiario.enteDocumento_id\" required>\n<md-option ng-repeat=\"item in vm.enteDocumentoids\" ng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.enteDocumento_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex=\"25\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.documentoNumero.$invalid)}\">Documento Numero</label><input type=\"text\" \nname=\"documentoNumero\" ng-model=\"vm.beneficiario.documentoNumero\" placeholder=\"Inserire numero documento...\" required>\n<div ng-messages=\"personaNForm.documentoNumero.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (personaNForm.dataRilascioDocumento.$invalid)}\">Data Rilascio documento</label><md-datepicker \ndatepicker-validation-fix name=\"dataRilascioDocumento\" ng-model=\"vm.beneficiario.dataRilascioDocumento\" \nmd-placeholder=\"Data Rilascio Documento\" md-max-date=\"vm.oggi\" md-min-date=\"vm.beneficiario.dataNascita\" \nng-required=\"true\"></md-datepicker></div><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\" ng-class=\"{\'md-warn-fg\': (personaNForm.dataScadenzaDocumento.$invalid)}\">\nData Scadenza documento</label><md-datepicker datepicker-validation-fix name=\"dataScadenzaDocumento\" \nng-model=\"vm.beneficiario.dataScadenzaDocumento\" md-placeholder=\"Data Scadenza Documento\" \nmd-min-date=\"vm.beneficiario.dataRilascioDocumento\" ng-required=\"true\"></md-datepicker></div><md-input-container flex>\n<label>Cambio questura, prefettura, commissione</label><md-select name=\"cambioQPC\" \nplaceholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.beneficiario.cambioQPC\"><md-option \nng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.cambioQPC.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote cambio questura, prefettura, commissione</label><textarea name=\"noteCambioQPC\" \nng-model=\"vm.beneficiario.noteCambioQPC\" placeholder=\"Note cambio questura, prefettura, commissione...\" \naria-label=\"Notecqpc\" rows=\"1\"></textarea></md-input-container></div></div></md-tab><md-tab label=\"Identita e Tutela\" \nng-if=\"vm.minori\"><div id=\"identitatab\"><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nIDENTITA\' MINORE E TUTELA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex>\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.iTipoDocumento.$invalid)}\">Tipo Documento Identità\n</md-select-label><md-select name=\"iTipoDocumento\" placeholder=\"Tipo Documento Identità\" \nng-model=\"vm.beneficiario.iTipoDocumento\" required><md-option ng-repeat=\"item in vm.iTipoDocumento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.iLuogoDocumento.$invalid)}\">Luogo Rilascio Documento</md-select-label><md-select\n name=\"iLuogoDocumento\" placeholder=\"Luogo Rilascio Documento\" ng-model=\"vm.beneficiario.iLuogoDocumento\" required>\n<md-option ng-repeat=\"item in vm.iLuogoDocumento\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b>\n</small></md-option></md-select><div ng-messages=\"personaNForm.iLuogoDocumento.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex>\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.iModalitaAccertamento.$invalid)}\">Modalità di Accertamento\n</md-select-label><md-select name=\"iModalitaAccertamento\" placeholder=\"Modalità di Accertamento\" \nng-model=\"vm.beneficiario.iModalitaAccertamento\" required><md-option ng-repeat=\"item in vm.iModalitaAccertamento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iModalitaAccertamento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote Accertamento età</label><textarea name=\"iNoteAccertamento\" ng-model=\"vm.beneficiario.iNoteAccertamento\" \nplaceholder=\"Note Accertamento età...\" aria-label=\"iNoteAccertamento\" rows=\"1\"></textarea></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.iRichiestaTutela.$invalid)}\">Richiesta Apertura Tutela</md-select-label>\n<md-select name=\"iRichiestaTutela\" placeholder=\"Richiesta Apertura Tutela\" ng-model=\"vm.beneficiario.iRichiestaTutela\" \nrequired><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.iRichiestaTutela.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Richiesta Apertura Tutela</label><md-datepicker \ndatepicker-validation-fix name=\"iDataRichiestaTutela\" ng-model=\"vm.beneficiario.iDataRichiestaTutela\" \nmd-placeholder=\"Data Richiesta Apertura Tutela\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.minDated\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" ng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div>\n<div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Apertura Tutela\n</label><md-datepicker datepicker-validation-fix name=\"iDataAperturaTutela\" \nng-model=\"vm.beneficiario.iDataAperturaTutela\" md-placeholder=\"Data Apertura Tutela\" md-max-date=\"vm.maxDated\" \nmd-min-date=\"vm.beneficiario.iDataRichiestaTutela\" ng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" \nng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label ng-class=\"{\'md-warn-fg\': (personaNForm.iTutore.$invalid)}\">Cognome e Nome Tutore</label><input type=\"text\" \nname=\"iTutore\" ng-model=\"vm.beneficiario.iTutore\" placeholder=\"Cognome e Nome Tutore\" required><div \nng-messages=\"personaNForm.iTutore.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.iQualifica.$invalid)}\">Qualifica del Tutore</md-select-label><md-select \nname=\"iQualifica\" placeholder=\"Qualifica del Tutore\" ng-model=\"vm.beneficiario.iQualifica\" required><md-option \nng-repeat=\"item in vm.iQualifica\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.iQualifica.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (personaNForm.iResponsabile.$invalid)}\">Cognome e Nome Responsabile Struttura</label><input \ntype=\"text\" name=\"iResponsabile\" ng-model=\"vm.beneficiario.iResponsabile\" \nplaceholder=\"Cognome e Nome Responsabile Struttura\" ng-disabled=\"(vm.beneficiario.iRichiestaTutela)\"><div \nng-messages=\"personaNForm.iResponsabile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container><md-input-container flex><label>Tribunale Compentente</label><input \ntype=\"text\" name=\"iTribunale\" ng-model=\"vm.beneficiario.iTribunale\" placeholder=\"Tribunale Compentente\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\"><div ng-messages=\"personaNForm.iTribunale.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div>\n</md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/dettagliop.html","<div id=\"beneficiario\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.returnBeneficiari()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Beneficiario :&nbsp;</span> <span class=\"logo-text\"><b>\n{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</b></span> <span class=\"logo-text\">&nbsp;&nbsp;<b>\ncod.&nbsp;{{vm.beneficiario.codice}}</b></span></div></div></div><div><md-button aria-label=\"Dettaglio\" \nng-click=\"vm.annullaUscitaBeneficiario()\" ng-if=\"vm.api.isAdminG && vm.beneficiario.stato == \'TERMINATO\'\" \nclass=\"md-raised\"><span>ANNULLA USCITA BENEFICIARIO</span></md-button><md-button aria-label=\"Dettaglio\" \nng-click=\"vm.save()\" ng-if=\"vm.api.isAdminG\" class=\"md-raised\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza) || personaNForm.$invalid || personaNForm.$pristine || vm.isomonimo || vm.beneficiario.cancellato\">\n<span>SALVA</span></md-button></div></div><div class=\"content dettaglio\" ms-scroll><form name=\"personaNForm\" \nnovalidate ng-style=\"{\'background-color\': vm.beneficiario.cancellato ? \'rgba(255,0,0,0.2)\' : \'rgba(255,255,255,1)\'}\">\n<md-tabs md-dynamic-height><md-tab label=\"PRINCIPALE\"><div id=\"principaletab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>PROGETTO ACCOGLIENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><b>PROGETTO</b></label><input type=\"text\" name=\"progetto_id\" value=\"{{vm.beneficiario.progettos.nome}}\" \nplaceholder=\"Progetto\" disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\" \nng-if=\"vm.beneficiario.ultimastrutturas !== null\"><label><b>STRUTTURA</b></label><input type=\"text\" \nname=\"struttura_id\" value=\"{{vm.beneficiario.ultimastrutturas.nome}}\" placeholder=\"Struttura\" disabled=\"disabled\">\n<md-button class=\"md-accent md-raised\" ng-if=\"vm.struttura_corr.isDisattivabileEsterna\" ng-click=\"vm.popupEsterna()\">\nCHIUDI STRUTTURA</md-button></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small>\n<b>DATI BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.cognome.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required ng-disabled=\"vm.api.isOperatoreG\" \nclass=\"text-uppercase\"><div ng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl cognome è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.beneficiario.nome\" placeholder=\"Nome\" required ng-disabled=\"vm.api.isOperatoreG\" class=\"text-uppercase\">\n<div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il nome è richiesto</span>\n</div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex=\"50\">\n<label ng-class=\"{\'md-warn-fg\': (personaNForm.codiceVestanet.$invalid)}\">Codice Vestanet</label><input type=\"text\" \nid=\"formDialogVestanet\" name=\"Vestanet\" \nng-init=\"vm.beneficiario.codiceVestanet = vm.beneficiario.codiceVestanet || \'\'\" \nng-model=\"vm.beneficiario.codiceVestanet\" placeholder=\"Codice Vestanet\" onfocus=\"this.value = \'\'\" \nng-disabled=\"vm.checkboxVestanet\" ng-required=\"vm.beneficiario.codiceVestanet !== null\"></md-input-container><div \nflex=\"50\"><label>Codice Vestanet non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxVestanet\" \nng-change=\"vm.checkboxVestanetOnClick()\"></label></div></div><div layout=\"row\" layout-align=\"space-between-center\" \nclass=\"margin-top-16\"><md-input-container flex=\"50\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cui.$invalid)}\">\nCodice Unico di Identificazione</label><input type=\"text\" id=\"formDialogCui\" name=\"Cui\" \nng-init=\"vm.beneficiario.cui = vm.beneficiario.cui || \'\'\" ng-model=\"vm.beneficiario.cui\" placeholder=\"Codice CUI\" \nonfocus=\"this.value = \'\'\" ng-disabled=\"vm.checkboxCui\" ng-required=\"vm.beneficiario.cui !== null\"></md-input-container>\n<div flex=\"50\"><label>Codice CUI non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxCui\" \nng-change=\"vm.checkboxCuiOnClick()\" ng-init=\"vm.checkboxCui\"></label></div></div><div layout=\"row\" \nlayout-align=\"space-between-center\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vm.beneficiario.sesso\" placeholder=\"Sesso\" required \nng-disabled=\"vm.api.isOperatoreG\" class=\"\"><md-option value=\"M\"><small><b>MASCHILE</b></small></md-option><md-option \nvalue=\"F\"><small><b>FEMMINILELE</b></small></md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.nazionalita.$invalid)}\">Nazionalita\n</md-select-label><md-select name=\"nazionalita\" placeholder=\"Nazionalita\" ng-model=\"vm.beneficiario.codNazionalita\" \nrequired ng-disabled=\"vm.api.isOperatoreG\" class=\"\"><md-option ng-repeat=\"item in vm.nazionalitas\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.nazionalita.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Nazionalita richiesta</span></div></div></md-input-container></div></div>\n<div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Nascita</label><md-datepicker \ndatepicker-validation-fix class=\"md-block\" name=\"dataNascita\" ng-model=\"vm.beneficiario.dataNascita\" \nng-disabled=\"vm.api.isOperatoreG\" required></md-datepicker></div><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.tipoProteziones| filter:{id:vm.beneficiario.tipoProtezione_id}\"><label>Tipo di soggiorno</label>\n<input type=\"text\" name=\"tipop\" value=\"{{item.descrizione}}\" placeholder=\"Tipo di soggiorno...\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo di segnalazione\n</label><input type=\"text\" name=\"tipoSegnalazione\" value=\"{{vm.beneficiario.tipoSegnalazione}}\" \nplaceholder=\"Tipo di segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Stato Attuale Beneficiario</label><input type=\"text\" name=\"dataNascita\" \nvalue=\"{{vm.beneficiario.stato}}\" required ng-disabled=\"true\" class=\"text-uppercase\"></md-input-container></div></div>\n<div layout=\"row\" class=\"margin-top-16\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data Inizio Presenza Sul Territorio</label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataInizio\" ng-model=\"vm.beneficiario.dataInizio\" md-min-date=\"vm.beneficiario.dataIngresso\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data fine Presenza Sul Territorio</label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscita\" ng-model=\"vm.beneficiario.dataUscita\" \nmd-min-date=\"vm.beneficiario.dataIngresso\" ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker>\n</div></div><div layout=\"row\" class=\"margin-top-16\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data Ingresso in Italia</label><md-datepicker datepicker-validation-fix class=\"md-block\" \nname=\"dataIngresso\" ng-model=\"vm.beneficiario.dataIngresso\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker><div \nng-messages=\"personaNForm.dataIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData richiesta</span></small></div></div></div><md-input-container flex><md-select-label>Tipologia ingresso protetto\n</md-select-label><md-select name=\"tipologia\" placeholder=\"Tipologia ingresso protetto\" \nng-model=\"vm.beneficiario.tipologia_id\" ng-disabled=\"vm.canUpdateTipologia\"><md-option \nng-repeat=\"item in vm.tipologiaBenficiario\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"[3,7].includes(vm.beneficiario.tipologia_id)\">\n<md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.paeseTerzoProvenienza.$invalid)}\">Paese Terzo Provenienza\n</md-select-label><md-select name=\"paeseTerzoProvenienza\" placeholder=\"Paese Terzo Provenienza...\" \nng-model=\"vm.beneficiario.paeseTerzoProvenienzaId\" required ng-disabled=\"!vm.api.isAdmin\"><md-option \nng-repeat=\"item in vm.paeseProvenienza | filter: {\'tipologiaId\': vm.beneficiario.tipologia_id}\" ng-value=\"item.id\">\n<small><b>{{item.nazione.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.paeseTerzoProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>\nModalità ingresso in Italia</label><md-select name=\"idTipoIngresso\" ng-model=\"vm.beneficiario.idTipoIngresso\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.idTipoIngresso == item.id\"><strong><small>{{item.descrizione}}</small></strong>\n</md-option></md-select><div ng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesto</span></div></div></md-input-container></div><div layout=\"row\"><div \nng-if=\"vm.beneficiario.stato === \'PRESENTE SUL TERRITORIO\'\" flex=\"50\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button aria-label=\"Termina presenza nel territorio\" ng-click=\"vm.terminaNelTerritorio()\" \nclass=\"md-button md-raised md-accent\" flex>TERMINA PRESENZA NEL TERRITORIO</md-button></div></div></div><div \nng-if=\"vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"50\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button class=\"md-button md-accent-bg\" ng-click=\"vm.reintegraBeneficiario()\" flex><b>\nRipristina scheda Beneficiario</b></md-button></div></div></div><div \nng-if=\"!vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"50\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button class=\"md-button\" ng-style=\"{\'background-color\': \'red\', \'color\': \'white\'}\" \nng-click=\"vm.cancellaBeneficiario()\" ng-show=\"vm.api.isAdmin\" flex><b>Elimina scheda beneficiario</b></md-button></div>\n</div></div></div></div></md-tab><md-tab label=\"DETTAGLIO\"><div id=\"anagraficatab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>NUCLEI, PARENTELA E NOTE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nucleoFamiliare.$invalid)}\">Stato Parentela</md-select-label><md-select \nname=\"nucleoFamiliare\" placeholder=\"Stato Parentela\" ng-model=\"vm.beneficiario.nucleoFamiliare\" required \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-value=\"item.codice\" ng-repeat=\"item in vm.nucleofamiliares\"><div \nlayout=\"column\"><small><b>{{item.descrizione}}</b></small> <small>{{item.note}}</small></div></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Parentela</label><md-select \nname=\"parentela_id\" ng-model=\"vm.beneficiario.parentela_id\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"item in vm.parentelas | filtraparentele:[vm.beneficiario.nucleoFamiliare]:\'id\'\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.parentela_id == item.id\"><div layout=\"column\"><small><b>{{item.descrizione}}</b></small> \n<small>{{item.note}} <span ng-if=\"(item.note == \'Nucleo familiare\' && vm.beneficiario.nucleoFamiliare == 0)\">\no monoparentale</span></small></div></md-option></md-select></md-input-container></div><div layout=\"row\"><ng-form \nname=\"vm.capofamigliaForm\" ng-if=\"[0,1].indexOf(vm.beneficiario.nucleoFamiliare) !== -1\" flex><span flex \nclass=\"margin-bottom-0\"><label><b>Capofamiglia:</b></label><input type=\"text\" name=\"capof_id\" \nng-value=\"vm.beneficiario.capof_id\" placeholder=\"Capofamiglia\" hidden required> <span \nng-if=\"vm.beneficiario.capoFamiglia != null\">\n{{vm.beneficiario.capoFamiglia.cognome}} {{vm.beneficiario.capoFamiglia.nome}} ({{vm.beneficiario.capoFamiglia.codice}})\n</span> <span ng-if=\"vm.beneficiario.capoFamiglia == null\">Capofamiglia non presente</span></span></ng-form>\n<md-input-container flex><label>Vulnerabilita</label><md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" \nng-model=\"vm.beneficiario.idVulnerabilita\" ng-disabled=\"!vm.api.isAdminG\"><md-option ng-value=\"0\"><small \nclass=\"text-italic\">Nessuna/o</small></md-option><md-option ng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Note</label><textarea name=\"note\" ng-model=\"vm.beneficiario.note\" \nplaceholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\" ng-disabled=\"!vm.api.isAdminG\"></textarea>\n</md-input-container><md-input-container flex><label>Note Sanitarie</label><textarea name=\"noteSanitarie\" \nng-model=\"vm.beneficiario.noteSanitarie\" placeholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\" \nng-disabled=\"!vm.api.isAdminG\"></textarea></md-input-container></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>FAMIGLIA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-card><md-table-container><table data-md-table><thead md-head><tr md-row style=\"height: 24px\">\n<th md-column style=\"padding:2px\"></th><th md-column style=\"padding:2px\" md-order-by=\"nome\">NOME</th><th md-column \nstyle=\"padding:2px\">COGNOME</th><th md-column style=\"padding:2px\">CODICE</th><th md-column style=\"padding:2px\">\nPARENTELA</th></tr></thead><tbody md-body ng-repeat=\"item in vm.famiglia\"><tr md-row style=\"height: 36px\"><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><md-icon ng-if=\"item.capof_id == 0\" \nmd-font-icon=\"icon-account-circle\"><md-tooltip>CAPOFAMIGLIA</md-tooltip></md-icon></div></td><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.nome | uppercase}}</span></div>\n</td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.cognome | uppercase}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.codice}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>\n{{ item.parentelas.descrizione}}</span></div></td></tr></tbody></table></md-table-container></md-card></div><md-divider\n class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI FACOLTATIVE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"naz in vm.religioni\" ng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>\n{{naz.descrizione}}</small></strong></md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Gruppo Etnico</label><input type=\"text\" name=\"gruppoEtnico\" \nng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div><div layout=\"row\" flex class=\"margin-top-16\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.beneficiario.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Telefono\n</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" ng-disabled=\"!vm.api.isAdminG\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" \nng-model=\"vm.beneficiario.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div></div></md-tab><md-tab label=\"STATUS GIURIDICO\"><div \nid=\"statustab\"><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg\"><small><b>STATUS GIURIDICO E PROTEZIONE\n</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex><label>\nManifestazione volontà protezione internazionale</label><md-select name=\"interesseExArt\" \nplaceholder=\"Manifestazione volontà protezione internazionale\" ng-model=\"vm.beneficiario.interesseExArt\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data Manifestazione volontà</label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataInteresseExArt\" ng-model=\"vm.beneficiario.dataInteresseExArt\" \nng-disabled=\"!vm.beneficiario.interesseExArt && !vm.api.isAdminG\"></md-datepicker></div><md-input-container flex>\n<label>Compilazione C3</label><md-select name=\"c3\" placeholder=\"Compilazione C3\" ng-model=\"vm.beneficiario.c3\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data compilazione C3</label><md-datepicker datepicker-validation-fix class=\"md-block\" \nname=\"dataC3\" ng-model=\"vm.beneficiario.dataC3\" ng-disabled=\"(!vm.beneficiario.c3 && !vm.api.isAdminG)\">\n</md-datepicker></div></div><div layout=\"row\"><md-input-container flex><label>Tipo di Soggiorno</label><md-select \nname=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" ng-model=\"vm.beneficiario.tipoProtezione_id\" \nng-disabled=\"true\"><md-option ng-repeat=\"item in vm.tipoProteziones\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex=\"25\" layout=\"column\" class=\"datepicker-container\">\n<label flex style=\"max-height: 22px\">Data richiesta protezione</label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataRichiestaProtezione\" ng-model=\"vm.beneficiario.dataRichiestaProtezione\"></md-datepicker>\n</div><div flex=\"25\" layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData avvenuta notifica</label><md-datepicker datepicker-validation-fix name=\"dataAvvenutaNotifica\" \nng-model=\"vm.beneficiario.dataAvvenutaNotifica\" md-placeholder=\"Data avvenuta notifica\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.minDatesafe\" ng-disabled=\"true\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label>Provenienza</label><md-select name=\"idProvenienza\" placeholder=\"Provenienza\" \nng-model=\"vm.beneficiario.idProvenienza\"><md-option ng-repeat=\"item in vm.provenienza\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select></md-input-container><md-input-container flex><label>\nStato Dublino</label><md-select name=\"idDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.beneficiario.idDublino\" \nng-disabled=\"(vm.beneficiario.idProvenienza != 624)\" ng-required=\"(vm.beneficiario.idProvenienza == 624)\"><md-option \nng-repeat=\"item in vm.dublino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select>\n</md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData richiesta Pds</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataRichiestaPds\" \nng-model=\"vm.beneficiario.dataRichiestaPds\" md-min-date=\"vm.beneficiario.dataInteresseExArt\" md-max-date=\"vm.oggi\">\n</md-datepicker></div></div><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg margin-top-16\"><small><b>\nULTIMO DOCUMENTO BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex>\n<label>Documento di soggiorno</label><md-select name=\"idTipoDocumento\" placeholder=\"Documento di soggiorno...\" \nng-model=\"vm.beneficiario.idTipoDocumento\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"item in vm.tipoDocumento\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Documento rilasciato da</label><md-select \nname=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" ng-model=\"vm.beneficiario.enteDocumento_id\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.enteDocumentoids\" ng-value=\"item.id\"><small><b>\n{{item.nome}}</b></small></md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>\nDocumento Numero</label><input type=\"text\" name=\"documentoNumero\" ng-model=\"vm.beneficiario.documentoNumero\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div><div layout=\"row\"><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Rilascio documento</label><md-datepicker \ndatepicker-validation-fix class=\"md-block\" name=\"dataRilascioDocumento\" \nng-model=\"vm.beneficiario.dataRilascioDocumento\" ng-disabled=\"!vm.api.isAdminG\"></md-datepicker></div><div flex \nlayout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Scadenza documento</label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataScadenzaDocumento\" \nng-model=\"vm.beneficiario.dataScadenzaDocumento\" ng-disabled=\"!vm.api.isAdminG\"></md-datepicker></div>\n<md-input-container flex><label>Cambio questura, prefettura, commissione</label><md-select name=\"cambioQPC\" \nplaceholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.beneficiario.cambioQPC\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote cambio questura, prefettura, commissione</label><textarea name=\"noteCambioQPC\" \nng-model=\"vm.beneficiario.noteCambioQPC\" placeholder=\"Note cambio questura, prefettura, commissione...\" \naria-label=\"Notecqpc\" rows=\"1\" ng-disabled=\"!vm.api.isAdminG\"></textarea></md-input-container></div></div></md-tab>\n<md-tab label=\"CORSI SERVIZI\"><div id=\"strutturecorsiservizitab\"><div id=\"sectionservizi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>SERVIZI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei servizi\" type=\"text\" ng-model=\"vm.sersearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.sersearchYear\" \nplaceholder=\"Anno servizi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">\nNOME SERVIZIO</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.servizios| filter: vm.sersearch | filter: {dataFine:vm.sersearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.servizi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.servizicat\" ng-if=\"sitem.id === item.servizi.servizi_id\"><small>\n{{ sitem.descrizione|uppercase}}</small></span> <span class=\"light-blue-900-fg font-weight-600\">\n{{ item.servizi.descrizione | uppercase}}</span> <span><small>{{ item.servizi.note|uppercase}}</small></span></div>\n</td><td md-cell><div layout=\"column\"><span class=\"light-blue-900-fg font-weight-600\">\n{{ item.progetto.nome | uppercase}}</span> <span><small>{{ item.progetto.istat.comune|uppercase}}</small></span></div>\n</td><td md-cell style=\"text-align: left\"><b>{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell \nstyle=\"text-align: left\"><b>{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phs.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phs.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"></td></tr></tbody></table>\n</md-table-container><div layout=\"row\" ng-if=\"vm.api.isAdminG && !vm.beneficiario.cancellato\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openServiziBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO SERVIZIO</md-button></div></md-card></div><div id=\"sectioncorsi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>CORSI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei corsi\" type=\"text\" ng-model=\"vm.corsearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.corsearchYear\" \nplaceholder=\"Anno corsi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">NOME CORSO\n</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.corsos| filter: vm.corsearch | filter: {dataFine:vm.corsearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.corsi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.corsicat\" ng-if=\"sitem.id === item.corsi.corsi_id\"><small>{{ sitem.descrizione|uppercase}}\n</small></span> <span class=\"light-blue-900-fg font-weight-600\">{{ item.corsi.descrizione | uppercase}}</span> <span>\n<small>{{ item.corsi.note|uppercase}}</small></span></div></td><td md-cell><div layout=\"column\"><span \nclass=\"light-blue-900-fg font-weight-600\">{{ item.progetto.nome | uppercase}}</span> <span><small>\n{{ item.progetto.istat.comune|uppercase}}</small></span></div></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phc.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phc.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"></td></tr></tbody></table>\n</md-table-container><div layout=\"row\" ng-if=\"vm.api.isAdminG && !vm.beneficiario.cancellato\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openCorsiBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO CORSO</md-button></div></md-card></div></div></md-tab><md-tab label=\"STORICI\"><div \nid=\"storicostatustab\"><div id=\"storicoeventi\" ng-if=\"vm.bloaded\"><sprardb-tabellar titolo=\"Storico status giuridico\" \nng-model=\"vm.beneficiario.eventoAstatusgs\" mostrazioni=\"0\" mostradate=\"0\"></sprardb-tabellar><sprardb-tabellar \ntitolo=\"Storico documenti\" ng-model=\"vm.beneficiario.eventoAdocumentos\" mostrazioni=\"0\"></sprardb-tabellar><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico trasferimenti\" \nng-model=\"vm.beneficiario.eventoAtrasferimentos\" mostrazioni=\"0\"></sprardb-tabellar><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><md-divider style=\"margin: 24px 0px\"></md-divider><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Presenze Sul Territorio</b></small><div flex></div></div></md-toolbar>\n<md-table-container><table data-md-table><thead md-head><tr md-row><th md-column md-order-by=\"id\"><span>#</span></th>\n<th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">STATO</th><th md-column style=\"text-align: left\" \nmd-order-by=\"eventoTipo_id\">EVENTO</th><th md-column md-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th \nmd-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.eventiPresenze track by item.id\"><td md-cell>{{item.id}}</td><td md-cell><md-button \nclass=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">{{item.eventoStato.stato| limitTo:2 }}\n<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b> // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td \nmd-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell><b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell>\n<b>{{item.dataFine| date: \"dd/MM/yyyy\"}}</b></td></tr></tbody></table></md-table-container></md-card><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><md-card><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>Storico proroghe</b>\n</small><div flex></div></div></md-toolbar><md-table-container><table data-md-table><thead md-head><tr md-row><th \nmd-column md-order-by=\"id\"><span>#</span></th><th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">\nSTATO</th><th md-column style=\"text-align: left\" md-order-by=\"eventoTipo_id\">EVENTO</th><th md-column \nmd-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\">FINE</th><th md-column style=\"text-align: center\">PROCESSO</th></tr></thead><tbody md-body><tr\n md-row ng-repeat=\"item in vm.beneficiario.eventoAprorogas track by item.id\"><td md-cell>{{item.id}}</td><td md-cell>\n<md-button class=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">\n{{item.eventoStato.stato| limitTo:2 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell>\n<b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{(item.eventoStato_id == 4 ? item.extra.dataConcessioneProroga : item.dataFine)| date: \"dd/MM/yyyy\"}}</b> <small \nng-if=\"(item.dataFine == null)\">NON LAVORATO</small></td><td md-cell style=\"text-align: right\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"DettaglioEvento\" \nng-click=\"vm.viewEvento($event, item, \'evento\')\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><b><small>\nDETTAGLIO EVENTO</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"DettaglioExtra\" \nng-click=\"vm.viewEvento($event, item, \'extra\')\"><md-icon md-font-icon=\"icon-details\"></md-icon><b><small>DETTAGLI EXTRA\n</small></b></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n</md-card><md-divider style=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico uscite\" \nng-model=\"vm.beneficiario.eventoAuscitas\" mostrazioni=\"0\"></sprardb-tabellar><md-divider style=\"margin: 24px 0px\">\n</md-divider></div><md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><b>Storico strutture</b></small><div layout=\"row\" flex></div><div flex></div></div>\n</md-toolbar><md-table-container id=\"tabellar\" ng-if=\"vm.api.isOperatoreG\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"nome\">NOME</th><th md-column>\nDATA INSERIMENTO</th><th md-column>DATA CESSAZIONE</th><th md-column>ACCOGLIENZA</th><th md-column \nmd-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th></tr></thead><tbody md-body \nng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios | filter: {progetto_id:vm.beneficiario.progetto_id} track by preitem.id\">\n<tr md-row ng-repeat=\"item in vm.beneficiario.strutturas\" ng-if=\"vm.possovisualizzare(item.progettos.id)\"><td \nclass=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>{{ item.nome | uppercase}}</span>\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\"></md-progress-linear>\n<span>{{item.progettos.nome| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}<md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.changeDataIns(preitem.id, preitem.dataInserimento, \'dataInserimento\')\" aria-label=\"bt\" \nng-if=\"(vm.api.isAdmin)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-default-theme md-font material-icons icon-pencil\"></md-icon></md-button></span></div></td><td md-cell><div \nlayout=\"column\"><span>{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}<md-button \nclass=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.changeDataIns(preitem.id, preitem.dataCessazione, \'dataCessazione\')\" aria-label=\"bt1\" \nng-if=\"(vm.api.isAdmin)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-default-theme md-font material-icons icon-pencil\"></md-icon></md-button></span></div></td><td md-cell><span \nng-if=\"preitem.esterna\">ESTERNA</span></td><td md-cell><div layout=\"column\"><span>\n{{item.indirizzo| uppercase | limitTo:25}}...</span> <span><b>{{item.istats.comune| uppercase}}</b></span> <span>\n{{item.istats.provincia| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span><b>\n{{item.strutturaAccoglienzas.descrizione}}</b></span> <span>{{item.strutturaAlloggios.descrizione}}</span></div></td>\n</tr></tbody></table></md-table-container><md-table-container id=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"nome\">NOME</th><th md-column>\nDATA INSERIMENTO</th><th md-column>DATA CESSAZIONE</th><th md-column>ACCOGLIENZA</th><th md-column \nmd-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th></tr></thead><tbody md-body \nng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios track by preitem.id\"><tr md-row \nng-repeat=\"item in vm.beneficiario.strutturas\"><td class=\"light-blue-900-fg font-weight-600\" md-cell><div \nlayout=\"column\"><span>{{ item.nome | uppercase}}</span><md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\"></md-progress-linear>\n<span>{{item.progettos.nome| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><span ng-if=\"preitem.esterna\">ESTERNA\n</span></td><td md-cell><div layout=\"column\"><span>{{item.indirizzo| uppercase | limitTo:25}}...</span> <span><b>\n{{item.istats.comune| uppercase}}</b></span> <span>{{item.istats.provincia| uppercase}}</span></div></td><td md-cell>\n<div layout=\"column\"><span><b>{{item.strutturaAccoglienzas.descrizione}}</b></span> <span>\n{{item.strutturaAlloggios.descrizione}}</span></div></td></tr></tbody></table></md-table-container></md-card></div>\n</md-tab><md-tab label=\"DOCUMENTI\"><div id=\"doctab\" bg-if=\"vm.caricamentoultimato\"><sprardb-uploaddocuments3 \nng-model=\"vm.uploadParams\"></sprardb-uploaddocuments3></div></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/dettagliostorico.html","<div id=\"beneficiario\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.returnBeneficiari()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Beneficiario :&nbsp;</span> <span class=\"logo-text\"><b>\n{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</b></span> <span class=\"logo-text\">&nbsp;&nbsp;<b>\ncod.&nbsp;{{vm.beneficiario.codice}}</b></span></div></div></div><div><md-button aria-label=\"Dettaglio\" \nng-click=\"vm.annullaUscitaBeneficiario()\" ng-if=\"vm.api.isAdminG && vm.beneficiario.stato == \'TERMINATO\'\" \nclass=\"md-raised\"><span>ANNULLA USCITA BENEFICIARIO</span></md-button><md-button aria-label=\"Dettaglio\" \nng-click=\"vm.modificastorico()\" ng-if=\"vm.api.isAdminG\" class=\"md-raised\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza) || personaNForm.$invalid || personaNForm.$pristine || vm.isomonimo || vm.beneficiario.cancellato\">\n<span>SALVA</span></md-button></div></div><div class=\"content dettaglio\" ms-scroll><form name=\"personaNForm\" \nnovalidate ng-style=\"{\'background-color\': vm.beneficiario.cancellato ? \'rgba(255,0,0,0.2)\' : \'rgba(255,255,255,1)\'}\">\n<md-tabs md-dynamic-height><md-tab label=\"PRINCIPALE\"><div id=\"principaletab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>PROGETTO ACCOGLIENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><b>PROGETTO</b></label><input type=\"text\" name=\"progetto_id\" value=\"{{vm.beneficiario.progettos.nome}}\" \nplaceholder=\"Progetto\" disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\" \nng-if=\"vm.beneficiario.ultimastrutturas !== null\"><label><b>STRUTTURA</b></label><input type=\"text\" \nname=\"struttura_id\" value=\"{{vm.beneficiario.ultimastrutturas.nome}}\" placeholder=\"Struttura\" disabled=\"disabled\">\n<md-button class=\"md-accent md-raised\" ng-if=\"vm.struttura_corr.isDisattivabileEsterna\" ng-click=\"vm.popupEsterna()\">\nCHIUDI STRUTTURA</md-button></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small>\n<b>DATI BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.cognome.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.beneficiario.cognome\" placeholder=\"Cognome\" required ng-disabled=\"vm.api.isOperatoreG\" \nclass=\"text-uppercase md-amber-50-bg\"><div ng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il cognome è richiesto</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" \nname=\"nome\" ng-model=\"vm.beneficiario.nome\" placeholder=\"Nome\" required ng-disabled=\"vm.api.isOperatoreG\" \nclass=\"text-uppercase md-amber-50-bg\"><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il nome è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex=\"50\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codiceVestanet.$invalid)}\">Codice Vestanet</label><input type=\"text\" \nid=\"formDialogVestanet\" name=\"Vestanet\" \nng-init=\"vm.beneficiario.codiceVestanet = vm.beneficiario.codiceVestanet || \'\'\" \nng-model=\"vm.beneficiario.codiceVestanet\" placeholder=\"Codice Vestanet\" onfocus=\"this.value = \'\'\" \nng-disabled=\"vm.checkboxVestanet\" ng-required=\"vm.beneficiario.codiceVestanet !== null\"></md-input-container><div \nflex=\"50\"><label>Codice Vestanet non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxVestanet\" \nng-change=\"vm.checkboxVestanetOnClick()\"></label></div></div><div layout=\"row\" layout-align=\"space-between-center\" \nclass=\"margin-top-16\"><md-input-container flex=\"50\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cui.$invalid)}\">\nCodice Unico di Identificazione</label><input type=\"text\" id=\"formDialogCui\" name=\"Cui\" \nng-init=\"vm.beneficiario.cui = vm.beneficiario.cui || \'\'\" ng-model=\"vm.beneficiario.cui\" placeholder=\"Codice CUI\" \nonfocus=\"this.value = \'\'\" ng-disabled=\"vm.checkboxCui\" ng-required=\"vm.beneficiario.cui !== null\"></md-input-container>\n<div flex=\"50\"><label>Codice CUI non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxCui\" \nng-change=\"vm.checkboxCuiOnClick()\" ng-init=\"vm.checkboxCui\"></label></div></div><div layout=\"row\" \nlayout-align=\"space-between-center\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vm.beneficiario.sesso\" placeholder=\"Sesso\" required \nng-disabled=\"vm.api.isOperatoreG\" class=\"md-amber-50-bg\"><md-option value=\"M\"><small><b>MASCHILE</b></small>\n</md-option><md-option value=\"F\"><small><b>FEMMINILELE</b></small></md-option></md-select><div \nng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span></div>\n</div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nazionalita.$invalid)}\">Nazionalita</md-select-label><md-select \nname=\"nazionalita\" placeholder=\"Nazionalita\" ng-model=\"vm.beneficiario.codNazionalita\" required \nng-disabled=\"vm.api.isOperatoreG\" class=\"md-amber-50-bg\"><md-option ng-repeat=\"item in vm.nazionalitas\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.nazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nazionalita richiesta\n</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Nascita</label><md-datepicker datepicker-validation-fix class=\"md-block md-amber-50-bg\" name=\"dataNascita\" \nng-model=\"vm.beneficiario.dataNascita\" ng-disabled=\"vm.api.isOperatoreG\" required></md-datepicker></div>\n<md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.tipoProteziones| filter:{id:vm.beneficiario.tipoProtezione_id}\"><label>Tipo di soggiorno</label>\n<input type=\"text\" name=\"tipop\" value=\"{{item.descrizione}}\" placeholder=\"Tipo di soggiorno...\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo di segnalazione\n</label><input type=\"text\" name=\"tipoSegnalazione\" value=\"{{vm.beneficiario.tipoSegnalazione}}\" \nplaceholder=\"Tipo di segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Stato Attuale Beneficiario</label><input type=\"text\" name=\"dataNascita\" \nvalue=\"{{vm.beneficiario.stato}}\" required ng-disabled=\"true\" class=\"text-uppercase\"></md-input-container></div></div>\n<div layout=\"row\" class=\"margin-top-16\" \nng-if=\"vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\" ng-if=\"vm.api.isAdminG\">\n<b><label ng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataInizio == null)}\" style=\"pointer-events: all\"><small>\nData Inizio Accoglienza</small> <small ng-if=\"vm.eventiCambioData.length\">(<a ng-click=\"vm.mostraStoricoAccoglienza()\" \nstyle=\"cursor: pointer\">modifiche</a>)</small></label></b><md-icon style=\"color:rgba(0,0,0,0.54); cursor: pointer\" \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==\" \nng-click=\"vm.cambiaDataAccoglienza()\"></md-icon><input readonly=\"readonly\" \nng-model=\"vm.beneficiario.dataInizioDisplay\" name=\"dataInizio\" required ng-click=\"vm.cambiaDataAccoglienza()\" \nplaceholder=\"{{vm.dataOggiDisplay}}\"><div ng-messages=\"personaNForm.dataInizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Data richiesta</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dip.getFullYear() !== 3000\"><label flex style=\"max-height: 22px\">\nData ingresso progetto</label><md-datepicker disabled=\"disabled\" datepicker-validation-fix class=\"md-block\" \nname=\"dataIngressoProgetto\" ng-model=\"vm.beneficiario.dip\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dip.getFullYear() === 3000\"><label flex style=\"max-height: 22px\">\nData ingresso progetto</label><md-datepicker disabled=\"disabled\" datepicker-validation-fix class=\"md-block\" \nname=\"dataIngressoProgettoAlt\"></md-datepicker></div><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data fine accoglienza</label><md-datepicker datepicker-validation-fix class=\"md-block\" \nname=\"dataFine\" ng-model=\"vm.beneficiario.dataFine\" md-min-date=\"vm.beneficiario.dataIngresso\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dup.getFullYear() !== 1900\"><label flex style=\"max-height: 22px\">\nData uscita progetto</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscitaProgetto\" \nng-model=\"vm.beneficiario.dup\" ng-disabled=\"true\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.beneficiario.dup.getFullYear() === 1900\"><label flex style=\"max-height: 22px\">\nData uscita progetto</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscitaProgettoAlt\" \nng-disabled=\"true\"></md-datepicker></div><div flex layout=\"column\" class=\"datepicker-container\" \nng-if=\"vm.api.isAdminG\"><label flex style=\"max-height: 22px\">Data Uscita Accoglienza</label><md-datepicker \ndatepicker-validation-fix class=\"md-block\" name=\"dataUscita\" ng-model=\"vm.beneficiario.dataUscita\" \nmd-min-date=\"vm.beneficiario.dataUscita\" ng-disabled=\"(vm.api.isOperatoreG || vm.beneficiario.dataUscita == null)\">\n</md-datepicker></div></div></div><div layout=\"row\" class=\"margin-top-16\" \nng-if=\"vm.beneficiario.stato == \'PRESENTE SUL TERRITORIO\' || vm.beneficiario.stato == \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Inizio Presenza Sul Territorio</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataInizio\" \nng-model=\"vm.beneficiario.dataInizio\" md-min-date=\"vm.beneficiario.dataIngresso\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data fine Presenza Sul Territorio</label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataUscita\" ng-model=\"vm.beneficiario.dataUscita\" \nmd-min-date=\"vm.beneficiario.dataIngresso\" ng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker>\n</div></div><div layout=\"row\" class=\"margin-top-16\"><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (vm.beneficiario.dataIngresso == null && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\')}\" \nflex style=\"max-height: 22px\">Data Ingresso in Italia<sup>*</sup></label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataIngresso\" ng-model=\"vm.beneficiario.dataIngresso\" ng-required=\"!vm.api.isAdmin\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\"></md-datepicker><div \nng-messages=\"personaNForm.dataIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData richiesta</span></small></div></div></div><md-input-container flex class=\"margin-bottom-0\"><label>\nTipologia ingresso protetto</label><input type=\"text\" name=\"tipologia_id\" \nvalue=\"{{vm.beneficiario.tipologia.descrizione}}\" required disabled=\"disabled\"></md-input-container><md-input-container\n flex class=\"margin-bottom-0\"><label>Paese Terzo Provenienza</label><input type=\"text\" name=\"tipologia_id\" \nvalue=\"{{vm.beneficiario.paeseProvenienza.nazione.descrizione}}\" required disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Modalità ingresso in Italia</label><md-select \nname=\"idTipoIngresso\" ng-model=\"vm.beneficiario.idTipoIngresso\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\" ng-selected=\"vm.beneficiario.idTipoIngresso == item.id\"><strong>\n<small>{{item.descrizione}}</small></strong></md-option></md-select><div \nng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div>\n</div></md-input-container><md-input-container flex=\"25\" class=\"margin-bottom-0\" \nng-if=\"vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato != \'PRESENTE SUL TERRITORIO TERMINATO\'\">\n<label>Giorni Totali di Accoglienza</label><input type=\"text\" name=\"gta\" \nvalue=\"{{vm.calcolomontanteeffettuato[vm.beneficiario.id]}}\" required disabled=\"disabled\" class=\"text-uppercase\">\n</md-input-container></div><div layout=\"row\"><div \nng-if=\"vm.beneficiario.stato !== \'PRESENTE SUL TERRITORIO\' && vm.beneficiario.stato !== \'PRESENTE SUL TERRITORIO TERMINATO\'\" \nflex=\"50\"><div class=\"column padding-top-8\" flex><div layout=\"row\" flex><md-button class=\"md-button md-accent-bg\" \naria-label=\"Libera sul territorio\" ng-click=\"vm.liberaBeneficiario()\" flex>Registra come presente sul territorio\n</md-button></div></div></div><div ng-if=\"vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"50\"><div \nclass=\"column padding-top-8\" flex><div layout=\"row\" flex><md-button class=\"md-button md-accent-bg\" \nng-click=\"vm.reintegraBeneficiario()\" flex><b>Ripristina scheda Beneficiario</b></md-button></div></div></div><div \nng-if=\"!vm.beneficiario.cancellato && vm.api.isAdmin\" flex=\"50\"><div class=\"column padding-top-8\" flex><div \nlayout=\"row\" flex><md-button class=\"md-button\" ng-style=\"{\'background-color\': \'red\', \'color\': \'white\'}\" \nng-click=\"vm.cancellaBeneficiario()\" ng-show=\"vm.api.isAdmin\" flex><b>Elimina scheda beneficiario</b></md-button></div>\n</div></div></div></div></md-tab><md-tab label=\"DETTAGLIO\"><div id=\"anagraficatab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>NUCLEI, PARENTELA E NOTE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.nucleoFamiliare.$invalid)}\">Stato Parentela</md-select-label><md-select \nname=\"nucleoFamiliare\" placeholder=\"Stato Parentela\" ng-model=\"vm.beneficiario.nucleoFamiliare\" required \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-value=\"item.codice\" ng-repeat=\"item in vm.nucleofamiliares\"><div \nlayout=\"column\"><small><b>{{item.descrizione}}</b></small> <small>{{item.note}}</small></div></md-option></md-select>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Parentela</label><md-select \nname=\"parentela_id\" ng-model=\"vm.beneficiario.parentela_id\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"item in vm.parentelas | filtraparentele:[vm.beneficiario.nucleoFamiliare]:\'id\'\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.parentela_id == item.id\"><div layout=\"column\"><small><b>{{item.descrizione}}</b></small> \n<small>{{item.note}} <span ng-if=\"(item.note == \'Nucleo familiare\' && vm.beneficiario.nucleoFamiliare == 0)\">\no monoparentale</span></small></div></md-option></md-select></md-input-container></div><div layout=\"row\"><ng-form \nname=\"vm.capofamigliaForm\" ng-if=\"[0,1].indexOf(vm.beneficiario.nucleoFamiliare) !== -1\" flex><span flex \nclass=\"margin-bottom-0\"><label><b>Capofamiglia:</b></label><input type=\"text\" name=\"capof_id\" \nng-value=\"vm.beneficiario.capof_id\" placeholder=\"Capofamiglia\" hidden required> <span \nng-if=\"vm.beneficiario.capoFamiglia != null\">\n{{vm.beneficiario.capoFamiglia.cognome}} {{vm.beneficiario.capoFamiglia.nome}} ({{vm.beneficiario.capoFamiglia.codice}})\n</span> <span ng-if=\"vm.beneficiario.capoFamiglia == null\">Capofamiglia non presente</span></span></ng-form>\n<md-input-container flex><label>Vulnerabilita</label><md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" \nng-model=\"vm.beneficiario.idVulnerabilita\" ng-disabled=\"!vm.api.isAdminG\"><md-option ng-value=\"0\"><small \nclass=\"text-italic\">Nessuna/o</small></md-option><md-option ng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Note</label><textarea name=\"note\" ng-model=\"vm.beneficiario.note\" \nplaceholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\" ng-disabled=\"!vm.api.isAdminG\"></textarea>\n</md-input-container><md-input-container flex><label>Note Sanitarie</label><textarea name=\"noteSanitarie\" \nng-model=\"vm.beneficiario.noteSanitarie\" placeholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\" \nng-disabled=\"!vm.api.isAdminG\"></textarea></md-input-container></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>FAMIGLIA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-card><md-table-container><table data-md-table><thead md-head><tr md-row style=\"height: 24px\">\n<th md-column style=\"padding:2px\"></th><th md-column style=\"padding:2px\" md-order-by=\"nome\">NOME</th><th md-column \nstyle=\"padding:2px\">COGNOME</th><th md-column style=\"padding:2px\">CODICE</th><th md-column style=\"padding:2px\">\nPARENTELA</th></tr></thead><tbody md-body ng-repeat=\"item in vm.famiglia\"><tr md-row style=\"height: 36px\"><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><md-icon ng-if=\"item.capof_id == 0\" \nmd-font-icon=\"icon-account-circle\"><md-tooltip>CAPOFAMIGLIA</md-tooltip></md-icon></div></td><td \nclass=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.nome | uppercase}}</span></div>\n</td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.cognome | uppercase}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>{{ item.codice}}\n</span></div></td><td class=\"light-blue-900-fg font-weight-600 md-cell\"><div layout=\"column\"><span>\n{{ item.parentelas.descrizione}}</span></div></td></tr></tbody></table></md-table-container></md-card></div><md-divider\n class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI FACOLTATIVE</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"naz in vm.religioni\" ng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>\n{{naz.descrizione}}</small></strong></md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Gruppo Etnico</label><input type=\"text\" name=\"gruppoEtnico\" \nng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div><div layout=\"row\" flex class=\"margin-top-16\">\n<md-input-container flex class=\"margin-bottom-0\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.beneficiario.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Telefono\n</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" ng-disabled=\"!vm.api.isAdminG\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" \nng-model=\"vm.beneficiario.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div></div></md-tab><md-tab label=\"STATUS GIURIDICO\"><div \nid=\"statustab\"><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg\"><small><b>STATUS GIURIDICO E PROTEZIONE\n</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex><label>\nManifestazione volontà protezione internazionale</label><md-select name=\"interesseExArt\" \nplaceholder=\"Manifestazione volontà protezione internazionale\" ng-model=\"vm.beneficiario.interesseExArt\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data Manifestazione volontà</label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataInteresseExArt\" ng-model=\"vm.beneficiario.dataInteresseExArt\" \nng-disabled=\"!vm.beneficiario.interesseExArt && !vm.api.isAdminG\"></md-datepicker></div><md-input-container flex>\n<label>Compilazione C3</label><md-select name=\"c3\" placeholder=\"Compilazione C3\" ng-model=\"vm.beneficiario.c3\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label \nflex style=\"max-height: 22px\">Data compilazione C3</label><md-datepicker datepicker-validation-fix class=\"md-block\" \nname=\"dataC3\" ng-model=\"vm.beneficiario.dataC3\" ng-disabled=\"(!vm.beneficiario.c3 && !vm.api.isAdminG)\">\n</md-datepicker></div></div><div layout=\"row\"><md-input-container flex><label>Tipo di Soggiorno</label><md-select \nname=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" ng-model=\"vm.beneficiario.tipoProtezione_id\" \nng-disabled=\"true\"><md-option ng-repeat=\"item in vm.tipoProteziones\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container><div flex=\"25\" layout=\"column\" class=\"datepicker-container\">\n<label flex style=\"max-height: 22px\">Data richiesta protezione</label><md-datepicker datepicker-validation-fix \nclass=\"md-block\" name=\"dataRichiestaProtezione\" ng-model=\"vm.beneficiario.dataRichiestaProtezione\"></md-datepicker>\n</div><div flex=\"25\" layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData avvenuta notifica</label><md-datepicker datepicker-validation-fix name=\"dataAvvenutaNotifica\" \nng-model=\"vm.beneficiario.dataAvvenutaNotifica\" md-placeholder=\"Data avvenuta notifica\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.minDatesafe\" ng-disabled=\"true\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label>Provenienza</label><md-select name=\"idProvenienza\" placeholder=\"Provenienza\" \nng-model=\"vm.beneficiario.idProvenienza\"><md-option ng-repeat=\"item in vm.provenienza\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select></md-input-container><md-input-container flex><label>\nStato Dublino</label><md-select name=\"idDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.beneficiario.idDublino\" \nng-disabled=\"(vm.beneficiario.idProvenienza != 624)\" ng-required=\"(vm.beneficiario.idProvenienza == 624)\"><md-option \nng-repeat=\"item in vm.dublino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select>\n</md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData richiesta Pds</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataRichiestaPds\" \nng-model=\"vm.beneficiario.dataRichiestaPds\" md-min-date=\"vm.beneficiario.dataInteresseExArt\" md-max-date=\"vm.oggi\">\n</md-datepicker></div></div><md-divider class=\"md-light-blue-100-bg padding-8 red-500-fg margin-top-16\"><small><b>\nULTIMO DOCUMENTO BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex>\n<label>Documento di soggiorno</label><md-select name=\"idTipoDocumento\" placeholder=\"Documento di soggiorno...\" \nng-model=\"vm.beneficiario.idTipoDocumento\" ng-disabled=\"!vm.api.isAdminG\"><md-option \nng-repeat=\"item in vm.tipoDocumento\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Documento rilasciato da</label><md-select \nname=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" ng-model=\"vm.beneficiario.enteDocumento_id\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.enteDocumentoids\" ng-value=\"item.id\"><small><b>\n{{item.nome}}</b></small></md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>\nDocumento Numero</label><input type=\"text\" name=\"documentoNumero\" ng-model=\"vm.beneficiario.documentoNumero\" \nng-disabled=\"!vm.api.isAdminG\"></md-input-container></div><div layout=\"row\"><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Rilascio documento</label><md-datepicker \ndatepicker-validation-fix class=\"md-block\" name=\"dataRilascioDocumento\" \nng-model=\"vm.beneficiario.dataRilascioDocumento\" ng-disabled=\"!vm.api.isAdminG\"></md-datepicker></div><div flex \nlayout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Scadenza documento</label>\n<md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataScadenzaDocumento\" \nng-model=\"vm.beneficiario.dataScadenzaDocumento\" ng-disabled=\"!vm.api.isAdminG\"></md-datepicker></div>\n<md-input-container flex><label>Cambio questura, prefettura, commissione</label><md-select name=\"cambioQPC\" \nplaceholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.beneficiario.cambioQPC\" \nng-disabled=\"!vm.api.isAdminG\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote cambio questura, prefettura, commissione</label><textarea name=\"noteCambioQPC\" \nng-model=\"vm.beneficiario.noteCambioQPC\" placeholder=\"Note cambio questura, prefettura, commissione...\" \naria-label=\"Notecqpc\" rows=\"1\" ng-disabled=\"!vm.api.isAdminG\"></textarea></md-input-container></div></div></md-tab>\n<md-tab label=\"CORSI SERVIZI\"><div id=\"strutturecorsiservizitab\"><div id=\"sectionservizi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>SERVIZI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei servizi\" type=\"text\" ng-model=\"vm.sersearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.sersearchYear\" \nplaceholder=\"Anno servizi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">\nNOME SERVIZIO</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.servizios| filter: vm.sersearch | filter: {dataFine:vm.sersearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.servizi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.servizicat\" ng-if=\"sitem.id === item.servizi.servizi_id\"><small>\n{{ sitem.descrizione|uppercase}}</small></span> <span class=\"light-blue-900-fg font-weight-600\">\n{{ item.servizi.descrizione | uppercase}}</span> <span><small>{{ item.servizi.note|uppercase}}</small></span></div>\n</td><td md-cell><div layout=\"column\"><span class=\"light-blue-900-fg font-weight-600\">\n{{ item.progetto.nome | uppercase}}</span> <span><small>{{ item.progetto.istat.comune|uppercase}}</small></span></div>\n</td><td md-cell style=\"text-align: left\"><b>{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell \nstyle=\"text-align: left\"><b>{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phs.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phs.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"></td></tr></tbody></table>\n</md-table-container><div layout=\"row\" ng-if=\"vm.api.isAdminG && !vm.beneficiario.cancellato\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openServiziBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO SERVIZIO</md-button></div></md-card></div><div id=\"sectioncorsi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>CORSI USUFRUITI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei corsi\" type=\"text\" ng-model=\"vm.corsearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.corsearchYear\" \nplaceholder=\"Anno corsi\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"servizi_id\" style=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">NOME CORSO\n</th><th md-column style=\"text-align: left\">PROGETTO</th><th md-column md-order-by=\"dataInizio\" \nstyle=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th><th \nmd-column style=\"text-align: left\">ATTIVO DAL</th><th md-column style=\"text-align: left\">AL</th><th md-column \nstyle=\"text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.beneficiario.corsos| filter: vm.corsearch | filter: {dataFine:vm.corsearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.corsi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.corsicat\" ng-if=\"sitem.id === item.corsi.corsi_id\"><small>{{ sitem.descrizione|uppercase}}\n</small></span> <span class=\"light-blue-900-fg font-weight-600\">{{ item.corsi.descrizione | uppercase}}</span> <span>\n<small>{{ item.corsi.note|uppercase}}</small></span></div></td><td md-cell><div layout=\"column\"><span \nclass=\"light-blue-900-fg font-weight-600\">{{ item.progetto.nome | uppercase}}</span> <span><small>\n{{ item.progetto.istat.comune|uppercase}}</small></span></div></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\">\n{{item.phc.dataInizio| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: left\">\n{{item.phc.dataFine| date: \'dd/MM/yyyy\'}}</td><td md-cell style=\"text-align: right\"></td></tr></tbody></table>\n</md-table-container><div layout=\"row\" ng-if=\"vm.api.isAdminG && !vm.beneficiario.cancellato\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openCorsiBenDialog($event, vm.beneficiario, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO CORSO</md-button></div></md-card></div></div></md-tab><md-tab label=\"STORICI\"><div \nid=\"storicostatustab\"><div id=\"storicoeventi\" ng-if=\"vm.bloaded\"><sprardb-tabellar titolo=\"Storico status giuridico\" \nng-model=\"vm.beneficiario.eventoAstatusgs\" mostrazioni=\"0\" mostradate=\"0\"></sprardb-tabellar><sprardb-tabellar \ntitolo=\"Storico documenti\" ng-model=\"vm.beneficiario.eventoAdocumentos\" mostrazioni=\"0\"></sprardb-tabellar><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico trasferimenti\" \nng-model=\"vm.beneficiario.eventoAtrasferimentos\" mostrazioni=\"0\"></sprardb-tabellar><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><md-divider style=\"margin: 24px 0px\"></md-divider><md-card><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Presenze Sul Territorio</b></small><div flex></div></div></md-toolbar>\n<md-table-container><table data-md-table><thead md-head><tr md-row><th md-column md-order-by=\"id\"><span>#</span></th>\n<th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">STATO</th><th md-column style=\"text-align: left\" \nmd-order-by=\"eventoTipo_id\">EVENTO</th><th md-column md-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th \nmd-column md-order-by=\"dataFine\" style=\"text-align: left\">FINE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.eventiPresenze track by item.id\"><td md-cell>{{item.id}}</td><td md-cell><md-button \nclass=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">{{item.eventoStato.stato| limitTo:2 }}\n<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b> // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td \nmd-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell><b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell>\n<b>{{item.dataFine| date: \"dd/MM/yyyy\"}}</b></td></tr></tbody></table></md-table-container></md-card><md-divider \nstyle=\"margin: 24px 0px\"></md-divider><md-card><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><small><b>Storico proroghe</b>\n</small><div flex></div></div></md-toolbar><md-table-container><table data-md-table><thead md-head><tr md-row><th \nmd-column md-order-by=\"id\"><span>#</span></th><th md-column style=\"text-align: center\" md-order-by=\"eventoStato_id\">\nSTATO</th><th md-column style=\"text-align: left\" md-order-by=\"eventoTipo_id\">EVENTO</th><th md-column \nmd-order-by=\"dataInizio\" style=\"text-align: left\">INIZIO</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\">FINE</th><th md-column style=\"text-align: center\">PROCESSO</th></tr></thead><tbody md-body><tr\n md-row ng-repeat=\"item in vm.beneficiario.eventoAprorogas track by item.id\"><td md-cell>{{item.id}}</td><td md-cell>\n<md-button class=\"md-fab md-mini {{vm.colors[item.eventoStato_id]}}\" aria-label=\"status\">\n{{item.eventoStato.stato| limitTo:2 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell><b>{{item.eventoTipo.nome}}</b></td><td md-cell>\n<b>{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{(item.eventoStato_id == 4 ? item.extra.dataConcessioneProroga : item.dataFine)| date: \"dd/MM/yyyy\"}}</b> <small \nng-if=\"(item.dataFine == null)\">NON LAVORATO</small></td><td md-cell style=\"text-align: right\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"DettaglioEvento\" \nng-click=\"vm.viewEvento($event, item, \'evento\')\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><b><small>\nDETTAGLIO EVENTO</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"DettaglioExtra\" \nng-click=\"vm.viewEvento($event, item, \'extra\')\"><md-icon md-font-icon=\"icon-details\"></md-icon><b><small>DETTAGLI EXTRA\n</small></b></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n</md-card><md-divider style=\"margin: 24px 0px\"></md-divider><sprardb-tabellar titolo=\"Storico uscite\" \nng-model=\"vm.beneficiario.eventoAuscitas\" mostrazioni=\"0\"></sprardb-tabellar><md-divider style=\"margin: 24px 0px\">\n</md-divider></div><md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><b>Storico strutture</b></small><div layout=\"row\" flex></div><div flex></div></div>\n</md-toolbar><md-table-container id=\"tabellar\" ng-if=\"vm.api.isOperatoreG\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"nome\">NOME</th><th md-column>\nDATA INSERIMENTO</th><th md-column>DATA CESSAZIONE</th><th md-column>ACCOGLIENZA</th><th md-column \nmd-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th></tr></thead><tbody md-body \nng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios| filter: {progetto_id:vm.beneficiario.progetto_id} track by preitem.id\">\n<tr md-row ng-repeat=\"item in vm.beneficiario.strutturas| filter: {id:preitem.struttura_id}\"><td \nclass=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>{{ item.nome | uppercase}}</span>\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\"></md-progress-linear>\n<span>{{item.progettos.nome| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}<md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.changeDataIns(preitem.id, preitem.dataInserimento, \'dataInserimento\')\" aria-label=\"bt\" \nng-if=\"(vm.api.isAdmin)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-default-theme md-font material-icons icon-pencil\"></md-icon></md-button></span></div></td><td md-cell><div \nlayout=\"column\"><span>{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}<md-button \nclass=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.changeDataIns(preitem.id, preitem.dataCessazione, \'dataCessazione\')\" aria-label=\"bt1\" \nng-if=\"(vm.api.isAdmin)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-default-theme md-font material-icons icon-pencil\"></md-icon></md-button></span></div></td><td md-cell><span \nng-if=\"preitem.esterna\">ESTERNA</span></td><td md-cell><div layout=\"column\"><span>\n{{item.indirizzo| uppercase | limitTo:25}}...</span> <span><b>{{item.istats.comune| uppercase}}</b></span> <span>\n{{item.istats.provincia| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span><b>\n{{item.strutturaAccoglienzas.descrizione}}</b></span> <span>{{item.strutturaAlloggios.descrizione}}</span></div></td>\n</tr></tbody></table></md-table-container><md-table-container id=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"nome\">NOME</th><th md-column>\nDATA INSERIMENTO</th><th md-column>DATA CESSAZIONE</th><th md-column>ACCOGLIENZA</th><th md-column \nmd-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th></tr></thead><tbody md-body \nng-repeat=\"preitem in vm.beneficiario.strutturahasbeneficiarios track by preitem.id\"><tr md-row \nng-repeat=\"item in vm.beneficiario.strutturas| filter: {id:preitem.struttura_id}\"><td \nclass=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>{{ item.nome | uppercase}}</span>\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - item.postioccupati) / item.numeroPosti * 100) | number}}\"></md-progress-linear>\n<span>{{item.progettos.nome| uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataInserimento | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{ preitem.dataCessazione | date : \"dd/MM/yyyy\"}}</span></div></td><td md-cell><span ng-if=\"preitem.esterna\">ESTERNA\n</span></td><td md-cell><div layout=\"column\"><span>{{item.indirizzo| uppercase | limitTo:25}}...</span> <span><b>\n{{item.istats.comune| uppercase}}</b></span> <span>{{item.istats.provincia| uppercase}}</span></div></td><td md-cell>\n<div layout=\"column\"><span><b>{{item.strutturaAccoglienzas.descrizione}}</b></span> <span>\n{{item.strutturaAlloggios.descrizione}}</span></div></td></tr></tbody></table></md-table-container></md-card></div>\n</md-tab><md-tab label=\"DOCUMENTI\"><div id=\"doctab\" bg-if=\"vm.caricamentoultimato\"><sprardb-uploaddocuments3 \nng-model=\"vm.uploadParams\"></sprardb-uploaddocuments3></div></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/nuovo.html","<div id=\"forms\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" onclick=\"history.go(-1)\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"column\" layout-align=\"start start\"><span class=\"logo-text\">Inserimento nuovo Beneficiario</span><div \nclass=\"subtitle secondary-text\"><span>{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</span></div></div></div>\n</div><div></div></div><div class=\"content\" ms-scroll><form name=\"personaNForm\" ms-vertical-stepper \nng-submit=\"vm.submitVerticalStepper()\" ng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step \nng-form=\"verticalStep1\" step=\"1\" step-title=\"\'Inserisci i dati essenziali\'\"><div \nng-include=\"\'app/main/sprardb/form/beneficiario-step-1.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Informazioni di Ingresso\'\" \nhide-step=\"!vm.isnew\"><div ng-include=\"\'app/main/sprardb/form/beneficiario-step-2.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" \nstep-title=\"\'Progetti Territoriali\'\"><div ng-include=\"\'app/main/sprardb/form/beneficiario-step-3.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Dati accessori\'\" \noptional-step><div ng-include=\"\'app/main/sprardb/form/beneficiario-step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Invio Inserimento\'\"><div \nng-include=\"\'app/main/sprardb/form/beneficiario-step-5.html\'\"></div></ms-vertical-stepper-step></form></div></div>\n</div>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/accogliInStruttura-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>ACCOGLI BENEFICIARIO IN STRUTTURA</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"beneficiarioForm\" novalidate><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">Data accoglienza in struttura</label><br>\n<md-datepicker datepicker-validation-fix ng-model=\"vmd.dataInizio\" flex=\"100\" name=\"dataInizio\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required md-min-date=\"vmd.beneficiario.dataIngresso\">\n</md-datepicker><div ng-messages=\"beneficiarioForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data inizio è obbligatoria</span></div></div></div><md-input-container flex><label>\nStruttura</label><md-select ng-model=\"vmd.struttura\" required><md-select-header>Scegli Struttura</md-select-header>\n<md-option ng-repeat=\"pro in vmd.strutture\" value=\"{{pro.id}}\"><small><b>{{pro.nome}}</b>\n in {{pro.istats.comune}} ({{(pro.numeroPosti - pro.beneficiarios.length)}}) - {{pro.strutturaAccoglienzas.descrizione}} {{pro.strutturaAlloggios.descrizione}}\n</small></md-option></md-select></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button class=\"md-raised md-accent\" ng-click=\"vmd.accogliInStruttura()\">ACCOGLI IN STRUTTURA</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/annullaUscita-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Annulla Uscita Beneficiario</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>Sei sicuro di voler annullare l\'uscita di questo beneficiario?\n</h3></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancelDialog()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vmd.hideDialog()\">\nCONFERMA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/cambioData-dialog.html","<md-dialog><form><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 ng-if=\"vmd.flag==\'dataInserimento\'\">\nModifica Data Inserimento</h2><h2 ng-if=\"vmd.flag==\'dataCessazione\'\">Modifica Data Cessazione</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"datepicker-container\"><label nstyle=\"max-height: 22px;\" ng-if=\"vmd.flag==\'dataCessazione\'\">Data Cessazione\n</label><label nstyle=\"max-height: 22px;\" ng-if=\"vmd.flag==\'dataInserimento\'\">Data Inserimento</label><md-datepicker \nclass=\"md-block\" name=\"dataNascita\" ng-model=\"vmd.data\" ng-if=\"vmd.flag==\'dataCessazione\'\" \nmd-placeholder=\"Data inserimento\" required></md-datepicker><md-datepicker class=\"md-block\" name=\"dataNascita\" \nng-model=\"vmd.data\" ng-if=\"vmd.flag==\'dataInserimento\'\" md-placeholder=\"Data cessazione\" required></md-datepicker>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-if=\"vmd.dataNew.getTime() != vmd.data.getTime()\" ng-click=\"vmd.save(vmd.data,vmd.flag,vmd.id)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">SALVA</md-button><md-button type=\"submit\" \nng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">CHIUDI</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/cambioDataMc_dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Cambia Data Inizio Accoglienza</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"segnalaForm\" novalidate><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">Nuova Data Inizio Accoglienza*</label><br>\n<md-datepicker datepicker-validation-fix ng-model=\"vmd.dataInizio\" flex=\"100\" name=\"dataInizio\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required md-min-date=\"vmd.beneficiario.dataIngresso\">\n</md-datepicker><div ng-messages=\"segnalaForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data inizio è obbligatoria</span></div></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancelDialog()\" style=\"margin-right:20px\">\nAnnulla</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"segnalaForm.$submitted || segnalaForm.$invalid\" \nng-click=\"vmd.hideDialog()\">CONFERMA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/dialog_parentela.html","<md-dialog aria-label=\"gestisci parentela\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Gestisci parentela</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"simple-table-container\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>Cod</th><th>COGNOME</th><th>NOME</th><th class=\"text-center\">CAPOFAMIGLIA</th><th>\nPARENTELA</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"item in vmd.items track by $index\">\n<td>{{ item.id}}</td><td class=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td class=\"text-center\"><input type=\"radio\" \nname=\"capofamiglia\" ng-model=\"vmd.capofamiglia\" ng-value=\"item.id\" ng-change=\"item.parentela_id = 674;\"></td><td>\n<md-select name=\"parentela\" ng-model=\"item.parentela_id\" style=\"margin: 0px\" aria-label=\"paren\"><md-option \nng-repeat=\"p in vmd.parentelas\" ng-value=\"p.id\" ng-selected=\"item.parentela_id == p.id\"><strong><small>\n{{p.descrizione}}</small></strong></md-option></md-select></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancel()\" style=\"margin-right:20px\">Annulla\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vmd.assegna()\" \nstyle=\"margin-right:20px\">Assegna</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/disattivaEsterna.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Struttura esterna</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><span>La struttura esterna <b>\n{{vmd.struttura.nome}} </b>è vuota, si prega di andare a disattivarla.</span></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"send-button md-accent md-raised\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vmd.progetto_id})\" ng-click=\"vmd.closeDialog()\">VAI AL PROGETTO\n</md-button><md-button ng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Notification\">CHIUDI</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/liberaBeneficiario-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Registra come presente sul territorio</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"beneficiarioForm\" novalidate><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">Data registrazione presente sul territorio\n</label><br><md-datepicker datepicker-validation-fix ng-model=\"vmd.dataInizio\" flex=\"100\" name=\"dataInizio\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required md-min-date=\"vmd.beneficiario.dataIngresso\">\n</md-datepicker><div ng-messages=\"beneficiarioForm.dataInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data inizio è obbligatoria</span></div></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vmd.liberaBeneficiario()\">Conferma</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/mostraDataMc_dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>STORICO</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-table-container><table data-md-table><thead md-head><tr md-row>\n<th md-column>Data Precedente Inizio</th><th md-column>Nuova Data Inizio</th><th md-column>Data Precedente Fine</th><th\n md-column>Nuova Data Fine</th><th md-column>Da</th><th md-column>Data Modifica</th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"e in vmd.eventi\"><td md-cell>{{e.extra.dataInizioPrecedente | date: \'dd/MM/yyyy\'}}</td><td md-cell>\n{{e.dataInizio | date: \'dd/MM/yyyy\'}}</td><td md-cell>{{e.extra.dataFinePrecedente | date: \'dd/MM/yyyy\'}}</td><td \nmd-cell>{{e.dataFine | date: \'dd/MM/yyyy\'}}</td><td md-cell>{{e.da}}</td><td md-cell>\n{{e.dataInserimento | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container><div class=\"grid-container\">\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised\" \nng-click=\"vmd.hideDialog()\">OK</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/omonimi.html","<md-dialog><form><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Omonimi</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container><table \nmd-table><thead md-head><tr md-row><th md-column>Id</th><th md-column>NOME</th><th md-column>COGNOME</th><th md-column>\nDATA DI NASCITA</th><th md-column>NAZIONALITA</th><th md-column>STATO</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.omonimi\" ng-class=\"{\'md-light-blue-50-bg\': item.omonimo.id === vmd.item.id}\"><td md-cell><span \nng-if=\"item.omonimo[\'codice\'] == undefined || item.omonimo[\'codice\'] == 0\">{{item.omonimo.id}}</span> <span \nng-if=\"item.omonimo[\'codice\'] != undefined && item.omonimo[\'codice\'] != 0\">{{item.omonimo.codice}}</span></td><td \nmd-cell>{{item.omonimo.nome}}</td><td md-cell>{{item.omonimo.cognome}}</td><td md-cell>\n{{item.omonimo.dataNascita|date: \"dd/MM/yyyy\"}}</td><td md-cell>{{item.omonimo.nazionalita.descrizione}}</td><td \nmd-cell><span ng-if=\"item.omonimo[\'codice\'] == undefined\">SEGNALATO</span> <span \nng-if=\"item.omonimo[\'codice\'] != undefined\">BENEFICIARIO</span></td></tr></tbody></table></md-table-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">CHIUDI</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/dialog/terminaBeneficiarioNelTerritorio-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>TERMINA BENEFICIARIO NEL TERRITORIO</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"beneficiarioForm\" novalidate><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">Data chiusura presenza nel territorio</label>\n<br><md-datepicker datepicker-validation-fix ng-model=\"vmd.dataFine\" flex=\"100\" name=\"dataFine\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required md-min-date=\"vmd.beneficiario.dataInizio\">\n</md-datepicker><div ng-messages=\"beneficiarioForm.dataFine.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data fine è obbligatoria</span></div></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vmd.terminaNelTerritorio()\">TERMINA PRESENZA NEL TERRITORIO</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/configurazioni/bandos/bandos.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/bandos/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Bandi\n</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"><md-button layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" class=\"mr-8\"></md-icon>server</md-button>\n</md-input-container></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div \nclass=\"main\" ms-scroll><md-list class=\"contacts-list\"><div class=\"result-info\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\">&nbsp;\n</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: </span><span>:</span> </span><span \nclass=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>{{vm.meta.pageCount}}</span> <span \ntranslate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div><div class=\"pager\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button disabled\" aria-label=\"previous page\" translate \ntranslate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" ng-click=\"vm.pagerPrev(vm.links.prev.href)\" \nng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"next page\" translate translate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" \nng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" layout=\"row\"><div \nclass=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'ruolo\', ((vm.listOrderAsc)?\'-\':\'\'));\"></md-icon></a><strong>BANDO</strong></div></div>\n<md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"bando in vm.bandos  | filter: vm.search track by bando.id \" ng-click=\"vm.openContactDialog($event, bando)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.bandos.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(bando)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">\n{{bando.descrizione}}</p></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/enteruolos/enteruolos.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/enteruolos/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nEnte/Ruolo</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"><md-button layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" class=\"mr-8\"></md-icon>\nserver</md-button></md-input-container></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pagerPrev(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'ruolo\', ((vm.listOrderAsc)?\'-\':\'\'));\"></md-icon></a><strong>GRUPPO</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"30\"><strong>RUOLO</strong></div><div class=\"secondary-text padding-8\" flex>\n</div></div><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"enteruolo in vm.enteruolos  | filter: vm.search track by enteruolo.id \" \nng-click=\"vm.openContactDialog($event, enteruolo)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.enteruolos.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(enteruolo)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">\n{{enteruolo.gruppo}}</p></div><div flex=\"30\"><p class=\"text-truncate font-weight-600\">{{enteruolo.descrizione}}</p>\n</div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p \ntranslate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/documentotipos/documentotipos.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/documentotipos/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nTipo di Documenti</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"><md-button layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" class=\"mr-8\"></md-icon>\nserver</md-button></md-input-container></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pagerPrev(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'ruolo\', ((vm.listOrderAsc)?\'-\':\'\'));\"></md-icon></a><strong>TIPO</strong></div><div \nclass=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'ruolo\', ((vm.listOrderAsc)?\'-\':\'\'));\"></md-icon></a><strong>GRUPPO</strong></div></div>\n<md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"documentotipo in vm.documentotipos  | filter: vm.search track by documentotipo.id \" \nng-click=\"vm.openContactDialog($event, documentotipo)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.documentotipos.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(documentotipo)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">\n{{documentotipo.tipo}}</p></div><div flex=\"30\"><p class=\"text-truncate font-weight-600\">{{documentotipo.gruppo}}</p>\n</div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p \ntranslate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/entetipos/entetipos.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/entetipos/sidenavs/main/main-sidenav.html\'\">Ente/Tipo</md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nEnte/Tipo</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"><md-button layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" class=\"mr-8\"></md-icon>\nserver</md-button></md-input-container></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pagerPrev(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8\" flex=\"30\"><strong>TIPO</strong></div><div \nclass=\"secondary-text padding-8\" flex></div></div><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"entetipo in vm.entetipos  | filter: vm.search track by entetipo.id \" \nng-click=\"vm.openContactDialog($event, entetipo)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.entetipos.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(entetipo)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">\n{{entetipo.descrizione}}</p></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/personaruolos/personaruolos.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/personaruolos/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">\nPersona/Ruolo</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"><md-button layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" class=\"mr-8\"></md-icon>\nserver</md-button></md-input-container></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pagerPrev(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'ruolo\', ((vm.listOrderAsc)?\'-\':\'\'));\"></md-icon></a><strong>GRUPPO</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"30\"><strong>RUOLO</strong></div><div class=\"secondary-text padding-8\" flex>\n</div></div><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"personaruolo in vm.personaruolos  | filter: vm.search track by personaruolo.id \" \nng-click=\"vm.openContactDialog($event, personaruolo)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.personaruolos.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(personaruolo)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">\n{{personaruolo.gruppo}}</p></div><div flex=\"30\"><p class=\"text-truncate font-weight-600\">{{personaruolo.descrizione}}\n</p></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/tags/tags.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/configurazioni/tags/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Tag\n</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Ricerca\" type=\"text\" ng-model=\"vm.search\"><md-button \nclass=\"md-button-icon\" layout-align=\"start center\" ng-click=\"vm.searchServer2();\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"mr-8\"></md-icon></md-button></md-input-container></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pagerPrev(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pagerNext(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8\" flex=\"30\"><strong>TAG</strong></div><div \nclass=\"secondary-text padding-8\" flex></div></div><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"tag in vm.tags| filter: vm.search track by tag.id \" ng-click=\"vm.openContactDialog($event, tag)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': vm.tags.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(tag)}\"><div flex=\"30\"><p class=\"text-truncate font-weight-600\">{{tag.tag}}</p>\n</div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p \ntranslate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/contatti/dettaglio/dettaglio.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" onclick=\"history.go( - 1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Persona</span><div class=\"subtitle secondary-text\"><span>{{vm.contact.nome}} {{vm.contact.cognome}}\n</span></div></div></div></div><div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveContact();\" \nclass=\"md-raised md-background\" ng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" aria-label=\"Add Task\">\nSALVA</md-button></div></md-dialog-actions></div></div><div class=\"content\" ms-scroll><md-tabs md-dynamic-height>\n<md-tab><md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-8\"><form name=\"personaNForm\" class=\"md-inline-form\" \nnovalidate><h2 class=\"no-padding\"><strong>Informazioni Generali</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div flex=\"100\"><div layout=\"row\" flex><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><input type=\"text\" name=\"nome\" ng-model=\"vm.contact.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl nome dell\'utente è richiesto.</span></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><input type=\"text\" name=\"cognome\" ng-model=\"vm.contact.cognome\" \nplaceholder=\"Cognome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il cognome dell\'utente è richiesto.</span></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso\n</label><md-select name=\"sesso\" ng-model=\"vm.contact.sesso\"><md-option value=\"M\">Maschio</md-option><md-option \nvalue=\"F\">Femmina</md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex><div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><label>Email</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input type=\"email\" name=\"email\" ng-model=\"vm.contact.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required class=\"font-size-12\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n</div><div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><label>Telefono</label><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" \nplaceholder=\"Telefono\" class=\"font-size-12\"></md-input-container></div><div layout=\"column\" flex><md-input-container \nflex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale</label><input \ntype=\"text\" name=\"codicefiscale\" ng-model=\"vm.contact.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.codicefiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n</div></div><h2 class=\"no-padding\"><strong>Luogo di residenza</strong></h2><md-divider></md-divider><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>\nRegione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" ng-model=\"vm.contact.codRegione\" \nng-change=\"vm.caricaProvince(vm.contact.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label><md-select \nname=\"prov\" ng-model=\"vm.contact.codProvincia\" ng-disabled=\"!vm.contact.codRegione\" \nng-change=\"vm.caricaComuni(vm.contact.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.contact.indirizzo\" \nplaceholder=\"Indirizzo\"></md-input-container><md-input-container flex><label>codice Postale</label><input name=\"cap\" \nng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><h2 class=\"no-padding\"><strong>Luogo e data di nascita</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg2\" \nng-model=\"vm.contact.nascita.codRegione\" ng-change=\"vm.caricaProvince2(vm.contact.nascita.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones2\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.nascita.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex required><label>Provincia</label><md-select name=\"prov2\" \nng-model=\"vm.contact.nascita.codProvincia\" ng-disabled=\"!vm.contact.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.contact.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vm.contact.codComuneNascita\" ng-disabled=\"!vm.contact.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.contact.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><label>Nazionalità</label><md-icon \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><md-select name=\"naz\" ng-model=\"vm.contact.codNazionalita\"><md-option \nng-repeat=\"nazione in vm.nazioni\" value=\"{{nazione.id}}\">{{nazione.descrizione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container><div flex><strong>\n<small>DATA DI NASCITA</small></strong><md-datepicker ng-model=\"vm.contact.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex></md-datepicker></div></div></div><h2 class=\"no-padding\">\n<strong>Tags</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-chips ng-model=\"vm.contact.tags\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText,vm.tags,\'tag\')\" md-item-text=\"item.tag\" \nplaceholder=\"Aggiungi nuovo tag\"><span md-highlight-text=\"vm.searchText\">{{item.tag}}</span></md-autocomplete>\n<md-chip-template><small><span><strong>{{$chip.tag}}</strong></span></small></md-chip-template></md-chips></div></div>\n</form></div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Ruoli <span \nng-class=\"{\'md-warn-bg\': (vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasprogettos.length) == 0}\" \nclass=\"text-boxed\">\n{{(vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasprogettos.length)}}</span>\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Ruoli generici</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in ::vm.contact.ruolos\"><div flex=\"40\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ ruolo.descrizione | uppercase}}</span></div><md-divider>\n</md-divider></md-list-item></div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCollega nuovo ruolo generico</strong></h2><md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple><div layout=\"row\" class=\"margin-top-16\"><md-button aria-label=\"Nuovo Ruolo  Esistente\" ng-click=\"\">\n<md-icon md-font-icon=\"icon-link\"></md-icon>Nuovo ruolo esistente<md-tooltip><span>Collega nuovo ruolo esistente</span>\n</md-tooltip></md-button><md-button aria-label=\"Crea Nuovo Ruolo\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon>Crea nuovo ruolo<md-tooltip><span>Crea nuovo ruolo</span></md-tooltip>\n</md-button></div></md-list-item></md-list><div layout=\"row\" flex><div layout=\"column\" flex=\"50\"><h2 \nclass=\"no-padding\"><strong>Ruolo nei progetti</strong></h2><md-divider></md-divider><div layout=\"column\" \nclass=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in vm.contact.personahasprogettos\"><dl><dd \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'PROGETTO\'}\"><span \nclass=\"text-boxed\">{{pruolo.descrizione}}</span></dd></dl><md-divider></md-divider></md-list-item></div></div><div \nlayout=\"column\" flex=\"50\"><h2 class=\"no-padding\"><strong>Ruolo negli Enti</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in vm.contact.personahasentes\"><dl><dd \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'ENTE\'}\"><span \nclass=\"text-boxed\">{{pruolo.descrizione}}</span></dd></dl><md-divider></md-divider></md-list-item></div></div></div>\n</div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Progetti <span \nng-class=\"{\'md-warn-bg\': vm.contact.progettos.length === 0}\" class=\"text-boxed\">{{vm.contact.progettos.length}}</span>\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Progetti collegati</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"progetto in ::vm.contact.progettos\"><div flex=\"30\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ progetto.nome | uppercase}}</span></div><div flex=\"20\"><ul \nclass=\"text-truncate hide show-gt-sm\"><li ng-repeat=\"bando in ::progetto.bandos\" class=\"line-height-24\" \nstyle=\"list-style-type:none\"><span class=\"text-boxed md-light-blue-200-bg\">{{bando.descrizione}}</span></li></ul></div>\n<div flex=\"30\" class=\"padding-4\"><span \nng-repeat=\"ruolo in vm.contact.personahasprogettos| filter: {\'progetto_id\': progetto.id}\"><small class=\"text-boxed\" \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'PROGETTO\'}\">\n{{pruolo.descrizione}}</small></span></div><div flex><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Dettaglio\" ng-click=\"vm.gotoProgetto(progetto.id)\"><md-icon md-font-icon=\"icon-apps\"></md-icon><md-tooltip>\n<span>Vai al progetto</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item></div></md-list>\n</div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Enti <span \nng-class=\"{\'md-warn-bg\': vm.contact.entes.length === 0}\" class=\"text-boxed\">{{vm.contact.entes.length}}</span></span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg padding-16\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Enti collegati</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ente in ::vm.contact.entes\"><div flex=\"35\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ ente.nome | uppercase}}</span><md-tooltip><mark>\n{{ente.email}}</mark></md-tooltip></div><div flex=\"15\" class=\"padding-4\"><span class=\"text-boxed\">\n{{ente.entetipo.descrizione}}</span></div><div flex=\"50\" class=\"padding-4\"><span \nng-repeat=\"ruolo in vm.contact.personahasentes| filter: {\'ente_id\': ente.id}\"><small class=\"text-boxed\" \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'ENTE\'}\">{{pruolo.descrizione}}\n</small></span></div><div flex class=\"padding-4\"><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"Modifica link\" ng-click=\"vm.openEntiDialog($event, vm.contact, $index, false)\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><md-tooltip><span>Modifica collegamento</span></md-tooltip></md-button></div>\n<md-divider></md-divider></md-list-item></div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCollega nuovo ente</strong></h2><md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple>\n<div layout=\"row\" class=\"margin-top-16\"><md-button aria-label=\"Nuovo Ente Esistente\" \nng-click=\"vm.openEntiDialog($event, vm.contact, null, true)\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\nNuovo ente esistente<md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip></md-button><md-button \naria-label=\"Crea Nuovo ente\" ng-click=\"vm.openEntiDialog($event, vm.contact, null, false)\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon>Crea nuovo ente<md-tooltip><span>Crea nuovo ente</span></md-tooltip>\n</md-button></div></md-list-item></md-list></div><div layout=\"column\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openEntiDialog($event, vm.contact, null, true)\" aria-label=\"Nuovo Ente Esistente\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip>\n</md-button></div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Extra\n<span ng-class=\"{\'md-warn-bg\': vm.contact.personaextras.length === 0}\" class=\"text-boxed\">\n{{vm.contact.personaextras.length}}</span></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-16\"><md-list class=\"contacts-list\"><h2 \nclass=\"no-padding\"><strong>Campi Extra</strong></h2><md-divider></md-divider><md-list-item \nclass=\"contact-item md-white-bg\" md-ink-ripple ng-repeat=\"extra in ::vm.contact.personaextras\"><div flex=\"30\" \nclass=\"padding-4\"><p class=\"font-weight-600\"><span class=\"secondary-text light-blue-900-fg\">\n{{ extra.chiave | uppercase}}</span></p></div><div flex=\"60\" class=\"padding-4\"><p class=\"font-weight-600\"><span \nclass=\"secondary-text light-blue-800-fg\"><small>{{ extra.valore| uppercase}}</small></span></p></div><div flex>\n<md-button class=\"md-fab md-mini md-secondary\" aria-label=\"modifica campo\" \nng-click=\"vm.openExtraDialog($event, vm.contact, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>\n<span>Modifica campo</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item></md-list><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Nuovo campo extra</strong></h2><md-divider></md-divider>\n<md-list-item class=\"contact-item md-white-bg\" md-ink-ripple><div layout=\"row\" class=\"margin-top-16\"><md-button \naria-label=\"Crea Nuovo campo\" ng-click=\"vm.openExtraDialog($event, vm.contact, null)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Nuovo campo extra<md-tooltip><span>Aggiungi nuovo campo extra</span></md-tooltip>\n</md-button></div></md-list-item></md-list></div><div layout=\"row\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-contact-button\" ng-click=\"vm.openExtraDialog($event, vm.contact, null)\" aria-label=\"aggiungi corso\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip><span>Inserisci nuovo Extra</span></md-tooltip></md-button>\n</div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/file-manager.html","<div id=\"file-managers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/sprardb/documenti/file-manager/sidenavs/sidenav-ricerca.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/progetti/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Documenti</span></div></div></div><div class=\"main\" \nms-scroll><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"80\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei files\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex>\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n</div></div><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/main/sprardb/documenti/file-manager/views/grid/grid-view.html\'\"></div><div \nng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/sprardb/documenti/file-manager/views/list/list-view.html\'\">\n</div></div></div></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/uploaddocumentsDialog.html","<md-dialog aria-label=\"uploadDialog\" id=\"uploaddialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento {{vmdd.grupposelezionato}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vmdd.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 520px\" class=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\">\n<div layout=\"column\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un gruppo di documenti</label><md-select name=\"nome\" ng-model=\"vmdd.grupposelezionato\" required flex \nng-change=\"vmdd.selezionagruppo()\"><md-option ng-repeat=\"item in vmdd.gruppi\" value=\"{{item.gruppo}}\"><small><strong>\n{{item.gruppo}}</strong></small></md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\" flex><label>Scegli un tipo documento</label><md-select name=\"nome\" \nng-model=\"vmdd.params.documentoTipo_id\" required flex ng-change=\"vmdd.selezionatipo()\"><md-option \nng-repeat=\"item in vmdd.documentotipo\" value=\"{{item.id}}\"><small><strong>{{item.tipo}}</strong></small></md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div id=\"file\" \nflow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" flow-files-submitted=\"vmdd.upload()\" \nflow-file-added=\"vmdd.fileAdded($file)\" flow-file-success=\"vmdd.fileSuccess($file, $message)\" \nflow-complete=\"vmdd.uploadComplete()\" flex><md-button flow-btn class=\"add-file-button md-accent md-grey-100-bg\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" style=\"width: 100%\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon>Allega un file</md-button></div></div></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/sprardb/enti/dettaglio/ente.html","<div id=\"progetto\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Ente: <b>{{vm.ente.nome}}</b></span></div></div></div><div><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.salva();\" class=\"md-raised md-background\" ng-disabled=\"enteNForm.$invalid || enteNForm.$pristine \" \naria-label=\"Add Task\">SALVA</md-button></div></md-dialog-actions></div></div><div class=\"content dettaglio\" ms-scroll>\n<md-tabs md-dynamic-height><md-tab><md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg padding-8\"><form name=\"enteNForm\" novalidate>\n<h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider></md-divider><div layout=\"row\" \nclass=\"margin-top-32\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><strong>Nome Ente</strong></label><input type=\"text\" name=\"nome\" ng-model=\"vm.ente.nome\" \nplaceholder=\"Nome Ente\" required><div ng-messages=\"enteNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><md-select-label><b>Tipo Ente</b>\n</md-select-label><md-select name=\"entetipo\" placeholder=\"Tipo Ente\" ng-model=\"vm.ente.enteTipo_id\" required><md-option\n ng-repeat=\"entetipos in vm.ricercaApi.entetipos\" value=\"{{entetipos.id}}\"><div layout=\"column\"><b>\n{{entetipos.descrizione}}</b> <small>SETTORE {{entetipos.enteTipo_id}}</small></div></md-option></md-select><div \nng-messages=\"enteNForm.entetipo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-select-label><b>\nEnte Attivo?</b></md-select-label><md-select name=\"attivo\" placeholder=\"Ente attivo?\" ng-model=\"vm.ente.attivo\" \nrequired><md-option ng-repeat=\"item in [{id: 1, descrizione: \'SI\'}, {id: 0, descrizione: \'NO\'}]\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"enteNForm.attivo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div></div>\n<div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label><b>\nTelefono</b></label><input type=\"text\" name=\"telefono\" ng-model=\"vm.ente.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" required><div ng-messages=\"enteNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label><b>Email\n</b></label><input type=\"email\" name=\"email\" ng-model=\"vm.ente.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired class=\"font-size-12\"><div ng-messages=\"enteNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Localizzazione</strong></h2><md-divider>\n</md-divider><div layout=\"row\" class=\"margin-top-32\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><md-select-label><b>Regione</b></md-select-label><md-select name=\"reg\" ng-model=\"vm.ente.codRegione\" \nng-change=\"vm.onChangeRegione(vm.ente.codRegione)\"><md-option ng-repeat=\"regione in vm.ricercaApi.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.ente.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"enteNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div></div></md-input-container><md-input-container flex required><md-select-label><b>Provincia</b></md-select-label>\n<md-select name=\"prov\" ng-model=\"vm.ente.codProvincia\" ng-disabled=\"!vm.ente.codRegione\" \nng-change=\"vm.onChangeProvincia(vm.ente.codProvincia)\"><md-option ng-repeat=\"provincia in vm.province\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.ente.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"enteNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><md-select-label><b>Comune</b>\n</md-select-label><md-select name=\"com\" ng-model=\"vm.ente.codComune\" ng-disabled=\"!vm.ente.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.ente.codComune\">{{istat.comune}}\n</md-option></md-select><div ng-messages=\"enteNForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label><b>Indirizzo</b></label><input type=\"text\" name=\"indirizzo\" \nng-model=\"vm.ente.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\"><div \nng-messages=\"enteNForm.indirizzo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><label><b>Codice Postale</b></label><input name=\"cap\" \nng-model=\"vm.ente.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div \nng-messages=\"enteNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div></form><md-button class=\"md-raised md-warn\" \nng-disabled=\"vm.ente.progettohasentes.length || vm.ente.persone.length\" ng-click=\"vm.elimina()\">Elimina</md-button>\n</div></md-tab-body></md-tab><md-tab ng-if=\"vm.ente.id\"><md-tab-label class=\"padding-right-4\"><span>Persone <span \nng-class=\"{\'md-warn-bg\': vm.ente.persone.length === 0}\" class=\"text-boxed\">{{vm.ente.persone.length}}</span></span>\n</md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"vm.ente.id\"><small><b>\nPERSONE NELL\'ENTE</b></small></md-divider><div layout=\"row\"><md-input-container md-no-float class=\"m-0\" flex><small><b>\nRicerca per Cognome</b></small> <input placeholder=\"Cognome\" type=\"text\" ng-model=\"vm.psearch.cognome\">\n</md-input-container><md-input-container md-no-float class=\"m-0\" flex><small><b>Ricerca per Nome</b></small> <input \nplaceholder=\"Nome\" type=\"text\" ng-model=\"vm.psearch.nome\"></md-input-container><md-input-container md-no-float \nclass=\"m-0\" flex><small><b>Ricerca per Email</b></small> <input placeholder=\"Email\" type=\"text\" \nng-model=\"vm.psearch.email\"></md-input-container><md-input-container md-no-float class=\"m-0\" flex><small><b>\nRicerca per Stato</b></small><md-select ng-model=\"vm.statoPersone\" \nng-change=\"vm.filtroPersoneAttive = vm.stati[vm.statoPersone].value\"><md-option ng-repeat=\"(index,stato) in vm.stati\" \nng-value=\"{{index}}\">{{stato.label}}</md-option></md-select></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button></div></div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table \ndata-md-table><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column>COGNOME</th><th md-column>NOME</th><th md-column>RECAPITI</th><th \nmd-column>RUOLO</th><th md-column style=\"text-align: center\">DAL</th><th md-column style=\"text-align: center\">AL</th>\n<th md-column>PROFILO</th><th md-column style=\"padding-right:8px;text-align: right\">AZIONE</th></tr></thead><tbody \nmd-body><tr md-row ng-repeat=\"item in vm.ente.persone | filter: vm.psearch | filter: vm.filtroPersoneAttive\" \nng-class=\"{\'md-grey-200-bg\': item.entiPersonaAttivi.length === 0}\"><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><a title=\"{{item.email}}\" \nhref=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}{{item.email.length > 25 ? \'...\':\'\'}} </a><br>{{item.telefono}}\n</td><td md-cell style=\"white-space: nowrap\"><div layout=\"column\" layout-align=\"center\"><b \nng-class=\"{\'hint-text\': !subitem.attivo}\" \nng-repeat=\"subitem in item.personahasentes | filter: vm.filtroPersoneAttive.personahasentes\">\n{{subitem.personaruolo.descrizione}}</b></div></td><td md-cell style=\"text-align: center\"><div layout=\"column\" \nlayout-align=\"center\"><span \nng-repeat=\"subitem in item.personahasentes | filter: vm.filtroPersoneAttive.personahasentes\">\n{{subitem.dataInizio || \'-\' | date: \"dd/MM/yyyy\"}}</span></div></td><td md-cell style=\"text-align: center\"><div \nlayout=\"column\" layout-align=\"center\"><span \nng-repeat=\"subitem in item.personahasentes | filter: vm.filtroPersoneAttive.personahasentes\">\n{{subitem.dataFine || \'-\' | date: \"dd/MM/yyyy\"}}</span></div></td><td md-cell><div layout=\"column\"><b \nng-if=\"item.entiPersonaAttivi.length > 0\">ATTIVO</b> <span ng-if=\"item.entiPersonaAttivi.length === 0\">DISATTIVO</span>\n <b ng-if=\"item.user === null\">INESISTENTE</b></div></td><td md-cell style=\"padding-right:8px;text-align: right\">\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-accent\" aria-label=\"dettaglio\" ui-sref=\"app.sprardb_personasdettaglio2({id:item.id})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><small><b>APRI ANAGRAFICA</b></small></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Dettaglio2\" ng-click=\"vm.openPersoneEnteDialog($event, \'associa\', item)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA/RIMUOVI ASSOCIAZIONE</b></small></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" \nng-click=\"vm.openPersoneEnteDialog($event, \'associa\', null)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nASSOCIA NUOVO OPERATORE</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-click=\"vm.openPersoneDialog($event, \'inserisci\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>CREA NUOVO OPERATORE</md-button></div></md-card></md-tab-body></md-tab><md-tab \nng-if=\"vm.ente.id\"><md-tab-label class=\"padding-right-4\"><span>Progetti <span \nng-class=\"{\'md-warn-bg\': vm.ente.progetti.length === 0}\" class=\"text-boxed\">{{vm.ente.progetti.length}}</span></span>\n</md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>\nPROGETTI COLLEGATI</b></small></md-divider><div layout=\"row\"><md-input-container md-no-float class=\"m-0\" flex><small>\n<b>Ricerca per Nome</b></small> <input placeholder=\"Nome Progetto\" type=\"text\" ng-model=\"vm.prsearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container><md-input-container md-no-float class=\"m-0\" flex><small><b>\nRicerca per Stato</b></small><md-select ng-model=\"vm.statoProgetti\" \nng-change=\"vm.filtroStatoProg = vm.statiProgetto[vm.statoProgetti].value\"><md-option \nng-repeat=\"(index,stato) in vm.statiProgetto\" ng-value=\"{{index}}\">{{stato.label}}</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container class=\"tabellar\"><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.entes\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"nome\">NOME PROGETTO</th><th md-column \nmd-order-by=\"codComune\"><span>CITTA</span></th><th md-column md-order-by=\"email\">RECAPITI</th><th md-column>RUOLO</th>\n<th md-column style=\"text-align: center\">DAL</th><th md-column style=\"text-align: center\">AL</th><th md-column \nstyle=\"text-align: center\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"p in vm.ente.progetti | filter: {nome: vm.prsearch} | filter: vm.filtroStatoProg\" \nng-class=\"{\'md-grey-300-bg\': (p.progettohasentes | filter: vm.filtroProgAttivi.value.progettohasentes).length === 0}\">\n<td md-cell>{{p.id}}</td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ p.nome | uppercase}}</td><td md-cell>\n<div layout=\"column\"><b>{{p.istats.comune| uppercase}}</b> <span>{{p.istats.provincia| uppercase}}</span> <span>\n{{p.istats.regione| uppercase}}</span></div></td><td md-cell><a title=\"{{p.email}}\" href=\"mailto:{{p.email}}\">\n{{p.email|limitTo:25}}{{p.email.length > 25 ? \'...\':\'\'}}</a><br>{{p.telefono}}</td><td md-cell><div layout=\"column\" \nlayout-align=\"center\"><b ng-class=\"{\'hint-text\': !item.attivo}\" \nng-repeat=\"item in p.progettohasentes | filter: vm.filtroStatoProg.progettohasentes\">{{item.enteruolo.descrizione}}</b>\n</div></td><td md-cell style=\"text-align: center\"><div layout=\"column\" layout-align=\"center\"><span \nng-repeat=\"item in p.progettohasentes | filter: vm.filtroStatoProg.progettohasentes\">\n{{item.dataInizio || \'-\' | date: \"dd/MM/yyyy\"}}</span></div></td><td md-cell style=\"text-align: center\"><div \nlayout=\"column\" layout-align=\"center\"><span \nng-repeat=\"item in p.progettohasentes | filter: vm.filtroStatoProg.progettohasentes\">\n{{item.dataFine || \'-\' | date: \"dd/MM/yyyy\"}}</span></div></td><td md-cell \nstyle=\"text-align: right; padding-right: 0px\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.gotoProgetto(item.progetto_id)\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon><span>Apri progetto</span></md-button></md-menu-item></md-menu-content></md-menu>\n</td></tr></tbody></table></md-table-container></md-card></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/enti/dialogs/dialogAssociaPersonaEnte.html","<md-dialog id=\"personedialog\" class=\"persone-dialog\" aria-label=\"persone Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Incarichi nell\'ente</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"associa\" ng-if=\"vmd.action === \'associa\'\"><md-content \nclass=\"md-padding\"><h2 class=\"no-padding\"><strong>\n{{vmd.entiCollegati ? \'Modifica collegamenti\' : \'Crea nuovo collegamento\'}}</strong></h2><md-divider></md-divider><div \nlayout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"margin-bottom-0\" ng-if=\"!vmd.entiCollegati\"><label>\nRicerca operatore per cognome, città ed ente</label><input type=\"text\" name=\"nome\" ng-model=\"vmd.ricerca.cognome\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il testo da cercare\" \naria-label=\"\"></md-input-container></div><form name=\"personaForm\" novalidate><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"margin-bottom-0 margin-top-4\" flex=\"60\"><label>\nScegli una Persona [<span class=\"text-boxed\">{{vmd.allpersonas.length}}</span>]</label><md-select name=\"nome\" \nng-model=\"vmd.personaId\" aria-label=\"nome persona selezionato\" ng-disabled=\"!vmd.ricerca.cognome\" \nng-required=\"!vmd.entiCollegati\"><md-option ng-repeat=\"persona in vmd.allpersonas\" value=\"{{persona.id}}\"><small>\n<strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</small></md-option></md-select>\n</md-input-container><md-input-container class=\"margin-bottom-0 margin-top-4\" flex><md-button class=\"m-0 md-accent\" \nng-click=\"vmd.inizializzaModel(null)\" ng-disabled=\"!vmd.personaId\">Aggiungi Ruolo</md-button></md-input-container>\n</div><div ng-repeat=\"model in vmd.models\" layout=\"column\"><md-card class=\"padding-8\" \nng-class=\"model._delete ? \'md-grey-200-bg\' : \'\'\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex><label>Ruolo</label><md-select name=\"ruolo\" ng-model=\"model.personaRuolo_id\" \nng-disabled=\"model._delete\" required><md-option ng-repeat=\"ruolo in vmd.ricercaApi.personaruoloentes\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}}</md-option></md-select></md-input-container><md-input-container flex><label>\nAttivo</label><md-select name=\"attivo\" ng-model=\"model.attivo\" ng-disabled=\"model._delete\"><md-option \nng-repeat=\"option in vmd.booleanOptions\" ng-value=\"option.id\">{{option.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex><label>\nData Inizio</label><md-datepicker name=\"dataInizio\" ng-model=\"model.dataInizio\" ng-disabled=\"model._delete\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\"></md-datepicker></md-input-container>\n<md-input-container flex><label>Data Fine</label><md-datepicker name=\"dataFine\" ng-model=\"model.dataFine\" \nng-disabled=\"model._delete\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\"></md-datepicker>\n</md-input-container><md-button class=\"md-icon-button md-secondary\" ng-disabled=\"model._delete\" \nng-click=\"vmd.delete(model)\"><md-icon md-font-icon=\"icon-delete orange-700-fg\"></md-icon><md-tooltip><span>Cancella\n</span></md-tooltip></md-button></div></md-card></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.save()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaForm.$invalid\" aria-label=\"salva\" flex>\nSALVA</md-button></div></form></md-content></md-tab><md-tab label=\"inserisci\" ng-if=\"vmd.action === \'inserisci\'\">\n<md-content class=\"padding-16\"><form name=\"personaNForm\" novalidate><md-divider class=\"md-light-blue-100-bg padding-8\">\n<small><b>ANAGRAFICA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.cognone.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vmd.persona.cognome\" placeholder=\"Cognome\" required aria-label=\"cognome\"><div \nng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vmd.persona.nome\" placeholder=\"Nome\" required aria-label=\"\"><div ng-messages=\"personaNForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vmd.persona.sesso\" required aria-label=\"sesso\"><md-option \nvalue=\"M\"><small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codicefiscale.$invalid)}\">Codice Fiscale</label><input type=\"text\" \nname=\"codicefiscale\" ng-model=\"vmd.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\" \nrequired aria-label=\"codicefiscale\" ng-change=\"vmd.checkCF()\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Codice fiscale non valido</span></div><div \nng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div><div ng-message=\"md-minlength\"><span>\nDeve essere lungo 16 caratteri</span></div><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div><div\n ng-if=\"!vmd.validcf\" class=\"md-warn-fg\"><small>Una persona con questo codice fiscale è già presente in banca dati\n</small></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label ng-class=\"{\'md-warn-fg\': (personaNForm.telefono.$invalid)}\">\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vmd.persona.telefono\" placeholder=\"Telefono\" \nclass=\"font-size-12\" required aria-label=\"telefono\"><div ng-messages=\"personaNForm.telefono.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vmd.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\" required ng-change=\"vmd.checkEmail($event)\" aria-label=\"email\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span></ng-message></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nINCARICO / FUNZIONE, RUOLI e AMBITI OPERATIVI</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\" \nng-repeat=\"indice in vmd.indexEnte\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-4 margin-top-4\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.phe.$invalid)}\">Nome Ente\n</md-select-label><md-select name=\"phe\" ng-model=\"vmd.phe[indice].ente_id\" required fle aria-label=\"ente\"><md-option \nng-repeat=\"item in vmd.enti_collegati\" ng-value=\"item.id\"><div layout=\"column\"><b>{{item.nome|uppercase}}</b> <small>\n<b>Tipo:</b> {{item.entetipo.descrizione|uppercase}}, <b>Ruolo: </b><span ng-repeat=\"r in item.enteruolos\">\n{{r.descrizione}},</span></small></div></md-option></md-select><div ng-messages=\"personaNForm.phe.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto il primo incarico</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.incarico.$invalid)}\">Incarico Funzione</md-select-label><md-select \nname=\"incarico\" ng-model=\"vmd.phe[indice].ruolo_id\" multiple=\"multiple\" required aria-label=\"incarico\"><md-option \nng-repeat=\"ruolo in vmd.personaruoloentes\" ng-value=\"ruolo.id\" \nng-disabled=\"(vmd.phe[indice].length == 1 && vmd.phe[indice].indexOf(ruolo.id) == 26)\"><div layout=\"column\"><small>\n<strong>{{ruolo.descrizione|uppercase}}</strong> </small><span>&nbsp;</span></div></md-option></md-select><div \nng-messages=\"personaNForm.incarico.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto il primo incarico</span></div></div></md-input-container><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"-\" ng-if=\"indice > 0\" \nng-click=\"vmd.aggrimuoviente(indice)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></div></div><small \nng-click=\"vmd.aggrimuoviente()\" class=\"text-boxed cursor-pointer\"><b class=\"cursor-pointer\">+ AGGIUNGI INCARICO</b>\n</small><br><br><div layout=\"row\" class=\"margin-top-4\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container\n flex class=\"margin-bottom-4 margin-top-4\"><md-select-label \nng-class=\"{\'md-warn-fg\': (personaNForm.studi_id.$invalid)}\">Titolo di studi</md-select-label><md-select \nname=\"studi_id\" ng-model=\"vmd.persona.studi_id\" aria-label=\"studi_id\"><md-option ng-repeat=\"item in vmd.personastudis\" \nng-value=\"item.id\"><div layout=\"column\"><small><strong>{{item.descrizione|uppercase}}</strong></small></div>\n</md-option></md-select><div ng-messages=\"personaNForm.studi_id.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Titolo studi richiesto</span></div></div></md-input-container></div></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>RESIDENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Regione\n</md-select-label><md-select name=\"reg\" ng-model=\"vmd.persona.codRegione\" \nng-change=\"vmd.caricaProvince(vmd.persona.codRegione)\" aria-label=\"regione\"><md-option \nng-repeat=\"regione in vmd.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vmd.persona.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<md-select-label>Provincia</md-select-label><md-select name=\"prov\" ng-model=\"vmd.persona.codProvincia\" \nng-disabled=\"!vmd.persona.codRegione\" ng-change=\"vmd.caricaComuni(vmd.persona.codProvincia)\" aria-label=\"provncia\">\n<md-option ng-repeat=\"provincia in vmd.provincias\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com\" ng-model=\"vmd.persona.codComune\" ng-disabled=\"!vmd.persona.codProvincia\" aria-label=\"comune\"><md-option \nng-repeat=\"istat in vmd.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vmd.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Indirizzo</label>\n<input type=\"text\" name=\"indirizzo\" ng-model=\"vmd.persona.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\" \naria-label=\"indirizzi\"></md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vmd.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\" \naria-label=\"cap\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\">\n<span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.\n</span></div></div></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nNASCITA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Regione</md-select-label><md-select name=\"reg2\" \nng-model=\"vmd.persona.nascita.codRegione\" ng-change=\"vmd.caricaProvince2(vmd.persona.nascita.codRegione)\" \naria-label=\"regione\"><md-option ng-repeat=\"regione in vmd.regiones2\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vmd.persona.nascita.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia</md-select-label>\n<md-select name=\"prov2\" ng-model=\"vmd.persona.nascita.codProvincia\" ng-disabled=\"!vmd.persona.nascita.codRegione\" \nng-change=\"vmd.caricaComuni2(vmd.persona.nascita.codProvincia)\" aria-label=\"prov\"><md-option \nng-repeat=\"provincia in vmd.provincias2\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vmd.persona.nascita.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com2\" ng-model=\"vmd.persona.codComuneNascita\" ng-disabled=\"!vmd.persona.nascita.codProvincia\" \naria-label=\"comune\"><md-option ng-repeat=\"istat in vmd.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vmd.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Nazione</md-select-label><md-select name=\"nazionalita\" \nng-model=\"vmd.persona.codNazionalita\" aria-label=\"naz\"><md-option ng-repeat=\"naz in vmd.nazionalitas\" \nvalue=\"{{naz.id}}\" ng-selected=\"naz.id == vmd.persona.codNazionalita\"><small>{{naz.descrizione}}</small></md-option>\n</md-select></md-input-container><div flex><md-datepicker ng-model=\"vmd.progetto.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex aria-label=\"nascita\"></md-datepicker></div></div></div><div \nlayout=\"row\" class=\"margin-top-16\"><span ng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\">\n<span class=\"md-warn-fg\" ng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></span> <span \nng-if=\"errors.length < 10\"><span class=\"md-warn-fg\">Campi obbligatori da riempire:</span><span class=\"md-warn-fg\" \nng-repeat=\"e in errors\"> <b>{{ e.$name}}</b>, </span></span></span><span ng-if=\"!personaNForm.$invalid\" flex=\"75\">\nValidazione <b>OK</b></span></div><div layout=\"row\" class=\"margin-top-16\"><md-button type=\"button\" \nng-click=\"vmd.savenew()\" class=\"md-button md-accent md-raised\" ng-disabled=\"personaNForm.$invalid\" aria-label=\"salva\" \nflex>SALVA</md-button></div></form></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/enti/dialogs/dialogMostraRuoli.html","<md-dialog id=\"mostraruoli\" class=\"mostra-ruoli-dialog\" aria-label=\"mostra ruoli Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Incarichi nell\'ente di {{vmd.persona.cognome}} {{vmd.persona.nome}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card><md-table-container class=\"tabellar\"><table data-md-table>\n<thead md-head><tr md-row><th md-column>RUOLO/AMBITO/INCARICO</th><th md-column>DATA INIZIO</th><th md-column>DATA FINE\n</th><th md-column>ATTIVO</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"personaente in vmd.personaEnte\"><td \nmd-cell><b>{{personaente.personaruolo.descrizione}}</b>\n ({{personaente.personaruolo.gruppo.replace(\"ENTE\", \"INCARICO\")}})</td><td md-cell style=\"text-align: center\"><b>\n{{personaente.dataInizio || \' - \' | date: \"dd/MM/yy\"}}</b></td><td md-cell style=\"text-align: center\"><b>\n{{personaente.dataFine || \' - \' | date: \"dd/MM/yy\"}}</b></td><td md-cell style=\"text-align: center\"><md-icon \nclass=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"!personaente.attivo\"></md-icon><md-icon \nclass=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"personaente.attivo\"></md-icon></td></tr></tbody></table>\n</md-table-container></md-card></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/enti/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate layout=\"column\">\n<md-input-container flex><label>Regioni</label><md-select ng-model=\"vm.ricerca.regione\" ng-change=\"vm.loadEnti()\" \nmultiple=\"true\"><md-option ng-value=\"regione\" ng-repeat=\"regione in vm.ricercaApi.regiones\"><b><small>\n{{ regione[vm.displayLabel(\'regione\')]|uppercase }}</small></b></md-option></md-select></md-input-container>\n<md-input-container flex><label>Province</label><md-select ng-model=\"vm.ricerca.provincia\" ng-change=\"vm.loadEnti()\" \nmultiple=\"true\"><md-option ng-value=\"provincia\" ng-repeat=\"provincia in vm.ricercaApi.provincias\"><b><small>\n{{ provincia[vm.displayLabel(\'provincia\')]|uppercase }}</small></b></md-option></md-select></md-input-container>\n<md-input-container flex><label>Attivo</label><md-select ng-model=\"vm.ricerca.attivo\" ng-change=\"vm.loadEnti()\">\n<md-option ng-value=\"\"><b><small>-</small></b></md-option><md-option ng-repeat=\"item in vm.booleanOptions\" \nng-value=\"item\"><b><small>{{item.label}}</small></b></md-option></md-select></md-input-container><md-input-container \nflex><label>Tipo Ente</label><md-select ng-model=\"vm.ricerca.tipo\" ng-change=\"vm.loadEnti()\" multiple=\"true\"><md-option\n ng-value=\"enteTipo\" ng-repeat=\"enteTipo in vm.ricercaApi.entetipos\"><b><small>\n{{ enteTipo[vm.displayLabel(\'tipo\')]|uppercase }}</small></b></md-option></md-select></md-input-container>\n<md-input-container flex><label>Con Progetti</label><md-select ng-model=\"vm.ricerca.progetti\" \nng-change=\"vm.loadEnti()\"><md-option ng-value=\"\"><b><small>-</small></b></md-option><md-option \nng-repeat=\"item in vm.optionsProgetto\" ng-value=\"item\"><b><small>{{item.label}}</small></b></md-option></md-select>\n</md-input-container><md-input-container flex><label>Con Persone</label><md-select ng-model=\"vm.ricerca.persone\" \nng-change=\"vm.loadEnti()\"><md-option ng-value=\"\"><b><small>-</small></b></md-option><md-option \nng-repeat=\"item in vm.booleanOptions\" ng-value=\"item\"><b><small>{{item.label}}</small></b></md-option></md-select>\n</md-input-container></form></div>");
$templateCache.put("app/main/sprardb/entisegnalatori/dettaglio/dettaglio.html","<div id=\"entisegnalatori\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" \naria-label=\"b1\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\" class=\"logo\"><div layout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">\nEnte Segnalatore:&nbsp;</span> <span class=\"logo-text\"><b>{{vm.contact.nome}}</b></span></div></div></div><div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.saveContact();\" class=\"md-raised md-background\" \nng-disabled=\"enteNForm.$invalid || enteNForm.$pristine || vm.api.isSegnalatore\" ng-if=\"!vm.api.isReadOnly\" \naria-label=\"Add Task\">SALVA</md-button></div></md-dialog-actions></div></div><div class=\"content dettaglio\" ms-scroll>\n<md-tabs md-dynamic-height><md-tab><md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg padding-8\"><form name=\"enteNForm\" novalidate>\n<h2 class=\"no-padding\"><strong>Informazioni generali</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Codice: <b \nclass=\"md-accent-bg\">&nbsp;{{vm.contact.codiceSegnalatore}}&nbsp;</b></h2><md-divider></md-divider><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><label>Nome Ente</label><md-icon md-font-icon=\"icon-clipboard-account\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"nome\" ng-model=\"vm.contact.nome\" placeholder=\"Nome Ente\" \nrequired><div ng-messages=\"enteNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div>\n</div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-8\"><label>Ente Tipo</label><md-select \nname=\"entetipo\" ng-model=\"vm.contact.enteTipo_id\" required><md-option ng-repeat=\"entetipos in vm.tempentetipo\" \nvalue=\"{{entetipos.id}}\" ng-selected=\"entetipos.id == vm.contact.enteTipo_id\"><div layout=\"column\"><b>\n{{entetipos.descrizione}}</b> <small><small>{{entetipos.enteTipo_id}}° SETTORE</small></small></div></md-option>\n</md-select><div ng-messages=\"enteNForm.entetipo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Ente tipo richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<md-icon md-font-icon=\"icon-phone-dots\" class=\"blue-grey-800-fg\"></md-icon><label>Telefono</label><input type=\"text\" \nname=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\" required class=\"font-size-12 margin-bottom-0\">\n<div ng-messages=\"enteNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Email</label>\n<md-icon md-font-icon=\"icon-email\" class=\"blue-grey-800-fg\"></md-icon><input type=\"email\" name=\"email\" \nng-model=\"vm.contact.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nclass=\"font-size-12 margin-bottom-0\"><div ng-messages=\"enteNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email è richiesta</span></div><div ng-message=\"pattern\"><span>Email invalida</span></div>\n<ng-message class=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita.</span></ng-message></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container class=\"md-block\" md-no-float flex><label>Cod.Fiscale / P. Iva</label>\n<md-icon md-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"piva\" \nng-model=\"vm.contact.piva\" placeholder=\"Codice Fiscale\" \nng-pattern=\"/^[a-zA-Z0-9]{6}[a-zA-Z0-9]{2}[a-zA-Z0-9][a-zA-Z0-9]{2}[a-zA-Z]{0,1}[0-9]{0,3}[a-zA-Z]{0,1}$/\" \nminlength=\"11\" maxlength=\"16\" ng-change=\"vm.checkCf($event)\"><div ng-messages=\"enteNForm.piva.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Cod.Fiscale / P. Iva è richiesto</span></div><div \nng-message=\"pattern\"><span>Cod.Fiscale / P. Iva invalido</span></div><ng-message class=\"help-block\" when=\"unique\">\n<span>Cod.Fiscale / P. Iva già in uso.</span></ng-message><div ng-message=\"minlength,maxlength\"><span>\nIl cap deve essere di 11 o 16 caratteri.</span></div></div></md-input-container><md-input-container flex \nclass=\"md-input-has-placeholder\"><label>Ente attivo / Non attivo</label><md-switch ng-model=\"vm.contact.attivo\" \naria-label=\"Attivo\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"margin-top-0 padding-left-16\"><small>\nENTE {{((!vm.contact.attivo) ? \'NON\' : \'\')}} ATTIVO</small></md-switch></md-input-container></div></div><h2 \nclass=\"no-padding\"><strong>Localizzazione</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Regione</label>\n<md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" ng-model=\"vm.contact.codRegione\" \nng-change=\"vm.caricaProvince(vm.contact.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"enteNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label><md-select \nname=\"prov\" ng-model=\"vm.contact.codProvincia\" ng-disabled=\"!vm.contact.codRegione\" \nng-change=\"vm.caricaComuni(vm.contact.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"enteNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select name=\"com\" \nng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\"><md-option ng-repeat=\"istat in vm.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"enteNForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" \nname=\"indirizzo\" ng-model=\"vm.contact.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\"><div \nng-messages=\"enteNForm.indirizzo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><label>codice Postale</label><input name=\"cap\" \nng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div \nng-messages=\"enteNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div></form></div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label \nclass=\"padding-right-4\"><span>Segnalatori collegati <span ng-class=\"{\'md-warn-bg\': vm.contact.personas.length === 0}\" \nclass=\"text-boxed\">{{vm.contact.personas.length}}</span></span></md-tab-label><md-tab-body><md-divider \nclass=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>SEGNALATORI NELL\'ENTE</b></small></md-divider><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"psearch\" placeholder=\"Ricerca nei segnalatori\" type=\"text\" ng-model=\"vm.psearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column>COGNOME</th><th md-column>NOME</th><th md-column>RECAPITI</th><th \nmd-column>RUOLO/AMBITO/INCARICO</th><th md-column>PROFILO</th><th md-column \nstyle=\"padding-right:8px;text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.contact.personas| filter: vm.psearch track by item.id\" \nng-class=\"{\'md-grey-200-bg\': item.users.user.status !== 10}\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><a title=\"{{item.email}}\" \nhref=\"mailto:{{item.email}}\">{{item.email|limitTo:20}}...</a><br>{{item.telefono}}</td><td md-cell><div \nlayout=\"column\"><span ng-repeat=\"subitem in ::item.progettoruolos\"><b>{{subitem.descrizione}}</b>\n ({{subitem.gruppo.replace(\"PROGETTO\", \"RUOLO\")}})</span> <span ng-repeat=\"subitem in ::item.enteruolos\"><b>\n{{subitem.descrizione}}</b> ({{subitem.gruppo.replace(\"ENTE\", \"INCARICO\")}})</span></div></td><td md-cell><div \nlayout=\"column\"><b ng-if=\"(item.users.user.status === 10)\">ATTIVO</b> <span ng-if=\"(item.users.user.status === 10)\">\n({{item.users.user.groups.length}}) PROFILO</span> <span ng-if=\"(item.users.user.status !== 10)\">DISATTIVO</span> <b \nng-if=\"(item.users === null)\">INESISTENTE</b></div></td><td md-cell style=\"padding-right:8px;text-align: right\">\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\" ng-if=\"!vm.api.isReadOnly\">\n<md-menu-item><md-button class=\"md-accent\" aria-label=\"dettaglio\" \nui-sref=\"app.sprardb_personasdettaglio2({id:item.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\"></md-icon>\n<small><b>APRI ANAGRAFICA</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-button aria-label=\"Dettaglio2\" \nng-click=\"vm.openPersoneDialog($event, vm.contact, $index, false)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<small><b>MODIFICA/RIMUOVI ASSOCIAZIONE</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"((vm.api.isAdmin || vm.api.isAccoglienza) && !item.users.user)\"><md-button aria-label=\"crea\" \nng-click=\"vm.openRegisterDialog($event, item.id, false)\" class=\"md-blue-100-bg\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><small><b>NUOVO PROFILO</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.api.isAdmin && item.users.user)\"><md-button aria-label=\"crea2\" \nng-click=\"vm.openUserDialog($event, item.id)\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"(item.users.user.status !== 10)\"></md-icon><md-icon md-font-icon=\"icon-account-key\" \nng-if=\"(item.users.user.status === 10)\"></md-icon><small><b>PROFILO, PASSWORD e ABILITAZIONE</b></small></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" \nng-click=\"vm.openPersoneDialog($event, vm.contact, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nASSOCIA NUOVO OPERATORE</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-click=\"vm.openPersoneDialog($event, vm.contact, null, false)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>CREA NUOVO OPERATORE</md-button></div></md-card></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/sprardb/entisegnalatori/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/eventi/dialogs/dialogConfermaTrasferimento.html","<md-dialog flex style=\"width: 95%; height: 95%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Lavora Trasferimento</h2>\n<span flex></span></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-card class=\"md-padding\"><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>\nRicerca beneficiario per cognome</label><input type=\"text\" ng-model=\"vmd.cercaModel.cognome\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaBeneficiario()\" \nplaceholder=\"Inserisci il cognome del beneficiario\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Ricerca beneficiario per nome</label><input type=\"text\" ng-model=\"vmd.cercaModel.nome\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaBeneficiario()\" \nplaceholder=\"Inserisci il nome del beneficiario\"></md-input-container><md-autocomplete \nmd-floating-label=\"Progetto di Partenza\" md-no-cache=\"1\" md-selected-item=\"vmd.progettoPartenza\" \nng-model=\"vmd.cercaModel.progetto_id\" md-search-text-change=\"vmd.cercaProgetti(vmd.progettoPartenzaNome)\" \nmd-search-text=\"vmd.progettoPartenzaNome\" md-items=\"progetto in vmd.progetti\" md-item-text=\"progetto.nome\" \nmd-min-length=\"3\" md-require-match ng-model-options=\"{ debounce: 200 }\" name=\"progettoNome\" \nmd-selected-item-change=\"vmd.cercaBeneficiario()\" flex><md-item-template><span md-highlight-text=\"vmd.progettoNome\" \nmd-highlight-flags=\"i\">{{progetto.nome}}</span></md-item-template></md-autocomplete></div><div layout=\"row\" \nclass=\"margin-top-8\"><md-input-container flex class=\"margin-bottom-0\"><label>Codice</label><input type=\"text\" \nng-model=\"vmd.cercaModel.codice\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaBeneficiario()\" \nplaceholder=\"Inserisci il codice del beneficiario\"></md-input-container><md-input-container flex><label>Data di Nascita\n</label><md-datepicker ng-model=\"vmd.cercaModel.dataNascita\" name=\"dataNascita\" \nmd-placeholder=\"Seleziona la data di nascita\" ng-change=\"vmd.cercaBeneficiario()\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label>Nazione di Nascita</label><md-select name=\"nazione\" \nng-model=\"vmd.cercaModel.nazione\" ng-change=\"vmd.cercaBeneficiario()\"><md-option \nng-repeat=\"nazione in vmd.ricerca.naziones\" ng-value=\"nazione.id\">{{nazione.descrizione}}</md-option></md-select>\n</md-input-container></div><br><md-divider></md-divider><div layout=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Beneficiario [<span class=\"text-boxed\">\n{{vmd.beneficiari.data.length}}</span>]</label><md-select name=\"nome\" ng-model=\"vmd.beneficiario\" \nng-change=\"vmd.checkDataMin()\"><md-option ng-repeat=\"beneficiario in vmd.beneficiari.data\" ng-value=\"beneficiario\">\n<span>Codice: <strong>{{beneficiario.codice}}</strong> - Cognome: <strong>{{beneficiario.cognome}}</strong> - Nome: \n<strong>{{beneficiario.nome}}</strong> - Progetto: <strong>{{beneficiario.progettos.nome}}</strong></span></md-option>\n</md-select></md-input-container></div></md-card><md-card class=\"md-padding\" ng-show=\"vmd.beneficiario\"><form \nnovalidate name=\"vmd.campiForm\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-around center\">\n<md-input-container flex class=\"m-10\"><label>Data Arrivo</label><md-datepicker required name=\"dataFine\" \nng-model=\"vmd.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" md-min-date=\"vmd.dataMin\">\n</md-datepicker></md-input-container></div><md-autocomplete md-floating-label=\"Progetto di Destinazione\" \nmd-no-cache=\"1\" md-selected-item=\"vmd.progetto\" ng-model=\"vmd.progettoArrivo\" \nmd-search-text-change=\"vmd.cercaProgetti(vmd.progettoNome)\" md-search-text=\"vmd.progettoNome\" \nmd-items=\"progetto in vmd.progetti\" md-item-text=\"progetto.nome\" md-min-length=\"3\" md-require-match \nng-model-options=\"{ debounce: 200 }\" name=\"progettoNome\" \nmd-selected-item-change=\"vmd.searchStrutturas(vmd.progetto.id)\"><md-item-template><span \nmd-highlight-text=\"vmd.progettoNome\" md-highlight-flags=\"i\">{{progetto.nome}} - {{progetto.codiceMinistero}}</span>\n</md-item-template></md-autocomplete><md-input-container class=\"margin-bottom-0\"><label>Struttura di accoglienza\n</label><md-select required name=\"struttura\" ng-model=\"vmd.struttura\" aria-label=\"Struttura di accoglienza\"><md-option \nng-repeat=\"struttura in vmd.strutturas\" ng-value=\"struttura\">{{struttura.nome}}</md-option></md-select>\n</md-input-container></div></form></md-card></md-dialog-content><md-dialog-actions><div layout=\"row\" flex><span \nclass=\"red-700-fg\" flex>{{vmd.errorMsg}}</span><md-button type=\"button\" ng-click=\"vmd.cancel()\" \nclass=\"md-button md-raised\">ANNULLA</md-button><md-button type=\"button\" ng-click=\"vmd.salva()\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"vmd.campiForm.$invalid || vmd.campiForm.$pristine\">SALVA</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/eventi-dialog.html","<md-dialog class=\"eventi-dialog\" aria-label=\"{{vm.title}}\"><form name=\"notificationForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button><h2>Dettagli {{vm.tipo}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nng-repeat=\"groupitem in ::vm.items[vm.tipo] track by $index\"><div flex \nng-repeat=\"(key, value) in ::groupitem track by $index\"><div><md-input-container class=\"md-block\" md-no-float flex>\n<label>{{value}}</label><input type=\"text\" name=\"{{vm.tipo}}-{{$index}}\" ng-value=\"vm.getDataModel(key)\" \nplaceholder=\"{{value}}...\" readonly=\"readonly\" ng-if=\"key !== \'extra\'\"><br><pre ng-if=\"key === \'extra\'\">\n{{vm.getDataModel(key)}}</pre></md-input-container></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">CHIUDI</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/inserisci-segnalato.html","<md-dialog id=\"inserisciSegnalato\" class=\"add-dialog\" aria-label=\"process\"><form name=\"inserisciForm\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Inserisci Beneficiario</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div ng-if=\"vmd.segnalati.length > 1\">\n<div layout=\"row\"><b>Applica questa azione a:</b></div><div layout=\"row\" ng-repeat=\"seg in vmd.segnalati \"><small><b>\n{{seg.cognome|uppercase}}</b> {{seg.nome}}</small></div><md-divider></md-divider></div><span><b>\nCompleta il processo compilando i seguenti dati:</b></span><md-input-container><md-datepicker \nmd-min-date=\"vmd.minDate\" md-max-date=\"vmd.oggi\" md-no-float ng-model=\"vmd.res.dataInizio\" \nmd-placeholder=\"Data Ingresso/Inizio Progetto\" flex required></md-input-container><md-input-container flex><label>Note\n</label><textarea name=\"note\" ng-model=\"vmd.res.note\" placeholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\">\n</textarea></md-input-container><md-input-container flex \nng-if=\"vmd.segnalati.length == 1 && vmd.segnalati[0].segnalazione.idTipoSegnalazione !== 697\"><label>Accoglienza\n</label><textarea ng-if=\"vmd.segnalati[0].esterna == 0\" disabled=\"disabled\">INTERNA</textarea><textarea \nng-if=\"vmd.segnalati[0].esterna != 0\" disabled=\"disabled\">ESTERNA</textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vmd.inserisci();\" class=\"send-button md-accent md-raised\" ng-disabled=\"inserisciForm.$invalid\" \naria-label=\"Allow\">INSERISCI</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/lettera-dialog.html","<md-dialog class=\"lettera-dialog\" aria-label=\"{{vm.title}}\"><form name=\"letteraForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button><h2>Modifica lettera</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><img \nsrc=\"{{vm.data.renderizzato[\'nota0\']}}\" flex><md-divider></md-divider><div layout=\"row\" \nng-repeat=\"item in vm.data.templater|limitTo: -12 \"><md-input-container flex ng-if=\"item !== \'tabella\'\"><label><b>\n{{vm.data.etichette[item]|uppercase}}</b></label><textarea name=\"{{item}}\" ng-model=\"vm.data.renderizzato[item]\" \naria-label=\"{{item}}\" rows=\"4\"></textarea></md-input-container><div layout=\"column\" ng-if=\"item == \'tabella\'\" \nclass=\"md-amber-200-bg padding-16 margin-bottom-16\" flex><h4><b>Tabella segnalati:</b></h4><md-divider></md-divider>\n<span class=\"padding-8 margin-top-24\" ng-repeat=\"item2 in vm.data.segnalatos\">{{item2.cognome}} {{item2.nome}}</span>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.saveLettera()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">MODIFICA</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/omonimi.html","<md-dialog><form><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Omonimi</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container><table \nmd-table><thead md-head><tr md-row><th md-column>CODICE</th><th md-column>NOME</th><th md-column>COGNOME</th><th \nmd-column>TIPOLOGIA SOGGIORNO</th><th md-column>STATO</th><th md-column>DATA DI NASCITA</th><th md-column>NAZIONALITA\n</th><th md-column>PROGETTO</th><th md-column>AZIONI</th></tr></thead><tbody md-body><tr md-row \nng-class=\"\'md-light-blue-50-bg\'\"><td md-cell><span ng-if=\"vmd.item.omonimo[\'codice\'] == undefined\"><b>{{vmd.item.id}}\n</b></span> <span ng-if=\"vmd.item.omonimo[\'codice\'] != undefined\"><b>{{vmd.item.codice}}</b></span></td><td md-cell><b>\n{{vmd.item.nome}}</b></td><td md-cell><b>{{vmd.item.cognome}}</b></td><td md-cell><b>\n{{vmd.item.protezioneTipo.descrizione}}</b></td><td md-cell><span ng-if=\"vmd.item.omonimo[\'codice\'] == undefined\"><b>\nSEGNALATO</b></span> <span ng-if=\"vmd.item.omonimo[\'codice\'] != undefined\"><b>{{vmd.item.omonimo.stato}}</b></span>\n</td><td md-cell><b>{{vmd.item.dataNascita|date: \"dd/MM/yyyy\"}}</b></td><td md-cell><b>\n{{vmd.item.nazionalita.descrizione}}</b></td><td md-cell><b>{{vmd.item.progetto.nome}}</b></td><td md-cell><md-menu>\n<md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Nuovo Inserimento\" ng-click=\"vmd.nuovoinserimento()\"><md-icon md-font-icon=\"icon-human-child\"></md-icon>\n<span>NON OMONIMO - NUOVO INSERIMENTO</span></md-button></md-menu-item><md-menu-item \nng-if=\"vmd.item.segnalazione.idTipoSegnalazione !== 697\"><md-button aria-label=\"Rifiuta segnalato\" \nng-click=\"vmd.rifiutasegnalato()\" class=\"md-warn md-button-icon\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><span>\nRIFIUTA SENZA RISOLVERE OMONIMIA</span></md-button></md-menu-item><md-menu-item \nng-if=\"vmd.item.segnalazione.idTipoSegnalazione === 697\"><md-button aria-label=\"Rimuovi segnalato\" \nng-click=\"vmd.cancellaSegnalato()\" class=\"md-warn md-button-icon\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><span>\nRIMUOVI SEGNALATO</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr md-row \nng-repeat=\"item in vmd.omonimi track by $index\" ng-class=\"{\'md-light-blue-50-bg\': item.omonimo.id === vmd.item.id}\"><td\n md-cell><span ng-if=\"item.omonimo[\'codice\'] == undefined || item.omonimo[\'codice\'] == 0\">{{item.omonimo.id}}</span> \n<span ng-if=\"item.omonimo[\'codice\'] != undefined && item.omonimo[\'codice\'] != 0\">{{item.omonimo.codice}}</span></td><td\n md-cell>{{item.omonimo.nome}}</td><td md-cell>{{item.omonimo.cognome}}</td><td md-cell>\n{{item.omonimo.protezioneTipo.descrizione}}</td><td md-cell><span ng-if=\"item.omonimo.beneficiario_id == 0\">SEGNALATO\n</span> <span ng-if=\"item.omonimo.beneficiario_id != 0\">{{item.omonimo.stato}}</span></td><td md-cell>\n{{item.omonimo.dataNascita|date: \"dd/MM/yyyy\"}}</td><td md-cell>{{item.omonimo.nazionalita.descrizione}}</td><td \nmd-cell>{{item.omonimo.progetto.nome}}</td><td md-cell><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-if=\"vmd.item.id != item.omonimo.id\"><md-button aria-label=\"Conserva dati\" \nng-click=\"vmd.conservaDati(item)\"><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon><span>CONSERVA QUESTI DATI\n</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">CHIUDI</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/omonimo-dialog.html","<md-dialog class=\"omonimo-dialog\" aria-label=\"dettaglioomonimo\"><form name=\"omonimoForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon\n md-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button><h2>Risoluzione omonimia</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-card style=\"padding-top:0px\">\n<md-table-container><table data-md-table data-md-row-select=\"vmd.options.rowSelection\" md-progress=\"vmd.beneficiari\" \nmultiple=\"{{vmd.options.multiSelect}}\"><thead ng-if=\"!vmd.options.decapitate\" md-head><tr md-row><th md-column \nstyle=\"padding-right:8px\"><span>COD</span></th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\"><span>\nCOGNOME</span></th><th md-column md-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column \nstyle=\"text-align:center;padding-right:8px\">DOCUM</th><th md-column style=\"text-align:center;padding-right:8px\">STATO\n</th><th md-column style=\"padding-right:8px\">NAZIONE</th><th md-column style=\"text-align:center;padding-right:4px\" \nmd-order-by=\"sesso\">SESSO</th><th md-column md-order-by=\"dataInserimento\" style=\"text-align:center;padding-right:8px\">\nDATE</th><th md-column md-order-by=\"nucleoFamiliare\" style=\"text-align:center;padding-right:4px\">NUCLEO</th><th \nmd-column style=\"text-align:center;padding-right:4px\">PROG</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody md-body><tr md-row><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">-</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">{{vmd.data.omonimo.cognome|uppercase}}</td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">{{vmd.data.omonimo.nome|uppercase}}</td><td\n md-cell style=\"text-align:center;padding-right:8px\"><div layout=\"column\" \nng-if=\"vmd.data.omonimo.idTipoDocumento != \'0\'\"><span \nng-repeat=\"doc in vmd.documentotipos| filter: {id:vmd.data.omonimo.idTipoDocumento}:true\"><small>{{ doc.descrizione}}\n</small> </span><span><small>{{vmd.data.omonimo.dataRilascioDocumento|date: \"dd/MM/yy\"}}</small></span> <span><small>\n{{vmd.data.omonimo.dataScadenzaDocumento|date: \"dd/MM/yy\"}}</small></span></div><div layout=\"column\" \nng-if=\"vmd.data.omonimo.idTipoDocumento == \'0\'\"><span><small>NESSUNO</small></span></div></td><td md-cell \nstyle=\"padding-right:8px\"><small>SEGNALATO</small></td><td md-cell style=\"padding-right:8px\"><div layout=\"column\">\n<span><small>{{vmd.data.omonimo.codNazionalitas.descrizione}}</small> </span><span><small>\n{{vmd.data.omonimo.dataNascita| date : \"dd/MM/yy\"}}</small></span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:4px\"><b>{{vmd.data.omonimo.sesso}}</b></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><div layout=\"column\"><span><small>\n{{vmd.data.omonimo.dataInserimento| date : \"dd/MM/yy\"}}</small></span> <span><small>\n{{vmd.data.omonimo.dataFine| date : \"dd/MM/yy\"}}</small></span> <span \nng-if=\"vmd.data.omonimo.dataUscita != \'0000-00-00\'\"><small>{{vmd.data.omonimo.dataUscita| date : \"dd/MM/yy\"}}</small>\n</span></div></td><td md-cell style=\"text-align:center;padding-right:4px\"><div \nng-if=\"(vmd.data.omonimo.nucleoFamiliare > 0)\">SI</div><div ng-if=\"(vmd.data.omonimo.nucleoFamiliare <= 0)\">NO</div>\n</td><td md-cell style=\"text-align:center;padding-right:4px\"></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button aria-label=\"Dettaglio\"><md-icon md-font-icon=\"icon-debug-step-over\" \nclass=\"md-accent-fg\" ng-click=\"vmd.nuovoinserimento();\"></md-icon><span><b><small>NON OMONIMO - NUOVO INSERIMENTO\n</small></b></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\"><tr md-row><th md-column \nstyle=\"padding-right:8px\"><span>COD</span></th><th md-column md-order-by=\"cognome\" style=\"padding-right:8px\"><span>\nCOGNOME</span></th><th md-column md-order-by=\"nome\" style=\"padding-right:8px\">NOME</th><th md-column \nstyle=\"text-align:center;padding-right:8px\">DOCUM</th><th md-column style=\"text-align:center;padding-right:8px\">STATO\n</th><th md-column style=\"padding-right:8px\">NAZIONE</th><th md-column style=\"text-align:center;padding-right:4px\" \nmd-order-by=\"sesso\">SESSO</th><th md-column md-order-by=\"dataInserimento\" style=\"text-align:center;padding-right:8px\">\nDATE</th><th md-column md-order-by=\"nucleoFamiliare\" style=\"text-align:center;padding-right:4px\">NUCLEO</th><th \nmd-column style=\"text-align:center;padding-right:4px\">PROG</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"beneficiario\" \nmd-select-id=\"beneficiario\" ng-disabled=\"(beneficiario.def === 0)\" x-md-auto-select=\"vmd.options.autoSelect\" \nng-repeat=\"beneficiario in vmd.data.items\"><td md-cell class=\"light-blue-900-fg font-weight-600\" \nstyle=\"padding-right:8px\">{{beneficiario.codice}}<span ng-if=\"beneficiario.pl == 1\" class=\"md-warn-fg\"><b>*</b></span>\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">{{beneficiario.cognome|uppercase}}\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\" style=\"padding-right:8px\">{{beneficiario.nome|uppercase}}\n</td><td md-cell style=\"text-align:center;padding-right:8px\"><div layout=\"column\" \nng-if=\"beneficiario.idTipoDocumento != \'0\'\"><span \nng-repeat=\"doc in vmd.documentotipos| filter: {id:beneficiario.idTipoDocumento}:true\"><small>{{ doc.descrizione}}\n</small> </span><span><small>{{beneficiario.dataRilascioDocumento|date: \"dd/MM/yy\"}}</small></span> <span><small>\n{{beneficiario.dataScadenzaDocumento|date: \"dd/MM/yy\"}}</small></span></div><div layout=\"column\" \nng-if=\"beneficiario.idTipoDocumento == \'0\'\"><span><small>NESSUNO</small></span></div></td><td md-cell \nstyle=\"padding-right:8px\"><small>{{beneficiario.stato}}</small> <small ng-if=\"beneficiario.beneficiario_id\">SEGNALATO\n</small></td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span \nng-repeat=\"nazione in vmd.naziones| filter: {id:beneficiario.codNazionalita}\"><small>{{ nazione.descrizione}}</small> \n</span><span><small>{{beneficiario.dataNascita| date : \"dd/MM/yy\"}}</small></span></div></td><td md-cell \nstyle=\"text-align:center;padding-right:4px\"><b>{{beneficiario.sesso}}</b></td><td md-cell \nstyle=\"text-align:center;padding-right:8px\"><div layout=\"column\"><span><small>\n{{beneficiario.dataInserimento| date : \"dd/MM/yy\"}}</small></span> <span><small>\n{{beneficiario.dataFine| date : \"dd/MM/yy\"}}</small></span> <span ng-if=\"beneficiario.dataUscita != \'0000-00-00\'\">\n<small>{{beneficiario.dataUscita| date : \"dd/MM/yy\"}}</small></span> <span ng-if=\"beneficiario.dataUscita == NULL\">\n<small>NON USCITO</small></span></div></td><td md-cell style=\"text-align:center;padding-right:4px\"><div \nng-if=\"(beneficiario.nucleoFamiliare > 0)\">SI</div><div ng-if=\"(beneficiario.nucleoFamiliare <= 0)\">NO</div></td><td \nmd-cell style=\"text-align:center;padding-right:4px\"><span \nng-repeat=\"item in vmd.progettos| filter: {id:beneficiario.progetto_id}:true\"><small>{{ item.nome}}</small></span></td>\n<td md-cell style=\"text-align:right;padding-right:8px\"><md-menu ng-if=\"!beneficiario.beneficiario_id\"><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-if=\"beneficiario.dataUscita === null\"><md-button \naria-label=\"Dettaglio\"><md-icon md-font-icon=\"icon-cancel\" class=\"md-warn-fg\"></md-icon><span><b><small>\nOMONIMIA NON RISOLVIBILE PER BENEFICIARIO PRESENTE</small></b></span></md-button></md-menu-item><md-menu-item \nng-if=\"beneficiario.dataUscita !== null && beneficiario.stato == \'PRESENTE SUL TERRITORIO\'\"><md-button \naria-label=\"Dettaglio\"><md-icon md-font-icon=\"icon-cancel\" class=\"md-warn-fg\"></md-icon><span><b><small>\nOMONIMIA NON RISOLVIBILE PER PRESENTE SUL TERRITORIO</small></b></span></md-button></md-menu-item><md-menu-item \nng-if=\"beneficiario.dataUscita !== null && beneficiario.stato == \'TERMINATO\'\"><md-button aria-label=\"Dettaglio\" \nng-click=\"vmd.conserva(beneficiario);\"><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon><span><b><small>\nCONSERVA QUESTI DATI</small></b></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></md-table-container><md-button aria-label=\"Nuovo inserimento\" ng-click=\"vmd.nuovoinserimento()\" \nclass=\"md-button md-accent-bg\">NON OMONIMO - NUOVO INSERIMENTO</md-button><md-button aria-label=\"Nuovo inserimento\" \nng-click=\"vmd.rifiutoDiretto()\" class=\"md-button md-red-900-bg\">RIFIUTA SENZA RISOLVERE OMONIMIA</md-button></md-card>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Notification\">CHIUDI</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/processosc.html","<md-dialog id=\"processosc\" class=\"add-dialog\" aria-label=\"process\"><form name=\"processForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" ng-if=\"!vm.button2\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.reject($event)\" \nng-if=\"vm.button2\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div ng-if=\"vm.segnalatis.length > 1\"><div layout=\"row\"><b>Applica questa azione a:</b>\n</div><div layout=\"row\" flex-offset=\"5\" style=\"margin: 4px 0px\" ng-repeat=\"seg in vm.segnalatis track by $index\">\n<small>*&nbsp;&nbsp;&nbsp;<b>{{seg.entita1.cognome|uppercase}}</b> {{seg.entita1.nome}}</small></div><md-divider>\n</md-divider><br></div><div layout=\"row\"><b>Completa il processo compilando i seguenti dati:</b></div>\n<sprardb-jsonform4 vm=\"vm\" formschema=\"vm.extrasetup\"></sprardb-jsonform4></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.reject($event);\" \nonclick=\"this.disabled = true\" class=\"md-primary md-raised\" ng-if=\"vm.button2\" aria-label=\"Cancel\">{{vm.titlecancel}}\n</md-button><md-button type=\"submit\" ng-click=\"vm.save($event);\" onclick=\"this.disabled = true\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"processForm.$invalid\" aria-label=\"Allow\">{{vm.title}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/processosc2.html","<md-dialog id=\"processosc\" class=\"add-dialog\" aria-label=\"process\"><form name=\"processForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><b>\nCompleta il processo compilando i seguenti dati:</b></div><sprardb-jsonform3 vm=\"vm\" formschema=\"vm.extrasetup\">\n</sprardb-jsonform3></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end start\"><div layout=\"column\" \nflex><md-button type=\"button\" ng-click=\"vm.indietro();\" class=\"md-primary md-raised\" aria-label=\"avanti\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline\"></md-icon>{{processo[2]|uppercase}} Indietro</md-button></div><div \nlayout=\"column\" flex><md-button type=\"submit\" ng-click=\"vm.salvaedesci();\" class=\"send-button md-accent md-raised\" \naria-label=\"Allow\">Salva ed esci</md-button></div><div layout=\"column\" flex><md-button type=\"button\" \nng-repeat=\"proc in vm.tuttiprocessi1| filter: \'(\' + vm.statoCorrente + \',\' track by $index\" \nclass=\"md-primary md-raised margin-bottom-32\" aria-label=\"changestatus-{{$index}}\" ng-click=\"vm.avanti(proc)\" \nstyle=\"margin-bottom: 8px\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\"></md-icon>\n{{vm.nomeProcessoPulsante(proc)}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/dialogs/rifiuta-segnalato.html","<md-dialog id=\"rifiutaSegnalato\" class=\"add-dialog\" aria-label=\"process\"><form name=\"rifiutaForm\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Rifiuta Segnalato</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vmd.segnalati.length > 1\"><div layout=\"row\"><b>\nApplica questa azione a:</b></div><div layout=\"row\" ng-repeat=\"seg in vmd.segnalati \"><small><b>\n{{seg.entita1.cognome|uppercase}}</b> {{seg.entita1.nome}}</small></div><md-divider></md-divider></div><div \nlayout=\"row\"><b>Completa il processo compilando i seguenti dati:</b></div><div layout=\"row\" \nclass=\"datepicker-container\" flex><md-input-container><md-select ng-model=\"vmd.res.tipoRifiuto\" \nplaceholder=\"Selezionare tipologia rifiuto\" required><md-option ng-repeat=\"tipRifiuto in vmd.tipoRifiuto\" \nng-value=\"tipRifiuto.id\">{{ tipRifiuto.descrizione }}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex><md-input-container flex><label>Note Rifiuto</label><textarea name=\"noteRifiuto\" \nng-model=\"vmd.res.noteRifiuto\" placeholder=\"Inserire note rifiuto...\" aria-label=\"Note Rifiuto\" rows=\"2\" required>\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vmd.rifiuta();\" class=\"send-button md-accent md-raised\" \nng-disabled=\"rifiutaForm.$invalid\">RIFIUTA SEGNALATO</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/eventi/sidenavs/main-sidenav.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchFormb\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/eventi/sidenavs/main-sidenav2.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchForms\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/entes/dettaglio/dettaglio.html","<div id=\"progetto\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Ente: <b>{{vm.contact.nome}}</b></span></div></div></div><div><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveContact();\" class=\"md-raised md-background\" ng-if=\"!vm.isVisitatore\" \nng-disabled=\"enteNForm.$invalid || enteNForm.$pristine \" aria-label=\"Add Task\">SALVA</md-button></div>\n</md-dialog-actions></div></div><div class=\"content dettaglio\" ms-scroll><md-tabs md-dynamic-height><md-tab>\n<md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-8\"><form name=\"enteNForm\" novalidate><h2 \nclass=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider></md-divider><div layout=\"row\" \nclass=\"margin-top-32\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><strong>Nome Ente</strong></label><input type=\"text\" name=\"nome\" ng-model=\"vm.contact.nome\" \nplaceholder=\"Nome Ente\" required><div ng-messages=\"enteNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><md-select-label><b>Ente tipo</b>\n</md-select-label><md-select name=\"entetipo\" ng-model=\"vm.contact.enteTipo_id\"><md-option \nng-repeat=\"entetipos in vm.tempentetipo\" value=\"{{entetipos.id}}\" \nng-if=\"vm.filtro_id_applicato.indexOf(entetipos.id) > -1\"><div layout=\"column\"><b>{{entetipos.descrizione}}</b> <small>\nSETTORE {{entetipos.enteTipo_id}}</small></div></md-option></md-select><div ng-messages=\"enteNForm.entetipo.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><md-select-label><b>Ente Attivo?</b></md-select-label><md-select \nname=\"attivo\" placeholder=\"Ente attivo?\" ng-model=\"vm.contact.attivo\" required><md-option \nng-repeat=\"item in [{id: 1, descrizione: \'SI\'}, {id: 0, descrizione: \'NO\'}]\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"enteNForm.attivo.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label><b>Telefono</b>\n</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\" class=\"font-size-12\" \nrequired><div ng-messages=\"enteNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label><b>Email</b></label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.contact.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nclass=\"font-size-12\"><div ng-messages=\"enteNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Localizzazione</strong></h2><md-divider>\n</md-divider><div layout=\"row\" class=\"margin-top-32\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><md-select-label><b>Regione</b></md-select-label><md-select name=\"reg\" ng-model=\"vm.contact.codRegione\" \nng-change=\"vm.caricaProvince(vm.contact.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"enteNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label><b>Provincia</b>\n</md-select-label><md-select name=\"prov\" ng-model=\"vm.contact.codProvincia\" ng-disabled=\"!vm.contact.codRegione\" \nng-change=\"vm.caricaComuni(vm.contact.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"enteNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div></div></md-input-container><md-input-container flex><md-select-label><b>Comune</b>\n</md-select-label><md-select name=\"com\" ng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"enteNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label><b>Indirizzo</b>\n</label><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.contact.indirizzo\" placeholder=\"Indirizzo\" \nclass=\"font-size-12\"><div ng-messages=\"enteNForm.indirizzo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label><b>\nCodice Postale</b></label><input name=\"cap\" ng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\" class=\"font-size-12\"><div ng-messages=\"enteNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container></div></div></form></div>\n</md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Persone <span \nng-class=\"{\'md-warn-bg\': vm.contact.personas.length === 0}\" class=\"text-boxed\">{{vm.contact.personas.length}}</span>\n</span></md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>\nPERSONE NELL\'ENTE</b></small></md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"psearch\" placeholder=\"Ricerca nele persone\" \ntype=\"text\" ng-model=\"vm.psearch\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button></div></div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table \ndata-md-table><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column>COGNOME</th><th md-column>\nNOME</th><th md-column>RECAPITI</th><th md-column>RUOLO/AMBITO/INCARICO</th><th md-column>PROFILO</th><th md-column \nstyle=\"padding-right:8px;text-align: right\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.contact.personas| filter: vm.psearch track by item.id\" \nng-class=\"{\'md-grey-200-bg\': item.users.user.status !== 10}\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><a title=\"{{item.email}}\" \nhref=\"mailto:{{item.email}}\">{{item.email|limitTo:20}}...</a><br>{{item.telefono}}</td><td md-cell><div \nlayout=\"column\"><span ng-repeat=\"subitem in ::item.progettoruolos\"><b>{{subitem.descrizione}}</b>\n ({{subitem.gruppo.replace(\"PROGETTO\", \"RUOLO\")}})</span> <span ng-repeat=\"subitem in ::item.enteruolos\"><b>\n{{subitem.descrizione}}</b> ({{subitem.gruppo.replace(\"ENTE\", \"INCARICO\")}})</span></div></td><td md-cell><div \nlayout=\"column\"><b ng-if=\"(item.users.user.status === 10)\">ATTIVO</b> <span ng-if=\"(item.users.user.status === 10)\">\n({{item.users.user.groups.length}}) PROFILO</span> <span ng-if=\"(item.users.user.status !== 10)\">DISATTIVO</span> <b \nng-if=\"(item.users === null)\">INESISTENTE</b></div></td><td md-cell style=\"padding-right:8px;text-align: right\">\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-accent\" aria-label=\"dettaglio\" ui-sref=\"app.sprardb_personasdettaglio2({id:item.id})\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><small><b>APRI ANAGRAFICA</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\"><md-button aria-label=\"Dettaglio2\" \nng-click=\"vm.openPersoneDialog($event, vm.contact, $index, false)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<small><b>MODIFICA/RIMUOVI ASSOCIAZIONE</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"((vm.api.isAdmin || vm.api.isAccoglienza) && !item.users.user)\"><md-button aria-label=\"crea\" \nng-click=\"vm.openRegisterDialog($event, item.id, false)\" class=\"md-blue-100-bg\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><small><b>NUOVO PROFILO</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.api.isAdmin && item.users.user)\"><md-button aria-label=\"crea2\" \nng-click=\"vm.openUserDialog($event, item.id)\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"(item.users.user.status !== 10)\"></md-icon><md-icon md-font-icon=\"icon-account-key\" \nng-if=\"(item.users.user.status === 10)\"></md-icon><small><b>PROFILO, PASSWORD e ABILITAZIONE</b></small></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" \nng-click=\"vm.openPersoneDialog($event, vm.contact, null, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nASSOCIA NUOVO OPERATORE</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-click=\"vm.openPersoneDialog($event, vm.contact, null, false)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>CREA NUOVO OPERATORE</md-button></div></md-card></md-tab-body></md-tab>\n<md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Progetti <span \nng-class=\"{\'md-warn-bg\': vm.contact.progettos.length === 0}\" class=\"text-boxed\">{{vm.contact.progettos.length}}</span>\n</span></md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>\nPROGETTI COLLEGATI</b></small></md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"psearch\" placeholder=\"Ricerca nei progetti\" \ntype=\"text\" ng-model=\"vm.prsearch\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button></div></div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table \ndata-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.entes\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"nome\">\nNOME PROGETTO</th><th md-column md-order-by=\"codComune\"><span>CITTA</span></th><th md-column md-order-by=\"email\">\nRECAPITI</th><th md-column style=\"text-align: center\">RUOLI</th><th md-column style=\"text-align: center\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row md-select=\"item\" ng-disabled=\"item.attivo == 0\" \ndata-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.contact.progettos| filter: vm.prsearch\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><div layout=\"column\"><b>\n{{item.istat.comune| uppercase}}</b> <span>{{item.istat.provincia| uppercase}}</span> <span>\n{{item.istat.regione| uppercase}}</span></div></td><td md-cell><a title=\"{{item.email}}\" href=\"mailto:{{item.email}}\">\n{{item.email|limitTo:25}}...</a><br>{{item.telefono}}</td><td md-cell style=\"text-align: center\"><div layout=\"column\">\n<span ng-repeat=\"ruolo in vm.contact.progettohasentes| filter: {progetto_id: item.id} : true\"><b>{{ruolo.ruolo}}</b>\n</span></div></td><td md-cell style=\"text-align: right; padding-right: 0px\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Visualizza lista\" ng-click=\"vm.gotoProgetto(item.id)\">\n<md-icon md-font-icon=\"icon-apps\"></md-icon><span>Apri progetto</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container></md-card></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/entes/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/liste_distribuzione/liste_distribuzione/liste_distribuzione.html","<div id=\"persone\" class=\"persone page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-menu\" class=\"s24\"></md-icon></span><span class=\"logo-text\">Liste Distribuzione</span></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nelle liste\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch();\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\">\n<thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr \nmd-row><th md-column md-order-by=\"id\">Cod</th><th md-column>NOME</th><th md-column>DESCRIZIONE</th><th md-column>\nPARTECIPANTI</th><th md-column>ULTIMO INVIO</th><th md-column>ATTIVO</th><th md-column>AZIONI</th></tr></thead><tbody \nmd-body><tr md-row x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.liste.data\"><td md-cell>{{item.id}}\n</td><td md-cell>{{item.nome}}</td><td md-cell>{{item.descrizione}}</td><td md-cell>\n{{item.personas.length + item.entes.length}}</td><td md-cell>{{item.dataUltimoInvio}}</td><td md-cell><md-icon \nclass=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"!item.attivo\"></md-icon><md-icon \nclass=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"item.attivo\"></md-icon></td><td md-cell><section \nlayout=\"row\" layout-sm=\"column\" layout-wrap><md-button class=\"md-fab md-mini\" aria-label=\"Componi comunicazione\" \nng-click=\"\"><md-tooltip>Componi comunicazione</md-tooltip><md-icon md-font-icon=\"icon-document\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Modifica lista\" ng-click=\"\"><md-tooltip>Modifica lista</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Visualizza emali\" ng-if=\"(item.personas.length + item.entes.length) > 0\" ng-click=\"\"><md-tooltip>\nVisualizza emali</md-tooltip><md-icon md-font-icon=\"icon-email\"></md-icon></md-button></section></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/liste_distribuzione/persone/persone.html","<div id=\"persone\" class=\"persone page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"logo layout-align-start-center layout-row\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-menu\" class=\"s24\"></md-icon></span>\n</div><div layout=\"column\" layout-align=\"start start\" class=\"layout-align-start-start layout-column\"><span \nclass=\"logo-text\">Lista Distribuzione</span><div class=\"subtitle secondary-text\"><span class=\"ng-binding\">\nRicerca persone</span></div></div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" \nms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nome o cognome\" \ntype=\"text\" ng-model=\"vm.ricerca2\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch();\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch();\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button \nng-click=\"vm.allFields = !vm.allFields\"><small>Ricerca avanzata</small><md-icon ng-if=\"!vm.allFields\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"vm.allFields\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\">\n</md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex ng-if=\"vm.allFields\">\n<md-input-container flex><label>Progetto</label><md-select ng-model=\"vm.ricerca[\'progettos-nome\']\" \nng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option class=\"small\" \nng-repeat=\"progetto in vm.progettos\" value=\"{{progetto.nome}}\">{{progetto.nome}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Regione</label><md-select ng-model=\"vm.ricerca[\'istats-regione\']\" \nng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutte</md-option><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.regione}}\">{{regione.regione}}</md-option></md-select></md-input-container><md-button \nng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small></md-button></div><div layout=\"row\" \nclass=\"margin-top-4 layout-row\"><button ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.OpenAggiungiAListaDialog()\" \nclass=\"md-button md-accent md-raised md-ink-ripple md-default-theme\" type=\"button\" aria-label=\"Aggiungi ad una lista\">\n<md-icon md-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Assegna ad una lista</span></button></div><md-card \nstyle=\"padding-top:0px\"><md-table-container><table md-table md-row-select multiple=\"multiple\" \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column>NOME</th><th md-column>COGNOME</th><th md-column>LISTA</th><th \nmd-column>AZIONI</th></tr></thead><tbody md-body><tr md-row x-md-auto-select=\"vm.options.autoSelect\" \nmd-select=\"item.id\" md-select-id=\"item.id\" data-md-on-select=\"\" md-on-deselect=\"vm.deselect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.persone.data\"><td md-cell>{{item.id}}</td><td md-cell>\n{{item.nome}}</td><td md-cell>{{item.cognome}}</td><td md-cell><span \nng-repeat=\"item_lista in item.listadistribuziones\">{{item_lista.nome}}<br></span></td><td md-cell><section \nlayout=\"row\" layout-sm=\"column\" layout-wrap><md-button class=\"md-fab md-mini\" aria-label=\"Aggiungi a\" ng-click=\"\">\n<md-tooltip>Rimuovi da lista</md-tooltip><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></section></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/aggiungi-tutor.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Nuovo Tutor Monitoraggio</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"ruoliForm\" novalidate layout=\"column\"><md-autocomplete \nmd-floating-label=\"Cognome e nome...\" md-selected-item=\"vmd.newTutor\" \nmd-search-text-change=\"vmd.cercaTutor(vmd.search)\" md-search-text=\"vmd.search\" \nmd-items=\"tutor in vmd.listaTutor.$promise\" md-item-text=\"tutor.persona.cognome+\' \'+tutor.persona.nome | uppercase\" \nmd-min-length=\"3\" md-require-match ng-model-options=\"{debounce: 500}\" required md-auto-focus><md-item-template><span \nmd-highlight-text=\"vmd.search\" md-highlight-flags=\"i\">{{tutor.persona.cognome+\' \'+tutor.persona.nome | uppercase}}\n</span></md-item-template></md-autocomplete><md-input-container><label><b>Ruoli</b></label><md-select \nng-model=\"vmd.newTutor.ruoli\" multiple=\"multiple\" flex><md-option ng-value=\"ruolo\" ng-repeat=\"ruolo in vmd.ruoli\">\n{{ruolo.substring(6)}}</md-option></md-select></md-input-container></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancel()\" style=\"margin-right:20px\">Annulla</md-button>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"ruoliForm.$submitted || ruoliForm.$invalid || ruoliForm.$pristine\" \nng-click=\"vmd.salva()\">CONFERMA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/assegna-esito.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assegna esito e chiudi monitoraggio</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><b ng-if=\"vmd.richieste\">\nAttenzione: sono state segnalate delle richieste.</b><form name=\"esitoForm\" novalidate><md-input-container flex><label>\n<b>Esito</b></label><md-select ng-model=\"vmd.esitoId\" required name=\"esitoId\"><md-option ng-value=\"esito.id\" \nng-repeat=\"esito in vmd.statoMonitoraggio | filter: {gruppo: \'ESITO\'}\">{{esito.descrizione}}</md-option></md-select>\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vmd.cancelDialog()\" style=\"margin-right:20px\">Annulla</md-button><md-button class=\"md-raised md-accent\" \nng-disabled=\"esitoForm.$submitted || esitoForm.$invalid || esitoForm.$pristine\" ng-click=\"vmd.hideDialog()\">CONFERMA\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/cambia-ruoli-tutor.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vmd.tutor.persona.nomeCognome}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"ruoliForm\" novalidate><md-input-container flex><label><b>\nRuoli</b></label><md-select ng-model=\"vmd.tutor.ruoli\" multiple=\"multiple\" flex><md-option ng-value=\"ruolo\" \nng-repeat=\"ruolo in vmd.ruoli\">{{ruolo.substring(6)}}</md-option></md-select></md-input-container></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancel()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"ruoliForm.$pristine\" \nng-click=\"vmd.salva()\">CONFERMA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/new-monitoraggio.html","<md-dialog style=\"width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Nuova visita di monitoraggio</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Progetto</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate layout=\"row\"><md-autocomplete md-floating-label=\"Progetto\" \nmd-no-cache=\"1\" md-selected-item=\"vmd.progetto\" md-search-text-change=\"vmd.cercaProgetti(vmd.progettoNome)\" \nmd-selected-item-change=\"vmd.caricaMonitoraggio()\" md-search-text=\"vmd.progettoNome\" \nmd-items=\"progetto in vmd.progetti.$promise\" md-item-text=\"progetto.nome\" md-min-length=\"3\" md-require-match \nng-model-options=\"{debounce: 200}\" name=\"progettoNome\" required flex><md-item-template><span \nmd-highlight-text=\"vmd.progettoNome\" md-highlight-flags=\"i\">{{progetto.nome}}</span></md-item-template>\n</md-autocomplete><md-input-container flex><label>Anno</label><md-select ng-model=\"vmd.anno\" required \nng-change=\"vmd.caricaMonitoraggio()\"><md-option ng-value=\"anno\" ng-repeat=\"anno in vmd.anni\">{{anno}}</md-option>\n</md-select></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Info progetto</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep2\" ng-disabled=\"vmd.progettoMonitoraggio.id\" ms-form-wizard-form novalidate \nlayout=\"column\"><div layout=\"row\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (wizardStep2.codiceProgetto.$invalid)}\"><b>Codice Ministeriale</b></label><input type=\"text\" \nng-model=\"vmd.progettoMonitoraggio.codiceProgetto\" placeholder=\"Codice Ministeriale\" name=\"codiceProgetto\" \nclass=\"font-size-12\" required><div ng-messages=\"wizardStep2.codiceProgetto.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il codice ministeriale è richiesto.</span></div></div></md-input-container><md-autocomplete\n md-floating-label=\"Ente Locale\" md-no-cache=\"1\" md-selected-item=\"vmd.progettoMonitoraggio.enteLocale\" \nmd-search-text-change=\"vmd.cercaEnti(vmd.progettoMonitoraggio.enteLocaleSearch)\" \nmd-search-text=\"vmd.progettoMonitoraggio.enteLocaleSearch\" md-items=\"nomeEnte in vmd.nomiEnte.$promise\" \nmd-item-text=\"nomeEnte\" md-min-length=\"3\" ng-model-options=\"{debounce: 200}\" name=\"enteLocale\" flex required>\n<md-item-template><span md-highlight-text=\"vmd.progettoMonitoraggio.enteLocaleSearch\" md-highlight-flags=\"i\">\n{{nomeEnte}}</span></md-item-template><div ng-messages=\"wizardStep2.enteLocale.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il nome ente locale è richiesto.</span></div></div></md-autocomplete></div><div \nlayout=\"row\"><md-input-container flex><label>Categoria</label><md-select ng-model=\"vmd.progettoMonitoraggio.bandoId\" \nng-disabled=\"vmd.progettoMonitoraggio.id\" required><md-option ng-value=\"bando.id\" \nng-repeat=\"bando in vmd.progettoMonitoraggio.bandiPossibili\">{{bando.descrizione}}</md-option></md-select>\n</md-input-container><div class=\"datepicker-container\" style=\"font-size:12px;margin-left:40px\" flex><label flex \nstyle=\"max-height: 22px\">Data inizio finanziamento *</label><br><md-datepicker \nng-disabled=\"vmd.progettoMonitoraggio.id\" datepicker-validation-fix \nng-model=\"vmd.progettoMonitoraggio.dataInizioFinanziamento\" flex=\"100\" name=\"dataInizioFinanziamento\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required></md-datepicker><div \nng-messages=\"wizardStep2.dataInizioFinanziamento.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data inizio finanziamento è obbligatoria</span></div></div></div><div \nclass=\"datepicker-container\" style=\"font-size:12px;margin-left:40px\" flex><label flex style=\"max-height: 22px\">\nData fine finanziamento *</label><br><md-datepicker ng-disabled=\"vmd.progettoMonitoraggio.id\" \ndatepicker-validation-fix ng-model=\"vmd.progettoMonitoraggio.dataFineFinanziamento\" flex=\"100\" \nname=\"dataFineFinanziamento\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" required></md-datepicker>\n<div ng-messages=\"wizardStep2.dataFineFinanziamento.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data fine finanziamento è obbligatoria</span></div></div></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Info visita</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate layout=\"column\"><monitoraggio-form ng-model=\"vmd.visita\">\n</monitoraggio-form></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Indietro</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Avanti</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vmd.salva()\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"vmd.saving || wizardStep3.$invalid\">Conferma\n</md-button></div></ms-form-wizard></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/segnala-minint.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Segnala al MININT</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"segnalaForm\" novalidate><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">Data *</label><br><md-datepicker \ndatepicker-validation-fix ng-model=\"vmd.data\" flex=\"100\" name=\"data\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\" required></md-datepicker><div ng-messages=\"segnalaForm.data.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vmd.cancelDialog()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button class=\"md-raised md-accent\" \nng-disabled=\"segnalaForm.$submitted || segnalaForm.$invalid\" ng-click=\"vmd.hideDialog()\">CONFERMA</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/show-rapporto.html","<md-dialog style=\"width: 80%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Rapporto {{vmd.dettaglio.tipo}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"rapportoForm\" class=\"content padding-15\" novalidate \nlayout=\"column\"><ng-quill-editor ng-model=\"vmd.dettaglio.rapporto\" read-only=\"true\"></ng-quill-editor></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vmd.copy()\">COPIA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dialogs/uploadFile-dialog.html","<md-dialog aria-label=\"Carica un file\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Aggiungi un file</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"100\"><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"uploadFileForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><input type=\"file\" \nfileread=\"vmd.upload.file\" required></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nTipo File</label><md-select name=\"tipoFile\" ng-model=\"vmd.upload.fileType\" required><md-option ng-value=\"codice.id\" \nng-repeat=\"codice in vmd.tipiFile\">{{ codice.tipo}}</md-option></md-select><div \nng-messages=\"uploadFileForm.tipoFile.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\" style=\"margin-right:20px\">Annulla\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-click=\"vmd.salvaFile(vmd.upload)\">Salva</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/monitoraggio/dettaglio/azioni-dettaglio.html","<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.sprardb_monitoraggio.view.checklist({visitaId:vm.dettaglio.visitaId, id:vm.dettaglio.id})\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><small><b>CHECKLIST</b></small></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.user.permissions.includes(\'view-rapporto\')\"><md-button \nui-sref=\"app.sprardb_monitoraggio.view.rapporto({visitaId:vm.dettaglio.visitaId, id:vm.dettaglio.id})\"><md-icon \nmd-font-icon=\"icon-document\"></md-icon><small><b>RAPPORTO</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentState.name !== \'app.sprardb_monitoraggio.view\'\"><md-button \nui-sref=\"app.sprardb_monitoraggio.view({visitaId:vm.dettaglio.visitaId, \'#\': \'dettagli\'})\"><md-icon \nmd-font-icon=\"icon-chevron-double-right\"></md-icon><small><b>VAI ALLA VISITA</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.duplica && vm.canDuplicate()\"><md-button ng-click=\"vm.duplicaDettaglio()\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><small><b>DUPLICA</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"vm.dettaglio.visita.statoId == 2 && !vm.dettaglio.validato && !vm.dettaglio.inviato && vm.dettaglio.created_by == vm.user.id\">\n<md-button ng-click=\"vm.inviaDettaglio()\"><md-icon md-font-icon=\"icon-send\"></md-icon><small><b>INVIA AL SC</b></small>\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.canValidaDettaglio()\"><md-button ng-click=\"vm.validaDettaglio()\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon><small><b>VALIDA</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.canRifiutaDettaglio()\"><md-button ng-click=\"vm.rifiutaDettaglio()\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon><small><b>RIFIUTA</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"vm.dettaglio.statoId === 17 && vm.canRifiutaDettaglio()\"><md-button ng-click=\"vm.invalidaDettaglio()\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon><small><b>INVALIDA</b></small></md-button></md-menu-item><md-menu-item \nng-if=\"vm.dettaglio.visita.statoId == 2 && !vm.dettaglio.timeInvio && vm.dettaglio.created_by == vm.user.id\"><md-button\n ng-click=\"vm.eliminaDettaglio()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><small><b>ELIMINA</b></small>\n</md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/sprardb/monitoraggio/dettaglio/checklist.html","<div id=\"monitoraggio\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header white-fg\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" aria-label=\"indietro\" onclick=\"history.go(-1)\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><span class=\"h2\">Checklist di tipo {{vm.dettaglio.tipo}}</span> <span flex></span><md-button \nclass=\"md-button\" ng-click=\"vm.stateUp()\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon>Torna alla visita</md-button>\n</div><form name=\"checklistForm\" novalidate class=\"content-card\" layout=\"column\" flex style=\"padding: 0\" \nunsaved-warning-form><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><h2>\n{{vm.dettaglio.visita.nome}} ({{vm.dettaglio.visita.progettoMonitoraggio.anno}})</h2><small>\nPunteggio totale: {{vm.d.checklist.score | number:3}}</small> <small>\nValutazione sintetica: {{vm.d.checklist.punteggio}}</small> <small>{{vm.d.checklist.giudizio.descrizione}}</small>\n<md-button class=\"md-icon-button\" ng-click=\"vm.exportCsv()\"><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button><md-button type=\"submit\" \nng-click=\"vm.salva()\" class=\"md-accent md-raised\" ng-disabled=\"checklistForm.$submitted || checklistForm.$pristine\">\nSALVA</md-button></div><md-content class=\"content\" flex ms-scroll><table class=\"simple\" ms-responsive-table><thead \nfix-head><tr><th><b>COD.</b></th><th><b>DESCRIZIONE</b></th><th><b>PUNTEGGIO</b></th><th \nng-if=\"vm.dettaglio.tipo == \'amministrativo\'\"><b>DOC. PRESENTE</b></th><th \nng-if=\"vm.dettaglio.tipo == \'amministrativo\'\"><b>DOC. RICHIESTA</b></th><th><b>NOTE</b></th><th><b>HELP</b></th></tr>\n</thead><tbody><tr ng-repeat-start=\"(codice, item) in vm.template track by codice\" class=\"md-blue-grey-200-bg\"><td \nclass=\"text-center\"><b>{{codice}}</b></td><td><b>{{item.descrizione}}</b></td><td><b>\n{{vm.d.checklist.items[codice].score | number : 3}}</b></td><td ng-if=\"vm.dettaglio.tipo == \'amministrativo\'\"></td><td \nng-if=\"vm.dettaglio.tipo == \'amministrativo\'\"></td><td></td><td></td></tr><tr ng-repeat-end \nng-repeat=\"(sottocodice, subitem) in item.items track by sottocodice\"><td class=\"text-center\"><b>{{sottocodice}}</b>\n</td><td><b>{{subitem.descrizione}}</b></td><td><md-input-container><md-select \nng-model=\"vm.d.checklist.items[codice].items[sottocodice].optionsId\" required aria-label=\"sottocodice\" \nmd-container-class=\"checklistSelect\" ng-disabled=\"vm.disabled\" flex><md-option ng-value=\"option.key\" \nng-repeat=\"option in vm.getRange(subitem.range) | orderBy: option.order\"><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"pr-5\" ng-class=\"option.value == option.label ? \'text-center\' : \'\'\" flex>\n{{option.label}}</span> <span style=\"width: 22px\" class=\"border-left text-right\" ng-if=\"option.value != option.label\">\n{{option.value}}</span></div></md-option></md-select></md-input-container></td><td \nng-if=\"vm.dettaglio.tipo == \'amministrativo\'\"><md-checkbox \nng-model=\"vm.d.checklist.items[codice].items[sottocodice].docPresente\" ng-disabled=\"vm.disabled\" ng-true-value=\"1\" \nng-false-value=\"0\" aria-label=\"Doc. Presente\"></md-checkbox></td><td ng-if=\"vm.dettaglio.tipo == \'amministrativo\'\">\n<md-checkbox ng-model=\"vm.d.checklist.items[codice].items[sottocodice].docRichiesta\" ng-disabled=\"vm.disabled\" \nng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Doc. Richiesta\"></md-checkbox></td><td><md-input-container><textarea \nng-readonly=\"vm.disabled\" ng-model=\"vm.d.checklist.items[codice].items[sottocodice].note\" type=\"text\" \naria-label=\"sottocodice\" ng-maxlength=\"200\" placeholder=\"Note\" flex></textarea></md-input-container></td><td><md-button\n ng-if=\"subitem.help\" class=\"md-icon-button\" ng-click=\"vm.showHelp(subitem)\" aria-label=\"help\"><md-icon \nmd-font-icon=\"icon-help\"></md-icon></md-button></td></tr></tbody></table></md-content></form></div></div>");
$templateCache.put("app/main/sprardb/monitoraggio/dettaglio/rapporto.html","<div id=\"monitoraggio\" class=\"page-layout simple tabbed ng-scope layout-column\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"indietro\" onclick=\"history.go(-1)\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"h2\">Rapporto</span> <span flex></span><md-button \nclass=\"md-button\" ng-click=\"vm.stateUp()\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon>Torna alla visita</md-button>\n</div><md-card class=\"content\"><form name=\"rapportoForm\" class=\"content md-inline-form padding-15\" novalidate \nlayout=\"column\" unsaved-warning-form><ng-quill-editor ng-model=\"vm.dettaglio.rapporto\"></ng-quill-editor>\n<md-input-container flex=\"20\" class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (rapportoForm.note.$invalid)}\">\n<b>Annotazioni</b></label><textarea name=\"note\" ng-model=\"vm.dettaglio.note\" class=\"font-size-12\" rows=\"3\" \nplaceholder=\"Annotazioni personali (visibili al SC{{vm.altroTipo ? \' e al Tutor \'+vm.altroTipo : \'\'}})\"></textarea>\n</md-input-container><div layout=\"row\" layout-align=\"end\"><md-button type=\"submit\" ng-click=\"vm.salva()\" \nclass=\"md-raised md-accent\" ng-disabled=\"rapportoForm.$submitted ||rapportoForm.$invalid || rapportoForm.$pristine\">\nSALVA</md-button></div></form></md-card></div>");
$templateCache.put("app/main/sprardb/monitoraggio/sidenavs/main-sidenav.html","<md-toolbar><h1 class=\"md-toolbar-tools\">Ricerca avanzata</h1></md-toolbar><md-content layout-margin><form \nname=\"ricercaAvanzata\" novalidate layout=\"column\" ng-submit=\"vm.toggleSidenav(\'sidenav\')\"><search-form \nng-model=\"vm.searchModel\" filter=\"vm.filter\" cruscotto=\"vm.isCruscotto\"></search-form></form></md-content>");
$templateCache.put("app/main/sprardb/monitoraggio/tutor/tutor.html","<div id=\"monitoraggio\" class=\"monitoraggio page-layout simple fullwidth\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/monitoraggio/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Lista Tutor</span></div>\n</div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" \nms-scroll><md-card style=\"padding-top:0px\"><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.monitoraggi.$promise\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column></th><th md-column></th><th md-column><md-select class=\"ml-5 pt-5 md-no-underline\" ng-model=\"vm.anno\" \nrequired ng-change=\"vm.loadTutor()\" aria-label=\"anno\"><md-option ng-value=\"anno\" ng-repeat=\"anno in vm.anni\">{{anno}}\n</md-option></md-select></th><th md-column colspan=\"3\">VISITE ASSEGNATE</th><th md-column colspan=\"3\">VISITE ESEGUITE\n</th><th md-column><md-button class=\"md-icon-button\" ng-click=\"vm.exportCsv()\"><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"light-green-900-fg\"></md-icon><md-tooltip>Esporta i dati</md-tooltip></md-button></th></tr><tr md-row><th \nmd-column md-order-by=\"dataInizio\">COGNOME</th><th md-column md-order-by=\"questionario_tipo\">NOME</th><th md-column \nmd-order-by=\"progetto_id\">RUOLI ASSEGNATI</th><th md-column md-numeric \nng-if-start=\"vm.listaTutor && vm.listaTutor.data[0] && vm.listaTutor.data[0].descrizione === \'SEMESTRE\'\">S1</th><th \nmd-column md-numeric>S2</th><th md-column md-numeric>S1</th><th md-column md-numeric ng-if-end>S2</th><th md-column \nmd-numeric \nng-if-start=\"vm.listaTutor && vm.listaTutor.data[0] && vm.listaTutor.data[0].descrizione === \'QUADRIMESTRE\'\">Q1</th><th\n md-column md-numeric>Q2</th><th md-column md-numeric>Q3</th><th md-column md-numeric>Q1</th><th md-column md-numeric>\nQ2</th><th md-column md-numeric ng-if-end>Q3</th><th md-column ng-if=\"vm.user.permissions.includes(\'edit-tutor\')\">\nCAMBIA RUOLI</th></tr></thead><tbody md-body><tr md-row md-select=\"monitoraggios\" md-select-id=\"monitoraggios\" \ndata-md-on-select=\"vm.toggleSelectContact\" md-on-deselect=\"vm.deselectContacts\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.listaTutor.data\"><td md-cell><b>\n{{item.cognome | uppercase}}</b></td><td md-cell><b>{{item.nome | uppercase}}</b></td><td md-cell><div layout=\"column\" \nlayout-align=\"space-around\"><span ng-repeat=\"ruolo in item.ruoli\">{{ruolo.substring(6)}}</span></div></td><td md-cell \nng-if-start=\"vm.listaTutor && vm.listaTutor.data[0] && vm.listaTutor.data[0].descrizione === \'SEMESTRE\'\">\n{{item.assegnate_S1}}</td><td md-cell>{{item.assegnate_S2}}</td><td md-cell>{{item.eseguite_S1}}</td><td md-cell \nng-if-end>{{item.eseguite_S2}}</td><td md-cell \nng-if-start=\"vm.listaTutor && vm.listaTutor.data[0] && vm.listaTutor.data[0].descrizione === \'QUADRIMESTRE\'\">\n{{item.assegnate_Q1}}</td><td md-cell>{{item.assegnate_Q2}}</td><td md-cell>{{item.assegnate_Q3}}</td><td md-cell>\n{{item.eseguite_Q1}}</td><td md-cell>{{item.eseguite_Q2}}</td><td md-cell ng-if-end>{{item.eseguite_Q3}}</td><td \nmd-cell><md-button class=\"md-icon-button\" ng-click=\"vm.cambiaRuoli($event, item)\" \nng-if=\"vm.user.permissions.includes(\'edit-tutor\')\" aria-label=\"modifica ruoli\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.search[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" md-page=\"vm.search.page\" md-total=\"{{vm.totalCount}}\" \nmd-on-paginate=\"vm.loadTutor\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-if=\"vm.user.permissions.includes(\'edit-tutor\')\" ng-click=\"vm.aggiungiTutor($event)\" aria-label=\"nuovo tutor\">\n<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/sprardb/personas/dettaglio/dettaglio.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Persona</span><div class=\"subtitle secondary-text\"><span>{{vm.contact.nome}} {{vm.contact.cognome}}\n</span></div></div></div></div><div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveContact();\" \nclass=\"md-raised md-background\" ng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" aria-label=\"Add Task\">\nSALVA</md-button></div></md-dialog-actions></div></div><div class=\"content\" ms-scroll><md-tabs md-dynamic-height>\n<md-tab><md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-8\"><form name=\"personaNForm\" class=\"md-inline-form\" \nnovalidate><h2 class=\"no-padding\"><strong>Informazioni Generali</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div flex=\"100\"><div layout=\"row\" flex><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><input type=\"text\" name=\"nome\" ng-model=\"vm.contact.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl nome dell\'utente è richiesto.</span></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><input type=\"text\" name=\"cognome\" ng-model=\"vm.contact.cognome\" \nplaceholder=\"Cognome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il cognome dell\'utente è richiesto.</span></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso\n</label><md-select name=\"sesso\" ng-model=\"vm.contact.sesso\"><md-option value=\"M\">Maschio</md-option><md-option \nvalue=\"F\">Femmina</md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex><div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><label>Email</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input type=\"email\" name=\"email\" ng-model=\"vm.contact.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required class=\"font-size-12\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n</div><div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><label>Telefono</label><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" \nplaceholder=\"Telefono\" class=\"font-size-12\"></md-input-container></div><div layout=\"column\" flex><md-input-container \nflex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale</label><input \ntype=\"text\" name=\"codicefiscale\" ng-model=\"vm.contact.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.codicefiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n</div></div><h2 class=\"no-padding\"><strong>Luogo di residenza</strong></h2><md-divider></md-divider><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>\nRegione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" ng-model=\"vm.contact.codRegione\" \nng-change=\"vm.caricaProvince(vm.contact.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">{{regione.regione}}</md-option></md-select>\n<div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label><md-select \nname=\"prov\" ng-model=\"vm.contact.codProvincia\" ng-disabled=\"!vm.contact.codRegione\" \nng-change=\"vm.caricaComuni(vm.contact.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.contact.indirizzo\" \nplaceholder=\"Indirizzo\"></md-input-container><md-input-container flex><label>codice Postale</label><input name=\"cap\" \nng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><h2 class=\"no-padding\"><strong>Luogo e data di nascita</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg2\" \nng-model=\"vm.contact.nascita.codRegione\" ng-change=\"vm.caricaProvince2(vm.contact.nascita.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones2\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.nascita.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex required><label>Provincia</label><md-select name=\"prov2\" \nng-model=\"vm.contact.nascita.codProvincia\" ng-disabled=\"!vm.contact.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.contact.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vm.contact.codComuneNascita\" ng-disabled=\"!vm.contact.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.contact.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><label>Nazionalità</label><md-icon \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><md-select name=\"naz\" ng-model=\"vm.contact.codNazionalita\"><md-option \nng-repeat=\"nazione in vm.nazioni\" value=\"{{nazione.id}}\">{{nazione.descrizione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container><div flex><strong>\n<small>DATA DI NASCITA</small></strong><md-datepicker ng-model=\"vm.contact.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex></md-datepicker></div></div></div><h2 class=\"no-padding\">\n<strong>Tags</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-chips ng-model=\"vm.contact.tags\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText,vm.tags,\'tag\')\" md-item-text=\"item.tag\" \nplaceholder=\"Aggiungi nuovo tag\"><span md-highlight-text=\"vm.searchText\">{{item.tag}}</span></md-autocomplete>\n<md-chip-template><small><span><strong>{{$chip.tag}}</strong></span></small></md-chip-template></md-chips></div></div>\n</form></div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Ruoli <span \nng-class=\"{\'md-warn-bg\': (vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasprogettos.length) == 0}\" \nclass=\"text-boxed\">\n{{(vm.contact.ruolos.length + vm.contact.personahasprogettos.length + vm.contact.personahasprogettos.length)}}</span>\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Ruoli generici</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in ::vm.contact.ruolos\"><div flex=\"40\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ ruolo.descrizione | uppercase}}</span></div><md-divider>\n</md-divider></md-list-item></div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCollega nuovo ruolo generico</strong></h2><md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple><div layout=\"row\" class=\"margin-top-16\"><md-button aria-label=\"Nuovo Ruolo  Esistente\" ng-click=\"\">\n<md-icon md-font-icon=\"icon-link\"></md-icon>Nuovo ruolo esistente<md-tooltip><span>Collega nuovo ruolo esistente</span>\n</md-tooltip></md-button><md-button aria-label=\"Crea Nuovo Ruolo\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon>Crea nuovo ruolo<md-tooltip><span>Crea nuovo ruolo</span></md-tooltip>\n</md-button></div></md-list-item></md-list><div layout=\"row\" flex><div layout=\"column\" flex=\"50\"><h2 \nclass=\"no-padding\"><strong>Ruolo nei progetti</strong></h2><md-divider></md-divider><div layout=\"column\" \nclass=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in vm.contact.personahasprogettos\"><dl><dd \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'PROGETTO\'}\"><span \nclass=\"text-boxed\">{{pruolo.descrizione}}</span></dd></dl><md-divider></md-divider></md-list-item></div></div><div \nlayout=\"column\" flex=\"50\"><h2 class=\"no-padding\"><strong>Ruolo negli Enti</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ruolo in vm.contact.personahasentes\"><dl><dd \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'ENTE\'}\"><span \nclass=\"text-boxed\">{{pruolo.descrizione}}</span></dd></dl><md-divider></md-divider></md-list-item></div></div></div>\n</div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Progetti <span \nng-class=\"{\'md-warn-bg\': vm.contact.progettos.length === 0}\" class=\"text-boxed\">{{vm.contact.progettos.length}}</span>\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Progetti collegati</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"progetto in ::vm.contact.progettos\"><div flex=\"30\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ progetto.nome | uppercase}}</span></div><div flex=\"20\"><ul \nclass=\"text-truncate hide show-gt-sm\"><li ng-repeat=\"bando in ::progetto.bandos\" class=\"line-height-24\" \nstyle=\"list-style-type:none\"><span class=\"text-boxed md-light-blue-200-bg\">{{bando.descrizione}}</span></li></ul></div>\n<div flex=\"30\" class=\"padding-4\"><span \nng-repeat=\"ruolo in vm.contact.personahasprogettos| filter: {\'progetto_id\': progetto.id}\"><small class=\"text-boxed\" \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'PROGETTO\'}\">\n{{pruolo.descrizione}}</small></span></div><div flex><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Dettaglio\" ng-click=\"vm.gotoProgetto(progetto.id)\"><md-icon md-font-icon=\"icon-apps\"></md-icon><md-tooltip>\n<span>Vai al progetto</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item></div></md-list>\n</div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Enti <span \nng-class=\"{\'md-warn-bg\': vm.contact.entes.length === 0}\" class=\"text-boxed\">{{vm.contact.entes.length}}</span></span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg padding-16\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Enti collegati</strong></h2><md-divider></md-divider><div \nlayout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ente in ::vm.contact.entes\"><div flex=\"35\" class=\"padding-4\"><span \nclass=\"font-weight-600 secondary-text light-blue-900-fg\">{{ ente.nome | uppercase}}</span><md-tooltip><mark>\n{{ente.email}}</mark></md-tooltip></div><div flex=\"15\" class=\"padding-4\"><span class=\"text-boxed\">\n{{ente.entetipo.descrizione}}</span></div><div flex=\"50\" class=\"padding-4\"><span \nng-repeat=\"ruolo in vm.contact.personahasentes| filter: {\'ente_id\': ente.id}\"><small class=\"text-boxed\" \nng-repeat=\"pruolo in vm.personaruolos| filter: {\'id\': ruolo.personaRuolo_id, \'gruppo\': \'ENTE\'}\">{{pruolo.descrizione}}\n</small></span></div><div flex class=\"padding-4\"><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"Modifica link\" ng-click=\"vm.openEntiDialog($event, vm.contact, $index, false)\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><md-tooltip><span>Modifica collegamento</span></md-tooltip></md-button></div>\n<md-divider></md-divider></md-list-item></div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCollega nuovo ente</strong></h2><md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple>\n<div layout=\"row\" class=\"margin-top-16\"><md-button aria-label=\"Nuovo Ente Esistente\" \nng-click=\"vm.openEntiDialog($event, vm.contact, null, true)\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\nNuovo ente esistente<md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip></md-button><md-button \naria-label=\"Crea Nuovo ente\" ng-click=\"vm.openEntiDialog($event, vm.contact, null, false)\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon>Crea nuovo ente<md-tooltip><span>Crea nuovo ente</span></md-tooltip>\n</md-button></div></md-list-item></md-list></div><div layout=\"column\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openEntiDialog($event, vm.contact, null, true)\" aria-label=\"Nuovo Ente Esistente\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip>\n</md-button></div></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Extra\n<span ng-class=\"{\'md-warn-bg\': vm.contact.personaextras.length === 0}\" class=\"text-boxed\">\n{{vm.contact.personaextras.length}}</span></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-16\"><md-list class=\"contacts-list\"><h2 \nclass=\"no-padding\"><strong>Campi Extra</strong></h2><md-divider></md-divider><md-list-item \nclass=\"contact-item md-white-bg\" md-ink-ripple ng-repeat=\"extra in ::vm.contact.personaextras\"><div flex=\"30\" \nclass=\"padding-4\"><p class=\"font-weight-600\"><span class=\"secondary-text light-blue-900-fg\">\n{{ extra.chiave | uppercase}}</span></p></div><div flex=\"60\" class=\"padding-4\"><p class=\"font-weight-600\"><span \nclass=\"secondary-text light-blue-800-fg\"><small>{{ extra.valore| uppercase}}</small></span></p></div><div flex>\n<md-button class=\"md-fab md-mini md-secondary\" aria-label=\"modifica campo\" \nng-click=\"vm.openExtraDialog($event, vm.contact, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>\n<span>Modifica campo</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item></md-list><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding\"><strong>Nuovo campo extra</strong></h2><md-divider></md-divider>\n<md-list-item class=\"contact-item md-white-bg\" md-ink-ripple><div layout=\"row\" class=\"margin-top-16\"><md-button \naria-label=\"Crea Nuovo campo\" ng-click=\"vm.openExtraDialog($event, vm.contact, null)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Nuovo campo extra<md-tooltip><span>Aggiungi nuovo campo extra</span></md-tooltip>\n</md-button></div></md-list-item></md-list></div><div layout=\"row\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-contact-button\" ng-click=\"vm.openExtraDialog($event, vm.contact, null)\" aria-label=\"aggiungi corso\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip><span>Inserisci nuovo Extra</span></md-tooltip></md-button>\n</div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/sprardb/personas/sidenavs/sidenav-ricerca.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchForms\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/personas2/dettaglio/dettaglio.html","<div id=\"progetto\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"Go to products\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Persona: <b>{{vm.contact.nome|uppercase}} {{vm.contact.cognome|uppercase}}</b></span></div></div>\n</div><div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveContact();\" class=\"md-raised md-background\" \nng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" aria-label=\"Add Task\">SALVA</md-button></div>\n</md-dialog-actions></div></div><div class=\"content dettaglio\" ms-scroll><md-tabs md-dynamic-height><md-tab \nlabel=\"DETTAGLIO\"><div id=\"dettagliotab\"><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-8\"><div class=\"row\" ng-if=\"vm.confermaUtente == 0\"><h3><i\n class=\"icon-alert s18 md-warn-fg\"></i>\n Gentile utente,l’informativa privacy della Banca Dati è stata aggiornata. Per procedere è necessario <b>\nconfermare di avere letto ed accettare l’informativa, modificare la password e confermare i dati personali</b>\n. Al termine della procedura, per poter continuare a lavorare dovrà effettuare nuovamente la login.</h3><md-divider>\n</md-divider><br></div><form name=\"personaNForm\" novalidate><div ng-if=\"vm.confermaUtente == 0\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.confermaUtente\"><small><b><i class=\"icon-key-variant s16\"></i>\n CAMBIAMENTO PASSWORD, OBBLIGATORIO AL PRIMO AVVIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div\n layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.passwordAttuale.$invalid)}\">Inserire password attuale</label><input \ntype=\"{{vm.passwordvisible}}\" name=\"passwordAttuale\" ng-model=\"vm.logindata.passwordAttuale\" \naria-label=\"passwordAttuale\" ng-model-options=\"{debounce: 1500}\" ng-change=\"vm.validatepassword($event)\" \nplaceholder=\"Inserire password attuale\" required><div ng-messages=\"personaNForm.passwordAttuale.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Richiesto</span></div></div><div class=\"green-800-fg\" \nng-if=\"vm.passwordvalidata === 1\"><small>Perfetto, la password è corretta.</small></div><div class=\"md-warn-fg\" \nng-if=\"vm.passwordvalidata === 0\"><small>La password non coincide con l\'attuale.</small></div></md-input-container>\n<md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.nuovaPassword.$invalid)}\">Inserire nuova password</label><input \ntype=\"{{vm.passwordvisible}}\" name=\"nuovaPassword\" ng-model=\"vm.logindata.nuovaPassword\" aria-label=\"nuovaPassword\" \nplaceholder=\"Inserire nuova password\" minlength=\"8\" required ng-change=\"vm.resetConfirmpass($event)\" \nng-model-options=\"{debounce: 500}\"><div ng-messages=\"personaNForm.nuovaPassword.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div><div ng-message=\"minlength\"><span>Deve essere minimo 8 caratteri\n</span></div><div ng-message=\"passwordVerify\"><span>Password deve essere diversa dalla precedente</span></div></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-checkbox ng-model=\"vm.passwordvisible\" \naria-label=\"Checkbox 2\" ng-true-value=\"\'text\'\" ng-false-value=\"\'password\'\"><small>Mostra password</small></md-checkbox>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-checkbox name=\"trattamentoPrivacy\" \nng-model=\"vm.logindata.privacy\" aria-label=\"Checkbox Provacy\" ng-true-value=\"1\" ng-false-value=\"0\" required><div \nlayout=\"column\"><small><b>Ho letto e acconsento al trattamento dei dati</b></small> <small><a \nhref=\"{{vm.api.baseUrl}}privacy.pdf\" target=\"_blank\"><i class=\"icon-file-document-box s14\"></i>\n Clicca qui per visualizzare l\'informativa</a></small></div></md-checkbox></md-input-container></div></div></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b><i class=\"icon-account-box s16\"></i> ANAGRAFICA</b>\n</small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (personaNForm.cognone.$invalid)}\">\nCognome</label><input type=\"text\" name=\"cognome\" ng-model=\"vm.contact.cognome\" aria-label=\"cog\" placeholder=\"Cognome\" \nrequired><div ng-messages=\"personaNForm.cognome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span>\n</div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.none.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.contact.nome\" aria-label=\"nom\" placeholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div \nlayout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><md-select-label ng-class=\"{\'md-warn-fg\': (personaNForm.sesso.$invalid)}\">Sesso\n</md-select-label><md-select name=\"sesso\" ng-model=\"vm.contact.sesso\" required aria-label=\"ses\"><md-option value=\"M\">\n<small><b>MASCHILE</b></small></md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small></md-option></md-select>\n<div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span>\n</div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.codicefiscale.$invalid)}\">Codice Fiscale</label><input type=\"text\" \nname=\"codicefiscale\" ng-model=\"vm.contact.codiceFiscale\" aria-label=\"cf\" placeholder=\"Codice Fiscale\" \nclass=\"font-size-12\" ng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" minlength=\"16\" \nmaxlength=\"16\" required ng-change=\"vm.checkCf($event)\" ng-model-options=\"{debounce: 1500}\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"maxlength\"><span>Deve essere lungo 16 caratteri</span></div><div\n ng-message=\"minlength\"><span>Deve essere lungo 16 caratteri</span></div><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div><div class=\"md-warn-fg\" ng-if=\"vm.cfvalido == 0\"><small>\nCodice Fiscale già in uso oppure non inserita. Contattare SC.</small></div></md-input-container><md-input-container \nflex><label ng-class=\"{\'md-warn-fg\': (personaNForm.telefono.$invalid)}\">Telefono</label><input type=\"text\" \nname=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\" class=\"font-size-12\" required aria-label=\"teò\">\n<div ng-messages=\"personaNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email.$invalid)}\">Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.contact.email\" placeholder=\"Email\" aria-label=\"email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\" \nrequired ng-change=\"vm.checkEmail($event)\" ng-model-options=\"{debounce: 3000}\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita. Contattare SC.</span></ng-message></div>\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email2.$invalid)}\">Email2</label><input type=\"text\" name=\"email2\" \nng-model=\"vm.contact.email2\" placeholder=\"Email2\" aria-label=\"email2\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.email2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email3.$invalid)}\">Email3</label><input type=\"text\" name=\"email3\" \nng-model=\"vm.contact.email3\" placeholder=\"Email3\" aria-label=\"email3\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.email3.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" class=\"margin-top-0\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email4.$invalid)}\">Email4 / Altro telefono</label><input type=\"text\" \nname=\"email2\" ng-model=\"vm.contact.email4\" placeholder=\"Email4\" aria-label=\"email4\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.email4.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.email5.$invalid)}\">Email5 / Altro telefono</label><input type=\"text\" \nname=\"email2\" ng-model=\"vm.contact.email5\" placeholder=\"Email5\" aria-label=\"email5\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.email5.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div></div></md-input-container><md-input-container flex><md-select-label>Studi\n</md-select-label><md-select name=\"studi\" ng-model=\"vm.contact.studi_id\" aria-label=\"studi\"><md-option \nng-repeat=\"item in vm.studis\" value=\"{{item.id}}\" ng-selected=\"item.id == vm.contact.studi_id\">\n{{item.descrizione|uppercase}}</md-option></md-select><div ng-messages=\"personaNForm.studi.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b><i class=\"icon-map-marker-radius s16\"></i> RESIDENZA</b>\n</small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Regione</md-select-label><md-select name=\"reg\" \nng-model=\"vm.contact.codRegione\" ng-change=\"vm.caricaProvince(vm.contact.codRegione)\" aria-label=\"reg\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<md-select-label>Provincia</md-select-label><md-select name=\"prov\" ng-model=\"vm.contact.codProvincia\" \nng-disabled=\"!vm.contact.codRegione\" ng-change=\"vm.caricaComuni(vm.contact.codProvincia)\" aria-label=\"pr\"><md-option \nng-repeat=\"provincia in vm.provincias\" value=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">\n{{provincia.provincia}}</md-option></md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex><md-select-label>Comune</md-select-label><md-select name=\"com\" \nng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\" aria-label=\"com\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>Indirizzo</label>\n<input type=\"text\" name=\"indirizzo\" ng-model=\"vm.contact.indirizzo\" aria-label=\"ind\" placeholder=\"Indirizzo\" \nclass=\"font-size-12\"></md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b><i \nclass=\"icon-calendar-select s16\"></i> NASCITA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-select-label>Regione</md-select-label><md-select \nname=\"reg2\" ng-model=\"vm.contact.nascita.codRegione\" ng-change=\"vm.caricaProvince2(vm.contact.nascita.codRegione)\" \naria-label=\"reg2\"><md-option ng-repeat=\"regione in vm.regiones2\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vm.contact.nascita.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex required><md-select-label>Provincia</md-select-label>\n<md-select name=\"prov2\" ng-model=\"vm.contact.nascita.codProvincia\" ng-disabled=\"!vm.contact.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.contact.nascita.codProvincia)\" aria-label=\"pr2\"><md-option \nng-repeat=\"provincia in vm.provincias2\" value=\"{{provincia.id}}\" \nng-selected=\"provincia.id == vm.contact.nascita.codProvincia\">{{provincia.provincia}}</md-option></md-select><div \nng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container><md-input-container flex><md-select-label>Comune</md-select-label><md-select \nname=\"com2\" ng-model=\"vm.contact.codComuneNascita\" ng-disabled=\"!vm.contact.nascita.codProvincia\" aria-label=\"com2\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.contact.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label>Nazione</md-select-label><md-select name=\"nazionalita\" \nng-model=\"vm.contact.codNazionalita\" aria-label=\"naz\"><md-option ng-repeat=\"naz in vm.nazionalitas\" value=\"{{naz.id}}\" \nng-selected=\"naz.id == vm.contact.codNazionalita\"><small><b>{{naz.descrizione|uppercase}}</b></small></md-option>\n</md-select></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label \nng-class=\"{\'md-warn-fg\': (personaNForm.dataNascita.$invalid)}\" flex style=\"max-height: 22px\">Data Nascita<sup>*</sup>\n</label><md-datepicker datepicker-validation-fix class=\"md-block\" name=\"dataNascita\" \nng-model=\"vm.contact.dataNascita2\" md-placeholder=\"Data di Nascita\" aria-label=\"dn\"></md-datepicker><div \nng-messages=\"personaNForm.dataNascita.$error\" role=\"alert\"><div ng-message=\"required\"><small><span class=\"md-warn-fg\">\nData nascita richiesta</span></small></div></div></div></div></div><div layout=\"row\" class=\"margin-top-16\"><span \nng-repeat=\"(key, errors) in personaNForm.$error track by $index\" flex=\"75\"><div class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></div><div ng-if=\"errors.length < 10\"><div \nclass=\"md-warn-fg\">Campi obbligatori da riempire:</div><div class=\"md-warn-fg\" layout=\"row\" ng-repeat=\"e in errors\"><b>\n{{ e.$name}}</b>,</div></div></span><small ng-if=\"!personaNForm.$invalid\" flex=\"75\">Validazione <b>OK</b></small></div>\n<div layout=\"row\" class=\"margin-top-16\"><md-button class=\"mb-button md-accent-bg\" ng-click=\"vm.saveContact();\" \nng-if=\"vm.confermaUtente == 0\" ng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" \naria-label=\"AggiornaInformazioni\"><i class=\"icon-content-save s16\"></i> AGGIORNA LE INFORMAZIONI UTENTE</md-button>\n</div></form></div></md-tab-body></div></md-tab><md-tab ng-if=\"!vm.isnew && vm.confermaUtente\"><md-tab-label \nclass=\"padding-right-4\"><span>PROFILI <span ng-class=\"{\'md-warn-bg\': vm.contact.utentes.length === 0}\" \nclass=\"text-boxed\">{{vm.contact.utentes.length}}</span></span></md-tab-label><md-tab-body><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><b>PROFILI</b> associati</md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nei profili\" type=\"text\" ng-model=\"vm.usearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container class=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th \nmd-column md-order-by=\"id\">ID</th><th md-column md-order-by=\"username\">USERNAME</th><th md-column md-order-by=\"email\">\nEMAIL</th><th md-column ng-if=\"vm.contact.utentes[0].id === vm.currentuser.id\">ACCESS TOKEN</th><th md-column>\nRUOLO/PROFILO UTENTE</th><th md-column md-order-by=\"status\">STATO</th><th md-column>GRUPPI</th><th md-column>AZIONI\n</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.contact.utentes| filter: {nome: vm.usearch} track by item.id\"><td md-cell>{{item.id}}</td><td \nclass=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>{{ item.username}}</span></div></td><td \nmd-cell><div layout=\"column\"><span><a href=\"mailto:{{item.email}}\">{{item.email}}</a></span></div></td><td md-cell \nng-if=\"vm.contact.utentes[0].id === vm.currentuser.id\">{{vm.currentuser.access_token}}</td><td md-cell><form \nname=\"roles\" novalidate><md-input-container class=\"md-block\" md-no-float><md-select ng-model=\"item.roleNames\" \nng-disabled=\"!vm.api.isAdminG\" multiple=\"multiple\" md-on-close=\"vm.changedUser = item; vm.saveRoles()\"><md-option \nng-repeat=\"roleName in vm.roleNames\" value=\"{{roleName}}\"><small><b>{{roleName}}</b></small></md-option></md-select>\n</md-input-container></form></td><td md-cell><div layout=\"column\"><md-icon class=\"icon-bookmark-outline\" \nng-class=\"{\'orange-900-fg\': item.status !== 10}\" style=\"font-size:20px;padding-right:8px\" ng-if=\"item.status !== 10\">\n</md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px;padding-right:8px\" ng-if=\"item.status == 10\">\n</md-icon></div></td><td md-cell><div ng-repeat=\"g in vm.contact.personahasusergroupvs\"><div layout=\"column\" \nng-repeat=\"item2 in vm.gruppos| filter: {id: g.group_id} : true\"><span>{{item2.gruppo|uppercase }}</span></div></div>\n</td><td md-cell style=\"text-align: right\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-if=\"(vm.api.isAdmin && item.id > 0)\"><md-button aria-label=\"crea2\" \nng-click=\"vm.openUserDialog($event, vm.contact.id)\"><md-icon md-font-icon=\"icon-pencil\" ng-if=\"(item.status !== 10)\">\n</md-icon><md-icon md-font-icon=\"icon-account-key\" ng-if=\"(item.status === 10)\"></md-icon><small><b>\nPROFILO, PASSWORD e ABILITAZIONE</b></small></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></md-table-container><div layout=\"row\"><md-button aria-label=\"crea\" \nng-click=\"vm.openRegisterDialog($event, vm.contact.id, false)\" class=\"md-blue-100-bg\" \nng-if=\"(vm.api.isAdmin && vm.contact.utentes.length == 0)\"><md-icon md-font-icon=\"icon-account-multiple-plus\">\n</md-icon><small><b>NUOVO PROFILO</b></small></md-button><md-button aria-label=\"crea2\" \nng-if=\"((!vm.api.isAdmin && vm.contact.utentes[0].id === vm.currentuser.id) || vm.api.isAdmin)\" \nng-click=\"vm.openUserDialog($event, vm.contact.id)\"><md-icon md-font-icon=\"icon-pencil\" ng-if=\"(item.status !== 10)\">\n</md-icon><md-icon md-font-icon=\"icon-account-key\" ng-if=\"(item.status === 10)\"></md-icon><small><b>CAMBIA PASSWORD</b>\n</small></md-button></div></md-card></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew && vm.confermaUtente\"><md-tab-label\n class=\"padding-right-4\"><span>RUOLI <span ng-class=\"{\'md-warn-bg\': (vm.meta.totalCount + vm.meta.totalCount) == 0}\" \nclass=\"text-boxed\">{{(vm.meta.totalCount + vm.contact.personahasentes.length)}}</span></span></md-tab-label>\n<md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\"><b>RUOLI </b>nei progetti di riferimento</md-divider>\n<div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float \nclass=\"m-0\" flex><input placeholder=\"Ricerca nei ruoli/ambiti dei progetti\" type=\"text\" ng-model=\"vm.rsearchProgetti\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"progetto_id\">NOME PROGETTO</th><th \nmd-column md-order-by=\"ruolo\">RUOLO/FUNZIONE</th><th md-column md-order-by=\"ruolo\">AMBITO</th></tr></thead><tbody \nmd-body><tr md-row ng-repeat=\"p in vm.contact.ruoli | filter: vm.rsearchProgetti\"><td md-cell><div layout=\"column\">\n<span><b>{{p.progetto.nome|uppercase|limitTo:50}}{{p.progetto.nome.length > 50 ? \"...\" : \"\" }}</b></span> <span>\n{{p.progetto.istats.comune| uppercase}} ({{p.progetto.istats.siglaAut}})</span></div></td><td md-cell \nstyle=\"white-space: nowrap\" class=\"light-blue-900-fg font-weight-600\"><div layout=\"column\">{{ p.ruolo | uppercase}}\n</div></td><td md-cell style=\"white-space: nowrap\"><div layout=\"column\"><span \nng-repeat=\"ambito in p.personahasprogetto | filter: {personaRuolo: {gruppo: \'AMBITO\'}}\">\n{{ ambito.personaRuolo.descrizione | uppercase }}</span></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.pagination[\'per-page\']\" md-limit-options=\"[1,5,10,20]\" md-page=\"vm.pagination.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-page-select=\"true\" md-boundary-links=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><b>RUOLI </b>negli enti di riferimento</md-divider><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca nei ruoli enti\" type=\"text\" ng-model=\"vm.rsearchEnti\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"id\">COD</th><th md-column \nmd-order-by=\"ruolo\">RUOLO/FUNZIONE</th><th md-column md-order-by=\"ente_id\">NOME ENTE</th></tr></thead><tbody md-body>\n<tr md-row ng-repeat=\"item in vm.contact.personahasentes| filter: {ruolo: vm.rsearchEnti} track by item.id\"><td \nmd-cell>{{item.id}}</td><td class=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>\n{{ item.ruolo | uppercase}}</span></div></td><td md-cell><div layout=\"column\" \nng-repeat=\"item2 in vm.contact.entes| filter: {id: item.ente_id}\"><span>{{item2.nome|uppercase|limitTo:50}}...</span> \n<span><b>{{item2.istat.comune| uppercase}}</b></span> <span>{{item2.istat.provincia| uppercase}}</span></div></td></tr>\n</tbody></table></md-table-container></md-card></md-tab-body></md-tab><md-tab ng-if=\"!vm.isnew && vm.confermaUtente\">\n<md-tab-label class=\"padding-right-4\"><span>PROGETTI <span ng-class=\"{\'md-warn-bg\': vm.meta.totalCount === 0}\" \nclass=\"text-boxed\">{{vm.meta.totalCount}}</span></span></md-tab-label><md-tab-body><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><b>PROGETTI TERRITORIALI</b> associati</md-divider><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.psearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container class=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th \nmd-column md-order-by=\"id\">COD</th><th md-column md-order-by=\"nome\">PROGETTO</th><th md-column \nmd-order-by=\"progetto_id\">UBICAZIONE</th><th md-column md-order-by=\"email\">RIFERIMENTI</th><th md-column>\nPERIODO RENDICONTAZIONE</th><th md-column md-order-by=\"attivo\">ATTIVO</th><th md-column>ACCESSO AL PROGETTO</th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"p in vm.contact.ruoli | filter: {progetto: {nome: vm.psearch}}\"><td \nmd-cell>{{p.progetto.codiceMinistero|uppercase}}</td><td class=\"light-blue-900-fg font-weight-600\" md-cell><div \nlayout=\"column\"><a ui-sref=\"app.sprardb_progetti_progetti_progetto({id:p.id})\">{{ p.progetto.nome | uppercase}}</a>\n</div></td><td md-cell><div layout=\"column\"><span>{{p.progetto.istats.regione|uppercase}}</span> <span>\n{{p.progetto.istats.provincia| uppercase}}</span> <span><b>{{p.progetto.istats.comune| uppercase}}</b></span></div>\n</td><td md-cell><div layout=\"column\"><span>{{p.progetto.telefono}}</span> <span>{{p.progetto.pec}}</span> <span><a \nhref=\"mailto:{{p.email}}\">{{p.progetto.email}}</a></span></div></td><td md-cell><div layout=\"column\"><span \nng-if=\"p.personaRuolo_id === 51\">{{ vm.contact.anniRendicontazione }}</span></div></td><td md-cell><div \nlayout=\"column\"><md-icon class=\"icon-bookmark-outline\" ng-class=\"{\'orange-900-fg\': p.progetto.attivo === -1}\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"p.progetto.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"p.progetto.attivo == 1\"></md-icon></div></td><td md-cell><div \nlayout=\"column\"><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px;padding-right:8px\" \nng-if=\"p.accessPermission == 0\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"p.accessPermission == 1\"></md-icon></div></td></tr></tbody></table>\n</md-table-container><div layout=\"row\"></div></md-card><md-button class=\"md-raised md-primary\" \nng-click=\"vm.openDialogProgetti()\" ng-if=\"vm.isAdmin === true\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>\nSeleziona Progetti</span></md-button><md-table-pagination md-limit=\"vm.pagination[\'per-page\']\" \nmd-limit-options=\"[1,5,10,20]\" md-page=\"vm.pagination.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearchRuolo\" md-page-select=\"true\" md-boundary-links=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-tab-body></md-tab>\n<md-tab ng-if=\"!vm.isnew && vm.confermaUtente\"><md-tab-label class=\"padding-right-4\"><span>ENTI <span \nng-class=\"{\'md-warn-bg\': vm.contact.entes.length === 0}\" class=\"text-boxed\">{{vm.contact.entes.length}}</span></span>\n</md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\"><b>ENTI</b>\n titolari, attuatori, partner e locali associati</md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" \nplaceholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.esearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container class=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th \nmd-column md-order-by=\"id\">COD</th><th md-column md-order-by=\"id\">TIPO</th><th md-column md-order-by=\"id\">RUOLO</th><th\n md-column md-order-by=\"nome\">ENTE</th><th md-column md-order-by=\"progetto_id\">UBICAZIONE</th><th md-column \nmd-order-by=\"email\">RIFERIMENTI</th><th md-column md-order-by=\"attivo\">ATTIVO</th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"item in vm.contact.personahasentes| filter: {ente: {nome: vm.esearch}} track by item.id\"><td md-cell>\n{{item.ente_id}}</td><td md-cell>{{item.ente.entetipo.descrizione|uppercase}}</td><td md-cell><div layout=\"row\"><span>\n{{ item.ruolo | uppercase}}</span></div></td><td class=\"light-blue-900-fg font-weight-600\" md-cell><div \nlayout=\"column\"><a ui-sref=\"app.sprardb_enti.dettaglio({id:item.ente.id})\">{{ item.ente.nome | uppercase}}</a></div>\n</td><td md-cell><div layout=\"column\"><span>{{item.ente.istats.regione|uppercase}}</span> <span>\n{{item.ente.istats.provincia| uppercase}}</span> <span><b>{{item.ente.istats.comune| uppercase}}</b></span></div></td>\n<td md-cell><div layout=\"column\"><span>{{item.ente.telefono}}</span> <span>{{item.ente.pec}}</span> <span><a \nhref=\"mailto:{{item.ente.email}}\">{{item.ente.email}}</a></span></div></td><td md-cell><div layout=\"column\"><md-icon \nclass=\"icon-bookmark-outline\" ng-class=\"{\'orange-900-fg\': item.attivo === -1}\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo == 1\"></md-icon></div></td></tr></tbody></table>\n</md-table-container><div layout=\"row\"></div></md-card></md-tab-body></md-tab><md-tab \nng-if=\"!vm.isnew && vm.confermaUtente\"><md-tab-label class=\"padding-right-4\"><span>Extra<span \nng-class=\"{\'md-warn-bg\': vm.contact.personaextras.length === 0}\" class=\"text-boxed\">{{vm.contact.personaextras.length}}\n</span></span></md-tab-label><md-tab-body><md-divider class=\"md-light-blue-100-bg padding-8\"><b>CAMPI EXTRA</b>\n associati alla persona</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\">\n<md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" \nng-model=\"vm.cesearch\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button></div></div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table \ndata-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"chiave\">NOME CAMPO\n</th><th md-column md-order-by=\"valore\">VALORE</th><th md-column style=\"text-align: right\">AZIONI</th></tr></thead>\n<tbody md-body><tr md-row ng-repeat=\"item in vm.contact.personaextras| filter: {valore: vm.cesearch} track by item.id\">\n<td md-cell>{{item.chiave|uppercase}}</td><td class=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\">\n<span>{{ item.valore | uppercase}}</span></div></td><td md-cell style=\"text-align: right\"><div><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"modifica\" \nng-click=\"vm.openExtraDialog($event, vm.contact, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><span>\nMODIFICA CAMPO</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table>\n</md-table-container><div layout=\"row\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openExtraDialog($event, vm.contact, null)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO CAMPO EXTRA</md-button></div></md-card></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/personas2/sidenavs/sidenav-ricerca.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchForms\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/postlogin/cancellazione-beneficiari/cancellazione-beneficiari.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\"></md-icon></md-button><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Aggiornamento dati importanti</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><form name=\"stepper\" \nclass=\"main\" ms-scroll ms-horizontal-stepper ng-submit=\"vm.finePostloginBen()\" ng-model=\"vm.stepper\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'1. Introduzione\'\">\nNelle schermata che segue visualizzerete una tabella che vi permetterà di verificare se i beneficiari contenuti in essa siano effettivamente dei beneficiari duplicati. Nel caso in cui lo fossero tramite l\'apposito tasto avrete la possibilità di cancellare il beneficiario duplicato basandovi anche sui vari corsi, servizi, trasferimenti che appartengono a quel codice specifico. Nel caso in cui si tratti di beneficiari omonimi dovrete semplicemente confermare entrambi i beneficiari.\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'2. Aggiornamento Beneficiari Duplicati\'\"><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><strong>Aggiorna beneficiari</strong></small><md-switch class=\"pl-15\" \nng-model=\"vm.confirmDialog\"><small>Mostra avvisi di conferma</small><md-tooltip>\nAttiva o disattiva gli avvisi di conferma modifiche</md-tooltip></md-switch><md-switch name=\"lavorato\" \nng-model=\"vm.lavorato\" ng-change=\"vm.onSearch()\" ng-true-value=\"1\" ng-false-value=\"0\"><small>\nMostra beneficiari lavorati</small></md-switch><div flex></div><md-button \nng-if=\"vm.user.permissions.includes(\'report-postlogin-beneficiari\')\" class=\"md-icon-button\" \nng-disabled=\"!vm.downloadButton\" ng-click=\"vm.scaricaRapporto()\" aria-label=\"scarica rapporto\"><i \nclass=\"icon-file-excel s18\" ng-class=\"{\'light-green-900-fg\': vm.downloadButton}\"></i><md-tooltip>Scarica il rapporto\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\" aria-label=\"ricarica\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table id=\"presenza\" data-md-table \nmd-progress=\"vm.models.$promise\"><thead md-head><tr md-row><th md-column><div layout=\"column\"><span>CODICE</span></div>\n</th><th md-column><div layout=\"column\"><span>COGNOME</span></div></th><th md-column><div layout=\"column\"><span>NOME\n</span></div></th><th md-column><div layout=\"column\"><span>NASCITA</span> <span>NAZIONALITA</span> <span>GENERE</span>\n</div></th><th md-column><div layout=\"column\"><span>PROGETTO</span> <span>STRUTTURA</span></div></th><th md-column>\n</th><th md-column ng-if=\"vm.lavorato == 1\">STATO</th><th md-column></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"model in vm.models.data\"><td md-cell><div layout=\"column\"><span ng-if=\"(model.b.def == 1)\">\n{{model.b.codice}}</span> <span ng-if=\"(model.b.def == 0)\">{{model.b.id}}</span> <span ng-if=\"(model.b.def == 0)\">\n<small>INCOMPLETO</small></span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ model.b.cognome | uppercase}}</td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ model.b.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span>{{model.b.dataNascita|date:\"dd/MM/yyyy\" }}\n</span> <span>{{model.b.nazionalita.descrizione}}</span> <span>{{model.b.sesso}}</span></div></td><td md-cell><div \nlayout=\"column\"><b>{{model.b.progetto.nome}}</b> <small>{{model.b.struttura.nome}}</small></div></td><td md-cell>\n<md-button class=\"md-button md-accent-bg\" ng-click=\"vm.mostraBeneficiariDuplicati($event,model)\">BENEFICIARI DUPLICATI\n</md-button></td><td md-cell><div layout=\"column\" ng-if=\"model.lavorato == 1\"><b>\n{{model.cancellato == 1 ? \"CANCELLATO\" : \"CONFERMATO\"}}</b></div></td><td md-cell><div layout=\"row\" layout-align=\"end\" \nflex ng-if=\"model.lavorato === 0\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.confermaBeneficiario(model)\">\nCONFERMA BENEFICIARIO</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancellaBeneficiario(model)\">\nCANCELLA BENEFICIARIO</md-button></div><div layout=\"row\" layout-align=\"end\" flex \nng-if=\"model.lavorato == 1 && model.cancellato == 1\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.annullaCancellazione(model)\">ANNULLA ELIMINAZIONE</md-button></div><div layout=\"row\" layout-align=\"end\" \nflex ng-if=\"model.lavorato == 1 && model.cancellato == 0\"><md-button class=\"md-raised\" \nng-click=\"vm.cancellaBeneficiario(model)\">CANCELLA BENEFICIARIO</md-button></div></td></tr></tbody></table>\n<md-table-pagination md-limit=\"vm.pagination[\'per-page\']\" md-limit-options=\"[5,10,20,50]\" md-page=\"vm.pagination.page\" \nmd-total=\"{{vm.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-table-container>\n</md-card></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'3. Fine\'\">\nCliccando sul tasto “fine” la procedura di aggiornamento beneficiari si chiuderà.<br>\nVi ricordiamo che la schermata verrà proposta ad ogni accesso fino a completamento di tutti i dati richiesti.<br>\nPer eventuali difficoltà nella compilazione è possibile contattare il referente regionale del settore “Accoglienza e Inserimenti”.\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/progetti.html","<div id=\"progetti\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/progetti/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Progetti</span></div></div></div><div class=\"content\" \nmd-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float class=\"m-0\" flex><input \nid=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Ricerca Progetti</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex><span \nclass=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar>\n<md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'enti selezionati\' : \'ente selezionato\'}} :</span><div flex></div>\n<md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'progetto\'])\"><i class=\"icon-view-list s16\"></i> TAGS SPECIFICI</md-button>\n<md-button class=\"md-button\" style=\"color: rgba(255, 255, 255, 0.87)\" \nng-click=\"vm.edittags(vm.selected, [\'generico\'])\"><i class=\"icon-flag-triangle s16\"></i> TAGS</md-button></div>\n</md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.progetti\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\" style=\"padding-right:8px\">Cod</th><th md-column style=\"padding-right:8px\">CATEG</th><th \nmd-column style=\"padding-right:8px\">E.TITOLARE</th><th md-column md-order-by=\"nome\" style=\"padding-right:8px\">PROGETTO\n</th><th md-column md-order-by=\"codComune\" style=\"padding-right:8px\"><span>CITTA/PROV</span></th><th md-column \nstyle=\"padding-right:8px\">E.GESTORE</th><th md-column md-order-by=\"email\" style=\"padding-right:8px\">RECAPITI</th><th \nmd-column style=\"padding-right:8px\" md-order-by=\"postiTotali\">POSTI</th><th md-column md-order-by=\"attivo\" \nstyle=\"padding-right:8px\">ATTIVO</th><th md-column style=\"text-align:center;padding-right:8px\">AZIONE</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"item\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" \nmd-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.progetti\" \nng-class=\"{\'md-light-blue-50-bg\': item.attivo === -1, \'md-grey-200-bg\': item.attivo === 0}\"><td md-cell \nstyle=\"padding-right:8px\">{{item.codiceMinistero}}</td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span\n ng-repeat=\"subitem in item.bandi track by $index\"><md-button \nclass=\"md-fab md-mini {{vm.colors[subitem.id]}} no-margin\" aria-label=\"tipos\" ng-if=\"$index == 0\">\n{{subitem.descrizione|limitTo: 2}}<md-tooltip><span>\n{{subitem.descrizione}} // {{subitem.dataInizio}}-{{subitem.dataFine}}</span></md-tooltip></md-button><span \nng-if=\"$index > 0\" layout=\"row\"><b>+</b>&nbsp;<small>{{subitem.descrizione}}</small></span></span></div></td><td \nmd-cell style=\"padding-right:8px\"><div layout=\"column\"><span><b>{{item.enteTitolare.nome|uppercase}}</b></span> <span>\n<small>({{item.enteTitolare.istat.provincia|uppercase}})</small></span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\"><div layout=\"column\"><span>{{ item.nome | uppercase}}</span>\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{(item.totalePostiOccupati / item.postiTotali * 100) | number:0}}\" \ntitle=\"occupati {{item.totalePostiOccupati}} su {{item.postiTotali}}\"></md-progress-linear></div></td><td md-cell \nstyle=\"padding-right:8px\"><div layout=\"column\"><b>{{item.istats.comune| uppercase}}</b> <span><small>\n({{item.istats.provincia| uppercase}})</small></span></div></td><td md-cell style=\"padding-right:8px\"><div \nlayout=\"column\"><span><b>{{item.enteGestore.nome|uppercase}}</b></span> <span><small>\n({{item.enteGestore.istat.provincia|uppercase}})</small></span></div></td><td md-cell style=\"padding-right:8px\"><div \nlayout=\"column\"><span><a title=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}...</a></span> \n<span>{{item.telefono}}</span></div></td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span layout=\"row\">\n<b>TOT: {{item.postiTotali}}</b></span> <span layout=\"row\" ng-if=\"!vm.api.isReadOnly\"><small>\nOCC: {{item.totalePostiOccupati}}</small></span></div></td><td md-cell class=\"text-center\"><div layout=\"column\">\n<md-icon class=\"icon-bookmark-outline\" ng-class=\"{\'orange-900-fg\': item.attivo === -1}\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo == 1\"></md-icon></div></td><td md-cell \nstyle=\"padding-right:4px;text-align: right\"><div><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:item.id})\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\">\n</md-icon><small><b>APRI PROGETTO</b></small></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/progetti/strutture/strutture.html","<div id=\"contacts\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/strutture/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Lista Strutture</span></div></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span class=\"small\">Indietro</span></md-button></div>\n<div flex layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{vm.selectedContacts.length}}</span> <span class=\"small\">Selezionato</span></span><md-menu class=\"select-menu\" \nng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">Select all</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\" translate=\"CONTACTS.SELECT_NONE\">Select none\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll>\n<md-list class=\"contacts-list\"><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\">\n<md-input-container md-no-float class=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" \nng-model=\"vm.search2\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.searchServerNome(vm.search2)\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-button \nng-click=\"vm.searchServerNome(vm.search)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small>\n</md-button><md-button ng-click=\"vm.allFields = !vm.allFields\"><small>Ricerca avanzata</small><md-icon \nng-if=\"!vm.allFields\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"vm.allFields\" \nmd-font-icon=\"icon-chevron-up\"></md-icon><md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata\n</md-tooltip></md-button></div></div><div layout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" \nng-if=\"vm.search2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\"></md-icon>Parola chiave: {{vm.search2| uppercase}} \n</span><span class=\"text-boxed\" ng-repeat=\"(key,ricercato) in vm.ricerca\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex \nng-if=\"vm.allFields\"><md-input-container flex><label>Tipo Accoglienza</label><md-select \nng-model=\"vm.ricerca[\'strutturaAccoglienza_id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti\n</md-option><md-option class=\"small\" ng-repeat=\"item in vm.accoglienzas\" value=\"{{item.id}}\">{{item.descrizione}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Tipo Alloggio</label><md-select \nng-model=\"vm.ricerca[\'strutturaAlloggio_id\']\" ng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option>\n<md-option ng-repeat=\"item in vm.alloggios\" value=\"{{item.id}}\">{{item.descrizione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Regione</label><md-select ng-model=\"vm.ricerca[\'istats-regione\']\" \nng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option><md-option ng-repeat=\"regione in vm.regiones\" \nvalue=\"{{regione.regione}}\">{{regione.regione}}</md-option></md-select></md-input-container><md-input-container flex>\n<label>Posti in struttura</label><md-select ng-model=\"vm.ricerca.numeroPosti\" ng-change=\"vm.searchServer();\"><md-option\n value=\"null\">Tutti</md-option><md-option value=\">1\">+1 posto</md-option><md-option value=\">5\">+5 posti</md-option>\n<md-option value=\">10\">+10 posti</md-option><md-option value=\">20\">+20 posti</md-option></md-select>\n</md-input-container><md-input-container flex><label>Attivo</label><md-select ng-model=\"vm.ricerca.attivo\" \nng-change=\"vm.searchServer();\"><md-option value=\"null\">Tutti</md-option><md-option value=\">1\">Si</md-option><md-option \nvalue=\"<0\">No</md-option></md-select></md-input-container><md-button \nng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small></md-button></div><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\">&nbsp;</span> <span class=\"secondary-text\"><span translate=\"CONTACTS.RESULTS\">Results: \n</span><span>:</span> </span><span class=\"page-info\"><span>{{vm.meta.currentPage}}</span> <span>-</span> <span>\n{{vm.meta.pageCount}}</span> <span translate=\"CONTACTS.OF\">of</span> <span>{{vm.meta.totalCount}}</span></span></div>\n<div class=\"pager\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button disabled\" \naria-label=\"previous page\" translate translate-attr-aria-label=\"CONTACTS.PREVIOUS_PAGE\" \nng-click=\"vm.pager(vm.links.prev.href)\" ng-if=\"vm.links.prev.href\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"CONTACTS.NEXT_PAGE\" ng-click=\"vm.pager(vm.links.next.href)\" ng-if=\"vm.links.next.href\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"md-blue-grey-200-bg\" \nlayout=\"row\"><div class=\"secondary-text padding-8 align-vertical-middle\" flex=\"30\"><a href=\"#\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" style=\"font-size: 18px\" \nng-click=\"vm.orderby(\'nome\', ((vm.listOrderAsc) ? \'-\' : \'\'));\"></md-icon></a><strong>NOME STRUTTURA</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"15\"><strong>INDIRIZZO</strong></div><div class=\"secondary-text padding-8\" \nflex=\"15\"><strong>COMUNE</strong></div><div class=\"secondary-text padding-8\" flex=\"15\"><strong>TIPO</strong></div><div \nclass=\"secondary-text padding-8\" flex=\"20\"><strong>ALLOGGIO</strong></div></div><md-list-item \nclass=\"contact-item md-white-bg height-120 align-with-text\" md-ink-ripple \nng-repeat=\"struttura in vm.strutture| filter:query as filteredContacts track by struttura.id\" \nng-style=\"{\'transform\': \'translate3d(0px, \' + $index * 120 + \'px, 0px)\', \'z-index\': filteredContacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\" ng-click=\"vm.gotoDettaglio(struttura.id, struttura.progetto_id)\">\n<md-checkbox ng-checked=\"vm.exists(struttura, vm.selectedContacts)\" \nng-click=\"vm.toggleSelectContact(struttura, $event)\" \naria-label=\"{{vm.exists(struttura, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}\" ng-disabled=\"!struttura.attivo\" \nstyle=\"margin-top: 16px;margin-right:4px\"></md-checkbox><div flex=\"25\" class=\"padding-top-16\"><span \nng-class=\"{\'text-strike\' : !struttura.attivo}\" class=\"secondary-text light-blue-900-fg font-weight-600 line-height-12\">\n{{ struttura.nome | uppercase}}</span><br><br><md-progress-linear flex=\"90\" md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{(struttura.beneficiarios.length / struttura.numeroPosti * 100) | number}}\"></md-progress-linear></div><div \nflex=\"15\" class=\"padding-top-16\"><span class=\"\">{{struttura.indirizzo}}</span></div><div flex=\"15\"><dl \nclass=\"text-truncate\"><dd class=\"line-height-12\"><span class=\"text-boxed text-uppercase\">{{ struttura.istats.area}}\n</span></dd><dd class=\"line-height-12\"><span class=\"text-boxed text-uppercase\">{{ struttura.istats.provincia}}</span>\n</dd><dd class=\"line-height-12\"><span class=\"text-boxed text-uppercase\">{{ struttura.istats.comune}}</span></dd></dl>\n</div><div flex=\"15\" class=\"padding-top-16\"><span class=\"text-boxed\"><small>\n{{ struttura.strutturaAccoglienzas.descrizione}}</small></span></div><div flex=\"20\" class=\"padding-top-16\"><span \nclass=\"text-boxed\"><small>{{ struttura.strutturaAlloggios.descrizione}}</small></span></div></md-list-item></md-list>\n<md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>Nessu risultato</p>\n</md-list-item></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.gotoDettaglio(0, 0)\" aria-label=\"nuova struttura\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/sprardb/postlogin/nuclei-familiari23/nuclei-familiari23.html","<div id=\"beneficiari\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\"></md-icon></md-button><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Aggiornamento dati importanti</span>\n</div></div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><form name=\"stepper\" \nclass=\"main\" ms-scroll ms-horizontal-stepper ng-submit=\"vm.finePostlogin()\" ng-model=\"vm.stepper\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'1. Introduzione\'\">\nNelle schermate che seguono visualizzerete due differenti tabelle che vi permetteranno censire in maniera agevole i beneficiari componenti di nuclei familiari e la loro presenza\\uscita dal progetto SAI.\n<br>\nNella prima tabella potrete confermare la presenza del beneficiario nel vostro progetto o eventualmente accedere al processo di uscita.\n<br>\nNella seconda tabella avrete la possibilità confermare, modificare o eliminare le informazioni relative all’eventuale nucleo familiare del beneficiario.\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'2. Aggiornamento Presenza Beneficiari\'\"><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><strong>Aggiorna beneficiari</strong></small><md-switch class=\"pl-15\" \nng-model=\"vm.presenza.confirm\"><small>Mostra avvisi di conferma</small><md-tooltip>\nAttiva o disattiva gli avvisi di conferma modifiche</md-tooltip></md-switch><div flex></div><md-button \nng-if=\"vm.user.permissions.includes(\'report-postlogin-nuclei23\')\" class=\"md-icon-button\" \nng-disabled=\"!vm.presenza.downloadButton\" ng-click=\"vm.scaricaRapporto(\'presenza\')\" aria-label=\"scarica rapporto\"><i \nclass=\"icon-file-excel s18\" ng-class=\"{\'light-green-900-fg\': vm.presenza.downloadButton}\"></i><md-tooltip>\nScarica il rapporto</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearchPresenza()\" \naria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table \nid=\"presenza\" data-md-table md-progress=\"vm.presenza.models.$promise\"><thead md-head><tr md-row><th md-column><div \nlayout=\"column\"><span>CODICE</span></div></th><th md-column><div layout=\"column\"><span>COGNOME</span></div></th><th \nmd-column><div layout=\"column\"><span>NOME</span></div></th><th md-column><div layout=\"column\"><span>NASCITA</span> \n<span>NAZIONALITA</span> <span>GENERE</span></div></th><th md-column><div layout=\"column\"><span>PROGETTO</span> <span>\nSTRUTTURA</span></div></th><th md-column></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"model in vm.presenza.models.data\"><td md-cell><div layout=\"column\"><span ng-if=\"(model.b.def == 1)\">\n{{model.b.codice}}</span> <span ng-if=\"(model.b.def == 0)\">{{model.b.id}}</span> <span ng-if=\"(model.b.def == 0)\">\n<small>INCOMPLETO</small></span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ model.b.cognome | uppercase}}</td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ model.b.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span>{{model.b.dataNascita|date:\"dd/MM/yyyy\" }}\n</span> <span>{{model.b.nazionalita.descrizione}}</span> <span>{{model.b.sesso}}</span></div></td><td md-cell><div \nlayout=\"column\"><b>{{model.b.progetto.nome}}</b> <small>{{model.b.struttura.nome}}</small></div></td><td md-cell><div \nlayout=\"row\" layout-align=\"end\" flex><md-button class=\"md-raised md-primary\" ng-click=\"vm.confermaPresenza(model)\">\nCONFERMA PRESENZA</md-button><md-button class=\"md-raised\" ng-click=\"vm.apriUscita(model)\">USCITA...</md-button></div>\n</td></tr></tbody></table><md-table-pagination md-limit=\"vm.presenza.pagination[\'per-page\']\" \nmd-limit-options=\"[5,10,20,50]\" md-page=\"vm.presenza.pagination.page\" md-total=\"{{vm.presenza.totalCount}}\" \nmd-on-paginate=\"vm.onSearchPresenza\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-table-container>\n</md-card></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" \nstep-title=\"\'3. Aggiornamento Nucleo Familiare\'\"><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><small><strong>Aggiorna beneficiari</strong></small><md-switch class=\"pl-15\" \nng-model=\"vm.nucleo.confirm\"><small>Mostra avvisi di conferma</small><md-tooltip>\nAttiva o disattiva gli avvisi di conferma modifiche</md-tooltip></md-switch><div flex></div><md-button \nng-if=\"vm.user.permissions.includes(\'report-postlogin-nuclei23\')\" class=\"md-icon-button\" \nng-disabled=\"!vm.nucleo.downloadButton\" ng-click=\"vm.scaricaRapporto(\'nucleo\')\" aria-label=\"scarica rapporto\"><i \nclass=\"icon-file-excel s18\" ng-class=\"{\'light-green-900-fg\': vm.nucleo.downloadButton}\"></i><md-tooltip>\nScarica il rapporto</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearchNucleo()\" \naria-label=\"ricarica\"><i class=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-table-container><table \nid=\"nucleo\" data-md-table md-progress=\"vm.nucleo.models.$promise\"><thead md-head><tr md-row><th md-column>CODICE</th>\n<th md-column>COGNOME</th><th md-column>NOME</th><th md-column><div layout=\"column\"><span>NASCITA</span> <span>\nNAZIONALITA</span> <span>GENERE</span></div></th><th md-column><div layout=\"column\"><span>PROGETTO</span> <span>\nSTRUTTURA</span></div></th><th md-column>STATO PARENTELA</th><th md-column>PARENTELA</th><th md-column>\nCODICE CAPOFAMIGLIA</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"model in vm.nucleo.models.data\"><td md-cell>\n<div layout=\"column\"><span ng-if=\"(model.b.def == 1)\">{{model.b.codice}}</span> <span ng-if=\"(model.b.def == 0)\">\n{{model.b.id}}</span> <span ng-if=\"(model.b.def == 0)\"><small>INCOMPLETO</small></span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ model.b.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ model.b.nome | uppercase}}</td><td md-cell><div layout=\"column\"><span>\n{{model.b.dataNascita|date:\"dd/MM/yyyy\" }}</span> <span>{{model.b.nazionalita.descrizione}}</span> <span>\n{{model.b.sesso}}</span></div></td><td md-cell><div layout=\"column\"><b>{{model.b.progetto.nome}}</b> <small>\n{{model.b.struttura.nome}}</small></div></td><td md-cell><md-input-container flex><md-select name=\"nucleoFamiliare\" \nng-model=\"model.nucleoFamiliare\" ng-change=\"model.parentela_id = null\" \nmd-selected-text=\"vm.displayNucleo(model.nucleoFamiliare)\" aria-label=\"stato parentela\" required><md-option \nng-value=\"item.codice\" ng-repeat=\"item in vm.tipNucleoFamiliare.data | filter : {id : \'!694\'}\"><div layout=\"column\"><b>\n{{item.descrizione}}</b> <small>{{item.note}}</small></div></md-option></md-select></md-input-container></td><td \nmd-cell><md-input-container flex><md-select name=\"parentela\" ng-model=\"model.parentela_id\" \nng-change=\"vm.onChangeParentela(model)\" aria-label=\"parentela\" \nmd-selected-text=\"vm.displayParentela(model.parentela_id)\" required><md-option \nng-repeat=\"item in vm.tipParentela.data | filtraparentele:[model.nucleoFamiliare]:\'id\'\" ng-value=\"item.id\"><div \nlayout=\"column\"><b>{{item.descrizione}}</b> <small>{{item.note}} <span \nng-if=\"(item.note == \'Nucleo familiare\' && model.nucleoFamiliare == 0)\">o monoparentale</span></small></div>\n</md-option></md-select></md-input-container></td><td md-cell><md-button \nng-if=\"[0,1].includes(model.nucleoFamiliare) && model.parentela_id != 674\" ng-click=\"vm.scegliCapofamiglia(model)\" \nclass=\"md-raised\" ng-class=\"{\'md-accent\': !model.b.capofamiglia}\">\n{{model.b.capofamiglia.codice || \'Scegli Capofamiglia\'}}</md-button></td><td md-cell><md-button \nng-disabled=\"!vm.valida(model)\" class=\"md-raised md-primary\" ng-click=\"vm.confermaNucleo(model)\">CONFERMA</md-button>\n</td></tr></tbody></table><md-table-pagination md-limit=\"vm.nucleo.pagination[\'per-page\']\" \nmd-limit-options=\"[5,10,20,50]\" md-page=\"vm.nucleo.pagination.page\" md-total=\"{{vm.nucleo.totalCount}}\" \nmd-on-paginate=\"vm.onSearchNucleo\" md-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-table-container>\n</md-card></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step4\" step=\"4\" step-title=\"\'4. Fine\'\">\nCliccando sul tasto “fine” la procedura di aggiornamento beneficiari si chiuderà.<br>\nVi ricordiamo che la schermata verrà proposta ad ogni accesso fino a completamento di tutti i dati richiesti.<br>\nPer eventuali difficoltà nella compilazione è possibile contattare il referente regionale del settore “Accoglienza e Inserimenti”.\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/sprardb/proroghe/dettaglio/dettaglioProroga.html","<div id=\"prorogadettaglio\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"vm.returnBeneficiari()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\" class=\"logo\"><div layout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">\nBeneficiario :&nbsp;</span> <span class=\"logo-text\"><b>{{vm.beneficiario.cognome}} {{vm.beneficiario.nome}}</b></span>\n</div></div></div><div></div></div><div class=\"content dettaglio\" ms-scroll><form name=\"personaNForm\" novalidate \nclass=\"md-background-bg\"><md-tabs md-dynamic-height><md-tab label=\"PRINCIPALE\"><div id=\"principaletab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>PROGETTO ACCOGLIENZA</b></small></md-divider><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label><b>PROGETTO</b></label><input type=\"text\" name=\"progetto_id\" \nvalue=\"{{vm.beneficiario.strutturas[(vm.beneficiario.strutturas.length - 1)].progettos.nome}}\" placeholder=\"Progetto\" \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label><b>STRUTTURA</b>\n</label><input type=\"text\" name=\"struttura_id\" \nvalue=\"{{vm.beneficiario.strutturas[(vm.beneficiario.strutturas.length - 1)].nome}}\" placeholder=\"Struttura\" \ndisabled=\"disabled\"></md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nDATI BENEFICIARIO</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex=\"50\" class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" \nname=\"cognome\" value=\"{{vm.beneficiario.cognome}}\" placeholder=\"Cognome\" required disabled=\"disabled\">\n</md-input-container><md-input-container flex=\"25\" class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" \nname=\"nome\" value=\"{{vm.beneficiario.nome}}\" placeholder=\"Nome\" required disabled=\"disabled\"></md-input-container>\n<md-input-container flex=\"25\" class=\"margin-bottom-0\"><label>Codice Vestanet</label><input type=\"text\" \nname=\"codiceVestanet\" value=\"{{vm.beneficiario.codiceVestanet}}\" placeholder=\"codice Vestanet\"></md-input-container>\n</div></div><div layout=\"row\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex class=\"margin-bottom-0\"><label>Sesso</label><input type=\"text\" name=\"sesso\" value=\"{{vm.beneficiario.sesso}}\" \nplaceholder=\"Sesso\" required disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<label>Nazionalita</label><input type=\"text\" name=\"nazionalita\" value=\"{{vm.beneficiario.nazionalita.descrizione}}\" \nplaceholder=\"Sesso\" required disabled=\"disabled\"></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\">\n<label>Data di nascita</label><input type=\"text\" name=\"dataNascita\" \nvalue=\"{{vm.beneficiario.dataNascita| date:\'dd/MM/yyyy\'}}\" placeholder=\"Data di nascita...\" disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\" \nng-repeat=\"item in vm.tipoProteziones| filter:{id:vm.beneficiario.tipoProtezione_id}\"><label>Tipo di protezione</label>\n<input type=\"text\" name=\"tipop\" value=\"{{item.descrizione}}\" placeholder=\"Tipo di protezione...\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Tipo di segnalazione\n</label><input type=\"text\" name=\"tipoSegnalazione\" value=\"{{vm.beneficiario.tipoSegnalazione}}\" \nplaceholder=\"Tipo di segnalazione\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Stato beneficiario</label><input type=\"text\" name=\"statob\" \nvalue=\"{{vm.beneficiario.stato}}\" placeholder=\"Stato beneficiario...\" required disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Data Inserimento</label><input type=\"text\" \nname=\"dataInserimento\" value=\"{{vm.beneficiario.dataInserimento|date:\'dd/MM/yyyy\'}}\" placeholder=\"Data inserimento...\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>\nData di Ingresso</label><input type=\"text\" name=\"dataIngresso\" \nvalue=\"{{(vm.beneficiario.dataIngresso)?(vm.beneficiario.dataIngresso | date:\'dd/MM/yyyy\'):\'nessuna\'}}\" \nplaceholder=\"Data ingresso...\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Data fine accoglienza</label><input type=\"text\" name=\"dataFine\" \nvalue=\"{{(vm.beneficiario.dataFine)?(vm.beneficiario.dataFine | date:\'dd/MM/yyyy\'):\'nessuna\'}}\" \nplaceholder=\"Data fine\" required disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Data uscita</label><input type=\"text\" name=\"dataUscita\" \nvalue=\"{{(vm.beneficiario.dataUscita)?(vm.beneficiario.dataUscita | date:\'dd/MM/yyyy\'):\'nessuna\'}}\" \nplaceholder=\"Data Uscita\" required disabled=\"disabled\"></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><md-input-container flex><label>Tipologia ingresso protetto</label><input type=\"text\" \nname=\"tipologia\" value=\"{{vm.beneficiario.tipologia.descrizione}}\" placeholder=\"Tipologia ingresso protetto...\" \nrequired disabled=\"disabled\"></md-input-container><md-input-container flex=\"50\" class=\"margin-bottom-0\"><label>\nReinserimento</label><md-select name=\"reinserimento\" ng-model=\"vm.beneficiario.reinserimento\" ng-disabled=\"!vm.isnew\">\n<md-option ng-value=\"1\" ng-selected=\"vm.beneficiario.reinserimento == 1\"><strong><small>Si, Reinserimento</small>\n</strong></md-option><md-option ng-value=\"0\" ng-selected=\"vm.beneficiario.reinserimento == 0\"><strong><small>No</small>\n</strong></md-option></md-select></md-input-container></div></div></md-tab><md-tab label=\"DETTAGLIO\"><div \nid=\"anagraficatab\"><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>NUCLEI, PARENTELA E NOTE</b></small>\n</md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>\nNucleo Familiare</label><md-select name=\"nucleoFamiliare\" ng-model=\"vm.beneficiario.nucleoFamiliare\" required>\n<md-option ng-repeat=\"item in ::vm.sino\" ng-value=\"item.id\" ng-selected=\"vm.beneficiario.nucleoFamiliare == item.id\">\n<strong><small>{{item.descrizione}}</small></strong></md-option></md-select><div \nng-messages=\"personaNForm.nucleoFamiliare.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div>\n</div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Parentela</label><md-select \nname=\"parentela_id\" ng-model=\"vm.beneficiario.parentela_id\" ng-disabled=\"!vm.isnew && vm.beneficiario.def == 1\" \nrequired><md-option ng-repeat=\"item in ::vm.parentelas\" ng-value=\"item.id\" \nng-selected=\"vm.beneficiario.parentela_id == item.id\"><strong><small>{{item.descrizione}}</small></strong></md-option>\n</md-select><div ng-messages=\"personaNForm.parentela_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"margin-bottom-0\">\n<label><b>Capofamiglia</b></label><input type=\"text\" name=\"capof_id\" \nng-value=\"(vm.beneficiario.capof_id == 1)?\'SI\':\'NO\';\" placeholder=\"Capofamiglia\" disabled=\"disabled\">\n</md-input-container><md-input-container flex><label>Vulnerabilita</label><md-select name=\"vulnerabilita_id\" \nplaceholder=\"Vulnerabilita...\" ng-model=\"vm.beneficiario.idVulnerabilita\"><md-option \nng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.vulnerabilita_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Tipo Ingresso</label><md-select name=\"idTipoIngresso\" \nng-model=\"vm.beneficiario.idTipoIngresso\" ng-disabled=\"!vm.isnew && vm.beneficiario.def == 1\" required><md-option \nng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\" ng-selected=\"vm.beneficiario.idTipoIngresso == item.id\"><strong>\n<small>{{item.descrizione}}</small></strong></md-option></md-select><div \nng-messages=\"personaNForm.idTipoIngresso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div>\n</div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Nazione Provenienza</label>\n<md-select name=\"provenienza\" ng-model=\"vm.beneficiario.idNazioneProvenienza\" \nng-disabled=\"!vm.isnew && vm.beneficiario.def == 1\" required><md-option ng-repeat=\"naz in vm.nazioni\" \nng-value=\"naz.id\" ng-selected=\"vm.beneficiario.idNazioneProvenienza == naz.id\"><strong><small>{{naz.descrizione}}\n</small></strong></md-option></md-select><div ng-messages=\"personaNForm.provenienza.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Note</label><textarea name=\"note\" ng-model=\"vm.beneficiario.note\" \nplaceholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\"></textarea></md-input-container><md-input-container flex>\n<label>Note Sanitarie</label><textarea name=\"noteSanitarie\" ng-model=\"vm.beneficiario.noteSanitarie\" \nplaceholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\"></textarea></md-input-container></div>\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>INFORMAZIONI FACOLTATIVE</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label>Religione</label><md-select \nname=\"religione\" ng-model=\"vm.beneficiario.idReligione\"><md-option ng-repeat=\"naz in vm.religioni\" ng-value=\"naz.id\" \nng-selected=\"vm.beneficiario.idReligione == naz.id\"><strong><small>{{naz.descrizione}}</small></strong></md-option>\n</md-select></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Gruppo Etnico</label><input \ntype=\"text\" name=\"gruppoEtnico\" ng-model=\"vm.beneficiario.gruppoEtnico\" placeholder=\"Gruppo Etnico\" \nclass=\"font-size-12\"></md-input-container></div><div layout=\"row\" flex class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.beneficiario.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\"><div ng-messages=\"personaNForm2.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email richiesta</span></div><div \nng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Telefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.beneficiario.telefono\" \nplaceholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" ng-model=\"vm.beneficiario.codiceFiscale\" \nplaceholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm2.codiceFiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n</md-tab><md-tab label=\"STATUS G\"><div id=\"statustab\"><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>\nSTATUS GIURIDICO E PROTEZIONE</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex>\n<label>Manifestazione volontà protezione internazionale</label><md-select name=\"interesseExArt\" \nplaceholder=\"Manifestazione volontà protezione internazionale\" ng-model=\"vm.beneficiario.interesseExArt\" required \nng-change=\"(vm.beneficiario.interesseExArt == 1) ? vm.beneficiario.tipoProtezione_id = 590 : vm.beneficiario.tipoProtezione_id = 0\" \ndisabled=\"disabled\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b>\n</small></md-option></md-select><div ng-messages=\"personaNForm.interesseExArt.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Manifestazione volontà</label><md-datepicker \nname=\"dataInteresseExArt\" ng-model=\"vm.beneficiario.dataInteresseExArt\" md-placeholder=\"Data Manifestazione volontà\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\" ng-disabled=\"(!vm.beneficiario.interesseExArt)\"></md-datepicker>\n</div></div><div layout=\"row\"><md-input-container flex><label>Compilazione C3</label><md-select name=\"c3\" \nplaceholder=\"Compilazione C3\" ng-model=\"vm.beneficiario.c3\" required><md-option ng-repeat=\"item in vm.sino\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.c3.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div>\n</div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData compilazione C3</label><md-datepicker name=\"dataC3\" ng-model=\"vm.beneficiario.dataC3\" \nmd-placeholder=\"Data compilazione C3\" md-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\" \nng-disabled=\"(!vm.beneficiario.c3)\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Soggiorno</label><md-select name=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" \nng-model=\"vm.beneficiario.tipoProtezione_id\" required disabled=\"disabled\"><md-option \nng-repeat=\"item in vm.tipoProteziones\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.tipoProtezione_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><div flex=\"50\" layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data richiesta protezione</label><md-datepicker \nname=\"dataRichiestaProtezione\" ng-model=\"vm.beneficiario.dataRichiestaProtezione\" \nmd-placeholder=\"Data richiesta protezione\" md-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\"></md-datepicker></div>\n</div><div layout=\"row\"><md-input-container flex><label>Provenienza</label><md-select name=\"idProvenienza\" \nplaceholder=\"Provenienza\" ng-model=\"vm.beneficiario.idProvenienza\" required><md-option \nng-repeat=\"item in vm.provenienza\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.idProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex><label>Stato Dublino</label>\n<md-select name=\"idDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.beneficiario.idDublino\" \nng-disabled=\"(vm.beneficiario.idProvenienza != 624)\" ng-required=\"(vm.beneficiario.idProvenienza == 624)\"><md-option \nng-repeat=\"item in vm.dublino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select>\n<div ng-messages=\"personaNForm.idDublino.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container></div><div layout=\"row\" flex-offset=\"50\"><div layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data richiesta Pds</label><md-datepicker \nname=\"dataRichiestaPds\" ng-model=\"vm.beneficiario.dataRichiestaPds\" md-placeholder=\"Data richiesta Pds\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.minDatesafe\"></md-datepicker></div></div><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>ULTIMO DOCUMENTO BENEFICIARIO</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex><label>Tipo di Documento</label><md-select \nname=\"idTipoDocumento\" placeholder=\"Tipo di documento...\" ng-model=\"vm.beneficiario.idTipoDocumento\" required \ndisabled=\"disabled\"><md-option ng-repeat=\"item in vm.tipoDocumento\" ng-value=\"item.id\"><small><b>{{item.descrizione}}\n</b></small></md-option></md-select><div ng-messages=\"personaNForm.idTipoDocumento.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex=\"50\">\n<label>Documento rilasciato da</label><md-select name=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" \nng-model=\"vm.beneficiario.enteDocumento_id\" required><md-option ng-repeat=\"item in vm.enteDocumentoids\" \nng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.enteDocumento_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Documento Numero\n</label><input type=\"text\" name=\"documentoNumero\" ng-model=\"vm.beneficiario.documentoNumero\" \nplaceholder=\"Inserire numero documento...\" required><div ng-messages=\"personaNForm.documentoNumero.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Rilascio documento</label><md-datepicker name=\"dataRilascioDocumento\" \nng-model=\"vm.beneficiario.dataRilascioDocumento\" md-placeholder=\"Data Rilascio Documento\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.minDatesafe\" ng-required=\"true\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Scadenza documento</label><md-datepicker \nname=\"dataScadenzaDocumento\" ng-model=\"vm.beneficiario.dataScadenzaDocumento\" md-placeholder=\"Data Scadenza Documento\" \nmd-max-date=\"vm.maxDated\" md-min-date=\"vm.beneficiario.dataRilascioDocumento\" ng-required=\"true\"></md-datepicker></div>\n</div><div layout=\"row\"><md-input-container flex><label>Cambio questura, prefettura, commissione</label><md-select \nname=\"cambioQPC\" placeholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.beneficiario.cambioQPC\"><md-option\n ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.cambioQPC.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span>\n</div></div></md-input-container><md-input-container flex><label>Note cambio questura, prefettura, commissione</label>\n<textarea name=\"noteCambioQPC\" ng-model=\"vm.beneficiario.noteCambioQPC\" \nplaceholder=\"Note cambio questura, prefettura, commissione...\" aria-label=\"Notecqpc\" rows=\"1\"></textarea>\n</md-input-container></div></div></md-tab><md-tab label=\"IDENTITA E TUTELA\" ng-if=\"vm.minori\"><div id=\"identitatab\">\n<md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>IDENTITA\' MINORE E TUTELA</b></small></md-divider><div \nlayout=\"row\" class=\"margin-top-16\"><md-input-container flex><label>Tipo Documento Identità</label><md-select \nname=\"iTipoDocumento\" placeholder=\"Tipo Documento Identità\" ng-model=\"vm.beneficiario.iTipoDocumento\" required>\n<md-option ng-repeat=\"item in vm.iTipoDocumento\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"personaNForm.iTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex><label>\nLuogo Rilascio Documento</label><md-select name=\"iLuogoDocumento\" placeholder=\"Luogo Rilascio Documento\" \nng-model=\"vm.beneficiario.iLuogoDocumento\" required><md-option ng-repeat=\"item in vm.iLuogoDocumento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"personaNForm.iLuogoDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><md-input-container flex><label>Modalità di Accertamento</label><md-select \nname=\"iModalitaAccertamento\" placeholder=\"Modalità di Accertamento\" ng-model=\"vm.beneficiario.iModalitaAccertamento\" \nrequired><md-option ng-repeat=\"item in vm.iModalitaAccertamento\" ng-value=\"item.descrizione\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.iModalitaAccertamento.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Note Accertamento età</label><textarea name=\"iNoteAccertamento\" \nng-model=\"vm.beneficiario.iNoteAccertamento\" placeholder=\"Note Accertamento età...\" aria-label=\"iNoteAccertamento\" \nrows=\"1\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nRichiesta Apertura Tutela</label><md-select name=\"iRichiestaTutela\" placeholder=\"Richiesta Apertura Tutela\" \nng-model=\"vm.beneficiario.iRichiestaTutela\" required><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small>\n<b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"personaNForm.iRichiestaTutela.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex \nlayout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Richiesta Apertura Tutela\n</label><md-datepicker name=\"iDataRichiestaTutela\" ng-model=\"vm.beneficiario.iDataRichiestaTutela\" \nmd-placeholder=\"Data Richiesta Apertura Tutela\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.minDated\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" ng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div>\n<div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Apertura Tutela\n</label><md-datepicker name=\"iDataAperturaTutela\" ng-model=\"vm.beneficiario.iDataAperturaTutela\" \nmd-placeholder=\"Data Apertura Tutela\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.beneficiario.iDataRichiestaTutela\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\" ng-required=\"vm.beneficiario.iRichiestaTutela\"></md-datepicker></div>\n</div><div layout=\"row\"><md-input-container flex><label>Cognome e Nome Tutore</label><input type=\"text\" name=\"iTutore\" \nng-model=\"vm.beneficiario.iTutore\" placeholder=\"Cognome e Nome Tutore\" required><div \nng-messages=\"personaNForm.iTutore.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto\n</span></div></div></md-input-container><md-input-container flex><label>Qualifica del Tutore</label><md-select \nname=\"iQualifica\" placeholder=\"Qualifica del Tutore\" ng-model=\"vm.beneficiario.iQualifica\" required><md-option \nng-repeat=\"item in vm.iQualifica\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"personaNForm.iQualifica.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nCognome e Nome Responsabile Struttura</label><input type=\"text\" name=\"iResponsabile\" \nng-model=\"vm.beneficiario.iResponsabile\" placeholder=\"Cognome e Nome Responsabile Struttura\" \nng-disabled=\"(vm.beneficiario.iRichiestaTutela)\"><div ng-messages=\"personaNForm.iResponsabile.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container>\n<md-input-container flex><label>Tribunale Compentente</label><input type=\"text\" name=\"iTribunale\" \nng-model=\"vm.beneficiario.iTribunale\" placeholder=\"Tribunale Compentente\" \nng-disabled=\"(!vm.beneficiario.iRichiestaTutela)\"><div ng-messages=\"personaNForm.iTribunale.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div>\n</md-tab><md-tab label=\"ULTIMA PROROGA APERTA\"><div id=\"ultimaptab\"><md-divider class=\"md-light-blue-100-bg padding-8\">\n<small><b>DATI PROROGA</b></small></md-divider><br><div layout=\"row\"><md-input-container flex><label>Stato Proroga\n</label><input type=\"text\" name=\"sproroga\" value=\"{{vm.prorogaApertaObj(vm.beneficiario).eventoStato.stato}}\" \nng-disabled=\"true\"></md-input-container><md-input-container flex><label>Data Inserimento</label><input type=\"text\" \nname=\"sproroga\" value=\"{{vm.prorogaApertaObj(vm.beneficiario).dataInserimento}}\" ng-disabled=\"true\">\n</md-input-container></div><md-divider></md-divider><br><span ng-if=\"vm.prorogaAperta(vm.beneficiario)\"><div \nlayout=\"column\" ng-repeat=\"(key, value) in vm.prorogaApertaExtra(vm.beneficiario)\"><md-input-container flex><label><b>\n{{vm.labelformat(key)}}</b></label><input ng-if=\"key.indexOf(\'relazione\') < 0\" type=\"text\" name=\"text{{key}}\" \nvalue=\"{{value}}\" placeholder=\"{{vm.labelformat(key)}}\" ng-disabled=\"true\"><textarea \nng-if=\"key.indexOf(\'relazione\') >= 0\" name=\"text{{key}}\" ng-model=\"value\" placeholder=\"{{vm.labelformat(key)}}\" \naria-label=\"{{vm.labelformat(key)}}\" rows=\"3\" ng-disabled=\"true\"></textarea></md-input-container></div></span><span \nng-if=\"!vm.prorogaAperta(vm.beneficiario)\">Non ci sono proroghe aperte. Consultare lo storico</span></div></md-tab>\n<md-tab label=\"STORICI PROROGHE\"><div id=\"storicostatustab\"><sprardb-tabellar titolo=\"Storico proroghe\" \nng-model=\"vm.beneficiario.eventoAprorogas\"></sprardb-tabellar></div></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/proroghe/dialogs/proroga.dialog.html","<md-dialog flex><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"white-space: nowrap\"><span \nng-if=\"vmd.action == \'conferma\'\">Nuova proroga per </span><span ng-if=\"vmd.action == \'approva\'\">\nApprova proroga #{{vmd.model.id}} per </span><span ng-if=\"vmd.action == \'rifiuta\'\">\nRigetta proroga #{{vmd.model.id}} per </span>\n{{vmd.beneficiario.codice}} {{vmd.beneficiario.nome}} {{vmd.beneficiario.cognome}} <span \nng-show=\"vmd.model.parenti.length\">({{vmd.beneficiario.parentela.descrizione}})</span></h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"vmd.prorogaForm\" novalidate layout=\"column\"><div \nlayout=\"row\"><md-input-container flex ng-if=\"vmd.action == \'conferma\'\"><label><b>Motivo Proroga</b></label><md-select \nng-model=\"vmd.proroga.motivoProrogaId\" required name=\"motivoProrogaId\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vmd.ricerca.motivoprorogas\">{{item.descrizione}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"vmd.action != \'conferma\'\"><label><b>Motivo Proroga</b></label><input type=\"text\" \nng-model=\"vmd.proroga.motivoProroga\" required name=\"motivoProroga\"></md-input-container><md-input-container flex>\n<label><b>Mesi Richiesti</b></label><md-select ng-model=\"vmd.proroga.mesiRichiesti\" required name=\"mesiRichiesti\">\n<md-option ng-value=\"num\" ng-repeat=\"num in vmd.mesi\">{{num}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"vmd.action == \'approva\'\"><label><b>Mesi Approvati</b></label><md-select \nng-model=\"vmd.proroga.mesiAccordati\" required name=\"mesiAccordati\"><md-option ng-value=\"num\" \nng-repeat=\"num in vmd.mesi |limitTo: vmd.proroga.mesiRichiesti\">{{num}}</md-option></md-select></md-input-container>\n</div><md-input-container flex><label><b>Relazione Sociale Servizi Offerti</b></label><textarea rows=\"3\" \nname=\"relazioneSocialeServiziOfferti\" ng-model=\"vmd.proroga.relazioneSocialeServiziOfferti\" required></textarea>\n</md-input-container><md-input-container flex><label><b>Descrizione percorso di uscita</b></label><textarea rows=\"3\" \nname=\"descrizionePercorsoUscita\" ng-model=\"vmd.proroga.descrizionePercorsoUscita\" required></textarea>\n</md-input-container><md-input-container flex ng-if=\"vmd.action == \'approva\'\"><label><b>Note conferma</b></label>\n<textarea name=\"noteConferma\" ng-model=\"vmd.proroga.noteConferma\" required></textarea></md-input-container>\n<md-input-container flex ng-if=\"vmd.action == \'rifiuta\'\"><label><b>Note rigetto</b></label><textarea \nname=\"noteRigetto\" ng-model=\"vmd.proroga.noteRigetto\" required></textarea></md-input-container><div layout=\"row\">\n<md-input-container flex><label><b>Nome Operatore</b></label><input type=\"text\" ng-model=\"vmd.proroga.nomeOperatore\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><label><b>Cognome Operatore</b></label><input \ntype=\"text\" ng-model=\"vmd.proroga.cognomeOperatore\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label><b>E-mail Operatore</b></label><input type=\"text\" \nng-model=\"vmd.proroga.emailOperatore\" readonly=\"readonly\"></md-input-container><md-input-container flex><label><b>\nTelefono Operatore</b></label><input type=\"text\" ng-model=\"vmd.proroga.telefonoOperatore\" readonly=\"readonly\">\n</md-input-container></div><div ng-if=\"vmd.model.parenti.length\"><md-divider></md-divider><h3>\nSelezionare i parenti a cui estendere <span ng-if=\"vmd.action == \'conferma\'\">questa proroga:</span> <span \nng-if=\"vmd.action == \'approva\'\">questa approvazione:</span> <span ng-if=\"vmd.action == \'rifiuta\'\">questo rigetto:\n</span></h3><table md-table><thead md-head><tr md-row><th md-column></th><th md-column \nng-if=\"vmd.action != \'conferma\'\">#</th><th md-column>CODICE</th><th md-column>NOME</th><th md-column>COGNOME</th><th \nmd-column>PARENTELA</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vmd.model.parenti\" \nng-init=\"parente = (vmd.action == \'conferma\' ? item : item.b)\"><td md-cell><md-input-container \nng-if=\"vmd.action == \'conferma\'\"><md-checkbox ng-model=\"vmd.altriBeneficiari[parente.id]\" \nng-disabled=\"!vmd.isEligible(parente)\"></md-checkbox><md-tooltip ng-if=\"!vmd.isEligible(parente)\">\nLa tipologia di soggiorno {{parente.tipoProtezione.descrizione}} non consente di richiedere proroghe. Aggiornare lo status giuridico per continuare.\n</md-tooltip></md-input-container><md-input-container ng-if=\"vmd.action != \'conferma\'\"><md-checkbox \nng-model=\"vmd.eventoIds[item.id]\"></md-checkbox></md-input-container></td><td md-cell ng-if=\"vmd.action != \'conferma\'\">\n{{item.id}}</td><td md-cell>{{parente.codice}}</td><td md-cell>{{parente.nome}}</td><td md-cell>{{parente.cognome}}\n</td><td md-cell>{{parente.parentela.descrizione}}</td></tr></tbody></table></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised md-warn\" ng-click=\"vmd.eliminaProroga()\" \nng-if=\"vmd.userCan(\'cancella-proroga\') && !vmd.isNew\">Elimina Proroga<md-tooltip>Elimina la proroga corrente\n</md-tooltip></md-button><md-button class=\"md-raised\" ng-click=\"vmd.cancelDialog()\">Annulla<md-tooltip>\nAnnulla senza salvare</md-tooltip></md-button><div ng-if=\"vmd.action == \'conferma\'\"><md-button \nng-if=\"vmd.proroga.actions.includes(\'update\')\" class=\"md-raised md-primary\" ng-click=\"vmd.salva()\" \nng-disabled=\"vmd.prorogaForm.$submitted || vmd.prorogaForm.$invalid || vmd.prorogaForm.$pristine\">Salva In Bozza\n<md-tooltip>Salva le informazioni</md-tooltip></md-button><md-button \nng-if=\"vmd.action == \'conferma\' && vmd.proroga.actions.includes(\'conferma\')\" class=\"md-raised md-accent\" \nng-click=\"vmd.lavora()\" ng-disabled=\"vmd.prorogaForm.$submitted || vmd.prorogaForm.$invalid\">Conferma e invia Richiesta\n<md-tooltip>Conferma la richiesta di proroga. Poi non saranno consentite modifiche.</md-tooltip></md-button></div>\n<md-button ng-if=\"vmd.action == \'approva\' && vmd.proroga.actions.includes(\'approva\')\" \nclass=\"md-raised md-light-green-500-bg\" ng-click=\"vmd.lavora()\" \nng-disabled=\"vmd.prorogaForm.$submitted || vmd.prorogaForm.$invalid || vmd.prorogaForm.$pristine\">CONFERMA APPROVAZIONE\n</md-button><md-button ng-if=\"vmd.action == \'rifiuta\' && vmd.proroga.actions.includes(\'rifiuta\')\" \nclass=\"md-raised md-red-900-bg md-background-fg\" ng-click=\"vmd.lavora()\" \nng-disabled=\"vmd.prorogaForm.$submitted || vmd.prorogaForm.$invalid || vmd.prorogaForm.$pristine\">CONFERMA RIGETTO\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/proroghe/dialogs/proroghe.show.html","<md-dialog flex><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"white-space: nowrap\">\nProroghe per {{vmd.beneficiario.codice}} {{vmd.beneficiario.nome}} {{vmd.beneficiario.cognome}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><table md-table><thead md-head><tr md-row><th md-column>#</th><th \nmd-column style=\"text-align:center\">STATO</th><th md-column style=\"text-align:center\">INIZIO</th><th md-column \nstyle=\"text-align:center\">FINE</th><th md-column style=\"text-align:center\">PROCESSO</th><th md-column \nstyle=\"text-align:center\">ALTRO</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vmd.beneficiario.proroghe\"><td md-cell>{{item.id}}</td><td md-cell style=\"text-align:center\">\n<md-button class=\"md-fab md-mini {{vmd.colors[item.eventoStato_id]}}\" aria-label=\"status\">\n{{item.eventoStato.stato| limitTo:2 }}<md-tooltip><b>{{item.eventoStato.stato|uppercase}}</b>\n // {{item.eventoTipo.nome}}</md-tooltip></md-button></td><td md-cell style=\"text-align:center\"><b>\n{{item.dataInizio| date: \"dd/MM/yyyy\"}}</b></td><td md-cell style=\"text-align:center\"><b>\n{{(item.eventoStato_id == 4 ? item.extra.dataConcessioneProroga : item.dataFine)| date: \"dd/MM/yyyy\"}}</b> <small \nng-if=\"(item.dataFine == null)\">NON LAVORATO</small></td><td md-cell layout=\"row\" layout-align=\"center\"><md-button \nng-if=\"item.actions.includes(\'update\')\" class=\"md-button-small md-grey-300-bg\" \nng-click=\"vmd.lavoraProroga(item, \'conferma\', $event)\" style=\"line-height: 18px\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><small>LAVORA</small></div></md-button><div layout=\"row\"><md-button \nng-if=\"item.actions.includes(\'approva\')\" class=\"md-button-small md-light-green-500-bg\" \nng-click=\"vmd.lavoraProroga(item, \'approva\', $event)\" style=\"line-height: 18px\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><small>APPROVA</small></div></md-button><md-button \nng-if=\"item.actions.includes(\'rifiuta\')\" class=\"md-button-small md-red-900-bg\" \nng-click=\"vmd.lavoraProroga(item, \'rifiuta\', $event)\" style=\"line-height: 18px\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-close md-background-fg\"></md-icon><small>RIFIUTA</small></div></md-button></div><div \nng-if=\"item.eventoStato_id > 3\"><md-button class=\"md-button-small-x2 md-grey-100-bg\" disabled=\"disabled\"><small>FINITO\n</small></md-button></div></td><td md-cell style=\"text-align:center\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-button aria-label=\"dettaglioproroga\" \nng-click=\"vmd.viewEvento($event, item, \'evento\')\" aria-label=\"dettagliopro\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\"></md-icon><small><b>DETTAGLIO PROROGA</b></small></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end\"><md-button class=\"md-raised\" ng-click=\"vmd.cancelDialog()\">CHIUDI</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/sprardb/proroghe/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/annoRend-dialog.html","<md-dialog aria-label=\"Crea nuova rendicontazione\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAnno di rendicontazione</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>Anni di rendicontazione disponibili</p><md-input-container \nclass=\"md-block\"><label>Filtra</label><input id=\"psearch\" placeholder=\"Ricerca nome progetto\" type=\"text\" \nng-model=\"vmd.pricerca\" ng-model-options=\"{debounce: 500}\"></md-input-container><md-input-container class=\"md-block\">\n<label>Scegli un anno</label><md-select ng-model=\"vmd.selected.projectId\"><md-option ng-repeat=\"item in vm.filtroanno\" \nng-value=\"item.id\">{{item.descrizione}}</md-option><div layout=\"column\"><small><b>{{ progetto.nome|uppercase}}</b>\n</small> <small ng-repeat=\"itemb in progetto.bandos\">{{itemb.descrizione}} >> {{itemb.dataFine|date:\"dd/MM/yyyy\"}}\n</small></div></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"vmd.azione(null)\" style=\"margin-right:20px\">Annulla</md-button><md-button \nng-click=\"vmd.azione(vmd.selected.projectId)\" style=\"margin-right:20px\">ASSOCIA PROGETTO</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/dialogMessaggiForm.html","<md-dialog id=\"messaggidialog\" class=\"persone-dialog\" aria-label=\"Profilo Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Messaggistica</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-width:800px;max-height:810px;min-width: 540px\" class=\"padding padding-top-8\"><form name=\"messaggiForm\" \nnovalidate><div layout=\"column\" flex><md-input-container flex><label>Messaggi precedenti</label><textarea \nng-model=\"vm.registerdata.messaggi\" md-maxlength=\"1500\" rows=\"8\" md-select-on-focus class=\"font-size-12\" \ndisabled=\"disabled\"></textarea></md-input-container><md-input-container flex class=\"margin-top-0\"><label>\nData Nuovo Messaggio</label><input type=\"text\" name=\"datamessaggio\" ng-model=\"vm.registerdata.datanuovomessaggio\" \nplaceholder=\"data Messaggio\" ng-disabled=\"true\"></md-input-container><md-input-container flex class=\"margin-top-0\">\n<label>Nuovo messaggio</label><textarea ng-model=\"vm.registerdata.nuovomessaggio\" md-maxlength=\"200\" rows=\"3\" \nmd-select-on-focus class=\"font-size-12\"></textarea></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.salvamessaggio()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"!vm.isVisitatore\" ng-disabled=\"messaggiForm.$invalid\" aria-label=\"SAVE\">\nSALVA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/project-dialog.html","<md-dialog aria-label=\"Crea nuova rendicontazione\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nGestisci rendicontazione</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>Scegli il progetto di riferimento.</p><md-input-container \nclass=\"md-block\"><label>Scegli un progetto</label><md-select ng-model=\"vmd.selected.projectId\"><small><b><md-option \nng-value=\"progetto.id\" ng-repeat=\"progetto in vmd.progetti.data\">{{ progetto.nome|uppercase}}</md-option></b></small>\n</md-select></md-input-container><md-autocomplete md-selected-item=\"vmd.selected.projectId\" \nmd-search-text=\"searchText\" md-items=\"progetto in vmd.progetti.data | filter: {nome: searchText}\" \nmd-item-text=\"progetto.nome\" ng-value=\"vmd.selected.projectId\" ng-model=\"vmd.selected.projectId\"><label>\nScegli un progetto</label><md-item-template><span md-highlight-text=\"searchText\" ng-value=\"progetto.id\">\n{{progetto.nome}}</span></md-item-template><md-not-found>Nessuna corrispondenza</md-not-found></md-autocomplete>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button ng-click=\"vmd.gestisciRendicontazione()\" \nstyle=\"margin-right:20px\">Conferma</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/project-dialog2.html","<md-dialog aria-label=\"Crea nuova rendicontazione\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nGestisci rendicontazione</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>Scegli il progetto di riferimento.</p><md-input-container \nclass=\"md-block\"><label>Filtra i progetti</label><input id=\"psearch\" placeholder=\"Ricerca nome progetto\" type=\"text\" \nng-model=\"vmd.pricerca\" ng-model-options=\"{debounce: 500}\"></md-input-container><md-input-container class=\"md-block\">\n<label>Scegli un progetto</label><md-select ng-model=\"vmd.selected.projectId\"><md-option ng-value=\"progetto.id\" \nng-repeat=\"progetto in vmd.progetti.data| filter: {nome: vmd.pricerca}\"><div layout=\"column\"><small><b>\n{{ progetto.nome|uppercase}}</b></small> <small ng-repeat=\"itemb in progetto.bandos\">\n{{itemb.descrizione}} >> {{itemb.dataFine|date:\"dd/MM/yyyy\"}}</small></div></md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vmd.azione(null)\" style=\"margin-right:20px\">Annulla</md-button><md-button \nng-click=\"vmd.azione(vmd.selected.projectId)\" style=\"margin-right:20px\">ASSOCIA PROGETTO</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/uploadFile-dialog.html","<md-dialog aria-label=\"Carica un file\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Aggiungi un file</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"100\"><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"uploadFileForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><input type=\"file\" \nfileread=\"vmd.upload.file\" required></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nTipo File</label><md-select name=\"tipoFile\" ng-model=\"vmd.upload.fileType\" required><md-option ng-value=\"codice.id\" \nng-repeat=\"codice in vmd.tipiFile\">{{ codice.tipo}}</md-option></md-select><div \nng-messages=\"uploadFileForm.tipoFile.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\" style=\"margin-right:20px\">Annulla\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-click=\"vmd.salvaFile(vmd.upload)\">Salva</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/dialogs/voceRegistroSpese-dialog.html","<md-dialog aria-label=\"Aggiungi una voce al Registro Generale delle Spese\" style=\"width: 80%\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Aggiungi una voce al Registro Generale delle Spese</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"100\"><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"voceRendicontazioneForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Numero documento</label><input type=\"text\" name=\"numeroDocumento\" \nng-model=\"vmd.datiVoceRendicontazione[3].value\" placeholder=\"Numero del documento\" ng-pattern=\"/^\\S*$/\" required><div \nng-messages=\"voceRendicontazioneForm.numeroDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span></div><div ng-message=\"pattern\"><span>\nIl numero di documento può contenere lettere, numeri e caratteri speciali, ma non gli spazi</span></div></div>\n</md-input-container><div class=\"datepicker-container\" style=\"font-size:12px;margin-left:40px\" flex><label flex \nstyle=\"max-height: 22px\">Data del documento</label><br><md-datepicker datepicker-validation-fix \nng-model=\"vmd.datiVoceRendicontazione[2].value\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"100\" \nname=\"dataDocumento\" startview=\"year\"></md-datepicker><div ng-messages=\"voceRendicontazioneForm.dataDocumento.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data del documento è obbligatoria</span>\n</div></div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nNatura del documento giustificativo</label><md-select name=\"naturaDocumento\" \nng-model=\"vmd.datiVoceRendicontazione[1].value\" required><md-option ng-value=\"naturaDocumento.id\" \nng-repeat=\"naturaDocumento in vmd.naturaDocumento\" maxlength=\"10\">{{ naturaDocumento.label}}</md-option></md-select>\n<div ng-messages=\"voceRendicontazioneForm.naturaDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><md-input-container flex><label>\nCodice spesa</label><md-select name=\"codiceSpesa\" ng-model=\"vmd.datiVoceRendicontazione[6].value\" required><md-option \nng-value=\"codice.id\" ng-repeat=\"codice in vmd.codiciSpesaPreventivo\" maxlength=\"10\">\n{{ codice.id}} - {{ codice.label | truncate:70 }}</md-option></md-select><div \nng-messages=\"voceRendicontazioneForm.codiceSpesa.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Tipo di pagamento</label><md-select name=\"tipoPagamento\" \nng-model=\"vmd.datiVoceRendicontazione[4].value\" required><md-option ng-value=\"tipopagamento.id\" \nng-repeat=\"tipopagamento in vmd.tipoPagamento\" maxlength=\"10\">{{ tipopagamento.label}}</md-option></md-select><div \nng-messages=\"voceRendicontazioneForm.tipoPagamento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><div class=\"datepicker-container\" flex \nstyle=\"font-size:12px;margin-left:40px\"><label flex style=\"max-height: 22px; margin-top:20px\">Data del pagamento\n</label><br><md-datepicker datepicker-validation-fix ng-model=\"vmd.datiVoceRendicontazione[5].value\" \nmd-placeholder=\"GG/MM/AAAA\" flex=\"50\" name=\"dataPagamento\" startview=\"year\"></md-datepicker><div \nng-messages=\"voceRendicontazioneForm.dataPagamento.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data del pagamento è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Importo totale del documento giustificativo</label><input \nng-model=\"vmd.datiVoceRendicontazione[8].value\" name=\"importoTotaleDocumento\" type=\"number\" placeholder=\"0,00\" \nlang=\"it_IT\" required><div ng-messages=\"voceRendicontazioneForm.importoTotaleDocumento.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è obbligatorio</span> {{error}}</div></div></md-input-container>\n<md-input-container flex><label>Importo cofinanziato</label><input name=\"importoCofinanziato\" \nng-model=\"vmd.datiVoceRendicontazione[9].value\" type=\"number\" placeholder=\"0,00\" lang=\"it_IT\" required><div \nng-messages=\"voceRendicontazioneForm.importoCofinanziato.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span></div></div></md-input-container><md-input-container flex><label>Importo finanziato\n</label><input name=\"importoFinanziato\" ng-model=\"vmd.datiVoceRendicontazione[10].value\" type=\"number\" \nplaceholder=\"0,00\" lang=\"it_IT\" required><div ng-messages=\"voceRendicontazioneForm.importoFinanziato.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è obbligatorio</span></div></div></md-input-container>\n<md-input-container flex><label>Importo imputato al progetto</label><input name=\"importoImputatoProgetto\" \nng-model=\"vmd.datiVoceRendicontazione[11].value\" type=\"number\" placeholder=\"0,00\" lang=\"it_IT\" required><div \nng-messages=\"voceRendicontazioneForm.importoImputatoProgetto.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Descrizione registrazione</label><input type=\"text\" name=\"descrizioneRegistrazione\" \nng-model=\"vmd.datiVoceRendicontazione[7].value\" placeholder=\"Descrizione registrazione\" required><div \nng-messages=\"voceRendicontazioneForm.descrizioneRegistrazione.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><md-input-container flex><label>\nSpesa attiva in modulo rendicontazione</label><md-select name=\"attiva\" \nng-model=\"vmd.datiVoceRendicontazione[12].value\" required><md-option ng-value=\"1\">Attiva</md-option><md-option \nng-value=\"0\">Non attiva</md-option></md-select><div ng-messages=\"voceRendicontazioneForm.attiva.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>E\' indispensabile inserire questo campo.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-checkbox \nng-if=\"vm.datiRendicontazione.anno === 2020\" ng-model=\"vmd.datiVoceRendicontazione[13].value\" \naria-label=\"Proroga tecnica\" name=\"prorogaTecnica\" ng-true-value=\"1\" ng-false-value=\"0\"><small>\nSpesa in regime di proroga tecnica</small></md-checkbox><div ng-messages=\"voceRendicontazioneForm.attiva.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>E\' indispensabile inserire questo campo.</span></div></div>\n</md-input-container><md-input-container flex><label>Programma</label><md-select name=\"attiva\" \nng-model=\"vmd.datiVoceRendicontazione[14].value\" required><md-option ng-value=\"0\">Standard</md-option><md-option \nng-value=\"1\">Isaf</md-option><md-option ng-value=\"2\">Reinsediamento</md-option><md-option ng-value=\"3\">Fami</md-option>\n</md-select><div ng-messages=\"voceRendicontazioneForm.attiva.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\" style=\"margin-right:20px\">Annulla\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"voceRendicontazioneForm.$invalid || voceRendicontazioneForm.$pristine || (vmd.datiVoceRendicontazione[8].value < ((vmd.datiVoceRendicontazione[9].value + vmd.datiVoceRendicontazione[10].value) | number : 2))\" \nng-click=\"vmd.salvaVoceRendicontazione()\">Salva</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/progetto/progetto.html","<div id=\"rendicontazioneProgetto\" class=\"rendicontazioni page-layout simple right-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Stato della Rendicontazione</span></div>\n</div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" \nng-show=\"vm.progetto\" ms-scroll><div class=\"md-title mb-32\">{{vm.progetto.nome}}</div><div \nclass=\"simple-table-container md-whiteframe-2dp\"><table class=\"simple font-size-14\"><tr><td class=\"text-right\"><strong>\nRegione</strong></td><td>{{vm.progetto.istats.regione}}</td><td class=\"text-right\"><strong>Provincia</strong></td><td>\n{{vm.progetto.istats.provincia}}</td><td class=\"text-right\"><strong>Comune</strong></td><td>\n{{vm.progetto.istats.comune}}</td><td class=\"text-right\"><strong>Area</strong></td><td>{{vm.progetto.istats.area}}</td>\n</tr></table></div><md-divider></md-divider><div layout=\"row\" class=\"margin-top-16 padding-16 text-italic md-warn-bg\" \nng-if=\"!vm.checkParametriRendicontazione()\">\nOccorre impostare i parametri della rendicontazione per questo progetto oppure selezionare l\'anno di riferimento</div>\n<h3>Seleziona l\'anno di rendicontazione per i nuovi documenti:<md-input-container flex width=\"50%\"><md-select \nname=\"annoSelect\" ng-model=\"vm.asd\" ng-change=\"vm.cambiaAnnoSetup()\"><md-option ng-repeat=\"item in vm.progetto.pprs\" \nng-value=\"item.anno\">{{item.anno}}</md-option></md-select></md-input-container></h3><div layout=\"row\" \nclass=\"margin-top-16 layout-row\" ng-if=\"vm.checkParametriRendicontazione()\"><button \nclass=\"md-button md-ink-ripple md-default-theme\" type=\"button\" ng-disabled=\"vm.disableBtnNuovoPreventivo()\" \naria-label=\"Nuovo Preventivo\" \nui-sref=\"app.sprardb_rendicontazioni_rendicontazione({projectId: vm.progetto.id, tipoRendicontazione: 1, annoCorrente: vm.anno_attuale})\">\n<md-icon md-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Nuovo preventivo</span></button> <button \nclass=\"md-button md-ink-ripple md-default-theme\" type=\"button\" ng-disabled=\"vm.disableBtnNuovoSAL()\" \nui-sref=\"app.sprardb_rendicontazioni_rendicontazione({projectId: vm.progetto.id, tipoRendicontazione: 4, annoCorrente: vm.anno_attuale, annoCorrente: vm.anno_attuale})\" \naria-label=\"Nuovo SAL\"><md-icon md-font-icon=\"icon-library-plus\" \nclass=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" aria-hidden=\"true\"></md-icon><span \nclass=\"ng-scope\">NUOVO SAL</span></button> <button class=\"md-button md-ink-ripple md-default-theme\" type=\"button\" \nng-disabled=\"vm.disableBtnNuovaRimodulazione()\" \nui-sref=\"app.sprardb_rendicontazioni_rendicontazione({projectId: vm.progetto.id, tipoRendicontazione: 2, annoCorrente: vm.anno_attuale})\" \naria-label=\"Nuova rimodulazione\"><md-icon md-font-icon=\"icon-library-plus\" \nclass=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" aria-hidden=\"true\"></md-icon><span \nclass=\"ng-scope\">Nuova rimodulazione</span></button> <button class=\"md-button md-ink-ripple md-default-theme\" \ntype=\"button\" ng-disabled=\"vm.disableBtnNuovaRendicontazione()\" aria-label=\"Nuova Rendicontazione Consuntiva\" \nui-sref=\"app.sprardb_rendicontazioni_rendicontazione({projectId: vm.progetto.id, tipoRendicontazione: 3, annoCorrente: vm.anno_attuale})\" \nng-if=\"vm.anno_attuale != 2017\"><md-icon md-font-icon=\"icon-library-plus\" \nclass=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" aria-hidden=\"true\"></md-icon><span \nclass=\"ng-scope\">Nuova rendicontazione</span></button></div><md-divider></md-divider><br><div \nclass=\"simple-table-container md-whiteframe-2dp\"><div class=\"table-title\">Documenti finanziari per questo progetto\n</div><div layout=\"row\" class=\"padding-16\"><md-input-container flex><label>Filtro generale</label><input type=\"text\" \nname=\"filtrogenerale\" ng-model=\"vm.filtrogenerale\"></md-input-container></div><div class=\"ms-responsive-table-wrapper\">\n<table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>TIPO</b></th><th><b>ANNO</b></th><th><b>STATO</b></th>\n<th><b>AZIONI</b></th></tr></thead><tfoot></tfoot><tbody><tr \nng-repeat=\"rendicontazione in vm.progetto.progettorendicontaziones| filter: vm.filtrogenerale\"><td>&nbsp;&nbsp;&nbsp;\n<b><a>{{rendicontazione.progettoRendicontazioneTipo_id| filterTipo:(vm.rendicontazioniTipi)|uppercase }}</a></b></td>\n<td>{{rendicontazione.anno}}</td><td>\n{{rendicontazione.progettoRendicontazioneStato_id| filterTipo:(vm.rendicontazioniStati)|uppercase }}</td><td><section \nlayout=\"row\" layout-sm=\"column\" layout-wrap><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"dettaglio\" ng-click=\"vm.gotoRendicontazione(rendicontazione.id);\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>MOD >></md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-if=\"rendicontazione.progettoRendicontazioneTipo_id != 4 && rendicontazione.progettoRendicontazioneTipo_id != 3\" \nng-click=\"vm.downloadPdf($event, rendicontazione)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>PDF >></md-button>\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-if=\"rendicontazione.progettoRendicontazioneTipo_id == 3 && rendicontazione.anno > 2017\" \nng-click=\"vm.downloadPdf($event, rendicontazione)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>PDF >></md-button>\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-if=\"rendicontazione.progettoRendicontazioneTipo_id == 4\" ng-click=\"vm.downloadPdfSAL($event, rendicontazione)\">\n<md-icon md-font-icon=\"icon-file-pdf\"></md-icon>PDF >></md-button></section></td></tr></tbody></table></div></div>\n</div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazione/rendicontazione.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Rendicontazione</span></div></div></div>\n<div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-show=\"vm.allLoaded\" ng-if=\"vm.tipoRendicontazione < 3\"><form \nname=\"rendicontazioneForm\" novalidate><div class=\"table-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b> per {{vm.progetto.nome}}\n<md-button class=\"md-accent\" aria-label=\"Vai\" ui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">\nVAI AL PROGETTO {{vm.progetto.nome}}</md-button></div><div class=\"table-title\" \nng-if=\"vm.nuovaRendicontazione == false\"><b>\nModifica documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b>\n per {{vm.datiRendicontazione.progettos.nome}} - anno {{vm.datiRendicontazione.anno}} <small>\n({{vm.datiRendicontazione.dataInizioPeriodo | date: \'dd/MM/yyyy\'}} - {{vm.datiRendicontazione.dataFinePeriodo | date: \'dd/MM/yyyy\'}})\n</small><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button><br><small class=\"ng-binding\">{{vm.bandoString}}\n</small></div><md-input-container class=\"md-default-theme\" ng-if=\"(vm.nuovaRendicontazione == true)\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(1);\" \nonclick=\"this.disabled = true\"><md-tooltip md-direction=\"top\">Inizializzazione del documento di rimodulazione\n</md-tooltip>Attiva il documento</md-button></md-input-container><div layout=\"row\" flex style=\"padding: 8px 24px\" \nng-if=\"vm.nuovaRendicontazione == false\" ng-show=\"vm.allLoaded\" class=\"grey-100-bg\"><span flex><strong>Codice:</strong>\n <small>{{vm.datiRendicontazione.codiceProgetto}}</small></span> <span flex><strong>Tipo</strong>: <small>\n{{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</small></span> <span flex><strong>Identificativo\n</strong>: <small>{{vm.datiRendicontazione.id}}</small></span> <span flex><strong>Stato:</strong> <small>\n{{vm.datiRendicontazione.progettoRendicontazioneStato_id| filterTipo:vm.rendicontazioniStati }} <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 3 && vm.datiRendicontazione.timePrimaValidazione\">\nil {{vm.datiRendicontazione.timePrimaValidazione }}</span></small></span></div><div \nng-show=\"(vm.nuovaRendicontazione == false)\" id=\"prorogaprosecuzione\" \nng-if=\"((vm.datiRendicontazione.progettoRendicontazioneTipo_id != 4) &&\n               (vm.datiRendicontazione.progettoRendicontazioneTipo_id != 1) &&\n                (vm.datiRendicontazione.anno != 2020 || vm.isAdmin)\n               )\">\n<h3 flex layout=\"row\" style=\"padding: 8px 24px\">\nCliccare su entrambe le voci &nbsp;SOLO SE NEL {{vm.datiRendicontazione.anno}} l\'ente locale ha fatto ricorso alla proroga prima della prosecuzione (nuovo affidamento). Altrimenti scegliere proroga tecnica o prosecuzione, secondo il caso che vi riguarda.\n</h3><div flex layout=\"row\" style=\"padding: 8px 24px\"><md-checkbox ng-model=\"vm.datiRendicontazione.prorogaTecnica\" \naria-label=\"Proroga tecnica\" name=\"prorogaTecnica\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in proroga tecnica</small>\n</md-checkbox><md-checkbox ng-model=\"vm.datiRendicontazione.prosecuzione\" aria-label=\"Proroga tecnica\" \nname=\"prosecuzione\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in prosecuzione</small>\n</md-checkbox></div><div layout=\"row\" style=\"padding: 8px 24px\"><h3 \nng-if=\"((vm.datiRendicontazione.prorogaTecnica == 1) && (vm.datiRendicontazione.prosecuzione == 1))\">\nAttenzione! La selezione di entrambe le opzioni (proroga tecnica + prosecuzione) conduce ad un processo in cui il sistema non è in grado di segnalarvi eventuali errori di calcolo.\n<br>Il documento può essere salvato in bozza più volte.<br>\nPer la trasmissione è necessario cliccare su \"valida e invia\".</h3></div></div><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\" \nng-show=\"(vm.nuovaRendicontazione == false)\"><thead><tr><th><b>COD.</b></th><th><b>DESCRIZIONE SPESA</b></th><th \nclass=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>CONTRIBUTO RICHIESTO</b></th><th \nclass=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th><th class=\"text-center\"><b>ERRORI</b></th></tr></thead><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id != \'Ci\') && (item.id != \'SAL\')\"><td><b>{{item.id}}_TOTALE</b></td><td><b>\n{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'totale\'] | currency}}</b>\n</td><td class=\"text-center\"><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td>\n</tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id != \'Ci\') && (item.id != \'SAL\')\"><td>\n{{subitem.id}}</td><td>{{subitem.label}}</td><td class=\"text-right\" \nng-repeat=\"subsubitem in subitem.fields| limitTo:2\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"15\" lang=\"it_IT\" type=\"number\" required> € \n</span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</td><td><i \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2) && (vm.nuovaRendicontazione == false)\" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"></i> <span class=\"font-size-10\" \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2) && (vm.nuovaRendicontazione == false)\">\n<br><mark>tot. prec. {{ vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</mark> </span></td>\n<td><i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}\n</md-tooltip></i></td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\">&nbsp;</td></tr><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" \nclass=\"md-blue-grey-200-bg\" ng-if=\"(item.id != \'TOTALE\') && (item.id == \'Ci\')\"><td><b>{{item.id}}_TOTALE</b></td><td>\n<b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'totale\'] | currency}}</b>\n</td><td class=\"text-center\"><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td>\n</tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'Ci\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"15\" lang=\"it_IT\" \ntype=\"number\" required> € </span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input \ntype=\"text\" style=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</td><td><i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}\n</md-tooltip></i><i \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2) && (vm.nuovaRendicontazione == false)\" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"></i> <span class=\"font-size-10\" \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2) && (vm.nuovaRendicontazione == false)\">\n<br><mark>tot. prec. {{ vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</mark> </span></td>\n</tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td \nclass=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\"><i \nng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i\n ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i\n ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td></tr>\n</tbody></table></div><div \nng-if=\"vm.tipoRendicontazione == 2 && (vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore) && !vm.nuovaRendicontazione\">\n<div layout=\"row\" class=\"margin-top-16 layout-row\"><h2>Carica qui la documentazione</h2></div><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><sprardb-uploaddocuments5 ng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments5>\n<md-button></md-button></div></div><div class=\"ms-responsive-table-wrapper\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id === 3)\"><table class=\"simple\" ms-responsive-table=\"\">\n<thead><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-right\">&nbsp;</th><th class=\"text-right\">&nbsp;</th><th \nclass=\"text-right\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr></thead><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'SAL\')\"><td><b>SAL</b></td><td>&nbsp;</td><td class=\"text-right\">&nbsp;\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td><td class=\"text-center\">&nbsp;</td></tr><tr \nng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'SAL\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input style=\"width: 100%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[0].value\" \nsize=\"15\" lang=\"it_IT\" ng-disabled=\"vm.validasal > 0\" required data-blur-currency></span></div></td><td><div \nclass=\"datepicker-container\" flex><label flex>Data del sal</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[1].value\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataSAL\" startview=\"year\" ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=\"vm.validasal > 0\">\n</md-datepicker><div ng-messages=\"voceRendicontazioneForm.dataPagamento.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data del sal è obbligatoria</span></div></div></div></td><td \nclass=\"text-right\"><md-input-container class=\"md-default-theme\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" ng-if=\"!vm.isVisitatore\" ng-disabled=\"vm.validasal > 0\" ng-click=\"vm.saveRendicontazione(3);\">\n<md-tooltip md-direction=\"top\">Stato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>\nAggiungi il sal</md-button></md-input-container></td><td><span style=\"text-align:center\" ng-if=\"vm.validasal > 0\" flex>\n<i class=\"icon-bookmark-check\"></i><br>il SAL è stato già trasmesso</span></td></tr></tbody></table><div \nclass=\"ms-responsive-table-wrapper\"></div></div><div ng-if=\"vm.checkErrors()\" \nclass=\"red-600-fg padding-top-16 padding-left-16\" ng-show=\"(vm.nuovaRendicontazione == false)\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti</b></div><div \nng-show=\"(vm.nuovaRendicontazione == false)\" layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\">\n<md-input-container class=\"md-default-theme\" ng-if=\"(vm.isallowed([10, 5, 4, 3]))\"><md-button type=\"button\" \nclass=\"md-raised md-primary\" aria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(1);\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.nuovaRendicontazione)\"><md-tooltip \nmd-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5]))\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"(vm.isallowed([3, 4]))\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\" ng-click=\"vm.saveRendicontazione(1);\">\n<md-tooltip md-direction=\"top\">Riapertura in stato bozza operata da amministratori SC</md-tooltip>Riapri in bozza\n</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4])) && (vm.tipoRendicontazione != 1)\"><md-input-container class=\"md-default-theme\" \nng-if=\"vm.nuovaRendicontazione == false\"></md-input-container><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></md-input-container></div></form></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-show=\"vm.allLoaded\" ng-if=\"vm.tipoRendicontazione == 4\"><form \nname=\"rendicontazioneForm\" novalidate><div class=\"table-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b> per {{vm.progetto.nome}}\n<md-button class=\"md-accent\" aria-label=\"Vai\" ui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">\nVAI AL PROGETTO {{vm.progetto.nome}}</md-button></div><div class=\"table-title\" \nng-if=\"vm.nuovaRendicontazione == false\"><b>\nModifica documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b>\n per {{vm.datiRendicontazione.progettos.nome}} - anno {{vm.datiRendicontazione.anno}} <small>\n({{vm.datiRendicontazione.dataInizioPeriodo | date: \'dd/MM/yyyy\'}} - {{vm.datiRendicontazione.dataFinePeriodo | date: \'dd/MM/yyyy\'}})\n</small><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button><br><small class=\"ng-binding\">{{vm.bandoString}}\n</small></div><div layout=\"row\" flex style=\"padding: 8px 24px\" ng-if=\"vm.nuovaRendicontazione == false\" \nng-show=\"vm.allLoaded\" class=\"grey-100-bg\"><span flex><strong>Codice:</strong> <small>\n{{vm.datiRendicontazione.codiceProgetto}}</small></span> <span flex><strong>Tipo</strong>: <small>\n{{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</small></span> <span flex><strong>Identificativo\n</strong>: <small>{{vm.datiRendicontazione.id}}</small></span> <span flex><strong>Stato:</strong> <small>\n{{vm.datiRendicontazione.progettoRendicontazioneStato_id| filterTipo:vm.rendicontazioniStati }} <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 3 && vm.datiRendicontazione.timePrimaValidazione\">\nil {{vm.datiRendicontazione.timePrimaValidazione }} (formato data aaaa-mm-gg)</span></small></span></div><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>&nbsp;</th><th>&nbsp;\n</th><th colspan=\"3\" class=\"text-right\">PIANO FINANZIARIO</th><th colspan=\"3\" class=\"text-right\">SPESE IMPEGNATE</th>\n<th colspan=\"3\" class=\"text-right\">di cui QUIETANZATE</th><th class=\"text-right\">&nbsp;</th><th class=\"text-right\">\n&nbsp;</th></tr><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-center\">A</th><th class=\"text-center\">B</th><th \nclass=\"text-center\">C</th><th class=\"text-center\">D</th><th class=\"text-center\">E</th><th class=\"text-center\">F</th><th\n class=\"text-center\">G</th><th class=\"text-center\">H</th><th class=\"text-center\">I</th><th class=\"text-center\">&nbsp;\n</th><th class=\"text-center\">&nbsp;</th></tr><tr><th><b>COD.</b></th><th><b>DESCRIZIONE<br>SPESA</b></th><th \nclass=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th><th class=\"text-center\"><b>CONTRIBUTO<br>RICHIESTO</b></th><th \nclass=\"text-center\"><b>TOTALE</b></th><th class=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th><th \nclass=\"text-center\"><b>CONTRIBUTO<br>RICHIESTO</b></th><th class=\"text-center\"><b>TOTALE</b></th><th \nclass=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th><th class=\"text-center\"><b>CONTRIBUTO<br>RICHIESTO</b></th><th \nclass=\"text-center\"><b>TOTALE</b></th><th class=\"text-center\">AV. %<br>IMPEGNI<br>(F/C)</th><th class=\"text-center\">\nAV. %<br>SPESA<br>(I/C)</th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" \nclass=\"md-blue-grey-200-bg\" ng-if=\"(item.id != \'TOTALE\') && (item.id != \'Ci\') && (item.id != \'SAL\')\"><td><b>\n{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</b></td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'])))* 100 | number:2}}%\n</td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'])))* 100 | number:2}}%\n</td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id != \'Ci\') && (item.id != \'SAL\')\"><td>\n{{subitem.id}}</td><td>{{subitem.label}}</td><td class=\"text-right\" \nng-repeat=\"subsubitem in subitem.fields| limitTo:2\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"15\" lang=\"it_IT\" type=\"number\" required> € \n</span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"15\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2:4\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"15\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']))) * 100 | number:2}}%\n</td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']))) * 100 | number:2}}%\n</td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-center\">\n{{ ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'])) * 100 | number:2}}%\n</td><td class=\"text-center\">\n{{ ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'])) * 100 | number:2}}%\n</td></tr><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'Ci\')\"><td><b>{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</b></td><td class=\"text-center\">\n{{ ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'])) * 100 | number:2}}%\n</td><td class=\"text-center\">\n{{ ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'])) * 100 | number:2}}%\n</td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'Ci\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"15\" lang=\"it_IT\" \ntype=\"number\" required> € </span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input \ntype=\"text\" style=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"15\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2:4\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"15\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']))) * 100 | number:2}}%\n</td><td class=\"text-center\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']))) * 100 | number:2}}%\n</td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td \nclass=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-center\">\n{{((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoImpegnato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoImpegnato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'])) * 100 | number:2}}%\n</td><td class=\"text-center\">\n{{((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoQuietanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoQuietanziato\'])) / ((vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\']) + (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'])) * 100 | number:2}}%\n</td></tr></tbody></table></div><div class=\"ms-responsive-table-wrapper\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id === 3)\"><table class=\"simple\" ms-responsive-table=\"\">\n<thead><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-right\">&nbsp;</th><th class=\"text-right\">&nbsp;</th><th \nclass=\"text-right\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr></thead><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'SAL\')\"><td><b>SAL</b></td><td>&nbsp;</td><td class=\"text-right\">&nbsp;\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td><td class=\"text-center\">&nbsp;</td></tr><tr \nng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'SAL\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input style=\"width: 100%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[0].value\" \nsize=\"15\" lang=\"it_IT\" ng-disabled=\"vm.validasal > 0\" required data-blur-currency></span></div></td><td><div \nclass=\"datepicker-container\" flex><label flex>Data del sal</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[1].value\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataSAL\" startview=\"year\" ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=\"vm.validasal > 0\">\n</md-datepicker><div ng-messages=\"voceRendicontazioneForm.dataPagamento.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data del sal è obbligatoria</span></div></div></div></td><td \nclass=\"text-right\"><md-input-container class=\"md-default-theme\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" ng-disabled=\"vm.validasal > 0\" ng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Aggiungi il sal</md-button>\n</md-input-container></td><td><span style=\"text-align:center\" ng-if=\"vm.validasal > 0\" flex><i \nclass=\"icon-bookmark-check\"></i><br>il SAL è stato già trasmesso</span></td></tr></tbody></table><div \nclass=\"ms-responsive-table-wrapper\"></div></div><div ng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti</b></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5]))\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"(vm.isallowed([10, 5, 4, 3]))\"><md-button \ntype=\"button\" class=\"md-raised md-primary\" aria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(1);\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.nuovaRendicontazione)\"><md-tooltip \nmd-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4]))\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\" ng-click=\"vm.saveRendicontazione(1);\">\n<md-tooltip md-direction=\"top\">Riapertura in stato bozza operata da amministratori SC</md-tooltip>Riapri in bozza\n</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4])) && (vm.tipoRendicontazione != 1)\"><md-input-container class=\"md-default-theme\" \nng-if=\"vm.nuovaRendicontazione == false\"></md-input-container><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></md-input-container></div></form></div><div \nng-if=\"((vm.tipoRendicontazione == 3 && vm.datiRendicontazione.anno != 2017) || vm.tipoRendicontazione == 5)\" \nng-show=\"vm.allLoaded\"><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di Rendicontazione Finale</b> per {{vm.progetto.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">VAI AL PROGETTO {{vm.progetto.nome}}</md-button>\n</div><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione == false\"><b><span \nng-if=\"vm.datiRendicontazione.rendicontazioneFinale_id == null\">Modifica documento di Rendicontazione Finale <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id == 5\">(INTEGRAZIONE)</span> </span><span \nng-if=\"vm.datiRendicontazione.rendicontazioneFinale_id != null\">\nCaricamento giornaliero rapido del registro delle spese </span></b>\nper {{vm.datiRendicontazione.progettos.nome}} {{vm.datiRendicontazione.anno}}<md-button class=\"md-accent\" \naria-label=\"Vai\" ui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\n</md-button></div><div layout=\"row\" ng-if=\"vm.datiRendicontazione.timePrimaValidazione\"><b><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 1\">Stato attuale Bozza, prima validazione il </span>\n<span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id >= 3\">Validato in data </span>\n{{vm.datiRendicontazione.timePrimaValidazione }} (formato data aaaa-mm-gg)</b></div><md-divider></md-divider><br>\n<md-input-container class=\"md-default-theme\" ng-if=\"(vm.nuovaRendicontazione == true && vm.tipoRendicontazione != 5)\">\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(1);\" \nonclick=\"this.disabled = true\"><md-tooltip md-direction=\"top\">Inizializzazione del processo di rendicontazione finale\n</md-tooltip>Attiva nuova rendicontazione</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.nuovaRendicontazione == true && vm.tipoRendicontazione == 5)\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.confermaIntegrazione()\" onclick=\"this.disabled = true\">\n<md-tooltip md-direction=\"top\">Inizializzazione del processo di integrazione dei documenti</md-tooltip>\nConferma l\'apertura della pratica di integrazione</md-button></md-input-container><form name=\"stepper\" \nms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-show=\"(vm.nuovaRendicontazione == false)\" \nng-model=\"vm.stepper\" novalidate><ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"vm.datiRendicontazione.rendicontazioneFinale_id != null ? \'Registro generale temporaneo per caricamento giornaliero\' : \'Registro Generale delle Spese\'\">\n<div ng-if=\"vm.datiRimodulazione\"><div id=\"prorogaprosecuzione\" \nng-if=\"((vm.datiRendicontazione.progettoRendicontazioneTipo_id != 4) &&\n			   (vm.datiRendicontazione.progettoRendicontazioneTipo_id != 1) && vm.rimodulazione == true && vm.finale &&\n			   (vm.datiRendicontazione.anno != 2020 || vm.isAdmin)\n			   )\">\n<h3 flex layout=\"row\" style=\"padding: 8px 24px\">\nCliccare su entrambe le voci &nbsp;SOLO SE NEL {{vm.datiRendicontazione.anno}} l\'ente locale ha fatto ricorso alla proroga prima della prosecuzione (nuovo affidamento). Altrimenti scegliere proroga tecnica o prosecuzione, secondo il caso che vi riguarda.\n<br>\nLo status di proroga tecnica e prosecuzione dovrebbe corrispondere a quanto dichiarato nel documento di rimodulazione.\n</h3><div flex layout=\"row\" style=\"padding: 8px 24px\"><md-checkbox ng-model=\"vm.datiRendicontazione.prorogaTecnica\" \naria-label=\"Proroga tecnica\" name=\"prorogaTecnica\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in proroga tecnica</small>\n</md-checkbox><md-checkbox ng-model=\"vm.datiRendicontazione.prosecuzione\" aria-label=\"Proroga tecnica\" \nname=\"prosecuzione\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in prosecuzione</small>\n</md-checkbox></div><span flex layout=\"row\" style=\"padding: 8px 24px; background-color:#CCCCCC\" \nng-if=\"vm.datiRimodulazione.prosecuzione !== vm.datiRendicontazione.prosecuzione || vm.datiRimodulazione.prorogaTecnica !== vm.datiRendicontazione.prorogaTecnica\">\nAttenzione! E’ stata scelta un’opzione diversa da quella indicata in sede di rimodulazione. E’ necessario provvedere alla modifica per poter proseguire.\n<div style=\"float:left; width:100%; text-align:center; font-weight:bold\" \nng-if=\"vm.datiRimodulazione.prorogaTecnica == 1\">Proroga tecnica in rimodulazione: SI<br><md-icon \nmd-font-icon=\"icon-check\" style=\"color:green\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prorogaTecnica != 1\">\nProroga tecnica in rimodulazione: NO<br><md-icon md-font-icon=\"icon-close\" style=\"color:red\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prosecuzione == 1\">\nProsecuzione in rimodulazione: SI<br><md-icon md-font-icon=\"icon-check\" style=\"color:green\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prosecuzione != 1\">\nProsecuzione in rimodulazione: NO<br><md-icon md-font-icon=\"icon-close\" style=\"color:red\"></md-icon></div></span>\n<md-input-container class=\"md-default-theme\" ng-if=\"(vm.isallowed([10, 5, 4, 3]))\"><md-button type=\"button\" \nclass=\"md-raised md-primary\" aria-label=\"Salva\" \nng-if=\"vm.datiRimodulazione.prosecuzione !== vm.datiRendicontazione.prosecuzione || vm.datiRimodulazione.prorogaTecnica !== vm.datiRendicontazione.prorogaTecnica\" \nng-click=\"vm.saveStatus();\"><md-tooltip md-direction=\"top\">\nAggiorna soltanto lo stato del progetto seguendo i valori indicati in spunta.</md-tooltip>Aggiorna lo status\n</md-button></md-input-container></div></div><h2 \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5 && vm.datiRendicontazione.rendicontazioneFinale_id == null\">\nRegistro Generale delle Spese</h2><h2 \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5 && vm.datiRendicontazione.rendicontazioneFinale_id != null\">\nRegistro generale temporaneo per caricamento giornaliero</h2><div layout=\"row\" \nng-if=\"vm.datiRendicontazione.rendicontazioneFinale_id != null\"><p>\nQuesto è un documento di registro delle spese temporaneo in cui è possibile caricare documenti e voci di spesa in modalità rapida. Ogni giorno alle 3:00 del mattino le voci di spesa ed i documenti caricati saranno riversati nel registro delle spese ufficiale, e la presente pagina sarà automaticamente svuotata.\n<br><br>\nSi raccomanda di prestare la massima attenzione al fatto che se le registrazioni saranno inserite nello stesso giorno della validazione non ci sarà il tempo materiale perché possano essere salvate nel documento ufficiale trasmesso al Servizio centrale.\n<br>\nNon utilizzare questa modalità di inserimento a ridosso della scadenza per la trasmissione della rendicontazione finale, considerando che il sistema allinea i dati solo alle 3 del mattino.\n<br>\nUna volta validata e inviata la rendicontazione finale, il registro temporaneo verrà automaticamente disattivato e non sarà possibile recuperare alcun dato inserito nello stesso.\n<br><br><b>Guarda il tutorial <a href=\"https://www.youtube.com/watch?v=UHBgd9-K6cg&feature=youtu.be\" target=\"_blank\">\nqui</a></b></p></div><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3 && vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5) && !vm.isReadOnly\">\n<button ng-click=\"vm.openVoceRegistroSpeseDialog(vm.jsonModel.items.item, 0)\" \nclass=\"md-button md-accent md-raised md-ink-ripple md-default-theme\" type=\"button\" aria-label=\"Nuova rimodulazione\">\n<md-icon md-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Aggiungi voce di spesa</span></button></div><div layout=\"row\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\"><md-input-container flex><label>Filtro generale\n</label><input type=\"text\" name=\"numeroDocumento\" ng-model=\"vm.filtroGenerale\"></md-input-container></div><div>\n<md-table-container ng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\"><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head \nmd-on-reorder=\"vm.registroSpeseOrdina\" md-order=\"vm.registroSpesePaginazione.sort\"><tr md-row><th md-column \nmd-order-by=\"progressivo\"><b>Cod</b></th><th md-column md-order-by=\"numeroDocumento\"><b>Num. del doc.</b></th><th \nmd-column md-order-by=\"dataDocumento\"><b>Data del doc.</b></th><th md-column md-order-by=\"codiceSpesa\"><b>Codice spesa\n</b></th><th md-column md-order-by=\"dataPagamento\"><b>Data del pag.</b></th><th md-column \nmd-order-by=\"importoTotaleDocumento\"><b>Imp. Totale</b></th><th md-column><b>Imp. Cofin.</b></th><th md-column><b>\nImp. Fin.</b></th><th md-column><b>Imputato Prog.</b></th><th md-column><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 3\">Azioni</span></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"segnalato\" md-select-id=\"segnalato\" ng-disabled=\"true\" x-md-auto-select=\"vm.options.autoSelect\" \nng-if=\"item.progressivo != 0\" \nng-repeat=\"item in vm.datiRendicontazioneItems| filter: {value:vm.filtroGenerale} | orderBy: vm.registroSpesePaginazione.sort\">\n<td md-cell ng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.progressivo}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.numeroDocumento}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.dataDocumento| date:\"dd/MM/yyyy\"}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item.codiceSpesa}}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item.dataPagamento| date:\"dd/MM/yyyy\"}}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.importoTotaleDocumento| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.importoCofinanziato| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item.importoFinanziato| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item.importoImputatoProgetto| currency}}</b></td><td md-cell \nstyle=\"text-align: center\"><md-menu ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 3\"><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore)\">\n</md-icon></md-button><md-menu-content width=\"20\" ng-style=\"{\'height\':\'200\'}\"><div \nng-style=\"{\'overflow\':\'scroll\',\'height\':\'inherit\'}\"><md-menu-item \nng-init=\"params = {documentoTipo_id: 0, gruppo: \'RENDICONTAZIONE\', dettaglio: false, dettagliomin: (item.progressivo != 0?true:false), entita: \'rendicontazione\', entitakey: \'progettoRendicontazione_id\', entitakey2: \'progettoRendicontazioneProgressivo_id\', entita_id: vm.datiRendicontazione.id, entita2_id: item.progressivo, progettoRendicontazione_id: vm.datiRendicontazione.id, progettoRendicontazioneProgressivo_id: item.progressivo, progettoRendicontazioneVoceSpesa: item.codiceSpesa, aggiorna:0, progettoRendicontazioneStato_id:vm.datiRendicontazione.progettoRendicontazioneStato_id}\">\n<sprardb-uploaddocuments5 ng-model=\"params\"></sprardb-uploaddocuments5></md-menu-item></div><div class=\"row\">\n<md-menu-item class=\"\"><md-button class=\"md-accent md-button-icon\" ng-click=\"vm.openVoceRegistroSpeseDialog(item, 1)\" \naria-label=\"Modifica\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>MOD >></md-button><md-button \nclass=\"md-button-icon md-primary\" aria-label=\"Elimina\" ng-click=\"vm.deleteVoceRegistroSpeseDialog(item)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon>ELIMINA</md-button></md-menu-item></div></md-menu-content></md-menu></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"vm.registroSpesePaginazione.pagination\" \nmd-limit-options=\"vm.registroSpesePaginazione.limitOptions\" md-page=\"vm.registroSpesePaginazione.page\" \nmd-total=\"{{vm.registroSpesePaginazione.meta.totalCount}}\" md-on-paginate=\"vm.registroSpesePagina\" \nmd-page-select=\"vm.registroSpesePaginazione.options.pageSelect\" \nmd-boundary-links=\"vm.registroSpesePaginazione.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination><div layout=\"row\" \nclass=\"margin-top-16 layout-row\" \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore) && !vm.nuovaRendicontazione\">\n<h2>Carica qui la documentazione</h2></div><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore || vm.api.isVisitatore || vm.api.isTutor) && !vm.nuovaRendicontazione\">\n<sprardb-uploaddocuments5 ng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments5><md-button></md-button></div>\n</div></ms-horizontal-stepper-step><span ng-if=\"vm.finale\"><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Prospetto di Rendicontazione Finale\'\"><h2 ng-if=\"vm.tipoRendicontazione == 5\">\nIl prospetto di rendicontazione in dettaglio è disponibile nella pratica principale</h2><span \nng-if=\"vm.tipoRendicontazione != 5\"><h2>Prospetto di Rendicontazione Finale</h2><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th><th><b>\nDESCRIZIONE SPESA</b></th><th class=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>\nCONTRIBUTO RICHIESTO</b></th><th class=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th><th class=\"text-center\"><b>ERRORI\n</b></th></tr></thead><tfoot><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency:\'€\'}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency:\'€\'}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\">&nbsp;</td></tr><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency:\'€\':2}}\n<br>\n{{((vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\']) / (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\'])) * 100 | number: 2}}% sul totale\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency:\'€\':2}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\'] | currency:\'€\':2}}\n</td><td class=\"text-right\"><i \nng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_percCofinanziamento\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_percCofinanziamento\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip>\n</i><i ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip>\n</i><i ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip>\n</i><i ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i></td></tr>\n</tfoot><tbody><tr ng-repeat-start=\"item in vm.datiRendicontazioneRecap.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"item.id != \'TOTALE\'\"><td><b>{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) | currency:\'€\'}} </b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency:\'€\'}} </b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'totale\'] | currency:\'€\'}} </b></td><td \nclass=\"text-center\"><i ng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i>\n<i \nng-if=\"vm.datiRendicontazione.anno !== 2020 && ((vm.totaliPrecedenti[item.id][\'importi\'][\'totale\']) < (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 3)\" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\nATTENZIONE È POSSIBILE SFORARE UNA SOLA VOCE fra L, B, G, S, T, I, ENTRO IL 10% - LE VOCI P, A e Ci rientrano fra quelle non sforabili in assoluto.\n</md-tooltip></i><i \nng-if=\"vm.datiRendicontazione.anno === 2020 && vm.tipoRendicontazione === 3 && item.id !== \'P\' &&\n                            ((vm.totaliPrecedenti[item.id][\'importi\'][\'totale\']) < (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'totale\']))\n                        \" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\nATTENZIONE ad eccezione della voce P, le altre macro voci possono essere «sforate in eccesso» entro il limite massimo del 10% rispetto a quanto indicato in rimodulazione\n</md-tooltip></i><i \nng-if=\"vm.datiRendicontazione.anno !== 2020 && vm.tipoRendicontazione === 3 && item.id === \'I\' &&\n                        (((vm.totaleIPFPcontributo / vm.datiRendicontazione.pprs.costoComplessivo)*(vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\']))> contributoRichiestoVoceI)\n                        \" \nstyle=\"color:#ff6600\" class=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip \nmd-direction=\"top\">\nAttenzione. Non è stata rispettata la percentuale prevista nel PFP sulla macrovoce I. L’importo residuo non potrà essere trasferito in nessun’altra voce di spesa\n</md-tooltip></i><i \nng-if=\"vm.datiRendicontazione.anno === 2020 && vm.tipoRendicontazione === 2 && item.id === \'I\' &&\n                        vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'I\'][\'importi\'][\'contributoRichiesto\'] >= vm.datiRendicontazione.pprs.costoComplessivo * 0.07\n                        \" \nstyle=\"color:#ff6600\" class=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip \nmd-direction=\"top\">\nATTENZIONE. Le risorse previste per la voce I e non utilizzate possono essere impiegate solo per spese direttamente collegate all’emergenza COVID-19 e trasferite, in particolare, nelle voci P, L3, L4, L5, B, A\n</md-tooltip></i><i \nng-if=\"vm.datiRendicontazione.anno === 2020 && vm.tipoRendicontazione === 3 && item.id === \'I\' &&\n                        vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'I\'][\'importi\'][\'contributoRichiesto\'] >= vm.totaleIRimodulazione\n                        \" \nstyle=\"color:#ff6600\" class=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip \nmd-direction=\"top\">\nATTENZIONE: le economie generate alla voce I possono essere utilizzate solo per spese direttamente collegate all’emergenza COVID-19\n</md-tooltip></i></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields| limitTo:2\">\n{{subsubitem.value| currency}}</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][subitem.id][\'importi\'][\'totale\']) | currency}}</td><td>\n<i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}\n</md-tooltip></i></td></tr></tbody></table></div></span></ms-horizontal-stepper-step></span><span \nng-if=\"((vm.datiRendicontazione.progettoRendicontazioneStato_id >= 3) || vm.isallowed([3])) && vm.finale\">\n<ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Status e conferma\'\"><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><h1>\nConferma di inoltro finale</h1>\nIl bilancio consuntivo finale è stato inoltrato con tutti gli allegati al Servizio Centrale <span \nng-if=\"vm.datiRendicontazione.timePrimaValidazione\">\nin data {{vm.datiRendicontazione.timePrimaValidazione }} (formato data aaaa-mm-gg)</span>\n. Verrà presto verificato da un operatore. Il codice di riferimento da usare per eventuali comunicazioni è il seguente:\n<h2>PR-{{vm.datiRendicontazione.progetto_id}}/{{vm.datiRendicontazione.id}}/{{vm.datiRendicontazione.anno}}</h2></span>\n<span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3\"><h1>Status della rendicontazione</h1>\nLa rendicontazione finale è in preparazione o in attesa di chiusura e approvazione da parte dell\'amministratore di progetto. \n</span><span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><h1>Status della rendicontazione</h1>\nUn\'integrazione dei documenti è stata richiesta dal servizio centrale. Usare lo step successivo per caricare i file integrativi\n</span></div></ms-horizontal-stepper-step></span><span \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore || vm.api.isTutor|| vm.api.isVisitatore) && vm.finale\">\n<ms-horizontal-stepper-step ng-form=\"step4\" step=\"4\" step-title=\"\'Riepilogo documenti e integrazioni\'\"><div \nlayout=\"row\" class=\"margin-top-16 layout-row\" ng-if=\"!vm.nuovaRendicontazione\"><sprardb-uploaddocuments5 \nng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments5><md-button></md-button></div></ms-horizontal-stepper-step>\n</span></form><div ng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti. Verifica il Prospetto di Rendicontazione Finale.\n</b></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container \nclass=\"md-default-theme\" ng-if=\"(vm.isallowed([3, 4, 5])) && vm.finale\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2) || vm.nuovaRendicontazione == true\" \nng-click=\"vm.saveRendicontazione(3);\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4])) && vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5 && vm.datiRendicontazione.progettoRendicontazioneTipo_id !== undefined && vm.finale\">\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 1\" ng-click=\"vm.saveRendicontazione(1);\">\n<md-tooltip md-direction=\"top\">Riapertura in stato bozza operata da amministratori SC</md-tooltip>Riapri in bozza\n</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([10, 5, 4, 3]))&& vm.finale\"><md-button type=\"button\" class=\"md-raised md-primary\" \naria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(1);\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.nuovaRendicontazione)\" \nng-disabled=\"vm.nuovaRendicontazione == true\"><md-tooltip md-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3)\" ng-click=\"vm.saveRendicontazione(3);\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Chiusura integrazione</md-tooltip>\nINTEGRAZIONE TERMINATA</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 7])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Riapertura per integrazione\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3)\" ng-click=\"vm.saveRendicontazione(3);\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Riapertura per integrazione\n</md-tooltip>APRI PRATICA DI INTEGRAZIONE</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(((vm.isallowed([3, 4, 5, 7])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 4) || vm.datiRendicontazione.progettoRendicontazioneTipo_id == 5) && !vm.isVisitatore\">\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.mostramessaggi();\"><md-icon \nmd-font-icon=\"icon-message\"></md-icon><md-tooltip md-direction=\"top\">Mostra i messaggi</md-tooltip>MESSAGGI</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"vm.nuovaRendicontazione == false\"><md-button \nclass=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button>\n</md-input-container></div></div><div ng-if=\"vm.tipoRendicontazione == 3 && vm.datiRendicontazione.anno == 2017\" \nng-show=\"vm.allLoaded\"><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di Rendicontazione Finale</b> per {{vm.progetto.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">VAI AL PROGETTO {{vm.progetto.nome}}</md-button>\n</div><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione == false\"><b>Modifica documento di Rendicontazione Finale\n</b> per {{vm.datiRendicontazione.progettos.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></div><md-divider></md-divider><br><form \nname=\"stepper\" ms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate><span>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Status e conferma\'\"><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3 || vm.datiRendicontazione.progettoRendicontazioneStato_id == 5\">\n<h1>Conferma di inoltro finale</h1>\nLa Rendicontazione Finale relativa all\'annualità {{vm.datiRendicontazione.anno}} è stata inoltrata al Servizio Centrale. Verrà verificata da un operatore.\n<br>Il codice di riferimento da usare per eventuali comunicazioni è il seguente:<h2>\nPR-{{vm.datiRendicontazione.codiceProgetto}}-{{vm.datiRendicontazione.id}}-{{vm.datiRendicontazione.anno}}</h2></span>\n<span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3\"><h1>Status della rendicontazione</h1>\nLa rendicontazione finale è in preparazione o in attesa di chiusura e approvazione da parte dell\'amministratore di progetto. \n</span><span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><h1>\nCaricamento dei documenti di rendicontazione</h1>\nLa rendicontazione per l\'anno 2017 prevede il caricamento dei file dei documenti giustificativi di spesa.<br>\nUsare lo step successivo per caricare i file integrativi, avendo cura di classificarli nelle macrovoci di spesa corrispondenti o nella categoria appropriata.\n<br>Al termine del caricamento cliccare sul pulsante \"Valida e invia\".<br>\nAttenzione! L\'operazione sottometterà al Servizio Centrale tutta la documentazione e gli allegati non saranno modificabili fino ad eventuale riapertura della pratica da parte di un operatore del Servizio Centrale.\n<br>Controllare attentamente i file prima dell\'inoltro.<br>\nSarà sempre possibile entrare ed uscire dalla bozza, fino ad inoltro definitivo.</span></div>\n</ms-horizontal-stepper-step></span><span \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore|| vm.api.isTutor|| vm.api.isVisitatore)\">\n<ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Riepilogo documenti e integrazioni\'\"><h3><i \nclass=\"icon-alert s18 md-warn-fg\"></i> Gentile utente, durante il caricamento del file <strong>\nattendere il completamento del processo</strong> e la visualizzazione del messaggio di avvenuto caricamento.<br>\nAl termine <strong>controllare l\'esattezza del file caricato</strong>\n, effettuando un download e la decompressione dello stesso.<br>Vi ricordiamo che la <strong>\ndimensione massima stabilita</strong> per ciascun file è di <strong>32Mb</strong>.<br><br>\nVi ringraziamo per la collaborazione.</h3><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-show=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore|| vm.api.isTutor|| vm.api.isVisitatore)\">\n<sprardb-uploaddocuments5 ng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments5><md-button></md-button></div>\n</ms-horizontal-stepper-step></span></form><div ng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti. Verifica il Prospetto di Rendicontazione Finale.\n</b></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container \nclass=\"md-default-theme\" ng-if=\"(vm.isallowed([3, 4]))\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" ng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"(vm.isallowed([3, 4]))\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 1\" ng-click=\"vm.saveRendicontazione(1);\">\n<md-tooltip md-direction=\"top\">Riapertura in stato bozza operata da amministratori SC</md-tooltip>Riapri in bozza\n</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5])) && ((vm.datiRendicontazione.progettoRendicontazioneStato_id == 4) || (vm.datiRendicontazione.progettoRendicontazioneStato_id == 1))\">\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.saveRendicontazione(5);\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Chiusura integrazione</md-tooltip>\nINTEGRAZIONE TERMINATA</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 7])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 5\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Riapertura per integrazione\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id !=5)\" ng-click=\"vm.saveRendicontazione(3);\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Riapertura per integrazione\n</md-tooltip>APRI PRATICA DI INTEGRAZIONE</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"((vm.isallowed([3, 4, 5, 7])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 4) || vm.datiRendicontazione.progettoRendicontazioneTipo_id == 5\">\n<md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.mostramessaggi();\" ng-if=\"!vm.isVisitatore\"><md-icon \nmd-font-icon=\"icon-message\"></md-icon><md-tooltip md-direction=\"top\">Mostra i messaggi</md-tooltip>MESSAGGI</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"vm.nuovaRendicontazione == false\"><md-button \nclass=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button>\n</md-input-container></div></div><br><br><br></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazione/rendicontazionenontransitoria.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Rendicontazione</span></div></div></div>\n<div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-show=\"vm.allLoaded\" ng-if=\"vm.tipoRendicontazione < 3\"><form \nname=\"rendicontazioneForm\" novalidate><div class=\"table-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b> per {{vm.progetto.nome}}\n<md-button class=\"md-accent\" aria-label=\"Vai\" ui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">\nVAI AL PROGETTO {{vm.progetto.nome}}</md-button></div><div class=\"table-title\" \nng-if=\"vm.nuovaRendicontazione == false\"><b>\nModifica documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b>\n per {{vm.datiRendicontazione.progettos.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button><br><small class=\"ng-binding\">{{vm.bandoString}}\n</small></div><div layout=\"row\" flex style=\"padding: 8px 24px\" ng-if=\"vm.nuovaRendicontazione == false\" \nng-show=\"vm.allLoaded\" class=\"grey-100-bg\"><span flex><strong>Codice:</strong> <small>\n{{vm.datiRendicontazione.codiceProgetto}}</small></span> <span flex></span> <span flex><strong>Tipo</strong>: <small>\n{{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</small></span> <span flex></span> <span flex>\n<strong>Identificativo</strong>: <small>{{vm.datiRendicontazione.id}}</small></span> <span flex></span> <span flex>\n<strong>Stato:</strong> <small>\n{{vm.datiRendicontazione.progettoRendicontazioneStato_id| filterTipo:(vm.rendicontazioniStati) }}</small></span></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th>\n<th><b>DESCRIZIONE SPESA</b></th><th class=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>\nCONTRIBUTO RICHIESTO</b></th><th class=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th><th class=\"text-center\"><b>ERRORI\n</b></th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id != \'Ci\') && (item.id != \'SAL\')\"><td><b>{{item.id}}_TOTALE</b></td><td><b>\n{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'totale\'] | currency}}</b>\n</td><td class=\"text-center\"><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td>\n</tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id != \'Ci\') && (item.id != \'SAL\')\"><td>\n{{subitem.id}}</td><td>{{subitem.label}}</td><td class=\"text-right\" \nng-repeat=\"subsubitem in subitem.fields | limitTo:2\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"10\" lang=\"it_IT\" type=\"number\" required> € \n</span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</td><td><i \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2)\" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"></i> <span class=\"font-size-10\" \nng-if=\"((vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\']) != (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 2)\">\n<br><mark>tot. prec. {{ vm.totaliPrecedenti[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</mark> </span></td>\n<td><i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}\n</md-tooltip></i></td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\">&nbsp;</td></tr><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" \nclass=\"md-blue-grey-200-bg\" ng-if=\"(item.id != \'TOTALE\') && (item.id == \'Ci\')\"><td><b>{{item.id}}_TOTALE</b></td><td>\n<b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'totale\'] | currency}}</b>\n</td><td class=\"text-center\"><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td>\n</tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'Ci\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"10\" lang=\"it_IT\" \ntype=\"number\" required> € </span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input \ntype=\"text\" style=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'totale\'] | currency}}</td><td><i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}\n</md-tooltip></i></td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>\nTOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\"><i \nng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i\n ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i><i\n ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazione.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazione.jsonData)}}</md-tooltip></i></td></tr>\n</tbody></table></div><div class=\"ms-responsive-table-wrapper\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id === 3)\"><table class=\"simple\" ms-responsive-table=\"\">\n<thead><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-right\">&nbsp;</th><th class=\"text-right\">&nbsp;</th><th \nclass=\"text-right\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr></thead><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'SAL\')\"><td><b>SAL</b></td><td>&nbsp;</td><td class=\"text-right\">&nbsp;\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td><td class=\"text-center\">&nbsp;</td></tr><tr \nng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'SAL\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input style=\"width: 100%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[0].value\" \nsize=\"10\" lang=\"it_IT\" ng-disabled=\"vm.validasal > 0\" required data-blur-currency></span></div></td><td><div \nclass=\"datepicker-container\" flex><label flex>Data del sal</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[1].value\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataSAL\" startview=\"year\" ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=\"vm.validasal > 0\">\n</md-datepicker><div ng-messages=\"voceRendicontazioneForm.dataPagamento.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data del sal è obbligatoria</span></div></div></div></td><td \nclass=\"text-right\"><md-input-container class=\"md-default-theme\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" ng-disabled=\"vm.validasal > 0\" ng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Aggiungi il sal</md-button>\n</md-input-container></td><td><span style=\"text-align:center\" ng-if=\"vm.validasal > 0\" flex><i \nclass=\"icon-bookmark-check\"></i><br>il SAL è stato già trasmesso</span></td></tr></tbody></table><div \nclass=\"ms-responsive-table-wrapper\"></div></div><div ng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti</b></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([10,5,4,3]))\"><md-button type=\"button\" class=\"md-raised md-primary\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid\" ng-click=\"vm.saveRendicontazione(1);\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.nuovaRendicontazione)\"><md-tooltip \nmd-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5]))\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4])) && (vm.tipoRendicontazione != 1)\"><md-input-container class=\"md-default-theme\" \nng-if=\"vm.nuovaRendicontazione == false\"></md-input-container><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></md-input-container></div></form></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-show=\"vm.allLoaded\" ng-if=\"vm.tipoRendicontazione == 4\"><form \nname=\"rendicontazioneForm\" novalidate><div class=\"table-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b> per {{vm.progetto.nome}}\n<md-button class=\"md-accent\" aria-label=\"Vai\" ui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">\nVAI AL PROGETTO {{vm.progetto.nome}}</md-button></div><div class=\"table-title\" \nng-if=\"vm.nuovaRendicontazione == false\"><b>\nModifica documento di {{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</b>\n per {{vm.datiRendicontazione.progettos.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button><br><small class=\"ng-binding\">{{vm.bandoString}}\n</small></div><div layout=\"row\" flex style=\"padding: 8px 24px\" ng-if=\"vm.nuovaRendicontazione == false\" \nng-show=\"vm.allLoaded\" class=\"grey-100-bg\"><span flex><strong>Codice:</strong> <small>\n{{vm.datiRendicontazione.codiceProgetto}}</small></span> <span flex></span> <span flex><strong>Tipo</strong>: <small>\n{{ vm.tipoRendicontazione | filterTipo:(vm.rendicontazioniTipi) }}</small></span> <span flex></span> <span flex>\n<strong>Identificativo</strong>: <small>{{vm.datiRendicontazione.id}}</small></span> <span flex></span> <span flex>\n<strong>Stato:</strong> <small>\n{{vm.datiRendicontazione.progettoRendicontazioneStato_id| filterTipo:(vm.rendicontazioniStati) }}</small></span></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>&nbsp;</th><th>\n&nbsp;</th><th colspan=\"3\" class=\"text-right\">PIANO FINANZIARIO</th><th colspan=\"3\" class=\"text-right\">SPESE IMPEGNATE\n</th><th colspan=\"3\" class=\"text-right\">di cui QUIETANZATE</th><th class=\"text-right\">&nbsp;</th><th \nclass=\"text-right\">&nbsp;</th></tr><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-center\">A</th><th \nclass=\"text-center\">B</th><th class=\"text-center\">C</th><th class=\"text-center\">D</th><th class=\"text-center\">E</th><th\n class=\"text-center\">F</th><th class=\"text-center\">G</th><th class=\"text-center\">H</th><th class=\"text-center\">I</th>\n<th class=\"text-center\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr><tr><th><b>COD.</b></th><th><b>DESCRIZIONE\n<br>SPESA</b></th><th class=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th><th class=\"text-center\"><b>CONTRIBUTO<br>\nRICHIESTO</b></th><th class=\"text-center\"><b>TOTALE</b></th><th class=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th>\n<th class=\"text-center\"><b>CONTRIBUTO<br>RICHIESTO</b></th><th class=\"text-center\"><b>TOTALE</b></th><th \nclass=\"text-center\"><b>IMPORTO<br>COFINANZIATO</b></th><th class=\"text-center\"><b>CONTRIBUTO<br>RICHIESTO</b></th><th \nclass=\"text-center\"><b>TOTALE</b></th><th class=\"text-center\">AV. %<br>IMPEGNI<br>(F/C)</th><th class=\"text-center\">\nAV. %<br>SPESA<br>(I/C)</th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" \nclass=\"md-blue-grey-200-bg\" ng-if=\"(item.id != \'TOTALE\') && (item.id != \'Ci\') && (item.id != \'SAL\')\"><td><b>\n{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</b></td><td class=\"text-right\"></td><td class=\"text-right\"></td></tr><tr ng-repeat-end=\"\" \nng-repeat=\"subitem in item.items\" ng-if=\"(item.id != \'Ci\') && (item.id != \'SAL\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"10\" lang=\"it_IT\" \ntype=\"number\" required> €</span></div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"10\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2:4\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"10\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-right\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']))/((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\'])))*100 | number:2}}%\n</td><td>\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\']))/((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\'])))*100 | number:2}}%\n</td><td>&nbsp;</td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td></tr><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'Ci\')\"><td><b>{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency}}</b></td><td \nclass=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziato\'])+( vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\'] | currency}}</b>\n</td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][\'importi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</b></td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td></tr><tr ng-repeat-end=\"\" \nng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'Ci\')\"><td>{{subitem.id}}</td><td>{{subitem.label}}</td><td \nclass=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2\"><div layout=\"row\" layout-align=\"end center\">\n<span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"subsubitem.value\" size=\"10\" lang=\"it_IT\" type=\"number\" required> € \n</span><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" \nvalue=\"{{subsubitem.value|currency}}\"></span></div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields  | limitTo:2:2\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"10\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields  | limitTo:2:4\"><div layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 3)\"><input \ntype=\"number\" required=\"required\" class=\"text-right rendicontazioneInput\" style=\"width: 80%\" lang=\"it_IT\" size=\"10\" \nng-model=\"subsubitem.value\" xml:lang=\"it_IT\"> € </span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"10\" disabled=\"disabled\" value=\"{{subsubitem.value|currency}}\"> </span>\n</div></td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuitenziato\']) | currency}}\n</td><td class=\"text-right\">\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoImpegnato\']))/((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\'])))*100 | number:2}}%\n</td><td>\n{{ (((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziatoQuietanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiestoQuietanziato\']))/((vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[item.id][subitem.id][\'importi\'][\'contributoRichiesto\'])))*100 | number:2}}%\n</td></tr><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td \nclass=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoImpegnato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoImpegnato\'])+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoImpegnato\']) | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoQuietanziato\'] | currency}}\n</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziatoQuietanziato\'] )+(vm.getTotal(vm.datiRendicontazione.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiestoQuietanziato\']) | currency}}\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td></tr></tbody></table></div><div \nclass=\"ms-responsive-table-wrapper\" ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id === 3)\"><table \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-right\">&nbsp;</th><th \nclass=\"text-right\">&nbsp;</th><th class=\"text-right\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr></thead><tbody>\n<tr ng-repeat-start=\"item in vm.datiRendicontazione.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"(item.id != \'TOTALE\') && (item.id == \'SAL\')\"><td><b>SAL</b></td><td>&nbsp;</td><td class=\"text-right\">&nbsp;\n</td><td class=\"text-right\">&nbsp;</td><td class=\"text-right\">&nbsp;</td><td class=\"text-center\">&nbsp;</td></tr><tr \nng-repeat-end=\"\" ng-repeat=\"subitem in item.items\" ng-if=\"(item.id == \'SAL\')\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\"><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 3)\"><input style=\"width: 100%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[0].value\" \nsize=\"10\" lang=\"it_IT\" ng-disabled=\"vm.validasal > 0\" required data-blur-currency></span></div></td><td><div \nclass=\"datepicker-container\" flex><label flex>Data del sal</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datiRendicontazione.jsonData[9].items[0].fields[1].value\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataSAL\" startview=\"year\" ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=\"vm.validasal > 0\">\n</md-datepicker><div ng-messages=\"voceRendicontazioneForm.dataPagamento.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data del sal è obbligatoria</span></div></div></div></td><td \nclass=\"text-right\"><md-input-container class=\"md-default-theme\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" ng-disabled=\"vm.validasal > 0\" ng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Aggiungi il sal</md-button>\n</md-input-container></td><td><span style=\"text-align:center\" ng-if=\"vm.validasal > 0\" flex><i \nclass=\"icon-bookmark-check\"></i><br>il SAL è stato già trasmesso</span></td></tr></tbody></table><div \nclass=\"ms-responsive-table-wrapper\"></div></div><div ng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti</b></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([10,5,4,3]))\"><md-button type=\"button\" class=\"md-raised md-primary\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid\" ng-click=\"vm.saveRendicontazione(1);\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.nuovaRendicontazione)\"><md-tooltip \nmd-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4, 5]))\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3, 4])) && (vm.tipoRendicontazione != 1)\"><md-input-container class=\"md-default-theme\" \nng-if=\"vm.nuovaRendicontazione == false\"></md-input-container><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></md-input-container></div></form></div><div \nng-if=\"vm.tipoRendicontazione == 3\" ng-show=\"vm.allLoaded\"><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione\"><b>\nNuovo documento di Rendicontazione Finale</b> per {{vm.progetto.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.progetto.id})\">VAI AL PROGETTO {{vm.progetto.nome}}</md-button>\n</div><div class=\"md-title\" ng-if=\"vm.nuovaRendicontazione == false\"><b>Modifica documento di Rendicontazione Finale\n</b> per {{vm.datiRendicontazione.progettos.nome}}<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\">\nVAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button></div><md-divider></md-divider><br><form \nname=\"stepper\" ms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Registro Generale delle Spese\'\"><div layout=\"row\" \nclass=\"margin-top-16 layout-row\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.isallowed([3])\"><h2>\nCarica qui la documentazione obbligatoria</h2></div><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || vm.isallowed([3])\"><sprardb-uploaddocuments \nng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments><md-button></md-button></div><h2>\nRegistro Generale delle Spese</h2><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3\"><button \nng-click=\"vm.openVoceRegistroSpeseDialog(vm.jsonModel.items.item)\" \nclass=\"md-button md-accent md-raised md-ink-ripple md-default-theme\" type=\"button\" aria-label=\"Nuova rimodulazione\">\n<md-icon md-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Aggiungi voce di spesa</span></button></div><div layout=\"row\">\n<md-input-container flex><label>Filtro generale</label><input type=\"text\" name=\"numeroDocumento\" \nng-model=\"vm.filtroGenerale\"></md-input-container></div><div><md-table-container><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.segnalatos\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column><b>Cod</b></th><th md-column><b>Num. del doc.</b></th><th \nmd-column><b>Data del doc.</b></th><th md-column><b>Codice spesa</b></th><th md-column><b>Data del pag.</b></th><th \nmd-column><b>Imp. Totale</b></th><th md-column><b>Imp. Cofin.</b></th><th md-column><b>Imp. Fin.</b></th><th md-column>\n<b>Imputato Prog.</b></th><th md-column><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || (vm.isallowed([3])))\">Azioni<span></span></span>\n</th></tr></thead><tbody md-body><tr md-row md-select=\"segnalato\" md-select-id=\"segnalato\" ng-disabled=\"true\" \ndata-md-on-select=\"vm.log\" md-on-deselect=\"vm.deselect\" x-md-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"item in vm.datiRendicontazione.jsonData.items| filter: {value:vm.filtroGenerale}\"><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[0].value}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[3].value}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[2].value| date:\"dd/MM/yyyy\"}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item[6].value}}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item[5].value| date:\"dd/MM/yyyy\"}}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[8].value| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[9].value| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\">{{item[10].value| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item[12].value == 0}\"><b>{{item[11].value| currency}}</b></td><td md-cell \nstyle=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3 || (vm.isallowed([3])))\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item \nng-init=\"params = {documentoTipo_id: 0, gruppo: \'RENDICONTAZIONE\', dettaglio: false, dettagliomin: true, entita: \'rendicontazione\', entitakey: \'progettoRendicontazione_id\', entitakey2: \'progettoRendicontazioneProgressivo_id\', entita_id: vm.datiRendicontazione.id, entita2_id: item[0].value, progettoRendicontazione_id: vm.datiRendicontazione.id, progettoRendicontazioneProgressivo_id: item[0].value, aggiorna:0}\">\n<sprardb-uploaddocuments ng-model=\"params\"></sprardb-uploaddocuments></md-menu-item><md-menu-item class=\"\">\n</md-menu-item><md-menu-item class=\"\"><md-button class=\"md-accent md-button-icon\" \nng-click=\"vm.openVoceRegistroSpeseDialog(item)\" aria-label=\"Modifica\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\nMOD >></md-button></md-menu-item><md-menu-item class=\"\"><md-button class=\"md-button-icon md-primary\" \naria-label=\"Elimina\" ng-click=\"vm.deleteVoceRegistroSpeseDialog(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\nELIMINA</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Prospetto di Rendicontazione Finale\'\"><h2>Prospetto di Rendicontazione Finale</h2><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th><th><b>\nDESCRIZIONE SPESA</b></th><th class=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>\nCONTRIBUTO RICHIESTO</b></th><th class=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th><th class=\"text-center\"><b>ERRORI\n</b></th></tr></thead><tfoot><tr class=\"md-yellow-200-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'importoCofinanziato\'] | currency:\'€\'}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'contributoRichiesto\'] | currency:\'€\'}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiDiretti\'][\'totale\'] | currency}}</td><td \nclass=\"text-right\">&nbsp;</td></tr><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'importoCofinanziato\'] | currency:\'€\':2}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'contributoRichiesto\'] | currency:\'€\':2}}\n</td><td class=\"text-right\">\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[\'importi\'][\'totaleCostiComplessivi\'][\'totale\'] | currency:\'€\':2}}\n</td><td class=\"text-right\"><i \nng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_importoCofinanziato\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip>\n</i><i ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip>\n</i><i ng-if=\"vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(\'totaleCostiComplessivi_totale\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i></td></tr>\n</tfoot><tbody><tr ng-repeat-start=\"item in vm.datiRendicontazioneRecap.jsonData\" class=\"md-blue-grey-200-bg\" \nng-if=\"item.id != \'TOTALE\'\"><td><b>{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'importoCofinanziato\']) | currency:\'€\'}} </b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'contributoRichiesto\'] | currency:\'€\'}} </b>\n</td><td class=\"text-right\"><b>\n{{ vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'totale\'] | currency:\'€\'}} </b></td><td \nclass=\"text-center\"><i ng-if=\"vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_totale\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i><i \nng-if=\"vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}</md-tooltip></i>\n<i \nng-if=\"((vm.totaliPrecedenti[item.id][\'importi\'][\'totale\']) < (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][\'importi\'][\'totale\'])) && (vm.tipoRendicontazione == 3)\" \nclass=\"icon icon-alert-box md-raised md-alert md-alert-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\nATTENZIONE È POSSIBILE SFORARE UNA SOLA VOCE fra L, B, G, S, T, I, ENTRO IL 10% - LE VOCI P, A e Ci rientrano fra quelle non sforabili in assoluto.\n</md-tooltip></i></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\"><td>{{subitem.id}}</td><td>\n{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields | limitTo:2\">\n{{subsubitem.value| currency}}</td><td class=\"text-right\">\n{{ (vm.getTotal(vm.datiRendicontazioneRecap.jsonData)[item.id][subitem.id][\'importi\'][\'totale\']) | currency}}</td><td>\n<i \nng-if=\"vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)\" \nclass=\"icon icon-alert md-raised md-warn md-warn-fg s30 rulesValidatorIcon\"><md-tooltip md-direction=\"top\">\n{{vm.rulesValidator(item.id + \'_\' + subitem.id + \'_importi_contributoRichiesto\', vm.datiRendicontazioneRecap.jsonData)}}\n</md-tooltip></i></td></tr></tbody></table></div></ms-horizontal-stepper-step><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id >= 3) || vm.isallowed([3])\"><ms-horizontal-stepper-step \nng-form=\"step3\" step=\"3\" step-title=\"\'Status e conferma\'\"><div layout=\"row\" class=\"margin-top-16 layout-row\"><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><h1>Conferma di inoltro finale</h1>\nIl bilancio consuntivo finale è stato inoltrato con tutti gli allegati al Servizio Centrale. Verrà presto verificato da un operatore. Il codice di riferimento da usare per eventuali comunicazioni è il seguente:\n<h2>PR-{{vm.datiRendicontazione.progetto_id}}/{{vm.datiRendicontazione.id}}/{{vm.datiRendicontazione.anno}}</h2></span>\n<span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3\"><h1>Status della rendicontazione</h1>\nLa rendicontazione finale è in preparazione o in attesa di chiusura e approvazione da parte dell\'amministratore di progetto. \n</span><span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><h1>Status della rendicontazione</h1>\nUn\'integrazione dei documenti è stata richiesta dal servizio centrale. Usare lo step successivo per caricare i file integrativi\n</span></div></ms-horizontal-stepper-step></span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 4) || vm.isallowed([3])\"><ms-horizontal-stepper-step \nng-form=\"step4\" step=\"4\" step-title=\"\'Riepilogo documenti e integrazioni\'\" \nng-show=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 4) || vm.isallowed([3])\"><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><sprardb-uploaddocuments ng-model=\"vm.uploadParams\" flex></sprardb-uploaddocuments>\n<md-button></md-button></div></ms-horizontal-stepper-step></span></form><div \nng-if=\"vm.checkErrors() || rendicontazioneForm.$invalid\" class=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti. Verifica il Prospetto di Rendicontazione Finale.\n</b></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container \nclass=\"md-default-theme\" ng-if=\"(vm.isallowed([3, 4, 5]))\"><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Salva\" \nng-disabled=\"rendicontazioneForm.$invalid || vm.checkErrors() || (vm.datiRendicontazione.progettoRendicontazioneStato_id >= 2)\" \nng-click=\"vm.saveRendicontazione(3);\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3,4])) && vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3)\" ng-click=\"vm.saveRendicontazione(3);\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Chiusura integrazione</md-tooltip>\nINTEGRAZIONE TERMINATA</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"(vm.isallowed([3,4]))  && vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Salva\" \nng-disabled=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id < 3)\" ng-click=\"vm.saveRendicontazione(4);\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip md-direction=\"top\">Riapertura per integrazione\n</md-tooltip>RICHIESTA INTEGRAZIONE</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"vm.nuovaRendicontazione == false\"><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progettos.id})\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO {{vm.datiRendicontazione.progettos.nome}}</md-button>\n</md-input-container></div></div><br><br><br></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazione/schema_rendicontazione.html","<table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th><th><b>DESCRIZIONE SPESA</b></th><th \nclass=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>CONTRIBUTO RICHIESTO</b></th><th \nclass=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th></tr></thead><tfoot><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COSTI DIRETTI</td><td class=\"text-right\">{{ vm.getTotal()[\'importi\'][\'importoCofinanziato\']}} €</td><td \nclass=\"text-right\">{{ vm.getTotal()[\'importi\'][\'contributoRichiesto\']}} €</td><td class=\"text-right\">\n{{ vm.getTotal()[\'importi\'][\'totale\']}} € &nbsp;&nbsp;&nbsp;&nbsp;</td></tr></tfoot><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonDataToPhp.data\" class=\"md-blue-grey-200-bg\"><td><b>\n{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'importoCofinanziato\']}} €</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'contributoRichiesto\']}} €</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'totale\']}} €</b></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\">\n<td>{{subitem.id}}</td><td>{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields\"><input\n type=\"text\" style=\"border: 1px solid #aaaaaa; padding: 5px; border-radius: 2px; background-color: #eeeeee\" \nclass=\"text-right\" ng-model=\"subsubitem.value\" size=\"10\" required> €</td><td class=\"text-right\">\n{{ vm.getTotal()[item.id][subitem.id][\'importi\'][\'totale\']}} €</td></tr></tbody></table>");
$templateCache.put("app/main/sprardb/rendicontazioni/setup/dettaglio.html","<div id=\"dettagliop\" class=\"page-layout simple right-sidenav\" layout=\"row\"><script \nsrc=\"../../../../../../bower_components/moment/locale/it.js\"></script><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" onclick=\"history.go(-1)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Setup limiti rendicontazione</span></div></div></div><div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label class=\"padding-right-4\"><span>Rendicontazione</span></md-tab-label>\n<md-tab-body><h2 class=\"\"><strong>Scadenze per Preventivo/Rimodulazione e Rendicontazione e limiti di spesa previsti\n</strong></h2><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form \nname=\"rendicontazioneScadenzeLimitiForm\" class=\"md-inline-form\" ng-submit=\"reset()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"padding-top-16\"><div class=\"h2\">Imposta scadenze rendicontazione</div></div><md-divider>\n</md-divider><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-around center\" class=\"padding-top-16\">\n<md-input-container flex=\"70\"><label>Periodo Finanziamento</label><md-select name=\"anno\" ng-model=\"vm.datas.id\" \nng-change=\"vm.selectdatas()\"><md-option ng-repeat=\"item in vm.filtroanno\" ng-value=\"item.id\">{{item.descrizione}}\n</md-option></md-select></md-input-container><md-checkbox ng-if=\"vm.isnew\" ng-model=\"vm.periodo\" flex=\"30\" \nng-true-value=\"1\" ng-false-value=\"0\">ANNUALE</md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"padding-top-16\" ng-if=\"!vm.periodo\"><div class=\"datepicker-container\" flex><label flex \nstyle=\"max-height: 22px; margin-top:20px\">Data inizio periodo finanziamento</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataInizioPeriodo\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"!vm.periodo\" \nflex=\"50\" name=\"dataInizioPeriodo\" ng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataInizioPeriodo.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex><label\n flex style=\"max-height: 22px; margin-top:20px\">Data fine periodo finanziamento</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataFinePeriodo\" md-placeholder=\"GG/MM/AAAA\" flex=\"50\" \nname=\"dataFinePeriodo\" ng-required=\"!vm.periodo\" md-min-date=\"vm.datas.dataInizioPeriodo\" \nng-model-options=\"{timezone: \'utc\'}\" ng-change=\"vm.validateDataFine()\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataFinePeriodo.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"padding-top-16\"><div class=\"datepicker-container\" flex><label flex \nstyle=\"max-height: 22px; margin-top:20px\">Data di inizio compilazione preventivo</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataPreventivoInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataPreventivoInizio\" ng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataPreventivoInizio.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex>\n<label flex style=\"max-height: 22px; margin-top:20px\">Data di fine compilazione Preventivo</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataPreventivoFine\" md-placeholder=\"GG/MM/AAAA\" flex=\"50\" \nname=\"dataPreventivoFine\" ng-required=\"true\" md-min-date=\"vm.datas.dataPreventivoInizio\" \nng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataPreventivoFine.$error\" role=\"alert\"><div ng-message=\"required\"><span\n style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione SAL</label><md-datepicker datepicker-validation-fix ng-model=\"vm.datas.dataSALInizio\" \nmd-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" name=\"dataSALInizio\" ng-model-options=\"{timezone: \'utc\'}\">\n</md-datepicker><div ng-messages=\"rendicontazioneScadenzeLimitiForm.dataSALInizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">Data di Fine compilazione SAL\n</label><md-datepicker datepicker-validation-fix ng-model=\"vm.datas.dataSALFine\" md-placeholder=\"GG/MM/AAAA\" \nng-required=\"true\" flex=\"50\" name=\"dataSALFine\" md-min-date=\"vm.datas.dataSALInizio\" \nng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataSALFine.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione Rimodulazione</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datas.dataRimodulazioneInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRimodulazioneInizio\" ng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRimodulazioneInizio.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex>\n<label flex style=\"max-height: 22px; margin-top:20px\">Data di Fine compilazione Rimodulazione</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataRimodulazioneFine\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataRimodulazioneFine\" md-min-date=\"vm.datas.dataRimodulazioneInizio\" \nng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRimodulazioneFine.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione Rendicontazione</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datas.dataRendicontazioneInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRendicontazioneInizio\" ng-model-options=\"{timezone: \'utc\'}\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRendicontazioneInizio.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div \nclass=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Fine compilazione Rendicontazione</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datas.dataRendicontazioneFine\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRendicontazioneFine\" md-min-date=\"vm.datas.dataRendicontazioneInizio\" ng-model-options=\"{timezone: \'utc\'}\">\n</md-datepicker><div ng-messages=\"rendicontazioneScadenzeLimitiForm.dataRendicontazioneFine.$error\" role=\"alert\"><div \nng-message=\"required\"><span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div \nclass=\"h2 padding-top-8\">Limiti di spesa previsti</div><div class=\"h4 padding-top-8\">\nGli importi sono formattati automaticamente.</div><md-divider></md-divider><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"padding-top-16\"><md-input-container flex><label>Importo Costo Complessivo</label><input name=\"costoComplessivo\" \nng-model=\"vm.datas.costoComplessivo\" placeholder=\"0,00\" lang=\"it_IT\" data-blur-currency type=\"text\"><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.costoComplessivo.$error\" role=\"alert\" multiple=\"multiple\"></div>\n</md-input-container><md-input-container flex><label>Importo Costo del Personale</label><input name=\"costoPersonale\" \nng-model=\"vm.datas.costoPersonale\" placeholder=\"Euro 0,00\" lang=\"it_IT\" data-blur-currency type=\"text\"><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.costoPersonale.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Cifra in euro, comprensiva di due decimali separati dalla virgola</span></div></div>\n</md-input-container><md-input-container flex><label>Costo Pluriennale</label><input \nname=\"costoComplessivoPluriennale\" ng-model=\"vm.datas.costoComplessivoPluriennale\" placeholder=\"Euro 0,00\" \nlang=\"it_IT\" data-blur-currency type=\"text\"></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"rendicontazioneScadenzeLimitiForm.$invalid || rendicontazioneScadenzeLimitiForm.$pristine || rendicontazioneScadenzeLimitiForm.$submitted || vm.validAnno()\" \nng-click=\"vm.saveRendicontazioneData($event);\"><span ng-if=\"vm.isnew\">INSERISCI NUOVI LIMITI PER ANNO {{vm.datas.anno}}\n</span><span ng-if=\"!vm.isnew\">MODIFICA LIMITI PER ANNO {{vm.datas.anno}}</span></md-button></form></div></div>\n</md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/setup/dettagliob.html","<div id=\"dettagliop\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" onclick=\"history.go(-1)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\">Progetto</span><div class=\"subtitle secondary-text\"><span>{{vm.progetto.nome}}</span></div></div>\n</div></div><div></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label \nclass=\"padding-right-4\"><span>Rendicontazione</span></md-tab-label><md-tab-body><h2 class=\"\"><strong>\nScadenze di gruppo per Preventivo/Rimodulazione e Rendicontazione</strong></h2><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"rendicontazioneScadenzeLimitiForm\" \nclass=\"md-inline-form\" ng-submit=\"reset()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" class=\"padding-top-16\">\n<div class=\"h2\">Imposta scadenze rendicontazione</div></div><md-divider></md-divider><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"padding-top-16\"><md-input-container flex><label>Anno di rendicontazione</label><md-select \nname=\"anno\" ng-model=\"vm.datas.anno\" required ng-change=\"vm.selectdatas()\"><md-option \nng-repeat=\"item in vm.filtroanno\" ng-value=\"item.id\">{{item.descrizione}}</md-option></md-select><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.anno.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"padding-top-16\"><div class=\"datepicker-container\" flex><label flex \nstyle=\"max-height: 22px; margin-top:20px\">Data di inizio compilazione preventivo</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataPreventivoInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataPreventivoInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataPreventivoInizio.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex>\n<label flex style=\"max-height: 22px; margin-top:20px\">Data di fine compilazione Preventivo</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataPreventivoFine\" md-placeholder=\"GG/MM/AAAA\" flex=\"50\" \nname=\"dataPreventivoFine\" ng-required=\"true\" md-min-date=\"vm.datas.dataPreventivoInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataPreventivoFine.$error\" role=\"alert\"><div ng-message=\"required\"><span\n style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione Rimodulazione</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datas.dataRimodulazioneInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRimodulazioneInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRimodulazioneInizio.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex>\n<label flex style=\"max-height: 22px; margin-top:20px\">Data di Fine compilazione Rimodulazione</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataRimodulazioneFine\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataRimodulazioneFine\" md-min-date=\"vm.datas.dataRimodulazioneInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRimodulazioneFine.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione SAL</label><md-datepicker datepicker-validation-fix ng-model=\"vm.datas.dataSALInizio\" \nmd-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" name=\"dataSALInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataSALInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex><label\n flex style=\"max-height: 22px; margin-top:20px\">Data di Fine compilazione SAL</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataSALFine\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRimodulazioneFine\" md-min-date=\"vm.datas.dataSALInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataSALFine.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px; margin-top:20px\">\nData di Inizio compilazione Rendicontazione</label><md-datepicker datepicker-validation-fix \nng-model=\"vm.datas.dataRendicontazioneInizio\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" flex=\"50\" \nname=\"dataRendicontazioneInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataSALInizio.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div><div class=\"datepicker-container\" flex><label\n flex style=\"max-height: 22px; margin-top:20px\">Data di Fine compilazione Rendicontazione</label><md-datepicker \ndatepicker-validation-fix ng-model=\"vm.datas.dataRendicontazioneFine\" md-placeholder=\"GG/MM/AAAA\" ng-required=\"true\" \nflex=\"50\" name=\"dataRendicontazioneFine\" md-min-date=\"vm.datas.dataRendicontazioneInizio\"></md-datepicker><div \nng-messages=\"rendicontazioneScadenzeLimitiForm.dataRendicontazioneFine.$error\" role=\"alert\"><div ng-message=\"required\">\n<span style=\"color:rgb(213,0,0)\">La data è obbligatoria</span></div></div></div></div></form></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"rendicontazioneScadenzeLimitiForm.$invalid || rendicontazioneScadenzeLimitiForm.$pristine || rendicontazioneScadenzeLimitiForm.$submitted\" \nng-click=\"vm.savebulk($event);\">Salva i nuovi valori</md-button></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/setup/progetti.html","<div id=\"contacts\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/progetti/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Setup Rendicontazione Progetti</span></div></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts = []\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \nclass=\"small\">Indietro</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span class=\"small\">Selezionato</span>\n</span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item></md-menu-item><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\" \ntranslate=\"CONTACTS.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deselectContacts()\" translate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"40\"><md-button ng-click=\"vm.onSearch();\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button \nng-click=\"vm.allFields = !vm.allFields\"><small>Ricerca avanzata</small><md-icon ng-if=\"!vm.allFields\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"vm.allFields\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Apri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" \nng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\">\n</md-icon>{{vm.ricercalabel[key]}}{{ricercato}}</span></div><div layout=\"row\" flex ng-if=\"vm.allFields\">\n<md-input-container flex><label>Cat.Accoglienza</label><md-select ng-model=\"vm.ricerca[\'bandos-id\']\" \nng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option class=\"small\" \nng-repeat=\"bando in vm.bandos\" value=\"{{bando.id}}\">{{bando.descrizione}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Anno</label><md-select ng-model=\"vm.ricerca[\'bandos-dataFine\']\" \nng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"anno in vm.annos| filter: {dataFine: (\'\')}\" value=\"{{anno.dataFine}}\">{{anno.dataFine| limitTo: 4}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Regione</label><md-select \nng-model=\"vm.ricerca[\'istats-regione\']\" ng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.regione}}\">{{regione.regione}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Posti liberi</label><md-select ng-model=\"vm.ricerca.postiLiberi\" \nng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option value=\">1\">Si</md-option><md-option \nvalue=\"<0\">No</md-option></md-select></md-input-container><md-input-container flex><label>Attivo</label><md-select \nng-model=\"vm.ricerca.attivo\" ng-change=\"vm.onSearch();\"><md-option value=\"null\">Tutti</md-option><md-option value=\">1\">\nSi</md-option><md-option value=\"<0\">No</md-option></md-select></md-input-container><md-button \nng-click=\"vm.searchEmpty(); vm.allFields = !vm.allFields;\"><small>svuota</small></md-button></div><md-card \nstyle=\"padding-top:0px\"><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.contacts\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th \nmd-column>CATEGORIA</th><th md-column md-order-by=\"nome\">NOME</th><th md-column md-order-by=\"codComune\"><span>CITTA\n</span></th><th md-column md-order-by=\"email\">RECAPITI</th><th md-column>SETUP EFFETTUATO</th><th md-column \nclass=\"text-center\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"contacts\" md-select-id=\"contacts\" \nng-disabled=\"\" data-md-on-select=\"vm.toggleSelectContact\" md-on-deselect=\"vm.deselectContacts\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.contacts\"><td md-cell>{{item.id}}</td><td md-cell><div \nlayout=\"row\"><md-button ng-repeat=\"subitem in item.bandos\" class=\"md-fab md-mini {{vm.colors[subitem.id]}} no-margin\" \naria-label=\"tipos\">{{subitem.descrizione|limitTo: 1}}<md-tooltip><span>{{subitem.descrizione}}</span></md-tooltip>\n</md-button></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.tot - item.benefAttivi) / item.tot * 100) | number}}\"></md-progress-linear></td><td md-cell><b>\n{{item.istats.comune| uppercase}}</b><br>{{item.istats.provincia| uppercase}}</td><td md-cell><a \ntitle=\"{{item.email}}\" href=\"mailto:{{item.email}}\">{{item.email|limitTo:12}}...</a><br>{{item.telefono}}</td><td \nmd-cell><md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" \nng-if=\"item.progettoparametrirendicontaziones === null\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px\" ng-if=\"item.progettoparametrirendicontaziones !== null\"></md-icon></td><td md-cell><md-button \nclass=\"md-accent md-button-icon\" aria-label=\"View Detailed\" \nui-sref=\"app.sprardb_rendicontazioni_setupdetail({id:item.id})\">VAI >></md-button></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" \nmd-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card></div></div>\n</div>");
$templateCache.put("app/main/sprardb/rendicontazioni/setup/setuplistrendicontazione.html","<div id=\"progetti\" class=\"page-layout simple left-sidenav inner-sidenav\" ms-scroll><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/progetti/sidenavs/sidenav-ricerca.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Rendicontazioni > Setup</span></div></div></div><div \nclass=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"60\"><md-input-container md-no-float \nclass=\"m-0\" flex><input id=\"search\" placeholder=\"Ricerca nei progetti\" type=\"text\" ng-model=\"vm.ricerca2\" \nng-model-options=\"{\n                                    debounce: 500\n                                }\" \nng-change=\"vm.onSearch();\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\">\n<md-button ng-click=\"vm.onSearch();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'sidenav\')\"><small>Ricerca avanzata</small><md-tooltip md-direction=\"bottom\">\nApri opzioni di ricerca avanzata</md-tooltip></md-button></div></div><md-card style=\"padding-top:0px\"><md-toolbar \nclass=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><small><b>Setup delle rendicontazioni</b></small><div layout=\"row\" ng-if=\"vm.searched\" flex>\n<span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" \nng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>Parola chiave: {{vm.ricerca2| uppercase}} </span><span \nclass=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" ng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\"></md-icon>\n{{vm.searchForms[key].title}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div></div></md-toolbar>\n<md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i \nclass=\"icon-close s22 grey-400-fg\"></i><md-tooltip>Cancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'enti selezionati\' : \'ente selezionato\'}} :</span><div flex></div>\n<md-button class=\"md-raised md-background md-button md-default-theme md-ink-ripple\" aria-label=\"rsc\" \nng-click=\"vm.gotobulk(vm.selected)\" ng-disabled=\"(vm.selected.length == 0)\">NUOVO SETUP RENDICONTAZIONE IN BLOCCO\n</md-button></div></md-toolbar><md-table-container><table data-md-table data-md-row-select=\"vm.options.rowSelection\" \ndata-ng-model=\"vm.selected\" md-progress=\"vm.contacts\" multiple=\"{{vm.options.multiSelect}}\"><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column md-order-by=\"id\" style=\"padding-right:8px\">Cod</th><th md-column style=\"padding-right:8px\">CATEG</th><th \nmd-column style=\"padding-right:8px\">E.TITOLARE</th><th md-column md-order-by=\"nome\" style=\"padding-right:8px\">PROGETTO\n</th><th md-column md-order-by=\"codComune\" style=\"padding-right:8px\"><span>CITTA/PROV</span></th><th md-column \nmd-order-by=\"email\" style=\"padding-right:8px\">ANNI/PERIODO SETUP</th><th md-column style=\"padding-right:8px\" \nmd-order-by=\"postiTotali\">SETUP</th><th md-column md-order-by=\"attivo\" style=\"padding-right:8px\">ATTIVO</th><th \nmd-column style=\"text-align:center;padding-right:8px\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"item.id\" ng-disabled=\"item.attivo == 0\" data-md-on-select=\"vm.toggleSelect\" \nmd-on-deselect=\"vm.toggleSelect\" x-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"item in vm.contacts\" \nng-class=\"{\'md-light-blue-50-bg\': item.attivo === -1, \'md-grey-200-bg\': item.attivo === 0}\"><td md-cell \nstyle=\"padding-right:8px\">{{item.codiceMinistero}}</td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span\n ng-repeat=\"subitem in item.bandos track by $index\"><md-button \nclass=\"md-fab md-mini {{vm.colors[subitem.id]}} no-margin\" aria-label=\"tipos\" ng-if=\"$index == 0\">\n{{subitem.descrizione|limitTo: 2}}<md-tooltip><span>\n{{subitem.descrizione}} // {{subitem.dataInizio}}-{{subitem.dataFine}}</span></md-tooltip></md-button><span \nng-if=\"$index > 0\" layout=\"row\"><b>+</b>&nbsp;<small>{{subitem.descrizione}}</small></span></span></div></td><td \nmd-cell style=\"padding-right:8px\"><div layout=\"column\"><span><b>{{item.entetitolare.nome|uppercase}}</b></span> <span>\n<small>({{item.entetitolare.provincia|uppercase}})</small></span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\"><div layout=\"column\"><span>{{ item.nome | uppercase}}</span>\n<md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.postiTotali - item.postiLiberi) / item.postiTotali * 100) | number:0}}\" \ntitle=\"liberi {{item.postiLiberi}} su {{item.postiTotali}}\"></md-progress-linear></div></td><td md-cell \nstyle=\"padding-right:8px\"><div layout=\"column\"><b>{{item.istats.comune| uppercase}}</b> <span><small>\n({{item.istats.provincia| uppercase}})</small></span></div></td><td md-cell style=\"padding-right:8px\"><div \nlayout=\"column\"><span ng-repeat=\"subitem in item.pprs|orderBy:\'-dataFinePeriodo\'|limitTo:3 \">\n{{subitem.mesiAnniRendicontazione}}</span></div></td><td md-cell style=\"padding-right:8px\"><div layout=\"column\">\n<md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"item.progettoparametrirendicontaziones === null\">\n</md-icon><md-icon class=\"icon-bookmark-check\" style=\"font-size:20px\" \nng-if=\"item.progettoparametrirendicontaziones !== null\"></md-icon></div></td><td md-cell class=\"text-center\"><div \nlayout=\"column\"><md-icon class=\"icon-bookmark-outline\" ng-class=\"{\'orange-900-fg\': item.attivo === -1}\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon class=\"icon-bookmark-check\" \nstyle=\"font-size:20px;padding-right:8px\" ng-if=\"item.attivo == 1\"></md-icon></div></td><td md-cell \nstyle=\"padding-right:4px;text-align: right\"><div><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Dettaglio\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:item.id})\"><md-icon md-font-icon=\"icon-apps\"></md-icon><small><b>\nAPRI PROGETTO</b></small></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Accesso setup\" \nng-click=\"vm.editSetup(false, item.id, item.pprs)\" ng-disabled=\"(item.progettoparametrirendicontaziones === null)\">\n<md-icon md-font-icon=\"icon-table-edit\"></md-icon><small><b>MODIFICA SETUP ESISTENTE</b></small></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Accesso setup\" ng-click=\"vm.newSetup(true, item.id, item.pprs)\">\n<md-icon md-font-icon=\"icon-table-row-plus-after\"></md-icon><small><b>INSERISCI NUOVO SETUP</b></small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.allsearchs.pagination\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" \nmd-total=\"{{vm.meta.totalCount}}\" md-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\">\n</md-table-pagination></md-card></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/dialogMessaggiForm.html","<md-dialog id=\"messaggidialog\" class=\"persone-dialog\" aria-label=\"Profilo Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Messaggistica</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"space-between\" style=\"max-width:800px;max-height:810px;min-width: 540px\" class=\"padding padding-top-8\">\n<div><p><b>Messaggi precedenti</b></p><p ng-repeat-start=\"messaggio in vm.messaggi.data\">\n{{messaggio.data | date:\'dd/MM/yyyy\'}}<br>{{messaggio.testo}}</p><md-divider ng-repeat-end></md-divider></div><p \nclass=\"padding padding-top-16\" ng-if=\"vm.apertura_chiusura\"><b>Nuovo messaggio</b></p><form name=\"messaggiForm\" \nlayout=\"column\" novalidate><md-input-container ng-if=\"vm.apertura_chiusura\"><label>Data</label><input type=\"text\" \nname=\"datamessaggio\" ng-model=\"vm.model.data\" placeholder=\"data Messaggio\" ng-disabled=\"true\"></md-input-container>\n<md-input-container ng-if=\"vm.apertura_chiusura\"><label>Testo</label><textarea ng-model=\"vm.model.testo\" \nmd-maxlength=\"200\" rows=\"3\" md-select-on-focus class=\"font-size-12\"></textarea></md-input-container></form>\n<md-input-container ng-if=\"vm.showDataScadenza\"><label>Data scadenza Integrazione</label><md-datepicker \ndatepicker-validation-fix name=\"dataScadenza\" ng-model=\"vm.dataScadenza\" md-min-date=\"vm.oggi\" \nmd-placeholder=\"Data scadenza\" ng-disabled=\"vm.disableDataScadenza\"></md-datepicker></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.salvamessaggio()\" \nclass=\"send-button md-accent md-raised\" ng-if=\"vm.apertura_chiusura\" ng-disabled=\"messaggiForm.$invalid\" \naria-label=\"SAVE\">SALVA</md-button><md-button type=\"button\" ng-click=\"vm.aggiornadataScadenza()\" \nng-if=\"!vm.aggiornaHidden\" ng-disabled=\"vm.aggiornaDisabled\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\">\nCambio data scadenza</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/preventivo.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Rendicontazione</span></div></div></div>\n<div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nclass=\"simple-table-container md-whiteframe-4dp\"><form layout=\"column\" name=\"rendicontazioneForm\" novalidate \nlayout-margin><div class=\"table-title\"><b>Modifica documento di {{ vm.datiRendicontazione.tipo.descrizione }}</b>\n per {{vm.datiRendicontazione.progetto.nome}} ({{vm.datiRendicontazione.codiceProgetto}}) - anno {{vm.datiRendicontazione.anno}} \n<small>\n({{vm.datiRendicontazione.setup.dataInizioPeriodo | date: \'dd/MM/yyyy\'}} - {{vm.datiRendicontazione.setup.dataFinePeriodo | date: \'dd/MM/yyyy\'}})\n</small><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progetto.id})\" ng-if=\"!vm.api.isRevisore\">\n<md-icon md-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO</md-button><br><small class=\"ng-binding\">\n{{vm.datiRendicontazione.categoria}}</small></div><div layout=\"row\" flex style=\"padding: 8px 24px\" class=\"grey-100-bg\">\n<span flex><strong>Codice:</strong> <small>{{vm.datiRendicontazione.progetto.codiceMinistero}}</small></span> <span \nflex><strong>Tipo</strong>: <small>{{ vm.datiRendicontazione.tipo.descrizione }}</small></span> <span flex><strong>\nIdentificativo</strong>: <small>{{vm.datiRendicontazione.id}}</small></span> <span flex><strong>Stato:</strong> <small>\n{{vm.datiRendicontazione.stato.descrizione}} <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 3 && vm.datiRendicontazione.inviato_at > 0\">\nil {{vm.datiRendicontazione.inviato_at*1000 | date : \"medium\"}}</span></small></span></div><div \nid=\"prorogaprosecuzione\" \nng-if=\"!([1,4].includes(vm.datiRendicontazione.progettoRendicontazioneTipo_id)) && vm.datiRendicontazione.modo.prorogaTecnica\">\n<h3 flex layout=\"row\" style=\"padding: 8px 24px\">\nCliccare su entrambe le voci&nbsp;SOLO SE NEL {{vm.datiRendicontazione.anno}} l\'ente locale ha fatto ricorso alla proroga prima della prosecuzione (nuovo affidamento). Altrimenti scegliere proroga tecnica o prosecuzione, secondo il caso che vi riguarda.\n</h3><div flex layout=\"row\" style=\"padding: 8px 24px\"><md-checkbox ng-model=\"vm.datiRendicontazione.prorogaTecnica\" \naria-label=\"Proroga tecnica\" name=\"prorogaTecnica\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 1\"><small>Progetto in proroga tecnica</small>\n</md-checkbox><md-checkbox ng-model=\"vm.datiRendicontazione.prosecuzione\" aria-label=\"Proroga tecnica\" \nname=\"prosecuzione\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 1\"><small>Progetto in prosecuzione</small>\n</md-checkbox></div><div layout=\"row\" style=\"padding: 8px 24px\"><h3 \nng-if=\"((vm.datiRendicontazione.prorogaTecnica == 1) && (vm.datiRendicontazione.prosecuzione == 1))\">\nAttenzione! La selezione di entrambe le opzioni (proroga tecnica + prosecuzione) conduce ad un processo in cui il sistema non è in grado di segnalarvi eventuali errori di calcolo.\n<br>Il documento può essere salvato in bozza più volte.<br>\nPer la trasmissione è necessario cliccare su \"valida e invia\".</h3></div></div><div \nclass=\"ms-responsive-table-wrapper\" ng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id < 3\"><div \nlayout=\"row\" layout-align=\"end\" ng-if=\"vm.caricaImportiPreventivo(true)\"><md-button class=\"md-raised md-primary\" \naria-label=\"Salva\" ng-click=\"vm.caricaImportiPreventivo()\"><md-tooltip md-direction=\"top\">\nRecupera gli importi dal preventivo già validato. Sarà comunque necessario salvare le modifiche.</md-tooltip>\nCarica Importi Preventivo</md-button></div><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th>\n<th><b>DESCRIZIONE SPESA</b></th><th class=\"text-right\" ng-if=\"vm.datiRendicontazione.modo.cofinanziamento\"><b>\nIMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>CONTRIBUTO RICHIESTO</b></th><th class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\"><b>COSTO TOTALE PROGETTO</b></th><th \nclass=\"text-center\"><b>ERRORI</b></th></tr></thead><tbody><tr ng-switch=\"item.codice.charAt(0) === \'~\'\" \nng-repeat=\"item in vm.prospettoSerializzato.costiDiretti\" ng-class=\"item.class\"><td><b ng-switch-when=\"false\">\n{{item.codice}}</b></td><td><b>{{item.descrizione}}</b></td><td ng-switch-when=\"true\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"></td><td ng-switch-when=\"false\" \nclass=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\"><div \nng-if=\"item.voce\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\"><md-input-container style=\"margin: 0\"><input \nclass=\"rendicontazioneInput\" ng-model=\"item.voce[importo]\" type=\"text\" lang=\"it_IT\" aria-label=\" \" required \nui-money-mask ui-negative-number ui-currency-after></md-input-container></span><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{item[importo] | currency}}\"></span>\n</div><span ng-if=\"!item.voce\">{{item[importo] | currency}}</span></td><td ng-switch-when=\"false\" class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.totale | currency}}</td><td \nclass=\"text-center error-container\" id=\"{{item.path}}\"></td></tr><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COSTI DIRETTI</td><td class=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiDiretti[importo] | currency}}</td><td class=\"text-right\">&nbsp;</td></tr><tr \nng-repeat=\"item in vm.prospettoSerializzato.costiIndiretti\" ng-class=\"item.class\"><td><b>{{item.codice}}</b></td><td>\n<b>{{item.descrizione}}</b></td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\"><div ng-if=\"item.voce\" \nlayout=\"row\" layout-align=\"end center\"><span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\">\n<md-input-container style=\"margin:0\"><input class=\"rendicontazioneInput\" ng-model=\"item.voce[importo]\" type=\"text\" \nlang=\"it_IT\" aria-label=\" \" required ui-money-mask ui-negative-number ui-currency-after></md-input-container></span>\n<span ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\"><input type=\"text\" style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" value=\"{{item[importo] | currency}}\"></span>\n</div><span ng-if=\"!item.voce\">{{item[importo] | currency}}</span></td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.totale | currency}}</td><td \nclass=\"text-center error-container\" id=\"{{item.path}}\"></td></tr></tbody><tfoot><tr class=\"md-blue-grey-500-bg\"><td>\n</td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.cofinanziamento\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.importoCofinanziato | currency }}<br>\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.percentCofinanziamento | number}}% sul totale</td><td \nclass=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!importoCofinanziato\'\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi[importo] | currency}}</td><td class=\"text-center\"><span \nid=\"percentCofinanziamento\" class=\"error-container\"></span> <span id=\"costiComplessivi\" class=\"error-container\"></span>\n</td></tr></tfoot></table></div><div class=\"ms-responsive-table-wrapper\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id === 4\"><table class=\"simple\" ms-responsive-table=\"\">\n<thead><tr><th>&nbsp;</th><th>&nbsp;</th><th colspan=\"{{vm.datiRendicontazione.modo.importiPreventivo.length}}\" \nclass=\"text-right\">PIANO FINANZIARIO</th><th colspan=\"{{vm.datiRendicontazione.modo.importiPreventivo.length}}\" \nclass=\"text-right\">SPESE IMPEGNATE</th><th colspan=\"{{vm.datiRendicontazione.modo.importiPreventivo.length}}\" \nclass=\"text-right\">di cui QUIETANZATE</th><th class=\"text-right\">&nbsp;</th><th class=\"text-right\">&nbsp;</th></tr><tr \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.length > 1\"><th>&nbsp;</th><th>&nbsp;</th><th class=\"text-center\">\nA</th><th class=\"text-center\">B</th><th class=\"text-center\">C</th><th class=\"text-center\">D</th><th \nclass=\"text-center\">E</th><th class=\"text-center\">F</th><th class=\"text-center\">G</th><th class=\"text-center\">H</th><th\n class=\"text-center\">I</th><th class=\"text-center\">&nbsp;</th><th class=\"text-center\">&nbsp;</th></tr><tr><th><b>COD.\n</b></th><th><b>DESCRIZIONE<br>SPESA</b></th><th \nng-repeat=\"importo in vm.capsLabel(vm.datiRendicontazione.modo.importiPreventivo) track by $index\" class=\"text-center\">\n<b>{{importo}}</b></th><th \nng-repeat=\"importo in vm.capsLabel(vm.datiRendicontazione.modo.importiPreventivo) track by $index\" class=\"text-center\">\n<b>{{importo}}</b></th><th \nng-repeat=\"importo in vm.capsLabel(vm.datiRendicontazione.modo.importiPreventivo) track by $index\" class=\"text-center\">\n<b>{{importo}}</b></th><th class=\"text-center\">AV. %<br>IMPEGNI<br>(F/C)</th><th class=\"text-center\">AV. %<br>SPESA<br>\n(I/C)</th></tr></thead><tbody><tr ng-switch=\"item.codice.charAt(0) === \'~\'\" \nng-repeat=\"item in vm.prospettoSerializzato.costiDiretti\" ng-class=\"item.class\"><td><b ng-switch-when=\"false\">\n{{item.codice}}</b></td><td><b>{{item.descrizione}}</b></td><td ng-switch-when=\"true\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"></td><td ng-switch-when=\"true\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"></td><td ng-switch-when=\"true\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"></td><td ng-switch-when=\"true\"></td><td \nng-switch-when=\"true\"></td><td ng-switch-when=\"false\" class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\">\n{{vm.preventivoProspetto.get(\'costiDiretti.\'+item.path)[importo] | currency}}</td><td ng-switch-when=\"false\" \nclass=\"text-right\" ng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">\n{{vm.preventivoProspetto.get(\'costiDiretti.\'+item.path).totale | currency}}</td><td ng-switch-when=\"false\" \nclass=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\"><div \nng-if=\"item.impegnato.voce\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"item.impegnato.voce[importo]\" size=\"15\" lang=\"it_IT\" type=\"number\" \nrequired> € </span><input ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\" type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{item.impegnato[importo] | currency}}\"></div><span ng-if=\"!item.impegnato.voce\">\n{{item.impegnato[importo] | currency}}</span></td><td ng-switch-when=\"false\" class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.impegnato.totale | currency}}\n</td><td ng-switch-when=\"false\" class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\"><div \nng-if=\"item.quietanzato.voce\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"item.quietanzato.voce[importo]\" size=\"15\" lang=\"it_IT\" type=\"number\" \nrequired> € </span><input ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\" type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{item.quietanzato.voce[importo] | currency}}\"></div><span ng-if=\"!item.quietanzato.voce\">\n{{item.quietanzato[importo] | currency}}</span></td><td ng-switch-when=\"false\" class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.quietanzato.totale | currency}}\n</td><td ng-switch-when=\"false\" class=\"text-center\" ng-repeat=\"tipo in vm.tipi\">{{ item[tipo].percent | number:2}}%\n</td></tr><tr class=\"md-blue-grey-500-bg\"><td></td><td>TOTALE COSTI DIRETTI</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.preventivoProspetto.costiDiretti[importo] | currency}}</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiDiretti.impegnato[importo] | currency}}</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiDiretti.quietanzato[importo] | currency}}</td><td class=\"text-center\" \nng-repeat=\"tipo in vm.tipi\">\n{{ (vm.datiRendicontazione.prospetto.costiDiretti[tipo].totale / vm.preventivoProspetto.costiDiretti.totale) * 100 | number:2}}%\n</td></tr><tr ng-repeat=\"item in vm.prospettoSerializzato.costiIndiretti\" ng-class=\"item.class\"><td><b>{{item.codice}}\n</b></td><td><b>{{item.descrizione}}</b></td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\">\n{{vm.preventivoProspetto.get(\'costiIndiretti.\'+item.path)[importo] | currency}}</td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">\n{{vm.preventivoProspetto.get(\'costiIndiretti.\'+item.path).totale | currency}}</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\"><div \nng-if=\"item.impegnato.voce\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"item.impegnato.voce[importo]\" size=\"15\" lang=\"it_IT\" type=\"number\" \nrequired> € </span><input ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\" type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{item.impegnato[importo] | currency}}\"></div><span ng-if=\"!item.impegnato.voce\">\n{{item.impegnato[importo] | currency}}</span></td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.impegnato.totale | currency}}\n</td><td class=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!totale\'\">\n<div ng-if=\"item.quietanzato.voce\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id == 1)\"><input style=\"width: 80%\" \nclass=\"text-right rendicontazioneInput\" ng-model=\"item.quietanzato.voce[importo]\" size=\"15\" lang=\"it_IT\" type=\"number\" \nrequired> € </span><input ng-if=\"(vm.datiRendicontazione.progettoRendicontazioneStato_id != 1)\" type=\"text\" \nstyle=\"width: 80%\" class=\"text-right rendicontazioneInput\" size=\"15\" disabled=\"disabled\" \nvalue=\"{{item.quietanzato.voce[importo] | currency}}\"></div><span ng-if=\"!item.quietanzato.voce\">\n{{item.quietanzato[importo] | currency}}</span></td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.indexOf(\'totale\') !== -1\">{{ item.quietanzato.totale | currency}}\n</td><td class=\"text-center\" ng-repeat=\"tipo in vm.tipi\">{{ item[tipo].percent | number:2}}%</td></tr><tr \nclass=\"md-blue-grey-500-bg\"><td></td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td \nclass=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.preventivoProspetto.costiComplessivi[importo] | currency}}</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.impegnato[importo] | currency}}</td><td class=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.quietanzato[importo] | currency}}</td><td class=\"text-center\" \nng-repeat=\"tipo in vm.tipi\">\n{{ (vm.datiRendicontazione.prospetto.costiComplessivi[tipo].totale / vm.preventivoProspetto.costiComplessivi.totale) * 100 | number:2}}%\n</td></tr></tbody></table></div><div \nng-if=\"[2,4].indexOf(vm.datiRendicontazione.progettoRendicontazioneTipo_id) !== -1\"><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><h2>Carica qui la documentazione</h2></div><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><sprardb-allegati-rendicontazione ng-model=\"vm.datiRendicontazione\" \nparams=\"{dettaglio: true}\" flex></sprardb-allegati-rendicontazione></div></div><div ng-if=\"vm.errors.length\" \nclass=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti</b></div><md-collapsible \nclass=\"md-accordion\"><md-collapsible-item><md-collapsible-header class=\"md-primary-bg\" layout=\"row\"><h2>Storico stato\n</h2><span style=\"font-size: x-small\">(Clicca qui per espandere)</span> <span flex></span></md-collapsible-header>\n<md-collapsible-body><md-table-container><table data-md-table md-progress=\"vm.datiRendicontazione.$promise\"><thead \nmd-head><tr md-row><th md-column><b>Stato Precedente</b></th><th md-column><b>Stato Successivo</b></th><th md-column>\n<b>Modificato il</b></th><th md-column><b>Modificato da</b></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.datiRendicontazione.storicoStato\"><td md-cell>{{item.prevStato.descrizione}}</td><td md-cell>\n{{item.nextStato.descrizione}}</td><td md-cell>{{item.timestamp*1000| date:\"medium\"}}</td><td md-cell><b>\n{{item.user.username }}</b></td></tr></tbody></table></md-table-container></md-collapsible-body></md-collapsible-item>\n</md-collapsible><div layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container \nclass=\"md-default-theme\" ng-if=\"vm.buttons[\'update-voci-costo\'].hidden === false\"><md-button type=\"submit\" \nclass=\"md-raised md-primary\" aria-label=\"Salva\" ng-click=\"vm.salva()\"><md-tooltip md-direction=\"top\">\nSalva in stato \"Bozza\". I dati non sono definitivi e dovranno essere validati dal responsabile di progetto.\n</md-tooltip>Salva in bozza</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"vm.buttons.invia.hidden === false\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Invia\" \nng-click=\"vm.invia()\" ng-disabled=\"vm.buttons.invia.disabled === true\"><md-tooltip md-direction=\"top\">\nStato \"Salvato\". I dati sono a disposizione dell\'ufficio Centrale.</md-tooltip>Valida e invia</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"vm.buttons.riapri.hidden === false\"><md-button\n type=\"button\" class=\"md-raised md-accent\" aria-label=\"Riapri\" ng-disabled=\"vm.buttons.riapri.disabled === true\" \nng-click=\"vm.riapri()\"><md-tooltip md-direction=\"top\">Riapertura in stato bozza operata da amministratori SC\n</md-tooltip>Riapri in bozza</md-button></md-input-container></div></form></div></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/progetto.html","<div id=\"rendicontazioneProgetto\" class=\"rendicontazioni page-layout simple right-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Stato della Rendicontazione</span></div>\n</div></div><div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" \nng-show=\"vm.progetto\" ms-scroll><div class=\"md-title mb-32\">{{vm.progetto.nome}}</div><div \nclass=\"simple-table-container md-whiteframe-2dp\"><table class=\"simple font-size-14\"><tr><td class=\"text-right\"><strong>\nRegione</strong></td><td>{{vm.progetto.istats.regione}}</td><td class=\"text-right\"><strong>Provincia</strong></td><td>\n{{vm.progetto.istats.provincia}}</td><td class=\"text-right\"><strong>Comune</strong></td><td>\n{{vm.progetto.istats.comune}}</td><td class=\"text-right\"><strong>Area</strong></td><td>{{vm.progetto.istats.area}}</td>\n</tr></table></div><md-divider></md-divider><div layout=\"row\" class=\"margin-top-16 padding-16 text-italic md-warn-bg\" \nng-if=\"!vm.setupId\">\nOccorre impostare i parametri della rendicontazione per questo progetto oppure selezionare l\'anno di riferimento</div>\n<div layout=\"row\" class=\"margin-top-16 padding-16 text-italic\" layout-align=\"center center\"><h3>\nSeleziona il periodo di riferimento di rendicontazione per i nuovi documenti:</h3><md-input-container flex width=\"50%\">\n<md-select name=\"setupSelect\" ng-model=\"vm.setupId\" ng-change=\"vm.cambiaAnnoSetup()\"><md-option \nng-repeat=\"item in vm.progetto.setup\" ng-value=\"item.id\">{{item.mesiAnniRendicontazione}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"margin-top-16 layout-row\" \nng-if=\"vm.visualizzaRendicontazione == true\"><button class=\"md-button md-ink-ripple md-default-theme\" \nng-click=\"vm.creaDocumento(1)\" ng-disabled=\"vm.disableBtn[1]\" aria-label=\"Nuovo Preventivo\"><md-icon \nmd-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Nuovo preventivo</span></button> <button \nclass=\"md-button md-ink-ripple md-default-theme\" ng-click=\"vm.creaDocumento(4)\" ng-disabled=\"vm.disableBtn[4]\" \naria-label=\"Nuovo SAL\"><md-icon md-font-icon=\"icon-library-plus\" \nclass=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" aria-hidden=\"true\"></md-icon><span \nclass=\"ng-scope\">NUOVO SAL</span></button> <button class=\"md-button md-ink-ripple md-default-theme\" \nng-click=\"vm.creaDocumento(2)\" ng-disabled=\"vm.disableBtn[2]\" aria-label=\"Nuova rimodulazione\"><md-icon \nmd-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Nuova rimodulazione</span></button> <button \nclass=\"md-button md-ink-ripple md-default-theme\" ng-click=\"vm.creaDocumento(3)\" ng-disabled=\"vm.disableBtn[3]\" \naria-label=\"Nuova Rendicontazione Consuntiva\"><md-icon md-font-icon=\"icon-library-plus\" \nclass=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" aria-hidden=\"true\"></md-icon><span \nclass=\"ng-scope\">Nuova rendicontazione</span></button></div><md-divider></md-divider><br><div \nclass=\"simple-table-container md-whiteframe-2dp\"><div class=\"table-title\">Documenti finanziari per questo progetto\n</div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>TIPO</b>\n</th><th><b>ANNO</b></th><th><b>PERIODO</b></th><th><b>STATO</b></th><th><b>AZIONI</b></th></tr></thead><tbody><tr \nng-repeat=\"rendicontazione in vm.progetto.documentiRendicontazione\"><td>&nbsp;&nbsp;&nbsp;<b><a>\n{{rendicontazione.tipo.descrizione | uppercase}}</a></b></td><td>{{rendicontazione.anno}}</td><td>\n{{rendicontazione.setup.mesiAnniRendicontazione}}</td><td>{{rendicontazione.stato.descrizione | uppercase}}</td><td>\n<section layout=\"row\" layout-sm=\"column\" layout-wrap><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"dettaglio\" ng-click=\"vm.gotoRendicontazione(rendicontazione.id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>MOD >></md-button></section></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/rendicontazione.html","<div id=\"rendicontazione\" class=\"rendicontazioni page-layout simple right-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.backToRendicontazioni()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-text\">Rendicontazione</span></div></div></div>\n<div class=\"content\" md-background-bg flex layout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><div \nclass=\"md-title\"><b>Modifica documento di Rendicontazione Finale <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id == 5\">(INTEGRAZIONE)</span></b>\n per {{vm.datiRendicontazione.progetto.nome}} <small>({{vm.datiRendicontazione.setup.mesiAnniRendicontazione}})</small>\n ({{vm.datiRendicontazione.codiceProgetto}})<md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progetto.id})\" ng-if=\"!vm.api.isRevisore\">\n<md-icon md-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO</md-button></div><div \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 3\"><b>{{vm.datiRendicontazione.stato.descrizione}} \n<span ng-if=\"vm.datiRendicontazione.inviato_at > 0\">\nin data {{vm.datiRendicontazione.inviato_at*1000 | date : \"medium\"}} </span></b><span \nng-if=\"vm.datiRendicontazione.statoArchiviazioneId > 1\" style=\"color:red;font-size:large\">\n&nbsp;{{ vm.datiRendicontazione.statoArchiviazione.descrizione }}</span></div><div \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 6\"><b>{{vm.datiRendicontazione.stato.descrizione}} \n<span ng-if=\"vm.datiRendicontazione.validato_at > 0\">\nin data {{vm.datiRendicontazione.validato_at*1000 | date : \"medium\"}}</span></b></div><md-divider></md-divider><div \nlayout=\"row\"><ms-form-wizard flex><div class=\"ms-stepper-horizontal\"><md-tabs md-dynamic-height \nmd-selected=\"vm.selectedIndex\" md-center-tabs=\"true\"><md-tab ng-if=\"vm.steps.registro\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">{{vm.steps.registro}}</span> \n<span class=\"ms-form-wizard-step-text\">Registro Generale delle Spese</span></span></md-tab-label><md-tab-body><div \nlayout=\"column\" layout-margin><div id=\"prorogaprosecuzione\" \nng-if=\"(vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5) && vm.datiRendicontazione.modo.prorogaTecnica\"><h3 \nflex layout=\"row\">\nCliccare su entrambe le voci SOLO SE NEL {{vm.datiRendicontazione.progettoParametriRendicontazione.anno}} l\'ente locale ha fatto ricorso alla proroga prima della prosecuzione (nuovo affidamento). Altrimenti scegliere proroga tecnica o prosecuzione, secondo il caso che vi riguarda.\n<br>\nLo status di proroga tecnica e prosecuzione dovrebbe corrispondere a quanto dichiarato nel documento di rimodulazione.\n</h3><div flex layout=\"row\"><md-checkbox ng-model=\"vm.datiRendicontazione.prorogaTecnica\" aria-label=\"Proroga tecnica\" \nname=\"prorogaTecnica\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in proroga tecnica</small>\n</md-checkbox><md-checkbox ng-model=\"vm.datiRendicontazione.prosecuzione\" aria-label=\"Proroga tecnica\" \nname=\"prosecuzione\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3\"><small>Progetto in prosecuzione</small>\n</md-checkbox></div><span flex layout=\"row\" style=\"padding: 8px 24px; background-color:#CCCCCC\" \nng-if=\"vm.datiRimodulazione.prosecuzione !== vm.datiRendicontazione.prosecuzione || vm.datiRimodulazione.prorogaTecnica !== vm.datiRendicontazione.prorogaTecnica\">\nAttenzione! E’ stata scelta un’opzione diversa da quella indicata in sede di rimodulazione. E’ necessario provvedere alla modifica per poter proseguire.\n<div style=\"float:left; width:100%; text-align:center; font-weight:bold\" \nng-if=\"vm.datiRimodulazione.prorogaTecnica == 1\">Proroga tecnica in rimodulazione: SI<br><md-icon \nmd-font-icon=\"icon-check\" style=\"color:green\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prorogaTecnica != 1\">\nProroga tecnica in rimodulazione: NO<br><md-icon md-font-icon=\"icon-close\" style=\"color:red\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prosecuzione == 1\">\nProsecuzione in rimodulazione: SI<br><md-icon md-font-icon=\"icon-check\" style=\"color:green\"></md-icon></div><div \nstyle=\"float:left; width:100%; text-align:center; font-weight:bold\" ng-if=\"vm.datiRimodulazione.prosecuzione != 1\">\nProsecuzione in rimodulazione: NO<br><md-icon md-font-icon=\"icon-close\" style=\"color:red\"></md-icon></div></span></div>\n<h2 ng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\">Registro Generale delle Spese</h2><div \nlayout=\"row\" class=\"margin-top-16 layout-row\" ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 1\">\n<button ng-click=\"vm.openVoceRegistroSpeseDialog(vm.jsonModel.items.item, 0)\" \nclass=\"md-button md-accent md-raised md-ink-ripple md-default-theme\" type=\"button\" aria-label=\"Nuova rimodulazione\">\n<md-icon md-font-icon=\"icon-library-plus\" class=\"ng-scope md-font icon-library-plus material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><span class=\"ng-scope\">Aggiungi voce di spesa</span></button></div><form layout=\"row\" \nlayout-wrap layout-align=\"space-between\" ng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\">\n<md-input-container><md-datepicker datepicker-validation-fix ng-model=\"vm.filterModel.dataDocumento[\'>=\']\" \nng-model-options=\"{timezone: \'GMT\'}\" placeholder=\"Data Doc. Dal\" md-hide-icons=\"calendar\" name=\"dataDal\" \nstartview=\"year\" date-input-format></md-datepicker></md-input-container><md-input-container \nclass=\"datepicker-container\"><md-datepicker datepicker-validation-fix ng-model=\"vm.filterModel.dataDocumento[\'<\']\" \nng-model-options=\"{timezone: \'GMT\'}\" placeholder=\"Data Doc. Al\" md-hide-icons=\"calendar\" startview=\"year\" \ndate-input-midnight></md-datepicker></md-input-container><md-input-container><label>Codice spesa</label><md-select \nng-model=\"vm.filterModel.codiceSpesaId\"><md-option value=\"\">Tutti</md-option><md-option class=\"small\" \nng-repeat=\"codice in vm.liste.codiciSpesa | filter: \'!~\'\" value=\"{{codice.id}}\" ng-disabled=\"codice.nonAggiornabile\">\n{{codice.codice}}</md-option></md-select></md-input-container><md-input-container class=\"datepicker-container\">\n<md-datepicker datepicker-validation-fix ng-model=\"vm.filterModel.dataPagamento[\'>=\']\" \nng-model-options=\"{timezone: \'GMT\'}\" placeholder=\"Data Pag. Dal\" md-hide-icons=\"calendar\" name=\"dataDal\" \nstartview=\"year\" date-input-format></md-datepicker></md-input-container><md-input-container \nclass=\"datepicker-container\"><md-datepicker datepicker-validation-fix ng-model=\"vm.filterModel.dataPagamento[\'<\']\" \nng-model-options=\"{timezone: \'GMT\'}\" placeholder=\"Data Pag. Al\" md-hide-icons=\"calendar\" startview=\"year\" \ndate-input-midnight></md-datepicker></md-input-container><md-input-container flex><input placeholder=\"Imp. Totale\" \ntype=\"text\" ng-model=\"vm.filterModel.importoTotaleDocumento\" ui-money-mask ui-negative-number ui-currency-after>\n</md-input-container><md-input-container flex=\"15\"><input placeholder=\"Imp. Imputato Progetto\" type=\"text\" \nng-model=\"vm.filterModel.importoImputatoProgetto\" ui-money-mask ui-negative-number ui-currency-after>\n</md-input-container><div layout=\"row\" flex flex-gt-md=\"20\" style=\"min-width:200px\"><span flex></span><md-button \ntype=\"submit\" ng-click=\"vm.caricaVociSpesa();\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small>\n</md-button><md-button ng-click=\"vm.initSearch()\"><small>Reset</small></md-button></div></form><md-table-container \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\"><table data-md-table \ndata-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.vociSpesa.$promise\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head md-on-reorder=\"vm.caricaVociSpesa\" \nmd-order=\"vm.sort\"><tr md-row><th md-column><b>N. Progressivo</b></th><th md-column md-order-by=\"progressivo\"><b>\nCodice ID</b></th><th md-column md-order-by=\"numeroDocumento\"><b>Num. del doc.</b></th><th md-column \nmd-order-by=\"dataDocumento\"><b>Data del doc.</b></th><th md-column><b>Codice spesa</b></th><th md-column \nmd-order-by=\"dataPagamento\"><b>Data del pag.</b></th><th md-column md-order-by=\"importoTotaleDocumento\"><b>Imp. Totale\n</b></th><th md-column ng-if=\"vm.datiRendicontazione.modo.cofinanziamento\" md-order-by=\"importoCofinanziato\"><b>\nImp. Cofin.</b></th><th md-column ng-if=\"vm.datiRendicontazione.anno < 2023\" md-order-by=\"importoCofinanziato\"><b>\nImp. Fin.</b></th><th md-column md-order-by=\"importoImputatoProgetto\"><b>Imp. Imputato Prog.</b></th><th md-column><b>\nAzioni</b></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vm.vociSpesa.data\" ng-disabled=\"true\"><td \nmd-cell class=\"grey-500-fg\">{{vm.totalCount - (vm[\'per-page\']*(vm.page-1)) - $index}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\">{{item.progressivo}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\">{{item.numeroDocumento}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\">{{item.dataDocumento| date:\"dd/MM/yyyy\"}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\"><b>{{item.codiceSpesa.codice }}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\"><b>{{item.dataPagamento| date:\"dd/MM/yyyy\"}}</b></td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\">{{item.importoTotaleDocumento| currency}}</td><td md-cell \nng-if=\"vm.datiRendicontazione.modo.cofinanziamento\" ng-class=\"{\'grey-500-fg\': item.attivo == 0}\">\n{{item.importoCofinanziato| currency}}</td><td md-cell ng-if=\"vm.datiRendicontazione.anno < 2023\" \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\">{{item.importoFinanziato| currency}}</td><td md-cell \nng-class=\"{\'grey-500-fg\': item.attivo == 0}\"><b>{{item.importoImputatoProgetto| currency}}</b></td><td md-cell \nstyle=\"text-align: center\"><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-if=\"(vm.api.isAdmin || vm.api.isRendicontazione || vm.api.isAmministratore || vm.api.isOperatore || vm.api.isRendicontatore || vm.api.isRevisore || vm.api.isVisitatore)\">\n</md-icon></md-button><md-menu-content style=\"height:300px;min-width:400px\"><div \nng-style=\"{overflow:\'scroll\',height:\'inherit\'}\"><md-menu-item ng-init=\"params = {voceSpesa: item, dettaglio: false}\">\n<sprardb-allegati-rendicontazione ng-model=\"vm.datiRendicontazione\" params=\"params\" flex>\n</sprardb-allegati-rendicontazione></md-menu-item></div><div class=\"row\" \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 3\"><md-menu-item class=\"\"><md-button \nclass=\"md-accent md-button-icon\" ng-click=\"vm.openVoceRegistroSpeseDialog(item, 1)\" aria-label=\"Modifica\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>MOD >></md-button></md-menu-item><md-menu-item class=\"\"><md-button \nclass=\"md-button-icon md-primary\" aria-label=\"Elimina\" ng-click=\"vm.deleteVoceRegistroSpeseDialog(item)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon>ELIMINA</md-button></md-menu-item></div></md-menu-content></md-menu></td></tr>\n</tbody></table></md-table-container><md-table-pagination \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\" md-limit=\"vm[\'per-page\']\" \nmd-limit-options=\"[1,10,25,50]\" md-page=\"vm.page\" md-total=\"{{vm.totalCount}}\" md-on-paginate=\"vm.caricaVociSpesa\" \nmd-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><h2>Carica qui la documentazione</h2></div><div layout=\"row\" \nclass=\"margin-top-16 layout-row\"><sprardb-allegati-rendicontazione flex ng-model=\"vm.datiRendicontazione\" \nparams=\"{dettaglio: true, modoRevisione: vm.modoRevisione}\"></sprardb-allegati-rendicontazione></div></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.steps.prospetto\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"!vm.errors.length\">{{vm.steps.prospetto}}</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"vm.errors.length\"><i class=\"icon-exclamation\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Prospetto di Rendicontazione Finale</span></span></md-tab-label><md-tab-body><div \nlayout=\"column\" layout-margin><h2 ng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id == 5\">\nIl prospetto di rendicontazione in dettaglio è disponibile nella pratica principale</h2><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneTipo_id != 5\"><h2>Prospetto di Rendicontazione Finale</h2><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th><th><b>\nDESCRIZIONE SPESA</b></th><th class=\"text-right\" ng-if=\"vm.datiRendicontazione.modo.cofinanziamento\"><b>\nIMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>CONTRIBUTO RICHIESTO</b></th><th class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.importiPreventivo.length > 1\"><b>COSTO TOTALE PROGETTO</b></th><th \nclass=\"text-center\"><b>ERRORI</b></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.prospettoSerializzato.costiDiretti\" ng-class=\"item.class\"><td><b \nng-show=\"item.codice.charAt(0) !== \'~\'\">{{item.codice}}</b></td><td><b>{{item.descrizione}}</b></td><td \nclass=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"><b \nng-show=\"item.codice.charAt(0) !== \'~\' && !item.isDisabled\">{{ item[importo] | currency }}</b></td><td \nclass=\"text-center error-container\" id=\"{{item.path}}\"></td></tr><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COSTI DIRETTI</td><td class=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\">\n{{ vm.datiRendicontazione.prospetto.costiDiretti[importo] | currency }}</td><td class=\"text-center error-container\" \nid=\"costiDiretti\"></td></tr><tr ng-repeat=\"item in vm.prospettoSerializzato.costiIndiretti\" ng-class=\"item.class\"><td>\n<b ng-show=\"item.codice.charAt(0) !== \'~\'\">{{item.codice}}</b></td><td><b>{{item.descrizione}}</b></td><td \nclass=\"text-right\" ng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo\"><b \nng-show=\"item.codice.charAt(0) !== \'~\' && !item.isDisabled\">{{ item[importo] | currency }}</b></td><td \nclass=\"text-center error-container\" id=\"{{item.path}}\"></td></tr></tbody><tfoot><tr class=\"md-blue-grey-500-bg\"><td>\n</td><td>TOTALE COMPLESSIVO (COSTI DIRETTI + COSTI INDIRETTI)</td><td class=\"text-right\" \nng-if=\"vm.datiRendicontazione.modo.cofinanziamento\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.importoCofinanziato | currency }}<br>\n{{ vm.datiRendicontazione.prospetto.costiComplessivi.percentCofinanziamento | number}}% sul totale</td><td \nclass=\"text-right\" \nng-repeat=\"importo in vm.datiRendicontazione.modo.importiPreventivo | filter: \'!importoCofinanziato\'\">\n{{ vm.datiRendicontazione.prospetto.costiComplessivi[importo] | currency}}</td><td class=\"text-center\"><span \nid=\"percentCofinanziamento\" class=\"error-container\"></span> <span id=\"costiComplessivi\" class=\"error-container\"></span>\n</td></tr></tfoot></table></div></span></div></md-tab-body></md-tab><md-tab ng-if=\"vm.steps.status\"><md-tab-label><span\n class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">{{vm.steps.status}}</span> \n<span class=\"ms-form-wizard-step-text\">Status e conferma</span></span></md-tab-label><md-tab-body><md-table-container>\n<table data-md-table><thead md-head><tr md-row><th md-column><b>Stato Precedente</b></th><th md-column><b>\nStato Successivo</b></th><th md-column><b>Modificato il</b></th><th md-column><b>Modificato da</b></th></tr></thead>\n<tbody md-body><tr md-row ng-repeat=\"item in vm.datiRendicontazione.storicoStato\"><td md-cell>\n{{item.prevStato.descrizione}}</td><td md-cell>{{item.nextStato.descrizione}}</td><td md-cell>\n{{item.timestamp*1000| date:\"medium\"}}</td><td md-cell><b>{{item.user.username }}</b></td></tr></tbody></table>\n</md-table-container><div layout=\"row\" layout-margin><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id < 3\"><h1>Status della rendicontazione</h1>\nLa rendicontazione finale è in preparazione o in attesa di chiusura e approvazione da parte dell\'amministratore di progetto. \n</span><span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 3 || vm.datiRendicontazione.progettoRendicontazioneStato_id == 5\">\n<h1>Conferma di inoltro finale</h1>\nIl bilancio consuntivo finale è stato inoltrato con tutti gli allegati al Servizio Centrale <span \nng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id === 3 && vm.datiRendicontazione.inviato_at > 0\">\nin data {{vm.datiRendicontazione.inviato_at*1000 | date : \"medium\"}}</span>\n. Verrà presto verificato da un operatore. Il codice di riferimento da usare per eventuali comunicazioni è il seguente:\n<h2>\nPR-{{vm.datiRendicontazione.progetto_id}}/{{vm.datiRendicontazione.id}}/{{vm.datiRendicontazione.setup.mesiAnniRendicontazione}}\n</h2></span><span ng-if=\"vm.datiRendicontazione.progettoRendicontazioneStato_id == 4\"><h1>Status della rendicontazione\n</h1>\nUn\'integrazione dei documenti è stata richiesta dal servizio centrale. Usare lo step successivo per caricare i file integrativi\n</span></div></md-tab-body></md-tab><md-tab ng-if=\"vm.steps.revisione\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">{{vm.steps.revisione}}</span> \n<span class=\"ms-form-wizard-step-text\">Revisione</span></span></md-tab-label><md-tab-body><form novalidate \nlayout=\"row\" layout-margin name=\"vm.revisioneForm\" class=\"mt-15\"><md-input-container flex class=\"p-8\"><label \nng-class=\"{\'md-warn-fg\': (vm.datiRevisione.costoApprovato.$invalid)}\"><b>Costo Approvato</b></label><input \nname=\"costoApprovato\" ng-model=\"vm.datiRevisione.costoApprovato\" readonly=\"readonly\" type=\"text\" lang=\"it_IT\" required \nui-money-mask ui-currency-after><div ng-messages=\"vm.revisioneForm.costoApprovato.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il numero è richiesto.</span></div></div></md-input-container><md-input-container flex \nclass=\"p-8\"><label ng-class=\"{\'md-warn-fg\': (vm.datiRevisione.costoComplessivo.$invalid)}\"><b>\nCosto Complessivo Rendicontato</b></label><input name=\"costoComplessivo\" ng-model=\"vm.datiRevisione.costoComplessivo\" \nreadonly=\"readonly\" type=\"text\" lang=\"it_IT\" required ui-money-mask ui-currency-after><div \nng-messages=\"vm.revisioneForm.costoComplessivo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl numero è richiesto.</span></div></div></md-input-container><md-input-container flex class=\"p-8\"><label><b>\nSpese Ammissibili dal Revisore</b></label><input name=\"speseAmmissibili\" ng-model=\"vm.datiRevisione.speseAmmissibili\" \nng-blur=\"vm.updateRevisione()\" ng-readonly=\"vm.datiRendicontazione.progettoRendicontazioneStato_id != 6\" type=\"text\" \nlang=\"it_IT\" ui-money-mask ui-currency-after></md-input-container></form><div layout=\"row\" layout-margin>\n<sprardb-allegati-rendicontazione ng-model=\"vm.datiRendicontazione\" \nparams=\"{dettaglio: true, modoRevisione: 1, revisione: 1, buttonObj: vm, buttonKey: \'revisioneButtons\'}\" flex>\n</sprardb-allegati-rendicontazione></div></md-tab-body></md-tab><md-tab ng-if=\"vm.steps.documenti\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">{{vm.steps.documenti}}</span> \n<span class=\"ms-form-wizard-step-text\">Riepilogo documenti e integrazioni</span></span></md-tab-label><md-tab-body><div\n layout=\"row\" layout-margin><sprardb-allegati-rendicontazione ng-model=\"vm.datiRendicontazione\" \nparams=\"{dettaglio: true}\" flex></sprardb-allegati-rendicontazione></div></md-tab-body></md-tab></md-tabs></div>\n</ms-form-wizard></div><div ng-if=\"vm.errors.length\" class=\"red-600-fg padding-top-16 padding-left-16\"><b>\nSono presenti degli errori, non è possibile validare senza averli corretti. Verifica il Prospetto di Rendicontazione Finale.\n</b></div><div><p>I dati vengono salvati in automatico dopo ogni inserimento</p></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"layout-gt-xs-row layout-column\"><md-input-container class=\"md-default-theme\" \nng-if=\"!vm.buttons[\'conferma-validazione\'].hidden\"><md-button type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.confermaValidazione();\" ng-disabled=\"vm.buttons[\'conferma-validazione\'].disabled\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">\nLa rendicontazione finale sarà validata. Non potranno più essere apportate modifiche.</md-tooltip>Valida</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"!vm.buttons.invia.hidden\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.invia();\" \nng-disabled=\"vm.buttons.invia.disabled || (!!vm.datiRevisione && vm.revisioneForm.$invalid)\"><md-icon \nmd-font-icon=\"icon-send\"></md-icon><md-tooltip md-direction=\"top\">\nLa rendicontazione finale sarà inviata definitivamente unitamente al certificato del revisore. Non potranno più essere apportate modifiche.\n</md-tooltip>Invia</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"vm.datiRendicontazione.stato.id == 3 && !vm.buttons.invia.hidden\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" ng-click=\"vm.annullaInvio();\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><md-tooltip \nmd-direction=\"top\">Annulla l\'invio e riporta in stato di validazione</md-tooltip>Annulla Invio</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"!vm.buttons.riapri.hidden\"><md-button \ntype=\"button\" class=\"md-raised md-warn\" aria-label=\"Salva\" ng-click=\"vm.riapri();\" \nng-disabled=\"vm.buttons.riapri.disabled\"><md-tooltip md-direction=\"top\">\nRiapertura in stato bozza operata da amministratori SC</md-tooltip>Riapri in bozza</md-button></md-input-container>\n<md-input-container class=\"md-default-theme\" ng-if=\"!vm.buttons[\'chiudi-integrazione\'].hidden\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.chiudiIntegrazione();\" \nng-disabled=\"vm.buttons[\'chiudi-integrazione\'].disabled\"><md-icon md-font-icon=\"icon-check-all\"></md-icon><md-tooltip \nmd-direction=\"top\">Chiusura integrazione</md-tooltip>INTEGRAZIONE TERMINATA</md-button></md-input-container>\n<md-input-container class=\"md-default-theme\" ng-if=\"!vm.buttons[\'apri-integrazione\'].hidden\"><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Riapertura per integrazione\" ng-click=\"vm.apriIntegrazione();\" \nng-disabled=\"vm.buttons[\'apri-integrazione\'].disabled\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Riapertura per integrazione</md-tooltip>APRI PRATICA DI INTEGRAZIONE</md-button>\n</md-input-container><md-input-container class=\"md-default-theme\" ng-if=\"!vm.buttons.messaggi.hidden\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Salva\" ng-click=\"vm.mostraMessaggi();\" \nng-disabled=\"vm.buttons.messaggi.disabled\"><md-icon md-font-icon=\"icon-message\"></md-icon><md-tooltip \nmd-direction=\"top\">Mostra i messaggi</md-tooltip>MESSAGGI</md-button></md-input-container><md-input-container \nclass=\"md-default-theme\"><md-button class=\"md-accent\" aria-label=\"Vai\" \nui-sref=\"app.sprardb_progetti_progetti_progetto({id:vm.datiRendicontazione.progetto.id})\" ng-if=\"!vm.api.isRevisore\">\n<md-icon md-font-icon=\"icon-link\"></md-icon>VAI AL PROGETTO</md-button></md-input-container></div></div></div></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/schema_rendicontazione.html","<table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th><b>COD.</b></th><th><b>DESCRIZIONE SPESA</b></th><th \nclass=\"text-right\"><b>IMPORTO COFINANZIATO</b></th><th class=\"text-right\"><b>CONTRIBUTO RICHIESTO</b></th><th \nclass=\"text-right\"><b>COSTO TOTALE PROGETTO</b></th></tr></thead><tfoot><tr class=\"md-blue-grey-500-bg\"><td></td><td>\nTOTALE COSTI DIRETTI</td><td class=\"text-right\">{{ vm.getTotal()[\'importi\'][\'importoCofinanziato\']}} €</td><td \nclass=\"text-right\">{{ vm.getTotal()[\'importi\'][\'contributoRichiesto\']}} €</td><td class=\"text-right\">\n{{ vm.getTotal()[\'importi\'][\'totale\']}} € &nbsp;&nbsp;&nbsp;&nbsp;</td></tr></tfoot><tbody><tr \nng-repeat-start=\"item in vm.datiRendicontazione.jsonDataToPhp.data\" class=\"md-blue-grey-200-bg\"><td><b>\n{{item.id}}_TOTALE</b></td><td><b>{{item.label}}</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'importoCofinanziato\']}} €</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'contributoRichiesto\']}} €</b></td><td class=\"text-right\"><b>\n{{ vm.getTotal()[item.id][\'importi\'][\'totale\']}} €</b></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"subitem in item.items\">\n<td>{{subitem.id}}</td><td>{{subitem.label}}</td><td class=\"text-right\" ng-repeat=\"subsubitem in subitem.fields\"><input\n type=\"text\" style=\"border: 1px solid #aaaaaa; padding: 5px; border-radius: 2px; background-color: #eeeeee\" \nclass=\"text-right\" ng-model=\"subsubitem.value\" size=\"10\" required> €</td><td class=\"text-right\">\n{{ vm.getTotal()[item.id][subitem.id][\'importi\'][\'totale\']}} €</td></tr></tbody></table>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/sprardb-allegati-rendicontazione.html","<md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"ricarica\" ng-click=\"vmd.carica()\" \nng-if=\"vmd.params.dettaglio\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>AGGIORNA</md-button><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" ng-if=\"vmd.buttonObj[vmd.buttonKey].create.hidden === false\" \naria-label=\"Add file\" ng-click=\"vmd.openUpload($event)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>\nCARICA UN FILE</md-button><md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancellati\" \nng-click=\"vmd.visibile = (vmd.visibile == 0) ? 1 : 0;vmd.carica();\" \nng-if=\"!vmd.buttonObj[vmd.buttonKey][\'mostra-cancellati\'].hidden\"><md-icon ng-if=\"!vmd.visibile\" \nmd-font-icon=\"icon-eye\"></md-icon><md-icon ng-if=\"vmd.visibile\" md-font-icon=\"icon-eye-off\"></md-icon><span \nng-if=\"vmd.visibile\">MOSTRA CANCELLATI</span> <span ng-if=\"!vmd.visibile\">MOSTRA VISIBILI</span></md-button><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" ng-if=\"vmd.params.dettaglio\" aria-label=\"Scarica\" \nng-click=\"vmd.csvAllegati()\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon>SCARICA LISTA FILE</md-button><form \nlayout=\"row\" layout-wrap layout-align=\"space-between\" ng-if=\"vmd.params.dettaglio\"><md-input-container><input \nplaceholder=\"Identificativo\" type=\"text\" ng-model=\"vmd.filterModel[\'allegatoRendicontazione.id\']\"></md-input-container>\n<md-input-container><input placeholder=\"Nome file\" type=\"text\" ng-model=\"vmd.filterModel[\'documento.nomefile\'].like\">\n</md-input-container><md-input-container><label>Tipologia</label><md-select \nng-model=\"vmd.filterModel[\'documento.documentoTipo_id\']\"><md-option value=\"\">Tutti</md-option><md-option \nvalue=\"{{tipo.id}}\" ng-repeat=\"tipo in vmd.tipoDocumentoList | filter: vmd.tipoDocumentoFilter | orderBy: \'ordine\'\" \nclass=\"small\">{{tipo.tipo}}</md-option></md-select></md-input-container><md-input-container><md-datepicker \ndatepicker-validation-fix ng-model=\"vmd.filterModel[\'documento.data\'][\'>=\']\" ng-model-options=\"{timezone: \'GMT\'}\" \nplaceholder=\"Dal\" name=\"dataDal\" startview=\"year\" date-input-format></md-datepicker></md-input-container>\n<md-input-container><md-datepicker datepicker-validation-fix name=\"dataAl\" \nng-model=\"vmd.filterModel[\'documento.data\'][\'<\']\" ng-model-options=\"{timezone: \'GMT\'}\" placeholder=\"Al\" flex=\"100\" \nstartview=\"year\" date-input-midnight></md-datepicker></md-input-container><div layout=\"row\" flex flex-gt-md=\"20\" \nstyle=\"min-width:200px\"><span flex></span><md-button type=\"submit\" ng-click=\"vmd.carica();\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button><md-button ng-click=\"vmd.initFilterModel()\">\n<small>Reset</small></md-button></div></form><md-card style=\"padding-top:0px\" ng-if=\"vmd.params.dettaglio\">\n<md-table-container><table data-md-table md-progress=\"vmd.allegati.$promise\"><thead ng-if=\"!vmd.options.decapitate\" \nmd-head><tr md-row><th md-column>IDENTIF</th><th md-column>NOME FILE</th><th md-column>TIPOLOGIA</th><th md-column>\nDATA CARICAMENTO</th><th md-column ng-if=\"vmd.buttonObj[vmd.buttonKey].update.hidden === false\">AZIONE</th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"(key, item) in vmd.allegati.data\"><td md-cell><div layout=\"column\"><span>\n{{item.id}}</span></div></td><td md-cell class=\"light-blue-900-fg font-weight-600\"><span \nng-if=\"vmd.datiRendicontazione.statoArchiviazioneId > 3\">{{item.documento.nomefile}} </span><a \nng-if=\"vmd.datiRendicontazione.statoArchiviazioneId < 4\" title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.api.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase | limitTo:40}}</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ item.documento.documentoTipo.tipo | uppercase}}</td><td md-cell>\n{{ item.documento.data | date:\"dd/MM/yyyy HH:mm:ss\" : \'GMT\'}}</td><td md-cell \nng-if=\"vmd.buttonObj[vmd.buttonKey].update.hidden === false\"><md-button \nclass=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Cancella\" ng-if=\"(item.visibile == 1)\" \nng-click=\"vmd.cancelladocumento(item.id, 0)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Cancella il file</md-button>\n<md-button class=\"add-file-button md-accent md-grey-100-bg\" aria-label=\"Ripristina\" \nng-if=\"(vmd.api.isAdmin && item.visibile == 0)\" ng-click=\"vmd.cancelladocumento(item.id, 1)\"><md-icon \nmd-font-icon=\"icon-undo\"></md-icon>Ripristina il file</md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vmd.perPage\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"vmd.page\" \nmd-total=\"{{vmd.totalCount}}\" md-on-paginate=\"vmd.carica\" md-boundary-links=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card><div \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"!vmd.params.dettaglio\" ng-repeat=\"item in vmd.allegati.data\">\n<small><span ng-if=\"vmd.datiRendicontazione.statoArchiviazioneId > 3\">\n{{item.documento.nomefile | uppercase | limitTo:20}} </span><a \nng-if=\"vmd.datiRendicontazione.statoArchiviazioneId < 4\" title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.api.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\"><b>\n{{ item.documento.nomefile | uppercase|limitTo:20}}</b> </a>({{ item.documento.documentoTipo.tipo | uppercase}})\n</small><md-button layout=\"row\" layout-align=\"center\" class=\"md-mini\" aria-label=\"Cancella\" \nng-click=\"vmd.cancelladocumento(item.id, 0)\" \nng-if=\"item.visibile == 1 && vmd.buttonObj[vmd.buttonKey].update.hidden === false\"><md-icon md-font-icon=\"icon-trash\" \nstyle=\"margin:5px\"></md-icon></md-button></div>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/upload-dialog.html","<md-dialog aria-label=\"uploadDialog4\" id=\"uploaddialog4\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUpload documento RENDICONTAZIONE</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmdd.closeDialog()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"max-width:800px;max-height:810px;min-width: 520px\" \nclass=\"no-padding\"><form id=\"uploadForm\" class=\"padding-16\"><div layout=\"column\" layout-gt-md=\"row\"><md-input-container\n flex class=\"margin-bottom-0 margin-top-4\" flex><label>Scegli un tipo documento</label><md-select \nname=\"documentoTipo_id\" ng-model=\"vmdd.documento.documentoTipo_id\" required flex><md-option \nng-repeat=\"item in vmdd.tipoDocumentoList | filter: vmdd.tipoDocumentoFilter | orderBy: \'ordine\'\" value=\"{{item.id}}\" \nng-selected=\"item.id == vmdd.params.documentoTipo_id\"><small><strong>{{item.tipo}}</strong></small></md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div id=\"file\" \nflow-init=\"vmdd.ngFlowOptions\" flow-name=\"vmdd.ngFlow.flow\" flow-files-submitted=\"vmdd.upload()\" \nflow-file-added=\"vmdd.fileAdded($file)\" flow-file-success=\"vmdd.fileSuccess($file, $message)\" \nflow-complete=\"vmdd.uploadComplete()\" flow-progress=\"vmdd.fileprogress()\" \nflow-error=\"vmdd.fileerror($file, $message, $flow)\" flex><md-button flow-btn \nclass=\"add-file-button md-accent md-grey-100-bg\" style=\"width: 100%\" ng-disabled=\"!vmdd.documento.documentoTipo_id\" \nng-if=\"!vmdd.inprogress\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon>Allega un file</md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" id=\"toolbar-progress\" class=\"md-accent\" ng-disabled=\"!vmdd.inprogress\">\n</md-progress-linear></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/rendicontazioni/rendicontazionemc/voceRegistroSpese-dialog.html","<md-dialog aria-label=\"Aggiungi una voce al Registro Generale delle Spese\" style=\"width: 80%\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Aggiungi una voce al Registro Generale delle Spese</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"100\"><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"voceRendicontazioneForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Numero documento</label><input type=\"text\" name=\"numeroDocumento\" \nng-model=\"vmd.voceSpesa.numeroDocumento\" placeholder=\"Numero del documento\" ng-pattern=\"/^\\S*$/\" required><div \nng-messages=\"voceRendicontazioneForm.numeroDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span></div><div ng-message=\"pattern\"><span>\nIl numero di documento può contenere lettere, numeri e caratteri speciali, ma non gli spazi</span></div></div>\n</md-input-container><div class=\"datepicker-container\" style=\"font-size:12px;margin-left:40px\" flex><label flex \nstyle=\"max-height: 22px\">Data del documento *</label><br><md-datepicker datepicker-validation-fix \nng-model=\"vmd.voceSpesa.dataDocumento\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" \nng-required=\"true\" flex=\"100\" name=\"dataDocumento\" startview=\"year\"></md-datepicker><div \nng-messages=\"voceRendicontazioneForm.dataDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span \nstyle=\"color:rgb(213,0,0)\">La data del documento è obbligatoria</span></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Natura del documento giustificativo</label><md-select \nname=\"naturaDocumentoId\" ng-model=\"vmd.voceSpesa.naturaDocumentoId\" required><md-option ng-value=\"naturaDocumento.id\" \nng-repeat=\"naturaDocumento in vmd.liste.naturaDocumento\" maxlength=\"10\">{{ naturaDocumento.label}}</md-option>\n</md-select><div ng-messages=\"voceRendicontazioneForm.naturaDocumento.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>E\' indispensabile inserire questo campo.</span></div></div></md-input-container><md-input-container flex><label>\nCodice spesa</label><md-select name=\"codiceSpesaId\" ng-model=\"vmd.voceSpesa.codiceSpesaId\" required><md-option \nng-value=\"codice.id\" ng-repeat=\"codice in vmd.liste.codiciSpesa\" ng-disabled=\"codice.nonAggiornabile\" maxlength=\"10\">\n<span ng-if=\"codice.codice.charAt(0) !== \'~\'\">{{codice.codice}} - </span>{{codice.descrizione | truncate:70}}\n</md-option></md-select><div ng-messages=\"voceRendicontazioneForm.codiceSpesa.$error\" role=\"alert\"><div \nng-message=\"required\"><span>E\' indispensabile inserire questo campo.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tipo di pagamento</label><md-select \nname=\"tipoPagamentoId\" ng-model=\"vmd.voceSpesa.tipoPagamentoId\" required><md-option ng-value=\"tipopagamento.id\" \nng-repeat=\"tipopagamento in vmd.liste.tipoPagamento\" maxlength=\"10\">{{ tipopagamento.label}}</md-option></md-select>\n<div ng-messages=\"voceRendicontazioneForm.tipoPagamento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><div class=\"datepicker-container\" flex \nstyle=\"font-size:12px;margin-left:40px\"><label flex style=\"max-height: 22px; margin-top:20px\">Data del pagamento\n</label><br><md-datepicker datepicker-validation-fix ng-model=\"vmd.voceSpesa.dataPagamento\" \nng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\" flex=\"50\" name=\"dataPagamento\" startview=\"year\">\n</md-datepicker></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nImporto totale del documento giustificativo</label><input ng-model=\"vmd.voceSpesa.importoTotaleDocumento\" \nname=\"importoTotaleDocumento\" type=\"text\" lang=\"it_IT\" required ui-money-mask ui-negative-number ui-currency-after><div\n ng-messages=\"voceRendicontazioneForm.importoTotaleDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span> {{error}}</div></div></md-input-container><md-input-container \nng-if=\"vmd.datiRendicontazione.modo.cofinanziamento\" flex><label>Importo cofinanziato</label><input \nname=\"importoCofinanziato\" ng-model=\"vmd.voceSpesa.importoCofinanziato\" type=\"text\" lang=\"it_IT\" ng-required=\"true\" \nui-money-mask ui-negative-number ui-currency-after><div \nng-messages=\"voceRendicontazioneForm.importoCofinanziato.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è obbligatorio</span></div></div></md-input-container><md-input-container flex \nng-if=\"vmd.datiRendicontazione.anno < 2023\"><label>Importo finanziato</label><input name=\"importoFinanziato\" \nng-model=\"vmd.voceSpesa.importoFinanziato\" type=\"text\" lang=\"it_IT\" required ui-money-mask ui-negative-number \nui-currency-after><div ng-messages=\"voceRendicontazioneForm.importoFinanziato.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è obbligatorio</span></div></div></md-input-container><md-input-container flex>\n<label>Importo imputato al progetto</label><input name=\"importoImputatoProgetto\" \nng-model=\"vmd.voceSpesa.importoImputatoProgetto\" type=\"text\" lang=\"it_IT\" required ui-money-mask ui-negative-number \nui-currency-after><div ng-messages=\"voceRendicontazioneForm.importoImputatoProgetto.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è obbligatorio</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Descrizione registrazione</label><input type=\"text\" \nname=\"descrizioneRegistrazione\" ng-model=\"vmd.voceSpesa.descrizioneRegistrazione\" \nplaceholder=\"Descrizione registrazione\" required><div \nng-messages=\"voceRendicontazioneForm.descrizioneRegistrazione.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><md-input-container flex><label>\nSpesa attiva in modulo rendicontazione</label><md-select name=\"attivo\" ng-model=\"vmd.voceSpesa.attivo\" required>\n<md-option ng-value=\"1\">Attiva</md-option><md-option ng-value=\"0\">Non attiva</md-option></md-select><div \nng-messages=\"voceRendicontazioneForm.attivo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-checkbox ng-if=\"vmd.datiRendicontazione.modo.prorogaTecnica\" \nng-model=\"vmd.voceSpesa.prorogaTecnica\" aria-label=\"Proroga tecnica\" name=\"prorogaTecnica\" ng-true-value=\"1\" \nng-false-value=\"0\"><small>Spesa in regime di proroga tecnica</small></md-checkbox><div \nng-messages=\"voceRendicontazioneForm.prorogaTecnica.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nE\' indispensabile inserire questo campo.</span></div></div></md-input-container><md-input-container flex><label>\nProgramma</label><md-select name=\"programmaId\" ng-model=\"vmd.voceSpesa.programmaId\" required><md-option \nng-value=\"programma.id\" ng-repeat=\"programma in vmd.liste.programma\" maxlength=\"10\">{{ programma.nome}}</md-option>\n</md-select><div ng-messages=\"voceRendicontazioneForm.programmaId.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>E\' indispensabile inserire questo campo.</span></div></div></md-input-container></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"voceRendicontazioneForm.$invalid || voceRendicontazioneForm.$pristine || (vmd.datiVoceRendicontazione[8].value < ((vmd.datiVoceRendicontazione[9].value + vmd.datiVoceRendicontazione[10].value) | number : 2))\" \nng-click=\"vmd.salvaVoceRendicontazione()\">Salva</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/segnalatori/dettaglio/dettaglio.html","<div id=\"segnalatori\" class=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" onclick=\"history.go(-1)\" aria-label=\"indietro\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Segnalatore:&nbsp;</span><div class=\"logo-text\"><b>\n{{vm.contact.nome}} {{vm.contact.cognome}}</b></div></div></div></div><div><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveContact();\" class=\"md-raised md-background\" \nng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" aria-label=\"Add Task\">SALVA</md-button></div>\n</md-dialog-actions></div></div><div class=\"content dettaglio\" ms-scroll><form name=\"personaNForm\" novalidate><md-tabs \nmd-dynamic-height><md-tab><md-tab-label class=\"padding-right-4\"><span>Dettaglio</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg padding-8\"><h2 class=\"no-padding\"><strong>Informazioni Generali\n</strong></h2><md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div flex=\"100\"><div \nlayout=\"row\" flex><div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-clipboard-account\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"nome\" \nng-model=\"vm.contact.nome\" placeholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il nome dell\'utente è richiesto.</span></div></div></md-input-container></div><div \nlayout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-clipboard-account\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"cognome\" ng-model=\"vm.contact.cognome\" \nplaceholder=\"Cognome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il cognome dell\'utente è richiesto.</span></div></div></md-input-container></div></div><div layout=\"row\" flex>\n<div layout=\"column\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>Genere</label><md-select name=\"sesso\" \nng-model=\"vm.contact.sesso\" required><md-option value=\"M\"><small>MASCHIO</small></md-option><md-option value=\"F\">\n<small>FEMMINA</small></md-option></md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il sesso è richiesto</span></div></div></md-input-container></div><div layout=\"column\" \nflex><md-input-container flex class=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"email\" name=\"email\" ng-model=\"vm.contact.email\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" required class=\"font-size-12 margin-bottom-0\" ng-change=\"vm.checkEmail($event)\"><div \nng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail è richiesta</span></div><div ng-message=\"pattern\"><span>Email invalida</span></div><ng-message \nclass=\"help-block\" when=\"unique\"><span>Email già in uso oppure non inserita.</span></ng-message></div>\n</md-input-container></div></div><div layout=\"row\" flex><div layout=\"column\" flex><md-input-container flex \nclass=\"margin-bottom-0\"><md-icon md-font-icon=\"icon-phone-dots\" class=\"blue-grey-800-fg\"></md-icon><label>Telefono\n</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\" required \nclass=\"font-size-12 margin-bottom-0\" ng-change=\"vm.checkTelefono($event)\"><div \nng-messages=\"personaNForm.telefono.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta\n</span></div></div></md-input-container></div><div layout=\"column\" flex><md-input-container class=\"md-block\" \nmd-no-float flex><label>Cod.Fiscale</label><md-icon md-font-icon=\"icon-barcode\" class=\"blue-grey-800-fg\"></md-icon>\n<input type=\"text\" name=\"codiceFiscale\" ng-model=\"vm.contact.codiceFiscale\" placeholder=\"Codice Fiscale\" \nng-pattern=\"/^[a-zA-Z0-9]{6}[a-zA-Z0-9]{2}[a-zA-Z0-9][a-zA-Z0-9]{2}[a-zA-Z]{0,1}[0-9]{0,3}[a-zA-Z]{0,1}$/\" \nminlength=\"11\" maxlength=\"16\" ng-change=\"vm.checkCf($event)\" required><div \nng-messages=\"personaNForm.codiceFiscale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCod.Fiscale / P. Iva è richiesto</span></div><div ng-message=\"pattern\"><span>Cod.Fiscale / P. Iva invalido</span></div>\n<ng-message class=\"help-block\" when=\"unique\"><span>Cod.Fiscale / P. Iva già in uso.</span></ng-message><div \nng-message=\"minlength,maxlength\"><span>Il cap deve essere di 11 o 16 caratteri.</span></div></div></md-input-container>\n</div></div></div></div><h2 class=\"no-padding\"><strong>Luogo di residenza</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><label>Regione</label><md-icon md-font-icon=\"icon-map-marker-radius\" class=\"blue-grey-800-fg\"></md-icon><md-select\n name=\"reg\" ng-model=\"vm.contact.codRegione\" ng-change=\"vm.caricaProvince(vm.contact.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<label>Provincia</label><md-select name=\"prov\" ng-model=\"vm.contact.codProvincia\" ng-disabled=\"!vm.contact.codRegione\" \nng-change=\"vm.caricaComuni(vm.contact.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vm.contact.codComune\" ng-disabled=\"!vm.contact.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.contact.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-google-maps\" class=\"blue-grey-800-fg\"></md-icon><input type=\"text\" name=\"indirizzo\" \nng-model=\"vm.contact.indirizzo\" placeholder=\"Indirizzo\"></md-input-container><md-input-container flex><label>\ncodice Postale</label><md-icon md-font-icon=\"icon-numeric\" class=\"blue-grey-800-fg\"></md-icon><input name=\"cap\" \nng-model=\"vm.contact.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><h2 class=\"no-padding\"><strong>Luogo e data di nascita</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map-marker-radius\" class=\"blue-grey-800-fg\">\n</md-icon><md-select name=\"reg2\" ng-model=\"vm.contact.nascita.codRegione\" \nng-change=\"vm.caricaProvince2(vm.contact.nascita.codRegione)\"><md-option ng-repeat=\"regione in vm.regiones2\" \nvalue=\"{{regione.id}}\" ng-selected=\"regione.id == vm.contact.nascita.codRegione\">{{regione.regione}}</md-option>\n</md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex required><label>Provincia</label>\n<md-select name=\"prov2\" ng-model=\"vm.contact.nascita.codProvincia\" ng-disabled=\"!vm.contact.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.contact.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.contact.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vm.contact.codComuneNascita\" ng-disabled=\"!vm.contact.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.contact.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-top-0\"><label>Nazionalità</label><md-icon \nmd-font-icon=\"icon-flag-checkered-variant\" class=\"blue-grey-800-fg\"></md-icon><md-select name=\"naz\" \nng-model=\"vm.contact.codNazionalita\"><md-option ng-repeat=\"nazione in vm.nazioni\" value=\"{{nazione.id}}\">\n{{nazione.descrizione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida\n</span></div></div></md-input-container><div layout=\"column\" flex style=\"margin-bottom:16px\" \nclass=\"datepicker-container\" md-no-float flex><label flex>Data di nascita *</label><div flex><md-datepicker \nng-model=\"vm.contact.dataNascita2\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" ng-required=\"true\" \nmd-placeholder=\"Data di nascita\" name=\"dataNascita\" flex></md-datepicker></div></div></div></div></div></md-tab-body>\n</md-tab><md-tab ng-if=\"!vm.isnew\"><md-tab-label class=\"padding-right-4\"><span>Autenticazione</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg padding-8\"><h2 class=\"no-padding\"><strong>\nInformazioni Generali</strong></h2><md-divider></md-divider><div layout-gt-sm=\"row\" flex-offset=\"5\" \nclass=\"margin-top-16\"><md-input-container class=\"md-block\" md-no-float show-errors flex><label>Nome utente</label>\n<md-icon md-font-icon=\"icon-account-key\" class=\"blue-grey-800-fg\"></md-icon><input name=\"username\" \nng-model=\"vm.contact.utentes[0].username\" maxlength=\"15\" minlength=\"5\" disabled=\"disabled\" readonly=\"readonly\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Email (modificare nella scheda dettaglio)\n</label><md-icon md-font-icon=\"icon-email\" class=\"blue-grey-800-fg\"></md-icon><input type=\"email\" name=\"email2\" \nng-model=\"vm.contact.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"margin-bottom-0\" disabled=\"disabled\" \nreadonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" flex-offset=\"5\" class=\"margin-top-0\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Password</label><md-icon md-font-icon=\"icon-key-change\" \nclass=\"blue-grey-800-fg\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"vm.contact.utentes[0].password\" \nplaceholder=\"Password\" minlength=\"8\" ng-change=\"vm.resetConfirmpass($event)\"><div \nng-messages=\"personaNForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password obbligatoria</span>\n</div><div ng-message=\"minlength\"><span>La password deve essere di almeno 8 caratteri.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Password conferma</label><input \ntype=\"password\" name=\"passwordc\" ng-model=\"vm.contact.utentes[0].passwordc\" placeholder=\"Password conferma\" \nng-change=\"vm.resetConfirmpass($event)\"><div ng-messages=\"personaNForm.passwordc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password di conferma è obbligatoria.</span></div><div ng-message=\"passwordVerify\"><span>\nPassword di conferma non coincide</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" flex-offset=\"5\" \nclass=\"margin-top-0\"><md-button ng-click=\"vm.cambiapassword();\" class=\"md-accent-bg\" \nng-disabled=\"personaNForm.$invalid || personaNForm.$pristine\" aria-label=\"cambiapassword\">cambia la password\n</md-button></div></div></md-tab-body></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/sprardb/report/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/segnalatori/sidenavs/sidenav-ricerca.html","<h2 class=\"no-padding\"><strong>Ricerca avanzata</strong></h2><md-divider></md-divider><div ms-scroll \nstyle=\"margin-top:16px\"><form name=\"processForm\" novalidate><sprardb-jsonform vm=\"vm\" formschema=\"vm.searchForms\">\n</sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/statusg/dialogs/processo.html","<md-dialog class=\"add-dialog\" aria-label=\"process\"><form name=\"processForm\" novalidate><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>{{vm.evento.eventoTipo.nome}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-button \nclass=\"md-raised {{vm.colors[vm.eventostatos.id]}} flex\">{{vm.eventostatos.stato}}</md-button><div layout=\"row\" \nclass=\"margin-top-8\"><div layout=\"column\" layout-gt-md=\"row\" flex><div flex=\"50\" class=\"margin-top-8 text-right\">\n<small><b>Data Richiesta</b></small></div><div flex=\"50\" class=\"margin-left-32\"><md-datepicker \nng-model=\"vm.evento.dataInserimento2\" md-placeholder=\"Data Richiesta\" ng-required=\"true\" flex ng-disabled=\"true\">\n</md-datepicker></div></div></div><div layout=\"row\"><div layout=\"column\" layout-gt-md=\"row\" flex><div flex=\"50\" \nclass=\"margin-top-8 text-right\"><small><b>Data Commissione</b></small></div><div flex=\"50\" class=\"margin-left-32\">\n<md-datepicker ng-model=\"vm.evento.dataAlert2\" md-placeholder=\"Data Commissione\" ng-required=\"true\" flex \nng-disabled=\"vm.view\"></md-datepicker></div></div></div><div layout=\"row\" ng-if=\"!vm.isnew && vm.nuovostato != \'5\'\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><div flex=\"50\" class=\"margin-top-8 text-right\"><small><b>Data Rilascio</b>\n</small></div><div flex=\"50\" class=\"margin-left-32\"><md-datepicker ng-model=\"vm.evento.dataInizio2\" \nmd-placeholder=\"Data Rilascio\" ng-required=\"true\" flex ng-disabled=\"vm.view\"></md-datepicker></div></div></div><div \nlayout=\"row\" ng-if=\"!vm.isnew && vm.nuovostato != \'5\'\"><div layout=\"column\" layout-gt-md=\"row\" flex><div flex=\"50\" \nclass=\"margin-top-8 text-right\"><small><b>Data Scadenza</b></small></div><div flex=\"50\" class=\"margin-left-32\">\n<md-datepicker ng-model=\"vm.evento.dataFine2\" md-placeholder=\"Data Scadenza\" ng-required=\"true\" flex \nng-disabled=\"vm.view\"></md-datepicker></div></div></div><br><br><div layout=\"row\" \nng-repeat=\"(key, value) in vm.evento.extra\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\" class=\"margin-bottom-0\"><label><strong>{{key|uppercase}}</strong></label><input \nng-if=\"key != \'questura\'\" type=\"text\" name=\"{{key}}\" ng-model=\"vm.evento.extra[key]\" placeholder=\"{{key}}\" \nng-disabled=\"vm.view\"><md-select ng-if=\"key == \'questura\'\" name=\"{{key}}\" ng-model=\"vm.evento.extra[key]\" \nclass=\"margin-top-0\" ng-disabled=\"vm.view\"><md-option ng-value=\"\"><strong><small>Nessuna</small></strong></md-option>\n<md-option ng-repeat=\"item in vm.commissiones\" ng-value=\"item.nome\"><strong><small>{{item.nome}}</small></strong>\n</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!vm.view\"><md-button type=\"submit\" ng-click=\"vm.saveDialog($event);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"processForm.$invalid\" aria-label=\"Update Notification\">\nSALVA STATUS GIURIDICO</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/statusg/sidenavs/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtri veloci</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps| filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Indietro</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Avanti\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Fine</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/sprardb/beneficiari/beneficiario/uscita/uscita.dialog.html","<md-dialog flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUscita Beneficiario {{vmd.postloginModel.b.codice}} {{vmd.postloginModel.b.nome | uppercase}} {{vmd.postloginModel.b.cognome | uppercase}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"vmd.uscitaForm\" class=\"md-inline-form\" layout=\"column\" \nnovalidate ng-include=\"vmd.baseUrl +\'postlogin-nuclei-familiari23/uscita-form\'\"></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-raised\" ng-click=\"vmd.cancelDialog()\" \nstyle=\"margin-right:20px\">Annulla</md-button><md-button class=\"md-raised md-warn\" \nng-disabled=\"vmd.uscitaForm.$invalid || vmd.uscitaForm.$submitted\" ng-click=\"vmd.hideDialog()\">CONFERMA</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/beneficiari/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/contatti/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.contact.nome}} {{vm.contact.cognome}}</div></div></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.nome\" type=\"text\" \nng-required md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input ng-model=\"vm.contact.cognome\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.SEX\">Sex</label>\n<md-select name=\"sex\" ng-model=\"vm.contact.sesso\"><md-option value=\"M\">M</md-option><md-option value=\"F\">F</md-option>\n</md-select></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div>\n<div ng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><label translate=\"CONTACTS.PHONE_NUMBER\"></label>\n<md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.contact.telefono\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTACTS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Codice Regione</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.codRegione\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Provincia</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codProvincia\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Comune</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codComune\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cap</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.cap\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Comune di Nascita</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.codComuneNascita\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Nazionalità</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codNazionalita\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Fiscale</label><md-icon \nmd-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.codiceFiscale\" type=\"text\"></md-input-container>\n<md-datepicker class=\"birthday-input\" ng-model=\"vm.contact.dataNascita\" md-placeholder=\"Data di Nascita\" \nng-required=\"false\"></md-datepicker><md-input-container class=\"md-block\"><label translate=\"CONTACTS.ADDRESS\"></label>\n<md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.indirizzo\" type=\"text\"></md-input-container>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.saveContact(vm.evento,vm.contact);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newContact ? \'NUOVO CONTATTO\' : \'SALVA CONTATTO\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.contact,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/contatti/dialogs/contact/contact-dialog1.html","<md-dialog ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"personaNForm\" novalidate><h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.persona.cognome\" placeholder=\"Cognome\" required><div ng-messages=\"personaNForm.cognome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" ng-model=\"vm.persona.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso</label><md-select name=\"sesso\" \nng-model=\"vm.persona.sesso\"><md-option value=\"M\">Maschio</md-option><md-option value=\"F\">Femmina</md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" \nng-model=\"vm.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container\n flex><md-icon md-font-icon=\"icon-phone\"></md-icon><label>Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vm.persona.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \ntype=\"email\" name=\"email\" ng-model=\"vm.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div></div></form></div><h2 class=\"no-padding\"><strong>Residenza</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" \nng-model=\"vm.persona.codRegione\" ng-change=\"vm.caricaProvince(vm.persona.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.persona.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<label>Provincia</label><md-select name=\"prov\" ng-model=\"vm.persona.codProvincia\" ng-disabled=\"!vm.persona.codRegione\" \nng-change=\"vm.caricaComuni(vm.persona.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.persona.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vm.persona.codComune\" ng-disabled=\"!vm.persona.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.persona.indirizzo\" \nplaceholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container><md-input-container flex><label>codice Postale\n</label><input name=\"cap\" ng-model=\"vm.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container><md-input-container flex><label>\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\">\n</md-input-container></div></div><h2 class=\"no-padding\"><strong>Nascita</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg2\" \nng-model=\"vm.persona.nascita.codRegione\" ng-change=\"vm.caricaProvince2(vm.persona.nascita.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones2\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.persona.nascita.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex required><label>Provincia</label><md-select name=\"prov2\" \nng-model=\"vm.persona.nascita.codProvincia\" ng-disabled=\"!vm.persona.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.persona.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.persona.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vm.persona.codComuneNascita\" ng-disabled=\"!vm.persona.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label>Nazionalità</label><md-select name=\"naz\" \nng-model=\"vm.contact.codNazionalita\"><md-option ng-repeat=\"nazione in vm.nazioni\" value=\"{{nazione.id}}\">\n{{nazione.descrizione}}</md-option></md-select><div ng-messages=\"basicForm.reg.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida\n</span></div></div></md-input-container><div flex><md-datepicker ng-model=\"vm.contact.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex></md-datepicker></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveContact(vm.evento,vm.contact);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newContact ? \'NUOVO CONTATTO\' : \'SALVA CONTATTO\' }}</md-button></div><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.contact,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/contatti/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/entisegnalatori/dialogs/ente/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Nuovo Ente</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.ente.nome}}</div></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.ente.nome\" type=\"text\" ng-required md-autofocus>\n</md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><label translate=\"CONTACTS.PHONE_NUMBER\"></label><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.ente.telefono\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTACTS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input ng-model=\"vm.ente.email\" type=\"email\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Codice Regione</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.ente.codRegione\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Provincia</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.ente.codProvincia\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Comune</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.ente.codComune\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cap</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.ente.cap\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTACTS.ADDRESS\"></label><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.ente.indirizzo\" \ntype=\"text\"></md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = false\" translate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveEnte(vm.evento,vm.ente);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newEnte ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.ente,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/entisegnalatori/dialogs/ente/contact-dialog1.html","<md-dialog ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"personaNForm\" novalidate><h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.ente.nome\" placeholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><label>Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vm.ente.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \ntype=\"email\" name=\"email\" ng-model=\"vm.ente.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\">\n<div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n<md-input-container flex><label>codice Postale</label><input name=\"cap\" ng-model=\"vm.ente.cap\" placeholder=\"00100\" \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div ng-messages=\"personaNForm.cap.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.</span></div><div \nng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container>\n</div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" \nng-model=\"vm.ente.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveEnte(vm.evento,vm.ente);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newEnte ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.ente,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></div></form></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/entisegnalatori/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/entes/dialogs/ente/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Nuovo Ente</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.ente.nome}}</div></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.ente.nome\" type=\"text\" ng-required md-autofocus>\n</md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><label translate=\"CONTACTS.PHONE_NUMBER\"></label><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.ente.telefono\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTACTS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input ng-model=\"vm.ente.email\" type=\"email\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Codice Regione</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.ente.codRegione\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Provincia</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.ente.codProvincia\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Comune</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.ente.codComune\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cap</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.ente.cap\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTACTS.ADDRESS\"></label><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.ente.indirizzo\" \ntype=\"text\"></md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = false\" translate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveEnte(vm.evento,vm.ente);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newEnte ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.ente,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/entes/dialogs/ente/contact-dialog1.html","<md-dialog ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"personaNForm\" novalidate><h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.ente.nome\" placeholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesto</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><label>Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vm.ente.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \ntype=\"email\" name=\"email\" ng-model=\"vm.ente.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"font-size-12\">\n<div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n<md-input-container flex><label>codice Postale</label><input name=\"cap\" ng-model=\"vm.ente.cap\" placeholder=\"00100\" \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" class=\"font-size-12\"><div ng-messages=\"personaNForm.cap.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.</span></div><div \nng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container>\n</div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" \nng-model=\"vm.ente.indirizzo\" placeholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveEnte(vm.evento,vm.ente);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newEnte ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.ente,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></div></form></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/enti/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/entes/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/liste_distribuzione/persone/dialogs/aggiungi_a_lista-dialog.html","<md-dialog aria-label=\"Crea nuova rendicontazione\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAggiungi persone a lista distribuzione</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><p>Scegli la lista di distribuzione.</p><md-input-container \nclass=\"md-block\"><label>Scegli una lista</label><md-select multiple=\"multiple\" ng-model=\"vmd.selected.listaId\">\n<md-option ng-value=\"lista.id\" ng-repeat=\"lista in vmd.liste.data\">{{ lista.nome }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Crea una nuova lista</label><input type=\"text\" \nng-model=\"vmd.selected.listaNew\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button ng-click=\"cancel()\" style=\"margin-right:20px\">Annulla</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vmd.aggiungiALista()\" style=\"margin-right:20px\" \nng-disabled=\"!(vmd.selected.listaId || vmd.selected.listaNew)\">Assegna</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/notification/dialogs/notification/add-dialog.html","<md-dialog id=\"adddialog\" class=\"add-dialog\" aria-label=\"{{vm.title}}\" ms-scroll><form name=\"notificationForm\" \nnovalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button><h2 \nng-if=\"!vm.readonly && vm.tipoSegnalazione != 697\">Inserisci Nuovo Beneficiario</h2><h2 ng-if=\"vm.readonly\">\nVisualizza Beneficiario</h2><h2 ng-if=\"!vm.readonly && vm.tipoSegnalazione == 697\">\nInserisci Nuovo Presente sul Territorio</h2><span flex></span></div></md-toolbar><md-dialog-content class=\"padding-0\">\n<md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\" md-selected=\"vm.selectedtab\"><md-tab \nlabel=\"Anagrafica\"><div id=\"anagraficatab\" class=\"padding-16\"><div layout=\"row\"><input hidden=\"\" name=\"id\" \nng-model=\"vm.segnalati.id\"><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (notificationForm.cognome.$invalid)}\">Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.segnalati.cognome\" placeholder=\"Inserire cognome...\" required=\"\"><div \nng-messages=\"notificationForm.cognome.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCognome richiesto</span></div></div></md-input-container><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (notificationForm.nome.$invalid)}\">Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.segnalati.nome\" placeholder=\"Inserire nome...\" required><div ng-messages=\"notificationForm.nome.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Nome richiesto</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.sesso.$invalid)}\">Sesso</md-select-label><md-select name=\"sesso\" \nng-model=\"vm.segnalati.sesso\" placeholder=\"Sesso\" required><md-option value=\"M\"><small><b>MASCHILE</b></small>\n</md-option><md-option value=\"F\"><small><b>FEMMINILE</b></small></md-option></md-select><div \nng-messages=\"notificationForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il sesso è richiesto</span>\n</div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.nazionalita.$invalid)}\">Nazionalita</md-select-label><md-select \nname=\"nazionalita\" placeholder=\"Nazionalita\" ng-model=\"vm.segnalati.codNazionalita\" required><md-option \nng-repeat=\"item in vm.nazionalitas\" ng-value=\"item.id\"><small><b>{{item.descrizione|uppercase}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.nazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNazionalita richiesta</span></div></div></md-input-container></div><div layout=\"row\"><div flex layout=\"column\" \nclass=\"datepicker-container\"><label ng-class=\"{\'md-warn-fg\': (vm.segnalati.dataNascita == null)}\" flex \nstyle=\"max-height: 22px\">Data Nascita<sup>*</sup></label><md-datepicker class=\"md-block\" name=\"dataNascita\" \nng-model=\"vm.segnalati.dataNascita\" md-placeholder=\"Data di Nascita\" md-max-date=\"vm.oggi\" md-min-date=\"vm.minDate\" \nng-required=\"true\"></md-datepicker></div><md-input-container flex><label>Vulnerabilita</label><md-select \nname=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" ng-model=\"vm.segnalati.idVulnerabilita\" \nng-disabled=\"vm.tipo==606\"><md-option ng-value=\"0\"><small class=\"text-italic\">Nessuna</small></md-option><md-option \nng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.vulnerabilita_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between-center\"><md-input-container flex=\"50\"><label \nng-class=\"{\'md-warn-fg\': (notificationForm.cui.$invalid)}\">Codice Unico di Identificazione</label><input type=\"text\" \nid=\"formDialogCui\" name=\"Cui\" ng-init=\"vm.segnalati.cui = vm.segnalati.cui || \'\'\" ng-model=\"vm.segnalati.cui\" \nplaceholder=\"Inserire CUI...\" onfocus=\"this.value = \'\'\" ng-disabled=\"vm.checkboxCui\" \nng-required=\"vm.segnalati.cui !== null\"></md-input-container><div flex=\"50\"><label>Codice CUI non disponibile: <input \ntype=\"checkbox\" ng-model=\"vm.checkboxCui\" ng-change=\"vm.checkboxCuiOnClick()\"></label></div></div><div layout=\"row\" \nlayout-align=\"space-between-center\"><md-input-container flex=\"50\"><label \nng-class=\"{\'md-warn-fg\': (notificationForm.codiceVestanet.$invalid)}\">Codice Vestanet</label><input type=\"text\" \nid=\"formDialogVestanet\" name=\"Vestanet\" ng-init=\"vm.segnalati.codiceVestanet = vm.segnalati.codiceVestanet || \'\'\" \nng-model=\"vm.segnalati.codiceVestanet\" placeholder=\"Inserire Codice Vestanet...\" onfocus=\"this.value = \'\'\" \nng-disabled=\"vm.checkboxVestanet\" ng-required=\"vm.segnalati.codiceVestanet !== null\"></md-input-container><div \nflex=\"50\"><label>Codice Vestanet non disponibile: <input type=\"checkbox\" ng-model=\"vm.checkboxVestanet\" \nng-change=\"vm.checkboxVestanetOnClick()\"></label></div></div><div layout=\"row\"><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (notificationForm.nucleoFamiliare.$invalid)}\">Stato Parentela</label><md-select \nname=\"nucleoFamiliare\" ng-model=\"vm.segnalati.nucleoFamiliare\" required ng-change=\"vm.resetParentela()\"><md-option \nng-value=\"item.codice\" ng-repeat=\"item in vm.nucleofamiliares| filter : {id : \'!694\'}\"><div layout=\"column\"><small><b>\n{{item.descrizione}}</b></small> <small>{{item.note}}</small></div></md-option></md-select></md-input-container>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (notificationForm.parentela_id.$invalid)}\">Parentela\n</md-select-label><md-select name=\"parentela_id\" placeholder=\"Parentela\" ng-model=\"vm.segnalati.parentela_id\" \nng-required=\"true\"><md-option ng-repeat=\"item in vm.parentelas| filtraparentele:[vm.segnalati.nucleoFamiliare]:\'id\'\" \nng-value=\"item.id\" ng-disabled=\"vm.isParentelaDisabled(item)\"><div layout=\"column\"><small><b>{{item.descrizione}}</b>\n</small> <small>{{item.note}} <span ng-if=\"(item.note == \'Nucleo familiare\' && vm.segnalati.nucleoFamiliare == 0)\">\no monoparentale</span></small></div></md-option></md-select><div ng-messages=\"notificationForm.parentela_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (notificationForm.dataIngresso.$invalid)}\">Data Ingresso Italia</label><md-datepicker \nclass=\"md-block\" name=\"dataIngresso\" ng-model=\"vm.segnalati.dataIngresso\" md-placeholder=\"Data Ingresso Italia\" \nmd-max-date=\"(vm.segnalati.dataC3)?vm.segnalati.dataC3:vm.oggi\" md-min-date=\"vm.segnalati.dataNascita\" \nng-required=\"vm.tipoSegnalazione != 697\" ng-disabled=\"!vm.segnalati.dataNascita\"></md-datepicker></div><div flex \nlayout=\"column\" class=\"datepicker-container\" ng-if=\"vm.tipoSegnalazione == 605\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (notificationForm.dataInizio.$invalid)}\">Data Ingresso beneficiario nel Progetto</label>\n<md-datepicker class=\"md-block\" name=\"dataInizio\" ng-model=\"vm.segnalati.dataInizio\" \nmd-placeholder=\"Data Ingresso Progetto\" md-max-date=\"vm.oggi\" md-min-date=\"vm.segnalati.dataIngresso\" \nng-required=\"true\" ng-disabled=\"!vm.segnalati.dataIngresso\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\" ng-if=\"vm.tipoSegnalazione == 697\"><label flex style=\"max-height: 20px\" \nng-class=\"{\'md-warn-fg\': (notificationForm.dataInizio.$invalid)}\">Data Inizio presenza sul territorio</label>\n<md-datepicker class=\"md-block\" name=\"dataInizio\" ng-model=\"vm.segnalati.dataInizio\" \nmd-placeholder=\"Data Inizio presenza\" md-max-date=\"vm.oggi\" md-min-date=\"vm.segnalati.dataIngresso\" ng-required=\"true\">\n</md-datepicker></div><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.tipologia.$invalid)}\">Tipologia ingresso protetto</md-select-label>\n<md-select name=\"tipologia\" placeholder=\"Tipologia ingresso protetto\" ng-model=\"vm.segnalati.tipologia_id\" \nng-required=\"vm.tipoSegnalazione != 697\" ng-change=\"vm.segnalati.paeseTerzoProvenienzaId = null\"><md-option \nng-repeat=\"item in vm.tipologiaBenficiario\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.tipologia.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Tipologia ingresso protetto richiesta</span></div></div></md-input-container>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (notificationForm.ingresso_id.$invalid)}\">\nModalità ingresso in Italia</md-select-label><md-select name=\"ingresso_id\" \nplaceholder=\"Modalità ingresso in Italia...\" ng-model=\"vm.segnalati.idTipoIngresso\" \nng-required=\"vm.tipoSegnalazione != 697\"><md-option ng-repeat=\"item in vm.ingressos\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"notificationForm.ingresso_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"[3,7].includes(vm.segnalati.tipologia_id)\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.paeseTerzoProvenienza.$invalid)}\">Paese Terzo Provenienza</md-select-label>\n<md-select name=\"paeseTerzoProvenienza\" placeholder=\"Paese Terzo Provenienza...\" \nng-model=\"vm.segnalati.paeseTerzoProvenienzaId\" required><md-option \nng-repeat=\"item in vm.paeseProvenienza | filter: {\'tipologiaId\': vm.segnalati.tipologia_id}\" ng-value=\"item.id\"><small>\n<b>{{item.nazione.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.paeseTerzoProvenienza.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div></div></md-tab><md-tab label=\"Procedura\"><div \nid=\"statustab\" class=\"padding-16\"><div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.manifestazioneVolontaProtezioneInternazionale.$invalid)}\">\nManifestazione volontà protezione internazionale</md-select-label><md-select \nname=\"manifestazioneVolontaProtezioneInternazionale\" placeholder=\"Manifestazione volontà protezione internazionale\" \nng-model=\"vm.segnalati.interesseExArt\" ng-required=\"vm.tipoSegnalazione != 697\" \nng-change=\"(vm.segnalati.interesseExArt == 1) ? vm.segnalati.tipoProtezione_id = 590 : vm.segnalati.tipoProtezione_id = 597; vm.toggleblocco(\'blocco2\', \'dataManifestazioneVolonta\', vm.segnalati.interesseExArt)\">\n<md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b ng-if=\"item.id == 1\">RICHIESTA FORMALE</b> <b \nng-if=\"item.id == 0\">RICHIESTA VERBALE</b></small></md-option></md-select><div \nng-messages=\"notificationForm.manifestazioneVolontaProtezioneInternazionale.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\" \nng-class=\"{\'md-warn-fg\': (notificationForm.dataManifestazioneVolonta.$invalid)}\">Data Manifestazione volontà</label>\n<md-datepicker name=\"dataManifestazioneVolonta\" ng-model=\"vm.segnalati.dataInteresseExArt\" \nmd-placeholder=\"Data Manifestazione volontà\" md-max-date=\"vm.oggi\" md-min-date=\"(vm.cambiaData(\'dataInteresseExArt\'))\" \nng-disabled=\"(!(vm.cambiaData(\'dataInteresseExArt\')))\" ng-required=\"vm.segnalati.interesseExArt\" \nng-change=\"vm.controllaD()\"></md-datepicker><div ng-messages=\"notificationForm.dataManifestazioneVolonta.$error\" \nrole=\"alert\"><div ng-message=\"required\" class=\"md-warn-fg\"><small>Il campo è richiesto.</small></div><div \nng-message=\"mindate\" class=\"md-warn-fg\"><small>Data troppo piccola</small></div><div ng-message=\"maxdate\" \nclass=\"md-warn-fg\"><small>Data troppo grande</small></div></div></div></div><div layout=\"row\"><md-input-container flex>\n<md-select-label ng-class=\"{\'md-warn-fg\': (notificationForm.compilazioneC3.$invalid)}\">Compilazione C3\n</md-select-label><md-select name=\"compilazioneC3\" placeholder=\"Compilazione C3\" ng-model=\"vm.segnalati.c3\" \nng-required=\"vm.tipoSegnalazione != 697\" ng-change=\"vm.toggleblocco(\'blocco2\', \'dataC3\', vm.segnalati.c3)\"><md-option \nng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.compilazioneC3.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\" ng-class=\"{\'md-warn-fg\': (notificationForm.dataC3.$invalid)}\">Data compilazione C3</label>\n<md-datepicker name=\"dataC3\" ng-model=\"vm.segnalati.dataC3\" md-placeholder=\"Data compilazione C3\" \nmd-max-date=\"vm.oggi\" md-min-date=\"vm.cambiaData(\'dataC3\')\" ng-disabled=\"(!(vm.cambiaData(\'dataC3\')))\" \nng-required=\"vm.segnalati.c3\" ng-change=\"vm.controllaD()\"></md-datepicker><div \nng-messages=\"notificationForm.dataC3.$error\" role=\"alert\"><div ng-message=\"required\" class=\"md-warn-fg\"><small>\nIl campo è richiesto.</small></div><div ng-message=\"mindate\" class=\"md-warn-fg\"><small>Data troppo piccola</small>\n</div><div ng-message=\"maxdate\" class=\"md-warn-fg\"><small>Data troppo grande</small></div></div></div></div><div \nlayout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.tipoProtezione.$invalid)}\">Tipo di Soggiorno</md-select-label><md-select \nname=\"tipoProtezione\" placeholder=\"Tipo di Soggiorno\" ng-model=\"vm.segnalati.tipoProtezione_id\" required><md-option \nng-repeat=\"item in vm.tipoproteziones| filter: {id: \'!\' + 961} | filter: {id: \'!\' + 962} | filter: {id: \'!\' + 597}\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.tipoProtezione.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container><div flex layout=\"column\" class=\"datepicker-container\"><label flex \nstyle=\"max-height: 22px\">Data richiesta protezione</label><md-datepicker name=\"dataRichiestaProtezione\" \nng-model=\"vm.segnalati.dataRichiestaProtezione\" md-placeholder=\"Data richiesta protezione\" md-max-date=\"vm.oggi\" \nmd-min-date=\"vm.cambiaData(\'dataRichiestaProtezione\')\" ng-change=\"vm.controllaD()\"></md-datepicker><div \nng-messages=\"notificationForm.dataRichiestaProtezione.$error\" role=\"alert\"><div ng-message=\"required\" \nclass=\"md-warn-fg\"><small>Il campo è richiesto.</small></div><div ng-message=\"mindate\" class=\"md-warn-fg\"><small>\nData troppo piccola</small></div><div ng-message=\"maxdate\" class=\"md-warn-fg\"><small>Data troppo grande</small></div>\n</div></div></div><div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.provenienzaSegnalato.$invalid)}\">Provenienza</md-select-label><md-select \nname=\"provenienzaSegnalato\" placeholder=\"Provenienza\" ng-model=\"vm.segnalati.idProvenienza\" \nng-required=\"vm.tipoSegnalazione != 697\"><md-option ng-repeat=\"item in vm.provenienza\" ng-value=\"item.id\"><small><b>\n{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.provenienzaSegnalato.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex><label>Stato Dublino</label>\n<md-select name=\"paeseDublino\" placeholder=\"Stato Dublino\" ng-model=\"vm.segnalati.idDublino\" \nng-disabled=\"(vm.segnalati.idProvenienza != 624)\" ng-required=\"(vm.segnalati.idProvenienza == 624)\"><md-option \nng-repeat=\"item in vm.dublino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select>\n<div ng-messages=\"notificationForm.paeseDublino.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote</label><textarea name=\"note\" ng-model=\"vm.segnalati.note\" placeholder=\"Inserire note...\" aria-label=\"Note\" \nrows=\"2\"></textarea></md-input-container><md-input-container flex><label>Note Sanitarie</label><textarea \nname=\"noteSanitarie\" ng-model=\"vm.segnalati.noteSanitarie\" placeholder=\"Inserire note sanitarie...\" \naria-label=\"Note Sanitarie\" rows=\"2\"></textarea></md-input-container></div></div></md-tab><md-tab label=\"Documenti\">\n<div id=\"doctab\" class=\"padding-16\"><div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.documentoSoggiorno.$invalid)}\">Documento di soggiorno</md-select-label>\n<md-select name=\"documentoSoggiorno\" placeholder=\"Documento di soggiorno\" ng-model=\"vm.segnalati.idTipoDocumento\" \nrequired><md-option ng-repeat=\"item in vm.documentos\" ng-value=\"item.id\" \nng-disabled=\"vm.documentoAbilitato(item, vm.segnalati.tipoProtezione_id)\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"notificationForm.documentoSoggiorno.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div><div layout=\"row\" class=\"md-warn-fg\"><i \nclass=\"icon-information red-900-fg s18 cursor-pointer\"></i>&nbsp; <small>\nAlcune voci potrebbero essere disabilitate in base al <b>Tipo di soggiorno</b> scelto.</small></div>\n</md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.enteDocumento_id.$invalid)}\">Documento rilasciato dalla Questura di\n</md-select-label><md-select name=\"enteDocumento_id\" placeholder=\"Documento rilasciato dalla Questura di\" \nng-model=\"vm.segnalati.enteDocumento_id\" ng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"><md-option \nng-repeat=\"item in vm.enterilascios\" ng-value=\"item.id\"><small><b>{{item.nome}}</b></small></md-option></md-select><div\n ng-messages=\"notificationForm.enteDocumento_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nDocumento Numero</label><input type=\"text\" name=\"documentoNumero\" ng-model=\"vm.segnalati.documentoNumero\" \nplaceholder=\"Inserire numero documento...\" ng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"></md-input-container>\n</div><div layout=\"row\"><div flex layout=\"column\" class=\"datepicker-container\"><label flex style=\"max-height: 22px\">\nData Rilascio documento</label><md-datepicker name=\"dataRilascioDocumento\" \nng-model=\"vm.segnalati.dataRilascioDocumento\" md-placeholder=\"Data Rilascio Documento\" md-max-date=\"vm.oggi\" \nmd-min-date=\"(angular.isUndefined(vm.segnalati.dataRichiestaPds)||(vm.segnalati.dataRichiestaPds==null))?vm.minDatesafeDoc:vm.segnalati.dataRichiestaPds\" \nng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Scadenza documento</label><md-datepicker \nname=\"dataScadenzaDocumento\" ng-model=\"vm.segnalati.dataScadenzaDocumento\" md-placeholder=\"Data Scadenza Documento\" \nmd-max-date=\"vm.maxDated\" md-min-date=\"vm.segnalati.dataRilascioDocumento\" \nng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"></md-datepicker></div></div><div layout=\"row\"><md-input-container \nflex><label>Cambio questura, prefettura, commissione</label><md-select name=\"cambioQPC\" \nplaceholder=\"Cambio questura, prefettura, commissione\" ng-model=\"vm.segnalati.cambioQPC\" \nng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small>\n<b>{{item.descrizione}}</b></small></md-option></md-select><div ng-messages=\"notificationForm.cambioQPC.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container>\n<md-input-container flex><label>Note cambio questura, prefettura, commissione</label><textarea name=\"noteCambioQPC\" \nng-model=\"vm.segnalati.noteCambioQPC\" placeholder=\"Note cambio questura, prefettura, commissione...\" \naria-label=\"Notecqpc\" rows=\"1\" ng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\"></textarea></md-input-container>\n</div><div layout=\"row\"><div layout=\"column\" class=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">\nData richiesta Documento</label><md-datepicker name=\"dataRichiestaPds\" ng-model=\"vm.segnalati.dataRichiestaPds\" \nmd-placeholder=\"Data richiesta Pds\" md-max-date=\"vm.segnalati.dataRilascioDocumento\" \nmd-min-date=\"vm.segnalati.dataIngresso\" ng-disabled=\"(vm.segnalati.idTipoDocumento == 670)\" \nng-change=\"vm.cambiaRpds()\"></md-datepicker></div><div layout=\"column\" flex><md-input-container flex \nng-disabled=\"disabled\"><label>Accoglienza</label><p ng-if=\"vm.esterna==0\" type=\"text\">Interna</p><p \nng-if=\"vm.esterna==1\" type=\"text\">Esterna</p></md-input-container></div></div></div></md-tab><md-tab \nlabel=\"Identita Tutela\" ng-if=\"vm.minori\"><div id=\"identitatab\" class=\"padding-16\"><div layout=\"row\">\n<md-input-container flex><label>Tipo Documento Identità</label><md-select name=\"tipoDocumentoIdentita\" \nplaceholder=\"Tipo Documento Identità\" ng-model=\"vm.segnalati.iTipoDocumento\" required><md-option \nng-repeat=\"item in vm.iTipoDocumento\" ng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"notificationForm.tipoDocumentoIdentita.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><md-input-container flex>\n<label>Luogo Rilascio Documento</label><md-select name=\"luogoRilascioDocumento\" placeholder=\"Luogo Rilascio Documento\" \nng-model=\"vm.segnalati.iLuogoDocumento\" required><md-option ng-repeat=\"item in vm.iLuogoDocumento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.luogoRilascioDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container><md-input-container flex><label>Modalità di Accertamento\n</label><md-select name=\"modalitaAccertamentoIdentita\" placeholder=\"Modalità di Accertamento\" \nng-model=\"vm.segnalati.iModalitaAccertamento\" required><md-option ng-repeat=\"item in vm.iModalitaAccertamento\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.modalitaAccertamentoIdentita.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nNote Accertamento età</label><textarea name=\"iNoteAccertamento\" ng-model=\"vm.segnalati.iNoteAccertamento\" \nplaceholder=\"Note Accertamento età...\" aria-label=\"iNoteAccertamento\" rows=\"1\"></textarea></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><label>Richiesta Apertura Tutela</label><md-select \nname=\"richiestaAperturaTutela\" placeholder=\"Richiesta Apertura Tutela\" ng-model=\"vm.segnalati.iRichiestaTutela\" \nrequired><md-option ng-repeat=\"item in vm.sino\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"notificationForm.richiestaAperturaTutela.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Richiesta Apertura Tutela</label><md-datepicker \nname=\"iDataRichiestaTutela\" ng-model=\"vm.segnalati.iDataRichiestaTutela\" \nmd-placeholder=\"Data Richiesta Apertura Tutela\" md-max-date=\"vm.maxDated\" md-min-date=\"vm.minDated\" \nng-disabled=\"(!vm.segnalati.iRichiestaTutela)\"></md-datepicker></div><div flex layout=\"column\" \nclass=\"datepicker-container\"><label flex style=\"max-height: 22px\">Data Apertura Tutela</label><md-datepicker \nname=\"iDataAperturaTutela\" ng-model=\"vm.segnalati.iDataAperturaTutela\" md-placeholder=\"Data Apertura Tutela\" \nmd-max-date=\"vm.maxDated\" md-min-date=\"vm.segnalati.iDataRichiestaTutela\" \nng-disabled=\"(!vm.segnalati.iRichiestaTutela)\"></md-datepicker></div></div><div layout=\"row\"><md-input-container flex>\n<label>Cognome e Nome Tutore</label><input type=\"text\" name=\"iTutore\" ng-model=\"vm.segnalati.iTutore\" \nplaceholder=\"Cognome e Nome Tutore\" ng-disabled=\"!(vm.segnalati.iRichiestaTutela)\"><div \nng-messages=\"notificationForm.iTutore.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container><md-input-container flex><label>Qualifica del Tutore</label><md-select\n name=\"iQualifica\" placeholder=\"Qualifica del Tutore\" ng-model=\"vm.segnalati.iQualifica\" \nng-disabled=\"!(vm.segnalati.iRichiestaTutela)\"><md-option ng-repeat=\"item in vm.iQualifica\" \nng-value=\"item.descrizione\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.iQualifica.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nCognome e Nome Responsabile Struttura accoglienza</label><input type=\"text\" name=\"iResponsabile\" \nng-model=\"vm.segnalati.iResponsabile\" placeholder=\"Cognome e Nome Responsabile Struttura accoglienza\" \nng-disabled=\"(vm.segnalati.iRichiestaTutela)\"><div ng-messages=\"notificationForm.iResponsabile.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container>\n<md-input-container flex><label>Tribunale Compentente</label><input type=\"text\" name=\"iTribunale\" \nng-model=\"vm.segnalati.iTribunale\" placeholder=\"Tribunale Compentente\" ng-disabled=\"(!vm.segnalati.iRichiestaTutela)\">\n<div ng-messages=\"notificationForm.iTribunale.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesto</span></div></div></md-input-container></div></div></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-if=\"!vm.readonly\"><span \nng-repeat=\"(key, errors) in notificationForm.$error track by $index\" flex=\"75\"><small class=\"md-warn-fg\" \nng-if=\"errors.length >= 10\">CAMPI OBBLIGATORI: <b>{{errors.length}}</b></small> <small ng-if=\"errors.length < 10\">\n<small class=\"md-warn-fg\">Campi obbligatori da riempire:</small><small class=\"md-warn-fg\" ng-repeat=\"e in errors\"> <b>\n{{ e.$name}}</b>, </small></small></span><small ng-if=\"!notificationForm.$invalid\" flex=\"75\">Validazione <b>OK</b>\n</small><md-button ng-if=\"(vm.selectedtab >= 1 && vm.selectedtab <= vm.maxtabs)\" type=\"button\" \nng-click=\"vm.selectedtab = vm.selectedtab - 1;\" class=\"md-button md-accent md-raised\" aria-label=\"Avanti\" flex>INDIETRO\n</md-button><md-button ng-if=\"vm.selectedtab == 0\" type=\"button\" ng-click=\"vm.selectedtab = vm.selectedtab + 1;\" \nclass=\"md-button md-accent md-raised\" ng-disabled=\"!(notificationForm | validacampi:vm.blocco1)\" aria-label=\"Avanti\" \nflex>AVANTI</md-button><md-button ng-if=\"vm.selectedtab == 1\" type=\"button\" \nng-click=\"vm.selectedtab = vm.selectedtab + 1;\" class=\"md-button md-accent md-raised\" \nng-disabled=\"!(notificationForm | validacampi:vm.blocco2)\" aria-label=\"Avanti\" flex>AVANTI</md-button><md-button \nng-if=\"vm.selectedtab == 2 && vm.selectedtab !== vm.maxtabs\" type=\"button\" \nng-click=\"vm.selectedtab = vm.selectedtab + 1;\" class=\"md-button md-accent md-raised\" \nng-disabled=\"!(notificationForm | validacampi:vm.blocco3)\" aria-label=\"Avanti\" flex>AVANTI</md-button><md-button \nng-if=\"vm.selectedtab == 3 && vm.selectedtab !== vm.maxtabs\" type=\"button\" \nng-click=\"vm.selectedtab = vm.selectedtab + 1;\" class=\"md-button md-accent md-raised\" \nng-disabled=\"!(notificationForm | validacampi:vm.blocco4)\" aria-label=\"Avanti\" flex>AVANTI</md-button><md-button \ntype=\"button\" ng-click=\"vm.saveNotification($event);\" class=\"md-button md-accent md-raised\" \nng-disabled=\"notificationForm.$invalid\" aria-label=\"Add Notification\" flex>SALVA</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/sprardb/notification/dialogs/notification/edit-dialog.html","<md-dialog class=\"add-dialog\" aria-label=\"{{vm.title}}\"><form name=\"notificationForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button><h2>Modifica segnalato...</h2><span \nflex></span></div></md-toolbar><md-dialog-content><div layout=\"row\"><input hidden=\"\" name=\"id\" \nng-model=\"vm.segnalati.id\"><md-input-container flex><label>Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.segnalati.nome\" placeholder=\"Inserire nome...\" required><div ng-messages=\"notificationForm.nome.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"NOTIFICATIONS.ERRORS.NOME\">\nCognome richiesta</span></div></div></md-input-container><md-input-container flex><label>Cognome</label><input \ntype=\"text\" name=\"cognome\" ng-model=\"vm.segnalati.cognome\" placeholder=\"Inserire cognome...\" required=\"\"><div \nng-messages=\"notificationForm.cognome.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.COGNOME\">Cognome richiesta</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Sesso</label><md-select name=\"sesso\" ng-model=\"vm.segnalati.sesso\" \nplaceholder=\"Sesso\" required style=\"margin-top: 0px\"><md-option value=\"M\">Maschio</md-option><md-option value=\"F\">\nFemmina</md-option></md-select><div ng-messages=\"notificationForm.sesso.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NOTIFICATIONS.ERRORS.SESSO\">Il sesso è richiesto</span></div></div>\n</md-input-container><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>Data Nascita:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataNascita\" ng-model=\"vm.segnalati.dataNascita\" md-placeholder=\"Data di Nascita\"></md-datepicker></div></div>\n<div layout=\"row\"><md-input-container flex><label>Nazionalita</label><md-select name=\"codNazionalita\" \nplaceholder=\"Scegliere nazionalita...\" ng-model=\"vm.segnalati.codNazionalita\" required><md-option \nng-repeat=\"item in vm.nazionalitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.codNazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.NATIONALITY\">Nationality field is required</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label>Parentela</label><md-select name=\"parentela_id\" \nplaceholder=\"Grado parentela...\" ng-model=\"vm.segnalati.parentela_id\"><md-option ng-repeat=\"item in vm.parentelas\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.parentela_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Vulnerabilita</label>\n<md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" ng-model=\"vm.segnalati.vulnerabilita_id\"><md-option \nng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.vulnerabilita_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Soggiorno</label><md-select name=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" \nng-model=\"vm.segnalati.tipoProtezione_id\" required><md-option ng-repeat=\"item in vm.tipoproteziones\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.tipoProtezione_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Documento</label><md-select name=\"idTipoDocumento\" placeholder=\"Documento...\" \nng-model=\"vm.segnalati.idTipoDocumento\" required><md-option ng-repeat=\"item in vm.documentos\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.idTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nDocumento rilasciato da</label><md-select name=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" \nng-model=\"vm.segnalati.enteDocumento_id\"><md-option ng-repeat=\"item in vm.enterilascios\" ng-value=\"item.id\"><small><b>\n{{item.nome}}</b></small></md-option></md-select><div ng-messages=\"notificationForm.enteDocumento_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Documento Numero</label><input type=\"text\" name=\"documentoNumero\" \nng-model=\"vm.segnalati.documentoNumero\" placeholder=\"Inserire numero documento...\"></md-input-container></div><div \nlayout=\"row\"><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>RILASCIO:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataRilascioDocumento\" ng-model=\"vm.segnalati.dataRilascioDocumento\" md-placeholder=\"Data Rilascio Documento\">\n</md-datepicker></div><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>SCADENZA:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataScadenzaDocumento\" ng-model=\"vm.segnalati.dataScadenzaDocumento\" md-placeholder=\"Data Scadenza Documento\">\n</md-datepicker></div></div><div layout=\"row\"><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (notificationForm.tipologia.$invalid)}\">Tipologia ingresso protetto</md-select-label>\n<md-select name=\"tipologia\" placeholder=\"Tipologia ingresso protetto\" ng-model=\"vm.segnalati.tipologia_id\" required>\n<md-option ng-repeat=\"item in vm.tipologiaBenficiario\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small>\n</md-option></md-select><div ng-messages=\"notificationForm.tipologia.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Tipologia ingresso protetto richiesta</span></div></div></md-input-container></div><div \nlayout=\"row\" style=\"margin-top:16px\"><md-input-container flex><label>Note</label><textarea name=\"note\" \nng-model=\"vm.segnalati.note\" placeholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\"></textarea></md-input-container>\n<md-input-container flex><label>Note Sanitarie</label><textarea name=\"noteSanitarie\" \nng-model=\"vm.segnalati.noteSanitarie\" placeholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\">\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vm.updateNotification($event);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"notificationForm.$invalid || notificationForm.$pristine\" aria-label=\"Update Notification\">\nAGGIORNARE NOTIFICA</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/notification/dialogs/notification/verification-dialog.html","<md-dialog id=\"telephoneForm\" aria-label=\"Telephone Verification\" flex=\"30\"><form name=\"telephoneForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nConvalida segnalazione</h2><span flex></span><md-button class=\"md-icon-button\" placeholder=\"x\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p>\nUn SMS contenente un codice di conferma di questa operazione è stato inviato al numero <b>del SEGNALATORE </b>.</p><p>\nPer favore inserica il codice e validi il suo numero di telefono entro 3 minuti. Grazie</p>{{vm.tokenauto}}<div \nlayout=\"row\" layout-align=\"space-around center\"><input name=\"telefono\" ng-model=\"vm.verifydata.mobile\" hidden=\"\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"token\" ng-model=\"vm.verifydata.token\" type=\"password\" \nplaceholder=\"Token\" translate translate-attr-placeholder=\"REGISTER.TOKEN\" required> <span flex></span><div \nng-messages=\"telephoneForm.token.$error\" multiple=\"multiple\" md-auto-hide=\"true\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.TOKEN_REQUIRED\">Token field is required</span></div><div class=\"help-block\" \nng-show=\"vm.validtoken\"><span translate=\"NOTIFICATIONS.ERRORS.TOKEN_NOT_VALID\">Please enter valid token</span></div>\n</div></md-input-container><md-button ng-click=\"vm.verify($event)\" ng-disabled=\"telephoneForm.$invalid\" \nclass=\"md-raised md-accent md-primary\" placeholder=\"Verify\" translate=\"REGISTER.VERIFY\" \ntranslate-attr-aria-label=\"REGISTER.VERIFY\">Verify</md-button></div><div ng-if=\"vm.tokenresend\" role=\"success\"><span>\nNuovo token spedito correttamente</span></div><div ng-if=\"vm.tokenfailed\" role=\"success\"><span>\nToken non corretto, prova a rispedirlo.</span></div><div layout=\"row\" layout-align=\"space-around center\"><md-button \nng-click=\"vm.resend($event)\" class=\"md-raised md-accent md-warn\" placeholder=\"Re-send\" translate=\"REGISTER.RESEND\" \ntranslate-attr-aria-label=\"REGISTER.RESEND\">Re-Send</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/sprardb/notification/dialogs/notification/view-dialog.html","<md-dialog class=\"view-dialog\" aria-label=\"{{vm.title}}\"><form name=\"notificationForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button><h2>Visualizza segnalato...</h2><span \nflex></span></div></md-toolbar><md-dialog-content><div layout=\"row\"><input hidden=\"\" name=\"id\" \nng-model=\"vm.segnalati.id\"><md-input-container flex><label>Nome</label><input type=\"text\" name=\"nome\" \nng-model=\"vm.segnalati.nome\" placeholder=\"Inserire nome...\" required><div ng-messages=\"notificationForm.nome.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"NOTIFICATIONS.ERRORS.NOME\">\nCognome richiesta</span></div></div></md-input-container><md-input-container flex><label>Cognome</label><input \ntype=\"text\" name=\"cognome\" ng-model=\"vm.segnalati.cognome\" placeholder=\"Inserire cognome...\" required=\"\"><div \nng-messages=\"notificationForm.cognome.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.COGNOME\">Cognome richiesta</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Sesso</label><md-select name=\"sesso\" ng-model=\"vm.segnalati.sesso\" \nplaceholder=\"Sesso\" required style=\"margin-top: 0px\"><md-option value=\"M\">Maschio</md-option><md-option value=\"F\">\nFemmina</md-option></md-select><div ng-messages=\"notificationForm.sesso.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NOTIFICATIONS.ERRORS.SESSO\">Il sesso è richiesto</span></div></div>\n</md-input-container><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>Data Nascita:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataNascita\" ng-model=\"vm.segnalati.dataNascita\" md-placeholder=\"Data di Nascita\"></md-datepicker></div></div>\n<div layout=\"row\"><md-input-container flex><label>Nazionalita</label><md-select name=\"codNazionalita\" \nplaceholder=\"Scegliere nazionalita...\" ng-model=\"vm.segnalati.codNazionalita\" required><md-option \nng-repeat=\"item in vm.nazionalitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.codNazionalita.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NOTIFICATIONS.ERRORS.NATIONALITY\">Nationality field is required</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label>Parentela</label><md-select name=\"parentela_id\" \nplaceholder=\"Grado parentela...\" ng-model=\"vm.segnalati.parentela_id\"><md-option ng-repeat=\"item in vm.parentelas\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.parentela_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Vulnerabilita</label>\n<md-select name=\"vulnerabilita_id\" placeholder=\"Vulnerabilita...\" ng-model=\"vm.segnalati.vulnerabilita_id\"><md-option \nng-repeat=\"item in vm.vulnerabilitas\" ng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option>\n</md-select><div ng-messages=\"notificationForm.vulnerabilita_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Soggiorno</label><md-select name=\"tipoProtezione_id\" placeholder=\"Tipo Soggiorno...\" \nng-model=\"vm.segnalati.tipoProtezione_id\" required><md-option ng-repeat=\"item in vm.tipoproteziones\" \nng-value=\"item.id\"><small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.tipoProtezione_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nTipo di Documento</label><md-select name=\"idTipoDocumento\" placeholder=\"Documento...\" \nng-model=\"vm.segnalati.idTipoDocumento\" required><md-option ng-repeat=\"item in vm.documentos\" ng-value=\"item.id\">\n<small><b>{{item.descrizione}}</b></small></md-option></md-select><div \nng-messages=\"notificationForm.idTipoDocumento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl campo è richiesto</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\nDocumento rilasciato da</label><md-select name=\"enteDocumento_id\" placeholder=\"Documento rilasciato da\" \nng-model=\"vm.segnalati.enteDocumento_id\"><md-option ng-repeat=\"item in vm.enterilascios\" ng-value=\"item.id\"><small><b>\n{{item.nome}}</b></small></md-option></md-select><div ng-messages=\"notificationForm.enteDocumento_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il campo è richiesto</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Documento Numero</label><input type=\"text\" name=\"documentoNumero\" \nng-model=\"vm.segnalati.documentoNumero\" placeholder=\"Inserire numero documento...\"></md-input-container></div><div \nlayout=\"row\"><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>RILASCIO:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataRilascioDocumento\" ng-model=\"vm.segnalati.dataRilascioDocumento\" md-placeholder=\"Data Rilascio Documento\">\n</md-datepicker></div><div class=\"md-block birthday-input\" flex><label class=\"grey-400-fg\" \nstyle=\"margin-top:8px;margin-left:8px\"><small>SCADENZA:&nbsp;&nbsp;</small></label><md-datepicker \nname=\"dataScadenzaDocumento\" ng-model=\"vm.segnalati.dataScadenzaDocumento\" md-placeholder=\"Data Scadenza Documento\">\n</md-datepicker></div></div><div layout=\"row\" style=\"margin-top:16px\"><md-input-container flex><label>Note</label>\n<textarea name=\"note\" ng-model=\"vm.segnalati.note\" placeholder=\"Inserire note...\" aria-label=\"Note\" rows=\"2\">\n</textarea></md-input-container><md-input-container flex><label>Note Sanitarie</label><textarea name=\"noteSanitarie\" \nng-model=\"vm.segnalati.noteSanitarie\" placeholder=\"Inserire note sanitarie...\" aria-label=\"Note Sanitarie\" rows=\"2\">\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Notification\">CHIUDI</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/personas/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/personas/dialogs/persona/persona-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.contact.nome}} {{vm.contact.cognome}}</div></div></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.nome\" type=\"text\" \nng-required md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input ng-model=\"vm.contact.cognome\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.SEX\">Sex</label>\n<md-select name=\"sex\" ng-model=\"vm.contact.sesso\"><md-option value=\"M\">M</md-option><md-option value=\"F\">F</md-option>\n</md-select></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div>\n<div ng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><label translate=\"CONTACTS.PHONE_NUMBER\"></label>\n<md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.contact.telefono\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTACTS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Codice Regione</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.codRegione\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Provincia</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codProvincia\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Comune</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codComune\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cap</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.cap\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Comune di Nascita</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.codComuneNascita\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>\nCodice Nazionalità</label><md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.codNazionalita\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Codice Fiscale</label><md-icon \nmd-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.codiceFiscale\" type=\"text\"></md-input-container>\n<md-datepicker class=\"birthday-input\" ng-model=\"vm.contact.dataNascita\" md-placeholder=\"Data di Nascita\" \nng-required=\"false\"></md-datepicker><md-input-container class=\"md-block\"><label translate=\"CONTACTS.ADDRESS\"></label>\n<md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.indirizzo\" type=\"text\"></md-input-container>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.saveContact(vm.evento,vm.contact);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newContact ? \'NUOVO CONTATTO\' : \'SALVA CONTATTO\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.contact,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/personas/dialogs/persona/persona-dialog1.html","<md-dialog ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"personaNForm\" novalidate><h2 class=\"no-padding\"><strong>Informazioni generali</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex class=\"margin-bottom-0\"><label>Cognome</label><input type=\"text\" name=\"cognome\" \nng-model=\"vm.persona.cognome\" placeholder=\"Cognome\" required><div ng-messages=\"personaNForm.cognome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Nome</label><input type=\"text\" name=\"nome\" ng-model=\"vm.persona.nome\" \nplaceholder=\"Nome\" required><div ng-messages=\"personaNForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRichiesto</span></div></div></md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\">\n<div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>Sesso</label><md-select name=\"sesso\" \nng-model=\"vm.persona.sesso\"><md-option value=\"M\">Maschio</md-option><md-option value=\"F\">Femmina</md-option>\n</md-select><div ng-messages=\"personaNForm.sesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIl sesso è richiesto</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><md-icon \nmd-font-icon=\"icon-barcode\"></md-icon><label>Codice Fiscale</label><input type=\"text\" name=\"codicefiscale\" \nng-model=\"vm.persona.codiceFiscale\" placeholder=\"Codice Fiscale\" class=\"font-size-12\" \nng-pattern=\"/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/\" md-maxlength=\"16\" md-minlength=\"16\"><div \nng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nCodice fiscale non valido</span></div><div ng-message=\"md-maxlength\"><span>Deve essere lungo 16 caratteri</span></div>\n<div ng-message=\"md-minlength\"><span>Deve essere lungo 16 caratteri</span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container\n flex><md-icon md-font-icon=\"icon-phone\"></md-icon><label>Telefono</label><input type=\"text\" name=\"telefono\" \nng-model=\"vm.persona.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \ntype=\"email\" name=\"email\" ng-model=\"vm.persona.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container></div></div></form></div><h2 class=\"no-padding\"><strong>Residenza</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg\" \nng-model=\"vm.persona.codRegione\" ng-change=\"vm.caricaProvince(vm.persona.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.persona.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex required>\n<label>Provincia</label><md-select name=\"prov\" ng-model=\"vm.persona.codProvincia\" ng-disabled=\"!vm.persona.codRegione\" \nng-change=\"vm.caricaComuni(vm.persona.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.persona.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"personaNForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune</label><md-select \nname=\"com\" ng-model=\"vm.persona.codComune\" ng-disabled=\"!vm.persona.codProvincia\"><md-option \nng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.persona.codComune\">\n{{istat.comune}}</md-option></md-select><div ng-messages=\"personaNForm.com.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nflex-offset=\"5\" class=\"margin-top-0\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.persona.indirizzo\" \nplaceholder=\"Indirizzo\" class=\"font-size-12\"></md-input-container><md-input-container flex><label>codice Postale\n</label><input name=\"cap\" ng-model=\"vm.persona.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" \nclass=\"font-size-12\"><div ng-messages=\"personaNForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container><md-input-container flex><label>\nTelefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.contact.telefono\" placeholder=\"Telefono\">\n</md-input-container></div></div><h2 class=\"no-padding\"><strong>Nascita</strong></h2><md-divider></md-divider><div \nlayout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container \nflex><label>Regione</label><md-icon md-font-icon=\"icon-map\"></md-icon><md-select name=\"reg2\" \nng-model=\"vm.persona.nascita.codRegione\" ng-change=\"vm.caricaProvince2(vm.persona.nascita.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones2\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.persona.nascita.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"personaNForm.reg2.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex required><label>Provincia</label><md-select name=\"prov2\" \nng-model=\"vm.persona.nascita.codProvincia\" ng-disabled=\"!vm.persona.nascita.codRegione\" \nng-change=\"vm.caricaComuni2(vm.persona.nascita.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias2\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.persona.nascita.codProvincia\">{{provincia.provincia}}\n</md-option></md-select><div ng-messages=\"personaNForm.prov2.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container flex><label>Comune\n</label><md-select name=\"com2\" ng-model=\"vm.persona.codComuneNascita\" ng-disabled=\"!vm.persona.nascita.codProvincia\">\n<md-option ng-repeat=\"istat in vm.istats2\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.persona.codComuneNascita\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"personaNForm.com2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\"><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex><label>Nazionalità</label><md-select name=\"naz\" \nng-model=\"vm.contact.codNazionalita\"><md-option ng-repeat=\"nazione in vm.nazioni\" value=\"{{nazione.id}}\">\n{{nazione.descrizione}}</md-option></md-select><div ng-messages=\"basicForm.reg.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida\n</span></div></div></md-input-container><div flex><md-datepicker ng-model=\"vm.contact.dataNascita2\" \nmd-placeholder=\"Data di Nascita\" ng-required=\"false\" flex></md-datepicker></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveContact(vm.evento,vm.contact);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newContact ? \'NUOVO CONTATTO\' : \'SALVA CONTATTO\' }}</md-button></div><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.contact,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/sprardb/personas2/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/dialogs/dialogMostraRuoliProgettoEnti.html","<md-dialog id=\"mostraruoli\" class=\"mostra-ruoli-dialog\" aria-label=\"mostra ruoli Form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Dettaglio ente {{ente.nome}} nel progetto {{vm.progetto.nome}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card><md-table-container class=\"tabellar\"><table data-md-table>\n<thead md-head><tr md-row><th md-column>RUOLO/AMBITO/INCARICO</th><th md-column>DATA INIZIO</th><th md-column>DATA FINE\n</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"progettoEnte in ente.progettohasentes\" \nng-class=\"{\'md-grey-300-bg\': !progettoEnte.attivo}\"><td md-cell><b>{{progettoEnte.ruolo}}</b></td><td md-cell \nstyle=\"text-align: center\"><b>{{progettoEnte.dataInizio || \' - \' | date: \"dd/MM/yyyy\"}}</b></td><td md-cell \nstyle=\"text-align: center\"><b>{{progettoEnte.dataFine || \' - \' | date: \"dd/MM/yyyy\"}}</b></td><td md-cell \nstyle=\"text-align: right\"><md-button class=\"md-accent md-button-icon\" \nng-class=\"{\'md-grey-100-bg\': progettoEnte.attivo, \'md-grey-300-bg\': !progettoEnte.attivo}\" aria-label=\"Dettaglio\" \nng-click=\"vm.openProgettoEnti($event, null, progettoEnte, ente)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><b>\n<small>MODIFICA</small></b></md-button></td></tr></tbody></table></md-table-container></md-card></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/sprardb/progetti/progetti/dialogs/dialogOperatoriForm.html","<md-dialog flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>Ruoli Ambiti e Incarichi <span \nng-if=\"vmd.locals.persona\">per {{vmd.locals.persona.nome}} {{vmd.locals.persona.cognome}}</span></h2><span flex></span>\n<md-menu ng-if=\"vmd.userCan(\'modifica-operatori\') && vmd.locals.persona\"><md-button aria-label=\"Altro\" \nclass=\"md-fab md-mini md-raised\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content><md-menu-item><md-button ng-click=\"vmd.toggleAccessoProgetto()\" \nmd-prevent-menu-close=\"md-prevent-menu-close\"><md-icon ng-class=\"{\'md-accent\': vmd.persona.accessoProgetto}\" \nmd-font-icon=\"icon-checkbox-{{vmd.persona.accessoProgetto ? \'marked\' : \'blank-outline\'}}\"></md-icon>\nAccesso alla banca dati</md-button></md-menu-item><md-menu-item><md-button class=\"md-warn\" \nng-click=\"vmd.cancellaRelazione()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Cancella Relazione</md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-card \nclass=\"md-padding\" ng-if=\"!vmd.locals.persona\"><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Ricerca operatore per cognome, città ed ente</label><input type=\"text\" \nng-model=\"vmd.cercaModel.cognome\" ng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" \nplaceholder=\"Inserisci il cognome da cercare\"></md-input-container><md-input-container flex class=\"margin-bottom-0\">\n<label>Comune ente collegato</label><input type=\"text\" ng-model=\"vmd.cercaModel.nomeComune\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il comune da cercare\">\n</md-input-container></div><div layout=\"row\" class=\"margin-top-8\"><md-input-container flex class=\"margin-bottom-0\">\n<label>Codice Fiscale</label><input type=\"text\" ng-model=\"vmd.cercaModel.codiceFiscale\" \nng-model-options=\"{debounce: 500}\" ng-change=\"vmd.cercaPersona()\" placeholder=\"Inserisci il codice fiscale da cercare\">\n</md-input-container></div><md-divider></md-divider><div layout=\"row\"><md-input-container flex \nclass=\"margin-bottom-0 margin-top-4\"><label>Scegli un Persona [<span class=\"text-boxed\">{{vmd.persone.data.length}}\n</span>]</label><md-select name=\"nome\" ng-model=\"vmd.persona\" ng-change=\"vmd.changePersona()\"><md-option \nng-repeat=\"persona in vmd.persone.data\" ng-value=\"persona\"><span><strong>{{persona.cognome}} {{persona.nome}}</strong>\n - {{persona.residenza.comune}}/{{persona.entes[0].nome}}/{{persona.progettos[0].nome}}</span></md-option></md-select>\n</md-input-container></div></md-card><md-card class=\"md-padding\" ng-show=\"vmd.persona\"><div layout=\"row\" \nlayout-align=\"space-between\" flex><h2>Ruoli e ambiti</h2><md-button ng-if=\"vmd.userCan(\'modifica-operatori\')\" \nclass=\"md-icon-button md-secondary\" ng-disabled=\"!vmd.persona\" ng-click=\"vmd.inizializzaModel()\"><md-icon \nmd-font-icon=\"icon-plus-circle green-700-fg\"></md-icon><md-tooltip>Aggiungi Ruolo</md-tooltip></md-button></div><form \nnovalidate name=\"vmd.ruoliForm\"><div ng-repeat=\"model in vmd.models\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-around center\"><md-input-container flex><label>Ruolo / Ambito nel progetto</label><md-select \nng-model=\"model.personaRuolo_id\" ng-disabled=\"!vmd.userCan(\'modifica-operatori\')\" required><md-optgroup label=\"Ruolo\">\n<md-option ng-repeat=\"ruolo in vmd.ricerca.personaruoloprogettos\" ng-value=\"ruolo.id\">{{ruolo.descrizione}} (RUOLO)\n</md-option></md-optgroup><md-optgroup label=\"Ambito\"><md-option ng-repeat=\"ruolo in vmd.ricerca.personaruoloambitos\" \nng-value=\"ruolo.id\">{{ruolo.descrizione}} (AMBITO)</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container><md-checkbox class=\"margin-vertical-0\" name=\"attivo\" ng-model=\"model.attivo\" ng-true-value=\"1\" \nng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"space-around center\">\n<md-input-container flex class=\"m-10\"><label>Data Inizio</label><md-datepicker name=\"dataInizio\" \nng-model=\"model.dataInizio\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\"></md-datepicker>\n</md-input-container><md-input-container flex class=\"m-10\"><label>Data Fine</label><md-datepicker name=\"dataFine\" \nng-model=\"model.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" md-placeholder=\"GG/MM/AAAA\"></md-datepicker>\n</md-input-container><md-button class=\"md-icon-button md-secondary\" ng-if=\"vmd.userCan(\'modifica-operatori\')\" \nng-click=\"vmd.cancellaModel(model)\" ng-show=\"vmd.models.length > 1\"><md-icon md-font-icon=\"icon-close-circle md-warn\">\n</md-icon><md-tooltip><span>Cancella</span></md-tooltip></md-button></div></div></form></md-card><md-card \nclass=\"md-padding\" ng-if=\"vmd.persona.altriProgetti.length > 0\"><div layout=\"column\"><small>\nRuoli e ambiti associati ad altri progetti (non modificabili)</small> <small layout=\"row\" \nng-repeat=\"item in vmd.persona.altriProgetti | orderBy: \'progetto_id\'\"><b>{{item.personaRuolo.descrizione}}</b>&nbsp;(\n<span class=\"md-accent-fg\">{{item.progettoMin.nome}}</span>)</small></div></md-card></md-dialog-content>\n<md-dialog-actions><div layout=\"row\" flex><span class=\"red-700-fg\" flex>{{vmd.errorMsg}}</span><md-button \ntype=\"button\" ng-click=\"vmd.cancel()\" class=\"md-button md-raised\">ANNULLA</md-button><md-button type=\"button\" \nng-click=\"vmd.salva()\" class=\"md-button md-accent md-raised\" ng-disabled=\"vmd.ruoliForm.$invalid\">SALVA</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/progetti/progetti/dialogs/dialogProgettoEntiForm.html","<md-dialog aria-label=\"enti Form\" id=\"personedialog\" class=\"persone-dialog\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>{{vmd.progettoEnte.id ? \'Ente associato\' : \'Associa un ente\'}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-content class=\"md-padding\"><form \nname=\"enteNForm\" novalidate flex layout=\"column\" layout-align=\"space-between\"><div layout=\"column\"><md-input-container \nflex><label>Ente Tipo</label><md-select name=\"entetipoR\" ng-model=\"vmd.ricerca.enteTipo_id\" ng-disabled=\"!vmd.isNew\" \nng-change=\"vmd.onChangeTipo()\"><md-option ng-value=\"\">Tutti</md-option><md-option \nng-repeat=\"tipoEnte in vmd.apiRicerca.entetipos\" value=\"{{tipoEnte.id}}\"><b>{{tipoEnte.descrizione}}</b><br><small>\n{{tipoEnte.settore_id}}° SETTORE</small></md-option></md-select></md-input-container><md-autocomplete \nmd-floating-label=\"{{vmd.sceltaEnteLabel}}\" md-no-cache=\"1\" md-selected-item=\"vmd.ente\" \nmd-search-text-change=\"vmd.getEnti()\" md-selected-item-change=\"\" md-search-text=\"vmd.ricerca.nome\" \nmd-items=\"ente in vmd.enti.$promise\" md-item-text=\"ente.nome\" md-min-length=\"vmd.minLength\" md-require-match=\"true\" \nng-model-options=\"{debounce: 200}\" name=\"enteNome\" ng-readonly=\"!vmd.isNew\" required flex><md-item-template><span \nmd-highlight-text=\"vmd.ricerca.nome\" md-highlight-flags=\"i\">{{ente.nome}}</span></md-item-template></md-autocomplete>\n</div><md-divider class=\"mt-20 mb-20\"></md-divider><md-input-container flex><label>Ruolo nel progetto</label><md-select\n ng-model=\"vmd.progettoEnte.enteruolo\" ng-model-options=\"{trackBy: \'$value.id\'}\" required flex><md-option \nng-repeat=\"ruolo in vmd.apiRicerca.enteruoloprogettos\" ng-value=\"ruolo\">{{ruolo.descrizione}}</md-option></md-select>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex class=\"m-10\"><label>Data Inizio\n</label><md-datepicker name=\"dataInizio\" ng-model=\"vmd.progettoEnte.dataInizio\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\"></md-datepicker></md-input-container><md-input-container flex class=\"m-10\"><label>Data Fine\n</label><md-datepicker name=\"dataFine\" ng-model=\"vmd.progettoEnte.dataFine\" ng-model-options=\"{timezone: \'GMT\'}\" \nmd-placeholder=\"GG/MM/AAAA\"></md-datepicker></md-input-container><div flex layout=\"row\" layout-align=\"center\">\n<md-switch ng-model=\"vmd.progettoEnte.attivo\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-switch></div></div>\n</form></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end\"><md-button \nng-if=\"vmd.progettoEnte.id\" class=\"md-button md-secondary orange-700-fg\" ng-click=\"vmd.elimina()\"><md-icon \nmd-font-icon=\"icon-delete orange-700-fg\"></md-icon>ELIMINA RELAZIONE</md-button><md-button type=\"button\" \nng-click=\"vmd.progetto.id ? vmd.salva() : vmd.salvaNuovoProgettoEnte()\" class=\"md-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"enteNForm.$invalid\">SALVA</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/postlogin/cancellazione-beneficiari/dialogs/mostraBeneficiariDuplicati.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \nng-click=\"vmd.closeDialog()\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"Close dialog\"></md-icon></md-button>\n<h2>Beneficiari Duplicati</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vmd.closeDialog()\"><md-icon\n md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-card style=\"padding-top:0px\"><md-table-container><table id=\"presenza\" data-md-table \nmd-progress=\"vmd.models.$promise\"><thead md-head><tr md-row><th md-column><div layout=\"column\"><span>CODICE</span>\n</div></th><th md-column><div layout=\"column\"><span>COGNOME</span></div></th><th md-column><div layout=\"column\"><span>\nNOME</span></div></th><th md-column><div layout=\"column\">TIPOLOGIA DI SOGGIORNO</div></th><th md-column><div \nlayout=\"column\"><span>NASCITA</span> <span>NAZIONALITA</span> <span>GENERE</span></div></th><th md-column><div \nlayout=\"column\">INGRESSO ITALIA</div></th><th md-column><div layout=\"column\">INGRESSO PROGETTO</div></th><th md-column>\n<div layout=\"column\">STATO</div></th><th md-column><div layout=\"column\"><span>PROGETTO</span> <span>STRUTTURA</span>\n</div></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"model in vmd.models\" \nng-class=\"{\'md-light-blue-50-bg\': model.b.id === vmd.locals.beneficiarioId}\"><td md-cell><div layout=\"column\"><span \nng-if=\"(model.b.def == 1)\">{{model.b.codice}}</span> <span ng-if=\"(model.b.def == 0)\">{{model.b.id}}</span> <span \nng-if=\"(model.b.def == 0)\"><small>INCOMPLETO</small></span></div></td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ model.b.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ model.b.nome | uppercase}}</td><td md-cell><div layout=\"column\">\n{{model.b.protezioneTipo.descrizione}}</div></td><td md-cell><div layout=\"column\"><span>\n{{model.b.dataNascita|date:\"dd/MM/yyyy\" }}</span> <span>{{model.b.nazionalita.descrizione}}</span> <span>\n{{model.b.sesso}}</span></div></td><td md-cell><div layout=\"column\"><span>{{model.b.dataIngresso |date:\"dd/MM/yyyy\"}}\n</span></div></td><td md-cell><div layout=\"column\"><span>{{vmd.dataInizioProgetto[model.b.id] |date:\"dd/MM/yyyy\"}}\n</span></div></td><td md-cell><div layout=\"column\"><span>{{model.b.stato}}</span></div></td><td md-cell><div \nlayout=\"column\"><b>{{model.b.progetto.nome}}</b> <small>{{model.b.struttura.nome}}</small></div></td></tr></tbody>\n</table></md-table-container></md-card></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vmd.closeDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Notification\">CHIUDI</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/progetti/progetti/progetto/dettaglio.html","<div id=\"progetto\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"indietro\" onclick=\"history.go(-1)\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" class=\"logo\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"logo-text\">Progetto:&nbsp;</span> <span class=\"logo-text\"><small>\n<b>{{vm.progetto.nome}}</b></small></span></div></div></div><div><md-button type=\"submit\" \nng-click=\"vm.saveProgetto(vm.isnew)\" ng-if=\"!vm.api.isReadOnly\" class=\"md-raised md-background\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" aria-label=\"SALVA\"><span>SALVA</span></md-button></div></div>\n<div class=\"content dettaglio\" ms-scroll><md-tabs md-dynamic-height><md-tab label=\"PRINCIPALE\" ng-if=\"!vm.isRevisore\">\n<form name=\"basicForm\" class=\"md-inline-form md-background-bg\" novalidate><div id=\"principaletab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\"><small><b>ENTI TITOLARE &AMP; ATTUATORE + CATEGORIA PROGETTO</b></small>\n</md-divider><div layout=\"row\" class=\"{{($index===0)?\'margin-top-16\':\'margin-top-0\'}}\" \nng-repeat=\"item in vm.progetto.enti\" ng-if=\"!vm.isnew\"><md-input-container \nng-repeat=\"subitem in item.enteruolos| orderBy: \'-id\'\" flex class=\"margin-bottom-0\" \nng-if=\"(subitem.id == 1 || subitem.id == 8)\"><label>Ente {{subitem.descrizione}}</label><input type=\"text\" \nname=\"ente{{subitem.id}}\" placeholder=\"Ente {{subitem.descrizione}}\" required ng-disabled=\"true\" readonly=\"readonly\" \nng-value=\"item.nome\"></md-input-container></div><div layout=\"row\" class=\"margin-top-16\" ng-if=\"vm.isnew\">\n<md-input-container flex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (basicForm.ente8.$invalid)}\"><b>\nEnte Titolare</b></label><input type=\"text\" name=\"ente8\" placeholder=\"Inserire un ente titolare...\" required \nreadonly=\"readonly\" ng-disabled=\"false\" ng-model=\"vm.payloadsToStore[8].nomeEnte\"><div \nng-messages=\"basicForm.ente8.$error\" role=\"alert\"><div ng-message=\"required\"><span>Impostare un ente titolare.</span>\n</div></div></md-input-container><md-button class=\"md-accent md-grey-100-bg\" aria-label=\"Modifica link\" \nng-click=\"vm.createProgettoEnti($event, 8, null)\">Inserisci Ente Titolare</md-button></div><div layout=\"row\" \nclass=\"margin-top-4\" ng-if=\"vm.payloadsToStore[8]\"><md-switch ng-model=\"vm.gestionediretta\" \naria-label=\"GestioneDiretta\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"margin: 0px 0px 0px 20px\" \nng-change=\"vm.cambiagestionediretta()\"><small>Gestione diretta: </small><small ng-if=\"vm.gestionediretta == 0\"><b>NO\n</b></small><small ng-if=\"vm.gestionediretta == 1\"><b>SI</b></small></md-switch></div><div layout=\"row\" \nclass=\"margin-top-16\" ng-if=\"vm.isnew && (vm.gestionediretta == 0)\"><md-input-container flex class=\"margin-bottom-0\">\n<label ng-class=\"{\'md-warn-fg\': (basicForm.ente1.$invalid)}\"><b>Ente Attuatore</b></label><input type=\"text\" \nname=\"ente1\" placeholder=\"Inserire un ente attuatore...\" required readonly=\"readonly\" ng-disabled=\"false\" \nng-model=\"vm.payloadsToStore[1].nomeEnte\"><div ng-messages=\"basicForm.ente1.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Impostare un ente attuatore.</span></div></div></md-input-container><md-button \nclass=\"md-accent md-grey-100-bg\" aria-label=\"Modifica link\" ng-click=\"vm.createProgettoEnti($event, 1, null)\">\nInserisci Ente Attuatore</md-button></div><div layout=\"row\" class=\"margin-top-0\"><md-input-container flex><label \nng-class=\"{\'md-warn-fg\': (basicForm.bandoscat.$invalid)}\">Categoria accoglienza</label><md-select name=\"bandoscat\" \nng-model=\"vm.progetto.bandosIds\" required multiple=\"multiple\" ng-disabled=\"(!vm.api.isAdmin)\"><md-option \nng-repeat=\"item in vm.ricerca.bandos\" ng-value=\"item.id\"><b>{{ item.descrizione}}</b> <small>\n{{item.dataInizio| date : \"dd/MM/yyyy\"}} - {{item.dataFine| date : \"dd/MM/yyyy\"}}</small></md-option></md-select><div \nng-messages=\"basicForm.bandoscat.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCategoria di accoglienza richiesta</span></div></div></md-input-container><md-input-container flex><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.tipologiaAccoglienza.$invalid)}\">Tipologia Categoria</md-select-label><md-select \nname=\"tipologia\" ng-model=\"vm.progetto.tipologiaAccoglienzaId\" required ng-disabled=\"(!vm.api.isAdmin)\" \nplaceholder=\"Tipologia Progetto\"><md-option ng-repeat=\"item in vm.tipologieAccoglienza\" ng-value=\"item.id\"><b>\n{{ item.descrizione}}</b></md-option></md-select><div ng-messages=\"basicForm.tipologiaAccoglienza.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Tipologia di accoglienza richiesta</span></div></div>\n</md-input-container></div><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>DATI PROGETTO</b></small>\n</md-divider><div layout=\"row\" class=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.nome.$invalid)}\"><b>Nome del progetto</b></label><input type=\"text\" name=\"nome\" \nng-model=\"vm.progetto.nome\" placeholder=\"Nome Progetto\" ng-required=\"!vm.api.isAdmin\"><div \nng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Il nome del progetto è richiesto.\n</span></div></div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.codiceMinistero.$invalid)}\"><b>Codice Ministeriale Progetto</b></label><input \ntype=\"text\" name=\"codiceMinistero\" ng-model=\"vm.progetto.codiceMinistero\" placeholder=\"Codice Ministeriale\" \nclass=\"font-size-12\" ng-required=\"!vm.api.isAdmin\"><div ng-messages=\"basicForm.codiceMinistero.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Il codice ministeriale è richiesto.</span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"margin-top-0\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.email.$invalid)}\"><b>Email unica di progetto</b></label><input type=\"email\" \nname=\"email\" ng-model=\"vm.progetto.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" ng-required=\"!vm.api.isAdmin\" \nclass=\"font-size-12\"><div ng-messages=\"basicForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div>\n</div></md-input-container><md-input-container flex class=\"margin-bottom-0\"><label>Telefono</label><input type=\"text\" \nname=\"telefono\" ng-model=\"vm.progetto.telefono\" placeholder=\"Telefono\" class=\"font-size-12\"></md-input-container></div>\n<div layout=\"row\" class=\"margin-top-0\"><md-input-container flex class=\"margin-bottom-0\"><label \nng-class=\"{\'md-warn-fg\': (basicForm.postiTotali.$invalid)}\"><b>Posti Totali Finanziati</b></label><input type=\"number\" \nname=\"postiTotali\" ng-model=\"vm.progetto.postiTotali\" ng-required=\"!vm.api.isAdmin\" \nng-change=\"vm.progetto.postiLiberi = vm.progetto.postiTotali; vm.progetto.postiRiservatiSC = vm.round(vm.progetto.postiTotali * 0.7);\" \nng-disabled=\"vm.modificaDisabilitata\" placeholder=\"Numero posti nel progetto\"></md-input-container><md-input-container \nflex class=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (basicForm.budget.$invalid)}\"><b>Budget stimato in Euro\n</b></label><input type=\"number\" name=\"budget\" ng-model=\"vm.progetto.budget\" class=\"font-size-12\" \nng-required=\"!vm.api.isAdmin\" ng-disabled=\"vm.modificaDisabilitata\"></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\"><label ng-class=\"{\'md-warn-fg\': (basicForm.operatori.$invalid)}\"><b>Operatori di progetto</b>\n</label><input type=\"number\" name=\"operatori\" ng-model=\"vm.progetto.operatori\" class=\"font-size-12\" \nng-disabled=\"vm.modificaDisabilitata\" placeholder=\"Numero operatori impiegabili\"></md-input-container></div><div \nlayout=\"row\" class=\"margin-top-16\"><div class=\"datepicker-container\" flex><label flex style=\"max-height: 22px\">\nData Inizio Progetto</label><md-datepicker ng-model=\"vm.progetto.dataInizio2\" md-placeholder=\"data Inizio\" \nng-required=\"false\" flex ng-disabled=\"vm.modificaDisabilitata\"></md-datepicker></div><div class=\"datepicker-container\" \nflex><label flex style=\"max-height: 22px\">Data Fine Progetto</label><md-datepicker ng-model=\"vm.progetto.dataFine2\" \nmd-placeholder=\"data Fine\" ng-required=\"false\" flex ng-disabled=\"vm.modificaDisabilitata\"></md-datepicker></div>\n<md-input-container flex ng-if=\"vm.api.isAdmin && !vm.isnew\"><md-select-label \nng-class=\"{\'md-warn-fg\': (basicForm.attivo.$invalid)}\">Progetto Attivo</md-select-label><md-select name=\"attivo\" \nng-model=\"vm.progetto.attivo\" ng-disabled=\"vm.modificaDisabilitata\" required placeholder=\"Progetto Attivo\"><md-option \nng-repeat=\"item in vm.sino\" value=\"{{item.id}}\"><small>{{item.descrizione|uppercase}}</small></md-option></md-select>\n<div ng-messages=\"basicForm.attivo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesto</span></div></div>\n</md-input-container></div><br><md-divider class=\"md-light-blue-100-bg padding-8\"><small><b>UBICAZIONE PROGETTO</b>\n</small></md-divider><div layout=\"row\" class=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (basicForm.reg.$invalid)}\">Regione</md-select-label>\n<md-select name=\"reg\" ng-model=\"vm.progetto.codRegione\" ng-change=\"vm.caricaProvince(vm.progetto.codRegione)\" \nng-disabled=\"vm.modificaDisabilitata\" ng-required=\"!vm.api.isAdmin\" placeholder=\"Regione\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.progetto.codRegione\"><small><b>\n{{regione.regione|uppercase}}</b></small></md-option></md-select><div ng-messages=\"basicForm.reg.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex required><md-select-label ng-class=\"{\'md-warn-fg\': (basicForm.prov.$invalid)}\">Provincia\n</md-select-label><md-select name=\"prov\" ng-model=\"vm.progetto.codProvincia\" \nng-change=\"vm.caricaComuni(vm.progetto.codProvincia)\" ng-disabled=\"vm.modificaDisabilitata || !vm.progetto.codRegione\" \nplaceholder=\"Provincia\" ng-required=\"!vm.api.isAdmin\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.progetto.codProvincia\"><small><b>\n{{provincia.provincia|uppercase}}</b></small></md-option></md-select><div ng-messages=\"basicForm.prov.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container>\n<md-input-container flex><md-select-label ng-class=\"{\'md-warn-fg\': (basicForm.com.$invalid)}\">Comune</md-select-label>\n<md-select name=\"com\" ng-model=\"vm.progetto.codComune\" \nng-disabled=\"vm.modificaDisabilitata || !vm.progetto.codProvincia\" ng-required=\"!vm.api.isAdmin\" placeholder=\"Comune\">\n<md-option ng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.progetto.codComune\">\n<small>{{istat.comune|uppercase}}</small></md-option></md-select><div ng-messages=\"basicForm.com.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"margin-top-16\"><div layout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex><label>\nIndirizzo del progetto</label><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.progetto.indirizzo\" \nplaceholder=\"Indirizzo\"></md-input-container><md-input-container flex><label>Codice Postale</label><input name=\"cap\" \nng-model=\"vm.progetto.cap\" placeholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"basicForm.cap.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.\n</span></div><div ng-message=\"md-maxlength\"><span>Cap non può essere più lungo di 5 caratteri.</span></div></div>\n</md-input-container></div></div><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>\nQUESTURA E PREFETTURA</b></small></md-divider><div layout=\"row\" class=\"margin-top-16\" ng-if=\"!vm.isnew\">\n<md-input-container flex class=\"margin-bottom-0\" flex><label>Questura</label><input type=\"text\" name=\"entequestura\" \nplaceholder=\"Questura non presente\" readonly=\"readonly\" ng-disabled=\"true\" ng-model=\"vm.progetto.questura.nome\">\n</md-input-container><md-input-container flex class=\"margin-bottom-0\" flex><label>Prefettura</label><input type=\"text\" \nname=\"enteprefettura\" placeholder=\"Prefettura non presente\" readonly=\"readonly\" ng-disabled=\"true\" \nng-model=\"vm.progetto.prefettura.nome\"></md-input-container></div></div></form></md-tab><md-tab \nng-if=\"!vm.isnew && !vm.isRevisore\" label=\"STRUTTURE\"><div id=\"strutturecorsiservizitab\"><div id=\"sectionstrutture\">\n<md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>STRUTTURE <span ng-if=\"vm.satt\">ATTIVE\n</span><span ng-if=\"!vm.satt\">DISATTIVE</span></b></small></md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"80\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"ssearch\" \nplaceholder=\"Ricerca nelle strutture\" type=\"text\" ng-model=\"vm.ssearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-input-container flex><md-select style=\"max-height: 100% !important\" \nng-model=\"vm.filtros\" ng-change=\"vm.cambiaFiltroStruttura(vm.filtros)\" aria-label=\"filtro\"><md-option value=\"-1\">\n<small><b>TUTTE</b></small></md-option><md-option value=\"0\"><small>INTERNE DISATTIVE</small></md-option><md-option \nvalue=\"1\"><small>INTERNE ATTIVE</small></md-option><md-option value=\"2\"><small>INTERNE DA ATTIVARE</small></md-option>\n<md-option value=\"3\"><small>ESTERNE ATTIVE</small></md-option><md-option value=\"4\"><small>ESTERNE DISATTIVE</small>\n</md-option></md-select></md-input-container></div></div><md-card style=\"padding-top:0px\"><md-table-container \nclass=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\">\n<tr md-row><th md-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"nome\">NOME</th><th md-column \nmd-order-by=\"indirizzo\">UBICAZIONE</th><th md-column>TIPOLOGIA</th><th md-column md-order-by=\"attivo\" \nstyle=\"text-align: center\">ATTIVO</th><th md-column md-order-by=\"dataInizio\" style=\"text-align: center\">DATA INIZIO\n</th><th md-column md-order-by=\"dataFine\" style=\"text-align: center\">DATA FINE</th><th md-column \nstyle=\"text-align: center\" md-order-by=\"numeroPosti\">TOTALE POSTI</th><th md-column style=\"text-align: center\">\nPOSTI OCCUPATI</th><th md-column style=\"text-align: center\">ALLEGATI</th><th md-column style=\"text-align: right\" \nng-if=\"!vm.isVisitatore\">AZIONI</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.progetto.strutturas | filter: {nome:vm.ssearch} | filter: {attivo: vm.satt} | filter: {daattivare: vm.sdatt} | filter: {esterna: vm.sesterna}\">\n<td md-cell>{{item.id}}</td><td class=\"light-blue-900-fg font-weight-600\" md-cell><div layout=\"column\"><span>\n{{ item.nome | uppercase}}</span><md-progress-linear md-mode=\"determinate\" class=\"md-accent-fg\" \nvalue=\"{{100 - ((item.numeroPosti - (item.numeroPosti - item.postioccupati)) / item.numeroPosti * 100) | number:0}}\">\n</md-progress-linear><span>{{item.progettos.nome|uppercase}}</span></div></td><td md-cell><div layout=\"column\"><span>\n{{item.indirizzo|uppercase|limitTo:25}}{{item.indirizzo.length > 25 ? \'...\':\'\'}}</span> <span><b>\n{{item.istats.comune| uppercase}}</b></span> <span>{{item.istats.provincia| uppercase}}</span></div></td><td md-cell>\n<div layout=\"column\"><span><b>{{item.strutturaAccoglienza.descrizione}}</b></span> <span>\n{{item.strutturaAlloggio.descrizione}}</span></div></td><td md-cell style=\"text-align: center\"><div layout=\"column\">\n<md-icon class=\"icon-bookmark-outline\" style=\"font-size:20px\" ng-if=\"item.attivo != 1\"></md-icon><md-icon \nclass=\"icon-bookmark-check\" style=\"font-size:20px\" ng-if=\"item.attivo == 1\"></md-icon></div></td><td md-cell \nstyle=\"text-align: center\"><div layout=\"column\">{{item.dataInizio|date:\'dd/MM/yyyy\'}}</div></td><td md-cell \nstyle=\"text-align: center\"><div layout=\"column\">{{item.dataFine|date:\'dd/MM/yyyy\'}}</div></td><td md-cell \nstyle=\"text-align: center\"><div layout=\"column\"><span><b>{{item.numeroPosti}}</b></span></div></td><td md-cell \nstyle=\"text-align: center\"><div layout=\"column\"><span><b>{{item.numeroBeneficiariPresenti}}</b></span></div></td><td \nmd-cell style=\"text-align: center\"><div layout=\"column\">{{item.numeroDocumentiCaricati}}</div></td><td md-cell \nstyle=\"text-align: right\" ng-if=\"!vm.isVisitatore\"><div><md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"modifica\" \nng-click=\"vm.openDialogEditStruttura($event, item.id, item.progetto_id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<b><small>MODIFICA STRUTTURA</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"visualizzaBen\" \nui-sref=\"app.sprardb_beneficiari({def:1,prequery:vm.createprequery(item.id,item.progetto_id)})\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon><b><small>BENEFICIARI</small></b></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td></tr><tr md-row class=\"md-amber-100-bg\"><td md-cell colspan=\"6\">&nbsp</td><td \nmd-cell colspan=\"2\" style=\"text-align: center\"><b>Posti totali finanziati da progetto</b></td><td md-cell \nstyle=\"text-align: center\"><b>Posti totali strutture</b></td><td md-cell style=\"text-align: center\"><b>\nPosti totali occupati</b></td><td md-cell colspan=\"2\">&nbsp</td></tr><tr md-row><td md-cell colspan=\"6\"><div \nlayout=\"column\">&nbsp;</div></td><td md-cell colspan=\"2\" style=\"text-align: center\"><div layout=\"column\"><big><b>\n{{vm.progetto.postiTotali}}</b></big></div></td><td md-cell style=\"text-align: center\"><div layout=\"column\"><big><b>\n{{vm.progetto.totalePostiStrutture }}</b></big></div></td><td md-cell style=\"text-align: center\"><div layout=\"column\">\n<big><b>{{vm.progetto.totalePostiOccupati }}</b></big></div></td><td md-cell colspan=\"2\"><div layout=\"column\">&nbsp;\n</div></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openDialogNewStruttura($event, vm.progetto.id,0)\" ng-if=\"!vm.api.isReadOnly\" \nng-disabled=\"vm.api.user.gruppos[0].gruppo == \'SC-TUTOR\'\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVA STRUTTURA INTERNA</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"Nuova\" ng-click=\"vm.openDialogNewStruttura($event, vm.progetto.id,1)\" ng-if=\"!vm.api.isReadOnly\" \nng-disabled=\"vm.api.user.gruppos[0].gruppo == \'SC-TUTOR\'\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVA STRUTTURA ESTERNA</md-button></div></md-card></div></div></md-tab><md-tab \nng-if=\"!vm.isnew && !vm.isRevisore\" label=\"CORSI\"><div id=\"sectioncorsi\"><md-divider \nclass=\"md-light-blue-100-bg padding-8 margin-top-16\" ng-if=\"!vm.isnew\"><small><b>CORSI ATTIVI e DISATTIVI</b></small>\n</md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container \nmd-no-float class=\"m-0\" flex><input id=\"sersearch\" placeholder=\"Ricerca nei corsi\" type=\"text\" ng-model=\"vm.corsearch\" \nng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"40\"><md-input-container md-no-float class=\"m-0\" flex><md-select ng-model=\"vm.corsearchYear\" \nplaceholder=\"Anno corsi\" ng-change=\"vm.loadCorsi()\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">\n{{ year.id}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div>\n<md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table \nmd-progress=\"vm.progetto.corsos.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"servizi_id\" \nstyle=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">NOME CORSO</th><th md-column \nmd-order-by=\"dataInizio\" style=\"text-align: left\">DATA ATTIVAZ.</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\">DATA CESSAZ.</th><th md-column style=\"text-align: right\" ng-if=\"!vm.isReadOnly\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.progetto.corsos.data | filter: vm.corsearch | filter: {dataFine:vm.corsearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.corsi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.corsicat\" ng-if=\"sitem.id === item.corsi.corsi_id\"><small>{{ sitem.descrizione|uppercase}}\n</small></span> <span class=\"light-blue-900-fg font-weight-600\">{{ item.corsi.descrizione | uppercase}}</span> <span>\n<small>{{ item.corsi.note|uppercase}}</small></span></div></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: right\" ng-if=\"!vm.isReadOnly\"><div>\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-click=\"vm.openCorsiDialog($event, vm.progetto, item.id, item.corsi_id, $index, false)\" \nng-disabled=\"!vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<b><small>MODIFICA</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"inserisci\" \nng-click=\"vm.openCorsiDialog($event, vm.progetto, item.id, item.corsi_id, null, true)\" \nng-disabled=\"!vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<b><small>NUOVO</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.searchCorsi[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" \nmd-page=\"vm.searchCorsi.page\" md-total=\"{{vm.totalCountCorsi}}\" md-on-paginate=\"vm.loadCorsi\" md-boundary-links=\"true\" \nmd-page-select=\"true\" md-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination>\n<div layout=\"row\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openCorsiDialog($event, vm.progetto, item.id, item.corsi_id, null, true)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO CORSO</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openCorsiDialog($event, vm.progetto, item.id, item.corsi_id, null, false)\" ng-if=\"(vm.isAdmin)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>CREA NUOVO CORSO</md-button><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openClonaCorsiDialog($event, vm.progetto, item.id, item.corsi_id, null, false)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nCLONA CORSI</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openAssCorsiBenDialog($event, vm.progetto, item.id, item.corsi_id, null, false)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nASSOCIA BENEFICIARI</md-button></div></md-card></div></md-tab><md-tab ng-if=\"!vm.isnew && !vm.isRevisore\" \nlabel=\"SERVIZI\"><div id=\"sectionservizi\"><md-divider class=\"md-light-blue-100-bg padding-8 margin-top-16\" \nng-if=\"!vm.isnew\"><small><b>SERVIZI ATTIVI e DISATTIVI</b></small></md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"50\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"sersearch\" \nplaceholder=\"Ricerca nei servizi\" type=\"text\" ng-model=\"vm.sersearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"40\"><md-input-container \nmd-no-float class=\"m-0\" flex><md-select ng-model=\"vm.sersearchYear\" placeholder=\"Anno servizi\" \nng-change=\"vm.loadServizi()\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.years\">{{ year.id}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card \nstyle=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table \nmd-progress=\"vm.progetto.servizios.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"servizi_id\" \nstyle=\"text-align: center\">Cod</th><th md-column style=\"text-align: left\">NOME SERVIZIO</th><th md-column \nmd-order-by=\"dataInizio\" style=\"text-align: left\">DATA ATTIVAZ.</th><th md-column md-order-by=\"dataFine\" \nstyle=\"text-align: left\">DATA CESSAZ.</th><th md-column style=\"text-align: right\" ng-if=\"!vm.isReadOnly\">AZIONE</th>\n</tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.progetto.servizios.data | filter: vm.sersearch | filter: {dataFine:vm.sersearchYear} track by $index\">\n<td md-cell>{{item.progetto_id}}.{{item.servizi_id}}</td><td md-cell><div layout=\"column\"><span \nng-repeat=\"sitem in ::vm.servizicat\" ng-if=\"sitem.id === item.servizi.servizi_id\"><small>\n{{ sitem.descrizione|uppercase}}</small></span> <span class=\"light-blue-900-fg font-weight-600\">\n{{item.servizi.servizi_id}} - {{ item.servizi.descrizione | uppercase}}</span> <span><small>\n{{ item.servizi.note|uppercase}}</small></span></div></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataInizio| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: left\"><b>\n{{item.dataFine| date: \'dd/MM/yyyy\'}}</b></td><td md-cell style=\"text-align: right\" ng-if=\"!vm.isReadOnly\"><div>\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Dettaglio\" \nng-click=\"vm.openServiziDialog($event, vm.progetto, item.id, item.servizi_id, $index, false)\" \nng-disabled=\"!vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<b><small>MODIFICA</small></b></md-button></md-menu-item><md-menu-item><md-button aria-label=\"inserisci\" \nng-click=\"vm.openServiziDialog($event, vm.progetto, item.id, item.servizi_id, null, true)\" \nng-disabled=\"!vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<b><small>NUOVO</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.searchServizi[\'per-page\']\" md-limit-options=\"[1,10,25,50]\" \nmd-page=\"vm.searchServizi.page\" md-total=\"{{vm.totalCountServizi}}\" md-on-paginate=\"vm.loadServizi\" \nmd-boundary-links=\"true\" md-page-select=\"true\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination><div layout=\"row\">\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openServiziDialog($event, vm.progetto, item.id, item.servizi_id, null, true)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO SERVIZIO</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openServiziDialog($event, vm.progetto, item.id, item.servizi_id, null, false)\" ng-if=\"(vm.isAdmin)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>CREA NUOVO SERVIZIO</md-button><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openClonaServiziDialog($event, vm.progetto, item.id, item.corsi_id, null, false)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nCLONA SERVIZI</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openAssServiziBenDialog($event, vm.progetto, item.id, item.corsi_id, null, false)\" \nng-if=\"vm.api.user.permissions.includes(\'associa-corsi-servizi\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nASSOCIA BENEFICIARI</md-button></div></md-card></div></md-tab><md-tab ng-if=\"!vm.isnew && !vm.isRevisore\" label=\"ENTI\">\n<div id=\"entitab\"><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>\nENTI TITOLARI E ATTUATORI COLLEGATI</b></small></md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"esearch\" \nplaceholder=\"Ricerca negli enti\" type=\"text\" ng-model=\"vm.esearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div></div><md-card style=\"padding-top:0px\">\n<md-table-container class=\"tabellar\"><table data-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th \nmd-column md-order-by=\"id\">Cod</th><th md-column md-order-by=\"nome\">NOME ENTE</th><th md-column>TIPO</th><th md-column>\nRUOLI NEL PROGETTO</th><th md-column>RECAPITI</th><th md-column style=\"text-align: right\" \nng-if=\"!vm.isReadOnly && vm.canTitolare\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.progetto.enti | filtraRuoliProgetto: [1,2,8] | filter: vm.esearch\" \nng-class=\"{\'md-grey-300-bg\': item.relazioniProgettoAttive.length === 0}\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>{{item.entetipo.descrizione}}\n</b></td><td md-cell><div ng-if=\"item.progettohasentes.length === 1\">{{item.progettohasentes[0].ruolo}} <small \nng-if=\"item.progettohasentes[0].dataInizio\">dal <b>{{item.progettohasentes[0].dataInizio || \' - \' | date: \"dd/MM/yy\"}}\n</b> </small><small ng-if=\"item.progettohasentes[0].dataFine\">al <b>\n{{item.progettohasentes[0].dataFine || \' - \' | date: \"dd/MM/yy\"}}</b></small></div><a \nng-if=\"item.progettohasentes.length > 1\" ng-click=\"vm.mostraRuoliProgetto($event, item)\" href=\"#\">\nMostra tutti i ruoli...</a></td><td md-cell><div layout=\"column\"><span><a title=\"{{item.email}}\" \nhref=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}{{(item.email.length>25)?\'...\':\'\'}}</a></span> <span>\n{{item.telefono}}</span></div></td><td md-cell style=\"text-align: right\" ng-if=\"!vm.isReadOnly && vm.canTitolare\"><div>\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"item.progettohasentes.length === 1\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"Dettaglio\" ng-click=\"vm.openProgettoEnti($event, null, item.progettohasentes[0], item)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><b><small>MODIFICA</small></b></md-button></md-menu-item><md-menu-item><md-button \nui-sref=\"app.sprardb_enti.dettaglio({id:item.id})\"><md-icon md-font-icon=\"icon-eye\"></md-icon><b><small>VISUALIZZA\n</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table>\n</md-table-container><div layout=\"row\"><md-input-container class=\"md-default-theme\" ng-if=\"!vm.api.isReadOnly\">\n<md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openProgettoEnti($event, 1, null)\" ng-disabled=\"!vm.api.user.permissions.includes(\'edit-ente\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>INSERISCI NUOVO ENTE ATTUATORE</md-button></md-input-container><md-input-container \nclass=\"md-default-theme\" ng-if=\"!vm.api.isReadOnly && vm.canTitolare\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" ng-click=\"vm.openProgettoEnti($event, 8, null)\" \nng-disabled=\"!vm.api.user.permissions.includes(\'edit-ente\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nINSERISCI NUOVO ENTE TITOLARE</md-button></md-input-container><md-input-container class=\"md-default-theme\" \nng-if=\"!vm.api.isReadOnly\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openProgettoEnti($event, 2, null)\" ng-disabled=\"!vm.api.user.permissions.includes(\'edit-ente\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>INSERISCI NUOVO ENTE PARTNER</md-button></md-input-container></div></md-card>\n<md-divider class=\"md-light-blue-100-bg padding-8 margin-top-32\" ng-if=\"!vm.isnew\"><small><b>ALTRI ENTI COLLEGATI</b>\n</small></md-divider><div layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"90\">\n<md-input-container md-no-float class=\"m-0\" flex><input id=\"es2search\" placeholder=\"Ricerca negli enti\" type=\"text\" \nng-model=\"vm.es2earch\" ng-model-options=\"{debounce: 500}\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"10\"><md-button><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca\n</small></md-button></div></div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table \ndata-md-table><thead ng-if=\"!vm.options.decapitate\" md-head><tr md-row><th md-column md-order-by=\"id\">Cod</th><th \nmd-column md-order-by=\"nome\">NOME ENTE</th><th md-column>TIPO</th><th md-column>RUOLI NEL PROGETTO</th><th md-column>\nRECAPITI</th><th md-column style=\"text-align: right\" ng-if=\"!vm.isReadOnly && vm.canTitolare\">AZIONE</th></tr></thead>\n<tbody md-body><tr md-row \nng-repeat=\"item in vm.progetto.enti| filterByArray2:[2, 3, 6, 7]:\'id\':\'ruolo\' | filter: vm.es2earch track by item.id\" \nng-class=\"{\'md-grey-300-bg\': item.relazioniProgettoAttive.length === 0}\"><td md-cell>{{item.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.nome | uppercase}}</td><td md-cell><b>{{item.entetipo.descrizione}}\n</b></td><td md-cell><div ng-if=\"item.progettohasentes.length === 1\">{{item.progettohasentes[0].ruolo}} <small \nng-if=\"item.progettohasentes[0].dataInizio\">dal <b>{{item.progettohasentes[0].dataInizio || \' - \' | date: \"dd/MM/yy\"}}\n</b> </small><small ng-if=\"item.progettohasentes[0].dataFine\">al <b>\n{{item.progettohasentes[0].dataFine || \' - \' | date: \"dd/MM/yy\"}}</b></small></div><a \nng-if=\"item.progettohasentes.length > 1\" ng-click=\"vm.mostraRuoliProgetto($event, item)\" href=\"#\">\nMostra tutti i ruoli...</a></td><td md-cell><div layout=\"column\"><span><a title=\"{{item.email}}\" \nhref=\"mailto:{{item.email}}\">{{item.email|limitTo:25}}{{(item.email.length>25)?\'...\':\'\'}}</a></span> <span>\n{{item.telefono}}</span></div></td><td md-cell style=\"text-align: right\" ng-if=\"!vm.isReadOnly && vm.canTitolare\"><div>\n<md-menu><md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"item.progettohasentes.length === 1\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"Dettaglio\" ng-click=\"vm.openProgettoEnti($event, null, item.progettohasentes[0], item)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><b><small>MODIFICA</small></b></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"inserisci\" ui-sref=\"app.sprardb_entes_dettaglio_dettaglio({id:item.id})\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><b><small>VISUALIZZA</small></b></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr>\n</tbody></table></md-table-container><div layout=\"row\"><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"Nuova\" ng-click=\"vm.openProgettoEnti($event, 6, null)\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-if=\"!vm.api.isReadOnly\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>INSERISCI NUOVA QUESTURA</md-button><md-button class=\"md-accent md-button-icon md-grey-100-bg\" \naria-label=\"Nuova\" ng-click=\"vm.openProgettoEnti($event, 7, null)\" \nng-disabled=\"!(vm.api.isAdmin || vm.api.isAccoglienza)\" ng-if=\"!vm.api.isReadOnly\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>INSERISCI NUOVA PREFETTURA</md-button></div></md-card></div></md-tab><md-tab ng-if=\"!vm.isnew\" \nlabel=\"OPERATORI\"><div id=\"operatoritab\"><md-divider class=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small>\n<b>OPERATORI DI PROGETTO</b></small></md-divider><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"90\"><md-input-container md-no-float class=\"m-0\" flex><input id=\"psearch\" \nplaceholder=\"Ricerca negli operatori\" type=\"text\" ng-model=\"vm.psearch\" ng-model-options=\"{debounce: 500}\">\n</md-input-container><md-input-container flex=\"20\"><label>Ruolo Attivo</label><md-select \nng-model=\"vm.searchOperatore.attivo\" ng-change=\"vm.cercaOperatore()\"><md-option ng-value=\"\"><b>-</b></md-option>\n<md-option ng-repeat=\"item in vm.booleanOptions\" ng-value=\"item.id\"><b>{{item.label}}</b></md-option></md-select>\n</md-input-container><md-input-container flex=\"20\"><label>Accesso alla banca dati</label><md-select \nng-model=\"vm.searchOperatore.credenziali\" ng-change=\"vm.cercaOperatore()\"><md-option ng-value=\"\"><b>-</b></md-option>\n<md-option ng-repeat=\"item in vm.booleanOptions\" ng-value=\"item.id\"><b>{{ item.label}}</b></md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"10\"><md-button \nng-click=\"vm.cercaOperatore()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><small>Cerca</small></md-button></div>\n</div><md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table \nmd-progress=\"vm.progetto.personas.$promise\"><thead ng-if=\"!vm.options.decapitate\" md-head \ndata-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\">Cod</th><th \nmd-column>COGNOME</th><th md-column>NOME</th><th md-column>RECAPITI</th><th md-column>RUOLO/AMBITO/INCARICO</th><th \nmd-column>CREDENZIALI BANCA DATI</th><th md-column>ACCESSO ALLA BANCA DATI</th><th md-column \nstyle=\"padding-right:8px;text-align: right\" ng-if=\"!vm.isReadOnly\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"persona in vm.progetto.personas.data | filter: vm.psearch track by persona.id\" \nng-if=\"persona.personahasprogetto[0].ruolo != \'CONSULENTE\'\"><td md-cell>{{persona.id}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ persona.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ persona.nome | uppercase}}</td><td md-cell><a title=\"{{persona.email}}\" \nhref=\"mailto:{{persona.email}}\">{{persona.email}} </a><br>{{persona.telefono}}</td><td md-cell><div layout=\"column\">\n<small ng-repeat=\"item in persona.personahasprogetto | filter:{attivo:vm.searchOperatore.attivo}\" \nng-class=\"item.attivo ? \'light-blue-900-fg\' : \'secondary-text\'\"><b>{{item.personaRuolo.descrizione}}</b>\n ({{item.personaRuolo.gruppo.replace(\"PROGETTO\", \"RUOLO\")}}) <span ng-if=\"item.dataInizio\">dal <b>\n{{item.dataInizio || \' - \' | date: \"dd/MM/yy\"}}</b> </span><span ng-if=\"item.dataFine\">al <b>\n{{item.dataFine || \' - \' | date: \"dd/MM/yy\"}}</b></span></small></div></td><td md-cell><div layout=\"column\"><b \nng-if=\"(persona.user.status === 10)\">ATTIVO</b> <span ng-if=\"(persona.user.status === 0)\">DISATTIVO</span> <b \nng-if=\"!(persona.user)\">INESISTENTE</b></div></td><td md-cell><div layout=\"column\" \nng-if=\"persona.user && persona.user.status === 10\"><md-icon \nng-class=\"{\'icon-bookmark-outline\': !persona.accessoProgetto, \'icon-bookmark-check\': persona.accessoProgetto}\" \nstyle=\"font-size:20px;padding-right:8px\" aria-label=\"accesso al progetto\"></md-icon></div></td><td md-cell \nstyle=\"padding-right:8px;text-align: right\" ng-if=\"!vm.isReadOnly\"><md-menu><md-button aria-label=\"Altro\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-accent\" aria-label=\"dettaglio\" \nui-sref=\"app.sprardb_personasdettaglio2({id:persona.id})\" ng-if=\"!vm.api.isReadOnly\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><small><b>APRI ANAGRAFICA</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.api.user.can(\'modifica-operatori\') || (vm.api.user.can(\'disattiva-operatori-progetto\'))\">\n<md-button aria-label=\"Dettaglio2\" ng-click=\"vm.openOperatoreDialog($event, persona)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA/RIMUOVI ASSOCIAZIONE</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.isAdmin && !item.persona.user)\"><md-button aria-label=\"crea\" \nng-click=\"vm.openRegisterDialog($event, item.persona.id, false)\" class=\"md-blue-100-bg\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><small><b>NUOVO PROFILO</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.isAdmin && item.persona.user)\"><md-button aria-label=\"crea2\" \nng-click=\"vm.openUserDialog($event, item.persona.id)\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"(item.persona.user.status !== 10)\"></md-icon><md-icon md-font-icon=\"icon-account-key\" \nng-if=\"(item.persona.user.status === 10)\"></md-icon><small><b>PROFILO, PASSWORD e ABILITAZIONE</b></small></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" ng-click=\"vm.openOperatoreDialog($event)\" \nng-if=\"!vm.api.isReadOnly\" ng-disabled=\"!vm.api.user.permissions.includes(\'modifica-operatori\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>ASSOCIA OPERATORE ESISTENTE</md-button><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openPersoneDialog($event, vm.progetto, null, false)\" ng-if=\"!vm.api.isReadOnly\" \nng-disabled=\"!vm.api.user.permissions.includes(\'modifica-operatori\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nCREA NUOVO OPERATORE</md-button></div></md-card></div></md-tab><md-tab \nng-if=\"(!vm.isnew && vm.canSeeRevisoreTab) && !vm.isRevisore\" label=\"REVISORI\"><div id=\"revisoritab\"><md-divider \nclass=\"md-light-blue-100-bg padding-8\" ng-if=\"!vm.isnew\"><small><b>REVISORI DI PROGETTO</b></small></md-divider>\n<md-card style=\"padding-top:0px\"><md-table-container class=\"tabellar\"><table data-md-table><thead \nng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" md-on-reorder=\"vm.onSearch\"><tr md-row><th \nmd-column>Cod</th><th md-column>COGNOME</th><th md-column>NOME</th><th md-column>RECAPITI</th><th md-column>ANNI</th>\n<th md-column>CREDENZIALI BANCA DATI</th><th md-column>ATTIVO</th><th md-column \nstyle=\"padding-right:8px;text-align: right\" ng-if=\"!vm.isReadOnly\">AZIONE</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.revisori\" ng-class=\"{\'md-grey-200-bg\': item.anni.length == 0}\"><td md-cell>{{item.persona.id}}\n</td><td md-cell class=\"light-blue-900-fg font-weight-600\">{{ item.persona.cognome | uppercase}}</td><td md-cell \nclass=\"light-blue-900-fg font-weight-600\">{{ item.persona.nome | uppercase}}</td><td md-cell><a \ntitle=\"{{item.persona.email}}\" href=\"mailto:{{item.persona.email}}\">{{item.persona.email|limitTo:20}}...</a><br>\n{{item.persona.telefono}}</td><td md-cell style=\"padding-right:8px\"><div layout=\"column\"><span \nng-repeat=\"subitem in item.anni |  limitTo : 3\">{{subitem}}</span></div></td><td md-cell><div layout=\"column\"><b \nng-if=\"(item.persona.user.status === 10)\">ATTIVO</b> <span ng-if=\"(item.persona.user.status === 10)\">\n({{item.persona.user.groups.length}}) PROFILO</span> <span ng-if=\"(item.persona.user.status !== 10)\">DISATTIVO</span> \n<b ng-if=\"!(item.persona.user)\">INESISTENTE</b></div></td><td md-cell><div layout=\"column\"><md-icon \nclass=\"icon-bookmark-outline\" style=\"font-size:20px;padding-right:8px\" ng-if=\"item.anni.length == 0\"></md-icon><md-icon\n class=\"icon-bookmark-check\" style=\"font-size:20px;padding-right:8px\" ng-if=\"item.anni.length != 0\"></md-icon></div>\n</td><td md-cell style=\"padding-right:8px;text-align: right\" ng-if=\"!vm.isReadOnly\"><md-menu><md-button \naria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-accent\" aria-label=\"dettaglio\" \nui-sref=\"app.sprardb_personasdettaglio2({id:item.persona.id})\" ng-if=\"!vm.api.isReadOnly\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\"></md-icon><small><b>APRI ANAGRAFICA</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.api.isAdmin || vm.api.isAccoglienza || vm.api.isAmministratore || vm.api.isOperatore)\">\n<md-button aria-label=\"Dettaglio2\" ng-click=\"vm.openRevisoriDialog($event, vm.progetto, $index, false)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><small><b>MODIFICA/RIMUOVI ASSOCIAZIONE</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.isAdmin && !item.persona.user)\"><md-button aria-label=\"crea\" \nng-click=\"vm.openRegisterDialog($event, item.persona.id, false)\" class=\"md-blue-100-bg\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><small><b>NUOVO PROFILO</b></small></md-button></md-menu-item>\n<md-menu-item ng-if=\"(vm.isAdmin && item.persona.user)\"><md-button aria-label=\"crea2\" \nng-click=\"vm.openUserDialog($event, item.persona.id)\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"(item.persona.user.status !== 10)\"></md-icon><md-icon md-font-icon=\"icon-account-key\" \nng-if=\"(item.persona.user.status === 10)\"></md-icon><small><b>PROFILO, PASSWORD e ABILITAZIONE</b></small></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div layout=\"row\"><md-button \nclass=\"md-accent md-button-icon md-grey-100-bg\" aria-label=\"Nuova\" \nng-click=\"vm.openRevisoriDialog($event, vm.progetto, null, true)\" ng-if=\"!vm.api.isReadOnly\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>ASSOCIA REVISORE</md-button></div></md-card></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/progetto/dettaglio_1.html","<div id=\"contacts\" class=\"page-layout tabbed simple right-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to products\" ng-click=\"vm.gotoProducts()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"product-image\" hide-xs><img ng-src=\"{{vm.product.images[0].url}}\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{vm.product.name}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"EC.PRODUCT_DETAIL\">Product Detail</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\"><span translate=\"EC.SAVE\">SAVE</span></md-button></div></div><div class=\"content\" \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"EC.BASIC_INFO\">Basic Info</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form>\n<md-input-container class=\"md-block\"><label translate=\"EC.PRODUCT_NAME\">Product Name</label><input type=\"text\" \nng-model=\"vm.product.name\"></md-input-container><h3 class=\"secondary-text\" translate=\"EC.PRODUCT_DESCRIPTION\">\nProduct Description</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.product.description\" class=\"pb-32\">\n</text-angular><md-input-container class=\"md-block\"><label translate=\"EC.CATEGORIES\">Categories</label><md-select \nng-model=\"vm.product.categories\" md-on-open=\"vm.onCategoriesSelectorOpen()\" \nmd-on-close=\"vm.onCategoriesSelectorClose()\" multiple=\"multiple\"><md-select-header><input type=\"search\" \nclass=\"md-text\" ng-model=\"vm.categoriesSelectFilter\" placeholder=\"Search for a category\"></md-select-header>\n<md-optgroup><md-option ng-value=\"category\" \nng-repeat=\"category in vm.product.categories | filter:vm.categoriesSelectFilter\">{{category}}</md-option></md-optgroup>\n</md-select></md-input-container><h3 class=\"tags secondary-text\" translate=\"EC.TAGS\">Tags</h3><md-chips \nng-model=\"vm.product.tags\" placeholder=\"Enter a tag\" delete-button-label=\"Remove Tag\" \ndelete-hint=\"Press delete to remove tag\" secondary-placeholder=\"+Tag\"></md-chips></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"EC.PRODUCT_IMAGES\">Product Images</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"EC.DROP_TO_UPLOAD\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>Upload</md-button><span \nclass=\"secondary-text mt-8\">You can also drop images here to upload. Only PNG, JPG - Max. 8MB</span></div><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div ng-repeat=\"image in vm.product.images\" ng-switch=\"image.type\">\n<div class=\"product-image uploading\" ng-switch-when=\"uploading\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{image.file.progress() * 100}}\"></md-progress-linear></div><img class=\"media\" flow-img=\"image.file\"></div><div \nclass=\"product-image\" ng-switch-when=\"image\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" \nng-src=\"{{image.url}}\"></div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"EC.PRICING\">Pricing</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container \nclass=\"md-block md-icon-float\"><label translate=\"EC.TAX_EXCL_PRICE\">Tax Excluded Price</label><md-icon \nmd-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" ng-model=\"vm.product.priceTaxExcl\">\n</md-input-container><md-input-container class=\"md-block md-icon-float\"><label translate=\"EC.TAX_INCL_PRICE\">\nTax Included Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" \nng-model=\"vm.product.priceTaxIncl\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"EC.TAX_RATE\">Tax Rate</label><md-icon md-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.product.taxRate\"></md-input-container><md-input-container class=\"md-block md-icon-float\">\n<label translate=\"EC.COMPARED_PRICE\">Compared Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon>\n<input type=\"number\" step=\"0.01\" ng-model=\"vm.product.comparedPrice\"><div class=\"input-hint\">\nAdd a compare price to show next to the real price</div></md-input-container></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"EC.INVENTORY\">Inventory</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container class=\"md-block\">\n<label translate=\"EC.SKU\">SKU</label><input type=\"text\" ng-model=\"vm.product.sku\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"EC.BARCODE\">Barcode</label><input type=\"text\" \nng-model=\"vm.product.barcode\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"EC.QUANTITY\">\nQuantity</label><input type=\"number\" step=\"1\" ng-model=\"vm.product.quantity\"></md-input-container></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EC.SHIPPING\">Shipping</span></md-tab-label><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"EC.WIDTH\">Width</label>\n<input type=\"text\" ng-model=\"vm.product.width\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"EC.HEIGHT\">Height</label><input type=\"text\" ng-model=\"vm.product.height\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"EC.DEPTH\">Depth</label><input type=\"text\" \nng-model=\"vm.product.depth\"></md-input-container></div><md-input-container class=\"md-block\"><label \ntranslate=\"EC.WEIGHT\">Weight</label><input type=\"text\" ng-model=\"vm.product.weight\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float\"><label translate=\"EC.EXTRA_SHIPPING_FEE\">Extra Shipping Fee</label>\n<md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"text\" ng-model=\"vm.product.extraShippingFee\">\n</md-input-container></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/progetto/progetto.html","<div id=\"contacts\" class=\"page-layout simple right-sidenav\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/sprardb/progetti/progetti/sidenavs/progetto/main-sidenav.html\'\"></md-sidenav><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-image: url(\'../assets/images/backgrounds/header-bg.png\');background-size: cover\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-text\">Progetto</span></div></div></div><div class=\"content\" md-background-bg flex \nlayout-align=\"start start\" ms-scroll><div class=\"main\" ms-scroll><h2></h2><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-md=\"row\"></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><input type=\"text\" name=\"nome\" ng-model=\"vm.progetto.nome\" \nplaceholder=\"Nome Progetto\" required><div ng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Il nome del progetto è richiesto.</span></div></div></md-input-container><md-input-container flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.progetto.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired><div ng-messages=\"basicForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail richiesta</span></div><div ng-message=\"pattern\"><span>Email non valida</span></div></div></md-input-container>\n<md-input-container flex><label>Cat.Accoglienza</label><md-select name=\"bnd\" ng-model=\"vm.progetto.bandos.id\" required>\n<md-option ng-repeat=\"bando in vm.bandos\" value=\"{{bando.id}}\" ng-selected=\"bando.id == vm.progetto.bandos.id\">\n{{bando.descrizione}}</md-option></md-select><div ng-messages=\"basicForm.bnd.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Regione</label>\n<md-select name=\"reg\" ng-model=\"vm.progetto.codRegione\" required ng-change=\"vm.caricaProvince(vm.progetto.codRegione)\">\n<md-option ng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" \nng-selected=\"regione.id == vm.progetto.codRegione\">{{regione.regione}}</md-option></md-select><div \nng-messages=\"basicForm.reg.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container><md-input-container flex \nrequired><label>Provincia</label><md-select name=\"prov\" ng-model=\"vm.progetto.codProvincia\" \nng-disabled=\"!vm.progetto.codRegione\" ng-change=\"vm.caricaComuni(vm.progetto.codProvincia)\"><md-option \nng-repeat=\"provincia in vm.provincias\" value=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.progetto.codProvincia\">\n{{provincia.provincia}}</md-option></md-select><div ng-messages=\"basicForm.prov.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida\n</span></div></div></md-input-container><md-input-container flex required><label>Comune</label><md-select name=\"com\" \nng-model=\"vm.progetto.codComune\" ng-disabled=\"!vm.progetto.codProvincia\"><md-option ng-repeat=\"istat in vm.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.progetto.codComune\">{{istat.comune}}</md-option></md-select><div\n ng-messages=\"basicForm.com.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container></div><div \nng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\">MOSTRA TUTTI</md-button></div><div ng-if=\"vm.allFields\"><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>codice Postale</label><input name=\"cap\" ng-model=\"vm.progetto.cap\" \nplaceholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"indirizzo\" ng-model=\"vm.progetto.indirizzo\" placeholder=\"Indirizzo\"></md-input-container>\n<md-input-container flex><label>Telefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.progetto.telefono\" \nplaceholder=\"Telefono\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" class=\"center-block\">\n<md-datepicker ng-model=\"vm.progetto.dataInizio\" md-placeholder=\"data Inizio\" ng-required=\"false\" flex=\"50\">\n</md-datepicker><md-datepicker ng-model=\"vm.progetto.dataFine\" md-placeholder=\"data Fine\" ng-required=\"false\" \nflex=\"50\"></md-datepicker></div><br><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Durata\n</label><input type=\"number\" name=\"durata\" ng-model=\"vm.progetto.durata\"></md-input-container><md-input-container flex>\n<label>Budget</label><input type=\"number\" name=\"budget\" ng-model=\"vm.progetto.budget\"></md-input-container>\n<md-input-container flex><label>Operatori</label><input type=\"number\" name=\"operatori\" \nng-model=\"vm.progetto.operatori\"></md-input-container><md-input-container flex><label>Posti Totali</label><input \ntype=\"number\" name=\"postiTotali\" ng-model=\"vm.progetto.postiTotali\"></md-input-container><md-input-container flex>\n<label>Posti Finanziati</label><input type=\"number\" name=\"postiFinanziati\" ng-model=\"vm.progetto.postiFinanziati\">\n</md-input-container><md-input-container flex><label>Posti Riservati SC</label><input type=\"number\" \nname=\"postiRiservatiSC\" ng-model=\"vm.progetto.postiRiservatiSC\"></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Posti Asilo</label><input type=\"number\" name=\"postiAsilo\" \nng-model=\"vm.progetto.postiAsilo\"></md-input-container><md-input-container flex><label>Posti Umanitari</label><input \ntype=\"number\" name=\"postiUmanitari\" ng-model=\"vm.progetto.postiUmanitari\"></md-input-container><md-input-container \nflex><label>Posti Rifugiati</label><input type=\"number\" name=\"postiRifugiati\" ng-model=\"vm.progetto.postiRifugiati\">\n</md-input-container></div><div ng-if=\"vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = false\">MOSTRA MENO</md-button></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button type=\"button\" ng-click=\"\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" \naria-label=\"SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/progetto/test.html","<!DOCTYPE html><div>TODO write content</div>");
$templateCache.put("app/main/sprardb/progetti/progetti/sidenavs/sidenav-ricerca.html","<h3 class=\"no-padding no-margin\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><strong>Ricerca avanzata</strong>\n</h3><div ms-scroll style=\"margin-top:8px\"><form id=\"processForm\" name=\"processForm\" novalidate><sprardb-jsonform \nvm=\"vm\" formschema=\"vm.searchForms\"></sprardb-jsonform></form></div>");
$templateCache.put("app/main/sprardb/progetti/strutture/struttura/dettaglios.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div id=\"contacts\" \nclass=\"center page-layout simple tabbed\" layout=\"column\" flex><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" onclick=\"history.go(-1)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"logo\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\"><span ng-if=\"vm.newStruttura\">Nuova</span> Struttura</span><div class=\"subtitle secondary-text\">\n<span>{{vm.struttura.nome}}</span></div></div></div></div><div><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"md-raised md-background\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\" aria-label=\"SALVA\"><span>SALVA\n</span></md-button></div></div><div class=\"content\" ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nDettaglio</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><h2 class=\"no-padding\"><strong>Informazioni Generali</strong></h2>\n<md-divider></md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\" flex><div \nng-if=\"!vm.newStruttura || (vm.progetto_id > 0)\" layout=\"column\" layout-gt-md=\"row\"><md-input-container flex \nclass=\"margin-bottom-0\"><label>Nome Progetto</label><input type=\"text\" name=\"progetto\" \nng-model=\"vm.struttura.progettos.nome\" placeholder=\"Nome Progetto\" readonly=\"readonly\" disabled=\"disabled\">\n</md-input-container></div><div ng-if=\"vm.newStruttura && (vm.progetto_id == 0)\" layout=\"column\" layout-gt-md=\"row\" \nflex><md-input-container flex class=\"margin-bottom-0\"><label>Nome Progetto</label><md-select name=\"progetto\" \nng-model=\"vm.struttura.progetto_id\"><md-option ng-repeat=\"progetto in vm.progettos\" value=\"{{progetto.id}}\">\n{{progetto.nome}}</md-option></md-select><div ng-messages=\"basicForm.accoglienza.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Richiesta</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-input-container flex class=\"margin-bottom-0\"><input type=\"text\" name=\"nome\" \nng-model=\"vm.struttura.nome\" placeholder=\"Nome Struttura\" required><div ng-messages=\"basicForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il nome è richiesto.</span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\" flex><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Tipo Alloggio</label><md-select name=\"accoglienza\" \nng-model=\"vm.struttura.strutturaAccoglienza_id\"><md-option ng-repeat=\"accoglienza in vm.accoglienzas\" \nvalue=\"{{accoglienza.id}}\" ng-selected=\"accoglienza.id == vm.struttura.strutturaAccoglienza_id\"><small>\n{{accoglienza.descrizione}}</small></md-option></md-select><div ng-messages=\"basicForm.accoglienza.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div></md-input-container><md-input-container \nflex><label>Tipo Accoglienza</label><md-select name=\"alloggio\" ng-model=\"vm.struttura.strutturaAlloggio_id\"><md-option \nng-repeat=\"alloggio in vm.alloggios\" value=\"{{alloggio.id}}\" \nng-selected=\"alloggio.id == vm.struttura.strutturaAlloggio_id\"><small>{{alloggio.descrizione}}</small></md-option>\n</md-select><div ng-messages=\"basicForm.alloggio.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span>\n</div></div></md-input-container></div></div><h2 class=\"no-padding\"><strong>Localizzazione</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\" flex><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Regione</label><input type=\"text\" name=\"regione\" \nng-model=\"vm.struttura.istats.regione\" placeholder=\"Regione\" readonly=\"readonly\" disabled=\"disabled\" \nclass=\"font-size-12\"></md-input-container><md-input-container flex><label>Provincia</label><input type=\"text\" \nname=\"regione\" ng-model=\"vm.struttura.istats.provincia\" placeholder=\"Provincia\" readonly=\"readonly\" \ndisabled=\"disabled\" class=\"font-size-12\"></md-input-container><md-input-container flex=\"50\"><label>Comune</label>\n<md-select name=\"com\" ng-model=\"vm.struttura.codComune\"><md-option ng-repeat=\"istat in vm.istats\" \nvalue=\"{{istat.istat}}\" ng-selected=\"istat.istat == vm.struttura.codComune\">{{istat.comune}}</md-option></md-select>\n<div ng-messages=\"basicForm.com.$error\" role=\"alert\"><div ng-message=\"required\"><span>Richiesta</span></div></div>\n</md-input-container></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\" flex><md-input-container flex \nclass=\"margin-top-0\"><input type=\"text\" name=\"nome\" ng-model=\"vm.struttura.indirizzo\" placeholder=\"Indirizzo\" required>\n<div ng-messages=\"basicForm.nome.$error\" role=\"alert\"><div ng-message=\"required\"><span>Indirizzo è richiesto.</span>\n</div></div></md-input-container></div><h2 class=\"no-padding\"><strong>Date e posti</strong></h2><md-divider>\n</md-divider><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\" flex><div flex><small class=\"text-uppercase\">\nData inizio</small></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\" flex><div layout=\"column\" \nlayout-gt-md=\"row\" flex><md-datepicker ng-model=\"vm.struttura.dataInizio2\" md-placeholder=\"data Inizio\" \nng-required=\"false\" flex></md-datepicker></div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-16\" flex><div \nlayout=\"column\" layout-gt-md=\"row\" flex><md-input-container flex=\"50\"><label>Numero Posti</label><input type=\"number\" \nname=\"posti\" ng-model=\"vm.struttura.numeroPosti\"></md-input-container><md-input-container flex=\"50\"><label>\nNumero Stanze</label><input type=\"number\" name=\"stanze\" ng-model=\"vm.struttura.numeroStanze\"></md-input-container>\n</div></div><div layout=\"row\" flex-offset=\"5\" class=\"margin-top-0\" flex><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex=\"50\" class=\"margin-top-0\"><label>Numero Servizi Igienici</label><input type=\"number\" \nname=\"operatori\" ng-model=\"vm.struttura.numeroIgienici\"></md-input-container><md-input-container flex=\"50\" \nclass=\"margin-top-0\"><md-switch ng-model=\"vm.struttura.attivo\" aria-label=\"Attivo\" ng-true-value=\"1\" \nng-false-value=\"0\" style=\"margin: 0px 0px 0px 20px\"><small>Struttura {{((!vm.struttura.attivo) ? \'non\' : \'\')}} attiva\n</small></md-switch></md-input-container></div></div></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nEnti <span ng-class=\"{\'md-warn-bg\': vm.struttura.entes.length === 0}\" class=\"text-boxed\">{{vm.struttura.entes.length}}\n</span></span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg\"><md-list \nclass=\"contacts-list\"><h2 class=\"no-padding margin-bottom-4\" flex><strong>Enti collegati</strong></h2><md-divider>\n</md-divider><div layout=\"column\" class=\"margin-top-16\"><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"ente in vm.struttura.entes track by ente.id\"><div flex=\"40\" class=\"padding-4\"><p class=\"font-weight-600\">\n<span class=\"secondary-text light-blue-900-fg\">{{ ente.nome | uppercase}}</span></p></div><div flex=\"20\" \nclass=\"padding-4\"><span class=\"text-boxed\"><small>{{ente.entetipo.descrizione}}</small><md-tooltip><mark><small>\n{{ente.email}}</small></mark></md-tooltip></span></div><div flex=\"30\" class=\"padding-4\"><span class=\"text-boxed\" \nng-repeat=\"ruolo in vm.struttura.strutturahasentes| filter: {\'ente_id\': ente.id}\"><small \nng-repeat=\"enteruolo in vm.enteruolos| filter: {\'id\': ruolo.enteRuolo_id}\">{{enteruolo.descrizione}}</small></span>\n</div><div flex=\"\" class=\"padding-4\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Modifica link\" \nng-click=\"vm.openEntiDialog($event, vm.struttura, $index, false)\"><md-icon md-font-icon=\"icon-link\"></md-icon>\n<md-tooltip><span>Modifica collegamento</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item>\n</div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>Collega nuovo ente</strong></h2>\n<md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple><div layout=\"row\" \nclass=\"margin-top-16\"><md-button aria-label=\"Nuovo Ente Esistente\" \nng-click=\"vm.openEntiDialog($event, vm.struttura, null, true)\"><md-icon md-font-icon=\"icon-link\"></md-icon>\nNuovo ente esistente<md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip></md-button><md-button \naria-label=\"Crea Nuovo ente\" ng-click=\"vm.openEntiDialog($event, vm.struttura, null, false)\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon>Crea nuovo ente<md-tooltip><span>Crea nuovo ente</span></md-tooltip>\n</md-button></div></md-list-item></md-list></div><div layout=\"column\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openEntiDialog($event, vm.progetto, null, true)\" aria-label=\"Nuovo Ente Esistente\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip><span>Collega nuovo ente esistente</span></md-tooltip>\n</md-button></div></md-tab-body></md-tab><md-tab><md-tab-label class=\"padding-right-4\"><span>Extra <span \nng-class=\"{\'md-warn-bg\': vm.struttura.strutturaextras.length === 0}\" class=\"text-boxed\">\n{{vm.struttura.strutturaextras.length}}</span></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg\"><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCampi Extra</strong></h2><md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"extra in vm.struttura.strutturaextras track by extra.id\"><div flex=\"30\" class=\"padding-4 padding-top-8\">\n<span class=\"small text-bold\">{{extra.chiave| uppercase}}</span></div><div flex class=\"padding-4 padding-top-8\"><span>\n{{extra.valore| uppercase}}</span></div><div flex><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"modifica campo\" ng-click=\"vm.openDialog($event, vm.struttura, $index)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip><span>Modifica campo</span></md-tooltip></md-button></div><md-divider></md-divider>\n</md-list-item></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>Nuovo campo extra</strong></h2>\n<md-divider></md-divider><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple><div layout=\"row\" \nclass=\"margin-top-16\"><md-button aria-label=\"Crea Nuovo campo\" ng-click=\"vm.openDialog($event, vm.struttura, null)\">\n<md-icon md-font-icon=\"icon-library-plus\"></md-icon>Nuovo campo extra<md-tooltip><span>Aggiungi nuovo campo extra\n</span></md-tooltip></md-button></div></md-list-item></md-list></div><div layout=\"column\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openDialog($event, vm.struttura, null)\" \naria-label=\"Nuovo Campo Extra\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span>Aggiungi nuovo campo extra\n</span></md-tooltip></md-button></div></md-tab-body></md-tab><md-tab><md-tab-label class=\"padding-right-4\"><span>\nEventi <span ng-class=\"{\'md-warn-bg\': vm.struttura.eventos.length === 0}\" class=\"text-boxed\">\n{{vm.struttura.eventos.length}}</span></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg\"><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nEventi della struttura</strong></h2><md-divider></md-divider><div layout=\"column\" class=\"margin-top-16\"><md-list-item \nclass=\"contact-item md-white-bg\" md-ink-ripple ng-repeat=\"attributo in vm.struttura.eventos track by attributo.id\"><div\n flex=\"10\" class=\"padding-4\"><span class=\"text-truncate hide show-gt-md\">{{ attributo.dataInizio | uppercase}}</span> \n<span class=\"text-truncate hide show-gt-md\" ng-if=\"attributo.dataFine\">{{ attributo.dataFine | uppercase}}</span></div>\n<div flex=\"20\" class=\"padding-4\"><span class=\"secondary-text light-blue-900-fg font-weight-600\">\n{{ attributo.eventoTipo.nome | uppercase}}</span></div><div flex=\"20\" class=\"padding-4\"><span class=\"text-boxed\">\n{{ attributo.eventoStato.stato | uppercase}}</span></div><div flex=\"10\" class=\"padding-4\"><md-icon \nmd-font-icon=\"icon-alert\" ng-if=\"attributo.alert\" class=\"md-warn-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-information\" ng-if=\"!attributo.alert\" class=\"md-accent-fg\"></md-icon></div><div flex=\"40\" \nclass=\"padding-4\"><span ng-repeat=\"ben in vm.struttura.beneficiarios| filter: {id: attributo.entita1_id}\"><b>\n{{ben.cognome}} {{ben.nome}}</b> - <small>{{ben.nazionalita.descrizione}} // {{ben.dataNascita}}</small></span></div>\n<div flex class=\"padding-4\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Dettaglio\" \nng-click=\"vm.accetta(attributo.id, attributo.entita1_id, 0)\"><md-icon md-font-icon=\"icon-check-bookmark\"></md-icon>\n<md-tooltip><span>Accetta Evento</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Dettaglio\" ng-click=\"vm.rifiuta(attributo.id, attributo.entita1_id, 0)\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon><md-tooltip><span>Rifiuta Evento</span></md-tooltip></md-button></div><md-divider>\n</md-divider></md-list-item></div></md-list><md-list class=\"contacts-list\"><h2 class=\"no-padding\"><strong>\nCrea nuovo evento</strong></h2><md-divider></md-divider></md-list></div></md-tab-body></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/sprardb/progetti/strutture/struttura/sprardb-documenti-struttura.html","<div flex><small flex style=\"max-height: 22px\" ng-if=\"vmd.documenti.length == 0 && !vmd.d.params.tipoModello_id\"><b>\nCaricare i documenti richiesti</b></small><div><small flex style=\"max-height: 22px\" \nng-if=\"vmd.d.params.tipoModello_id && vmd.d.params.tipoModello_id < 4\"><b>Caricare la PEC inviata al Servizio Centrale\n</b></small> <small flex style=\"max-height: 22px\" ng-if=\"vmd.d.params.tipoModello_id == 4\"><b>\nCaricare il Nulla Osta e la ricevuta della PEC inviata al Ministero degli Interni e al Servizio Centrale</b></small>\n</div></div><div ng-if=\"vmd.step1\"><md-button class=\"add-file-button md-accent\" aria-label=\"Add file\" \nng-click=\"vmd.openUpload($event, vmd.authb, vmd.uploadCfg)\" ng-if=\"!vmd.api.isReadOnly\">CARICA UN FILE<md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><small>File caricati: <b>{{vmd.uploadCfg.caricato}}</b><span \nng-if=\"vmd.uploadCfg.caricato < vmd.uploadCfg.mincaricato\"> di <b>{{vmd.uploadCfg.mincaricato}}</b></span></small>\n<md-card style=\"padding-top:0px\" ng-if=\"vmd.uploadCfg.dettaglio\"><md-table-container><table data-md-table><thead \nng-if=\"!vmd.options.decapitate\" md-head data-md-order=\"vmd.allsearchs.sort\" md-on-reorder=\"vmd.onSearch\"><tr md-row><th\n md-column md-order-by=\"id\">#</th><th md-column>NOME FILE</th><th md-column>TIPO</th><th md-column>CARICAMENTO</th>\n</tr></thead><tbody md-body><tr md-row ng-repeat=\"item in vmd.documenti\"><td md-cell>{{item.documento.id}}</td><td \nmd-cell class=\"light-blue-900-fg font-weight-600\"><a title=\"{{item.documento.nomefile}}\" \nhref=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" target=\"_blank\">\n{{ item.documento.nomefile | uppercase|limitTo:20}}</a></td><td md-cell class=\"light-blue-900-fg font-weight-600\">\n{{ item.documento.documentotipo.tipo | uppercase}}</td><td md-cell>{{ item.documento.data}}</td></tr></tbody></table>\n</md-table-container></md-card><div layout=\"column\" ng-if=\"vmd.uploadCfg.dettagliomin\" class=\"margin-left-16\"><div \nlayout=\"row\" ng-repeat=\"item in vmd.documenti track by $index\"><small><small>{{$index + 1}})</small>&nbsp;&nbsp; <b><a \ntitle=\"{{item.documento.nomefile}}\" href=\"{{vmd.baseUrl}}documentos/show/{{item.documento.id}}?k={{item.key}}\" \ntarget=\"_blank\">{{ item.documento.nomefile | uppercase|limitTo:20}}.{{item.documento.tipoFile}} </a></b>\n&nbsp;&nbsp;&nbsp; <small ng-if=\"item.tipoModello\">\n({{item.tipoModello.descrizione | uppercase}} - {{item.documento.documentotipo.tipo | uppercase}})</small> <small \nng-if=\"!item.tipoModello\">({{item.documento.documentotipo.tipo | uppercase}})</small></small></div></div></div><div \nng-if=\"vmd.step2\"><div layout=\"row\" class=\"margin-top-0\" flex><div layout=\"column\" layout-gt-md=\"row\" flex>\n<md-input-container flex><label>Tipologia di Modello</label><md-select name=\"tipoModello_id\" \nng-model=\"vmd.d.params.tipoModello_id\" ng-change=\"updateTipoModello()\" aria-label=\"tipoModello\" required><md-option \nng-repeat=\"tipoModello in vmd.tipiModello\" ng-value=\"tipoModello.id\">{{tipoModello.descrizione | uppercase}}\n</md-option></md-select><div ng-messages=\"basicForm.tipoModello_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Richiesto</span></div></div></md-input-container></div></div><div layout=\"column\" layout-gt-md=\"row\" \nclass=\"margin-top-16\"><md-input-container flex class=\"margin-bottom-0 margin-top-4\" flex><label>\nScegli un tipo documento</label><md-select name=\"nome\" ng-model=\"vmd.d.params.documentoTipo_id\" required flex>\n<md-option ng-repeat=\"item in vmd.uploadCfg.tipiDocumento\" value=\"{{item.id}}\"><small><strong>{{item.tipo}}</strong>\n</small></md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div id=\"file\" \nflow-init=\"vmd.d.ngFlowOptions\" flow-name=\"vmd.d.ngFlow.flow\" flow-files-submitted=\"vmd.upload()\" \nflow-file-added=\"vmd.fileAdded($file)\" flow-file-success=\"vmd.fileSuccess($file, $message)\" \nflow-file-error=\"vmd.fileError($file, $message, $flow )\" flow-complete=\"vmd.uploadComplete()\" flex><div layout=\"row\">\n<md-button class=\"add-file-button md-accent\" aria-label=\"Back\" ng-click=\"vmd.closeUpload()\" flex><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon>INDIETRO</md-button><md-button flow-btn class=\"add-file-button md-accent\" \naria-label=\"Allega\" translate translate-attr-aria-label=\"Allega file\" flex><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon>Allega un file</md-button></div></div></div></div>");
$templateCache.put("app/main/sprardb/segnalatori/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Indietro\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Avanti\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Invia</md-button></div>");
$templateCache.put("app/main/sprardb/configurazioni/enteruolos/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/configurazioni/bandos/dialogs/bando/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.bando.descrizione}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>Bando</label><md-icon></md-icon><input \nng-model=\"vm.bando.descrizione\" type=\"text\"></md-input-container><md-datepicker class=\"birthday-input\" \nng-model=\"vm.bando.dataInizio\" md-placeholder=\"Data Inizio\" ng-required=\"false\"></md-datepicker><md-datepicker \nclass=\"birthday-input\" ng-model=\"vm.bando.dataFine\" md-placeholder=\"Data Fine\" ng-required=\"false\"></md-datepicker>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveBando(vm.evento,vm.bando);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newBando ? \'NUOVO BANDO\' : \'SALVA BANDO\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.bando,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/bandos/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/configurazioni/documentotipos/dialogs/documentotipo/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.documentotipo.tipo}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>Nome Documento</label><md-icon></md-icon><input \nng-model=\"vm.documentotipo.tipo\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label>Tipo Documento</label><md-icon></md-icon><input ng-model=\"vm.documentotipo.gruppo\" type=\"text\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveDocumentotipo(vm.evento,vm.documentotipo);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newDocumentotipo ? \'NUOVO DOCUMENTO\' : \'SALVA DOCUMENTO\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.documentotipo,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/documentotipos/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/configurazioni/enteruolos/dialogs/enteruolo/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.enteruolo.descrizione}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>Ruolo (required)</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input ng-model=\"vm.enteruolo.descrizione\" type=\"text\" ng-required md-autofocus>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Gruppo</label><md-icon></md-icon><input \nng-model=\"vm.enteruolo.gruppo\" type=\"text\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveEnteruolo(vm.evento,vm.enteruolo);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newEnteruolo ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.enteruolo,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/entetipos/dialogs/entetipo/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.entetipo.descrizione}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>Tipo Ente (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.entetipo.descrizione\" type=\"text\" ng-required \nmd-autofocus></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveEntetipo(vm.evento,vm.entetipo);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newEntetipo ? \'NUOVO ENTE\' : \'SALVA ENTE\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.entetipo,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/entetipos/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/configurazioni/personaruolos/dialogs/personaruolo/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.personaruolo.descrizione}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>Ruolo (required)</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input ng-model=\"vm.personaruolo.descrizione\" type=\"text\" ng-required md-autofocus>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Gruppo</label><md-icon></md-icon><input \nng-model=\"vm.personaruolo.gruppo\" type=\"text\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.savePersonaruolo(vm.evento,vm.personaruolo);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\">\n{{ vm.newPersonaruolo ? \'NUOVO RUOLO\' : \'SALVA RUOLO\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.personaruolo, $event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/personaruolos/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/configurazioni/tags/dialogs/tag/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.tag.tag}}</div></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label>Tag</label><md-icon></md-icon><input ng-model=\"vm.tag.tag\" type=\"text\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveTag(vm.evento,vm.tag);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">{{ vm.newTag ? \'NUOVO TAG\' : \'SALVA TAG\' }}</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm(vm.tag,$event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/configurazioni/tags/sidenavs/main/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"text-truncate\" flex=\"50\"><b>{{vm.selected.nomefile}}</b>\n.{{vm.selected.tipoFile}}</div><div layout=\"row\" flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip><span>Cancella</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button></div></div><md-content class=\"content\" flex ms-scroll>\n<div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i \nclass=\"icon-document s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p>Dettagli documento</p>\n</md-list-item></md-list><div class=\"title\">Tipologia di file: <span class=\"text-boxed\">\n{{vm.selected.documentotipo.tipo}}</span></div><div class=\"title\">Gruppo/Area: <span class=\"text-boxed\">\n{{vm.selected.documentotipo.gruppo}}</span></div></div></md-content>");
$templateCache.put("app/main/sprardb/documenti/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\">Tipo File</span></div></div><div class=\"content\"><div class=\"navigation-simple\" \nlayout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" \ntranslate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div \nclass=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div \nclass=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div \nclass=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>\n<div class=\"title\">Rendicontazione</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div \nclass=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s16\"></md-icon><div \nclass=\"title\">Progetti</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bank\" class=\"s16\"></md-icon><div class=\"title\">\nStrutture</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-network\" class=\"s16\"></md-icon><div class=\"title\">\nBeneficiari</div></div></md-button></div></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-2\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><i md-font-icon=\"icon-{{file.type}}\"></i> </span><span class=\"name\">{{file.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/sprardb/documenti/file-manager/views/list/list-view.html","<md-card style=\"padding-top:0px\"><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><span>Ricerca Files</span><div \nlayout=\"row\" ng-if=\"vm.searched\" flex><span class=\"text-boxed\" ng-if=\"vm.ricerca2\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.ricerca2 = \'\'; vm.onSearch();\"></md-icon>\nParola chiave: {{vm.ricerca2| uppercase}} </span><span class=\"text-boxed\" ng-repeat=\"(key, ricercato) in vm.ricerca\" \nng-if=\"key != \'operatore\'\"><md-icon class=\"s16\" md-font-icon=\"icon-delete\" ng-click=\"vm.deletefiltersearch(key)\">\n</md-icon>{{vm.searchForms[key][\'title\']}}: {{vm.valuesearched(key, ricercato)}}</span></div><div flex></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.exportcsvente()\"><i class=\"icon-file-excel light-green-900-fg s18\"></i>\n<md-tooltip>Prepara i dati per esportazione</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-json-export-excel data=\"vm.entesexport\" report-fields=\"vm.entesfileds\" ng-disabled=\"(!vm.preparati)\"><i \nclass=\"icon-download s18\" \nng-class=\"{\'light-green-900-fg\': vm.preparati === true, \'grey-400-fg\': vm.preparati === false}\"></i><md-tooltip>\nScarica i dati preparati</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.onSearch()\"><i \nclass=\"icon-refresh s18\"></i></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selected = [];\"><i class=\"icon-close s22 grey-400-fg\"></i><md-tooltip>\nCancella selezione</md-tooltip></md-button><span>\n{{vm.selected.length}} {{vm.selected.length > 1 ? \'files selezionati\' : \'file selezionato\'}} :</span><div flex></div>\n<md-button aria-label=\"Tags\" class=\"md-button\" ng-click=\"vm.edittags(vm.selected, [\'generico\'])\" \nng-disabled=\"(vm.selected.length == 0)\"><md-icon md-font-icon=\"icon-flag-triangle\" \nstyle=\"color: rgba(255, 255, 255, 0.87)\"></md-icon>TAGS</md-button></div></md-toolbar><md-table-container><table \ndata-md-table data-md-row-select=\"vm.options.rowSelection\" data-ng-model=\"vm.selected\" md-progress=\"vm.files\" \nmultiple=\"{{vm.options.multiSelect}}\"><thead ng-if=\"!vm.options.decapitate\" md-head data-md-order=\"vm.allsearchs.sort\" \nmd-on-reorder=\"vm.onSearch\"><tr md-row><th md-column md-order-by=\"id\" style=\"text-align:center;padding-right:4px\">Cod\n</th><th md-column md-order-by=\"nomefile\" style=\"text-align:center;padding-right:8px\">NOME</th><th md-column \nstyle=\"text-align:center;padding-right:8px\">TIPO</th><th md-column style=\"padding-right:8px\"><span>GRUPPO</span></th>\n<th md-column md-order-by=\"data\" style=\"padding-right:8px\">DATA</th><th md-column \nstyle=\"text-align:right;padding-right:16px\">AZIONE</th></tr></thead><tbody md-body><tr md-row md-select=\"file\" \nmd-select-id=\"file\" data-md-on-select=\"vm.toggleSelect\" md-on-deselect=\"vm.toggleSelect\" \nx-md-auto-select=\"vm.options.autoSelect\" ng-repeat=\"file in vm.files\"><td md-cell \nstyle=\"text-align:center;padding-right:4px\"><small>{{file.id}}</small></td><td md-cell \nstyle=\"text-align:left;padding-right:8px;text-transform: uppercase\" class=\"light-blue-900-fg font-weight-600\"><div \nlayout=\"column\">{{file.nomefile}}.{{file.tipoFile}}</div></td><td md-cell style=\"text-align:left;padding-right:8px\">\n<div layout=\"column\">{{file.documentotipo.tipo}}</div></td><td md-cell style=\"text-align:left;padding-right:8px\"><div \nlayout=\"column\">{{file.documentotipo.gruppo}}</div></td><td md-cell style=\"text-align:left;padding-right:8px\"><div \nlayout=\"column\"><small>{{file.data}}</small></div></td><td md-cell style=\"text-align:right;padding-right:8px\"><md-menu>\n<md-button aria-label=\"Altro\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Apri\" href=\"{{vm.baseUrl}}{{file.unomefile}}\" target=\"_blank\"><md-icon md-font-icon=\"icon-document\" href>\n</md-icon><small><b>APRI DOCUMENTO</b></small></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.allsearchs.pagination\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.allsearchs.page\" md-total=\"{{vm.meta.totalCount}}\" \nmd-on-paginate=\"vm.onSearch\" md-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\" \nmd-label=\"{page: \'Pagina:\', rowsPerPage: \'Record per pagina:\', of: \'di\'}\"></md-table-pagination></md-card>");
$templateCache.put("app/main/sprardb/progetti/progetti/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contact.avatar}}\" class=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.contact.name}}\"><div \nclass=\"contact-name\">{{vm.contact.name}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleInArray(vm.contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(vm.contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(vm.contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required \nmd-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input ng-model=\"vm.contact.lastName\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.NICKNAME\">Nickname\n</label><md-icon></md-icon><input ng-model=\"vm.contact.nickname\" type=\"text\"></md-input-container><div \nng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"vm.contact.phone\" type=\"text\" placeholder=\"Phone number\" translate \ntranslate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\" placeholder=\"Email\" \ntranslate translate-attr-placeholder=\"CONTACTS.EMAIL\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.company\" type=\"text\" placeholder=\"Company\" \ntranslate translate-attr-placeholder=\"CONTACTS.COMPANY\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.jobTitle\" type=\"text\" \nplaceholder=\"Job title\" translate translate-attr-placeholder=\"CONTACTS.JOB_TITLE\"></md-input-container><md-datepicker \nclass=\"birthday-input\" ng-model=\"vm.contact.birthday\" md-placeholder=\"Birthday\" ng-required=\"false\"></md-datepicker>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" \ntype=\"text\" placeholder=\"Address\" translate translate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div \nlayout=\"row\" class=\"md-block textarea-wrapper\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea \nng-model=\"vm.contact.notes\" type=\"text\" max-rows=\"4\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTACTS.SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" \nng-click=\"vm.addNewContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sprardb/progetti/progetti/dialogs/contact/dialog1.tmpl.html","<md-dialog aria-label=\"{{vm.progetto.nome}}\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{vm.title + \" \" + vm.progetto.nome}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div class=\"form-wrapper\" flex=\"100\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-md=\"row\"></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><input type=\"text\" \nname=\"nome\" ng-model=\"vm.progetto.nome\" placeholder=\"Nome Progetto\" required><div ng-messages=\"basicForm.nome.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il nome del progetto è richiesto.</span></div></div></md-input-container>\n<md-input-container flex><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.progetto.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"basicForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email richiesta</span></div><div ng-message=\"pattern\"><span>\nEmail non valida</span></div></div></md-input-container><md-input-container flex><label>Cat.Accoglienza</label>\n<md-select name=\"bnd\" ng-model=\"vm.progetto.bandos.id\" required><md-option ng-repeat=\"bando in vm.bandos\" \nvalue=\"{{bando.id}}\" ng-selected=\"bando.id == vm.progetto.bandos.id\">{{bando.descrizione}}</md-option></md-select><div \nng-messages=\"basicForm.bnd.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Regione</label><md-select name=\"reg\" \nng-model=\"vm.progetto.codRegione\" required ng-change=\"vm.caricaProvince(vm.progetto.codRegione)\"><md-option \nng-repeat=\"regione in vm.regiones\" value=\"{{regione.id}}\" ng-selected=\"regione.id == vm.progetto.codRegione\">\n{{regione.regione}}</md-option></md-select><div ng-messages=\"basicForm.reg.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Richiesta</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div>\n</md-input-container><md-input-container flex required><label>Provincia</label><md-select name=\"prov\" \nng-model=\"vm.progetto.codProvincia\" ng-disabled=\"!vm.progetto.codRegione\" \nng-change=\"vm.caricaComuni(vm.progetto.codProvincia)\"><md-option ng-repeat=\"provincia in vm.provincias\" \nvalue=\"{{provincia.id}}\" ng-selected=\"provincia.id == vm.progetto.codProvincia\">{{provincia.provincia}}</md-option>\n</md-select><div ng-messages=\"basicForm.prov.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRichiesta</span></div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container>\n<md-input-container flex required><label>Comune</label><md-select name=\"com\" ng-model=\"vm.progetto.codComune\" \nng-disabled=\"!vm.progetto.codProvincia\"><md-option ng-repeat=\"istat in vm.istats\" value=\"{{istat.istat}}\" \nng-selected=\"istat.istat == vm.progetto.codComune\">{{istat.comune}}</md-option></md-select><div \nng-messages=\"basicForm.com.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Richiesta</span>\n</div><div ng-message=\"pattern\"><span>Non valida</span></div></div></md-input-container></div><div \nng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\">MOSTRA TUTTI</md-button></div><div ng-if=\"vm.allFields\"><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>codice Postale</label><input name=\"cap\" ng-model=\"vm.progetto.cap\" \nplaceholder=\"00100\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.cap.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Cap invalido.</span></div><div ng-message=\"md-maxlength\"><span>\nCap non può essere più lungo di 5 caratteri.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"indirizzo\" ng-model=\"vm.progetto.indirizzo\" placeholder=\"Indirizzo\"></md-input-container>\n<md-input-container flex><label>Telefono</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.progetto.telefono\" \nplaceholder=\"Telefono\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" class=\"center-block\">\n<md-datepicker ng-model=\"vm.progetto.dataInizio\" md-placeholder=\"data Inizio\" ng-required=\"false\" flex=\"50\">\n</md-datepicker><md-datepicker ng-model=\"vm.progetto.dataFine\" md-placeholder=\"data Fine\" ng-required=\"false\" \nflex=\"50\"></md-datepicker></div><br><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex><label>Durata\n</label><input type=\"number\" name=\"durata\" ng-model=\"vm.progetto.durata\"></md-input-container><md-input-container flex>\n<label>Budget</label><input type=\"number\" name=\"budget\" ng-model=\"vm.progetto.budget\"></md-input-container>\n<md-input-container flex><label>Operatori</label><input type=\"number\" name=\"operatori\" \nng-model=\"vm.progetto.operatori\"></md-input-container><md-input-container flex><label>Posti Totali</label><input \ntype=\"number\" name=\"postiTotali\" ng-model=\"vm.progetto.postiTotali\"></md-input-container><md-input-container flex>\n<label>Posti Finanziati</label><input type=\"number\" name=\"postiFinanziati\" ng-model=\"vm.progetto.postiFinanziati\">\n</md-input-container><md-input-container flex><label>Posti Riservati SC</label><input type=\"number\" \nname=\"postiRiservatiSC\" ng-model=\"vm.progetto.postiRiservatiSC\"></md-input-container></div><div layout=\"column\" \nlayout-gt-md=\"row\"><md-input-container flex><label>Posti Asilo</label><input type=\"number\" name=\"postiAsilo\" \nng-model=\"vm.progetto.postiAsilo\"></md-input-container><md-input-container flex><label>Posti Umanitari</label><input \ntype=\"number\" name=\"postiUmanitari\" ng-model=\"vm.progetto.postiUmanitari\"></md-input-container><md-input-container \nflex><label>Posti Rifugiati</label><input type=\"number\" name=\"postiRifugiati\" ng-model=\"vm.progetto.postiRifugiati\">\n</md-input-container></div><div ng-if=\"vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = false\">MOSTRA MENO</md-button></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button type=\"button\" ng-click=\"\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" \naria-label=\"SAVE\"></md-button></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-if=\"!vm.newProgetto\" ng-click=\"vm.saveProgetto(vm.progetto)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" aria-label=\"SALVA\">{{(!vm.newProgetto)?\'SALVA\':\'NUVO\'}}\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sprardb/progetti/progetti/sidenavs/dettaglio/main-sidenav.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-16 light-blue-bg white-fg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">Posti disponibili</div><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div><div \nclass=\"md-display-1 pb-16\">{{(100 - ((10 / vm.progetto.postiTotali) * 100)) | number}}%</div><div class=\"pb-16\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{(100 - ((10 / vm.progetto.postiTotali) * 100)) | number}}\">\n</md-progress-linear></div></div><div layout=\"row\" layout-align=\"start center\"><span>\nTotale posti: {{vm.progetto.postiTotali}}</span> <span class=\"text-boxed-light\">Totale occupati: 10</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>Posti risevati:<br>Posti risevati:<br>Posti risevati:<br>Posti risevati:<br></div>\n</ms-widget-back></ms-widget></div><md-divider></md-divider><div ms-scroll class=\"content\" id=\"progetto-extras\">\n<md-list><md-toolbar layout=\"row\" class=\"md-hue-3\"><div class=\"md-toolbar-tools\"><span>Informazioni Extra</span></div>\n</md-toolbar><md-subheader class=\"md-no-sticky\"><span>Campi Extra</span><md-button class=\"md-icon-button md-secondary\" \nng-click=\"vm.openDialog($event, vm.progetto, null)\"><md-icon md-font-icon=\"icon-comment-plus-outline\"></md-icon>\n<md-tooltip><span>Aggiungi nuovo campo extra</span></md-tooltip></md-button></md-subheader><md-list-item \nng-repeat=\"extra in ::vm.progetto.progettoextras track by extra.id\" \nng-click=\"vm.openDialog($event, vm.progetto, $index)\"><span class=\"small text-bold\">{{extra.chiave| uppercase}}</span>\n:&nbsp;<small><span>{{extra.valore| uppercase}}</span></small><md-divider></md-divider></md-list-item><md-subheader \nclass=\"md-no-sticky\"><span>Enti</span><md-button class=\"md-icon-button margin-left-20\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><md-tooltip><span>Collega nuovi enti</span></md-tooltip></md-button></md-subheader>\n<md-list-item ng-repeat=\"ente in ::vm.progetto.entes\"><span class=\"text-boxed\">{{ente.nome | uppercase}}</span>:&nbsp;\n<small><span>{{ente.entetipo.descrizione}}</span></small> (<span ng-repeat=\"enteruolo in ::ente.enteruolos\">&nbsp;\n<small>{{enteruolo.ruolo}},&nbsp;</small></span>)<md-divider></md-divider></md-list-item><md-subheader \nclass=\"md-no-sticky\"><span>Documenti</span><md-button class=\"md-icon-button margin-left-20\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><md-tooltip><span>Carica nuovo documento</span></md-tooltip></md-button>\n</md-subheader><md-list-item class=\"padding-left-16\"><span class=\"text-boxed\">Documenti caricati totale</span>:&nbsp;\n<small><span>{{vm.progetto.documentos.totale}}</span></small><md-button ng-click=\"vm.gotoDocumenti()\">vedi tutti\n<md-tooltip><span>Vedi tutti</span></md-tooltip></md-button><md-divider></md-divider></md-list-item></md-list><md-list>\n<md-subheader class=\"md-no-sticky\">Tags<md-icon md-font-icon=\"icon-tag\"></md-icon></md-subheader><md-list-item \nng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag = !vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item>\n<md-list-item ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag); vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag = !vm.mostraitag;\">ANNULLA</md-button></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/progetti/progetti/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/progetti/strutture/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Cancella</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate \ntranslate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.nomefile}}\n</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.updated_at | date}}\n</div></div></div><md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div class=\"preview file-icon\" \nlayout=\"row\" layout-align=\"center center\"><i class=\"icon-document s48\"></i></div><md-list class=\"offline-switch\">\n<md-list-item><p>Dettagli</p></md-list-item></md-list><div class=\"title\">Tipologia di file: <span class=\"text-boxed\">\n{{vm.selected.documentotipo.tipo}}</span></div><div class=\"title\">Gruppo/Area: <span class=\"text-boxed\">\n{{vm.selected.documentotipo.gruppo}}</span></div></div></md-content>");
$templateCache.put("app/main/sprardb/progetti/strutture/sidenavs/dettaglio/main-sidenav.html","<div class=\"widget-group h-250\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-16 light-blue-bg white-fg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">Posti disponibili</div><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div><div \nclass=\"md-display-1 pb-16\">{{(100 - ((10 / vm.struttura.postiTotali) * 100)) | number}}%</div><div class=\"pb-16\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{(100 - ((10 / vm.struttura.postiTotali) * 100)) | number}}\">\n</md-progress-linear></div></div><div layout=\"row\" layout-align=\"start center\"><span>\nTotale posti: {{vm.struttura.postiTotali}}</span> <span class=\"text-boxed-light\">Totale occupati: 10</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>Posti risevati:<br>Posti risevati:<br>Posti risevati:<br>Posti risevati:<br></div>\n</ms-widget-back></ms-widget></div><md-divider></md-divider><div ms-scroll class=\"content\" id=\"progetto-extras\">\n<md-list><md-toolbar layout=\"row\" class=\"md-hue-3\"><div class=\"md-toolbar-tools\"><span>Informazioni Extra</span></div>\n</md-toolbar><md-subheader class=\"md-no-sticky\"><span>Campi Extra</span><md-button class=\"md-icon-button md-secondary\" \nng-click=\"vm.openDialog($event, vm.struttura, null)\"><md-icon md-font-icon=\"icon-comment-plus-outline\"></md-icon>\n<md-tooltip><span>Aggiungi nuovo campo extra</span></md-tooltip></md-button></md-subheader><md-list-item \nng-repeat=\"extra in ::vm.struttura.strutturaextras track by extra.id\" \nng-click=\"vm.openDialog($event, vm.struttura, $index)\"><span class=\"small text-bold\">{{extra.chiave| uppercase}}</span>\n:&nbsp;<small><span>{{extra.valore| uppercase}}</span></small><md-divider></md-divider></md-list-item><md-subheader \nclass=\"md-no-sticky\"><span>Enti</span><md-button class=\"md-icon-button margin-left-20\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><md-tooltip><span>Collega nuovi enti</span></md-tooltip></md-button></md-subheader>\n<md-list-item ng-repeat=\"ente in ::vm.struttura.entes\"><span class=\"text-boxed\">{{ente.nome| uppercase}}</span>:&nbsp;\n<small><span>{{ente.entetipo.descrizione}}</span></small> (<span ng-repeat=\"enteruolo in ::ente.enteruolos\">&nbsp;\n<small>{{enteruolo.ruolo}},&nbsp;</small></span>)<md-divider></md-divider></md-list-item><md-subheader \nclass=\"md-no-sticky\"><span>Documenti</span><md-button class=\"md-icon-button margin-left-20\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><md-tooltip><span>Carica nuovo documento</span></md-tooltip></md-button>\n</md-subheader><md-list-item class=\"padding-left-16\"><span class=\"text-boxed\">Documenti caricati totale</span>:&nbsp;\n<small><span>{{vm.struttura.documentos.totale}}</span></small><md-button ng-click=\"vm.gotoDocumenti()\">vedi tutti\n<md-tooltip><span>Vedi tutti</span></md-tooltip></md-button><md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/progetti/strutture/sidenavs/main/main-sidenav.html","<h2 class=\"no-padding\"><md-icon md-font-icon=\"icon-tag\"></md-icon><strong>Filtra per Tag</strong></h2><md-divider>\n</md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\"><strong><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s18 md-warn-fg\"></md-icon>Elimina filtro Tag</strong><md-divider></md-divider></md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();\n            vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag| uppercase}}\n<md-divider></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/sprardb/progetti/strutture/sidenavs/struttura/main-sidenav.html","<md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-subheader class=\"md-no-sticky\">Tags</md-subheader>\n<md-list-item ng-if=\"vm.mostraitag\"><md-input-container flex><input type=\"text\" name=\"nometag\" ng-model=\"vm.nometag\" \nplaceholder=\"Nome Tag\" required></md-input-container></md-list-item><md-list-item ng-if=\"!vm.mostraitag\"><md-button \nclass=\"md-accent primary\" ng-click=\"vm.mostraitag=!vm.mostraitag;\">AGGIUNGI TAG</md-button></md-list-item><md-list-item\n ng-if=\"vm.mostraitag\"><md-button class=\"md-accent primary\" \nng-click=\"vm.aggiungiTag(vm.nometag);vm.toggleSidenav(\'sidenav\');\">SALVA</md-button><md-button class=\"md-accent\" \nng-click=\"vm.mostraitag=!vm.mostraitag;\">ANNULLA</md-button></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = null;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === null}\">TUTTI</md-list-item><md-list-item \nng-click=\"vm.ricerca[\'tags-id\'] = tag.id;\n            vm.searchServer();vm.toggleSidenav(\'sidenav\')\" \nng-class=\"{\'selected\':vm.ricerca[\'tags-id\'] === tag.id}\" ng-repeat=\"tag in ::vm.tags\">{{tag.tag}}</md-list-item>\n</md-list></div>");}]);